(function (angular) {

  // Create all modules and define dependencies to make sure they exist
  // and are loaded in the correct order to satisfy dependency injection
  // before all nested files are concatenated by Gulp

  // Config
  angular.module('xipnyWkflow.config', [])
      .value('xipnyWkflow.config', {
          debug: true
      });
  // Modules
  angular.module('xipnyWkflow.directives', []);
  angular.module('xipnyWkflow.filters', []);
  angular.module('xipnyWkflow.services', []);
  angular.module('xipnyWkflow',
      [
          'xipnyWkflow.config',
          'xipnyWkflow.directives',
          'xipnyWkflow.filters',
          'xipnyWkflow.services',
          'ngResource',
          'ngCookies',
          'ngSanitize'
      ]);

})(angular);

(function () {
    "use strict";
    angular.module("xipnyWkflow").directive("xipnyWkflowEntityListButtons", xipnyWkflowEntityListButtons);
    function xipnyWkflowEntityListButtons() {
        return {
            restrict: "E",
            templateUrl:
                "app/xipny-wkflow/directives/wk-entity-list-buttons/wk-entity-list-buttons.html",
            bindToController: {
                user: "=",
                token: "=",
                entity: "=",
                wkflow: "=",
                wkstate: "=",
                list: "=",
                hideauto: "<",
                hideundo: "<"
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                "$window",
                "$scope",
                "$log",
                "$location",
                "$timeout",
                "$http",
                "$mdSidenav",
                "$mdDialog",
                "$mdToast",
                "$filter",
                "WkflowService",
                "UsersService",
                "env",
                function (
                    $window,
                    $scope,
                    $log,
                    $location,
                    $timeout,
                    $http,
                    $mdSidenav,
                    $mdDialog,
                    $mdToast,
                    $filter,
                    WkflowService,
                    UsersService,
                    env
                ) {
                    var vm = this;
                    $log.info("xipnyWkflowEntityList");
                    vm.mdToast = $mdToast;
                    vm.mdDialog = $mdDialog;
                    vm.env = env;
                    if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
                        return;
                    }

                    //console.log("after userservice: "+vm.token);

                    vm.today = new Date(
                        moment().hours(0).minutes(0).seconds(0)
                    );
                    vm.showActionToast = function (text) {
                        text =
                            text && angular.isDefined(text)
                                ? text
                                : "Tutto Ok!";
                        var toast = $mdToast
                            .simple()
                            .textContent(text)
                            .action("")
                            .highlightAction(true)
                            .position("bottom right");
                        return $mdToast.show(toast).finally(function () {
                            toast = undefined;
                        });
                    };

                    vm.canTransition = function(transition) {
                        if (!vm.entity && (!vm.list || !vm.list.data || !vm.list.data.length>0)) return false;
                        if (transition.permission) {
                            if (vm.user) {
                                return vm.user.permissions.indexOf(transition.permission)>=0;
                            } else {
                                return false;
                            }
                        } else {
                            return true;
                        }
                    };

                    vm.printErrorMessage = function (response) {
                        var errMsg = "";
                        if (response.data != null
                            && response.data.message != null) {
                            errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                            var url = response.config != null && response.config.url != null ? response.config.url : "";
                            if (url != null) {
                                errMsg += "\nUrl: " + url;
                            }
                        }
                        vm.showActionToast("Si è verificato un errore " + errMsg);
                    };

                    vm.undoTransition = function(transitionlog) {
                        var nomecognome = (vm.entity.customer && vm.entity.customer.data? (vm.entity.customer.data.firstname?vm.entity.customer.data.firstname:'') + ' ' + (vm.entity.customer.data.lastname?vm.entity.customer.data.lastname:''):'')
                        var confirm = $mdDialog
                            .confirm({
                                multiple: true
                            })
                            .title('Attenzione')
                            .ariaLabel('Attenzione')
                            .textContent('Sicuro di voler confermere? Verrà ANNULLATA la transizione di stato: '+(transitionlog.wktransition_id?transitionlog.wkTransition.data.label:'Join') + ' - ' + nomecognome)
                            .ok('Si')
                            .cancel('Ops, ho sbagliato');

                        return $mdDialog
                            .show(confirm)
                            .then(
                                function() {
                                    vm.entity.wkloading = true;
                                    WkflowService.undoTransition(vm.entity, transitionlog).then(
                                        function (response) {
                                            var newEntity = response.data.entity;
                                            var saveLog = response.data.log;
                                            var stateTo = response.data.wkstateTo;
                                            var childtodelete = response.data.childtodelete;
                                            if (childtodelete && childtodelete.length>0 && vm.entity.childs && vm.entity.childs.data && vm.entity.childs.data.length>0) {
                                                var newChilds = [];
                                                angular.forEach(vm.entity.childs.data, function(c) {
                                                    var toAdd = true;
                                                    angular.forEach(childtodelete, function(id) {
                                                        if (c.id == id) {
                                                            toAdd = false;
                                                        }
                                                    });
                                                    if (toAdd) {
                                                        newChilds.push(c);
                                                    }
                                                });
                                                vm.entity.childs.data = newChilds;
                                            }
                                            vm.entity[vm.wkflow.entity_state] = stateTo.name;
                                            vm.entity.wkstate = {data: WkflowService.getState(vm.entity, vm.wkflow)};
                                            vm.entity.updated_at_frmt = moment(newEntity.updated_at).format('DD/MM/YYYY HH:mm');
                                            vm.entity.transitionLast = null; //andrebbe messa la precedente
                                            vm.entity.isSelected = false;
                                            vm.initTransitionAndInitialStates();
                                            vm.showActionToast("Annullo transizione effettuata:\nNuovo stato: "+stateTo.label+(saveLog?"\n"+saveLog:''));
                                            vm.entity.wkloading = false;
                                        },
                                        function (response) {
                                            vm.entity.wkloading = false;
                                            vm.printErrorMessage(response);
                                        }
                                    );

                                }
                            )
                            .finally(
                                function() {
                                    confirm = undefined;
                                }
                            );
                    };

                    //console.log ("define starttransition: "+vm.token);
                    vm.token2 = vm.token;
                    //console.log("this on define",this);
                    vm.startTransition = function(transition, stateInitial) {
                        //console.log ("start transition: "+vm.token);
                        //console.log("this on start",this);
                        if (!vm.entity) {
                            /**
                             * transizione multipla su entità selezionate
                             */
                            vm.multipleSave = true;
                            //$log.info(vm.list);
                            vm.entityList = $filter('filter')(vm.list.data, {'isSelected': 1}, true);
                            if (vm.entityList && vm.entityList.length>0) {
                                vm.entity = vm.entityList[0];
                                vm.multipleSaveNextIndex = 1;
                                //vm.showActionToast("Selezionare almeno una riga");
                            } else {
                                vm.showActionToast("Selezionare almeno una riga");
                                return;
                            }
                        }
                        var confirm = $mdDialog.confirm({
                            title: 'Conferma',
                            ariaLabel: 'Conferma',
                            templateUrl: 'app/xipny-wkflow/directives/wk-entity-list-buttons/dialogs/transition.html',
                            fullscreen: false,
                            escapeToClose: true,
                            multiple: true,
                            controller: [
                                '$scope',
                                '$mdDialog',
                                function ($scope, $mdDialog) {

                                    //console.log ("open transition: "+vm.token);
                                    //console.log ("open transition: "+vm.token2);
                                    /**
                                     * Allegato
                                     */
                                     $scope.img = {};
                                     $scope.img.fileObj = null;
                                     $scope.img.fileName = null;
                                     $scope.token = vm.token2;

                                     $scope.init = function() {
                                        var fileName = angular.element( '#fileName').first()
                                            , fileObj = angular.element( '#fileObj').first()
                                            , button = angular.element( '#upload' ).first()
                                        ;
                                        if ( fileObj.length && button.length && fileName.length ) {
                                            button.click( function( e ) {
                                                e.preventDefault();
                                                fileObj.click();
                                            });
                                            fileName.click( function( e ) {
                                                e.preventDefault();
                                                fileObj.click();
                                            });

                                            fileObj.on( 'change', function ( e ) {
                                                $timeout( function() {
                                                    var files = e.target.files
                                                        , filename
                                                    ;
                                                    if( files.length ) {
                                                        filename = [];
                                                        for ( var i = 0; i < files.length; i++ ) {
                                                            filename.push( files[ i ].name );
                                                        };
                                                        filename = filename.join(", ");
                                                    } else {
                                                        filename = null;
                                                        files = null;
                                                    };
                                                    $scope.img.fileName = filename;
                                                    $scope.img.fileObj = files;
                                                }, 0 );
                                            });
                                        };
                                    };


                                    var fn = '';
                                    if (vm.wkflow && vm.wkflow.entity == 'customers') {
                                        fn = (vm.entity.firstname?vm.entity.firstname + ' ':'' )
                                            + (vm.entity.lastname?vm.entity.lastname:'');
                                    } else {
                                        fn = (vm.entity.customer && vm.entity.customer.data?
                                                (vm.entity.customer.data.firstname?vm.entity.customer.data.firstname + ' ':'') + (vm.entity.customer.data.lastname?vm.entity.customer.data.lastname:'')
                                            :'');
                                    }
                                    $scope.title = (transition?transition.label:stateInitial.label) + ' - ' + fn;
                                    $scope.loading = true;
                                    vm.entity.loading = true;
                                    $scope.transition = transition;
                                    $scope.stateInitial = stateInitial;
                                    $scope.wkform = null;
                                    $scope.note = {data: null};
                                    $scope.entity = vm.entity;
                                    $scope.wkflow = vm.wkflow;

                                    $scope.filter = {
                                        options: {
                                            'debounce': 0,
                                            'updateOn': 'default'
                                        }
                                    };

                                    if (transition && transition.wkform_id) {
                                        WkflowService.getForm(transition.wkform_id).then(
                                            function (response) {
                                                $scope.loading = false;
                                                delete vm.entity.loading;
                                                //$log.info("wkform");
                                                //$log.info(response.data.data);
                                                $scope.wkform = response.data.data;
                                                angular.forEach($scope.wkform.fields.data, function(fld) {
                                                    if(vm.wkflow.entity == fld.entity && vm.entity[fld.name]) {
                                                        fld.data = vm.entity[fld.name];
                                                    } else {
                                                        fld.data = null;
                                                    }
                                                    if (fld.type == 'select' || fld.widget && fld.widget.indexOf('options')>=0) {
                                                        fld.options = JSON.parse(fld.widget).options;
                                                        //$log.info(fld.options);
                                                    }
                                                    if (fld.type == 'attachment') {
                                                        var w = JSON.parse(fld.widget);
                                                        fld.accept = w.accept.join(',');
                                                        fld.label = w.label;
                                                        fld.icon = w.icon;
                                                    }
                                                });
                                                setTimeout($scope.init, 50);
                                            },
                                            function (response) {
                                                vm.printErrorMessage(response);
                                                $scope.loading = false;
                                                delete vm.entity.loading;
                                            }
                                        );
                                    } else {
                                        $scope.loading = false;
                                        delete vm.entity.loading;
                                    }

                                    $scope.save = function() {
                                        WkflowService.saveTransition(vm.entity, $scope.transition, $scope.stateInitial, $scope.note.data, $scope.wkform?$scope.wkform.fields.data:null).then(
                                            function (response) {
                                                $scope.loading = false;
                                                delete vm.entity.loading;
                                                //$log.info("saveTransaction ok!");
                                                //$log.info(response);
                                                var newEntity = response.data.entity;
                                                var saveLog = response.data.log;
                                                var stateTo = response.data.wkstateTo;
                                                var transitionLog = response.data.wktransitionLog;
                                                var downloads = response.data.downloads;
                                                transitionLog.data.wkTransition = {data: transitionLog.data.wktransition};
                                                transitionLog.data.wkstateFrom = {data: transitionLog.data.wkstate_from};
                                                transitionLog.data.wkstateTo = {data: transitionLog.data.wkstate_to};
                                                /**
                                                 * Devo fare merge dati entity perchè se cè form vanno aggiornati i dati
                                                 */
                                                if ($scope.wkform && $scope.wkform.fields.data) {
                                                    angular.forEach($scope.wkform.fields.data, function(f) {
                                                        if (f.type!='attachment') {
                                                            vm.entity[f.name] = f.data;
                                                        }
                                                    });
                                                }
                                                vm.entity[vm.wkflow.entity_state] = stateTo.name;
                                                vm.entity.wkstate = {data: WkflowService.getState(vm.entity, vm.wkflow)};
                                                vm.entity.updated_at_frmt = moment(newEntity.updated_at).format('DD/MM/YYYY HH:mm');
                                                vm.entity.transitionLast = transitionLog;
                                                vm.entity.isSelected = false;
                                                vm.initTransitionAndInitialStates();
                                                $scope.close();
                                                vm.showActionToast("Transizione effettuata: Nuovo stato: "+stateTo.label+(saveLog?" "+saveLog:''));
                                                /**
                                                 * Apro i downloads
                                                 */
                                                //$log.info(downloads);
                                                //$log.info(downloads.length);
                                                //$log.info("vm.token: "+vm.token);
                                                //$log.info("$scope.token: "+$scope.token);
                                                //$log.info("vm.token2: "+vm.token2);

                                                if (downloads && downloads.length>0) {
                                                    angular.forEach(downloads, function(d) {
                                                        var url = env.API + '/documents/'+ d.id + '/download?token=' + vm.token2;
                                                        //$log.info("download: "+ url);
                                                        $window.open(url, '_blank');
                                                    });
                                                }
                                                if (vm.multipleSave && vm.multipleSaveNextIndex<vm.entityList.length-1) {
                                                    vm.entity = vm.entityList[vm.multipleSaveNextIndex];
                                                    vm.multipleSaveNextIndex++;
                                                    vm.startTransition(transition, stateInitial);
                                                } else if (vm.multipleSave) {
                                                    vm.entity = null;
                                                    vm.showActionToast("Fine!");
                                                }
                                            },
                                            function (response) {
                                                $scope.loading = false;
                                                delete vm.entity.loading;
                                                vm.printErrorMessage(response);
                                            }
                                        );
                                    }

                                    $scope.saveTransition = function() {
                                        var confirm = $mdDialog
                                            .confirm({
                                                multiple: true
                                            })
                                            .title('Attenzione')
                                            .ariaLabel('Attenzione')
                                            .textContent("Sicuro di voler proseguire? Verrà eseguita l'operazione: "+($scope.transition?$scope.transition.label:$scope.stateInitial.label))
                                            .ok('Si')
                                            .cancel('Ops, ho sbagliato');

                                        return $mdDialog
                                            .show(confirm)
                                            .then(
                                                function() {
                                                    $scope.loading = true;
                                                    vm.entity.loading = true;
                                                    if ($scope.img.fileObj && $scope.img.fileObj[0]) {
                                                        vm.entity.attachment = {
                                                            "fileName" : $scope.img.fileObj[0].name,
                                                            "fileType": $scope.img.fileObj[0].type
                                                        };
                                                        var reader = new FileReader();
                                                        reader.onload = function () {
                                                          //$log.info(reader.result);
                                                          vm.entity.attachment.fileBase64 = reader.result;
                                                          $scope.save();
                                                        };
                                                        reader.onerror = function (error) {
                                                            $log.info('Error: ', error);
                                                            $scope.loading = false;
                                                            delete vm.entity.loading;
                                                        };
                                                        reader.readAsDataURL($scope.img.fileObj[0]);
                                                    } else {
                                                        $scope.save();
                                                    }
                                                }
                                            )
                                            .finally(
                                                function() {
                                                    confirm = undefined;
                                                }
                                            );

                                    };

                                    $scope.close = function () {
                                        $mdDialog.hide(true);
                                    };
                                }]
                        });
                        return $mdDialog
                            .show(confirm);
                    };

                    /* WATCHO wkflow bind */
                    $scope.$watch("ab.wkflow", function () {
                        vm.initTransitionAndInitialStates();
                    });
                    $scope.$watch("ab.wkstate", function () {
                        vm.initTransitionAndInitialStates();
                    });
                    $scope.$watch("ab.entity", function () {
                        vm.initTransitionAndInitialStates();
                    });
                    $scope.$watch("ab.list", function () {
                        //$log.info("watch ab.entityList");
                        //$log.info(vm.list);
                        vm.initTransitionAndInitialStates();
                    });
                    vm.initTransitionAndInitialStates = function() {
                        if (vm.entity && vm.wkflow) {
                            vm.transitionsFrom = WkflowService.transitionsFrom(vm.entity, vm.wkflow);
                            if (!vm.transitionsFrom || vm.transitionsFrom.length == 0) {
                                var wkstate = WkflowService.getState(vm.entity, vm.wkflow);
                                if (!wkstate) {
                                    vm.statesInitial = WkflowService.statesInitial(vm.wkflow);
                                } else {
                                    vm.statesInitial = null;
                                }
                            }
                        } else if (vm.list && vm.wkflow && vm.wkstate) {
                            vm.statesInitial = null;
                            vm.transitionsFrom = WkflowService.transitionsFromByStateName(vm.wkflow, vm.wkstate);
                        }
                    }
                 },
            ],
        };
    }
})();

(function () {
    "use strict";
    angular.module("xipnyWkflow").directive("xipnyWkflowEntityList", xipnyWkflowEntityList);
    function xipnyWkflowEntityList() {
        return {
            restrict: "E",
            templateUrl:
                "app/xipny-wkflow/directives/wk-entity-list/wk-entity-list.html",
            bindToController: {
                user: "=",
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                "$window",
                "$scope",
                "$log",
                "$location",
                "$timeout",
                "$http",
                "$mdSidenav",
                "$mdDialog",
                "$mdToast",
                "$filter",
                "WkflowService",
                "LeadService",
                "env",
                "CustomerService",
                "CrudService",
                "Italia",
                "UsersService",
                "AppointmentsService",
                function (
                    $window,
                    $scope,
                    $log,
                    $location,
                    $timeout,
                    $http,
                    $mdSidenav,
                    $mdDialog,
                    $mdToast,
                    $filter,
                    WkflowService,
                    LeadService,
                    env,
                    CustomerService,
                    CrudService,
                    Italia,
                    UsersService,
                    AppointmentsService
                ) {
                    var vm = this;
                    $log.info("xipnyWkflowEntityList");
                    vm.mdToast = $mdToast;
                    vm.mdDialog = $mdDialog;
                    vm.env = env;
                    vm.Italia = Italia;
                    /* Operatore connesso */
                    if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
                        return;
                    }
                    /**
                     * carica wkflows e wkstates in oggetto vm
                     */
                    WkflowService.loadAll(vm, function() {
                        vm.eListLoad();
                    });

                    vm.searchWkflowChanged = function() {
                        vm.eStatus.wkstate = null;
                        vm.eListLoad(1);
                    };


                    //---------- Leads Table -------------------------------------//
                    vm.today = new Date(
                        moment().hours(0).minutes(0).seconds(0)
                    );


                    vm.eStatus = {
                        filter_from: null,
                        filter_to: null,
                        filter_upd_to: null,
                        filter_upd_from: null,
                        wkflow: null,
                        wkstate: null,
                    };
                    vm.selected = [];
                    vm.options = {
                        autoSelect: false,
                        boundaryLinks: true,
                        pageSelector: true,
                        rowSelection: false,
                        pageSelect: true,
                    };
                    vm.filter = {
                        options: {
                            debounce: 0,
                            updateOn: "default",
                        },
                    };
                    vm.entityList = {"data": null};
                    vm.query = {
                        filter: "",
                        order: null,
                        limit: 10,
                        page: 1,
                    };
                    vm.removeSearch = function (filter) {
                        if (filter) {
                            vm.query.filter = filter;
                        } else {
                            vm.query.filter = "";
                        }
                        vm.query.order = null;
                        vm.eStatus.filter_from = null;
                        vm.eStatus.filter_to = null;
                        vm.eStatus.filter_upd_from = null;
                        vm.eStatus.filter_upd_to = null;
                        vm.eStatus.wkflow = null;
                        vm.eStatus.wkstate = null;
                        vm.query.page = 1;
                        vm.eListLoad();
                    };
                    vm.eList = [];
                    vm.entityList.data = vm.eList;
                    vm.eListLoading = false;
                    vm.allSelected = false;
                    vm.eListPag = {
                        total: 0,
                        count: 10,
                        per_page: 10,
                        current_page: 1,
                        total_pages: 0,
                        links: {},
                    };
                    vm.eListLoad = function (p, s) {
                        vm.allSelected = false;
                        vm.eList = [];
                        vm.entityList.data = vm.eList;
                        /**
                         * Per inserire notifiche unreaded
                         */
                        $scope.$parent.main.wkList = vm.eList;

                        //$log.info("list wkflow is:");
                        //$log.info(vm.eStatus.wkflow);
                        vm.saveStatus();
                        if (!vm.eStatus.wkflow
                            || !vm.eStatus.wkflow.name
                            || !vm.eStatus.wkflow.entity) {
                            $log.info("eListLoad: wkflow non indicato" );
                            return;
                        }
                        vm.eListLoading = true;
                        vm.eList = [];
                        vm.entityList.data = vm.eList;
                        /**
                         * Per inserire notifiche unreaded
                         */
                         $scope.$parent.main.wkList = vm.eList;
                        if (p == null) {
                            p = vm.query.page;
                        }
                        if (s == null) {
                            s = parseInt(vm.eListPag.per_page);
                        }
                        var pars = {
                            page: p,
                            s: s,
                            with: "customer;parent;childs;transitionLast",
                            searchJoin: "and",
                            c_role: vm.user.type,
                            c_sid: vm.user.store_id,
                        };
                        var pstr = "";
                        if (vm.query.filter != null && vm.query.filter != "") {
                            pars.filtro = vm.query.filter;
                            pstr += "&filtro=" + pars.filtro;
                        }

                        var search = new Array();
                        var searchFields = new Array();

                        /**
                         * Ricerca su wkflow e stato
                         */
                         if (vm.eStatus.wkflow && vm.eStatus.wkflow.name) {
                            search.push(vm.eStatus.wkflow.entity_flow+":" + vm.eStatus.wkflow.name);
                            searchFields.push(vm.eStatus.wkflow.entity_flow+":=");
                        }
                        if (vm.eStatus.wkstate && vm.eStatus.wkstate != "") {
                            search.push(vm.eStatus.wkflow.entity_state+":" + vm.eStatus.wkstate);
                            searchFields.push(vm.eStatus.wkflow.entity_state+":=");
                        }
                        if (
                            vm.eStatus.filter_from != null &&
                            vm.eStatus.filter_from != ""
                        ) {
                            pars.created_from = moment(vm.eStatus.filter_from).format(
                                "YYYY-MM-DD"
                            );
                            pstr += "&created_from=" + pars.created_from;
                        }
                        if (
                            vm.eStatus.filter_to != null &&
                            vm.eStatus.filter_to != ""
                        ) {
                            pars.created_to = moment(vm.eStatus.filter_to)
                                .add("day", 1)
                                .format("YYYY-MM-DD");
                            pstr += "&created_to=" + pars.created_to;
                        }
                        if (
                            vm.eStatus.filter_upd_from != null &&
                            vm.eStatus.filter_upd_from != ""
                        ) {
                            pars.updated_from = moment(vm.eStatus.filter_upd_from).format(
                                "YYYY-MM-DD"
                            );
                            pstr += "&updated_from=" + pars.updated_from;
                         ;
                        }
                        if (
                            vm.eStatus.filter_upd_to != null &&
                            vm.eStatus.filter_upd_to != ""
                        ) {
                            pars.updated_to = moment(vm.eStatus.filter_upd_to)
                                .add("day", 1)
                                .format("YYYY-MM-DD");
                            pstr += "&updated_to=" + pars.updated_to;
                        }

                        pars.search = search.join(";");
                        pars.searchFields = searchFields.join(";");
                        if (vm.query.order != null && vm.query.order != "") {
                            pars.orderBy =
                                vm.query.order.indexOf("-") == 0
                                    ? vm.query.order.substring(1)
                                    : vm.query.order;
                            pars.sortedBy =
                                vm.query.order.indexOf("-") == 0
                                    ? "desc"
                                    : null;
                            pstr += "&orderBy=" + pars.orderBy;
                            pstr += "&sortedBy=" + pars.sortedBy;
                        }

                        CrudService.all(vm.eStatus.wkflow.entity, pars, vm,
                            function (response) {
                                if (response.data && response.data.data) {
                                    //response.data.meta.pagination.per_page = vm.eListPag.per_page;
                                    vm.eListPag = response.data.meta.pagination;
                                    vm.eList = response.data.data;
                                    vm.entityList.data = vm.eList;
                                    /**
                                     * Per inserire notifiche unreaded
                                     */
                                    $scope.$parent.main.wkList = vm.eList;
                                    angular.forEach(vm.eList, function(el) {
                                        el.wkstate = {data: WkflowService.getState(el, vm.eStatus.wkflow)};
                                        if (el.created_at) {
                                            if (el.created_at.date) {
                                                el.created_at_frmt = moment(el.created_at.date).format('DD/MM/YYYY HH:mm');
                                            }
                                        }
                                        if (el.updated_at) {
                                            if (el.updated_at.date) {
                                                el.updated_at_frmt = moment(el.updated_at.date).format('DD/MM/YYYY HH:mm');
                                            }
                                        }
                                        if (el.childs && el.childs.data) {
                                            angular.forEach(el.childs.data, function(c) {
                                                c.customer = el.customer;
                                                c.wkstate = {data: WkflowService.getState(c, vm.eStatus.wkflow)};
                                                if (c.created_at) {
                                                    if (c.created_at.date) {
                                                        c.created_at_frmt = moment(c.created_at.date).format('DD/MM/YYYY HH:mm');
                                                    }
                                                }
                                                if (c.updated_at) {
                                                    if (c.updated_at.date) {
                                                        c.updated_at_frmt = moment(c.updated_at.date).format('DD/MM/YYYY HH:mm');
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                                vm.eListLoading = false;
                            },
                            function (response) {
                                var errMsg = "";
                                if (
                                    response.data != null &&
                                    response.data.message != null
                                ) {
                                    errMsg =
                                        response.data != null &&
                                        response.data.message != null
                                            ? response.data.message + "."
                                            : ".";
                                    var url =
                                        response.config != null &&
                                        response.config.url != null
                                            ? response.config.url
                                            : "";
                                    if (url != null) {
                                        errMsg += "\nUrl: " + url;
                                    }
                                }
                                alert(
                                    "Si è verificato un errore nel caricamento clienti: " +
                                        errMsg
                                );
                                vm.eListLoading = false;
                            }
                        );
                    };

                    vm.showNote = function (a) {
                        if (a.note == null || a.note.trim() == "") return;
                        var p = $mdDialog
                            .confirm()
                            .title(
                                "Nota su " +
                                    (a.customer.data.firstname != null
                                        ? a.customer.data.firstname.toUpperCase()
                                        : "") +
                                    " " +
                                    (a.customer.data.lastname != null
                                        ? a.customer.data.lastname.toUpperCase()
                                        : "")
                            )
                            .textContent(a.note)
                            .ok("Ok");
                        return $mdDialog.show(p);
                    };

                    /**
                         * Documenti cliente
                         */
                    vm.showDocuments = function( a ) {
                        var dialog = $mdDialog.confirm({
                            title: 'Elenco documenti di ' + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
                            + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'') + " (eid="+a.id+" cid="+a.customer_id+")",
                            ariaLabel: 'Documenti',
                            templateUrl: 'app/xipny-wkflow/directives/wk-entity-list/dialogs/customer-documents.html',
                            escapeToClose: true,
                            controller: [ '$scope', '$mdDialog', '$filter', '$http', '$log',  function( $scope, $mdDialog, $filter, $http, $log ) {
                                $scope.title = this.title;
                                $scope.button_ok = 'Chiudi';
                                $scope.customer = a.customer.data;
                                $scope.env = vm.env;
                                $scope.token = vm.token;
                                $scope.refresh = function() {
                                    /**
                                     * ricarico documenti cliente
                                     */
                                    //$log.info("http.get: "+$scope.env.API+"/documents?customer_id="+$scope.app.customer_id);
                                    $scope.loading = true;
                                    $http.get($scope.env.API+"/documents?customer_id="+$scope.customer.id).then(
                                        function (response) {
                                            //$log.info(response.data.data);
                                            $scope.customer.documents = {'data': response.data.data };
                                            $scope.loading = false;
                                        },
                                        function (response) {
                                            //$log.info(response);
                                            $scope.loading = false;
                                        }
                                    );
                                };
                                $scope.close = function() {
                                    $mdDialog.hide( true );
                                };
                                $scope.refresh();
                            }]
                        });

                        return $mdDialog
                            .show( dialog )
                            .finally(
                                function() {
                                    dialog = undefined;
                                }
                            )
                        ;
                    };

                    vm.toggleAllSelected = function () {
                        vm.allSelected = !vm.allSelected;
                        angular.forEach(vm.eList, function (elem) {
                            //if (!elem.closed && !elem.f_oper && !elem.f_dup) {
                            if (elem[vm.eStatus.wkflow.entity_state] == vm.eStatus.wkstate) {
                                elem.isSelected = vm.allSelected;
                            }
                            //}
                        });
                    };
                    vm.toggleSelected = function (e) {
                        e.isSelected = !e.isSelected;
                    };
                    vm.saveStatus = function () {
                        //if (true) return;
                        localStorage.setItem(
                            vm.env.currentTenant + "_leads_eStatus",
                            angular.toJson(vm.eStatus, false)
                        );
                        localStorage.setItem(
                            vm.env.currentTenant + "_leads_query",
                            angular.toJson(vm.query, false)
                        );
                    };
                    vm.restoreStatus = function () {
                        //if (true) return;
                        var eStatus = angular.fromJson(
                            localStorage.getItem(
                                vm.env.currentTenant + "_leads_eStatus"
                            )
                        );
                        if (eStatus != null) {
                            angular.merge(vm.eStatus, eStatus);
                        }
                        var query = angular.fromJson(
                            localStorage.getItem(
                                vm.env.currentTenant + "_leads_query"
                            )
                        );
                        if (query != null) {
                            angular.merge(vm.query, query);
                        }
                    };
                    vm.restoreStatus();
                    vm.onKeyPressSearch = function (event) {
                        if (event.keyCode == 13) {
                            if (vm.query.filter != null) {
                                vm.query.filter = vm.query.filter.trim();
                                if (vm.query.filter.length == 1) {
                                    vm.query.order = "customers.lastname";
                                }
                            }
                            vm.eListLoad(1);
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    };

                    vm.eListReOrder = function (column) {
                        vm.query.order = column;
                        vm.eListLoad(1);
                    };

                    vm.removeFromEList = function (lead) {
                        var ind = vm.eList.indexOf(lead);
                        if (ind >= 0) {
                            vm.eList.splice(ind, 1);
                        }
                    };

                    //---------- Sidebar -------------------------------------//
                    vm.rowClicked = function (lead) {
                        vm.toggleRight(lead);
                    };
                    //vm.undoVisible = false;
                    vm.img_loading = false;
                    vm.loading = false;
                    vm.activeE = {};
                    vm.backupE = {};
                    vm.toggleRight = function (lead) {
                        if (!lead) {
                            if (vm.eStatus.wkflow) {
                                lead = {};
                                lead[vm.eStatus.wkflow.entity_flow] = vm.eStatus.wkflow.name;
                            } else {
                                lead = {};
                            }
                            lead.customer = {"data": {"birthdate": null}};
                            lead.campagna = "Inserito da gestionale";
                        }
                        vm.activeE = lead;
                        vm.activeE.moveTo = null;
                        angular.copy(lead, vm.backupE);
                        $timeout($mdSidenav("right").open, 0);
                    };
                    /**
                     * Caso nuovo inserimento: Carica cliente se esiste già
                     * Caso modifica cell: Controlla se esiste e nel caso da errore
                     */
                    vm.checkPhoneExists = function() {
                        vm.activeCustomer = vm.activeE.customer.data;
                        vm.customerExists = {};
                        if (vm.activeCustomer
                                && vm.activeCustomer.phone
                                && vm.activeCustomer.phone.trim()!='')
                        {
                            vm.phoneChecking = true;
                            CustomerService.all(
                                {'filtro': vm.activeCustomer.phone,
                                'search': 'phone:'+vm.activeCustomer.phone,
                                'searchFields':'phone:='
                              }).then(
                                  function(response) {
                                    vm.phoneChecking = false;
                                    if(response.data.data.length >= 1
                                        && (!vm.activeCustomer.id || response.data.data[0].id != vm.activeCustomer.id)) {
                                        $scope.eForm.phone.$setValidity('alreadyexists', !vm.activeCustomer.id);
                                        vm.customerExists = response.data.data[0];
                                        if (!vm.activeCustomer.id) {
                                            vm.activeE.customer.data = vm.customerExists;
                                        }
                                    } else {
                                        $scope.eForm.phone.$setValidity('alreadyexists', true);
                                    }
                                  },
                                  function(response) {
                                      vm.phoneChecking = false;
                                  }
                              );
                        }
                      };
                    vm.resetAll = function () {
                        vm.activeE = {};
                        vm.backupE = {};
                        /**
                         * In questo modo riesegue la init
                         */
                        vm.eStatus.showDatePicker = false;

                        return $timeout(vm.resetForm, 0);
                    };
                    vm.closeSidebar = function () {
                        vm.undo();
                        return vm.resetAll();
                    };
                    vm.resetForm = function () {
                        return $mdSidenav("right")
                            .close()
                            .then(function () {
                                $scope.eForm.$setPristine();
                                $scope.eForm.$setUntouched();
                            });
                    };
                    vm.showActionToast = function (text) {
                        text =
                            text && angular.isDefined(text)
                                ? text
                                : "Tutto Ok!";
                        var toast = $mdToast
                            .simple()
                            .textContent(text)
                            .action("")
                            .highlightAction(true)
                            .position("bottom right");
                        return $mdToast.show(toast).finally(function () {
                            toast = undefined;
                        });
                    };
                    vm.responseStatusSuccessful = [200, 201, 202];
                    vm.checkResponse = function (response) {
                        vm.saving = false;
                        if (
                            vm.responseStatusSuccessful.indexOf(
                                response.status
                            ) === -1
                        ) {
                            var errMsg = "";
                            if (
                                response.data != null &&
                                response.data.message != null
                            ) {
                                errMsg =
                                    response.data != null &&
                                    response.data.message != null
                                        ? response.data.message
                                        : "";
                                var url =
                                    response.config != null &&
                                    response.config.url != null
                                        ? response.config.url
                                        : "";
                                vm.showActionToast("KO: " + errMsg + " " + url);
                            }
                            var alert = $mdDialog
                                .alert()
                                .title("Attenzione")
                                .ariaLabel("Attenzione")
                                .textContent("C'è stato un problema: " + errMsg)
                                .ok("Ok");
                            return $mdDialog.show(alert).finally(function () {
                                alert = undefined;
                            });
                        } else {
                            vm.showActionToast();
                            return vm.resetAll();
                        }
                    };
                    vm.update = function (lead, archivia, sendWa) {
                        $log.info("Update");
                        //$log.info(lead);
                        if (angular.isDefined(lead)) {
                            var tM = 'aggiornare';
                            if (!lead.id) {
                                tM = 'inserire';
                            }
                            var msg = "Sicuro di voler "+tM+"?";
                            if (
                                lead.call_state == "fuori zona" &&
                                lead.moveTo != null
                            ) {
                                msg =
                                    "Sicuro di voler inviare il lead a " +
                                    lead.moveTo.label +
                                    " ed eliminarlo da qui?";
                            } else {
                                delete lead.moveTo;
                            }
                            var confirm = $mdDialog
                                .confirm()
                                .title("Attenzione")
                                .ariaLabel("Attenzione")
                                .textContent(msg)
                                .ok("Si")
                                .cancel("Ops, ho sbagliato");
                            return $mdDialog
                                .show(confirm)
                                .then(function () {
                                    vm.saving = true;
                                    //angular.copy(customer, vm.update_customer);
                                    var call_date = null;
                                    //$log.info(lead.call_date);
                                    if (lead.call_date) {
                                        var nd = new Date(lead.call_date);
                                        call_date = $filter("date")(
                                            nd,
                                            "yyyy-MM-dd HH:mm:ss"
                                        );
                                        lead.indata = nd;
                                    } else {
                                        lead.indata = null;
                                    }
                                    var updObj = {};
                                    if (lead.moveTo != null) {
                                        updObj = {
                                            id: lead.id,
                                            move_to: lead.moveTo.tenant,
                                            c_role: vm.user.type,
                                            c_sid: vm.user.store_id,
                                        };
                                    } else if (lead.call_state == "spostato") {
                                        //mando a booking sposta
                                        //vado in booking passando id appuntamento e una volta preso il nuovo appuntamento setto come disdetto questo
                                        var nl =
                                            vm.env.booking +
                                            "/operator?store=" +
                                            lead.appointment.data.store_id +
                                            "&tenant=" +
                                            vm.env.currentTenant +
                                            "&c_sid=" +
                                            vm.user.store_id +
                                            "&c_role=" +
                                            vm.user.type +
                                            "&customer=" +
                                            lead.customer.data.phone +
                                            "&callcenter=" +
                                            (vm.user.type == "callcenter") +
                                            "&appointment=" +
                                            lead.appointment.data.id +
                                            "&treatment=" +
                                            lead.appointment.data.treatment_id +
                                            "&appointmentDate=" +
                                            moment(
                                                lead.appointment.data.date_start
                                            ).format("YYYY-MM-DD HH:mm") +
                                            "&token=" +
                                            vm.token;
                                        //alert (nl);
                                        window.location.href = nl;
                                        return;
                                    } else {
                                        var props = ['firstname', 'lastname',
                                            'email', 'gender', 'birthdate', 'address', 'phone',
                                            'city', 'province', 'zip_code'
                                        ];
                                        var customerData = {};
                                        for (var k in lead.customer.data) {
                                            if (props.indexOf(k) >= 0) {
                                                if (k=='birthdate' && lead.customer.data[k]) {
                                                    customerData[k] = moment(lead.customer.data[k]).format('YYYY-MM-DD');
                                                } else {
                                                    customerData[k] = lead.customer.data[k];
                                                }
                                            }
                                        }
                                        updObj = {
                                            id: lead.id?lead.id:null,
                                            //call_date: call_date,
                                            //call_state: lead.call_state,
                                            note: lead.note,
                                            customer: customerData,
                                            c_role: vm.user.type,
                                            c_sid: vm.user.store_id,
                                        };
                                        if (!lead.archived && archivia) {
                                            updObj.archived = true;
                                            lead.archived = true;
                                            updObj.archived_by = vm.user.id;
                                            lead.archived_by = vm.user.id;
                                        }
                                    }
                                    if (updObj.id) {
                                        LeadService.update(updObj).then(
                                            function (response) {
                                                vm.checkResponse(response);
                                                if (lead.moveTo != null) {
                                                    vm.removeFromEList(lead);
                                                } else if (lead.archived) {
                                                    vm.removeIfArchived("0", lead);
                                                }
                                                if (
                                                    lead.categoria == "conferma" &&
                                                    lead.appointment_id
                                                ) {
                                                    if (
                                                        lead.call_state == "disdetto" &&
                                                        lead.appointment.data.recalled <
                                                            3
                                                    ) {
                                                        AppointmentsService.update({
                                                            id: lead.appointment_id,
                                                            recalled: 3,
                                                            paid: 0,
                                                        }).then(function () {
                                                            lead.appointment.data.recalled = 3;
                                                            vm.showActionToast(
                                                                "Appuntamento disdetto."
                                                            );
                                                        }, vm.checkResponse);
                                                    } else if (
                                                        lead.call_state ==
                                                            "confermato" &&
                                                        lead.appointment.data.recalled <
                                                            4 &&
                                                        lead.appointment.data
                                                            .recalled != 1
                                                    ) {
                                                        AppointmentsService.update({
                                                            id: lead.appointment_id,
                                                            recalled: 1,
                                                        }).then(function () {
                                                            lead.appointment.data.recalled = 1;
                                                            vm.showActionToast(
                                                                "Appuntamento confermato."
                                                            );
                                                        }, vm.checkResponse);
                                                    } else if (
                                                        lead.call_state.indexOf("NR") >=
                                                            0 &&
                                                        lead.appointment.data.recalled <
                                                            4 &&
                                                        lead.appointment.data
                                                            .recalled != 2
                                                    ) {
                                                        AppointmentsService.update({
                                                            id: lead.appointment_id,
                                                            recalled: 2,
                                                        }).then(function () {
                                                            lead.appointment.data.recalled = 2;
                                                            vm.showActionToast(
                                                                "Appuntamento aggiornato."
                                                            );
                                                        }, vm.checkResponse);
                                                    }
                                                }
                                                $scope.$parent.main.alertsDachiamareRefresh();
                                                if (sendWa) {
                                                    //$log.info(lead);
                                                    $window.open(
                                                        "https://api.whatsapp.com/send?phone=" +
                                                            env.countryCode +
                                                            lead.customer.data.phone +
                                                            "&text=" +
                                                            window.encodeURIComponent(
                                                                lead.note
                                                            ),
                                                        "WhatsUp"
                                                    );
                                                }
                                            },
                                        vm.checkResponse);
                                    } else { //creazione entity
                                        updObj.campagna = lead.campagna;
                                        //per aggangiare la transizione iniziale su questo wkflow
                                        updObj[vm.eStatus.wkflow.entity_flow] = vm.eStatus.wkflow.name;
                                        LeadService.save(updObj).then(
                                            function (response) {
                                                vm.checkResponse(response);
                                                var wk = vm.eStatus.wkflow;
                                                vm.removeSearch(updObj.customer.phone);
                                                vm.eStatus.wkflow = wk;
                                                //vm.query.filter = updObj.customer.phone;
                                                vm.eStatus.filter_from = moment();
                                                vm.eListLoad();
                                            },
                                            vm.checkResponse);
                                    }
                                })
                                .finally(function () {
                                    confirm = undefined;
                                });
                        }
                    };
                    vm.undo = function () {
                        $log.info("Undo");

                        if (!angular.equals(vm.activeE, vm.backupE)) {
                            angular.copy(vm.backupE, vm.activeE);
                        }

                        return vm.resetAll();
                    };

                    /* WATCHO Lo Store */
                    vm.storesList = null;
                    vm.storeId = null;
                    $scope.$watch("$parent.selectedStore", function (id) {
                        vm.storeId = id;
                    });
                },
            ],
        };
    }
})();

(function() {
  'use strict';

    angular
        .module(
            'admin',
            [
                'ngAnimate',
                'ngCookies',
                'ngSanitize',
                'ngMessages',
                'ngAria',
                'ngResource',
                'restangular',
                'ui.router',
                'ngMaterial',
                'toastr',
                'md.data.table',
                'ui.calendar',
                'ngMaterialDatePicker',
                'satellizer',
                'chart.js',
                'daterangepicker',
                'colorpicker.module',
                'vcRecaptcha',
                'ngRateIt',
                'angular-notification-icons'
                ,'pusher-angular'
                ,'angularjs-gauge'
                ,'xipnyWkflow'
            ]
        )
    ;

})();

(function () {
    "use strict";
    angular.module("admin").directive("xipnyWkflowEntityHistoryButton", xipnyWkflowEntityHistoryButton);
    function xipnyWkflowEntityHistoryButton() {
        return {
            restrict: "E",
            templateUrl:
                "app/xipny-wkflow/directives/wk-entity-history-button/wk-entity-history-button.html",
            bindToController: {
                entity: "=",
                user: "=",
                wkflow: "="
            },
            scope: true,
            controllerAs: "vm",
            controller: [
                "$filter",
                "$scope",
                "$mdDialog",
                "CrudService",
                function ($filter, $scope, $mdDialog, CrudService) {
                    var vm = this;
                    vm.showHistory = function (a) {
                        if (!a) {
                            a = vm.entity;
                        }
                        if (!a.customer.data) {
                            a.customer.data = a.customer;
                        }

                        var dialog = $mdDialog.confirm({
                            title:
                                "Storico Modifiche: " +
                                a.campagna +
                                " di " +
                                (a.customer.data.firstname != null
                                    ? a.customer.data.firstname.toUpperCase()
                                    : "") +
                                " " +
                                (a.customer.data.lastname != null
                                    ? a.customer.data.lastname.toUpperCase()
                                    : "") +
                                " del " +
                                a.created_at_frmt +
                                " (lid=" +
                                a.id +
                                ")",
                            ariaLabel: "Storia Modifiche",
                            templateUrl: "app/xipny-wkflow/directives/wk-entity-history-button/dialogs/entity-history.html",
                            escapeToClose: true,
                            controller: [
                                "$scope",
                                "$log",
                                "$mdDialog",
                                "$filter",
                                "WkflowService",
                                function ($scope, $log, $mdDialog, $filter, WkflowService) {
                                    $scope.title = this.title;
                                    $scope.button_ok = "Chiudi";
                                    $scope.user = vm.user;
                                    $scope.transitionlogs = [];
                                    $scope.activities = [];
                                    $scope.loadingAct = true;
                                    $scope.loadingLog = true;
                                    $scope.entity = vm.entity;
                                    $scope.loadActivities = function () {
                                        var pars = {
                                            log_name: "default",
                                            subject_type: "App\\Entities\\Lead",
                                            subject_id: a.id,
                                            with: "causer;subject",
                                        };
                                        $scope.loadingAct = true;
                                        $scope.activities = [];
                                        CrudService.all(
                                            "activity_log",
                                            pars,
                                            vm,
                                            function (response) {
                                                angular.forEach(
                                                    response.data.data,
                                                    function (act) {
                                                        act.created_at_frmt = moment(
                                                            act.created_at
                                                        ).format(
                                                            "DD/MM/YYYY HH:mm:ss"
                                                        );
                                                        $scope.activities.push(
                                                            act
                                                        );
                                                    }
                                                );
                                                $scope.loadingAct = false;
                                            },
                                            function (response) {
                                                var errMsg = "";
                                                if (
                                                    response.data != null &&
                                                    response.data.message !=
                                                        null
                                                ) {
                                                    errMsg =
                                                        response.data != null &&
                                                        response.data.message !=
                                                            null
                                                            ? response.data
                                                                  .message + "."
                                                            : ".";
                                                    var url =
                                                        response.config !=
                                                            null &&
                                                        response.config.url !=
                                                            null
                                                            ? response.config
                                                                  .url
                                                            : "";
                                                    if (url != null) {
                                                        errMsg +=
                                                            "\nUrl: " + url;
                                                    }
                                                }
                                                alert(
                                                    "Si è verificato un errore nel caricamento delle attività: " +
                                                        errMsg
                                                );
                                                $scope.loadingAct = false;
                                            }
                                        );
                                    };
                                    $scope.loadingLog = true;
                                    WkflowService.getTransitionLogs(vm.entity, vm.wkflow).then(
                                        function(response) {
                                            $scope.loadingLog = false;
                                            $scope.transitionLogs = response.data.data;
                                            angular.forEach($scope.transitionLogs, function(t){
                                                t.created_at_frmt = moment(t.created_at.date?t.created_at.date:t.created_at).format('DD/MM/YYYY HH:mm');
                                            });
                                        },
                                        function(response) {
                                            $log.error(response);
                                            $scope.loadingLog = false;
                                        }
                                    );
                                    $scope.close = function () {
                                        $mdDialog.hide(true);
                                    };
                                    $scope.loadActivities();
                                },
                            ],
                        });

                        return $mdDialog.show(dialog).finally(function () {
                            dialog = undefined;
                        });
                    };
                },
            ],
        };
    }
})();

(function() {
    'use strict';

    angular
        .module( 'xipnyWkflow' )
        .service(
            'WkflowService',
            [
                '$log',
                'env',
                '$http',
                function(
                    $log,
                    env,
                    $http
                ) {
                    return {
                        loadAll: function(vm, callback) {
                            this.load(vm, null, callback);
                        },
                        loadOne: function(vm, name, callback) {
                            this.load(vm, {search: 'name:'+name, searchFields: 'name:='}, callback);
                        },
                        load: function(vm, pars, callback) {
                            if (!pars) {
                                pars = {};
                            }
                            pars.with = 'transitions';
                            var _this = this;
                            this.all('wkflows', pars).then(function(response) {
                                vm.wkflows = response.data.data;
                                var spars = {};
                                if (vm.wkflows.length == 1) {
                                    spars.search = 'wkflow_id:'+vm.wkflows[0].id;
                                    spars.searchFields = 'wkflow_id:=';
                                }
                                _this.all('wkstates', spars).then(function(response) {
                                    vm.wkstates = response.data.data;
                                    angular.forEach(vm.wkstates, function(s) {
                                        angular.forEach(vm.wkflows, function(w) {
                                            if (!w.states) {
                                                w.states = {data: []};
                                            }
                                            if (s.wkflow_id == w.id) {
                                                w.states.data.push(s);
                                                //s.wkflow = w;
                                                //$log.info("Wkflow for "+s.name+" is "+w.name);
                                                //$log.info(s);
                                            }
                                        });
                                    });
                                    if (vm.wkflows.length == 1) {
                                        vm.wkflow = vm.wkflows[0];
                                    }
                                    vm.wkFlowLoaded = true;
                                    if (callback) {
                                        callback(vm.wkflows, vm.wkstates);
                                    }
                                });
                            });
                        },
                        all: function(path, pars) {
                            var apiURI = env.API + '/xipny/'+path;
                            return $http.get( apiURI, { params:  pars } );
                        },
                        getState: function(entity, wkflow) {
                            if (!entity[wkflow.entity_state]) return null;
                            return this.getStateByName(wkflow, entity[wkflow.entity_state]);
                        },
                        getStateByName: function(wkflow, wkstate) {
                            if (wkflow.states.data) {
                                for(var i=0; i<wkflow.states.data.length; i++) {
                                    if (wkflow.states.data[i].name == wkstate) {
                                        return wkflow.states.data[i];
                                    }
                                }
                            }
                            return null;
                        },
                        transitionsFrom: function(entity, wkflow) {
                            var wkstate = this.getState(entity, wkflow);
                            return this.transitionsFromByState(wkflow, wkstate);
                        },
                        transitionsFromByStateName: function(wkflow, wkstatename) {
                            var wkstate = this.getStateByName(wkflow, wkstatename);
                            return this.transitionsFromByState(wkflow, wkstate);
                        },
                        transitionsFromByState: function(wkflow, wkstate) {
                            var transitions = [];
                            if(wkstate) {
                                angular.forEach(wkflow.transitions.data, function(t) {
                                    if (t.wkstate_id_from == wkstate.id) {
                                        transitions.push(t);
                                    }
                                });
                            }
                            //$log.info("caricate transizioni from");
                            //$log.info(transitions);
                            return transitions;
                        },
                        statesInitial: function(wkflow) {
                            var states = [];
                            if (wkflow.states && wkflow.states.data) {
                                angular.forEach(wkflow.states.data, function(s) {
                                    if (s.initial) {
                                        states.push(s);
                                    }
                                });
                            }
                            return states;
                        },
                        getForm: function(id) {
                            var apiURI = env.API + '/xipny/wkforms/'+id + '?with=fields';
                            return $http.get( apiURI,  { params:  null });
                        },
                        saveTransition: function(entity, transition, stateInitial, note, fields) {
                            $log.info("saveTransition");
                            //$log.info(fields);
                            if (fields) {
                                angular.forEach(fields, function(f) {
                                    if (f.type == 'date') {
                                        f.data = moment(f.data).format('YYYY-MM-DD');
                                    } else if (f.type == 'datetime') {
                                        f.data = moment(f.data).format('YYYY-MM-DD HH:mm:ss');
                                    }
                                });
                                //$log.info(fields);
                            }
                            var apiURI = env.API + '/xipny/wkflows/saveTransition';
                            return $http.post( apiURI,  {
                                                wkstate_id_to: stateInitial?stateInitial.id:null,
                                                wktransition_id: transition?transition.id:null,
                                                entity_id: entity.id,
                                                note: note,
                                                wkfields: fields,
                                                attachment: entity.attachment?entity.attachment:null
                            });
                        },
                        undoTransition: function(entity, transitionlog) {
                            var apiURI = env.API + '/xipny/wkflows/undoTransition';
                            return $http.post( apiURI,  {
                                                wktransitionlog_id: transitionlog.id,
                                                entity_id: entity.id
                            });
                        },
                        getTransitionLogs: function(entity,wkflow) {
                            var apiURI = env.API + '/xipny/wktransition_logs'
                            + '?search=entity_id:'+entity.id+';wkflow_name:'+wkflow.name+'&searchFields=entity_id:=;wkflow_name:='+
                            '&with=user;wkaction;wkactionStateTo;wkform;wktransition;wkcondition;wkstateTo;wkstateFrom&orderBy=id&sortedBy=asc';
                            return $http.get( apiURI,  { params:  null });
                        }
                    };
                }
            ]
        );

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .directive('testDirectiveWithScope', function () {
            return {
                restrict: 'E',
                scope: true,
                bindToController: {
                    employees: "=",
                    data: '=',
                    delay: '=',
                    readonly: '=',
                    editable: '=',
                    customer: '=',
                    command: '=',
                    label: '='
                },
                controller: [
                    '$filter',
                    '$scope',
                    'CustomerService',
                    function(
                        $filter,
                        $scope,
                        CustomerService
                    ) {
                    this.name = "Tech Department";
                    console.log("Tech Department",this);
                    //this.employees = 1;
                }],
                controllerAs: 'vm',
                /*template: '',*/
                templateUrl: 'app/components/test-directive-with-scope/test-directive-with-scope.html'
            };
        })

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .directive('surveys', surveys);

    function surveys( 
        $timeout,
        $log,
        $mdDialog,
        CrudService,
        CustomerService
    ) {
        return {
            restrict: 'E',  
            templateUrl: 'app/components/surveys/surveys.html',  
            scope: {
                control: '='
            },          
            link: function( 
                scope,
                element,
                attrs
            ) {
				$timeout( function() {
                  
                    scope.customerId = attrs.customerid;
                    scope.editable = attrs.editable;
                    scope.customerSurvey = scope.control || {};


                    scope.mergeAnswerStructure = function (customerSurvey) {
                        
                        var surveys = scope.surveys;
                        var newCustomerSurvey = {'data': []};
            
                        if (!customerSurvey) {
                            customerSurvey = {'data': []};
                        }

                        angular.forEach(surveys, function(elem) {
                            
                            angular.forEach(elem.survey_questions, function(elem1) {

                                var answerCustomer = {
                                    id: null,
                                    answer: null,
                                    customer_id: scope.customerId,
                                    survey_id: elem1.survey_id,
                                    survey_question_id: elem1.id,
                                    created_at: null,
                                    updated_at: null,
                                    surveyQuestion: elem1,
                                    answer_choices_toArray: elem1.answer_choices_toArray
                                };
                            
                                if(customerSurvey && customerSurvey.data && customerSurvey.data.length > 0) {
                                    angular.forEach(customerSurvey.data, function(custSurvey) {
                                        if(custSurvey.survey_question_id == elem1.id) {
                                            answerCustomer.id = custSurvey.id;
                                            answerCustomer.answer = custSurvey.answer;
                                            answerCustomer.created_at = custSurvey.created_at;
                                            answerCustomer.updated_at = custSurvey.updated_at;
                                        }
                                    });
                                }


                                newCustomerSurvey.data.push(answerCustomer);

                            });    
            
                        });
                 
                        return newCustomerSurvey;
                    }


                    scope.loadCustomerSurveys = function() {
                        CustomerService.get(
                            scope.customerId, 
                            {'with': 'customerSurvey'}
                        )
                        .then(function(response) {
                            if (response.data && response.data.data) {
                                
                                scope.customerSurvey.data = scope.mergeAnswerStructure(response.data.data.customerSurvey);

                            }    
                        });
                    }


                    scope.loadSurveyQuestion = function(){
                        scope.eListLoading = true;
                        var pars = {
                            'search': 'f_active:1',
                            'searchFields': 'f_active:=',
                            'with' : 'surveyQuestions'
                        };

                        CrudService.all('surveys', pars, scope, function (response) {
                            scope.surveys = response.data.data;
                            angular.forEach(scope.surveys, function(elem) {
                                angular.forEach(elem.survey_questions, function(elem1) {
                                    if(elem1.answer_type && elem1.answer_type !="open" && elem1.answer_choices) {
                                        var answer_choices_toArray = elem1.answer_choices.split(";");
                                        elem1.answer_choices_toArray = answer_choices_toArray;
                                    }
                                });    
                           });
                           scope.eListLoading = false;
                           scope.loadCustomerSurveys();
                         },
                         function (response) {
                            scope.eListLoading = false;
                           var errMsg = "";
                           if (response.data!=null
                                   && response.data.message!=null) {
                             errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                             var url = response.config!=null && response.config.url!=null?response.config.url:"";
                             if (url!=null) {
                               errMsg+= "\nUrl: " + url;
                             }
                           }
                           alert ("Si è verificato un errore nel caricamento delle attività: " + errMsg);
                           $scope.loading = false;
                        });
                    }
                    scope.loadSurveyQuestion();



                    scope.updateSurveys = function(surveyName) {

                        $log.info('Update Survey');
                        var confirm = $mdDialog.confirm()
                        .title('Attenzione')
                        .ariaLabel('Attenzione')
                        .textContent('Sicuro di voler aggiornare?')
                        .ok('Si')
                        .cancel('Ops, ho sbagliato');
                        return $mdDialog
                            .show(confirm)
                            .then(
                                function() {
                                    scope.saving = true;
                                    
                                    var customer = {
                                        id: scope.customerId,
                                        customerSurvey: scope.customerSurvey       
                                    };

                                    CustomerService.update(customer).then(
                                        function (response) {
                                            scope.saving = false;
                                        },
                                        scope.checkResponse);
                                }
                            )
                            .finally(
                                function() {
                                    confirm = undefined;
                                }
                            );

                    }


                    scope.$on('enableSurveysForm',function(event, data){
                        scope.editable = data.editable;
                    });

                }, 0 );
            }       
        }
    };

})();

(function () {
    'use strict';

    angular
        .module('admin')
        .directive('newSurvey', newSurvey);

    function newSurvey(
        $timeout,
        $log,
        $mdToast,
        $mdDialog,
        CrudService,
        CustomerService,
        env
    ) {
        return {
            restrict: 'E',
            templateUrl: 'app/components/new-survey/new-survey.html',
            scope: {
                control: '=',
                customersurveys: '=',
                customerid: '=',
                user: '=',
                token: '='
            },
            link: function (
                scope,
                element,
                attrs
            ) {
                scope.customerId = scope.customerid;
                scope.editable = false;
                // scope.customerSurvey = scope.control || {};
                scope.customerSurveys = [];  //All surveys of the customer
                scope.customerSurvey = null;
                scope.customerSurveySel = null;
                scope.survey = null;     // All surveys
                scope.surveys = [];     // All surveys
                scope.custSurveys = [];  // Selected surveys
                scope.surveyType = '';  // Tipo selezionato
                scope.mainEntity = null;
                scope.selectedLanguage = null;
                /* SET VM */
                var vm = this;
                vm.user = null
                vm.$mdToast = $mdToast;
                scope.selectedLanguage = '';
                scope.localLanguage = window.navigator.language || window.navigator.userLanguage;


                if (scope.customersurveys) {
                    scope.customerSurveys = scope.customersurveys
                }
                if (attrs.user) {
                    vm.user = scope.user;
                }

                /*SET DEFAULT MAINENTITY*/
                scope.mainEntity = {
                    customer_id: scope.customerId,
                    survey_id: null,
                    user_id: vm.user.id,
                    expires_at: null,
                    customer_survey_questions: {}
                }


                scope.loadSurveyQuestion = function () {
                    scope.eListLoading = true;
                    var pars = {
                        'search': 'f_active:1',
                        'searchFields': 'f_active:=',
                        'with': 'surveyQuestions'
                    };

                    CrudService.all('surveys', pars, scope, function (response) {
                        scope.surveys = response.data.data;
                        angular.forEach(scope.surveys, function (elem) {
                            angular.forEach(elem.survey_questions, function (elem1) {
                                if (elem1.answer_type && elem1.answer_type != "open" && elem1.answer_choices) {
                                    var answer_choices_toArray = elem1.answer_choices.split(";");
                                    elem1.answer_choices_toArray = answer_choices_toArray;
                                }
                            });
                            elem.expired = scope.detectSurveyExpired(elem.id);
                        });
                        scope.eListLoading = false;
                    },
                        function (response) {
                            scope.eListLoading = false;
                            var errMsg = "";
                            if (response.data != null
                                && response.data.message != null) {
                                errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                                var url = response.config != null && response.config.url != null ? response.config.url : "";
                                if (url != null) {
                                    errMsg += "\nUrl: " + url;
                                }
                            }
                            alert("Si è verificato un errore nel caricamento delle attività: " + errMsg);
                            scope.loading = false;
                        });
                }

                /***** language ******/
                scope.languages = [];
                scope.languageLoad = function () {
                    var pars = {};
                    pars.searchFields = 'active:=';
                    pars.search = 'active:1';

                    CrudService.all('languages', pars, vm,
                        function (response) {
                            scope.languages = response.data.data;
                            scope.languages.forEach(function (elem) {
                                if (elem.locale.toUpperCase() === scope.localLanguage.toUpperCase()) {
                                    scope.selectedLanguage = elem.id.toString();
                                }
                            });
                        },
                        function (response) {
                            console.error(response);
                        }
                    );
                };
                /***** end language *****/

                /**
                 * Save customer survey v2
                 * @returns
                 */
                scope.saveCustomerSurvey = function () {

                    scope.loading = true;

                    if (!scope.customerId) {
                        var confirm1 = $mdDialog.confirm()
                            .title('Errore')
                            .ariaLabel('Attenzione')
                            .textContent('Non è possibile selezionare il cliente del questionario!')
                            .ok('OK');

                        return $mdDialog
                            .show(confirm1)
                            .then(function () {
                                scope.loading = false;
                            });
                    }

                    //CREATE OR UPDATE CUSTOMER-QUOTATION
                    //CREATE IF NOT EXIST ID.
                    if (!scope.mainEntity.id) {

                        var confirm = $mdDialog.confirm()
                            .title('Attenzione')
                            .ariaLabel('Attenzione')
                            .textContent('Sicuro di voler creare un nuovo questionario?')
                            .ok('Si')
                            .cancel('No, annulla');

                        return $mdDialog
                            .show(confirm)
                            .then(
                                function () {

                                    //ADD QUESTIONS TO REQUEST
                                    scope.mainEntity.customer_id = scope.customerId;
                                    scope.mainEntity.survey_id = scope.survey.id;
                                    scope.mainEntity.expires_at = moment().add('days', scope.survey.validity_in_days).format("YYYY-MM-DD");

                                    scope.mainEntity.customer_survey_questions = [];
                                    scope.survey.survey_questions.forEach(function (item) {
                                        scope.mainEntity.customer_survey_questions.push({
                                            survey_question_id: item.id,
                                            language_id: scope.selectedLanguage,
                                            question: item.question,
                                            answer: item.answer,
                                        });
                                    });

                                    CrudService
                                        .save(
                                            'customer_surveys_v2',
                                            scope.mainEntity,
                                            vm,
                                            function (response) {
                                                scope.loading = false;
                                                if (
                                                    response &&
                                                    response.data &&
                                                    response.data.data &&
                                                    response.data.data.id
                                                ) {
                                                    scope.mergeSurveyToCustomerSurveys(response.data.data);
                                                }
                                            },
                                            function (response) {
                                                scope.loading = false;
                                            });
                                },
                                function () {
                                    scope.loading = false;
                                }
                            )
                            .finally(
                                function () {
                                    confirm = undefined;
                                }
                            );

                    } else {
                        CrudService.update(
                            'customer_surveys_v2',
                            scope.mainEntity,
                            scope,
                            function (response) {
                                scope.loading = false;

                            },
                            function (response) {
                                scope.loading = false;
                            }
                        );
                    }

                };

                /**
                 * Scarica pdf del questionario
                 */
                 scope.onScaricaPdf = function() {
                    var url =
                        env.API+"/customer_surveys_v2/pdf/" +
                        +parseInt(scope.customerSurvey.id)
                        +"?token="+scope.token;
                    window.open(url);
                }

                /**
                 * merge new survey into customer surveys existing
                 * @param {*} survey 
                 */
                scope.mergeSurveyToCustomerSurveys = function (survey) {
                    scope.customerSurveys.push(survey);

                    // Aggiorna la scadenza del questionario
                    scope.filterSurveyById(survey.survey_id).expired = scope.detectSurveyExpired(survey.survey_id);
                    scope.editable = false;
                    scope.changeSurveyType();
                };

                // INIT
                scope.loadSurveyQuestion();
                scope.languageLoad();

                /**
                 * Change survey type
                 */
                scope.changeSurveyType = function () {
                    scope.survey = scope.filterSurveyById(parseInt(scope.surveyType));

                    var sur = scope.customerSurveys.filter(function (el) { return el.survey_id == parseInt(scope.surveyType) });
                    sur = sur.sort(function (a, b) {
                        a = parseInt(a['created_at']);
                        b = parseInt(b['created_at']);
                        return b - a;
                    });
                    if (sur.length > 0) {
                        scope.custSurveys = sur;
                        scope.customerSurveySel = sur[0].id.toString();
                        scope.changeDateCompilation();
                    } else {
                        scope.custSurveys = [];
                        scope.customerSurveySel = null;
                        scope.changeDateCompilation();
                    }
                }

                /**
                 * Change date compilation
                 */
                scope.changeDateCompilation = function () {
                    scope.customerSurvey = scope.filterCustomerSurveyById(scope.customerSurveySel)
                }

                /**
                 * Edit survey question
                 * @param {*} surveyId 
                 */
                scope.editSurvey = function () {
                    scope.survey.survey_questions.forEach(function (question) {
                        if (scope.customerSurvey) {
                            var quest = scope.customerSurvey.customerSurveyQuestions.find(function (el) { return el.survey_question_id == question.id });
                            question.answer = (quest) ? quest.answer : '';
                        }
                        else
                            question.answer = "";
                    });
                    scope.editable = true;
                }

                /**
                 * Detect if survey expired
                 */
                scope.detectSurveyExpired = function (surveyId) {
                    var now = new Date().getTime();
                    var expired = -1;
                    var surveyFiltered = scope.customerSurveys.filter(function (el) { return el.survey_id == surveyId });
                    for (var i = 0; i < surveyFiltered.length; i++) {
                        if ((surveyFiltered[i].expires_at * 1000) > now) {
                            return -1;
                        } else {
                            if (surveyFiltered[i].expires_at > expired) {
                                expired = surveyFiltered[i].expires_at;
                            }
                        }

                        if (i + 1 == surveyFiltered.length) {
                            return expired;
                        }
                    }
                }

                /**
                 * There is at least one survey that has expired
                 */
                scope.leastSurveySurveyExpired = function () {
                    var expired = -1;
                    var surveyFiltered = scope.surveys.filter(function (el) { return el.expired > -1 });
                    if (surveyFiltered.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                }


                /**
                 * Open customer survey
                 * @param {*} surveyId
                 */
                scope.openCustomerSurvey = function (surveyId) {
                    scope.surveyType = surveyId.toString();
                    scope.changeSurveyType();
                    scope.editable = false;
                }

                /**
                 * Filter customer survey by id
                 * @param {*} customerSurveyId
                 * @returns
                 */
                scope.filterCustomerSurveyById = function (customerSurveyId) {
                    var sur = scope.customerSurveys.find(function (el) { return el.id == customerSurveyId });
                    return (sur) ? sur : null;
                }

                /**
                 * Filter  survey by id
                 * @param {*} surveyId
                 * @returns
                 */
                scope.filterSurveyById = function (surveyId) {
                    var sur = scope.surveys.find(function (el) { return el.id == surveyId });
                    return (sur) ? sur : null;
                }

                /**
                 * Split answer to array
                 * @param {*} str 
                 * @returns 
                 */
                scope.splitAnswersToArray = function (str) {
                    return str.split(";");
                }

                /**
                 * Translation
                 * @param {*} arrTransls 
                 * @returns 
                 */
                scope.translation = function (arrTransls) {
                    if (arrTransls && arrTransls.length > 0) {
                        var res = arrTransls.find(function (el) { return el.language_id == scope.selectedLanguage });
                        return (res) ? res.translation : '';
                    } else {
                        return "";
                    }
                }

                /**
                 * Stamp toast
                 * @param {*} text 
                 * @returns 
                 */
                vm.showActionToast = function (text) {

                    text = text && angular.isDefined(text) ? text : 'Tutto Ok!';

                    var toast = $mdToast
                        .simple()
                        .textContent(text)
                        .action('')
                        .highlightAction(true)
                        .position('bottom right');

                    return $mdToast
                        .show(toast)
                        .finally(
                            function () {
                                toast = undefined;
                            }
                        );

                };

                scope.$watch('$parent.selectedLanguage', function (idLang) {
                    scope.selectedLanguage = parseInt(idLang);
                });

            }
        }
    };

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .directive('mdInputFileImg', mdInputFileImg);

    function mdInputFileImg( $timeout ) {
        return {
			restrict: 'E',
			templateUrl: 'app/components/md-input-file-img/md-input-file-img.html',
			bindToController: true,
			link: function( scope, element, attrs ) {
				$timeout( function() {
					scope.$apply( function() {
						scope.multiple = ( 'multiple' in attrs ) ? true : false;
						scope.required = ( 'required' in attrs ) ? true : false;
                        scope.accept = attrs['accept']?attrs['accept']:'*';
                        scope.label = scope.multiple ? "Scegli una o più Immagini" : "Scegli un'Immagine";
						scope.img = {
							fileName : null,
							fileObj : null
						};
					});
					var fileName = angular.element( element[0].querySelector('.fileName') ).first()
						, fileObj = angular.element( element[0].querySelector('.fileObj') ).first()
						, button = angular.element( element[0].querySelector('button') ).first()
					;
					if ( fileObj.length && button.length && fileName.length ) {
						if( scope.multiple ) {
							fileObj.attr( "multiple", "multiple" );
						};
                        if( scope.required ) {
							fileObj.attr( "required", "required" );
						};
						button.click( function( e ) {
							e.preventDefault();
							fileObj.click();
						});
						fileName.click( function( e ) {
							e.preventDefault();
							fileObj.click();
						});
						
						fileObj.on( 'change', function ( e ) {
							$timeout( function() {
								var files = e.target.files
                                    , filename
                                ;
                                if( files.length ) {
                                    filename = [];
                                    for ( var i = 0; i < files.length; i++ ) {
                                        filename.push( files[ i ].name );
                                    };
                                    filename = filename.join(", ");
                                } else {
                                    filename = null;
                                    files = null;
                                };
                                scope.$apply( function() {
                                    scope.img.fileName = filename;
                                    scope.img.fileObj = files;
                                });
							}, 0 );
						});
					};
				}, 0 );
			},
		};
    };

})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .directive( 'mdDatetimePicker', mdDatetimePicker )
    ;

    function mdDatetimePicker() {
        return {
            templateUrl: 'app/components/md-datetime-picker/md-datetime-picker.html',
            restrict: 'E',
            bindToController: {
                data: '=',
                delay: '=',
                readonly: '=',
                editable: '=',
                customer: '=',
                command: '=',
                label: '=',
                withdelay: '='
            },
            scope: true,
            controllerAs: 'vm',
            controller: [
                '$filter',
                '$scope',
                'CustomerService',
                function(
                    $filter,
                    $scope,
                    $log,
                    CustomerService
                ) {
                    var today = new Date( moment() )
                    var vm = this;
                    this.$log = $log;
                    this.today= today;
                    this.date= today;
                    this.hours= today.getHours();
                    this.minutes= today.getMinutes();
                    this.bypass= false;
                    this.backup= {};
                    this.update_customer= {};
                    this.loading= false;

                    //vm.backup = angular.copy( "vm.data: " + vm.data );
                    //console.log(vm);
                    // Methods
                    vm.setTime = function(ora,min,delay) {
                        console.log("setTime: " + ora + ':' + min + ':' + delay);
                        vm.hours = ora;
                        vm.minutes = min;
                        if (vm.noDelay) {
                            vm.delay = 0;
                        } else {
                            vm.delay = delay;
                        }
                        vm.changeDate();
                    };
                    vm.oggi = function() {
                        vm.datepicker = new Date(moment());
                        vm.changeDate();
                    };
                    vm.domani = function() {
                        vm.datepicker = new Date(moment().add(1,'days'));
                        vm.changeDate();
                    };
                    vm.addDays = function(i) {
                        vm.datepicker = new Date(moment(vm.datepicker).add(i, 'days'));
                        vm.changeDate();
                    };
                    vm.subDays = function(i) {
                        vm.datepicker = new Date(moment(vm.datepicker).subtract(i, 'days'));
                        vm.changeDate();
                    };
                    vm.noDalayChange = function() {
                        if (vm.noDelay) {
                            vm.delay = 0;
                        }
                    }

                    vm.changeDate = function changeDate() {
                        console.log("vm.datepicker: " + vm.datepicker);
                        if (vm.datepicker==null) {
                          vm.data = null;
                          return null;
                        }
                        var date = moment( vm.datepicker ).format( 'DD-MM-YYYY' );
                        var hours = vm.hours;
                        var minutes = vm.minutes;
                        var hoursOk = (
                                hours!=null && hours.toString().length === 1
                                ? '0' + hours
                                : hours
                            );
                         var minutesOk = (
                                minutes!=null && minutes.toString().length === 1
                                ? '0' + minutes
                                : minutes
                            );
                        var newDate = null;
                        if (hoursOk!=null && minutesOk!=null) {
                          newDate = new Date( moment( date + ' ' + hoursOk + ':' + minutesOk, 'DD-MM-YYYY HH:mm' ) );
                        } else {
                          newDate = new Date( moment( date, 'DD-MM-YYYY HH:mm' ) );
                        }


                        vm.data = newDate;
                        console.log('newDate',newDate);

                        return newDate;

                    };
                    vm.changeEditable = function changeEditable() {

                        vm.loading = false;

                        if( angular.isDefined( vm.readonly ) && vm.readonly === false && angular.isDefined( vm.editable ) )
                            vm.readonly = true;

                    };
                    // Posponi
                    vm.snooze = function snooze( customer, autosave ) {

                        var tomorrowIsSunday = ( new Date().getDay() + 1 ) % 7 === 0
                            , days2Add = (
                                ! tomorrowIsSunday
                                ? 1
                                : 2
                            )
                            , updateDay = false
                        ;

                        if( customer.change_state_counter || vm.hours >= 16 || ( vm.hours === 15 && vm.minutes >= 30 ) )
                            updateDay = true;

                        if( ! updateDay )
                            vm.hours += 4;
                        else {
                            vm.datepicker = new Date( moment( vm.datepicker ).add( days2Add, 'days' ) )
                            vm.hours = 9;
                            vm.minutes = 0;
                        };

                        var update_customer = angular.copy( customer );
                        update_customer.call_date = vm.changeDate();

                        if( autosave )
                            vm.save( update_customer );
                    };

                    // Undo and Save
                    vm.undo = function undo( customer ) {

                        vm.data = angular.copy( vm.backup );

                        if( customer )
                            customer.call_date = vm.backup;

                        vm.changeEditable();

                    };
                    vm.save = function sve( customer ) {

                        if( customer ) {

                            vm.loading = true;
                            vm.update_customer = angular.copy( customer );

                            if( ! vm.data )
                                vm.update_customer.call_date = vm.changeDate();

                            if( vm.update_customer.call_date )
                                vm.update_customer.call_date = $filter( 'date' )(
                                    new Date( vm.update_customer.call_date ),
                                    'yyyy-MM-dd HH:mm'
                                );

                            CustomerService
                                .update( vm.update_customer )
                                .catch(
                                    function() {
                                        alert( "Errore, provare a ricaricare la pagina!" );
                                    }
                                )
                                .finally( vm.changeEditable )
                            ;

                        } else
                            vm.changeEditable();

                    };
                    vm.inizizlized = false;
                    vm.Init = function Init() {
                        //if (vm.inizizlized) return;
                        var date_e_ora = (
                            vm.data
                            ? new Date( moment( vm.data ) )
                            : new Date( moment() )
                        );

                        vm.datepicker = date_e_ora;
                        vm.hours = date_e_ora.getHours();
                        vm.minutes = date_e_ora.getMinutes();
                        //vm.changeDate();
                        vm.inizizlized = true;
                    };
                    $scope.$watch( 'vm.data', function ( newValue, oldValue ) {
                        console.log('watch vm date new: ',newValue);
                        console.log('watch vm date old: ',oldValue);
                        vm.Init();
                    });

                    //vm.Init();

                }
            ],
        };
    };
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("mbReferralList", mbReferralList);
    function mbReferralList() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/mb-referral-list/mb-referral-list.html",
            bindToController: {
                customer: "=",
                user: "=",
                token: "="
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                "$log",
                "$scope",
                "CrudService",
                "env",
                "$mdToast",
                "$mdDialog",
                "WkflowService",
                "UsersService",
                function (
                    $log,
                    $scope,
                    CrudService,
                    env,
                    $mdToast,
                    $mdDialog,
                    WkflowService,
                    UsersService
                ) {

                    var vm = this;
                    vm.env = env;
                    vm.mdToast = $mdToast;
                    vm.mdDialog = $mdDialog;
                    if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
                        return;
                    }

                    vm.token2 = vm.token;

                    vm.wkflow = {name: 'unsetted'};
                    vm.wkflows = [];

                    WkflowService.loadOne(vm, 'REF');

                    $log.info('mbLeferralList');

                    vm.today = new Date(
                        moment().hours(0).minutes(0).seconds(0)
                    );


                    vm.eStatus = {
                        filter_from: null,
                        filter_to: null,
                        filter_upd_to: null,
                        filter_upd_from: null,
                        wkstate: null,
                    };

                    vm.query = {
                        filter: '',
                        order: 'lastname',
                        limit: 10,
                        page: 1
                    };

                    vm.defaultListPagination = function () {
                        vm.listPagination = {
                            "total": 0,
                            "count": 0,
                            "per_page": 50,
                            "current_page": 1,
                            "total_pages": 0,
                            "links": {}
                        };
                    }
                    vm.defaultListPagination();


                    vm.loadItems = function (p, s) {

                        vm.customers = [];
                        vm.loading = true;

                        if (vm.customer && vm.customer.referralPhoneFriends) {
                            this.buildReferralPhoneFriendsStats(vm.customer);
                            vm.customers.push(vm.customer);
                            vm.loading = false;
                            return;
                        }


                        if (p == null) {
                            p = 1;
                        }
                        if (s == null) {
                            s = parseInt(vm.listPagination.per_page);
                        }

                        var pars = {};
                        var search = [];
                        var searchFields = [];

                        //IF ISSET CUSTOMER FILTER BY CUSTOMER
                        if (vm.customer) {
                            searchFields.push("id:=");
                            search.push("id:" + vm.customer.id);
                        }

                        if (vm.storeId) {
                            searchFields.push("last_store_id:=");
                            search.push("last_store_id:" + vm.storeId);
                        }

                        vm.loadedStoreId = vm.storeId?vm.storeId:0;

                        pars.search = search.join(";");
                        pars.searchFields = searchFields.join(";");

                        pars.page = p;
                        pars.s = s;
                        pars.with = "lastStore;referralPhoneFriends;referralPhoneFriends.customer;referralPhoneFriends.transitions";
                        if (vm.user && vm.user.type == 'admin') {
                            pars.with += ";referralPhoneFriends.transitionLast";
                        }
                        pars.referrals = 1;

                        if (vm.query.filter!=null && vm.query.filter!='') {
                            pars.filtro=vm.query.filter.trim();
                        }

                        if (vm.query.order!=null && vm.query.order!='') {
                            pars.orderBy = vm.query.order.indexOf('-')==0?vm.query.order.substring(1):vm.query.order;
                            pars.sortedBy = vm.query.order.indexOf('-')==0?'desc':null;
                        }
                        if (vm.eStatus.wkstate!=null && vm.eStatus.wkstate!='') {
                            pars.filter_referral_wkstate_id = vm.eStatus.wkstate.id;
                        }
                        if (vm.eStatus.filter_from!=null && vm.eStatus.filter_from!='') {
                            pars.filter_referral_from = moment(vm.eStatus.filter_from).format('YYYY-MM-DD');
                        }
                        if (vm.eStatus.filter_to!=null && vm.eStatus.filter_to!='') {
                            pars.filter_referral_to = moment(vm.eStatus.filter_to).format('YYYY-MM-DD');
                        }
                        if (vm.eStatus.filter_upd_from!=null && vm.eStatus.filter_upd_from!='') {
                            pars.filter_referral_upd_from = moment(vm.eStatus.filter_upd_from).format('YYYY-MM-DD');
                        }
                        if (vm.eStatus.filter_upd_to!=null && vm.eStatus.filter_upd_to!='') {
                            pars.filter_referral_supd_to = moment(vm.eStatus.filter_upd_to).format('YYYY-MM-DD');
                        }

                        CrudService.all(
                            "customers",
                            pars,
                            vm,
                            function (response) {

                                if (response.data && response.data.meta && response.data.meta.pagination) {

                                    vm.listPagination = response.data.meta.pagination;

                                    if (response.data &&
                                        response.data.data &&
                                        response.data.data.length > 0
                                    ) {

                                        angular.forEach( response.data.data, function( customer ) {

                                            vm.buildReferralPhoneFriendsStats(customer);

                                        });

                                        vm.customers = response.data.data;

                                    }
                                }

                                vm.loading = false;

                            },
                            function (response) {
                                vm.loading = false;
                                $log.info(response);
                            }
                        );
                    };

                    vm.buildReferralPhoneFriendsStats = function(customer) {
                        customer.referralPhoneFriendsStats = {
                            'bookCount': 0,
                            'bookPhoneCount': 0,
                            'paidCount': 0,
                            'paidPhoneCount': 0,
                            'subscrCount': 0,
                            'subscr50PaidCount': 0,
                            'readyCount': 0,
                            'delivCount': 0
                        };
                        customer.referralPhoneFriends.data.forEach( function( referralPhoneFriend ) {
                            switch (referralPhoneFriend.status) {
                                case 'Delivered':
                                    customer.referralPhoneFriendsStats.delivCount++;
                                // eslint-disable-next-line no-fallthrough
                                case 'Ready':
                                    customer.referralPhoneFriendsStats.readyCount++;
                                // eslint-disable-next-line no-fallthrough
                                case 'SubscrPaid50':
                                    customer.referralPhoneFriendsStats.subscr50PaidCount++;
                                // eslint-disable-next-line no-fallthrough
                                case 'Subscr':
                                    customer.referralPhoneFriendsStats.subscrCount++;
                                // eslint-disable-next-line no-fallthrough
                                case 'Show':
                                    customer.referralPhoneFriendsStats.paidCount++;
                                // eslint-disable-next-line no-fallthrough
                                case 'Book':
                                    customer.referralPhoneFriendsStats.bookCount++;
                                    if (vm.haveTransitionTo('ShowPhone', referralPhoneFriend)) {
                                        customer.referralPhoneFriendsStats.paidPhoneCount++;
                                        customer.referralPhoneFriendsStats.bookPhoneCount++;
                                    } else if (vm.haveTransitionTo('BookPhone', referralPhoneFriend)) {
                                        customer.referralPhoneFriendsStats.bookPhoneCount++;
                                    }
                                    break;
                                case 'ShowPhone':
                                    customer.referralPhoneFriendsStats.paidPhoneCount++;
                                // eslint-disable-next-line no-fallthrough
                                case 'BookPhone':
                                    customer.referralPhoneFriendsStats.bookPhoneCount++;
                            }
                        });
                    };

                    vm.haveTransitionTo = function (to, referralPhoneFriend) {
                        var to_id = null;

                        vm.wkstates.forEach( function( wkstate ) {
                            if (wkstate.name == to) {
                                to_id = wkstate.id;
                            }
                        });

                        if (referralPhoneFriend.transitions && referralPhoneFriend.transitions.data) {
                            for (var i=0; i<referralPhoneFriend.transitions.data.length; i++) {
                                var transition = referralPhoneFriend.transitions.data[i];
                                if (transition.wkstate_id_to == to_id) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    };



                    vm.onKeyPressSearch = function (event) {
                        if (!event || event.keyCode==13) {
                            vm.loadItems(1);
                            if (event) {
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        }
                    }


                    vm.removeSearch = function() {
                        vm.eStatus.showChild = false;
                        vm.eStatus.filter_from = null;
                        vm.eStatus.filter_to = null;
                        vm.eStatus.filter_upd_from = null;
                        vm.eStatus.filter_upd_to = null;
                        vm.eStatus.wkstate = null;
                        vm.query.filter = '';
                        vm.query.order = 'lastname';
                        vm.query.off = 0;
                        vm.query.page = 1;
                        vm.loadItems(1);
                    };


                    vm.eListReOrder = function (column) {
                        vm.query.order = column;
                        vm.loadItems(1);
                    };


                    vm.showDocuments = function( a ) {
                        var dialog = $mdDialog.confirm({
                            title: 'Elenco documenti di ' + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
                            + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'') + " (eid="+a.id+" cid="+a.customer_id+")",
                            ariaLabel: 'Documenti',
                            templateUrl: 'app/xipny-wkflow/directives/wk-entity-list/dialogs/customer-documents.html',
                            escapeToClose: true,
                            controller: [ '$scope', '$mdDialog', '$filter', '$http', '$log',  function( $scope, $mdDialog, $filter, $http, $log ) {
                                $scope.title = this.title;
                                $scope.button_ok = 'Chiudi';
                                $scope.customer = a.customer.data;
                                $scope.env = vm.env;
                                $scope.token = vm.token2;
                                $scope.refresh = function() {
                                    /**
                                     * ricarico documenti cliente
                                     */
                                    //$log.info("http.get: "+$scope.env.API+"/documents?customer_id="+$scope.app.customer_id);
                                    $scope.loading = true;
                                    $http.get($scope.env.API+"/documents?customer_id="+$scope.customer.id).then(
                                        function (response) {
                                            //$log.info(response.data.data);
                                            $scope.customer.documents = {'data': response.data.data };
                                            $scope.loading = false;
                                        },
                                        function (response) {
                                            //$log.info(response);
                                            $scope.loading = false;
                                        }
                                    );
                                };
                                $scope.close = function() {
                                    $mdDialog.hide( true );
                                };
                                $scope.refresh();
                            }]
                        });

                        return $mdDialog
                            .show( dialog )
                            .finally(
                                function() {
                                    dialog = undefined;
                                }
                            )
                        ;
                    };

                    vm.showDocumentsRoot = function( c ) {
                        var dialog = $mdDialog.confirm({
                            title: 'Elenco documenti di ' + (c.firstname!=null?c.firstname.toUpperCase():'')
                            + ' ' + (c.lastname!=null?c.lastname.toUpperCase():'') + " (cid="+c.id+")",
                            ariaLabel: 'Documenti',
                            templateUrl: 'app/xipny-wkflow/directives/wk-entity-list/dialogs/customer-documents.html',
                            escapeToClose: true,
                            controller: [ '$scope', '$mdDialog', '$filter', '$http', '$log',  function( $scope, $mdDialog, $filter, $http, $log ) {
                                $scope.title = this.title;
                                $scope.button_ok = 'Chiudi';
                                $scope.customer = c;
                                $scope.env = vm.env;
                                $scope.token = vm.token2;
                                $scope.refresh = function() {
                                    /**
                                     * ricarico documenti cliente
                                     */
                                    //$log.info("http.get: "+$scope.env.API+"/documents?customer_id="+$scope.app.customer_id);
                                    $scope.loading = true;
                                    $http.get($scope.env.API+"/documents?customer_id="+$scope.customer.id).then(
                                        function (response) {
                                            //$log.info(response.data.data);
                                            $scope.customer.documents = {'data': response.data.data };
                                            $scope.loading = false;
                                        },
                                        function (response) {
                                            //$log.info(response);
                                            $scope.loading = false;
                                        }
                                    );
                                };
                                $scope.close = function() {
                                    $mdDialog.hide( true );
                                };
                                $scope.refresh();
                            }]
                        });

                        return $mdDialog
                            .show( dialog )
                            .finally(
                                function() {
                                    dialog = undefined;
                                }
                            )
                        ;
                    };



                    this.$onInit = function () {

                        vm.customer = this.customer;
                        vm.user = this.user;

                    };

                    /**
                         * deve aver caricato i workflow prima di caricare i customer
                    */
                    $scope.$watch('ab.wkFlowLoaded',
                        function (newValue, oldValue) {
                            if (newValue) {
                                vm.loadItems();
                            }
                        }
                    );

                    $scope.$watch('ab.token',
                        function (newValue, oldValue) {
                            //console.log('mb-referral-list -> token old: '+oldValue);
                            //console.log('mb-referral-list -> token new: '+newValue);
                        }
                    );

                    /**
                     * watch store da parent
                     */
                    vm.storeId = undefined;
                    vm.store = {};
                    $scope.$watch( '$parent.selectedStore', function( id ) {
                        $log.info('mb-referral-list -> selectedStore: '+id);
                        vm.storeId = id;
                        vm.store = {};
                        if( angular.isDefined( id )) {
                            if (id>0) {
                                angular.forEach($scope.$parent.main.storesList, function (s) {
                                if (s.id == vm.storeId) {
                                    vm.store = s;
                                    $log.info('mb-referral-list -> selectedStore: '+vm.store.alias);
                                }
                                });
                            }
                            /**
                             * Carico dati???
                             */
                            if (vm.wkFlowLoaded && vm.loadedStoreId!=null && vm.storeId!=vm.loadedStoreId) {
                                vm.loadItems();
                            }
                        }
                    });

                }]
            }
        }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("bmQuotationsList", bmQuotationsList);

    function bmQuotationsList(
        $timeout,
        $http,
        $log,
        $mdDialog,
        $mdMedia,
        $sce,
        $state,
        $window,
        env,
        CrudService
    ) {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bm-quotations-list/bm-quotations-list.html",
                scope: {
                    control: '='
                },          
                link: function( 
                    scope,
                    element,
                    attrs
                ) {
                    $timeout( function() {

                        $log.info('bmQuotationsList');

                        scope.customerid = attrs.customerid;
                        scope.token = attrs.token;
    
                        scope.listPagination = {
                            "total":0,
                            "count":0,
                            "per_page":20,
                            "current_page":1,
                            "total_pages":0,
                            "links":{}
                        };
                
                        scope.query = {
                            filter: '',
                            status: '',
                            order: '-updated_at',
                            off: 0,
                            limit: 20,
                            page: 1
                        };

    
                        scope.quotations = [];
                        scope.loading = true;
                        scope.canReadList = true;
                        

                        scope.orderItems = function (column) {
                            scope.query.order = column;
                            scope.loadItems();
                        };


                        scope.loadItems = function (p, s) {
                            scope.quotations = [];
                            scope.saveStatus();
    
                            scope.loading = true;
    
                            if (p == null) {
                                p = 1;
                            }
                            if (s == null) {
                                s = parseInt(scope.listPagination.per_page);
                            }
    
                            var pars = {};
                            pars.with = "user;customer;document";
                            pars.filtro = scope.query.filter;
                            pars.stato = scope.query.status;
                            pars.orderBy = scope.query.order.indexOf('-')==0?
                                scope.query.order.substring(1):scope.query.order;
                            pars.sortedBy = scope.query.order.indexOf('-')==0?
                                'desc':null;
    
                            if (scope.customerid) {
                                pars.customer_id=scope.customerid;
                            }
    
                            pars.page = p;
                            pars.s = s;

                            CrudService.all(
                                'customer_quotations', 
                                pars, 
                                scope,
                                function (response) {
    
                                    if (response.data &&
                                        response.data.data &&
                                        response.data.data.length > 0
                                    ) {
    
                                        scope.listPagination = response.data.meta.pagination;
    
                                        angular.forEach(response.data.data, function (elem) {
                                            elem.date_formatted = moment(elem.date).format('DD/MM/YYYY');
                                            if (elem.sent_at != null) {
                                                elem.sent_at_frmt = moment(elem.sent_at).format('DD/MM/YYYY HH:mm');
                                            }
                                        });
    
                                        scope.quotations = response.data.data;
                                    }
                                    scope.loading = false;
                                },
                                function () {
                                    scope.loading = false;
                                }
                            );
                        };


                        scope.create = function() {
                            $state.go("home.nestimate", {
                                customer_id: scope.customerid
                            });
                        };


                        scope.edit = function(e) {
                            $state.go("home.nestimate", {
                                customer_id: e.customer_id,
                                customer_quotation_id: e.id
                            });
                        };

                        scope.view = function(e) {
                            $state.go("home.nestimate", {
                                customer_id: e.customer_id,
                                customer_quotation_id: e.id,
                                read_only: true
                            });
                        };

                        scope.openEmailPopup = function(mainEntity) {

                            scope.loading = true;
                
                            $http
                                .get(  env.API + '/customer-quotation-view-v2/' + mainEntity.id, null )
                                .then(function(response) {
                
                                    scope.loading = false;
                
                                    if ( response.data &&
                                         mainEntity.customer &&
                                         mainEntity.customer.email
                                    ) {
                
                                        var useFullScreen = $mdMedia('xs');
                                        var confirm = $mdDialog.confirm({
                                            title: 'Info',
                                            ariaLabel: 'Info',
                                            templateUrl: 'app/customer-quotations/dialogs/email-dialog.html',
                                            fullscreen: useFullScreen,
                                            escapeToClose: false,
                                            controller: [ '$scope', '$mdDialog', function( $scope, $mdDialog ) {

                                                scope.saveDocument = true;
                                                scope.customerQuotationDocument = mainEntity.id;
                                                $scope.env = env;

                                                $scope.mainEntity = mainEntity;
                                                $scope.view = $sce.trustAsHtml(response.data.view);
                                                $scope.token = scope.token;
                                                $scope.postUrl =  $sce.trustAsResourceUrl( env.API + '/signed-quotations-v2/send' );
                
                                                console.log($scope);
                                                $scope.close = function() {
                                                    $mdDialog.hide( true );
                                                };
                
                                            }]
                                        });
                                        return $mdDialog
                                            .show( confirm );
                
                                    } else {
                
                                        var confirm = $mdDialog.confirm()
                                            .title('Attenzione')
                                            .ariaLabel('Attenzione')
                                            .textContent('Non è possibile inviare l\'email al cliente.')
                                            .cancel('Ok');
                
                                        return $mdDialog
                                            .show(confirm);
                
                                    }
                
                                });
                
                        };     


                        scope.openCancelEstimateModal = function(cq) {
                            $log.info( 'Cancel' );
                            if( angular.isDefined( cq ) ) {
                                var confirm = $mdDialog.confirm()
                                    .title( 'Attenzione' )
                                    .ariaLabel( 'Attenzione' )
                                    .textContent( 'Sicuro di voler cancellare questo preventivo?' )
                                    .ok( 'Si' )
                                    .cancel( 'Ops, ho sbagliato' )
                                ;
                                return $mdDialog
                                    .show( confirm )
                                    .then(
                                        function() {
                                            CrudService.get( 
                                                "customer-quotation-v2/cancel", 
                                                cq.id, 
                                                {}, 
                                                scope,
                                                function (response) {
                                                    cq.status = 'canceled';
                                                },
                                                function (response) {
                                                }
                                            );
                                        }
                                    )
                                    .finally(
                                        function() {
                                            confirm = undefined;
                                        }
                                    );
                            };
                        };


                        scope.openSuspendEstimateModal = function(cq) {
                            $log.info( 'Suspend' );
                            if( angular.isDefined( cq ) ) {
                                var confirm = $mdDialog.confirm()
                                    .title( 'Attenzione' )
                                    .ariaLabel( 'Attenzione' )
                                    .textContent( 'Sicuro di voler sospendere questo preventivo?' )
                                    .ok( 'Si' )
                                    .cancel( 'Ops, ho sbagliato' )
                                ;
                                return $mdDialog
                                    .show( confirm )
                                    .then(
                                        function() {
                                            CrudService.get( 
                                                "customer-quotation-v2/suspend", 
                                                cq.id, 
                                                {}, 
                                                scope,
                                                function (response) {
                                                    cq.status = 'suspended';
                                                },
                                                function (response) {
                                                }
                                            );
                                        }
                                    )
                                    .finally(
                                        function() {
                                            confirm = undefined;
                                        }
                                    );
                            };
                        };


                        scope.openRestoreEstimateModal = function(cq) {
                            $log.info( 'Restore' );
                            if( angular.isDefined( cq ) ) {
                                var confirm = $mdDialog.confirm()
                                    .title( 'Attenzione' )
                                    .ariaLabel( 'Attenzione' )
                                    .textContent( 'Sicuro di voler ripristinare questo preventivo?' )
                                    .ok( 'Si' )
                                    .cancel( 'Ops, ho sbagliato' )
                                ;
                                return $mdDialog
                                    .show( confirm )
                                    .then(
                                        function() {
                                            CrudService.get( 
                                                "customer-quotation-v2/restore", 
                                                cq.id, 
                                                {}, 
                                                scope,
                                                function (response) {
                                                    cq.status = 'signed';
                                                },
                                                function (response) {
                                                }
                                            );
                                        }
                                    )
                                    .finally(
                                        function() {
                                            confirm = undefined;
                                        }
                                    );
                            };
                        };
                        

                        scope.openDocumentPage = function(id) {
                            scope.saveDocument = true;
                            scope.customerQuotationDocument = id;
                            window.open(
                                env.API + '/signed-quotations-v2/?customer_quotation_id=' + id + '&token=' + scope.token, 
                                '_blank'
                            );
                        };
    

                        scope.delete = function ( id ) {
                            $log.info( 'Del' );
                            if( angular.isDefined( id ) ) {
                                var confirm = $mdDialog.confirm()
                                    .title( 'Attenzione' )
                                    .ariaLabel( 'Attenzione' )
                                    .textContent( 'Sicuro di voler eliminare questo preventivo?' )
                                    .ok( 'Si' )
                                    .cancel( 'Ops, ho sbagliato' )
                                ;
                                return $mdDialog
                                    .show( confirm )
                                    .then(
                                        function() {
                                            CrudService.del( 
                                                'customer_quotations', 
                                                id, 
                                                scope,
                                                function( response ) {
                                                    scope.loadItems();
                                                },
                                                function( response ) {
                                                }
                                            );
                                        }
                                    )
                                    .finally(
                                        function() {
                                            confirm = undefined;
                                        }
                                    );
                            };
                        };

    
                        scope.saveStatus = function () {
                            //localStorage.setItem( 'customer_quotations_query', angular.toJson( scope.query, false ) );
                        };
                
                
                        scope.restoreStatus = function () {
                            /*var query = localStorage.hasOwnProperty('customer_quotations_query');
                            if(query != null && query != undefined){
                                var query = angular.fromJson(query);
                                scope.query =  query;
                            }*/
                        };
                
                
                        scope.restoreStatus();
    

                        scope.loadItems(scope.query.page, 20);


                        $window.onfocus = function (event) {

                            if( scope.saveDocument && scope.saveDocument == true ) {
                                CrudService.get(
                                    "customer_quotations", 
                                    scope.customerQuotationDocument, 
                                    {}, 
                                    scope,
                                    function (response) {
                                        if( response.data.data.status != 'draft' ) {
                                            scope.loadItems();
                                        }
                                    },
                                    function (response) {
                                    }
                                );
                            }
                        };
                

                    }, 0 );
                }       
            }
        };
    
    })();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("bmPicturesList", bmPicturesList);
    function bmPicturesList() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bm-pictures-list/bm-pictures-list.html",
            bindToController: {
                customer: "=",
                user: "=",
                token: "="
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                "$http",
                "$log",
                "$mdDialog",
                "$mdMedia",
                "$mdToast",
                "$rootScope",
                "$scope",
                "AppointmentsService",
                "env",
                function (
                    $http,
                    $log,
                    $mdDialog,
                    $mdMedia,
                    $mdToast,
                    $rootScope,
                    $scope,
                    AppointmentsService,
                    env
                ) {

                    var vm = this;
                    $log.info('bmPicturesList');


                    vm.defaultListPagination = function () {
                        $scope.listPagination = {
                            "total": 0,
                            "count": 0,
                            "per_page": 50,
                            "current_page": 1,
                            "total_pages": 0,
                            "links": {}
                        };
                    }
                    vm.defaultListPagination();


                    vm.loadItems = function (p, s) {

                        vm.appointments = [];
                        $scope.loading = true;

                        if (p == null) {
                            p = 1;
                        }
                        if (s == null) {
                            s = parseInt($scope.listPagination.per_page);
                        }

                        var pars = {};
                        var search = [];
                        var searchFields = [];

                        pars.with = "pictures;user;customer";

                        //IF ISSET CUSTOMER FILTER BY CUSTOMER
                        if (vm.customer) {
                            searchFields.push("appointments.customer_id:=");
                            search.push("appointments.customer_id:" + vm.customer.id);
                        }

                        //FILTER APPOINTMENTS MAX TODAY
                        searchFields.push("appointments.date_start:<=");
                        search.push("appointments.date_start:" + moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'));

                        pars.search = search.join(";");
                        pars.searchFields = searchFields.join(";");

                        pars.page = p;
                        pars.s = s;
                        pars.orderBy = 'date_start';
                        pars.sortedBy = 'desc';

                        AppointmentsService
                        .all(pars)
                        .then(
                            function (response) {

                                $scope.listPagination = response.data.meta.pagination;

                                if (response.data &&
                                    response.data.data &&
                                    response.data.data.length > 0
                                ) {

                                    angular.forEach( response.data.data, function( appointment ) {
                                        appointment.date_fmt = moment(appointment.date_start).format('DD/MM/YYYY');
                                    });    

                                    vm.appointments = response.data.data;

                                }

                                $scope.loading = false;
                            },
                            function () {
                                $scope.loading = false;
                            }
                        );
                    };


                    vm.openEmailPopup = function (appointment) {

                        //OPEN POPUP
                        var useFullScreen = $mdMedia('xs');
                        var confirm = $mdDialog.confirm({
                            title: 'Info',
                            ariaLabel: 'Info',
                            templateUrl: 'app/components/bm-pictures-list/dialogs/email-dialog.html',
                            fullscreen: useFullScreen,
                            escapeToClose: false,
                            controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {

                                $scope.loading = true;
                                $scope.appointment = appointment;

                                //GET TEMPLATE CONTENT
                                $http.get(
                                        env.API + '/appointments/appointment-pictures-template/' + appointment.id
                                    ).then(
                                        function (response) {

                                            $scope.loading = false;
                                            $scope.template = response.data.data;
                                            console.log($scope.template);

                                        }
                                    );        
                       

                                $scope.sendEmail = function() {
                                    
                                    $scope.loading = true;
                                    $http
                                        .get(
                                            env.API + '/appointments/send-pictures/' + appointment.id
                                        ).then(
                                            function (response) {
                                                $scope.loading = false;

                                                if( 
                                                    response && 
                                                    response.data &&
                                                    response.data.data == true 
                                                ) {
                                                    vm.showActionToast();
                                                    $mdDialog.hide(true);
                                                } 
                                            },
                                            function (response) {
                                                $log.info(response);
                                                vm.showActionToast("Invio email non riuscito!");
                                                $scope.loading = false;
                                            }
                                        );

                                }

                                $scope.close = function () {
                                    $mdDialog.hide(true);
                                };

                            }]
                        });
                        return $mdDialog
                            .show(confirm);              

                    };


                    vm.checkSendEmail = function(appointment){

                        var error = false;
                        var errorMessage = "";

                        if( appointment.pictures.data.length > 0 ) {

                            if( appointment.customer.data.email ) {

                                vm.openEmailPopup(appointment);

                            } else {

                                error = true;
                                errorMessage = 'Non è possibile inviare l\'email al cliente.';

                            }

                        } else {
                        
                            error = true;
                            errorMessage = 'Non sono presenti foto per questo preventivo.';
                        
                        }


                        if(error) {

                            var confirm = $mdDialog
                                .alert()
                                .title('Attenzione')
                                .ariaLabel('Attenzione')
                                .textContent(errorMessage)
                                .ok('Ok');

                            return $mdDialog
                                .show(confirm);

                        }

                    }


                    vm.showActionToast = function(text) {

                        text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
                        
                        var toast = $mdToast
                            .simple()
                            .textContent(text)
                            .action('')
                            .highlightAction(true)
                            .position('bottom right');
                        
                        return $mdToast
                            .show(toast)
                            .finally(
                                function() {
                                    toast = undefined;
                                }
                            );

                    };


                    //OPEN APPOINTMENT SIDEBAR
                    vm.toggleRight = function () {
                        $rootScope.$broadcast(
                            'bm-picture-sidenav-toggleRight',
                            {
                            }
                        );
                    };


                    //LISTENER TO UPDATE PICTURES
                    $scope.$on("bm-picture-sidenav-reload", function (event, data) {
                        
                        vm.loadItems();

                    });


                    this.$onInit = function () {

                        vm.customer = this.customer;
                        vm.user = this.user;
                        vm.token = this.token;

                        vm.loadItems();

                    };

                }]
        }
    }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("bmPictureSidenav", bmPictureSidenav);
    function bmPictureSidenav() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bm-picture-sidenav/bm-picture-sidenav.html",
            bindToController: {
                customer: "=",
                user: "=",
                token: "=",
                appointmentid: "="
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                '$scope',
                '$log',
                '$mdDialog',
                '$mdSidenav',
                '$rootScope',
                'moment',
                'CrudService',
                'AppointmentsService',
                function (
                    $scope,
                    $log,
                    $mdDialog,
                    $mdSidenav,
                    $rootScope,
                    moment,
                    CrudService,
                    AppointmentsService
                ) {

                    var vm = this;
                    $log.info('bmPictureSidenav');


                    vm.customerAppointmentsLoad = function () {

                        vm.loading = true;
                        vm.appointments = [];

                        var pars = {};
                        var search = [];
                        var searchFields = [];


                        searchFields.push("customer_id:=");
                        search.push("customer_id:" + vm.customer.id);

                        //IF APPOINTMENT GET ONLY ONE ITEM
                        //ELSE ADD MORE FILTERS
                        if(vm.appointment_id) {

                            searchFields.push("id:=");
                            search.push("id:" + vm.appointment_id);

                        } else {

                            searchFields.push("recalled:<");
                            search.push("recalled:3");

                            searchFields.push("date_start:>=");
                            search.push("date_start:"+moment().format('YYYY-MM-DD 23:59'));

                            searchFields.push("closed:=");
                            search.push("closed:0");

                        }

                        pars.search = search.join(";");
                        pars.searchFields = searchFields.join(";");


                        AppointmentsService
                            .all( pars )
                            .then(
                                function (response) {

                                    if (
                                        response.data &&
                                        response.data.data
                                    ) {

                                        angular.forEach( response.data.data, function( elem ) {
                                            elem.date_start_frmt = moment( elem.date_start).format('DD/MM/YYYY HH:mm')
                                        });

                                        vm.appointments = response.data.data;

                                    }

                                    vm.loading = false;

                                },
                                function (response) {

                                    var errMsg = "";
                                    if (response.data != null && response.data.message != null) {
                                        errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                                        var url = response.config != null && response.config.url != null ? response.config.url : "";
                                        if (url != null) {
                                            errMsg += "\nUrl: " + url;
                                        }
                                    }
                                    alert("Si è verificato un errore nel caricamento: " + errMsg);
                                    vm.loading = false;

                                }
                            );
                    };


                    vm.saving = false;
                    vm.save = function() {
                        $log.info('Salva');
                        var confirm = $mdDialog.confirm()
                            .title('Attenzione')
                            .ariaLabel('Attenzione')
                            .textContent('Sicuro di voler inserire queste foto?')
                            .ok('Si')
                            .cancel('Ops, ho sbagliato');

                        return $mdDialog
                            .show(confirm)
                            .then(
                                function() {

                                    vm.saving = true;
                                    if ($scope.img.fileObj && $scope.img.fileObj.length > 0) {

                                        vm.createPictureAction.attachments = new Array($scope.img.fileObj.length);

                                        vm.uploadImages(
                                            0,
                                            $scope.img.fileObj.length
                                        );

                                    } else {
                                        vm.saving = false;
                                    }
                                }
                            ).finally(
                                function() {
                                    confirm = undefined;
                                }
                            );
                    };


                    vm.uploadImages = function( currentImage, totalImages ) {

                        vm.createPictureAction.attachments[currentImage] = {
                            document_name: null,
                            document_type: null,
                            document_file: null
                        };

                        vm.createPictureAction.attachments[currentImage].document_name = $scope.img.fileObj[currentImage].name;
                        vm.createPictureAction.attachments[currentImage].document_type = $scope.img.fileObj[currentImage].type;
                        var reader = new FileReader();

                        reader.onload = function () {

                            vm.createPictureAction.attachments[currentImage].document_file = reader.result;

                            if( (currentImage+1) < totalImages ) { //ADD ANOTHER IMAGE TO SEND

                                vm.uploadImages(
                                    currentImage+1,
                                    $scope.img.fileObj.length
                                );

                            } else { //UPLOAD IMAGES TO SERVER

                                vm.createPictureAction.date = moment(vm.createPictureAction.date).format("DD/MM/YYYY");

                                CrudService.save('customer_pictures', vm.createPictureAction, vm,
                                    function(response) {
                                        vm.saving = false;
                                        vm.closeSidebar();
                                        vm.updateParentPage();
                                    },
                                    function(response) {
                                        vm.saving = false;
                                    });

                            }

                        };

                        reader.onerror = function (error) {
                            $log.info('Error: ', error);
                            vm.saving = false;
                        };

                        reader.readAsDataURL($scope.img.fileObj[currentImage]);

                    };



                    vm.updateParentPage = function () {

                        $rootScope.$broadcast(
                            'bm-picture-sidenav-reload'
                        );

                    }


                    //---------- Sidebar -------------------------------------//
                    vm.createPictureAction = { 'date': new Date() };
                    vm.toggleRight = function (data) {
                        $log.info("toggleRigth: ");
                        $log.info(data);
                        vm.createPictureAction = {
                            user_id: vm.user.id,
                            customer_id: vm.customer.id,
                            appointment_id: data && data.appointment_id ? data.appointment_id:
                                (vm.customer && vm.customer.appointments && vm.customer.appointments.data && vm.customer.appointments.data.length > 0 ? vm.customer.appointments.data[0].id : null),
                            date: new Date(),
                            parameter: null,
                            attachments: [],
                            description: null
                        };
                        $mdSidenav('bm-picture-sidenav').open();

                        //LOAD APPOINTMENTS
                        vm.customerAppointmentsLoad();
                    };


                    vm.closeSidebar = function () {
                        $mdSidenav('bm-picture-sidenav').close();
                    };


                    //LISTENER TO OPEN SIDEBAR
                    $scope.$on("bm-picture-sidenav-toggleRight", function (event, data) {
                        vm.toggleRight(data);
                    });


                    this.$onInit = function () {

                        /* Controllo se c'è un Customer */
                        if (angular.isDefined(this.customer)) {
                            vm.customer = this.customer;
                            vm.user = this.user;
                            vm.token = this.token;
                            vm.appointment_id = this.appointmentid;
                        }

                    };

                }]
        }
    }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("bmPagination", bmPagination);

    function bmPagination(
        $timeout,
        $log,
        $mdDialog,
        $state,
        CrudService
    ) {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bm-pagination/bm-pagination.html",
                scope: {
                    loaditems: "&"
                },         
                link: function( 
                    scope,
                    element,
                    attrs
                ) {
                    $timeout( function() {

                        $log.info('bmPagination');

                        scope.maxPages = 10;

                        scope.listPagination = {
                            "total":0,
                            "count":10,
                            "per_page":10,
                            "current_page":1,
                            "total_pages":0,
                            "links":{}
                        };

                        scope.setPagination = function(p) {
                            scope.loaditems()(p, scope.listPagination.per_page);
                        };

                        attrs.$observe('listpagination', function(newValue){
                            scope.listPagination = JSON.parse(newValue);
                        });

                    }, 0 );
                }       
            }
        };
    
    })();
(function () {
    "use strict";
    angular
        .module("admin")
        .directive("blAppointmentsList", blAppointmentsList);
    function blAppointmentsList() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bm-appointments-list/bm-appointments-list.html",
            bindToController: {
                customer: "=",
                user: "=",
                token: "="
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                "$filter",
                "$http",
                "$scope",
                "$log",
                "$mdDialog",
                "$mdToast",
                "$rootScope",
                "env",
                "CrudService",
                "AppointmentsService",
                "TreatmentService",
                "UsersService",
                "OperatorAvailabilityService",
                function (
                    $filter,
                    $http,
                    $scope,
                    $log,
                    $mdDialog,
                    $mdToast,
                    $rootScope,
                    env,
                    CrudService,
                    AppointmentsService,
                    TreatmentService,
                    UsersService,
                    OperatorAvailabilityService
                ) {

                    var vm = this;
                    $log.info('blAppointmentsList');

                    /**
                     * Per crud service
                     */
                    //SERVE QUESTA ROBA QUA?
                    vm.mdToast = $mdToast;
                    vm.mdDialog = $mdDialog;
                    vm.env = env;
                    //SERVE QUESTA ROBA QUA?

                    vm.defaultListPagination = function () {
                        $scope.listPagination = {
                            "total": 0,
                            "count": 0,
                            "per_page": 50,
                            "current_page": 1,
                            "total_pages": 0,
                            "links": {}
                        };
                    }
                    vm.defaultListPagination();

                    vm.query = {
                        filter: '',
                        status: '',
                        order: 'date_start',
                        off: 0,
                        limit: 20,
                        page: 1
                    };

                    $scope.appointments = [];
                    vm.userRolesList = [];
                    vm.userRolesListAll = []
                    vm.userRolesListCall = [];
                    $scope.loading = true;


                    /* Treatments */
                    vm.treatmentsList = [];
                    vm.treatmentsListStoreId = null;
                    vm.treatmentsListAll = [];
                    vm.laserTreatmentsList = [];
                    vm.portaEnabled = true;
                    vm.filterTreatments = function () {
                        if (!vm.treatmentsLoaded || vm.treatmentsListStoreId == vm.storeId) {
                            return;
                        }
                        vm.treatmentsListStoreId = vm.storeId;
                        vm.treatmentsList = [];
                        //$log.info("vm.filterTreatments: "+ vm.storeId);
                        var filterCategory = vm.storeId && vm.env.stores != null && vm.env.stores[vm.storeId] != null && vm.env.stores[vm.storeId].categories != null;
                        //$log.info("vm.filterTreatments: filterCategory="+ filterCategory);
                        angular.forEach(vm.treatmentsListAll, function (ct) {
                            //$log.info(ct);
                            if (filterCategory) {
                                //$log.info(vm.env.stores[vm.storeId].categories);
                                //$log.info(vm.env.stores[vm.storeId].categories.includes(ct.id));
                            }
                            if (!filterCategory || vm.env.stores[vm.storeId].categories.includes(ct.id)) {
                                vm.treatmentsList.push(ct);
                            }
                        });
                    }
                    vm.pricings = [];
                    vm.pricingsLoad = function () {
                        vm.pricings = [];
                        $http
                            .get(env.API + "/leads_campaign_pricings")
                            .then(function (response) {
                                if (response.data && response.data.data) {
                                    vm.pricings = response.data.data;
                                }
                            });
                    };
                    vm.pricingsLoad();
                    vm.treatmentsLoaded = false;
                    TreatmentService.categories().then(function (data) {
                        //$log.info(data);
                        vm.treatmentsListAll = data;
                        var ids = [1, 2, 3, 4, 5, 6, 126, 127, 128, 129];
                        for (var i = 0; i < ids.length; i++) {
                            //console.log(ids[i]);
                            var t = $filter('treatment')(ids[i], vm.treatmentsListAll);
                            //$log.info("trattamento "+ ids[i]);
                            //$log.info(t);
                            if (t != null && t != '') {
                                vm.laserTreatmentsList.push(t);
                            }
                        }
                        vm.treatmentsLoaded = true;
                        vm.filterTreatments();
                    });


                    $scope.orderItems = function (column) {
                        vm.query.order = column;
                        vm.loadItems();
                    };


                    vm.checkPictureButtonVisibility = function(appointment) {
                        var ret = true;

                        if(
                            appointment.recalled == 4 ||
                            appointment.recalled == 3 ||
                            (appointment.recalled < 3 && appointment.payed == 0) ||
                            appointment.closed
                        ) {
                            ret = false;
                        }

                        return ret;

                    }


                    vm.onChangeDateStart = function() {
                        if( vm.eStatus.filterDateStart && vm.eStatus.filterDateEnd ) {
                            if( moment( vm.eStatus.filterDateEnd ).hour(23).minute(59).second(59).isBefore( vm.eStatus.filterDateStart ) ) {
                                vm.eStatus.filterDateEnd = null;
                            }
                        }
                        vm.eStatus.filterTimeStart = new Date(vm.today).getTime();

                        vm.query.page = 1;
                        vm.query.order = 'date_start';

                        vm.loadItems();
                    };


                    vm.onChangeTimeStart = function() {
                        vm.eStatus.filterTimeStart = new Date(vm.eStatus.filterTimeStart).getTime();
                        
                        vm.query.page = 1;
                        vm.query.order = 'date_start';

                        vm.loadItems();
                    };


                    vm.loadItems = function (p, s) {

                        $scope.appointments = [];
                        $scope.loading = true;

                        var search = [];
                        var searchFields = [];

                        if (p == null) {
                            p = 1;
                        }
                        if (s == null) {
                            s = parseInt($scope.listPagination.per_page);
                        }

                        var pars = {};
                        pars.with = "user;customer;commercial_user;assist_user;store";
                        if (vm.env.documentsEnabled) {
                            pars.with = pars.with + ";documents";
                        }
                        pars.filtro = vm.query.filter;
                        pars.stato = vm.query.status;
                        pars.orderBy = vm.query.order.indexOf('-') == 0 ?
                            vm.query.order.substring(1) : vm.query.order;
                        pars.sortedBy = vm.query.order.indexOf('-') == 0 ?
                            'desc' : null;

                        //IF ISSET CUSTOMER FILTER BY CUSTOMER
                        if (vm.customer) {
                            searchFields.push("appointments.customer_id:=");
                            search.push("appointments.customer_id:" + vm.customer.id);
                        }

                        //IF NOT ISSET CUSTOMER FILTER BY STORE
                        if (!vm.customer && vm.storeId) {
                            searchFields.push("appointments.store_id:=");
                            search.push("appointments.store_id:" + vm.storeId);
                        }

                        if (vm.eStatus.filterReminder) {
                            if(vm.eStatus.filterReminder <= 4){
                                search.push("appointments.recalled:" + vm.eStatus.filterReminder);
                                searchFields.push("appointments.recalled:=");    
                            } else {
                                if(vm.eStatus.filterReminder == 5){ //RECALLED < 3
                                    search.push("recalled:3");
                                    searchFields.push("recalled:<");
                                } else if(vm.eStatus.filterReminder == 6){ //UNCOVERED
                                    searchFields.push("uncovered:=");
                                    search.push("uncovered:1");
                                } else if ( vm.eStatus.filterReminder == 7 ){//TO SCHEDULE
                                    search.push("appointments.f_over:3");
                                    searchFields.push("appointments.f_over:=");

                                    search.push("recalled:4");
                                    searchFields.push("recalled:<");
                                }
                            }
                        }

                        if (vm.eStatus.filterPresenza) {
                            if( vm.eStatus.filterPresenza <= 1 ){
                                search.push("appointments.paid:" + vm.eStatus.filterPresenza);
                                searchFields.push("appointments.paid:=");    
                            } else {
                                if( vm.eStatus.filterPresenza == 2 ){//PAIED
                                    search.push("appointments.paid:1");
                                    searchFields.push("appointments.paid:=");  

                                    search.push("price:0");
                                    searchFields.push("price:>");
                                }
                            }
                        }

                        if (vm.eStatus.filterEsito) {
                            search.push("appointments." + vm.eStatus.filterEsito + ":" + "1");
                            searchFields.push("appointments." + vm.eStatus.filterEsito + ":=");
                        }

                        if (vm.eStatus.filterAgenda) {
                            search.push("appointments.user_times:1");
                            if (vm.eStatus.filterAgenda == 1) {
                                searchFields.push("appointments.user_times:<=");
                            } else {
                                searchFields.push("appointments.user_times:>");
                            }
                        }

                        if (
                            vm.eStatus.filterDateStart != null && 
                            vm.eStatus.filterDateStart != ''
                        ) {
                            var filterDS = moment(vm.eStatus.filterDateStart).format("YYYY-MM-DD 00:00:00");
                            if(
                                vm.eStatus.filterTimeStart != null && 
                                vm.eStatus.filterTimeStart != ''
                            ) {
                                filterDS = moment(vm.eStatus.filterDateStart).format("YYYY-MM-DD ") + 
                                            moment(vm.eStatus.filterTimeStart).format("HH:mm:ss");
                            }

                            search.push("date_start:" + filterDS);
                            searchFields.push("date_start:>=");
                        }
                        
                        if (
                            vm.eStatus.filterDateEnd != null && 
                            vm.eStatus.filterDateEnd != ''
                        ) {
                            search.push("date_end:"+moment(vm.eStatus.filterDateEnd).format("YYYY-MM-DD 23:59:59.9"));
                            searchFields.push("date_end:<");
                        }

                        if( vm.eStatus.filterOperatorId ){
                            search.push("user_id:" + vm.eStatus.filterOperatorId);
                            searchFields.push("user_id:=");
                        }

                        if( vm.eStatus.filterCommercialId ){
                            search.push("commercial_user_id:" + vm.eStatus.filterCommercialId);
                            searchFields.push("commercial_user_id:=");
                        }

                        if( vm.eStatus.filterAssistId ){
                            search.push("assist_user_id:" + vm.eStatus.filterAssistId);
                            searchFields.push("assist_user_id:=");
                        }

                        pars.search = search.join(";");
                        pars.searchFields = searchFields.join(";");

                        pars.page = p;
                        pars.s = s;

                        //SAVE PARS IN LOCAL STORAGE
                        vm.saveStatus();

                        AppointmentsService
                            .all(pars)
                            .then(
                                function (response) {

                                    if (response.data &&
                                        response.data.data &&
                                        response.data.data.length > 0
                                    ) {

                                        vm.appointmentsListPag = response.data.meta.pagination;
                                        var appCreditXuser = [];
                                        var foundVisita = false;

                                        $scope.listPagination = response.data.meta.pagination;

                                        angular.forEach(response.data.data, function (elem) {

                                            vm.dateFormat(elem);
                                            if (vm.visite && elem.paid && elem.recalled < 3) {
                                                foundVisita = true;
                                            }
                                            if (!vm.storeId) {
                                                angular.forEach($scope.$parent.main.storesList, function (s) {
                                                    if (s.id == elem.store_id) {
                                                        elem.store = { data: s };
                                                    }
                                                });
                                            }
                                            elem.treatment = { 'data': $filter('treatment')(elem.treatment_id, vm.treatmentsList) };
                                            vm.setUserRole(elem);
                                            vm.setAssistUserRole(elem);
                                            vm.setCommercialUserRole(elem);
                                            vm.setUserRoleSm(elem);
                                            vm.initRatePayment(elem);
                                            vm.initTreatmentCanChange(elem);
                                            vm.initDocuments(elem);
                                            //per il cambio operatore
                                            //$log.vinfo(elem);
                                            //$log.info(vm.user);
                                            elem.haveCard = elem.card_pf != null;
                                            elem.deliverCard = elem.card_pf != null && !elem.card_pf.data.delivered;
                                            elem.newOperatorId = elem.user_id;
                                            if (elem.role) {
                                                elem.newOperatorCandidates = [elem.role.data];
                                            }
                                            elem.treatment_name = $filter('treatmentIdtoName')(elem.treatment_id, vm.treatmentsList);
                                            if (elem.credit == null) {
                                                elem.credit = 0;
                                            }
                                            if (elem.discount == null) {
                                                elem.discount = 0;
                                            }
                                            elem.usecredit = elem.credit > 0;
                                            if (elem.credit > 0) {
                                                elem.credit_usage = $filter('filter')(vm.sconti, { sconto: elem.discount }, true)[0];
                                            }
                                            if (appCreditXuser['uid_' + elem.customer.data.id] == null) {
                                                elem.totalcredit = elem.credit + elem.customer.data.credit;
                                                appCreditXuser['uid_' + elem.customer.data.id] = 'S';
                                            } else {
                                                elem.totalcredit = elem.credit;
                                            }
                                            vm.initPriceFullPriceDiscounted(elem);
                                            /*if (elem.price_full == null) {
                                              elem.price_full = elem.price+elem.discount;
                                            }
                                            elem.price_discounted = elem.price+elem.price_due-elem.ratePayment;
                                            if (elem.price_treatment == null) {
                                                if (vm.isAcquistoDip(elem)) {
                                                    elem.price_treatment = elem.price_full - elem.product_price/2 - elem.product_price10/2;
                                                } else if (vm.isStorno(elem)) {
                                                    elem.price_treatment = 0-elem.price_full;
                                                } else {
                                                    elem.price_treatment = elem.price_full - elem.product_price - elem.product_price10;
                                                }
                                            }*/
                                            if (elem.f_smallpay) {
                                                elem.rateizzazione_type = "S";
                                            } else {
                                                if (elem.price_due > 0) {
                                                    elem.rateizzazione_type = "M";
                                                }
                                            }
                                            //$log.info(elem);

                                        });

                                        vm.appointmentsAll = response.data.data;
                                        $scope.appointments = response.data.data;

                                    } else {

                                        vm.defaultListPagination();

                                    }

                                    $scope.loading = false;
                                },
                                function () {
                                    $scope.loading = false;
                                }
                            );
                    };


                    vm.rowClicked = function (appointment, field) {
                        vm.toggleRight(appointment, true, field);
                    };


                    vm.userRolesLoad = function () {
                        console.log("UserRolesLoad partito");
                        if (vm.userRolesListAll.length == 0) {
                            var pars = { with: 'user' };
                            return UsersService
                                .allRoles(pars)
                                .then(function (response) {
                                    if (response.data && response.data.data) {
                                        vm.userRolesListAll = response.data.data;
                                        vm.userRolesList = vm.filterRolesXStore();
                                        vm.userRoles = vm.userRolesList;
                                        vm.userRolesListCall = vm.filterRolesXRole('callcenter');

                                        vm.userRoles = vm.userRolesList;
                                    }
                                });
                        } else {
                            vm.userRolesList = vm.filterRolesXStore();
                            vm.userRolesListCall = vm.filterRolesXRole('callcenter');
                        }

                    };

                    vm.filterRolesXStore = function () {
                        var fs = { active: true };
                        if (vm.storeId) {
                            fs.store_id = vm.storeId;
                        } else {
                            //fs.store_id = '>0';
                        }
                        return $filter('filter')(vm.userRolesListAll, fs, true);
                    };

                    vm.filterRolesXRole = function (role) {
                        var fs = { active: true, role: role };
                        return $filter('filter')(vm.userRolesListAll, fs, true);
                    };


                    // MODAL MODIFICA OPERATORI
                    vm.openChangeOperatorsModal = function (appointment) {
                        var dialog = $mdDialog.confirm({
                            title: 'Modifica operatori',
                            ariaLabel: 'Modifica operatori',
                            templateUrl: 'app/customer-detail/dialogs/operators.html',
                            escapeToClose: true,
                            controller: ['$scope', '$mdDialog', '$filter', function ($scope, $mdDialog, $filter) {

                                $scope.activeAppointment = appointment;
                                $scope.users = vm.userRolesList;

                                $scope.close = function () {
                                    $mdDialog.hide(true);
                                };

                                $scope.save = function () {
                                    if (
                                        $scope.activeAppointment.user_id
                                    ) {

                                        $rootScope.$broadcast(
                                            'bm-appointment-sidenav-update-users',
                                            {
                                                appointment: {
                                                    id: $scope.activeAppointment.id,
                                                    user_id: $scope.activeAppointment.user_id,
                                                    store_id: $scope.activeAppointment.store_id,
                                                    assist_user_id: $scope.activeAppointment.assist_user_id,
                                                    commercial_user_id: $scope.activeAppointment.commercial_user_id,
                                                    closed: $scope.activeAppointment.closed
                                                }
                                            }
                                        );
                                    }
                                }

                            }]
                        });

                        return $mdDialog
                            .show(dialog)
                            .finally(
                                function () {
                                    dialog = undefined;
                                }
                            )
                            ;
                    };


                    // MODAL STORICO APPUNTAMENTO
                    vm.openAppointmentHistoryModal = function (a) {
                        var dialog = $mdDialog.confirm({
                            title: 'Storico appuntamento',
                            ariaLabel: 'Storico appuntamento',
                            templateUrl: 'app/customer-detail/dialogs/appointment-history.html',
                            escapeToClose: true,
                            controller: ['$scope', '$mdDialog', '$filter', function ($scope, $mdDialog, $filter) {

                                $scope.appointmentCreationDate = null;
                                $scope.recall_types = vm.recall_types;
                                $scope.appointmentPassed = a;
                                $scope.appointment = null;
                                $scope.appointmentsList = [];
                                $scope.loadOrigin = function () {
                                    var pars = {};
                                    pars.with = "customer;byOperator;movedBy;cancelledBy;updatedBy;lead;treatment";
                                    console.log("ID APPUNTAMENTO (a.id): ", a.id);
                                    //                  $scope.loadAppointments(a.id);

                                    if (a.appointment_id == null) {//questo è l'origine
                                        $scope.appointment = a;
                                        $scope.appointmentCreationDate = moment(a.created_at.date).format('DD/MM/YYYY HH:mm');
                                        console.log("Appointment in primo if: ", a);
                                        $scope.appointmentsList.push(a);
                                        var elem = $scope.appointment;
                                        if (elem.recalled == 4) {
                                            $scope.loading = true;
                                            $scope.loadAppointments(a.id);
                                        }
                                    } else {
                                        $scope.loading = true;
                                        AppointmentsService.get(a.appointment_id, pars).then(function (response) {
                                            $scope.appointment = response.data.data;
                                            vm.setUserRole($scope.appointment);
                                            var elem = $scope.appointment;
                                            console.log("Appointment in secondo if: ", a);

                                            vm.dateFormat($scope.appointment);
                                            $scope.loadAppointments(a.appointment_id);
                                        },
                                            function (response) {
                                                var errMsg = "";
                                                if (response.data != null && response.data.message != null) {
                                                    errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                                                    var url = response.config != null && response.config.url != null ? response.config.url : "";
                                                    if (url != null) {
                                                        errMsg += "\nUrl: " + url;
                                                    }
                                                }
                                                alert("Si è verificato un errore nel caricamento appuntamenti: " + errMsg);
                                                $scope.loading = false;
                                            });
                                    }

                                }

                                /**
                                 * Tutti gli spostati
                                 */
                                $scope.loadAppointments = function (aid) {
                                    $scope.appointmentsList = [];
                                    var pars = { page: 1, s: 1000 };
                                    var search = [];
                                    var searchFields = [];
                                    search.push("appointment_id:" + aid);
                                    searchFields.push("appointment_id:=");
                                    pars.orderBy = 'id';
                                    pars.sortedBy = "desc";
                                    pars.search = search.join(";");
                                    pars.searchFields = searchFields.join(";");
                                    pars.with = "movedBy;cancelledBy;createdBy;updatedBy;treatment;user";
                                    AppointmentsService.all(pars).then(function (response) {
                                        $scope.appointmentsList = [];
                                        if (response.data && response.data.data) {
                                            var nextApp = null;
                                            /**
                                             * Itero dal più nuovo al più vecchio
                                             */
                                            angular.forEach(response.data.data, function (elem) {
                                                vm.setUserRole(elem);
                                                if (nextApp != null) {
                                                    if (elem.moved_by == null) {
                                                        elem.moved_by = nextApp.created_by;
                                                        elem.movedBy = nextApp.createdBy;
                                                    }
                                                }
                                                vm.dateFormat(elem);
                                                nextApp = elem;
                                                $scope.appointmentsList.push(elem);
                                            });
                                            /**
                                             * L'ultimo selezionato è il primo spostamento dell'originale
                                             */
                                            var elem = $scope.appointment;

                                            console.log("Appointment arrivato in loadAppointments: ", elem);
                                            if (nextApp != null) {
                                                if (elem.moved_by == null) {
                                                    elem.moved_by = nextApp.created_by;
                                                    elem.movedBy = nextApp.createdBy;
                                                }
                                            }
                                            /**
                                             * Metto anche il primo in elenco
                                             */
                                            $scope.appointmentsList.push($scope.appointment);
                                            //$log.info($scope.appointment);
                                            //$log.info($scope.appointmentsList);
                                            $scope.loading = false;
                                        };
                                    },
                                        function (response) {
                                            var errMsg = "";
                                            if (response.data != null && response.data.message != null) {
                                                errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                                                var url = response.config != null && response.config.url != null ? response.config.url : "";
                                                if (url != null) {
                                                    errMsg += "\nUrl: " + url;
                                                }
                                            }
                                            alert("Si è verificato un errore nel caricamento appuntamenti: " + errMsg);
                                            $scope.loading = false;
                                        });
                                };

                                $scope.close = function () {
                                    $mdDialog.hide(true);
                                };
                                $scope.loadOrigin();
                            }]
                        });

                        return $mdDialog
                            .show(dialog)
                            .finally(
                                function () {
                                    dialog = undefined;
                                }
                            )
                            ;
                    };


                    // MODAL NOTE
                    vm.openNoteModal = function (appointent) {
                        var headerTitle;
                        var headerAriaLabel;

                        if (appointent.closed) {
                            headerTitle = 'Nota';
                            headerAriaLabel = 'La cassa è chiusa, quindi non è possibile modificare o creare una nota';
                        }
                        else if (appointent.note == null || appointent.note == '' && !appointent.closed) {
                            headerTitle = 'Nuova nota';
                            headerAriaLabel = 'Crea nota';
                        }
                        else {
                            headerTitle = 'Modifica nota';
                            headerAriaLabel = 'Modifica nota';
                        }

                        var dialog = $mdDialog.confirm({

                            title: headerTitle,
                            ariaLabel: headerAriaLabel,
                            templateUrl: 'app/customer-detail/dialogs/notes.html',
                            escapeToClose: true,
                            controller: ['$scope', '$mdDialog', '$filter', function ($scope, $mdDialog, $filter) {

                                $scope.title = headerTitle;
                                $scope.label = headerAriaLabel;
                                $scope.appointmentPassed = appointent;

                                $scope.update = function (appointment) {
                                    $log.info('Update');
                                    console.log(appointment);
                                    if (angular.isDefined(appointment)) {
                                        var confirm = $mdDialog.confirm()
                                            .title('Attenzione')
                                            .ariaLabel('Attenzione')
                                            .textContent('Sei sicuro delle modifiche?')
                                            .ok('Si')
                                            .cancel('No');

                                        return $mdDialog
                                            .show(confirm)
                                            .then(
                                                function () {
                                                    var update_appointment = { id: appointment.id, note: appointment.note };
                                                    CrudService.update('appointments', update_appointment, vm,
                                                        function (response) {
                                                            //console.log("response: ", response);
                                                            var data = response.data.data;
                                                            vm.alignAppoiuntmentUpdatedData(appointment);
                                                        },
                                                        function (response) {
                                                        }
                                                    );
                                                },
                                                function () {
                                                }
                                            )
                                            .finally(
                                                function () {
                                                    confirm = undefined;
                                                }
                                            )
                                            ;
                                    }
                                };
                                $scope.close = function () {
                                    $mdDialog.hide(true);
                                };
                            }]
                        });
                        return $mdDialog
                            .show(dialog)
                            .finally(
                                function () {
                                    dialog = undefined;
                                }
                            )
                            ;
                    };


                    // MODAL ANAMNESI
                    vm.openAnamnesisModal = function () {
                        var dialog = $mdDialog.confirm({
                            title: 'Anamnesi',
                            ariaLabel: 'Crea anamnesi',
                            templateUrl: 'app/customer-detail/dialogs/anamnesis.html',
                            escapeToClose: true,
                            controller: ['$scope', '$mdDialog', '$filter', function ($scope, $mdDialog, $filter) {

                                $scope.customer = vm.customer;
                                $scope.user = vm.user;
                                $scope.token = vm.token;

                                $scope.loadOrigin = function () {
                                    var pars = {};
                                }

                                $scope.close = function () {
                                    $mdDialog.hide(true);
                                };
                                $scope.loadOrigin();
                            }]
                        });

                        return $mdDialog
                            .show(dialog)
                            .finally(
                                function () {
                                    dialog = undefined;
                                }
                            )
                            ;
                    };

                    vm.onKeyPressSearch = function (event) {
                        if (event.keyCode == 13) {
                            vm.loadItems();
                            event.stopPropagation();
                            event.preventDefault();
                        }
                    };

                    vm.update = function (appointment, fields) {
                        fields.id = appointment.id;
                        $('#actionSelect_' + appointment.id).hide();
                        CrudService.update('appointments', fields, vm,
                            function (response) {
                                //console.log("response: ", response);
                                var data = response.data.data;
                                vm.alignAppoiuntmentUpdatedData(appointment);
                                angular.merge(appointment, fields);
                            },
                            function (response) {
                            }
                        );
                    }

                    vm.moveAppointment = function(appointment) {

                        //vado in booking passando id appuntamento e una volta preso il nuovo appuntamento setto come disdetto questo
                        var nl = vm.env.booking +
                            "/operator?store=" + appointment.store_id +
                            "&c_sid=" + vm.user.store_id +
                            "&c_role=" + vm.user.type +
                            "&callcenter=" + (vm.user.type === 'callcenter') +
                            "&appointment=" + appointment.id +
                            "&treatment=" + appointment.treatment_id +
                            "&customer=" + appointment.customer.data.phone +
                            "&appointmentDate=" + moment(appointment.date_start).format('YYYY-MM-DD HH:mm') +
                            "&token=" + vm.token;
                        //alert (nl);
                        window.location.href = nl;

                    }


                    vm.showActionToast = function (text) {
                        text = text && angular.isDefined(text) ? text : 'Tutto Ok!';
                        var toast = $mdToast.simple()
                            .textContent(text)
                            .action('')
                            .highlightAction(true)
                            .position('bottom right');
                        return $mdToast
                            .show(toast)
                            .finally(
                                function () {
                                    toast = undefined;
                                }
                            );
                    };


                    vm.responseStatusSuccessful = [200, 201, 202];
                    vm.checkResponse = function (response, appointment) {
                        if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
                            var errMsg = "";
                            if (response.data != null && response.data.message != null) {
                                errMsg = response.data != null && response.data.message != null ? response.data.message : "";
                                var url = response.config != null && response.config.url != null ? response.config.url : "";
                                vm.showActionToast("KO: " + errMsg + " " + url);
                            }
                            var alert = $mdDialog.alert()
                                .title('Attenzione')
                                .ariaLabel('Attenzione')
                                .textContent("C'è stato un problema: " + errMsg)
                                .ok('Ok')
                                ;
                            return $mdDialog
                                .show(alert)
                                .then(function () {
                                    vm.resetAll();
                                    /**
                                     * Ripristino il valore precedente contenuto in appointment.user.data
                                     */
                                    vm.operatorChange.reset(appointment);
                                })
                                .finally(
                                    function () {
                                        alert = undefined;
                                    }
                                )
                                ;
                        } else {
                            /**
                             * Aggiorno user.data con il nuovo valore
                             */
                            vm.operatorChange.complete(appointment);
                            vm.showActionToast();
                            return vm.resetAll();
                        };
                    };


                    vm.alignAppoiuntmentUpdatedData = function (appointment) {
                        appointment.updated_by = vm.user.id;
                        appointment.updatedBy = { data: vm.user };
                        appointment.updated_at = moment();
                        appointment.updated_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                    };


                    vm.dateFormat = function (elem, deleteCreatedAt) {


                        elem.updated_at_frmt = moment(elem.updated_at.date).format('DD/MM/YYYY HH:mm');

                        var createdR = moment(elem.created_at_r);
                        elem.createdRecently = moment().diff(createdR, 'hours') < 12;
                        //$log.info(elem);
                        elem.created_at_frmt = moment(elem.created_at.date).format('DD/MM/YYYY HH:mm');

                        elem.date_fmt = moment(elem.date_start).format('DD/MM/YYYY');
                        elem.start_hour_fmt = moment(elem.date_start).format('HH:mm');
                        elem.date_end_frmt = moment(elem.date_end).format('HH:mm');

                        if (elem.moved_at != null) {
                            elem.moved_at_frmt = moment(elem.moved_at).format('DD/MM/YYYY HH:mm');
                        }
                        if (elem.cancelled_at != null) {
                            elem.cancelled_at_frmt = moment(elem.cancelled_at).format('DD/MM/YYYY HH:mm');
                        }

                        if (deleteCreatedAt) {
                            delete elem.created_at;
                            delete elem.updated_at;
                        }

                        if (elem.lead != null && elem.lead.data != null && elem.lead.data.created_at != null) {
                            elem.lead.data.created_at_frmt = moment(elem.lead.data.created_at.date).format('DD/MM/YYYY HH:mm');
                        }

                    };

                    vm.setUserRole = function (elem) {
                        if (elem.user_id) {
                            angular.forEach(vm.userRolesListAll, function (r) {
                                if (r.user_id == elem.user_id && r.store_id == elem.store_id) {
                                    elem.role = { data: r };
                                }
                            });
                        }
                    };

                    vm.setAssistUserRole = function (elem) {
                        if (elem.assist_user_id) {
                            angular.forEach(vm.userRolesListAll, function (r) {
                                if (r.user_id == elem.assist_user_id && r.store_id == elem.store_id) {
                                    elem.assistRole = { data: r };
                                }
                            });
                        }
                    };

                    vm.setCommercialUserRole = function (elem) {
                        if (elem.commercial_user_id) {
                            angular.forEach(vm.userRolesListAll, function (r) {
                                if (r.user_id == elem.commercial_user_id && r.store_id == elem.store_id) {
                                    elem.commercialRole = { data: r };
                                }
                            });
                        }
                    };

                    vm.setUserRoleSm = function (elem) {
                        if (elem.user_id_sm) {
                            angular.forEach(vm.userRolesListAll, function (r) {
                                if (r.role == 'storemngr' && r.user_id == elem.user_id_sm && r.store_id == elem.store_id) {
                                    elem.roleSm = { data: r };
                                }
                            });
                        }
                    };

                    vm.initRatePayment = function (app) {
                        app.ratePayment = 0;
                        app.ratePaymentIds = [];
                        if (app.customer && app.customer.data && app.customer.data.payments) {
                            angular.forEach(app.customer.data.payments.data, function (payment) {
                                if (payment.selected) {
                                    app.ratePayment += payment.total;
                                    payment.selected = true;
                                    app.ratePaymentIds.push(payment.id);
                                }
                            });
                        }
                        if (app.payments && app.payments.data) {
                            angular.forEach(app.payments.data, function (payment) {
                                if (payment.selected === undefined) {
                                    payment.selected = true;
                                }
                                if (payment.selected) {
                                    app.ratePayment += payment.total;
                                    app.ratePaymentIds.push(payment.id);
                                }
                            });
                        }
                    };

                    vm.initTreatmentCanChange = function (app) {
                        app.treatmentCanChange = false;
                        if (app.treatment_id) {
                            //$log.info("App "+app.id+" recalled is "+app.recalled);
                            app.treatmentCanChange = !app.closed
                                && app.recalled < 3
                                && (vm.user.type == 'admin'
                                    || vm.user.type == 'storemngr'
                                    || vm.user.type == 'assist'
                                );
                        }
                    };

                    vm.initDocuments = function (app) {
                        if (!vm.env.documentsEnabled) {
                            return;
                        }
                        //$log.info('trt',app.treatment);
                        //$log.info("docs",app.documents);
                        /**
                         * verifico se presente privacy + autorizzazione foto + consenso al trattamento corrente
                         */
                        app.docPrivacyOk = false;
                        app.docCovidOk = false;
                        app.docPicturesOk = false;
                        app.docContrPicturesOk = false;
                        app.docTreatmentOk = false;
                        if (!app.treatment.data.document_template_id) {
                            app.docTreatmentOk = true;
                        }
                        angular.forEach(app.documents.data, function (doc) {
                            if (doc.document_type_id == 301 && !app.docPrivacyOk) {
                                app.docPrivacyOk = true;
                                app.docPrivacy = { 'data': doc };
                            } else if (doc.document_type_id == 302 && !app.docPicturesOk) {
                                app.docPicturesOk = true;
                                app.docPictures = { 'data': doc };
                            } else if (doc.document_type_id == 305 && !app.docCovidOk) {
                                app.docCovidOk = true;
                                app.docCovid = { 'data': doc };
                            } else if (doc.document_template_id == app.treatment.data.document_template_id && !app.docTreatmentOk) {
                                app.docTreatmentOk = true;
                                app.docTreatment = { 'data': doc };
                            }
                        });
                        app.pictureBeforeOk = true;
                        app.pictureAfterOk = true;
                        if (app.docPicturesOk) {
                            if (app.treatment.data.f_pic_before &&
                                    (!app.pictures || !app.pictures.data || $filter('filter')(app.pictures.data, { parameter: '1' }, true).length == 0)) {
                                app.pictureBeforeOk = false;
                                //$log.info("manca foto prima");
                            }
                            if (app.treatment.data.f_pic_after &&
                                (!app.pictures || !app.pictures.data || $filter('filter')(app.pictures.data, { parameter: '2' }, true).length == 0)) {
                                app.pictureAfterOk = false;
                                //$log.info("manca foto dopo");
                            }
                        }

                        //$log.info("docPrivacy "+app.id,app.docPrivacyOk);
                        //$log.info("docCovid "+app.id,app.docCovidOk);
                        //$log.info("docPictures "+app.id,app.docPicturesOk);
                        //$log.info("docTreatmentOk "+app.id,app.docTreatmentOk);
                    };


                    vm.initPriceFullPriceDiscounted = function (elem) {
                        /**
                         * elem.price_treatment se non inizializzato caso pregresso
                         */
                        var priceProd = 0;
                        if (vm.isAcquistoDip(elem)) {
                            priceProd = elem.product_price / 2 + elem.product_price10 / 2;
                        } else {
                            priceProd = elem.product_price + elem.product_price10;
                        }
                        if (!elem.price_discounted) {
                            elem.price_discounted = elem.price + elem.price_due - elem.ratePayment;
                        }
                        if (vm.isStorno(elem)) {
                            elem.price_discounted = 0 - elem.price_discounted;
                        }
                        if (elem.price_treatment === null) {
                            elem.price_treatment = elem.price_discounted - priceProd;
                        }
                        elem.price_full = elem.price_treatment + priceProd;
                        if (vm.isStorno(elem)) {
                            elem.price_full = 0 - elem.price_full;
                        }
                    };

                    vm.isAcquistoDip = function (app) {
                        return app.treatment_id == 67 || app.treatment_id == 68 || app.treatment_id == 69;
                    };

                    vm.isStorno = function (elem) {
                        return elem && elem.treatment_id &&
                            (elem.treatment_id == 85 ||
                                elem.treatment_id == 86 ||
                                elem.treatment_id == 87
                            );
                    };


                    vm.planAppointment = function ( appointment, old_value ) {
                        $log.info( 'Pianifica Appuntamento' );
                        vm.activeAppointment = null;
                        if( appointment ) {
                            var confirm = $mdDialog.confirm()
                                .title( 'Attenzione' )
                                .ariaLabel( 'Attenzione' )
                                .textContent(
                                    'Sicuro di voler segnare come "PIANIFICARE" questo appuntamento?'
                                )
                                .ok( 'Si' )
                                .cancel( 'Ops, ho sbagliato' );
                            return $mdDialog
                                .show( confirm )
                                .then(
                                    function() {
                                        
                                        vm.updateAppointmentBooking(
                                            appointment,
                                            appointment.store_id
                                        );
            
                                    },
                                    function() {
                                        appointment.recalled = old_value;
                                    }
                                )
                                .finally(
                                    function() {
                                        confirm = undefined;
                                    }
                                )
                            ;
                        };
                    };     
                    
                    
                    vm.updateAppointmentBooking = function(
                        appointment,
                        store_id
                    ) {
            
                        var nl = vm.env.booking +
                            "/operator?store=" + store_id +
                            "&c_sid=" + vm.user.store_id +
                            "&c_role=" + vm.user.type +
                            "&callcenter=" + vm.isCallCenter +
                            "&appointment=" + appointment.id +
                            "&treatment=" + appointment.treatment_id +
                            "&customer=" + appointment.customer.data.phone +
                            "&appointmentDate=" + moment(appointment.date_start).format('YYYY-MM-DD HH:mm') +
                            "&token="+vm.token;
                            
                        //alert (nl);
                        window.location.href = nl;
            
                    }


                    vm.saveStatus = function () {
                        var eStatusStorageName = (vm.customer)? 'appointments_customer_eStatus' : 'appointments_storemanager_eStatus';
                        var queryStorageName = (vm.customer)? 'appointments_cusotmer_query' : 'appointments_storemanager_query';

                        localStorage.setItem( eStatusStorageName, angular.toJson( vm.eStatus, false ) );
                        localStorage.setItem( queryStorageName, angular.toJson( vm.query, false ) );
                    };


                    vm.restoreStatus = function () {
                        var eStatusStorageName = (vm.customer)? 'appointments_customer_eStatus' : 'appointments_storemanager_eStatus';
                        var queryStorageName = (vm.customer)? 'appointments_cusotmer_query' : 'appointments_storemanager_query';

                        var eStatus = angular.fromJson(localStorage.getItem(eStatusStorageName));
                        if (eStatus!=null) {
                          vm.eStatus = eStatus;
                        }
                        var query = angular.fromJson(localStorage.getItem(queryStorageName));
                        if (query!=null) {
                          vm.query =  query;
                        }
                    };


                    vm.removeSearch = function (reload) {

                        vm.query.filter = '';
                        vm.query.status = '';
                        vm.query.order = 'date_start';
                        vm.query.page = 1;

                        vm.eStatus = {};
                        vm.eStatus.filterReminder = (vm.customer)? 5 : null;
                        vm.eStatus.filterPresenza = (vm.customer)? 1 : null;
                        vm.eStatus.filterEsito = null;
                        vm.eStatus.filterAgenda = null;
                        vm.eStatus.filterDateStart = (!vm.customer)? vm.today : null;
                        vm.eStatus.filterTimeStart = (!vm.customer)? new Date(moment().subtract(1,'hour')).getTime() : null;
                        vm.eStatus.filterDateEnd = null;
                        vm.eStatus.filterOperatorId = null;
                        vm.eStatus.filterCommercialId = null;
                        vm.eStatus.filterAssistId = null;

                        if(reload){
                            vm.loadItems();
                        }
                    };    


                    this.$onInit = function () {

                        vm.customer = this.customer;
                        vm.user = this.user;
                        vm.token = this.token;
                        vm.today = new Date( moment().hour(8).minute(0).second(0) );

                        //RESTORE FILTERS FROM LOCAL STORAGE
                        vm.removeSearch(false);
                        vm.restoreStatus();

                        if (vm.customer) {
                            vm.loadItems();
                        }

                    };


                    /* WATCHO Lo Store */
                    vm.storeId = undefined;
                    vm.store = {};
                    $scope.$watch('$parent.selectedStore', function (id) {
                        vm.storeId = id;
                        vm.store = {};
                        if (angular.isDefined(id)) {
                            if (id > 0) {
                                if (vm.user.type == 'operator' || vm.user.type == 'storemngr' && vm.user.store_id != vm.storeId) {
                                    vm.disdSpostEnabled = false;
                                    /**
                                     * Carico presenza store manager per questo store e di conseguenza setto parametro
                                     */
                                    var adesso = moment().format('YYYY-MM-DD HH:mm:ss');
                                    OperatorAvailabilityService.all(
                                        {
                                            search: "store_id:" + vm.storeId + ";date_start:" + adesso + ";date_end:" + adesso + ";reserved:5",
                                            searchFields: "store_id:=;date_start:<=;date_end:>;reserved"
                                        }
                                    ).then(
                                        function (data) {
                                            if (data.length == 0) {
                                                vm.disdSpostEnabled = true;
                                            } else {
                                                vm.disdSpostEnabled = false;
                                            }
                                        });

                                } else {
                                    vm.disdSpostEnabled = true;
                                }
                                angular.forEach($scope.$parent.main.storesList, function (s) {
                                    if (s.id == vm.storeId) {
                                        vm.store = s;
                                    }
                                });
                            }
                            vm.userRolesLoad();

                        }


                        //IF CUSTOMER IS NULL RELOAD APPOINTEMNTS BY STORE ID
                        if (!vm.customer && vm.storeId >= 0) {
                            vm.loadItems();
                        }

                    });


                    //OPEN APPOINTMENT SIDEBAR
                    vm.toggleRight = function (appointment, isRowClick, updatingField) {
                        $rootScope.$broadcast(
                            'bm-appointment-sidenav-toggleRight',
                            {
                                appointment: appointment,
                                isRowClick: isRowClick,
                                updatingField: updatingField
                            }
                        );
                    };


                    vm.toggleActionSelect = function (appointment) {
                        //appointment.showActionSelect = !appointment.showActionSelect;
                        //alert($('#actionSelect_'+appointment.id));
                        //console.log($('#actionSelect_'+appointment.id));
                        $('#actionSelect_' + appointment.id).toggle();
                    };


                    //ADD APPOINTMENT AFTER CREATE
                    $scope.$on("bm-appointment-sidenav-reloadAppointments", function (event, data) {
                        vm.loadItems();
                    });

                }]
        }
    }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("bmAppointmentsHistory", bmAppointmentsHistory);
    function bmAppointmentsHistory() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bm-appointments-history/bm-appointments-history.html",
            bindToController: {
                customer: "=",
                user: "=",
                token: "="
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                "$filter",
                "$http",
                "$scope",
                "$log",
                "$mdDialog",
                "$mdToast",
                "$rootScope",
                "env",
                "CrudService",
                "AppointmentsService",
                "TreatmentService",
                "UsersService",
                function (
                    $filter,
                    $http,
                    $scope,
                    $log,
                    $mdDialog,
                    $mdToast,
                    $rootScope,
                    env,
                    CrudService,
                    AppointmentsService,
                    TreatmentService,
                    UsersService
                ) {

                    var vm = this;
                    $log.info('bmAppointmentsHistory');

                    /**
                     * Per crud service
                     */
                    //SERVE QUESTA ROBA QUA?
                    vm.mdToast = $mdToast;
                    vm.mdDialog = $mdDialog;
                    vm.env = env;
                    //SERVE QUESTA ROBA QUA?

                    vm.defaultListPagination = function () {
                        $scope.listPagination = {
                            "total": 0,
                            "count": 0,
                            "per_page": 50,
                            "current_page": 1,
                            "total_pages": 0,
                            "links": {}
                        };
                    }
                    vm.defaultListPagination();

                    $scope.query = {
                        filter: '',
                        status: '',
                        order: '-date_start',
                        off: 0,
                        limit: 50,
                        page: 1,
                        filter_customer: '',
                        filter_treatment: ''
                    };

                    $scope.loading = true;
                    vm.filterReminder = 4;
                    vm.filterPresenza = 1;

                    $scope.orderItems = function (column) {
                        vm.query.order = column;
                        vm.loadItems();
                    };


                    vm.loadItems = function (p, s) {

                        vm.appointments = [];
                        $scope.loading = true;

                        if (p == null) {
                            p = 1;
                        }
                        if (s == null) {
                            s = parseInt($scope.listPagination.per_page);
                        }

                        var pars = {};
                        var search = [];
                        var searchFields = [];

                        pars.with = "user;customer;assist_user";

                        //IF ISSET CUSTOMER FILTER BY CUSTOMER
                        if (vm.customer) {
                            searchFields.push("appointments.customer_id:=");
                            search.push("appointments.customer_id:" + vm.customer.id);

                            // search.push("appointments.recalled:" + vm.filterReminder);
                            // searchFields.push("appointments.recalled:=");

                            search.push("appointments.paid:" + vm.filterPresenza);
                            searchFields.push("appointments.paid:=");
                        }

                        pars.search = search.join(";");
                        pars.searchFields = searchFields.join(";");

                        pars.page = p;
                        pars.s = s;
                        pars.orderBy = 'date_start';
                        pars.sortedBy = 'desc';

                        AppointmentsService
                            .all(pars)
                            .then(
                                function (response) {


                                    if (response.data &&
                                        response.data.data &&
                                        response.data.data.length > 0
                                    ) {
                                        $scope.listPagination = response.data.meta.pagination;

                                        angular.forEach(response.data.data, function (appointment) {
                                            appointment.date_fmt = moment(appointment.date_start).format('DD/MM/YYYY');
                                        });

                                        vm.appointmentsAll = response.data.data;

                                    } else {
                                        vm.defaultListPagination();

                                    }

                                    $scope.loading = false;
                                },
                                function () {
                                    $scope.loading = false;
                                }
                            );
                    };

                    this.$onInit = function () {

                        vm.customer = this.customer;
                        vm.user = this.user;
                        vm.token = this.token;

                        vm.loadItems($scope.query.page, 50);

                    };


                    //ADD APPOINTMENT AFTER CREATE
                    $scope.$on("bm-appointment-sidenav-reloadAppointments", function (event, data) {
                        vm.loadItems();
                    });

                }]
        }
    }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("bmAppointmentSidenav", bmAppointmentSidenav);
    function bmAppointmentSidenav() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bm-appointment-sidenav/bm-appointment-sidenav.html",
            bindToController: {
                customer: "="
            },
            scope: true,
            controllerAs: "ap",
            controller: [
                '$scope',
                '$log',
                '$http',
                '$mdDialog',
                'moment',
                'TreatmentService',
                'AppointmentsService',
                'CustomerService',
                '$filter',
                '$timeout',
                '$location',
                '$mdSidenav',
                '$mdToast',
                'UsersService',
                'env',
                'SubscriptionService',
                'CustomerSubscriptionService',
                'OperatorAvailabilityService',
                'CrudService',
                'RecallTypes',
                '$rootScope',
                function (
                    $scope,
                    $log,
                    $http,
                    $mdDialog,
                    moment,
                    TreatmentService,
                    AppointmentsService,
                    CustomerService,
                    $filter,
                    $timeout,
                    $location,
                    $mdSidenav,
                    $mdToast,
                    UsersService,
                    env,
                    SubscriptionService,
                    CustomerSubscriptionService,
                    OperatorAvailabilityService,
                    CrudService,
                    RecallTypes,
                    $rootScope
                ) {

                    var vm = this;
                    $log.info('bmAppointmentSidenav');

                    vm.filtersList = [
                        {
                            value: 3,
                            name: "In agenda",
                        },
                        {
                            value: 7,
                            name: "Da chiamare",
                        },
                        {
                            value: 8,
                            name: "Non risp.",
                        },
                        {
                            value: 0,
                            name: "Non present.",
                        },
                        {
                            value: 1,
                            name: "Presentato",
                        },
                        {
                            value: 2,
                            name: "Pagato",
                        },
                        {
                            value: 4,
                            name: "In Agenda + Disd.",
                        },
                        {
                            value: 5,
                            name: "Disdetti",
                        },
                        {
                            value: 6,
                            name: "Spostati",
                        },
                        {
                            value: 9,
                            name: "Scoperti",
                        },
                        {
                            value: 17,
                            name: "Pag. Assegno",
                        },
                        {
                            value: 11,
                            name: "Pag. Bonifico",
                        },
                        {
                            value: 14,
                            name: "Pag. Contanti",
                        },
                        {
                            value: 16,
                            name: "Pag. Gift",
                        },
                        {
                            value: 12,
                            name: "Pag. Pagodil",
                        },
                        {
                            value: 13,
                            name: "Pag. Pos",
                        }
                    ];
                    if (env.smallpayEnabled) {
                        vm.filtersList.push({value: 15, name: 'Pag. Smallpay'});
                    }
                    if (env.satispayEnabled) {
                        vm.filtersList.push({value: 18, name: 'Pag. Satispay'});
                    }

                    vm.filtersListUT = [
                        {
                            value: 1,
                            name: "1a volta",
                        },
                        {
                            value: 2,
                            name: "Smaltimento",
                        },
                    ];

                    vm.filtersListCOM = [
                        {
                            value: 1,
                            name: "Commerc.",
                        },
                        {
                            value: 4,
                            name: "Comm. da bidoni",
                        },
                        {
                            value: 8,
                            name: "Comm. da lead",
                        },
                        {
                            value: 9,
                            name: "Comm. Phone Friend",
                        },
                        {
                            value: 11,
                            name: "Comm. rullo o nuovi cli.",
                        },
                        {
                            value: 2,
                            name: "Non Comm.",
                        },
                        {
                            value: 3,
                            name: "Rullo e social",
                        },
                        {
                            value: 10,
                            name: "Non fidelizzati",
                        },
                        {
                            value: 7,
                            name: "Rate insolute",
                        },
                        {
                            value: 5,
                            name: "Online Booking",
                        },
                        {
                            value: 6,
                            name: "Bot Booking",
                        },
                    ];

                    vm.filtersListAnom = [
                        {
                            value: 'A',
                            name: "Con anomalia",
                        },
                        {
                            value: 'N',
                            name: "Non risolte",
                        },
                        {
                            value: 'RP',
                            name: "Recensioni positive",
                        },
                        {
                            value: 'RN',
                            name: "Recensioni negative",
                        }
                    ];

                    vm.appointmentTypologies = [
                        {value:null,label:'Prezzo pieno'},
                        {value:'promo',label:'Promo'},
                        {value:'free',label:'Omaggio'}
                    ];        vm.sconti = [
                        {sconto: 5, credit: 800, limit: 20 },
                        {sconto: 10, credit: 1500, limit: 30 },
                        {sconto: 25, credit: 3000, limit: 50 },
                        {sconto: 50, credit: 5000, limit: 80 },
                        {sconto: 80, credit: 7500, limit: 150 },
                        {sconto: 115, credit: 10000, limit: 230 },
                        {sconto: 250, credit: 20000, limit: 400 },
                        {sconto: 500, credit: 30000, limit: 800 }
                    ];

                    vm.showLegend = false;
                    /* Operatore connesso */
                    if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
                        return;
                    }

                    vm.treatmentParams = [];
                    CrudService.all('treatment_params', { with: 'param' }, vm, function (response) {
                        vm.treatmentParams = response.data.data;
                        //console.log(vm.treatmentParams);
                    }, function (response) {
                        //console.log(response);
                    });
                    vm.maxDiscount = $scope.$parent.main.config.get("appointment.maxdiscount", 20);
                    vm.maxRate = 6;
                    vm.sogliaRateizzazione = $scope.$parent.main.config.get("appointment.sogliarateizzazione", 0);
                    vm.minAccontoPerc = $scope.$parent.main.config.get("appointment.minaccontoperc", 0);
                    vm.minAcconto = $scope.$parent.main.config.get("appointment.minacconto", 0);
                    vm.sogliaAcconto = $scope.$parent.main.config.get("appointment.sogliaacconto", 0);
                    vm.canEdit = {
                        'price_treatment': $scope.$parent.main.config.get("appointment.editenabled.price_treatment", false),
                        'price_due': $scope.$parent.main.config.get("appointment.editenabled.price_due", false)

                    };
                    vm.refEnabled = $scope.$parent.main.config.get("appointment.ref.enabled", false);
                    //$log.info('refEnabled: '+vm.refEnabled);
                    //$log.info(filter);
                    //$log.info(filter_date);
                    /*
                     * Provo config
                     */
                    //$log.info("appointment.maxdiscount: " + $scope.$parent.main.config.get("appointment.maxdiscount",-1));
                    //$log.info("prova.config:");
                    //$log.info($scope.$parent.main.config.get("prova.config", {'xx':10}));
                    vm.disdSpostEnabled = true;
                    vm.env = env;
                    vm.mdToast = $mdToast;
                    vm.mdDialog = $mdDialog;
                    $log.info('AppointmentsController');
                    //---------- Appointments -------------------------------------//
                    vm.viewAction = false;
                    vm.customersLoading = false;
                    vm.isNewAppointment = false;
                    vm.customer_id = undefined;
                    vm.selected = [];
                    vm.recall_types = RecallTypes;
                    vm.options = {
                        autoSelect: false,
                        boundaryLinks: true,
                        pageSelector: true,
                        rowSelection: false
                    };
                    vm.filter = {
                        options: {
                            'debounce': 0,
                            'updateOn': 'default'
                        }
                    };
                    vm.treatmentdate = null;
                    vm.today = new Date(moment().hour(8).minute(0).second(0));
                    vm.yesterday = new Date(moment(vm.today).subtract(1, 'days'));
                    vm.minday = vm.user.type != 'admin' ? new Date(moment(vm.today).subtract(1, 'days'))
                        : null;

                    vm.query = {
                        filter: this.filter ? this.filter : '',
                        filter_customer: '',
                        filter_treatment: '',
                        order: 'date_start',
                        limit: 20,
                        page: 1
                    };

                    /* Treatments */
                    vm.treatmentsList = [];
                    vm.treatmentsListStoreId = null;
                    vm.treatmentsListAll = [];
                    vm.laserTreatmentsList = [];
                    vm.portaEnabled = true;
                    vm.appointmentProducts = [];
                    vm.appointmentCartProducts = [];
                    vm.hideAppointmentProducts = false;
                    var appCurrentTreatment = null;
                    vm.filterTreatments = function () {
                        if (!vm.treatmentsLoaded || vm.treatmentsListStoreId == vm.storeId) {
                            return;
                        }
                        vm.treatmentsListStoreId = vm.storeId;
                        vm.treatmentsList = [];
                        //$log.info("vm.filterTreatments: "+ vm.storeId);
                        var filterCategory = vm.storeId && vm.env.stores != null && vm.env.stores[vm.storeId] != null && vm.env.stores[vm.storeId].categories != null;
                        //$log.info("vm.filterTreatments: filterCategory="+ filterCategory);
                        angular.forEach(vm.treatmentsListAll, function (ct) {
                            //$log.info(ct);
                            if (filterCategory) {
                                //$log.info(vm.env.stores[vm.storeId].categories);
                                //$log.info(vm.env.stores[vm.storeId].categories.includes(ct.id));
                            }
                            if (!filterCategory || vm.env.stores[vm.storeId].categories.includes(ct.id)) {
                                vm.treatmentsList.push(ct);
                            }
                        });
                    }
                    vm.pricings = [];
                    vm.pricingsLoad = function () {
                        vm.pricings = [];
                        $http
                            .get(env.API + "/leads_campaign_pricings")
                            .then(function (response) {
                                if (response.data && response.data.data) {
                                    vm.pricings = response.data.data;
                                }
                            });
                    };
                    vm.pricingsLoad();
                    vm.treatmentsLoaded = false;
                    TreatmentService.categories().then(function (data) {
                        //$log.info(data);
                        vm.treatmentsListAll = data;
                        var ids = [1, 2, 3, 4, 5, 6, 126, 127, 128, 129];
                        for (var i = 0; i < ids.length; i++) {
                            //console.log(ids[i]);
                            var t = $filter('treatment')(ids[i], vm.treatmentsListAll);
                            //$log.info("trattamento "+ ids[i]);
                            //$log.info(t);
                            if (t != null && t != '') {
                                vm.laserTreatmentsList.push(t);
                            }
                        }
                        vm.treatmentsLoaded = true;
                        vm.filterTreatments();
                    });
                    /* Subscriptions */
                    vm.subscriptionsList = [];
                    SubscriptionService.all({ search: 1, searchFields: 'active:=' }).then(function (response) {
                        vm.subscriptionsList = response.data.data;
                    });

                    vm.subscriptionsListByCustomer = [];
                    vm.customerSubscriptionService = CustomerSubscriptionService;
                    vm.checkSubscriptionByUserNewAppointment = function(item) {
                        if (vm.isNewAppointment) {
                            var options = {
                                with: 'subscription;quotation',
                                search:
                                    'customer_id:' + item
                                ,
                                searchFields: 'customer_id:=;'
                            };

                            vm.subscriptionsListByCustomer = [];

                            vm.customerSubscriptionService.get( options ).then(function( response ){
                                angular.forEach( response.data.data, function( elem ) {
                                    if((elem.customer_id == item) && (elem.app_remaining >= 1)) {
                                        vm.subscriptionsListByCustomer.push(elem);
                                    }
                                });
                            });
                        }
                    };

                    vm.checkSubscriptionByUserAndSetSubscriptionName = function (item, appointment, callback) {
                        var options = {
                            with: 'subscription;quotation',
                            search:
                                'customer_id:' + item
                            ,
                            searchFields: 'customer_id:=;'
                        };

                        vm.subscriptionsListByCustomer = [];

                        vm.customerSubscriptionService.get(options).then(
                            function (response) {
                                angular.forEach(response.data.data, function (elem) {
                                    if ((elem.customer_id == item) && (elem.app_remaining >= 1)) {
                                        vm.subscriptionsListByCustomer.push(elem);
                                    }
                                    else {
                                        if (appointment.customer_subscription_id == elem.id) {
                                            vm.subscriptionsListByCustomer.push(elem);
                                        }
                                    }
                                });
                            }
                        ).then(callback);
                    };

                    /* Appointments */
                    vm.totFirstTime = 0;
                    vm.totPrices = 0;
                    vm.appointmentsList = [];
                    vm.loading = true;
                    vm.appCustomerParams = {};
                    vm.amountEarnedWithThisAppointment = 0;

                    vm.emettiCardPf = function (app) {
                        CrudService.save(
                            'cards',
                            {
                                'store_id': app.store_id,
                                'appointment_id': app.id,
                                'customer_id': app.customer_id,
                                'campaign': 'PhoneFriend'
                            }, vm,
                            function (response) {
                                //$log.info(response);
                                app.card = { 'data': response.data.data };
                                app.haveCard = true;
                                app.deliverCard = true;
                                var nl = vm.env.booking +
                                    "/pf?store=" + vm.storeId +
                                    "&c_sid=" + vm.user.store_id +
                                    "&c_role=" + vm.user.type +
                                    "&cph=" + app.customer.data.phone +
                                    "&crdid=" + app.card.data.id +
                                    "&token=" + vm.token;
                                //alert (nl);
                                window.open(nl, '_blank');
                            },
                            function (response) {

                            });
                    };

                    vm.delAp = function (id) {
                        $log.info('Del');
                        if (angular.isDefined(id)) {
                            var confirm = $mdDialog.confirm()
                                .title('Attenzione')
                                .ariaLabel('Attenzione')
                                .textContent('Sicuro di voler eliminare questo appuntamento?')
                                .ok('Si')
                                .cancel('Ops, ho sbagliato')
                            ;
                            return $mdDialog
                                .show(confirm)
                                .then(
                                    function () {
                                        var position = vm.appointmentsList.map(function (x) { return x.id; }).indexOf(id);
                                        AppointmentsService.del(vm.appointmentsList[position]).then(function (response) {
                                            vm.calcsOnVisibileElements();
                                            if (response.status === 204) {
                                                vm.appointmentsList.splice(position, 1);
                                            } else {
                                                alert("Errore durante l'elaborazione delle richiesta.");
                                            };
                                        });
                                    }
                                )
                                .finally(
                                    function () {
                                        confirm = undefined;
                                    }
                                )
                                ;
                        };
                    };
                    vm.confirmAp = function (id) {
                        $log.info('Confirmed');
                        vm.activeAppointment = null;
                        var position = vm.appointmentsList.map(function (x) { return x.id; }).indexOf(id);
                        if (position !== -1) {
                            var confirm = $mdDialog.confirm()
                                .title('Attenzione')
                                .ariaLabel('Attenzione')
                                .textContent(
                                    'Sicuro di voler ' +
                                    (
                                        vm.appointmentsList[position].confirmed
                                            ? 'Annullare'
                                            : 'Confermare'
                                    ) +
                                    ' questo appuntamento?'
                                )
                                .ok('Si')
                                .cancel('Ops, ho sbagliato')
                            ;
                            return $mdDialog
                                .show(confirm)
                                .then(
                                    function () {
                                        if (vm.appointmentsList[position].confirmed) {
                                            vm.appointmentsList[position].confirmed = 0;
                                        } else {
                                            vm.appointmentsList[position].confirmed = 1;
                                        };

                                        angular.copy(vm.appointmentsList[position], vm.update_appointment);
                                        vm.appointmentsList[position].updated_by = vm.user.id;
                                        vm.appointmentsList[position].updatedBy = { data: vm.user };
                                        vm.appointmentsList[position].updated_at = moment();
                                        vm.appointmentsList[position].updated_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                                        AppointmentsService.update({ id: vm.update_appointment.id, confirmed: vm.update_appointment.confirmed });
                                    }
                                )
                                .finally(
                                    function () {
                                        confirm = undefined;
                                    }
                                )
                                ;
                        };
                    };
                    /* Ricordato Non-Ricordato ... disdetto spostato */
                    vm.rememberApSelect = function (id, old_value, store_id) {
                        $log.info('Ricordato Non-Ricordato');
                        vm.activeAppointment = null;
                        var position = vm.appointmentsList.map(function (x) { return x.id; }).indexOf(id);
                        if (position !== -1) {
                            if (false && vm.appointmentsList[position].user_times < 2
                                && vm.appointmentsList[position].byOperator.data.id > 0
                                && vm.appointmentsList[position].byOperator.data.store_id == 0
                                && vm.user.store_id != null) {
                                vm.appointmentsList[position].recalled = old_value;
                                vm.showActionToast("Operazione non consentita su appuntamento commerciale");
                                return;
                            }
                            var confirm = $mdDialog.confirm()
                                .title('Attenzione')
                                .ariaLabel('Attenzione')
                                .textContent(
                                    'Sicuro di voler segnare come "' +
                                    vm.recall_types[vm.appointmentsList[position].recalled].text_esteso.toUpperCase() +
                                    '" questo appuntamento?'
                                )
                                .ok('Si')
                                .cancel('Ops, ho sbagliato');
                            return $mdDialog
                                .show(confirm)
                                .then(
                                    function () {
                                        if (vm.appointmentsList[position].recalled != 4) {
                                            angular.copy(vm.appointmentsList[position], vm.update_appointment);
                                            AppointmentsService.update({
                                                    id: vm.update_appointment.id,
                                                    recalled: vm.update_appointment.recalled,
                                                    paid: vm.update_appointment.recalled < 3 ? vm.update_appointment.paid : 0
                                                }
                                            ).then(
                                                function (response) {
                                                    if (vm.appointmentsList[position].recalled == 3) {
                                                        vm.appointmentsList[position].cancelled_at = moment();
                                                        vm.appointmentsList[position].cancelled_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                                                        vm.appointmentsList[position].cancelledBy = { data: vm.user };
                                                        vm.appointmentsList[position].cancelled_by = vm.user.id;
                                                        if (vm.appointmentsList[position].paid && vm.appointmentsList[position].paid == 1) {
                                                            vm.appointmentsList[position].paid = 0;
                                                            vm.calcsOnVisibileElements();
                                                        }
                                                    } else {
                                                        vm.appointmentsList[position].cancelled_at = null;
                                                        vm.appointmentsList[position].cancelled_at_frmt = null;
                                                        vm.appointmentsList[position].cancelledBy = null;
                                                        vm.appointmentsList[position].cancelled_by = null;
                                                    }
                                                    vm.appointmentsList[position].updated_by = vm.user.id;
                                                    vm.appointmentsList[position].updatedBy = { data: vm.user };
                                                    vm.appointmentsList[position].updated_at = moment();
                                                    vm.appointmentsList[position].updated_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                                                    vm.initTreatmentCanChange(vm.appointmentsList[position]);
                                                    vm.showActionToast();
                                                },
                                                function (response) {
                                                    vm.appointmentsList[position].recalled = old_value;
                                                    vm.checkResponse(response, vm.appointmentsList[position]);
                                                }
                                            );
                                        } else {
                                            //vado in booking passando id appuntamento e una volta preso il nuovo appuntamento setto come disdetto questo
                                            var nl = vm.env.booking +
                                                "/operator?store=" + store_id +
                                                "&c_sid=" + vm.user.store_id +
                                                "&c_role=" + vm.user.type +
                                                "&callcenter=" + vm.isCallCenter +
                                                "&appointment=" + vm.appointmentsList[position].id +
                                                "&treatment=" + vm.appointmentsList[position].treatment_id +
                                                "&customer=" + vm.appointmentsList[position].customer.data.phone +
                                                "&appointmentDate=" + moment(vm.appointmentsList[position].date_start).format('YYYY-MM-DD HH:mm') +
                                                "&token=" + vm.token;
                                            //alert (nl);
                                            window.location.href = nl;
                                        }
                                    },
                                    function () {
                                        vm.appointmentsList[position].recalled = old_value;
                                    }
                                )
                                .finally(
                                    function () {
                                        confirm = undefined;
                                    }
                                )
                                ;
                        };
                    };
                    /**
                     * Non usata
                     */
                    vm.rememberAp = function (id) {
                        $log.info('Ricordato Non-Ricordato');
                        vm.activeAppointment = null;
                        var position = vm.appointmentsList.map(function (x) { return x.id; }).indexOf(id);
                        if (position !== -1) {
                            var confirm = $mdDialog.confirm()
                                .title('Attenzione')
                                .ariaLabel('Attenzione')
                                .textContent(
                                    'Sicuro di voler ' +
                                    (
                                        vm.appointmentsList[position].recalled
                                            ? 'Segnare come RICORDATO'
                                            : 'Segnare come NON Ricordato'
                                    ) +
                                    ' questo appuntamento?'
                                )
                                .ok('Si')
                                .cancel('Ops, ho sbagliato')
                            ;
                            return $mdDialog
                                .show(confirm)
                                .then(
                                    function () {
                                        if (vm.appointmentsList[position].recalled) {
                                            vm.appointmentsList[position].recalled = 0;
                                        } else {
                                            vm.appointmentsList[position].recalled = 1;
                                        };
                                        vm.appointmentsList[position].updated_at = moment();
                                        vm.appointmentsList[position].updated_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                                        angular.copy(vm.appointmentsList[position], vm.update_appointment);
                                        AppointmentsService.update({ id: vm.update_appointment.id, recalled: vm.update_appointment.recalled });
                                    }
                                )
                                .finally(
                                    function () {
                                        confirm = undefined;
                                    }
                                )
                                ;
                        };
                    };
                    vm.minPrice = function () {
                        if (vm.activeAppointment && vm.activeAppointment.price_discounted) {
                            return (vm.activeAppointment.price_discounted < vm.sogliaAcconto ? (vm.minAccontoPerc / 100) * vm.activeAppointment.price_discounted : vm.minAcconto);
                        } else {
                            return 0;
                        }
                    }
                    /* Pagato Non-Pagato */
                    vm.payAp = function (id) {
                        $log.info('Pagato Non-Pagato');
                        vm.activeAppointment = null;
                        var position = vm.appointmentsList.map(function (x) { return x.id; }).indexOf(id);
                        if (position !== -1) {
                            if (vm.appointmentsList[position].recalled == 3) {
                                vm.showActionToast("Appuntamento disdetto.");
                                return;
                            }
                            if (vm.appointmentsList[position].recalled == 4) {
                                vm.showActionToast("Appuntamento spostato.");
                                return;
                            }
                            var confirm = $mdDialog.confirm()
                                .title('Attenzione')
                                .ariaLabel('Attenzione')
                                .textContent(
                                    'Sicuro di voler ' +
                                    (
                                        vm.appointmentsList[position].paid
                                            ? 'Segnare come NON PAGATO'
                                            : 'Segnare come Pagato'
                                    ) +
                                    ' questo appuntamento?'
                                )
                                .ok('Si')
                                .cancel('Ops, ho sbagliato')
                            ;
                            return $mdDialog
                                .show(confirm)
                                .then(
                                    function () {
                                        var newpaid = 1;
                                        if (vm.appointmentsList[position].paid) {
                                            newpaid = 0;
                                        };
                                        AppointmentsService.update({ id: vm.appointmentsList[position].id, paid: newpaid, updatingField: 'price' }).then(
                                            function (response) {
                                                vm.appointmentsList[position].paid = newpaid;
                                                vm.calcsOnVisibileElements();
                                                vm.appointmentsList[position].updated_by = vm.user.id;
                                                vm.appointmentsList[position].updatedBy = { data: vm.user };
                                                vm.appointmentsList[position].updated_at = moment();
                                                vm.appointmentsList[position].updated_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                                            },
                                            function (response) {
                                                vm.checkResponse(response, vm.appointmentsList[position]);
                                            }
                                        );
                                    }
                                )
                                .finally(
                                    function () {
                                        confirm = undefined;
                                    }
                                )
                                ;
                        };
                    };
                    /* Date Changed - Load Availabilities */
                    vm.selectedAvaibilityRequired = false;
                    vm.selectedAvaibility = null;
                    vm.availabilitiesList = [];
                    vm.treatment = {};
                    vm.availabilityLoad = function () {
                        vm.availabilitiesList = [];

                        var date_start = moment(vm.treatmentdate).format('YYYY-MM-DD');

                        /*
                        if( moment( moment().format( 'YYYY-MM-DD' ) ).isSame( date_start ) ) {
                            date_start += ' ' + moment().format( 'HH:mm' );
                        } else {
                            date_start += ' 00:00:00';
                        };
                        */
                        date_start += ' 00:00:00';

                        var options = {
                            date_start: date_start,
                            treatment_id: vm.activeAppointment.treatment_id,
                            user_id: vm.activeAppointment.user_id,
                            store_id: vm.storeId,
                            available: true,
                            all: true,
                        };
                        return AppointmentsService
                            .all(options)
                            .then(
                                function (response) {
                                    if (response.data && response.data.data) {
                                        if (response.data.data.length > 0) {
                                            angular.forEach(response.data.data, function (el) {
                                                el.customer_id = null;
                                                if (el.date_start == null && el.hours != null) {
                                                    el.store_id = options.store_id;
                                                    el.treatment_id = vm.activeAppointment.treatment_id;
                                                    el.price = vm.treatment.start_price;
                                                    el.price_full = vm.treatment.start_price;
                                                    el.price_treatment = vm.treatment.start_price;
                                                    el.date_start = el.date + ' ' + el.hours;
                                                    el.date_end = moment(el.date_start).add(vm.treatment.duration, 'minutes').format("YYYY-MM-DD HH:mm:ss");
                                                    delete el.date;
                                                    delete el.minute;
                                                    delete el.hours;
                                                }
                                                el.role = { data: vm.getUserRole(el.user_id, options.store_id) };
                                                vm.availabilitiesList.push(el);
                                            });
                                        } else {
                                            vm.showActionToast("Nessuna disponibilità in questo periodo.");
                                        };
                                    }
                                },
                                function (rejection) {
                                    angular.element("md-backdrop.md-select-backdrop").click();
                                    if (rejection.data.message === "The given data failed to pass validation.") {
                                        rejection.data.message = "Controllare la data inserita!";
                                    };
                                    var alert = $mdDialog.alert()
                                        .title('Attenzione')
                                        .ariaLabel('Attenzione')
                                        .textContent(rejection.data.message)
                                        .ok('Ok')
                                    ;
                                    return $mdDialog
                                        .show(alert)
                                        .finally(
                                            function () {
                                                alert = undefined;
                                                angular.element("#treatmentdate").removeClass('md-datepicker-remove-red-border');
                                            }
                                        )
                                        ;
                                }
                            )
                            ;
                    };

                    //return vm.showActionToast( "Impostare correttamente l'oeratrice e il trattamento." );
                    //};
                    $scope.$watch('ap.selectedAvaibility', function (newValue) {
                        if (newValue !== null) {
                            vm.undoVisible = true;
                            if (vm.isNewAppointment && vm.availabilitiesList.length) {
                                vm.activeAppointment.price = vm.availabilitiesList[0].price;
                                vm.activeAppointment.price_full = vm.availabilitiesList[0].price;
                                vm.activeAppointment.price_treatment = vm.availabilitiesList[0].price;
                            }
                        }
                    });

                    vm.subscriptionNewIdChange = function () {
                        if (vm.activeAppointment) {
                            var newValue = vm.activeAppointment.subscription_new_id;
                            if ((newValue !== null)
                                && (newValue !== undefined)) {
                                vm.activeAppointment.customer_subscription_id = null;
                                vm.genericPaymentChangeAny(false);
                            }
                        }
                    };

                    vm.appointmentTypeChange = function () {
                        vm.genericPaymentChangeAny(false);
                    };

                    vm.appointmentTypeAppChange = function () {
                        var newValue = vm.activeAppointment.type;
                        if (!newValue || newValue != 'abb') {
                            vm.activeAppointment.customer_subscription_id = null;
                            vm.activeAppointment.subscription_new_id = null;
                        }
                        vm.genericPaymentChangeAny(false);
                    };

                    vm.initPriceFullPriceDiscounted = function (elem) {
                        /**
                         * elem.price_treatment se non inizializzato caso pregresso
                         */
                        var priceProd = 0;
                        if (vm.isAcquistoDip(elem)) {
                            priceProd = elem.product_price / 2 + elem.product_price10 / 2;
                        } else {
                            priceProd = elem.product_price + elem.product_price10;
                        }
                        if (!elem.price_discounted) {
                            elem.price_discounted = elem.price + elem.price_due - elem.ratePayment;
                        }
                        if (vm.isStorno(elem)) {
                            elem.price_discounted = 0 - elem.price_discounted;
                        }
                        if (elem.price_treatment === null) {
                            elem.price_treatment = elem.price_discounted - priceProd;
                        }
                        elem.price_full = elem.price_treatment + priceProd;
                        if (vm.isStorno(elem)) {
                            elem.price_full = 0 - elem.price_full;
                        }
                    };

                    vm.paymentDiscountPriceRateUpdate = function (isInit) {
                        vm.initPriceFullPriceDiscounted(vm.activeAppointment);
                        if (!isInit) {
                            /**
                             * va controllato che il prezzo non possa essere 0 se non in abbonamento e non ritiro prodotti
                             */
                            //$log.info(vm.activeAppointment);
                            $scope.appointmentForm.price_treatment.$setValidity('notzero', true);
                            if ('abb' != vm.activeAppointment.type
                                && !vm.activeAppointment.type_app == 'free'
                                && !vm.activeAppointment.treatment_name.endsWith('GP')
                                && !vm.activeAppointment.treatment_name.startsWith('Ritiro')
                                && !vm.activeAppointment.treatment_name.startsWith('Colloquio')
                                && !vm.activeAppointment.treatment_name.startsWith('Accademy')
                                && !vm.activeAppointment.treatment_name.endsWith('omaggio')
                                && !vm.activeAppointment.treatment_name.endsWith('conoscitivo')
                                && !vm.isAcquistoDip(vm.activeAppointment)
                            ) {
                                if (vm.activeAppointment.price_treatment == 0) {
                                    $scope.appointmentForm.price_treatment.$setValidity('notzero', false);
                                }
                            }
                            /*$scope.appointmentForm.price_treatment.$setValidity('infcompresi', true);
                            if ((vm.activeAppointment.product_price_in + vm.activeAppointment.product_price10_in)>vm.activeAppointment.price_treatment) {
                                if (vm.activeAppointment.type!='abb' && vm.activeAppointment) {//TODO <1
                                    $log.info("checkInfoCompresi");
                                    $log.info(vm.activeAppointment);
                                    $scope.appointmentForm.price_treatment.$setValidity('infcompresi', false);
                                }
                            }*/

                            /*if (vm.activeAppointment.totalcredit>0
                                && vm.activeAppointment.credit_usage!=null
                                && vm.activeAppointment.credit_usage.sconto<vm.activeAppointment.price_full) {
                                  vm.activeAppointment.credit = vm.activeAppointment.credit_usage.credit;
                                  vm.activeAppointment.price = vm.activeAppointment.price_full-vm.activeAppointment.credit_usage.sconto;
                                  vm.activeAppointment.discount = vm.activeAppointment.credit_usage.sconto;
                            } else {
                              vm.activeAppointment.credit = 0;
                              vm.activeAppointment.discount = 0;
                              vm.activeAppointment.credit_usage = undefined;
                              vm.activeAppointment.price = vm.activeAppointment.price_full;
                            }*/
                            /*if (vm.activeAppointment.customer!=null) {
                              vm.activeAppointment.customer.data.credit = vm.activeAppointment.totalcredit - vm.activeAppointment.credit;
                            }*/
                            vm.activeAppointment.price_discounted = vm.activeAppointment.price_full;
                            vm.activeAppointment.price = vm.activeAppointment.ratePayment + vm.activeAppointment.price_discounted;
                            $scope.appointmentForm.price.$setValidity('lowerpayment', true);
                            vm.activeAppointment.price_due = 0;
                            vm.activeAppointment.num_rate = 0;
                            vm.activeAppointment.rateizzazione_type = null;
                        }
                    };

                    /**
                     * Aggiorna abbonamento, tipo app treatment price e tutto a cascata in base a f_exclude
                     */
                    vm.genericPaymentChangeAny = function (isInit) {
                        if (!isInit) {
                            vm.activeAppointment.price_treatment = 0;
                            if (vm.activeAppointment.type == 'abb') {
                                if (vm.activeAppointment.customer_subscription_id) {
                                    angular.forEach(vm.subscriptionsListByCustomer,
                                        function (cs) {
                                            if ((cs.id == vm.activeAppointment.customer_subscription_id)) {
                                                vm.customerSubscription = cs;
                                                vm.maxRate = 6;
                                                if (vm.activeAppointment.id == cs.appointment_id) {
                                                    vm.maxRate = cs.subscription.data.max_rate;
                                                    vm.minAcconto = cs.subscription.data.min_deposit;
                                                    if (!vm.maxRate) {
                                                        vm.activeAppointment.f_abb_payall = 1;
                                                    }
                                                    if (vm.activeAppointment.f_abb_payall) {
                                                        vm.activeAppointment.price_treatment = parseFloat(cs.subscription.data.price_promo);
                                                    } else {
                                                        vm.activeAppointment.price_treatment = parseFloat(cs.subscription.data.price);
                                                    }
                                                }

                                                if (cs.subscription_id == 1000 &&
                                                      ((cs.appointment_id == null) || (cs.appointment_id == vm.activeAppointment.id))) {
                                                    vm.activeAppointment.price_treatment = parseFloat(cs.quotation.data.price) - parseFloat(cs.quotation.data.total_discount);
                                                }
                                            }
                                        }
                                    );
                                } else if (vm.activeAppointment.subscription_new_id) {
                                    angular.forEach(vm.subscriptionsList, function (subscription) {
                                        if ((subscription.id == vm.activeAppointment.subscription_new_id)) {
                                            vm.newSubscription = subscription;
                                            vm.maxRate = vm.newSubscription.max_rate;
                                            vm.minAcconto = vm.newSubscription.min_deposit;
                                            if (!vm.maxRate) {
                                                vm.activeAppointment.f_abb_payall = 1;
                                            }
                                            if (vm.activeAppointment.f_abb_payall) {
                                                vm.activeAppointment.price_treatment = parseFloat(subscription.price_promo);
                                            } else {
                                                vm.activeAppointment.price_treatment = parseFloat(subscription.price);
                                            }
                                        }
                                    });
                                }
                                if (vm.activeAppointment.f_exclude) {
                                    vm.activeAppointment.price_treatment += vm.getTreatmentPrice();
                                }
                            } else {
                                vm.newSubscription = null;
                                vm.customerSubscription = null;
                                vm.activeAppointment.customer_subscription_id = null;
                                vm.activeAppointment.subscription_new_id = null;
                                vm.activeAppointment.f_exclude = 0;
                                vm.activeAppointment.price_treatment += vm.getTreatmentPrice();
                            }
                        }
                        vm.paymentDiscountPriceRateUpdate(isInit);
                        vm.paymentPosUpdate();
                    };

                    vm.customerSubscriptionIdChange = function () {
                        if (vm.activeAppointment) {
                            var newValue = vm.activeAppointment.customer_subscription_id;
                            if ((newValue !== null)
                                && (newValue !== undefined)) {
                                vm.activeAppointment.subscription_new_id = null;
                                vm.genericPaymentChangeAny(false);
                            }
                        }
                    };

                    vm.getTreatmentPrice = function () {
                        if (vm.activeAppointment && vm.treatment) {
                            if (!vm.activeAppointment.type_app) {
                                return vm.treatment.start_price;
                            }
                            if (vm.activeAppointment.type_app == 'promo') {
                                return vm.treatment.promo_price ? vm.treatment.promo_price : vm.treatment.start_price * 0.75;
                            }
                            if (vm.activeAppointment.type_app == 'free') {
                                return 0;
                            }
                        }
                        return 0;
                    }

                    vm.fExcludeChange = function () {
                        if (vm.activeAppointment && vm.activeAppointment.type == 'abb') {
                            if (vm.activeAppointment.customer_subscription_id) {
                                vm.customerSubscriptionIdChange(vm.activeAppointment.customer_subscription_id, vm.activeAppointment.customer_subscription_id);
                            } else if (vm.activeAppointment.subscription_new_id) {
                                vm.subscriptionNewIdChange(vm.activeAppointment.subscription_new_id, vm.activeAppointment.subscription_new_id);
                            }
                        }
                    };

                    vm.initTreatmentCanChange = function (app) {
                        app.treatmentCanChange = false;
                        if (app.treatment_id) {
                            //$log.info("App "+app.id+" recalled is "+app.recalled);
                            app.treatmentCanChange = !app.closed
                                && app.recalled < 3
                                && (vm.user.type == 'admin'
                                    || vm.user.type == 'storemngr'
                                    || vm.user.type == 'assist'
                                );
                        }
                    };
                    vm.initRatePayment = function (app) {
                        app.ratePayment = 0;
                        app.ratePaymentIds = [];
                        if (app.customer && app.customer.data && app.customer.data.payments) {
                            angular.forEach(app.customer.data.payments.data, function (payment) {
                                if (payment.selected) {
                                    app.ratePayment += payment.total;
                                    payment.selected = true;
                                    app.ratePaymentIds.push(payment.id);
                                }
                            });
                        }
                        if (app.payments && app.payments.data) {
                            angular.forEach(app.payments.data, function (payment) {
                                if (payment.selected === undefined) {
                                    payment.selected = true;
                                }
                                if (payment.selected) {
                                    app.ratePayment += payment.total;
                                    app.ratePaymentIds.push(payment.id);
                                }
                            });
                        }
                    };

                    vm.rataSelectionChange = function (p) {
                        vm.activeAppointment.price = vm.activeAppointment.price_discounted;
                        vm.initRatePayment(vm.activeAppointment);
                        vm.activeAppointment.price += vm.activeAppointment.ratePayment;
                        vm.activeAppointment.price_due = 0;
                        vm.activeAppointment.num_rate = 0;
                        vm.paymentPosUpdate();
                    };

                    /* Users */
                    vm.userRolesList = [];
                    vm.userRolesListAll = []
                    vm.userRolesListCall = [];
                    vm.userRolesLoad = function () {
                        if (vm.userRolesListAll.length == 0) {
                            var pars = { with: 'user' };
                            return UsersService.allRoles(pars).then(function (response) {
                                if (response.data && response.data.data) {
                                    vm.userRolesListAll = response.data.data;
                                    //$log.info(vm.userRolesListAll);
                                    vm.userRolesList = vm.filterRolesXStore();
                                    //$log.info(vm.userRolesList);
                                    vm.userRolesListCall = vm.filterRolesXRole('callcenter');
                                    //$log.info(vm.userRolesListCall);
                                }
                            });
                        } else {
                            vm.userRolesList = vm.filterRolesXStore();
                            vm.userRolesListCall = vm.filterRolesXRole('callcenter');
                        }
                    };
                    vm.filterRolesXStore = function () {
                        var fs = { active: true };
                        if (vm.storeId) {
                            fs.store_id = vm.storeId;
                        } else {
                            //fs.store_id = '>0';
                        }
                        return $filter('filter')(vm.userRolesListAll, fs, true);
                    };
                    vm.filterRolesXRole = function (role) {
                        var fs = { active: true, role: role };
                        return $filter('filter')(vm.userRolesListAll, fs, true);
                    };

                    vm.getUserRole = function (user_id, store_id, role_id) {
                        var res = null;
                        angular.forEach(vm.userRolesList, function (r) {
                            if (r.user_id == user_id && r.store_id == store_id && (!role_id || r.id == role_id)) {
                                res = r;
                            }
                        });
                        if (res != null) {
                            return res;
                        }
                        $log.error("non trovato ruolo per utente " + user_id + "/" + store_id);
                        return { id: user_id, color: '#888888' };
                    };
                    //---------- Sidebar -------------------------------------//
                    vm.testsVisible = false;
                    vm.currentSubscription = '';
                    vm.isDeleteAllowed = true;
                    vm.undoVisible = false;
                    vm.img_loading = false;
                    vm.activeAppointment = null;
                    vm.backup_appointment = {};
                    vm.update_appointment = {};
                    vm.empty_appointment = {};
                    /* Element Clicked */
                    vm.updatingField = '';
                    vm.rowClicked = function (appointment, field) {
                        vm.updatingField = (field == null ? '' : field);
                        vm.toggleRight(appointment, true);
                        //$log.info(appointment);
                    };
                    vm.toggleRight = function (appointment, isRowClick) {


                        vm.appointmentProducts = [];

                        /**
                         * Check if payment_pos
                         */
                        if (appointment && appointment.payment_type == 'P' && appointment.payment_pos_type == 'C') {
                            appointment.payment_pos = appointment.price;
                            appointment.payment_card = 0;
                            //appointment.payment_card =
                        }
                        if (appointment && appointment.payment_type == 'P' && appointment.payment_pos_type == 'A') {
                            appointment.payment_pos = appointment.price;
                            appointment.payment_app = 0;
                            //appointment.payment_card =
                        }

                        vm.original_payment_app = appointment && appointment.payment_app ? appointment.payment_app : 0;
                        vm.appCustomerParams = {};
                        vm.currentParamsT = [];
                        vm.subscriptionsListFiltered = vm.subscriptionsList;
                        vm.maxRate = 6;
                        //vm.rolesOperators = $filter('filter')(vm.userRolesList, {store_id: appointment?appointment.store_id:vm.storeId, active: true, role: 'operator'}, true);
                        //$log.info(vm.rolesOperators);
                        var customer_subscription_id = '';
                        vm.isNewAppointment = !isRowClick;//angular.isUndefined( appointment );
                        if (!isRowClick) {
                            vm.updatingField = '';
                        }
                        if (!vm.isNewAppointment) {
                            vm.customer_id = appointment.customer_id;
                            if (appointment.treatment_id == 99) {
                                vm.card.init(appointment);
                            }
                            appCurrentTreatment = appointment.treatment.data;

                            vm.checkSubscriptionByUserAndSetSubscriptionName(
                                appointment.customer_id,
                                appointment,
                                function () {
                                    vm.treatmentdate = new Date(appointment.date_start);
                                    vm.treatment = $filter("treatment")(appointment.treatment_id, vm.treatmentsList);
                                    vm.storno = vm.isStorno(appointment);
                                    //filtro abbonamenti in base a zone
                                    vm.subscriptionsListFiltered = [];
                                    vm.appCustomerParams = {};
                                    angular.forEach(vm.subscriptionsList, function (s) {
                                        if (vm.treatment.zone === 0) {
                                            if (s.zone === 0) {
                                                vm.subscriptionsListFiltered.push(s);
                                            }
                                        } else {
                                            if (s.zone > 0) {
                                                vm.subscriptionsListFiltered.push(s);
                                            }
                                        }
                                    });
                                    vm.activeAppointment = appointment;
                                    //$log.info(vm.activeAppointment);
                                    angular.copy(vm.activeAppointment, vm.backup_appointment);

                                    if (vm.activeAppointment.customer.data.app_customer_id) {
                                        vm.loadCustomerAppInfo(vm.activeAppointment.customer.data.app_customer_id);
                                    }

                                    return $mdSidenav('bm-appointment-sidenav').open();
                                }

                            );
                            //console.log(["Ristampo l'appuntamento", appointment, ]);
                        }
                        else {

                            vm.treatmentdate = new Date();
                            vm.customer_id = null;
                            /**
                             * Svuoto la ricerca customers e la lista se non ho passato il cliente
                             */
                            if(!this.customer){
                                vm.customersReset();
                            }

                            appointment = {
                                payment_type: 'C',
                                f_over: vm.portaEnabled ? true : false,
                                start: moment(),
                                price_treatment: 0,
                                product_price: 0,
                                product_price10: 0,
                                discount: 0,
                                type: null,
                                ratePayment: 0,
                                paid: 1
                            };
                            vm.activeAppointment = appointment;
                            //$log.info(vm.activeAppointment);
                            angular.copy(vm.activeAppointment, vm.backup_appointment);
                            return $mdSidenav('bm-appointment-sidenav').open();
                        }

                        vm.loadAppointmentProducts(appointment, appointment.treatment_id);

                    };
                    /**
                     * Verifica sconto in base ad autonomia
                     */
                    vm.priceDiscountedCheck = function () {
                        if (vm.storno) {
                            vm.activeAppointment.price_treatment = vm.activeAppointment.price_discounted;
                            vm.activeAppointment.price_full = 0 - vm.activeAppointment.price_discounted;
                            vm.activeAppointment.price = vm.activeAppointment.price_full;
                            vm.paymentPosUpdate();
                        } else {
                            //$log.info("---------------- priceDiscountedCheck ----------");
                            var pMin = vm.activeAppointment.price_full / 100 * (100 - vm.maxDiscount);
                            var tri = vm.tri(vm.activeAppointment);
                            if ((pMin - tri) > vm.activeAppointment.price_discounted) {
                                $scope.appointmentForm.price_discounted.$setValidity('overdiscount', false);
                            } else {
                                $scope.appointmentForm.price_discounted.$setValidity('overdiscount', true);
                                //vm.paymentDiscountPriceRateUpdate(false);
                                var p = vm.activeAppointment.ratePayment + vm.activeAppointment.price_discounted;
                                vm.activeAppointment.price = parseFloat(p.toFixed(2));
                                $scope.appointmentForm.price.$setValidity('lowerpayment', true);
                                vm.activeAppointment.price_due = 0;
                                vm.activeAppointment.num_rate = 0;
                                vm.activeAppointment.rateizzazione_type = null;
                                vm.paymentPosUpdate();
                            }
                        }
                    };
                    vm.tri = function (app) {
                        app.tri = 0;
                        if (app.includedProducts
                            && app.includedProducts.data
                            && app.includedProducts.data.length > 0) {
                            angular.forEach(app.includedProducts.data, function (s) {
                                if (!s.product_id) {
                                    app.tri += (s.price * s.qty);
                                }
                            });
                        }
                        return app.tri;
                    };
                    /**
                     * Verifica prezzo (acconto) in base a regole predefinite
                     * E aggiorna importo rateizzato
                     */
                    vm.priceCheck = function () {
                        $scope.appointmentForm.price.$setValidity('lowerpayment', true);
                        var tri = vm.tri(vm.activeAppointment);
                        var minPayment = (vm.activeAppointment.price_discounted + tri) < vm.sogliaAcconto
                            ? (vm.minAccontoPerc / 100) * (vm.activeAppointment.price_discounted + tri)
                            : vm.minAcconto;
                        minPayment = minPayment - tri;
                        minPayment += vm.activeAppointment.ratePayment;
                        if (minPayment < 0) {
                            minPayment = 0;
                        }
                        var minPaymentStr = $filter('number')(minPayment, 2);
                        var ratePaymentStr = $filter('number')(vm.activeAppointment.ratePayment, 2);
                        if (vm.activeAppointment.price > vm.activeAppointment.ratePayment + vm.activeAppointment.price_discounted) {
                            vm.activeAppointment.price = vm.activeAppointment.ratePayment + vm.activeAppointment.price_discounted;
                            vm.activeAppointment.rateizzazione_type = undefined;
                            vm.activeAppointment.price_due = 0;
                            vm.activeAppointment.num_rate = 0;
                        } else if (vm.activeAppointment.price == vm.activeAppointment.ratePayment + vm.activeAppointment.price_discounted) {
                            vm.activeAppointment.rateizzazione_type = undefined;
                            vm.activeAppointment.price_due = 0;
                            vm.activeAppointment.num_rate = 0;
                        } else if (vm.activeAppointment.price < minPayment) {
                            vm.messageLowerPayment = " "
                                + minPaymentStr + "&euro;"
                                + (vm.activeAppointment.price_discounted < vm.sogliaAcconto ? ', cio&egrave; al ' + vm.minAccontoPerc + '% del prezzo' :
                                    (vm.activeAppointment.ratePayment > 0 ? ', cio&egrave; a ' + vm.minAcconto + '&euro;' : '.'))
                                + (vm.activeAppointment.ratePayment > 0 ? ', pi&ugrave; l\'importo delle rate di ' + ratePaymentStr + "&euro;." : '');
                            $scope.appointmentForm.price.$setValidity('lowerpayment', false);
                            //$log.info("message = "+vm.messageLowerPayment);
                            return;
                        } else {
                            if (!vm.activeAppointment.rateizzazione_type) {
                                vm.activeAppointment.rateizzazione_type = 'M';
                            }
                            var pd = vm.activeAppointment.ratePayment + vm.activeAppointment.price_discounted - vm.activeAppointment.price;
                            vm.activeAppointment.price_due = parseFloat(pd.toFixed(2));
                            if (!vm.activeAppointment.num_rate) {
                                vm.activeAppointment.num_rate = 1;
                            }
                        }
                        vm.paymentPosUpdate();
                    };

                    vm.paymentPosUpdate = function () {
                        /**
                         * verifica f_abb_payall
                         */
                        if (vm.activeAppointment.f_abb_payall) {
                            vm.activeAppointment.payment_dil = 0;
                            vm.activeAppointment.installments_dil = null;
                            vm.activeAppointment.payment_small = 0;
                            if (vm.activeAppointment.payment_type == 'D'
                                || vm.activeAppointment.payment_type == 'S') {
                                vm.activeAppointment.payment_type = 'C';
                            }
                        }
                        if (vm.activeAppointment.f_ref) {
                            vm.activeAppointment.payment_type = 'C';
                        }
                        if (vm.activeAppointment.payment_type == 'C') {
                            vm.activeAppointment.payment_pos = 0;
                            vm.activeAppointment.payment_card = 0;
                            vm.activeAppointment.payment_app = 0;
                            vm.activeAppointment.payment_pos_type = null;
                            vm.activeAppointment.payment_dil = 0;
                            vm.activeAppointment.installments_dil = null;
                            vm.activeAppointment.payment_cc = 0;
                            vm.activeAppointment.installments_cc = null;
                            vm.activeAppointment.payment_small = 0;
                            vm.activeAppointment.payment_gift = 0;
                            vm.activeAppointment.gift_number = null;
                            vm.activeAppointment.payment_satis = 0;
                            vm.activeAppointment.payment_bon = 0;
                            vm.activeAppointment.payment_check = 0;
                            vm.activeAppointment.payment_app = 0;
                        } else if (vm.activeAppointment.payment_type == 'P') {
                            vm.activeAppointment.payment_pos = vm.activeAppointment.price;
                            vm.activeAppointment.payment_card = 0;
                            vm.activeAppointment.payment_app = 0;
                            vm.activeAppointment.payment_dil = 0;
                            vm.activeAppointment.installments_dil = null;
                            vm.activeAppointment.payment_cc = 0;
                            vm.activeAppointment.installments_cc = null;
                            vm.activeAppointment.payment_small = 0;
                            vm.activeAppointment.payment_satis = 0;
                            vm.activeAppointment.payment_gift = 0;
                            vm.activeAppointment.gift_number = null;
                            vm.activeAppointment.payment_bon = 0;
                            vm.activeAppointment.payment_check = 0;
                            vm.activeAppointment.payment_app = 0;
                        } else if (vm.activeAppointment.payment_type == 'D') {
                            vm.activeAppointment.payment_dil = vm.activeAppointment.price;
                            vm.activeAppointment.payment_cc = 0;
                            vm.activeAppointment.installments_cc = null;
                            vm.activeAppointment.payment_small = 0;
                            vm.activeAppointment.payment_satis = 0;
                            vm.activeAppointment.payment_gift = 0;
                            vm.activeAppointment.gift_number = null;
                            vm.activeAppointment.payment_pos = 0;
                            vm.activeAppointment.payment_card = 0;
                            vm.activeAppointment.payment_app = 0;
                            vm.activeAppointment.payment_pos_type = null;
                            vm.activeAppointment.payment_bon = 0;
                            vm.activeAppointment.payment_check = 0;
                            vm.activeAppointment.payment_app = 0;
                        } else if (vm.activeAppointment.payment_type == 'B') {
                            vm.activeAppointment.payment_bon = vm.activeAppointment.price;
                            vm.activeAppointment.payment_pos = 0;
                            vm.activeAppointment.payment_card = 0;
                            vm.activeAppointment.payment_app = 0;
                            vm.activeAppointment.payment_pos_type = null;
                            vm.activeAppointment.payment_dil = 0;
                            vm.activeAppointment.installments_dil = null;
                            vm.activeAppointment.payment_cc = 0;
                            vm.activeAppointment.installments_cc = null;
                            vm.activeAppointment.payment_small = 0;
                            vm.activeAppointment.payment_satis = 0;
                            vm.activeAppointment.payment_gift = 0;
                            vm.activeAppointment.gift_number = null;
                            vm.activeAppointment.payment_check = 0;
                            vm.activeAppointment.payment_app = 0;
                        } else if (vm.activeAppointment.payment_type == 'S') {
                            vm.activeAppointment.payment_small = vm.activeAppointment.price;
                            vm.activeAppointment.payment_gift = 0;
                            vm.activeAppointment.gift_number = null;
                            vm.activeAppointment.payment_satis = 0;
                            vm.activeAppointment.payment_dil = 0;
                            vm.activeAppointment.installments_dil = null;
                            vm.activeAppointment.payment_cc = 0;
                            vm.activeAppointment.installments_cc = null;
                            vm.activeAppointment.payment_pos = 0;
                            vm.activeAppointment.payment_card = 0;
                            vm.activeAppointment.payment_app = 0;
                            vm.activeAppointment.payment_pos_type = null;
                            vm.activeAppointment.payment_bon = 0;
                            vm.activeAppointment.payment_check = 0;
                            vm.activeAppointment.payment_app = 0;
                        } else if (vm.activeAppointment.payment_type == 'G') {
                            vm.activeAppointment.payment_gift = vm.activeAppointment.price;
                            vm.activeAppointment.payment_small = 0;
                            vm.activeAppointment.payment_satis = 0;
                            vm.activeAppointment.payment_dil = 0;
                            vm.activeAppointment.installments_dil = null;
                            vm.activeAppointment.payment_cc = 0;
                            vm.activeAppointment.installments_cc = null;
                            vm.activeAppointment.payment_pos = 0;
                            vm.activeAppointment.payment_card = 0;
                            vm.activeAppointment.payment_app = 0;
                            vm.activeAppointment.payment_pos_type = null;
                            vm.activeAppointment.payment_bon = 0;
                            vm.activeAppointment.payment_check = 0;
                            vm.activeAppointment.payment_app = 0;
                        } else if (vm.activeAppointment.payment_type == 'A') {
                            vm.activeAppointment.payment_check = vm.activeAppointment.price;
                            vm.activeAppointment.payment_gift = 0;
                            vm.activeAppointment.gift_number = null;
                            vm.activeAppointment.payment_small = 0;
                            vm.activeAppointment.payment_satis = 0;
                            vm.activeAppointment.payment_dil = 0;
                            vm.activeAppointment.installments_dil = null;
                            vm.activeAppointment.payment_cc = 0;
                            vm.activeAppointment.installments_cc = null;
                            vm.activeAppointment.payment_pos = 0;
                            vm.activeAppointment.payment_card = 0;
                            vm.activeAppointment.payment_app = 0;
                            vm.activeAppointment.payment_pos_type = null;
                            vm.activeAppointment.payment_bon = 0;
                            vm.activeAppointment.payment_app = 0;
                        } else if (vm.activeAppointment.payment_type == 'T') {
                            vm.activeAppointment.payment_satis = vm.activeAppointment.price;
                            vm.activeAppointment.payment_gift = 0;
                            vm.activeAppointment.gift_number = null;
                            vm.activeAppointment.payment_small = 0;
                            vm.activeAppointment.payment_dil = 0;
                            vm.activeAppointment.installments_dil = null;
                            vm.activeAppointment.payment_cc = 0;
                            vm.activeAppointment.installments_cc = null;
                            vm.activeAppointment.payment_pos = 0;
                            vm.activeAppointment.payment_card = 0;
                            vm.activeAppointment.payment_app = 0;
                            vm.activeAppointment.payment_pos_type = null;
                            vm.activeAppointment.payment_bon = 0;
                            vm.activeAppointment.payment_check = 0;
                            vm.activeAppointment.payment_app = 0;
                        } else if (vm.activeAppointment.payment_type == 'M') {
                            vm.activeAppointment.payment_pos_type = null;
                        } else if (vm.activeAppointment.payment_type == 'F') {
                            vm.activeAppointment.payment_dil = 0;
                            vm.activeAppointment.installments_dil = null;
                            vm.activeAppointment.payment_cc = vm.activeAppointment.price;
                            vm.activeAppointment.payment_small = 0;
                            vm.activeAppointment.payment_satis = 0;
                            vm.activeAppointment.payment_gift = 0;
                            vm.activeAppointment.gift_number = null;
                            vm.activeAppointment.payment_pos = 0;
                            vm.activeAppointment.payment_card = 0;
                            vm.activeAppointment.payment_app = 0;
                            vm.activeAppointment.payment_pos_type = null;
                            vm.activeAppointment.payment_bon = 0;
                            vm.activeAppointment.payment_check = 0;
                            vm.activeAppointment.payment_app = 0;
                        }
                    };
                    vm.isStorno = function (elem) {
                        return elem && elem.treatment_id &&
                            (elem.treatment_id == 85 ||
                                elem.treatment_id == 86 ||
                                elem.treatment_id == 87 ||
                                elem.treatment_id == 156 ||
                                elem.treatment_id == 157 ||
                                elem.treatment_id == 158 ||
                                elem.treatment_id == 159
                            );
                    };

                    vm.closeSidebar = function () {
                        if (vm.undoVisible) {
                            var confirm = $mdDialog.confirm()
                                .title('Attenzione')
                                .textContent('Ci sono delle modifiche non commissionate, proseguire?')
                                .ariaLabel('Attenzione')
                                .ok('Si')
                                .cancel('Ops, ho sbagliato')
                            ;
                            return $mdDialog
                                .show(confirm)
                                .then(vm.undo)
                                .finally(
                                    function () {
                                        confirm = undefined;
                                        vm.hidePreview();
                                    }
                                )
                                ;
                        } else {
                            vm.resetAll();
                        };
                    };

                    vm.mergeParams = function (app) {
                        var newPars = $filter('filter')(vm.treatmentParams, { treatment_id: app.treatment_id }, true);
                        //DO MERGE
                        var oldPars = [];
                        if (app.params && app.params.data) {
                            oldPars = app.params.data;
                        } else {
                            app.params = { data: oldPars };
                        }
                        angular.forEach(newPars, function (el) {
                            var found = false;
                            angular.forEach(oldPars, function (op) {
                                if (op.param_id == el.param_id) {
                                    found = true;
                                    op.param = el;
                                }
                            });
                            if (!found) {
                                oldPars.push({ param_id: el.param_id, value: el.default, param: el });
                            }
                        });
                    }
                    vm.activeStartChange = function (trt) {
                        if (vm.activeAppointment.start != null && vm.activeAppointment.treatment_id != null) {
                            var t = trt != null ? trt : $filter('treatment')(vm.activeAppointment.treatment_id, vm.treatmentsList);
                            vm.activeAppointment.end = moment(vm.activeAppointment.start).add(t.min_duration, 'minutes');
                        }
                    };
                    vm.storno = false;
                    vm.activeTreatmentChange = function () {
                        vm.resetAvailabilities();
                        var t = $filter('treatment')(vm.activeAppointment.treatment_id, vm.treatmentsList);
                        vm.mergeParams(vm.activeAppointment);
                        vm.treatment = t;
                        if (vm.treatment.id == 99) {
                            vm.treatment.start_price = 0;
                        }
                        vm.activeAppointment.treatment_name = t.name;
                        vm.storno = vm.isStorno(vm.activeAppointment);
                        vm.appointmentTypeChange();
                        vm.activeStartChange(t);

                        if(vm.treatment.id != appCurrentTreatment.id) {
                            vm.hideAppointmentProducts = true;
                        } else {
                            vm.hideAppointmentProducts = false;
                        }
                        //vm.switchTheTreatment(t);
                        vm.appointmentTreatmentProducts();
                    };
                    vm.resetAvailabilities = function () {
                        vm.selectedAvaibility = null;
                        vm.availabilitiesList = [];
                        if (angular.isDefined($scope.appointmentForm.availability)) {
                            $scope.appointmentForm.availability.$setPristine();
                            $scope.appointmentForm.availability.$setUntouched();
                        };
                    };
                    vm.angularFormReset = function () {
                        $scope.appointmentForm.$setPristine();
                        $scope.appointmentForm.$setUntouched();
                    };
                    vm.resetForm = function () {
                        vm.undoVisible = false;
                        return $mdSidenav('bm-appointment-sidenav').close().then(function () {
                            vm.activeAppointment = null;
                            vm.update_appointment = {};
                            vm.treatmentdate = null;
                            vm.selectedAvaibilityRequired = false;
                            vm.resetAvailabilities();
                            vm.angularFormReset();
                            vm.card.filter_number = null;
                            vm.card.filter_number_pay = null;
                            vm.card.list = [];
                            vm.card.value = null;
                        });
                    };
                    vm.resetAll = function () {
                        return $timeout(vm.resetForm, 10);
                    };
                    vm.undo = function () {
                        $log.info('Undo');
                        if (!angular.equals(vm.activeAppointment, vm.backup_appointment)) {
                            angular.copy(vm.backup_appointment, vm.activeAppointment);
                        };
                        vm.resetAll();
                    };
                    /* Response */
                    vm.showActionToast = function (text) {
                        text = text && angular.isDefined(text) ? text : 'Tutto Ok!';
                        var toast = $mdToast.simple()
                            .textContent(text)
                            .action('')
                            .highlightAction(true)
                            .position('bottom right')
                        ;
                        return $mdToast
                            .show(toast)
                            .finally(
                                function () {
                                    toast = undefined;
                                }
                            )
                            ;
                    };
                    vm.responseStatusSuccessful = [200, 201, 202];
                    vm.checkResponse = function (response, appointment) {
                        if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
                            var errMsg = "";
                            if (response.data != null && response.data.message != null) {
                                errMsg = response.data != null && response.data.message != null ? response.data.message : "";
                                var url = response.config != null && response.config.url != null ? response.config.url : "";
                                vm.showActionToast("KO: " + errMsg + " " + url);
                            }
                            var alert = $mdDialog.alert()
                                .title('Attenzione')
                                .ariaLabel('Attenzione')
                                .textContent("C'è stato un problema: " + errMsg)
                                .ok('Ok')
                            ;
                            return $mdDialog
                                .show(alert)
                                .then(function () {
                                    vm.resetAll();
                                    /**
                                     * Ripristino il valore precedente contenuto in appointment.user.data
                                     */
                                    vm.operatorChange.reset(appointment);
                                })
                                .finally(
                                    function () {
                                        alert = undefined;
                                    }
                                )
                                ;
                        } else {
                            /**
                             * Aggiorno user.data con il nuovo valore
                             */
                            vm.operatorChange.complete(appointment);
                            vm.showActionToast();
                            return vm.resetAll();
                        };
                    };

                    // Salva e Aggiorna
                    vm.save = function (appointment) {
                        $log.info('Salva');

                        var canSave = vm.canSave(appointment);

                        if (canSave && angular.isDefined(appointment)) {
                            var confirm = $mdDialog.confirm()
                                .title('Attenzione')
                                .ariaLabel('Attenzione')
                                .textContent('Sicuro di voler inserire questo appuntamento?')
                                .ok('Si')
                                .cancel('Ops, ho sbagliato')
                            ;
                            return $mdDialog
                                .show(confirm)
                                .then(
                                    function () {
                                        console.log("Mi preparo a salvare l'appuntamento");
                                        angular.copy(appointment, vm.update_appointment);
                                        vm.update_appointment.customer_id = vm.customer_id;
                                        vm.update_appointment.by_operator = vm.userId;
                                        vm.update_appointment.confirmed = 1;
                                        //vm.update_appointment.paid = 0;
                                        vm.update_appointment.new_customer = 0;
                                        vm.update_appointment.store_id = vm.storeId;
                                        vm.update_appointment.shoppingPlusEnabled = vm.env.shoppingPlusEnabled;

                                        if (vm.selectedAvaibility !== null) {
                                            vm.update_appointment.date_start = vm.availabilitiesList[vm.selectedAvaibility].date_start;
                                            vm.update_appointment.date_end = vm.availabilitiesList[vm.selectedAvaibility].date_end;
                                        } else if (vm.activeAppointment.f_over) {
                                            var dataApp = moment(vm.treatmentdate).format('YYYY-MM-DD');
                                            vm.update_appointment.date_start = dataApp + ' ' + moment(appointment.start).format('HH:mm:ss');
                                            vm.update_appointment.date_end = dataApp + ' ' + moment(appointment.end).format('HH:mm:ss');
                                        }
                                        delete vm.update_appointment.start;
                                        delete vm.update_appointment.end;

                                        AppointmentsService
                                            .save(vm.update_appointment)
                                            .then(
                                                function (response) {

                                                    vm.checkResponse(response);
                                                    if (response && response.data && response.data.data) {
                                                        var elem = response.data.data
                                                            , position = vm.customersList.map(function (x) { return x.id; }).indexOf(vm.customer_id);
                                                        ;

                                                        vm.dateFormat(elem, true);

                                                        elem.subscription_new_id = null;
                                                        elem.treatment_name = $filter('treatmentIdtoName')(elem.treatment_id, vm.treatmentsList);

                                                        elem.treatment = { data: { name: elem.treatment_name } };
                                                        elem.by_operator = vm.user.id;
                                                        elem.byOperator = { data: vm.user };
                                                        elem.created_by = vm.user.id;
                                                        elem.createdBy = { data: vm.user };
                                                        elem.anomalie = { data: [] };
                                                        vm.initTreatmentCanChange(elem);
                                                        vm.initRatePayment(elem);

                                                        elem.customer = {
                                                            data: vm.customersList[position],
                                                        };

                                                        elem.user_times = elem.customer.data.user_times + 1;
                                                        /**
                                                         * Setto i dati per il cambio operatore
                                                         */
                                                        elem.newOperatorId = elem.user_id;
                                                        if (elem.user_id && (elem.role == null || elem.role.data == null)) {
                                                            elem.role = { data: vm.getUserRole(elem.user_id, elem.store_id) };
                                                        } else if (!elem.user_id) {
                                                            elem.role = null;
                                                        }
                                                        if (elem.assist_user_id && (elem.assistRole == null || elem.assistRole.data == null)) {
                                                            elem.assistRole = { data: vm.getUserRole(elem.assist_user_id, elem.store_id) };
                                                        } else if (!elem.assist_user_id) {
                                                            elem.assistRole = null;
                                                        }
                                                        if (elem.commercial_user_id && (elem.commercialRole == null || elem.commercialRole.data == null)) {
                                                            elem.commercialRole = { data: vm.getUserRole(elem.commercial_user_id, elem.store_id) };
                                                        } else if (!elem.commercial_user_id) {
                                                            elem.commercialRole = null;
                                                        }
                                                        elem.newOperatorCandidates = [elem.role.data];
                                                        elem.price_full = elem.price + elem.discount;
                                                        if (vm.isAcquistoDip(elem)) {
                                                            elem.price_treatment = elem.price_full - elem.product_price / 2 - elem.product_price10 / 2;
                                                        } else {
                                                            elem.price_treatment = elem.price_full - elem.product_price - elem.product_price10;
                                                        }
                                                        if (vm.isStorno(elem)) {
                                                            elem.price_treatment = 0 - elem.price_treatment;
                                                            elem.price_discounted = elem.price_treatment;
                                                        }
                                                        vm.appointmentsList.push(elem);
                                                        vm.calcsOnVisibileElements();

                                                        //RELOAD ITEMS UPDATE MARCO
                                                        $rootScope.$broadcast(
                                                            'bm-appointment-sidenav-reloadAppointments',
                                                            {elem: elem}
                                                        );
                                                    };

                                                    vm.loadAppointmentProducts(vm.update_appointment, vm.update_appointment.treatment_id);
                                                },
                                                vm.checkResponse
                                            )
                                            ;



                                    }
                                )
                                .finally(
                                    function () {
                                        confirm = undefined;
                                    }
                                )
                                ;
                        };
                    };
                    vm.isAcquistoDip = function (app) {
                        return app.treatment_id == 67 || app.treatment_id == 68 || app.treatment_id == 69;
                    };
                    vm.update = function (appointment) {
                        $log.info('Update');

                        var canSave = vm.canSave(appointment);

                        /* console.log(payment_app);
                         console.log(vm.appCustomerParams.app_customer_balance);*/

                        if (canSave && angular.isDefined(appointment)) {
                            var confirm = $mdDialog.confirm()
                                .title('Attenzione')
                                .ariaLabel('Attenzione')
                                .textContent('Sicuro di voler aggiornare?')
                                .ok('Si')
                                .cancel('Ops, ho sbagliato')
                            ;
                            return $mdDialog
                                .show(confirm)
                                .then(
                                    function () {
                                        angular.copy(appointment, vm.update_appointment);
                                        vm.update_appointment.updatingField = vm.updatingField;
                                        if (vm.selectedAvaibility !== null) {
                                            vm.update_appointment.date_start = vm.availabilitiesList[vm.selectedAvaibility].date_start;
                                            vm.update_appointment.date_end = vm.availabilitiesList[vm.selectedAvaibility].date_end;
                                        };

                                        if(typeof vm.update_appointment.created_at === 'object'){
                                            vm.update_appointment.created_at = vm.update_appointment.created_at.data;
                                        }

                                        if(typeof vm.update_appointment.updated_at === 'object'){
                                            vm.update_appointment.updated_at = vm.update_appointment.updated_at.data;
                                        }

                                        vm.update_appointment.shoppingPlusEnabled = vm.env.shoppingPlusEnabled;

                                        CrudService.update('appointments', vm.update_appointment, vm,
                                            function (response) {
                                                var data = response.data.data;
                                                if (vm.selectedAvaibility !== null) {
                                                    var date_start = moment(data.date_start)
                                                        , date_end = moment(data.date_end);
                                                    appointment.date_start = new Date(date_start);
                                                    appointment.date_end = new Date(date_end);
                                                };
                                                appointment.customer_subscription_id = data.customer_subscription_id;
                                                appointment.subscription_new_id = null;
                                                appointment.updated_by = vm.user.id;
                                                appointment.updatedBy = { data: vm.user };
                                                appointment.updated_at = moment();
                                                appointment.updated_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                                                /**
                                                 * Aggiorno user.data con il nuovo valore
                                                 */
                                                vm.operatorChange.complete(appointment);
                                                vm.resetAll();
                                                vm.calcsOnVisibileElements();
                                                //appointent.customer_subscriprion_id = response.data.data.customer_subscription_id;

                                                //RELOAD APPOINTMENTS
                                                $rootScope.$broadcast(
                                                    'bm-appointment-sidenav-reloadAppointments'
                                                );

                                                vm.loadAppointmentProducts(vm.update_appointment, vm.update_appointment.treatment_id);
                                                vm.hideAppointmentProducts = false;

                                            },
                                            function (response) {
                                                vm.resetAll();
                                                /**
                                                 * Ripristino il valore precedente contenuto in appointment.user.data
                                                 */
                                                vm.operatorChange.reset(appointment);
                                            }
                                        );
                                        /*AppointmentsService.update( vm.update_appointment ).then( function( response ) {
                                            if( vm.selectedAvaibility !== null ) {
                                                var data = response.data.data
                                                    , date_start = moment( data.date_start )
                                                    , date_end = moment( data.date_end )
                                                ;
                                                appointment.date_start = new Date( date_start );
                                                appointment.date_end = new Date( date_end );
                                            };
                                            vm.checkResponse( response, appointment );
                                            vm.calcsOnVisibileElements();
                                        }, function (response) {//in caso di errore
                                            vm.checkResponse( response, appointment );
                                        });*/
                                    },
                                    function () {
                                        vm.operatorChange.reset(appointment);
                                    }
                                )
                                .finally(
                                    function () {
                                        confirm = undefined;
                                    }
                                )
                                ;
                        }
                        vm.hideAppointmentProducts = false;
                    };

                    vm.canSave = function (appointment) {

                        var textContent = 'Non è possibile pagare con app';
                        var errorMessage = false;

                        if (((appointment.payment_app > 0) || (appointment.payment_pos_type == 'A' && appointment.payment_pos > 0))) {

                            if (!vm.env.shoppingPlusEnabled || !vm.appCustomerParams) {
                                errorMessage = true;
                            }

                            else if (appointment.source != 'app') {
                                errorMessage = true;
                                textContent = 'Non è possibile pagare con app: l\'appuntamento non è proveniente da app.';
                            }

                            else if (appointment.price_discounted < appointment.price_full) {
                                errorMessage = true;
                                textContent = 'Non è possibile pagare questo appuntamento con app: il prezzo scontato è minore di quello totale.';
                            }

                            else if (!(vm.appCustomerParams.app_customer_balance - vm.amountEarnedWithThisAppointment + vm.original_payment_app) ||
                                ((vm.appCustomerParams.app_customer_balance - vm.amountEarnedWithThisAppointment + vm.original_payment_app) < appointment.payment_app) ||
                                (((vm.appCustomerParams.app_customer_balance - vm.amountEarnedWithThisAppointment + vm.original_payment_app) < appointment.payment_pos) && appointment.payment_pos_type == 'A')) {
                                errorMessage = true;
                                if (vm.amountEarnedWithThisAppointment > 0) {
                                    var totalForThisAppointment = vm.appCustomerParams.app_customer_balance - vm.amountEarnedWithThisAppointment + vm.original_payment_app;
                                    if (totalForThisAppointment != vm.appCustomerParams.app_customer_balance) {
                                        textContent = 'Non è possibile pagare questo appuntamento con app: per questo appuntamento il cliente ha già guadagnato ' + vm.amountEarnedWithThisAppointment +
                                            '€ ed ha a disposizione ' + totalForThisAppointment + '€' ;
                                    }
                                }
                                else {
                                    textContent = 'Non è possibile pagare questo appuntamento con app: il cliente non ha abbastanza credito residuo' ;
                                }
                            }
                        }


                        if (errorMessage) {

                            var paymentAppAlert = $mdDialog.alert()
                                .title('Attenzione')
                                .ariaLabel('Attenzione')
                                .textContent(textContent)
                                .ok('Ops, ho sbagliato');

                            $mdDialog
                                .show(paymentAppAlert);
                            return false;
                        }
                        return true;
                    }

                    $scope.$watch('ap.activeAppointment.rateizzazione_type', function (newValue) {
                        if (newValue && newValue !== null && newValue == 'S') {
                            if (vm.activeAppointment && !vm.activeAppointment.f_smallpay) {
                                vm.activeAppointment.f_smallpay = true;
                            }
                        } else {
                            if (vm.activeAppointment && vm.activeAppointment.f_smallpay) {
                                vm.activeAppointment.f_smallpay = false;
                            }
                        }
                        //$log.info(newValue);
                        //$log.info(vm.activeAppointment);
                    }, true);


                    $scope.$watch('ap.activeAppointment', function (newValue) {
                        if (newValue && newValue !== null && newValue.price_full != undefined) {
                            vm.undoVisible = (angular.equals(newValue, vm.backup_appointment)) ? false : true;
                            if (vm.undoVisible) {
                                if (newValue.user_id !== vm.backup_appointment.user_id || newValue.treatment_id !== vm.backup_appointment.treatment_id) {
                                    vm.selectedAvaibilityRequired = true;
                                }
                            } else {
                                vm.selectedAvaibilityRequired = false;
                            }
                        }
                    }, true);

                    /* Load Customers */
                    vm.customersList = [];
                    vm.query.filter_customer = '';
                    vm.query.filter_treatment = '';

                    vm.customersLoad = function (customer_id) {
                        vm.customersList = [];
                        var pars = { limit: 30, orderBy: 'firstname', 'with': 'customer_subscriptions' };
                        var search = [];
                        var searchFields = [];
                        if (customer_id != null) {
                            search.push("id:" + customer_id);
                            searchFields.push("id:=");
                        }
                        if (vm.query.filter_customer != null && vm.query.filter_customer != '') {
                            pars.filtro = vm.query.filter_customer;
                        }
                        if (search.length > 0) {
                            pars.search = search.join(";");
                            pars.searchFields = searchFields.join(";");
                        }
                        return CustomerService
                            .users_for_appointment(pars).then(
                                function (response) {
                                    if (response.data && response.data.data) {
                                        vm.customersList = response.data.data.map(
                                            function (customer) {
                                                customer.fullName = (
                                                    (customer.firstname || '')
                                                    + ' '
                                                    + (customer.lastname || '')
                                                ).toUpperCase();

                                                return customer;
                                            }
                                        );
                                        if (vm.customersList.length == 0) {
                                            vm.showActionToast("Nessun elemento trovato.");
                                        }
                                        if (customer_id)
                                            vm.customer_id = customer_id;

                                        /*$timeout(
                                            function() {*/
                                        vm.customersLoading = false;
                                        /*    }, 60
                                        )*/
                                    };
                                }
                            )
                            ;
                    };
                    vm.customersReset = function () {
                        vm.customersList = [];
                        vm.query.filter_customer = '';
                    };
                    vm.customer_app_card = function (app_customer_id) {
                        if (app_customer_id) {
                            vm.customersList = [];
                            vm.query.filter_customer = '';
                        }
                    };

                    vm.onKeyUpCustomersSearch = function (evento, obj) {
                        if (evento.keyCode == 13) {
                            /*if (evento.currentTarget.value != vm.query.filter_customer) {
                                vm.query.filter_customer = evento.currentTarget.value;
                            }*/
                            vm.customersLoad(null);
                            evento.stopPropagation();
                            evento.preventDefault();
                        }
                    };
                    vm.onKeyUpTreatmentsSearch = function (evento, obj) {
                        //$log.info(evento);
                        //$log.info(obj);
                    };
                    /* Filtro attivi from url */
                    var confirmedFilter = $location.search().confirmed;
                    if (confirmedFilter) {
                        $timeout(function () {
                            vm.eStatus.selectedFilter = parseInt(confirmedFilter);
                        }, 0);
                    }

                    var uncovered = $location.search().uncovered;
                    if (uncovered) {
                        $timeout(function () {
                            vm.eStatus.uncoveredFilter = parseInt(uncovered);
                        }, 0);
                    }
                    vm.canDelete = false;
                    /* WATCHO Lo Store */
                    vm.storeId = undefined;
                    vm.store = {};
                    $scope.$watch('$parent.selectedStore', function (id) {
                        vm.storeId = id;
                        vm.store = {};
                        if (angular.isDefined(id)) {
                            if (id > 0) {
                                if (vm.user.type == 'operator' || vm.user.type == 'storemngr' && vm.user.store_id != vm.storeId) {
                                    vm.disdSpostEnabled = false;
                                    /**
                                     * Carico presenza store manager per questo store e di conseguenza setto parametro
                                     */
                                    var adesso = moment().format('YYYY-MM-DD HH:mm:ss');
                                    OperatorAvailabilityService.all(
                                        {
                                            search: "store_id:" + vm.storeId + ";date_start:" + adesso + ";date_end:" + adesso + ";reserved:5",
                                            searchFields: "store_id:=;date_start:<=;date_end:>;reserved"
                                        }
                                    ).then(
                                        function (data) {
                                            if (data.length == 0) {
                                                vm.disdSpostEnabled = true;
                                            } else {
                                                vm.disdSpostEnabled = false;
                                            }
                                        });

                                } else {
                                    vm.disdSpostEnabled = true;
                                }
                                angular.forEach($scope.$parent.main.storesList, function (s) {
                                    if (s.id == vm.storeId) {
                                        vm.store = s;
                                    }
                                });
                            }
                            vm.userRolesLoad();
                            vm.filterTreatments();
                        }
                    });

                    vm.calcsOnVisibileElements = function () {
                        $timeout(function () {
                            vm.totFirstTime = 0;
                            vm.totPrices = 0;
                            vm.totApps = 0;
                            vm.totMinutes = 0;
                            vm.tmpAff = 0
                            vm.affidabilita = 0;
                            vm.appointmentsList.forEach(function (item) {
                                item.affidabilita = null;
                                if (item.recalled == null || item.recalled < 3) {
                                    var user_times = item.user_times > 0 ? item.user_times : 1;
                                    var app_times = item.app_times > 0 ? item.app_times : user_times;
                                    if (app_times < user_times) {
                                        app_times = user_times;
                                    }
                                    if ((item.appointment_id != null || app_times == 1) && app_times == user_times) {
                                        app_times++;
                                    }
                                    var min = moment(item.date_end).diff(moment(item.date_start), 'minutes');
                                    vm.totMinutes += min;
                                    var r = 0;
                                    if (user_times == 1) {
                                        r = 0 - item.relevance;
                                    }
                                    item.affidabilita = user_times * 100 / (app_times + r);
                                    vm.tmpAff += min * user_times / (app_times + r);
                                    if (item.paid) {
                                        vm.totPrices = vm.totPrices + item.price;
                                    }
                                    if (item.user_times <= 1) {
                                        vm.totFirstTime++;
                                    }
                                }
                            });
                            vm.affidabilita = vm.tmpAff * 100 / vm.totMinutes;

                        });
                    };

                    vm.dateFormat = function (elem, deleteCreatedAt) {

                        elem.updated_at_frmt = moment(elem.updated_at.date).format('DD/MM/YYYY HH:mm');

                        var createdR = moment(elem.created_at_r);
                        elem.createdRecently = moment().diff(createdR, 'hours') < 12;
                        //$log.info(elem);
                        elem.created_at_frmt = moment(elem.created_at.date).format('DD/MM/YYYY HH:mm');

                        elem.date_start_frmt = moment(elem.date_start).format('DD/MM/YYYY HH:mm');
                        elem.date_end_frmt = moment(elem.date_end).format('HH:mm');

                        if (elem.moved_at != null) {
                            elem.moved_at_frmt = moment(elem.moved_at).format('DD/MM/YYYY HH:mm');
                        }
                        if (elem.cancelled_at != null) {
                            elem.cancelled_at_frmt = moment(elem.cancelled_at).format('DD/MM/YYYY HH:mm');
                        }

                        if (deleteCreatedAt) {
                            delete elem.created_at;
                            delete elem.updated_at;
                        }

                        if (elem.lead != null && elem.lead.data != null && elem.lead.data.created_at != null) {
                            elem.lead.data.created_at_frmt = moment(elem.lead.data.created_at.date).format('DD/MM/YYYY HH:mm');
                        }

                    };

                    vm.manageProducts = function (a) {
                        var dialog = $mdDialog.confirm({
                            title: 'Carrello prodotti: ' + a.treatment_name + ' di ' + (a.customer.data.firstname != null ? a.customer.data.firstname.toUpperCase() : '')
                                + ' ' + (a.customer.data.lastname != null ? a.customer.data.lastname.toUpperCase() : '') + " (aid=" + a.id + ")",
                            ariaLabel: 'Carrello prodotti',
                            templateUrl: 'app/appointments/dialogs/appointmentProducts.html',
                            escapeToClose: true,
                            controller: ['$scope', '$mdDialog', '$filter', function ($scope, $mdDialog, $filter) {
                                $scope.title = this.title;
                                $scope.button_ok = 'Chiudi';
                                $scope.appointmentQuesto = a;
                                $scope.mainEntity = a;
                                $scope.productsList = [];
                                $scope.suppliersList = [];
                                $scope.appProductsList = [];
                                a.treatment = { data: { name: a.treatment_name } };
                                $scope.loadSuppliers = function (a) {
                                    var pars = {
                                    };
                                    $scope.loading = true;
                                    CrudService.all('suppliers', pars, vm, function (response) {
                                            $scope.suppliersList = response.data.data;
                                            $scope.loading = false;
                                            $scope.loadProducts();
                                        },
                                        function (response) {
                                            $scope.loading = false;
                                        });
                                };
                                $scope.loadProducts = function () {
                                    var pars = {
                                        'active': 1
                                    };
                                    $scope.loading = true;
                                    CrudService.all('products', pars, vm, function (response) {
                                            angular.forEach(response.data.data, function (p) {
                                                if (p.price_pub) {
                                                    $scope.productsList.push(p);
                                                    $scope.setSupplier(p);
                                                }
                                            });
                                            $scope.loading = false;
                                            $scope.loadAppProducts($scope.appointmentQuesto)
                                        },
                                        function (response) {
                                            $scope.loading = false;
                                        });
                                };
                                $scope.loadAppProducts = function (a) {
                                    var pars = {
                                        'search': a.id,
                                        'searchFields': 'appointment_id',
                                        'not_in_treatment':true,
                                        'orderBy': 'id',
                                        'with': 'product'
                                    };
                                    $scope.loading = true;
                                    CrudService.all('appointment_products', pars, vm, function (response) {
                                            $scope.appProductsList = response.data.data;
                                            angular.forEach($scope.appProductsList, function (ap) {
                                                $scope.setSupplier(ap.product);
                                            });
                                            $scope.computeTotals();
                                            $scope.loading = false;

                                        },
                                        function (response) {
                                            $scope.loading = false;
                                        });
                                };
                                $scope.setSupplier = function (e) {
                                    angular.forEach($scope.suppliersList, function (s) {
                                        if (s.id == e.supplier_id) {
                                            e.supplier = s;
                                        }
                                    });
                                };

                                $scope.addProduct = function (p) {
                                    var trov = false;
                                    var nap = null;
                                    angular.forEach($scope.appProductsList, function (ap) {
                                        if (ap.product_id == p.id) {
                                            ap.qty = ap.qty + 1;
                                            trov = true;
                                            nap = ap;
                                        }
                                    });
                                    if (!trov) {
                                        nap = {
                                            'id': null,
                                            'product_id': p.id,
                                            'store_id': $scope.mainEntity.store_id,
                                            'appointment_id': $scope.mainEntity.id,
                                            'qty': 1,
                                            'price': p.price_pub, /*todo va messa la logica dei prodotti operatrice*/
                                            'in_treatment': p.id ? 0 : 1,
                                            'product': p,
                                            'subblier': p.supplier
                                        };
                                        $scope.appProductsList.push(nap);
                                    }
                                    $scope.save(nap);
                                }
                                $scope.save = function (row) {
                                    $scope.loading = true;
                                    $scope.mainEntity.includedProducts = { data: $filter('filter')($scope.appProductsList, { 'in_treatment': 1 }, true) };
                                    if (row.qty == 0) {
                                        $scope.deleteProduct(row);
                                        return;
                                    }
                                    CrudService.save('appointment_products', row, vm, function (response) {
                                            row.id = response.data.data.id;
                                            $scope.loading = false;
                                            //vanno ricalcolati i totali
                                            $scope.computeTotals();
                                        },
                                        function (response) {
                                            $scope.loading = false;
                                        });

                                };

                                $scope.deleteProduct = function (ap) {
                                    $scope.loading = true;
                                    CrudService.del('appointment_products', ap.id, vm, function (response) {
                                            var tmpList = $scope.appProductsList;
                                            $scope.appProductsList = [];
                                            angular.forEach(tmpList, function (e) {
                                                if (e.id != ap.id) {
                                                    $scope.appProductsList.push(e);
                                                }
                                            });
                                            $scope.loading = false;
                                            //vanno ricalcolati i totali
                                            $scope.mainEntity.includedProducts = { data: $filter('filter')($scope.appProductsList, { 'in_treatment': 1 }, true) };
                                            $scope.computeTotals();
                                        },
                                        function (response) {
                                            $scope.loading = false;
                                        });
                                };

                                $scope.computeTotals = function () {
                                    var t = 0;
                                    var t_in = 0;
                                    var t10 = 0;
                                    var t10_in = 0;
                                    angular.forEach($scope.appProductsList, function (ap) {
                                        if (!ap.in_treatment) {
                                            if (ap.product.supplier.vat == 10) {
                                                t10 += (ap.price * ap.qty);
                                            } else {
                                                t += (ap.price * ap.qty);
                                            }
                                        } else {
                                            if (ap.product.supplier.vat == 10) {
                                                t10_in += (ap.price * ap.qty);
                                            } else {
                                                t_in += (ap.price * ap.qty);
                                            }
                                        }
                                    });
                                    $scope.mainEntity.product_price = t;
                                    $scope.mainEntity.product_price10 = t10;
                                    $scope.mainEntity.product_price_in = t_in;
                                    $scope.mainEntity.product_price10_in = t10_in;
                                    //$scope.mainEntity.tri = vm.tri($scope.mainEntity);
                                    //$log.info("computedTri: ");
                                    //$log.info($scope.mainEntity.includedProducts);
                                    vm.paymentDiscountPriceRateUpdate(false);
                                    vm.paymentPosUpdate();
                                };

                                $scope.close = function () {
                                    $mdDialog.hide(true);
                                };
                                $scope.loadSuppliers();
                            }]
                        });

                        return $mdDialog
                            .show(dialog)
                            .finally(
                                function () {
                                    dialog = undefined;
                                }
                            )
                            ;
                    };

                    vm.manageTreatmentProducts = function(a) {

                        var titleDialog = 'Selezione medicinali del usati per ' + a.treatment_name;
                        if(a.customer) {
                            titleDialog += ' di ' + (a.customer.data.firstname != null ? a.customer.data.firstname.toUpperCase() : '')
                            + ' ' + (a.customer.data.lastname != null ? a.customer.data.lastname.toUpperCase() : '') + " (aid=" + a.id + ")";
                        }

                        var dialog = $mdDialog.confirm({
                            title: titleDialog,
                            ariaLabel: 'Medicinali del trattamento',
                            templateUrl: 'app/appointments/dialogs/appointmentTreatmentProducts.html',
                            escapeToClose: true,
                            controller: ['$scope', '$mdDialog', '$filter', function ($scope, $mdDialog, $filter) {
                                $scope.title = this.title;
                                $scope.button_close = 'Chiudi';
                                $scope.button_save = 'Salva';
                                $scope.appointmentQuesto = a;
                                $scope.mainEntity = angular.copy(a);
                                $scope.productsList = [];
                                $scope.suppliersList = [];
                                $scope.treatmentProductsList = [];
                                $scope.appTreatmentProductsList = [];
                                $scope.loadingTreatmentProductApp = true;
                                $scope.loadingTreatmentProduct = true;
                                $scope.saving = false;
                                a.treatment = { data: { name: a.treatment_name } };

                                var used_product_ids = [];

                                $scope.loadAppointmentTreatmentProducts = function() {
                                    $scope.loadingTreatmentProductApp = true;
                                    var pars = {
                                        /*
                                        "appointment_id":$scope.appointmentQuesto.id,
                                        "treatment_id":$scope.appointmentQuesto.treatment_id,
                                        "used_in_treatment":1
                                        */
                                    };

                                    CrudService.all('treatment-products/appointments/'+$scope.appointmentQuesto.id+'/treatments/'+$scope.appointmentQuesto.treatment_id, pars, vm,
                                    function(response) {

                                        $scope.appTreatmentProductsList = response.data;
                                        for(var key in $scope.appTreatmentProductsList) {
                                            $scope.appTreatmentProductsList[key].checked = true;
                                            $scope.appTreatmentProductsList[key].qty = $scope.appTreatmentProductsList[key].appointment_products[0].qty;
                                            //$scope.appProductsList[key].qty = $scope.appProductsList[key].qty;
                                            used_product_ids.push($scope.appTreatmentProductsList[key].id);

                                        }
                                        $scope.loadingTreatmentProductApp = false;
                                        $scope.loadTreatmentProducts();

                                    },
                                    function (response) {
                                        $log.log(response);
                                        $scope.loadingTreatmentProductApp = false;
                                    });
                                }

                                $scope.loadTreatmentProducts = function() {
                                    $scope.loadingTreatmentProduct = true;
                                    var pars = {
                                        "treatment_id":$scope.appointmentQuesto.treatment_id
                                    };

                                    $scope.loading = true;

                                    CrudService.all('treatment-products', pars, vm,
                                    function(response) {

                                        $scope.treatmentProductsList = response.data;
                                        for(var key in $scope.treatmentProductsList) {
                                            //$scope.treatmentProductsList[key].checked = false;

                                            $scope.treatmentProductsList[key].checked = used_product_ids.includes($scope.treatmentProductsList[key].id);
                                            //$scope.computeTotals();
                                        }

                                        $scope.loadingTreatmentProduct = false;
                                    },
                                    function (response) {
                                        $log.log(response);
                                        $scope.loadingTreatmentProduct = false;
                                    });
                                }

                                $scope.selectProduct = function(product) {

                                    if(product.checked == 1) {
                                        if(!used_product_ids.includes(product.id)) {
                                            $scope.appTreatmentProductsList.push(product);
                                        }
                                    } else {
                                        //console.log("Lista prodotti"); console.log($scope.appProductsList); return;
                                        for(var key in $scope.appTreatmentProductsList) {
                                            if($scope.appTreatmentProductsList[key].id == product.id) {
                                                //console.log("Key"); console.log(key);
                                                $scope.appTreatmentProductsList.splice(key, 1);
                                                var index = used_product_ids.indexOf(product.id);
                                                used_product_ids.splice(index, 1);
                                                //used_product_ids.filter(Number);
                                                break;
                                            }
                                        }
                                    }
                                }

                                $scope.save = function () {

                                    if($scope.appTreatmentProductsList.length==0) {
                                        alert("E' necessario selezionare almeno un prodotto");
                                        return;
                                    }

                                    var postUrl = "appointment_products/"+$scope.appointmentQuesto.id+"/treatments/"+$scope.appointmentQuesto.treatment_id+"/store_products";
                                    vm.appointmentProducts = [];
                                    $scope.saving = true;
                                    CrudService.save(postUrl, $scope.appTreatmentProductsList, vm, function (response) {

                                            $scope.saving = false;
                                            //$log.log(response);
                                            $scope.close();
                                            //vm.appointmentProducts= $scope.appProductsList;
                                            //vm.hideAppointmentProducts = false;
                                            vm.loadAppointmentProducts($scope.appointmentQuesto, $scope.appointmentQuesto.treatment_id);
                                        },
                                        function (response) {
                                            $scope.saving = false;
                                            $log.info(response);
                                        });

                                };

                                $scope.close = function () {
                                    $mdDialog.hide(true);
                                };

                                if($scope.appointmentQuesto.id) {
                                    $scope.loadAppointmentTreatmentProducts();
                                } else {
                                    $scope.loadTreatmentProducts();
                                }

                            }]


                        });


                        return $mdDialog
                            .show(dialog)
                            .finally(
                                function () {
                                    dialog = undefined;
                                }
                            )
                            ;
                    }

                    vm.switchTheTreatment = function(treatment) {
                        return null;
                        console.log(["Switcho il treatment", treatment]);
                        console.log(["Attuale appuntamento", vm.activeAppointment]);
                        ///appointments/{appointment_id}/trestments/reset-treatment
                        var postUrl = "treatment-products/appointments/"+vm.activeAppointment.id+"/reset-treatment";
                        CrudService.save(postUrl, {'treatment_id':treatment.id}, vm, function (response) {
                            console.log(["response switch", response]);
                        },
                        function (response) {
                            $scope.loading = false;
                            //$mdDialog.hide(true);
                        });

                    }

                    vm.loadAppointmentProducts = function(appointment, treatment_id) {
                        //console.log(["Ricarico i prodotti dell'appuntamento", appointment]);
                        var pars = {
                            "search":appointment.id,
                            "searchFields":"appointment_id",
                            "with":"product"
                        };
                        var url = "appointment_products";
                        CrudService.all(url, pars, vm, function(response) {

                            //vm.appointmentProducts = response.data.data;
                            var products = response.data.data;
                            //console.log(["Qta dei prodotti", vm.appointmentProducts]);
                            for(var i=0; i<products.length; i++) {
                                if(products[i].treatment_id!=null) {
                                    if(treatment_id != undefined) {
                                        if(treatment_id==products[i].treatment_id) {
                                            vm.appointmentProducts.push(products[i]);
                                        }
                                    } else {
                                        vm.appointmentProducts.push(products[i]);
                                    }

                                } else {
                                    vm.appointmentCartProducts.push(products[i]);
                                }
                            }
                            vm.hideAppointmentProducts = false;

                        });
                    }

                    vm.appointmentTreatmentProducts = function() {

                        //console.log("Appuntamento attivo"); console.log(vm.activeAppointment); return;
                        if(!vm.activeAppointment) return;
                        if(!vm.activeAppointment.treatment_id || !vm.activeAppointment.treatment_id > 0) return;

                        var pars = {};

                        CrudService.all('treatment-products/appointments/'+vm.activeAppointment.id+'/treatments/'+vm.activeAppointment.treatment_id, pars, vm,
                        function(response) {

                            //$scope.appTreatmentProductsList = response.data;
                            vm.appointmentProducts = response.data;
                            if(response.data.length>0) {
                                vm.hideAppointmentProducts = false;
                            }

                        },
                        function (response) {
                            $log.log(response);
                        });
                    }


                    vm.operatorChange = {
                        complete: function (appointment) {
                            if (appointment != null && appointment.user_id
                                && (!appointment.role || !appointment.role.data || appointment.user_id != appointment.role.data.user_id)) {
                                appointment.role = { data: vm.getUserRole(appointment.user_id, appointment.store_id) };
                                appointment.newOperatorCandidates = [appointment.role.data];
                                appointment.newOperatorId = appointment.user_id;
                            } else if (appointment != null && !appointment.user_id) {
                                appointment.role = null;
                                appointment.newOperatorCandidates = [];
                            }
                            if (appointment != null && appointment.assist_user_id
                                && (!appointment.assistRole || !appointment.assistRole.data || appointment.assist_user_id != appointment.assistRole.data.user_id)) {
                                appointment.assistRole = { data: vm.getUserRole(appointment.assist_user_id, appointment.store_id) };
                            } else if (appointment != null && !appointment.assist_user_id) {
                                appointment.assistRole = null;
                            }
                            if (appointment != null && appointment.commercial_user_id
                                && (!appointment.commercialRole || !appointment.commercialRole.data || appointment.commercial_user_id != appointment.commercialRole.data.user_id)) {
                                appointment.commercialRole = { data: vm.getUserRole(appointment.commercial_user_id, appointment.store_id) };
                            } else if (appointment != null && !appointment.commercial_user_id) {
                                appointment.commercialRole = null;
                            }
                        },
                        reset: function (appointment) {
                            if (appointment != null && appointment.user_id != appointment.role.data.user_id) {
                                appointment.user_id = appointment.role.data.user_id;
                                appointment.newOperatorCandidates = [appointment.role.data];
                                appointment.newOperatorId = appointment.user_id;
                            }
                        },
                        doChange: function (appointment) {
                            if (appointment.closed) {
                                vm.showActionToast("Cassa chiusa.");
                                return;
                            }
                            appointment.uncovered = 0;
                            vm.update(appointment);
                        },
                        gotFocus: function (appointment) {
                            /**
                             * devo caricare gli operatori disponibili per il cambio su questo appuntamento
                             */
                            if (appointment.closed) {
                                vm.showActionToast("Cassa chiusa.");
                                return;
                            }
                            /*if (vm.user.type!='admin') {
                                vm.showActionToast("Operazione non consentita. Contattare l'assistenza.");
                                return;
                            }*/
                            if (appointment.recalled != null && appointment.recalled >= 3) {
                                if (appointment.recalled == 4) {
                                    vm.showActionToast("Appuntamento spostato.");
                                } else if (appointment.recalled == 3) {
                                    vm.showActionToast("Appuntamento disdetto.");
                                }
                                return;
                            }
                            appointment.newOperatorId = appointment.user_id;
                            appointment.newOperatorCandidates = [];
                            if (appointment.role && appointment.role.data) {
                                appointment.newOperatorCandidates.push(appointment.role.data);
                            }
                            UsersService.availablesForChange(appointment.store_id, appointment.id, appointment.user_id, moment(appointment.date_start).format('YYYY-MM-DD')).then(
                                function (response) {
                                    if (response.data && response.data) {
                                        if (response.data.length == 0) {
                                            vm.showActionToast("Nessuna disponibilità per il cambio.");
                                        } else {
                                            response.data.forEach(function (op) {
                                                appointment.newOperatorCandidates.push(vm.getUserRole(op.id, appointment.store_id, op.role_id));
                                            });
                                        }
                                    }
                                });
                        }
                    };

                    vm.preview = document.getElementById('preview');
                    if (false && vm.env.giftcardEnabled) {
                        vm.scanner = new Instascan.Scanner({ video: vm.preview, scanPeriod: 5 });
                        //console.log(vm.preview);
                        vm.scanner.addListener('scan', function (content, image) {
                            //console.log(content);
                            //console.log(vm);
                            //console.log(vm.activeAppointment);
                            if (vm.activeAppointment) {
                                //$scope.appointmentForm.gift_number.val(content);
                                vm.activeAppointment.gift_number = content;
                                $scope.$digest();
                                vm.hidePreview();
                            }
                            //console.log("setted: "+vm.activeAppointment.gift_number);
                        });
                        Instascan.Camera.getCameras().then(function (cameras) {
                            vm.cameras = cameras;
                            if (cameras.length > 0) {
                                vm.activeCameraId = cameras[0].id;
                                console.log("starting scanner on ");
                                console.log(cameras[0]);
                                vm.scanner.start(cameras[0]);
                            } else {
                                console.error('No cameras found.');
                            }
                        }).catch(function (e) {
                            console.error(e);
                        });
                    }
                    vm.showPreview = function (obj) {
                        if (vm.preview && vm.preview.style) {
                            vm.preview.style.visibility = 'visible';
                            vm.preview.style.display = '';
                            vm.preview.style.position = 'absolute';
                            vm.preview.style.top = '50%';
                            vm.preview.style.left = '50%';
                            vm.preview.style['margin-top'] = '-200px';
                            vm.preview.style['margin-left'] = '-350px';
                        }
                    };
                    vm.hidePreview = function () {
                        if (vm.preview && vm.preview.style) {
                            vm.preview.style.visibility = 'hidden';
                            vm.preview.style.display = 'none';
                        }
                    };

                    vm.n_installments = [1,2,3,4,5,6,7,8,9,10,11,12];

                    vm.n_consumerCredit = [6,12,18,24,30,36,42,48];

                    vm.getCustomerAppId = function (customer_id) {
                        if (env.shoppingPlusEnabled) {
                            vm.appCustomerParams = {};
                            CustomerService.get(
                                customer_id
                            )
                                .then(function (response) {
                                    if (response.data && response.data.data && response.data.data.hasOwnProperty('app_customer_id')
                                        && response.data.data.app_customer_id
                                    ) {
                                        vm.loadCustomerAppInfo(response.data.data.app_customer_id);
                                    }
                                });
                        }
                    }

                    vm.loadCustomerAppInfo = function (customer_app_id) {
                        vm.amountEarnedWithThisAppointment = 0;
                        vm.appCustomerParams.coupon_title = null;
                        if (env.shoppingPlusEnabled) {
                            vm.appCustomerParams = {};
                            $http
                                .get(env.API + "/recharges_app/getCard?balance=true&to_send=true&app_customer_id=" + customer_app_id)
                                .then(function (response) {
                                    if (response.data && response.data.data) {
                                        vm.appCustomerParams.app_customer_card_date = moment(response.data.data.daticard.dataemissione, 'YYYYMMDD').format("DD/MM/YYYY");
                                        if ((response.data.data.hasOwnProperty('balance')) && response.data.data.balance.hasOwnProperty('saldor')) {
                                            vm.appCustomerParams.app_customer_points = response.data.data.balance.saldor;
                                            vm.appCustomerParams.app_customer_balance = parseInt(response.data.data.balance.saldor /
                                                $scope.$parent.main.config.get("app.customer.points_to_balance", 100));
                                        }
                                    }
                                });

                            var endPointGetCoupon = '';

                            if (!vm.isNewAppointment && vm.activeAppointment.id) {
                                endPointGetCoupon = (env.API + "/recharges_app/getCoupon?app_customer_id=" + customer_app_id + '&store_id=' + vm.storeId + '&coupon_code=' + vm.activeAppointment.coupon_code);
                            }
                            else {
                                endPointGetCoupon = (env.API + "/recharges_app/getCoupon?app_customer_id=" + customer_app_id + '&store_id=' + vm.storeId);
                            }

                            $http
                                .get(endPointGetCoupon)
                                .then(function (response) {
                                    if (response && response.data && response.data.data && response.data.data.coupon) {
                                        vm.appCustomerParams.coupon_title = response.data.data.coupon.coupon.titolo;
                                    }
                                });

                            if (!vm.isNewAppointment && vm.activeAppointment.id) {
                                $scope.loading = true;
                                return CrudService.all(
                                    'recharges_app',
                                    {
                                        appointment_id: vm.activeAppointment.id
                                    },
                                    vm,
                                    function (response) {
                                        angular.forEach(response.data.data, function (item) {
                                            if (item.status == 'ok' && item.type == 0) {
                                                vm.amountEarnedWithThisAppointment += item.amount;
                                            }
                                        });
                                        $scope.loading = false;
                                    },
                                    function (response) {
                                        var errMsg = "";
                                        if (response.data != null
                                            && response.data.message != null) {
                                            errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                                            var url = response.config != null && response.config.url != null ? response.config.url : "";
                                            if (url != null) {
                                                errMsg += "\nUrl: " + url;
                                            }
                                        }
                                        alert("Si è verificato un errore nel caricamento delle attività: " + errMsg);
                                        $scope.loading = false;
                                        return false;
                                    }
                                );
                            }
                        }
                    }

                    /**
                     * Gestione card gift
                     */
                    vm.card = {
                        area: vm.env.tenant_giftcode,
                        value: null,
                        filter_number: null,
                        filter_number_pay: null,
                        card: { balance: 0 },
                        list: [],
                        init: function (app) {
                            if (app.treatment_id == 99) {
                                if (app.gift_number && app.gift_number.length > 3) {
                                    this.value = app.gift_number.substring(2, 5);
                                    app.treatment.data.start_price = parseFloat(this.value);
                                } else {
                                    app.treatment.data.start_price = 0;
                                }
                            }
                        },
                        setValue: function () {
                            vm.treatment.start_price = parseFloat(vm.card.value);
                            this.list = [];
                            this.number = null;
                            vm.appointmentTypeChange();
                        },
                        onKeyUpSearch: function (evento, obj) {
                            if (evento.keyCode == 13) {
                                this.load();
                                evento.stopPropagation();
                                evento.preventDefault();
                            }
                        },
                        format: function (card_number) {
                            if (card_number != null && card_number != '' && card_number.length == 11) {
                                return card_number.substring(0, 2) + "-" + card_number.substring(2, 5) + "-" + card_number.substring(5, 11);
                            } else {
                                return card_number;
                            }
                        },
                        select: function () {
                            vm.card.card = { balance: 0 };
                            if (vm.activeAppointment.gift_number) {
                                angular.forEach(this.list, function (el) {
                                    if (el.number == vm.activeAppointment.gift_number) {
                                        vm.card.card = el;
                                        //$log.info("selected card: " + el);
                                        //$log.info(el);
                                    }
                                });
                            }
                        },
                        load: function () {
                            var pars = {
                                'searchJoin': 'and',
                                'searchFields': 'number:like;released:=',
                            };
                            if (vm.activeAppointment.treatment_id == 99) {
                                if (this.filter_number.substring(0, 5) == this.area + this.value) {
                                    this.filter_number = this.filter_number.substring(5);
                                }
                                pars.search = 'released:0;number:' + this.area + this.value + '%' + this.filter_number + "%";
                            } else {
                                pars.search = 'released:1;number:%' + this.filter_number_pay + "%";
                            }
                            this.loading = true;
                            CrudService.all('giftcards', pars, vm,
                                function (response) {
                                    vm.card.list = response.data.data;
                                    vm.card.loading = false;
                                },
                                function (response) {
                                    vm.card.loading = false;
                                }
                            );
                        },
                        find: function (app) {
                            var pars = {
                                'searchJoin': 'and',
                                'searchFields': 'rel_tenant:=;rel_appointment_id:=',
                                'search': 'rel_tenant:' + vm.env.tenant + ';rel_appointment_id:' + app.id,
                            };
                            this.loading = true;
                            CrudService.all('giftcards', pars, vm,
                                function (response) {
                                    var list = response.data.data;
                                    if (list.length >= 1) {
                                        app.giftcard = { data: list[0] };
                                        //app.gift_number = app.giftcard.data.number;
                                    } else {
                                        //app.gift_number = -1;
                                    }
                                    vm.card.loading = false;
                                },
                                function (response) {
                                    vm.card.loading = false;
                                }
                            );
                        },
                    };//fine def card


                    //LISTENER TO OPEN SIDEBAR
                    $scope.$on("bm-appointment-sidenav-toggleRight",function(event, data){
                        vm.updatingField = (data.updatingField==null? '' : data.updatingField);
                        vm.toggleRight(data.appointment, data.isRowClick);
                    });


                    //LISTENER TO UPDATE APPOINTMENT USERS
                    $scope.$on("bm-appointment-sidenav-update-users",function(event, data){
                        vm.operatorChange.doChange(data.appointment);
                    });


                    this.$onInit = function () {

                        /* Controllo se c'è un Customer */
                        if (this.customer && angular.isDefined(this.customer)) {
                            vm.customersLoading = true;
                            vm.customersLoad(this.customer.id);
                        }

                    };

                }]
        }
    }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("blWireTransfersConsumerCredit", blWireTransfersConsumerCredit);
    function blWireTransfersConsumerCredit() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bl-wire-transfers-consumer-credit/bl-wire-transfers-consumer-credit.html",
            bindToController: {
                filtertype: "=",
                archive: "=",
                token: "="
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                '$http',
                "$log",
                "$mdDialog",
                "$mdToast",
                "$scope",
                "CrudService",
                "env",
                "UsersService",
                function (
                    $http,
                    $log,
                    $mdDialog,
                    $mdToast,
                    $scope,
                    CrudService,
                    env,
                    UsersService
                ) {

                    var vm = this;
                    vm.env = env;
                    vm.mdDialog = $mdDialog;
                    $log.info('blWireTransfersConsumerCredit');

                    /* Operatore connesso */
                    if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
                        return;
                    }

                    vm.today = new Date(moment().hour(8).minute(0).second(0));
                    vm.minDateFilter = new Date(2022, 1, 1);

                    vm.options = {
                        autoSelect: false,
                        boundaryLinks: true,
                        pageSelector: true,
                        rowSelection: false
                    };

                    vm.wireTransfersListPag = {
                        "total": 0,
                        "count": 10,
                        "per_page": 50,
                        "current_page": 1,
                        "total_pages": 0,
                        "links": {}
                    };

                    vm.queryWireTransfers = {
                        filter: '',
                        filter_date_start: vm.today,
                        filter_date_end: null,
                        order: '-transfer_date',
                        limitOptions: [ 50, 75, 100 ],
                        page: 1
                    };

                    vm.onChangeDateStartWireTransfer = function () {
                        vm.queryWireTransfers.page = 1;
                        vm.queryWireTransfers.order = 'transfer_date';
                        if (vm.queryWireTransfers.filter_date_start && vm.queryWireTransfers.filter_date_end) {
                            if (moment(vm.queryWireTransfers.filter_date_end).hour(23).minute(59).second(59).isBefore(vm.queryWireTransfers.filter_date_start)) {
                                vm.queryWireTransfers.filter_date_end = null;
                            }
                        }

                        vm.loadConsumerCredits();
                    }

                    vm.onChangeDateEndWireTransfer = function () {
                        vm.queryWireTransfers.page = 1;
                        vm.queryWireTransfers.order = 'transfer_date';
                        if (vm.queryWireTransfers.filter_date_start && vm.queryWireTransfers.filter_date_end) {
                            if (moment(vm.queryWireTransfers.filter_date_end).hour(23).minute(59).second(59).isBefore(vm.queryWireTransfers.filter_date_start)) {
                                vm.queryWireTransfers.filter_date_start = vm.queryWireTransfers.filter_date_end;
                            }
                        }

                        vm.loadConsumerCredits();
                    }

                    vm.loadConsumerCredits = function (p, s) {

                        if (vm.storeId) {

                            vm.loadingWireTransfers = true;

                            vm.wireTransfers = [];
                            var search = [];
                            var searchFields = [];

                            if (p == null) {
                                p = vm.queryWireTransfers.page;
                            }
                            vm.queryWireTransfers.page = p;

                            if (s == null) {
                                s = parseInt(vm.wireTransfersListPag.per_page);
                            }

                            var pars = {
                                page: p,
                                s: s,
                                store_id: vm.store_id,
                                with: null
                            };

                            if (vm.queryWireTransfers.filter_date_start != null && vm.queryWireTransfers.filter_date_start != '') {
                                var date_start = moment(vm.queryWireTransfers.filter_date_start).format("YYYY-MM-DD 00:00:00");
                                pars.filter_date_start = date_start;
                            }

                            if (vm.queryWireTransfers.filter_date_end != null && vm.queryWireTransfers.filter_date_end != '') {
                                var date_end = moment(vm.queryWireTransfers.filter_date_end).format("YYYY-MM-DD 23:59:59");
                                pars.filter_date_end = date_end;
                            }

                            if (vm.queryWireTransfers.order != null && vm.queryWireTransfers.order != '') {
                                pars.orderBy = vm.queryWireTransfers.order.indexOf('-') == 0 ? vm.queryWireTransfers.order.substring(1) : vm.queryWireTransfers.order;
                                pars.sortedBy = vm.queryWireTransfers.order.indexOf('-') == 0 ? 'desc' : null;
                            }

                            //FILTER BY TYPE
                            if (vm.filtertype) {
                                searchFields.push("wire_transfers.type:=");
                                search.push("wire_transfers.type:" + vm.filtertype);
                            }

                            //FILTER ARCHIVE
                            if (vm.archive) {
                                pars.filter_archive = true;
                            }

                            //BIOSMED FILTER STORE
                            if (vm.storeId) {
                                searchFields.push("store_id:=");
                                search.push("store_id:" + vm.storeId);
                            }

                            pars.search = search.join(";");
                            pars.searchFields = searchFields.join(";");

                            CrudService.all(
                                'wire_transfers/index-consumer-credit',
                                pars,
                                vm,
                                function (response) {

                                    if (response.data && response.data.data) {
                                        vm.wireTransfersListPag = response.data.meta.pagination;

                                        angular.forEach(response.data.data, function (elem) {
                                            elem.value_date_frmt = moment(elem.value_date).format('DD/MM/YYYY');
                                            elem.transfer_date_frmt = moment(elem.transfer_date).format('DD/MM/YYYY');
                                        });

                                        vm.wireTransfers = response.data.data;
                                    }

                                    vm.loadingWireTransfers = false;

                                },
                                function (response) {
                                    vm.printErrorMessage(response);
                                    vm.loadingWireTransfers = false;
                                });

                        } else {

                            vm.showActionToast("Seleziona lo store per filtrare i crediti al consumo!");

                        }

                    }

                    vm.deleteImport = function() {
                        $log.info('Elimina Importazione Credito Al Consumo');

                        var date_start = "";
                        var date_end = "";

                        if (vm.queryWireTransfers.filter_date_start != null && vm.queryWireTransfers.filter_date_start != '') {
                            var date_start = moment(vm.queryWireTransfers.filter_date_start);
                        }

                        if (vm.queryWireTransfers.filter_date_end != null && vm.queryWireTransfers.filter_date_end != '') {
                            var date_end = moment(vm.queryWireTransfers.filter_date_end);
                        }

                        var confirm = $mdDialog.confirm()
                            .title('Attenzione')
                            .ariaLabel('Attenzione')
                            .textContent(
                                'Sicuro di voler eliminare i crediti al consumo' +
                                ' DAL: ' + ((date_start)? date_start.format("DD/MM/YYYY") : "-") +
                                ' AL: ' + ((date_end)? date_end.format("DD/MM/YYYY") : "-")
                            )
                            .ok('Si')
                            .cancel('Ops, ho sbagliato');

                        return $mdDialog
                            .show(confirm)
                            .then(
                                function () {
                                    vm.loadingWireTransfers = true;

                                    $http
                                        .post(
                                            vm.env.API + '/wire_transfers/delete-import',
                                            {
                                                type: 'consumer-credit',
                                                date_start: ((date_start)? date_start.format("YYYY-MM-DD 00:00:00") : ""),
                                                date_end: ((date_end)? date_end.format("YYYY-MM-DD 23:59:59") : "")
                                            }
                                        )
                                        .then(
                                            function (response) {
                                                vm.loadingWireTransfers = false;
                                                vm.loadConsumerCredits();
                                            },
                                            function (response) {
                                                vm.loadingWireTransfers = false;
                                                vm.printErrorMessage(response);
                                            }
                                        );

                                }
                            ).finally(
                                function () {
                                    confirm = undefined;
                                }
                            );
                    };

                    vm.reorderWireTransfers = function (column) {
                        vm.queryWireTransfers.order = column;
                        vm.loadConsumerCredits();
                    };

                    vm.printErrorMessage = function (response) {
                        var errMsg = "";
                        if (response.data != null
                            && response.data.message != null) {
                            errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                            var url = response.config != null && response.config.url != null ? response.config.url : "";
                            if (url != null) {
                                errMsg += "\nUrl: " + url;
                            }
                        }

                        vm.showActionToast("Si è verificato un errore " + errMsg);
                    };

                    vm.showActionToast = function (text) {
                        text = text && angular.isDefined(text) ? text : 'Tutto Ok!';
                        var toast = $mdToast.simple()
                            .textContent(text)
                            .action('')
                            .highlightAction(true)
                            .position('bottom right');
                        return $mdToast
                            .show(toast)
                            .finally(
                                function () {
                                    toast = undefined;
                                }
                            );
                    };


                    this.$onInit = function () {

                        vm.archive = this.archive;
                        vm.filtertype = this.filtertype;

                        //ON ARCHIEVE REMOVE FILTER MIN DATE
                        if (vm.archive) {
                            vm.minDateFilter = null;
                        }

                        vm.loadConsumerCredits();

                    };


                    $scope.$on("bl-wire-transfers-consumer-credit-loadWireTransfers", function (event) {
                        vm.loadConsumerCredits();
                    });


                    /* WATCHO Lo Store */
                    $scope.$watch('$parent.selectedStore', function (id) {
                        if (angular.isDefined(id)) {
                            vm.storeId = id;
                            vm.loadConsumerCredits();
                        };
                    });

                }]
        }
    }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("blWireTransfersCofidis", blWireTransfersCofidis);
    function blWireTransfersCofidis() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bl-wire-transfers-cofidis/bl-wire-transfers-cofidis.html",
            bindToController: {
                filtertype: "=",
                archive: "=",
                token: "="
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                '$http',
                "$log",
                "$mdDialog",
                "$mdToast",
                "$scope",
                "CrudService",
                "env",
                "UsersService",
                function (
                    $http,
                    $log,
                    $mdDialog,
                    $mdToast,
                    $scope,
                    CrudService,
                    env,
                    UsersService
                ) {

                    var vm = this;
                    vm.env = env;
                    vm.mdDialog = $mdDialog;
                    $log.info('blAppointmentsWireTransfersCofidis');

                    /* Operatore connesso */
                    if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
                        return;
                    }

                    vm.today = new Date(moment().hour(8).minute(0).second(0));
                    vm.minDateFilter = new Date(2022, 1, 1);

                    vm.options = {
                        autoSelect: false,
                        boundaryLinks: true,
                        pageSelector: true,
                        rowSelection: false
                    };

                    vm.wireTransfersListPag = {
                        "total": 0,
                        "count": 10,
                        "per_page": 50,
                        "current_page": 1,
                        "total_pages": 0,
                        "links": {}
                    };

                    vm.queryWireTransfers = {
                        filter: '',
                        filter_date_start: vm.today,
                        filter_date_end: null,
                        order: '-transfer_date',
                        limitOptions: [ 50, 75, 100 ],
                        page: 1
                    };

                    vm.onChangeDateStartWireTransfer = function () {
                        vm.queryWireTransfers.page = 1;
                        vm.queryWireTransfers.order = 'transfer_date';
                        if (vm.queryWireTransfers.filter_date_start && vm.queryWireTransfers.filter_date_end) {
                            if (moment(vm.queryWireTransfers.filter_date_end).hour(23).minute(59).second(59).isBefore(vm.queryWireTransfers.filter_date_start)) {
                                vm.queryWireTransfers.filter_date_end = null;
                            }
                        }

                        vm.loadCofidis();
                    }

                    vm.onChangeDateEndWireTransfer = function () {
                        vm.queryWireTransfers.page = 1;
                        vm.queryWireTransfers.order = 'transfer_date';
                        if (vm.queryWireTransfers.filter_date_start && vm.queryWireTransfers.filter_date_end) {
                            if (moment(vm.queryWireTransfers.filter_date_end).hour(23).minute(59).second(59).isBefore(vm.queryWireTransfers.filter_date_start)) {
                                vm.queryWireTransfers.filter_date_start = vm.queryWireTransfers.filter_date_end;
                            }
                        }

                        vm.loadCofidis();
                    }

                    vm.loadCofidis = function (p, s) {

                        if (vm.storeId) {

                            vm.loadingWireTransfers = true;

                            vm.wireTransfers = [];
                            var search = [];
                            var searchFields = [];

                            if (p == null) {
                                p = vm.queryWireTransfers.page;
                            }
                            vm.queryWireTransfers.page = p;

                            if (s == null) {
                                s = parseInt(vm.wireTransfersListPag.per_page);
                            }

                            var pars = {
                                page: p,
                                s: s,
                                store_id: vm.store_id,
                                with: null
                            };

                            if (vm.queryWireTransfers.filter_date_start != null && vm.queryWireTransfers.filter_date_start != '') {
                                var date_start = moment(vm.queryWireTransfers.filter_date_start).format("YYYY-MM-DD 00:00:00");
                                pars.filter_date_start = date_start;
                            }

                            if (vm.queryWireTransfers.filter_date_end != null && vm.queryWireTransfers.filter_date_end != '') {
                                var date_end = moment(vm.queryWireTransfers.filter_date_end).format("YYYY-MM-DD 23:59:59");
                                pars.filter_date_end = date_end;
                            }

                            if (vm.queryWireTransfers.order != null && vm.queryWireTransfers.order != '') {
                                pars.orderBy = vm.queryWireTransfers.order.indexOf('-') == 0 ? vm.queryWireTransfers.order.substring(1) : vm.queryWireTransfers.order;
                                pars.sortedBy = vm.queryWireTransfers.order.indexOf('-') == 0 ? 'desc' : null;
                            }

                            //FILTER BY TYPE
                            if (vm.filtertype) {
                                searchFields.push("wire_transfers.type:=");
                                search.push("wire_transfers.type:" + vm.filtertype);
                            }

                            //FILTER ARCHIVE
                            if (vm.archive) {
                                pars.filter_archive = true;
                            }

                            //BIOSMED FILTER STORE
                            if (vm.storeId) {
                                searchFields.push("store_id:=");
                                search.push("store_id:" + vm.storeId);
                            }

                            pars.search = search.join(";");
                            pars.searchFields = searchFields.join(";");

                            CrudService.all(
                                'wire_transfers/index-cofidis',
                                pars,
                                vm,
                                function (response) {

                                    if (response.data && response.data.data) {
                                        vm.wireTransfersListPag = response.data.meta.pagination;

                                        angular.forEach(response.data.data, function (elem) {
                                            elem.value_date_frmt = moment(elem.value_date).format('DD/MM/YYYY');
                                            elem.transfer_date_frmt = moment(elem.transfer_date).format('DD/MM/YYYY');
                                        });

                                        vm.wireTransfers = response.data.data;
                                    }

                                    vm.loadingWireTransfers = false;

                                },
                                function (response) {
                                    vm.printErrorMessage(response);
                                    vm.loadingWireTransfers = false;
                                });

                        } else {

                            vm.showActionToast("Seleziona lo store per filtrare i cofidis!");

                        }

                    }

                    vm.deleteImport = function() {
                        $log.info('Elimina Importazione Cofidis');

                        var date_start = "";
                        var date_end = "";

                        if (vm.queryWireTransfers.filter_date_start != null && vm.queryWireTransfers.filter_date_start != '') {
                            var date_start = moment(vm.queryWireTransfers.filter_date_start);
                        }

                        if (vm.queryWireTransfers.filter_date_end != null && vm.queryWireTransfers.filter_date_end != '') {
                            var date_end = moment(vm.queryWireTransfers.filter_date_end);
                        }

                        var confirm = $mdDialog.confirm()
                            .title('Attenzione')
                            .ariaLabel('Attenzione')
                            .textContent(
                                'Sicuro di voler eliminare i cofidis' +
                                ' DAL: ' + ((date_start)? date_start.format("DD/MM/YYYY") : "-") +
                                ' AL: ' + ((date_end)? date_end.format("DD/MM/YYYY") : "-")
                            )
                            .ok('Si')
                            .cancel('Ops, ho sbagliato');

                        return $mdDialog
                            .show(confirm)
                            .then(
                                function () {
                                    vm.loadingWireTransfers = true;

                                    $http
                                        .post(
                                            vm.env.API + '/wire_transfers/delete-import',
                                            {
                                                type: 'cofidis',
                                                date_start: ((date_start)? date_start.format("YYYY-MM-DD 00:00:00") : ""),
                                                date_end: ((date_end)? date_end.format("YYYY-MM-DD 23:59:59") : "")
                                            }
                                        )
                                        .then(
                                            function (response) {
                                                vm.loadingWireTransfers = false;
                                                vm.loadCofidis();
                                            },
                                            function (response) {
                                                vm.loadingWireTransfers = false;
                                                vm.printErrorMessage(response);
                                            }
                                        );

                                }
                            ).finally(
                                function () {
                                    confirm = undefined;
                                }
                            );
                    };

                    vm.reorderWireTransfers = function (column) {
                        vm.queryWireTransfers.order = column;
                        vm.loadCofidis();
                    };

                    vm.printErrorMessage = function (response) {
                        var errMsg = "";
                        if (response.data != null
                            && response.data.message != null) {
                            errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                            var url = response.config != null && response.config.url != null ? response.config.url : "";
                            if (url != null) {
                                errMsg += "\nUrl: " + url;
                            }
                        }

                        vm.showActionToast("Si è verificato un errore " + errMsg);
                    };

                    vm.showActionToast = function (text) {
                        text = text && angular.isDefined(text) ? text : 'Tutto Ok!';
                        var toast = $mdToast.simple()
                            .textContent(text)
                            .action('')
                            .highlightAction(true)
                            .position('bottom right');
                        return $mdToast
                            .show(toast)
                            .finally(
                                function () {
                                    toast = undefined;
                                }
                            );
                    };


                    this.$onInit = function () {

                        vm.archive = this.archive;
                        vm.filtertype = this.filtertype;

                        //ON ARCHIEVE REMOVE FILTER MIN DATE
                        if (vm.archive) {
                            vm.minDateFilter = null;
                        }

                        vm.loadCofidis();

                    };


                    $scope.$on("bl-wire-transfers-cofidis-loadWireTransfers", function (event) {
                        vm.loadCofidis();
                    });


                    /* WATCHO Lo Store */
                    $scope.$watch('$parent.selectedStore', function (id) {
                        if (angular.isDefined(id)) {
                            vm.storeId = id;
                            vm.loadCofidis();
                        };
                    });

                }]
        }
    }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("blWireTransfers", blWireTransfers);
    function blWireTransfers() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bl-wire-transfers/bl-wire-transfers.html",
            bindToController: {
                filtertype: "=",
                archive: "=",
                token: "="
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                "$log",
                "$mdDialog",
                "$mdMedia",
                "$mdToast",
                "$rootScope",
                "$scope",
                "$window",
                "CrudService",
                "env",
                "UsersService",
                function (
                    $log,
                    $mdDialog,
                    $mdMedia,
                    $mdToast,
                    $rootScope,
                    $scope,
                    $window,
                    CrudService,
                    env,
                    UsersService
                ) {

                    var vm = this;
                    vm.env = env;
                    vm.mdDialog = $mdDialog;
                    vm.mdToast = $mdToast;
                    $log.info('blAppointmentsWireTransfers');

                    /* Operatore connesso */
                    if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
                        return;
                    }

                    vm.today = new Date(moment().hour(8).minute(0).second(0));
                    vm.minDateFilter = new Date(2022, 1, 1);

                    vm.options = {
                        autoSelect: false,
                        boundaryLinks: true,
                        pageSelector: true,
                        rowSelection: false
                    };

                    vm.wireTransfersListPag = {
                        "total": 0,
                        "count": 10,
                        "per_page": 50,
                        "current_page": 1,
                        "total_pages": 0,
                        "links": {}
                    };

                    vm.queryWireTransfers = {
                        filter: '',
                        filter_date_start: vm.today,
                        filter_date_end: null,
                        order: '-transfer_date',
                        limitOptions: [ 50, 75, 100 ],
                        page: 1
                    };

                    vm.onKeyPressSearchWireTransfer = function (event) {
                        if (event.keyCode == 13) {
                            vm.loadWireTransfers();
                            event.stopPropagation();
                            event.preventDefault();
                        }
                    };

                    vm.onChangeDateStartWireTransfer = function () {
                        vm.queryWireTransfers.page = 1;
                        vm.queryWireTransfers.order = 'transfer_date';
                        if (vm.queryWireTransfers.filter_date_start && vm.queryWireTransfers.filter_date_end) {
                            if (moment(vm.queryWireTransfers.filter_date_end).hour(23).minute(59).second(59).isBefore(vm.queryWireTransfers.filter_date_start)) {
                                vm.queryWireTransfers.filter_date_end = null;
                            }
                        }

                        vm.loadWireTransfers();
                    }

                    vm.onChangeDateEndWireTransfer = function () {
                        vm.queryWireTransfers.page = 1;
                        vm.queryWireTransfers.order = 'transfer_date';
                        if (vm.queryWireTransfers.filter_date_start && vm.queryWireTransfers.filter_date_end) {
                            if (moment(vm.queryWireTransfers.filter_date_end).hour(23).minute(59).second(59).isBefore(vm.queryWireTransfers.filter_date_start)) {
                                vm.queryWireTransfers.filter_date_start = vm.queryWireTransfers.filter_date_end;
                            }
                        }

                        vm.loadWireTransfers();
                    }               

                    vm.loadWireTransfers = function (p, s, exp) {

                        var search = [];
                        var searchFields = [];

                        if (p == null) {
                            p = vm.queryWireTransfers.page;
                        }
                        vm.queryWireTransfers.page = p;

                        if (s == null) {
                            s = parseInt(vm.wireTransfersListPag.per_page);
                        }

                        var pars = {
                            page: p,
                            s: s,
                            store_id: vm.store_id,
                            with: 'appointmentWireTransfers.appointment.treatment'
                        };

                        if (vm.queryWireTransfers.filter_date_start != null && vm.queryWireTransfers.filter_date_start != '') {
                            var date_start = moment(vm.queryWireTransfers.filter_date_start).format("YYYY-MM-DD 00:00:00");
                            pars.filter_date_start = date_start;
                        }

                        if (vm.queryWireTransfers.filter_date_end != null && vm.queryWireTransfers.filter_date_end != '') {
                            var date_end = moment(vm.queryWireTransfers.filter_date_end).format("YYYY-MM-DD 23:59:59");
                            pars.filter_date_end = date_end;
                        }

                        if (vm.queryWireTransfers.filter != null && vm.queryWireTransfers.filter != '') {
                            pars.filtro = vm.queryWireTransfers.filter;
                        }

                        if (vm.queryWireTransfers.order != null && vm.queryWireTransfers.order != '') {
                            pars.orderBy = vm.queryWireTransfers.order.indexOf('-') == 0 ? vm.queryWireTransfers.order.substring(1) : vm.queryWireTransfers.order;
                            pars.sortedBy = vm.queryWireTransfers.order.indexOf('-') == 0 ? 'desc' : 'asc';
                        }

                        //FILTER BY TYPE
                        if(vm.filtertype){
                            searchFields.push("wire_transfers.type:=");
                            search.push("wire_transfers.type:" + vm.filtertype);
                        }

                        //FILTER ARCHIVE
                        if(vm.archive){
                            pars.filter_archive = true;
                        }

                        //BIOSMED FILTER STORE: BIOLASER DIVIDED BY AREA, BIOSMED BY STORE
                        //BIOLASER FILTER STORE ON ARCHIEVE
                        if (
                            (vm.env.company == 'Biosmed' || vm.archive ) && 
                            vm.storeId
                        ) {
                            pars.filter_store_id = vm.storeId;
                        }

                        pars.search = search.join(";");
                        pars.searchFields = searchFields.join(";");


                        //LOAD ITEMS OR EXPORT
                        if(!exp) {

                            vm.loadingWireTransfers = true;

                            vm.wireTransfers = [];
                        
                            CrudService.all(
                                'wire_transfers',
                                pars,
                                vm,
                                function (response) {
    
                                    if (response.data && response.data.data) {
                                        vm.wireTransfersListPag = response.data.meta.pagination;
    
                                        angular.forEach(response.data.data, function (elem) {
                                            elem.value_date_frmt = moment(elem.value_date).format('DD/MM/YYYY');
                                            elem.transfer_date_frmt = moment(elem.transfer_date).format('DD/MM/YYYY');
    
                                            if (elem.appointment_wire_transfers) {
                                                angular.forEach(elem.appointment_wire_transfers, function (elem1) {
                                                    elem1.updated_at_frmt = moment(elem1.updated_at).format('DD/MM/YYYY HH:mm');
                                                    if (elem1.appointment) {
                                                        elem1.appointment.date_start_frmt = moment(elem1.appointment.date_start).format('DD/MM/YYYY HH:mm');
                                                    }
                                                });
                                            }
                                        });
    
                                        vm.wireTransfers = response.data.data;
                                    }
    
                                    vm.loadingWireTransfers = false;
    
                                },
                                function (response) {
                                    vm.printErrorMessage(response);
                                    vm.loadingWireTransfers = false;
                                });
                        
                        } else {

                            var append = "?token=" + vm.token + "&export=true";
                            angular.forEach(pars, function (v, k) {
                                append += "&" + k + "=" + window.encodeURIComponent(v);
                            });

                            $window.open( vm.env.API + "/wire_transfers/" + append, "_self");

                        }

                    }

                    vm.reorderWireTransfers = function (column) {
                        vm.queryWireTransfers.order = column;
                        vm.loadWireTransfers();
                    };

                    vm.deleteWireTransfer = function (wireTransfer) {
                        $log.info('Elimina Bonifico');

                        var confirm = $mdDialog.confirm()
                            .title('Attenzione')
                            .ariaLabel('Attenzione')
                            .textContent('Sicuro di voler eliminare questo bonifico?')
                            .ok('Si')
                            .cancel('Ops, ho sbagliato');

                        return $mdDialog
                            .show(confirm)
                            .then(
                                function () {
                                    vm.loadingWireTransfers = true;

                                    CrudService.del(
                                        'wire_transfers',
                                        wireTransfer.id,
                                        vm,
                                        function (response) {
                                            vm.loadingWireTransfers = false;

                                            //REMOVE ITEM FROM ARRAY
                                            if (
                                                response.status == 200 &&
                                                response.data &&
                                                response.data.deleted
                                            ) {
                                                vm.removeWireTransferFromlist(wireTransfer);
                                            }
                                        },
                                        function (response) {
                                            vm.loadingWireTransfers = false;
                                        }
                                    );

                                }
                            ).finally(
                                function () {
                                    confirm = undefined;
                                }
                            );
                    };

                    vm.deleteAppointmentWireTransfer = function (wireTransfer, appointmentWireTransfer) {
                        $log.info('Elimina Appuntamento Bonifico');

                        var confirm = $mdDialog.confirm()
                            .title('Attenzione')
                            .ariaLabel('Attenzione')
                            .textContent('Sicuro di voler eliminare questa associazione?')
                            .ok('Si')
                            .cancel('Ops, ho sbagliato');

                        return $mdDialog
                            .show(confirm)
                            .then(
                                function () {
                                    vm.loadingWireTransfers = true;

                                    CrudService.del(
                                        'appointments_wire_transfers',
                                        appointmentWireTransfer.id,
                                        vm,
                                        function (response) {
                                            vm.loadingWireTransfers = false;

                                            //REMOVE ITEM FROM ARRAY
                                            if (
                                                response.status == 200 &&
                                                response.data &&
                                                response.data.deleted
                                            ) {
                                                $rootScope.$broadcast("bl-appointments-wire-transfers-loadAppointments");
                                                $rootScope.$broadcast("bl-wire-transfers-loadWireTransfers");
                                            }
                                        },
                                        function (response) {
                                            vm.loadingWireTransfers = false;
                                        }
                                    );

                                }
                            ).finally(
                                function () {
                                    confirm = undefined;
                                }
                            );
                    };

                    vm.removeWireTransferFromlist = function (wireTransfer) {
                        var index = vm.wireTransfers.indexOf(wireTransfer);
                        vm.wireTransfers.splice(index, 1);
                    }

                    vm.printErrorMessage = function (response) {
                        var errMsg = "";
                        if (response.data != null
                            && response.data.message != null) {
                            errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                            var url = response.config != null && response.config.url != null ? response.config.url : "";
                            if (url != null) {
                                errMsg += "\nUrl: " + url;
                            }
                        }
            
                        vm.showActionToast("Si è verificato un errore " + errMsg);
                    };

                    vm.showActionToast = function(text) {
                        text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
                        var toast = $mdToast.simple()
                            .textContent(text)
                            .action('')
                            .highlightAction(true)
                            .position('bottom right');
                        return $mdToast
                            .show(toast)
                            .finally(
                                function() {
                                    toast = undefined;
                                }
                            );
                    };            


                    //-----------DIALOGS--------------------------------------//
                    vm.showAssociatedAppointmentsModal = function (wireTransfer) {
                        var useFullScreen = $mdMedia('xs');
                        var confirm = $mdDialog.confirm({
                            title: 'Info',
                            ariaLabel: 'Info',
                            templateUrl: 'app/wire-transfer/dialogs/associated-appointments-dialog.html',
                            fullscreen: useFullScreen,
                            escapeToClose: false,
                            controller: [
                                '$scope',
                                '$mdDialog',
                                function ($scope, $mdDialog) {

                                    $scope.wireTransfer = wireTransfer;
                                    $scope.user = vm.user;

                                    $scope.deleteAppointmentWireTransfer = function(appointmentWireTransfer){
                                        vm.deleteAppointmentWireTransfer(wireTransfer, appointmentWireTransfer);
                                    }

                                    $scope.close = function () {
                                        $mdDialog.hide(true);
                                    };
                                }]
                        });
                        return $mdDialog
                            .show(confirm);
                    };

                    vm.showDetailsModal = function (wireTransfer) {

                        var useFullScreen = $mdMedia('xs');
                        var confirm = $mdDialog.confirm({
                            title: 'Info',
                            ariaLabel: 'Info',
                            templateUrl: 'app/wire-transfer/dialogs/details-dialog.html',
                            fullscreen: useFullScreen,
                            escapeToClose: false,
                            controller: [
                                '$scope',
                                '$mdDialog',
                                function ($scope, $mdDialog) {

                                    $scope.wireTransfer = wireTransfer;

                                    $scope.close = function () {
                                        $mdDialog.hide(true);
                                    };
                                }]
                        });
                        return $mdDialog
                            .show(confirm);
                    };


                    vm.showAssignAppointmentsModal = function (wireTransfer) {
                        var dialog = $mdDialog.confirm({
                            templateUrl: 'app/wire-transfer/dialogs/associate-appointments-dialog.html',
                            escapeToClose: true,
                            multiple: true,
                            controller: [
                                '$scope',
                                '$mdDialog',
                                function (
                                    $scope,
                                    $mdDialog
                                ) {

                                    $scope.wireTransfer = wireTransfer;
                                    $scope.storeId = vm.storeId;

                                    $scope.close = function () {
                                        $mdDialog.hide(true);
                                    };

                                }]
                        });

                        return $mdDialog
                            .show(dialog)
                            .finally(
                                function () {
                                    dialog = undefined;
                                }
                            );
                    };


                    this.$onInit = function () {

                        vm.archive = this.archive;
                        vm.filtertype = this.filtertype;
                        vm.token = this.token;

                        //ON ARCHIEVE REMOVE FILTER MIN DATE
                        if(vm.archive){
                            vm.minDateFilter = null;
                        }

                        vm.loadWireTransfers();

                    };


                    $scope.$on("bl-wire-transfers-loadWireTransfers", function (event) {
                        vm.loadWireTransfers();
                    });


                    /* WATCHO Lo Store */
                    $scope.$watch('$parent.selectedStore', function (id) {
                        if (angular.isDefined(id)) {
                            vm.storeId = id;
                            vm.loadWireTransfers();
                        };
                    });

                }]
        }
    }
})();

(function () {
    "use strict";
    angular.module("admin")
    .filter('unsafe', function($sce) {
        return function(val) {
            return $sce.trustAsHtml(val);
        };
    }).directive("blWhatsapp", blWhatsapp);
    function blWhatsapp() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bl-whatsapp/bl-whatsapp.html",
            bindToController: {
                customer: "=",
                user: "=",
                reset: "=",
                pusher: "="
            },
            scope: true,
            controllerAs: "whatsapp",
            controller: [
                "$filter",
                "$scope",
                "$mdDialog",
                "$mdToast",
                "$log",
                "$timeout",
                "$pusher",
                "env",
                "CrudService",
                function ($filter, $scope, $mdDialog, $mdToast, $log, $timeout, $pusher, env, CrudService) {
                    var vm = this;
                    vm.env = env;
                    vm.mdToast = $mdToast;
                    vm.mdDialog = $mdDialog;
                    vm.loadingMessagesList = true;
                    vm.userSelectedMessagesList = [];
                    vm.messageToSend = null;
                    vm.templateSelected = null;
                    vm.currentPage = 1;
                    vm.pusherInitOk = false;
                    vm.token = localStorage.getItem('Biolaser_token');

                    vm.attachmentIcons = {
                        "application/pdf": "<span class=\"material-icons\">picture_as_pdf</span>",
                        "application/octet-stream": "<span class=\"material-icons\">picture_as_pdf</span>",
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "<span class=\"material-icons\">description</span>",
                        "text/x-comma-separated-values": "<span class=\"material-icons\">view_module</span>",
                        "text/comma-separated-values": "<span class=\"material-icons\">view_module</span>",
                        "application/vnd.msexcel": "<span class=\"material-icons\">view_module</span>",
                        "application/excel": "<span class=\"material-icons\">view_module</span>",
                        "application/msexcel": "<span class=\"material-icons\">view_module</span>",
                        "application/x-msexcel": "<span class=\"material-icons\">view_module</span>",
                        "application/x-ms-excel": "<span class=\"material-icons\">view_module</span>",
                        "application/x-excel": "<span class=\"material-icons\">view_module</span>",
                        "application/x-dos_ms_excel": "<span class=\"material-icons\">view_module</span>",
                        "application/xls": "<span class=\"material-icons\">view_module</span>",
                        "application/x-xls": "<span class=\"material-icons\">view_module</span>",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "<span class=\"material-icons\">view_module</span>",
                        "application/vnd.ms-excel": "<span class=\"material-icons\">view_module</span>",
                        "application/x-zip": "<span class=\"material-icons\">folder_zip</span>",
                        "application/zip": "<span class=\"material-icons\">folder_zip</span>",
                        "application/x-zip-compressed": "<span class=\"material-icons\">folder_zip</span>",
                        "application/s-compressed": "<span class=\"material-icons\">folder_zip</span>",
                        "multipart/x-zip": "<span class=\"material-icons\">folder_zip</span>",
                        "text/plain": "<span class=\"material-icons\">text_fields</span>",
                        "text/rtf": "<span class=\"material-icons\">text_fields</span>",
                        "video/mp4": "<span class=\"material-icons\">ondemand_video</span>",
                        "video/x-msvideo": "<span class=\"material-icons\">ondemand_video</span>",
                        "video/mpeg": "<span class=\"material-icons\">ondemand_video</span>",
                        "video/ogg": "<span class=\"material-icons\">ondemand_video</span>",
                        "video/webm": "<span class=\"material-icons\">ondemand_video</span>",
                    };

                    vm.changeMEssage = function() {
                    };

                    vm.handleKeyDown = function(e) {
                        //console.log(e);
                    }

                    vm.initPusher = function() {
                        if (vm.pusherInitOk || !$pusher) {
                            if (!$pusher) {
                                console.log('$pusher NULL');
                            }
                            return;
                        }
                        console.log('init pusher: ' + $pusher);

                        /**
                         * Enable pusher
                         */
                        // Enable pusher logging - don't include this in production
                        //Pusher.logToConsole = true;
                        var client = new Pusher(vm.env.pusher_key?vm.env.pusher_key:'a9119391f9a6c97a31a8', {
                            cluster: 'eu'
                        });
                        var pusher = $pusher(client);

                        vm.channel = pusher.subscribe(vm.env.currentTenant+'-waMessage-channel');

                        vm.channel.bind('waMessage-event', function(data) {
                            vm.onWAMessageRecived(data);
                        });

                        vm.channel.bind('waNotify-event', function(data) {
                            vm.onWaNotify(data);
                        });
                        vm.pusherInitOk = true;
                        $scope.$on("$destroy", function() {
                            console.log('unbind bl-wa pusher channel');
                            vm.channel.unbind();
                        });
                    }
                    /**
                     * alla ricezione del messaggio wapp:
                     * se ho il customer nell'elenco dei customer lo metto in cima alla lista
                     * se non c'è lo aggiungo in cima all'array
                     * in ogni caso visualizzo il toast con il nome di chi l'ha inviato e il messaggio
                     * @param {*} data
                     */
                    vm.onWAMessageRecived = function( data ) {
                        $log.info("onWAMessageRecived");
                        //$log.info(data);
                        if(data && data.customer && vm.customer && (vm.customer.id && data.customer.id == vm.customer.id || vm.customer.customer_id && data.customer.id == vm.customer.customer_id)) {
                            //devo appendere l'ultimo messaggio e posizionarmi sull'ultimo
                            vm.userSelectedMessagesList = [];
                            vm.currentPage = 1;
                            vm.pagination = null;
                            vm.getCustomerMessages();
                            vm.showActionToast(data.customer.firstname + ': ' +  data.message);
                        }
                    };

                    /**
                     * quando i messaggi vengono letti azzera gli eventuali sospesi della lista
                     * @param {*} data
                     */
                    vm.onWaNotify = function(data) {
                        $log.info("onWaNotify bl-wa");
                        //$log.info(data);
                        if(data && data.user.id!=vm.user.id && data.customer && vm.customer && (vm.customer.id && data.customer.id == vm.customer.id || vm.customer.customer_id && data.customer.id == vm.customer.customer_id)) {
                            vm.userSelectedMessagesList = [];
                            vm.currentPage = 1;
                            vm.pagination = null;
                            vm.getCustomerMessages();
                        }
                    };

                    vm.takeView = function() {
                        vm.userSelectedMessagesList = [];
                        vm.currentPage = 1;
                        vm.pagination = null;
                        vm.getCustomerMessages(true, false);
                    };

                    vm.unTakeView = function() {
                        vm.userSelectedMessagesList = [];
                        vm.currentPage = 1;
                        vm.pagination = null;
                        vm.getCustomerMessages(false,true);
                    };

                    vm.getCustomerMessages = function (takeView, unTakeView) {
                        vm.initPusher();
                        var pars = {
                            'search': 'customer_id:' + (vm.customer.id?vm.customer.id:vm.customer.customer_id),
                            'searchFields': 'customer_id:=',
                            'orderBy': 'id',
                            'sortedBy': 'desc',
                            'page': vm.currentPage,
                            'with': 'user',
                            'reset_unreaded' : takeView?takeView:false,
                            'unreset_unreaded' : unTakeView?unTakeView:false,
                            'customer_id': vm.customer.id,
                            'c_role': vm.user.type
                        };
                        vm.loadingMessagesList = true;
                        vm.scrollToId = null;
                        CrudService.all('customer_messages', pars, vm,
                            function (response) {
                                if(response && response.data && response.data.data){
                                    vm.pagination = response.data.data;
                                    var tmpArray = response.data.data.data.reverse();

                                    if(tmpArray.length >0) {
                                        vm.scrollToId = tmpArray[tmpArray.length-1];
                                        if (!vm.lastMessage) {
                                            var l = tmpArray.length-1;
                                            for(var i=l; i>=0; i--) {
                                                if (!tmpArray[i].f_sent) {
                                                    vm.lastMessage = tmpArray[i];
                                                    vm.lastMessage.created_at_frmt = moment(vm.lastMessage.created_at).format('DD/MM/YYYY HH:mm:ss');
                                                    vm.setIsLastUserMessageInH24();
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                    angular.forEach(tmpArray, function (element) {
                                        if(element.created_at != null){
                                            element.created_at_formatted = vm.formatDate(element.created_at);
                                        }
                                        element.media_url = "";
                                        element.media_icon;
                                        element.video_content = "";
                                        if(element.ext_type == "voice" || element.ext_type == "image" || element.ext_type == "video" || element.ext_type == "attachment" || element.ext_type == "audio") {

                                            if(element.ext_type == "audio" && element.f_sent) {
                                                /**
                                                 * Se ho invio da gestionale metto ho il base64 dell'audio nel campo message
                                                 */
                                                element.media_url = vm.env.API+"/customer_messages/wa_media/"+element.id+"/"+element.ext_sha256;
                                            } else {
                                                element.media_url = vm.env.API+"/customer_messages/messages/"+element.id+"/media?token="+vm.token;
                                            }


                                            element.media_icon = vm.attachmentIcons[element.ext_mime_type] != undefined ? vm.attachmentIcons[element.ext_mime_type] : "<span class='material-icons'>attach_file</span>";

                                            if(element.ext_type == "video") {
                                                CrudService.all("customer_messages/messages/"+element.id+"/media?token="+vm.token, {}, vm,
                                                    function(media_response) {
                                                        if(media_response.data) {
                                                            element.video_content = media_response.data;
                                                        }
                                                    },
                                                    function(media_response) {
                                                        var errMsg = "";
                                                        if (media_response.data != null
                                                            && media_response.data.message != null) {
                                                            errMsg = media_response.data != null && media_response.data.message != null ? media_response.data.message + "." : ".";
                                                            var url = media_response.config != null && media_response.config.url != null ? media_response.config.url : "";
                                                            if (url != null) {
                                                                errMsg += "\nUrl: " + url;
                                                            }
                                                        }
                                                        alert("Si è verificato un errore nel caricamento di un video: " + errMsg);

                                                    }
                                                );
                                            }

                                        }

                                    });

                                    if(vm.userSelectedMessagesList.length == 0) {
                                        vm.userSelectedMessagesList = tmpArray;
                                    } else {
                                        vm.userSelectedMessagesList = tmpArray.concat(vm.userSelectedMessagesList);
                                    }
                                }
                                vm.loadingMessagesList = false;
                            },
                            function (response) {
                                var errMsg = "";
                                if (response.data != null
                                    && response.data.message != null) {
                                    errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                                    var url = response.config != null && response.config.url != null ? response.config.url : "";
                                    if (url != null) {
                                        errMsg += "\nUrl: " + url;
                                    }
                                }
                                alert("Si è verificato un errore nel caricamento dei messaggi: " + errMsg);
                                vm.loadingMessagesList = false;
                            });
                    }
                    vm.sending = false;
                    vm.sendMessage = function(template) {
                        vm.sending = true;
                        vm.messageToSend = vm.messageToSend?vm.messageToSend.trim():'';
                        var prefix = "";
                        var templ = vm.templateSelected?vm.templateSelected.name:null;
                        if (template && vm.templateSelected && vm.templateSelected.document_template_id) {
                            prefix = vm.templateSelected.blade + "\n";
                            templ = vm.templateSelected.document_template.name;
                        }
                        var message = {
                            'customer_id':  (vm.customer.id?vm.customer.id:vm.customer.customer_id),
                            'message': prefix+vm.messageToSend,
                            'phone': vm.customer.phone
                        }
                        if (template) {
                            if  (vm.templateSelected) {
                                message.template = templ;
                                message.url_image = vm.templateSelected.url_image;
                            } else {
                                vm.showActionToast("Selezionare il template!");
                                vm.sending = false;
                                return;
                            }
                        } else {
                            if(vm.messageToSend=='') {
                                vm.showActionToast("Inserire il testo del messaggio!");
                                return;
                            }
                        }
                        $log.info('Salva');
                        CrudService
                            .save( 'customer_messages', message, vm ,
                                function(response) {
                                    if (response.data && response.data.data) {
                                        var messageTmp = response.data.data;
                                        if (messageTmp) {
                                            messageTmp.user = vm.user;
                                            messageTmp.created_at_formatted = vm.formatDate(messageTmp.created_at);
                                            vm.userSelectedMessagesList.push(messageTmp);
                                            vm.scrollToId = messageTmp;
                                            vm.messageToSend = '';
                                            vm.templateSelected = null;
                                        } else {
                                            vm.showActionToast(response.message?response.message:response.data.message);
                                        }
                                    }
                                    if (response.data && response.data.error) {
                                        vm.showActionToast(response.data.error);
                                    }
                                    vm.sending = false;
                                },
                                function(response) {
                                    vm.sending = false;
                                    vm.showActionToast(response.data.message?response.data.message:response.data.error);
                                    //$log.info(response);
                                }
                        );

                    };

                    vm.recording = false;
                    vm.sendAudio = function() {

                        vm.recording = !vm.recording;

                        //console.log(vm.recording?"Inizio a registrare audio":"Stoppo l'audio");

                        var playButton = document.getElementById('user_audio_play');
                        var stopButton = document.getElementById('user_audio_stop');
                        var cancelButton = document.getElementById('user_audio_cancel');
                        var downloadButton = document.getElementById('user_audio_download');
                        var reader;
                        var base64Audio;
                        var cancel_action = false;
                        var recordedChunks = [];


                        var handleSuccess = function(stream) {
                            var options = {mimeType: 'audio/webm;codecs=opus'};
                            var mediaRecorder = new MediaRecorder(stream, options);

                            mediaRecorder.addEventListener('dataavailable', function(e) {
                                /*
                                console.log("Dati audio disponibili");
                                console.log(e.data);
                                */
                                if (e.data.size > 0 && !cancel_action) {
                                    recordedChunks.push(e.data)
                                } else {
                                    console.log("Cancello:"+(cancel_action?"SI":"NO"));
                                    recordedChunks = [];
                                }

                            });

                            mediaRecorder.addEventListener('stop', function() {

                                //console.log("Cancello:"+(cancel_action?"SI":"NO"));
                                if(cancel_action) {
                                    recordedChunks = [];
                                    return;
                                }


                                var recorded = new Blob(recordedChunks);

                                var reader = new FileReader();
                                reader.readAsDataURL(recorded);
                                reader.onloadend = function() {

                                    base64Audio = reader.result.split(";base64,")[1];
                                    //console.log("base64Audio"); console.log(base64Audio);
                                    // Invio Messaggio audio
                                    var message = {
                                        'customer_id':  (vm.customer.id?vm.customer.id:vm.customer.customer_id),
                                        'message': base64Audio,
                                        'phone': vm.customer.phone,
                                        'type': 'audio',
                                        'mime_type': 'audio/mpeg'
                                    }

                                    CrudService
                                        .save( 'customer_messages', message, vm ,
                                            function(response) {
                                                if (response.data) {
                                                var messageTmp = response.data;
                                                    if (messageTmp) {
                                                        messageTmp.user = vm.user;
                                                        messageTmp.created_at_formatted = vm.formatDate(messageTmp.created_at);
                                                        /*
                                                        console.log("Lista prima del push");
                                                        console.log(vm.userSelectedMessagesList);
                                                        */
                                                        var audio_message = vm.getAudioMessage(messageTmp);
                                                        //console.log("Audio message"); console.log(audio_message);
                                                        vm.userSelectedMessagesList.push(audio_message);
                                                        vm.scrollToId = messageTmp;
                                                        vm.messageToSend = '';
                                                        vm.templateSelected = null;
                                                    } else {
                                                        vm.showActionToast(response.message?response.message:response.data.message);
                                                    }

                                                }
                                                if (response.data && response.data.error) {
                                                    vm.showActionToast(response.data.error);
                                                }
                                                vm.sending = false;
                                                recordedChunks = [];

                                            },
                                            function(response) {
                                                //vm.cancelAudio();
                                                vm.sending = false;
                                                vm.showActionToast(response.data.message?response.data.message:response.data.error);
                                                //$log.info(response);
                                            }
                                    );


                                }
                            });

                            stopButton.addEventListener('click', function() {
                                vm.recording = false;
                                mediaRecorder.stop();
                                vm.stopStream(mediaRecorder.stream);
                            });

                            cancelButton.addEventListener('click', function() {
                                cancel_action = true;
                                recordedChunks = [];
                                mediaRecorder.stop();
                            });

                            mediaRecorder.start();

                          };

                          navigator.mediaDevices.getUserMedia({ audio: true, video: false })
                            .then(handleSuccess);

                    }

                    vm.cancelAudio = function() {
                        vm.recording = false;
                        var handleSuccess = function(stream) {
                            var options = {mimeType: 'audio/webm'};
                            var mediaRecorder = new MediaRecorder(stream, options);
                            vm.stopStream(mediaRecorder.stream);
                        }
                        navigator.mediaDevices.getUserMedia({ audio: true, video: false })
                            .then(handleSuccess);
                    }

                    vm.getAudioMessage = function(message) {
                        message.media_url = vm.env.API+"/customer_messages/wa_media/"+message.id+"/"+message.ext_sha256;
                        message.media_icon = vm.attachmentIcons[message.ext_mime_type] != undefined ? vm.attachmentIcons[message.ext_mime_type] : "<span class='material-icons'>attach_file</span>";
                        return message;
                    }

                    vm.stopStream = function(stream) {
                        /*
                        console.log("Stream trovato"); console.log(stream);
                        stream.getTracks().forEach( track => track.stop() );
                        */
                       /*
                        stream.getTracks().forEach(function(track) {
                            track.stop();
                        });
                        */
                    }

                    vm.scrollInizialized = false;

                    /**
                     * alla fine del caricamento della renderizzazione dell'elenco dei messaggi:
                     * 1) scrollo il div che li contiene all'ultimo arrivato/inviato(quindi verso il basso)
                     * 2) controllo lo scroll del div e quando arrivo al più recente(quindi in alto) carico altri messaggi
                     * se ce ne sono ancora(lo controllo dalla paginazione)
                     * @param {*} message
                     */
                    vm.finishedLoadMessages = function (message) {
                            $timeout(function() {
                                if( vm.scrollToId != null) {
                                    var selettoreLast = "#message-"+ vm.scrollToId.id;
                                    var rowLast = $(selettoreLast);
                                    var wappMessagesContainer = $('.whatsapp-messages-container');
                                    if (rowLast != null) {
                                        var top = null;
                                        top = rowLast.get(0).offsetTop;
                                        wappMessagesContainer.animate({ scrollTop: top }, 10);
                                    }

                                    if(!vm.scrollInizialized){
                                        wappMessagesContainer.scroll(function() {
                                            if( this.scrollTop == 0  && !vm.loadingMessagesList)  {
                                                if(vm.pagination && vm.pagination.last_page > vm.currentPage) {
                                                    vm.currentPage ++;
                                                    vm.getCustomerMessages();
                                                }
                                            }
                                        });
                                        vm.scrollInizialized = true;
                                    }
                                }

                            }, 100);
                    }

                    vm.formatDate = function (dataDaFormattare) {
                        var dt = moment(dataDaFormattare);
                        if (moment().format('YYYY-MM-DD') == dt.format(('YYYY-MM-DD'))) {
                            return dt.format('H:mm:ss');
                        } else {
                            return dt.format('DD/MM/YYYY H:mm');
                        }
                    }

                    /**
                     * visualizzi il toast
                     * @param {*} text
                     */
                    vm.showActionToast = function( text) {
                        text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
                        var toast = $mdToast.simple()
                            .textContent(text)
                            .action('')
                            .highlightAction(true)
                            .position('bottom right');
                        return $mdToast
                            .show(toast)
                            .finally(
                                function() {
                                    toast = undefined;
                                }
                            );
                    };

                    vm.onTemplateSelezionato = function() {
                        vm.messageToSend = vm.templateSelected.blade;
                    }
                    vm.lastMessage = null;
                    vm.isLastUserMessageInH24 = vm.env.whatsapp && !vm.env.whatsapp.check24?true:false;
                    vm.setIsLastUserMessageInH24 = function() {
                        if (vm.env.whatsapp && !vm.env.whatsapp.check24) {
                            vm.isLastUserMessageInH24 = true;
                        } else {
                            if (vm.lastMessage) {
                                var customerLastMessageTimeStamp = moment(vm.lastMessage.created_at).valueOf();
                                var yesterdayTimeStamp = moment().subtract(1, 'days').valueOf();
                                vm.isLastUserMessageInH24 = customerLastMessageTimeStamp > yesterdayTimeStamp;
                            } else {
                                vm.isLastUserMessageInH24 = false;
                            }
                        }
                    }

                    vm.waTemplatesList =[];
                    vm.getWaTemplates = function() {
                        vm.waTemplatesList =[];

                        var pars = {
                            'f_hidden': 0
                        }

                        CrudService.all('document_templates', pars, vm,
                            function (response) {
                                if(response && response.data && response.data.data){
                                    vm.waTemplatesList = response.data.data;
                                }
                            },
                            function (response) {
                                var errMsg = "";
                                if (response.data != null
                                    && response.data.message != null) {
                                    errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                                    var url = response.config != null && response.config.url != null ? response.config.url : "";
                                    if (url != null) {
                                        errMsg += "\nUrl: " + url;
                                    }
                                }
                                alert("Si è verificato un errore nel caricamento dei template: " + errMsg);
                            });
                    }

                    vm.getWaTemplates();

                    $scope.$watch('$parent.customerSelected', function() {
                    /*    alert("parent->customer.phone");
                        $log.info(newVal);
                        $log.info(oldVal);
                        if (vm.customer) {
                            vm.getCustomerMessages();
                        }
                    */
                    });
                    $scope.$watch('customer.phone', function() {
                    /*
                        alert("customer.phone");
                        $log.info(newVal);
                        $log.info(oldVal);
                        if (vm.customer) {
                            vm.getCustomerMessages();
                        }
                    */
                    });
                    $scope.$watch('whatsapp.customer.phone', function(newVal, oldVal) {
                        //alert("whatsapp.customer.phone");
                        $log.info(newVal);
                        $log.info(oldVal);
                        if (vm.customer) {
                            vm.userSelectedMessagesList = [];
                            vm.messageToSend = null;
                            vm.templateSelected = null;
                            vm.currentPage = 1;
                            vm.pagination = null;
                            vm.lastMessage = null;
                            vm.getCustomerMessages();
                        }
                    });
                    $scope.$on("someEvent",function(){
                        //alert(vm.customer.phone);
                    });
                    $scope.$watch('whatsapp.templateSelected', function() {
                        if (vm.templateSelected) {
                            var bladeText = vm.templateSelected.blade;
                            var childText = "";
                            if (vm.templateSelected.document_template_id) {
                                bladeText = vm.templateSelected.document_template.blade;
                                childText  = vm.templateSelected.blade;
                            }
                            var iNote = bladeText.indexOf("{{2}}");
                            vm.templateSelected.blade_header = "";
                            if (iNote>=0) {
                                vm.templateSelected.blade_header = bladeText.substring(0,iNote) + childText;
                                vm.templateSelected.blade_footer = bladeText.substring(iNote+5);
                            } else {
                                vm.templateSelected.blade_footer = bladeText;
                            }
                            vm.templateSelected.blade_footer = vm.replateTemplateVariables(vm.templateSelected.blade_footer, vm.templateSelected.f_html);
                            vm.templateSelected.blade_header = vm.replateTemplateVariables(vm.templateSelected.blade_header, vm.templateSelected.f_html);
                        }
                    });

                    vm.replateTemplateVariables = function(s, isHtml) {
                        s = s.replace('*{{1}}*', '<b>' + (vm.customer.firstname?vm.customer.firstname:'Cliente') +'</b>');
                        s = s.replace('{{1}}', '<b>' + (vm.customer.firstname?vm.customer.firstname:'Cliente') +'</b>');
                        s = s.replace('{{3}}', vm.user.firstname);
                        s = s.replace('{{4}}', vm.user.store_id?"Numero del centro":vm.user.phone);
                        if (!isHtml || isHtml=='0') {
                            s = s.replaceAll('\r', '');
                            s = s.replaceAll('\n', '<br/>');
                        }
                        return s;
                    }
                },
            ],
        };
    }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("blPfInfo", blPfInfo);
    function blPfInfo() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bl-pf-info/bl-pf-info.html",
            bindToController: {
                customer: "=",
                loading: "="
            },
            scope: true,
            controllerAs: "ap",
            controller: [
                '$scope',
                '$log',
                '$rootScope',
                function (
                    $scope,
                    $log,
                    $rootScope
                ) {

                    var vm = this;
                    $log.info('blPfInfo');

                }]
        }
    }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("blCustomerCallsModal", blCustomerCallsModal);
    function blCustomerCallsModal() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bl-customer-calls-modal/bl-customer-calls-modal.html",
            bindToController: {
                customerid: "=",
                user: "=",
                token: "="
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                "$log",
                "$mdDialog",
                function (
                    $log,
                    $mdDialog
                ) {

                    var vm = this;
                    $log.info('blCustomerCallsModal');

                    vm.openModal = function() {
                        var dialog = $mdDialog.confirm({
                            title: 'Info acquisto prodotto ',
                            ariaLabel: 'Info carico',
                            templateUrl: 'app/components/bl-customer-calls-modal/dialogs/dialog.html',
                            escapeToClose: true,
                            controller: [ 
                                '$scope', 
                                '$mdDialog', 
                                function( 
                                    $scope, 
                                    $mdDialog 
                                ) {

                                    $scope.customer_id = vm.customer_id;

                                    $scope.close = function() {
                                        $mdDialog.hide( true );
                                    };

                            }]
                        });

                        return $mdDialog
                            .show( dialog )
                            .finally(
                                function() {
                                    dialog = undefined;
                                }
                            );
                    }

                    this.$onInit = function () {

                        vm.customer_id = this.customerid;

                    };

                }]
        }
    }
})();
   
(function () {
    "use strict";
    angular
        .module("admin")
        .directive("blCustomerCallsList", blCustomerCallsList);
    function blCustomerCallsList() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bl-customer-calls-list/bl-customer-calls-list.html",
            bindToController: {
                customer: "=",
                customerid: "=",
                user: "=",
                token: "="
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                "$log",
                "$scope",
                "CrudService",
                "env",
                function (
                    $log,
                    $scope,
                    CrudService,
                    env
                ) {

                    var vm = this;
                    vm.env = env;

                    $log.info('blCustomerCallsList');

                    vm.query = {
                        filter: '',
                        order: '-date_start',
                        limit: 10,
                        page: 1
                    };

                    vm.defaultListPagination = function () {
                        vm.listPagination = {
                            "total": 0,
                            "count": 0,
                            "per_page": 50,
                            "current_page": 1,
                            "total_pages": 0,
                            "links": {}
                        };
                    }
                    vm.defaultListPagination();


                    vm.loadItems = function (p, s) {

                        vm.customerCalls = [];
                        vm.loading = true;

                        if (p == null) {
                            p = 1;
                        }
                        if (s == null) {
                            s = parseInt(vm.listPagination.per_page);
                        }

                        var pars = {};
                        var search = [];
                        var searchFields = [];

                        //IF ISSET CUSTOMER FILTER BY CUSTOMER
                        if (vm.customer_id) {
                            searchFields.push("customer_id:=");
                            search.push("customer_id:" + vm.customer_id);
                        }

                        pars.search = search.join(";");
                        pars.searchFields = searchFields.join(";");

                        pars.page = p;
                        pars.s = s;
                        pars.with = "customer;user";

                        if (vm.query.filter!=null && vm.query.filter!='') {
                            pars.filtro=vm.query.filter.trim();
                        }

                        if (vm.query.order!=null && vm.query.order!='') {
                            pars.orderBy = vm.query.order.indexOf('-')==0?vm.query.order.substring(1):vm.query.order;
                            pars.sortedBy = vm.query.order.indexOf('-')==0?'desc':null;
                        }

                        CrudService.all(
                            "customer_calls",
                            pars,
                            vm,
                            function (response) {

                                vm.listPagination = response.data.meta.pagination;

                                if (response.data &&
                                    response.data.data &&
                                    response.data.data.length > 0
                                ) {

                                    angular.forEach( response.data.data, function( call ) {
                                        call.date_fmt = moment(call.date_start).format('DD/MM/YYYY HH:mm:ss');
                                    });

                                    vm.customerCalls = response.data.data;

                                }

                                vm.loading = false;

                            },
                            function (response) {

                                vm.loading = false;
                            }
                        );
                    };


                    vm.onKeyPressSearch = function (event) {
                        if (!event || event.keyCode==13) {
                            vm.loadItems(1);
                            if (event) {
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        }
                    }


                    vm.removeSearch = function() {
                        vm.query.filter = '';
                        vm.query.order = '-date_start';
                        vm.query.off = 0;
                        vm.query.page = 1;
                        vm.loadItems(1);
                    };


                    vm.eListReOrder = function (column) {
                        vm.query.order = column;
                        vm.loadItems(1);
                    };


                    this.$onInit = function () {

                        vm.customer = this.customer;
                        vm.customer_id = this.customerid;
                        vm.user = this.user;
                        vm.token = this.token;

                        vm.loadItems();

                    };

                }]
        }
    }
})();

(function () {
    "use strict";
    angular.module("admin").directive("blBtnLeadHistory", blBtnLeadHistory);
    function blBtnLeadHistory() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bl-btn-lead-history/bl-btn-lead-history.html",
            bindToController: {
                entity: "=",
                user: "="
            },
            scope: true,
            controllerAs: "vm",
            controller: [
                "$filter",
                "$scope",
                "$mdDialog",
                "CrudService",
                function ($filter, $scope, $mdDialog, CrudService) {
                    var vm = this;
                    vm.showHistory = function (a) {
                        if (!a) {
                            a = vm.entity;
                        }
                        if (!a.customer.data) {
                            a.customer.data = a.customer;
                        }

                        var dialog = $mdDialog.confirm({
                            title:
                                "Storico Modifiche: " +
                                a.campagna +
                                " di " +
                                (a.customer.data.firstname != null
                                    ? a.customer.data.firstname.toUpperCase()
                                    : "") +
                                " " +
                                (a.customer.data.lastname != null
                                    ? a.customer.data.lastname.toUpperCase()
                                    : "") +
                                " del " +
                                a.created_at_frm +
                                " (lid=" +
                                a.id +
                                ")",
                            ariaLabel: "Storia Modifiche Lead",
                            templateUrl: "app/components/dialogs/entity-history.html",
                            escapeToClose: true,
                            controller: [
                                "$scope",
                                "$mdDialog",
                                "$filter",
                                function ($scope, $mdDialog, $filter) {
                                    $scope.title = this.title;
                                    $scope.button_ok = "Chiudi";
                                    $scope.user = vm.user;
                                    $scope.leadevents = [];
                                    $scope.activities = [];
                                    $scope.loadingAct = false;
                                    $scope.loading = true;
                                    $scope.entity = a;
                                    $scope.loadActivities = function () {
                                        var pars = {
                                            log_name: "default",
                                            subject_type: "App\\Entities\\Lead",
                                            subject_id: a.id,
                                            with: "causer;subject",
                                        };
                                        $scope.loadingAct = true;
                                        $scope.activities = [];
                                        CrudService.all(
                                            "activity_log",
                                            pars,
                                            vm,
                                            function (response) {
                                                angular.forEach(
                                                    response.data.data,
                                                    function (act) {
                                                        act.created_at_frmt = moment(
                                                            act.created_at
                                                        ).format(
                                                            "DD/MM/YYYY HH:mm:ss"
                                                        );
                                                        $scope.activities.push(
                                                            act
                                                        );
                                                    }
                                                );
                                                $scope.loadingAct = false;
                                            },
                                            function (response) {
                                                var errMsg = "";
                                                if (
                                                    response.data != null &&
                                                    response.data.message !=
                                                        null
                                                ) {
                                                    errMsg =
                                                        response.data != null &&
                                                        response.data.message !=
                                                            null
                                                            ? response.data
                                                                  .message + "."
                                                            : ".";
                                                    var url =
                                                        response.config !=
                                                            null &&
                                                        response.config.url !=
                                                            null
                                                            ? response.config
                                                                  .url
                                                            : "";
                                                    if (url != null) {
                                                        errMsg +=
                                                            "\nUrl: " + url;
                                                    }
                                                }
                                                alert(
                                                    "Si è verificato un errore nel caricamento delle attività: " +
                                                        errMsg
                                                );
                                                $scope.loadingAct = false;
                                            }
                                        );
                                    };
                                    $scope.loadLeadEvents = function () {
                                        var pars = {
                                            search: "lead_idt:" + a.uid,
                                            searchFields: "lead_idt:=",
                                            orderBy: "created_at",
                                            sortedBy: "asc",
                                            with: "user",
                                        };
                                        $scope.loading = true;
                                        $scope.leadevents = [];
                                        CrudService.all(
                                            "lead_events",
                                            pars,
                                            vm,
                                            function (response) {
                                                angular.forEach(
                                                    response.data.data,
                                                    function (e) {
                                                        if (
                                                            e.created_at &&
                                                            e.created_at.date
                                                        ) {
                                                            e.created_at_frmt = moment(
                                                                e.created_at
                                                                    .date
                                                            ).format(
                                                                "DD/MM/YYYY HH:mm:ss"
                                                            );
                                                        } else {
                                                            e.created_at_frmt = moment(
                                                                e.created_at
                                                            ).format(
                                                                "DD/MM/YYYY HH:mm:ss"
                                                            );
                                                        }
                                                        if (
                                                            e.call_date &&
                                                            e.call_date.date
                                                        ) {
                                                            e.call_date_frmt = moment(
                                                                e.call_date.date
                                                            ).format(
                                                                "DD/MM/YYYY HH:mm:ss"
                                                            );
                                                        } else {
                                                            if (e.call_date) {
                                                                e.call_date_frmt = moment(
                                                                    e.call_date
                                                                ).format(
                                                                    "DD/MM/YYYY HH:mm:ss"
                                                                );
                                                            }
                                                        }

                                                        $scope.leadevents.push(
                                                            e
                                                        );
                                                    }
                                                );
                                                if (vm.user.type == 'admin') {
                                                    $scope.loadActivities();
                                                }
                                                $scope.loading = false;
                                            },
                                            function (response) {
                                                var errMsg = "";
                                                if (
                                                    response.data != null &&
                                                    response.data.message !=
                                                        null
                                                ) {
                                                    errMsg =
                                                        response.data != null &&
                                                        response.data.message !=
                                                            null
                                                            ? response.data
                                                                  .message + "."
                                                            : ".";
                                                    var url =
                                                        response.config !=
                                                            null &&
                                                        response.config.url !=
                                                            null
                                                            ? response.config
                                                                  .url
                                                            : "";
                                                    if (url != null) {
                                                        errMsg +=
                                                            "\nUrl: " + url;
                                                    }
                                                }
                                                alert(
                                                    "Si è verificato un errore nel caricamento dello storico modifiche: " +
                                                        errMsg
                                                );
                                                $scope.loading = false;
                                            }
                                        );
                                    };
                                    $scope.close = function () {
                                        $mdDialog.hide(true);
                                    };
                                    $scope.loadLeadEvents();
                                },
                            ],
                        });

                        return $mdDialog.show(dialog).finally(function () {
                            dialog = undefined;
                        });
                    };
                },
            ],
        };
    }
})();

(function () {
    "use strict";
    angular.module("admin").directive("blBtnCustomerHistory", blBtnCustomerHistory);
    function blBtnCustomerHistory() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bl-btn-customer-history/bl-btn-customer-history.html",
            bindToController: {
                entity: "=",
                user: "="
            },
            scope: true,
            controllerAs: "vm",
            controller: [
                "$filter",
                "$scope",
                "$mdDialog",
                "CrudService",
                function ($filter, $scope, $mdDialog, CrudService) {
                    var vm = this;
                    vm.showHistory = function () {
                        var a = vm.entity;
                        var dialog = $mdDialog.confirm({
                            title:
                                "Storico Modifiche: " +
                                (a.firstname != null
                                    ? a.firstname.toUpperCase()
                                    : "") +
                                " " +
                                (a.lastname != null
                                    ? a.lastname.toUpperCase()
                                    : "") +
                                " (cid=" +
                                a.id +
                                ")",
                            ariaLabel: "Storia Modifiche Cliente",
                            templateUrl: "app/components/dialogs/entity-history.html",
                            escapeToClose: true,
                            controller: [
                                "$scope",
                                "$mdDialog",
                                "$filter",
                                function ($scope, $mdDialog, $filter) {
                                    $scope.title = this.title;
                                    $scope.button_ok = "Chiudi";
                                    $scope.user = vm.user;
                                    $scope.leadevents = [];
                                    $scope.activities = [];
                                    $scope.loadingAct = true;
                                    $scope.loading = true;
                                    $scope.loadActivities = function () {
                                        var pars = {
                                            log_name: "default",
                                            subject_type: "App\\Entities\\Customer",
                                            subject_id: a.id,
                                            with: "causer;subject",
                                        };
                                        $scope.loadingAct = true;
                                        $scope.loading = true;
                                        $scope.activities = [];
                                        CrudService.all(
                                            "activity_log",
                                            pars,
                                            vm,
                                            function (response) {
                                                angular.forEach(
                                                    response.data.data,
                                                    function (act) {
                                                        act.created_at_frmt = moment(
                                                            act.created_at
                                                        ).format(
                                                            "DD/MM/YYYY HH:mm:ss"
                                                        );
                                                        $scope.activities.push(
                                                            act
                                                        );
                                                    }
                                                );
                                                $scope.loadingAct = false;
                                                $scope.loading = false;
                                            },
                                            function (response) {
                                                var errMsg = "";
                                                if (
                                                    response.data != null &&
                                                    response.data.message !=
                                                        null
                                                ) {
                                                    errMsg =
                                                        response.data != null &&
                                                        response.data.message !=
                                                            null
                                                            ? response.data
                                                                  .message + "."
                                                            : ".";
                                                    var url =
                                                        response.config !=
                                                            null &&
                                                        response.config.url !=
                                                            null
                                                            ? response.config
                                                                  .url
                                                            : "";
                                                    if (url != null) {
                                                        errMsg +=
                                                            "\nUrl: " + url;
                                                    }
                                                }
                                                alert(
                                                    "Si è verificato un errore nel caricamento delle attività: " +
                                                        errMsg
                                                );
                                                $scope.loadingAct = false;
                                                $scope.loading = false;
                                            }
                                        );
                                    };
                                    $scope.close = function () {
                                        $mdDialog.hide(true);
                                    };
                                    $scope.loadActivities();
                                },
                            ],
                        });

                        return $mdDialog.show(dialog).finally(function () {
                            dialog = undefined;
                        });
                    };
                },
            ],
        };
    }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("blBtnAppointmentInfo", blBtnAppointmentInfo);
    function blBtnAppointmentInfo() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bl-btn-appointment-info/bl-btn-appointment-info.html",
            bindToController: {
                appointment: "=",
                customer: "=",
                lead: "=",
                byOperator: "=",
                user: "=",
                newlayout: "=",
            },
            scope: true,
            controllerAs: "vm",
            controller: [
                "$filter",
                "$scope",
                "$mdDialog",
                "RecallTypes",
                "AppointmentsService",
                function (
                    $filter,
                    $scope,
                    $mdDialog,
                    RecallTypes,
                    AppointmentsService
                ) {
                    var vm = this;
                    vm.recall_types = RecallTypes;
                    vm.newLayout = (this.newlayout)? this.newlayout: false;
                    vm.dateFormat = function (elem, deleteCreatedAt) {
                        elem.updated_at_frmt = moment(
                            elem.updated_at.date?elem.updated_at.date:elem.updated_at
                        ).format("DD/MM/YYYY HH:mm");

                        var createdR = moment(elem.created_at_r);
                        elem.createdRecently =
                            moment().diff(createdR, "hours") < 12;
                        //$log.info(elem);
                        elem.created_at_frmt = moment(
                            elem.created_at.date?elem.created_at.date:elem.created_at
                        ).format("DD/MM/YYYY HH:mm");

                        elem.date_start_frmt = moment(elem.date_start).format(
                            "DD/MM/YYYY HH:mm"
                        );
                        elem.date_end_frmt = moment(elem.date_end).format(
                            "HH:mm"
                        );

                        if (elem.moved_at != null) {
                            elem.moved_at_frmt = moment(elem.moved_at).format(
                                "DD/MM/YYYY HH:mm"
                            );
                        }
                        if (elem.cancelled_at != null) {
                            elem.cancelled_at_frmt = moment(
                                elem.cancelled_at
                            ).format("DD/MM/YYYY HH:mm");
                        }

                        if (deleteCreatedAt) {
                            delete elem.created_at;
                            delete elem.updated_at;
                        }

                        if (
                            elem.lead != null &&
                            elem.lead.data != null &&
                            elem.lead.data.created_at != null
                        ) {
                            elem.lead.data.created_at_frmt = moment(
                                elem.lead.data.created_at.date?elem.lead.data.created_at.date:elem.lead.data.created_at
                            ).format("DD/MM/YYYY HH:mm");
                        }
                    };
                    vm.setUserRole = function (a) {
                        if (a.id == vm.appointment.id) {
                            a.role = vm.appointment.role;
                        }
                    };
                    vm.showInfo = function (a) {
                        if (!a) {
                            a = vm.appointment;
                        }
                        if (!a.customer) {
                            a.customer = {data: vm.customer} ;
                        }
                        if (!a.treatment_name && a.treatment) {
                            a.treatment_name = a.treatment.name;
                            if (!a.treatment.data) {
                                a.treatment.data = a.treatment;
                            }
                        }
                        if (a.role && !a.role.data) {
                            a.role.data = a.role;
                        }
                        if(a.lead && !a.lead.data) {
                            a.lead.data = a.lead;
                        }
                        if(a.byOperator && !a.byOperator.data) {
                            a.byOperator.data = a.byOperator;
                        }
                        vm.dateFormat(a);
                        var dialog = $mdDialog.confirm({
                            title:
                                "Info: " +
                                a.treatment_name +
                                " di " +
                                (a.customer.data.firstname != null
                                    ? a.customer.data.firstname.toUpperCase()
                                    : "") +
                                " " +
                                (a.customer.data.lastname != null
                                    ? a.customer.data.lastname.toUpperCase()
                                    : "") +
                                " (aid=" +
                                a.id +
                                ")",
                            ariaLabel: "Storia spostamenti",
                            templateUrl:
                                "app/components/dialogs/appointment-moves.html",
                            escapeToClose: true,
                            controller: [
                                "$scope",
                                "$mdDialog",
                                "$filter",
                                function ($scope, $mdDialog, $filter) {
                                    $scope.title = this.title;
                                    $scope.button_ok = "Chiudi";
                                    $scope.recall_types = vm.recall_types;
                                    $scope.appointmentQuesto = a;
                                    $scope.appointment = null;
                                    $scope.appointmentsList = [];
                                    $scope.loadOrigin = function () {
                                        var pars = {};
                                        pars.with =
                                            "customer;byOperator;movedBy;cancelledBy;updatedBy;lead;treatment";
                                        /*if (a.treatment_id == 99) {
                                        vm.card.find(a);
                                    }*/

                                        if (a.appointment_id == null && a.byOperator) {
                                            //questo è l'origine
                                            $scope.appointment = a;
                                            $scope.appointmentsList.push(a);
                                            var elem = $scope.appointment;
                                            if (elem.recalled == 4) {
                                                $scope.loading = true;
                                                $scope.loadAppointments(a.id);
                                            }
                                        } else {
                                            $scope.loading = true;
                                            AppointmentsService.get(
                                                a.appointment_id?a.appointment_id:a.id,
                                                pars
                                            ).then(
                                                function (response) {
                                                    $scope.appointment =
                                                        response.data.data;
                                                    $scope.appointmentsList.push($scope.appointment);
                                                    vm.setUserRole(
                                                        $scope.appointment
                                                    );
                                                    var elem =
                                                        $scope.appointment;
                                                    vm.dateFormat(
                                                        $scope.appointment
                                                    );
                                                    $scope.loadAppointments(
                                                        a.appointment_id?a.appointment_id:a.id
                                                    );
                                                },
                                                function (response) {
                                                    var errMsg = "";
                                                    if (
                                                        response.data != null &&
                                                        response.data.message !=
                                                            null
                                                    ) {
                                                        errMsg =
                                                            response.data !=
                                                                null &&
                                                            response.data
                                                                .message != null
                                                                ? response.data
                                                                      .message +
                                                                  "."
                                                                : ".";
                                                        var url =
                                                            response.config !=
                                                                null &&
                                                            response.config
                                                                .url != null
                                                                ? response
                                                                      .config
                                                                      .url
                                                                : "";
                                                        if (url != null) {
                                                            errMsg +=
                                                                "\nUrl: " + url;
                                                        }
                                                    }
                                                    alert(
                                                        "Si è verificato un errore nel caricamento appuntamenti: " +
                                                            errMsg
                                                    );
                                                    $scope.loading = false;
                                                }
                                            );
                                        }
                                    };

                                    /**
                                     * Tutti gli spostati
                                     */
                                    $scope.loadAppointments = function (aid) {
                                        $scope.appointmentsList = [];
                                        var pars = { page: 1, s: 1000 };
                                        var search = [];
                                        var searchFields = [];
                                        search.push("appointment_id:" + aid);
                                        searchFields.push("appointment_id:=");
                                        pars.orderBy = "id";
                                        pars.sortedBy = "desc";
                                        pars.search = search.join(";");
                                        pars.searchFields = searchFields.join(
                                            ";"
                                        );
                                        pars.with =
                                            "movedBy;cancelledBy;createdBy;updatedBy;treatment;user";
                                        AppointmentsService.all(pars).then(
                                            function (response) {
                                                $scope.appointmentsList = [];
                                                if (
                                                    response.data &&
                                                    response.data.data
                                                ) {
                                                    var nextApp = null;
                                                    /**
                                                     * Itero dal più nuovo al più vecchio
                                                     */
                                                    angular.forEach(
                                                        response.data.data,
                                                        function (elem) {
                                                            vm.setUserRole(
                                                                elem
                                                            );
                                                            if (
                                                                nextApp != null
                                                            ) {
                                                                if (
                                                                    elem.moved_by ==
                                                                    null
                                                                ) {
                                                                    elem.moved_by =
                                                                        nextApp.created_by;
                                                                    elem.movedBy =
                                                                        nextApp.createdBy;
                                                                }
                                                            }
                                                            vm.dateFormat(elem);
                                                            nextApp = elem;
                                                            $scope.appointmentsList.push(
                                                                elem
                                                            );
                                                        }
                                                    );
                                                    /**
                                                     * L'ultimo selezionato è il primo spostamento dell'originale
                                                     */
                                                    var elem =
                                                        $scope.appointment;
                                                    if (nextApp != null) {
                                                        if (
                                                            elem.moved_by ==
                                                            null
                                                        ) {
                                                            elem.moved_by =
                                                                nextApp.created_by;
                                                            elem.movedBy =
                                                                nextApp.createdBy;
                                                        }
                                                    }
                                                    /**
                                                     * Metto anche il primo in elenco
                                                     */
                                                    $scope.appointmentsList.push(
                                                        $scope.appointment
                                                    );
                                                    //$log.info($scope.appointment);
                                                    //$log.info($scope.appointmentsList);
                                                    $scope.loading = false;
                                                }
                                            },
                                            function (response) {
                                                var errMsg = "";
                                                if (
                                                    response.data != null &&
                                                    response.data.message !=
                                                        null
                                                ) {
                                                    errMsg =
                                                        response.data != null &&
                                                        response.data.message !=
                                                            null
                                                            ? response.data
                                                                  .message + "."
                                                            : ".";
                                                    var url =
                                                        response.config !=
                                                            null &&
                                                        response.config.url !=
                                                            null
                                                            ? response.config
                                                                  .url
                                                            : "";
                                                    if (url != null) {
                                                        errMsg +=
                                                            "\nUrl: " + url;
                                                    }
                                                }
                                                alert(
                                                    "Si è verificato un errore nel caricamento appuntamenti: " +
                                                        errMsg
                                                );
                                                $scope.loading = false;
                                            }
                                        );
                                    };
                                    $scope.close = function () {
                                        $mdDialog.hide(true);
                                    };
                                    $scope.loadOrigin();
                                },
                            ],
                        });

                        return $mdDialog.show(dialog).finally(function () {
                            dialog = undefined;
                        });
                    };
                },
            ],
        };
    }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("blBtnAppointmentDocuments", blBtnAppointmentDocuments);
    function blBtnAppointmentDocuments() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bl-btn-appointment-documents/bl-btn-appointment-documents.html",
            bindToController: {
                appointment: "=",
                customer: "=",
                user: "=",
            },
            scope: true,
            controllerAs: "vm",
            controller: [
                "$mdDialog",
                "$scope",
                "$filter",
                "env",
                function (
                    $mdDialog,
                    $scope,
                    $filter,
                    env
                ) {

                    var vm = this;


                    vm.initDocuments = function(app) {
                        if (!env.documentsEnabled) {
                            return;
                        }
                        //$log.info('trt',app.treatment);
                        //$log.info("docs",app.documents);
                        /**
                         * verifico se presente privacy + autorizzazione foto + consenso al trattamento corrente
                         */
                        app.docPrivacyOk = false;
                        app.docCovidOk = false;
                        app.docPicturesOk = false;
                        app.docContrPicturesOk = false;
                        app.docTreatmentOk = false;
                        if (!app.treatment.data.document_template_id) {
                            app.docTreatmentOk = true;
                        }
                        angular.forEach(app.documents.data, function(doc) {
                            if (doc.document_type_id == 301 && !app.docPrivacyOk) {
                                app.docPrivacyOk = true;
                                app.docPrivacy = {'data':doc};
                            } else if (doc.document_type_id == 302 && !app.docPicturesOk) {
                                app.docPicturesOk = true;
                                app.docPictures = {'data':doc};
                            } else if (doc.document_type_id == 305 && !app.docCovidOk) {
                                app.docCovidOk = true;
                                app.docCovid = {'data':doc};
                            } else if (doc.document_template_id == app.treatment.data.document_template_id && !app.docTreatmentOk) {
                                app.docTreatmentOk = true;
                                app.docTreatment = {'data':doc};
                            }
                        });
                        app.pictureBeforeOk = true;
                        app.pictureAfterOk = true;
                        if (app.docPicturesOk) {
                            if (app.treatment.data.f_pic_before && (!app.docPictures.data.parameter || $filter('filter')(app.docPictures.data, {parameter: '1'}, true).length==0)) {
                                app.pictureBeforeOk = false;
                                //$log.info("manca foto prima");
                            }
                            if (app.treatment.data.f_pic_after && (!app.docPictures.data.parameter || $filter('filter')(app.docPictures.data, {parameter: '2'}, true).length==0)) {
                                app.pictureAfterOk = false;
                                //$log.info("manca foto dopo");
                            }
                        }
            
                        //$log.info("docPrivacy "+app.id,app.docPrivacyOk);
                        //$log.info("docCovid "+app.id,app.docCovidOk);
                        //$log.info("docPictures "+app.id,app.docPicturesOk);
                        //$log.info("docTreatmentOk "+app.id,app.docTreatmentOk);
                    };


                    vm.showDocuments = function( a ) {
                        var dialog = $mdDialog.confirm({
                              title: 'Elenco documenti: ' + a.treatment.data.name + ' di ' + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
                              + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'') + " (aid="+a.id+" cid="+a.customer_id+" tid="+a.treatment_id+")",
                              ariaLabel: 'Storia cambi op.',
                              templateUrl: 'app/appointments/dialogs/appointment-documents.html',
                              escapeToClose: true,
                              controller: [ '$scope', '$mdDialog', '$filter', '$http', '$log',  function( $scope, $mdDialog, $filter, $http, $log ) {
                                  $scope.title = this.title;
                                  $scope.button_ok = 'Chiudi';
                                  $scope.app = a;
                                  $scope.env = env;
                                  $scope.token = localStorage.getItem( 'Biolaser_token' );
                                  $scope.refresh = function() {
                                      /**
                                      * ricarico documenti cliente
                                      */
                                      //$log.info("http.get: "+$scope.env.API+"/documents?customer_id="+$scope.app.customer_id);
                                      $scope.loading = true;
                                      $http.get($scope.env.API+"/documents?customer_id="+$scope.app.customer_id).then(
                                          function (response) {
                                              //$log.info(response.data.data);
                                              $scope.app.documents = {'data': response.data.data };
                                              vm.initDocuments($scope.app);
                                              $scope.loading = false;
                                          },
                                          function (response) {
                                              //$log.info(response);
                                              $scope.loading = false;
                                          }
                                      );
                                  };
                                  $scope.close = function() {
                                      $mdDialog.hide( true );
                                  };
                              }]
                        });
               
                        return $mdDialog
                            .show( dialog )
                            .finally(
                                function() {
                                    dialog = undefined;
                                }
                            )
                        ;
                    };


                    this.$onInit = function () {

                        //SET TREATMENT.DATA IF IS NULL
                        if(!this.appointment.treatment.data){
                            this.appointment.treatment.data = this.appointment.treatment;
                        }

                        vm.initDocuments(this.appointment);

                    };
                    
                },
            ],
        };
    }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("blAppointmentsWireTransfers", blAppointmentsWireTransfers);
    function blAppointmentsWireTransfers() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bl-appointments-wire-transfers/bl-appointments-wire-transfers.html",
            bindToController: {
                paymenttype: "=",
                wiretransfer: "=",
                storeid: "=",
                token: "="
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                "$http",
                "$log",
                "$mdDialog",
                "$mdMedia",
                "$mdToast",
                "$rootScope",
                "$scope",
                "$window",
                "CrudService",
                "env",
                "UsersService",
                function (
                    $http,
                    $log,
                    $mdDialog,
                    $mdMedia,
                    $mdToast,
                    $rootScope,
                    $scope,
                    $window,
                    CrudService,
                    env,
                    UsersService
                ) {

                    var vm = this;
                    vm.env = env;
                    vm.mdDialog = $mdDialog;
                    vm.mdToast = $mdToast;
                    $log.info('blAppointmentsWireTransfers');

                    /* Operatore connesso */
                    if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
                        return;
                    }

                    vm.today = new Date(moment().hour(8).minute(0).second(0));
                    vm.minDateFilter = new Date(2022, 1, 1);

                    vm.options = {
                        autoSelect: false,
                        boundaryLinks: true,
                        pageSelector: true,
                        rowSelection: false
                    };

                    vm.appointmentsListPag = {
                        "total": 0,
                        "count": 10,
                        "per_page": 50,
                        "current_page": 1,
                        "total_pages": 0,
                        "links": {}
                    };

                    vm.queryAppointments = {
                        filter: '',
                        filter_date_start: vm.today,
                        filter_date_end: null,
                        filter_unassociated_cro: 0,
                        order: '-date_start',
                        limitOptions: [50, 75, 100],
                        page: 1
                    };

                    vm.onKeyPressSearchAppointment = function (event) {
                        if (event.keyCode == 13) {
                            vm.loadAppointments();
                            event.stopPropagation();
                            event.preventDefault();
                        }
                    };

                    vm.onChangeDateStartAppointment = function () {
                        vm.queryAppointments.page = 1;
                        vm.queryAppointments.order = 'date_start';
                        if (vm.queryAppointments.filter_date_start && vm.queryAppointments.filter_date_end) {
                            if (moment(vm.queryAppointments.filter_date_end).hour(23).minute(59).second(59).isBefore(vm.queryAppointments.filter_date_start)) {
                                vm.queryAppointments.filter_date_end = null;
                            }
                        }

                        vm.loadAppointments();
                    }

                    vm.onChangeDateEndAppointment = function () {
                        vm.queryAppointments.page = 1;
                        vm.queryAppointments.order = 'date_start';
                        if (vm.queryAppointments.filter_date_start && vm.queryAppointments.filter_date_end) {
                            if (moment(vm.queryAppointments.filter_date_end).hour(23).minute(59).second(59).isBefore(vm.queryAppointments.filter_date_start)) {
                                vm.queryAppointments.filter_date_start = vm.queryAppointments.filter_date_end;
                            }
                        }

                        vm.loadAppointments();
                    }

                    vm.onChangeFilterUnassociatedCRO = function() {
                        vm.queryAppointments.page = 1;

                        vm.loadAppointments();
                    }

                    vm.loadAppointments = function (p, s, exp) {

                        var search = [];
                        var searchFields = [];

                        if (p == null) {
                            p = vm.queryAppointments.page;
                        }
                        vm.queryAppointments.page = p;

                        if (s == null) {
                            s = parseInt(vm.appointmentsListPag.per_page);
                        }

                        var pars = {
                            page: p,
                            s: s,
                            store_id: vm.store_id,
                            with: 'treatment;customer;appointmentWireTransfers.wireTransfer'
                        };

                        if (vm.queryAppointments.filter_date_start != null && vm.queryAppointments.filter_date_start != '') {
                            var date_start = moment(vm.queryAppointments.filter_date_start).format("YYYY-MM-DD 00:00:00");
                            search.push("date_start:" + date_start);
                            searchFields.push("date_start:>=");
                        }

                        if (vm.queryAppointments.filter_date_end != null && vm.queryAppointments.filter_date_end != '') {
                            var date_end = moment(vm.queryAppointments.filter_date_end).format("YYYY-MM-DD 23:59:59.9");
                            search.push("date_end:" + date_end);
                            searchFields.push("date_end:<");
                        }

                        if (vm.queryAppointments.filter != null && vm.queryAppointments.filter != '') {
                            pars.filtro = vm.queryAppointments.filter;
                        }

                        if (vm.queryAppointments.order != null && vm.queryAppointments.order != '') {
                            pars.orderBy = vm.queryAppointments.order.indexOf('-') == 0 ? vm.queryAppointments.order.substring(1) : vm.queryAppointments.order;
                            pars.sortedBy = vm.queryAppointments.order.indexOf('-') == 0 ? 'desc' : 'asc';
                        }

                        //FILTER STORE
                        if (vm.storeId) {
                            searchFields.push("appointments.store_id:=");
                            search.push("appointments.store_id:" + vm.storeId);
                        }

                        //FILTER UNASSOCIATED CRO
                        if(vm.queryAppointments.filter_unassociated_cro) {
                            pars.filter_unassociated_cro = true;
                        }

                        //FILTER ONLY WIRE TRANSFERS
                        pars.payment_type = vm.paymentType;

                        pars.search = search.join(";");
                        pars.searchFields = searchFields.join(";");

                        //LOAD ITEMS OR EXPORT
                        if(!exp) {

                            vm.loadingAppointments = true;

                            vm.appointments = [];

                            CrudService.all(
                                'appointments_wire_transfers',
                                pars,
                                vm,
                                function (response) {

                                    if (response.data && response.data.data) {
                                        vm.appointmentsListPag = response.data.meta.pagination;

                                        angular.forEach(response.data.data, function (elem) {
                                            elem.date_frmt = moment(elem.date_start).format('DD/MM/YYYY HH:mm');

                                            if (elem.appointment_wire_transfers) {
                                                angular.forEach(elem.appointment_wire_transfers, function (elem1) {
                                                    elem1.updated_at_frmt = moment(elem1.updated_at).format('DD/MM/YYYY HH:mm');
                                                    if (elem1.wire_transfer) {
                                                        elem1.wire_transfer.value_date_frmt = moment(elem1.wire_transfer.value_date).format('DD/MM/YYYY');
                                                        elem1.wire_transfer.transfer_date_frmt = moment(elem1.wire_transfer.transfer_date).format('DD/MM/YYYY');
                                                    }
                                                });
                                            }
                                        });

                                        vm.appointments = response.data.data;
                                    }

                                    vm.loadingAppointments = false;

                                },
                                function (response) {
                                    var errMsg = "";
                                    if (response.data != null
                                        && response.data.message != null) {
                                        errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                                        var url = response.config != null && response.config.url != null ? response.config.url : "";
                                        if (url != null) {
                                            errMsg += "\nUrl: " + url;
                                        }
                                    }
                                    vm.showActionToast(errMsg);
                                    vm.loadingAppointments = false;
                                }
                            );
                        
                        } else {

                            var append = "?token=" + vm.token + "&export=true";
                            angular.forEach(pars, function (v, k) {
                                append += "&" + k + "=" + window.encodeURIComponent(v);
                            });

                            $window.open( vm.env.API + "/appointments_wire_transfers/" + append, "_self");

                        }
                    };

                    vm.reorderAppointments = function (column) {
                        vm.queryAppointments.order = column;
                        vm.loadAppointments();
                    };

                    vm.setWireTransferAppointment = function (appointment) {
                        var confirm = $mdDialog
                            .confirm()
                            .title('Attenzione')
                            .ariaLabel('Attenzione')
                            .textContent('Sicuro di voler associare questo appuntamento?')
                            .ok('Si')
                            .cancel('Ops, ho sbagliato')
                            .multiple(true);

                        return $mdDialog
                            .show(confirm)
                            .then(
                                function () {
                                    vm.saving = true;

                                    $http
                                        .post(
                                            vm.env.API + "/wire_transfers/assign-wire-transfer-appointment",
                                            {
                                                appointment_id: appointment.id,
                                                wire_transfer_id: vm.wireTransfer.id
                                            }
                                        )
                                        .then(
                                            function (response) {

                                                var messageToast = '';

                                                if (response && response.data.appointmentWireTransfer) {

                                                    //IF AMOUNT <= ASSOCIATED_AMOUNT CLOSE MODAL
                                                    var totalWireTransfers = 0;
                                                    angular.forEach(response.data.appointmentWireTransfer, function (elem) {
                                                        totalWireTransfers += ((elem.appointment) ? Number(elem.appointment.price) : 0);
                                                    });

                                                    if (vm.wireTransfer.amount <= totalWireTransfers) {
                                                        $mdDialog.hide(true);
                                                    }

                                                    $rootScope.$broadcast("bl-appointments-wire-transfers-loadAppointments");
                                                    $rootScope.$broadcast("bl-wire-transfers-loadWireTransfers");

                                                    messageToast = "Bonifico associato ad Appuntamento!";
                                                } else if (response.data.oldAppointmentWireTransfer) {
                                                    messageToast = "Appuntamento già associato al bonifico!";
                                                } else {
                                                    messageToast = "Ops, si è verificato un errore!";
                                                }

                                                vm.showActionToast(messageToast);

                                            },
                                            function (response) {
                                                $scope.loading = false;
                                                vm.printErrorMessage(response);
                                            }
                                        );
                                }
                            ).finally(
                                function () {
                                    confirm = undefined;
                                }
                            );

                    };

                    vm.checkAssociableAppointmentToWireTransferBtn = function (appointment) {

                        var ret = true;

                        angular.forEach(appointment.appointment_wire_transfers, function (elem) {
                            if (!elem.wire_transfer_id && elem.identification != vm.wireTransfer.identification) {
                                ret = false;
                            }
                        });

                        return ret;

                    }

                    vm.checkAssociateAppointmentToWireTransferBtn = function (appointment) {

                        var ret = true;

                        angular.forEach(appointment.appointment_wire_transfers, function (elem) {
                            if (elem.wire_transfer_id == vm.wireTransfer.id) {
                                ret = false;
                            }
                        });

                        return ret;

                    }

                    vm.deleteAppointmentWireTransfer = function (appointment, appointmentWireTransfer) {
                        $log.info('Elimina Appuntamento Bonifico');

                        var confirm = $mdDialog.confirm()
                            .title('Attenzione')
                            .ariaLabel('Attenzione')
                            .textContent('Sicuro di voler eliminare questa associazione?')
                            .ok('Si')
                            .cancel('Ops, ho sbagliato');

                        return $mdDialog
                            .show(confirm)
                            .then(
                                function () {
                                    vm.loadingAppointments = true;

                                    CrudService.del(
                                        'appointments_wire_transfers',
                                        appointmentWireTransfer.id,
                                        vm,
                                        function (response) {
                                            vm.loadingAppointments = false;

                                            //REMOVE ITEM FROM ARRAY
                                            if (
                                                response.status == 200 &&
                                                response.data &&
                                                response.data.deleted
                                            ) {
                                                vm.removeAppointmentWireTransferFromlist(appointment, appointmentWireTransfer);
                                                $rootScope.$broadcast("bl-wire-transfers-loadWireTransfers");
                                            }
                                        },
                                        function (response) {
                                            vm.loadingAppointments = false;
                                        }
                                    );

                                }
                            ).finally(
                                function () {
                                    confirm = undefined;
                                }
                            );
                    };

                    vm.archiveAppointment = function (appointment) {
                        var confirm = $mdDialog
                            .confirm()
                            .title('Attenzione')
                            .ariaLabel('Attenzione')
                            .textContent('Sicuro di voler archiviare questo appuntamento?')
                            .ok('Si')
                            .cancel('Ops, ho sbagliato')
                            .multiple(true);

                        return $mdDialog
                            .show(confirm)
                            .then(
                                function () {
                                    vm.saving = true;

                                    $http
                                        .post(
                                            vm.env.API + "/wire_transfers/archive-appointment",
                                            {
                                                appointment_id: appointment.id,
                                            }
                                        )
                                        .then(
                                            function (response) {

                                                var messageToast = '';

                                                if (response && response.data.appointmentWireTransfers) {

                                                    vm.loadAppointments();

                                                    messageToast = "Appuntamento archiviato";
                                                } else {
                                                    messageToast = "Ops, si è verificato un errore!";
                                                }

                                                vm.showActionToast(messageToast);

                                            },
                                            function (response) {
                                                $scope.loading = false;
                                                vm.printErrorMessage(response);
                                            }
                                        );
                                }
                            ).finally(
                                function () {
                                    confirm = undefined;
                                }
                            );

                    };

                    vm.removeAppointmentWireTransferFromlist = function (appointment, appointmentWireTransfer) {
                        var index = appointment.appointment_wire_transfers.indexOf(appointmentWireTransfer);
                        appointment.appointment_wire_transfers.splice(index, 1);
                    }

                    vm.removeAppointmentFromlist = function (appointment) {
                        var index = vm.appointments.indexOf(appointment);
                        vm.appointments.splice(index, 1);
                    }

                    vm.printErrorMessage = function (response) {
                        var errMsg = "";
                        if (response.data != null
                            && response.data.message != null) {
                            errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                            var url = response.config != null && response.config.url != null ? response.config.url : "";
                            if (url != null) {
                                errMsg += "\nUrl: " + url;
                            }
                        }

                        vm.showActionToast("Si è verificato un errore " + errMsg);
                    };

                    vm.showActionToast = function (text) {
                        text = text && angular.isDefined(text) ? text : 'Tutto Ok!';
                        var toast = $mdToast.simple()
                            .textContent(text)
                            .action('')
                            .highlightAction(true)
                            .position('bottom right');
                        return $mdToast
                            .show(toast)
                            .finally(
                                function () {
                                    toast = undefined;
                                }
                            );
                    };


                    //-----------DIALOGS--------------------------------------//
                    vm.showSetCroModal = function (appointment) {
                        var useFullScreen = $mdMedia('xs');
                        var confirm = $mdDialog.confirm({
                            title: 'Info',
                            ariaLabel: 'Info',
                            templateUrl: 'app/wire-transfer/dialogs/set-cro-dialog.html',
                            fullscreen: useFullScreen,
                            escapeToClose: false,
                            controller: [
                                '$scope',
                                '$mdDialog',
                                function ($scope, $mdDialog) {

                                    $scope.appointment = appointment;
                                    $scope.loading = false;
                                    $scope.croNumber = null;

                                    $scope.confirm = function () {

                                        if (
                                            appointment &&
                                            $scope.croNumber
                                        ) {

                                            $scope.loading = true;

                                            $http
                                                .post(
                                                    vm.env.API + "/wire_transfers/assign-appointment-cro",
                                                    {
                                                        appointment_id: $scope.appointment.id,
                                                        identification: $scope.croNumber
                                                    }
                                                )
                                                .then(
                                                    function (response) {

                                                        var messageToast = "";
                                                        $scope.loading = false;

                                                        if (response && response.data.wire_transfers) {

                                                            //SET TOAST MESSAGE
                                                            if (response.data.wire_transfer) {

                                                                //GET NEW TOTAL
                                                                var totalWireTransfers = 0;
                                                                angular.forEach(response.data.wire_transfers, function (elem) {
                                                                    totalWireTransfers += ((elem.wire_transfer) ? Number(elem.wire_transfer.amount) : 0);
                                                                });

                                                                if (appointment.price <= totalWireTransfers) {
                                                                    messageToast = "CRO trovato nei bonifici, appuntamento completamente verificato!";
                                                                } else {
                                                                    messageToast = "CRO trovato nei bonifici, la verifica non è completa!";
                                                                }
                                                            } else {
                                                                messageToast = "CRO associato ad Appuntamento senza corrispondenza!";
                                                            }

                                                            $rootScope.$broadcast("bl-appointments-wire-transfers-loadAppointments");
                                                            $rootScope.$broadcast("bl-wire-transfers-loadWireTransfers");

                                                        } else {
                                                            messageToast = "Ops, si è verificato un errore!";
                                                        }


                                                        vm.showActionToast(messageToast);
                                                        $mdDialog.hide(true);

                                                    },
                                                    function (response) {
                                                        $scope.loading = false;
                                                        vm.printErrorMessage(response);
                                                    }
                                                );

                                        } else {

                                            vm.showActionToast("Inserisci il CRO per procedere!");

                                        }
                                    }

                                    $scope.close = function () {
                                        $mdDialog.hide(true);
                                    };
                                }]
                        });
                        return $mdDialog
                            .show(confirm);
                    };

                    vm.showAssociatedCroModal = function (appointment) {
                        var useFullScreen = $mdMedia('xs');
                        var confirm = $mdDialog.confirm({
                            title: 'Info',
                            ariaLabel: 'Info',
                            templateUrl: 'app/wire-transfer/dialogs/associated-cro-dialog.html',
                            fullscreen: useFullScreen,
                            escapeToClose: false,
                            controller: [
                                '$scope',
                                '$mdDialog',
                                function ($scope, $mdDialog) {

                                    $scope.appointment = appointment;
                                    $scope.user = vm.user;

                                    $scope.deleteAppointmentWireTransfer = function(appointmentWireTransfer){
                                        vm.deleteAppointmentWireTransfer(appointment, appointmentWireTransfer);
                                    }

                                    $scope.close = function () {
                                        $mdDialog.hide(true);
                                    };
                                }]
                        });
                        return $mdDialog
                            .show(confirm);
                    };


                    this.$onInit = function () {

                        vm.paymentType = this.paymenttype;
                        vm.wireTransfer = this.wiretransfer;

                        //CHECK PARAM STORE
                        if( this.storeid ){
                            vm.storeId = this.storeid;
                        }

                        vm.loadAppointments();

                    };


                    $scope.$on("bl-appointments-wire-transfers-loadAppointments", function (event) {
                        vm.loadAppointments();
                    });


                    /* WATCHO Lo Store */
                    $scope.$watch('$parent.selectedStore', function (id) {
                        if (angular.isDefined(id)) {
                            vm.storeId = id;
                            vm.loadAppointments();
                        };
                    });

                }]
        }
    }
})();

(function () {
    "use strict";
    angular
        .module("admin")
        .directive("blAppAppointment", blAppAppointment);
    function blAppAppointment() {
        return {
            restrict: "E",
            templateUrl:
                "app/components/bl-app-appointment/bl-app-appointment.html",
            bindToController: {
                appointment: "=",
            },
            scope: true,
            controllerAs: "ab",
            controller: [
                "$http",
                "$log",
                "$mdDialog",
                "$mdMedia",
                "$mdToast",
                "CrudService",
                "env",
                function (
                    $http,
                    $log,
                    $mdDialog,
                    $mdMedia,
                    $mdToast,
                    CrudService,
                    env
                ) {

                    var vm = this;
                    vm.env = env;
                    vm.mdDialog = $mdDialog;
                    $log.info('blAppAppointment');
                    
                    vm.printErrorMessage = function (response) {
                        var errMsg = "";
                        if (response.data != null
                            && response.data.message != null) {
                            errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                            var url = response.config != null && response.config.url != null ? response.config.url : "";
                            if (url != null) {
                                errMsg += "\nUrl: " + url;
                            }
                        }

                        vm.showActionToast("Si è verificato un errore " + errMsg);
                    };

                    vm.showActionToast = function (text) {
                        text = text && angular.isDefined(text) ? text : 'Tutto Ok!';
                        var toast = $mdToast.simple()
                            .textContent(text)
                            .action('')
                            .highlightAction(true)
                            .position('bottom right');
                        return $mdToast
                            .show(toast)
                            .finally(
                                function () {
                                    toast = undefined;
                                }
                            );
                    };

                    this.$onInit = function () {

                        vm.appointment = this.appointment;

                    };


                    //-----------DIALOGS--------------------------------------//
                    vm.openPointsModal = function () {
                        var useFullScreen = $mdMedia('xs');
                        var confirm = $mdDialog.confirm({
                            title: 'Info',
                            ariaLabel: 'Info',
                            templateUrl: 'app/components/bl-app-appointment/dialogs/appointment-app-points-list.html',
                            fullscreen: useFullScreen,
                            escapeToClose: true,
                            multiple: true,
                            controller: [
                                '$scope',
                                '$mdDialog',
                                function ($scope, $mdDialog) {

                                    $scope.rechargesApp = [];

                                    $scope.env = vm.env;

                                    $scope.appointment = vm.appointment;

                                    $scope.loading = true;

                                    CrudService.all(
                                        'recharges_app', 
                                        {
                                            appointment_id: vm.appointment.id
                                        }, 
                                        vm,
                                        function (response) {
                                            angular.forEach(response.data.data, function(item) {
                                                item.created_at_frmt = moment(item.created_at).format('D/M/YYYY HH:mm:ss');
                                                $scope.rechargesApp.push(item);
                                            });
                                            $scope.loading = false;
                                            },
                                            function (response) {
                                            var errMsg = "";
                                            if (response.data!=null
                                                    && response.data.message!=null) {
                                                errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                                                var url = response.config!=null && response.config.url!=null?response.config.url:"";
                                                if (url!=null) {
                                                errMsg+= "\nUrl: " + url;
                                                }
                                            }
                                            alert ("Si è verificato un errore nel caricamento delle attività: " + errMsg);
                                            $scope.loading = false;
                                        }
                                    );

                                    $scope.updateItemAtPosition = function (item, newItem) {
                                        var index = $scope.rechargesApp.indexOf(item);
                                        console.log(newItem);
                                        if (index !== -1) {
                                            $scope.rechargesApp[index] = newItem;
                                        }
                                    }

                                    $scope.sendToApp = function(item){

                                        var confirm = $mdDialog
                                            .confirm({
                                                multiple: true
                                            })
                                            .title('Attenzione')
                                            .ariaLabel('Attenzione')
                                            .textContent('Sicuro di voler salvare questa movimentazione?')
                                            .ok('Si')
                                            .cancel('Ops, ho sbagliato');

                                        return $mdDialog
                                            .show(confirm)
                                            .then(
                                                function() {
                                                    $scope.loading = true;

                                                    $http
                                                        .get(
                                                            $scope.env.API + "/recharges_app/sendToApp",
                                                            {params: {id: item.id}}
                                                        ).then(
                                                            function (response) {
                                                                $scope.loading = false;

                                                                if(response && response.data && response.data.data){
                                                                    response.data.data.created_at_frmt = moment(response.data.data.created_at).format('D/M/YYYY HH:mm:ss');
                                                                    $scope.updateItemAtPosition(item, response.data.data);

                                                                    vm.showActionToast("Contabilizzazione sincronizzata!");
                                                                } else {
                                                                    vm.printErrorMessage();
                                                                }

                                                            },
                                                            function (response) {
                                                                $scope.loading = false;
                                                                vm.printErrorMessage(response);
                                                            }
                                                        );

                                                }        
                                            )
                                            .finally(
                                                function() {
                                                    confirm = undefined;
                                                }
                                            );

                                    };

                                    $scope.removeFromApp = function(item){

                                        var confirm = $mdDialog
                                            .confirm({
                                                multiple: true
                                            })
                                            .title('Attenzione')
                                            .ariaLabel('Attenzione')
                                            .textContent('Sicuro di voler salvare questa movimentazione?')
                                            .ok('Si')
                                            .cancel('Ops, ho sbagliato');

                                        return $mdDialog
                                            .show(confirm)
                                            .then(
                                                function() {
                                                    $scope.loading = true;

                                                    $http
                                                        .get(
                                                            $scope.env.API + "/recharges_app/removeFromApp",
                                                            {params: {id: item.id}}
                                                        ).then(
                                                            function (response) {
                                                                $scope.loading = false;

                                                                if(response && response.data && response.data.data){
                                                                    response.data.data.created_at_frmt = moment(response.data.data.created_at).format('D/M/YYYY HH:mm:ss');
                                                                    $scope.updateItemAtPosition(item, response.data.data);

                                                                    vm.showActionToast("Contabilizzazione sincronizzata!");
                                                                } else {
                                                                    vm.printErrorMessage();
                                                                }
                                                            },
                                                            function (response) {
                                                                $scope.loading = false;
                                                                vm.printErrorMessage(response);
                                                            }
                                                        );

                                                }        
                                            )
                                            .finally(
                                                function() {
                                                    confirm = undefined;
                                                }
                                            );

                                    };
                                    
                                    $scope.close = function () {
                                        $mdDialog.hide(true);
                                    };
                                }]
                        });
                        return $mdDialog
                            .show(confirm);
                    };

                }]
        }
    }
})();

(function () {
    "use strict";

    angular.module("admin").controller("WklistController", WklistController);

    /** @ngInject */
    function WklistController(
        $window,
        $scope,
        $log,
        $location,
        $timeout,
        $http,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        UsersService
    ) {
        var vm = this;
        if (
            !UsersService.loadUserFromLocalStorage(
                vm,
                $scope.$parent.main
            )
        ) {
            return;
        }
        console.log(vm.user);
    }

    WklistController.$inject = [
        "$window",
        "$scope",
        "$log",
        "$location",
        "$timeout",
        "$http",
        "$mdSidenav",
        "$mdDialog",
        "$mdToast",
        "$filter",
        "env",
        "UsersService"
    ];
})();

(function () {
    'use strict';

    angular
        .module('admin')
        .controller('WireTransferHistoryController', WireTransferHistoryController);

    /** @ngInject */
    function WireTransferHistoryController(
        $scope,
        $log,
        type,
        env,
        UsersService
    ) {

        $log.info('WireTransferHistoryController');

        var vm = this;
        vm.env = env;
        vm.type = type;

        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }

        $scope.$emit("bl-wire-transfers-loadWireTransfers");

    };

    WireTransferHistoryController
        .$inject = [
            '$scope',
            '$log',
            'env',
            'type',
            'UsersService'
        ];

})();

(function () {
    'use strict';

    angular
        .module('admin')
        .controller('WireTransferConsumerCreditHistoryController', WireTransferConsumerCreditHistoryController);

    /** @ngInject */
    function WireTransferConsumerCreditHistoryController(
        $scope,
        $log,
        env,
        UsersService
    ) {

        $log.info('WireTransferConsumerCreditHistoryController');

        var vm = this;
        vm.env = env;

        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }

        $scope.$emit("bl-wire-transfers-consumer-credit-loadWireTransfers");

    };

    WireTransferConsumerCreditHistoryController
        .$inject = [
            '$scope',
            '$log',
            'env',
            'UsersService'
        ];

})();
(function () {
    'use strict';

    angular
        .module('admin')
        .controller('WireTransferCofidisHistoryController', WireTransferCofidisHistoryController);

    /** @ngInject */
    function WireTransferCofidisHistoryController(
        $scope,
        $log,
        env,
        UsersService
    ) {

        $log.info('WireTransferCofidisHistoryController');

        var vm = this;
        vm.env = env;

        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }

        $scope.$emit("bl-wire-transfers-cofidis-loadWireTransfers");

    };

    WireTransferCofidisHistoryController
        .$inject = [
            '$scope',
            '$log',
            'env',
            'UsersService'
        ];

})();
(function () {
    'use strict';

    angular
        .module('admin')
        .directive("fileInput", function ($parse) {
            return {
                link: function ($scope, element, attrs) {
                    element.on("change", function (event) {
                        $parse(attrs.fileInput).assign($scope, event.target.files);
                        $scope.$apply();
                    });
                }
            }
        })
        .controller('WireTransferController', WireTransferController);

    /** @ngInject */
    function WireTransferController(
        $http,
        $mdDialog,
        $mdSidenav,
        $mdToast,
        $scope,
        $log,
        $rootScope,
        env,
        UsersService
    ) {

        $log.info('WireTransferController');

        var vm = this;
        vm.env = env;
        vm.files = null;
        vm.saving = false;
        vm.today = new Date( moment().hour(8).minute(0).second(0) );


        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }


        vm.getFiles = function ($files) {
            vm.files = $files;
        };

        vm.save = function () {
            $log.info('Salva');

            //FOR BIOSMED STORE_ID IS REQUIRED
            if(
                vm.env.company != 'Biosmed' ||
                vm.storeId
            ) {

                var confirm = $mdDialog
                    .confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler inserire questo file?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');

                return $mdDialog
                    .show(confirm)
                    .then(
                        function () {
                            vm.saving = true;

                            var i = 0;
                            var fd = new FormData();
                            
                            angular.forEach($scope.files, function (file) {
                                fd.append('files[' + i + ']', file);
                                i++;
                            });

                            $http.post(
                                env.API + '/wire_transfers/import' + ((vm.storeId)? '?store_id=' + vm.storeId : ''),
                                fd,
                                {
                                    headers: {
                                        "Content-Type": undefined
                                    }
                                }
                            )
                                .then(
                                    function (response) {
                                        vm.saving = false;
                                        vm.closeImportSidebar();

                                        var reportText = "";
                                        if (response && response.data) {

                                            reportText =
                                                "<b>File Importati/Saltati:</b> " + response.data.importedFiles +
                                                "/" + response.data.excludedFiles + "<br />" +
                                                "<b>Righe Importate/Saltate:</b> " + response.data.importedRows +
                                                "/" + response.data.excludedRows;

                                        } else {

                                            reportText = "Importazione fallita!";

                                        }

                                        var confirm = $mdDialog
                                            .confirm()
                                            .title('Report Importazione')
                                            .htmlContent(reportText)
                                            .ok('Ok');

                                        return $mdDialog
                                            .show(confirm)
                                            .then(
                                                function() {
                                                    $rootScope.$broadcast("bl-appointments-wire-transfers-loadAppointments");
                                                    $rootScope.$broadcast("bl-wire-transfers-loadWireTransfers");
                                                }
                                            )
                                            .finally(
                                                function() {
                                                    confirm = undefined;
                                                }
                                            );

                                    },
                                    function (response) {
                                        vm.saving = false;
                                        vm.printErrorMessage(response);
                                    }
                                );

                        }
                    ).finally(
                        function () {
                            confirm = undefined;
                        }
                    );

            } else {

                vm.showActionToast("Seleziona lo Store per importare!");

            }

        };


        vm.printErrorMessage = function (response) {
            var errMsg = "";
            if (response.data != null
                && response.data.message != null) {
                errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                var url = response.config != null && response.config.url != null ? response.config.url : "";
                if (url != null) {
                    errMsg += "\nUrl: " + url;
                }
            }

            vm.showActionToast("Si è verificato un errore " + errMsg);
        }

        vm.showActionToast = function(text) {
            text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent(text)
                .action('')
                .highlightAction(true)
                .position('bottom right');
            return $mdToast
                .show(toast)
                .finally(
                    function() {
                        toast = undefined;
                    }
                );
        };

        //---------- Sidebar -------------------------------------//
        vm.openImportSidebar = function () {
            $mdSidenav('right').open();
        };

        vm.closeImportSidebar = function () {
            $mdSidenav('right').close();
        };


        /* WATCHO Lo Store */
        $scope.$watch('$parent.selectedStore', function (id) {
            if (angular.isDefined(id)) {
                vm.storeId = id;

                $scope.$emit("bl-appointments-wire-transfers-loadAppointments");
                $scope.$emit("bl-wire-transfers-loadWireTransfers");
            };
        });


        $scope.$emit("bl-appointments-wire-transfers-loadAppointments");
        $scope.$emit("bl-wire-transfers-loadWireTransfers");

    };

    WireTransferController
        .$inject = [
            '$http',
            '$mdDialog',
            '$mdSidenav',
            '$mdToast',
            '$scope',
            '$log',
            '$rootScope',
            'env',
            'UsersService'
        ];

})();

(function () {
    'use strict';

    angular
        .module('admin')
        .controller('WhatsappController', WhatsappController);

    /** @ngInject */
    function WhatsappController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        $http,
        $pusher,
        CustomerService,
        env,
        phone,
        CallState,
        Italia,
        TreatmentService,
        StoreService,
        SubscriptionService,
        UsersService,
        CrudService
    ) {
        try {
            var vm = this;
            vm.env = env;
            $log.info('WhatsappController');
            vm.mdToast = $mdToast;
            vm.mdDialog = $mdDialog;

            /* Operatore connesso */
            if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
                return;
            }

            vm.exclude_callcenter = false;

            vm.reset_unreaded = false;

                /**
                 * Enable pusher
                 */
                // Enable pusher logging - don't include this in production
                //Pusher.logToConsole = true;
                var client = new Pusher(vm.env.pusher_key?vm.env.pusher_key:'a9119391f9a6c97a31a8', {
                    cluster: 'eu'
                });
                var pusher = $pusher(client);

                vm.channel = pusher.subscribe(vm.env.currentTenant+'-waMessage-channel');

                vm.channel.bind('waMessage-event', function(data) {

                    vm.onWAMessageRecived(data);
                });

                vm.channel.bind('waNotify-event', function(data) {

                    vm.onWaNotify(data);
                });

                $scope.$on("$destroy", function() {
                    console.log('unbind wa pusher channel');
                    vm.channel.unbind();
                });
            /* Treatments */
            /*
            vm.treatmentsList = [];
            TreatmentService.categories().then(function (data) {
                vm.treatmentsList = data;
            });
            vm.subscriptionsList = [];
            SubscriptionService.all({
                search: 1,
                searchFields: 'active:='
            }).then(function (response) {
                vm.subscriptionsList = response.data.data;
            });
            */
            vm.customerSelected = null;
            vm.messageToSend = null;
            vm.userSelectedMessagesList = [];
            vm.templateSelected = null;
            vm.lastUserMessageInH24 = false;
            //---------- Customers Table -------------------------------------//
            vm.today = new Date(moment().hours(0).minutes(0).seconds(0));
            vm.yesterday = new Date(moment(vm.today).subtract(1, 'days'));
            vm.customerStatus = {
                showDatePicker: false,
                selectedIndexFilter: undefined,
                selectedIndex: undefined,
                filter_date_start: null,
                call_state: CallState,
                needDatePicker: function () {
                    this.showDatePicker = true;
                },
                onChange: function () {

                    vm.query.page = 1;

                    if (vm.activeCustomer && angular.isDefined(this.selectedIndex))
                        vm.activeCustomer.call_state = this.call_state[this.selectedIndex]

                    this.needDatePicker();

                },
                onChangeDateFilter: function () {

                    var date = this.filter_date_start;

                    return function (item) {

                        if (!date)
                            return true;

                        if (date && !item.call_date)
                            return false;

                        if (item.call_date)
                            return moment(date).isSame(moment(item.call_date)) || moment(date).isBefore(moment(item.call_date));

                        return true;

                    };
                },
                setIndex: function () {

                    if (vm.activeCustomer && vm.activeCustomer.call_state && ~this.call_state.indexOf(vm.activeCustomer.call_state))
                        vm.customerStatus.selectedIndex = this.call_state.indexOf(vm.activeCustomer.call_state);
                    else
                        vm.customerStatus.selectedIndex = undefined;

                    this.needDatePicker();

                },
            };
            vm.selected = [];
            vm.options = {
                autoSelect: false,
                boundaryLinks: true,
                pageSelector: true,
                rowSelection: false
            };
            vm.filter = {
                options: {
                    'debounce': 0,
                    'updateOn': 'default'
                }
            };
            vm.query = {
                filter: '',
                filter_user_id: (vm.user.type=='callcenter' && !vm.user.ext_f_cs?vm.user.id:null),
                off: 0,
                order: '',
                limit: 10,
                page: 1,
                filter_date_app: moment().subtract(1,'month').format('YYYY-MM-DD')
            };
            //$log.info(vm.query);
            vm.rememberSelected = function() {
                localStorage.setItem( 'whatsapp_customerSelected',  vm.customerSelected.phone  );
            };
            vm.unRememberSelected = function() {
                localStorage.removeItem( 'whatsapp_customerSelected');
            };
            vm.restoreLastSelected = function () {
                //if (true) return;
                var phone = localStorage.getItem('whatsapp_customerSelected');
                if (phone!=null) {
                    vm.query.filter =  phone;
                }
            };
            if (phone) {
                vm.query.filter = phone;
            } else {
                vm.restoreLastSelected();
            }

            vm.customersList = [];
            vm.eListLoading = false;
            vm.firstLoad = false;
            vm.mergeCheckOk = false;
            vm.customersListPag = { "total": 0, "count": 10, "per_page": 10, "current_page": 1, "total_pages": 0, "links": {} };
            vm.loadingCustomersList = false;
            vm.loadingMessagesList = false;
            // vm.customersListLoad(vm.query.page,10);
            vm.onKeyPressSearch = function (event) {
                $log.info(event);
                if (!event || event.keyCode == 13) {
                    vm.customersListLoad(1);
                    if (event) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }
            }

            /**
             * riordina i dati in base alla colonna selezionata
             * @param {} column
             */
            vm.customersListReOrder = function (column) {
                vm.query.order = column;
                vm.customersListLoad(1);
            };

                /* Users */
            vm.userRolesListAll = []
            vm.userRolesListCall = [];
            vm.userRolesLoad = function () {
                if (vm.userRolesListAll.length==0) {
                    var pars = {with: 'user'};
                    return UsersService.allRoles( pars ).then( function( response ) {
                        if( response.data && response.data.data ) {
                            vm.userRolesListAll = response.data.data;
                            //$log.info(vm.userRolesListAll);
                            //$log.info(vm.userRolesList);
                            vm.userRolesListCall = vm.filterRolesXRole('callcenter');
                            //$log.info(vm.userRolesListCall);
                        }
                    });
                } else {
                    vm.userRolesListCall = vm.filterRolesXRole('callcenter');
                }
            };
            vm.filterRolesXRole = function (role) {
                var fs = {active: true, role: role};
                return $filter('filter')(vm.userRolesListAll, fs, true);
            };
            vm.userRolesLoad();

            vm.storeId = undefined;
            vm.store = {};
            $scope.$watch( '$parent.selectedStore', function( id ) {
                vm.storeId = id;
                vm.store = {};
                if( angular.isDefined( id )) {
                    if (id>0) {
                        angular.forEach($scope.$parent.main.storesList, function (s) {
                        if (s.id == vm.storeId) {
                            vm.store = s;
                        }
                        });
                    }
                    vm.customersListLoad();
                }
            });


            vm.sendMessage = function(template) {
                vm.messageToSend = vm.messageToSend?vm.messageToSend.trim():'';
                var message = {
                    'customer_id':  vm.customerSelected.customer_id,
                    'message': vm.messageToSend
                }

                if (template) {
                    if  (vm.templateSelected) {
                        message.template = vm.templateSelected.name;
                    } else {
                        return;
                    }
                } else {
                    if(vm.messageToSend=='') {
                        return;
                    }
                }
                $log.info('Salva');
                CrudService
                    .save( 'customer_messages', message, vm ,
                        function(response) {
                            var messageTmp = response.data.data;
                            messageTmp.user = vm.user;
                            messageTmp.created_at_formatted = vm.formatDate(messageTmp.created_at);
                            vm.userSelectedMessagesList.push(messageTmp);
                            vm.scrollToId = messageTmp;
                            vm.messageToSend = '';
                        },
                        function(response) {
                            $log.info(response);
                        }
                );

            };

            /**
             *al click sulla riga imposta il customerSelected e poi richiama la funzione per la visualizzazione dei messaggi
             * di quell'utente.
             * @param {*} customer
             */
            vm.rowClicked = function (customer) {
                if (!vm.customerSelected || customer.customer_id != vm.customerSelected.customer_id) {
                    vm.customerSelected = customer;
                    vm.rememberSelected();
                    vm.getWaTemplates();
                    vm.userSelectedMessagesList = [];
                    vm.messageToSend = null;
                    vm.templateSelected = null;
                    vm.currentPage = 1;
                    vm.pagination = null;
                    vm.loadingMessagesList = false;
                    //vm.getCustomerMessages(); //lo fa il componente
                }
            };
            vm.testsVisible = false;
            vm.isDeleteAllowed = true;
            vm.undoVisible = false;
            vm.img_loading = false;

            vm.loading = false;
            vm.activeCustomer = {};
            vm.backup_customer = {};
            vm.update_customer = {};
            vm.empty_customer = {};
            vm.phoneChecking = false;

        } catch (err) {
            $log.info('error:', err);
        }


        /**
         * alla ricezione del messaggio wapp:
         * se ho il customer nell'elenco dei customer lo metto in cima alla lista
         * se non c'è lo aggiungo in cima all'array
         * in ogni caso visualizzo il toast con il nome di chi l'ha inviato e il messaggio
         * @param {*} data
         */
        vm.onWAMessageRecived = function( data ) {
            $log.info("onWAMessageRecived wa");
            //$log.info(data);
            var customerMessage = null;
            var customerMessageIndex = null;
            if(data && data.customer) {
                var toShow = false;
                for(var i=0; i<vm.customersList.length; i++) {
                    if(vm.customersList[i].customer_id == data.customer.id) {
                        customerMessage = vm.customersList[i];
                        customerMessageIndex = i;
                        toShow = true;
                        break;
                    }
                }
                if(customerMessage) {
                    vm.customersList.splice(customerMessageIndex,1);
                    customerMessage.unreaded_count = data.unreaded;
                    customerMessage.last_date = moment().format("YYYY-MM-DD H:mm:ss");
                    customerMessage.last_date_frmt = moment().format("HH:mm:ss");
                    customerMessage.order_date = moment().format("YYYY-MM-DD H:mm:ss");
                    customerMessage.order_date_frmt = moment().format("HH:mm:ss");
                    vm.customersList.unshift(customerMessage);
                } else {
                    if(vm.user.type=='admin'
                        || (vm.user.store_id && data.customer.last_store_id && data.customer.last_store_id == vm.user.store_id)
                        || (vm.user.type=="callcenter" &&
                            (data.customer.user_id == vm.user.id
                            || vm.user.delegate1_user_id && data.customer.user_id == vm.user.delegate1_user_id
                            || vm.user.delegate2_user_id && data.customer.user_id == vm.user.delegate2_user_id ))){

                        toShow = true;
                        var newUser = [{
                            firstname: data.customer.firstname,
                            customer_id: data.customer.id,
                            last_date: moment().format("YYYY-MM-DD H:mm:ss"),
                            last_date_frmt: moment().format("H:mm:ss"),
                            order_date: moment().format("YYYY-MM-DD H:mm:ss"),
                            order_date_frmt: moment().format("H:mm:ss"),
                            lastname: data.customer.lastname,
                            phone: data.customer.phone,
                            unreaded_count: data.unreaded
                        }];

                        if (data.customer.user_id) {
                            console.log(vm.userRolesListAll);
                            var fs = {user_id: data.customer.user_id};
                            var roles = $filter('filter')(vm.userRolesListAll, fs, true);
                            if (roles && roles.length>0) {
                                console.log(roles[0]);
                                if (!roles[0].user.alias) {
                                    roles[0].user.alias = (roles[0].user.firstname+'   ').substring(0,3)+'.'+(roles[0].user.lastname+'   ').substring(0,3);
                                }
                                newUser[0].user = {data: roles[0].user};
                            }
                        }

                        vm.customersList = newUser.concat(vm.customersList);
                    }

                }
                if (toShow) {
                    vm.showActionToast(data.customer.firstname + ': ' +  data.message);
                }
            }
        };

        /**
         * quando i messaggi vengono letti azzera gli eventuali sospesi della lista
         * @param {*} data
         */
        vm.onWaNotify = function(data) {
            $log.info("onWaNotify wa");
            //$log.info(data);
            if(data && data.customer) {

                for(var i=0; i<vm.customersList.length; i++) {
                    if(vm.customersList[i].customer_id == data.customer.id) {
                        vm.customersList[i].unreaded_count = data.unreaded;
                        break;
                    }
                }
            }
        };



        /**
         * recupera l'elenco dei messaggi in base all'id dell'utente selezionato
         */
        //FATTO DAL COMPONENTE
        /*vm.getCustomerMessages = function () {
            var pars = {
                'search': 'customer_id:' + vm.customerSelected.customer_id,
                'searchFields': 'customer_id:=',
                'orderBy': 'id',
                'sortedBy': 'desc',
                'page': vm.currentPage,
                'with': 'user',
                'reset_unreaded' : vm.reset_unreaded,
                'customer_id': vm.customerSelected.customer_id,
                'c_role': vm.user.type
            };
            vm.loadingMessagesList = true;
            vm.scrollToId = null;
            CrudService.all('customer_messages', pars, vm,
                function (response) {
                    if(response && response.data && response.data.data){
                        vm.pagination = response.data.data;
                        var tmpArray = response.data.data.data.reverse();
                        if(tmpArray.length >0) {
                            vm.scrollToId=tmpArray[tmpArray.length-1];
                        }

                        angular.forEach(tmpArray, function (element) {
                            if(element.created_at != null){
                                element.created_at_formatted = vm.formatDate(element.created_at);
                            }
                        });

                        if(vm.userSelectedMessagesList.length == 0) {
                            vm.userSelectedMessagesList = tmpArray;
                        } else {
                            vm.userSelectedMessagesList = tmpArray.concat(vm.userSelectedMessagesList);
                        }
                    }
                    vm.loadingMessagesList = false;
                },
                function (response) {
                    var errMsg = "";
                    if (response.data != null
                        && response.data.message != null) {
                        errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                        var url = response.config != null && response.config.url != null ? response.config.url : "";
                        if (url != null) {
                            errMsg += "\nUrl: " + url;
                        }
                    }
                    alert("Si è verificato un errore nel caricamento dei messaggi: " + errMsg);
                    vm.loadingMessagesList = false;
                });
        }*/

        /**
         * formatta la data da formato db (YYYY-MM-DD HH:MM) a formato user (DD-MM-YYYY HH:MM)
         * @param {*} dataDaFormattare
         */
        vm.formatDate = function (dataDaFormattare) {

            var dt = moment(dataDaFormattare);
            if (moment().format('YYYY-MM-DD') == dt.format(('YYYY-MM-DD'))) {
                return dt.format('H:mm:ss');
            } else {
                return dt.format('DD/MM/YYYY H:mm');
            }
        }

        vm.removeSearch = function() {
            vm.query.filter = "";
            vm.query.filter_user_id = vm.user.type=='callcenter'?vm.user.id:null;
            vm.unRememberSelected();
            vm.customersListLoad(1);
        };

        /**
         * carica l'elenco degli utenti
         */
        vm.customersListLoad = function (p,s) {
            vm.customerSelected = null;
            vm.customersList = [];
            if(p == null) {
                p = 1;
            }
            if (s==null) {
                s = parseInt(vm.customersListPag.per_page);
            }
            var pars = {
                's': s,
                'filtro': vm.query.filter,
                'with': 'user',
                'page': p,
                'c_role': vm.user.type,
                'exclude_callcenter': vm.exclude_callcenter
            };
            if (vm.query.filter_user_id) {
                pars.filter_user_id = vm.query.filter_user_id;
            }
            if(vm.storeId) {
                pars.filter_last_store_id = vm.storeId;
            }
            vm.loadingCustomersList = true;
            $http.get(vm.env.API + '/customer_messages_all', { 'params': pars })
                .then(
                    function (response) {
                        angular.forEach(response.data.data, function (element) {
                            element.last_date_frmt = vm.formatDate(element.last_date);
                            element.order_date_frmt = vm.formatDate(element.order_date);
                            element.unreaded_count = parseInt(element.unreaded_count);
                            element.id = element.customer_id;//usato dal componente bl-whatsapp
                            vm.customersList.push(element);
                        });
                        vm.customersListPag = response.data.meta.pagination;
                        //console.log('vm.customersListPag', vm.customersListPag);
                        if (vm.customersList.length == 1) {
                            vm.rowClicked(vm.customersList[0]);
                        }
                        vm.firstLoad = true;
                        vm.loadingCustomersList = false;
                    },
                    function (response) {
                        var errMsg = "";
                        if (response.data != null
                            && response.data.message != null) {
                            errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                            var url = response.config != null && response.config.url != null ? response.config.url : "";
                            if (url != null) {
                                errMsg += "\nUrl: " + url;
                            }
                        }
                        alert("Si è verificato un errore nel caricamento degli utenti: " + errMsg);
                        vm.loadingCustomersList = false;
                    });
        }
        vm.scrollInizialized = false;

        /**
         * alla fine del caricamento della renderizzazione dell'elenco dei messaggi:
         * 1) scrollo il div che li contiene all'ultimo arrivato/inviato(quindi verso il basso)
         * 2) controllo lo scroll del div e quando arrivo al più recente(quindi in alto) carico altri messaggi
         * se ce ne sono ancora(lo controllo dalla paginazione)
         * @param {*} message
         */
        vm.finishedLoadMessages = function (message) {
                $timeout(function() {
                    if( vm.scrollToId != null) {
                        var selettoreLast = "#message-"+ vm.scrollToId.id;
                        var rowLast = $(selettoreLast);
                        var wappMessagesContainer = $('.whatsapp-messages-container');
                        if (rowLast != null) {
                            var top = null;
                            top = rowLast.get(0).offsetTop;
                            wappMessagesContainer.animate({ scrollTop: top }, 10);
                        }

                        if(!vm.scrollInizialized){
                            wappMessagesContainer.scroll(function() {
                                if( this.scrollTop == 0  && !vm.loadingMessagesList)  {
                                    if(vm.pagination && vm.pagination.last_page > vm.currentPage) {
                                        vm.currentPage ++;
                                        vm.getCustomerMessages();
                                    }
                                }
                            });
                            vm.scrollInizialized = true;
                        }
                    }

                }, 100);
        }

        /**
         * visualizzi il toast
         * @param {*} text
         */
        vm.showActionToast = function( text) {
            text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent(text)
                .action('')
                .highlightAction(true)
                .position('bottom right');
            return $mdToast
                .show(toast)
                .finally(
                    function() {
                        toast = undefined;
                    }
                );
        };

        vm.onTemplateSelezionato = function() {
            vm.messageToSend = vm.templateSelected.blade;
        }

        vm.isLastUserMessageInH24 = function() {
            var customerLastMessageTimeStamp = moment(vm.customerSelected.last_date).valueOf();
            var yesterdayTimeStamp = moment().subtract(1, 'days').valueOf();
            return customerLastMessageTimeStamp > yesterdayTimeStamp;
        }

        vm.waTemplatesList =[];
        vm.getWaTemplates = function() {
            vm.waTemplatesList =[];
            var pars = {
                'search': 'document_type_id:150',
                'searchFields': 'document_type_id:='
            }
            CrudService.all('document_templates', pars, vm,
                function (response) {
                    if(response && response.data && response.data.data){
                        vm.waTemplatesList = response.data.data;
                    }
                },
                function (response) {
                    var errMsg = "";
                    if (response.data != null
                        && response.data.message != null) {
                        errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                        var url = response.config != null && response.config.url != null ? response.config.url : "";
                        if (url != null) {
                            errMsg += "\nUrl: " + url;
                        }
                    }
                    alert("Si è verificato un errore nel caricamento dei template: " + errMsg);
                });
        }


    };

    WhatsappController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            '$http',
            '$pusher',
            'CustomerService',
            'env',
            'phone',
            'CallState',
            'Italia',
            'TreatmentService',
            'StoreService',
            'SubscriptionService',
            'UsersService',
            'CrudService'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('TreatmentsController', TreatmentsController);

    /** @ngInject */
    function TreatmentsController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        StoreService,
        UsersService, 
        CrudService
    ) {
        var vm = this;
        vm.env = env;
        $log.info('TreatmentsController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
        	return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        vm.query = {
            filter: '',
            order: 'name',
            active: 1
        };
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.order = 'name';
            ab.query.active = 1;
        };
        vm.eList = [];
		vm.loading = true;
        vm.eListLoad = function() {
        	vm.eList = [];
			vm.loading = true;
			vm.query.filter = '';
        	var pars = {with: 'category;capability'};
        	CrudService.all('treatments', pars, vm, 
        		function(response) {
	                if (response.data && response.data.data && response.data.data.length) {
	                    vm.eList = response.data.data;
	                }
					vm.loading = false;
        		},
        		function () {
					vm.loading = false;
        		}
            );
        };
        vm.eListLoad();
        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(e) {
          if (vm.env.isMaster &&  (vm.user.type == 'admin' || vm.user.type=='backoffice')) {
            vm.toggleRight(e);
          }
        };
        vm.activeEntity = {};
        vm.updateEntity = {};
        vm.toggleRight = function(e) {
        	if (e!=null && e.id != null) {
				angular.copy(e, vm.updateEntity)
                vm.activeEntity = vm.updateEntity;
				/*if (vm.activeEntity.active==1) {
					vm.activeEntity.active = true;
				} else if (vm.activeEntity.active==0) {
					vm.activeEntity.active = false;
				}*/
            } else {
				vm.updateEntity = {};
				vm.activeEntity = {
                	id: null,
                	active: 1
                };
            }
            $timeout($mdSidenav('right').open, 0);
        };
        vm.resetAll = function() {
			vm.activeEntity = {}
			vm.updateEntity = {}
            $scope.entityForm.$setPristine();
            $scope.entityForm.$setUntouched();
        };
        vm.closeSidebar = function() {
			vm.resetAll();
        	$mdSidenav('right').close();
        };
        vm.saving = false;
        vm.save = function(e) {
            $log.info('Salva');
            if (angular.isDefined(e)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler salvare?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {	
                        		vm.saving = true;
								CrudService
                                    .save( 'treatments', vm.activeEntity, vm ,
										function(response) {
                                    		if (vm.activeEntity.id) {
                                    			var id = vm.activeEntity.id;
                                    			vm.activeEntity.max_app = parseInt(response.data.data.max_app);
                                    			var position = vm.eList.map( function( x ) { return x.id; } ).indexOf( id );
                                        		angular.copy(vm.activeEntity, vm.eList[position]);
                                    		} else {
                                    			vm.eList.push(response.data.data);	
                                    		}
                                    		vm.closeSidebar();
                                    		vm.saving = false;
										},
										function(response) {
											vm.saving = false;
										});
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };
		
		vm.del = function ( id ) {
            $log.info( 'Del' );
            if( angular.isDefined( id ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler eliminare questo abbonamento?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            CrudService.del( 'treatments', id, vm, 
								function( response ) {
                            		var position = vm.eList.map( function( x ) { return x.id; } ).indexOf( id );
                            		vm.eList.splice(position, 1);
								},
								function( response ) {
								}
							);
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };

    };

    TreatmentsController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',            
            'StoreService',
            'UsersService',
            'CrudService'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')

        .factory('TodayService', function(Restangular, moment, $log) {

            var service = Restangular
                .withConfig(function(RestangularConfigurer) {
                    RestangularConfigurer.addElementTransformer('appointments', false, function(element) {

                       element.start = moment(element.date_start).toDate();
                       delete element.date_start;
                       element.end = moment(element.date_end).toDate();
                       delete element.date_end;
                       // $log.info(element);
                       element.type = 'hair-removal';
                       element.title = element.treatment.data.name + " - " + element.customer.data.firstname;
                       return element;
                    })
                    .setRequestInterceptor(function(element, operation) {
                       $log.info(operation);
                       if(operation == 'put' || operation == 'post') {
                           element.date_start = moment(element.start).format('YYYY-MM-DD HH:mm:ss');
                           delete element.start;
                           element.date_end = moment(element.end).format('YYYY-MM-DD HH:mm:ss');
                           delete element.end;
                           //console.log(element);
                           
                           return element;
                        }
                    });
                })
                .all('appointments');

            service.all = function(options){
                return service.getList(options);
            };

            service.save = function(data){
                return service.post(data);  
            };

            return service;
        });
        
})();
(function() {
    'use strict';

    angular
        .module('admin')
  
        // restituisce solo i minuti da un time
        // .filter( 'splitMinutesFilter', function() {
        //     return function( time ) {
        //         if (typeof time != "undefined") {
        //             var partsOfStr = time.split(':');
        //         }
        //         return parseInt(partsOfStr[1]);
        //     }
        // })

        // restituisce solo i minuti da un time
        .filter( 'splitMinutesFilter', function() {
            return function( time ) {
                return moment.duration(time).asMinutes();
            }
        })


        // dice se l'attività passata è attiva in questo momento (true/false) 
        .filter( 'activeActivityFilter', function($filter) {
            return function( activity, appointmentSelected ) {
                var start = appointmentSelected.start;
                var end = moment();
                var now = moment();
                var duration = 0;
                var is_active = false;

                angular.forEach(appointmentSelected.treatment.data.activities.data, function(one_activity) {
                    duration = $filter('splitMinutesFilter')(one_activity.duration);
                    end = moment(start).add(duration, 'minutes');

                    if(start < now && end > now && one_activity == activity){
                        is_active = true;
                    }else{
                        start = end;
                    }
                });

                return is_active;
            }
        })


        // restituisce i tempo di inizio e fine di un'attività (9:00 - 10:00)
        .filter( 'startendActivityFilter', function($filter) {
            return function( activity, appointmentSelected ) {
                var start = appointmentSelected.start;
                var end = start;
                var startend = '';
                var duration = 0;

                angular.forEach(appointmentSelected.treatment.data.activities.data, function(one_activity) {
                    duration = $filter('splitMinutesFilter')(one_activity.duration);
                    end = moment(start).add(duration, 'minutes');
                    if(one_activity == activity){
                        startend = moment(start).format('H:mm')+' - '+moment(end).format('H:mm');
                    }
                    start = end

                });

                return startend;
            }
        })




})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .controller( 'TodayController', TodayController )
    ;

    /** @ngInject */
    function TodayController(
        $log,
        $http,
        $scope,
        $window,
        uiCalendarConfig,
        $interval,
        $timeout,
        $mdDialog,
        moment,
        TodayService,
        env,
        UsersService,
        OperatorAvailabilityService
    ) {
        var vm = this;
        $log.info( 'TodayController' );
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.env = env;
        vm.today = new Date( moment() );
        vm.filter_date_start = vm.today;
        vm.checkDateStart = function() {
            vm.load();
        };
        /* Click su icona Commerciale */
        vm.commercial = function() {
            var content = '';
            angular.forEach( vm.appointmentSelected.treatment.data.commercials.data, function( elem ) {
                if( elem.id === vm.appointmentSelected.user_times ) {
                    content += '<h4>' + elem.title + '</h4>';
                    content += '<p>' + elem.description + '</p>';
                };
            });

            var confirm = $mdDialog.alert({
                title: 'Fase commerciale',
                ariaLabel: 'Fase commerciale',
                htmlContent: ( content ? content : '<h4>Nessuna informazione trovata</h4>' ),
                ok: 'Ho capito',
                preserveScope: true,
                onComplete: function() {
                    vm.Timer = $timeout( function() {
                        $mdDialog.hide();
                    }, 10000 );
                },
                onRemoving:function() {
                    $timeout.cancel( vm.Timer );
                },
            });

            return $mdDialog
                .show( confirm )
                .finally(
                    function() {
                        confirm = undefined;
                    }
                )
            ;
        };

        // ---------- Calendar -------------------------------------//
        // calcolo l'altezza del calendario e quella del dettaglio trattamenti
        // in base a quella della pagina
        vm.calendarHeight = function(){
            vm.headerHeight = angular.element( '.header' ).outerHeight( true );
            vm.calHeight = $window.innerHeight - vm.headerHeight - 90;
            $timeout( function() {
                vm.threatmentHeight = angular.element( '.fc-body' ).outerHeight( true );
                angular.element('.flex-container').height( vm.threatmentHeight );
            }, 50 );
        };
        vm.calendarHeight();
        angular.element(window).resize(function(){
            vm.calendarHeight();
            uiCalendarConfig.calendars.myCalendar.fullCalendar( 'option', 'height', vm.calHeight );
        });


        // click su appuntamento
        vm.selEvent = null;
        vm.appointmentOnClick = function( event ) {
            if( event.id != 'currenttime' ){
                vm.appointmentSelected = event;
                event.selected = true;
                /**
                 * devo mettere evidenziato
                 */
                if (vm.selEvent) {
                    vm.selEvent.css('background-color','');
                }
                $(this).css('background-color', 'yellow');
                vm.selEvent = $(this);
                var d = event.date_start?moment(event.date_start):moment(event.start);
                var df = d.format(vm.usageDateFormat);
                if (vm.usageSelected!=df) {
                     vm.renderUsage(df);
                }
            };
        };


        // time line che avanza
        vm.setCurrentTime = function( view ) {
            if( view ) {
                if (true || view.start.isSame(moment(), 'day')) {
                    view.calendar.removeEvents( "currenttime" );
                    view.calendar.renderEvent(
                        {
                            id: "currenttime",
                            title: "Current Time",
                            start: moment().format(),
                            end: moment().add(1, 'minutes').format(),
                            className: "current-time-event",
                            editable: false
                        }, true
                    );
                    var row = $( ".current-time-event" );
                    // $log.info(row);
                    if (row && row.position() && row.position().top) {
                        var top = row.position().top;
                        // alert(top);
                        $('.fc-scroller').animate({scrollTop: top-30}, 10);
                        // calendar.fullCalendar( 'gotoDate', vm.scrollTo.date
                        // );
                    }
                } else {
                    $log.info("start<>oggi");
                }
            };
            return true;
        };
        vm.timeLine = function( view ) {
            if ( view.name == "agendaWeek" || view.name == "agendaDay" ) {
                $timeout( function() {
                    vm.setCurrentTime( view );
                }, 2000 );
                $.doTimeout( "currenttime", 60000, vm.setCurrentTime );
            } else {
                $.doTimeout( "currenttime" );
                view.calendar.removeEvents("currenttime");
            };
        };


        vm.uiConfig = {
            calendar: {
                defaultDate: moment( vm.filter_date_start ),
                height: vm.calHeight,
                defaultView: 'agendaDay',
                editable: false,
                dayNamesShort: [ 'Dom\n', 'Lun\n', 'Mar\n', 'Mer\n', 'Gio\n', 'Ven\n', 'Sab\n' ],
                header: {
                    right: 'agendaWeek agendaDay',
                    left: 'prev,next today title'
                    // right: '',
                    // left: 'title'
                    // left: 'title agendaDay agendaWeek month',
                },
                businessHours: {
                    start: '08:00:00',
                    end: '21:30:00',
                    dow: [ 1, 2, 3, 4, 5, 6 ]
                },
                minTime: '08:00:00',
                maxTime: '21:30:00',
                timeFormat: 'HH:mm',
                axisFormat: 'H',
                titleFormat: 'D MMMM - YYYY',
                allDaySlot: false,
                eventClick: vm.appointmentOnClick,
                viewRender: function(view, element) {
                    $log.info("View Changed");
                    // $log.info(view);
                    // $log.info(element);
                    vm.view = view;
                    // $log.info("Start: ", view.start.format('YYYY-MM-DD
                    // HH:mm'));
                    // $log.info("End: ", view.end.format('YYYY-MM-DD HH:mm'));
                    vm.filter_date_start = view.start;
                    // $log.info(moment(vm.filter_date_start).toDate());
                    vm.filter_date_end = view.end;
                    // $log.info(vm.filter_date_end.toDate());

                    if (!vm.loading) {
                        vm.load();
                    }
                    var today = moment().format('YYYY-MM-DD');
                    vm.view_isCurrentPeriod = false;
                    if (view.type=='agendaDay' || view.type=='agendaWeek') {
                        if (moment(view.start).format('YYYY-MM-DD')<=today && moment(view.end).format('YYYY-MM-DD')>=today) {
                            vm.view_isCurrentPeriod = true;
                        }
                    }

                },
                eventRender: function ( event, element ) {
                    $log.info(event);
                    if( event.type ) {
                        element.addClass( 'type-' + event.type );
                    };
                    if (event.role) {
                        element
                        .find('.fc-time')
                        .prepend("<div class=\"operator-circle\" style=\"background-color: "+event.role.data.color+";\"></div>");
                    }
                    if (event.selected) {
                        element.css('background-color','yellow');
                    }
                }
            }
        };


        // prendo gli appuntamenti della giornata odierna confermati e
        // dell'operatrice loggata
        vm.appointmentsList = [];
        vm.eventSources = [];
        vm.resetEvents = function() {
            var calendar = angular.element( '#mycalendar' );
            if( calendar ) {
                calendar.fullCalendar( 'removeEvents' );
                calendar.fullCalendar( 'addEventSource', vm.appointmentsList );
                /*
                 * if (vm.view && (vm.view.name == 'agendaDay' || vm.view.name ==
                 * 'agendWeek') && vm.view_isCurrentPeriod) { alert ("dovrei
                 * andare a "+moment()); calendar.fullCalendar( 'gotoDate',
                 * moment() ); }
                 */
                calendar.fullCalendar( 'rerenderEvents' );
            };
            if (false && vm.appointmentsList.length>0) {
                vm.appointmentSelected = vm.appointmentsList[ 0 ];
            } else {
                vm.appointmentSelected = {};
            }
            vm.loading = false;
        };
        vm.reRenderEvents = function() {
            // altrimenti il calendario non si aggiorna in tempo
            // return $timeout( vm.resetEvents, 50 );
            vm.resetEvents();
        };
        vm.newSetEvents = function( events ) {
            // return $timeout(
            // function() {
                    vm.buildResourceUsage(events);
                    vm.appointmentsList = events;
                    vm.eventSources = [ events ];
                    vm.timeLine(vm.view);
           // }
           // , 50 );
        };
        /**
         * Classe Usage
         */
        vm.usageDateFormat = 'D MMMM - YYYY';
        vm.usageFirst = 480;
        vm.usageLast = 21*60; //== fino alle 21
        vm.usageSteps =(vm.usageLast-vm.usageFirst)/5;

        function Usage(type) {
            this.type = type;
            this.chart = null;
            this.usedCount = 0;
            this.availabilityCount = 0;
            this.minutes = [];
            this.available = [];
            // array dalle 8 == 480 che sarà lo 0 alle 21.55 == 1315 che sarà
            for (var i=0; i<vm.usageSteps; i++) {
                this.minutes.push(0);
                this.available.push(0);
            }
        };
        Usage.prototype.addAvailability = function(from, to, val) {
            if (!val) {
                val = 1;
            }
            if (!from) {
                from = vm.usageFirst;
            }
            if (!to) {
                to = vm.usageLast-5;
            }
            while(from<=to) {
                  var i = from/5-vm.usageFirst/5;
                  if (i>=0 && i<vm.usageSteps) {
                      this.available[i] = this.available[i] + val;
                      this.availabilityCount++;
                  }
              from+=5;
            }
        };
        Usage.prototype.addUsage = function (from, to) {
          // $log.info(this.type + " -> addUsage: " + from + ".." + to);
          while(from<=to) {
            var i = from/5-vm.usageFirst/5;
            // $log.info(this.type + " -> addUsage: " + from + "=>" + i);
            if (i>=0 && i<vm.usageSteps) {
                this.minutes[i] = this.minutes[i] + 1;
                this.usedCount++;
            }
          from+=5;
          }
       };
       Usage.prototype.setChart = function (c) {
           this.chart = c;
       };

       Usage.prototype.loadMachineryAvailability = function(sid, mid, df) {
           var q = this;
           $http.get(vm.env.API+"/machinery_store_available/"+sid+"/"+mid+"/"+df).then(
                   function(response) {
                       q.addAvailability(null, null, response.data.data.quantity);
                       if(q.chart!=null) {
                           q.chart.update();
                       }
                   },
                   function(response){
                     $log.info(response);
                   }
           );
       };
       Usage.prototype.loadOperatorAvailability = function(sid, uid, df) {
           var q = this;
           OperatorAvailabilityService.all(
                   {     search: "store_id:"+sid + ";date:"+df+";user_id:"+uid,
                       searchFields: "store_id:=;date:=;user_id:="
                   }
               ).then(
                   function( data ) {
                    //$log.info(data);
                        angular.forEach(data, function(r) {
                       q.addAvailability(r.minute_start, r.minute_end-5);
                        });
                    if(q.chart!=null) {
                       q.chart.update();
                    }
                },
                function(response){
                  $log.info(response);
                }
           );
       };
       Usage.prototype.loadAssistAvailability = function(sid, df) {
           var q = this;
           OperatorAvailabilityService.all(
                   {     search: "store_id:"+sid + ";date:"+df+";reserved:4",
                       searchFields: "store_id:=;date:=;reserved:="
                   }
               ).then(
                   function( data ) {
                    //$log.info(data);
                        angular.forEach(data, function(r) {
                       q.addAvailability(r.minute_start, r.minute_end-5);
                        });
                    if(q.chart!=null) {
                       q.chart.update();
                    }
                },
                function(response){
                  $log.info(response);
                }
           );
       };
        vm.usageUsers = [];
        vm.usageUsersGet = function(df, d, app) {
            // $log.info(app.role.data);
            var key = 'user_'+app.role.data.user_id;
            var label = app.role.data.user.lastname + " " + app.role.data.user.firstname;
            if (!vm.usageUsers[df]) {
                vm.usageUsers[df] = [];
            }
            var uu = vm.usageUsers[df];
            if (!uu[key]) {
                uu[key] = {
                    'label': label,
                    'color': app.role.data.color,
                    'usage': new Usage('operator')
                };
                /**
                 * TODO caricare availability per utente in questa data
                 */
                uu[key].usage.loadOperatorAvailability(vm.storeId, app.role.data.user_id, d.format('YYYY-MM-DD'));
            }
            return uu[key];
        };
        vm.usageLabels = [];
        for(var i=vm.usageFirst; i<vm.usageLast; i=i+5) {
              var min = "0"+(i % 60);
              min = min.substring(min.length-2);
              var all = i - (i % 60);
              vm.usageLabels.push(''+Math.round(all/60)+":"+min);
              // $log.info(''+Math.round(all/60)+":" + min + " == "+ i);
          }
          // $log.info(vm.usageLabels);
        vm.usageAssists = [];
        vm.usageAssistsGet = function(df, d) {
            if (!vm.usageAssists[df]) {
                vm.usageAssists[df] = {
                    'label': 'Assistenti',
                    'usage': new Usage('assist')
                }
                vm.usageAssists[df].usage.loadAssistAvailability(vm.storeId, d.format('YYYY-MM-DD'));
            }
            return vm.usageAssists[df];
        };
        vm.usageRooms = [];
        vm.usageRoomsGet = function(d) {
            if (!vm.usageRooms[d]) {
                vm.usageRooms[d] = {
                    'label': 'Cabine',
                    'usage': new Usage('room')
                }
                vm.usageRooms[d].usage.addAvailability(null, null, vm.store.rooms);
            }
            return vm.usageRooms[d];
        };
        vm.usageMachineries = [];
        vm.usageMachineriesGet = function(df, d, act) {
            var key = act.machinery.name;
            var label = act.machinery.name;
            if (!vm.usageMachineries[df]) {
                vm.usageMachineries[df] = [];
            }
            var uu = vm.usageMachineries[df];
            if (!uu[key]) {
                uu[key] = {
                    'label': label,
                    'usage': new Usage('machinery')
                };
                uu[key].usage.loadMachineryAvailability(vm.storeId, act.machinery_id,d.format('YYYY-MM-DD'));
            }
            return uu[key];
        };
        vm.resetUsage = function() {
            vm.usageUsers = [];
            vm.usageRooms = [];
            vm.usageAssists = [];
            vm.usageMachineries = [];
            $('#operChartContainer').html("");
            $('#areaChartContainer').html("");
        };
        vm.buildResourceUsage = function(apps) {
            vm.resetUsage();
            var firstD = null;
            angular.forEach(apps, function(app) {
                var d = app.date_start?moment(app.date_start):moment(app.start);
                var df = d.format(vm.usageDateFormat);
                if (firstD == null) {
                    firstD = df;
                }
                var uUser = vm.usageUsersGet(df, d, app);
                var uUserAssist = null;
                if (app.assist_user) {
                    uUserAssist = vm.usageUsersGet(df, d, app, 'assist');
                }
                var uRoom = vm.usageRoomsGet(df);
                var uAssist = vm.usageAssistsGet(df, d);
                var from = d.get('hour')*60+d.get('minute');
                var begin = d.get('hour')*60+d.get('minute');
                from = from - from % 5;
                begin = begin - begin % 5;
                var to = from+app.treatment.data.min_duration-5;
                if (uRoom) {
                    uRoom.usage.addUsage(from, to);
                }
                angular.forEach(app.treatment.data.activities.data, function(act) {
                    var dur = moment.duration(act.duration).asMinutes();
                    if (dur<5) {dur = 5};
                    from = begin + act.minute_start;
                    to = from + dur - 5;
                    if (act.machinery_id) {
                        var uMachinery = vm.usageMachineriesGet(df, d, act);
                        if (uMachinery) {
                            uMachinery.usage.addUsage(from, to);
                        }
                    }
                    if (act.type == 'operator') {
                        if (uUser) {
                            uUser.usage.addUsage(from, to);
                        }
                    } else if (act.type == 'assist') {
                        if (uAssist) {
                            uAssist.usage.addUsage(from, to);
                        }
                    }
                    //$log.info("from="+from+" to="+to+" done!");
                    from = to+5;
                });
            });
            if(firstD) {
                vm.renderUsage(firstD);
            }
            //$log.info(vm.usageUsers);
            // $log.info(vm.usageRooms);
            // $log.info(vm.usageAssists);
            // $log.info(vm.usageMachineries);
        };

        /*
         * Grafici utilizzo risorse
         */
        vm.usageSelected = null;
        vm.renderUsage = function(d) {
            vm.usageSelected = d;
            var areaChartOptions = {
                      maintainAspectRatio : false,
                      responsive : true,
                      legend: {
                        display: true
                      },
                      scales: {
                        xAxes: [{
                          gridLines : {
                            display : true,
                          }
                        }],
                        yAxes: [{
                          gridLines : {
                            display : true,
                          },
                          ticks: {
                              beginAtZero: true,
                              callback: function(value) {if (value % 1 === 0) {return value;}}
                          }
                        }]
                      }
                    };


            /**
             * Grafici operatrici
             */
            // $log.info("html->"+$('#operChartContainer').html());

            var i=0;
            for(var k in vm.usageUsers[d]) {
                var us = vm.usageUsers[d][k];
                //$log.info(k,us);
                $('#areaChartU_'+i).remove();
                $('#operChartContainer').append('<canvas id="areaChartU_'+i+'" style="min-height: 150px; height: 150px; max-height: 150px; max-width: 100%;"></canvas>');
                var areaChartUCanvas = $('#areaChartU_'+i).get(0).getContext('2d');
                var areaChartUData = {
                  labels  : vm.usageLabels,
                  datasets: [
                    {
                          label               : us.label + " occ.",
                          backgroundColor     : us.color,
                          borderColor         : us.color,
                          pointRadius          : 1,
                          pointColor          : '#3b8bba',
                          pointStrokeColor    : us.color,
                          pointHighlightFill  : '#fff',
                          pointHighlightStroke: us.color,
                          data                : us.usage.minutes
                    },
                      {
                            label               : us.label + " disp.",
                        backgroundColor     : 'rgba(210,214,222,1)',
                        borderColor         : 'rgba(210,214,222,1)',
                        pointRadius         : 1,
                        pointColor          : 'rgba(210,214,222,1)',
                        pointStrokeColor    : '#c1c7d1',
                        pointHighlightFill  : '#fff',
                        pointHighlightStroke: 'rgba(220,220,220,1)',
                            data                : us.usage.available
                      }
                  ]
                };
                var c = new Chart(areaChartUCanvas, {
                      type: 'line',
                      data: areaChartUData,
                      options: areaChartOptions
                    });
                us.usage.setChart(c);
                i++;
            };


            // REMOVE OLD CHART IF EXIST
            $('#areaChartContainer').append('<canvas id="areaChartR" style="min-height: 250px; height: 250px; max-height: 250px; max-width: 100%;"></canvas>');
            $('#areaChartContainer').append('<canvas id="areaChartA" style="min-height: 250px; height: 250px; max-height: 250px; max-width: 100%;"></canvas>');
            $('#areaChartContainer').append('<canvas id="areaChartL" style="min-height: 250px; height: 250px; max-height: 250px; max-width: 100%;"></canvas>');


            var areaChartRCanvas = $('#areaChartR').get(0).getContext('2d');
            var areaChartACanvas = $('#areaChartA').get(0).getContext('2d');
            var areaChartLCanvas = $('#areaChartL').get(0).getContext('2d');

            var areaChartRData = {
              labels  : vm.usageLabels,
              datasets: [
                {
                      label               : vm.usageRooms[d].label + " occ.",
                      backgroundColor     : 'rgba(60,141,188,0.5)',
                      borderColor         : 'rgba(60,141,188,0.5)',
                      pointRadius          : 1,
                      pointColor          : '#3b8bba',
                      pointStrokeColor    : 'rgba(60,141,188,0.5)',
                      pointHighlightFill  : '#fff',
                      pointHighlightStroke: 'rgba(60,141,188,0.5)',
                      data                : vm.usageRooms[d].usage.minutes
                },
                {
                      label               : vm.usageRooms[d].label + " disp.",
                    backgroundColor     : 'rgba(210,214,222,1)',
                    borderColor         : 'rgba(210,214,222,1)',
                    pointRadius         : 1,
                    pointColor          : 'rgba(210,214,222,1)',
                    pointStrokeColor    : '#c1c7d1',
                    pointHighlightFill  : '#fff',
                    pointHighlightStroke: 'rgba(220,220,220,1)',
                      data                : vm.usageRooms[d].usage.available
                }
              ]
            };
            new Chart(areaChartRCanvas, {
                  type: 'line',
                  data: areaChartRData,
                  options: areaChartOptions,
                });
            var areaChartAData = {
                labels  : vm.usageLabels,
                datasets: [
                  {
                        label               : vm.usageAssists[d].label +" occ.",
                      backgroundColor     : 'rgba(0,166,90,0.5)',
                    borderColor         : 'rgba(0,166,90,0.5)',
                    pointRadius         : 1,
                    pointColor          : '#00A65A',
                    pointStrokeColor    : 'rgba(0,166,90,0.5)',
                    pointHighlightFill  : '#fff',
                    pointHighlightStroke: 'rgba(0,166,90,0.5)',
                    data                : vm.usageAssists[d].usage.minutes
                  },
                {
                      label               : vm.usageAssists[d].label + " disp.",
                    backgroundColor     : 'rgba(210,214,222,1)',
                    borderColor         : 'rgba(210,214,222,1)',
                    pointRadius         : 1,
                    pointColor          : 'rgba(210,214,222,1)',
                    pointStrokeColor    : '#c1c7d1',
                    pointHighlightFill  : '#fff',
                    pointHighlightStroke: 'rgba(220,220,220,1)',
                      data                : vm.usageAssists[d].usage.available
                }
                ]
              };
            var c = new Chart(areaChartACanvas, {
                  type: 'line',
                  data: areaChartAData,
                  options: areaChartOptions,
                });
            vm.usageAssists[d].usage.setChart(c);
            if (vm.usageMachineries && vm.usageMachineries[d] && vm.usageMachineries[d]['Laser']) {
                var areaChartLData = {
                        labels  : vm.usageLabels,
                        datasets: [{
                        label               : vm.usageMachineries[d]['Laser'].label + ' occ.',
                        backgroundColor     : 'rgba(243,156,18,0.5)',
                        borderColor         : 'rgba(243,156,18,0.5)',
                        pointRadius         : 1,
                        pointColor          : '#f39c12',
                        pointStrokeColor    : 'rgba(243,156,18,0.5)',
                        pointHighlightFill  : '#fff',
                        pointHighlightStroke: 'rgba(243,156,18,0.5)',
                        data                : vm.usageMachineries[d]['Laser'].usage.minutes
                        },
                      {
                            label               : vm.usageMachineries[d]['Laser'].label + " disp.",
                        backgroundColor     : 'rgba(210,214,222,1)',
                        borderColor         : 'rgba(210,214,222,1)',
                        pointRadius         : 1,
                        pointColor          : 'rgba(210,214,222,1)',
                        pointStrokeColor    : '#c1c7d1',
                        pointHighlightFill  : '#fff',
                        pointHighlightStroke: 'rgba(220,220,220,1)',
                            data                : vm.usageMachineries[d]['Laser'].usage.available
                      }
                        ]
                };
                //$log.info(vm.usageMachineries[d]['Laser'].usage.available);
                var c = new Chart(areaChartLCanvas, {
                    type: 'line',
                    data: areaChartLData,
                    options: areaChartOptions,
                  });
                vm.usageMachineries[d]['Laser'].usage.setChart(c);
            }
        };


        vm.loading = true;
        vm.load = function() {
            vm.loading = true;
            vm.appointmentsList = [];
            vm.eventSources = [];
            if (!vm.storeId) {
                vm.reRenderEvents();
                return;
            }
            var options = {
                with : 'role;treatment;customer;treatment.activities;treatment.commercials',
                search :
                    'recalled:3' +
                    ';date_start:' + moment( vm.filter_date_start ).format( 'YYYY-MM-DD' ) +
                    ';date_end:' + moment( vm.filter_date_end?vm.filter_date_end:vm.filter_date_start ).add( 1, 'd' ).format( 'YYYY-MM-DD' ) +
                    ';store_id:' + vm.storeId
                ,
                searchFields : 'confirmed:=;date_start:>;date_end:<;store_id:=;recalled:<',
                s: 9999 // per bypassare la paginazione
            };
            TodayService
                .all( options )
                .then( vm.newSetEvents )
                .finally( vm.reRenderEvents )
            ;
        };



        /* Timer to check if everything has loaded correctly */
        vm.Timer = undefined;
        vm.StartTimer = function () {
            vm.Timer = $interval( function () {
                if( angular.isDefined( $scope.selectedStore ) && angular.isDefined( vm.userId ) ) {
                    if( vm.user_type !== 'admin' ) {
                        vm.StopTimer();
                    };
                };
            }, 500 );
        };
        vm.StopTimer = function () {
            if ( angular.isDefined( vm.Timer ) ) {
                $interval.cancel( vm.Timer );
                $interval( function(){
                    vm.commercial();
                }, 1810000 );
            };
        };
        vm.StartTimer();


        // ---------- Activities -------------------------------------//
        vm.choosenActivity = {};
        vm.activityDetail = function ( activity ) {
            vm.choosenActivity = activity;
            $scope.activity = activity;

            var content = '';
            angular.forEach( vm.choosenActivity.description, function( elem ) {
                content += '<h4>' + elem.title + ' ' + elem.time +'</h4>';
                content += '<p>' + elem.description + '</p>';
            });

            var confirm = $mdDialog.alert({
                title: 'Dettaglio Attività',
                ariaLabel: 'Dettaglio Attività',
                htmlContent: ( content ? content : '<h4>Nessuna informazione trovata</h4>' ),
                ok: 'Ho capito',
                preserveScope: true,
                onComplete: function() {
                    vm.timerActivity = $timeout( function() {
                        $mdDialog.hide();
                    }, 10000 );
                },
                onRemoving:function() {
                    $timeout.cancel( vm.timerActivity );
                },
            });

            return $mdDialog
                .show( confirm )
                .finally(
                    function() {
                        confirm = undefined;
                    }
                )
            ;
        };
        vm.machineries = [];
        vm.loadMachineries = function() {
            $http.get(vm.env.API+'/machinery_stores?store_id='+vm.storeId).then(function(response){
                vm.machineries = response.data.data;
                //$log.info(response.data.data);
            }, function(response){
                $log.info(response);
            });
        };
        vm.availabilityIntervalDailyReport = function () {
            window.open(env.API+"/operator-availability-interval-daily"
                +"?store_id="+(vm.storeId)
                +"&start="+moment( vm.filter_date_start ).format( 'YYYY-MM-DD' )
                +"&end="+moment( vm.filter_date_end?vm.filter_date_end:vm.filter_date_start ).format( 'YYYY-MM-DD' )
                +"&token="+vm.token
                +"&assist=0"
            );
        };
        /* Watcho lo Store */
        vm.storeId = null;
        vm.storesList = null;
        vm.store = null;
        $scope.$watch( '$parent.selectedStore', function( id ) {
            if( angular.isDefined( id ) ) {
                vm.storeId = id;
                if (vm.storesList == null) {
                    vm.storesList = $scope.$parent.main.storesList;
                }
                angular.forEach(vm.storesList, function(el) {
                    if (el.id == id) {
                        vm.store = el;
                    }
                });
                vm.load();
            };
        });
    };
})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('SubscriptionsController', SubscriptionsController);

    /** @ngInject */
    function SubscriptionsController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        StoreService,
        UsersService,
        CrudService
    ) {
        var vm = this;
        vm.env = env;
        $log.info('SubscriptionsController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
        	return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        vm.query = {
            filter: '',
            order: 'name',
            active: 1
        };
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.order = 'name';
            ab.query.active = 1;
        };
        vm.eList = [];
		vm.loading = true;
        vm.eListLoad = function() {
        	vm.eList = [];
			vm.loading = true;
			vm.query.filter = '';
        	var pars = {};
        	CrudService.all('subscriptions', pars, vm,
        		function(response) {
	                if (response.data && response.data.data && response.data.data.length) {
	                    vm.eList = response.data.data;
	                }
					vm.loading = false;
        		},
        		function () {
					vm.loading = false;
        		}
            );
        };
        vm.eListLoad();
        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(e) {
          if ( (vm.env.tenant == 'Morepa' || vm.env.tenant == 'Lombardia' || vm.env.isMaster) &&  (vm.user.type == 'admin' || vm.user.type=='backoffice')) {
            vm.toggleRight(e);
          }
        };
        vm.activeEntity = {};
        vm.updateEntity = {};
        vm.toggleRight = function(e) {
        	if (e!=null && e.id != null) {
				angular.copy(e, vm.updateEntity)
                vm.activeEntity = vm.updateEntity;
				/*if (vm.activeEntity.active==1) {
					vm.activeEntity.active = true;
				} else if (vm.activeEntity.active==0) {
					vm.activeEntity.active = false;
				}*/
            } else {
				vm.updateEntity = {};
				vm.activeEntity = {
                	id: null,
                	active: 1
                };
            }
            $timeout($mdSidenav('right').open, 0);
        };
        vm.resetAll = function() {
			vm.activeEntity = {}
			vm.updateEntity = {}
            $scope.entityForm.$setPristine();
            $scope.entityForm.$setUntouched();
        };
        vm.closeSidebar = function() {
			vm.resetAll();
        	$mdSidenav('right').close();
        };
        vm.saving = false;
        vm.save = function(e) {
            $log.info('Salva');
            if (angular.isDefined(e)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler salvare?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {
                        		vm.saving = true;
								CrudService
                                    .save( 'subscriptions', vm.activeEntity, vm ,
										function(response) {
                                    		if (vm.activeEntity.id) {
                                    			var id = vm.activeEntity.id;
                                    			vm.activeEntity.max_app = parseInt(response.data.data.max_app);
                                    			var position = vm.eList.map( function( x ) { return x.id; } ).indexOf( id );
                                        		angular.copy(vm.activeEntity, vm.eList[position]);
                                    		} else {
                                    			vm.eList.push(response.data.data);
                                    		}
                                    		vm.closeSidebar();
                                    		vm.saving = false;
										},
										function(response) {
											vm.saving = false;
										});
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };

		vm.del = function ( id ) {
            $log.info( 'Del' );
            if( angular.isDefined( id ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler eliminare questo abbonamento?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            CrudService.del( 'subscriptions', id, vm,
								function( response ) {
                            		var position = vm.eList.map( function( x ) { return x.id; } ).indexOf( id );
                            		vm.eList.splice(position, 1);
								},
								function( response ) {
								}
							);
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };

    };

    SubscriptionsController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',
            'StoreService',
            'UsersService',
            'CrudService'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('StorageStateController', StorageStateController);

    /** @ngInject */
    function StorageStateController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        StoreService,
        UsersService,
        CrudService
    ) {
        var vm = this;

        //flag primo caricamento
        vm.firstLoad = true;

        $log.info('StorageStateController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        var current = moment();

        vm.query = {
            filter: '',
            supplierId: null,
            month: current.format('MM'),
            year: current.format('YYYY'),
            qty: 0,
            order: '',
            page: 1
        };
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.supplierId = '';
            vm.query.order = '';
            vm.query.qty = 0;
            vm.query.page = 1;
            vm.query.filterGiacenzaInfMin = 0;
            var cm = current.format('MM');
            var cy = current.format('YYYY');
            if (cm!=vm.query.month || cy!=vm.query.year) {
                vm.query.month = cm;
                vm.query.year = cy;
            }
            vm.eListLoad(1);
        };
        vm.years = [];
        for (var i=2017; i<=parseInt(vm.query.year); i++) {
            vm.years.push(''+i);
        }
        vm.eList = [];
        vm.eListTotal = 0;
        vm.loading = true;
        vm.eListPag = {"total":0,"count":10,"per_page":10,"current_page":1,"total_pages":0,"links":{} };
        vm.options = {
                autoSelect: false,
                boundaryLinks: true,
                pageSelector: true,
                rowSelection: false,
            };


        vm.eListLoad = function(p, s) {
            vm.eList = [];
            vm.eListTotal = 0;
            if (!vm.storeId) {
                vm.loading = false;
                return;
            }
            vm.loading = true;
            if (p==null) {
                p = vm.query.page;
            }
            vm.query.page = p;
            //vm.saveStatus();
            if (s==null) {
                s = parseInt(vm.eListPag.per_page);
            }
            var pars = {page:p, s: s, firstLoad: vm.firstLoad, store_id: vm.storeId, searchJoin: 'and', orderBy: 'suppliers.name'};
            pars.with = "product";//products_storage_logs;orders_pending";
            var search = ["store_id:"+vm.storeId];
            var searchFields = ["store_id:="];

            if (vm.query.year && vm.query.month) {
                pars.yearmonth=vm.query.year+"-"+vm.query.month;
            }
            if (vm.query.filterGiacenzaInfMin) {
                pars.filterGiacenzaInfMin = 1;
            }
            if ((vm.query.filter!=null && vm.query.filter!='') || vm.query.supplierId) {
                var f = "";
                if (vm.query.supplierId) {
                    f="sid="+vm.query.supplierId + " ";
                }
                if (vm.query.filter!=null && vm.query.filter!='') {
                    f = f+vm.query.filter;
                }
                pars.filtro = f;
            }
            /*if (vm.query.supplierId!=null && vm.query.supplierId!='') {
                search.push('suppliers.id:',vm.query.supplierId);
                searchFields.push('suppliers.id:=');
            }*/

            pars.searchFields = searchFields.join(';');
            pars.search = search.join(';');
            CrudService.all('products_storage', pars, vm,
                function(response) {
                    if (response.data && response.data.data && response.data.data.data && response.data.data.data.length)
                    {
                        vm.eListPag = response.data.data;

                        if(vm.firstLoad) {
                            vm.storage_balance = response.data.balance;
                            vm.firstLoad=false;
                        }

                        var eList = response.data.data.data;
                        //setto supplier e data formattata
                        for (var i = 0; i<eList.length; i++) {
                            var el = eList[i];
                            el.created_at_frmt = moment(el.created_at).format('DD/MM/YYYY HH:mm');
                            angular.forEach(vm.suppliersList, function(s) {
                                if (el.product.supplier_id == s.id) {
                                    el.supplier = s;
                                }
                            });
                            /*el.inOrd = 0;
                            angular.forEach(el.orders_pending, function(o) {
                                el.inOrd+=o.pivot.qty;
                            });*/

                        }
                        //console.log("eList in prima ricezione:",eList);

                        vm.eList = eList;

                        var secpars = {};
                        search = ["store_id:"+vm.storeId];
                        searchFields = ["store_id:="];
                        secpars.searchFields = searchFields.join(';');
                        secpars.search = search.join(';');
                        vm.exportUrl = env.API+'/products_storage?'
                        +'&searchFields='+secpars.searchFields
                        +'&search='+secpars.search
                        +'&store_id='+vm.storeId
                        +'&export=true'
                        +'&token='+vm.token;
                    }
                   vm.loading = false;
                },
                function () {
                    vm.loading = false;
                }
            );
        };

        vm.onKeyPressSearch = function (event) {
            if (event.keyCode==13) {
                vm.eListLoad(1);
                event.stopPropagation();
                event.preventDefault();
            }
        }

        /**
         * Dettaglio scarico
         */
        vm.save = function(e) {
            if (e.type=='scarico') {
                e.add_qty = 0-e.qty;
            }
            e.product_id = vm.selectedPs.product_id;
            if (e.type == 'ordine') {
                e.supplier_id = vm.selectedPs.product.supplier_id;
                e.qty = e.ord_qty;
                CrudService.save( 'products_orders', e, vm ,
                        function(response) {
                            vm.closeSidebar();
                            vm.eListLoad();
                        },
                        function(response) {
                        });
            } else {
                CrudService.save( 'products_storage_log', e, vm ,
                    function(response) {
                        vm.firstLoad=true;
                        vm.closeSidebar();
                        vm.eListLoad();

                    },
                    function(response) {
                    });
            }
        };
        vm.toggleRight = function (type, ps) {
            /**
             * Svuoto la ricerca customers e la lista
            */
            vm.productsReset();
            var e = {
                user_id: vm.user.id,
                store_id: vm.storeId,
                created_at: new Date(),
                qty: 1,
                add_qty: 1,
                type: type
            };
            if (ps) {
                e.product_id = ps.product_id;
                e.rowselection= true;
                vm.selectedPs = ps;
                vm.productsList = [ps];
                e.ord_qty = ps.product.qta_xct;
            }
            vm.activeE = e;

            $mdSidenav( 'right' ).open();
        };
        vm.closeSidebar = function() {
            $mdSidenav( 'right' ).close();
        };
        vm.productsReset = function () {
            vm.productsList = [];
            vm.query.filter_product = '';
            vm.selectedPs = null;
        };
        /* Load Products */
        vm.productsList = [];
        vm.query.filter_product = '';
        vm.productsLoad = function ( ) {
            vm.productsList = [];
            var pars = {limit:30, orderBy: 'products.name', with: 'product', searchJoin: 'and'};
            var search = ['store_id:'+vm.storeId];
            var searchFields = ['store_id:='];
            if (vm.query.filter_product!=null && vm.query.filter_product!='') {
                pars.filtro = vm.query.filter_product;
            }
            if (search.length>0) {
                pars.search = search.join(";");
                pars.searchFields = searchFields.join(";");
            }
            return CrudService.all('products_storage', pars, vm,
                    function(response) {
                        if (response.data && response.data.data && response.data.data.data && response.data.data.data.length) {
                            var eList = response.data.data.data;

                            //setto supplier e data formattata
                            for (var i = 0; i<eList.length; i++) {
                                var el = eList[i].product;
                                angular.forEach(vm.suppliersList, function(s) {
                                    if (el.supplier_id == s.id) {
                                        el.supplier = s;
                                    }
                                });
                            }
                            vm.productsList = eList;
                            if (vm.productsList.length==0) {
                                vm.showActionToast("Nessun elemento trovato.");
                            }
                            vm.productsLoading = false;
                        };
                    }
                )
            ;
        };

        vm.onKeyUpProductsSearch = function (evento, obj) {
            if (evento.keyCode==13)  {
                vm.productsLoad();
                evento.stopPropagation();
                evento.preventDefault();
            }
        };

        /* WATCHO Lo Store */
        vm.storeId = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                vm.storeId = id;
                vm.firstLoad = true;
                vm.suppliersLoad();
            };
        });

        /* Prodotti */
        vm.suppliersList = [];
        vm.suppliersLoad = function() {
            vm.suppliersList = [];
            vm.suppliersLoading = true;
            CrudService.all('suppliers', {orderBy: 'name'}, vm,
                    function(response) {
                        if (response.data && response.data.data) {
                            vm.suppliersList = response.data.data;
                        }
                        vm.suppliersLoading = false;
                        vm.eListLoad(1);
                    },
                    function () {
                        vm.suppliersLoading = false;
                    }
            );
        };

        /**
         * Quagga
         */
        /*vm.config = {inputWH: '320x240'};
        var resultCollector = Quagga.ResultCollector.create({
            capture: true,
            capacity: 20,
            blacklist: [{
                code: "WIWV8ETQZ1", format: "code_93"
            }, {
                code: "EH3C-%GU23RK3", format: "code_93"
            }, {
                code: "O308SIHQOXN5SA/PJ", format: "code_93"
            }, {
                code: "DG7Q$TV8JQ/EN", format: "code_93"
            }, {
                code: "VOFD1DB5A.1F6QU", format: "code_93"
            }, {
                code: "4SO64P4X8 U4YUU1T-", format: "code_93"
            }],
            filter: function(codeResult) {
                // only store results which match this constraint
                // e.g.: codeResult
                return true;
            }
        });
        var App = {
            init: function() {
                var self = this;

                Quagga.init(this.state, function(err) {
                    if (err) {
                        return self.handleError(err);
                    }
                    //Quagga.registerResultCollector(resultCollector);
                    App.attachListeners();
                    App.checkCapabilities();
                    Quagga.start();
                });
            },
            handleError: function(err) {
                console.log(err);
            },
            checkCapabilities: function() {
                var track = Quagga.CameraAccess.getActiveTrack();
                var capabilities = {};
                if (typeof track.getCapabilities === 'function') {
                    capabilities = track.getCapabilities();
                }
                this.applySettingsVisibility('zoom', capabilities.zoom);
                this.applySettingsVisibility('torch', capabilities.torch);
            },
            updateOptionsForMediaRange: function(node, range) {
                console.log('updateOptionsForMediaRange', node, range);
                var NUM_STEPS = 6;
                var stepSize = (range.max - range.min) / NUM_STEPS;
                var option;
                var value;
                while (node.firstChild) {
                    node.removeChild(node.firstChild);
                }
                for (var i = 0; i <= NUM_STEPS; i++) {
                    value = range.min + (stepSize * i);
                    option = document.createElement('option');
                    option.value = value;
                    option.innerHTML = value;
                    node.appendChild(option);
                }
            },
            applySettingsVisibility: function(setting, capability) {
                // depending on type of capability
                if (typeof capability === 'boolean') {
                    var node = document.querySelector('input[name="settings_' + setting + '"]');
                    if (node) {
                        node.parentNode.style.display = capability ? 'block' : 'none';
                    }
                    return;
                }
                if (window.MediaSettingsRange && capability instanceof window.MediaSettingsRange) {
                    var node = document.querySelector('select[name="settings_' + setting + '"]');
                    if (node) {
                        this.updateOptionsForMediaRange(node, capability);
                        node.parentNode.style.display = 'block';
                    }
                    return;
                }
            },
            initCameraSelection: function(){
                var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();
                return Quagga.CameraAccess.enumerateVideoDevices()
                .then(function(devices) {
                    function pruneText(text) {
                        return text.length > 30 ? text.substr(0, 30) : text;
                    }
                    vm.devices = [];
                    devices.forEach(function(device) {
                        var $option = {}
                        $option.value = device.deviceId || device.id;
                        $option.name = pruneText(device.label || device.deviceId || device.id);
                        if (streamLabel === device.label) {
                            vm.App.state.inputStream.constraints.deviceId = $option.value;
                        }
                        vm.devices.push($option);
                    });
                    devices.forEach(function(device) {
                        if (device.label.indexOf('facing back')>=0) {
                            vm.App.state.inputStream.constraints.deviceId = device.deviceId || device.id;
                        }
                    });
                });
            },
            attachListeners: function() {
                var self = this;

                self.initCameraSelection();
                $(".controls").on("click", "button.stop", function(e) {
                    e.preventDefault();
                    Quagga.stop();
                    self._printCollectedResults();
                });

                $(".controls .reader-config-group").on("change", "input, select", function(e) {
                    e.preventDefault();
                    var $target = $(e.target),
                        value = $target.attr("type") === "checkbox" ? $target.prop("checked") : $target.val(),
                        name = $target.attr("name"),
                        state = self._convertNameToState(name);

                    console.log("Value of "+ state + " changed to " + value);
                    self.setState(state, value);
                });
            },
            _printCollectedResults: function() {
                var results = resultCollector.getResults(),
                    $ul = $("#result_strip ul.collector");

                results.forEach(function(result) {
                    var $li = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');

                    $li.find("img").attr("src", result.frame);
                    $li.find("h4.code").html(result.codeResult.code + " (" + result.codeResult.format + ")");
                    $ul.prepend($li);
                });
            },
            _accessByPath: function(obj, path, val) {
                var parts = path.split('.'),
                    depth = parts.length,
                    setter = (typeof val !== "undefined") ? true : false;

                return parts.reduce(function(o, key, i) {
                    if (setter && (i + 1) === depth) {
                        if (typeof o[key] === "object" && typeof val === "object") {
                            Object.assign(o[key], val);
                        } else {
                            o[key] = val;
                        }
                    }
                    return key in o ? o[key] : {};
                }, obj);
            },
            _convertNameToState: function(name) {
                return name.replace("_", ".").split("-").reduce(function(result, value) {
                    return result + value.charAt(0).toUpperCase() + value.substring(1);
                });
            },
            detachListeners: function() {
                $(".controls").off("click", "button.stop");
                $(".controls .reader-config-group").off("change", "input, select");
            },
            applySetting: function(setting, value) {
                var track = Quagga.CameraAccess.getActiveTrack();
                if (track && typeof track.getCapabilities === 'function') {
                    switch (setting) {
                    case 'zoom':
                        return track.applyConstraints({advanced: [{zoom: parseFloat(value)}]});
                    case 'torch':
                        return track.applyConstraints({advanced: [{torch: !!value}]});
                    }
                }
            },
            stateChanged: function(path, value) {
                var values = vm.config.inputWH.split('x');
                vm.App.state.inputStream.constraints.width = {min: parseInt(values[0])};
                vm.App.state.inputStream.constraints.height = {min: parseInt(values[1])};
                //vm.App.state.decoder = this.inputMapper.decoder.readers(vm.config.decoder);

                console.log(JSON.stringify(this.state));
                App.detachListeners();
                Quagga.stop();
                App.init();
            },
            inputMapper: {
                inputStream: {
                    constraints: function(value){
                        if (/^(\d+)x(\d+)$/.test(value)) {
                            var values = value.split('x');
                            return {
                                width: {min: parseInt(values[0])},
                                height: {min: parseInt(values[1])}
                            };
                        }
                        return {
                            deviceId: value
                        };
                    }
                },
                numOfWorkers: function(value) {
                    return parseInt(value);
                },
                decoder: {
                    readers: function(value) {
                        if (value === 'ean_extended') {
                            return [{
                                format: "ean_reader",
                                config: {
                                    supplements: [
                                        'ean_5_reader', 'ean_2_reader'
                                    ]
                                }
                            }];
                        }
                        return [{
                            format: value + "_reader",
                            config: {}
                        }];
                    }
                }
            },
            state: {
                inputStream: {
                    type : "LiveStream",
                    constraints: {
                        width: {min: 640},
                        height: {min: 480},
                        facingMode: "environment",
                        aspectRatio: {min: 1, max: 2}
                    }
                },
                locator: {
                    patchSize: "large",
                    halfSample: true
                },
                numOfWorkers: 4,
                frequency: 10,
                decoder: {
                    readers : [
                        {
                            format: "ean_reader",
                            config: {
                            }
                        },
                        {
                        format: "ean_reader",
                        config: {
                            supplements: [
                                'ean_5_reader', 'ean_2_reader'
                            ]
                        }
                    }]
                },
                locate: false
            },
            lastResult : null
        };

        vm.App = App;
        //App.init();

        Quagga.onProcessed(function(result) {
            var drawingCtx = Quagga.canvas.ctx.overlay,
                drawingCanvas = Quagga.canvas.dom.overlay;

            if (result) {
                if (result.boxes) {
                    drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                    result.boxes.filter(function (box) {
                        return box !== result.box;
                    }).forEach(function (box) {
                        Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "green", lineWidth: 2});
                    });
                }

                if (result.box) {
                    Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
                }

                if (result.codeResult && result.codeResult.code) {
                    Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
                }
            }
        });

        Quagga.onDetected(function(result) {
            var code = result.codeResult.code;

            if (App.lastResult !== code) {
                App.lastResult = code;
                var $node = null, canvas = Quagga.canvas.dom.image;

                $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
                $node.find("img").attr("src", canvas.toDataURL());
                $node.find("h4.code").html(code);
                $("#result_strip ul.thumbnails").prepend($node);
            }
        });
        */
    };



    StorageStateController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',
            'StoreService',
            'UsersService',
            'CrudService'
        ];

})();


(function() {
    'use strict';

    angular
        .module('admin')
        .controller('StorageController', StorageController);

    /** @ngInject */
    function StorageController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        StoreService,
        UsersService, 
        CrudService
    ) {
        var vm = this;
        $log.info('StorageController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
        	return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        var current = moment();
        vm.query = {
            filter: '',
            supplierId: null,
            month: current.format('MM'),
            year: current.format('YYYY'),
            qty: 0,
            order: ''
        };
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.supplierId = '';
            vm.query.order = '';
            vm.query.qty = 0;
            var cm = current.format('MM');
            var cy = current.format('YYYY');
            if (cm!=vm.query.month || cy!=vm.query.year) {
	            vm.query.month = cm; 
	            vm.query.year = cy;
            }
            vm.eListLoad();
        };
        vm.years = [];
        for (var i=2017; i<=parseInt(vm.query.year); i++) {
        	vm.years.push(''+i);
        }
        vm.eList = [];
		vm.eListTotal = 0;
		vm.loading = true;
		vm.eListPag = {"total":0,"count":10,"per_page":10,"current_page":1,"total_pages":0,"links":{} };
		vm.options = {
            autoSelect: false,
            boundaryLinks: true,
            pageSelector: true,
            rowSelection: false,
		};
        vm.eListLoad = function(p,s) {
        	vm.eList = [];
        	vm.eListTotal = 0;
        	if (!vm.storeId) { 
        		vm.loading = false;
    			return;
        	}
        	vm.loading = true;
			if (p==null) {
        		p = vm.query.page;
        	}
        	vm.query.page = p;
        	//vm.saveStatus();
        	if (s==null) {
        		s = parseInt(vm.eListPag.per_page);
        	}
			var pars = {page:p, s: s, searchJoin: 'and', orderBy: 'products_storage_log.created_at', sortedBy: 'desc'};
			pars.with = "product;user;order;appointment;products_storage";
        	var search = ["store_id:"+vm.storeId];
        	var searchFields = ["store_id:="];
        	if (vm.query.year && vm.query.month) {
        		pars.yearmonth=vm.query.year+"-"+vm.query.month;
        	}
        	if ((vm.query.filter!=null && vm.query.filter!='') || vm.query.supplierId) {
        		var f = "";
        		if (vm.query.supplierId) {
        			f="sid="+vm.query.supplierId + " ";
        		}
        		if (vm.query.filter!=null && vm.query.filter!='') {
        			f = f+vm.query.filter;
        		}
        		pars.filtro = f;
        	}
        	/*if (vm.query.supplierId!=null && vm.query.supplierId!='') {
        		search.push('suppliers.id:',vm.query.supplierId);
        		searchFields.push('suppliers.id:=');
        	}*/
        	pars.searchFields = searchFields.join(';');
        	pars.search = search.join(';');
        	CrudService.all('products_storage_log', pars, vm, 
        		function(response) {
	                if (response.data && response.data.data && response.data.data.length) {
	                	var eList = response.data.data;
	                	vm.eListPag = response.data.meta.pagination;
	                	//setto supplier e data formattata
	                	for (var i = 0; i<eList.length; i++) {
	                		var el = eList[i];
	                		el.created_at_frmt = moment(el.created_at.date).format('DD/MM/YYYY HH:mm');
	                		angular.forEach(vm.suppliersList, function(s) {
	                			if (el.product.data.supplier_id == s.id) {
	                				el.supplier = {'data':s};
	                			}
	                		});
	                		angular.forEach($scope.$parent.main.storesList, function(s) {
	                			if (el.store_id == s.id) {
	                				el.store = s;
	                			}
	                		});
	                		
	                	}
	                	vm.eList = eList;
	                }
	                vm.loading = false;
        		},
        		function () {
					vm.loading = false;
        		}
            );
        };
        
        vm.onKeyPressSearch = function (event) {
        	if (event.keyCode==13) {
        		vm.eListLoad();
        		event.stopPropagation();
        		event.preventDefault();
        	}
        }
        
        /**
         * Dettaglio scarico
         */
        vm.save = function(e) {
        	e.add_qty = 0-e.qty;
        	e.product_id = vm.selectedPs.product_id;
        	CrudService.save( 'products_storage_log', e, vm ,
				function(response) {
        			vm.closeSidebar();
        			vm.eListLoad();
				},
				function(response) {
				});
        };
        vm.toggleRight = function () {
        	/**
             * Svuoto la ricerca customers e la lista
            */
            vm.productsReset();
            var e = {
                user_id: vm.user.id,
                store_id: vm.storeId,
                created_at: new Date(),
                qty: 1
            };
            vm.activeE = e;
        
            $mdSidenav( 'right' ).open();
        };
        vm.closeSidebar = function() {
            $mdSidenav( 'right' ).close();
        };
        vm.productsReset = function () {
        	vm.productsList = [];
        	vm.query.filter_product = '';
        	vm.selectedPs = null;
        };
        /* Load Products */
        vm.productsList = [];
        vm.query.filter_product = '';        
        vm.productsLoad = function ( ) {
            vm.productsList = [];
            var pars = {size:30, orderBy: 'products.name', with: 'product', searchJoin: 'and'};
            var search = ['qty:0','store_id:'+vm.storeId];
            var searchFields = ['qty:>', 'store_id:='];
            if (vm.query.filter_product!=null && vm.query.filter_product!='') {
            	pars.filtro = vm.query.filter_product; 
            }
            if (search.length>0) {
            	pars.search = search.join(";");
            	pars.searchFields = searchFields.join(";");
            }
            return CrudService.all('products_storage', pars, vm, 
            		function(response) {
            			if (response.data && response.data.data && response.data.data.data && response.data.data.data.length) {
            				var eList = response.data.data.data;
    	                	//setto supplier e data formattata
    	                	for (var i = 0; i<eList.length; i++) {
    	                		var el = eList[i].product;
    	                		angular.forEach(vm.suppliersList, function(s) {
    	                			if (el.supplier_id == s.id) {
    	                				el.supplier = s;
    	                			}
    	                		});
    	                	}
                            vm.productsList = eList;
                            if (vm.productsList.length==0) {
                            	vm.showActionToast("Nessun elemento trovato.");
                            }
                            vm.productsLoading = false;
                        };
                    }
                )
            ;
        };
        vm.onKeyUpProductsSearch = function (evento, obj) {
        	if (evento.keyCode==13)  {
        		vm.productsLoad();
        		evento.stopPropagation();
        		evento.preventDefault();
        	}
        };
        
        vm.showInfo = function( sl ) {
        	var carico = sl.add_qty>0;
        	var label = (carico?'Carico':'Scarico');
        	var dialog = $mdDialog.confirm({
                  title: 'Info ' +label.toLowerCase()+ ' prodotto '+ sl.product.data.name,
                  ariaLabel: 'Info ' + label,
                  templateUrl: 'app/storage/dialogs/info.html',
                  escapeToClose: true,
                  controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                      $scope.title = this.title;
                      $scope.label = label;
                      $scope.button_ok = 'Chiudi';
                      $scope.questo = sl;
                      
                      $scope.type = label.toLowerCase();
                      $scope.close = function() {
                          $mdDialog.hide( true );
                      };
                  }]
            });
            return $mdDialog
            .show( dialog )
            .finally(
                function() {
                    dialog = undefined;
                }
            );
        };
        
        vm.showInfoApp = function( sl ) {
        	var dialog = $mdDialog.confirm({
                  title: 'Info vendita prodotto '+ sl.product.data.name,
                  ariaLabel: 'Info scarico',
                  templateUrl: 'app/storage/dialogs/appointment-info.html',
                  escapeToClose: true,
                  controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                      $scope.title = this.title;
                      $scope.button_ok = 'Chiudi';
                      $scope.questo = sl;
                      $scope.close = function() {
                          $mdDialog.hide( true );
                      };
                      $scope.origin = null;
                      $scope.loading = true;
                      $scope.loadOrigin = function () {
                          var pars = {};
                          pars.with = "treatment;user;customer";
                          if (sl.appointment_id != null) {
                            CrudService.get('appointments', sl.appointment_id, pars, vm, 
                            		function (response) {
	                                    $scope.origin = response.data.data;
	                                    vm.dateFormatApp($scope.origin);
	                                    $scope.loading = false;
	                                },
	                                 function (response) {
	                                	$scope.loading = false;
	                                });
	                      } else {
	                    	  $scope.loading = false;
	                      }
                       };
                       $scope.loadOrigin();
                  }]
            });
            return $mdDialog
            .show( dialog )
            .finally(
                function() {
                    dialog = undefined;
                }
            );
        };
        
        vm.showInfoOrder = function( sl ) {
        	var dialog = $mdDialog.confirm({
                  title: 'Info acquisto prodotto '+ sl.product.data.name,
                  ariaLabel: 'Info carico',
                  templateUrl: 'app/storage/dialogs/order-info.html',
                  escapeToClose: true,
                  controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                      $scope.title = this.title;
                      $scope.button_ok = 'Chiudi';
                      $scope.questo = sl;
                      $scope.close = function() {
                          $mdDialog.hide( true );
                      };
                      $scope.origin = null;
                      $scope.loading = true;
                      $scope.loadOrigin = function () {
                          var pars = {with: 'supplier;user' };
                          //pars.with = "treatment;user";
                          if (sl.order_id != null) {
                            CrudService.get('orders', sl.order_id, pars, vm, 
                            		function (response) {
	                                    $scope.origin = response.data.data;
	                                    vm.dateFormatOrder($scope.origin);
	                                    $scope.loading = false;
	                                },
	                                 function (response) {
	                                	$scope.loading = false;
	                                });
	                      } else {
	                    	  $scope.loading = false;
	                      }
                       };
                       $scope.loadOrigin();
                  }]
            });
            return $mdDialog
            .show( dialog )
            .finally(
                function() {
                    dialog = undefined;
                }
            );
        };
        vm.dateFormatApp = function(elem) {
        	elem.date_start_frmt = moment( elem.date_start ).format('DD/MM/YYYY HH:mm');
            elem.date_end_frmt = moment( elem.date_end ).format('HH:mm');
        };
        vm.dateFormatOrder = function(elem) {
        	elem.date_frmt = moment( elem.date ).format('DD/MM/YYYY');
        	elem.updated_at_frmt = moment( elem.updated_at ).format('DD/MM/YYYY HH:mm');
        	elem.sent_at_frmt = moment( elem.sent_at ).format('DD/MM/YYYY');
        };

        
        /* WATCHO Lo Store */
        vm.storeId = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                vm.storeId = id;
                vm.suppliersLoad();
            };
        });

        /* Prodotti */
        vm.suppliersList = [];
        vm.suppliersLoad = function() {
            vm.suppliersList = [];
			vm.suppliersLoading = true;
            CrudService.all('suppliers', {orderBy: 'name'}, vm,	
                	function(response) {
	                	if (response.data && response.data.data) {
	                		vm.suppliersList = response.data.data;
	                	}
						vm.suppliersLoading = false;
						vm.eListLoad();
                	},
                	function () {
						vm.suppliersLoading = false;
                	}
            );
        };
        
        /**
         * Quagga
         */
        /*vm.config = {inputWH: '320x240'};
        var resultCollector = Quagga.ResultCollector.create({
            capture: true,
            capacity: 20,
            blacklist: [{
                code: "WIWV8ETQZ1", format: "code_93"
            }, {
                code: "EH3C-%GU23RK3", format: "code_93"
            }, {
                code: "O308SIHQOXN5SA/PJ", format: "code_93"
            }, {
                code: "DG7Q$TV8JQ/EN", format: "code_93"
            }, {
                code: "VOFD1DB5A.1F6QU", format: "code_93"
            }, {
                code: "4SO64P4X8 U4YUU1T-", format: "code_93"
            }],
            filter: function(codeResult) {
                // only store results which match this constraint
                // e.g.: codeResult
                return true;
            }
        });
        var App = {
            init: function() {
                var self = this;

                Quagga.init(this.state, function(err) {
                    if (err) {
                        return self.handleError(err);
                    }
                    //Quagga.registerResultCollector(resultCollector);
                    App.attachListeners();
                    App.checkCapabilities();
                    Quagga.start();
                });
            },
            handleError: function(err) {
                console.log(err);
            },
            checkCapabilities: function() {
                var track = Quagga.CameraAccess.getActiveTrack();
                var capabilities = {};
                if (typeof track.getCapabilities === 'function') {
                    capabilities = track.getCapabilities();
                }
                this.applySettingsVisibility('zoom', capabilities.zoom);
                this.applySettingsVisibility('torch', capabilities.torch);
            },
            updateOptionsForMediaRange: function(node, range) {
                console.log('updateOptionsForMediaRange', node, range);
                var NUM_STEPS = 6;
                var stepSize = (range.max - range.min) / NUM_STEPS;
                var option;
                var value;
                while (node.firstChild) {
                    node.removeChild(node.firstChild);
                }
                for (var i = 0; i <= NUM_STEPS; i++) {
                    value = range.min + (stepSize * i);
                    option = document.createElement('option');
                    option.value = value;
                    option.innerHTML = value;
                    node.appendChild(option);
                }
            },
            applySettingsVisibility: function(setting, capability) {
                // depending on type of capability
                if (typeof capability === 'boolean') {
                    var node = document.querySelector('input[name="settings_' + setting + '"]');
                    if (node) {
                        node.parentNode.style.display = capability ? 'block' : 'none';
                    }
                    return;
                }
                if (window.MediaSettingsRange && capability instanceof window.MediaSettingsRange) {
                    var node = document.querySelector('select[name="settings_' + setting + '"]');
                    if (node) {
                        this.updateOptionsForMediaRange(node, capability);
                        node.parentNode.style.display = 'block';
                    }
                    return;
                }
            },
            initCameraSelection: function(){
                var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();
                return Quagga.CameraAccess.enumerateVideoDevices()
                .then(function(devices) {
                    function pruneText(text) {
                        return text.length > 30 ? text.substr(0, 30) : text;
                    }
                    vm.devices = [];
                    devices.forEach(function(device) {
                        var $option = {}
                        $option.value = device.deviceId || device.id;
                        $option.name = pruneText(device.label || device.deviceId || device.id);
                        if (streamLabel === device.label) {
                        	vm.App.state.inputStream.constraints.deviceId = $option.value;
                        }
                        vm.devices.push($option);
                    });
                    devices.forEach(function(device) {
                    	if (device.label.indexOf('facing back')>=0) {
                    		vm.App.state.inputStream.constraints.deviceId = device.deviceId || device.id;
                    	}
                    });
                });
            },
            attachListeners: function() {
                var self = this;

                self.initCameraSelection();
                $(".controls").on("click", "button.stop", function(e) {
                    e.preventDefault();
                    Quagga.stop();
                    self._printCollectedResults();
                });

                $(".controls .reader-config-group").on("change", "input, select", function(e) {
                    e.preventDefault();
                    var $target = $(e.target),
                        value = $target.attr("type") === "checkbox" ? $target.prop("checked") : $target.val(),
                        name = $target.attr("name"),
                        state = self._convertNameToState(name);

                    console.log("Value of "+ state + " changed to " + value);
                    self.setState(state, value);
                });
            },
            _printCollectedResults: function() {
                var results = resultCollector.getResults(),
                    $ul = $("#result_strip ul.collector");

                results.forEach(function(result) {
                    var $li = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');

                    $li.find("img").attr("src", result.frame);
                    $li.find("h4.code").html(result.codeResult.code + " (" + result.codeResult.format + ")");
                    $ul.prepend($li);
                });
            },
            _accessByPath: function(obj, path, val) {
                var parts = path.split('.'),
                    depth = parts.length,
                    setter = (typeof val !== "undefined") ? true : false;

                return parts.reduce(function(o, key, i) {
                    if (setter && (i + 1) === depth) {
                        if (typeof o[key] === "object" && typeof val === "object") {
                            Object.assign(o[key], val);
                        } else {
                            o[key] = val;
                        }
                    }
                    return key in o ? o[key] : {};
                }, obj);
            },
            _convertNameToState: function(name) {
                return name.replace("_", ".").split("-").reduce(function(result, value) {
                    return result + value.charAt(0).toUpperCase() + value.substring(1);
                });
            },
            detachListeners: function() {
                $(".controls").off("click", "button.stop");
                $(".controls .reader-config-group").off("change", "input, select");
            },
            applySetting: function(setting, value) {
                var track = Quagga.CameraAccess.getActiveTrack();
                if (track && typeof track.getCapabilities === 'function') {
                    switch (setting) {
                    case 'zoom':
                        return track.applyConstraints({advanced: [{zoom: parseFloat(value)}]});
                    case 'torch':
                        return track.applyConstraints({advanced: [{torch: !!value}]});
                    }
                }
            },
            stateChanged: function(path, value) {
            	var values = vm.config.inputWH.split('x');
            	vm.App.state.inputStream.constraints.width = {min: parseInt(values[0])};
            	vm.App.state.inputStream.constraints.height = {min: parseInt(values[1])};
            	//vm.App.state.decoder = this.inputMapper.decoder.readers(vm.config.decoder);
            	
                console.log(JSON.stringify(this.state));
                App.detachListeners();
                Quagga.stop();
                App.init();
            },
            inputMapper: {
                inputStream: {
                    constraints: function(value){
                        if (/^(\d+)x(\d+)$/.test(value)) {
                            var values = value.split('x');
                            return {
                                width: {min: parseInt(values[0])},
                                height: {min: parseInt(values[1])}
                            };
                        }
                        return {
                            deviceId: value
                        };
                    }
                },
                numOfWorkers: function(value) {
                    return parseInt(value);
                },
                decoder: {
                    readers: function(value) {
                        if (value === 'ean_extended') {
                            return [{
                                format: "ean_reader",
                                config: {
                                    supplements: [
                                        'ean_5_reader', 'ean_2_reader'
                                    ]
                                }
                            }];
                        }
                        return [{
                            format: value + "_reader",
                            config: {}
                        }];
                    }
                }
            },
            state: {
                inputStream: {
                    type : "LiveStream",
                    constraints: {
                        width: {min: 640},
                        height: {min: 480},
                        facingMode: "environment",
                        aspectRatio: {min: 1, max: 2}
                    }
                },
                locator: {
                    patchSize: "large",
                    halfSample: true
                },
                numOfWorkers: 4,
                frequency: 10,
                decoder: {
                    readers : [
                    	{
                            format: "ean_reader",
                            config: {
                            }
                        },
                    	{
                        format: "ean_reader",
                        config: {
                            supplements: [
                                'ean_5_reader', 'ean_2_reader'
                            ]
                        }
                    }]
                },
                locate: false
            },
            lastResult : null
        };

        vm.App = App;
        //App.init();

        Quagga.onProcessed(function(result) {
            var drawingCtx = Quagga.canvas.ctx.overlay,
                drawingCanvas = Quagga.canvas.dom.overlay;

            if (result) {
                if (result.boxes) {
                    drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                    result.boxes.filter(function (box) {
                        return box !== result.box;
                    }).forEach(function (box) {
                        Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "green", lineWidth: 2});
                    });
                }

                if (result.box) {
                    Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
                }

                if (result.codeResult && result.codeResult.code) {
                    Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
                }
            }
        });

        Quagga.onDetected(function(result) {
            var code = result.codeResult.code;

            if (App.lastResult !== code) {
                App.lastResult = code;
                var $node = null, canvas = Quagga.canvas.dom.image;

                $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
                $node.find("img").attr("src", canvas.toDataURL());
                $node.find("h4.code").html(code);
                $("#result_strip ul.thumbnails").prepend($node);
            }
        });
        */
        
    };

    StorageController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',            
            'StoreService',
            'UsersService',
            'CrudService'
        ];

})();


(function() {
    'use strict';

    angular
        .module('admin')
        .controller('ReviewsController', ReviewsController);

    /** @ngInject */
    function ReviewsController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        StoreService,
        UsersService,
        CrudService
    ) {
        var vm = this;
        vm.env = env;
        $log.info('ReviewsController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.rolesCanEditNotes = ["admin", "operator", "storemngr"];
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        vm.selectedS1 = [];
        vm.today = new Date( moment().hour(8).minute(0).second(0) );
        vm.removeSearch = function (tab) {
            if (!tab) {
                vm.query.filter = '';
                vm.query.order = '-createTime';
                vm.query.page = 1;
                vm.eStatus.filter_date_start = null;
                vm.eStatus.filter_date_end = null;
                vm.eStatus.selectedFilterStelle = null;
                vm.eListLoad(1);
            } else {
                vm.initQuery(tab);
                vm.initStatus(tab);
                vm.eListLoads[tab](tab, 1);
            }
        };

        vm.initQuery = function(tab) {
            if (!vm.query.surveis) {
                vm.query.surveis = { tab: {}};
            }
            if(!vm.query.surveis[tab]) {
                vm.query.surveis[tab] = {};
            }

            vm.query.surveis[tab].filter = '';
            vm.query.surveis[tab].order = '-created_at';
            vm.query.surveis[tab].limit = 10;
            vm.query.surveis[tab].limitOptions = [ 5, 10, 15, 20 ];

        }

        vm.initStatus = function(tab) {
            if (!vm.eStatus.surveis) {
                vm.eStatus.surveis = { tab: {}};
            }
            if(!vm.eStatus.surveis[tab]) {
                vm.eStatus.surveis[tab] = {};
            }
            vm.eStatus.surveis[tab].filter_date_start = null;
            vm.eStatus.surveis[tab].filter_date_end = null;
            vm.eStatus.surveis[tab].selectedFilterStelle = null;
            vm.eStatus.surveis[tab].selectedFilterStelleMax = null;
        }

        vm.initQueryAll = function() {
            vm.initQuery('S1');
        };

        vm.initStatusAll = function() {
            vm.initStatus('S1');
        };

        vm.filtersListStelle = [
            {
                value: 'ONE',
                name: "1"
            },
            {
                value: 'TWO',
                name: "2"
            },
            {
                value: 'THREE',
                name: "3"
            },
            {
                value: 'FOUR',
                name: "4"
            },
            {
                value: 'FIVE',
                name: "5"
            }
          ];

          vm.filtersListStelleSurvey = [
            {
                value: '1',
                name: "1"
            },
            {
                value: '2',
                name: "2"
            },
            {
                value: '3',
                name: "3"
            },
            {
                value: '4',
                name: "4"
            },
            {
                value: '5',
                name: "5"
            }
          ];

        vm.options = {
            autoSelect: false,
            boundaryLinks: true,
            pageSelector: true,
            rowSelection: false,
        };
        vm.filter = {
            options: {
                'debounce': 0,
                'updateOn': 'default'
            }
        };

        vm.eStatus = {
            filter_date_start: null,
            filter_date_end: null,
            selectedFilter: null,
            selectedFilterStelle: null
        };
        vm.query = {
            filter: '',
            order: '-createTime',
            limit: 10,
            limitOptions: [ 5, 10, 15, 20 ],
            page: 1
        };

        vm.initQueryAll();
        vm.initStatusAll();

        /*
        vm.userCanSetNotes = false; console.log("Stampo lo User"); console.log(vm.user);
        angular.forEach(vm.user.roles, function (role) {
            if(role.active && vm.rolesCanEditNotes.indexOf(role.role)!=-1) {
                vm.userCanSetNotes = true;
            }
        });
        */
        vm.userCanSetNotes = vm.rolesCanEditNotes.indexOf(vm.user.c_role)!=-1;
        vm.userCanSetNotesSurveis = {
            'S1': vm.rolesCanEditNotes.indexOf(vm.user.c_role)!=-1
        }

        vm.saveStatus = function () {
          //if (true) return;
          localStorage.setItem( 'Reviews_eStatus', angular.toJson( vm.eStatus, false ) );
          localStorage.setItem( 'Reviews_query', angular.toJson( vm.query, false ) );
        };
        vm.restoreStatus = function () {
          //if (true) return;
          var eStatus = angular.fromJson(localStorage.getItem('Reviews_eStatus'));
          if (eStatus!=null) {
            vm.eStatus = eStatus;
            if (!vm.eStatus.surveis) {
                vm.initStatusAll();
            }
          }
          var query = angular.fromJson(localStorage.getItem('Reviews_query'));
          if (query!=null) {
            vm.query =  query;
            if (!vm.query.surveis) {
                vm.initQueryAll();
            }
          }
        };
        vm.today = moment();
        vm.restoreStatus();
        vm.onKeyPressSearch = function (event, tab) {
            if (event.keyCode==13) {
                if (!tab) {
                    vm.eListLoad(1);
                } else {
                    vm.eListLoads[tab](tab, 1);
                }
                event.stopPropagation();
                event.preventDefault();
            }
        };

        vm.onChangeDateStart = function() {
            vm.query.page = 1;
            if( vm.eStatus.filter_date_start && vm.eStatus.filter_date_end ) {
                if( moment( vm.eStatus.filter_date_end ).hour(23).minute(59).second(59).isBefore( vm.eStatus.filter_date_start ) ) {
                    vm.eStatus.filter_date_end = null;
                }
            }
            vm.eListLoad(null);
        };
        vm.onChangeDateEnd = function() {
          vm.query.page = 1;
          if( vm.eStatus.filter_date_start && vm.eStatus.filter_date_end ) {
              if( moment( vm.eStatus.filter_date_end ).hour(23).minute(59).second(59).isBefore( vm.eStatus.filter_date_start ) ) {
                  vm.eStatus.filter_date_start = vm.eStatus.filter_date_end;
              }
          }
          vm.eListLoad(null);
        };
        vm.onChangeDateStartSurveis = function(tab) {
            vm.query.surveis[tab].page = 1;
            if( vm.eStatus.surveis[tab].filter_date_start && vm.eStatus.surveis[tab].filter_date_end ) {
                if( moment( vm.eStatus.surveis[tab].filter_date_end ).hour(23).minute(59).second(59).isBefore( vm.eStatus.surveis[tab].filter_date_start ) ) {
                    vm.eStatus.surveis[tab].filter_date_end = null;
                }
            }
            vm.eListLoads[tab](tab);
        };
        vm.onChangeDateEndSurveis = function(tab) {
          vm.query.surveis[tab].page = 1;
          if( vm.eStatus.surveis[tab].filter_date_start && vm.eStatus.surveis[tab].filter_date_end ) {
              if( moment( vm.eStatus.surveis[tab].filter_date_end ).hour(23).minute(59).second(59).isBefore( vm.eStatus.surveis[tab].filter_date_start ) ) {
                  vm.eStatus.surveis[tab].filter_date_start = vm.eStatus.surveis[tab].filter_date_end;
              }
          }
            vm.eListLoads[tab](tab);
        };

        vm.onChangeRateMin = function(tab) {
            vm.query.surveis[tab].page = 1;
            if( vm.eStatus.surveis[tab].selectedFilterStelle !==null && vm.eStatus.surveis[tab].selectedFilterStelleMax !==null ) {
                if( vm.eStatus.surveis[tab].selectedFilterStelle > vm.eStatus.surveis[tab].selectedFilterStelleMax ) {
                    vm.eStatus.surveis[tab].selectedFilterStelleMax = vm.eStatus.surveis[tab].selectedFilterStelle;
                }
            }
              vm.eListLoads[tab](tab);
          };

          vm.onChangeRateMax = function(tab) {
            vm.query.surveis[tab].page = 1;
            if( vm.eStatus.surveis[tab].selectedFilterStelle !==null && vm.eStatus.surveis[tab].selectedFilterStelleMax !==null ) {
                if( vm.eStatus.surveis[tab].selectedFilterStelle > vm.eStatus.surveis[tab].selectedFilterStelleMax ) {
                    vm.eStatus.surveis[tab].selectedFilterStelle = vm.eStatus.surveis[tab].selectedFilterStelleMax;
                }
            }
              vm.eListLoads[tab](tab);
          };

        vm.loading = true;
        vm.loadingSurveis = {'S1': false};
        vm.eList = [];
        vm.eListSurveis = {
            'S1': []
        };
        vm.eListPagSurveis = {
            'S1': {"total":0,"count":10,"per_page":10,"current_page":1,"total_pages":0,"links":{} }
        };
        vm.surveisIds = {
            'S1': 1
        }
        vm.eListLoads = {
            'S1': function(tab, p, s) {
                if (!tab) {
                    tab = 'S1';
                }
                vm.eListSurveis[tab] = [];
                vm.loadingSurveis[tab] = true;
                if (p==null) {
                    p = vm.query.surveis[tab].page;
                }
                vm.query.surveis[tab].page = p;
                if (s==null) {
                    s = parseInt(vm.eListPagSurveis[tab].per_page);
                }
                var pars = {page:p, s: s, searchJoin: 'and', with: 'store'};
                var search = ['survey_id:'+vm.surveisIds[tab]];
                var searchFields = ['survey_id:='];
                if (vm.query.surveis[tab].filter!=null && vm.query.surveis[tab].filter!='') {
                    pars.filtro=vm.query.surveis[tab].filter;
                }
                if (vm.storeId) {
                    var dField = 'store_id';
                    search.push(dField+":"+vm.storeId);
                    searchFields.push(dField+":=");
                }

                if (vm.eStatus.surveis[tab].filter_date_start!=null && vm.eStatus.surveis[tab].filter_date_start!='') {
                var dField = 'created_at';
                search.push(dField+":"+moment(vm.eStatus.surveis[tab].filter_date_start).format("YYYY-MM-DD"));
                searchFields.push(dField+":>=");
                }
                if (vm.eStatus.surveis[tab].filter_date_end!=null && vm.eStatus.surveis[tab].filter_date_end!='') {
                    pars.date_end = moment(vm.eStatus.surveis[tab].filter_date_end).add(1,'days').format("YYYY-MM-DD");
                }
                if (vm.eStatus.surveis[tab].selectedFilterStelle) {
                    pars.rateMin = vm.eStatus.surveis[tab].selectedFilterStelle;
                }
                if (vm.eStatus.surveis[tab].selectedFilterStelleMax) {
                    pars.rateMax = vm.eStatus.surveis[tab].selectedFilterStelleMax;
                }
                vm.saveStatus();
                if (vm.query.surveis[tab].order!=null && vm.query.surveis[tab].order!='') {
                    if (vm.query.surveis[tab].order.indexOf("-")==0) {
                        pars.orderBy = vm.query.surveis[tab].order.substring(1);
                        pars.sortedBy = "desc";
                    } else {
                        pars.orderBy = vm.query.surveis[tab].order;
                        pars.sortedBy = "asc";
                    }
                }
                pars.search = search.join(";");
                pars.searchFields = searchFields.join(";");
                pars.with = 'customer;customerSurveyQuestions;store;appointment;operator';
                CrudService.all('customer_surveys_v2', pars, vm,
                    function(response) {
                        if (response.data && response.data.data && response.data.data.length) {
                            vm.eListPagSurveis[tab] = response.data.meta.pagination;
                            vm.eListSurveis[tab] = response.data.data;
                        }
                        vm.loadingSurveis[tab] = false;
                    },
                    function () {
                        vm.loadingSurveis[tab] = false;
                    });
                },
                'S2': function(tab, p, s) {
                }
            };

        vm.eListPag = {"total":0,"count":10,"per_page":10,"current_page":1,"total_pages":0,"links":{} };
        vm.eListLoad = function(p, s) {
            vm.eList = [];
            vm.loading = true;
            if (p==null) {
                p = vm.query.page;
            }
            vm.query.page = p;
            if (s==null) {
                s = parseInt(vm.eListPag.per_page);
            }
            var pars = {page:p, s: s, searchJoin: 'and', with: 'store'};
            var search = [];
            var searchFields = [];
            if (vm.query.filter!=null && vm.query.filter!='') {
                pars.filtro=vm.query.filter;
            }
            if (vm.storeId) {
                var dField = 'store_id';
                search.push(dField+":"+vm.storeId);
                searchFields.push(dField+":=");
            }

            if (vm.eStatus.filter_date_start!=null && vm.eStatus.filter_date_start!='') {
              var dField = 'createTime';
              search.push(dField+":"+moment(vm.eStatus.filter_date_start).format("YYYY-MM-DD"));
              searchFields.push(dField+":>=");
            }
            if (vm.eStatus.filter_date_end!=null && vm.eStatus.filter_date_end!='') {
                pars.date_end = moment(vm.eStatus.filter_date_end).add(1,'days').format("YYYY-MM-DD");
            }
            if (vm.eStatus.selectedFilterStelle) {
                var dField = 'starRating';
                  search.push(dField+":"+vm.eStatus.selectedFilterStelle);
                searchFields.push(dField+":=");
            }
            vm.saveStatus();
            if (vm.query.order!=null && vm.query.order!='') {
                if (vm.query.order.indexOf("-")==0) {
                    pars.orderBy = vm.query.order.substring(1);
                    pars.sortedBy = "desc";
                } else {
                    pars.orderBy = vm.query.order;
                    pars.sortedBy = "asc";
                }
            }
            pars.search = search.join(";");
            pars.searchFields = searchFields.join(";");
            CrudService.all('gmb_reviews', pars, vm,
                function(response) {
                    if (response.data && response.data.data && response.data.data.length) {
                        angular.forEach(response.data.data, function(cs) {
                            if (cs.appointments && cs.appointments.data.length>0) {
                                cs.lastappointment = cs.appointments.data[0];
                                var lastDate = moment(cs.lastappointment.date_start);
                                cs.haveFutureApp = lastDate.isAfter(vm.today);
                                cs.lastappointment.date_start_frmt = moment(cs.lastappointment.date_start).format("DD/MM/YYYY HH:mm");
                                cs.isEnded = cs.f_over || cs.app_remaining==0 || (cs.zone_total>0 && cs.zone_remaining==0);
                                cs.daysLastApp = !cs.haveFutureApp && !cs.isEnded? lastDate.diff(vm.today,'days'):'';
                            }
                            cs.rate = 0;
                            if (cs.starRating == 'ONE') {
                                cs.rate = 1;
                            } else if (cs.starRating == 'TWO') {
                                cs.rate = 2;
                            }  else if (cs.starRating == 'THREE') {
                                cs.rate = 3;
                            }  else if (cs.starRating == 'FOUR') {
                                cs.rate = 4;
                            }  else if (cs.starRating == 'FIVE') {
                                cs.rate = 5;
                            }
                            cs.createTimeLong = moment(cs.createTime).format('x');
                        });
                        vm.eListPag = response.data.meta.pagination;
                        vm.eList = response.data.data;

                    }
                    vm.loading = false;
                },
                function () {
                    vm.loading = false;
                }
            );
        };
        vm.eListReorder = function (column) {
            vm.query.order = column;
            vm.eListLoad(1);
        };
        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(e) {
            return;
          if (vm.env.isMaster &&  (vm.user.type == 'admin' || vm.user.type=='backoffice')) {
            vm.toggleRight(e);
          }
        };
        vm.activeEntity = {};
        vm.updateEntity = {};
        vm.toggleRight = function(e) {
            if (e!=null && e.id != null) {
                angular.copy(e, vm.updateEntity)
                vm.activeEntity = vm.updateEntity;
                /*if (vm.activeEntity.active==1) {
                    vm.activeEntity.active = true;
                } else if (vm.activeEntity.active==0) {
                    vm.activeEntity.active = false;
                }*/
            } else {
                vm.updateEntity = {};
                vm.activeEntity = {
                    id: null,
                    active: 1
                };
            }
            $timeout($mdSidenav('right').open, 0);
        };
        vm.resetAll = function() {
            vm.activeEntity = {}
            vm.updateEntity = {}
            $scope.entityForm.$setPristine();
            $scope.entityForm.$setUntouched();
        };
        vm.closeSidebar = function() {
            vm.resetAll();
            $mdSidenav('right').close();
        };
        vm.saving = false;
        vm.save = function(e) {
            if (true) return;
            $log.info('Salva');
            if (angular.isDefined(e)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler salvare?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {
                                vm.saving = true;
                                CrudService
                                    .save( 'customer_subscriptions', vm.activeEntity, vm ,
                                        function(response) {
                                            if (vm.activeEntity.id) {
                                                var id = vm.activeEntity.id;
                                                vm.activeEntity.max_app = parseInt(response.data.data.max_app);
                                                var position = vm.eList.map( function( x ) { return x.id; } ).indexOf( id );
                                                angular.copy(vm.activeEntity, vm.eList[position]);
                                            } else {
                                                vm.eList.push(response.data.data);
                                            }
                                            vm.closeSidebar();
                                            vm.saving = false;
                                        },
                                        function(response) {
                                            vm.saving = false;
                                        });
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };


        vm.end = function(e) {
            $log.info('Termina');
            if (angular.isDefined(e.id)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler terminare questo abbonamento?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {
                                CrudService
                                    .update( 'customer_subscriptions', {id: e.id, f_over: true}, vm ,
                                        function(response) {
                                            e.f_over = true;
                                        },
                                        function(response) {
                                        });
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };



        vm.del = function ( id ) {
            $log.info( 'Del' );
            if( angular.isDefined( id ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler eliminare questo abbonamento?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            CrudService.del( 'customer_subscriptions', id, vm,
                                function( response ) {
                                    var position = vm.eList.map( function( x ) { return x.id; } ).indexOf( id );
                                    vm.eList.splice(position, 1);
                                },
                                function( response ) {
                                }
                            );
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };

        vm.storeId = null;
        vm.store = null;
        vm.tenantStore = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            vm.storeId = id;
            if (vm.storeId) {
                angular.forEach($scope.$parent.main.storesList, function (s) {
                    if (s.id == vm.storeId) {
                        vm.store = s;
                    }
                });
            } else {
                if (!vm.tenantStore && $scope.$parent.main.storesList && $scope.$parent.main.storesList.length) {
                    vm.tenantStore = {'gmb_reviews': 0, 'gmb_total_rating':0, 'gmb_rating': 0, 'survey1av_reviews': 0, 'survey1av_total_rating':0, 'survey1av_rating': 0};
                    angular.forEach($scope.$parent.main.storesList, function (s) {
                        vm.tenantStore.gmb_reviews += s.gmb_reviews;
                        vm.tenantStore.gmb_total_rating += (s.gmb_reviews*s.gmb_rating);
                        if (s.survey1av_reviews) {
                            vm.tenantStore.survey1av_reviews += s.survey1av_reviews;
                        }
                        if (s.survey1av_reviews && s.survey1av_rating) {
                            vm.tenantStore.survey1av_total_rating += (s.survey1av_reviews*s.survey1av_rating);
                        }
                    });
                    vm.tenantStore.gmb_rating = vm.tenantStore.gmb_total_rating/vm.tenantStore.gmb_reviews;
                    vm.tenantStore.survey1av_rating = vm.tenantStore.survey1av_total_rating/vm.tenantStore.survey1av_reviews;
                }
                vm.store = vm.tenantStore;
            }
            vm.eListLoad(1);
            vm.eListLoads['S1']('S1', 1);
        });

        vm.editNotes = function(review) {

            var dialog = $mdDialog.confirm({
                title: "Imposta le note della recensione",
                ariaLabel: "Imposta le note della recensione",
                templateUrl: "app/reviews/dialogs/editNotes.html",
                escapeToClose: true,
                controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                    $scope.title = this.title;
                    $scope.button_ok = 'Chiudi senza salvare';
                    $scope.button_save = 'Salva';
                    $scope.review = review;
                    $scope.oldNotes = review.notes;
                    $scope.notesAreSaved = false;

                    $scope.save = function(review) {
                        $scope.loading = true;
                        var endpoint = "gmb_reviews/"+review.id+"/save-notes";
                        var data = {notes:review.notes};
                        CrudService.save(endpoint, data, vm, function(response) {
                            $scope.loading = false;
                            $scope.notesAreSaved = true;
                            $scope.close();
                        },
                        function (response) {
                            $scope.loading = false;
                        }
                        );
                    }

                    $scope.close = function() {
                        if(!$scope.notesAreSaved) {
                            $scope.review.notes = $scope.oldNotes;
                        }

                        $mdDialog.hide( true );
                    };

                }]
            });

            return $mdDialog
                .show( dialog )
                .finally(
                    function() {
                        dialog = undefined;
                    }
                );
        };



    };


    ReviewsController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',
            'StoreService',
            'UsersService',
            'CrudService'
        ];

})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .service(
            'ReferralsService',
            [
                '$log',
                'env',
                '$http',
                function(
                    $log,
                    env,
                    $http
                ) {
                    return {
                        users_for_appointment : function(pars) {
                            var apiURI = env.API + '/customers/users_for_appointment';
                            //?with=customer_subscriptions
                            return $http.get( apiURI, { params:  pars } );
                        },
                        all : function(pars) {
                            var apiURI = env.API + '/customers';
                            //?with=customer_subscriptions
                            return $http.get( apiURI,  { params:  pars } );
                        },
                        /*allWithSubscriptionActive : function(pars) {
                              //pars.with = 'customer_subscriptions_active';
                            var apiURI = env.API + '/customers'
                            return $http.get( apiURI, { params:  pars } );
                        },*/
                        get : function( id, pars ) {
                            if( angular.isDefined( id ) && id ) {
                                var apiURI = env.API + '/customers/' + id;
                                return $http.get( apiURI,  { params:  pars } );
                            }
                        },
                        rotation : function(phone, id, store_id , paid, noshow, dormientiDa, pars) {
                            if( id && angular.isDefined( id ) ) {
                                var apiURI = env.API + '/customers/' + id;
                                return $http.get( apiURI, { params:  pars } );
                            } else if ( phone && angular.isDefined( phone ) ) {
                                var apiURI = env.API + '/customers_by_phone/' + phone;
                                return $http.get( apiURI, { params:  pars } );
                            } else {
                                var apiURI = env.API + '/customers/rotation/' + store_id + "/" + paid + "/" + dormientiDa + "/" + noshow;
                                return $http.get( apiURI, { params:  pars } );
                            }
                        },
                        update : function( data ) {
                            if(
                                angular.isDefined( data ) &&
                                angular.isObject( data ) &&
                                data.id
                            ) {
                                var transformer = data;

                                if( transformer.hasOwnProperty( "$readonly" ) )
                                    delete( transformer.$readonly );

                                if( transformer.hasOwnProperty( "$selectedIndex" ) )
                                    delete( transformer.$selectedIndex );

                                var apiURI = env.API + '/customers/' + transformer.id;
                                return $http.put( apiURI, transformer );
                            };
                        },
                        del : function( id ) {
                            if( id ) {
                                var apiURI = env.API + '/customers/' + id;
                                return $http.delete( apiURI );
                            };
                        },
                        save : function( data ) {
                            if(
                                angular.isDefined( data ) &&
                                angular.isObject( data )
                            ) {
                                var transformer = data;

                                if( transformer.hasOwnProperty( "$readonly" ) )
                                    delete( transformer.$readonly );

                                if( transformer.hasOwnProperty( "$selectedIndex" ) )
                                    delete( transformer.$selectedIndex );

                                var apiURI = env.API + '/customers';
                                return $http.post( apiURI, transformer );
                            };
                        },
                    };
                }
            ]
        );

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('ReferralsController', ReferralsController);

    /** @ngInject */
    function ReferralsController(
        $scope,
        $log,
        $window,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        $http,
        CustomerService,
        env,
        CallState,
        Italia,
        TreatmentService,
        SubscriptionService,
        UsersService,
        CrudService
    ) {
        try {
        var vm = this;
        vm.env = env;
        $log.info('AddressBookController');
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        /* Treatments */
        vm.treatmentsList = [];
        TreatmentService.categories().then(function(data) {
            vm.treatmentsList = data;
        });
        vm.subscriptionsList = [];
        SubscriptionService.all({
            search: 1,
            searchFields: 'active:='
        }).then(function(response) {
            vm.subscriptionsList = response.data.data;
        });

        //---------- Customers Table -------------------------------------//
        vm.env = env;
        vm.today = new Date(moment().hours(0).minutes(0).seconds(0));
        vm.yesterday = new Date(moment(vm.today).subtract(1, 'days'));
        vm.guaranteeDisabled = false;
        vm.customerStatus = {
            showDatePicker: false,
            selectedIndexFilter: undefined,
            selectedIndex: undefined,
            filter_date_start: null,
            call_state: CallState,
            needDatePicker: function() {
                this.showDatePicker = true;
            },
            onChange: function() {

                vm.query.page = 1;

                if (vm.activeCustomer && angular.isDefined(this.selectedIndex))
                    vm.activeCustomer.call_state = this.call_state[this.selectedIndex]

                this.needDatePicker();

            },
            onChangeDateFilter: function() {

                var date = this.filter_date_start;

                return function(item) {

                    if (!date)
                        return true;

                    if (date && !item.call_date)
                        return false;

                    if (item.call_date)
                        return moment(date).isSame(moment(item.call_date)) || moment(date).isBefore(moment(item.call_date));

                    return true;

                };
            },
            setIndex: function() {

                if (vm.activeCustomer && vm.activeCustomer.call_state && ~this.call_state.indexOf(vm.activeCustomer.call_state))
                    vm.customerStatus.selectedIndex = this.call_state.indexOf(vm.activeCustomer.call_state);
                else
                    vm.customerStatus.selectedIndex = undefined;

                this.needDatePicker();

            },
        };
        vm.selected = [];
        vm.options = {
            autoSelect: false,
            boundaryLinks: true,
            pageSelector: true,
            rowSelection: false
        };
        vm.filter = {
            options: {
                'debounce': 0,
                'updateOn': 'default'
            }
        };
        vm.query = {
            filter: '',
            off: 0,
            order: '',
            limit: 10,
            page: 1
        };
        /* Controllo se c'è un Customer Id nell'URL */
        vm.phone = null;
        if (phone && angular.isDefined(phone)) {
            vm.query.filter = phone.toString();
            vm.phone = phone.toString();
        };
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.filter_merge_ok = '';
            vm.query.filter_merge_ko = '';
            vm.query.order = '';
            vm.query.off = 0;
            vm.customerStatus.filter_date_start = null;
            vm.query.page = 1;
            vm.customersListLoad(1);
        };
        vm.customersList = [];
        vm.eListLoading = false;
        vm.firstLoad = false;
        vm.mergeCheckOk = false;
        vm.customersListPag = {"total":0,"count":10,"per_page":10,"current_page":1,"total_pages":0,"links":{} };
        vm.customersListLoad = function(p,s) {
            vm.mergeCheckOk = false;
            vm.customersList = [];
            if (
                    (vm.query.filter==null || vm.query.filter.trim()=='')
                && (!vm.query.filter_merge_ok || !vm.query.filter_merge_ko)) {
                return;
            }
            vm.eListLoading = true;
            vm.customersList = [];
            if (p==null) {
                p = 1;
            }
            if (s==null) {
                s = parseInt(vm.customersListPag.per_page);
            }
            var pars = {page: p, s:s, 'with':'sourceCustomer;customer_subscriptions_active;card;user;operator'};
            if (vm.env.documentsEnabled) {
                pars.with += ';documents';
            }
            if (vm.query.filter_merge_ok && vm.query.filter_merge_ko) {
                pars.filtro_merge_ok=vm.query.filter_merge_ok;
                pars.filtro_merge_ko=vm.query.filter_merge_ko;
                vm.query.filter = null;
            }
            if (vm.query.filter!=null && vm.query.filter!='') {
                pars.filtro=vm.query.filter.trim();
            }
            if (vm.customerStatus.filter_date_start!=null && vm.customerStatus.filter_date_start!='') {
                pars.data_richiamo= moment(vm.customerStatus.filter_date_start).format('YYYY-MM-DD');
            }
            if (vm.customerStatus.selectedIndexFilter!=null && vm.customerStatus.selectedIndexFilter!='') {
                pars.search='call_state:'+vm.customerStatus.selectedIndexFilter;
                pars.searchFields='call_state:=';
            }
            if (vm.query.off) {//se non vedo tutti
                pars.search='off:'+vm.query.off;
                pars.searchFields='off:=';
            }
          if (vm.query.order!=null && vm.query.order!='') {
                pars.orderBy = vm.query.order.indexOf('-')==0?vm.query.order.substring(1):vm.query.order;
                pars.sortedBy = vm.query.order.indexOf('-')==0?'desc':null;
            }
            CustomerService.all(pars).then(function(response) {
                if (response.data && response.data.data) {
                    vm.customersList = [];
                    var customersList = [];
                    //response.data.meta.pagination.per_page = vm.customersListPag.per_page;
                    vm.customersListPag = response.data.meta.pagination;
                    angular.forEach(response.data.data, function(elem) {
                        delete elem.updated_at;
                        delete elem.created_at;
                        elem.firstname = elem.firstname || '';
                        elem.lastname = elem.lastname || '';

                        var birthdate = elem.birthdate ? moment(elem.birthdate) : null;
                        elem.birthdate = birthdate ? new Date(birthdate) : null;

                        var call_date = elem.call_date ? moment(elem.call_date) : null;
                        elem.call_date = call_date ? new Date(call_date) : null;
                        if (vm.env.isMaster && elem.tenant && elem.tenant!=vm.env.currentTenant && vm.env.admins) {
                            elem.urlCustomer = vm.env.admins[elem.tenant] + "/customer?phone="+elem.phone;
                        }
                        vm.initDocuments(elem);
                        customersList.push(elem);
                    });
                    vm.customersList = customersList;
                    if (vm.customersList.length==1) {
                        //vm.rowClicked(vm.customersList[0]);
                    } else if (vm.customersList.length==0 && vm.query.filter.trim().match("^[0-9]{9}[0-9]?$")) {
                      vm.toggleRight();
                    } else if (vm.customersList.length==2) {
                        var c0 = vm.customersList[0];
                        var c1 = vm.customersList[1];
                        if (c0.phone == vm.query.filter_merge_ok
                                || c0.phone == vm.query.filter_merge_ko ) {
                            if (c1.phone == vm.query.filter_merge_ok
                                || c1.phone == vm.query.filter_merge_ko ) {
                                vm.mergeCheckOk = true;
                            }
                        }
                    }
                }
                vm.eListLoading = false;
                vm.firstLoad = true;
            },
            function (response) {
                var errMsg = "";
                if (response.data!=null && response.data.message!=null) {
                    errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    if (url!=null) {
                        errMsg+= "\nUrl: " + url;
                    }
                }
                alert ("Si è verificato un errore nel caricamento clienti: " + errMsg);
                vm.eListLoading = false;
            });
        };
        vm.customersListLoad(vm.query.page,10);
        vm.onKeyPressSearch = function (event) {
            if (!event || event.keyCode==13) {
                vm.customersListLoad(1);
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        }

        /**
         * Visualizzo activities su app
         */
        vm.showActivities = function( ent ) {
               if (vm.user.type != 'admin') {
                    return vm.rowClicked(ent);
               }
               var dialog = $mdDialog.confirm({
                  title: 'Storico Modifiche: ' + (ent.firstname!=null?ent.firstname.toUpperCase():'')
                  + ' ' + (ent.lastname!=null?ent.lastname.toUpperCase():'') + " (cid="+ent.id+")",
                  ariaLabel: 'Storia Modifiche Cliente',
                  templateUrl: 'app/components/dialogs/activity-log.html',
                  escapeToClose: true,
                  controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                      $scope.title = this.title;
                      $scope.button_ok = 'Chiudi';
                      $scope.activities = [];
                      $scope.loadActivities = function () {
                      var pars = {
                              'log_name': 'default',
                           'subject_type':'App\\Entities\\Customer',
                           'subject_id': ent.id,
                           with: 'causer;subject'
                      };
                      $scope.loading = true;
                      CrudService.all('activity_log', pars, vm,
                            function (response) {
                              angular.forEach(response.data.data, function(act) {
                                  act.created_at_frmt = moment(act.created_at).format('D/M/YYYY HH:mm:ss');
                                  $scope.activities.push(act);
                              });
                              $scope.loading = false;
                            },
                            function (response) {
                              var errMsg = "";
                              if (response.data!=null
                                      && response.data.message!=null) {
                                errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                                var url = response.config!=null && response.config.url!=null?response.config.url:"";
                                if (url!=null) {
                                  errMsg+= "\nUrl: " + url;
                                }
                              }
                              alert ("Si è verificato un errore nel caricamento delle attività: " + errMsg);
                              $scope.loading = false;
                           });
                      }
                      $scope.close = function() {
                          $mdDialog.hide( true );
                      };
                      $scope.loadActivities();
                  }]
            });

            return $mdDialog
                .show( dialog )
                .finally(
                    function() {
                        dialog = undefined;
                    }
                )
            ;
        };

        /**
         * Documenti cliente
         */
        /**
         * verifico se è presente documento firmato associato al trattamento (se il trattamento lo richiede)
         */
        vm.initDocuments = function(customer) {
            if (!vm.env.documentsEnabled) {
                return;
            }
            $log.info("docs",customer.documents);
            /**
             * verifico se presente privacy + autorizzazione foto + consenso al trattamento corrente
             */
            customer.docPrivacyOk = false;
            customer.docCovidOk = false;
            customer.docPicturesOk = false;
            angular.forEach(customer.documents.data, function(doc) {
                if (doc.document_type_id == 301 && !customer.docPrivacyOk) {
                    customer.docPrivacyOk = true;
                    doc.title = 'Privacy';
                    customer.docPrivacy = {'data':doc};
                } else if (doc.document_type_id == 302 && !customer.docPicturesOk) {
                    customer.docPicturesOk = true;
                    doc.title = 'Consenso fotografie';
                    customer.docPictures = {'data':doc};
                } else if (doc.document_type_id == 305 && !customer.docCovidOk) {
                    customer.docCovidOk = true;
                    doc.title = 'Autocertificazione COVID-19';
                    customer.docCovid = {'data':doc};
                } else {
                    if (doc.description) {
                        var sA = doc.description.split('|');
                        doc.title = sA[0];
                    }
                }
            });
            $log.info("docPrivacy "+customer.id,customer.docPrivacyOk);
            $log.info("docPictures "+customer.id,customer.docPicturesOk);
        };
        vm.showDocuments = function( customer ) {
            var dialog = $mdDialog.confirm({
                  title: 'Elenco documenti: di ' + (customer.firstname!=null?customer.firstname.toUpperCase():'')
                  + ' ' + (customer.lastname!=null?customer.lastname.toUpperCase():'') + " (cid="+customer.id+")",
                  ariaLabel: 'Elenco documenti cliente',
                  templateUrl: 'app/addressbook/dialogs/customer-documents.html',
                  escapeToClose: true,
                  controller: [ '$scope', '$mdDialog', '$filter', '$http', '$log',  function( $scope, $mdDialog, $filter, $http, $log ) {
                      $scope.title = this.title;
                      $scope.button_ok = 'Chiudi';
                      $scope.customer = customer;
                      $scope.env = vm.env;
                      $scope.token = vm.token;
                      $scope.refresh = function() {
                          /**
                          * ricarico documenti cliente
                          */
                          $scope.loading = true;
                          $http.get($scope.env.API+"/documents?customer_id="+$scope.customer.id).then(
                              function (response) {
                                  $scope.customer.documents = {'data': response.data.data };
                                  vm.initDocuments($scope.customer);
                                  $scope.loading = false;
                              },
                              function (response) {
                                  $log.info(response);
                                  $scope.loading = false;
                              }
                          );
                      };
                      $scope.close = function() {
                          $mdDialog.hide( true );
                      };
                  }]
            });

            return $mdDialog
                .show( dialog )
                .finally(
                    function() {
                        dialog = undefined;
                    }
                )
            ;
        };
        vm.showNote = function (c) {
            if (c.note==null || c.note.trim()=='' ) return;
            var testo = "";
            if (c.note!=null && c.note.trim()!='') {
                testo += "<p>"+c.note.trim()+"</p>";
            }
            var p = $mdDialog.confirm()
                    .title("Note su " + (c.firstname!=null?c.firstname.toUpperCase():'')
                 + ' ' + (c.lastname!=null?c.lastname.toUpperCase():'')
              ).htmlContent(testo)
                .ok( 'Ok' );
            return $mdDialog.show( p );
        };
        vm.merging = false;
        vm.merge = function() {
            vm.merging = true;
            vm.eListLoading = true;
            $http.post(env.API + "/customers_merge/"
                    +vm.query.filter_merge_ok
                    +"/"+vm.query.filter_merge_ko,{}).then(
                            function(response) {
                                //$log.info(response);
                                vm.merging = false;
                                vm.customersListLoad(1);
                            },
                            function(response) {
                                $log.info(response);
                                vm.merging = false;
                                vm.eListLoading = false;
                                alert("Errore!");
                            }
            );
        };
        vm.customersListReOrder = function (column) {
            vm.query.order = column;
            vm.customersListLoad(1);
        };
        vm.richiestaCard = function (customer) {
          customer.isCardRequest = true;
          vm.toggleRight(customer);
          //customer.card = {data: {id: 1, delivered: false}};
        };
        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(customer) {
            delete customer.isCardRequest;
            vm.toggleRight(customer);
        };
        vm.testsVisible = false;
        vm.isDeleteAllowed = true;
        vm.undoVisible = false;
        vm.img_loading = false;
        vm.loading = false;
        vm.isNewCustomer = false;
        vm.activeCustomer = {};
        vm.backup_customer = {};
        vm.update_customer = {};
        vm.empty_customer = {};
        vm.toggleRight = function(customer) {
            vm.appointmentsForCustomer = [];
            vm.isNewCustomer = angular.isUndefined(customer);
            if (angular.isDefined(customer)) {
              vm.guaranteeDisabled = customer.f_guarantee && vm.user.type!='admin';
              if (customer.src_cid!=null) {
                vm.activeRelCustomer = customer.sourceCustomer.data;
                vm.relCustomersList = [customer.sourceCustomer.data].map(
                    function( customer ) {
                        customer.fullName =  (
                            ( customer.firstname || '' )
                            + ' '
                            + ( customer.lastname || '' )
                        ).toUpperCase();
                        return customer;
                    }
                );
              }
                if (customer.zip_code!=null) {
                    if (customer.zip_code!='') {
                        customer.zip_code = parseInt(''+customer.zip_code);
                    } else {
                        customer.zip_code = null;
                    }
                }
                vm.customerStatus.setIndex();
                vm.loading = true;
                angular.copy(customer, vm.backup_customer);
                vm.activeCustomer = customer;
                CustomerService.get(customer.id, {'with': 'card;appointments;recharges;invited'}).then(function(response) {
                    if (response.data && response.data.data) {
                      if (response.data.data.card!=null) {
                        response.data.data.card.data.created_at_frmt = response.data.data.card.data.created_at!=null?
                            moment(response.data.data.card.data.created_at.data).format('DD/MM/YYYY'):null;
                        response.data.data.card.data.delivered_at_frmt = response.data.data.card.data.delivered_at!=null?
                                moment(response.data.data.card.data.delivered_at.data).format('DD/MM/YYYY'):null;
                        vm.backup_customer.card = response.data.data.card;
                        vm.activeCustomer.card = response.data.data.card;

                      }
                      /**
                       * Setto data creazione e invitato per ogni ricarica
                       */
                      angular.forEach(response.data.data.recharges.data, function(elem) {
                        elem.created_at_frmt = moment(elem.created_at.date).format("DD/MM/YYYY");
                        angular.forEach(response.data.data.invited.data, function(inv) {
                          if (elem.from_customer_id == inv.id) {
                            elem.customer = {data: inv};
                          }
                        });
                      });
                      /**
                       * Setto total amount per ogni invitato
                       */
                      angular.forEach(response.data.data.invited.data, function(elem) {
                        elem.created_at_frmt = moment(elem.created_at.date).format("DD/MM/YYYY");
                        elem.rechargeAmount = 0;
                        angular.forEach(response.data.data.recharges.data, function(rec) {
                            if (rec.from_customer_id == elem.id) {
                              elem.rechargeAmount += rec.amount;
                            }
                        });
                      });
                      vm.backup_customer.credit = response.data.data.credit;
                      vm.activeCustomer.credit = response.data.data.credit;
                        angular.forEach(response.data.data.appointments.data, function(element) {
                            var color = '';
                            /*angular.forEach(vm.operatorsList, function(operator) {
                                if (operator.id == element.user_id)
                                    color = operator.color
                            });*/
                            var appointment = {
                                "date_start": new Date(element.date_start),
                                "treatment_id": element.treatment_id,
                                "store_id": element.store_id,
                                "user_color": color,
                                "price": element.price,
                                "recalled": element.recalled,
                                "customer_subscription_id": element.customer_subscription_id,
                                "paid": element.paid,
                                "credit": element.credit
                            }
                            vm.appointmentsForCustomer.push(appointment);
                        });
                        vm.backup_customer.invited = response.data.data.invited;
                        vm.activeCustomer.invited = response.data.data.invited;
                        vm.backup_customer.recharges = response.data.data.recharges;
                        vm.activeCustomer.recharges = response.data.data.recharges;
                        vm.loading = false;
                    }
                }, function() {
                    vm.loading = false;
                });
            } else {
              var phone = null;
              if (vm.customersList==0) {
                var s = vm.query.filter.trim();
                var m = s.match("^[0-9]{9}[0-9]?$");
                if (m && m.length>=1 && m[0]==s) {
                  phone = s;
                }
              }
                vm.empty_customer = {
                    id: null,
                    firstname: '',
                    lastname: '',
                    phone: phone,
                    gender: 'F',
                    email: '',
                    referral_code: '',
                    note: '',
                    campaign: '',
                    birthdate: null,
                    city: null,
                    call_state: null,
                    call_date: null,
                };
                angular.copy(vm.empty_customer, vm.backup_customer);
                vm.activeCustomer = vm.empty_customer;
            };
            $timeout($mdSidenav('right').open, 0);
        };
        vm.phoneChecking = false;
        vm.checkPhoneExists = function() {
          vm.phoneChecking = true;
          vm.customerExists = {};
          if (vm.activeCustomer
                  && vm.activeCustomer.phone
                  && vm.activeCustomer.phone.trim()!='')
          {
              CustomerService.all(
                  {'filtro': vm.activeCustomer.phone,
                  'search': 'phone:'+vm.activeCustomer.phone,
                  'searchFields':'phone:='
                }).then(
                    function(response) {
                        vm.phoneChecking = false;
                        if(response.data.data.length >= 1 && (vm.activeCustomer.id==null || vm.activeCustomer.id!=response.data.data[0].id)) {
                          $scope.customerForm.phone.$setValidity('alreadyexists', false);
                          vm.customerExists = response.data.data[0];
                        } else {
                          $scope.customerForm.phone.$setValidity('alreadyexists', true);
                        }
                    },
                    function(response) {
                        vm.phoneChecking = false;
                    }
                );
          }
        };

        vm.resetAll = function() {
            vm.undoVisible = false;
            vm.backup_customer = {};
            vm.update_customer = {};
            vm.activeCustomer = {};
            $timeout(vm.resetForm,0);
        };
        vm.closeSidebar = function() {
            if (vm.undoVisible) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .textContent('Ci sono delle modifiche non commissionate, proseguire?')
                    .ariaLabel('Attenzione')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(vm.undo)
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            } else {
                return vm.resetAll();
            };
        };
        vm.resetForm = function() {
            return $mdSidenav('right').close().then(
                function() {
                  $scope.customerForm.$setPristine();
                  $scope.customerForm.$setUntouched();
                  vm.relCustomersReset();
                });
        };
        vm.undo = function() {
            $log.info('Undo');

            if (!angular.equals(vm.activeCustomer, vm.backup_customer)) {
                angular.copy(vm.backup_customer, vm.activeCustomer);
            };

            vm.customerStatus.selectedIndex = undefined;
            vm.customerStatus.showDatePicker = false;

            return vm.resetAll();
        };
        vm.fakeDelForced = function(customer) {
            $log.info('Del Forced');
            if (angular.isDefined(customer)) {
                var index = vm.customersList.indexOf(customer);
                vm.customersList.splice(index, 1);
            };
        };
        /*vm.del = function(customer) {
            $log.info('Del');
            if (angular.isDefined(customer)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .htmlContent('<p class="md-title">Sicuro di voler Cancellare questo utente?<br/><strong>Verranno eleminati anche tutti i suoi appuntamenti.</strong></p>')
                    .ariaLabel('Attenzione')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {
                            CustomerService.del(customer.id).then(function(response) {
                                if (response.status === 204) {
                                    vm.fakeDelForced(customer);
                                    vm.resetAll();
                                } else {
                                    alert("Errore durante l'elaborazione delle richiesta.");
                                };
                            });
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };
        */
        vm.showActionToast = function( text) {
            text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent(text)
                .action('')
                .highlightAction(true)
                .position('bottom right');
            return $mdToast
                .show(toast)
                .finally(
                    function() {
                        toast = undefined;
                    }
                );
        };
        vm.responseStatusSuccessful = [200, 201, 202];
        vm.checkResponse = function(response) {
            vm.saving = false;
            if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
                var errMsg = "";
                if (response.data!=null && response.data.message!=null) {
                    errMsg = response.data!=null && response.data.message!=null?response.data.message:"";
                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    vm.showActionToast("KO: " + errMsg + " " + url);
                }
                var alert = $mdDialog.alert()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent("C'è stato un problema: "+errMsg)
                    .ok('Ok');
                return $mdDialog
                    .show(alert)
                    .finally(
                        function() {
                            alert = undefined;
                        }
                    );
            } else {
                vm.showActionToast();
                return vm.resetAll();
            };
        };
        vm.saving = false;
        vm.save = function(customer, book) {
            $log.info('Salva');
            if (angular.isDefined(customer)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler inserire questo utente?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {
                            vm.saving = true;
                            angular.copy(customer, vm.update_customer);
                            if (customer.birthdate) {
                                vm.update_customer.birthdate = $filter('date')(new Date(vm.update_customer.birthdate), 'yyyy-MM-dd');
                            };
                            if (customer.call_date) {
                                vm.update_customer.call_date = $filter('date')(new Date(vm.update_customer.call_date), 'yyyy-MM-dd HH:mm');
                            };
                            delete(vm.update_customer.id);
                            CustomerService.save(vm.update_customer).then(
                                    function(response) {
                                        vm.checkResponse(response);
                                        if (vm.responseStatusSuccessful.indexOf(response.status) !== -1) {
                                            if (response.data && response.data.data) {
                                                vm.customersList.push(response.data.data);
                                                $log.info("todo dovrei aprire booking");
                                                vm.query.filter = response.data.data.phone;
                                                vm.customersListLoad(1);
                                                var w = $window.open(vm.env.booking +"/operator?tenant="+vm.env.currentTenant+
                                                    "&c_sid="+vm.user.store_id+
                                                    "&c_role="+vm.user.type+
                                                    "&customer="+response.data.data.phone+
                                                    "&store="+vm.storeId+
                                                    "&callcenter="+vm.isCallCenter+
                                                    "&token="+vm.token,
                                                    "_self" /*vm.env.company+"_Booking_"+vm.env.tenant*/
                                                );
                                                //w.focus();
                                                //ng-href="{{ ap.env.booking }}/operator?c_sid={{ ap.user.store_id }}&amp;c_role={{ ap.user.type }}&amp;store={{ ap.storeId }}&amp;callcenter={{ ap.isCallCenter }}&amp;token={{ ap.token }}"

                                            };
                                        };
                                        vm.saving = false;
                                    },
                                    function(response) {
                                        vm.checkResponse(response);
                                        vm.saving = false;
                                    });
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };
        vm.update = function(customer) {
            $log.info('Update');
            if (angular.isDefined(customer)) {
                if (!angular.equals(customer, vm.backup_customer)) {
                    var confirm = $mdDialog.confirm()
                        .title('Attenzione')
                        .ariaLabel('Attenzione')
                        .textContent('Sicuro di voler aggiornare?')
                        .ok('Si')
                        .cancel('Ops, ho sbagliato');
                    return $mdDialog
                        .show(confirm)
                        .then(
                            function() {
                                vm.saving = true;
                                angular.copy(customer, vm.update_customer);
                                vm.update_customer.with = 'card';
                                if (customer.birthdate) {
                                    vm.update_customer.birthdate = $filter('date')(new Date(vm.update_customer.birthdate), 'yyyy-MM-dd');
                                };
                                if (customer.call_date) {
                                    vm.update_customer.call_date = $filter('date')(new Date(vm.update_customer.call_date), 'yyyy-MM-dd HH:mm');
                                };
                                CustomerService.update(vm.update_customer).then(
                                    function (response) {
                                      vm.checkResponse(response);
                                      if (response.data!=null && response.data.data!=null) {
                                        customer.card = response.data.data.card;
                                        if (response.data.data.f_guarantee) {
                                            vm.guaranteeDisabled = vm.user.type!='admin';
                                        }
                                      }
                                    },
                                    vm.checkResponse);
                            }
                        )
                        .finally(
                            function() {
                                confirm = undefined;
                            }
                        );
                };
            };
        };
        $scope.$watch('ab.activeCustomer', function(newValue) {
            vm.undoVisible = (angular.equals(newValue, vm.backup_customer) || vm.isNewCustomer) ? false : true;
        }, true);
        vm.Italia = Italia;
        /**
         * Gestione invitato da
         */
        vm.filter_relcustomer = '';
        vm.relCustomersList = [];
        vm.activeRelCustomer = null;
        vm.activeRelCustomerChange = function () {
          vm.activeCustomer.src_cid = vm.activeRelCustomer.id;
          vm.activeCustomer.sourceCustomer = {data: vm.activeRelCustomer};
        }
        vm.onKeyUpRelCustomersSearch = function (evento, obj) {
          if (evento.keyCode==13)  {
            vm.relCustomersLoad();
            evento.stopPropagation();
            evento.preventDefault();
          }
        };
        vm.relCustomersReset = function () {
          vm.relCustomersList = [];
          vm.filter_relcustomer = '';
          vm.activeRelCustomer = null;
        };
        vm.relCustomersLoad = function ( ) {
          vm.relCustomersList = [];
          vm.relCustomersLoading = true;
          var pars = {page:1, s:10, orderBy: 'firstname'};
          var search = [];
          var searchFields = [];
          if (vm.filter_relcustomer!=null && vm.filter_relcustomer!='') {
            pars.filtro = vm.filter_relcustomer;
          }
          if (search.length>0) {
            pars.search = search.join(";");
            pars.searchFields = searchFields.join(";");
          }
          return CustomerService
              .all(pars).then(
                  function( response ) {
                      if( response.data && response.data.data ) {
                          vm.relCustomersList = response.data.data.map(
                              function( customer ) {
                                  customer.fullName =  (
                                      ( customer.firstname || '' )
                                      + ' '
                                      + ( customer.lastname || '' )
                                  ).toUpperCase();
                                  return customer;
                              }
                          );
                          if (vm.relCustomersList.length==0) {
                            vm.showActionToast("Nessun elemento trovato.");
                          }
                          vm.relCustomersLoading = false;
                      };
                  },
                  function (response) {
                    vm.checkResponse(response);
                    vm.relCustomersLoading = false;
                  }
              )
          ;
      };



        /* WATCHO Lo Store */
        vm.storesList = [];
        vm.storeId = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                if (vm.storeId==null) {//è il primo caricamento
                    vm.storesList = $scope.$parent.main.storesList;
                    //vm.operatorLoad();
                }
                vm.storeId = id;
            };
        });

        /* Operators */
        /*vm.operatorsList = [];
        vm.operatorLoad = function() {
            vm.operatorsList = [];
            UsersService.all({
                search: 'active:1;type:operator',
                searchFields: 'active:=;type:='
            }).then(function(response) {
                if (response.data && response.data.data) {
                    vm.operatorsList = response.data.data;
                };
            });
        };*/
        } catch(err) {
            $log.info('error:',err);
        }
    };

    ReferralsController
        .$inject = [
            '$scope',
            '$log',
            '$window',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            '$http',
            'CustomerService',
            'env',
            'CallState',
            'Italia',
            'TreatmentService',
            'SubscriptionService',
            'UsersService',
            'CrudService'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('ProductsController', ProductsController);

    /** @ngInject */
    function ProductsController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        $http,
        env,
        StoreService,
        UsersService, 
        CrudService
    ) {
        var vm = this;
        vm.env = env;
        $log.info('ProductsController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
        	return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        vm.query = {
            filter: '',
            supplierName: undefined,
            order: 'id',
        };
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.order = 'id';
            vm.query.supplierName= undefined;
        };
        vm.eList = [];
		vm.loading = true;
        vm.eListLoad = function() {
        	vm.eList = [];
			vm.loading = true;
			vm.query.filter = '';
        	var pars = {};
        	CrudService.all('products', pars, vm, 
        		function(response) {
	                if (response.data && response.data.data && response.data.data.length) {
	                    angular.forEach(response.data.data, function(elem) {
							elem.supplier = vm.getSupplierById(elem.supplier_id);
						});
						vm.eList = response.data.data;
	                }
					vm.loading = false;
        		},
        		function () {
					vm.loading = false;
        		}
            );
        };
        
        vm.showActionToast = function( text) {
        	text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent(text)
                .action('')
                .highlightAction(true)
                .position('bottom right');
            return $mdToast
                .show(toast)
                .finally(
                    function() {
                        toast = undefined;
                    }
                );
        };
        
        
        vm.overrideFromMaster = function() {
        	var confirm = $mdDialog.confirm()
            .title('Attenzione')
            .ariaLabel('Attenzione')
            .textContent('Sicuro di voler copiare i prodotti su tutte le aree?')
            .ok('Si')
            .cancel('Ops, ho sbagliato');
        return $mdDialog
            .show(confirm)
            .then(
                function() {	
                	vm.loading = true;
                	$http.post(vm.env.API+'/products/override_from_master').then(
                			function(response) {
                				if (response.data.success) {
                					vm.showActionToast("Tutto OK. Copia prodotti effettuata sulle AREE: "+response.data.tenants.join(', '));
                				}
                				vm.loading = false;
                			},
                			function(response) {
                				alert(response.data.message);
                				vm.loading = false;
                			}
                	);
                }
            )
            .finally(
                function() {
                    confirm = undefined;
                }
            );
        };
        
        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(e) {
          if (vm.env.isMaster &&  (vm.user.type == 'admin' || vm.user.type=='backoffice')) {
            vm.toggleRight(e);
          }
        };
        vm.activeEntity = {};
        vm.updateEntity = {};
        vm.toggleRight = function(e) {
        	if (e!=null && e.id != null) {
				angular.copy(e, vm.updateEntity)
                vm.activeEntity = vm.updateEntity;
				if (vm.activeEntity.active==1) {
					vm.activeEntity.active = true;
				} else if (vm.activeEntity.active==0) {
					vm.activeEntity.active = false;
				}
            } else {
				vm.updateEntity = {};
				var supplierSelected = vm.getSupplierByName(vm.query.supplierName);
                vm.activeEntity = {
                	id: null,
                	supplier_id: supplierSelected == null ? null:supplierSelected.id,
                	active: true
                };
            }
            $timeout($mdSidenav('right').open, 0);
        };
        vm.resetAll = function() {
			vm.activeEntity = {}
			vm.updateEntity = {}
            $scope.entityForm.$setPristine();
            $scope.entityForm.$setUntouched();
        };
        vm.closeSidebar = function() {
			vm.resetAll();
        	$mdSidenav('right').close();
        };
        vm.saving = false;
        vm.save = function(e) {
            $log.info('Salva');
            if (angular.isDefined(e)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler salvare?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {	
                        		vm.saving = true;
								CrudService
                                    .save( 'products', vm.activeEntity, vm ,
										function(response) {
                                    		if (vm.activeEntity.id) {
                                    			var id = vm.activeEntity.id;
                                    			var position = vm.eList.map( function( x ) { return x.id; } ).indexOf( id );
                                        		angular.copy(vm.activeEntity, vm.eList[position]);
                                    		} else {
                                    			vm.eList.push(response.data);	
                                    		}
                                    		vm.closeSidebar();
                                    		vm.saving = false;
										},
										function(response) {
											vm.saving = false;
										});
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };
		
		vm.del = function ( id ) {
            $log.info( 'Del' );
            if( angular.isDefined( id ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler eliminare questo prodotto?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            CrudService.del( 'products', id, vm, 
								function( response ) {
                            		var position = vm.eList.map( function( x ) { return x.id; } ).indexOf( id );
                            		vm.eList.splice(position, 1);
								},
								function( response ) {
								}
							);
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };

        /* Suppliers */
        vm.causaliList = [];
		vm.causaliLoading = true;
        vm.suppliersLoad = function() {
            vm.causaliList = [];
			vm.causaliLoading = true;
            CrudService.all('suppliers', {}, vm,	
                	function(response) {
	                	if (response.data && response.data.data) {
	                		vm.causaliList = response.data.data;
	                	}
						vm.causaliLoading = false;
						vm.eListLoad();
                	},
                	function () {
						vm.causaliLoading = false;
                	}
            );
        };
        vm.getSupplierById = function (id) {
        	for(var i=0; i<vm.causaliList.length; i++) {
        		if (vm.causaliList[i].id == id) return vm.causaliList[i];
        	}
        	return null;
        };
        vm.getSupplierByName = function (name) {
        	for(var i=0; i<vm.causaliList.length; i++) {
        		if (vm.causaliList[i].name == name) return vm.causaliList[i];
        	}
        	return null;
        }
        
        vm.suppliersLoad();
        
    };

    ProductsController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            '$http',
            'env',            
            'StoreService',
            'UsersService',
            'CrudService'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('OrdersController', OrdersController);

    /** @ngInject */
    function OrdersController(
        $scope,
        $log,
        $http,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        $state,
        env,
        CrudService,
        UsersService
    ) {
        var vm = this;
        $log.info('OrdersController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
        	return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        vm.query = {
            filter: '',
            month: moment().format('MM'),
            year: moment().format('YYYY'),
            order: '-date',
        };
        vm.saveStatus = function () {
          //if (true) return;
          localStorage.setItem( 'orders_query', angular.toJson( vm.query, false ) );
        };
        vm.restoreStatus = function () {
          var query = angular.fromJson(localStorage.getItem('orders_query'));
          if (query!=null) {
            vm.query =  query;
          }
        };
        vm.restoreStatus();
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.month = moment().format('MM');
            vm.query.year = moment().format('YYYY');
            vm.query.order = '-date';
            vm.eListLoad();
        };
        vm.years = [];
        for (var i=2017; i-1<=parseInt(vm.query.year); i++) {
        	vm.years.push(''+i);
        }
        vm.eList = [];
		vm.eListTotal = 0;
		vm.eListTotalDel = 0;
		vm.eListTotalVat = 0;
		vm.eListTotalTot = 0;
		vm.loading = true;
		vm.canReadList = true;
        vm.eListLoad = function() {
        	vm.eList = [];
        	vm.eListTotal = 0;
        	vm.eListTotalDel = 0;
          vm.eListTotalTot = 0;
          vm.eListTotalVat = 0;
        	vm.saveStatus();
			/*vm.canReadList = vm.perm.canRead('orders', vm.getNewEntity());
			if (! vm.canReadList ) {
				return;
			}*/
			vm.loading = true;
			vm.query.filter = '';
        	var pars = {};
			pars.with = "user;supplier";
			if (vm.storeId) {
        	  pars.store_id = vm.storeId;
    		}
        	vm.loadBudget();
        	pars.year = vm.query.year;
            pars.month = vm.query.month;
        	CrudService.all('orders', pars, vm, 
        		function(response) {
	                if (response.data && response.data.data && response.data.data.length) {
	                    angular.forEach(response.data.data, function(elem) {
	                      vm.eListTotal+=elem.total;
	                      vm.eListTotalDel += parseFloat(elem.delivery_cost);
	                      vm.eListTotalTot += elem.total+elem.total*elem.vat/100 + parseFloat(elem.delivery_cost);
	                      vm.eListTotalVat += elem.total*elem.vat/100;
	                      elem.date_formatted = moment(elem.date).format('DD/MM/YYYY');
	                      if (elem.sent_at!=null) {
	                        elem.sent_at_frmt = moment(elem.sent_at).format('DD/MM/YYYY HH:mm');
	                      }
	                      angular.forEach(vm.storesList, function(s) {
	                          if (elem.store_id == s.id) {
	                            elem.store = {data: s};
	                          }
	                      });
	                        
	                    });
	                    vm.eList = response.data.data;
	                }
					vm.loading = false;
        		},
        		function () {
					vm.loading = false;
        		}
            );
        };
        
        vm.rowClicked = function(e) {
        	$state.go("home.orderdetails", {order_id: e.id});
        };
        
        
        //---------- Sidebar -------------------------------------//
        vm.activeEntity = {};
        vm.updateEntity = {};
        vm.toggleRight = function(e) {
        	if (e!=null && e.id != null) {
				angular.copy(e, vm.updateEntity)
                vm.activeEntity = vm.updateEntity;
            } else {
				vm.updateEntity = {};
                vm.activeEntity = vm.getNewEntity();
            }
            $timeout($mdSidenav('right').open, 0);
        };
        vm.getNewEntity = function () {
        	return {
            	store_id: vm.storeId,
            	user_id: vm.user.id,
            	date: moment().format('YYYY-MM-DD')
            };
        };
        vm.resetAll = function() {
			vm.activeEntity = {}
			vm.updateEntity = {}
            $scope.entityForm.$setPristine();
            $scope.entityForm.$setUntouched();
        };
        vm.closeSidebar = function() {
			vm.resetAll();
        	$mdSidenav('right').close();
        };
        vm.save = function(e) {
            $log.info('Salva');
            if (angular.isDefined(e)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler creare un nuovo ordine?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {	
								vm.activeEntity.year = parseInt(moment(vm.activeEntity.date).format('YYYY'));
								vm.activeEntity.month = parseInt(moment(vm.activeEntity.date).format('MM'));
                                CrudService
                                    .save( 'orders', vm.activeEntity, vm ,
										function(response) {
											vm.closeSidebar();
											$state.go("home.orderdetails", {order_id: response.data.data.id});
											return;
											//vm.eListLoad();
										},
										function(response) {
										});
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };
		
		vm.del = function ( id ) {
            $log.info( 'Del' );
            if( angular.isDefined( id ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler eliminare questo ordine?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            CrudService.del( 'orders', id, vm, 
								function( response ) {
									vm.eListLoad();
								},
								function( response ) {
								}
							);
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };
		$scope.$watch('ab.query.filter', function() {
			if (!vm.loading) {
				vm.calcsOnVisibileElements();
			}
		});

		vm.calcsOnVisibileElements = function() {
			$timeout(function () {
			   vm.eListTotal = 0;
			   vm.filteredItems.forEach(function(item) {
				  vm.eListTotal += item.total;
			   });
			 });
		 };
        /* WATCHO Lo Store */
        vm.storeId = null;
        vm.storesList = [];
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
            	if (vm.storeId == null) {
            	  vm.storeId = id;
            	  vm.storesList = $scope.$parent.main.storesList;
            		vm.causaliLoad();
            		vm.eListLoad();
            	} else {
              	vm.storeId = id;
                //if (vm.user.store_id!=null && vm.user.store_id>0) {
                  vm.eListLoad();
                //}
             }
            };
        });
        
        vm.storeBudget = null;
        vm.loadBudget = function () {
        	vm.storeBudget = null;
        	var apiURI = env.API + '/orders/maxamount/'+vm.storeId+'/'+vm.query.year+"/"+vm.query.month+"/0";
            $http.get( apiURI ).then( 
        		function (response) {
					if (response.data) {
						vm.storeBudget = response.data.data;
					}
        		},
        		function (response) {
        			CrudService.handleError(vm, response);
        		}
            );
        }

        /* Fornitori */
        vm.causaliList = [];
		vm.causaliLoading = true;
        vm.causaliLoad = function() {
            vm.causaliList = [];
			vm.causaliLoading = true;
            CrudService.all('suppliers', {orderBy: 'name'}, vm,	
                	function(response) {
	                	if (response.data && response.data.data) {
	                		vm.causaliList = response.data.data;
	                	}
						vm.causaliLoading = false;
                	},
                	function () {
						vm.causaliLoading = false;
                	}
            );
        };
        
        vm.perm = {
            	canFire: function (id, ent) {
            		return $scope.$parent.main.perm.canFire(id, ent);
            	},
            	canRead: function (id, ent) {
            		return $scope.$parent.main.perm.canRead(id, ent);
            	},
            	canCreate: function (id) {
            		return $scope.$parent.main.perm.canCreate(id, vm.getNewEntity());
            	},
            	canUpdate: function (id, ent) {
            		return $scope.$parent.main.perm.canUpdate(id, ent);
            	},
            	canDelete: function (id, ent) {
            		return $scope.$parent.main.perm.canDelete(id, ent);
            	},
            	canSave: function (id, ent) {
            		return $scope.$parent.main.perm.canSave(id, ent);
            	}
       };
        
    };

    OrdersController
        .$inject = [
            '$scope',
            '$log',
            '$http',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            '$state',
            'env',            
            'CrudService',
            'UsersService'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('OrderDetailsController', OrderDetailsController);

    /** @ngInject */
    function OrderDetailsController(
        $scope,
        $log,
        $http,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        CrudService,
        $stateParams,
        $state,
        UsersService
    ) {
        var vm = this;
        $log.info('OrderDetailsController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
        	return;
        }
        vm.order_id = $stateParams.order_id;
        var order_id = vm.order_id;
        if (order_id == null) {
        	$state.go("home.orders");
        	return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        vm.query = {
            filter: '',
            qty: 0,
            order: ''
        };
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.order = '';
        };
        vm.eListTotal = 0;
		vm.loading = true;
		vm.mainEntity = null;
        
        vm.getNewEmptyProdInv = function(product) {
        	return {
				order: vm.mainEntity,
				order_id: vm.mainEntity.id,
				store_id: vm.mainEntity.store_id,
				product_id: product.id,
				price: product.price,
				qty: 0,
				prev_qty: 0
			};
        }
        vm.saveProdInv = function(prodInv, qta_xct) {
        	if (prodInv.saving) return;
        	if (prodInv.qty==null) {
        		prodInv.qty = 0;
        	}
        	if (prodInv.qty==prodInv.prev_qty) return;
        	prodInv.saving = true;
        	if (prodInv.qty % qta_xct != 0) {
        		prodInv.qty += (qta_xct - prodInv.qty % qta_xct);
        		CrudService.showActionToast(vm, "La quantità ordinata per questo prodotto deve essere multipla di "+qta_xct+", impostato "+ prodInv.qty);
        	}
        	CrudService.save( 'products_orders', prodInv, vm ,
				function(response) {
        			if (prodInv.id==null) {
        				prodInv.id = response.data.data.id;
        			}
        			prodInv.qty = response.data.data.qty;
        			/**Aggiorno totale */
        			vm.eListTotal -= prodInv.price*prodInv.prev_qty;
        			vm.eListTotal += prodInv.price*prodInv.qty;
        			
        			prodInv.prev_qty = response.data.data.qty;
        			prodInv.saving = false;
				},
				function(response) {
					prodInv.qty = prodInv.prev_qty;
					prodInv.saving = false;
					vm.loading = false;
				});
        };
        vm.gtQueryQty = function (v) {
        	return v.prodInv.qty >= vm.query.qty || (v.prodInv.qty==null && !vm.mainEntity.closed);
        };
        vm.chiudiOrdine = function () {
        	var confirm = $mdDialog.confirm()
            .title('Attenzione')
            .ariaLabel('Attenzione')
            .textContent('Sicuro di voler chiudere l\'ordine?')
            .ok('Si')
            .cancel('Ops, ho sbagliato');
        return $mdDialog
            .show(confirm)
            .then(
                function() {	
                	vm.mainEntity.status = 'chiuso';
                	vm.close();
                	CrudService.save( 'orders', vm.mainEntity , vm ,
                			vm.updateMainEntityStatus,
                			function (response) {
                				vm.main.status = 'bozza';
                				vm.edit();
                			});
                }
             )
            .finally(
                function() {
                    confirm = undefined;
                }
            );
        };
        vm.edit = function () {
	        if (vm.mainEntity.canUpdate) {
				vm.query.qty = 0;
				vm.mainEntity.closed = false;
			} 
        };
        vm.close = function () {
        	vm.query.qty = 1;
			vm.mainEntity.closed = true;
        };
        vm.updateMainEntityStatus = function () {
	        vm.mainEntity.canUpdate = vm.perm.canUpdate('orders',vm.mainEntity);
        };
        vm.consegnatoOrdine = function () {
        	var confirm = $mdDialog.confirm()
            .title('Attenzione')
            .ariaLabel('Attenzione')
            .textContent('Sicuro di voler impostare a consegnato l\'ordine?')
            .ok('Si')
            .cancel('Ops, ho sbagliato');
        return $mdDialog
            .show(confirm)
            .then(
                function() {	
                	if (!vm.mainEntity.closed) {
                		vm.close();
                	}
                	vm.mainEntity.prev_status = vm.mainEntity.status;
                	vm.mainEntity.status = 'consegnato';
                	CrudService.save( 'orders', vm.mainEntity , vm ,
                			vm.updateMainEntityStatus,
                			function (response) {
                				vm.mainEntity.status = vm.mainEntity.prev_status;
                			});
                }
             )
            .finally(
                function() {
                    confirm = undefined;
                }
            );
        };
        vm.evadiOrdine = function () {
        	var confirm = $mdDialog.confirm()
            .title('Attenzione')
            .ariaLabel('Attenzione')
            .textContent('Sicuro di voler inviare l\'ordine?')
            .ok('Si')
            .cancel('Ops, ho sbagliato');
        return $mdDialog
            .show(confirm)
            .then(
                function() {	
                	vm.mainEntity.prev_status = vm.mainEntity.status;
                	vm.mainEntity.status = 'evaso';
                	vm.mainEntity.sent_at = moment().format("YYYY-MM-DD HH:mm:ss");
                	vm.mainEntity.sent_at_frmt = moment().format("DD/MM/YYYY");
                	CrudService.save( 'orders', vm.mainEntity, vm,
                			vm.updateMainEntityStatus,
                			function (response) {
                				vm.mainEntity.status = vm.mainEntity.prev_status;
                			});
                }
             )
            .finally(
                function() {
                    confirm = undefined;
                }
            );
        };
		$scope.$watch('ab.query.filter', function() {
			$timeout(vm.calcsOnVisibileElements, 300);
		});

		vm.calcsOnVisibileElements = function() {
			$timeout(function () {
			   vm.eListTotal = 0;
			   vm.filteredItems.forEach(function(item) {
				   if (item.prodInv!=null && item.prodInv.qty!=null && item.prodInv.qty!=0) { 
					   vm.eListTotal += item.prodInv.price*item.prodInv.qty;
				   }
			   });
			 });
		 };
        vm.getProductOrder = function (product) {
        	for (var i = 0; i<vm.mainEntity.products.length; i++) {
        		if (product.id == vm.mainEntity.products[i].id) {
        			return vm.mainEntity.products[i];
        		}
        	}
        	return null;
        };
        
        vm.loadOrder = function() {
        	var pars = {with: 'store;products;supplier'};
        	CrudService.get("orders", order_id, pars,  vm,
        			function (response) {
        				vm.mainEntity = response.data.data;
        				if (vm.mainEntity.sent_at!=null) {
        				  vm.mainEntity.sent_at_frmt = moment(vm.mainEntity.sent_at).format("DD/MM/YYYY HH:mm");
        				}
        				vm.loadBudget();
        				if (vm.mainEntity.closed) {
        					vm.query.qty = 1;
        				}
        				angular.forEach(vm.mainEntity.products, function (p) {
        					p.prodInv = p.pivot;
        					p.prodInv.prev_qty = p.prodInv.qty;
        				});
        				vm.mainEntity.canUpdate = vm.perm.canUpdate('orders',vm.mainEntity); 
        				if (vm.mainEntity.canUpdate) {
        					vm.productsLoad(); // 	carico prodotti e faccio il merge successivamente
        				} else {//inizializzo l'elenco prodotti con i soli ordinati
        					vm.productsList = vm.mainEntity.products;
        					vm.productsLoading = false;
        					vm.loading = false;
        					vm.calcsOnVisibileElements();
        				}
        			},
        			function (response) {
        			}
        	);
        }
        vm.loadOrder();
        vm.storeBudget = 2000;
        vm.loadBudget = function () {
        	vm.storeBudget = 1500;
        	var apiURI = env.API + '/orders/maxamount/'+vm.mainEntity.store_id+'/'+vm.mainEntity.year+"/"+vm.mainEntity.month+"/"+vm.mainEntity.id;
            $http.get( apiURI ).then( 
        		function (response) {
					if (response.data) {
						vm.storeBudget = response.data.data;
					}
        		},
        		function (response) {
        			CrudService.handleError(vm, response);
        		}
            );
        }
        
        vm.perm = {
        	canFire: function (id, ent) {
        		return $scope.$parent.main.perm.canFire(id, ent);
        	},
        	canUpdate: function (id, ent) {
        		return $scope.$parent.main.perm.canUpdate(id, ent);
        	}
        };
        
        /* Prodotti */
        vm.productsList = [];
        vm.productsLoading = true;
        vm.productsLoad = function() {
            vm.productsList = [];
			vm.productsLoading = true;
			var params = {orderBy: 'id', 	search: 'active:1;supplier_id:'+vm.mainEntity.supplier_id, 
											searchJoin: 'and', 
											searchFields: 'active:=;supplier_id:='};
            CrudService.all('products', params, vm,	
                	function(response) {
	                	if (response.data && response.data.data) {
	                		angular.forEach(response.data.data, function (product) {
	                			product.supplier = vm.mainEntity.supplier;
	                			var po = vm.getProductOrder(product);
	                			if (po!=null) {//già in ordine
	                				product = po;
	                			} else {
	                				product.prodInv = vm.getNewEmptyProdInv(product);
	                			}
	                			vm.productsList.push(product);
	                		});
	                	}
						vm.productsLoading = false;
						vm.loading = false;
						vm.calcsOnVisibileElements();
                	},
                	function () {
						vm.productsLoading = false;
						vm.loading = false;
                	}
            );
        };
    };

    OrderDetailsController
        .$inject = [
            '$scope',
            '$log',
            '$http',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',            
            'CrudService',
            '$stateParams',
            '$state',
            'UsersService'
        ];

})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .service(
            'UserRolesService',
            [
                '$log',
                'env',
                '$http',
                function(
                    $log,
                    env,
                    $http
                ) {
                    return {
                        /*all : function(pars) {
                            var apiURI = env.API + '/leads';
                            return $http.get( apiURI, { params:  pars } );
                        },
                        get : function( id, withAppointments ) {
                            if( angular.isDefined( id ) && id ) {
                                var apiURI = env.API + '/leads/' + id + ((withAppointments) ? '?with=appointments' : '');
                                return $http.get( apiURI );
                            }
                        },
                        counters : function(pars, uid) {
                          var apiURI = env.API + '/leads/counters/'+uid;
                          return $http.get( apiURI, { params:  pars } );
                        },
                        update : function( data ) {
                            if(
                                angular.isDefined( data ) &&
                                angular.isObject( data ) &&
                                data.id
                            ) {
                                var apiURI = env.API + '/leads/' + data.id;
                                return $http.put( apiURI, data );
                            };
                        },
                        */
                        put : function( data, id ) {
                          if(
                              angular.isDefined( data ) &&
                              angular.isObject( data ) 
                          ) {
                              var apiURI = env.API + '/user_roles/' + id;
                              return $http.put( apiURI, data );
                          };
                        },
                        /*,
                        del : function( id ) {
                            if( id ) {
                                var apiURI = env.API + '/leads/' + id;
                                return $http.delete( apiURI );
                            };
                        },*/
                        save : function( data ) {
                            if(
                                angular.isDefined( data ) &&
                                angular.isObject( data )
                            ) {
                                var apiURI = env.API + '/user_roles';
                                return $http.post( apiURI, data );
                            };
                        },
                    };
                }
            ]
        );

})();

(function () {
    "use strict";

    angular
        .module("admin")
        .controller("OperatorController", OperatorController);

    /** @ngInject */
    function OperatorController(
        $scope,
        $log,
        $http,
        $mdDialog,
        $mdMedia,
        $timeout,
        $mdSidenav,
        $mdToast,
        $filter,
        UsersService,
        UserRolesService,
        StoreService,
        AppointmentsService,
        CrudService,
        env,
        ROLES
    ) {
        var vm = this;
        vm.mdDialog = $mdDialog;
        vm.mdToast = $mdToast;
        vm.env = env;
        $log.info("OperatorController");
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        // ---------- Operators -------------------------------------//

        vm.containsMaiuscolo = function(stringa) {
            // Utilizza un'espressione regolare per verificare se la stringa contiene almeno un carattere maiuscolo
            if (!stringa && vm.activeOperator && vm.activeOperator.password) {
                stringa = vm.activeOperator.password;
            }
            if (!stringa) return false;
            var regex = /[A-Z]/;
            return regex.test(stringa);
        }
        vm.containsMinuscolo = function(stringa) {
            // Utilizza un'espressione regolare per verificare se la stringa contiene almeno un carattere maiuscolo
            if (!stringa && vm.activeOperator && vm.activeOperator.password) {
                stringa = vm.activeOperator.password;
            }
            if (!stringa) return false;
            var regex = /[a-z]/;
            return regex.test(stringa);
        };
        vm.containsNumero = function(stringa) {
            // Utilizza un'espressione regolare per verificare se la stringa contiene almeno un carattere maiuscolo
            if (!stringa && vm.activeOperator && vm.activeOperator.password) {
                stringa = vm.activeOperator.password;
            }
            if (!stringa) return false;
            var regex = /[0-9]/;
            return regex.test(stringa);
        };
        vm.containsSpeciale = function(stringa) {
            // Utilizza un'espressione regolare per verificare se la stringa contiene almeno un carattere maiuscolo
            if (!stringa && vm.activeOperator && vm.activeOperator.password) {
                stringa = vm.activeOperator.password;
            }
            if (!stringa) return false;
            var regex = /[!@#$%^&*_;:]/;
            return regex.test(stringa);
        };


        vm.viewAction = false;
        vm.selected = [];
        vm.roles = ROLES;
        vm.extlistData = [
            /*{
                name: "Notifiche lead assegnati",
                field: "f_notify_lead"
            },
            {
                name: "Scelta coda lavorazione lead",
                field: "ext_l_leads",
                field_enable: "ext_f_leads",
            },*/
            {
                name: "Scelta tipo lead",
                field: "ext_l_caveau",
                field_enable: "ext_f_caveau",
            },
            {
                name: "Gestione lead centri (social)",
                field: "ext_l_leads2",
                field_enable: "ext_f_leads2",
            },
            {
                name: "Gestione messaggi whatsapp di tutti",
                field: "ext_l_cs",
                field_enable: "ext_f_cs",
            },
            {
                name: "Gestione completa lead",
                field: "ext_l_bid",
                field_enable: "ext_f_bid",
            },
            {
                name: "Lavorazione lead da elenco",
                field: "ext_l_pf",
                field_enable: "ext_f_pf",
            },
            /*
            {
                name: "Caveau",
                field: "ext_l_caveau",
                field_enable: "ext_f_caveau",
            },
            {
                name: "Recall",
                field: "ext_l_recall",
                field_enable: "ext_f_recall",
            },*/
        ];
        vm.extlistAll = function (val) {
            /*$log.info(vm);
            $log.info($scope);
            $log.info($scope.operatorForm);
            */
            $scope.operatorForm.$setDirty();
            angular.forEach(vm.extlistData, function (c) {
                vm.activeOperator[c.field_enable] = val ? 1 : 0;
            });
        };

        vm.query = {
            filter: "",
            order: "lastname",
            type: "",
            store_id: "",
            active: true,
            online: false,
            page: 1,
            filterType: null,
        };
        vm.query_empty = {
            filter: "",
            order: "lastname",
            type: "",
            store_id: "",
            active: true,
            online: false,
            page: 1,
            filterType: null,
        };
        //vm.query_backup = {};
        /* Operators */
        vm.filterRoleChanged = function () {
            if (
                vm.query.type == "operator" ||
                vm.query.type == "storemngr" ||
                vm.query.type == "assist"
            ) {
                vm.query.store_id = vm.storeId;
            } else {
                vm.query.store_id = 0;
            }
        };
        vm.operatorsList = [];
        vm.loading = true;
        vm.operatorsListPag = {
            total: 0,
            count: 10,
            per_page: 10,
            current_page: 1,
            total_pages: 0,
            links: {},
        };
        vm.onKeyPressSearch = function (event) {
            if (event.keyCode == 13) {
                vm.operatorLoad(1);
                event.stopPropagation();
                event.preventDefault();
            }
        };
        vm.usersList = [];
        vm.usersListLoad = function () {
            var pars = {
                page: 1,
                s: 1000,
                searchJoin: "and",
                searchFields: "type:=",
                search: "type:callcenter",
                orderBy: "lastname",
            };
            UsersService.all(pars).then(
                function (response) {
                    if (response.data && response.data.data) {
                        vm.usersList = response.data.data;
                    }
                },
                function (response) {
                    console.log(response);
                }
            );
        };
        vm.usersListLoad();
        vm.operatorLoad = function (p, s) {
            vm.loading = true;
            vm.operatorsList = [];
            if (p == null) {
                p = vm.query.page;
            }
            vm.query.page = p;
            //vm.saveStatus();
            if (s == null) {
                s = parseInt(vm.operatorsListPag.per_page);
            }
            var opts = { page: p, s: s, searchJoin: "and" };
            var search = [];
            var searchFields = [];
            //vm.query.filter = '';
            //angular.copy(vm.query, vm.query_backup);
            //angular.copy(vm.query_empty, vm.query);
            opts.with =
                "roles;lead_categories_current;user_attr_current;currentDesignation2";
            opts.withminutesrec = true;
            /*if (vm.user.type == 'operator' || vm.user.type == 'callcenter') {
                // vedo solo quelli del mio ruolo
                search.push('users.type:' + vm.user.type);
                searchFields.push('users.type:=');
            } else*/
            if (vm.query.filterType) {
                search.push("users.type:" + vm.query.filterType);
                searchFields.push("users.type:=");
            }
            search.push("users.active:" + (vm.query.active ? "1" : "0"));
            searchFields.push("users.active:=");
            opts.search = search.join(";");
            opts.searchFields = searchFields.join(";");
            if (vm.query.filter && vm.query.filter.trim() != "") {
                opts.filtro = vm.query.filter;
            }
            if (vm.query.online) {
                opts.online = vm.query.online;
            }
            UsersService.all(opts).then(
                function (response) {
                    vm.loading = true;
                    vm.operatorsList = [];
                    if (response.data && response.data.data) {
                        vm.operatorsListPag = response.data.meta.pagination;
                        angular.forEach(response.data.data, function (e) {
                            e.status = e.type;
                            if (e.lastname == null || e.lastname.trim() == "") {
                                e.lastnameEditable = true;
                            } else {
                                e.lastnameEditable = false;
                            }
                            if (
                                e.firstname == null ||
                                e.firstname.trim() == ""
                            ) {
                                e.firstnameEditable = true;
                            } else {
                                e.firstnameEditable = false;
                            }
                            angular.forEach(e.roles.data, function (r) {
                                angular.forEach(vm.storesList, function (s) {
                                    if (
                                        r.store_id != null &&
                                        r.store_id == s.id
                                    ) {
                                        r.store = s;
                                        e.isPerStore = true;
                                    }
                                });
                            });
                            e.categories = [];
                            e.regions = [];
                            angular.forEach(
                                e.lead_categories_current.data,
                                function (c) {
                                    if (c.field == "default") {
                                        e.categories.push(c.category);
                                    } else if (c.field == "region") {
                                        e.regions.push(c.category);
                                    }
                                }
                            );
                        });
                        vm.operatorsList = response.data.data;
                    }
                    vm.loading = false;
                    //angular.copy(vm.query_backup, vm.query);
                    // vm.filteredItems = $filter('filter')(vm.operatorsList, {
                    // 'store_id': vm.query.store_id, 'type': vm.query.type },
                    // true);
                },
                function (response) {
                    console.log(response);
                    vm.loading = false;
                }
            );
        };

        /**
         * Visualizzo activities su app
         */
        vm.showActivities = function (operator, role) {
            if (vm.user.type != "admin") {
                return vm.rowClicked(operator, role);
            }
            var dialog = $mdDialog.confirm({
                title:
                    "Storico Modifiche: " +
                    (role ? "Ruolo " + role.role + " " : "") +
                    (operator.firstname != null
                        ? operator.firstname.toUpperCase()
                        : "") +
                    " " +
                    (operator.lastname != null
                        ? operator.lastname.toUpperCase()
                        : "") +
                    " (uid=" +
                    operator.id +
                    ")",
                ariaLabel: "Storia Modifiche Utente",
                templateUrl: "app/components/dialogs/activity-log.html",
                escapeToClose: true,
                controller: [
                    "$scope",
                    "$mdDialog",
                    "$filter",
                    function ($scope, $mdDialog, $filter) {
                        $scope.title = this.title;
                        $scope.button_ok = "Chiudi";
                        $scope.activities = [];
                        $scope.loadActivities = function () {
                            var pars = {
                                log_name: "default",
                                subject_id: operator.id,
                                with: "causer;subject",
                            };
                            if (role) {
                                pars.subject_type = "App\\Entities\\UserRole";
                            } else {
                                pars.subject_type = "App\\Entities\\User";
                            }
                            $scope.loading = true;
                            CrudService.all(
                                "activity_log",
                                pars,
                                vm,
                                function (response) {
                                    angular.forEach(
                                        response.data.data,
                                        function (act) {
                                            act.created_at_frmt = moment(
                                                act.created_at
                                            ).format("D/M/YYYY HH:mm:ss");
                                            $scope.activities.push(act);
                                        }
                                    );
                                    $scope.loading = false;
                                },
                                function (response) {
                                    var errMsg = "";
                                    if (
                                        response.data != null &&
                                        response.data.message != null
                                    ) {
                                        errMsg =
                                            response.data != null &&
                                            response.data.message != null
                                                ? response.data.message + "."
                                                : ".";
                                        var url =
                                            response.config != null &&
                                            response.config.url != null
                                                ? response.config.url
                                                : "";
                                        if (url != null) {
                                            errMsg += "\nUrl: " + url;
                                        }
                                    }
                                    alert("Errore nel caricamento: " + errMsg);
                                    $scope.loading = false;
                                }
                            );
                        };
                        $scope.close = function () {
                            $mdDialog.hide(true);
                        };
                        $scope.loadActivities();
                    },
                ],
            });

            return $mdDialog.show(dialog).finally(function () {
                dialog = undefined;
            });
        };

        // Appuntamenti Uncovered - Orfani
        vm.showPopupAppointments = function (appointments) {
            var useFullScreen = $mdMedia("xs"),
                dialog;

            if (
                appointments &&
                appointments.data &&
                appointments.data.data.length
            ) {
                appointments = appointments.data.data;
                dialog = $mdDialog.confirm({
                    title: "Attenzione",
                    ariaLabel: "Attenzione",
                    templateUrl:
                        "app/appointments/dialogs/appointments-dialog-nextday.html",
                    fullscreen: useFullScreen,
                    escapeToClose: false,
                    controller: [
                        "$scope",
                        "$mdDialog",
                        "$filter",
                        function ($scope, $mdDialog, $filter) {
                            $scope.title = "Appuntamenti rimasti Scoperti";
                            $scope.button_ok = "Ho preso nota";
                            $scope.button_cancel = "Ignora";
                            $scope.uncovered = true;

                            $scope.appointmentsList = [];

                            angular.forEach(appointments, function (elem) {
                                delete elem.updated_at;
                                delete elem.created_at;

                                elem.date_start = $filter("date")(
                                    new Date(moment(elem.date_start)),
                                    "yyyy-MM-ddTHH:mm"
                                );
                                elem.date_end = $filter("date")(
                                    new Date(moment(elem.date_end)),
                                    "yyyy-MM-ddTHH:mm"
                                );

                                $scope.appointmentsList.push(elem);
                            });

                            $scope.close = function () {
                                $mdDialog.cancel(false);
                            };
                            $scope.open = function () {
                                $mdDialog.hide(true);
                            };
                        },
                    ],
                });
            } else {
                dialog = $mdDialog
                    .alert()
                    .title("Ottimo!")
                    .ariaLabel("Ottimo!")
                    .textContent(
                        "Questa modifica non ha generato alcun appuntamento Scoperto."
                    )
                    .fullscreen(useFullScreen)
                    .ok("Va bene");
            }
            return $mdDialog.show(dialog).finally(function () {
                dialog = undefined;
                useFullScreen = undefined;
                appointments = undefined;
            });
        };
        vm.checkUncovered = function () {
            // possono essere generati scoperti solo se metto active = 0
            // oppure cambio store operatore
            // oppure se cambio ruolo ad un operatore
            var check = vm.activeOperator.store_id != vm.origOperator.store_id;
            if (!check) return;
            var options = {
                search:
                    "uncovered:1" +
                    ";store_id:" +
                    vm.storeId +
                    ";date_start:" +
                    moment().format("YYYY-MM-DD"),
                searchFields: "store_id:=;uncovered:=;date_start:>=",
                with: "treatment;customer;user",
            };
            return AppointmentsService.all(options)
                .then(vm.showPopupAppointments)
                .finally(function () {
                    options = undefined;
                });
        };

        vm.getRole = function (user, role, store_id) {
            var res = null;
            angular.forEach(user.roles.data, function (r) {
                if (r.role == role && r.store_id == store_id) {
                    res = r;
                }
            });
            return res;
        };
        vm.haveActiveRole = function (user) {
            var res = false;
            angular.forEach(user.roles.data, function (r) {
                res = res || r.active;
            });
            return res;
        };

        /**
         * cambia il flag active
         */

        vm.toggleActiveRole = function (id, role, store_id) {
            vm.activeOperator = {};
            vm.emailKeypressed = false;
            //$scope.operatorForm.email.$setValidity('alreadyexists', true);
            vm.userExists = null;
            vm.showEmailError = false;
            var position = vm.operatorsList
                .map(function (x) {
                    return x.id;
                })
                .indexOf(id);
            var user = vm.operatorsList[position];
            //$log.info(user);
            if (
                vm.user.type != "admin" &&
                vm.user.type != "manager" &&
                vm.user.type == "storemngr" &&
                store_id != vm.user.store_id
            ) {
                var confirm = $mdDialog
                    .confirm()
                    .title("Attenzione")
                    .ariaLabel("Attenzione")
                    .textContent("Utente non abilitato.")
                    .ok("Ok");
                return $mdDialog
                    .show(confirm)
                    .then(function () {})
                    .finally(function () {
                        confirm = undefined;
                    });
            }
            if (position !== -1) {
                var r = vm.getRole(user, role, store_id);//ci puo' essere solo un ruolo per store_id altrimenti non va
                var confirm = $mdDialog
                    .confirm()
                    .title("Attenzione")
                    .ariaLabel("Attenzione")
                    .textContent(
                        "Sicuro di voler " +
                            (r.active == 0
                                ? "attivare"
                                : "disattivare") +
                            ' il ruolo "' +
                            role +
                            '" per ' +
                            user.firstname +
                            " " +
                            user.lastname +
                            "?"
                    )
                    .ok("Si")
                    .cancel("Ops, ho sbagliato");
                return $mdDialog
                    .show(confirm)
                    .then(function () {
                        if (r.active == 0) {
                            r.active = 1;
                        } else {
                            r.active = 0;
                        }
                        if (vm.haveActiveRole(user)) {
                            user.active = 1;
                        } else {
                            user.active = 0;
                        }
                        UserRolesService.put(
                            {
                                id: r.id,
                                store_id: r.store_id,
                                active: r.active,
                                c_role: vm.user.type,
                                c_sid: vm.user.store_id,
                            },
                            r.id
                        ).then(function (response) {}, vm.checkResponse);
                    })
                    .finally(function () {
                        confirm = undefined;
                    });
            }
        };

        // ---------- Sidebar -------------------------------------//
        vm.undoVisible = false;
        vm.loading = false;
        /* Element Clicked */
        vm.rowClicked = function (operator, role) {
            vm.toggleRight(operator, role);
        };
        vm.activeEntityRoleChanged = function () {
            if (
                vm.activeRole.role != "operator" &&
                vm.activeRole.role != "storemngr" &&
                vm.activeRole.role != "assist"
            ) {
                vm.activeRole.store_id = null;
                vm.activeRole.color = null;
            }
            if (
                vm.activeRole.role == "storemngr" &&
                vm.activeRole.id == null &&
                vm.user.type == "storemngr"
            ) {
                vm.activeRole.store_id = vm.user.store_id;
            }
            if (vm.activeOperatorIsNew) {
                vm.activeOperator.type = vm.activeRole.role;
                vm.activeOperator.store_id = vm.activeRole.store_id;
            }
        };
        vm.activeOperator = {};
        vm.emailKeypressed = false;
        vm.origOperator = {};
        vm.activeRole = {};
        vm.origRole = {};
        vm.activeIsRole = false;
        vm.activeRoleIsNew = false;
        vm.toggleRight = function (operator, role) {
            //$log.info("toggleRight");
            //$log.info(operator);
            //$scope.operatorForm.email.$setValidity('alreadyexists', true);
            vm.usersListDelegate1 = [];
            vm.usersListDelegate2 = [];
            vm.userExists = null;
            vm.showEmailError = false;
            vm.activeOperator = {};
            vm.emailKeypressed = false;
            vm.origOperator = {};
            vm.activeRole = {};
            vm.origRole = {};
            vm.activeIsRole = false;
            vm.activeRoleIsNew = false;
            if (operator != null && operator.id != null) {
                vm.activeOperatorIsNew = false;
                angular.copy(operator, vm.activeOperator);
                angular.copy(operator, vm.origOperator);
                vm.activeIsRole = role != null;
                if (vm.activeIsRole) {
                    vm.activeRoleIsNew = false;
                    angular.copy(role, vm.activeRole);
                    angular.copy(role, vm.origRole);
                }
                if (
                    role != null &&
                    role.role != "operator" &&
                    role.role != "storemngr" &&
                    role.role != "assist"
                ) {
                    //vm.activeRole.store_id = 0;
                    vm.activeRole.store = { data: { id: null } };
                    //vm.activeRole.color = null;
                }
            } else {
                vm.activeOperatorIsNew = true;
                vm.activeIsRole = false;
                vm.activeOperator = vm.getNewEntity();
                vm.emailKeypressed = false;
                //$log.info("???");
                //$log.info(vm.activeOperator);
                vm.activeRole = vm.getNewRoleEntity(vm.activeOperator);
            }
            vm.activeIsCallcenter = false;
            if (!vm.activeIsRole) {
                //se ha almeno un ruolo callcenter
                if (
                    vm.activeOperator.type != "callcenter" &&
                    vm.activeOperator.roles &&
                    vm.activeOperator.roles.data
                ) {
                    var callcenterRoles = $filter("filter")(
                        vm.activeOperator.roles.data,
                        { role: "callcenter", active: true },
                        true
                    );
                    if (callcenterRoles.length > 0) {
                        vm.activeIsCallcenter = true;
                    }
                } else {
                    vm.activeIsCallcenter = true;
                }
                vm.usersListDelegate1 = [];
                if (
                    !vm.activeOperatorIsNew &&
                    vm.activeOperator.delegate1_user_id
                ) {
                    var ud1 = $filter("filter")(
                        vm.usersList,
                        { id: vm.activeOperator.delegate1_user_id },
                        true
                    );
                    if (!ud1.active) {
                        vm.usersListDelegate1.push(ud1);
                    }
                }
                vm.usersListDelegate2 = [];
                if (
                    !vm.activeOperatorIsNew &&
                    vm.activeOperator.delegate2_user_id
                ) {
                    var ud2 = $filter("filter")(
                        vm.usersList,
                        { id: vm.activeOperator.delegate2_user_id },
                        true
                    );
                    if (!ud2.active) {
                        vm.usersListDelegate2.push(ud2);
                    }
                }
                var actives = $filter("filter")(
                    vm.usersList,
                    { active: 1 },
                    true
                );
                vm.usersListDelegate1 = vm.usersListDelegate1.concat(actives);
                vm.usersListDelegate2 = vm.usersListDelegate2.concat(actives);
            }
            $mdSidenav("right").open();
        };
        vm.newRole = function (operator) {
            //$log.info("newRole");
            //$log.info(operator);
            vm.activeIsRole = true;
            vm.activeRoleIsNew = true;
            vm.activeRole = vm.getNewRoleEntity(operator);
            vm.activeOperator = operator;
            vm.emailKeypressed = false;
            vm.activeOperatorIsNew = false;
            $mdSidenav("right").open();
        };
        vm.getNewEntity = function () {
            var sid =
                vm.user.store_id == null || vm.user.store_id == 0
                    ? 0
                    : vm.user.store_id;
            return {
                store_id: sid,
                store: { data: { id: sid } },
                type: null,
                active: 1,
            };
        };
        vm.getNewRoleEntity = function (op) {
            return {
                user_id: op.id,
                store_id: op.store_id,
                store: { data: { id: op.store_id } },
                role: op.type,
                active: true,
            };
        };

        vm.userExists = null;
        vm.showEmailError = null;
        //$log.info("vm.showEmailError==false");
        //$log.info(vm.showEmailError==false);
        vm.onFocusEmail = function (ev) {
            //$log.info("vm.onFocusEmail");
            //$log.info(ev);
            vm.showEmailError = false;
        };
        vm.emailKeypressed = false;
        vm.onKeyPressEmail = function (event) {
            vm.emailKeypressed = true;
        };
        vm.checkEmailExists = function (event) {
            if (!vm.emailKeypressed) {
                $scope.operatorForm.email.$setValidity("alreadyexists", true);
                vm.userExists = null;
                vm.showEmailError = false;
                return;
            }
            $log.info("checkEmailExists");
            //$log.info(vm.activeOperator);
            //$log.info(event);
            //$log.info("vm.showEmailError==false");
            //$log.info(vm.showEmailError==false);
            if (
                vm.showEmailError == false &&
                vm.activeOperator &&
                vm.activeOperator.email &&
                !vm.activeOperator.id &&
                !$scope.operatorForm.email.$error.required &&
                !$scope.operatorForm.email.$error.email
            ) {
                vm.emailChecking = true;
                vm.userExists = null;
                vm.showEmailError = false;
                $log.info("check email: " + vm.activeOperator.email);
                UsersService.searchByEmail(vm.activeOperator.email).then(
                    function (response) {
                        vm.emailChecking = false;
                        if (
                            response.data.data.length >= 1 &&
                            (vm.activeOperator.id == null ||
                                vm.activeOperator.id !=
                                    response.data.data[0].id) &&
                            response.data.data[0].email ==
                                vm.activeOperator.email
                        ) {
                            $scope.operatorForm.email.$setValidity(
                                "alreadyexists",
                                false
                            );
                            vm.userExists = response.data.data[0];
                            vm.showEmailError = true;
                        } else {
                            $scope.operatorForm.email.$setValidity(
                                "alreadyexists",
                                true
                            );
                            vm.userExists = null;
                            vm.showEmailError = false;
                        }
                    }
                );
            }
        };
        vm.closeSidebar = function () {
            vm.resetAll();
        };
        /* Form Reset */
        vm.angularFormReset = function () {
            $scope.operatorForm.$setPristine();
            $scope.operatorForm.$setUntouched();
        };
        vm.resetForm = function () {
            vm.loading = false;
            return $mdSidenav("right")
                .close()
                .then(function () {
                    vm.angularFormReset();
                });
        };
        vm.resetAll = function () {
            return $timeout(vm.resetForm, 10);
        };
        vm.undo = function () {
            $log.info("Undo");
            /*
             * if( ! angular.equals( vm.activeOperator, vm.backup_operator ) ) {
             * angular.copy( vm.backup_operator, vm.activeOperator ); };
             */
            vm.resetAll();
            vm.saving = false;
        };
        /* Response */
        vm.showActionToast = function (text) {
            text = text && angular.isDefined(text) ? text : "Tutto Ok!";
            var toast = $mdToast
                .simple()
                .textContent(text)
                .action("")
                .highlightAction(true)
                .position("bottom right");
            return $mdToast.show(toast).finally(function () {
                toast = undefined;
            });
        };
        vm.checkResponse = function (response) {
            var responseStatusSuccessful = [200, 201, 202, 204];
            if (responseStatusSuccessful.indexOf(response.status) === -1) {
                var alert = $mdDialog
                    .alert()
                    .title("Attenzione")
                    .ariaLabel("Attenzione")
                    .textContent(
                        "C'è stato un problema" +
                            (response.data != null
                                ? ": " + response.data.message
                                : ".")
                    )
                    .ok("Ok");
                return $mdDialog
                    .show(alert)
                    .then(vm.undo)
                    .finally(function () {
                        alert = undefined;
                    });
            } else {
                vm.showActionToast().then(function () {
                    if (vm.activeOperatorIsNew) {
                        // vm.filteredList.push(vm.activeOperator);
                        var newOp = response.data.data;
                        if (newOp.active) {
                            newOp.active = 1;
                        }

                        var store = vm.activeOperator.store;
                        if (
                            store == null ||
                            store.data == null ||
                            store.data.id == null
                        ) {
                            store = { data: { id: 0 } };
                        }
                        var roles = newOp.roles;
                        angular.forEach(roles, function (r) {
                            vm.setStoreInEntity(r, false, newOp);
                        });
                        newOp.roles = { data: roles };
                        vm.operatorsList.push(newOp);
                        if (newOp.designation_type_id) {
                            if (newOp.designation_type_id == 6) {
                                newOp.designation_name = "CoCoCo";
                            } else if (newOp.designation_type_id == 7) {
                                newOp.designation_name = "Partita Iva";
                            }
                        }
                        // vm.filteredItems.push(vm.activeOperator);

                        /*
                         * vm.query.type = vm.activeOperator.type;
                         * vm.query.filter = vm.activeOperator.lastname;
                         */
                    } else {
                        var pos = vm.operatorsList
                            .map(function (x) {
                                return x.id;
                            })
                            .indexOf(vm.activeOperator.id);
                        var operator = vm.operatorsList[pos];
                        if (vm.activeOperator.id && !vm.activeIsRole) {
                            if (vm.activeOperator.designation_type_id) {
                                if (
                                    vm.activeOperator.designation_type_id == 6
                                ) {
                                    vm.activeOperator.designation_name =
                                        "CoCoCo";
                                } else if (
                                    vm.activeOperator.designation_type_id == 7
                                ) {
                                    vm.activeOperator.designation_name =
                                        "Partita Iva";
                                }
                            }
                            angular.copy(vm.activeOperator, operator);
                            // vm.checkUncovered();
                        } else {
                            var role = response.data.data;
                            if (vm.activeRoleIsNew) {
                                vm.setStoreInEntity(role, false, operator);
                                operator.roles.data.push(role);
                            } else {
                                angular.forEach(
                                    operator.roles.data,
                                    function (r) {
                                        if (r.id == role.id) {
                                            angular.copy(vm.activeRole, r);
                                        }
                                    }
                                );
                            }
                        }
                        vm.activeOperator = {};
                        vm.emailKeypressed = false;
                        vm.activeRole = {};
                    }
                    vm.saving = false;
                });
                return vm.resetAll();
            }
        };
        vm.setStoreInActiveEntity = function () {
            vm.setStoreInEntity(vm.activeRole, true);
        };
        vm.setStoreInEntity = function (activeE, inside, op) {
            if (activeE.store_id == null || activeE.store_id == 0) return;
            angular.forEach(vm.storesList, function (store) {
                if (store.id == activeE.store_id) {
                    if (inside) {
                        activeE.store = {
                            data: store,
                        };
                    } else {
                        activeE.store = store;
                    }
                    if (op != null) {
                        op.isPerStore = true;
                    }
                    return;
                }
            });
        };
        vm.update = function () {
            var operator = vm.activeOperator;
            $log.info("Update");
            if (angular.isDefined(operator)) {
                var confirm = $mdDialog
                    .confirm()
                    .title("Attenzione")
                    .ariaLabel("Attenzione")
                    .textContent("Sicuro di voler salvare?")
                    .ok("Si")
                    .cancel("Ops, ho sbagliato");
                return $mdDialog
                    .show(confirm)
                    .then(function () {
                        vm.saving = true;
                        if (vm.activeOperatorIsNew) {
                            vm.activeOperator.store_id = vm.activeRole.store_id;
                            vm.activeOperator.store = vm.activeRole.store;
                            vm.activeOperator.type = vm.activeRole.role;
                            vm.activeOperator.active = vm.activeRole.active;
                            vm.activeOperator.color = vm.activeRole.color;
                            vm.activeOperator.c_sid = vm.user.store_id;
                            vm.activeOperator.c_role = vm.user.type;
                            UsersService.save(vm.activeOperator).then(
                                vm.checkResponse,
                                vm.checkResponse
                            );
                        } else if (vm.activeIsRole) {
                            vm.activeRole.c_sid = vm.user.store_id;
                            vm.activeRole.c_role = vm.user.type;
                            if (
                                vm.activeRole.role != "assist" &&
                                vm.activeRole.role != "operator" &&
                                vm.activeRole.role != "storemngr"
                            ) {
                                vm.activeRole.store_id = null;
                            }
                            if (vm.activeRoleIsNew) {
                                UserRolesService.save(vm.activeRole).then(
                                    vm.checkResponse,
                                    vm.checkResponse
                                );
                            } else {
                                UserRolesService.put(
                                    vm.activeRole,
                                    vm.activeRole.id
                                ).then(vm.checkResponse, vm.checkResponse);
                            }
                        } else {
                            UsersService.put(
                                vm.activeOperator,
                                vm.activeOperator.id
                            ).then(vm.checkResponse, vm.checkResponse);
                        }
                    })
                    .finally(function () {
                        confirm = undefined;
                    });
            }
        };

        /**
         * gestione edit capabilities operator
         */
        vm.dialogCapabilities = function (op) {
            return $mdDialog.confirm({
                title:
                    "Modifica abilitazioni: " +
                    (op.firstname != null ? op.firstname.toUpperCase() : "") +
                    " " +
                    (op.lastname != null ? op.lastname.toUpperCase() : "") +
                    " (uid=" +
                    op.id +
                    ")",
                ariaLabel: "Modifica abilitazioni",
                templateUrl: "app/operators/dialogs/capabilities.html",
                escapeToClose: true,
                controller: [
                    "$scope",
                    "$mdDialog",
                    "$filter",
                    function ($scope, $mdDialog, $filter) {
                        $scope.title = this.title;
                        $scope.button_ok = "Chiudi";
                        $scope.op = op;
                        $scope.capabilitiesList = [];
                        $scope.opCapabilitiesList = [];
                        $scope.loadCapabilities = function () {
                            var pars = {
                                orderBy: "name",
                            };
                            $scope.loading = true;
                            CrudService.all(
                                "capabilities",
                                pars,
                                vm,
                                function (response) {
                                    $scope.op.capabilities = response.data.data;
                                    $scope.loadOpCapabilities();
                                },
                                function (response) {
                                    $scope.loading = false;
                                }
                            );
                        };
                        $scope.loadOpCapabilities = function () {
                            var pars = {
                                search: "user_id:" + $scope.op.id,
                                searchFields: "user_id:=",
                                searchJoin: "and",
                            };
                            CrudService.all(
                                "user_capabilities",
                                pars,
                                vm,
                                function (response) {
                                    angular.forEach(
                                        $scope.op.capabilities,
                                        function (cap) {
                                            cap.comm = 1;
                                            cap.rel = 1;
                                            cap.man = 1;
                                            cap.capability_id = cap.id;
                                            cap.user_id = $scope.op.id;
                                            cap.c_role = vm.user.type;
                                            delete cap.id;
                                            angular.forEach(
                                                response.data.data,
                                                function (opCap) {
                                                    if (
                                                        opCap.capability_id ==
                                                        cap.capability_id
                                                    ) {
                                                        cap.id = opCap.id;
                                                        cap.comm = opCap.comm;
                                                        cap.rel = opCap.rel;
                                                        cap.man = opCap.man;
                                                    }
                                                }
                                            );
                                        }
                                    );
                                    //$log.info($scope.op.capabilities)
                                    $scope.loading = false;
                                },
                                function (response) {
                                    $scope.loading = false;
                                }
                            );
                        };
                        $scope.loadKpi = function () {
                            var pars = {
                                search: "user_id:" + $scope.op.id,
                                searchFields: "user_id:=",
                                searchJoin: "and",
                            };
                            CrudService.all(
                                "kpis",
                                pars,
                                vm,
                                function (response) {
                                    $scope.op.kpi = {};
                                    if (
                                        response.data.data &&
                                        response.data.data.length > 0
                                    ) {
                                        $scope.op.kpi = response.data.data[0];
                                    }
                                    //$log.info($scope.op.kpi);
                                    //$scope.loading = false;
                                },
                                function (response) {
                                    //$scope.loading = false;
                                }
                            );
                        };
                        $scope.save = function (cap) {
                            CrudService.save(
                                "user_capabilities",
                                cap,
                                vm,
                                function (response) {
                                    cap.id = response.data.data.id;
                                    cap.updated_at =
                                        response.data.data.updated_at;
                                    cap.created_at =
                                        response.data.data.created_at;
                                },
                                function (response) {}
                            );
                        };
                        $scope.reset = function (cap, fld) {
                            cap[fld] = 0;
                            CrudService.save(
                                "user_capabilities",
                                cap,
                                vm,
                                function (response) {
                                    cap.id = response.data.data.id;
                                    cap.updated_at =
                                        response.data.data.updated_at;
                                    cap.created_at =
                                        response.data.data.created_at;
                                },
                                function (response) {}
                            );
                        };
                        $scope.close = function () {
                            $mdDialog.hide(true);
                        };
                        $scope.loadCapabilities();
                        //$scope.loadKpi();
                    },
                ],
            });
        };

        vm.dialogCapabilitiesComm = function (op) {
            return $mdDialog.confirm({
                title:
                    "Modifica abilitazioni commerciali: " +
                    (op.firstname != null ? op.firstname.toUpperCase() : "") +
                    " " +
                    (op.lastname != null ? op.lastname.toUpperCase() : ""),
                ariaLabel: "Abilitazioni commerciali",
                templateUrl: "app/operators/dialogs/capabilitiesComm.html",
                escapeToClose: true,
                controller: [
                    "$scope",
                    "$mdDialog",
                    "$filter",
                    function ($scope, $mdDialog, $filter) {
                        $scope.title = this.title;
                        $scope.button_ok = "Chiudi";
                        $scope.op = op;
                        //$log.info(op);
                        $scope.user = vm.user;
                        $scope.env = vm.env;
                        $scope.mdDialog = $mdDialog;
                        $scope.mdToast = vm.mdToast;
                        $scope.categories = vm.categories;
                        $scope.regions = vm.regions;
                        /*$scope.categoryAll = function (val) {
                            this.capabilitiesForm.$setDirty();
                            if (this.capabilitiesForm.categories) {
                                this.capabilitiesForm.categories.$dirty = true;
                            }
                            $scope.activeUserAttr.categories = [];
                            $scope.activeUserAttr.regions = [];
                            if (val) {
                                angular.forEach(
                                    $scope.categories,
                                    function (c) {
                                        $scope.activeUserAttr.categories.push(
                                            c.category
                                        );
                                    }
                                );
                                $scope.activeUserAttr.regions.push('non presente');
                                angular.forEach($scope.regions, function (c) {
                                    $scope.activeUserAttr.regions.push(
                                        c.region
                                    );
                                });
                            }
                        };*/
                        $scope.pricingsAll = function(val) {
                            this.capabilitiesForm.$setDirty();
                            if (this.capabilitiesForm.categories) {
                                this.capabilitiesForm.categories.$dirty = true;
                            }
                            $scope.activeUserAttr.categories = [];
                            if (val) {
                                angular.forEach($scope.categories, function (c) {
                                    $scope.activeUserAttr.categories.push(c.category);
                                });
                            }
                        }
                        $scope.regionsAll = function(val) {
                            $scope.activeUserAttr.regions = [];
                            if (val) {
                                $scope.activeUserAttr.regions.push('non presente');
                                angular.forEach($scope.regions, function (c) {
                                    $scope.activeUserAttr.regions.push(c.region);
                                });
                            }
                        }
                        $scope.loadOpUserAttrs = function () {
                            $scope.activeUserAttr = {
                                user_id: $scope.op.id,
                                date_from: new Date(
                                    moment().hour(8).minute(0).second(0)
                                ),
                                date_to: null,
                                categories: [],
                                f_lead_new_a: 0,
                                f_lead_new_b: 0,
                                f_lead_rientri: 0,
                                time_perc: 100
                            };
                            var pars = {
                                search: "user_id:" + $scope.op.id,
                                searchFields: "user_id:=",
                                searchJoin: "and",
                                orderBy: "date_from",
                                sortedBy: "desc",
                            };
                            $scope.loading = true;
                            CrudService.all(
                                "user_attrs",
                                pars,
                                vm,
                                function (response) {
                                    $scope.op.user_attrs = response.data.data;
                                    angular.forEach(
                                        $scope.op.user_attrs,
                                        function (ua) {
                                            ua.date_from_frmt = moment(
                                                ua.date_from
                                            ).format("DD/MM/YYYY");
                                            if (ua.date_to == "2999-12-31") {
                                                ua.date_to_frmt = "";
                                            } else {
                                                ua.date_to_frmt = moment(
                                                    ua.date_to
                                                ).format("DD/MM/YYYY");
                                            }
                                        }
                                    );
                                    $scope.loadOpUserLeadCategories();
                                },
                                function (response) {
                                    $scope.loading = false;
                                }
                            );
                        };
                        $scope.loadOpUserLeadCategories = function () {
                            var pars = {
                                search: "user_id:" + $scope.op.id,
                                searchFields: "user_id:=",
                                searchJoin: "and",
                                orderBy: "date_from",
                                sortedBy: "asc",
                            };
                            CrudService.all(
                                "user_lead_categories",
                                pars,
                                vm,
                                function (response) {
                                    angular.forEach(
                                        $scope.op.user_attrs,
                                        function (user_attr) {
                                            user_attr.user_lead_categories =
                                                $filter("filter")(
                                                    response.data.data,
                                                    {
                                                        date_from:
                                                            user_attr.date_from,
                                                    },
                                                    true
                                                );
                                            user_attr.categories = [];
                                            user_attr.regions = [];

                                            angular.forEach(
                                                user_attr.user_lead_categories,
                                                function (cat) {
                                                    if (
                                                        cat.field == "default"
                                                    ) {
                                                    user_attr.categories.push(
                                                        cat.category
                                                    );
                                                    } else if (
                                                        cat.field == "region"
                                                    ) {
                                                        user_attr.regions.push(
                                                            cat.category
                                                        );
                                                    }
                                                }
                                            );
                                        }
                                    );
                                    //$log.info($scope.op.user_attrs);
                                    $scope.loading = false;
                                },
                                function (response) {
                                    $scope.loading = false;
                                }
                            );
                        };
                        $scope.save = function () {
                            $scope.saving = true;
                            var user_attr = {
                                user_id: $scope.op.id,
                                categories: $scope.activeUserAttr.categories,
                                regions: $scope.activeUserAttr.regions,
                                date_from: moment(
                                    $scope.activeUserAttr.date_from
                                ).format("YYYY-MM-DD"),
                                date_to: $scope.activeUserAttr.date_to
                                    ? moment(
                                          $scope.activeUserAttr.date_to
                                      ).format("YYYY-MM-DD")
                                    : "2999-12-31",
                                f_lead_new_a:
                                    $scope.activeUserAttr.f_lead_new_a,
                                f_lead_new_b:
                                    $scope.activeUserAttr.f_lead_new_b,
                                f_lead_rientri:
                                    $scope.activeUserAttr.f_lead_rientri,

                                f_lead_dup_wrk: $scope.activeUserAttr.f_lead_dup_wrk,
                                f_lead_dup_regen: $scope.activeUserAttr.f_lead_dup_regen,

                                time_perc: $scope.activeUserAttr.time_perc,
                            };
                            CrudService.save(
                                "user_attrs",
                                user_attr,
                                $scope,
                                function (response) {
                                    $scope.saving = false;
                                    /**
                                     * Se il periodo selezionato comprende oggi devo aggiornare dati operatore corrente
                                     */
                                    var today = moment().format("YYYY-MM-DD");
                                    if (
                                        user_attr.date_from <= today &&
                                        user_attr.date_to >= today
                                    ) {
                                        $scope.op.categories =
                                            user_attr.categories;
                                        $scope.op.regions = user_attr.regions;
                                        $scope.op.user_attr_current = {
                                            data: user_attr,
                                        };
                                    }

                                    $scope.loadOpUserAttrs();
                                },
                                function (response) {
                                    $scope.saving = false;
                                }
                            );
                        };
                        $scope.del = function (ua) {
                            $log.info("----- ELIMINO -----");
                            //$log.info(vm.activeEvent);
                            var msg =
                                "Sicuro di voler eliminare l'abilitazione con data inizio " +
                                ua.date_from_frmt +
                                "?";
                            /*var dialog = $mdDialog.confirm()
                            .title( 'Attenzione' )
                            .ariaLabel( 'Attenzione' )
                            .textContent( msg )
                            .ok( 'Si' )
                            .cancel( 'Ops, ho sbagliato' )
                        ;
                        return $mdDialog
                            .show( dialog )
                            .then( function() {

                          */
                            if (confirm(msg)) {
                                $scope.deleting = true;
                                CrudService.del(
                                    "user_attrs",
                                    ua.id,
                                    $scope,
                                    function () {
                                        $log.info("Eliminato");
                                        var today =
                                            moment().format("YYYY-MM-DD");
                                        if (
                                            ua.date_from <= today &&
                                            ua.date_to >= today
                                        ) {
                                            $scope.op.categories = [];
                                            $scope.op.user_attr_current = {
                                                data: {},
                                            };
                                        }
                                        $scope.op.user_attrs = _.without(
                                            $scope.op.user_attrs,
                                            _.find($scope.op.user_attrs, [
                                                "id",
                                                ua.id,
                                            ])
                                        );
                                        $scope.deleting = false;
                                    },
                                    function (error) {
                                        $scope.deleting = false;
                                    }
                                );
                            }
                            /* }).finally(
                                function() {
                                    dialog = undefined;
                                }
                            )
                        ;*/
                        };
                        $scope.close = function () {
                            $mdDialog.hide(true);
                        };
                        $scope.loadOpUserAttrs();
                    },
                ],
            });
        };

        vm.editCapabilities = function (op) {
            //$log.info(op);
            var dialog = null;
            if (op.type == "callcenter") {
                dialog = vm.dialogCapabilitiesComm(op);
            } else {
                dialog = vm.dialogCapabilities(op);
            }
            return $mdDialog.show(dialog).finally(function () {
                dialog = undefined;
            });
        };

        vm.categories = [];
        vm.categoriesLoad = function () {
            vm.categories = [];
            $http
                .get(env.API + "/leads_campaign_categories")
                .then(function (response) {
                    if (response.data && response.data.data) {
                        vm.categories = response.data.data;
                    }
                });
        };
        vm.categoriesLoad();

        vm.regions = [];
        vm.regionsLoad = function () {
            vm.regions = [];
            $http
                .get(env.API + "/leads_campaign_regions")
                .then(function (response) {
                    if (response.data && response.data.data) {
                        vm.regions = response.data.data;
                    }
                });
        };
        vm.regionsLoad();

        /*
         * $scope.$watch( 'op.activeOperator', function ( newValue ) { if(
         * newValue ) { vm.undoVisible = ( angular.equals( newValue,
         * vm.backup_operator ) ) ? false : true; }; }, true );
         */
        /* WATCHO Lo Store */
        /* Store */
        vm.storesList = [];
        vm.storeId = null;
        $scope.$watch("$parent.selectedStore", function (id) {
            if (angular.isDefined(id)) {
                if (vm.storeId == null) {
                    // è il primo caricamento
                    vm.storesList = $scope.$parent.main.storesList;
                    vm.storeId = id;
                    vm.query.type = vm.user.type;
                    vm.query.store_id =
                        vm.user.store_id == null ? 0 : vm.sotreId;
                    vm.operatorLoad();
                } else if (
                    vm.user.type == "operator" ||
                    vm.user.type == "storemngr" ||
                    vm.user.type == "assist"
                ) {
                    vm.storeId = id;
                    vm.query.store_id = id;
                } else {
                    if (
                        vm.query.type == "operator" ||
                        vm.user.type == "storemngr" ||
                        vm.user.type == "assist"
                    ) {
                        vm.query.store_id = id;
                    } else {
                        vm.query.store_id = 0;
                    }
                    vm.storeId = id;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('MonthCashController', MonthCashController);

    /** @ngInject */
    function MonthCashController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        CallState,
        Italia,
        UsersService,
        ClosingCashService,
        MONTHS
    ) {
        var vm = this;
        vm.MONTHS = MONTHS;
        $log.info('MonthCashController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.env = env;

        vm.query = {
           year: parseInt(moment().format('YYYY')),
           month: parseInt(moment().format('MM')),
           perDay: false,
           perMonth: false
        };

        vm.query.from = ''+vm.query.year+'-'+vm.query.month+'-01';
        vm.query.to = moment(vm.query.from).add(1,'month').format('YYYY-MM-DD');
        vm.date = {startDate: moment(''+vm.query.year+'-'+vm.query.month+'-01'), endDate: moment(vm.query.from).add(1,'month')};
        vm.options = {
            buttonClasses: 'md-button md-raised',
            applyClass: 'md-accent',
            cancelClass: 'md-warn',
            format: 'DD/MM/YYYY',
            customRangeLabel: "asd",
            opens: "right",
            locale: {
                format: 'DD/MM/YYYY',
                separator: " - ",
                applyLabel: "Conferma",
                cancelLabel: "Annulla",
                fromLabel: "Dal",
                toLabel: "Al",
                customRangeLabel: "Scegli un range",
            },
            parentEl: ".page-dashboard",
            ranges: {
                'Oggi': [moment(), moment()],
                'Ieri': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Ultima sett.': [moment().subtract(7, 'days'), moment()],
                'Ultime 2 sett.': [moment().subtract(7, 'days'), moment().add(7, 'days')],
                'Ultimi 30 giorni': [moment().subtract(30, 'days'), moment()],
                'Questo mese': [moment().startOf('month'), moment().endOf('month')]
            }
        };
        $scope.$watch( 'ab.date', function( newDate ) {
                $log.info( 'New date set: ', newDate );
                //vm.reload(true);
                vm.query.year=0;
                vm.query.month=0;
        }, false );

        vm.years = [];
        for (var i=2017; i-1<=parseInt(vm.query.year); i++) {
            vm.years.push(''+i);
        }

        vm.removeSearch = function() {
            vm.query.year = parseInt(moment().format('YYYY'));
            vm.query.month = parseInt(moment().format('MM'));
            vm.query.perDay = false;
            vm.date = {startDate: moment(''+vm.query.year+'-'+vm.query.month+'-01'), endDate: moment(vm.query.from).add(1,'month')};
            vm.eListLoad();
        };

        vm.eListLoading = true;
        vm.eList = [];
        vm.getSearch = function() {
            var search = ['operator_id:0'];
            if (vm.storeId) {
                search.push("store_id:"+vm.storeId);
            }
            if (vm.query.month) {
                search.push("month:"+vm.query.month);
            }
            search.push("year:"+vm.query.year);
            return search.join(';');
        };
        vm.getSearchFields = function() {
            var searchFields = ['operator_id:='];
            if (vm.storeId) {
                searchFields.push("store_id:=");
            }
            if (vm.query.month) {
                searchFields.push("month:=");
            }
            searchFields.push("year:=");
            return searchFields.join(';');
        }
        vm.eListLoad = function() {
            vm.eListLoading = true;
            vm.eList = [];
            vm.total = 0;
            vm.total_rel_gift = 0;
            vm.total_rel_gift_s = 0;
            vm.total_10 = 0;
            vm.total_coupon = 0;
            vm.total_pos = 0;
            vm.total_card = 0;
            vm.total_app = 0;
            vm.total_dil = 0;
            vm.total_apppago = 0;
            vm.total_light = 0;
            vm.total_small = 0;
            vm.total_satis = 0;
            vm.total_stripe = 0;
            vm.total_bon = 0;
            vm.total_check = 0;
            vm.total_gift_ns = 0;
            vm.total_gift = 0;
            if (vm.query.month) {
                vm.query.perMonth = false;
            }
            if (!vm.storeId) {
                if (!vm.query.perDay || vm.query.perMonth) {
                    vm.exportUrl = ClosingCashService.allGroupByStoreUrl(
                            vm.query.month,
                            vm.query.year,
                            vm.query.perMonth
                    )
                    +'&export=true'
                    +'&token='+vm.token;
                    //$log.info(vm.exportUrl);
                    ClosingCashService.allGroupByStore(
                            vm.query.month,
                            vm.query.year,
                            vm.query.perMonth
                    ).then(
                            vm.handleListLoadResponse,
                            function (response) {
                                vm.checkResponse(response);
                                vm.eListLoading = false;
                            }
                        );
                } else {
                    vm.exportUrl = ClosingCashService.allGroupByDateUrl(
                            vm.query.month,
                            vm.query.year
                    )
                    +'&export=true'
                    +'&token='+vm.token;
                    $log.info(vm.exportUrl);
                    ClosingCashService.allGroupByDate(
                            vm.query.month,
                            vm.query.year
                    ).then(
                            vm.handleListLoadResponse,
                            function (response) {
                                vm.checkResponse(response);
                                vm.eListLoading = false;
                            }
                        );
                }
            } else {
                if (vm.query.perMonth) {
                    vm.exportUrl = ClosingCashService.allGroupByStoreUrl(
                            vm.query.month,
                            vm.query.year,
                            vm.query.perMonth,
                            vm.storeId
                    )
                    +'&export=true'
                    +'&token='+vm.token;
                    $log.info(vm.exportUrl);
                    ClosingCashService.allGroupByStore(
                            vm.query.month,
                            vm.query.year,
                            vm.query.perMonth,
                            vm.storeId
                    ).then(
                            vm.handleListLoadResponse,
                            function (response) {
                                vm.checkResponse(response);
                                vm.eListLoading = false;
                            }
                        );
                } else {
                    var pars = {};
                    pars.searchFields = vm.getSearchFields();
                    pars.search = vm.getSearch();
                    pars.orderBy = 'date';
                    vm.exportUrl = env.API + '/closing-cash?searchFields='
                        +pars.searchFields
                        +'&search='+pars.search
                        +'&orderBy=date&export=true'
                        +'&token='+vm.token;
                    $log.info(vm.exportUrl);
                    ClosingCashService.all(pars).then(
                        vm.handleListLoadResponse,
                        function (response) {
                            vm.checkResponse(response);
                            vm.eListLoading = false;
                        }
                    );
                }
            }
        };

        vm.handleListLoadResponse = function(response) {
            if (response.data && response.data.data) {
                vm.eList = [];
                vm.total = 0;
                vm.total_rel_gift = 0;
                vm.total_10 = 0;
                vm.total_coupon = 0;
                vm.total_pos = 0;
                vm.total_card = 0;
                vm.total_app = 0;
                vm.total_dil = 0;
                vm.total_apppago = 0;
                vm.total_light = 0;
                vm.total_small = 0;
                vm.total_satis = 0;
                vm.total_stripe = 0;
                vm.total_bon = 0;
                vm.total_check = 0;
                vm.total_gift = 0;
                //vm.pagOpts = response.data.meta.pagination;
                angular.forEach(response.data.data, function(elem) {
                    if (elem.created_at) {
                        elem.created_at_formatted = moment(elem.created_at.date).format('DD/MM HH:mm');
                    }
                    if (!vm.storeId || vm.query.perMonth) {
                        elem.total = parseFloat(elem.total);
                        elem.total_rel_gift = parseFloat(elem.total_rel_gift);
                        elem.total_rel_gift_s = parseFloat(elem.total_rel_gift_s);
                        elem.total_10 = parseFloat(elem.total_10);
                        elem.total_coupon = parseFloat(elem.total_coupon);
                        elem.total_pos = parseFloat(elem.total_pos);
                        elem.total_card = parseFloat(elem.total_card);
                        elem.total_app = parseFloat(elem.total_app);
                        elem.total_dil = parseFloat(elem.total_dil);
                        elem.total_apppago = parseFloat(elem.total_apppago);
                        elem.total_light = parseFloat(elem.total_light);
                        elem.total_small = parseFloat(elem.total_small);
                        elem.total_satis = parseFloat(elem.total_satis);
                        elem.total_stripe = parseFloat(elem.total_stripe);
                        elem.total_bon = parseFloat(elem.total_bon);
                        elem.total_check = parseFloat(elem.total_check);
                        elem.total_gift = parseFloat(elem.total_gift);
                    }
                    vm.total+=elem.total;
                    vm.total_rel_gift+=elem.total_rel_gift;
                    vm.total_rel_gift_s+=elem.total_rel_gift_s;
                    vm.total_10+=elem.total_10;
                    vm.total_coupon+=elem.total_coupon;
                    vm.total_pos+=elem.total_pos;
                    vm.total_card+=elem.total_card;
                    vm.total_app+=elem.total_app;
                    vm.total_dil+=elem.total_dil;
                    vm.total_apppago+=elem.total_apppago;
                    vm.total_light+=elem.total_light;
                    vm.total_small+=elem.total_small;
                    vm.total_satis+=elem.total_satis;
                    vm.total_stripe+=elem.total_stripe;
                    vm.total_bon+=elem.total_bon;
                    vm.total_check+=elem.total_check;
                    vm.total_gift+=elem.total_gift;
                    vm.total_gift_ns+=elem.total_gift_ns;
                });
                vm.eList = response.data.data;
            }
            vm.eListLoading = false;
        };

        vm.showActionToast = function( text) {
            text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent(text)
                .action('')
                .highlightAction(true)
                .position('bottom right');
            return $mdToast
                .show(toast)
                .finally(
                    function() {
                        toast = undefined;
                    }
                );
        };
        vm.responseStatusSuccessful = [200, 201, 202, 203, 204];
        vm.checkResponse = function(response) {
            if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
                var errMsg = "";
                if (response.data!=null && response.data.message!=null) {
                    errMsg = response.data!=null && response.data.message!=null?response.data.message:"";
                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    vm.showActionToast("KO: " + errMsg + " " + url);
                }
                var alert = $mdDialog.alert()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent("C'è stato un problema: "+errMsg)
                    .ok('Ok');
                return $mdDialog
                    .show(alert)
                    .finally(
                        function() {
                            alert = undefined;
                        }
                    );
            } else {
                vm.showActionToast();
                return;
            };
        };

        vm.pdf = function () {
            window.open(env.API+"/closing-cash?token="+vm.token+"&pdf=true&orderBy=date&search="+vm.getSearch()+"&searchFields="+vm.getSearchFields());
        };

        vm.sendPdf = function () {
            window.open(env.API+"/closing-cash?token="+vm.token+"&pdf=send&orderBy=date&search="+vm.getSearch()+"&searchFields="+vm.getSearchFields());
        };

        /* WATCHO Lo Store */
        vm.storeId = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                vm.storeId = id;
                vm.eListLoad();
            };
        });

        vm.perm = {
            canFire: function (id, ent) {
                return $scope.$parent.main.perm.canFire(id, ent);
            },
            canRead: function (id, ent) {
                return $scope.$parent.main.perm.canRead(id, ent);
            },
            canCreate: function (id, ent) {
                return $scope.$parent.main.perm.canCreate(id, ent);
            },
            canUpdate: function (id, ent) {
                return $scope.$parent.main.perm.canUpdate(id, ent);
            },
            canDelete: function (id, ent) {
                return $scope.$parent.main.perm.canDelete(id, ent);
            },
            canSave: function (id, ent) {
                return $scope.$parent.main.perm.canSave(id, ent);
            }
       };
    };

    MonthCashController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',
            'CallState',
            'Italia',
            'UsersService',
            'ClosingCashService',
            'MONTHS'
        ];

})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .service(
            'CrudService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    all : function( ent, options, vm, callbacksuccess, callbackfail) {
                        if( ! options ) { options = {}; }
                        var apiURI = env.API + '/'+ent;
                        var crudService = this;
                        return $http.get( apiURI, { params: options }).then( 
                        		function (response) {
                        			if (response.data.error) {
                        				return crudService.handleError(vm, response).then(callbackfail(response));
                        			}
                        			if (response.data && response.data.data && response.data.data.length) {
										angular.forEach(response.data.data, function(elem) {
											if (elem.created_at!=null && elem.created_at.date!=null) {
												elem.created_at_formatted = moment(elem.created_at.date).format('DD/MM/YYYY HH:mm');
											} else if (elem.created_at!=null) {
											  elem.created_at_formatted = moment(elem.created_at).format('DD/MM/YYYY HH:mm');
											}
											if (elem.updated_at!=null && elem.updated_at.date!=null) {
												elem.updated_at_formatted = moment(elem.updated_at.date).format('DD/MM/YYYY HH:mm');
											} else if (elem.updated_at!=null) {
                        elem.updated_at_formatted = moment(elem.updated_at).format('DD/MM/YYYY HH:mm');
                      }
										});
									}
                        			callbacksuccess(response);
                        			//crudService.showActionToast(vm);
                        			return response.data;
                        		},
                        		function (response) {
                        			crudService.handleError(vm, response).then(callbackfail(response));
                        		}
                        );
                    },
                    get : function( ent, id,  options, vm, callbacksuccess, callbackfail) {
                    	var apiURI = env.API + '/' + ent + '/' + id;
                        if( angular.isDefined( id ) && id ) {
                            var apiURI = env.API + '/' + ent + '/' + id;
                            var crudService = this;
                            if( ! options ) { options = {}; }
                            return $http.get( apiURI, { params: options } ).then( 
                            		function (response) {
                            			if (response.data.error) {
                            				return crudService.handleError(vm, response).then(callbackfail(response));
                            			}
                            			callbacksuccess(response);
                            			crudService.showActionToast(vm);
                            			return response.data;
                            		},
                            		function (response) {
                            			crudService.handleError(vm, response).then(callbackfail(response));
                            		}
                            );
                        } else {
                        	this.handleError(vm, {config: {url: apiURI }, data: {message: 'CrudService.get: id non presente.'}});
                        }
                    },
                    update : function( ent, data, vm, callbacksuccess, callbackfail) {
                    	var apiURI = env.API + '/' + ent + '/' + data.id;
                        if( angular.isDefined( data ) && angular.isObject( data ) && data.id ) {
                            var crudService = this;
                            data.c_sid = vm.user.store_id;
                            data.c_role = vm.user.type;
                            return $http.put( apiURI, data ).then( 
                            		function (response) {
                            			if (response.data.error) {
                            				return crudService.handleError(vm, response).then(callbackfail(response));
                            			}
                            			callbacksuccess(response);
                            			crudService.showActionToast(vm);
                            		},
                            		function (response) {
                            			crudService.handleError(vm, response).then(callbackfail(response));
                            		}
                            );
                        } else {
                        	this.handleError(vm, {config: {url: apiURI }, data: {message: 'CrudService.update: id non presente.'}});
                        }
                    },
                    save : function( ent, data, vm, callbacksuccess, callbackfail) {
                        if( angular.isDefined( data ) && angular.isObject( data ) ) {
							if (data.id) {
								return this.update(ent, data, vm, callbacksuccess, callbackfail); 
							}
                            var apiURI = env.API + '/' + ent;
                            var crudService = this;
                            data.c_sid = vm.user.store_id;
                            data.c_role = vm.user.type;
                            return $http.post( apiURI, data ).then( 
                            		function (response) {
                            			if (response.data.error) {
                            				return crudService.handleError(vm, response).then(callbackfail(response));
                            			}
                            			callbacksuccess(response);
                            			crudService.showActionToast(vm);
                            		},
                            		function (response) {
                            			crudService.handleError(vm, response).then(callbackfail(response));
                            		}
                            );
                        }
                    },
                    del : function( ent, id, vm, callbacksuccess, callbackfail) {
                    	var apiURI = this.getApiUrl(ent) + '/' + ent + "/" + id;
                        if( angular.isDefined( id ) && id ) {
                            var crudService = this;
                            return $http.delete( apiURI).then( 
                            		function (response) {
                            			if (response.data.error) {
                            				return crudService.handleError(vm, response).then(callbackfail(response));
                            			}
                            			callbacksuccess(response);
                            			crudService.showActionToast(vm);
                            		},
                            		function (response) {
                            			crudService.handleError(vm, response).then(callbackfail(response));
                            		}
                            );
                        } else {
                        	this.handleError(vm, {config: {url: apiURI }, data: {message: 'CrudService.delete: id non presente.'}});
                        }
                    },
                    showActionToast: function( vm, text ) {
                        text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
                        var toast = vm.mdToast.simple()
                            .textContent( text )
                            .action( '' )
                            .highlightAction( true )
                            .position( 'bottom right' )
                        ;
                        return vm.mdToast
                            .show( toast )
                            .finally(
                                function() {
                                    toast = undefined;
                                }
                            )
                        ;
                    },
                    getApiUrl: function(ent) {
                    	return env.API;
                    },
                    handleError: function (vm, response) {
                    	var errMsg = "";
                    	$log.error(response);
                    	if (response.data!=null && response.data.message!=null) {
                    		errMsg = response.data!=null && response.data.message!=null?JSON.stringify(response.data.message):"";
                    		var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    		if (url!=null) {
                    			errMsg+= " " + url;
                    		}
                    		//this.showActionToast(vm, "KO: " + errMsg + " " + url);
                    	}
                        var alert = vm.mdDialog.alert()
                            .title( 'Attenzione' )
                            .ariaLabel( 'Attenzione' )
                            .textContent( "C'è stato un problema: "+errMsg)
                            .ok( 'Ok' )
                        ;
                        return vm.mdDialog
                            .show( alert )
                            .finally(
                                function() {
                                    alert = undefined;
                                }
                            )
                        ;                    
                    }
                };
            }
        )
        /*.service(
            'StoreService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    all : function() {
                        var apiURI = env.API + '/stores';
                        return $http.get( apiURI );
                    },
                    get : function( id ) {
                        if( angular.isDefined( id ) && id ) {
                            var apiURI = env.API + '/stores/' + id;
                            return $http.get( apiURI );
                        };
                    },
                    update : function( data ) {
                        if(
                            angular.isDefined( data ) &&
                            angular.isObject( data ) &&
                            data.id
                        ) {
                            var apiURI = env.API + '/stores/' + data.id;
                            return $http.put( apiURI, data );
                        };
                    },
                    save : function( data ) {
                        if(
                            angular.isDefined( data ) &&
                            angular.isObject( data )
                        ) {
                            var apiURI = env.API + '/stores';
                            return $http.post( apiURI, data );
                        };
                    }
                };
            }
        )*/
        .service(
            'NextDayAppointments',
            function(
                env,
                $http
            ) {
                return {
                    remainder: function( store_id, user_id ) {
                        var apiURI = env.API + '/appointments?remainder=true&with=user;customer;treatment&store_id=' + store_id + '&user_id=' + user_id;
                        return $http.get( apiURI );
                    },
                };
            }
        )
        .service(
            'PollService',
            [
                'env',
                '$q',
                '$http',
                '$timeout',
                function(
                    env,
                    $q,
                    $http,
                    $timeout
                ) {
                    var notification = {};

                    notification.poller = function( callback, error, urls, timing ) {

                        var api_urls = urls.map(
                            function( url ) {
                                return $http.get( env.API + url );
                            }
                        );

                        return $q
                            .all( api_urls )
                            .then( callback )
                            .catch( error )
                            .finally(
                                function() {
                                    $timeout(
                                        function() {
                                            notification.poller( callback, error, urls, timing )
                                        },
                                        timing
                                    );
                                }
                            )
                        ;
                    };

                    return notification;
                }
            ]
        )
        .service(
            'SubscriptionService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    all : function( options ) {
                        if( ! options ) {
                            options = {};
                        }
                        var apiURI = env.API + '/subscriptions';
                        return $http.get( apiURI, { params: options } );
                    },
                };
            }
        )
        .service(
            'CustomerSubscriptionService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    get : function( options ) {
                        if( ! options ) {
                            options = {};
                        }
                        var apiURI = env.API + '/customer_subscriptions';
                        return $http.get( apiURI, { params: options } );
                    },
                };
            }
        )
        .service(
            'AppointmentsService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    all : function( options ) {
                        if( ! options ) {
                            options = {};
                        };
                        var apiURI = env.API + '/appointments';
                        return $http.get( apiURI, { params: options } );
                    },
                    get : function( id, options ) {
                        if( angular.isDefined( id ) && id ) {
                            var apiURI = env.API + '/appointments/' + id;
                            return $http.get( apiURI, { params: options } );
                        };
                    },
                    update : function( data ) {
                        if(
                            angular.isDefined( data ) &&
                            angular.isObject( data ) &&
                            data.id
                        ) {
                            if (data.date_start!=null) {
                              data.date_start = moment( data.date_start ).format( 'YYYY-MM-DD HH:mm' );
                            }
                            if (data.date_end!=null) {
                              data.date_end = moment( data.date_end ).format( 'YYYY-MM-DD HH:mm' );
                            }
                            
                            var apiURI = env.API + '/appointments/' + data.id;
                            return $http.put( apiURI, data );
                        };
                    },
                    del : function( data ) {
                        if(
                            angular.isDefined( data ) &&
                            angular.isObject( data ) &&
                            data.id
                        ) {
                            var apiURI = env.API + '/appointments/' + data.id;
                            return $http.delete( apiURI );
                        };
                    },
                    save : function( data ) {
                        if(
                            angular.isDefined( data ) &&
                            angular.isObject( data )
                        ) {
                            var apiURI = env.API + '/appointments';
                            return $http.post( apiURI, data );
                        };
                    },
                };
            }
        )
        .filter( 'subscriptionIdtoName', function() {
            return function ( selected, array ) {
                if ( angular.isDefined( array ) && angular.isDefined( selected ) && array.length > 0 ) {
                    var value = "";
                    angular.forEach( array, function ( elemArray ) {
                        if ( angular.equals( elemArray.id, selected ) ) {
                            value = elemArray.name;
                        }
                    });
                    return value;
                }
                return selected;
            };
        })
        .factory( "LS", function( $window, $rootScope ) {
            angular.element( $window ).on( 'storage', function( event ) {
                if ( event.key === 'Biolaser_token' ) {
                    $rootScope.$apply();
                }
            });
            return {
                removeData: function( elem ) {
                    return $window.localStorage && $window.localStorage.removeItem( elem );
                },
                setData: function( elem, val ) {
                    $window.localStorage && $window.localStorage.setItem( elem, val );
                    return this;
                },
                getData: function( elem ) {
                    return $window.localStorage && $window.localStorage.getItem( elem );
                },
                getToken: function() {
                    return this.getData( 'Biolaser_token' );
                }
            };
        })
    ;

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController(
        $scope,
        $window,
        $log,
        $http,
        env,
        store_id,
        version,
        $auth,
        $state,
        $timeout,
        $interval,
        $mdSidenav,
        Restangular,
        StoreService,
        $mdMedia,
        NextDayAppointments,
        $mdDialog,
        $mdToast,
        CustomerService,
        PollService,
        CallState,
        logout,
        UsersService
        ,$pusher
    ) {
        var vm = this;
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.random = Math.floor(Math.random()*100000);
        /**
         * {
            '150': {color: 'violet'},
            '100': {color: 'green'},
            '50': {color: 'orange'},
            '25': {color: 'yellow'},
            '0': {color: 'red'}
            }
         */
        vm.thresholds ={
            '160': {color: '#38761d'},
            '140': {color: '#93c47d'},
            '120': {color:  '#b6d7a8'},
            '100': {color:  '#d9ead3'},
            '80': {color:  '#ffff00'},
            '60': {color:  '#ff9900'},
            '40': {color:  '#e06666'},
            '20': {color:  '#ff0000'},
            '0': {color:  '#660000'}
        };
        $log.info('MainController');

        if( logout == 1 ) {
            vm.doLogout("MainControllerLogoutFromPars");
        }


        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, vm)) {
            return;
        }
        $log.info("main store_id: "+store_id);
        $log.info("main user_id: "+vm.user.id);
        $log.info("main user tenant: "+vm.user.tenant);


        vm.setCurrentAPI = function() {
            if (vm.selectedArea == 'Italia') {
                vm.env.API = vm.apiItalia;
            } else if (vm.env.apis && vm.env.apis[vm.selectedArea]) {
                vm.env.API = vm.env.apis[vm.selectedArea];
            } else {
                $log.error("setCurrentAPI -> ATTENZIONE Area non trovata: " + vm.selectedArea + " utilizzo default " + vm.env.API );
            }
            vm.env.currentTenant = vm.selectedArea;
            Restangular.setBaseUrl(vm.env.API);
        };
        vm.apiItalia = vm.env.tenant=='Italia'?vm.env.API:null;
        if (vm.user.selectedArea && vm.env.apis) {
            vm.selectedArea = vm.user.selectedArea;
            vm.setCurrentAPI();
        } else {
            vm.selectedArea = vm.env.tenant;
            vm.env.currentTenant = vm.selectedArea;
        }
        $log.info("main current Tenant: "+vm.env.currentTenant);
        if (vm.user.tenant != vm.env.currentTenant) {
            $log.error("main: user tenant!=currentTenant vm.user.tenant=" + vm.user.tenant + ' vm.env.currentTenant=' + vm.env.currentTenant);
        }

        /**
         * Enable pusher
         */
        // Enable pusher logging - don't include this in production
            //Pusher.logToConsole = true;
            vm.client = new Pusher(vm.env.pusher_key?vm.env.pusher_key:'a9119391f9a6c97a31a8', {
                cluster: 'eu'
            });
            vm.pusher = $pusher(vm.client);
            vm.channel = vm.pusher.subscribe(vm.env.currentTenant+'-waMessage-channel');
            vm.channel.bind('waMessage-event', function(data) {
                vm.onWAMessageRecived(data);
            });
            vm.channel.bind('waNotify-event', function(data) {
                vm.onWaNotify(data);
            });
            vm.channel.bind('wk-event', function(data) {
                vm.wkListOnWkEventReceived(data);
            });
            $scope.$on("$destroy", function() {
                console.log('unbind main pusher channel');
                vm.channel.unbind();
            });

        vm.onWAMessageRecived = function(data) {
            $log.info("onWAMessageRecived main");
            //$log.info(data);
            vm.onWaNotify(data);
            vm.appointmentsListOnWaMessageReceived(data);
        };


        vm.onWaNotify = function(data) {
            $log.info("onWaNotify main");
            $log.info(data);

            if(vm.user.type=='admin' || vm.user.ext_f_cs) {

                if (data.unreaded_total) {
                    vm.alerts.messagesUnreaded = data.unreaded_total;
                } else {
                    $log.error("onWaNotify main manca unreaded_total");
                }

            } else if(vm.user.type=='callcenter') {
                //se sono callcenter aggiorno se un mio cliente o di una mia delega
                if (data.customer && data.customer.user_id && (data.customer.user_id == vm.user.id
                    || data.customer.user_id && data.customer.user_id == vm.user.delegate1_user_id
                    || data.customer.user_id && data.customer.user_id == vm.user.delegate2_user_id))  {

                        if (data.unreaded_team) {
                            vm.alerts.messagesUnreaded = data.unreaded_team;
                        } else {
                            $log.error("onWaNotify main manca unreaded_team");
                        }

                }
            } else if (vm.user.store_id && vm.user.store_id == data.customer.last_store_id) {

                if (data.unreaded_store) {
                    vm.alerts.messagesUnreaded = data.unreaded_store;
                } else {
                    $log.error("onWaNotify main manca unreaded_store");
                }

            }
        };
        vm.appointmentsListOnWaMessageReceived = function(data) {
            if (data.customer && vm.appointmentsList && vm.appointmentsList.length>0) {
                angular.forEach(vm.appointmentsList, function(app) {
                    if (app.customer_id == data.customer.id) {
                        if (app.customer && (!app.customer.data.unreadedMessages
                            || !app.customer.data.unreadedMessages.data)) {
                                app.customer.data.unreadedMessages = {'data': []};
                        }
                        app.customer.data.unreadedMessages.data.push({
                            'customer_id': data.customer.id,
                            'message': data.message,
                            'f_sent': false
                        });
                        while (app.customer.data.unreadedMessages.data.length!=0 && app.customer.data.unreadedMessages.data.length>data.unreaded) {
                            app.customer.data.unreadedMessages.data.shift();
                        }
                    }
                });
            }
        }
        vm.wkListOnWkEventReceived = function(data) {
            //TODO va ricalcolata riga con emit
            if (vm.wkList && vm.wkList.length>0 && data.entity) {
                angular.forEach(vm.wkList, function(ent) {
                    if (ent.id == data.entity.id) {
                        ent.status = data.entity.status;
                    }
                });
            }
        }
        vm.tenantLoading = true;
        vm.reloadSelectedArea = function(goTo) {
            $log.info("main.tick next execution cancellation ...");
            var promise = vm.nextTickPromise;
            if (promise) {
                var res = $timeout.cancel(promise);
                $log.info("main.tick cancel result: " + res);
            } else {
                $log.info("main.tick cancel nothing to do.");
            }
            if (vm.channel) {
                vm.channel.unbind();
                vm.pusher.unsubscribe(vm.env.currentTenant+'-waMessage-channel');
                vm.channel = vm.pusher.subscribe(vm.selectedArea+'-waMessage-channel');
                vm.channel.bind('waMessage-event', function(data) {
                    vm.onWAMessageRecived(data);
                });
                vm.channel.bind('waNotify-event', function(data) {
                    vm.onWaNotify(data);
                });
            }
            vm.setCurrentAPI();
            //$state.reload();
            vm.storesList = [];
            vm.store_id = null;
            $scope.selectedStore = 0;
            localStorage.setItem('current_store_id', parseInt($scope.selectedStore));
            $log.info(vm.selectedArea, vm.env.API);
            vm.storesListLoad();
            vm.statistics = {};
            vm.statMom = null;
            vm.statStore = null;
            vm.statArea = null;
            vm.alerts = {};
            vm.nextTickPromise = $timeout( vm.tick, 5000 );
            $log.info($state.current.name);
            var redirectTo = goTo?goTo:$state.current.name;
            if ($state.current.name=='home.customer') {
                redirectTo = 'home.addressbook';
            }
            $state.go ('home.blank', { redirectTo: redirectTo});
        };
        vm.prevSelectedArea = vm.selectedArea;
        vm.selectedAreaChange = function(reload, goTo, goToPars) {
            vm.tenantLoading = true;
            //prima controllo se l'utente è corretto con l'area corretta
            var api = vm.selectedArea == 'Italia'?vm.apiItalia:vm.env.apis[vm.selectedArea];
            var newApiURI = api + '/auth/user?c_role='+vm.user.type;
            return $http.get( newApiURI ).then(
                function(response) {
                    if( response && response.data ) {
                        //$log.info("logon", response.data);
                        var la = vm.user.logon_at;
                        var userData = response.data.user;
                        userData.logon_at = la;
                        userData.selectedArea = vm.selectedArea;
                        localStorage.setItem( 'user', angular.toJson( userData, false ) );
                        UsersService.loadUserFromLocalStorage(vm, vm);
                        if (reload) {
                            vm.reloadSelectedArea(goTo, goToPars);
                        }
                        vm.prevSelectedArea = vm.selectedArea;
                    } else {
                        vm.tenantLoading = false;
                        vm.selectedArea = vm.prevSelectedArea;
                        alert("Utente non trovato su: "+vm.selectedArea);
                    }
            },
            function(response) {
                alert('Errore nel caricamento dati Area: '+vm.selectedArea);
                vm.selectedArea = vm.prevSelectedArea;
                vm.tenantLoading = false;
            });
        };
        vm.fLeadOnlineLoading = true;
        vm.getFLeadOnline = function() {
            if (true) return;
            $http.get(env.API+"/user/getfleadonline",
                    {params: { 'c_role': vm.user.type, 'c_sid':vm.user.store_id }})
            .then(function (response) {
                vm.user.f_lead_online = response.data.data.f_lead_online;
                vm.fLeadOnlineLoading = false;
            }, function (response) {
                $log.info(response);
                vm.fLeadOnlineLoading = false;
            });
        };
        vm.setFLeadOnline = function(val) {
            vm.fLeadOnlineLoading = true;
            $http.get(env.API+"/user/setfleadonline/"+val,
                    {params: { 'c_role': vm.user.type, 'c_sid':vm.user.store_id }})
            .then(function (response) {
                vm.user.f_lead_online = val;
                vm.fLeadOnlineLoading = false;
            }, function (response) {
                $log.info(response);
                vm.fLeadOnlineLoading = false;
            });
        };

        vm.loadFLeadOnline = function() {
            if (vm.user && vm.user.type == 'callcenter' && !vm.user.store_id) {
                vm.user.f_lead_online = 0;
                vm.getFLeadOnline();
            }
        };

        vm.loadFLeadOnline();

        /* Logout */
        vm.doLogout = function(reason) {
            UsersService.doLogout(reason, vm).then (
                    function () {
                        $state.go ('login');
                    },
                    function () {
                        $state.go ('login');
                    }
            );
        };
        vm.openAdministration = function(target) {
            var dest = vm.env.API.substring(0, vm.env.API.length-3) + "token_login?c_role="+vm.user.type+"&token="+vm.token;

            if (target) {
                window.open(dest, target);
            } else {
                window.location = dest;
            }
        };
        vm.openAnalytics = function(target) {
            var dest = vm.env.API.substring(0, vm.env.API.length-3) + "token_login?c_role="+vm.user.type+"&token="+vm.token+"&redirect=bi/kpi-ranking-month-dashboard";
            if (target) {
                window.open(dest, target);
            } else {
                window.location = dest;
            }
        };
        vm.reload = function() {
            location.reload();
        };
        vm.setRole = function() {
          angular.forEach(vm.user.roles, function(r) {
            if (r.id == vm.user.role_id) {
              vm.user.type = r.role;
              vm.user.store_id = r.store_id;
              vm.user.c_sid = r.store_id;
              vm.user.c_role = r.role;
              vm.user.store = r.store;
              vm.user.color = r.color;
              vm.user.perm = r.perm;
              vm.user.config = r.config;
              localStorage.setItem( 'user', angular.toJson( vm.user, false ) );
              vm.reload();
              return;
            }
          });
        };
        /* Companies */
        $window.document.title = vm.env.company + " - " + vm.env.tenant
            + (vm.env.currentTenant!=vm.env.tenant?' ['+vm.env.currentTenant+']':'');
        vm.selectedStoreDisabled = (vm.user.type == 'operator' || vm.user.type == 'storemngr' || vm.user.type == 'assist') && !vm.user.f_dm;
        vm.storesList = [];
        vm.store_id = vm.selectedStoreDisabled?vm.user.store_id:store_id;
        vm.storesListLoad = function() {
            //usa storeService definito con restangular in landing
            StoreService.all({search:'booking_online:1', searchFields:'booking_online:=', orderBy: 'order'}).then( function( response ) {
                angular.forEach( response, function( elem ) {
                    elem.label = elem.alias!=null ? elem.alias : (elem.city + " - " + elem.address);
                    if (elem.id == vm.user.store_id) {
                        vm.user.store = elem;
                        vm.user_store = elem.label;
                    }
                    vm.storesList.push( elem );
                });
                if (vm.storesList.length>0) {
                        var storeSelected = false;
                       if (vm.store_id!=null) {
                           var selStore = parseInt(vm.store_id);
                           $scope.selectedStore = selStore;
                           storeSelected = true;
                       }
                       if (!storeSelected) {
                           if (parseInt(localStorage.getItem('current_store_id')) > 0) {
                               $scope.selectedStore = parseInt(localStorage.getItem('current_store_id'));
                           } else if (vm.user.store_id!=null && vm.user.store_id>0){
                               $scope.selectedStore = parseInt(vm.storesList[0].id);
                           } else {
                               $scope.selectedStore = 0;
                           }
                       }
                } else {
                   $scope.selectedStore = 0;
                }
                vm.tenantLoading = false;
            });
        };
        vm.storesListLoad();

        vm.setStoreInLocalStorage = function() {
          localStorage.setItem('current_store_id', parseInt($scope.selectedStore));
          vm.loadStatistics();
        };
        //---------- Menu -------------------------------------//
        vm.toggleLeft = function() {
            return $mdSidenav('left').toggle();
        };
        vm.checkVisibility = function ( item ) {
            var roles = item.visibility;
            if (item.storeDependent && vm.storesList.length==0) {
                return false;
            }
            if (!item.allowMultistore && !parseInt($scope.selectedStore)) {
                return false;
            }
            if( $.inArray( vm.user_type, roles ) === -1 ) {
                return false;
            } else {
                return true;
            }
        };
        vm.menu = [];
         if (vm.env.home && vm.env.home[vm.user.type]) {
            vm.menu.push(
                {
                    link : 'home.'+vm.env.home[vm.user.type].path,
                    title: vm.env.home[vm.user.type].title,
                    icon: vm.env.home[vm.user.type].icon,
                    storeDependent: vm.env.home[vm.user.type].storeDependent,
                    visibility : [vm.user.type],
                    allowMultistore: vm.env.home[vm.user.type].allowMultistore
                });
         }
          vm.menu.push(
              {
                  link : 'home.dashboard',
                  title: 'Dashboard',
                  icon: 'dashboard',
                  storeDependent: true,
                  visibility : [ 'admin', 'operator', 'callcenter','manager','storemngr' ],
                  allowMultistore: true
              });
          vm.menu.push(
              {
                  link : 'home.kpi',
                  title: 'Kpi',
                  icon: 'dashboard',
                  storeDependent: false,
                  visibility : [ 'admin'],
                  allowMultistore: true
              });
          vm.menu.push(
              {
                  link : 'home.today',
                  title: 'Oggi',
                  icon: 'view_day',
                  storeDependent: true,
                  visibility : [ 'admin', 'operator', 'manager','storemngr','callcenter' ]
              });
          vm.menu.push(
              {
                  link : 'home.appointments',
                  title: 'Appuntamenti',
                  icon: 'book',
                  storeDependent: true,
                  visibility : [ 'admin', 'operator', 'callcenter', 'manager','storemngr' ],
                  allowMultistore: true
              });
          vm.menu.push(
              {
                  link : 'home.wire-transfer',
                  title: 'Bonifici',
                  icon: 'account_balance',
                  visibility : [ 'admin','storemngr' ],
                  allowMultistore: true
            });
         if (!vm.env.menu || vm.env.menu.whatsapp) {
            vm.menu.push(
              {
                  link : 'home.whatsapp',
                  title: 'Whatsapp',
                  icon: 'chat',
                  storeDependent: false,
                  visibility : [ 'admin', 'callcenter','storemngr'],
                  allowMultistore: true
              });
          }
          vm.menu.push(
                  {
                      link : 'home.cussubscr',
                      title: 'Abb. Clienti',
                      icon: 'autorenew',
                      storeDependent: true,
                      visibility : [ 'admin' , 'operator', 'callcenter', 'manager','storemngr' ],
                      allowMultistore: true
                  });
          vm.menu.push(
                  {
                      link : 'home.cuspaym',
                      title: 'Scadenziario',
                      icon: 'alarm',
                      storeDependent: true,
                      visibility : [ 'admin', 'operator', 'manager', 'storemngr' ]
                  });
          vm.menu.push(
              {
                  link : 'home.addressbook',
                  title: 'Rubrica',
                  icon: 'contacts',
                  visibility : [ 'admin', 'operator', 'callcenter', 'manager','storemngr' ],
                  allowMultistore: true
              });
        if (vm.env.referralEnabled) {
              vm.menu.push(
                {
                    link : 'home.referrals',
                    title: 'Referral',
                    icon: 'group_add',
                    visibility : [ 'admin', 'operator', 'callcenter', 'manager','storemngr' ],
                    allowMultistore: true
                });
        }
          vm.menu.push(
              {
                  link : 'home.customer-calls',
                  title: 'Calls',
                  icon: 'mic',
                  visibility : [ 'admin' ],
                  allowMultistore: true
              });
          vm.menu.push(
                  {
                      link : 'home.giftcards',
                      title: 'Gift Cards',
                      icon: 'card_giftcard',
                      visibility : [ 'admin', 'operator', 'callcenter', 'manager','storemngr' ],
                      allowMultistore: true
                  });
          vm.menu.push(
                  {
                      link : 'home.reviews',
                      title: 'Recensioni',
                      icon: 'view_list',
                      storeDependent: true,
                      visibility : [ 'admin', 'backoffice', 'manager', 'storemngr', 'operator'],
                      allowMultistore: true
                  });
          var voiceLeads =  {
            link : 'home.leads',
            title: 'Leads',
            icon: 'input',
            visibility : [ 'admin', 'manager' ],
            allowMultistore: true
          };
          if (!vm.env.menu || vm.env.menu.leads || vm.user.ext_f_bid || vm.user.ext_f_pf) {
              voiceLeads.visibility.push('callcenter');
          }
          vm.menu.push(voiceLeads);
          if (vm.env.isMaster) {
              vm.menu.push(
                {
                  link : 'home.lead',
                  title: 'Prossimo Lead',
                  icon: 'input',
                  visibility : [ 'admin','callcenter' ],
                  allowMultistore: true
                });
            }

          vm.menu.push(
              {
                link : 'home.leads',
                title: 'Leads',
                icon: 'input',
                visibility : [ 'operator','storemngr']
              });
          vm.menu.push(
              {
                link : 'home.leadcash',
                title: !vm.env.menu?'Cassa leads':vm.env.menu.leadcash_label,
                icon: !vm.env.menu?'attach_money':vm.env.menu.leadcash_icon,
                visibility : !vm.env.menu?[ 'admin', 'callcenter', 'manager' ]:vm.env.menu.leadcash_visibility,
                allowMultistore: true
              });
          /*vm.menu.push(
                  {
                    link : 'home.leadcash1',
                    title: !vm.env.menu?'Cassa leads I':vm.env.menu.leadcash1_label,
                    icon: !vm.env.menu?'attach_money':vm.env.menu.leadcash1_icon,
                    visibility : !vm.env.menu?[ 'admin' ]:vm.env.menu.leadcash1_visibility,
                    allowMultistore: true
                  });
          */
          vm.menu.push(
              {
                  link : 'home.customer',
                  title: 'Rullo',
                  icon: 'perm_phone_msg',
                  visibility : [ 'admin', 'callcenter', 'operator', 'manager', 'storemngr' ],
                  allowMultistore: true
              });
          vm.menu.push(
             {
                link : 'home.cusacts',
                title: 'Contatti rullo',
                icon: 'supervisor_account',
                visibility : [ 'admin', 'operator', 'callcenter', 'manager', 'storemngr' ],
                allowMultistore: true
              });
          vm.menu.push(
                  {
                      link : 'home.availabilities',
                      title: 'Disponibilità',
                      icon: 'event',
                      visibility : [ 'admin', 'operator', 'manager','storemngr', 'callcenter' ],
                      allowMultistore: true
                  });

              vm.menu.push(
                  {
                      link : 'home.cash',
                      title: vm.env.currency?vm.env.currency.label:'Cassa',
                      icon: vm.env.currency?vm.env.currency.icon:'attach_money',
                      visibility : [ 'admin', 'operator', 'manager','storemngr' ],
                      allowMultistore: true,
                      storeDependent: true
                  });

              vm.menu.push(
                  {
                      link : 'home.cashout',
                      title: 'Uscite di Cassa',
                      icon: 'money_off',
                      visibility : [ 'admin', 'operator', 'manager','storemngr' ],
                      allowMultistore: false,
                      storeDependent: true
                  });
              vm.menu.push(
              {
                  link : 'home.monthcash',
                  title: 'Corrispettivi',
                  icon: 'library_books',
                  allowMultistore: true,
                  visibility : [ 'admin', 'backoffice', 'storemngr']
              });
          vm.menu.push(
                  {
                    link : 'home.orders',
                    title: 'Ordini',
                    icon: 'shopping_basket',
                    storeDependent: true,
                    visibility : [ 'admin', 'manager', 'operator', 'backoffice','storemngr' ],
                    allowMultistore: true
                  });
          if (!vm.env.menu || vm.env.menu.storage_state)
              vm.menu.push(
                  {
                      link : 'home.storage_state',
                      title: 'Magazzino',
                      icon: 'subtitles',
                      visibility : [ 'admin', 'backoffice', 'manager', 'storemngr', 'operator']
                  });
          if (!vm.env.menu || vm.env.menu.storage)
              vm.menu.push(
                  {
                      link : 'home.storage',
                      title: 'Mov. Magazzino',
                      icon: 'subtitles',
                      visibility : [ 'admin', 'backoffice', 'manager', 'storemngr', 'operator']
                  });
          if (!vm.env.menu || vm.env.menu.inventories)
              vm.menu.push(
                {
                    link : 'home.inventories',
                    title: 'Inventario',
                    icon: 'list',
                    visibility : [ 'admin', 'manager', 'operator','storemngr' ],
                    allowMultistore: true
                });
          if (!vm.env.menu || vm.env.menu.landings)
          vm.menu.push(
              {
                  link : 'home.landings',
                  title: 'Pagine Prenotazione',
                  icon: 'shopping_cart',
                  visibility : [ 'admin' ]
              });
          vm.menu.push(
              {
                  link : 'home.operators',
                  title: 'Utenti',
                  icon: 'face',
                  visibility : [ 'admin', 'operator', 'manager', 'backoffice', 'callcenter','storemngr' ],
                  allowMultistore: true
              });
          vm.menu.push(
              {
                  link : 'home.groups',
                  title: 'Gruppi',
                  icon: 'group',
                  visibility : [ 'admin', 'callcenter' ],
                  allowMultistore: true
              });

          vm.menu.push(
                  {
                      link : 'home.expcash',
                      title: 'Ricavi',
                      icon: 'nfc',
                      storeDependent: true,
                      visibility : [ 'admin', 'backoffice', 'manager', 'storemngr'],
                      allowMultistore: true
                  });
            vm.menu.push(
            {
                link : 'home.costs',
                title: 'Costi',
                icon: 'money_off',
                visibility : [ 'admin', 'manager', 'backoffice','storemngr' ],
                allowMultistore: true
            });

          vm.menu.push(
            {
                link : 'home.balance',
                title: 'Saldo',
                icon: 'account_balance_wallet',
                visibility : [ 'admin', 'manager', 'backoffice','storemngr','operator'],
                allowMultistore: true
            });
          vm.menu.push(
                  {
                      link : 'home.treatments',
                      title: 'Trattamenti',
                      icon: 'view_list',
                      visibility : [ 'admin', 'backoffice', 'manager', 'storemngr', 'operator'],
                      allowMultistore: true
                  });
          vm.menu.push(
                  {
                      link : 'home.subscriptions',
                      title: 'Abbonamenti',
                      icon: 'view_list',
                      visibility : [ 'admin', 'backoffice', 'manager', 'storemngr', 'operator'],
                      allowMultistore: true
                  });
          vm.menu.push(
              {
                  link : 'home.products',
                  title: 'Prodotti',
                  icon: 'view_list',
                  visibility : [ 'admin', 'backoffice', 'manager', 'storemngr', 'operator'],
                  allowMultistore: true
              });

            vm.menu.push(
            {
                link : 'home.availability-analysis',
                title: 'Analisi Occupazione',
                icon: 'settings',
                visibility : [ 'admin', 'backoffice', 'manager', 'storemngr', 'operator'],
                allowMultistore: false
            });


          /*,

              {
                  link : 'home.reports',
                  title: 'Reports',
                  icon: 'business',
                  visibility : [ 'admin', 'operator' ]
              }*/
        vm.openMoodle = function () {
            $http.get(env.API+"/moodleSSO")
                .then(function (response) {
                        $log.info(response);
                        window.open(response.data.data.loginurl);
                      },
                      function (response) {
                          $log.error(response);
                      }
                );
        }
        /**
         * ogni ora carico le statistiche proiezione per visualizzare quanto manca all'obiettivo di giornata
         */
        vm.statistics = {};
        vm.statMom = null;
        vm.statStore = null;
        vm.statArea = null;
        vm.statMinutes = 45;
        vm.loadStatistics = function () {
          if (vm.statMom!=null && $scope.selectedStore==vm.statStore && vm.selectedArea==vm.statArea && moment().diff(vm.statMom, 'minutes')<vm.statMinutes) {
            //$log.info("non faccio aggiormanento diff min:" + moment().diff(vm.statMom, 'minutes') + " <" + vm.statMinutes);
              if (vm.user.type=='callcenter') {
                  vm.alertsDachiamareRefresh(true, true);
              } else {
                  vm.alertsDachiamareRefresh(false, true);
              }
          } else {
            if (vm.statMom!=null) {
              //$log.info("faccio aggiormanento stats diff min:" + moment().diff(vm.statMom, 'minutes'));
            } else {
              //$log.info("faccio prima invocazione stats");
            }
            vm.statMom = moment();
            vm.statStore = $scope.selectedStore;
            vm.statArea = vm.selectedArea;
            vm.statistics = {};
            $http.get(env.API+"/proiezionemese/"
                +$scope.selectedStore+"/"+vm.statMom.format('YYYY')
                +"/"+vm.statMom.format('MM')
                +"/"+vm.statMom.format('DD'),
                {params: { 'uid': vm.user.id, 'rnd': vm.random, 'c_role': vm.user.type, 'c_sid':vm.user.store_id }})
                .then(function (response) {
                        vm.statistics = response.data.data;
                        vm.alertsDachiamareRefresh(true, true);
                      },
                      function (response) {
                          $log.error(response.data);
                          if (response.data && response.data.status_code >= 400 && response.data.message!="DataAccessException") {
                              vm.doLogout("MainControllerLogoutOnPollingProiezionemese");
                          } else {
                              vm.alertsDachiamareRefresh(true, true);
                          }
                      }
                );
          }
        };
        vm.alerts = {};
        vm.alertsDachiamareRefresh = function (withdata, schedulenext) {
            var uri = "";
            if (withdata) {
                uri = env.API+"/alerts/"
                    +$scope.selectedStore+"/"+vm.statMom.format('YYYY')
                    +"/"+vm.statMom.format('MM')
                    +"/"+vm.statMom.format('DD');
            } else {
                uri = env.API+"/alerts/0/0/0/0";//serve per verificare se l'utente risulta abilitato
            }
            $http.get(uri, {params: { 'uid': vm.user.id, 'rnd': vm.random, 'c_role': vm.user.type, 'c_sid':vm.user.store_id }})
            .then(function (response) {
                    if (withdata) {
                        vm.alerts = response.data.data;
                    }
                    if (schedulenext) {
                        $log.info("vm.tick scheduled at "
                            + moment().add(vm.getTickInterval()/1000, 'seconds')
                                .format('HH:mm:ss')
                        );
                        vm.nextTickPromise = $timeout( vm.tick, vm.getTickInterval() );
                    }
                },
                function (response) {
                    $log.error(response.data);
                    $log.info("Utente non attivo: [id="+vm.user.id);
                    if (response.data && response.data.status_code >= 400
                            && response.data.message
                            &&
                            (            response.data.message.startsWith("Utente non attivo: [id="+vm.user.id)
                                    ||     response.data.message.startsWith("The token has been blacklisted")
                            )
                    ) {
                        $log.info(response.data.message);
                        vm.doLogout("MainControllerLogoutOnPollingAlerts");
                    } else {//non faccio logout ma stoppo il polling
                        /*$log.info("vm.tick scheduled at "
                                + moment().add(vm.getTickInterval()/1000, 'seconds')
                                    .format('HH:mm:ss')
                        );
                        vm.nextTickPromise = $timeout( vm.tick, vm.getTickInterval() );
                        */
                    }
                }
          );
        }

        //---------- Clock -------------------------------------//

        vm.clock = "";
        vm.tickInterval = null;
        vm.getTickInterval = function() {
            if (!vm.tickInterval) {
                var seconds = vm.config.get('polling.interval.seconds', 600);
                vm.tickInterval = seconds*1000; //millisecondi
                $log.info("polling.interval.seconds is "+ seconds + " seconds, tickInterval is "+vm.tickInterval + " millis");
            }
            return vm.tickInterval;
        };
        /**
         * Appoitment list visualizzati in content caricato da appointments.controller.js
         */
        vm.appointmentsList = [];
        /**
         * Work list caricata da wklist.controller.js
         */
        vm.wkList = [];
        vm.tick = function() {
            vm.nextTickPromise = null;
            $log.info("vm.tick entered ... " + moment().format('HH:mm:ss'));
            if (!vm.user) {
                $log.info("logged user not found!");
                return;
            }
            vm.clock = Date.now();
            vm.loadStatistics();
        };
        vm.nextTickPromise = $timeout( vm.tick, 10000 );

        /* Show Reminder */
        vm.showPopupAppointments = function( data ) {
            var useFullScreen = $mdMedia('xs');
            var confirm = $mdDialog.confirm({
                title: 'Attenzione',
                ariaLabel: 'Attenzione',
                templateUrl: 'app/appointments/dialogs/appointments-dialog-nextday.html',
                fullscreen: useFullScreen,
                escapeToClose: false,
                controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                    $scope.title = "Appuntamenti di Domani";
                    $scope.button_ok = "Guarda Adesso";
                    $scope.button_cancel = "Ignora per un'ora";
                    $scope.uncovered = false;

                    $scope.appointmentsList = [];
                    if( data.length ) {
                        angular.forEach( data, function( elem ) {
                            delete elem.updated_at;
                            delete elem.created_at;

                            elem.date_start = $filter('date')( new Date( elem.date_start ), 'yyyy-MM-ddTHH:mm' );
                            elem.date_end = $filter('date')( new Date( elem.date_end ), 'yyyy-MM-ddTHH:mm' );

                            $scope.appointmentsList.push( elem );
                        });
                    };

                    $scope.close = function() {
                        $mdDialog.cancel( false );
                    };
                    $scope.open = function() {
                        $mdDialog.hide( true );
                    };
                }],
            });
            return $mdDialog
                .show( confirm )
                .then(
                    function( response ) {
                        if( response ) {
                            $state.go('home.appointments');
                        };
                    }
                )
                .finally(
                    function() {
                        confirm = undefined;
                        useFullScreen = undefined;
                    }
                )
            ;
        };
        vm.showReminder = function() {
            if( $state.current.name !== 'home.appointments' ) {
                NextDayAppointments.remainder( $scope.selectedStore, vm.userId ).then( function( response ) {
                    if ( response.data && response.data.data ) {
                        if ( response.data.data.length ) {
                            vm.showPopupAppointments( response.data.data );
                        };
                    };
                });
            };
        };
        /**
         * broadcast in tempo reale
         */
        /* Show Broadcast Message */
        vm.showBroadcastMessage = function( data ) {
            var useFullScreen = $mdMedia('xs');
            var confirm = $mdDialog.confirm({
                title: 'Attenzione messaggio importante',
                ariaLabel: 'Attenzione messaggio importante',
                templateUrl: 'app/main/dialogs/broadcast-message.html',
                fullscreen: useFullScreen,
                escapeToClose: false,
                controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                    $scope.title = "Attenzione! Messaggio Importante";
                    $scope.button_ok = "Ok";
                    $scope.data = data;
                    $log.info(data);
                    $scope.close = function() {
                        $mdDialog.cancel( false );
                    };
                }],
            });
            return $mdDialog
                .show( confirm )
                .finally(
                    function() {
                        confirm = undefined;
                        useFullScreen = undefined;
                    }
                )
            ;
        };
        /* Timer to check if everything as loaded correctly. */
        /*vm.Timer = undefined;
        vm.StartTimer = function () {
            vm.Timer = $interval( function () {
                if( angular.isDefined( $scope.selectedStore ) && angular.isDefined( vm.userId ) ) {
                    if( vm.user_type !== 'admin' ) {
                        vm.StopTimer();
                    };
                };
            }, 500 );
        };
        vm.StopTimer = function () {
            if ( angular.isDefined( vm.Timer ) ) {
                $interval.cancel( vm.Timer );
                $interval( function(){
                    vm.showReminder();
                }, 3600000 );
                vm.showReminder();
            };
        };
        vm.StartTimer();
    */
        /* Controllo che il Polling abbia dati */
    vm.showPopupCallState = function( data ) {
            var confirm = $mdDialog
                .confirm(
                    {
                        title: 'Attenzione',
                        ariaLabel: 'Attenzione',
                        templateUrl: 'app/addressbook/dialogs/addressbook-dialog-call_state.html',
                        clickOutsideToClose: false,
                        escapeToClose: false,
                        controllerAs: 'vm',
                        controller: [
                            '$mdDialog',
                            function(
                                $mdDialog
                            ) {
                                var vm = angular
                                    .extend(
                                        this,
                                        {
                                            title: "Richiami da fare",
                                            button_ok: "OK",
                                            button_cancel: null,
                                            // Customers
                                            customersList: [],
                                            customerStatus: {
                                                call_state: CallState,
                                                someoneNeedDatePicker: function( customers ) {

                                                    return (
                                                        customers
                                                            .filter(
                                                                function( customer ) {
                                                                    return (
                                                                        customer.call_date === null &&
                                                                        vm.customerStatus.needDatePicker( customer.$selectedIndex )
                                                                    );
                                                                }
                                                            )
                                                        .length > 0
                                                    );

                                                    return false;

                                                },
                                                needDatePicker: function( index ) {
                                                    return (
                                                        index === 0 || index === 1 || index === 4
                                                    );
                                                },
                                                onChange: function( customer ) {

                                                    customer.$readonly = false;

                                                    if( angular.isDefined( customer.$selectedIndex ) ) {
                                                        customer.call_state = this.call_state[ customer.$selectedIndex ]
                                                        customer.call_date = null;
                                                    };

                                                    CustomerService
                                                        .update( customer )
                                                        .catch(
                                                            function() {
                                                                alert( "Errore, provare a ricaricare la pagina!" );
                                                            }
                                                        )
                                                    ;
                                                },
                                            },
                                            // Methods
                                            close: close,
                                            open: open,
                                        }
                                    )
                                ;

                                if( data.length )
                                    angular
                                        .forEach(
                                            data,
                                            function( elem ) {
                                                delete elem.updated_at;
                                                delete elem.created_at;

                                                var call_date = elem.call_date ? moment( elem.call_date ) : null;
                                                elem.call_date = call_date ? new Date( call_date ) : null;

                                                vm.customersList.push( elem );
                                            }
                                        )
                                    ;

                                // Methods
                                function close() {
                                    $mdDialog.cancel();
                                };
                                function open() {
                                    $mdDialog.hide();
                                };
                            }
                        ],
                    }
                )
            ;
            return $mdDialog
                .show( confirm )
                .finally(
                    function() {
                        confirm = undefined;
                    }
                )
            ;
        };

        vm.config = {};
        vm.config.get = function(key, defaultValue) {
            var result = null;
            var resultOnRole = null;
            angular.forEach(vm.user.config, function(el) {

                if (el.key==key && (el.role==null || el.role==vm.user.type)) {

                    var tmpResult = null;
                    try {
                        switch (el.type) {
                            case "int":
                                tmpResult = parseInt(el.value);
                                break;
                            case "boolean":
                                switch(el.value.toLowerCase().trim()) {
                                    case "true": ;
                                    case "yes": ;
                                    case "1": {
                                        tmpResult = true;
                                        break;
                                    }
                                    case "false": ;
                                    case "no": ;
                                    case "0": {
                                        tmpResult = false;
                                        break;
                                    }
                                    default:
                                        tmpResult = false;
                                }
                                break;
                            case "object":
                                tmpResult = angular.fromJson(el.value);
                                break;
                            case "string":
                                tmpResult = el.value;
                                break;
                            default:
                                break;
                        }
                        if (el.role==null) {
                            result = tmpResult;
                        } else {
                            resultOnRole = tmpResult;
                        }
                    } catch (error) {
                        $log.error("Errore carivamento config: ");
                        $log.info(el);
                        $log.error(error);
                    }
                }

            });
            var res = null;
            if (resultOnRole != null) {
                res = resultOnRole;
            } else if (result == null) {
                res = defaultValue;
            } else {
                res = result;
            }
            $log.info("config.get "+key+ " is " +res);
            return res;
        };
        vm.perm = {};
        vm.perm.find = function(type, name, ent) {
                var res = {name: name, e: e, type: type, r: false, c: false, u: false, d: false};
                var glob = null;
                var xRuolo = null;
                var xStato = null;
                var xStatoXRuolo = null;
                var e = ent!=null?ent:{};
                var user = vm.user;
                for(var i=0; i<vm.user.perm.length; i++) {
                    if (vm.user.perm[i].type == type && vm.user.perm[i].name==name) {
                        if (vm.user.perm[i].cond==null) {
                            if (vm.user.perm[i].role==vm.user.type) {
                                xRuolo = vm.user.perm[i];
                            } else if ("*"==vm.user.perm[i].role) {
                                glob = vm.user.perm[i];
                            }
                        } else {
                            var cond = eval(vm.user.perm[i].cond);
                            //$log.info ("find: ",e, vm.user.perm[i].cond, cond);
                            if (cond && vm.user.perm[i].role==vm.user.type) {
                                xStatoXRuolo = vm.user.perm[i];
                            } else if (cond && "*"==vm.user.perm[i].role) {
                                xStato = vm.user.perm[i];
                            }
                        }
                        if (i==vm.user.perm.length-1 || vm.user.perm[i+1].name!=name) {//si presume siano in ordine di name
                            break;
                        }
                    }
                }
                if (xStatoXRuolo!=null) {
                    res = xStatoXRuolo;
                } else if (xStato!=null) {
                    res = xStato;
                } else if (xRuolo!=null) {
                    res = xRuolo;
                } else if (glob!=null) {
                    res = glob;
                }
                //$log.info ("find: ", type, name, ent, res);
                return res;
        };
        vm.perm.canRead = function (name, e) {
                var rule = this.find('e', name, e);
                var res = rule.r && (vm.user.store_id==null || vm.user.store_id==0 ||
                                        e == null || e.store_id == null || e.store_id==vm.user.store_id
                                    );
                //$log.info('canRead', name, e, res);
                return res;
            };
        vm.perm.canCreate = function (name, e) {
            var rule = this.find('e', name, e);
            var res = rule.c && (    vm.user.store_id==null || vm.user.store_id==0 ||
                                    e==null || e.store_id==null ||
                                    e.store_id==vm.user.store_id
                                );
            //$log.info('canCreate', name, e, res);
            return res;
            };
        vm.perm.canUpdate = function (name, e) {
            var rule = this.find('e', name, e);
            var res = rule.u && (    vm.user.store_id==null || vm.user.store_id==0 ||
                                    e.store_id==vm.user.store_id
                                );
            //$log.info('canUpdate', name, e, res);
            return res;
        };
        vm.perm.canSave = function (name, e) {
            if (e.id!=null) return this.canUpdate(name, e);
            else return this.canCreate(name, e);
        };

        vm.perm.canDelete = function (name, e) {
                var rule = this.find('e', name, e);
                var res = rule.d && (    vm.user.store_id==null || vm.user.store_id==0 ||
                                        e.store_id==vm.user.store_id
                                    );
                //$log.info('canDelete', name, e, res);
                return res;
            };
        vm.perm.canFire = function (name, e) {
            var rule = this.find('a', name, e);
            var res = rule.r && (    vm.user.store_id==null || vm.user.store_id==0 ||
                                        e==null || e.store_id == null || e.store_id==vm.user.store_id
                                    );
            //$log.info('canFire', name, e, res);
            return res;
        };


        /*if (false && vm.isCallCenter) {
            // Polling
            var urls = [
                    '/customers?searchFields=call_state&search=NR',
                    '/customers?searchFields=call_state&search=da chiamare',
                    '/customers?searchFields=call_state&search=occupato',
                ]
                , timing = 60 * 10000
            ;
            vm.PollData = [];
            PollService
                .poller(
                    function( responses ) {
                        var show = angular.element( document.body ).hasClass( 'md-dialog-is-showing' );

                        if( ! show && vm.isCallCenter ) {

                            var temp = [];

                            if( responses.length )
                                angular.forEach(
                                    responses,
                                    function( response ) {
                                        if( response.data && response.data.data.length )
                                            temp.push( response.data.data );
                                    }
                                );

                            vm.PollData = [].concat.apply( [], temp );

                            if( vm.PollData.length )
                                return vm.showPopupCallState( vm.PollData );

                        };
                    },
                    function() {
                        vm.PollData = [];
                    },
                    urls,
                    timing
                )
            ;
        }*/
          vm.version = version;

        vm.about = function( ) {
            var dialog = $mdDialog.confirm({
                title: 'Release notes '+vm.env.company+' Software ver. '+ vm.version,
                ariaLabel: 'Release notes',
                templateUrl: 'app/main/dialogs/release_notes.html',
                escapeToClose: true,
                controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                    $scope.title = this.title;
                    $scope.button_ok = 'Chiudi';
                    $scope.version = vm.version;
                    $scope.user = vm.user;
                    $scope.xstore = vm.user.store_id!=null && vm.user.store_id>0;
                    $scope.close = function() {
                        $mdDialog.hide( true );
                    };
                }]
          });
          return $mdDialog
          .show( dialog )
          .finally(
              function() {
                  dialog = undefined;
              }
          );
      };

    };

    MainController
        .$inject = [
            '$scope',
            '$window',
            '$log',
            '$http',
            'env',
            'store_id',
            'version',
            '$auth',
            '$state',
            '$timeout',
            '$interval',
            '$mdSidenav',
            'Restangular',
            'StoreService',
            '$mdMedia',
            'NextDayAppointments',
            '$mdDialog',
            '$mdToast',
            'CustomerService',
            'PollService',
            'CallState',
            'logout',
            'UsersService'
            ,'$pusher'
        ]
    ;
})();

(function (angular) {
    'use strict';
    angular
        .module('angularjs-gauge', [])
        .directive('ngGauge', gaugeMeterDirective)
        .provider('ngGauge', gaugeMeterProviderFn);

    gaugeMeterProviderFn.$inject = [];
    function gaugeMeterProviderFn() {
        var defaultOptions = {
            size: 200,
            value: undefined,
            min: 0,
            max: 100,
            cap: 'butt',
            thick: 6,
            type: 'full',
            foregroundColor: 'rgba(0, 150, 136, 1)',
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            duration: 1500,
            fractionSize: null,
            labelOnly: false,
        };

        this.setOptions = function (customOptions) {
            if (!(customOptions && angular.isObject(customOptions)))
                throw new Error('Invalid option type specified in the ngGaugeProvider');
            defaultOptions = angular.merge(defaultOptions, customOptions);
        };

        var ngGauge = {
            getOptions: function () {
                return angular.extend({}, defaultOptions);
            }
        };

        this.$get = function () {
            return ngGauge;
        };
    }

    gaugeMeterDirective.$inject = ['ngGauge'];

    function gaugeMeterDirective(ngGauge) {


        var tpl = '<div style="display:inline-block;text-align:center;position:relative;">' +
            '<span ng-show="{{!labelOnly}}"><u>{{prepend}}</u>' +
            '<span ng-if="fractionSize === null">{{value | number}}</span>' +
            '<span ng-if="fractionSize !== null">{{value | number: fractionSize}}</span>' +
            '<u>{{append}}</u></span>' +
            '<b>{{ label }}</b>' +
            '<canvas></canvas></div>';

        var Gauge = function (element, options) {
            this.element = element.find('canvas')[0];
            this.text = element.find('span');
            this.legend = element.find('b');
            this.unit = element.find('u');
            this.context = this.element.getContext('2d');
            this.options = options;
            this.init();
        };

        Gauge.prototype = {

            init: function () {
                this.setupStyles();
                this.create(null, null);
            },

            setupStyles: function () {

                this.context.canvas.width = this.options.size;
                this.context.canvas.height = this.options.size;
                this.context.lineCap = this.options.cap;
                this.context.lineWidth = this.options.thick;

                var lfs = this.options.size * 0.22,
                    llh = this.options.size;

                this.text.css({
                    display: 'inline-block',
                    fontWeight: 'normal',
                    width: '100%',
                    position: 'absolute',
                    textAlign: 'center',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: lfs + 'px',
                    lineHeight: llh + 'px'
                });

                this.unit.css({
                    textDecoration: 'none',
                    fontSize: '0.6em',
                    fontWeight: 200,
                    opacity: 0.8
                });

                var fs = this.options.labelOnly ? lfs * 0.8 : this.options.size / 13;
                var lh = this.options.labelOnly ? llh : (5 * fs) + parseInt(this.options.size);

                this.legend.css({
                    display: 'inline-block',
                    width: '100%',
                    position: 'absolute',
                    textAlign: 'center',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontWeight: 'normal',
                    fontSize: fs + 'px',
                    lineHeight: lh + 'px'
                });
            },
            create: function (nv, ov) {

                var self = this,
                    type = this.getType(),
                    bounds = this.getBounds(type),
                    duration = this.getDuration(),
                    min = this.getMin(),
                    max = this.getMax(),
                    value = this.clamp(this.getValue(), min, max),
                    start = bounds.head,
                    unit = (bounds.tail - bounds.head) / (max - min),
                    displacement = unit * (value - min),
                    tail = bounds.tail,
                    color = this.getForegroundColorByRange(value),
                    requestID,
                    startTime;

                if (nv && ov) {
                    displacement = unit * nv - unit * ov;
                }

                function animate(timestamp) {
                    timestamp = timestamp || new Date().getTime();
                    var runtime = timestamp - startTime;
                    var progress = Math.min(runtime / duration, 1); // never exceed 100%
                    var previousProgress = ov ? (ov * unit) : 0;
                    var middle = start + previousProgress + displacement * progress;

                    self.drawShell(start, middle, tail, color);
                    if (runtime < duration) {
                        requestID = window.requestAnimationFrame(function (timestamp) {
                            animate(timestamp);
                        });
                    } else {
                        cancelAnimationFrame(requestID);
                    }
                }

                requestAnimationFrame(function (timestamp) {
                    startTime = timestamp || new Date().getTime();
                    animate(timestamp);
                });

            },

            getBounds: function (type) {
                var head, tail;
                if (type == 'semi') {
                    head = Math.PI;
                    tail = 2 * Math.PI;
                } else if (type == 'full') {
                    head = 1.5 * Math.PI;
                    tail = 3.5 * Math.PI;
                } else if (type === 'arch') {
                    head = 0.8 * Math.PI;
                    tail = 2.2 * Math.PI;
                }

                return {
                    head: head,
                    tail: tail
                };

            },

            drawShell: function (start, middle, tail, color) {
                var
                    context = this.context,
                    center = this.getCenter(),
                    radius = this.getRadius(),
                    foregroundColor = color,
                    backgroundColor = this.getBackgroundColor();

                this.clear();

                middle = Math.max(middle, start); // never below 0%
                middle = Math.min(middle, tail); // never exceed 100%


                context.beginPath();
                context.strokeStyle = backgroundColor;
                context.arc(center.x, center.y, radius, middle, tail, false);
                context.stroke();

                context.beginPath();
                context.strokeStyle = foregroundColor;
                context.arc(center.x, center.y, radius, start, middle, false);
                context.stroke();

            },

            clear: function () {
                this.context.clearRect(0, 0, this.getWidth(), this.getHeight());
            },

            update: function (nv, ov) {
                this.create(nv, ov);
            },

            destroy: function () {
                this.clear();
            },

            getRadius: function () {
                var center = this.getCenter();
                return center.x - this.getThickness();
            },

            getCenter: function () {
                var x = this.getWidth() / 2,
                    y = this.getHeight() / 2;
                return {
                    x: x,
                    y: y
                };
            },

            getValue: function () {
                return this.options.value;
            },
            getMin: function () {
                return this.options.min;
            },
            getMax: function () {
                return this.options.max;
            },
            getWidth: function () {
                return this.context.canvas.width;
            },

            getHeight: function () {
                return this.context.canvas.height;
            },

            getThickness: function () {
                return this.options.thick;
            },

            getBackgroundColor: function () {
                return this.options.backgroundColor;
            },

            getForegroundColor: function () {
                return this.options.foregroundColor;
            },

            getForegroundColorByRange: function (value) {

                var isNumber = function (value) {
                    return value != undefined && !isNaN(parseFloat(value)) && !isNaN(Number(value));
                };

                var match = Object.keys(this.options.thresholds)
                    .filter(function (item) { return isNumber(item) && Number(item) <= value; })
                    .sort(function(a,b) {return Number(a) > Number(b);}).reverse()[0];

                return match !== undefined ? this.options.thresholds[match].color || this.getForegroundColor() : this.getForegroundColor();
            },

            getLineCap: function () {
                return this.options.cap;
            },

            getType: function () {
                return this.options.type;
            },

            getDuration: function () {
                return this.options.duration;
            },

            clamp: function (value, min, max) {
                return Math.max(min, Math.min(max, value));
            }

        };


        return {
            restrict: 'E',
            replace: true,
            template: tpl,
            scope: {
                append: '@?',
                backgroundColor: '@?',
                cap: '@?',
                foregroundColor: '@?',
                label: '@?',
                labelOnly: '@?',
                prepend: '@?',
                size: '@?',
                thick: '@?',
                type: '@?',
                duration: '@?',
                value: '=?',
                min: '=?',
                max: '=?',
                thresholds: '=?',
                fractionSize: '=?'

            },
            link: function (scope, element) {
                var defaults = ngGauge.getOptions(); // fetching default settings from provider
                scope.min = angular.isDefined(scope.min) ? scope.min : defaults.min;
                scope.max = angular.isDefined(scope.max) ? scope.max : defaults.max;
                scope.value = angular.isDefined(scope.value) ? scope.value : defaults.value;
                scope.size = angular.isDefined(scope.size) ? scope.size : defaults.size;
                scope.cap = angular.isDefined(scope.cap) ? scope.cap : defaults.cap;
                scope.thick = angular.isDefined(scope.thick) ? scope.thick : defaults.thick;
                scope.type = angular.isDefined(scope.type) ? scope.type : defaults.type;
                scope.duration = angular.isDefined(scope.duration) ? scope.duration : defaults.duration;
                scope.labelOnly = angular.isDefined(scope.labelOnly) ? scope.labelOnly : defaults.labelOnly;
                scope.foregroundColor = angular.isDefined(scope.foregroundColor) ? scope.foregroundColor : defaults.foregroundColor;
                scope.backgroundColor = angular.isDefined(scope.backgroundColor) ? scope.backgroundColor : defaults.backgroundColor;
                scope.thresholds = angular.isDefined(scope.thresholds) ? scope.thresholds : {};
                scope.fractionSize = angular.isDefined(scope.fractionSize) ? scope.fractionSize : defaults.fractionSize;

                var gauge = new Gauge(element, scope);

                scope.$watch('value', watchData, false);
                scope.$watch('min', watchData, false);
                scope.$watch('max', watchData, false);
                scope.$watch('cap', watchOther, false);
                scope.$watch('thick', watchOther, false);
                scope.$watch('type', watchOther, false);
                scope.$watch('size', watchOther, false);
                scope.$watch('duration', watchOther, false);
                scope.$watch('foregroundColor', watchOther, false);
                scope.$watch('backgroundColor', watchOther, false);
                scope.$watch('thresholds', watchOther, false);
                scope.$watch('fractionSize', watchData, false);

                scope.$on('$destroy', function () { });
                scope.$on('$resize', function () { });

                function watchData(nv, ov) {
                    if (!gauge) return;
                    if (!angular.isDefined(nv) || angular.equals(nv, ov)) return;
                    gauge.update(nv, ov);
                }

                function watchOther(nv, ov) {
                    if (!angular.isDefined(nv) || angular.equals(nv, ov)) return;
                    gauge.destroy();
                    gauge.init();
                }
            }
        };

    }
}(angular));

(function () {
    'use strict';

    angular
        .module('admin')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(
        $log,
        $auth,
        $window,
        $location,
        $http,
        $document,
        $state,
        $scope,
        redirect,
        env,
        ROLES,
        version,
        UsersService
    ) {
        $log.info( 'LoginController -> redirect=' + redirect);
        var vm = this;
        vm.env = env;
        if (redirect) {
            vm.redirect = redirect;
        }
        vm.containsMaiuscolo = function(stringa) {
            // Utilizza un'espressione regolare per verificare se la stringa contiene almeno un carattere maiuscolo
            if (!stringa) return false;
            var regex = /[A-Z]/;
            return regex.test(stringa);
        }
        vm.containsMinuscolo = function(stringa) {
            // Utilizza un'espressione regolare per verificare se la stringa contiene almeno un carattere maiuscolo
            if (!stringa) return false;
            var regex = /[a-z]/;
            return regex.test(stringa);
        };
        vm.containsNumero = function(stringa) {
            // Utilizza un'espressione regolare per verificare se la stringa contiene almeno un carattere maiuscolo
            if (!stringa) return false;
            var regex = /[0-9]/;
            return regex.test(stringa);
        };
        vm.containsSpeciale = function(stringa) {
            // Utilizza un'espressione regolare per verificare se la stringa contiene almeno un carattere maiuscolo
            if (!stringa) return false;
            var regex = /[!@#$%^&*_;:]/;
            return regex.test(stringa);
        };
        vm.email = '';
        vm.password = '';
        vm.isShowPsw=false;
        vm.isExpiredPsw=false;
        vm.setIsShowPsw = function(val) {
            vm.isShowPsw = val;
        };
        vm.loading = false;
        vm.doRigeneraPassword = function () {
            var apiURI = env.API + '/users/regenpsw';
            vm.loading = true;
            $http.post( apiURI, {'phone': vm.phone,
                                'captcha': vm.captcha,
                                'searchFields': "active:=;phone:=;email:=",
                                'search': "active:1;phone:"+vm.phone+";email:"+vm.reg_email
                                } ).then(
                    function (response) {
                        var msg = "";
                        if (response.data.sms.status=='success') {
                            msg += "Ti abbiamo inviato un sms con le nuove credenziali di accesso.";
                        } else {
                            msg += "Si è verificato un errore nell'invio sms: "+response.data.sms.message;
                        }
                        if (response.data.mail.status=='success') {
                            msg += "\nTi abbiamo inviato una mail con le nuove credenziali di accesso.";
                        } else {
                            msg += "\nSi è verificato un errore nell'invio email: "+response.data.mail.message;
                        }
                        alert (msg);
                        vm.loading = false;
                        vm.setIsShowPsw(false);
                    },
                    function (error) {
                        if (error.data!=null) {
                            alert ("Si è verificato un errore: "+error.data.message);
                        } else {
                            alert ("Si è verificato un errore.");
                        }
                        vm.loading = false;
                    }

            );
        }
        /* Check Authentication */
        vm.doLoginAuto = function() {
            vm.email = 'info@studiomado.it';
            vm.password = 'maxdona07';
            vm.doLogin();
        };
        vm.doLogin = function() {
            var data = {
                email : vm.email,
                password : vm.password,
                version: version,
                /*device_id: 'unknown',
                'app_secret': '169540'*/
            };
            if (vm.isExpiredPsw) {
                data.newpassword = vm.newpassword;
                data.cfnewpassword = vm.cfnewpassword;
            }
            vm.loading = true;
            $auth.login( data ).then(
                function(response) {
                    /**
                     * Se la password è scaduta, viene richiesto il cambio password
                     */
                    if (response.data.expired) {
                        vm.isExpiredPsw = true;
                        vm.loading = false;
                        return;
                    } else {
                        vm.isExpiredPsw = false;
                    }
                    vm.token = response.data.token;
                    var apiURI = env.API + '/auth/user';
                    return $http.get( apiURI );
                },
                function( error ) {
                    //$log.info( error );
                    var msg = "";
                    var wrongVersion = false;
                    if (error!=null && error.data!=null && error.data.error!=null) {
                      msg = "\n"+error.data.error;
                      wrongVersion = error.data.wrongVersion;
                    }
                    alert( "Autenticazione fallita." + msg);
                    vm.loading = false;
                    if (wrongVersion) {
                      $window.location.reload();
                    }
                    return;
                }
            )
            .then( function( response ) {
                vm.loading = false;
                if( response && response.data ) {
                    //$log.info("logon", response.data);
                    var userData = response.data.user;
                    userData.logon_at = moment();
                    userData.selectedArea = vm.env.currentTenant?vm.env.currentTenant:vm.env.tenant;
                    localStorage.setItem( 'user', angular.toJson( userData, false ) );
                    if (vm.redirect) {
                        window.location = "https://wiki."+vm.env.domain+"?destination="+vm.redirect+"&c_sid="+userData.store_id+"&c_role="+userData.type+"&store=0&token="+vm.token;
                    } else {
                        var dest = localStorage.getItem( 'destination');
                        if (dest) {
                            localStorage.removeItem('destination');
                            return $state.go('home.'+dest, $location.search());
                        } else {
                            if (env.home && env.home[userData.type]) {
                                return $state.go( 'home.'+env.home[userData.type].path);
                            } else {
                                return $state.go( 'home.'+ROLES.get(userData.type).home);
                            }
                        }
                    }
                }
            }).catch(
                function (responseError) {
                    vm.loading = false;
                    console.log(responseError);
                }
            );
        };
        vm.doLogout = function (reason) {
            UsersService.doLogout(reason, $scope.$parent.main).then ( function () { $state.go( 'login' ); });
        };
        var email = $location.search().email
            , password = $location.search().password
        ;
        if( email && password ) {
            $log.info( "Login data received" );
            vm.email = email;
            vm.password = password;
            vm.doLogin();
        };

        vm.keyUpLogin = function( e ) {
            if ( e.keyCode == 13 ) {
                vm.doLogin();
                e.preventDefault();
                e.stopPropagation();
            };
        };
    };

})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .service(
            'LeadService',
            [
                '$log',
                'env',
                '$http',
                function(
                    $log,
                    env,
                    $http
                ) {
                    return {
                        all : function(pars) {
                            var apiURI = env.API + '/leads';
                            return $http.get( apiURI, { params:  pars } );
                        },
                        next : function(pars) {
                            var apiURI = env.API + '/lead_next';
                            return $http.get( apiURI, { params:  pars } );
                        },
                        nextRecalls : function(pars) {
                            var apiURI = env.API + '/lead_next_recalls';
                            return $http.get( apiURI, { params:  pars } );
                        },
                        get : function( id, withRel, pars ) {
                            if( angular.isDefined( id ) && id ) {
                                var apiURI = env.API + '/leads/' + id + (withRel ? '?with='+withRel : '');
                                return $http.get( apiURI,  { params:  pars });
                            }
                        },
                        counters : function(pars, uid, lev) {
                            var apiURI = env.API + '/leads/counters';
                            if (lev) {
                                apiURI+=lev;
                            }
                            apiURI+='/'+uid;
                          return $http.get( apiURI, { params:  pars } );
                        },
                        counters1 : function(pars, uid) {
                            return this.counters(pars,uid,1);
                        },
                        counters2 : function(pars, uid) {
                            return this.counters(pars,uid,2);
                        },
                        update : function( data ) {
                            if(
                                angular.isDefined( data ) &&
                                angular.isObject( data ) &&
                                data.id
                            ) {
                                var apiURI = env.API + '/leads/' + data.id;
                                return $http.put( apiURI, data );
                            };
                        },
                        assignTo : function( data, uid ) {
                          if(
                              angular.isDefined( data ) &&
                              angular.isObject( data )
                          ) {
                              var apiURI = env.API + '/leads/assignto/' + uid;
                              return $http.put( apiURI, data );
                          };
                        },
                        resendToSendServide: function( data ) {
                            if(
                                angular.isDefined( data ) &&
                                angular.isObject( data )
                            ) {
                                var apiURI = env.API + '/leads_resendtosendservice';
                                return $http.put( apiURI, data );
                            };
                        },
                        del : function( id ) {
                            if( id ) {
                                var apiURI = env.API + '/leads/' + id;
                                return $http.delete( apiURI );
                            };
                        },
                        save : function( data ) {
                            if(
                                angular.isDefined( data ) &&
                                angular.isObject( data )
                            ) {
                                var apiURI = env.API + '/leads';
                                return $http.post( apiURI, data );
                            };
                        },
                    };
                }
            ]
        );

})();

(function () {
    "use strict";

    angular.module("admin").controller("LeadsController", LeadsController);

    /** @ngInject */
    function LeadsController(
        $window,
        $scope,
        $log,
        $location,
        $timeout,
        $http,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        LeadService,
        env,
        phone,
        CallState,
        TreatmentService,
        CrudService,
        Italia,
        /*
        StoreService,
        SubscriptionService,*/
        UsersService,
        call_state,
        f_oper,
        AppointmentsService
    ) {
        var vm = this;
        $log.info("LeadsController");
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.env = env;
        vm.Italia = Italia;
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }

        if (vm.user.type == 'callcenter' && (vm.env.menu && !vm.env.menu.leads && !vm.user.ext_f_bid && !vm.user.ext_f_pf)) {
            $log.error('utente non autorizzato');
            return $location.path( '/addressbook' );
        }
        /* Treatments */
        vm.treatmentsList = [];
        TreatmentService.categories().then(function (data) {
            vm.treatmentsList = data;
        });
        /*vm.subscriptionsList = [];
        SubscriptionService.all({
            search: 1,
            searchFields: 'active:='
        }).then(function(response) {
            vm.subscriptionsList = response.data.data;
        });
        */

        //---------- Leads Table -------------------------------------//
        vm.today = new Date(moment().hours(0).minutes(0).seconds(0));
        //vm.yesterday = new Date(moment(vm.today).subtract(1, 'days'));
        vm.filtersFNew = [
            {
                value: "1",
                name: "Nuovi [A]",
            },
            {
                value: "2",
                name: "Nuovi [B]",
            },
            {
                value: "0",
                name: "Rientri",
            },
            {
                value: "3",
                name: "Dup. Lavorabili",
            },
            {
                value: "4",
                name: "Rigenerati",
            },
            {
                value: "5",
                name: "Leads Caldi",
            },
        ];
        vm.filtersFClosed = [
            {
                value: "0",
                name: "Non chiusi",
            },
            {
                value: "1",
                name: "Chiusi",
            },
        ];
        vm.filtersFArchived = [
            {
                value: "0",
                name: "Inbox",
            },
            {
                value: "1",
                name: "Archivio",
            },
        ];
        vm.filtersListFOper = [
            {
                value: "0",
                name: "Commerc.",
            },
            {
                value: "1",
                name: "Non Comm.",
            },
            /*,
          {
            value: '2',
            name: "Duplicato",
        },*/
            {
                value: "3",
                name: "Non present.",
            },
            {
                value: "4",
                name: "Non fidelizz.",
            },
            {
                value: "5",
                name: "Rullo",
            },
        ];
        /*vm.filtersFSections = [
          {
              value: "A",
              name: "A"
          },
          {
            value: "G",
              name: "G"
          },
          {
            value: "P",
              name: "P"
          },
        ];*/
        /** A B C D E F G H I J K L M N O P Q R S T U V W X Y Z */
        vm.call_state = CallState;

        vm.dataRichiamoChanged = function () {
            var sel = moment(vm.eStatus.filter_date_start);
            //$log.info(moment(vm.eStatus.filter_date_start));
            var oggi = moment();
            if (oggi.format("YYYY-MM-DD") == sel.format("YYYY-MM-DD")) {
                vm.eStatus.filter_date_start = oggi;
            } else {
                vm.eStatus.filter_date_start = moment(
                    sel.format("YYYY-MM-DD") + " 23:59:59",
                    "YYYY-MM-DD HH:mm:ss"
                );
            }
            vm.eListLoad(1);
        };
        vm.eStatus = {
            showDatePicker: false,
            call_state: null, //undefined;//'da chiamare',//da chiamare
            selectedIndex: 0,
            filter_date_start: null, //vm.today,
            filter_from: null,
            filterUserIdType: 1,
            filter_to: null,
            filter_assign_at: vm.user.type == "callcenter" && !vm.user.ext_f_bid ? true : false,
            userId: null,
            fNew: null,
            fClosed: null,
            fArchived: null,
            category: null,
            pricing: null,
            region: null,
            fOper:
                vm.user.type == "operator" || vm.user.type == "storemngr"
                    ? "1"
                    : vm.user.type == "callcenter" && !vm.user.ext_f_bid
                    ? 0
                    : undefined,
            tenant: null,
            needDatePicker: function () {
                this.showDatePicker = true;
            },
            onChange: function () {
                vm.query.page = 1;

                if (
                    vm.activeE.call_state != "da chiamare" &&
                    vm.activeE.call_state != "da richiamare" &&
                    vm.activeE.call_state != "da confermare appuntamento"
                ) {
                    this.showDatePicker = false;
                    vm.activeE.call_date = null;
                } else {
                    this.needDatePicker();
                }
            },
            onChangeDateFilter: function () {
                var date = this.filter_date_start;

                $log.info(date);

                return function (item) {
                    if (!date) return true;

                    if (date && !item.call_date) return false;

                    if (item.call_date)
                        return (
                            moment(date).isSame(moment(item.call_date)) ||
                            moment(date).isBefore(moment(item.call_date))
                        );

                    return true;
                };
            },
            setIndex: function (lead) {
                var actObj = vm.activeE;
                if (lead != null) {
                    actObj = lead;
                }
                if (
                    actObj.call_state != "da chiamare" &&
                    actObj.call_state != "da richiamare" &&
                    actObj.call_state != "da confermare appuntamento"
                ) {
                    this.showDatePicker = false;
                    vm.activeE.call_date = null;
                } else {
                    this.needDatePicker();
                }
            },
        };
        vm.selected = [];
        vm.options = {
            autoSelect: false,
            boundaryLinks: true,
            pageSelector: true,
            rowSelection: false,
            pageSelect: true
        };
        vm.filter = {
            options: {
                debounce: 0,
                updateOn: "default",
            },
        };
        vm.query = {
            filter: "",
            order: "-leads.created_at",
            limit: 10,
            page: 1,
        };
        /* Controllo se c'è un Customer Id nell'URL */
        vm.phone = null;
        if (phone && angular.isDefined(phone)) {
            vm.query.filter = phone.toString();
            vm.phone = phone.toString();
        }
        vm.removeSearch = function (filter) {
            if (filter) {
                vm.query.filter = filter;
            } else {
                vm.query.filter = "";
            }
            vm.query.order =
                vm.user.type == "callcenter"  && !vm.user.ext_f_bid
                    ? "-leads.first_assign_at"
                    : "-leads.created_at";
            vm.eStatus.filter_date_start = null;
            vm.eStatus.filter_from = null;
            vm.eStatus.filter_to = null;
            vm.eStatus.filter_assign_at =
                vm.user.type == "callcenter" && !vm.user.ext_f_bid  ? true : false;
            vm.eStatus.filterUserIdType = 1;
            vm.eStatus.userId = null;
            vm.eStatus.fNew = null;
            vm.eStatus.fClosed = null;
            vm.eStatus.fArchived = null;
            vm.eStatus.category = null;
            vm.eStatus.pricing = null;
            vm.eStatus.region = null;
            vm.eStatus.fOper =
                vm.user.type == "operator" || vm.user.type == "storemngr"
                    ? "1"
                    : vm.user.type == "callcenter" && !vm.user.ext_f_bid
                    ? 0
                    : undefined;
            vm.eStatus.call_state = null;
            vm.eStatus.tenant = null;
            vm.query.page = 1;
            vm.eListLoad();
        };
        vm.eList = [];
        vm.eListLoading = true;
        vm.allSelected = false;
        vm.eListPag = {
            total: 0,
            count: 10,
            per_page: 10,
            current_page: 1,
            total_pages: 0,
            links: {},
        };
        vm.eListLoad = function (p, s) {
            vm.allSelected = false;
            vm.saveStatus();
            vm.eListLoading = true;
            vm.eList = [];
            if (p == null) {
                p = vm.query.page;
            }
            if (s == null) {
                s = parseInt(vm.eListPag.per_page);
            }
            var pars = {
                page: p,
                s: s,
                with:
                    "appointment;store;appointments;user;firstUser;firstChange;customer;verifiedRuleLog",
                searchJoin: "and",
                c_role: vm.user.type,
                c_sid: vm.user.store_id,
            };
            var pstr = "";
            if (vm.query.filter != null && vm.query.filter != "") {
                pars.filtro = vm.query.filter;
                pstr += "&filtro=" + pars.filtro;
            }

            var search = new Array();
            var searchFields = new Array();
            if (
                vm.eStatus.filter_date_start != null &&
                vm.eStatus.filter_date_start != ""
            ) {
                /*pars.data_richiamo= moment(vm.eStatus.filter_date_start).format('YYYY-MM-DD');
                pstr+="&data_richiamo="+pars.data_richiamo;
                */
                var d = moment(vm.eStatus.filter_date_start).format(
                    "YYYY-MM-DD HH:mm:ss"
                );
                //search.push('call_date:'+d);
                //searchFields.push('call_date:<=');
                pars.data_richiamo = d;
                pstr += "&data_richiamo=" + pars.data_richiamo;
            }
            if (
                (vm.user.type == "admin" || vm.user.ext_f_bid)  &&
                vm.user.tag_area &&
                vm.user.tag_area.trim() != "" &&
                vm.user.tag_area != "INBOUND"
            ) {
                search.push("tag_area:" + vm.user.tag_area + "%");
                searchFields.push("tag_area:like");
            }
            if (vm.eStatus.tenant && vm.eStatus.tenant != "") {
                pars.tenant = vm.eStatus.tenant;
            }

            if (vm.eStatus.call_state != null && vm.eStatus.call_state != "") {
                if (vm.eStatus.call_state == "escludi cancellati") {
                    pars.withTrashed = false;
                }
                else if (vm.eStatus.call_state == 'trasferiti') {

                  pars.withTrashed = true;
                  pars.trasferiti=true;

                  search.push('call_state:fuori zona');
                  searchFields.push('call_state:=');
                }
                else {
                    search.push("call_state:" + vm.eStatus.call_state);
                    searchFields.push("call_state:=");
                }
            }
            if (vm.eStatus.fNew != undefined && vm.eStatus.fNew != "") {
                if (vm.eStatus.fNew == "2") {
                    search.push("f_many_times:1");
                    searchFields.push("f_many_times:=");
                    search.push("f_new:1");
                    searchFields.push("f_new:=");
                } else if (vm.eStatus.fNew == "3") { //dup lavorabili
                    search.push("f_dup_wrk:1");
                    searchFields.push("f_dup_wrk:=");
                } else if (vm.eStatus.fNew == "4") { //rigenerati
                    search.push("f_dup_regen:1");
                    searchFields.push("f_dup_regen:=");
                } else if (vm.eStatus.fNew == "5") { //leads caldi (non duplicati e non rigenerati e non dup lavorabili)
                    search.push("f_dup_regen:0");
                    searchFields.push("f_dup_regen:=");
                    search.push("f_dup_wrk:0");
                    searchFields.push("f_dup_wrk:=");
                    pars.category_not_in =
                        "non presentato:disdetto:non fidelizzato:phonefriend:rullo:conferma:confermacomm:confermaop";
                } else {
                    if (vm.eStatus.fNew == "1") {
                        search.push("f_many_times:0");
                        searchFields.push("f_many_times:=");
                    }
                    search.push("f_new:" + vm.eStatus.fNew);
                    searchFields.push("f_new:=");
                }
                search.push("f_dup:0");
                searchFields.push("f_dup:=");
            }
            if (vm.eStatus.fOper != undefined) {
                search.push("f_dup:0");
                searchFields.push("f_dup:=");
                if (vm.eStatus.fOper == "0" || vm.eStatus.fOper == "1") {
                    search.push("f_oper:" + vm.eStatus.fOper);
                    searchFields.push("f_oper:=");
                    if (vm.storeId) {
                        if (
                            vm.eStatus.fOper == "1" &&
                            vm.env.currentTenant == "Bologna" &&
                            vm.storeId != 1
                        ) {
                            //devo far vedere anche 21 Aprile
                            pars.store_id_in = vm.storeId + ":1";
                        } else {
                            search.push("store_id:" + vm.storeId);
                            searchFields.push("store_id:=");
                        }
                    }
                    if (vm.eStatus.fOper == "0") {
                        if (angular.isUndefined(pars.category_not_in)) {
                            pars.category_not_in =
                                "non presentato:non fidelizzato:rullo:confermacomm:confermaop";
                        }
                        else {
                            pars.category_not_in +=
                                ":non presentato:non fidelizzato:rullo:confermacomm:confermaop";
                        }
                        //pstr+="&assigned="+pars.assigned;
                    }
                } else if (vm.eStatus.fOper == "3") {
                    vm.eStatus.category = "non presentato";
                } else if (vm.eStatus.fOper == "4") {
                    vm.eStatus.category = "non fidelizzato";
                } else if (vm.eStatus.fOper == "5") {
                    vm.eStatus.category = "rullo";
                }
            }
            if (
                vm.storeId &&
                (vm.user.type == "admin" || vm.user.ext_f_bid) &&
                (vm.eStatus.fOper == undefined ||
                    vm.eStatus.fOper == null ||
                    vm.eStatus.fOper > "1")
            ) {
                search.push("store_id:" + vm.storeId);
                searchFields.push("store_id:=");
            }

            if (
                vm.eStatus.fArchived != undefined &&
                vm.eStatus.fArchived != ""
            ) {
                search.push("archived:" + vm.eStatus.fArchived);
                searchFields.push("archived:=");
            }
            if (vm.eStatus.category && vm.eStatus.category != "") {
                search.push("category:" + vm.eStatus.category);
                searchFields.push("category:=");
            }
            if (vm.eStatus.pricing && vm.eStatus.pricing != "") {
                search.push("categoria:" + vm.eStatus.pricing);
                searchFields.push("categoria:=");
            }
            if (vm.eStatus.region && vm.eStatus.region != '') {
                if (vm.eStatus.region == 'non presente') {
                    pars.null_region = true;
                } else {
                    search.push("region:" + vm.eStatus.region);
                    searchFields.push("region:=");
                }
            }
            if (vm.eStatus.userId != undefined && vm.eStatus.userId == "-1") {
                //non assegnati
                pars.assigned = 0;
                pstr += "&assigned=" + pars.assigned;
            } else if (
                vm.eStatus.userId != undefined &&
                vm.eStatus.userId == "-2"
            ) {
                //assegnati
                pars.assigned = parseInt(vm.eStatus.filterUserIdType); //1 user_id / 2 first_user_id / 3 first_change_by
                pstr += "&assigned=" + pars.assigned;
            } else if (
                vm.eStatus.userId != undefined &&
                vm.eStatus.userId != ""
            ) {
                var fuid =
                    vm.eStatus.filterUserIdType == 2
                        ? "first_user_id"
                        : vm.eStatus.filterUserIdType == 3
                        ? "first_change_by"
                        : "user_id";
                search.push(fuid + ":" + vm.eStatus.userId);
                searchFields.push(fuid + ":=");
            }
            if (
                vm.eStatus.filter_from != null &&
                vm.eStatus.filter_from != ""
            ) {
                pars.created_from = moment(vm.eStatus.filter_from).format(
                    "YYYY-MM-DD"
                );
                pstr += "&created_from=" + pars.created_from;
            }
            if (vm.eStatus.filter_to != null && vm.eStatus.filter_to != "") {
                pars.created_to = moment(vm.eStatus.filter_to)
                    .add("day", 1)
                    .format("YYYY-MM-DD");
                pstr += "&created_to=" + pars.created_to;
            }
            if (
                vm.eStatus.filter_assign_at != null &&
                vm.eStatus.filter_assign_at
            ) {
                pars.filter_assign_at = vm.eStatus.filter_assign_at;
                pstr += "&filter_assign_at=" + pars.filter_assign_at;
            }
            if (vm.eStatus.fClosed != undefined && vm.eStatus.fClosed != "") {
                pars.chiusi = vm.eStatus.fClosed;
                pstr += "&chiusi=" + pars.chiusi;
            }
            pars.search = search.join(";");
            pars.searchFields = searchFields.join(";");
            if (vm.query.order != null && vm.query.order != "") {
                pars.orderBy =
                    vm.query.order.indexOf("-") == 0
                        ? vm.query.order.substring(1)
                        : vm.query.order;
                pars.sortedBy =
                    vm.query.order.indexOf("-") == 0 ? "desc" : null;
                pstr += "&orderBy=" + pars.orderBy;
                pstr += "&sortedBy=" + pars.sortedBy;
            }
            vm.exportLeadsUrl =
                env.API +
                "/leads?token=" +
                vm.token +
                "&export=true&with=customer&searchJoin=and&search=" +
                pars.search +
                "&searchFields=" +
                pars.searchFields +
                pstr;

            LeadService.all(pars).then(
                function (response) {
                    if (response.data && response.data.data) {
                        vm.eList = [];
                        //response.data.meta.pagination.per_page = vm.eListPag.per_page;
                        vm.eListPag = response.data.meta.pagination;
                        if (
                            vm.eListPag &&
                            vm.eListPag.total_pages &&
                            vm.eListPag.total_pages < 50
                        ) {
                            vm.options.pageSelect = true;
                        } else {
                            vm.options.pageSelect = false;
                        }
                        angular.forEach(response.data.data, function (elem) {
                            elem.isMine =
                                elem.user_id == vm.user.id ||
                                (vm.user.delegate1_user_id &&
                                    elem.user_id ==
                                        vm.user.delegate1_user_id) ||
                                (vm.user.delegate2_user_id &&
                                    elem.user_id == vm.user.delegate2_user_id);
                            elem.isSelected = false;
                            elem.created_at_frm = moment(
                                elem.created_at.date
                            ).format("DD/MM/YYYY");
                            if (elem.first_assign_at) {
                                elem.first_assign_at_frm = moment(
                                    elem.first_assign_at
                                ).format("DD/MM/YYYY");
                            }
                            var call_date = elem.call_date
                                ? moment(elem.call_date)
                                : null;
                            elem.call_date = call_date
                                ? new Date(call_date)
                                : null;

                            if (elem.appointments.data.length > 0) {
                                elem.indata = new Date(
                                    moment(
                                        elem.appointments.data[0].created_at
                                            .date
                                    )
                                );
                                elem.closed = true;
                            }
                            if (
                                elem.deleted &&
                                elem.deleted_at &&
                                elem.deleted_at.date
                            ) {
                                elem.indata = new Date(
                                    moment(elem.deleted_at.date)
                                );
                            } else {
                                elem.indata = elem.call_date;
                                elem.closed = false;
                            }
                            if (
                                vm.env.isMaster &&
                                elem.customer &&
                                elem.customer.data &&
                                elem.customer.data.tenant
                            ) {
                                var ten = elem.customer.data.tenant;
                                //angular.forEach(vm.tenantsList, function(t) {
                                //    if (ten==t.tenant) {
                                if (vm.env.admins && vm.env.admins[ten]) {
                                    elem.urlAddressbook =
                                        vm.env.admins[ten] +
                                        "/addressbook?phone=" +
                                        elem.customer.data.phone;
                                    elem.urlCustomer =
                                        vm.env.admins[ten] +
                                        "/customer?phone=" +
                                        elem.customer.data.phone;
                                    elem.urlLeads =
                                        vm.env.admins[ten] +
                                        "/leads?phone=" +
                                        elem.customer.data.phone;
                                }
                                elem.tenant = ten;
                                //    }
                                //});
                            }
                            vm.eList.push(elem);
                        });
                    }
                    vm.eListLoading = false;
                },
                function (response) {
                    var errMsg = "";
                    if (
                        response.data != null &&
                        response.data.message != null
                    ) {
                        errMsg =
                            response.data != null &&
                            response.data.message != null
                                ? response.data.message + "."
                                : ".";
                        var url =
                            response.config != null &&
                            response.config.url != null
                                ? response.config.url
                                : "";
                        if (url != null) {
                            errMsg += "\nUrl: " + url;
                        }
                    }
                    alert(
                        "Si è verificato un errore nel caricamento clienti: " +
                            errMsg
                    );
                    vm.eListLoading = false;
                }
            );
        };
        vm.showNote = function (a) {
            if (a.note == null || a.note.trim() == "") return;
            var p = $mdDialog
                .confirm()
                .title(
                    "Nota su " +
                        (a.customer.data.firstname != null
                            ? a.customer.data.firstname.toUpperCase()
                            : "") +
                        " " +
                        (a.customer.data.lastname != null
                            ? a.customer.data.lastname.toUpperCase()
                            : "")
                )
                .textContent(a.note)
                .ok("Ok");
            return $mdDialog.show(p);
        };

        vm.toggleAllSelected = function () {
            vm.allSelected = !vm.allSelected;
            angular.forEach(vm.eList, function (elem) {
                if (!elem.closed && !elem.f_oper && !elem.f_dup) {
                    elem.isSelected = vm.allSelected;
                }
            });
        };
        vm.toggleSelected = function (e) {
            e.isSelected = !e.isSelected;
        };
        vm.saveStatus = function () {
            //if (true) return;
            localStorage.setItem(
                vm.env.currentTenant + "_leads_eStatus",
                angular.toJson(vm.eStatus, false)
            );
            localStorage.setItem(
                vm.env.currentTenant + "_leads_query",
                angular.toJson(vm.query, false)
            );
        };
        vm.restoreStatus = function () {
            //if (true) return;
            var eStatus = angular.fromJson(
                localStorage.getItem(vm.env.currentTenant + "_leads_eStatus")
            );
            if (eStatus != null) {
                angular.merge(vm.eStatus, eStatus);
            }
            var query = angular.fromJson(
                localStorage.getItem(vm.env.currentTenant + "_leads_query")
            );
            if (query != null) {
                angular.merge(vm.query, query);
            }
        };
        if (call_state || f_oper || phone != null) {
            vm.eStatus.call_state = call_state;
            if (call_state == "da richiamare") {
                vm.eStatus.filter_date_start = moment().format(
                    "YYYY-MM-DD HH:mm:ss"
                );
                vm.query.order = "-call_date";
            }
            vm.eStatus.fOper = "" + f_oper;
            vm.query.filter = phone;
            if (!f_oper) {
                //tolgo selezione store
                vm.storeId = 0;
                $scope.$parent.main.store_id = 0;
                $log.info($scope.$parent);
                $scope.$parent.selectedStore = 0;
                vm.store = { alias: "Tutti", id: 0 };
            }
        } else {
            vm.restoreStatus();
        }
        vm.onKeyPressSearch = function (event) {
            if (event.keyCode == 13) {
                if (vm.query.filter != null) {
                    vm.query.filter = vm.query.filter.trim();
                    if (vm.query.filter.length == 1) {
                        vm.query.order = "customers.lastname";
                    }
                }
                vm.eListLoad(1);
                event.preventDefault();
                event.stopPropagation();
            }
        };

        vm.eListReOrder = function (column) {
            vm.query.order = column;
            vm.eListLoad(1);
        };
        vm.archivia = function (lead) {
            vm.saving = true;
            LeadService.update({
                id: lead.id,
                archived: true,
                c_role: vm.user.type,
                c_sid: vm.user.store_id,
            }).then(function (response) {
                vm.checkResponse(response);
                lead.archived = response.data.data.archived;
                lead.archived_by = response.data.data.archived_by;
                vm.removeIfArchived("0", lead);
            }, vm.checkResponse);
        };
        vm.removeIfArchived = function (val, lead) {
            if (vm.eStatus.fArchived == val) {
                vm.removeFromEList(lead);
            }
        };
        vm.removeFromEList = function (lead) {
            var ind = vm.eList.indexOf(lead);
            if (ind >= 0) {
                vm.eList.splice(ind, 1);
            }
        };
        vm.disarchivia = function (lead) {
            vm.saving = true;
            LeadService.update({
                id: lead.id,
                archived: false,
                c_role: vm.user.type,
                c_sid: vm.user.store_id,
            }).then(function (response) {
                vm.checkResponse(response);
                /**
                 * Se sono in archivio tolgo questa entry
                 */
                lead.archived = response.data.data.archived;
                vm.removeIfArchived("1", lead);
            }, vm.checkResponse);
        };
        vm.claim = function (lead) {
            if (lead.user_id != vm.user.id) {
                vm.saving = true;
                LeadService.update({
                    id: lead.id,
                    user_id: vm.user.id,
                    store_id: lead.store_id,
                    c_role: vm.user.type,
                    c_sid: vm.user.store_id,
                }).then(function (response) {
                    vm.checkResponse(response);
                    lead.user_id = vm.user.id;
                    lead.user = {data: vm.user};
                    lead.isMine = true;
                    if(lead.call_state == 'da chiamare' || lead.call_state == 'da verificare') {
                        lead.first_user_id = vm.user.id;
                        lead.firstUser = {data: vm.user};
                    }
                }, vm.checkResponse);
            } else {
                vm.toggleRight(lead);
            }
        };
        vm.assignToUser = null;
        vm.assignTo = function () {
            vm.saving = true;
            var ids = {
                ids: [],
                c_role: vm.user.type,
                c_sid: vm.user.store_id,
                store_id: vm.assignToUser.store_id,
            };
            angular.forEach(vm.eList, function (el) {
                if (el.isSelected) {
                    ids.ids.push(el.id);
                }
            });
            LeadService.assignTo(ids, vm.assignToUser.user.id).then(function (
                response
            ) {
                vm.checkResponse(response);
                vm.eListLoad();
            },
            vm.checkResponse);
        };

        vm.resendToSendService = function () {
            //alert("resentToSendService");
            vm.eListLoading = true;
            var ids = {
                ids: [],
                c_role: vm.user.type,
                c_sid: vm.user.store_id,
            };
            angular.forEach(vm.eList, function (el) {
                if (el.isSelected) {
                    ids.ids.push(el.id);
                }
            });
            LeadService.resendToSendServide(ids).then(function () {
                vm.eListLoading = false;
                vm.showActionToast(
                    "Invio a SendService effettuato correttamente."
                );
            }, vm.checkResponse);
        };

        //prospect si no
        /* Pagato Non-Pagato */
        vm.toggleProspect = function (lead) {
            $log.info("Prospect " + !lead.customer.data.f_prospect);
            CrudService.update(
                "customers",
                {
                    id: lead.customer.data.id,
                    f_prospect: !lead.customer.data.f_prospect,
                },
                vm,
                function (response) {
                    lead.customer.data.f_prospect = !lead.customer.data
                        .f_prospect;
                },
                function (response) {}
            );
        };

        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function (lead) {
            vm.toggleRight(lead);
        };
        //vm.undoVisible = false;
        vm.img_loading = false;
        vm.loading = false;
        vm.activeE = {};
        vm.backupE = {};
        vm.toggleRight = function (lead) {
            if(!lead) {
                vm.activeE = vm.newLead();
            } else {
                angular.forEach(lead.appointments.data, function (element) {
                    if (element.rebuilded == null) {
                        element.date_start = new Date(element.date_start);
                        element.rebuilded = true;
                    }
                });
                vm.activeE = lead;
                vm.eStatus.setIndex();
            }
            vm.activeE.moveTo = null;
            angular.copy(lead, vm.backupE);
            $timeout($mdSidenav("right").open, 0);
        };
        vm.newLead = function () {
            var lead = {
                id: null,
                customer: { data: {'birthdate': null} },
                appointments: { data: [] },
                call_state: "da chiamare",
                call_date: new Date(),
            };
            return lead;
        };
        vm.create = function () {
            vm.saving = true;
            LeadService.save(vm.activeE).then(
                function (response) {
                    vm.checkResponse(response);
                    vm.eStatus.filter_from = moment();
                    vm.eListLoad();
                },
                vm.checkResponse);
        };
        vm.resetAll = function () {
            vm.activeE = {};
            vm.backupE = {};
            /**
             * In questo modo riesegue la init
             */
            vm.eStatus.showDatePicker = false;

            return $timeout(vm.resetForm, 0);
        };
        vm.closeSidebar = function () {
            vm.undo();
            return vm.resetAll();
        };
        vm.resetForm = function () {
            return $mdSidenav("right")
                .close()
                .then(function () {
                    $scope.eForm.$setPristine();
                    $scope.eForm.$setUntouched();
                });
        };
        vm.showActionToast = function (text) {
            text = text && angular.isDefined(text) ? text : "Tutto Ok!";
            var toast = $mdToast
                .simple()
                .textContent(text)
                .action("")
                .highlightAction(true)
                .position("bottom right");
            return $mdToast.show(toast).finally(function () {
                toast = undefined;
            });
        };
        vm.responseStatusSuccessful = [200, 201, 202];
        vm.checkResponse = function (response) {
            vm.saving = false;
            if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
                var errMsg = "";
                if (response.data != null && response.data.message != null) {
                    errMsg =
                        response.data != null && response.data.message != null
                            ? response.data.message
                            : "";
                    var url =
                        response.config != null && response.config.url != null
                            ? response.config.url
                            : "";
                    vm.showActionToast("KO: " + errMsg + " " + url);
                }
                var alert = $mdDialog
                    .alert()
                    .title("Attenzione")
                    .ariaLabel("Attenzione")
                    .textContent("C'è stato un problema: " + errMsg)
                    .ok("Ok");
                return $mdDialog.show(alert).finally(function () {
                    alert = undefined;
                });
            } else {
                vm.showActionToast();
                return vm.resetAll();
            }
        };
        vm.update = function (lead, archivia, sendWa) {
            $log.info("Update");
            $log.info(lead);
            if (angular.isDefined(lead)) {
                var msg = "Sicuro di voler aggiornare?";
                if (lead.call_state == "fuori zona" && lead.moveTo != null) {
                    msg =
                        "Sicuro di voler inviare il lead a " +
                        lead.moveTo.label +
                        " ed eliminarlo da qui?";
                } else {
                    delete lead.moveTo;
                }
                var confirm = $mdDialog
                    .confirm()
                    .title("Attenzione")
                    .ariaLabel("Attenzione")
                    .textContent(msg)
                    .ok("Si")
                    .cancel("Ops, ho sbagliato");
                return $mdDialog
                    .show(confirm)
                    .then(function () {
                        vm.saving = true;
                        //angular.copy(customer, vm.update_customer);
                        var call_date = null;
                        $log.info(lead.call_date);
                        if (lead.call_date) {
                            var nd = new Date(lead.call_date);
                            call_date = $filter("date")(
                                nd,
                                "yyyy-MM-dd HH:mm:ss"
                            );
                            lead.indata = nd;
                        } else {
                            lead.indata = null;
                        }
                        var updObj = {};
                        if (lead.moveTo != null) {
                            updObj = {
                                id: lead.id,
                                move_to: lead.moveTo.tenant,
                                c_role: vm.user.type,
                                c_sid: vm.user.store_id,
                            };
                        } else if (lead.call_state == "spostato") {
                            //mando a booking sposta
                            //vado in booking passando id appuntamento e una volta preso il nuovo appuntamento setto come disdetto questo
                            var nl =
                                vm.env.booking +
                                "/operator?store=" +
                                lead.appointment.data.store_id +
                                "&tenant=" +
                                vm.env.currentTenant +
                                "&c_sid=" +
                                vm.user.store_id +
                                "&c_role=" +
                                vm.user.type +
                                "&customer=" +
                                lead.customer.data.phone +
                                "&callcenter=" +
                                (vm.user.type == "callcenter") +
                                "&appointment=" +
                                lead.appointment.data.id +
                                "&treatment=" +
                                lead.appointment.data.treatment_id +
                                "&appointmentDate=" +
                                moment(lead.appointment.data.date_start).format(
                                    "YYYY-MM-DD HH:mm"
                                ) +
                                "&token=" +
                                vm.token;
                            //alert (nl);
                            window.location.href = nl;
                            return;
                        } else {
                            updObj = {
                                id: lead.id,
                                call_date: call_date,
                                call_state: lead.call_state,
                                note: lead.note,
                                c_role: vm.user.type,
                                c_sid: vm.user.store_id,
                            };
                            if (!lead.archived && archivia) {
                                updObj.archived = true;
                                lead.archived = true;
                                updObj.archived_by = vm.user.id;
                                lead.archived_by = vm.user.id;
                            }
                        }
                        LeadService.update(updObj).then(function (response) {
                            vm.checkResponse(response);
                            if (lead.moveTo != null) {
                                vm.removeFromEList(lead);
                            } else if (lead.archived) {
                                vm.removeIfArchived("0", lead);
                            }
                            if (
                                lead.categoria == "conferma" &&
                                lead.appointment_id
                            ) {
                                if (
                                    lead.call_state == "disdetto" &&
                                    lead.appointment.data.recalled < 3
                                ) {
                                    AppointmentsService.update({
                                        id: lead.appointment_id,
                                        recalled: 3,
                                        paid: 0,
                                    }).then(function () {
                                        lead.appointment.data.recalled = 3;
                                        vm.showActionToast(
                                            "Appuntamento disdetto."
                                        );
                                    }, vm.checkResponse);
                                } else if (
                                    lead.call_state == "confermato" &&
                                    lead.appointment.data.recalled < 4 &&
                                    lead.appointment.data.recalled != 1
                                ) {
                                    AppointmentsService.update({
                                        id: lead.appointment_id,
                                        recalled: 1,
                                    }).then(function () {
                                        lead.appointment.data.recalled = 1;
                                        vm.showActionToast(
                                            "Appuntamento confermato."
                                        );
                                    }, vm.checkResponse);
                                } else if (
                                    lead.call_state.indexOf("NR") >= 0 &&
                                    lead.appointment.data.recalled < 4 &&
                                    lead.appointment.data.recalled != 2
                                ) {
                                    AppointmentsService.update({
                                        id: lead.appointment_id,
                                        recalled: 2,
                                    }).then(function () {
                                        lead.appointment.data.recalled = 2;
                                        vm.showActionToast(
                                            "Appuntamento aggiornato."
                                        );
                                    }, vm.checkResponse);
                                }
                            }
                            $scope.$parent.main.alertsDachiamareRefresh();
                            if (sendWa) {
                                $log.info(lead);
                                $window.open(
                                    "https://api.whatsapp.com/send?phone=" +
                                        env.countryCode +
                                        lead.customer.data.phone +
                                        "&text=" +
                                        window.encodeURIComponent(lead.note),
                                    "WhatsUp"
                                );
                            }
                        }, vm.checkResponse);
                    })
                    .finally(function () {
                        confirm = undefined;
                    });
            }
        };
        vm.undo = function () {
            $log.info("Undo");

            if (!angular.equals(vm.activeE, vm.backupE)) {
                angular.copy(vm.backupE, vm.activeE);
            }

            return vm.resetAll();
        };

        /* WATCHO Lo Store */
        vm.storesList = null;
        vm.storeId = null;
        $scope.$watch("$parent.selectedStore", function (id) {
            if (vm.storesList == null) {
                //è il primo caricamento
                vm.storesList = $scope.$parent.main.storesList;
                vm.tenantsLoad();
                if (vm.user.type != "storemngr" && vm.user.type != "operator") {
                    vm.operatorLoad();
                }
            }
            vm.storeId = id;
            vm.eListLoad();
        });

        vm.tenantsList = [];
        vm.tenantsLoad = function () {
            vm.tenantsList = [];
            $http
                .get(env.API + "/tenants?orderBy=tenant")
                .then(function (response) {
                    if (response.data && response.data.data) {
                        vm.tenantsList = [];
                        angular.forEach(response.data.data, function (elem) {
                            if (elem.tenant != vm.user.tenant) {
                                if (!elem.label) {
                                    elem.label = elem.tenant;
                                }
                                vm.tenantsList.push(elem);
                            }
                        });
                    }
                });
        };

        vm.pricings = [];
        vm.pricingsLoad = function () {
            vm.pricings = [];
            $http
                .get(env.API + "/leads_campaign_pricings")
                .then(function (response) {
                    if (response.data && response.data.data) {
                        vm.pricings = response.data.data;
                    }
                });
        };
        vm.pricingsLoad();

        vm.regions = [];
        vm.regionsLoad = function () {
            vm.regions = [];
            $http
                .get(env.API + "/leads_campaign_regions")
                .then(function (response) {
                    if (response.data && response.data.data) {
                        vm.regions = response.data.data;
                    }
                });
        };
        //vm.regionsLoad();


        vm.categories = [];
        vm.categoriesLoad = function () {
            vm.categories = [];
            $http
                .get(env.API + "/leads_campaign_categories")
                .then(function (response) {
                    if (response.data && response.data.data) {
                        vm.categories = response.data.data;
                    }
                });
        };
        vm.categoriesLoad();

        /* Operators devo caricare i ruoli */
        vm.operatorsCallList = [];
        vm.operatorsCall2List = [];
        vm.operatorLoad = function () {
            vm.operatorsCallList = [];
            vm.operatorsCall2List = [];

            UsersService.allRoles({
                search: "role:callcenter",
                searchFields: "role:=",
                with: "user",
            }).then(function (response) {
                if (response.data && response.data.data) {
                    if (vm.user.type != "callcenter" || vm.user.ext_f_bid ) {
                        vm.operatorsCallList = $filter("filter")(
                            response.data.data,
                            { active: true },
                            true
                        );
                    } else {
                        if (vm.user.delegate1_user_id) {
                            vm.operatorsCallList = vm.operatorsCallList.concat(
                                $filter("filter")(
                                    response.data.data,
                                    { user_id: vm.user.delegate1_user_id },
                                    true
                                )
                            );
                        }
                        if (vm.user.delegate2_user_id) {
                            vm.operatorsCallList = vm.operatorsCallList.concat(
                                $filter("filter")(
                                    response.data.data,
                                    { user_id: vm.user.delegate2_user_id },
                                    true
                                )
                            );
                        }
                    }
                    UsersService.allRoles({
                        search: "active:1;role:storemngr",
                        searchFields: "active:=;role:=",
                        with: "user;availabilityDay;store",
                    }).then(function (response) {
                        if (response.data && response.data.data) {
                            var ora = moment().format("YYYY-MM-DD HH:mm");
                            angular.forEach(response.data.data, function (s) {
                                angular.forEach(
                                    vm.operatorsCallList,
                                    function (c) {
                                        if (s.user_id == c.user_id) {
                                            angular.forEach(
                                                s.availability_day,
                                                function (a) {
                                                    if (
                                                        a.store_id ==
                                                            s.store_id &&
                                                        a.date_start <= ora &&
                                                        a.date_end >= ora
                                                    ) {
                                                        s.online = true;
                                                    }
                                                }
                                            );
                                            vm.operatorsCall2List.push(s); //per essere qui deve avere il doppio ruolo
                                        }
                                    }
                                );
                            });
                        }
                    });
                }
            });
        };
    }

    LeadsController.$inject = [
        "$window",
        "$scope",
        "$log",
        "$location",
        "$timeout",
        "$http",
        "$mdSidenav",
        "$mdDialog",
        "$mdToast",
        "$filter",
        "LeadService",
        "env",
        "phone",
        "CallState",
        "TreatmentService",
        "CrudService",
        "Italia",
        /*
            'StoreService',
            'SubscriptionService',*/
        "UsersService",
        "call_state",
        "f_oper",
        "AppointmentsService",
    ];
})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('LeadCash1Controller', LeadCash1Controller);

    /** @ngInject */
    function LeadCash1Controller(
        $scope,
        $http,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        LeadService,
        UsersService
    ) {
        var vm = this;
        $log.info('LeadCashController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
        	return;
        }
        vm.env = env;
        vm.today = new Date(moment().hours(0).minutes(0).seconds(0));
        vm.eStatus = {
            filter_date_start: moment().format('YYYY-MM-DD'),
            userId: vm.user.type=='admin'?undefined:vm.user.id,
            esteso: false,
            isToday: function() {
              return moment(this.filter_date_start).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD');
            } 
        };
        vm.removeSearch = function() {
            vm.eStatus.filter_date_start = moment().format('YYYY-MM-DD');
            vm.eListLoad();
        };
        vm.query = {
            order: 'lastname'
        };
        vm.eList = [];
        vm.eListLoading = true;
        /**
         * Lista contatori group by operatore
         */
        vm.eListLoad = function() {
          vm.eListLoading = true;
          vm.eList = [];
          var pars = {c_sid: vm.user.store_id, c_role: vm.user.type};
          pars.date = moment(vm.eStatus.filter_date_start).format('YYYY-MM-DD');
          if (vm.env.menu && !vm.env.menu.leadcash_leads) {
            pars.comm=2;//faccio vedere solo operatrici centri
          }
          vm.day = parseInt(moment(vm.eStatus.filter_date_start).format('DD'));
          vm.daysInMonth = moment(vm.eStatus.filter_date_start).daysInMonth();
          LeadService.counters1(pars, vm.eStatus.userId).then(function(response) {
                if (response.data && response.data.data) {
                    vm.eList = response.data.data;
                }
                vm.eListLoading = false;
            },
            function (response) {
              var errMsg = "";
              if (response.data!=null && response.data.message!=null) {
                errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                var url = response.config!=null && response.config.url!=null?response.config.url:"";
                if (url!=null) {
                  errMsg+= "\nUrl: " + url;
                }
              }
              alert ("Si è verificato un errore nel caricamento dati: " + errMsg);
              vm.eListLoading = false;
            });
        };
        
    
        vm.showActionToast = function( text) {
        	text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent(text)
                .action('')
                .highlightAction(true)
                .position('bottom right');
            return $mdToast
                .show(toast)
                .finally(
                    function() {
                        toast = undefined;
                    }
                );
        };
        vm.responseStatusSuccessful = [200, 201, 202, 203, 204];
        vm.checkResponse = function(response) {
            if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
            	var errMsg = "";
            	if (response.data!=null && response.data.message!=null) {
            		errMsg = response.data!=null && response.data.message!=null?response.data.message:"";
            		var url = response.config!=null && response.config.url!=null?response.config.url:"";
            		vm.showActionToast("KO: " + errMsg + " " + url);
            	}
                var alert = $mdDialog.alert()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent("C'è stato un problema: "+errMsg)
                    .ok('Ok');
                return $mdDialog
                    .show(alert)
                    .finally(
                        function() {
                            alert = undefined;
                        }
                    );
            } else {
                vm.showActionToast();
                return;
            };
        };
        
        /* WATCHO Lo Store */
        vm.storesList = [];
        vm.storeId = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
              if (vm.storeId==null) {//è il primo caricamento 
                vm.storesList = $scope.$parent.main.storesList;
                if (vm.user.type=='admin') {
                  vm.operatorLoad();
                }
                vm.eListLoad();
              }
              vm.storeId = id;
            };
        });

        vm.operatorsList = [];
        vm.operatorLoad = function() {
            vm.operatorsList = [];
            UsersService.all({orderBy: 'lastname', search: "type:callcenter", searchFields: "type:="}).then(function(response) {
                if (response.data && response.data.data) {
                    vm.operatorsList = response.data.data;
                };
            });
        };
        
        vm.perm = {
        	canFire: function (id, ent) {
        		return $scope.$parent.main.perm.canFire(id, ent);
        	},
        	canRead: function (id, ent) {
        		return $scope.$parent.main.perm.canRead(id, ent);
        	},
        	canCreate: function (id, ent) {
        		return $scope.$parent.main.perm.canCreate(id, ent);
        	},
        	canUpdate: function (id, ent) {
        		return $scope.$parent.main.perm.canUpdate(id, ent);
        	},
        	canDelete: function (id, ent) {
        		return $scope.$parent.main.perm.canDelete(id, ent);
        	},
        	canSave: function (id, ent) {
        		return $scope.$parent.main.perm.canSave(id, ent);
        	}
       };
        vm.soglie = {
            delta: {green: 10, normal: {min: -10, max: 10}, orange: {min: -35, max: -10}, red: -35},
            spost: {green: 10, normal: {min: 10, max: 15}, orange: {min: 15, max: 20}, red: 20},
            nonpres: {green: 10, normal: {min: 10, max: 20}, orange: {min: 20, max: 30}, red: 30},
            pres: {green: 90,  normal: {min: 80, max: 90}, orange: {min: 70, max: 80}, red: 70},
            dentro: function (val, range) {
              return val < range.max && val >= range.min;
            }
        };
    };

    LeadCash1Controller
        .$inject = [
            '$scope',
            '$http',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',
            'LeadService',
            'UsersService'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('LeadCashController', LeadCashController);

    /** @ngInject */
    function LeadCashController(
        $scope,
        $http,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        LeadService,
        UsersService
    ) {
        var vm = this;
        $log.info('LeadCashController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
        	return;
        }
        vm.env = env;
        vm.today = new Date(moment().hours(0).minutes(0).seconds(0));
        vm.eStatus = {
            filter_date_start: moment().format('YYYY-MM-DD'),
            userId: vm.user.type=='admin'?undefined:vm.user.id,
            esteso: false,
            isToday: function() {
              return moment(this.filter_date_start).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD');
            } 
        };
        vm.removeSearch = function() {
            vm.eStatus.filter_date_start = moment().format('YYYY-MM-DD');
            vm.eListLoad();
        };
        vm.query = {
            order: 'lastname'
        };
        vm.eList = [];
        vm.eListLoading = true;
        /**
         * Lista contatori group by operatore
         */
        vm.eListLoad = function() {
          vm.eListLoading = true;
          vm.eList = [];
          var pars = {c_sid: vm.user.store_id, c_role: vm.user.type};
          pars.date = moment(vm.eStatus.filter_date_start).format('YYYY-MM-DD');
          if (vm.env.menu && !vm.env.menu.leadcash_leads) {
            pars.comm=2;//faccio vedere solo operatrici centri
          }
          vm.day = parseInt(moment(vm.eStatus.filter_date_start).format('DD'));
          vm.daysInMonth = moment(vm.eStatus.filter_date_start).daysInMonth();
          LeadService.counters(pars, vm.eStatus.userId).then(function(response) {
                if (response.data && response.data.data) {
                    vm.eList = response.data.data;
                }
                vm.eListLoading = false;
            },
            function (response) {
              var errMsg = "";
              if (response.data!=null && response.data.message!=null) {
                errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                var url = response.config!=null && response.config.url!=null?response.config.url:"";
                if (url!=null) {
                  errMsg+= "\nUrl: " + url;
                }
              }
              alert ("Si è verificato un errore nel caricamento dati: " + errMsg);
              vm.eListLoading = false;
            });
        };
        
    
        vm.showActionToast = function( text) {
        	text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent(text)
                .action('')
                .highlightAction(true)
                .position('bottom right');
            return $mdToast
                .show(toast)
                .finally(
                    function() {
                        toast = undefined;
                    }
                );
        };
        vm.responseStatusSuccessful = [200, 201, 202, 203, 204];
        vm.checkResponse = function(response) {
            if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
            	var errMsg = "";
            	if (response.data!=null && response.data.message!=null) {
            		errMsg = response.data!=null && response.data.message!=null?response.data.message:"";
            		var url = response.config!=null && response.config.url!=null?response.config.url:"";
            		vm.showActionToast("KO: " + errMsg + " " + url);
            	}
                var alert = $mdDialog.alert()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent("C'è stato un problema: "+errMsg)
                    .ok('Ok');
                return $mdDialog
                    .show(alert)
                    .finally(
                        function() {
                            alert = undefined;
                        }
                    );
            } else {
                vm.showActionToast();
                return;
            };
        };
        
        /* WATCHO Lo Store */
        vm.storesList = [];
        vm.storeId = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
              if (vm.storeId==null) {//è il primo caricamento 
                vm.storesList = $scope.$parent.main.storesList;
                if (vm.user.type=='admin') {
                  vm.operatorLoad();
                }
                vm.eListLoad();
              }
              vm.storeId = id;
            };
        });

        vm.operatorsList = [];
        vm.operatorLoad = function() {
            vm.operatorsList = [];
            UsersService.all({orderBy: 'lastname', search: "type:callcenter", searchFields: "type:="}).then(function(response) {
                if (response.data && response.data.data) {
                    vm.operatorsList = response.data.data;
                };
            });
        };
        
        vm.perm = {
        	canFire: function (id, ent) {
        		return $scope.$parent.main.perm.canFire(id, ent);
        	},
        	canRead: function (id, ent) {
        		return $scope.$parent.main.perm.canRead(id, ent);
        	},
        	canCreate: function (id, ent) {
        		return $scope.$parent.main.perm.canCreate(id, ent);
        	},
        	canUpdate: function (id, ent) {
        		return $scope.$parent.main.perm.canUpdate(id, ent);
        	},
        	canDelete: function (id, ent) {
        		return $scope.$parent.main.perm.canDelete(id, ent);
        	},
        	canSave: function (id, ent) {
        		return $scope.$parent.main.perm.canSave(id, ent);
        	}
       };
        vm.soglie = {
            delta: {green: 10, normal: {min: -10, max: 10}, orange: {min: -35, max: -10}, red: -35},
            spost: {green: 10, normal: {min: 10, max: 15}, orange: {min: 15, max: 20}, red: 20},
            nonpres: {green: 10, normal: {min: 10, max: 20}, orange: {min: 20, max: 30}, red: 30},
            pres: {green: 90,  normal: {min: 80, max: 90}, orange: {min: 70, max: 80}, red: 70},
            dentro: function (val, range) {
              return val < range.max && val >= range.min;
            }
        };
    };

    LeadCashController
        .$inject = [
            '$scope',
            '$http',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',
            'LeadService',
            'UsersService'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('LeadController', LeadController);

    /** @ngInject */
    function LeadController(
        $window,
        $scope,
        $log,
        $timeout,
        $http,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        LeadService,
        env,
        CallState,
        lead_id,
        phone,
        CrudService,
        Italia,
        UsersService,
        AppointmentsService,
        CustomerService,
        $pusher
    ) {
        var vm = this;
        $log.info('LeadController');
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;

        vm.Italia = Italia;
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }

        //---------- Leads Table -------------------------------------//
        vm.env = env;

        /**
         * bind pusher per notifiche 3cx
         */
        var pusherKey = vm.env.pusher_key?vm.env.pusher_key:'a9119391f9a6c97a31a8';
        vm.client = new Pusher(pusherKey, {
            cluster: 'eu'
        });
        vm.pusher = $pusher(vm.client);
        vm.channel = vm.pusher.subscribe(vm.env.currentTenant+'-3cx-channel');

        $log.info("bind pusher 3cx " + vm.env.currentTenant+'-3cx-channel' + " on " + pusherKey);

        vm.channel.bind('call-journaling-3cx-event', function(data) {
            vm.on3cxCallJournalingEventReceived(data);
        });

        vm.on3cxCallJournalingEventReceived = function(data) {
            $log.info("on3cxCallJournalingEventReceived");
            $log.info(data);
            /**
             * Stesso utente che fa telefonata e stesso numero di telefono del cliente visualizzato
             */
            if (data && data.user && data.user.email == vm.user.email
                && data.customer && data.customer.phone
                && vm.eList.length>0 && vm.eList[0].customer
                && vm.eList[0].customer.phone == data.customer.phone
                && data.callData && data.callData.direction == 'out' && data.callData.type == 'Notanswered') {
                $log.info("on3cxCallJournalingEventReceived: match non risposto");
                $log.info(data.callData);
                /**
                 * devo automatizzare NR
                 */
                vm.buttonClick(vm.buttonNR);
                $timeout(function() {
                    vm.update(vm.backupE, vm.selectedStateIsFinal);
                }  , 500);
            }
        };

        vm.searchTailEnabled = false; //$scope.$parent.main.config.get("lead.searchtail.enabled", false) || vm.user.ext_f_leads || vm.user.type=='admin';
        vm.searchTypeEnabled = $scope.$parent.main.config.get("lead.searchtype.enabled", false) || vm.user.ext_f_caveau || vm.user.type=='admin';

        if (!vm.searchTailEnabled) {
            localStorage.removeItem('lead.searchTail');
        }
        if (!vm.searchTypeEnabled) {
            localStorage.removeItem('lead.searchType');
        }

        vm.today = new Date(moment().hours(0).minutes(0).seconds(0));
        vm.call_state = CallState;
        vm.search = '';
        vm.searchTenant = null;
        vm.searchId = null;
        vm.searchTail = localStorage.getItem('lead.searchTail');
        vm.searchType = localStorage.getItem('lead.searchType');
        vm.searchNr = localStorage.getItem('lead.searchNr');
        vm.searchCutDays = localStorage.getItem('lead.searchCutDays');

        if (phone) {
            vm.search = phone;
            localStorage.setItem('lead.search',phone);
        }

        /**
         * Gestione online lead hot
         */
        var leadHotOnline = localStorage.getItem('lead.fLeadHotOnline');
        if (leadHotOnline!=null) {
            vm.fLeadHotOnline = leadHotOnline!='false';
        } else {
            vm.fLeadHotOnline = true;
        }
        vm.setFLeadHotOnline = function(val) {
            vm.fLeadHotOnline = val;
            localStorage.setItem('lead.fLeadHotOnline', ''+val);
        };

        vm.onKeyPressSearch = function (event) {
            if (event.keyCode==13) {
              if (vm.search!=null) {
                vm.search = vm.search.trim();
              }
              vm.leadToShow = null;
              vm.eListLoad();
              event.preventDefault();
              event.stopPropagation();
            }
        };
        vm.filterTail = function() {
            $log.info("filterTail: " + vm.searchTail);
            vm.leadToShow = null;
            if (vm.searchTail) {
                if (vm.searchTail!='tail') {
                    vm.searchNr = null;
                    localStorage.removeItem('lead.searchNr');
                }
                localStorage.setItem('lead.searchTail',vm.searchTail);
            } else {
                localStorage.removeItem('lead.searchTail');
            }
            vm.eListLoad();
        };
        vm.filterType = function() {
            $log.info("filterType: " + vm.searchType);
            if (vm.searchType) {
                localStorage.setItem('lead.searchType',vm.searchType);
            } else {
                localStorage.removeItem('lead.searchType');
            }
            vm.leadToShow = null;
            vm.eListLoad();
        };
        vm.filterNr = function() {
            $log.info("filterNr: " + vm.searchNr);
            if (vm.searchNr) {
                vm.searchTail = null;
                localStorage.removeItem('lead.searchTail');
                localStorage.setItem('lead.searchNr', vm.searchNr);
                localStorage.setItem('lead.searchCutDays', vm.searchCutDays);
            } else {
                localStorage.removeItem('lead.searchNr');
                localStorage.removeItem('lead.searchCutDays');
            }
            vm.leadToShow = null;
            vm.eListLoad();
        };
        vm.selectByPhone = function (phone, tenant, id) {
            vm.search = phone;
            vm.searchTenant = tenant;
            vm.searchId = id;
            console.log("searchByPhone: ");
            console.log(phone);
            console.log(tenant);
            console.log(id);
            vm.searchTail = null;
            vm.leadToShow = null;
            vm.eListLoad();
        };
        vm.removeSearch = function () {
            localStorage.removeItem('lead.searchTail');
            localStorage.removeItem('lead.searchNr');
            localStorage.removeItem('lead.searchType');
            localStorage.removeItem('lead.searchCutDays');
            vm.searchTail = null;
            vm.searchType = null;
            vm.searchNr = null;
            vm.searchCutDays = null;
            vm.nextLead();
        };
        vm.phoneChecking = false;
        vm.customerExists = {};
        vm.checkPhoneExists = function() {
          vm.customerExists = {};
          if (vm.backupE
                  && vm.backupE.customer.phone
                  && vm.backupE.customer.phone.trim()!='')
          {
            vm.phoneChecking = true;
              CustomerService.all(
                  {'filtro': vm.backupE.customer.phone,
                  'search': 'phone:'+vm.backupE.customer.phone,
                  'searchFields':'phone:='
                }).then(
                    function(response) {
                        vm.phoneChecking = false;
                        if(response.data.data.length >= 1 && (vm.activeE.customer.id==null || vm.activeE.customer.id!=response.data.data[0].id)) {
                          $scope.eForm.phone.$setValidity('alreadyexists', false);
                          vm.customerExists = response.data.data[0];
                        } else {
                          $scope.eForm.phone.$setValidity('alreadyexists', true);
                        }
                    },
                    function(response) {
                        vm.phoneChecking = false;
                    }
                );
          }
        };

        vm.nextLead = function() {
            localStorage.removeItem('lead.search');
            vm.search= ''
            vm.leadToShow = null;
            vm.eListLoad();
        }
        vm.buttons = [];
        vm.buttonClick = function(button) {
            vm.eStatus.withdelay = true;
            vm.toggleRight(vm.currentLead, button.call_state);
            vm.selectedStateIsFinal = button.isFinal;
            if (button.isFinal || button.hideDatePicker) {
                vm.eStatus.showDatePicker = false;
                vm.backupE.call_date = null;
            } else {
                if (button.delay) {
                    var call_date = moment().add(button.delay, 'minute');
                    vm.backupE.call_date = new Date(call_date);
                    vm.backupE.recall_delay = 0;
                }
                vm.eStatus.showDatePicker = true;
            }
            if(button.isDisdetto) {
                vm.eStatus.ShowReason = true;
                vm.eStatus.showDatePicker = true;
                vm.eStatus.withdelay = false;
            } else {
                vm.eStatus.ShowReason = false;
            }
        }
        vm.eStatus = {
            showDatePicker: false,
            ShowReason:false,
            needDatePicker: function() {
                this.showDatePicker = true;
            },
            onChange: function() {
                if (vm.isFinalState(vm.backupE.call_state)) {
                  this.showDatePicker = false;
                  vm.backupE.call_date = null;
                  vm.selectedStateIsFinal = true;
                } else {
                  this.needDatePicker();
                  vm.selectedStateIsFinal = false;
                }
            }
        };

        vm.isFinalState = function(state) {
            var finals = [
                'fuori zona',
                'nr 5',
                'lista nera',
                'inviata mail 3',
                'inviato sms 3',
                'non interessato',
                //'ko stato salute',
                'non idoneo',
                'fake',
                'ha preso appuntamento',
                'ha già preso appuntamento'
            ];
            return finals.indexOf(state.toLowerCase())>=0;
        };
        vm.lead_id = lead_id;
        vm.leadToShow = null;
        if(!vm.lead_id) {
            var dataStr  = localStorage.getItem('lead.nextLead');
            var search = localStorage.getItem('lead.search');
            var searchTail = localStorage.getItem('lead.searchTail');
            if (dataStr) {
                localStorage.removeItem('lead.nextLead');
                vm.leadToShow = JSON.parse(dataStr);
                if(search) {
                    vm.search = search;
                    localStorage.removeItem('lead.search');
                }
                if(searchTail) {
                    vm.searchTail = searchTail;
                    localStorage.removeItem('lead.searchTail');
                }
            }
            if(search) {
                vm.search = search;
            }
            if(searchTail) {
                vm.searchTail = searchTail;
            }
        }
        vm.eList = [];
        vm.eListLoading = true;
        vm.eListLoad = function() {
            vm.allSelected = false;
            vm.eListLoading = true;
            vm.currentLead = {'customer': {}};
            vm.buttons = [];
            vm.eList = [];
            vm.richiamiList = [];
            vm.codaList = [];
            var pars = {
                with: 'store;appointments;user;firstUser;firstChange;customer'
            };
            if (vm.lead_id) {
                LeadService.get(vm.lead_id, pars.with, {c_sid: vm.user.store_id, c_role: vm.user.type}).then(
                    function(response) {
                        vm.handleEListLoad(response.data.data);
                        vm.eListLoading = false;
                    },
                    vm.handleEListLoadError
                );
            } else if (vm.leadToShow) {
                vm.handleEListLoad(vm.leadToShow);
                vm.eListLoading = false;
            } else {
                var pars = {c_sid: vm.user.store_id, c_role: vm.user.type};
                if (vm.search) {
                    pars.search = vm.search;
                }
                if (vm.searchTenant) {
                    pars.searchTenant = vm.searchTenant;
                    vm.searchTenant = null;
                    pars.searchId = vm.searchId;
                    vm.searchId = null;
                }
                if (vm.searchTail && vm.searchTailEnabled) {
                    pars.searchTail = vm.searchTail;
                }
                if (vm.searchType && vm.searchTypeEnabled) {
                    pars.searchType = vm.searchType;
                }
                if (vm.searchNr) {
                    pars.searchNr = vm.searchNr;
                    pars.searchCutDays = vm.searchCutDays;
                }
                pars.fLeadHotOnline = vm.fLeadHotOnline;
                LeadService.next(pars).then(//da richiamare
                    function(response) {
                        if (response.data
                            && response.data.data) {
                            if (response.data.allLeads) {
                                response.data.data.customer.leads = response.data.allLeads;
                            }
                            if (response.data.allAppointments) {
                                response.data.data.customer.appointments = response.data.allAppointments;
                            }
                            //console.log('lead da caricare:',response.data.data);
                            localStorage.setItem('lead.nextTail', JSON.stringify(response.data.tail));
                            localStorage.setItem('lead.nextRecalls', JSON.stringify(response.data.recalls));
                            if (pars.search) {
                                localStorage.setItem('lead.search', pars.search);
                            }
                            if (pars.searchTail) {
                                localStorage.setItem('lead.searchTail', pars.searchTail);
                            }
                            /**
                             * mi posiziono su area e procedo al caricamento
                             */
                            if (!vm.env.apis || $scope.$parent.main.selectedArea == response.data.data.tenant) {
                                    vm.handleEListLoad(response.data.data);
                                    vm.eListLoading = false;
                            } else {
                                $scope.$parent.main.selectedArea = response.data.data.tenant;
                                localStorage.setItem('lead.nextLead', JSON.stringify(response.data.data));
                                $scope.$parent.main.selectedAreaChange(true, 'home.lead');
                            }
                        } else {
                            vm.eListLoading = false;
                        }
                    },
                    vm.handleEListLoadError
                );
            }
        };

        vm.handleEListLoadError = function(response) {
            var errMsg = "";
            $log.error(response);
            if (response.data!=null && response.data.message!=null) {
                errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                var url = response.config!=null && response.config.url!=null?response.config.url:"";
                if (url!=null) {
                    errMsg+= "\nUrl: " + url;
                }
            }
            alert ("Errore nel caricamento: " + errMsg);
            vm.eListLoading = false;
            vm.richiamiListLoading = false;
        };

        vm.richiamiList = [];
        vm.richiamiListLoading = false;
        vm.richiamiListLoad = function() {
            //vm.richiamiListLoading = true;
            vm.richiamiList = JSON.parse(localStorage.getItem('lead.nextRecalls'));
            angular.forEach(vm.richiamiList, function(e) {
                vm.alterElement(e);
            });
            localStorage.removeItem('lead.nextRecalls');
            //vm.richiamiListLoading = false;
        };

        vm.codaList = [];
        vm.codaListLoad = function() {
            vm.codaList = JSON.parse(localStorage.getItem('lead.nextTail'));
            angular.forEach(vm.codaList, function(e) {
                vm.alterElement(e);
            });
            localStorage.removeItem('lead.nextTail');
        };

        vm.textColor = {
            'lead': 'black',
            'leadsocial': 'black',
            'rullo': 'black',
            'non presentato': 'black',
            'non fidelizzato': 'black',
            'confermacomm': 'black',
            'confermaop': 'black',
            'phonefriend': 'black',
            'disdetto': 'black'
        };

        vm.bgColor = {
            'lead': 'lightcoral',
            'leadsocial': '#fff1f1',
            'rullo': 'lightgreen',
            'non presentato': 'gold',
            'non fidelizzato': 'skyblue',
            'confermacomm': 'orange',
            'confermaop': 'orange',
            'phonefriend': 'pink',
            'disdetto': 'whitesmoke'
        };

        /*public static $typesColor = [
            'LEAD' => 'red',
            'NR' => 'violet',
            'RECALL' => 'orange',
            'NOSHOW' => 'yellow',
            'CS' => 'skyblue',
            'CAVEAU' => 'green',
            'PF' => 'pink'
        ];*/

        vm.alterElement = function(elem) {
            elem.typeDescr = 'LEAD';
            if (elem.f_dup_wrk) {
                elem.icon = 'looks_two';
                elem.iconColor = 'orange';
                elem.typeDescr = 'LEAD (Dupl. lavorabile)';
            }
            if (elem.f_dup_regen) {
                elem.icon = 'looks_two';
                elem.iconColor = 'green';
                elem.typeDescr = 'LEAD (Rigenerato)';
            }
            var defCat = 'lead';
            if (elem.f_oper) {
                defCat  = 'leadsocial';
                elem.typeDescr = 'LEAD CENTRO';
            }
            elem.bgColor = vm.bgColor[defCat];
            if (vm.bgColor[elem.category]) {
                elem.bgColor = vm.bgColor[elem.category];
                elem.typeDescr = elem.category.toUpperCase();
            }
            elem.textColor = vm.textColor[defCat];
            if (vm.textColor[elem.category]) {
                elem.textColor = vm.textColor[elem.category];
            }

            if (elem.appointment && elem.appointment.by_operator && (elem.appointment.by_operator.id || elem.appointment.by_operator.id==0)) {
                elem.appointment.byOperator = elem.appointment.by_operator;
                elem.appointment.by_operator = elem.appointment.byOperator.id;
            }

            elem.isSelected = false;
            if (elem.created_at) {
                if (elem.created_at.date) {
                    elem.created_at_frm = moment(elem.created_at.date).format("DD/MM/YYYY");
                } else {
                    elem.created_at_frm = moment(elem.created_at).format("DD/MM/YYYY");
                }
            }
            if (elem.first_assign_at) {
                elem.first_assign_at_frm = moment(elem.first_assign_at).format("DD/MM/YYYY");
            }
            var call_date = elem.call_date ? moment(elem.call_date) : null;
            elem.call_date = call_date ? new Date(call_date) : null;
            if (elem.appointment) {
                elem.appointment.date_start_frm = moment(elem.appointment.date_start).format('DD/MM/YYYY HH:mm');
                elem.appointment.created_at_frm = moment(elem.appointment.created_at).format('DD/MM/YYYY HH:mm');

            }

            if (elem.customer && elem.customer.appointments) {
                angular.forEach(elem.customer.appointments, function(el) {
                    el.date_start_frm = moment(el.date_start).format('DD/MM/YYYY HH:mm');
                });
            }
            if (elem.customer && elem.customer.leads) {
                angular.forEach(elem.customer.leads, function(el) {
                    el.created_at_frm = moment(el.created_at).format('DD/MM/YYYY HH:mm');
                });
            }
            if (vm.env.currentTenant == 'Italia'
                && elem.customer
                && elem.customer.tenant) {
                    var ten = elem.customer.tenant;
                    if (vm.env.admins && vm.env.admins[ten]) {
                        elem.urlAddressbook = vm.env.admins[ten] + "/addressbook?phone="+elem.customer.phone;
                        elem.urlCustomer = vm.env.admins[ten] + "/customer?phone="+elem.customer.phone;
                        elem.urlLeads = vm.env.admins[ten] + "/leads?phone="+elem.customer.phone;
                    }
                    elem.tenant = ten;
            }
        };

        vm.handleEListLoad = function(elem) {
            vm.richiamiListLoad();
            vm.codaListLoad();
            vm.alterElement(elem);
            vm.selectedPf = 0;
            elem.isMine = true;
            vm.eList = [];
            vm.eList.push(elem);
            vm.currentLead = elem;
            var nextNr = 'NR';
            var nrIsFinal = false;
            if (elem.call_state == 'NR') {
                nextNr = 'NR 2';
                nrIsFinal = false;
            } else if (elem.call_state == 'inviato WhatsApp 1') {
                nrIsFinal = true;
                if (elem.category!= 'non presentato'
                    && elem.category!= 'non fidelizzato'
                    && elem.category!= 'disdetto'
                    && elem.category!= 'confermacomm'
                    && elem.category!= 'confermaop'
                ) {
                    nextNr = 'NR 5';
                } else {
                    nextNr = 'NR 3';
                }
            } else if (elem.call_state && elem.call_state.indexOf('NR ')==0) {
                var nri = (parseInt(elem.call_state.split(' ')[1])+1);
                nextNr = 'NR '+nri;
                if (elem.category!= 'non presentato'
                    && elem.category!= 'non fidelizzato'
                    && elem.category!= 'disdetto'
                    && elem.category!= 'confermacomm'
                    && elem.category!= 'confermaop'
                ) {
                    nrIsFinal = (nri>=3);
                } else {
                    nrIsFinal = (nri>=3);
                }
            }
            vm.buttons = [];
            if (vm.currentLead.category == 'confermacomm' || vm.currentLead.category == 'confermaop') {
                if (!vm.currentLead.appointment.closed && elem.call_state != 'spostato') {
                    if (elem.call_state != 'confermato' && elem.call_state != 'disdetto' && elem.call_state != 'spostato') {
                        vm.buttons.push({label: 'Rich.', tip: 'Da richiamare', icon: 'schedule', condition: true, call_state: 'da richiamare', isFinal: false, delay: 60});
                    }
                    if (elem.call_state == 'NR' || elem.call_state == 'da richiamare') {
                        var isTomorrow = moment(elem.appointment.date_start).format('YYYY-MM-DD') == moment().add(1, 'days').format('YYYY-MM-DD');
                        if (isTomorrow) {
                            vm.buttonNR = {label: 'N.R. 3', tip: 'Non risponde', icon: 'ring_volume', condition: true, call_state: "NR 3", isFinal: true};
                            vm.buttons.push(vm.buttonNR);
                        } else {
                            vm.buttonNR = {label: 'N.R. 2', tip: 'Non risponde', icon: 'ring_volume', condition: true, call_state: "NR 2", isFinal: false, hideDatePicker: true};
                            vm.buttons.push(vm.buttonNR);
                        }
                    } else if (elem.call_state == 'inviato WhatsApp 1') {
                        vm.buttonNR = {label: 'N.R. 3', tip: 'Non risponde', icon: 'ring_volume', condition: true, call_state: "NR 3", isFinal: true};
                        vm.buttons.push(vm.buttonNR);
                    } else if (elem.call_state == 'da chiamare' || elem.call_state == 'da verificare') {
                        vm.buttonNR = {label: 'N.R.', tip: 'Non risponde', icon: 'ring_volume', condition: true, call_state: nextNr, isFinal: false, hideDatePicker: true};
                        vm.buttons.push(vm.buttonNR);
                    }
                    if (elem.call_state != 'confermato') {
                        vm.buttons.push({label: 'Confermato', tip: 'Confermato', icon: 'done', condition: true, call_state: 'confermato', isFinal: true});
                    }
                    if (elem.call_state != 'disdetto') {
                        vm.buttons.push({label: 'Disdetto', tip: 'Disdetto', icon: 'cancel', condition: true, call_state: 'disdetto', isFinal: true, isDisdetto:true});
                    }
                }
            } else {
                vm.buttons.push({label: 'Rich.', tip: 'Da richiamare', icon: 'schedule', condition: true, call_state: 'da richiamare', isFinal: false, delay: 60});

                /**
                 * Se sono in Da richiamare, NR, NR2, NR3, o NR4 faccio vedere Inviato Whatsapp
                 */
                //if (elem.call_state == 'da chiamare' || elem.call_state == 'da richiamare' || elem.call_state == 'NR' || elem.call_state == 'NR 2' || elem.call_state == 'NR 3' || elem.call_state == 'NR 4') {
                    //wa con delay 4gg
                vm.buttons.push({label: 'W.A.', tip: 'Inviato Whatsapp', icon: 'insert_comment', condition: true, call_state: 'inviato WhatsApp 1', isFinal: false, delay: 24*60*2 });
                //}
                vm.buttonNR = {label: 'N.R.', tip: 'Non risponde', icon: 'ring_volume', condition: true, call_state: nextNr, isFinal: nrIsFinal, hideDatePicker: true};
                vm.buttons.push(vm.buttonNR);
                vm.buttons.push({label: 'N.I.', tip: 'Non interessato', icon: 'not_interested', condition: true, call_state: 'non interessato', isFinal: true});
                vm.buttons.push({label: 'N.D.', tip: 'Download non effettuato', icon: 'file_download', condition: true, call_state: 'no download', isFinal: true});
                vm.buttons.push({label: 'N.C.', tip: 'Da non contattare (lista nera)', icon: 'not_interested', condition: true, call_state: 'Lista Nera', isFinal: true});
                vm.buttons.push({label: 'Fissato app.', tip: 'Appuntamento fissato', icon: 'event', condition: true, call_state: 'ha già preso appuntamento', isFinal: true});
                if (vm.currentLead.category == 'non presentato') {
                    vm.buttons.push({label: 'Presentato', tip: 'Il cliente si e\' presentato', icon: 'event', condition: true, call_state: 'presentato', isFinal: true});
                } else {
                    if (vm.currentLead.category != 'disdetto') {
                        vm.buttons.push({label: 'Fake', tip: 'Numero inesistente', icon: 'thumb_down', condition: true, call_state: 'fake', isFinal: true});
                    }
                    vm.buttons.push({label: 'Fuori zona', tip: 'Zona non servita', icon: 'location_off', condition: true, call_state: 'fuori zona', isFinal: true});
                }
            }
            if (elem.working_user_id && elem.working_user_id != vm.user.id) {
                vm.isWorkingByOther = true;
            } else {
                vm.isWorkingByOther = false;
            }

            // solo sui non fidelizzato non idoneo
            if (vm.currentLead.category == 'non fidelizzato') {
                vm.buttons.push({label: 'N.Idon.', tip: 'non idoneo', icon: 'not_interested', condition: true, call_state: 'non idoneo', isFinal: true});
            }
        }

        vm.inviaMessaggioReferral = function(customer) {
            $log.info('invio primo msg referral',customer);
            vm.sending = true;
            var store = customer.last_store;
            var message = {
                'customer_id':  customer.id,
                'template':  'referral_first',
                'phone': customer.phone,
                'message': '',
                'parameters': [
                    customer.firstname,
                    vm.user.firstname,
                    store.alias
                ]
            }
            $log.info('Salva');
            CrudService
                .save( 'customer_messages', message, vm ,
                    function(response) {
                        $log.info(response)
                        vm.showActionToast("Primo messaggio inviato correttamente!");
                        vm.inviaMessaggioReferralLink(customer);
                    },
                    function(response) {
                        vm.sending = false;
                        vm.showActionToast(response.data.message?response.data.message:response.data.error);
                        $log.info(response);
                    }
            );
        }

        vm.inviaMessaggioReferralLink = function(customer) {
            $log.info('invio secondo msg referral',customer);
            vm.sending = true;
            var store = customer.last_store;
            var message = {
                'customer_id':  customer.id,
                'template':  'referral_link_'+store.alias.toLowerCase()+'_link',
                'phone': customer.phone,
                'message': '',
                'parametersCount': 2
            }
            $log.info('Salva');
            CrudService
                .save( 'customer_messages', message, vm ,
                    function(response) {
                        $log.info(response)
                        vm.showActionToast("Secondo messaggio inviato correttamente!");
                        CrudService.update('customers', {
                            'id': customer.id,
                            'referral_sent_at': moment().format('YYYY-MM-DD HH:mm:ss'),
                            'referral_user_id': vm.user.id
                        }, vm, function(response) {
                            $log.info(response);
                            vm.showActionToast("Dati invio salvati correttamente!");
                            customer.referral_sent_at = moment().format('YYYY-MM-DD HH:mm:ss');
                            customer.referral_sent_at_frmt = moment().format('DD/MM/YYYY HH:mm');
                            customer.referral_sent_at_days = 0;
                            customer.referral_user_id = vm.user.id;
                            vm.sending = false;
                        }, function(response) {
                            vm.sending = false;
                            vm.showActionToast(response.data.message?response.data.message:response.data.error);
                            $log.info(response);
                        });

                    },
                    function(response) {
                        vm.sending = false;
                        vm.showActionToast(response.data.message?response.data.message:response.data.error);
                        $log.info(response);
                    }
            );
        }

        vm.showNoteApp = function (a) {
            //if (a.note==null || a.note.trim()=='') return;
            var p = $mdDialog.confirm()
                    .title("Nota su app. " + a.treatment.name + " del "+ moment(a.date_start).format('DD/MM/YYYY HH:mm')
              ).htmlContent((a.note?a.note:'')
                + (a.anomalie && a.anomalie.length>0?"<h3>Anomalie</h3>"+ vm.htmlAnomalie(a.anomalie):'')
                + (a.note_diagnosi?'<h3>Diagnosi</h3>'+a.note_diagnosi:'')
                + (a.note_terapia?'<h3>Terapia</h3>'+a.note_terapia:'')
                )
                    .ok( 'Ok' );
            return $mdDialog.show( p );
        };
        vm.htmlAnomalie = function(anomalie) {
            var res = "";
            angular.forEach(anomalie, function(el) {
                res+="<br/>"+el.description;
            });
            return res;
        }

        vm.showNoteLead = function (l) {
            if (l.note==null || l.note.trim()=='') return;
            var p = $mdDialog.confirm()
                    .title("Nota su lead " + l.campagna + " del "+ moment(l.created_at).format('DD/MM/YYYY HH:mm')
              ).textContent(l.note)
                    .ok( 'Ok' );
            return $mdDialog.show( p );
        };

        vm.showNoteSucc = function (a) {
            if (a.note==null || a.note.trim()=='') return;
            var p = $mdDialog.confirm()
                    .title("Nota su " + (a.firstname!=null?a.firstname.toUpperCase():'')
                 + ' ' + (a.lastname!=null?a.lastname.toUpperCase():'')
              ).textContent(a.note)
                    .ok( 'Ok' );
            return $mdDialog.show( p );
        };

        /**
         * Visualizza storico cambi di stato
         */
        /**
         * Visualizzo activities su app
         */
        vm.showHistory = function( a ) {
            var dialog = $mdDialog.confirm({
                  title: 'Storico Modifiche: ' + a.campagna + ' di ' + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
                  + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'') + " del "
                  + a.created_at_frm +" (lid="+a.id+")",
                  ariaLabel: 'Storia Modifiche Lead',
                  templateUrl: 'app/leads/dialogs/lead-history.html',
                  escapeToClose: true,
                  controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                      $scope.title = this.title;
                      $scope.button_ok = 'Chiudi';
                      $scope.user = vm.user;
                      $scope.leadevents = [];
                      $scope.activities = [];
                      $scope.loadActivities = function () {
                          var pars = {
                                  'log_name': 'default',
                                  'subject_type':'App\\Entities\\Lead',
                                  'subject_id': a.id,
                                  with: 'causer;subject'
                                };
                          $scope.loadingAct = true;
                          CrudService.all('activity_log', pars, vm,
                                function (response) {
                                  angular.forEach(response.data.data, function(act) {
                                      act.created_at_frmt = moment(act.created_at).format('D/M/YYYY HH:mm:ss');
                                      $scope.activities.push(act);
                                  });
                                  $scope.loadingAct = false;
                                },
                                function (response) {
                                  var errMsg = "";
                                  if (response.data!=null
                                          && response.data.message!=null) {
                                    errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                                    if (url!=null) {
                                      errMsg+= "\nUrl: " + url;
                                    }
                                  }
                                  alert ("Errore nel caricamento delle attivita\': " + errMsg);
                                  $scope.loadingAct = false;
                            });
                      }
                      $scope.loadLeadEvents = function () {
                             var pars = {
                                  'search': 'lead_idt:'+a.uid,
                                  'searchFields': 'lead_idt:=',
                                  'orderBy': 'created_at',
                                  'sortedBy': 'asc',
                               'with': 'user'
                          };
                          $scope.loading = true;
                          CrudService.all('lead_events', pars, vm,
                                function (response) {
                              angular.forEach(response.data.data, function(e) {
                                  if (e.created_at && e.created_at.date) {
                                      e.created_at_frmt = moment(e.created_at.date).format('D/M/YYYY HH:mm:ss');
                                  } else {
                                      e.created_at_frmt = moment(e.created_at).format('D/M/YYYY HH:mm:ss');
                                  }
                                  if (e.call_date && e.call_date.date) {
                                    e.call_date_frmt = moment(e.call_date.date).format('D/M/YYYY HH:mm:ss');
                                    } else {
                                        e.call_date_frmt = moment(e.call_date).format('D/M/YYYY HH:mm:ss');
                                    }
                                  $scope.leadevents.push(e);
                              });
                              $scope.loading = false;
                            },
                            function (response) {
                              var errMsg = "";
                              if (response.data!=null
                                      && response.data.message!=null) {
                                errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                                var url = response.config!=null && response.config.url!=null?response.config.url:"";
                                if (url!=null) {
                                  errMsg+= "\nUrl: " + url;
                                }
                              }
                              alert ("Errore nel caricamento dello storico modifiche: " + errMsg);
                              $scope.loading = false;
                           });
                      }
                      $scope.close = function() {
                          $mdDialog.hide( true );
                      };
                      $scope.loadLeadEvents();
                      $scope.loadActivities();
                  }]
            });

            return $mdDialog
                .show( dialog )
                .finally(
                    function() {
                        dialog = undefined;
                    }
                )
            ;
        };



        vm.toggleSelected = function (e) {
          e.isSelected = !e.isSelected;
        };

        vm.archivia = function (lead) {
          vm.saving = true;
          LeadService.update({id: lead.id, working_user_id: null, archived: true, c_role: vm.user.type, c_sid: vm.user.store_id}).then(
              function (response) {
                vm.checkResponse(response);
                lead.archived = response.data.data.archived;
                lead.archived_by = response.data.data.archived_by;
                vm.removeIfArchived('0', lead);
              },
              vm.checkResponse
          );
        };
        vm.removeIfArchived = function (val, lead) {
        };
        vm.removeFromEList = function (lead) {
        };
        vm.disarchivia = function (lead) {
          vm.saving = true;
          LeadService.update({id: lead.id, archived: false, c_role: vm.user.type, c_sid: vm.user.store_id}).then(
              function (response) {
                vm.checkResponse(response);
                /**
                 * Se sono in archivio tolgo questa entry
                 */
                lead.archived = response.data.data.archived;
                vm.removeIfArchived('1', lead);
              },
              vm.checkResponse
          );
        };



        //prospect si no
        /* Pagato Non-Pagato */
        vm.toggleProspect = function ( lead ) {
            $log.info( 'Prospect ' + (!lead.customer.data.f_prospect));
            CrudService.update(
                    'customers',
                    {id: lead.customer.data.id, f_prospect: !lead.customer.data.f_prospect },
                    vm,
                    function (response) {
                        lead.customer.data.f_prospect = !lead.customer.data.f_prospect;
                    },
                    function (response) {
                    }
            );
        };


        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(lead) {
            vm.toggleRight(lead);
        };
        //vm.undoVisible = false;
        vm.img_loading = false;
        vm.loading = false;
        vm.activeE = {};
        vm.backupE = {};
        vm.toggleRight = function(lead, call_state) {
            vm.backupE = {};
            vm.activeE = lead;
            vm.activeE.moveTo = null;
            angular.copy(vm.activeE, vm.backupE);
            vm.backupE.customer = {};
            angular.copy(vm.activeE.customer, vm.backupE.customer);
            if (call_state) {
                vm.backupE.call_state = call_state;
            }
            vm.eStatus.onChange();
            //$log.info(    vm.activeE);
            $timeout($mdSidenav('right').open, 0);
        };
        vm.closeSidebar = function() {
            return $timeout(vm.resetForm, 0);
        };
        vm.resetForm = function() {
            return $mdSidenav('right').close().then(function() {
                $scope.eForm.$setPristine();
                $scope.eForm.$setUntouched();
                vm.activeE = {};
                vm.backupE = {};
                vm.customerExists = {};
                if ($scope && $scope.eForm && $scope.eForm.phone) {
                    $scope.eForm.phone.$setValidity('alreadyexists', false);
                }
            });
        };
        vm.showActionToast = function( text) {
            text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent(text)
                .action('')
                .highlightAction(true)
                .position('bottom right');
            return $mdToast
                .show(toast)
                .finally(
                    function() {
                        toast = undefined;
                    }
                );
        };
        vm.responseStatusSuccessful = [200, 201, 202];
        vm.checkResponse = function(response) {
            vm.saving = false;
            if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
                var errMsg = "";
                if (response.data!=null && response.data.message!=null) {
                    errMsg = response.data!=null && response.data.message!=null?response.data.message:"";
                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    vm.showActionToast("KO: " + errMsg + " " + url);
                }
                var alert = $mdDialog.alert()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent("C'e\' stato un problema: "+errMsg)
                    .ok('Ok');
                return $mdDialog
                    .show(alert)
                    .finally(
                        function() {
                            alert = undefined;
                        }
                    );
            } else {
                vm.showActionToast();
                return vm.closeSidebar();
            };
        };

        vm.customerModified = function(lead) {//lead === vm.backupE originale vm.activeE
            var fields = ['phone', 'firstname', 'lastname', 'gender', 'province', 'email', 'birthdate'];
            var res = {};
            var modified = false;
            angular.forEach(fields, function(fld) {
                if (lead.customer[fld] != vm.activeE.customer[fld]) {
                    res[fld] = vm.backupE.customer[fld];
                    modified = true;
                }
            });
            if (modified) {
                return res;
            }
            return null;
        }
        vm.update = function(lead, archivia, sendWa) {
            //$log.info('Update');
            //$log.info(lead);
            if (angular.isDefined(lead)) {
              var msg = 'Sicuro di voler aggiornare?';
              if (lead.call_state == 'fuori zona' && lead.moveTo!=null) {
                  msg = 'Sicuro di voler inviare il lead a '+lead.moveTo.label+' ed eliminarlo da qui?';
              } else {
                delete lead.moveTo;
              }
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent(msg)
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {
                            vm.saving = true;
                            vm.search = "";
                            vm.searchTail = null;
                            //angular.copy(customer, vm.update_customer);
                            var call_date = null;
                            $log.info(lead.call_date);
                            if (lead.call_date) {
                              var nd = new Date(lead.call_date);
                              call_date = $filter('date')(nd, 'yyyy-MM-dd HH:mm:ss');
                              lead.indata = nd;
                            } else {
                                lead.indata = null;
                            }
                            var updObj = {};
                            if (lead.moveTo!=null) {
                              updObj = { id: lead.id, move_to: lead.moveTo.tenant, c_role: vm.user.type, c_sid: vm.user.store_id };
                            } else {
                              updObj = { id: lead.id,
                                        working_user_id: null,
                                        call_date: call_date,
                                        recall_delay: lead.recall_delay,
                                        call_state: lead.call_state,
                                        note: lead.note,
                                        c_role: vm.user.type, c_sid: vm.user.store_id
                                    };
                              if (!lead.archived && archivia) {
                                updObj.archived = true;
                                lead.archived = true;
                                updObj.archived_by = vm.user.id;
                                lead.archived_by = vm.user.id;
                              }
                            }

                            // Aggiungo all'oggetto la reason
                            updObj.reason = null;
                            if(lead.reason != undefined) {
                                updObj.reason = lead.reason;
                            }

                            //carica i campi customer modificati
                            updObj.customer = vm.customerModified(lead);
                            LeadService.update(updObj).then(
                              function (response) {
                                  vm.checkResponse(response);
                                  if ((lead.category == 'confermacomm' || lead.category == 'confermaop') && lead.appointment_id) {
                                    if (lead.call_state == 'disdetto' && lead.appointment.recalled<3) {

                                        AppointmentsService.update( {
                                                id: lead.appointment_id,
                                                recalled: 3,
                                                paid: 0,
                                                call_date: call_date.substring(0, 16),
                                                reason: updObj.reason
                                            } ).then (
                                            function () {
                                                lead.appointment.recalled = 3;
                                                vm.showActionToast("Appuntamento disdetto.");
                                                vm.nextLead();
                                            },
                                            vm.checkResponse
                                        ) ;
                                    } else if (lead.call_state == 'confermato' && lead.appointment.recalled<4
                                        && lead.appointment.recalled!=1) {
                                            AppointmentsService.update( {id: lead.appointment_id,recalled: 1} ).then (
                                                function () {
                                                    lead.appointment.recalled = 1;
                                                    vm.showActionToast("Appuntamento confermato.");
                                                    vm.nextLead();
                                                },
                                                vm.checkResponse
                                             );
                                    } else if (
                                        (lead.call_state.indexOf('NR')>=0
                                        || lead.call_state == 'da richiamare' )
                                        && lead.appointment.recalled<4
                                        && lead.appointment.recalled!=2) {
                                           AppointmentsService.update( {id: lead.appointment_id,recalled: 2} ).then (
                                                function () {
                                                    lead.appointment.recalled = 2;
                                                    vm.showActionToast("Appuntamento aggiornato.");
                                                    vm.nextLead();
                                                },
                                                vm.checkResponse
                                        );
                                    } else {
                                        vm.nextLead();
                                    }
                                  } else {
                                    vm.nextLead();
                                  }
                              },
                              vm.checkResponse
                            );
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
           }
        };

        /* WATCHO Lo Store */
        vm.storesList = null;
        vm.storeId = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            if (vm.storesList==null) {//primo caricamento
                vm.storesList = $scope.$parent.main.storesList;
                vm.tenantsLoad();
                vm.eListLoad();
                if (vm.user.type!='storemngr' && vm.user.type!='operator') {
                  //vm.operatorLoad();
                }
              }
              vm.storeId = id;
        });

        vm.tenantsList = [];
        vm.tenantsLoad = function() {
          vm.tenantsList = [];
          $http.get(env.API+'/tenants?orderBy=tenant').then(function(response) {
              if (response.data && response.data.data) {
                  vm.tenantsList = [];
                  angular.forEach(response.data.data, function (elem) {
                  if (elem.tenant!=vm.user.tenant) {
                      if (!elem.label) {
                          elem.label = elem.tenant;
                      }
                    vm.tenantsList.push(elem);
                  }
                });
              }
          });
      };

      vm.categories = [];
      vm.categoriesLoad = function() {
        vm.categories = [];
        $http.get(env.API+'/leads_campaign_categories').then(function(response) {
            if (response.data && response.data.data) {
                vm.categories = response.data.data;
            }
        });
      };
      //vm.categoriesLoad();

      /* Operators devo caricare i ruoli */
      vm.operatorsCallList = [];
      vm.operatorsCall2List = [];
      vm.operatorLoad = function() {
            vm.operatorsCallList = [];
            vm.operatorsCall2List = [];
            UsersService.allRoles({search: "role:callcenter", searchFields: "role:=", 'with': 'user'}).
                  then(function(response) {
                        if (response.data && response.data.data) {
                            if (vm.user.type!='callcenter') {
                                vm.operatorsCallList = $filter('filter')(response.data.data, {active: true}, true);
                            } else {
                                if (vm.user.delegate1_user_id) {
                                    vm.operatorsCallList = vm.operatorsCallList.concat($filter('filter')(response.data.data, {user_id: vm.user.delegate1_user_id}, true));
                                }
                                if (vm.user.delegate2_user_id) {
                                    vm.operatorsCallList = vm.operatorsCallList.concat($filter('filter')(response.data.data, {user_id: vm.user.delegate2_user_id}, true));
                                }
                            }
                            UsersService.allRoles({search: "active:1;role:storemngr", searchFields: "active:=;role:=", 'with': 'user;availabilityDay;store'}).
                            then(function(response) {
                                    if (response.data && response.data.data) {
                                        var ora = moment().format('YYYY-MM-DD HH:mm');
                                        angular.forEach(response.data.data, function(s) {
                                            angular.forEach(vm.operatorsCallList, function(c) {
                                                if (s.user_id == c.user_id) {
                                                    angular.forEach(s.availability_day, function(a) {
                                                        if (a.store_id == s.store_id && a.date_start<=ora && a.date_end>=ora) {
                                                            s.online = true;
                                                        }
                                                    });
                                                    vm.operatorsCall2List.push(s); //per essere qui deve avere il doppio ruolo
                                                }
                                            });
                                        });
                                    };
                        });
                        };
            });

      };
    };

    LeadController
        .$inject = [
            '$window',
            '$scope',
            '$log',
            '$timeout',
            '$http',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'LeadService',
            'env',
            'CallState',
            'lead_id',
            'phone',
            'CrudService',
            'Italia',
            'UsersService',
            'AppointmentsService',
            'CustomerService',
            '$pusher',
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')

        .factory('LandingService', function(Restangular) {

            var service = Restangular.all('landings');

            service.all = function(options){
                return service.getList(options);
            };

            service.save = function(data){
                return service.post(data);
            };

            return service;
        })

        .factory('TreatmentService', function(Restangular) {

            var service = {};

            service.categories = function(){
                return Restangular.all('treatments-categories').getList({with: 'treatments'});
            };

            service.treatments = function(){
                return Restangular.all('treatments').getList();
            };

            return service;
        })

        .factory('StoreService', function(Restangular) {

            var service = {};
            service.all = function(options){
                return Restangular.all('stores').getList(options);
            };

            return service;
        });

})();

(function() {
    'use strict';
    angular
        .module('admin')
        // Da Centro --> Id a Centro --> Name
        .filter( 'storeIdtoName', function() {
            return function ( selected, array ) {
                if ( angular.isDefined( array ) && angular.isDefined( selected ) && array.length > 0) {
                    var value = "";
                    angular.forEach( array, function ( elem ) {
                        if ( angular.equals( elem.id, selected ) ) {
                            value = elem.label;
                        };
                    });
                    return value;
                };
                return selected;
            };
        })
        .filter( 'treatmentIdtoName', function() {
            return function ( selected, array ) {
                if ( angular.isDefined( array ) && angular.isDefined( selected ) && array.length > 0 ) {
                    var value = "";
                    angular.forEach( array, function ( elemArray ) {
                        angular.forEach( elemArray.treatments.data, function ( elem ) {
                            if ( angular.equals( elem.id, selected ) ) {
                                value = elem.name;
                            };
                        });
                    });
                    return value;
                };
                return selected;
            };
        })
        .filter( 'treatment', function() {
            return function ( selected, array ) {
                if ( angular.isDefined( array ) && angular.isDefined( selected ) && array.length > 0 ) {
                    var value = "";
                    angular.forEach( array, function ( elemArray ) {
                        angular.forEach( elemArray.treatments.data, function ( elem ) {
                            if ( angular.equals( elem.id, selected ) ) {
                                value = elem;
                            };
                        });
                    });
                    return value;
                };
                return selected;
            };
        });
    ;
})();
(function () {
	'use strict';

	angular
		.module('admin')
		.controller('LandingsController', LandingsController);

	/** @ngInject */
	function LandingsController($scope,$log,$timeout,$mdSidenav,$mdDialog,LandingService,TreatmentService,StoreService, UsersService) {
		var vm = this;
		/* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
        	return;
        }
		$log.info( 'LandingsController' );
		//---------- Landings Table -------------------------------------//
		vm.selected = [];
		vm.options = {
			autoSelect: false,
			boundaryLinks: true,
			pageSelector: true,
			rowSelection: false,
		};
        vm.filter = {
            options: {
            	'debounce': 0,
            	'updateOn': 'default'
            }
        };
        vm.query = {
			filter: '',
			order: 'alias',
			limit: 10,
			page: 1,
		};
        vm.landings = [];
        LandingService.all({with:'stores'}).then(function(data){
            vm.landings = data;
        });

        vm.removeSearch = function () {
            vm.query.filter = '';
        };

		//---------- Treatments -------------------------------------//
		vm.treatmentsTitle = 'Scegli il servizio';
        TreatmentService.categories().then(function(data){
            vm.treatmentsList = data;
        });
		/*vm.treatmentsList = [
			{
				title: 'Epilazione',
				active: true,
				treatments: [
					{
						id: 1,
						name: 'Epilazione Servizio 1',
						gender: 'm',
						image: '/assets/images/treatments/image2.jpg',
						description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. '
					},
				],
			},
			{
				title: 'Viso',
				active: false,
				treatments: [
					{
						id: 4,
						name: 'Viso Servizio 4',
						gender: 'f',
						image: '/assets/images/treatments/image2.jpg',
						description: 'prova4'
					},
				],
			},
		];*/
		//---------- Stores -------------------------------------//
		vm.storesTitle = 'Scegli il centro estetico';
		vm.storesList = [];
		$scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
            	if (vm.storeId == null) {
            		vm.storesList = $scope.$parent.main.storesList;
            	}
            	vm.storeId = id;
            };
        });
		
		//---------- Sidebar -------------------------------------//
        vm.rowClicked = function ( landing ) {
            vm.toggleRight( landing );
		};
        vm.testsVisible = false;
        vm.undoVisible = false;
        vm.img_loading = false;
        vm.itsNew = false;
        vm.activeLanding = {};
        vm.backup_landing = {};
        vm.empty_landing = {};
		vm.toggleRight = function ( landing ) {
            vm.itsNew = angular.isUndefined( landing );
            if( angular.isDefined( landing ) ) {
                vm.activeLanding = landing;
                vm.activeLanding.store_id = _.map(landing.stores.data, function(v){return v.id;});

            } else {
                vm.empty_landing = {
                    alias: '',
                    title: '',
                    treatment_id: 0,
                    store_id: [],
                    image: null,
                    code: '',
                    price: null,
                };
                vm.activeLanding = vm.empty_landing;
            };
            angular.copy( vm.activeLanding, vm.backup_landing );
            $timeout( function() {
                return $mdSidenav( 'right' ).open();
            }, 0 );
		};
        vm.resetAll = function () {
            vm.undoVisible = false;
            $timeout( vm.resetForm, 0 );
        };
		vm.closeSidebar = function () {
            if( vm.undoVisible ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .textContent( 'Ci sono delle modifiche non commissionate, proseguire?' )
                    .ariaLabel( 'Attenzione' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then( vm.undo )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            } else {
                vm.resetAll();
            };
		};
        vm.resetForm = function() {
            return $mdSidenav( 'right' ).close().then(function() {
                vm.resetImgDirective();
                $scope.landingForm.$setPristine();
                $scope.landingForm.$setUntouched();
            });
        };
        vm.resetImgDirective = function() {
            if( angular.isDefined( $scope.img ) ) {
                $scope.img.fileName = null;
                $scope.img.fileObj = null;
            };
        };
		vm.delImg = function () {
            $log.info( 'delImg' );
            vm.resetImgDirective();
            vm.activeLanding.image = null;
        };
        vm.delForced = function ( landing ) {
            $log.info( 'Del Forced' );
            if( angular.isDefined( landing ) ) {
                var index = vm.landings.indexOf( landing );
                vm.landings.splice( index, 1 );
            };
        };
		vm.del = function ( landing ) {
            $log.info( 'Del' );
            if( angular.isDefined( landing ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .textContent( 'Sicuro di voler Cancellare questo elemento?' )
                    .ariaLabel( 'Attenzione' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            landing.remove().then(function(){
                                vm.delForced( landing );
                                vm.resetAll();
                            });
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };
        vm.save = function ( landing ) {
            $log.info( 'Save' );
            if( angular.isDefined( landing ) ) {
                if( ! angular.equals( landing, vm.backup_landing ) ) {
                    var confirm = $mdDialog.confirm()
                        .title( 'Attenzione' )
                        .textContent( 'Sicuro di voler Salvare?' )
                        .ariaLabel( 'Attenzione' )
                        .ok( 'Si' )
                        .cancel( 'Ops, ho sbagliato' )
                    ;
                    return $mdDialog
                        .show( confirm )
                        .then(
                            function() {
                                landing.put().then(function(data){
                                    vm.delForced( landing );
                                    landing = data;
                                    vm.landings.push( landing );
                                    vm.resetAll();
                                }, function errorCallback(data) {
                                    alert(data);
                                });
                            }
                        )
                        .finally(
                            function() {
                                confirm = undefined;
                            }
                        )
                    ;
                };
            };
        };
        vm.undo = function () {
            $log.info( 'Undo' );
            if( ! angular.equals( vm.activeLanding, vm.backup_landing ) ) {
                angular.copy( vm.backup_landing, vm.activeLanding );
            };
            vm.resetAll();
        };
		vm.add = function ( landing ) {
			$log.info( 'Add' );
            LandingService.save(landing).then(function(data){
                vm.landings.push( data );
                vm.closeSidebar();
            }, function errorCallback(data) {
                alert(data);
            });
            /*if( angular.isDefined( landing ) ) {
                landing.id = ++i;
                vm.landings.push( landing );
                vm.closeSidebar();
            };*/
        };
        vm.tests = function () {
            $log.info( 'Tests' );
        };
        $scope.$watch( 'landings.activeLanding', function ( newValue ) {
            vm.undoVisible = ( angular.equals( newValue, vm.backup_landing ) || vm.itsNew ) ? false : true;
        }, true );
        $scope.$watch( 'img.fileName', function ( newValue ) {
            if( newValue ) {
                if( $scope.img.fileObj ) {
                    vm.img_loading = true;
                    var reader = new FileReader();

                    reader.onload = function () {
                        vm.activeLanding.image = reader.result;
                        vm.img_loading = false;
                        return;
                    };
                    reader.onerror = function () {
                        alert("C'è stato un errore durante il caricamento dell'immagine.");
                        return;
                    };
                    reader.readAsDataURL( $scope.img.fileObj[0]  );
                };
            };
        });
	};

})();
(function() {
    'use strict';
    
    angular
        .module( 'admin' )
        .service(
            'StatisticService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    all : function(options) {
                        var apiURI = env.API + '/statistics';
                        if( angular.isUndefined( options ) ) {
                            options = {};
                        };
                        return $http.get( apiURI, { params: options } );
                    },
                };
            }
        );

})();
(function () {
    'use strict';

    angular
        .module('admin')
        .controller('KpiController', KpiController);

    /** @ngInject */
    function KpiController(
        $scope,
        env,
        $log,
        $http,
        $mdDialog,
        $mdToast,
        $q,
        $timeout,
        StatisticService,
        UsersService,
        CrudService
    ) {
        $log.info('KpiController');
        var vm = this;
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.isCallCenter = false;

        vm.date = { startDate: moment().subtract(7, 'days'), endDate: moment() };
        vm.selectedDate  = moment();
        vm.currentMonthSelected = true;
        vm.futureMonthSelected = false;
        vm.pastMonthSelected = false;

        vm.selectedMonth = vm.selectedDate.format('MMMM');
        vm.selectedYear = vm.selectedDate.format('YYYY');
        // vm.today = moment();
        vm.yesterday = moment().add(-1, 'days');
        vm.nextMonth = moment().add(1, 'months');
        vm.query = {
            filter: '',
        };

        vm.isFinoAIeriVisible = true;
        vm.isRestoDelMeseVisible = true;

        vm.annoPrecedente = 0;

        vm.stagionalitaList = [7.80, 8.40, 9.30, 8.90, 9.90, 8.90, 7.60, 6.00, 9.10, 9.00, 8.00, 7.10];

        $scope.$watch('dashboard.query.filter', function () {
            if (!vm.loading) {
                vm.calcsOnVisibileElements();
            }
        });

        vm.years = [];
        for (var i = 2016; i - 1 <= parseInt(vm.selectedDate.format('YYYY')); i++) {
            vm.years.push('' + i);
        }
        vm.months =['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre']

        vm.exportAppointmentsUrl = env.API + '/appointments?with=byOperator&token=' + vm.token + '&export=true&start=' +
            vm.date.startDate.format('YYYY-MM-DD') +
            '&end=' + vm.date.endDate.format('YYYY-MM-DD');;
        vm.exportCustomersUrl = env.API + '/customers?with=referral&token=' + vm.token + '&export=true';


        vm.options = {
            buttonClasses: 'md-button md-raised',
            applyClass: 'md-accent',
            cancelClass: 'md-warn',
            format: 'DD/MM/YYYY',
            customRangeLabel: "asd",
            opens: "right",
            locale: {
                format: 'DD/MM/YYYY',
                separator: " - ",
                applyLabel: "Conferma",
                cancelLabel: "Annulla",
                fromLabel: "Dal",
                toLabel: "Al",
                customRangeLabel: "Scegli un range",
            },
            parentEl: ".page-dashboard",
            ranges: {
                'Oggi': [moment(), moment()],
                'Ieri': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Ultima sett.': [moment().subtract(7, 'days'), moment()],
                'Ultime 2 sett.': [moment().subtract(7, 'days'), moment().add(7, 'days')],
                'Ultimi 30 giorni': [moment().subtract(30, 'days'), moment()],
                'Questo mese': [moment().startOf('month'), moment().endOf('month')]
            }
        };
        $scope.$watch('dashboard.date', function (newDate) {
            if (vm.storeId == null) return;
            //$log.info( 'New date set: ', newDate );
            vm.reload(true);
        }, false);

        vm.calcsOnVisibileElements = function () {
            $timeout(function () {
                vm.eListTotal = 0;
                vm.filteredItems.forEach(function (item) {
                    vm.eListTotal += item.total;
                });
            });
        };

        vm.selectedIndex = 0;
        vm.statistics = {};
        vm.loading = true;
        vm.statsStoreId = null;
        vm.reload = function (force) {
            if (vm.statsStoreId == vm.storeId && !force) return;
            vm.statistics = {};
            vm.loading = true;
            vm.exportAppointmentsUrl = env.API + '/appointments?token=' + vm.token + '&export=true&start=' +
                vm.date.startDate.format('YYYY-MM-DD') +
                '&end=' + vm.date.endDate.format('YYYY-MM-DD');
            var date = {
                date_start: vm.date.startDate.format(),
                date_end: vm.date.endDate.format()
            };
            if (vm.storeId != 0) {
                date.store_id = vm.storeId;
            }
            $log.info(date);
            vm.statsStoreId = vm.storeId;
            StatisticService.all(date).then(function (data) {
                vm.statistics = data.data;
                /**
                 * Valori calcolati
                 */
                vm.statistics.general.data.app_count_sm = vm.statistics.general.data.app_count - vm.statistics.general.data.app_count_1av;
                vm.statistics.general.data.perc_1av = vm.statistics.general.data.app_count_1av / vm.statistics.general.data.app_count;
                vm.statistics.general.data.perc_sm = vm.statistics.general.data.app_count_sm / vm.statistics.general.data.app_count;
                vm.statistics.general.data.app_count_paid_sm = vm.statistics.general.data.app_count_paid - vm.statistics.general.data.app_count_paid_1av;
                vm.statistics.general.data.paid_perc = vm.statistics.general.data.app_count_paid / vm.statistics.general.data.app_count;
                vm.statistics.general.data.paid_perc_1av = vm.statistics.general.data.app_count_paid_1av / vm.statistics.general.data.app_count_1av;
                vm.statistics.general.data.paid_perc_sm = vm.statistics.general.data.app_count_paid_sm / vm.statistics.general.data.app_count_sm;
                vm.statistics.general.data.app_total_sm = vm.statistics.general.data.app_total - vm.statistics.general.data.app_total_1av;
                vm.statistics.general.data.perc_total_1av = vm.statistics.general.data.app_total_1av / vm.statistics.general.data.app_total;
                vm.statistics.general.data.perc_total_sm = vm.statistics.general.data.app_total_sm / vm.statistics.general.data.app_total;
                vm.statistics.general.data.media_scontrino_sm = vm.statistics.general.data.app_total_sm / vm.statistics.general.data.app_count_paid_sm;
                vm.buildLaser(vm.statistics.general);


                chart1(vm.statistics.operators);
                chart2(vm.statistics.operators);
                chart3_perc(vm.statistics.operators);
                chart4(vm.statistics.treatments);
                chart5_perc(vm.statistics.operators);
                vm.loading = false;
                $timeout(function () { window.dispatchEvent(new Event('resize')); });
            });
        };

        vm.referenceStats = [];
        vm.referenceStatsOpts = {};
        vm.referenceStoreId = null;
        vm.currentMonthPastStats = [];
        vm.currentMonthFutureStats = [];
        vm.nextMonthStats = [];
        vm.currentMonthPastStatsOpts = {};
        vm.currentMonthFutureStatsOpts = {};
        vm.nextMonthStatsOpts = {};
        vm.refMonths = 2;
        vm.coeffCrescita = 1;

        //INIZIO MODIFIA MARCO
        vm.currentMonthFutureStats.simulate = {};
        vm.currentMonthFutureStats.simulate.obiettivo = 0;
        vm.currentMonthFutureStats.simulate.perc_categoria_1v = 0;
        vm.currentMonthFutureStats.simulate.perc_categoria_sm = 0;
        vm.currentMonthFutureStats.simulate.sm_backup_1v = 0;
        vm.currentMonthFutureStats.simulate.sm_backup_sm = 0;
        vm.currentMonthFutureStats.simulate.perc_presentazione_1v = 0;
        vm.currentMonthFutureStats.simulate.perc_presentazione_sm = 0;
        vm.currentMonthFutureStats.simulate.disabilita_form = true;
        //FINE MDIFICA MARCO

        vm.loadReferenceStats = function () {
            // if (vm.referenceStoreId == vm.storeId) return;
            vm.loading = true;
            vm.referenceStats = [];
            vm.currentMonthPastStats = [];
            vm.currentMonthFutureStats = [];
            vm.nextMonthStats = [];
            vm.referenceStoreId = vm.storeId;

            //INIZIO MODIFIA MARCO
            vm.currentMonthFutureStats.simulate = {};
            vm.currentMonthFutureStats.simulate.obiettivo = 0;
            vm.currentMonthFutureStats.simulate.perc_categoria_1v = 0;
            vm.currentMonthFutureStats.simulate.perc_categoria_sm = 0;
            vm.currentMonthFutureStats.simulate.sm_backup_1v = 0;
            vm.currentMonthFutureStats.simulate.sm_backup_sm = 0;
            vm.currentMonthFutureStats.simulate.perc_presentazione_1v = 0;
            vm.currentMonthFutureStats.simulate.perc_presentazione_sm = 0;
            vm.currentMonthFutureStats.simulate.disabilita_form = true;
            //FINE MDIFICA MARCO

            if (vm.annoPrecedente) {
                vm.referenceStatsOpts = {
                    date_start: vm.selectedDate.clone().add(0 - 12, 'months').startOf('month').format('YYYY-MM-DD'),
                    date_end: vm.selectedDate.clone().add(0 - 11, 'months').startOf('month').format('YYYY-MM-DD'),
                };
            } else {
                vm.referenceStatsOpts = {
                    date_start: vm.selectedDate.clone().add(0 - vm.refMonths, 'months').startOf('month').format('YYYY-MM-DD'),
                    date_end: vm.selectedDate.clone().startOf('month').format('YYYY-MM-DD')
                };
            }

            if (vm.storeId != 0) {
                vm.referenceStatsOpts.store_id = vm.storeId;
            }
            vm.referenceStatsOpts.costo_pers = true;
            vm.referenceStatsOpts.only_general = true;

            StatisticService.all(vm.referenceStatsOpts).then(function (data) {
                vm.referenceStats = data.data.general;
                vm.referenceStatsOpts.startDate = moment().add(0 - vm.refMonths, 'months').startOf('month');
                vm.referenceStatsOpts.endDate = moment().add(-1, 'months').endOf('month');
                vm.referenceStatsOpts.date_start_frmt = vm.referenceStatsOpts.startDate.format('DD/MM/YYYY');
                vm.referenceStatsOpts.date_end_frmt = vm.referenceStatsOpts.endDate.format('DD/MM/YYYY');

                $log.info("carico reference: ");
                //$log.info(vm.referenceStatsOpts);
                //$log.info(data.data.general);

                vm.buildLaser(vm.referenceStats);

                vm.loadCurrentMonthPastStats();
                //vm.loadNextMonthStats();
            });
        };
        vm.relateReferenceStatToDays = function (days) {
            /**
             * calcolo coefficienti vari
             */
            vm.refDays = days;
            vm.conversionCoeff = days / parseInt(vm.referenceStats.work_days);
            vm.referenceStats.data.app_count = Math.round(parseInt(vm.referenceStats.data.app_count) * vm.conversionCoeff);
            vm.referenceStats.data.app_count_1av = Math.round(parseInt(vm.referenceStats.data.app_count_1av) * vm.conversionCoeff);
            vm.referenceStats.data.app_count_spostati = Math.round(parseInt(vm.referenceStats.data.app_count_spostati) * vm.conversionCoeff);
            vm.referenceStats.data.app_count_spostati_perc = vm.referenceStats.data.app_count_spostati / (vm.referenceStats.data.app_count_spostati + vm.referenceStats.data.app_count);
            vm.referenceStats.data.perc_1av = vm.referenceStats.data.app_count_1av / vm.referenceStats.data.app_count;
            vm.referenceStats.data.app_total = Math.round(parseFloat(vm.referenceStats.data.app_total) * vm.coeffCrescita * vm.conversionCoeff);
            vm.referenceStats.data.app_total_1av = Math.round(parseFloat(vm.referenceStats.data.app_total_1av) * vm.coeffCrescita * vm.conversionCoeff);
            vm.referenceStats.data.app_total_sm = vm.referenceStats.data.app_total - vm.referenceStats.data.app_total_1av;
            vm.referenceStats.data.perc_total_1av = vm.referenceStats.data.app_total_1av / vm.referenceStats.data.app_total;
            vm.referenceStats.data.perc_total_sm = vm.referenceStats.data.app_total_sm / vm.referenceStats.data.app_total;
            vm.referenceStats.data.media_scontrino = parseFloat(vm.referenceStats.data.media_scontrino) * vm.coeffCrescita;
            vm.referenceStats.data.media_scontrino_1av = parseFloat(vm.referenceStats.data.media_scontrino_1av) * vm.coeffCrescita;
            vm.referenceStats.data.app_count_sm = vm.referenceStats.data.app_count - vm.referenceStats.data.app_count_1av;
            vm.referenceStats.data.perc_sm = vm.referenceStats.data.app_count_sm / vm.referenceStats.data.app_count;
            vm.referenceStats.data.app_count_paid = Math.round(parseInt(vm.referenceStats.data.app_count_paid) * vm.conversionCoeff);
            vm.referenceStats.data.app_count_paid_1av = Math.round(parseInt(vm.referenceStats.data.app_count_paid_1av) * vm.conversionCoeff);
            vm.referenceStats.data.app_count_paid_sm = vm.referenceStats.data.app_count_paid - vm.referenceStats.data.app_count_paid_1av;
            vm.referenceStats.data.paid_perc = vm.referenceStats.data.app_count_paid / vm.referenceStats.data.app_count;
            vm.referenceStats.data.paid_perc_1av = vm.referenceStats.data.app_count_paid_1av / vm.referenceStats.data.app_count_1av;
            vm.referenceStats.data.paid_perc_sm = vm.referenceStats.data.app_count_paid_sm / vm.referenceStats.data.app_count_sm;
            vm.referenceStats.data.media_scontrino_sm = (vm.referenceStats.data.app_total - vm.referenceStats.data.app_total_1av) / vm.referenceStats.data.app_count_paid_sm;
            vm.referenceStats.availab_minutes = parseInt(vm.referenceStats.availab_minutes) * vm.conversionCoeff;
            vm.referenceStats.worked_minutes = parseInt(vm.referenceStats.worked_minutes) * vm.conversionCoeff;
            vm.referenceStats.redd_h = vm.referenceStats.data.app_total * 60 / vm.referenceStats.availab_minutes;
            vm.referenceStats.redd_h_w = vm.referenceStats.data.app_total * 60 / vm.referenceStats.worked_minutes;

            vm.referenceStats.lead_count_1av = parseInt(vm.referenceStats.lead_count_1av) / vm.refMonths;
            vm.referenceStats.lead_count_1av_chiusi = parseInt(vm.referenceStats.lead_count_1av_chiusi) / vm.refMonths;
            vm.referenceStats.redemption_lead_1av = parseFloat(vm.referenceStats.redemption_lead_1av);
            vm.referenceStats.costo_pers = parseInt(vm.referenceStats.costo_pers) * vm.conversionCoeff;
            vm.referenceStats.costo_pers_perc = vm.referenceStats.costo_pers / vm.referenceStats.data.app_total;

        };
        vm.buildLaser = function (s) {
            if (vm.storeId) {
                s.laser_au.min_down = parseInt(s.laser_au.min_down);
                s.laser_au.min_laser_used = parseInt(s.laser_au.min_laser_used);
                s.laser_au.min_over = parseInt(s.laser_au.min_over);
                s.laser_au.min_tot = parseInt(s.laser_au.min_tot);
                s.laser_au.max_min_laser = s.laser_au.min_tot - s.laser_au.min_over;
                s.laser_au.num_laser = parseFloat(s.laser_au.num_laser);
                s.laser_au.num_rooms = parseFloat(s.laser_au.num_rooms);
                s.laser_au.min_laser_used_perc = s.laser_au.min_laser_used / s.laser_au.max_min_laser;
                s.laser_au.min_over_perc = s.laser_au.min_over / s.laser_au.min_tot;
                s.laser_au.min_down_perc = s.laser_au.min_down / s.laser_au.min_tot;
            }
        };
        vm.loadCurrentMonthPastStats = function () {
            vm.currentMonthPastStats = [];


            if (vm.pastMonthSelected) {
                vm.currentMonthPastStatsOpts = {
                    date_start: vm.selectedDate.format('YYYY-MM-01'),
                    date_end: vm.selectedDate.clone().add(1,'month').startOf('month').format('YYYY-MM-DD')
                };
            } else {
                vm.currentMonthPastStatsOpts = {
                    date_start: vm.selectedDate.format('YYYY-MM-01'),
                    date_end: vm.selectedDate.format('YYYY-MM-DD')
                };
            }
            if (vm.storeId != 0) {
                vm.currentMonthPastStatsOpts.store_id = vm.storeId;
            }
            vm.currentMonthPastStatsOpts.only_general = true;
            StatisticService.all(vm.currentMonthPastStatsOpts).then(function (data) {
                vm.currentMonthPastStats = data.data.general;
                $log.info("carico CurrentMonthPastStats: ");
                vm.currentMonthPastStatsOpts.startDate = moment().startOf('month');
                vm.currentMonthPastStatsOpts.endDate = vm.referenceStatsOpts.endDate;
                vm.currentMonthPastStatsOpts.date_start_frmt = vm.currentMonthPastStatsOpts.startDate.format('01');
                vm.currentMonthPastStatsOpts.date_end_frmt = vm.currentMonthPastStatsOpts.endDate.format('DD/MM');
                vm.currentMonthPastStatsOpts.date_end_frmt1 = vm.currentMonthPastStatsOpts.endDate.format('DD');
                //$log.info(vm.currentMonthPastStatsOpts);
                //$log.info(data.data.general);

                vm.currentMonthPastStats.data.app_count = parseInt(vm.currentMonthPastStats.data.app_count);
                vm.currentMonthPastStats.data.app_count_1av = parseInt(vm.currentMonthPastStats.data.app_count_1av);
                vm.currentMonthPastStats.data.app_count_spostati = parseInt(vm.currentMonthPastStats.data.app_count_spostati);
                vm.currentMonthPastStats.data.app_count_spostati_perc = vm.currentMonthPastStats.data.app_count_spostati / (vm.currentMonthPastStats.data.app_count_spostati + vm.currentMonthPastStats.data.app_count);
                vm.currentMonthPastStats.data.app_count_paid = parseInt(vm.currentMonthPastStats.data.app_count_paid);
                vm.currentMonthPastStats.data.app_count_paid_1av = parseInt(vm.currentMonthPastStats.data.app_count_paid_1av);
                vm.currentMonthPastStats.data.app_total = parseInt(vm.currentMonthPastStats.data.app_total);
                vm.currentMonthPastStats.data.app_total_1av = parseInt(vm.currentMonthPastStats.data.app_total_1av);
                vm.currentMonthPastStats.availab_minutes = parseInt(vm.currentMonthPastStats.availab_minutes);
                vm.currentMonthPastStats.redd_h = vm.currentMonthPastStats.data.app_total * 60 / vm.currentMonthPastStats.availab_minutes;


                /**
                 * Valori calcolati
                 */
                vm.currentMonthPastStats.data.app_count_sm = vm.currentMonthPastStats.data.app_count - vm.currentMonthPastStats.data.app_count_1av;
                vm.currentMonthPastStats.data.perc_1av = vm.currentMonthPastStats.data.app_count_1av / vm.currentMonthPastStats.data.app_count;
                vm.currentMonthPastStats.data.perc_sm = vm.currentMonthPastStats.data.app_count_sm / vm.currentMonthPastStats.data.app_count;
                vm.currentMonthPastStats.data.app_count_paid_sm = vm.currentMonthPastStats.data.app_count_paid - vm.currentMonthPastStats.data.app_count_paid_1av;
                vm.currentMonthPastStats.data.paid_perc = vm.currentMonthPastStats.data.app_count_paid / vm.currentMonthPastStats.data.app_count;
                vm.currentMonthPastStats.data.paid_perc_1av = vm.currentMonthPastStats.data.app_count_paid_1av / vm.currentMonthPastStats.data.app_count_1av;
                vm.currentMonthPastStats.data.paid_perc_sm = vm.currentMonthPastStats.data.app_count_paid_sm / vm.currentMonthPastStats.data.app_count_sm;
                vm.currentMonthPastStats.data.app_total_sm = vm.currentMonthPastStats.data.app_total - vm.currentMonthPastStats.data.app_total_1av;
                vm.currentMonthPastStats.data.perc_total_1av = vm.currentMonthPastStats.data.app_total_1av / vm.currentMonthPastStats.data.app_total;
                vm.currentMonthPastStats.data.perc_total_sm = vm.currentMonthPastStats.data.app_total_sm / vm.currentMonthPastStats.data.app_total;
                vm.currentMonthPastStats.data.media_scontrino_sm = vm.currentMonthPastStats.data.app_total_sm / vm.currentMonthPastStats.data.app_count_paid_sm;

                /*
                 * leads
                 */
                vm.currentMonthPastStats.lead_count_1av = parseInt(vm.currentMonthPastStats.lead_count_1av);
                vm.currentMonthPastStats.lead_count_1av_chiusi = parseInt(vm.currentMonthPastStats.lead_count_1av_chiusi);
                vm.currentMonthPastStats.redemption_lead_1av = parseFloat(vm.currentMonthPastStats.redemption_lead_1av);


                /*
                 * INIZIO MOFICIA MARCO
                 * KPI TAB 2
                 */
                vm.calcolaObiettivoKpi2(true, false);
                /*
                 * FINE MOFICIA MARCO
                 * KPI TAB 2
                 */


                vm.buildLaser(vm.currentMonthPastStats);

                vm.loadCurrentMonthFutureStats();

            });
        };
        vm.loadCurrentMonthFutureStats = function () {
            vm.currentMonthFutureStats = [];

            //INIZIO MODIFIA MARCO
            vm.currentMonthFutureStats.simulate = {};
            vm.currentMonthFutureStats.simulate.obiettivo = 0;
            vm.currentMonthFutureStats.simulate.perc_categoria_1v = 0;
            vm.currentMonthFutureStats.simulate.perc_categoria_sm = 0;
            vm.currentMonthFutureStats.simulate.sm_backup_1v = 0;
            vm.currentMonthFutureStats.simulate.sm_backup_sm = 0;
            vm.currentMonthFutureStats.simulate.perc_presentazione_1v = 0;
            vm.currentMonthFutureStats.simulate.perc_presentazione_sm = 0;
            vm.currentMonthFutureStats.simulate.disabilita_form = true;
            //FINE MDIFICA MARCO

            if (vm.pastMonthSelected) {
                vm.currentMonthFutureStatsOpts = {
                    date_start: vm.selectedDate.clone().add(1,'month').startOf('month').format('YYYY-MM-DD'),
                    date_end: vm.selectedDate.clone().add(1,'month').startOf('month').format('YYYY-MM-DD')
                };
            } else {
                vm.currentMonthFutureStatsOpts = {
                    date_start: vm.selectedDate.format('YYYY-MM-DD'),
                    date_end: vm.nextMonth.format('YYYY-MM-01')
                };
            }
            // $log.info('vm.currentMonthFutureStatsOpts', vm.currentMonthFutureStatsOpts);
            if (vm.storeId != 0) {
                vm.currentMonthFutureStatsOpts.store_id = vm.storeId;
            }
            vm.currentMonthFutureStatsOpts.only_general = true;
            vm.currentMonthFutureStatsOpts.costo_pers = true;
            vm.currentMonthFutureStatsOpts.target = true;
            StatisticService.all(vm.currentMonthFutureStatsOpts).then(function (data) {
                vm.currentMonthFutureStats = data.data.general;
                $log.info("carico loadCurrentMonthFutureStats: ");
                vm.currentMonthFutureStatsOpts.startDate = vm.selectedDate;
                // vm.currentMonthFutureStatsOpts.startDate = vm.today;
                vm.currentMonthFutureStatsOpts.endDate = vm.selectedDate.clone().endOf('month');
                vm.currentMonthFutureStatsOpts.date_start_frmt = vm.currentMonthFutureStatsOpts.startDate.format('DD');
                vm.currentMonthFutureStatsOpts.date_end_frmt = vm.currentMonthFutureStatsOpts.endDate.format('DD/MM');
                vm.currentMonthFutureStatsOpts.date_end_frmt1 = vm.currentMonthFutureStatsOpts.endDate.format('DD');
                //$log.info(vm.currentMonthFutureStatsOpts);
                //$log.info(data.data.general);
                /**
                 * Ricalcolo prev e total prendendo i dati da Past e Reference
                 */
                vm.currentMonthFutureStats.data.media_scontrino = vm.referenceStats.data.media_scontrino;
                vm.currentMonthFutureStats.data.media_scontrino_1av = vm.referenceStats.data.media_scontrino_1av;
                vm.currentMonthFutureStats.data.media_scontrino_sm = vm.referenceStats.data.media_scontrino_sm;


                var prev = {};
                vm.currentMonthFutureStats.data.app_count_1av = parseInt(vm.currentMonthFutureStats.data.app_count_1av);
                $log.info('parseInt(vm.currentMonthFutureStats.data.app_count_1av)',parseInt(vm.currentMonthFutureStats.data.app_count_1av));
                vm.currentMonthFutureStats.data.app_count = parseInt(vm.currentMonthFutureStats.data.app_count);
                vm.currentMonthFutureStats.availab_minutes = parseInt(vm.currentMonthFutureStats.availab_minutes);

                /**
                 * Rapporta i dati di confronto ai giorni di questo periodo
                 */
                vm.relateReferenceStatToDays(parseInt(vm.currentMonthFutureStats.work_days) + parseInt(vm.currentMonthPastStats.work_days));


                prev.app_count_paid = Math.round(vm.currentMonthFutureStats.data.app_count * vm.referenceStats.data.paid_perc);
                prev.app_count_paid_1av = Math.round(vm.currentMonthFutureStats.data.app_count_1av * vm.referenceStats.data.paid_perc_1av);
                prev.app_count_paid_sm = prev.app_count_paid - prev.app_count_paid_1av;
                prev.app_total_1av = vm.referenceStats.data.media_scontrino_1av * prev.app_count_paid_1av;
                prev.app_total_sm = vm.referenceStats.data.media_scontrino_sm * prev.app_count_paid_sm;
                prev.app_total = prev.app_total_1av + prev.app_total_sm;
                prev.redd_h = prev.app_total * 60 / vm.currentMonthFutureStats.availab_minutes;



                vm.currentMonthFutureStats.data.app_count_paid = prev.app_count_paid;
                vm.currentMonthFutureStats.data.app_count_paid_1av = prev.app_count_paid_1av;
                vm.currentMonthFutureStats.data.app_count_paid_sm = prev.app_count_paid_sm;
                vm.currentMonthFutureStats.data.app_total = prev.app_total;
                vm.currentMonthFutureStats.data.app_total_1av = prev.app_total_1av;
                vm.currentMonthFutureStats.data.app_total_sm = prev.app_total_sm;
                vm.currentMonthFutureStats.redd_h = prev.redd_h;
                /*
                 * leads
                 */
                vm.currentMonthFutureStats.lead_count_1av = vm.currentMonthPastStats.lead_count_1av / (vm.selectedDate.date() - 1) * (moment().daysInMonth() - vm.selectedDate.date() + 1);
                // vm.currentMonthFutureStats.lead_count_1av = vm.currentMonthPastStats.lead_count_1av / (vm.today.date() - 1) * (moment().daysInMonth() - vm.today.date() + 1);
                vm.currentMonthFutureStats.lead_count_1av_chiusi = Math.round(vm.currentMonthFutureStats.lead_count_1av * vm.referenceStats.redemption_lead_1av);
                vm.currentMonthFutureStats.redemption_lead_1av = vm.currentMonthFutureStats.lead_count_1av_chiusi / vm.currentMonthFutureStats.lead_count_1av;

                vm.currentMonthFutureStats.data.app_count_sm = vm.currentMonthFutureStats.data.app_count - vm.currentMonthFutureStats.data.app_count_1av;
                vm.currentMonthFutureStats.data.perc_1av = vm.currentMonthFutureStats.data.app_count_1av / vm.currentMonthFutureStats.data.app_count;
                vm.currentMonthFutureStats.data.perc_sm = vm.currentMonthFutureStats.data.app_count_sm / vm.currentMonthFutureStats.data.app_count;
                vm.currentMonthFutureStats.data.app_count_paid_sm = vm.currentMonthFutureStats.data.app_count_paid - vm.currentMonthFutureStats.data.app_count_paid_1av;
                vm.currentMonthFutureStats.data.paid_perc = vm.currentMonthFutureStats.data.app_count_paid / vm.currentMonthFutureStats.data.app_count;
                vm.currentMonthFutureStats.data.paid_perc_1av = vm.currentMonthFutureStats.data.app_count_paid_1av / vm.currentMonthFutureStats.data.app_count_1av;
                vm.currentMonthFutureStats.data.paid_perc_sm = vm.currentMonthFutureStats.data.app_count_paid_sm / vm.currentMonthFutureStats.data.app_count_sm;
                vm.currentMonthFutureStats.data.app_total_sm = vm.currentMonthFutureStats.data.app_total - vm.currentMonthFutureStats.data.app_total_1av;
                vm.currentMonthFutureStats.data.perc_total_1av = vm.currentMonthFutureStats.data.app_total_1av / vm.currentMonthFutureStats.data.app_total;
                vm.currentMonthFutureStats.data.perc_total_sm = vm.currentMonthFutureStats.data.app_total_sm / vm.currentMonthFutureStats.data.app_total;
                vm.currentMonthFutureStats.data.media_scontrino_sm = vm.currentMonthFutureStats.data.app_total_sm / vm.currentMonthFutureStats.data.app_count_paid_sm;


                vm.buildLaser(vm.currentMonthFutureStats);

                var total = {};
                total.app_count = vm.currentMonthPastStats.data.app_count + vm.currentMonthFutureStats.data.app_count;
                total.app_count_1av = vm.currentMonthPastStats.data.app_count_1av + vm.currentMonthFutureStats.data.app_count_1av;
                total.app_count_paid = vm.currentMonthPastStats.data.app_count_paid + prev.app_count_paid;
                total.app_count_paid_1av = vm.currentMonthPastStats.data.app_count_paid_1av + prev.app_count_paid_1av;
                total.app_total_1av = vm.currentMonthPastStats.data.app_total_1av + prev.app_total_1av;
                total.app_total = vm.currentMonthPastStats.data.app_total + prev.app_total;
                total.media_scontrino = total.app_total / total.app_count_paid;
                total.media_scontrino_1av = total.app_total_1av / total.app_count_paid_1av;
                total.availab_minutes = vm.currentMonthPastStats.availab_minutes + vm.currentMonthFutureStats.availab_minutes;
                total.redd_h = total.app_total * 60 / total.availab_minutes;
                total.availab_minutes = vm.currentMonthPastStats.availab_minutes + vm.currentMonthFutureStats.availab_minutes;
                total.worked_minutes = vm.currentMonthPastStats.worked_minutes + vm.currentMonthFutureStats.worked_minutes;
                total.worked_minutes_perc = total.worked_minutes / total.availab_minutes;
                total.redd_h_w = total.app_total * 60 / total.worked_minutes;
                total.costo_pers = parseFloat(vm.currentMonthFutureStats.costo_pers);
                total.costo_pers_perc = total.costo_pers / total.app_total;

                total.app_count_sm = total.app_count - total.app_count_1av;
                total.perc_1av = total.app_count_1av / total.app_count;
                total.perc_sm = total.app_count_sm / total.app_count;
                total.app_count_paid_sm = total.app_count_paid - total.app_count_paid_1av;
                total.paid_perc = total.app_count_paid / total.app_count;
                total.paid_perc_1av = total.app_count_paid_1av / total.app_count_1av;
                total.paid_perc_sm = total.app_count_paid_sm / total.app_count_sm;
                total.app_total_sm = total.app_total - total.app_total_1av;
                total.perc_total_1av = total.app_total_1av / total.app_total;
                total.perc_total_sm = total.app_total_sm / total.app_total;
                total.media_scontrino_sm = total.app_total_sm / total.app_count_paid_sm;

                total.lead_count_1av = vm.currentMonthPastStats.lead_count_1av + vm.currentMonthFutureStats.lead_count_1av;
                total.lead_count_1av_chiusi = vm.currentMonthPastStats.lead_count_1av_chiusi + vm.currentMonthFutureStats.lead_count_1av_chiusi;
                total.redemption_lead_1av = total.lead_count_1av_chiusi / total.lead_count_1av;

                if (vm.storeId) {
                    total.min_down = vm.currentMonthPastStats.laser_au.min_down + vm.currentMonthFutureStats.laser_au.min_down;
                    total.min_laser_used = vm.currentMonthPastStats.laser_au.min_laser_used + vm.currentMonthFutureStats.laser_au.min_laser_used;
                    total.max_min_laser = vm.currentMonthPastStats.laser_au.max_min_laser + vm.currentMonthFutureStats.laser_au.max_min_laser;
                    total.min_over = vm.currentMonthPastStats.laser_au.min_over + vm.currentMonthFutureStats.laser_au.min_over;
                    total.min_tot = vm.currentMonthPastStats.laser_au.min_tot + vm.currentMonthFutureStats.laser_au.min_tot;
                    total.num_laser = vm.currentMonthFutureStats.laser_au.num_laser;
                    total.num_rooms = vm.currentMonthFutureStats.laser_au.num_rooms;
                    total.min_laser_used_perc = total.min_laser_used / total.max_min_laser;
                    total.min_over_perc = total.min_over / total.min_tot;
                    total.min_down_perc = total.min_down / total.min_tot;
                }

                total.date = {
                    startDate: vm.currentMonthPastStatsOpts.startDate,
                    endDate: vm.currentMonthFutureStatsOpts.endDate
                }
                var trendPerc = {};
                trendPerc.app_count = (total.app_count - vm.referenceStats.data.app_count) * 100 / vm.referenceStats.data.app_count;
                trendPerc.app_count_1av = (total.app_count_1av - vm.referenceStats.data.app_count_1av) * 100 / vm.referenceStats.data.app_count_1av;
                trendPerc.app_count_paid = (total.app_count_paid - vm.referenceStats.data.app_count_paid) * 100 / vm.referenceStats.data.app_count_paid;
                trendPerc.app_count_paid_1av = (total.app_count_paid_1av - vm.referenceStats.data.app_count_paid_1av) * 100 / vm.referenceStats.data.app_count_paid_1av;
                trendPerc.app_total = (total.app_total - vm.referenceStats.data.app_total) * 100 / vm.referenceStats.data.app_total;
                trendPerc.app_total_1av = (total.app_total_1av - vm.referenceStats.data.app_total_1av) * 100 / vm.referenceStats.data.app_total_1av;
                trendPerc.media_scontrino = (total.media_scontrino - vm.referenceStats.data.media_scontrino) * 100 / vm.referenceStats.data.media_scontrino;
                trendPerc.media_scontrino_1av = (total.media_scontrino_1av - vm.referenceStats.data.media_scontrino_1av) * 100 / vm.referenceStats.data.media_scontrino_1av;
                trendPerc.availab_minutes = (total.availab_minutes - vm.referenceStats.availab_minutes) * 100 / vm.referenceStats.availab_minutes;
                trendPerc.redd_h = (total.redd_h - vm.referenceStats.redd_h) * 100 / vm.referenceStats.redd_h;
                trendPerc.worked_minutes = (total.worked_minutes - vm.referenceStats.worked_minutes) * 100 / vm.referenceStats.worked_minutes;
                trendPerc.redd_h_w = (total.redd_h_w - vm.referenceStats.redd_h_w) * 100 / vm.referenceStats.redd_h_w;
                trendPerc.worked_minutes_perc = (total.worked_minutes_perc - vm.referenceStats.worked_minutes_perc) * 100 / vm.referenceStats.worked_minutes_perc;
                trendPerc.costo_pers = (total.costo_pers - vm.referenceStats.costo_pers) * 100 / vm.referenceStats.costo_pers;
                trendPerc.costo_pers_perc = (total.costo_pers_perc - vm.referenceStats.costo_pers_perc) * 100 / vm.referenceStats.costo_pers_perc;

                trendPerc.app_count_sm = (total.app_count_sm - vm.referenceStats.data.app_count_sm) * 100 / vm.referenceStats.data.app_count_sm;
                trendPerc.perc_1av = (total.perc_1av - vm.referenceStats.data.perc_1av) * 100 / vm.referenceStats.data.perc_1av;
                trendPerc.perc_sm = (total.perc_sm - vm.referenceStats.data.perc_sm) * 100 / vm.referenceStats.data.perc_sm;
                trendPerc.app_count_paid_sm = (total.app_count_paid_sm - vm.referenceStats.data.app_count_paid_sm) * 100 / vm.referenceStats.data.app_count_paid_sm;
                trendPerc.paid_perc = (total.paid_perc - vm.referenceStats.data.paid_perc) * 100 / vm.referenceStats.data.paid_perc;
                trendPerc.paid_perc_1av = (total.paid_perc_1av - vm.referenceStats.data.paid_perc_1av) * 100 / vm.referenceStats.data.paid_perc_1av;
                trendPerc.paid_perc_sm = (total.paid_perc_sm - vm.referenceStats.data.paid_perc_sm) * 100 / vm.referenceStats.data.paid_perc_sm;
                trendPerc.app_total_sm = (total.app_total_sm - vm.referenceStats.data.app_total_sm) * 100 / vm.referenceStats.data.app_total_sm;
                trendPerc.perc_total_1av = (total.perc_total_1av - vm.referenceStats.data.perc_total_1av) * 100 / vm.referenceStats.data.perc_total_1av;
                trendPerc.perc_total_sm = (total.perc_total_sm - vm.referenceStats.data.perc_total_sm) * 100 / vm.referenceStats.data.perc_total_sm;
                trendPerc.media_scontrino_sm = (total.media_scontrino_sm - vm.referenceStats.data.media_scontrino_sm) * 100 / vm.referenceStats.data.media_scontrino_sm;

                /**
                 * leads
                 */
                trendPerc.lead_count_1av = (total.lead_count_1av - vm.referenceStats.lead_count_1av) * 100 / vm.referenceStats.lead_count_1av;
                trendPerc.lead_count_1av_chiusi = (total.lead_count_1av_chiusi - vm.referenceStats.lead_count_1av_chiusi) * 100 / vm.referenceStats.lead_count_1av_chiusi;
                trendPerc.redemption_lead_1av = (total.redemption_lead_1av - vm.referenceStats.redemption_lead_1av) * 100 / vm.referenceStats.redemption_lead_1av;

                if (vm.storeId) {
                    trendPerc.num_laser = (total.num_laser - vm.referenceStats.laser_au.num_laser) * 100 / vm.referenceStats.laser_au.num_laser;
                    trendPerc.num_rooms = (total.num_rooms - vm.referenceStats.laser_au.num_rooms) * 100 / vm.referenceStats.laser_au.num_rooms;
                    trendPerc.min_laser_used_perc = (total.min_laser_used_perc - vm.referenceStats.laser_au.min_laser_used_perc) * 100 / vm.referenceStats.laser_au.min_laser_used_perc;
                    trendPerc.min_over_perc = (total.min_over_perc - vm.referenceStats.laser_au.min_over_perc) * 100 / vm.referenceStats.laser_au.min_over_perc;
                    trendPerc.min_down_perc = (total.min_down_perc - vm.referenceStats.laser_au.min_down_perc) * 100 / vm.referenceStats.laser_au.min_down_perc;
                }


                vm.currentMonthFutureStats.prev = prev;
                vm.currentMonthFutureStats.total = total;
                vm.currentMonthFutureStats.trendPerc = trendPerc;

                /*
                 * inizializzo le variabili per il form di simulazione - TAB1
                 */
                vm.currentMonthFutureStats.simulate = {};
                vm.currentMonthFutureStats.simulate.media_scontrino = Math.round(vm.currentMonthFutureStats.total.media_scontrino);
                vm.currentMonthFutureStats.simulate.media_scontrino_1av = Math.round(vm.referenceStats.data.media_scontrino_1av * 100) / 100;
                vm.currentMonthFutureStats.simulate.perc_1av = vm.referenceStats.data.perc_1av;
                vm.currentMonthFutureStats.simulate.paid_perc = vm.referenceStats.data.paid_perc;
                vm.currentMonthFutureStats.simulate.paid_perc_1av = vm.referenceStats.data.paid_perc_1av;
                vm.currentMonthFutureStats.simulate.paid_perc_sm = vm.referenceStats.data.paid_perc_sm;
                vm.currentMonthFutureStats.simulate.crescita = 0;

                /*
                 * inizializzo le variabili per il form di simulazione - TAB2
                 */
                vm.currentMonthFutureStats.simulate.perc_categoria_1v = parseFloat( (vm.referenceStats.data.perc_1av * 100).toFixed(2) );
                vm.currentMonthFutureStats.simulate.perc_categoria_sm = parseFloat( (vm.referenceStats.data.perc_sm * 100).toFixed(2) );
                vm.currentMonthFutureStats.simulate.sm_backup_1v = parseFloat( (vm.referenceStats.data.media_scontrino_1av).toFixed(2) );
                vm.currentMonthFutureStats.simulate.sm_backup_sm = parseFloat( (vm.referenceStats.data.media_scontrino_sm).toFixed(2) );
                vm.currentMonthFutureStats.simulate.perc_presentazione_1v = parseFloat( (vm.referenceStats.data.paid_perc_1av * 100).toFixed(2) );
                vm.currentMonthFutureStats.simulate.perc_presentazione_sm = parseFloat( (vm.referenceStats.data.paid_perc_sm * 100).toFixed(2) );
                vm.currentMonthFutureStats.simulate.disabilita_form = true;


                vm.deltaCurr = {};

                vm.calcoloObbiettivo();
                vm.calcolaObiettivoKpi2(true, true);
                vm.calcolaDelta();
                vm.loading = false;
            });
        };

        /**
         * calcolo l'obbiettivo
         * se non ho spuntato annoPrecedente il calcolo è:
         *  mese_corrente*2/somma_stagionalità_2mesi_precedenti * stagionalità_mese_corrente * coefficiente di crescita(NB è una percentuale quindi viene convertita a numero)
         * se ho spuntato anno precedente il calcolo è:
         *  mese_corrente *coefficiente di crescita(NB è una percentuale quindi viene convertita a numero)
         */
        vm.calcoloObbiettivo = function() {

            var indexStagionalitaCorrente = vm.selectedDate.format('M') -1;
            var indexStagionalitaPrecedente1 = indexStagionalitaCorrente == 0 ? 11 : indexStagionalitaCorrente-1;
            var indexStagionalitaPrecedente2 = indexStagionalitaPrecedente1 == 0 ? 11 : indexStagionalitaPrecedente1-1;

            if (vm.annoPrecedente == 0) {
                vm.currentMonthFutureStats.simulate.app_total = Math.round(2 * vm.referenceStats.data.app_total / (vm.stagionalitaList[indexStagionalitaPrecedente2] + vm.stagionalitaList[indexStagionalitaPrecedente1]) * vm.stagionalitaList[indexStagionalitaCorrente] * (1+vm.currentMonthFutureStats.simulate.crescita / 100));
                vm.currentMonthFutureStats.simulate.obiettivo = vm.currentMonthFutureStats.simulate.app_total;

            } else {
                vm.currentMonthFutureStats.simulate.app_total = Math.round(vm.referenceStats.data.app_total * (1+vm.currentMonthFutureStats.simulate.crescita / 100));
                vm.currentMonthFutureStats.simulate.obiettivo = vm.currentMonthFutureStats.simulate.app_total;
            }
        }

        vm.calcolaObiettivoKpi2 = function(past, future) {

            if( past ) {

                var app_total = vm.currentMonthFutureStats.simulate.obiettivo;
                vm.currentMonthPastStats.data.tot_obiettivo_1v =
                    Math.round((app_total * vm.currentMonthFutureStats.simulate.perc_categoria_1v)/ 100);
                vm.currentMonthPastStats.data.tot_obiettivo_sm =
                    Math.round((app_total * vm.currentMonthFutureStats.simulate.perc_categoria_sm)/ 100);
                vm.currentMonthPastStats.data.tot_obiettivo =
                    vm.currentMonthPastStats.data.tot_obiettivo_1v + vm.currentMonthPastStats.data.tot_obiettivo_sm;

                vm.currentMonthPastStats.data.scostamento_1v =
                    vm.currentMonthPastStats.data.app_total_1av - vm.currentMonthPastStats.data.tot_obiettivo_1v;
                vm.currentMonthPastStats.data.scostamento_sm =
                    vm.currentMonthPastStats.data.app_total_sm - vm.currentMonthPastStats.data.tot_obiettivo_sm;
                vm.currentMonthPastStats.data.scostamento =
                    vm.currentMonthPastStats.data.scostamento_1v + vm.currentMonthPastStats.data.scostamento_sm;

            }

            if( future ) {

                vm.currentMonthFutureStats.data.obiettivo =
                    vm.currentMonthFutureStats.simulate.obiettivo - vm.currentMonthPastStats.data.app_total;

                vm.currentMonthFutureStats.data.incasso_tipologia_1v =
                    (vm.currentMonthFutureStats.data.obiettivo * vm.currentMonthFutureStats.simulate.perc_categoria_1v)/ 100;
                vm.currentMonthFutureStats.data.incasso_tipologia_sm =
                    (vm.currentMonthFutureStats.data.obiettivo * vm.currentMonthFutureStats.simulate.perc_categoria_sm)/ 100;
                vm.currentMonthFutureStats.data.incasso_tipologia =
                    vm.currentMonthFutureStats.data.incasso_tipologia_1v +
                    vm.currentMonthFutureStats.data.incasso_tipologia_sm;

                vm.currentMonthFutureStats.data.app_presentati_necessari_1v =
                    vm.currentMonthFutureStats.data.incasso_tipologia_1v / vm.currentMonthFutureStats.simulate.sm_backup_1v;
                vm.currentMonthFutureStats.data.app_presentati_necessari_sm =
                    vm.currentMonthFutureStats.data.incasso_tipologia_sm / vm.currentMonthFutureStats.simulate.sm_backup_sm;
                vm.currentMonthFutureStats.data.app_presentati_necessari =
                    vm.currentMonthFutureStats.data.app_presentati_necessari_1v +
                    vm.currentMonthFutureStats.data.app_presentati_necessari_sm;

                vm.currentMonthFutureStats.data.app_agendati_necessari_1v =
                    vm.currentMonthFutureStats.data.app_presentati_necessari_1v * 100 / vm.currentMonthFutureStats.simulate.perc_presentazione_1v;
                vm.currentMonthFutureStats.data.app_agendati_necessari_sm =
                    vm.currentMonthFutureStats.data.app_presentati_necessari_sm * 100 / vm.currentMonthFutureStats.simulate.perc_presentazione_sm;
                vm.currentMonthFutureStats.data.app_agendati_necessari =
                    vm.currentMonthFutureStats.data.app_agendati_necessari_1v +
                    vm.currentMonthFutureStats.data.app_agendati_necessari_sm;

                vm.currentMonthFutureStats.data.scostamento_appuntamenti_1v =
                    vm.currentMonthFutureStats.data.app_count_1av - vm.currentMonthFutureStats.data.app_agendati_necessari_1v;
                vm.currentMonthFutureStats.data.scostamento_appuntamenti_sm =
                    vm.currentMonthFutureStats.data.app_count_sm - vm.currentMonthFutureStats.data.app_agendati_necessari_sm;
                vm.currentMonthFutureStats.data.scostamento_appuntamenti =
                    vm.currentMonthFutureStats.data.app_count - vm.currentMonthFutureStats.data.app_agendati_necessari;

                vm.currentMonthFutureStats.data.appuntamenti_presenteranno_1v =
                    Math.round((vm.currentMonthFutureStats.data.app_count_1av * vm.currentMonthFutureStats.simulate.perc_presentazione_1v)/100);
                vm.currentMonthFutureStats.data.appuntamenti_presenteranno_sm =
                    Math.round((vm.currentMonthFutureStats.data.app_count_sm * vm.currentMonthFutureStats.simulate.perc_presentazione_sm)/100);
                vm.currentMonthFutureStats.data.appuntamenti_presenteranno =
                    vm.currentMonthFutureStats.data.appuntamenti_presenteranno_1v + vm.currentMonthFutureStats.data.appuntamenti_presenteranno_sm;

                vm.currentMonthFutureStats.data.scostamento_presentati_1v =
                    vm.currentMonthFutureStats.data.appuntamenti_presenteranno_1v - vm.currentMonthFutureStats.data.app_presentati_necessari_1v;
                vm.currentMonthFutureStats.data.scostamento_presentati_sm =
                    vm.currentMonthFutureStats.data.appuntamenti_presenteranno_sm - vm.currentMonthFutureStats.data.app_presentati_necessari_sm;
                vm.currentMonthFutureStats.data.scostamento_presentati =
                vm.currentMonthFutureStats.data.scostamento_presentati_1v + vm.currentMonthFutureStats.data.scostamento_presentati_sm;

                vm.currentMonthFutureStats.data.potenziale_agenda_1v =
                    vm.currentMonthFutureStats.data.appuntamenti_presenteranno_1v * vm.currentMonthFutureStats.simulate.sm_backup_1v;
                vm.currentMonthFutureStats.data.potenziale_agenda_sm =
                    vm.currentMonthFutureStats.data.appuntamenti_presenteranno_sm * vm.currentMonthFutureStats.simulate.sm_backup_sm;
                vm.currentMonthFutureStats.data.potenziale_agenda =
                    vm.currentMonthFutureStats.data.potenziale_agenda_1v + vm.currentMonthFutureStats.data.potenziale_agenda_sm;

                vm.currentMonthFutureStats.data.scostamento_1v =
                    vm.currentMonthFutureStats.data.potenziale_agenda_1v - vm.currentMonthFutureStats.data.incasso_tipologia_1v;
                vm.currentMonthFutureStats.data.scostamento_sm =
                    vm.currentMonthFutureStats.data.potenziale_agenda_sm - vm.currentMonthFutureStats.data.incasso_tipologia_sm;
                vm.currentMonthFutureStats.data.scostamento =
                vm.currentMonthFutureStats.data.scostamento_1v + vm.currentMonthFutureStats.data.scostamento_sm;

            }

        }

        vm.calcolaDelta = function(){
            vm.deltaCurr.app_count = 0;
            vm.deltaCurr.app_count_1av = 0;
            vm.deltaCurr.app_smaltimento = 0;
            vm.deltaCurr.media_scontrino = 0;

            vm.deltaCurr.app_count = Math.round((vm.currentMonthFutureStats.simulate.app_total - vm.currentMonthFutureStats.total.app_total) / (vm.currentMonthFutureStats.simulate.media_scontrino * vm.referenceStats.data.paid_perc));
            vm.deltaCurr.app_count_1av = Math.round((vm.deltaCurr.app_count * vm.currentMonthFutureStats.total.perc_1av));
            vm.deltaCurr.app_smaltimento = Math.round((vm.deltaCurr.app_count * vm.currentMonthFutureStats.total.perc_sm));
            vm.deltaCurr.media_scontrino = vm.currentMonthFutureStats.simulate.media_scontrino;
        }
        /*
         * cambia il parametro media scontrino
         */
        vm.onBlurCurrentMediaScontrino = function () {
            vm.calcolaDelta();
        };

        /*
         *
         */
        vm.onBlurCrescita = function () {
            vm.calcoloObbiettivo();
            vm.calcolaDelta();
        };

        vm.onRicalcola = function()  {
            vm.calcoloObbiettivo();
            vm.calcolaDelta();
        };

        vm.onRicalcola2 = function() {
            vm.currentMonthFutureStats.simulate.disabilita_form = true;
            vm.calcolaObiettivoKpi2(true, true);
        };

        vm.onBlurPercCategoria = function() {
            var val = vm.currentMonthFutureStats.simulate.perc_categoria_1v;
            if(val) {
                vm.currentMonthFutureStats.simulate.perc_categoria_sm = 100 - val;
            }
        };

        vm.abilitaForm = function() {
            vm.currentMonthFutureStats.simulate.disabilita_form = false;
        };

        vm.calculateTotalInPercentage = function(n1, n2){
          return (n1 * n2) / 100;
        };

        vm.loadNextMonthStats = function () {
            // TODO è normale che non venga chiamta?
            $log.info('loadNextMonthStats  viene chiamata');
            vm.loading = true;
            vm.nextMonthStats = [];
            vm.nextMonthStatsOpts = {
                date_start: vm.nextMonth.format('YYYY-MM-01'),
                date_end: moment().add(2, 'months').format('YYYY-MM-01')
            };
            $log.info('vm.nextMonthStatsOpts', vm.nextMonthStatsOpts);
            if (vm.storeId != 0) {
                vm.nextMonthStatsOpts.store_id = vm.storeId;
            }
            vm.nextMonthStatsOpts.only_general = true;
            vm.nextMonthStatsOpts.target = true;
            StatisticService.all(vm.nextMonthStatsOpts).then(function (data) {
                vm.nextMonthStats = data.data.general;
                $log.info("carico loadNextMonthStats: ");

                vm.nextMonthStatsOpts.startDate = moment().add(1, 'months').startOf('month');
                vm.nextMonthStatsOpts.endDate = moment().add(1, 'months').endOf('month');
                vm.nextMonthStatsOpts.date_start_frmt = vm.nextMonthStatsOpts.startDate.format('MMMM');
                vm.nextMonthStatsOpts.date_end_frmt = vm.nextMonthStatsOpts.endDate.format('YYYY');

                //$log.info(vm.nextMonthStatsOpts);
                //$log.info(data.data.general);

                vm.nextMonthStats.data.media_scontrino = vm.referenceStats.data.media_scontrino;
                vm.nextMonthStats.data.media_scontrino_1av = vm.referenceStats.data.media_scontrino_1av;
                vm.nextMonthStats.data.media_scontrino_sm = vm.referenceStats.data.media_scontrino_sm;

                /**
                 * devo calcolare prev in base a reference
                 */
                var prev = {};
                prev.app_count_paid = Math.round(parseInt(vm.nextMonthStats.data.app_count) * vm.referenceStats.data.paid_perc);
                prev.app_count_paid_1av = Math.round(parseInt(vm.nextMonthStats.data.app_count_1av) * vm.referenceStats.data.paid_perc_1av);
                prev.app_count_paid_sm = prev.app_count_paid - prev.app_count_paid_1av;
                prev.app_total_1av = vm.referenceStats.data.media_scontrino_1av * prev.app_count_paid_1av;
                prev.app_total_sm = vm.referenceStats.data.media_scontrino_sm * prev.app_count_paid_sm;
                prev.app_total = prev.app_total_1av + prev.app_total_sm;

                vm.nextMonthStats.prev = prev;

                vm.nextMonthStats.data.app_count_paid = prev.app_count_paid;
                vm.nextMonthStats.data.app_count_paid_1av = prev.app_count_paid_1av;
                vm.nextMonthStats.data.app_count_paid_sm = prev.app_count_paid_sm;
                vm.nextMonthStats.data.app_total = prev.app_total;
                vm.nextMonthStats.data.app_total_1av = prev.app_total_1av;
                vm.nextMonthStats.data.app_total_sm = prev.app_total_sm;

                vm.nextMonthStats.target = { app_total: parseFloat(vm.nextMonthStats.target) };
                $log.info(vm.nextMonthStats.target)
                vm.nextMonthStats.target.media_scontrino = Math.round(vm.referenceStats.data.media_scontrino * 100) / 100;
                vm.nextMonthStats.target.media_scontrino_1av = Math.round(vm.referenceStats.data.media_scontrino_1av * 100) / 100;
                vm.nextMonthStats.target.perc_1av = vm.referenceStats.data.perc_1av;
                vm.nextMonthStats.target.paid_perc = vm.referenceStats.data.paid_perc;
                vm.nextMonthStats.target.paid_perc_1av = vm.referenceStats.data.paid_perc_1av;
                vm.nextMonthStats.target.paid_perc_sm = vm.referenceStats.data.paid_perc_sm;

                vm.onBlurNextMediaScontrino();
                vm.loading = false;
            });
        }
        vm.onBlurNextMediaScontrino = function () {
            vm.nextMonthStats.target.app_count_paid = Math.round(vm.nextMonthStats.target.app_total / vm.nextMonthStats.target.media_scontrino);
            vm.nextMonthStats.target.app_count = Math.round(vm.nextMonthStats.target.app_count_paid / vm.nextMonthStats.target.paid_perc);
            vm.computeDeltaNext();
        };
        vm.onBlurNextAppCount = function () {
            vm.nextMonthStats.target.app_count_paid = Math.round(vm.nextMonthStats.target.app_count * vm.nextMonthStats.target.paid_perc);
            vm.nextMonthStats.target.media_scontrino = Math.round(vm.nextMonthStats.target.app_total * 100 / vm.nextMonthStats.target.app_count_paid) / 100;
            vm.computeDeltaNext();
        };
        vm.computeDeltaNext = function () {
            vm.deltaNext = {};
            vm.deltaNext.app_count = vm.nextMonthStats.target.app_count - vm.nextMonthStats.data.app_count;
            vm.deltaNext.app_count_paid = vm.nextMonthStats.target.app_count_paid - vm.nextMonthStats.data.app_count_paid;
            vm.deltaNext.app_total = vm.nextMonthStats.target.app_total - vm.nextMonthStats.data.app_total;
            vm.deltaNext.media_scontrino = vm.nextMonthStats.target.media_scontrino - vm.nextMonthStats.data.media_scontrino;
        };



        vm.loadPrevisione = function () {
            vm.loadReferenceStats();
        };

        /**
         * al cambio data setto tutte le variabili che contengono le date
         * selectedDate  in base a quello che ho selezionato
         * nextMonth
         */
        vm.onChangeDate = function (){
            vm.selectedDate.set({'year': vm.selectedYear, 'month': vm.months.indexOf(vm.selectedMonth)});

            vm.nextMonth.set({ 'month': vm.selectedDate.get('month') + 1});
            vm.yesterday.set({ 'month': vm.selectedDate.get('month'),'date': vm.selectedDate.get('date') - 1});

            var curYM = moment().format('YYYY-MM');
            vm.currentMonthSelected = false;
            vm.futureMonthSelected = false;
            vm.pastMonthSelected = false;
            if( curYM == vm.selectedDate.format('YYYY-MM')) {
                vm.currentMonthSelected = true;
            } else if (curYM < vm.selectedDate.format('YYYY-MM')) {
                vm.futureMonthSelected = true;
            } else {
                vm.pastMonthSelected = true;
            }

            vm.loadPrevisione();
        }

        /**
         * al click su anno precedente rilancia la previsione.
         */
        vm.onAnnoPrecedente = function () {
            vm.loadPrevisione();
        }

        /**
         * setta la visibilità delle colonne fino a ieri e resto del mese,
         */
        vm.setColumVisibility = function () {

        }

        /**
         * Carico dati eventi futuri e relative informazioni
         */
        vm.futureEvents = [];
        vm.pastEvents = [];
        vm.dataOggi = moment().format('YYYY-MM-DD');
        vm.loadEvents = function () {
            // TODO non viene chiamata
            vm.loading = true;
            vm.futureEvents = [];
            vm.pastEvents = [];
            var pars = {};
            if (vm.storeId != 0) {
                pars.store_id = vm.storeId;
            }
            CrudService.all('events', pars, vm,
                function (response) {
                    //$log.info(response);
                    angular.forEach(response.data.data, function (event) {
                        event.date_frmt = moment(event.datetime).format("DD/MM/YYYY");
                        if (event.datetime < vm.dataOggi) {
                            vm.pastEvents.push(event);
                        } else {
                            vm.futureEvents.push(event);
                        }
                    });
                    vm.loading = false;
                },
                function () {
                    vm.loading = false;
                }
            )
        };

        vm.chart1 = {
            labels: [], series: [], data: [],
            options: {
                legend: { display: true },
                scales: {
                    xAxes: [{
                        stacked: false
                    }],
                    yAxes: [{
                        stacked: false,
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        };
        vm.chart1 = {
            labels: [], series: [], data: [],
            options: {
                legend: { display: true }
            }
        };
        var chart1 = function (statistics) {
            //vm.labels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
            vm.chart1.labels = _.keys(statistics);
            vm.chart1.series = ['Minuti disponibili', 'Minuti lavorati'];
            vm.chart1.data = [[], []];
            var k = 0;
            angular.forEach(statistics, function (value) {
                this[0].push(parseInt(value.availabilities));
                this[1].push(parseInt(value.worked));

                var perc = parseInt(parseInt(value.worked) * 100 / parseInt(value.availabilities));
                vm.chart1.labels[k] = vm.chart1.labels[k] + ' (' + perc + '%)';
                k = k + 1;

            }, vm.chart1.data);
            /*vm.data = [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ];*/
        };

        vm.chart2 = {
            labels: [], series: [], data: [],
            options: {
                legend: { display: true },
                scales: {
                    xAxes: [{
                        stacked: false
                    }],
                    yAxes: [{
                        stacked: false,
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        };
        var chart2 = function (statistics) {
            //vm.labels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
            vm.chart2.labels = _.keys(statistics);
            vm.chart2.series = ['Appuntamenti', 'Avvisati', 'Non risp.', 'Disdetti', 'Spostati', 'Presentati'];
            vm.chart2.data = [[], [], [], [], [], []];
            angular.forEach(statistics, function (value) {
                this[0].push(parseInt(value.appointments));
                this[1].push(parseInt(value.appointments_recalled));
                this[2].push(parseInt(value.appointments_recalled_norisp));
                this[3].push(parseInt(value.appointments_recalled_disd));
                this[4].push(parseInt(value.appointments_recalled_spost));
                this[5].push(parseInt(value.appointments_paid));
                //this[1].push(parseInt(value.worked));
            }, vm.chart2.data);
            /*vm.data = [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ];*/
        };

        vm.chart3 = {
            labels: [], series: [], data: [],
            options: {
                legend: { display: true },
                scales: {
                    xAxes: [{
                        stacked: false
                    }],
                    yAxes: [{
                        stacked: false,
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        };
        vm.chart3_type = true;
        vm.chart3 = {
            labels: [], series: [], data: [],
            options: {
                legend: { display: true },
                scales: {
                    xAxes: [{
                        stacked: false
                    }],
                    yAxes: [{
                        stacked: false,
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        };
        var chart3_num = function (statistics) {
            vm.chart3.labels = _.keys(statistics);
            vm.chart3.series = ['Incasso totale'];
            vm.chart3.data = [[]];
            angular.forEach(statistics, function (value) {
                this[0].push(parseInt(value.profit));
            }, vm.chart3.data);
        };

        var chart3_perc = function (statistics) {
            vm.chart3.labels = _.keys(statistics);
            vm.chart3.series = ['Media incasso/appuntamento'];
            vm.chart3.data = [[]];
            angular.forEach(statistics, function (value) {
                var media = parseFloat(parseFloat(value.profit) / parseInt(value.appointments_paid));
                this[0].push(_.round(media, 2));
            }, vm.chart3.data);
        };
        vm.change_chart3 = function () {
            if (vm.chart3_type) {
                chart3_num(vm.statistics.operators);
            } else {
                chart3_perc(vm.statistics.operators);
            }
            vm.chart3_type = !vm.chart3_type;
        };

        vm.chart4 = {
            labels: [], series: [], data: [],
            options: {
                legend: { display: true },
                scales: {
                    xAxes: [{
                        stacked: false
                    }],
                    yAxes: [{
                        stacked: false,
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        };
        var chart4 = function (statistics) {
            //vm.labels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
            vm.chart4.labels = _.keys(statistics);
            vm.chart4.series = ['Trattamenti'];
            vm.chart4.data = [[]];
            var k = 0;
            var tot = _.reduce(statistics, function (sum, n) {
                return sum + n;
            }, 0);
            angular.forEach(statistics, function (value) {
                this[0].push(parseInt(value));

                var perc = parseInt(parseInt(value) * 100 / parseInt(tot));
                vm.chart4.labels[k] = vm.chart4.labels[k] + ' (' + perc + '%)';
                k = k + 1;

            }, vm.chart4.data);


        };

        vm.chart5 = {
            labels: [], series: [], data: [],
            options: {
                legend: { display: true },
                scales: {
                    xAxes: [{
                        stacked: false
                    }],
                    yAxes: [{
                        stacked: false,
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        };
        vm.chart5_type = true;
        var chart5_num = function (statistics) {
            vm.chart5.labels = _.keys(statistics);
            vm.chart5.series = ['Clienti 1° volta', 'Clienti 1° volta pagato', 'Clienti fidelizzati'];
            vm.chart5.data = [[], [], []];
            var k = 0;
            angular.forEach(statistics, function (value) {
                this[0].push(parseInt(value.appointments_first_time));
                this[1].push(parseInt(value.appointments_first_time_paid));
                this[2].push(parseInt(value.appointments_loyal));

                var perc = parseInt(parseInt(value.appointments_loyal) * 100 / parseInt(value.appointments_first_time_paid));
                vm.chart5.labels[k] = vm.chart5.labels[k] + ' (' + perc + '%)';
                k = k + 1;
            }, vm.chart5.data);
        };
        var chart5_perc = function (statistics) {
            vm.chart5.labels = _.keys(statistics);
            vm.chart5.series = ['Clienti fidelizzati'];
            vm.chart5.data = [[]];
            var k = 0;
            angular.forEach(statistics, function (value) {
                var perc = parseInt(parseInt(value.appointments_loyal) * 100 / parseInt(value.appointments_first_time_paid));
                this[0].push(parseInt(perc));
                vm.chart5.labels[k] = vm.chart5.labels[k] + ' (' + perc + '%)';
                k = k + 1;
            }, vm.chart5.data);
        };

        vm.change_chart5 = function () {
            if (vm.chart5_type) {
                chart5_num(vm.statistics.operators);
            } else {
                chart5_perc(vm.statistics.operators);
            }
            vm.chart5_type = !vm.chart5_type;
        };
        /*$timeout( function(){
            reload( vm.date );
        }, 500 );*/


        /* WATCHO Lo Store */
        vm.storeId = null;
        vm.store = {};
        vm.storesList = [];
        $scope.$watch('$parent.selectedStore', function (id) {
            if (angular.isDefined(id)) {
                if (vm.storeId == null) {
                    vm.storeId = id;
                    vm.storesList = $scope.$parent.main.storesList;
                } else {
                    vm.storeId = id;
                }
                if (id == 0) {
                    vm.store = { id: 0, alias: 'Tutti i centri' };
                } else {
                    angular.forEach(vm.storesList, function (s) {
                        if (s.id == vm.storeId) {
                            vm.store = s;
                        }
                    });
                }
                // vm.loadEvents();
                vm.loadPrevisione();
                // if (vm.selectedIndex == 2) {
                //     vm.reload();
                // } else if (vm.selectedIndex == 3) {
                //     vm.loadPrevisione();
                // }
            };
        });
    };

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('InventoriesController', InventoriesController);

    /** @ngInject */
    function InventoriesController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        StoreService,
        UsersService, 
        CrudService
    ) {
        var vm = this;
        $log.info('InventoriesController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
        	return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        var current = moment().add(-20, 'day');
        vm.query = {
            filter: '',
            supplierName: '',
            month: current.format('MM'),
            year: current.format('YYYY'),
            qty: 0,
            order: ''
        };
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.supplierName = '';
            vm.query.order = '';
            vm.query.qty = 0;
            var cm = current.format('MM');
            var cy = current.format('YYYY');
            if (cm!=vm.query.month || cy!=vm.query.year) {
	            vm.query.month = cm; 
	            vm.query.year = cy;
	            vm.eListLoad();
            }
        };
        vm.years = [];
        for (var i=2017; i<=parseInt(vm.query.year); i++) {
        	vm.years.push(''+i);
        }
        vm.eList = [];
		vm.eListTotal = 0;
		vm.loading = true;
        vm.eListLoad = function() {
        	if (vm.productsLoading) {//devo essere sicuro di aver caricato tutti i prodotti
            	$timeout(vm.eListLoad, 1000);
            	return;
            }
        	//vm.eList = [];
        	vm.productsList = [];
			vm.eListTotal = 0;
			vm.mainEntity = {};
			vm.loading = true;
			vm.query.filter = '';
			vm.query.supplierName = '';
			vm.query.qty = 0;
        	var pars = {searchJoin: 'and', orderBy: 'product_id'};
			var search = [];
        	var searchFields = [];
        	if (vm.storeId) {
        		search = ["store_id:"+vm.storeId];
        		searchFields = ["store_id:="];
        		pars.store_id = vm.storeId;
            	//pars.with = "inventory";
            }
        	searchFields.push("year:=");
        	search.push("year:"+vm.query.year);
        	searchFields.push("month:=");
        	search.push("month:"+vm.query.month);
        	pars.month = vm.query.month;
        	pars.year = vm.query.year;
        	//if (vm.loadFromStorage) {
        	pars.loadFromStorage = vm.fromStorage;
        	vm.fromStorage = false;
        	pars.searchFields = searchFields.join(';');
        	pars.search = search.join(';');
        	CrudService.all('products_inventories', pars, vm, 
        		function(response) {
	                if (response.data && response.data.data && response.data.data.length) {
	                	if (vm.storeId) {
	                		vm.mainEntity = response.data.inventory;
	                	} else {
	                		vm.mainEntity = {id:0, closed: true, store_id: 0, month: vm.query.month, year:vm.query.year};
	                	}
	                	var ip = 0;
	                	var eList = response.data.data;
	                	for (var i = 0; i<eList.length; i++) {
	                		eList[i].prev_qty = eList[i].qty;
	                		while (vm.productsListOrigin[ip].id<eList[i].product_id) {
	                			angular.copy(vm.getNewEmptyProdInv(vm.productsListOrigin[ip]), vm.productsListOrigin[ip].prodInv);
	                			ip++;
	                		}
	                		if (vm.productsListOrigin[ip].id==eList[i].product_id) {
	                			angular.copy(eList[i], vm.productsListOrigin[ip].prodInv);
	                			vm.eListTotal+=eList[i].price*eList[i].qty;
	                			ip++;
	                		}
	                	}
	                	for (var i=ip; i<vm.productsListOrigin.length; i++) {
	                		angular.copy(vm.getNewEmptyProdInv(vm.productsListOrigin[i]), vm.productsListOrigin[i].prodInv);
	                	}
	                	if (vm.mainEntity.closed || !vm.storeId) {
	                		vm.query.qty = 1;
	                	}
	                } else {
	                	vm.mainEntity = {
	                			id: null,
	                			store_id: vm.storeId,
	                			year: parseInt(vm.query.year),
	                			month: parseInt(vm.query.month),
	                			closed: false,
	                			user_id: vm.user.id
	                	};
	                	angular.forEach(vm.productsListOrigin, function(product) {
	                		angular.copy(vm.getNewEmptyProdInv(product), product.prodInv); 
	                	});
	                }
	                vm.productsList = vm.productsListOrigin;
	                vm.loading = false;
        		},
        		function () {
					vm.loading = false;
        		}
            );
        };
        vm.fromStorage = false;
        vm.loadFromStorage = function() {
        	vm.fromStorage = true;
        	vm.eListLoad();
        };
        vm.getNewEmptyProdInv = function(product) {
        	return {
				inventory: vm.mainEntity,
				inventory_id: null,
				store_id: vm.mainEntity.store_id,
				year: vm.mainEntity.year,
				month: vm.mainEntity.month,
				product_id: product.id,
				price: product.price,
				qty: 0,
				prev_qty: 0
			};
        }
        vm.saveProdInv = function(prodInv) {
        	if (prodInv.saving) return;
        	if (prodInv.qty==null) {
        		prodInv.qty = 0;
        	}
        	if (prodInv.inventory_id == null && prodInv.qty==0) return;
        	if (prodInv.qty==prodInv.prev_qty) return;
        	prodInv.saving = true;
        	if (prodInv.inventory_id == null) {
        		prodInv.inventory_id = vm.mainEntity.id;
        	}
        	if (vm.mainEntity.id==null) {
        		vm.loading = true;
        	}
        	CrudService.save( 'products_inventories', prodInv, vm ,
				function(response) {
        			if (vm.mainEntity.id==null) {
        				vm.mainEntity.id = response.data.data.inventory_id;
        				prodInv.inventory_id = response.data.data.inventory_id;
    					prodInv.inventory.id = response.data.data.inventory_id;
    					vm.loading = false;
        			}
        			if (prodInv.id==null) {
        				prodInv.id = response.data.data.id;
        			}
        			prodInv.qty = response.data.data.qty;
        			/**Aggiorno totale */
        			vm.eListTotal -= prodInv.price*prodInv.prev_qty;
        			vm.eListTotal += prodInv.price*prodInv.qty;
        			
        			prodInv.prev_qty = response.data.data.qty;
        			prodInv.saving = false;
				},
				function(response) {
					prodInv.qty = prodInv.prev_qty;
					prodInv.saving = false;
					vm.loading = false;
				});
        };
        vm.getQty = function (v, i, a) {
        	return v.prodInv?v.prodInv.qty:0;
        };
        vm.gtQueryQty = function (v) {
        	return v.prodInv.qty >= vm.query.qty || (v.prodInv.qty==null && !vm.mainEntity.closed);
        };
        vm.toggleInventario = function () {
        	if (vm.mainEntity.closed) {
        		vm.modificaInventario();
        	} else {
        		vm.chiudiInventario();
        	}
        };
        vm.chiudiInventario = function () {
        	var confirm = $mdDialog.confirm()
            .title('Attenzione')
            .ariaLabel('Attenzione')
            .textContent('Sicuro di voler chiudere l\'inventario del mese '+vm.mainEntity.month + '/' + vm.mainEntity.year  + '?')
            .ok('Si')
            .cancel('Ops, ho sbagliato');
        return $mdDialog
            .show(confirm)
            .then(
                function() {	
                	vm.mainEntity.closed = true;
                	vm.query.qty = 1;
                	CrudService.save( 'inventories', vm.mainEntity , vm ,
                			function (response) {
                				
                			},
                			function (response) {
                				vm.mainEntity.closed = false;
                				vm.query.qty = 0;
                			});
                }
             )
            .finally(
                function() {
                    confirm = undefined;
                }
            );
        };
        vm.modificaInventario = function () {
        	var confirm = $mdDialog.confirm()
            .title('Attenzione')
            .ariaLabel('Attenzione')
            .textContent('Sicuro di voler modificare l\'inventario del mese '+vm.mainEntity.month + '/' + vm.mainEntity.year  + '?')
            .ok('Si')
            .cancel('Ops, ho sbagliato');
        return $mdDialog
            .show(confirm)
            .then(
                function() {	
                	vm.mainEntity.closed = false;
                	CrudService.save( 'inventories', vm.mainEntity , vm ,
                			function (response) {
                				vm.query.qty = 0;
                			},
                			function (response) {
                				vm.mainEntity.closed = true;
                			});
                }
             )
            .finally(
                function() {
                    confirm = undefined;
                }
            );
        };
		$scope.$watch('ab.query.filter', function() {
			$timeout(vm.calcsOnVisibileElements, 300);
		});
		$scope.$watch('ab.query.supplierName', function() {
			$timeout(vm.calcsOnVisibileElements, 300);
		});
		
		vm.pdf = function () {
      window.open(env.API+"/products_inventories?token="+vm.token+"&pdf=true&month="+vm.query.month+"&year="+vm.query.year+"&store_id="+vm.storeId);
    };

		vm.calcsOnVisibileElements = function() {
			$timeout(function () {
			   vm.eListTotal = 0;
			   vm.filteredItems.forEach(function(item) {
				   if (item.prodInv!=null && item.prodInv.qty!=null && item.prodInv.qty!=0) { 
					   vm.eListTotal += item.prodInv.price*item.prodInv.qty;
				   }
			   });
			 });
		 };
        /* WATCHO Lo Store */
        vm.storeId = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                vm.storeId = id;
                vm.eListLoad();
            };
        });

        /* Prodotti */
        vm.productsList = [];
        vm.productsListOrigin = [];
		vm.productsLoading = true;
        vm.productsLoad = function() {
            vm.productsList = [];
			vm.productsLoading = true;
            CrudService.all('products', {with: 'supplier', orderBy: 'id', search:'id:0', searchFields: 'id:>'}, vm,	
                	function(response) {
	                	if (response.data && response.data.data) {
	                		angular.forEach(response.data.data, function (product) {
	                			product.prodInv = {qty:0};
	                		});
	                		vm.productsListOrigin = response.data.data;
	                	}
						vm.productsLoading = false;
                	},
                	function () {
						vm.productsLoading = false;
                	}
            );
        };
        vm.productsLoad();
    };

    InventoriesController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',            
            'StoreService',
            'UsersService',
            'CrudService'
        ];

})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .service(
            'GroupService',
            [
                '$log',
                'env',
                '$http',
                function(
                    $log,
                    env,
                    $http
                ) {
                    return {
                        all : function() {
                            var apiURI = env.API + '/groups';
                            return $http.get( apiURI, {} );
                        },

                        users : function(group_id) {
                            var apiURI = env.API + '/groups/'+group_id+"/users";
                            return $http.get( apiURI, {} );
                        },
                    }
                }

            ]
        );
    
    }
)();
(function() {
    'use strict';

    angular
        .module('admin')
        .controller('GroupsController', GroupsController);

    /** @ngInject */
    function GroupsController(
        $window,
        $scope,
        $log,
        $timeout,
        $http,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        GroupService,
        env,
        CrudService,
        Italia,
        UsersService
    ) {
        var vm = this;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.env = env;
        vm.Italia = Italia;
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }

        vm.eListLoading = true;
        vm.groups = null;
        GroupService.all().then(
            function (response) {
                if (response.data) {
                    vm.groups = response.data;
                }
                vm.eListLoading = false;
            },
            function (response) {
                var errMsg = "";
                if (
                    response.data != null &&
                    response.data.message != null
                ) {
                    errMsg =
                        response.data != null &&
                        response.data.message != null
                            ? response.data.message + "."
                            : ".";
                    var url =
                        response.config != null &&
                        response.config.url != null
                            ? response.config.url
                            : "";
                    if (url != null) {
                        errMsg += "\nUrl: " + url;
                    }
                }
                alert(
                    "Si è verificato un errore nel caricamento dei gruppi: " +
                        errMsg
                );
                vm.eListLoading = false;
            }
        );

        vm.showUsers = function(group) {
            //console.log("Mostro il gruppo "+group_id);

            var dialog = $mdDialog.confirm({
                title:
                    "Utenti associati al gruppo "+group.name,
                ariaLabel: "Lista Utenti",
                templateUrl: "app/groups/dialogs/users-list.html",
                escapeToClose: true,
                controller: [
                    "$scope",
                    "$mdDialog",
                    "$filter",
                    function ($scope, $mdDialog, $filter) {
                        $scope.title = this.title;
                        $scope.button_ok = "Chiudi";
                        $scope.groupUsers = [];
                        $scope.group = group;
                        $scope.usersLoading = true;
                        //return;
                        GroupService.users(group.id).then(
                            function (response) {
                                if(response.data) {
                                    $scope.groupUsers = response.data;
                                }
                                $scope.usersLoading = false;
                            },
                            function (response) {
                                var errMsg = "";
                                if (
                                    response.data != null &&
                                    response.data.message != null
                                ) {
                                    errMsg =
                                        response.data != null &&
                                        response.data.message != null
                                            ? response.data.message + "."
                                            : ".";
                                    var url =
                                        response.config != null &&
                                        response.config.url != null
                                            ? response.config.url
                                            : "";
                                    if (url != null) {
                                        errMsg += "\nUrl: " + url;
                                    }
                                }
                                $scope.usersLoading = false;
                                alert(
                                    "Si è verificato un errore nel caricamento degli utenti: " +
                                        errMsg
                                );
                                
                            }
                        );

                        $scope.close = function () {
                            $mdDialog.hide(true);
                        };

                    }
                ],
            });

            return $mdDialog.show(dialog).finally(function () {
                dialog = undefined;
            });
        }
    };

    GroupsController
        .$inject = [
            "$window",
            "$scope",
            "$log",
            "$timeout",
            "$http",
            "$mdSidenav",
            "$mdDialog",
            "$mdToast",
            "$filter",
            "GroupService",
            "env",
            "CrudService",
            "Italia",
            "UsersService"
        ];
        
})();
(function() {
    'use strict';

    angular
        .module('admin')
        .controller('GiftCardsController', GiftCardsController);

    /** @ngInject */
    function GiftCardsController(
        $scope,
        $log,
        $http,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        StoreService,
        UsersService, 
        CrudService
    ) {
        var vm = this;
        vm.entity = {
        		'name': 'giftcard',
        		'plural': 'giftcards',
        		'entity': 'giftcards',
        		'descr': 'giftcard',
        		'gender': 'F'
        		
        };
        vm.env = env;
        $log.info('GiftCardsController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
        	return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        vm.query = {
            filter: '',
            order: 'number',
            limit: 10,
            limitOptions: [ 5, 10, 15, 20 ],
            page: 1
        };
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.order = 'number';
            vm.eStatus.filter_date_start = null;
            vm.eStatus.filter_date_expire = false;
            vm.eStatus.filter_date_end = null;
            vm.eListLoad(1);
        };
        vm.options = {
                autoSelect: false,
                boundaryLinks: true,
                pageSelector: true,
                rowSelection: false,
        };
        vm.eStatus = {
        		'tenant': null
        };
        vm.eStatus.filter_date_start = null;
        vm.eStatus.filter_date_expire = false;
        vm.eStatus.filter_date_end = null;
        vm.saveStatus = function () {
	        //if (true) return;
	        localStorage.setItem( 'giftcard_eStatus', angular.toJson( vm.eStatus, false ) );
	        localStorage.setItem( 'giftcard_query', angular.toJson( vm.query, false ) );
	      };
	      vm.restoreStatus = function () {
	        //if (true) return;
	        var eStatus = angular.fromJson(localStorage.getItem('giftcard_eStatus'));
	        if (eStatus!=null) {
	          vm.eStatus = eStatus;
	        }
	        var query = angular.fromJson(localStorage.getItem('giftcard_query'));
	        if (query!=null) {
	          vm.query =  query;
	        }
	      };
	      vm.restoreStatus();
	      vm.removeSearch = function () {
	        	vm.query.filter = '';
	        	vm.query.order = 'number';
	            vm.query.page = 1;
	            vm.eStatus.tenant = null;
	            vm.eStatus.filter_date_start = null;
	            vm.eStatus.filter_date_expire = false;
	            vm.eStatus.filter_date_end = null;
	            vm.eListLoad(1);
	        };
        vm.onKeyPressSearch = function (event) {
        	if (event.keyCode==13) {
        		vm.eListLoad(1);
        		event.stopPropagation();
        		event.preventDefault();
        	}
        }
        vm.onChangeDateStart = function() {
            if( vm.eStatus.filter_date_start && vm.eStatus.filter_date_end ) {
                if( moment( vm.eStatus.filter_date_end ).hour(23).minute(59).second(59).isBefore( vm.eStatus.filter_date_start ) ) {
                    vm.eStatus.filter_date_end = null;
                }
            }
            vm.eStatus.filter_time_start = new Date(vm.today).getTime();
            vm.onChangeFilterDateExpire();
        };
        vm.onChangeDateEnd = function() {
          if( vm.eStatus.filter_date_start && vm.eStatus.filter_date_end ) {
              if( moment( vm.eStatus.filter_date_end ).hour(23).minute(59).second(59).isBefore( vm.eStatus.filter_date_start ) ) {
                  vm.eStatus.filter_date_start = vm.eStatus.filter_date_end;
                  vm.eStatus.filter_time_start = new Date(vm.today).getTime();
              }
          }
          vm.onChangeFilterDateExpire();
        };
        vm.onChangeFilterDateExpire = function () {
            if (vm.eStatus.filter_date_expire) {
              vm.query.order = 'date_expire';
            } else {
              vm.query.order = 'released_at';
            }
            vm.eListLoad(1);
        };
        vm.eList = [];
        vm.eListPag = {"total":0,"count":10,"per_page":10,"current_page":1,"total_pages":0,"links":{} }; 
        vm.loading = true;
        vm.eListReOrder = function (column) {
        	vm.query.order = column;
        	vm.eListLoad(1);
        };
        vm.eListLoad = function(p,s) {
        	vm.eList = [];
			vm.loading = true;
			if (p==null) {
        		p = vm.query.page;
        	}
        	vm.query.page = p;
        	vm.saveStatus();
        	if (s==null) {
        		s = parseInt(vm.eListPag.per_page);
        	}
        	var pars = {page:p, s: s, searchJoin: 'and'};
        	var search = [];
        	var searchFields = [];
        	if (vm.query.filter && vm.query.filter.trim()) {
        		searchFields.push('number:like');
        		search.push('number:%'+vm.query.filter.trim()+'%');
        	}
        	if (vm.eStatus.tenant) {
        		searchFields.push('rel_tenant:=');
        		search.push('rel_tenant:'+vm.eStatus.tenant);
        	}
        	var filterReleased = false;
        	if (vm.eStatus.filter_date_start!=null && vm.eStatus.filter_date_start!='') {
          	    var dField = vm.eStatus.filter_date_expire?'date_expire':'released_at';
          		search.push(dField+":"+moment(vm.eStatus.filter_date_start).format("YYYY-MM-DD"));
                searchFields.push(dField+":>=");
                filterReleased = true;
          	}
          	if (vm.eStatus.filter_date_end!=null && vm.eStatus.filter_date_end!='') {
          	  var date_end = moment(vm.eStatus.filter_date_end).format("YYYY-MM-DD");
          	  if (vm.eStatus.filter_date_expire) {
          	    pars.date_expire_to=date_end;
          	  } else {
          		pars.date_released_at_to=moment(vm.eStatus.filter_date_end).format("YYYY-MM-DD 23:59:59.9");
          	  }
          	  filterReleased = true;
          	}
        	if (vm.query.order!=null && vm.query.order!='') {
        		if (vm.query.order.indexOf("-")==0) {
        			pars.orderBy = vm.query.order.substring(1);
        			pars.sortedBy = "desc";
        		} else {
        			pars.orderBy = vm.query.order;
        			pars.sortedBy = "asc";
        		}
        	}
        	pars.with = 'rel_store';
    		if (filterReleased) {
        		searchFields.push('released:=');
        		search.push('released:1');
        	}
        	pars.search = search.join(";");
        	pars.searchFields = searchFields.join(";");
        	CrudService.all(vm.entity.entity, pars, vm, 
        		function(response) {
	                if (response.data && response.data.data && response.data.data.length) {
	                	vm.eListPag = response.data.meta.pagination;
	                	vm.eList = response.data.data;
	                    angular.forEach(vm.eList, function(el) {
	                    	//$log.info(el);
	                    	if (el.released && el.released_at!=null && el.released_at.date!=null) {
	                    		el.released_at_frmt = moment(el.released_at.date).format('D/M/YYYY');
	                    	}
	                    	if (el.released && el.date_expire!=null && el.date_expire.date!=null) {
	                    		el.date_expire_frmt = moment(el.date_expire.date).format('D/M/YYYY');
	                    	}
	                    });
	                }
					vm.loading = false;
        		},
        		function () {
					vm.loading = false;
        		}
            );
        };
        vm.eListLoad();
        vm.tenantsList = [];
        vm.tenantsLoad = function() {
          vm.tenantsList = [];
          $http.get(env.API+'/tenants?orderBy=tenant').then(function(response) {
              if (response.data && response.data.data) {
            	  vm.tenantsList = [];
                angular.forEach(response.data.data, function (elem) {
                    if (!elem.label) {
                    	elem.label = elem.tenant;
                	}
                    vm.tenantsList.push(elem);
                });
              }
          });
        };
          vm.tenantsLoad();
          //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(e) {
          if (vm.env.isMaster &&  (vm.user.type == 'admin' || vm.user.type=='backoffice')) {
            vm.toggleRight(e);
          }
        };
        vm.activeEntity = {};
        vm.updateEntity = {};
        vm.toggleRight = function(e) {
        	if (e!=null && e.id != null) {
				angular.copy(e, vm.updateEntity)
                vm.activeEntity = vm.updateEntity;
				/*if (vm.activeEntity.active==1) {
					vm.activeEntity.active = true;
				} else if (vm.activeEntity.active==0) {
					vm.activeEntity.active = false;
				}*/
            } else {
				vm.updateEntity = {};
				vm.activeEntity = {
                	id: null,
                	active: 1
                };
            }
            $timeout($mdSidenav('right').open, 0);
        };
        vm.resetAll = function() {
			vm.activeEntity = {}
			vm.updateEntity = {}
            $scope.entityForm.$setPristine();
            $scope.entityForm.$setUntouched();
        };
        vm.closeSidebar = function() {
			vm.resetAll();
        	$mdSidenav('right').close();
        };
        vm.saving = false;
        vm.save = function(e) {
            $log.info('Salva');
            if (angular.isDefined(e)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler salvare?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {	
                        		vm.saving = true;
								CrudService
                                    .save( vm.entity.entity, vm.activeEntity, vm ,
										function(response) {
                                    		if (vm.activeEntity.id) {
                                    			var id = vm.activeEntity.id;
                                    			vm.activeEntity.max_app = parseInt(response.data.data.max_app);
                                    			var position = vm.eList.map( function( x ) { return x.id; } ).indexOf( id );
                                        		angular.copy(vm.activeEntity, vm.eList[position]);
                                    		} else {
                                    			vm.eList.push(response.data.data);	
                                    		}
                                    		vm.closeSidebar();
                                    		vm.saving = false;
										},
										function(response) {
											vm.saving = false;
										});
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };
		
		vm.del = function ( id ) {
            $log.info( 'Del' );
            if( angular.isDefined( id ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler eliminare quest'+(vm.entity.gender=='F'?'a ':'o ')+vm.entity.descr +'?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            CrudService.del( vm.entity.entity, id, vm, 
								function( response ) {
                            		var position = vm.eList.map( function( x ) { return x.id; } ).indexOf( id );
                            		vm.eList.splice(position, 1);
								},
								function( response ) {
								}
							);
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };

    };

    GiftCardsController
        .$inject = [
            '$scope',
            '$log',
            '$http',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',            
            'StoreService',
            'UsersService',
            'CrudService'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('ExpcashController', ExpcashController);

    /** @ngInject */
    function ExpcashController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        CrudService,
        MONTHS,
        UsersService
    ) {
        var vm = this;
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.MONTHS = MONTHS;
        $log.info('ExpcashController');
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        vm.query = {
            year: parseInt(moment().format('YYYY')),
            month: parseInt(moment().format('MM')),
            type: '',
            period: null,
            order: 'month',
            grp_name: null,
            treatment_category_id: null
        };
        vm.removeSearch = function() {
            vm.query.year = parseInt(moment().format('YYYY'));
            vm.query.order = 'month';
            vm.query.month = parseInt(moment().format('MM')),
            vm.query.type = '';
            vm.query.grp_name = null;
            vm.query.period = null;
            vm.query.treatment_category_id = null;
            vm.eListLoad();
        };
        vm.years = [];
        for (var i=2015; i-3<=parseInt(vm.query.year); i++) {
            vm.years.push(''+i);
        }
        vm.eList = [];
        vm.eListTotal = 0;
        vm.monoType = false;
        vm.loading = true;
        vm.eListLoad = function() {
            vm.eList = [];
            vm.eListTotal = 0;
            vm.loading = true;
            vm.monoType = false;
            var pars = {'orderBy': ['month'], with: 'causal;category'};
            var search = [];
            var searchFields = [];
            if (vm.storeId) {
                searchFields.push("store_id:=");
                search.push("store_id:"+vm.storeId);
            }
            searchFields.push("year:=");
            search.push("year:"+vm.query.year);
            if (vm.query.month) {
                searchFields.push("month:=");
                search.push("month:"+vm.query.month);
            }
            if (vm.query.grp_name) {
                searchFields.push("grp_name:=");
                search.push("grp_name:"+vm.query.grp_name);
            }
            if (vm.query.treatment_category_id) {
                searchFields.push("treatment_category_id:=");
                search.push("treatment_category_id:"+vm.query.treatment_category_id);
            }
            if (vm.query.period) {
                if (vm.query.period == 'A') {
                    searchFields.push("day_to:<=");
                    search.push("day_to:15");
                } else if (vm.query.period == 'B') {
                    searchFields.push("day_from:>=");
                    search.push("day_from:16");
                }
            }
            if (vm.query.type!=null && vm.query.type!='') {
                searchFields.push("target:=");
                search.push("target:"+(vm.query.type=='O'?'1':'0'));
            }
            pars.searchFields = searchFields.join(';');
            pars.search = search.join(';');
            CrudService.all('expcash', pars, vm,
                function(response) {
                    if (response.data && response.data.data && response.data.data.length) {
                        var typeRic = false;
                        var typeOb = false;
                        angular.forEach(response.data.data, function(elem) {
                          vm.eListTotal+=elem.total;
                          if (elem.target) {
                              typeOb = true;
                          } else {
                              typeRic = true;
                          }
                          angular.forEach(vm.storesList, function(s) {
                              if (elem.store_id == s.id) {
                                elem.store = {data: s};
                              }
                          });
                        });
                        vm.monoType = !typeRic || !typeOb;
                        vm.eList = response.data.data;
                    }
                    vm.loading = false;
                },
                function () {
                    vm.loading = false;
                }
            );
        };


        vm.categoriesList = [];
        vm.categoriesListLoad = function() {
            CrudService.all('treatments-categories', null, vm,
                function(response) {
                    if (response.data && response.data.data && response.data.data.length) {
                        vm.categoriesList = response.data.data;
                    }
                },
                function () {}
            );
        };
        vm.categoriesListLoad();

        vm.groupNamesList = [];
        vm.groupNamesListLoad = function() {
            CrudService.all('treatments-group-names', null, vm,
                function(response) {
                    if (response.data && response.data.data && response.data.data.length) {
                        vm.groupNamesList = response.data.data;
                    }
                },
                function () {}
            );
        };
        vm.groupNamesListLoad();

        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(e) {
            vm.toggleRight(e);
        };
        vm.activeEntity = {};
        vm.updateEntity = {};
        vm.toggleRight = function(e, target) {
            if (e!=null && e.id != null) {
                angular.copy(e, vm.updateEntity)
                vm.activeEntity = vm.updateEntity;
            } else {
                vm.updateEntity = {};
                vm.activeEntity = {
                    store_id: vm.storeId,
                    year: vm.query.year,
                    month: vm.query.month,
                    target: target,
                    f_balance: target?true:false,
                    grp_name: null,
                    treatment_category_id: null,
                    day_from: null,
                    day_to: null,
                    prev: null,
                    store: {data: vm.store}
                };
            }
            $timeout($mdSidenav('right').open, 0);
        };
        vm.resetAll = function() {
            vm.activeEntity = {}
            vm.updateEntity = {}
            $scope.entityForm.$setPristine();
            $scope.entityForm.$setUntouched();
        };
        vm.closeSidebar = function() {
            $mdSidenav('right').close();
            vm.resetAll();
        };
        vm.setPeriodo = function(e, day_from, day_to) {
            if (e.day_from!=day_from) {
                $scope.entityForm.$setDirty();
                $scope.entityForm.day_from.$dirty = true;
            }
            if (e.day_to!=day_to) {
                $scope.entityForm.$setDirty();
                $scope.entityForm.day_to.$dirty = true;
            }
            e.day_from = day_from;
            e.day_to = day_to;
            if (day_from!=null && day_to == null) {//imposto ultimo giorno del mese
                var first = moment(e.year+'-'+e.month+'-01','Y-M-DD');
                e.day_to = first.daysInMonth();
            }
        };
        vm.save = function(e) {
            $log.info('Salva');
            if (angular.isDefined(e)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler salvare?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {
                            if (vm.activeEntity.target) {
                                delete vm.activeEntity.causal_id;
                            }
                            CrudService
                                .save( 'expcash', vm.activeEntity, vm ,
                                    function(response) {
                                        vm.closeSidebar();
                                        vm.eListLoad();
                                    },
                                    function(response) {
                                    }
                                );
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };

        vm.del = function ( id ) {
            $log.info( 'Del' );
            if( angular.isDefined( id ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler eliminare questo ricavo previsto?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            CrudService.del( 'expcash', id, vm,
                                function( response ) {
                                    vm.eListLoad();
                                },
                                function( response ) {
                                }
                            );
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };
        /* WATCHO Lo Store */
        vm.store = {id: 0, alias: 'Globale'};
        vm.storeId = null;
        vm.storesList = [];
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                vm.storeId = id;
                vm.storesList = $scope.$parent.main.storesList;
                angular.forEach(vm.storesList, function(s) {
                    if (s.id == id) {
                        vm.store = s;
                    }
                });
                vm.eListLoad();
            };
        });


    };

    ExpcashController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',
            'CrudService',
            'MONTHS',
            'UsersService'
        ];

})();

(function() {
    'use strict';
    
    angular
        .module( 'admin' )
        .service(
            'StatisticService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    all : function(options) {
                        var apiURI = env.API + '/statistics';
                        if( angular.isUndefined( options ) ) {
                            options = {};
                        };
                        return $http.get( apiURI, { params: options } );
                    },
                };
            }
        );

})();
(function() {
    'use strict';

    angular
        .module('admin')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController(
        $scope,
        env,
        $log,
        $http,
        $mdDialog,
        $mdToast,
        $q,
        $timeout,
        StatisticService,
        UsersService,
        CrudService,
        $sce
    ) {
        $log.info('DashboardController');
        var vm = this;
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.isCallCenter = false;
        $log.info(vm.token);
        /**
         * Prendo url prima di stringa api
         */
        var baseUrl = env.API.substring(0,env.API.length-4);
        vm.saldoUrl = baseUrl + '/token_login?token='+vm.token+'&redirect=/bi/kpi-ranking-month-dashboard';
        $log.info(vm.saldoUrl);
        vm.saldoUrl = $sce.trustAsResourceUrl(vm.saldoUrl);
        $log.info(vm.saldoUrl);
        vm.date = {startDate: moment().subtract(7, 'days'), endDate: moment()};
        vm.today = moment();
        vm.yesterday = moment().add(-1, 'days');
        vm.nextMonth = moment().add(1,'months');

        vm.exportAppointmentsUrl = env.API + '/appointments?with=byOperator&token='+vm.token+'&export=true&start='+
                vm.date.startDate.format('YYYY-MM-DD')+
                '&end='+vm.date.endDate.format('YYYY-MM-DD');               ;
        vm.exportCustomersUrl = env.API + '/customers?with=referral&token='+vm.token+'&export=true';


        vm.options = {
            buttonClasses: 'md-button md-raised',
            applyClass: 'md-accent',
            cancelClass: 'md-warn',
            format: 'DD/MM/YYYY',
            customRangeLabel: "asd",
            opens: "right",
            locale: {
                format: 'DD/MM/YYYY',
                separator: " - ",
                applyLabel: "Conferma",
                cancelLabel: "Annulla",
                fromLabel: "Dal",
                toLabel: "Al",
                customRangeLabel: "Scegli un range",
            },
            parentEl: ".page-dashboard",
            ranges: {
                'Oggi': [moment(), moment()],
                'Ieri': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Ultima sett.': [moment().subtract(7, 'days'), moment()],
                'Ultime 2 sett.': [moment().subtract(7, 'days'), moment().add(7, 'days')],
                'Ultimi 30 giorni': [moment().subtract(30, 'days'), moment()],
                'Questo mese': [moment().startOf('month'), moment().endOf('month')]
            }
        };
        $scope.$watch( 'dashboard.date', function( newDate ) {
                if (vm.storeId == null) return;
                //$log.info( 'New date set: ', newDate );
                vm.reload(true);
        }, false );

        vm.selectedIndex = 0;
        vm.statistics = {};
        vm.loading = true;
        vm.statsStoreId = null;
        vm.reload = function(force) {
            if (vm.statsStoreId == vm.storeId && !force) return;
            vm.statistics = {};
            vm.loading = true;
            vm.exportAppointmentsUrl = env.API + '/appointments?token='+vm.token+'&export=true&start='+
            vm.date.startDate.format('YYYY-MM-DD')+
            '&end='+vm.date.endDate.format('YYYY-MM-DD');
            var date = {
                date_start: vm.date.startDate.format(),
                date_end: vm.date.endDate.format()
            };
            if (vm.storeId!=0) {
                date.store_id = vm.storeId;
            }
            $log.info(date);
            vm.statsStoreId = vm.storeId;
            StatisticService.all( date ).then(function( data ){
                vm.statistics = data.data;
                /**
                 * Valori calcolati
                 */
                vm.statistics.general.data.app_count_sm = vm.statistics.general.data.app_count-vm.statistics.general.data.app_count_1av;
                vm.statistics.general.data.perc_1av = vm.statistics.general.data.app_count_1av/vm.statistics.general.data.app_count;
                vm.statistics.general.data.perc_sm = vm.statistics.general.data.app_count_sm/vm.statistics.general.data.app_count;
                vm.statistics.general.data.app_count_paid_sm = vm.statistics.general.data.app_count_paid-vm.statistics.general.data.app_count_paid_1av;
                vm.statistics.general.data.paid_perc = vm.statistics.general.data.app_count_paid/vm.statistics.general.data.app_count;
                vm.statistics.general.data.paid_perc_1av = vm.statistics.general.data.app_count_paid_1av/vm.statistics.general.data.app_count_1av;
                vm.statistics.general.data.paid_perc_sm = vm.statistics.general.data.app_count_paid_sm/vm.statistics.general.data.app_count_sm;
                vm.statistics.general.data.app_total_sm = vm.statistics.general.data.app_total-vm.statistics.general.data.app_total_1av;
                vm.statistics.general.data.perc_total_1av = vm.statistics.general.data.app_total_1av/vm.statistics.general.data.app_total;
                vm.statistics.general.data.perc_total_sm = vm.statistics.general.data.app_total_sm/vm.statistics.general.data.app_total;
                vm.statistics.general.data.media_scontrino_sm = vm.statistics.general.data.app_total_sm/vm.statistics.general.data.app_count_paid_sm;
                vm.buildLaser(vm.statistics.general);


                chart1( vm.statistics.operators );
                chart2( vm.statistics.operators );
                chart3_perc( vm.statistics.operators );
                chart4( vm.statistics.treatments );
                chart5_perc( vm.statistics.operators );
                chart5sm_perc( vm.statistics.operators );
                vm.loading = false;
                $timeout( function() { window.dispatchEvent( new Event( 'resize' ) ); } );
            });
        };

        vm.referenceStats = [];
        vm.referenceStatsOpts = {};
        vm.referenceStoreId = null;
        vm.currentMonthPastStats = [];
        vm.currentMonthFutureStats = [];
        vm.nextMonthStats = [];
        vm.currentMonthPastStatsOpts = {};
        vm.currentMonthFutureStatsOpts = {};
        vm.nextMonthStatsOpts = {};
        vm.refMonths = 2;
        vm.coeffCrescita = 1;
        vm.loadReferenceStats = function() {
            if (vm.referenceStoreId == vm.storeId) return;
            vm.loading = true;
            vm.referenceStats = [];
            vm.currentMonthPastStats = [];
            vm.currentMonthFutureStats = [];
            vm.nextMonthStats = [];
            vm.referenceStoreId = vm.storeId;
            vm.referenceStatsOpts = {
                date_start: moment().add(0-vm.refMonths,'months').startOf('month').format('YYYY-MM-DD'),
                date_end: moment().startOf('month').format('YYYY-MM-DD')
            };
            if (vm.storeId!=0) {
                vm.referenceStatsOpts.store_id = vm.storeId;
            }
            vm.referenceStatsOpts.costo_pers = true;
            vm.referenceStatsOpts.only_general = true;

            StatisticService.all( vm.referenceStatsOpts ).then(function( data ){
                vm.referenceStats = data.data.general;
                vm.referenceStatsOpts.startDate  = moment().add(0-vm.refMonths,'months').startOf('month');
                vm.referenceStatsOpts.endDate = moment().add(-1,'months').endOf('month');
                vm.referenceStatsOpts.date_start_frmt = vm.referenceStatsOpts.startDate.format('DD/MM/YYYY');
                vm.referenceStatsOpts.date_end_frmt = vm.referenceStatsOpts.endDate.format('DD/MM/YYYY');

                $log.info("carico reference: ");
                //$log.info(vm.referenceStatsOpts);
                //$log.info(data.data.general);

                vm.buildLaser(vm.referenceStats);

                vm.loadCurrentMonthPastStats();
                //vm.loadNextMonthStats();
            });
        };
        vm.relateReferenceStatToDays = function(days) {
            /**
             * calcolo coefficienti vari
             */
            vm.refDays = days;
            vm.conversionCoeff = days/parseInt(vm.referenceStats.work_days);
            vm.referenceStats.data.app_count = Math.round(parseInt(vm.referenceStats.data.app_count)*vm.conversionCoeff);
            vm.referenceStats.data.app_count_1av = Math.round(parseInt(vm.referenceStats.data.app_count_1av)*vm.conversionCoeff);
            vm.referenceStats.data.app_count_spostati = Math.round(parseInt(vm.referenceStats.data.app_count_spostati)*vm.conversionCoeff);
            vm.referenceStats.data.app_count_spostati_perc = vm.referenceStats.data.app_count_spostati/(vm.referenceStats.data.app_count_spostati+vm.referenceStats.data.app_count);
            vm.referenceStats.data.perc_1av = vm.referenceStats.data.app_count_1av/vm.referenceStats.data.app_count;
            vm.referenceStats.data.app_total = Math.round(parseFloat(vm.referenceStats.data.app_total)*vm.coeffCrescita*vm.conversionCoeff);
            vm.referenceStats.data.app_total_1av = Math.round(parseFloat(vm.referenceStats.data.app_total_1av)*vm.coeffCrescita*vm.conversionCoeff);
            vm.referenceStats.data.app_total_sm = vm.referenceStats.data.app_total - vm.referenceStats.data.app_total_1av;
            vm.referenceStats.data.perc_total_1av = vm.referenceStats.data.app_total_1av/vm.referenceStats.data.app_total;
            vm.referenceStats.data.perc_total_sm = vm.referenceStats.data.app_total_sm/vm.referenceStats.data.app_total;
            vm.referenceStats.data.media_scontrino = parseFloat(vm.referenceStats.data.media_scontrino)*vm.coeffCrescita;
            vm.referenceStats.data.media_scontrino_1av = parseFloat(vm.referenceStats.data.media_scontrino_1av)*vm.coeffCrescita;
            vm.referenceStats.data.app_count_sm = vm.referenceStats.data.app_count-vm.referenceStats.data.app_count_1av;
            vm.referenceStats.data.perc_sm = vm.referenceStats.data.app_count_sm/vm.referenceStats.data.app_count;
            vm.referenceStats.data.app_count_paid = Math.round(parseInt(vm.referenceStats.data.app_count_paid)*vm.conversionCoeff);
            vm.referenceStats.data.app_count_paid_1av = Math.round(parseInt(vm.referenceStats.data.app_count_paid_1av)*vm.conversionCoeff);
            vm.referenceStats.data.app_count_paid_sm = vm.referenceStats.data.app_count_paid-vm.referenceStats.data.app_count_paid_1av;
            vm.referenceStats.data.paid_perc = vm.referenceStats.data.app_count_paid/vm.referenceStats.data.app_count;
            vm.referenceStats.data.paid_perc_1av = vm.referenceStats.data.app_count_paid_1av/vm.referenceStats.data.app_count_1av;
            vm.referenceStats.data.paid_perc_sm = vm.referenceStats.data.app_count_paid_sm/vm.referenceStats.data.app_count_sm;
            vm.referenceStats.data.media_scontrino_sm = (vm.referenceStats.data.app_total-vm.referenceStats.data.app_total_1av)/vm.referenceStats.data.app_count_paid_sm;
            vm.referenceStats.availab_minutes = parseInt(vm.referenceStats.availab_minutes)*vm.conversionCoeff;
            vm.referenceStats.worked_minutes = parseInt(vm.referenceStats.worked_minutes)*vm.conversionCoeff;
            vm.referenceStats.redd_h = vm.referenceStats.data.app_total*60/vm.referenceStats.availab_minutes;
            vm.referenceStats.redd_h_w  = vm.referenceStats.data.app_total*60/vm.referenceStats.worked_minutes;

            vm.referenceStats.lead_count_1av = parseInt(vm.referenceStats.lead_count_1av)/vm.refMonths;
            vm.referenceStats.lead_count_1av_chiusi = parseInt(vm.referenceStats.lead_count_1av_chiusi)/vm.refMonths;
            vm.referenceStats.redemption_lead_1av = parseFloat(vm.referenceStats.redemption_lead_1av);
            vm.referenceStats.costo_pers = parseInt(vm.referenceStats.costo_pers)*vm.conversionCoeff;
            vm.referenceStats.costo_pers_perc = vm.referenceStats.costo_pers/vm.referenceStats.data.app_total;

        };
        vm.buildLaser = function(s) {
            if (vm.storeId) {
                s.laser_au.min_down = parseInt(s.laser_au.min_down);
                s.laser_au.min_laser_used = parseInt(s.laser_au.min_laser_used);
                s.laser_au.min_over = parseInt(s.laser_au.min_over);
                s.laser_au.min_tot = parseInt(s.laser_au.min_tot);
                s.laser_au.max_min_laser = s.laser_au.min_tot - s.laser_au.min_over;
                s.laser_au.num_laser = parseFloat(s.laser_au.num_laser);
                s.laser_au.num_rooms = parseFloat(s.laser_au.num_rooms);
                s.laser_au.min_laser_used_perc = s.laser_au.min_laser_used/s.laser_au.max_min_laser;
                s.laser_au.min_over_perc = s.laser_au.min_over/s.laser_au.min_tot;
                s.laser_au.min_down_perc = s.laser_au.min_down/s.laser_au.min_tot;
            }
        };
        vm.loadCurrentMonthPastStats = function() {
            vm.currentMonthPastStats = [];
            vm.currentMonthPastStatsOpts = {
                date_start: vm.today.format('YYYY-MM-01'),
                date_end: vm.today.format('YYYY-MM-DD')
            };
            if (vm.storeId!=0) {
                vm.currentMonthPastStatsOpts.store_id = vm.storeId;
            }
            vm.currentMonthPastStatsOpts.only_general = true;
            StatisticService.all( vm.currentMonthPastStatsOpts ).then(function( data ){
                vm.currentMonthPastStats = data.data.general;
                $log.info("carico CurrentMonthPastStats: ");
                vm.currentMonthPastStatsOpts.startDate  = moment().startOf('month');
                vm.currentMonthPastStatsOpts.endDate = vm.referenceStatsOpts.endDate;
                vm.currentMonthPastStatsOpts.date_start_frmt = vm.currentMonthPastStatsOpts.startDate.format('01');
                vm.currentMonthPastStatsOpts.date_end_frmt = vm.currentMonthPastStatsOpts.endDate.format('DD/MM');
                //$log.info(vm.currentMonthPastStatsOpts);
                //$log.info(data.data.general);

                vm.currentMonthPastStats.data.app_count = parseInt(vm.currentMonthPastStats.data.app_count);
                vm.currentMonthPastStats.data.app_count_1av = parseInt(vm.currentMonthPastStats.data.app_count_1av);
                vm.currentMonthPastStats.data.app_count_spostati = parseInt(vm.currentMonthPastStats.data.app_count_spostati);
                vm.currentMonthPastStats.data.app_count_spostati_perc = vm.currentMonthPastStats.data.app_count_spostati/(vm.currentMonthPastStats.data.app_count_spostati+vm.currentMonthPastStats.data.app_count);
                vm.currentMonthPastStats.data.app_count_paid = parseInt(vm.currentMonthPastStats.data.app_count_paid);
                vm.currentMonthPastStats.data.app_count_paid_1av = parseInt(vm.currentMonthPastStats.data.app_count_paid_1av);
                vm.currentMonthPastStats.data.app_total = parseInt(vm.currentMonthPastStats.data.app_total);
                vm.currentMonthPastStats.data.app_total_1av = parseInt(vm.currentMonthPastStats.data.app_total_1av);
                vm.currentMonthPastStats.availab_minutes = parseInt(vm.currentMonthPastStats.availab_minutes);
                vm.currentMonthPastStats.redd_h = vm.currentMonthPastStats.data.app_total*60/vm.currentMonthPastStats.availab_minutes;


                /**
                 * Valori calcolati
                 */
                vm.currentMonthPastStats.data.app_count_sm = vm.currentMonthPastStats.data.app_count-vm.currentMonthPastStats.data.app_count_1av;
                vm.currentMonthPastStats.data.perc_1av = vm.currentMonthPastStats.data.app_count_1av/vm.currentMonthPastStats.data.app_count;
                vm.currentMonthPastStats.data.perc_sm = vm.currentMonthPastStats.data.app_count_sm/vm.currentMonthPastStats.data.app_count;
                vm.currentMonthPastStats.data.app_count_paid_sm = vm.currentMonthPastStats.data.app_count_paid-vm.currentMonthPastStats.data.app_count_paid_1av;
                vm.currentMonthPastStats.data.paid_perc = vm.currentMonthPastStats.data.app_count_paid/vm.currentMonthPastStats.data.app_count;
                vm.currentMonthPastStats.data.paid_perc_1av = vm.currentMonthPastStats.data.app_count_paid_1av/vm.currentMonthPastStats.data.app_count_1av;
                vm.currentMonthPastStats.data.paid_perc_sm = vm.currentMonthPastStats.data.app_count_paid_sm/vm.currentMonthPastStats.data.app_count_sm;
                vm.currentMonthPastStats.data.app_total_sm = vm.currentMonthPastStats.data.app_total-vm.currentMonthPastStats.data.app_total_1av;
                vm.currentMonthPastStats.data.perc_total_1av = vm.currentMonthPastStats.data.app_total_1av/vm.currentMonthPastStats.data.app_total;
                vm.currentMonthPastStats.data.perc_total_sm = vm.currentMonthPastStats.data.app_total_sm/vm.currentMonthPastStats.data.app_total;
                vm.currentMonthPastStats.data.media_scontrino_sm = vm.currentMonthPastStats.data.app_total_sm/vm.currentMonthPastStats.data.app_count_paid_sm;

                /*
                 * leads
                 */
                vm.currentMonthPastStats.lead_count_1av = parseInt(vm.currentMonthPastStats.lead_count_1av);
                vm.currentMonthPastStats.lead_count_1av_chiusi = parseInt(vm.currentMonthPastStats.lead_count_1av_chiusi);
                vm.currentMonthPastStats.redemption_lead_1av = parseFloat(vm.currentMonthPastStats.redemption_lead_1av);

                vm.buildLaser(vm.currentMonthPastStats);

                vm.loadCurrentMonthFutureStats();
            });
        };
        vm.loadCurrentMonthFutureStats = function() {
            vm.currentMonthFutureStats = [];
            vm.currentMonthFutureStatsOpts = {
                date_start: vm.today.format('YYYY-MM-DD'),
                date_end: vm.nextMonth.format('YYYY-MM-01')
            };
            if (vm.storeId!=0) {
                vm.currentMonthFutureStatsOpts.store_id = vm.storeId;
            }
            vm.currentMonthFutureStatsOpts.only_general = true;
            vm.currentMonthFutureStatsOpts.costo_pers = true;
            vm.currentMonthFutureStatsOpts.target = true;
            StatisticService.all( vm.currentMonthFutureStatsOpts ).then(function( data ){
                vm.currentMonthFutureStats = data.data.general;
                $log.info("carico loadCurrentMonthFutureStats: ");
                vm.currentMonthFutureStatsOpts.startDate  = vm.today;
                vm.currentMonthFutureStatsOpts.endDate = moment().endOf('month');
                vm.currentMonthFutureStatsOpts.date_start_frmt = vm.currentMonthFutureStatsOpts.startDate.format('DD');
                vm.currentMonthFutureStatsOpts.date_end_frmt = vm.currentMonthFutureStatsOpts.endDate.format('DD/MM');
                //$log.info(vm.currentMonthFutureStatsOpts);
                //$log.info(data.data.general);
                /**
                 * Ricalcolo prev e total prendendo i dati da Past e Reference
                 */
                vm.currentMonthFutureStats.data.media_scontrino = vm.referenceStats.data.media_scontrino;
                vm.currentMonthFutureStats.data.media_scontrino_1av = vm.referenceStats.data.media_scontrino_1av;
                vm.currentMonthFutureStats.data.media_scontrino_sm = vm.referenceStats.data.media_scontrino_sm;


                var prev = {};
                vm.currentMonthFutureStats.data.app_count_1av = parseInt(vm.currentMonthFutureStats.data.app_count_1av);
                vm.currentMonthFutureStats.data.app_count = parseInt(vm.currentMonthFutureStats.data.app_count);
                vm.currentMonthFutureStats.availab_minutes = parseInt(vm.currentMonthFutureStats.availab_minutes);

                /**
                 * Rapporta i dati di confronto ai giorni di questo periodo
                 */
                vm.relateReferenceStatToDays(parseInt(vm.currentMonthFutureStats.work_days)+parseInt(vm.currentMonthPastStats.work_days));


                prev.app_count_paid = Math.round(vm.currentMonthFutureStats.data.app_count*vm.referenceStats.data.paid_perc);
                prev.app_count_paid_1av = Math.round(vm.currentMonthFutureStats.data.app_count_1av*vm.referenceStats.data.paid_perc_1av);
                prev.app_count_paid_sm = prev.app_count_paid-prev.app_count_paid_1av;
                prev.app_total_1av = vm.referenceStats.data.media_scontrino_1av*prev.app_count_paid_1av;
                prev.app_total_sm = vm.referenceStats.data.media_scontrino_sm*prev.app_count_paid_sm;
                prev.app_total = prev.app_total_1av+prev.app_total_sm;
                prev.redd_h = prev.app_total*60/vm.currentMonthFutureStats.availab_minutes;



                vm.currentMonthFutureStats.data.app_count_paid = prev.app_count_paid;
                vm.currentMonthFutureStats.data.app_count_paid_1av = prev.app_count_paid_1av;
                vm.currentMonthFutureStats.data.app_count_paid_sm = prev.app_count_paid_sm;
                vm.currentMonthFutureStats.data.app_total = prev.app_total;
                vm.currentMonthFutureStats.data.app_total_1av = prev.app_total_1av;
                vm.currentMonthFutureStats.data.app_total_sm = prev.app_total_sm;
                vm.currentMonthFutureStats.redd_h = prev.redd_h;
                /*
                 * leads
                 */
                vm.currentMonthFutureStats.lead_count_1av = vm.currentMonthPastStats.lead_count_1av/(vm.today.date()-1)*(moment().daysInMonth()-vm.today.date()+1);
                vm.currentMonthFutureStats.lead_count_1av_chiusi = Math.round(vm.currentMonthFutureStats.lead_count_1av*vm.referenceStats.redemption_lead_1av);
                vm.currentMonthFutureStats.redemption_lead_1av = vm.currentMonthFutureStats.lead_count_1av_chiusi/vm.currentMonthFutureStats.lead_count_1av;

                vm.currentMonthFutureStats.data.app_count_sm = vm.currentMonthFutureStats.data.app_count-vm.currentMonthFutureStats.data.app_count_1av;
                vm.currentMonthFutureStats.data.perc_1av = vm.currentMonthFutureStats.data.app_count_1av/vm.currentMonthFutureStats.data.app_count;
                vm.currentMonthFutureStats.data.perc_sm = vm.currentMonthFutureStats.data.app_count_sm/vm.currentMonthFutureStats.data.app_count;
                vm.currentMonthFutureStats.data.app_count_paid_sm = vm.currentMonthFutureStats.data.app_count_paid-vm.currentMonthFutureStats.data.app_count_paid_1av;
                vm.currentMonthFutureStats.data.paid_perc = vm.currentMonthFutureStats.data.app_count_paid/vm.currentMonthFutureStats.data.app_count;
                vm.currentMonthFutureStats.data.paid_perc_1av = vm.currentMonthFutureStats.data.app_count_paid_1av/vm.currentMonthFutureStats.data.app_count_1av;
                vm.currentMonthFutureStats.data.paid_perc_sm = vm.currentMonthFutureStats.data.app_count_paid_sm/vm.currentMonthFutureStats.data.app_count_sm;
                vm.currentMonthFutureStats.data.app_total_sm = vm.currentMonthFutureStats.data.app_total-vm.currentMonthFutureStats.data.app_total_1av;
                vm.currentMonthFutureStats.data.perc_total_1av = vm.currentMonthFutureStats.data.app_total_1av/vm.currentMonthFutureStats.data.app_total;
                vm.currentMonthFutureStats.data.perc_total_sm = vm.currentMonthFutureStats.data.app_total_sm/vm.currentMonthFutureStats.data.app_total;
                vm.currentMonthFutureStats.data.media_scontrino_sm = vm.currentMonthFutureStats.data.app_total_sm/vm.currentMonthFutureStats.data.app_count_paid_sm;


                vm.buildLaser(vm.currentMonthFutureStats);

                var total = {};
                total.app_count = vm.currentMonthPastStats.data.app_count+vm.currentMonthFutureStats.data.app_count;
                total.app_count_1av = vm.currentMonthPastStats.data.app_count_1av+vm.currentMonthFutureStats.data.app_count_1av;
                total.app_count_paid = vm.currentMonthPastStats.data.app_count_paid+prev.app_count_paid;
                total.app_count_paid_1av = vm.currentMonthPastStats.data.app_count_paid_1av+prev.app_count_paid_1av;
                total.app_total_1av = vm.currentMonthPastStats.data.app_total_1av+prev.app_total_1av;
                total.app_total = vm.currentMonthPastStats.data.app_total+prev.app_total;
                total.media_scontrino = total.app_total/total.app_count_paid;
                total.media_scontrino_1av = total.app_total_1av/total.app_count_paid_1av;
                total.availab_minutes = vm.currentMonthPastStats.availab_minutes+vm.currentMonthFutureStats.availab_minutes;
                total.redd_h = total.app_total*60/total.availab_minutes;
                total.availab_minutes = vm.currentMonthPastStats.availab_minutes+vm.currentMonthFutureStats.availab_minutes;
                total.worked_minutes = vm.currentMonthPastStats.worked_minutes+vm.currentMonthFutureStats.worked_minutes;
                total.worked_minutes_perc = total.worked_minutes/total.availab_minutes;
                total.redd_h_w = total.app_total*60/total.worked_minutes;
                total.costo_pers = parseFloat(vm.currentMonthFutureStats.costo_pers);
                total.costo_pers_perc = total.costo_pers/total.app_total;

                total.app_count_sm = total.app_count-total.app_count_1av;
                total.perc_1av = total.app_count_1av/total.app_count;
                total.perc_sm = total.app_count_sm/total.app_count;
                total.app_count_paid_sm = total.app_count_paid-total.app_count_paid_1av;
                total.paid_perc = total.app_count_paid/total.app_count;
                total.paid_perc_1av = total.app_count_paid_1av/total.app_count_1av;
                total.paid_perc_sm = total.app_count_paid_sm/total.app_count_sm;
                total.app_total_sm = total.app_total-total.app_total_1av;
                total.perc_total_1av = total.app_total_1av/total.app_total;
                total.perc_total_sm = total.app_total_sm/total.app_total;
                total.media_scontrino_sm = total.app_total_sm/total.app_count_paid_sm;

                total.lead_count_1av = vm.currentMonthPastStats.lead_count_1av+vm.currentMonthFutureStats.lead_count_1av;
                total.lead_count_1av_chiusi = vm.currentMonthPastStats.lead_count_1av_chiusi+vm.currentMonthFutureStats.lead_count_1av_chiusi;
                total.redemption_lead_1av = total.lead_count_1av_chiusi/total.lead_count_1av;

                if (vm.storeId) {
                    total.min_down = vm.currentMonthPastStats.laser_au.min_down+vm.currentMonthFutureStats.laser_au.min_down;
                    total.min_laser_used = vm.currentMonthPastStats.laser_au.min_laser_used+vm.currentMonthFutureStats.laser_au.min_laser_used;
                    total.max_min_laser = vm.currentMonthPastStats.laser_au.max_min_laser+vm.currentMonthFutureStats.laser_au.max_min_laser;
                    total.min_over = vm.currentMonthPastStats.laser_au.min_over+vm.currentMonthFutureStats.laser_au.min_over;
                    total.min_tot = vm.currentMonthPastStats.laser_au.min_tot+vm.currentMonthFutureStats.laser_au.min_tot;
                    total.num_laser = vm.currentMonthFutureStats.laser_au.num_laser;
                    total.num_rooms = vm.currentMonthFutureStats.laser_au.num_rooms;
                    total.min_laser_used_perc = total.min_laser_used/total.max_min_laser;
                    total.min_over_perc = total.min_over/total.min_tot;
                    total.min_down_perc = total.min_down/total.min_tot;
                }

                total.date = {
                        startDate: vm.currentMonthPastStatsOpts.startDate,
                        endDate: vm.currentMonthFutureStatsOpts.endDate
                }
                var trendPerc = {};
                trendPerc.app_count = (total.app_count-vm.referenceStats.data.app_count)*100/vm.referenceStats.data.app_count;
                trendPerc.app_count_1av = (total.app_count_1av-vm.referenceStats.data.app_count_1av)*100/vm.referenceStats.data.app_count_1av;
                trendPerc.app_count_paid = (total.app_count_paid-vm.referenceStats.data.app_count_paid)*100/vm.referenceStats.data.app_count_paid;
                trendPerc.app_count_paid_1av = (total.app_count_paid_1av-vm.referenceStats.data.app_count_paid_1av)*100/vm.referenceStats.data.app_count_paid_1av;
                trendPerc.app_total = (total.app_total-vm.referenceStats.data.app_total)*100/vm.referenceStats.data.app_total;
                trendPerc.app_total_1av = (total.app_total_1av-vm.referenceStats.data.app_total_1av)*100/vm.referenceStats.data.app_total_1av;
                trendPerc.media_scontrino = (total.media_scontrino-vm.referenceStats.data.media_scontrino)*100/vm.referenceStats.data.media_scontrino;
                trendPerc.media_scontrino_1av = (total.media_scontrino_1av-vm.referenceStats.data.media_scontrino_1av)*100/vm.referenceStats.data.media_scontrino_1av;
                trendPerc.availab_minutes = (total.availab_minutes-vm.referenceStats.availab_minutes)*100/vm.referenceStats.availab_minutes;
                trendPerc.redd_h = (total.redd_h-vm.referenceStats.redd_h)*100/vm.referenceStats.redd_h;
                trendPerc.worked_minutes = (total.worked_minutes-vm.referenceStats.worked_minutes)*100/vm.referenceStats.worked_minutes;
                trendPerc.redd_h_w = (total.redd_h_w-vm.referenceStats.redd_h_w)*100/vm.referenceStats.redd_h_w;
                trendPerc.worked_minutes_perc = (total.worked_minutes_perc-vm.referenceStats.worked_minutes_perc)*100/vm.referenceStats.worked_minutes_perc;
                trendPerc.costo_pers = (total.costo_pers-vm.referenceStats.costo_pers)*100/vm.referenceStats.costo_pers;
                trendPerc.costo_pers_perc = (total.costo_pers_perc-vm.referenceStats.costo_pers_perc)*100/vm.referenceStats.costo_pers_perc;

                trendPerc.app_count_sm = (total.app_count_sm-vm.referenceStats.data.app_count_sm)*100/vm.referenceStats.data.app_count_sm;
                trendPerc.perc_1av = (total.perc_1av-vm.referenceStats.data.perc_1av)*100/vm.referenceStats.data.perc_1av;
                trendPerc.perc_sm = (total.perc_sm-vm.referenceStats.data.perc_sm)*100/vm.referenceStats.data.perc_sm;
                trendPerc.app_count_paid_sm = (total.app_count_paid_sm-vm.referenceStats.data.app_count_paid_sm)*100/vm.referenceStats.data.app_count_paid_sm;
                trendPerc.paid_perc = (total.paid_perc-vm.referenceStats.data.paid_perc)*100/vm.referenceStats.data.paid_perc;
                trendPerc.paid_perc_1av = (total.paid_perc_1av-vm.referenceStats.data.paid_perc_1av)*100/vm.referenceStats.data.paid_perc_1av;
                trendPerc.paid_perc_sm = (total.paid_perc_sm-vm.referenceStats.data.paid_perc_sm)*100/vm.referenceStats.data.paid_perc_sm;
                trendPerc.app_total_sm = (total.app_total_sm-vm.referenceStats.data.app_total_sm)*100/vm.referenceStats.data.app_total_sm;
                trendPerc.perc_total_1av = (total.perc_total_1av-vm.referenceStats.data.perc_total_1av)*100/vm.referenceStats.data.perc_total_1av;
                trendPerc.perc_total_sm = (total.perc_total_sm-vm.referenceStats.data.perc_total_sm)*100/vm.referenceStats.data.perc_total_sm;
                trendPerc.media_scontrino_sm = (total.media_scontrino_sm-vm.referenceStats.data.media_scontrino_sm)*100/vm.referenceStats.data.media_scontrino_sm;

                /**
                 * leads
                 */
                trendPerc.lead_count_1av = (total.lead_count_1av-vm.referenceStats.lead_count_1av)*100/vm.referenceStats.lead_count_1av;
                trendPerc.lead_count_1av_chiusi = (total.lead_count_1av_chiusi-vm.referenceStats.lead_count_1av_chiusi)*100/vm.referenceStats.lead_count_1av_chiusi;
                trendPerc.redemption_lead_1av = (total.redemption_lead_1av-vm.referenceStats.redemption_lead_1av)*100/vm.referenceStats.redemption_lead_1av;

                if (vm.storeId) {
                    trendPerc.num_laser = (total.num_laser-vm.referenceStats.laser_au.num_laser)*100/vm.referenceStats.laser_au.num_laser;
                    trendPerc.num_rooms = (total.num_rooms-vm.referenceStats.laser_au.num_rooms)*100/vm.referenceStats.laser_au.num_rooms;
                    trendPerc.min_laser_used_perc = (total.min_laser_used_perc-vm.referenceStats.laser_au.min_laser_used_perc)*100/vm.referenceStats.laser_au.min_laser_used_perc;
                    trendPerc.min_over_perc = (total.min_over_perc-vm.referenceStats.laser_au.min_over_perc)*100/vm.referenceStats.laser_au.min_over_perc;
                    trendPerc.min_down_perc = (total.min_down_perc-vm.referenceStats.laser_au.min_down_perc)*100/vm.referenceStats.laser_au.min_down_perc;
                }


                vm.currentMonthFutureStats.prev = prev;
                vm.currentMonthFutureStats.total = total;
                vm.currentMonthFutureStats.trendPerc = trendPerc;
                /*
                 * inizializzo le variabili per il form di simulazione
                 */
                vm.currentMonthFutureStats.simulate = {};
                vm.currentMonthFutureStats.simulate.media_scontrino = Math.round(vm.referenceStats.data.media_scontrino*100)/100;
                vm.currentMonthFutureStats.simulate.media_scontrino_1av = Math.round(vm.referenceStats.data.media_scontrino_1av*100)/100;
                vm.currentMonthFutureStats.simulate.perc_1av = vm.referenceStats.data.perc_1av;
                vm.currentMonthFutureStats.simulate.paid_perc = vm.referenceStats.data.paid_perc;
                vm.currentMonthFutureStats.simulate.paid_perc_1av = vm.referenceStats.data.paid_perc_1av;
                vm.currentMonthFutureStats.simulate.paid_perc_sm = vm.referenceStats.data.paid_perc_sm;
                vm.currentMonthFutureStats.simulate.app_total = vm.currentMonthFutureStats.obiettivo;

                vm.deltaCurr = {};
                //costante la inizializzo solo qui
                vm.deltaCurr.app_total  = vm.currentMonthFutureStats.simulate.app_total - vm.currentMonthFutureStats.total.app_total;

                vm.onBlurCurrentMediaScontrino();
                vm.loading = false;
            });
        };
        /*
         * cambia il parametro media scontrino
         */
        vm.onBlurCurrentMediaScontrino = function() {
            /**
             * variabili
             */
            vm.deltaCurr.app_count_paid = Math.round(vm.deltaCurr.app_total/vm.currentMonthFutureStats.simulate.media_scontrino);
            vm.deltaCurr.app_count = Math.round(vm.deltaCurr.app_count_paid/vm.currentMonthFutureStats.simulate.paid_perc);
            vm.deltaCurr.media_scontrino = vm.currentMonthFutureStats.simulate.media_scontrino-vm.referenceStats.data.media_scontrino;
            vm.currentMonthFutureStats.simulate.app_count = vm.currentMonthFutureStats.total.app_count + vm.deltaCurr.app_count;
        };
        /*
         * cambia il parametro delta app_count
         */
        vm.onBlurCurrentAppCount = function() {
            vm.deltaCurr.app_count = vm.currentMonthFutureStats.simulate.app_count - vm.currentMonthFutureStats.total.app_count;
            vm.deltaCurr.app_count_paid = Math.round(vm.deltaCurr.app_count*vm.currentMonthFutureStats.simulate.paid_perc);
            vm.currentMonthFutureStats.simulate.media_scontrino = Math.round(vm.deltaCurr.app_total*100/vm.deltaCurr.app_count_paid)/100;
        };
        vm.loadNextMonthStats = function() {
            vm.loading = true;
            vm.nextMonthStats = [];
            vm.nextMonthStatsOpts = {
                date_start: vm.nextMonth.format('YYYY-MM-01'),
                date_end: moment().add(2,'months').format('YYYY-MM-01')
            };
            if (vm.storeId!=0) {
                vm.nextMonthStatsOpts.store_id = vm.storeId;
            }
            vm.nextMonthStatsOpts.only_general = true;
            vm.nextMonthStatsOpts.target = true;
            StatisticService.all( vm.nextMonthStatsOpts ).then(function( data ){
                vm.nextMonthStats = data.data.general;
                $log.info("carico loadNextMonthStats: ");

                vm.nextMonthStatsOpts.startDate = moment().add(1,'months').startOf('month');
                vm.nextMonthStatsOpts.endDate = moment().add(1,'months').endOf('month');
                vm.nextMonthStatsOpts.date_start_frmt = vm.nextMonthStatsOpts.startDate.format('MMMM');
                vm.nextMonthStatsOpts.date_end_frmt = vm.nextMonthStatsOpts.endDate.format('YYYY');

                //$log.info(vm.nextMonthStatsOpts);
                //$log.info(data.data.general);

                vm.nextMonthStats.data.media_scontrino = vm.referenceStats.data.media_scontrino;
                vm.nextMonthStats.data.media_scontrino_1av = vm.referenceStats.data.media_scontrino_1av;
                vm.nextMonthStats.data.media_scontrino_sm = vm.referenceStats.data.media_scontrino_sm;

                /**
                 * devo calcolare prev in base a reference
                 */
                var prev = {};
                prev.app_count_paid = Math.round(parseInt(vm.nextMonthStats.data.app_count)*vm.referenceStats.data.paid_perc);
                prev.app_count_paid_1av = Math.round(parseInt(vm.nextMonthStats.data.app_count_1av)*vm.referenceStats.data.paid_perc_1av);
                prev.app_count_paid_sm = prev.app_count_paid-prev.app_count_paid_1av;
                prev.app_total_1av = vm.referenceStats.data.media_scontrino_1av*prev.app_count_paid_1av;
                prev.app_total_sm = vm.referenceStats.data.media_scontrino_sm*prev.app_count_paid_sm;
                prev.app_total = prev.app_total_1av+prev.app_total_sm;

                vm.nextMonthStats.prev = prev;

                vm.nextMonthStats.data.app_count_paid = prev.app_count_paid;
                vm.nextMonthStats.data.app_count_paid_1av = prev.app_count_paid_1av;
                vm.nextMonthStats.data.app_count_paid_sm = prev.app_count_paid_sm;
                vm.nextMonthStats.data.app_total = prev.app_total;
                vm.nextMonthStats.data.app_total_1av = prev.app_total_1av;
                vm.nextMonthStats.data.app_total_sm = prev.app_total_sm;

                vm.nextMonthStats.target = {app_total: parseFloat(vm.nextMonthStats.target)};
                vm.nextMonthStats.target.media_scontrino = Math.round(vm.referenceStats.data.media_scontrino*100)/100;
                vm.nextMonthStats.target.media_scontrino_1av = Math.round(vm.referenceStats.data.media_scontrino_1av*100)/100;
                vm.nextMonthStats.target.perc_1av = vm.referenceStats.data.perc_1av;
                vm.nextMonthStats.target.paid_perc = vm.referenceStats.data.paid_perc;
                vm.nextMonthStats.target.paid_perc_1av = vm.referenceStats.data.paid_perc_1av;
                vm.nextMonthStats.target.paid_perc_sm = vm.referenceStats.data.paid_perc_sm;

                vm.onBlurNextMediaScontrino();
                vm.loading = false;
            });
        }
        vm.onBlurNextMediaScontrino = function() {
            vm.nextMonthStats.target.app_count_paid = Math.round(vm.nextMonthStats.target.app_total/vm.nextMonthStats.target.media_scontrino);
            vm.nextMonthStats.target.app_count = Math.round(vm.nextMonthStats.target.app_count_paid/vm.nextMonthStats.target.paid_perc);
            vm.computeDeltaNext();
        };
        vm.onBlurNextAppCount = function() {
            vm.nextMonthStats.target.app_count_paid = Math.round(vm.nextMonthStats.target.app_count*vm.nextMonthStats.target.paid_perc);
            vm.nextMonthStats.target.media_scontrino = Math.round(vm.nextMonthStats.target.app_total*100/vm.nextMonthStats.target.app_count_paid)/100;
            vm.computeDeltaNext();
        };
        vm.computeDeltaNext = function() {
            vm.deltaNext = {};
            vm.deltaNext.app_count          = vm.nextMonthStats.target.app_count        - vm.nextMonthStats.data.app_count;
            vm.deltaNext.app_count_paid     = vm.nextMonthStats.target.app_count_paid   - vm.nextMonthStats.data.app_count_paid;
            vm.deltaNext.app_total          = vm.nextMonthStats.target.app_total        - vm.nextMonthStats.data.app_total;
            vm.deltaNext.media_scontrino    = vm.nextMonthStats.target.media_scontrino  - vm.nextMonthStats.data.media_scontrino;
        };


        vm.loadPrevisione = function() {
            vm.loadReferenceStats();
        };


        /**
         * Carico dati eventi futuri e relative informazioni
         */
        vm.futureEvents = [];
        vm.pastEvents = [];
        vm.dataOggi = moment().format('YYYY-MM-DD');
        vm.loadEvents = function() {
            vm.loading = true;
            vm.futureEvents = [];
            vm.pastEvents = [];
            var pars = {};
            if (vm.storeId!=0) {
                pars.store_id = vm.storeId;
            }
            CrudService.all( 'events', pars, vm,
                    function(response) {
                        //$log.info(response);
                        angular.forEach(response.data.data, function(event) {
                            event.date_frmt = moment(event.datetime).format("DD/MM/YYYY");
                            if (event.datetime<vm.dataOggi) {
                                vm.pastEvents.push(event);
                            } else {
                                vm.futureEvents.push(event);
                            }
                        });
                        vm.loading = false;
                    },
                    function() {
                        vm.loading = false;
                    }
                    )
        };

        vm.chart1 = {labels:[],series:[],data:[],
            options:{
                legend: { display: true },
                scales: {
                        xAxes: [{
                                stacked: false
                        }],
                        yAxes: [{
                                stacked: false,
                                ticks: {
                                    beginAtZero:true
                                }
                        }]
                    }
                }
        };
        vm.chart1 = {labels:[],series:[],data:[],
                options:{
                    legend: { display: true }
                }
        };
        var chart1 = function(statistics){
            //vm.labels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
            vm.chart1.labels = _.keys(statistics);
            vm.chart1.series = ['Minuti disponibili', 'Minuti lavorati'];
            vm.chart1.data = [[],[]];
            var k = 0;
            angular.forEach(statistics, function(value) {
              this[0].push(parseInt(value.availabilities));
              this[1].push(parseInt(value.worked));

              var perc = parseInt(parseInt(value.worked)*100/parseInt(value.availabilities));
              vm.chart1.labels[k] = vm.chart1.labels[k] + ' ('+perc+'%)';
              k = k+1;

            }, vm.chart1.data);
            /*vm.data = [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ];*/
        };

        vm.chart2 = {labels:[],series:[],data:[],
            options:{
                legend: { display: true },
                scales: {
                        xAxes: [{
                                stacked: false
                        }],
                        yAxes: [{
                                stacked: false,
                                ticks: {
                                    beginAtZero:true
                                }
                        }]
                    }
                }
        };
        var chart2 = function(statistics){
            //vm.labels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
            vm.chart2.labels = _.keys(statistics);
            vm.chart2.series = ['Appuntamenti',/*'Avvisati','Non risp.',*/ 'Disdetti', 'Spostati', 'Presentati','No Show'];
            vm.chart2.data = [[],[],[],[],[]];
            angular.forEach(statistics, function(value) {
              this[0].push(parseInt(value.appointments));
              //this[1].push(parseInt(value.appointments_recalled));
              //this[2].push(parseInt(value.appointments_recalled_norisp));
              this[1].push(parseInt(value.appointments_recalled_disd));
              this[2].push(parseInt(value.appointments_recalled_spost));
              this[3].push(parseInt(value.appointments_paid));
              this[4].push(parseInt(value.appointments_no_show));
              //this[1].push(parseInt(value.worked));
            }, vm.chart2.data);
            /*vm.data = [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ];*/
        };

        vm.chart3 = {labels:[],series:[],data:[],
            options:{
                legend: { display: true },
                scales: {
                        xAxes: [{
                                stacked: false
                        }],
                        yAxes: [{
                                stacked: false,
                                ticks: {
                                    beginAtZero:true
                                }
                        }]
                    }
                }
        };
        vm.chart3_type = true;
        vm.chart3 = {labels:[],series:[],data:[],
                options:{
                    legend: { display: true },
                    scales: {
                        xAxes: [{
                                stacked: false
                        }],
                        yAxes: [{
                                stacked: false,
                                ticks: {
                                    beginAtZero:true
                                }
                        }]
                    }
                }
        };
        var chart3_num = function(statistics){
            vm.chart3.labels = [];
            angular.forEach(statistics, function(value, key) {
                if (value.appointments_paid && value.appointments_paid>0) {
                    vm.chart3.labels.push(key);
                }
            });
            vm.chart3.series = ['Incasso totale','Incasso 1a v.','Incasso smalt.'];
            vm.chart3.data = [[],[],[]];
            angular.forEach(statistics, function(value) {
                if (value.appointments_paid && value.appointments_paid>0) {
                    this[0].push(parseInt(value.profit));
                    this[1].push(parseInt(value.profit1av));
                    this[2].push(parseInt(value.profitsm));
                }
            }, vm.chart3.data);
        };

        var chart3_perc = function(statistics){
            vm.chart3.labels = [];
            angular.forEach(statistics, function(value, key) {
                if (value.appointments_paid && value.appointments_paid>0) {
                    vm.chart3.labels.push(key);
                }
            });

            vm.chart3.series = ['Scontrino medio','1a volta','Smaltimento'];
            vm.chart3.data = [[],[],[]];
            angular.forEach(statistics, function(value) {
                if (value.appointments_paid && value.appointments_paid>0) {
                    var media = parseFloat(parseFloat(value.profit)/parseInt(value.appointments_paid));
                    var media1av = parseFloat(parseFloat(value.profit1av)/parseInt(value.appointments_first_time_paid));
                    var mediasm = parseFloat(parseFloat(value.profit)/parseInt(value.appointments_no_first_time_paid));
                    this[0].push(_.round(media,2));
                    this[1].push(_.round(media1av,2));
                    this[2].push(_.round(mediasm,2));
                }
            }, vm.chart3.data);
        };
        vm.change_chart3 = function(){
            if(vm.chart3_type){
                chart3_num( vm.statistics.operators );
            }else{
                chart3_perc( vm.statistics.operators );
            }
            vm.chart3_type = !vm.chart3_type;
        };

        vm.chart4 = {labels:[],series:[],data:[],
                options:{
                    legend: { display: true },
                    scales: {
                        xAxes: [{
                                stacked: false
                        }],
                        yAxes: [{
                                stacked: false,
                                ticks: {
                                    beginAtZero:true
                                }
                        }]
                    }
                }
        };
        var chart4 = function(statistics){
            //vm.labels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
            vm.chart4.labels = _.keys(statistics);
            vm.chart4.series = ['Trattamenti'];
            vm.chart4.data = [[]];
            var k = 0;
            var tot = _.reduce(statistics, function(sum, n) {
              return sum + n;
            }, 0);
            angular.forEach(statistics, function(value) {
              this[0].push(parseInt(value));

              var perc = parseInt(parseInt(value)*100/parseInt(tot));
              vm.chart4.labels[k] = vm.chart4.labels[k] + ' ('+perc+'%)';
              k = k+1;

            }, vm.chart4.data);


        };

        vm.chart5 = {labels:[],series:[],data:[],
            options:{
                legend: { display: true },
                scales: {
                        xAxes: [{
                                stacked: false
                        }],
                        yAxes: [{
                                stacked: false,
                                ticks: {
                                    beginAtZero:true
                                }
                        }]
                    }
                }
        };
        vm.chart5_type = true;
        var chart5_num = function(statistics){
            vm.chart5.labels = [];
            angular.forEach(statistics, function(value, key) {
                if (value.appointments_first_time_show && value.appointments_first_time_show>0) {
                    vm.chart5.labels.push(key);
                }
            });
            vm.chart5.series = ['Clienti 1° volta','Clienti 1° volta pagato','Clienti fidelizzati'];
            vm.chart5.data = [[],[],[]];
            var k = 0;
            angular.forEach(statistics, function(value) {
                if (value.appointments_first_time_show && value.appointments_first_time_show>0) {
                    this[0].push(parseInt(value.appointments_first_time_show));
                    this[1].push(parseInt(value.appointments_first_time_paid?value.appointments_first_time_paid:0));
                    this[2].push(parseInt(value.appointments_loyal?value.appointments_loyal:0));
                    if (value.appointments_first_time_show) {
                        var perc = parseInt(parseInt(value.appointments_loyal)*100/parseInt(value.appointments_first_time_show));
                        vm.chart5.labels[k] = vm.chart5.labels[k] + ' ('+perc+'%)';
                    }
                    k = k+1;
                }
            }, vm.chart5.data);
        };
        var chart5_perc = function(statistics){
            vm.chart5.labels = [];
            angular.forEach(statistics, function(value, key) {
                if (value.appointments_first_time_show && value.appointments_first_time_show>0) {
                    vm.chart5.labels.push(key);
                }
            });
            //vm.chart5.labels = _.keys(statistics);
            vm.chart5.series = ['% Clienti fidelizzati'];
            vm.chart5.data = [[]];
            var k = 0;
            angular.forEach(statistics, function(value) {
                if (value.appointments_first_time_show && value.appointments_first_time_show>0) {
                    var perc = parseInt(parseInt(value.appointments_loyal)*100/parseInt(value.appointments_first_time_show));
                    this[0].push(parseInt(perc));
                    vm.chart5.labels[k] = vm.chart5.labels[k] + ' ('+value.appointments_loyal+' su ' +value.appointments_first_time_show+')'; //+ ' ('+perc+'%)';
                    k = k+1;
                }
            }, vm.chart5.data);
        };

        vm.change_chart5 = function(){
            $log.info(vm.statistics.operators);
            if(vm.chart5_type){
                chart5_num( vm.statistics.operators );
            }else{
                chart5_perc( vm.statistics.operators );
            }
            vm.chart5_type = !vm.chart5_type;
        };

        /**
         * fidelizzazione smaltimento
         */
        vm.chart5sm = {labels:[],series:[],data:[],
            options:{
                legend: { display: true },
                scales: {
                        xAxes: [{
                                stacked: false
                        }],
                        yAxes: [{
                                stacked: false,
                                ticks: {
                                    beginAtZero:true
                                }
                        }]
                    }
                }
        };
        vm.chart5sm_type = true;
        var chart5sm_num = function(statistics){
            vm.chart5sm.labels = [];
            angular.forEach(statistics, function(value, key) {
                if (value.appointments_no_first_time_show && value.appointments_no_first_time_show>0) {
                    vm.chart5sm.labels.push(key);
                }
            });
            vm.chart5sm.series = ['Clienti smalt.','Clienti smalt. pagato','Clienti smalt. fidelizzati'];
            vm.chart5sm.data = [[],[],[]];
            var k = 0;
            angular.forEach(statistics, function(value) {
                if (value.appointments_no_first_time_show && value.appointments_no_first_time_show>0) {
                    this[0].push(parseInt(value.appointments_no_first_time_show));
                    this[1].push(parseInt(value.appointments_no_first_time_paid?value.appointments_no_first_time_paid:0));
                    this[2].push(parseInt(value.appointments_no_first_time_loyal?value.appointments_no_first_time_loyal:0));
                    var perc = 0;
                    if (value.appointments_no_first_time_show) {
                        perc = parseInt(parseInt(value.appointments_no_first_time_loyal)*100/parseInt(value.appointments_no_first_time_show));
                        vm.chart5sm.labels[k] = vm.chart5sm.labels[k] + ' ('+perc+'%)';
                    }
                    k = k+1;
                }
            }, vm.chart5sm.data);
            //$log.info(vm.chart5sm);
        };
        var chart5sm_perc = function(statistics){
            vm.chart5sm.labels = [];
            angular.forEach(statistics, function(value, key) {
                if (value.appointments_no_first_time_show && value.appointments_no_first_time_show>0) {
                    vm.chart5sm.labels.push(key);
                }
            });
            //vm.chart5.labels = _.keys(statistics);
            vm.chart5sm.series = ['% Clienti fidelizzati'];
            vm.chart5sm.data = [[]];
            var k = 0;
            angular.forEach(statistics, function(value) {
                if (value.appointments_no_first_time_show && value.appointments_no_first_time_show>0) {
                    var perc = parseInt(parseInt(value.appointments_no_first_time_loyal)*100/parseInt(value.appointments_no_first_time_show));
                    this[0].push(parseInt(perc));
                    vm.chart5sm.labels[k] = vm.chart5sm.labels[k] + ' ('+value.appointments_no_first_time_loyal+' su ' +value.appointments_no_first_time_show+')'; //+ ' ('+perc+'%)';
                    k = k+1;
                }

            }, vm.chart5sm.data);
        };

        vm.change_chart5sm = function(){
            $log.info(vm.statistics.operators);
            if(vm.chart5sm_type){
                chart5sm_num( vm.statistics.operators );
            }else{
                chart5sm_perc( vm.statistics.operators );
            }
            vm.chart5sm_type = !vm.chart5sm_type;
        };


        /*$timeout( function(){
            reload( vm.date );
        }, 500 );*/


        /* WATCHO Lo Store */
        vm.storeId = null;
        vm.store = {};
        vm.storesList = [];
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                if (vm.storeId == null) {
                  vm.storeId = id;
                  vm.storesList = $scope.$parent.main.storesList;
                } else {
                   vm.storeId = id;
                }
                if (id == 0) {
                    vm.store = {id: 0, alias: 'Tutti i centri'};
                } else {
                    angular.forEach(vm.storesList, function(s) {
                        if (s.id == vm.storeId) {
                            vm.store = s;
                        }
                    });
                }
                vm.loadEvents();
                $log.info("selectedStoreChanged storeId: "+vm.storeId + ", selectedIndex is: "+vm.selectedIndex);
                if (vm.selectedIndex == 1) {
                    vm.reload();
                } else if (vm.selectedIndex == 2) {
                    vm.loadPrevisione();
                }
            };
        });
    };

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('CustomerQuotationsDetailsController', CustomerQuotationsDetailsController);

    /** @ngInject */
    function CustomerQuotationsDetailsController(
        $window,
        $scope,
        $log,
        $http,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdMedia,
        $mdToast,
        $filter,
        $sce,
        env,
        CrudService,
        $stateParams,
        $state,
        UsersService,
        $rootScope
    ) {

        $scope.customerSurvey = {};

        var vm = this;
        $log.info('CustomerQuotationsDetailsController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }

        vm.customer_quotation_id = $stateParams.customer_quotation_id;
        var customer_quotation_id = vm.customer_quotation_id;
        if (customer_quotation_id == null) {
            $state.go("home.customer-quotations");
            return;
        }

        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        vm.query = {
            filter: '',
            order: ''
        };

        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.order = '';
        };
        vm.eListTotal = 0;
        vm.loading = true;
        vm.saveDocument = false;
        vm.mainEntity = null;


        vm.getNewEmptyProdInv = function(quotationEntry) {
            return {
                customer_quotation: vm.mainEntity,
                customer_quotation_id: vm.mainEntity.id,
                quotation_entry_id: quotationEntry.id,
                price: parseFloat(quotationEntry.price),
                quantity: 1,
                checked: false,
                note: ""
            };
        };


        vm.saveCustomerQuotationEntry = function(prodInv) {

            if (prodInv.saving) return;

            vm.loading = true;
            prodInv.saving = true;

            if( !prodInv.checked ) {

                CrudService.save( 'customer_quotations_entries', prodInv, vm ,
                    function(response) {
                        vm.eListTotal += parseFloat(prodInv.price) * prodInv.quantity;

                        prodInv.saving = false;
                        prodInv.id = response.data.data.id;
                        prodInv.checked = true;

                        vm.loading = false;
                    },
                    function(response) {
                        prodInv.saving = false;
                        prodInv.checked = false;

                        vm.loading = false;
                    });

            } else { //DELETE THIS ITEM

                CrudService.del( 'customer_quotations_entries', prodInv.id, vm,
                    function(response) {
                        vm.eListTotal -= parseFloat(prodInv.price) * prodInv.quantity;

                        prodInv.saving = false;
                        prodInv.id = null;
                        prodInv.checked = false;

                        vm.loading = false;
                    },
                    function(response) {
                        prodInv.saving = false;
                        prodInv.checked = true;

                        vm.loading = false;
                    }
                );

            }

        };


        vm.updateCustomerQuotationEntry = function(prodInv) {

            if (prodInv.saving) return;

            if( prodInv.checked ) {

                vm.loading = true;
                prodInv.saving = true;

                CrudService.update( 'customer_quotations_entries', prodInv, vm,
                    function(response) {
                        prodInv.saving = false;
                        vm.loading = false;

                        vm.calcsOnVisibileElements();
                    },
                    function(response) {
                        prodInv.saving = false;
                        vm.loading = false;
                    }
                );

            }

        };


        vm.updateDiscount = function() {

            if( vm.mainEntity.total_discount ) {

                var sub = (vm.eListTotal - vm.mainEntity.total_discount).toFixed(2);
                vm.mainEntity.discount = ((sub / vm.eListTotal) * 100).toFixed(2);

            } else {

                vm.mainEntity.discount = 0;

            }

        }


        vm.updateCustomerQuotation = function() {

            vm.loading = true;

            //ADD ENTRIES TO REQUEST
            vm.mainEntity.entries = [];
            vm.quotationEntriesList.forEach(function(item) {
                if( item.prodInv.checked ){
                    vm.mainEntity.entries.push({
                        id: item.prodInv.id,
                        customer_quotation_id: item.prodInv.customer_quotation_id,
                        quotation_entry_id: item.prodInv.quotation_entry_id,
                        price: item.prodInv.price,
                        quantity: item.prodInv.quantity,
                        note: item.prodInv.note
                    });
                }
            });

            //ADD SURVEYS TO REQUEST
            vm.mainEntity.customerSurvey = $scope.customerSurvey.data;


            CrudService.update( 'customer_quotations', vm.mainEntity, vm,
                function(response) {
                    vm.loading = false;
                    vm.mainEntity.closed = true;
                    $rootScope.$broadcast('enableSurveysForm', {editable: false});

                    vm.calcsOnVisibileElements();
                },
                function(response) {
                    vm.loading = false;
                }
            );

        };


        vm.openEmailPopup = function() {

            vm.loading = true;

            $http
                .get(  env.API + '/customer-quotation-view/' + vm.mainEntity.id, null )
                .then(function(response) {

                    vm.loading = false;

                    if ( response.data &&
                         vm.mainEntity.customer &&
                         vm.mainEntity.customer.email
                    ) {

                        var useFullScreen = $mdMedia('xs');
                        var confirm = $mdDialog.confirm({
                            title: 'Info',
                            ariaLabel: 'Info',
                            templateUrl: 'app/customer-quotations/dialogs/email-dialog.html',
                            fullscreen: useFullScreen,
                            escapeToClose: false,
                            controller: [ '$scope', '$mdDialog', function( $scope, $mdDialog ) {

                                vm.saveDocument = true;
                                vm.customerQuotationDocument = vm.mainEntity.id;

                                $scope.mainEntity = vm.mainEntity;
                                $scope.view = $sce.trustAsHtml(response.data.view);
                                $scope.token = vm.token;
                                $scope.postUrl =  $sce.trustAsResourceUrl( env.API + '/signed-quotations' );

                                $scope.close = function() {
                                    $mdDialog.hide( true );
                                };

                            }]
                        });
                        return $mdDialog
                            .show( confirm );

                    } else {

                        var confirm = $mdDialog.confirm()
                            .title('Attenzione')
                            .ariaLabel('Attenzione')
                            .textContent('Non è possibile inviare l\'email al cliente.')
                            .cancel('Ok');

                        return $mdDialog
                            .show(confirm);

                    }

                });

        };


        vm.removeDocument = function(e) {

            $log.info('Annulla');
            var confirm = $mdDialog.confirm()
                .title('Attenzione')
                .ariaLabel('Attenzione')
                .textContent('Sicuro di voler annullare questo preventivo?')
                .ok('Si')
                .cancel('Ops, ho sbagliato');
            return $mdDialog
                .show(confirm)
                .then(
                    function() {

                        vm.loading = true;

                        CrudService.update( 'customer_quotations', {id: vm.mainEntity.id, status: 'draft'}, vm,
                            function(response) {
                                vm.loading = false;
                                vm.mainEntity.status = "draft";

                                $state.go("home.customer-quotations-details", {
                                    customer_quotation_id: vm.mainEntity.id,
                                    closed: false
                                });

                            },
                            function(response) {
                                vm.loading = false;
                            }
                        );

                    }
                )
                .finally(
                    function() {
                    }
                );

        };


        vm.openDocumentPage = function(url) {
            vm.saveDocument = true;
            window.open(url, '_blank');
        };


        vm.edit = function () {
            vm.mainEntity.closed = false;

            //ENABLE SURVEYS FORM
            $rootScope.$broadcast('enableSurveysForm', {editable: true});
        };


        vm.close = function () {
            vm.mainEntity.closed = true;

            //ENABLE SURVEYS FORM
            $rootScope.$broadcast('enableSurveysForm', {editable: false});
        };


        $scope.$watch('ab.query.filter', function() {
            $timeout(vm.calcsOnVisibileElements, 300);
        });

        vm.calcsOnVisibileElements = function() {
            $timeout(function () {
                vm.eListTotal = 0;
                vm.filteredItems.forEach(function(item) {
                    if (item.prodInv!=null && item.prodInv.checked) {
                        vm.eListTotal += parseFloat(item.prodInv.price) * item.prodInv.quantity;
                    }
                });

                vm.updateDiscount();
            });
        };

        vm.getCustomerQuotationEntry = function (quotationEntry) {
            for (var i = 0; i<vm.mainEntity.entries.length; i++) {
                if (quotationEntry.id == vm.mainEntity.entries[i].id) {
                    return vm.mainEntity.entries[i];
                }
            }
            return null;
        };

        vm.loadCustomerQuotation = function() {
            var pars = {with: 'entries;customer;document'};
            CrudService.get("customer_quotations", customer_quotation_id, pars,  vm,
                function (response) {
                    
                    vm.mainEntity = response.data.data;

                    vm.mainEntity.closed = $stateParams.closed;
                    $rootScope.$broadcast('enableSurveysForm', {editable: !$stateParams.closed});

                    vm.mainEntity.total_discount = (vm.mainEntity.discount)?
                        parseFloat(vm.mainEntity.price - (vm.mainEntity.price / 100) * vm.mainEntity.discount).toFixed(2) :
                        "";

                    angular.forEach(vm.mainEntity.entries, function (p) {
                        p.prodInv = p.pivot;
                        p.prodInv.checked = true;
                        p.prodInv.price = parseFloat(p.prodInv.price);
                    });

                    vm.quotationEntriesLoad();
                },
                function (response) {
                }
            );
        };
        vm.loadCustomerQuotation();

        /* Quotation Entries */
        vm.quotationEntriesList = [];
        vm.quotationEntriesLoading = true;
        vm.quotationEntriesLoad = function() {
            vm.quotationEntriesList = [];
            vm.quotationEntriesLoading = true;

            var params = {
                orderBy: 'id',
                search: 'active:1',
                searchJoin: 'and',
                searchFields: 'active:='
            };

            CrudService.all('quotations_entries', params, vm,
                function(response) {
                    if (response.data && response.data.data) {

                        angular.forEach(response.data.data, function (quotationEntry) {
                            quotationEntry.customer = vm.mainEntity.customer;
                            var po = vm.getCustomerQuotationEntry(quotationEntry);
                            if (po!=null) {//già in preventivo
                                quotationEntry = po;
                                quotationEntry.checked = true;
                                quotationEntry.price = parseFloat(quotationEntry.price);
                                quotationEntry.note = po.note;
                            } else {
                                quotationEntry.prodInv = vm.getNewEmptyProdInv(quotationEntry);
                            }
                            vm.quotationEntriesList.push(quotationEntry);

                        });
                    }
                    vm.quotationEntriesLoading = false;
                    vm.loading = false;
                    vm.calcsOnVisibileElements();
                },
                function () {
                    vm.quotationEntriesLoading = false;
                    vm.loading = false;
                }
            );
        };


        vm.getQueryChecked = function (v) {
            return v.prodInv.checked || (!v.prodInv.checked && !vm.mainEntity.closed);
        };


        vm.getStatusName = function(status) {

            var ret = "Bozza";
            if( status == 'sent' ) {
                ret = "Inviato";
            } else if( status == 'signed' ) {
                ret = "Sottoscritto";
            }

            return ret;

        };


        vm.getChecked = function(item) {

            return (item && item.checked)?
                item.checked :
                false;
        };


        $window.onfocus = function (event) {
            if( vm.saveDocument && vm.saveDocument == true ) {
                CrudService.get("customer_quotations", customer_quotation_id, {}, vm,
                    function (response) {
                        if( response.data.data.status != vm.mainEntity.status ) {
                            $state.go("home.customer-quotations");
                        }
                    },
                    function (response) {
                    }
                );
            }
        };

    };

    CustomerQuotationsDetailsController
        .$inject = [
            '$window',
            '$scope',
            '$log',
            '$http',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdMedia',
            '$mdToast',
            '$filter',
            '$sce',
            'env',
            'CrudService',
            '$stateParams',
            '$state',
            'UsersService',
            '$rootScope'
        ];

})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .controller( 'CustomerQuotationsController', CustomerQuotationsController )
    ;

    /** @ngInject */
    function CustomerQuotationsController(
        $window,
        $scope,
        $log,
        $http,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdMedia,
        $mdToast,
        $filter,
        $state,
        $sce,
        env,
        CrudService,
        UsersService,
        CustomerService
    ) {

        var vm = this;
        $log.info('CustomerQuotationsController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }

        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];

        vm.listPagination = {
            "total":0,
            "count":10,
            "per_page":10,
            "current_page":1,
            "total_pages":0,
            "links":{}
        };

        vm.query = {
            filter: '',
            status: '',
            order: '-date',
            off: 0,
            limit: 10,
            page: 1
        };


        vm.saveDocument = false;
        vm.customerQuotationDocument = null;


        vm.saveStatus = function () {
            localStorage.setItem( 'customer_quotations_query', angular.toJson( vm.query, false ) );
        };


        vm.restoreStatus = function () {
            var query = angular.fromJson(localStorage.getItem('customer_quotations_query'));
            if (query!=null) {
                vm.query =  query;
            }
        };


        vm.restoreStatus();


        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.status = '';
            vm.query.order = '-date';
            vm.query.off = 0;
            vm.query.page = 1;
            vm.eListLoad(1);
        };


        vm.onKeyPressSearch = function (event) {
            if (!event || event.keyCode==13) {
                vm.eListLoad(1);
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        };


        vm.eList = [];
        vm.loading = true;
        vm.canReadList = true;
        vm.eListLoad = function(p, s) {
            vm.eList = [];
            vm.saveStatus();

            vm.loading = true;
            //vm.query.filter = '';

            if (p==null) {
                p = 1;
            }
            if (s==null) {
                s = parseInt(vm.listPagination.per_page);
            }

            var pars = {};
            pars.with = "user;customer;document";
            pars.filtro = vm.query.filter;
            pars.stato = vm.query.status;
            pars.page = p;
            pars.s = s;


            CrudService.all('customer_quotations', pars, vm,
                function(response) {

                    if (response.data &&
                        response.data.data &&
                        response.data.data.length > 0
                    ) {

                        vm.listPagination = response.data.meta.pagination;

                        angular.forEach(response.data.data, function(elem) {
                            elem.date_formatted = moment(elem.date).format('DD/MM/YYYY');
                            if (elem.sent_at!=null) {
                                elem.sent_at_frmt = moment(elem.sent_at).format('DD/MM/YYYY HH:mm');
                            }
                        });

                        vm.eList = response.data.data;
                    }
                    vm.loading = false;
                },
                function () {
                    vm.loading = false;
                }
            );
        };

        vm.eListLoad(vm.query.page,10);


        vm.rowClicked = function(e) {
            $state.go("home.customer-quotations-details", {
                customer_quotation_id: e.id,
                closed: true
            });
        };


        vm.getStatusName = function(status) {

            var ret = "Bozza";
            if( status == 'sent' ) {
                ret = "Inviato";
            } else if( status == 'signed' ) {
                ret = "Sottoscritto";
            }

            return ret;

        };


        //---------- Sidebar -------------------------------------//
        vm.activeEntity = {};
        vm.updateEntity = {};
        vm.toggleRight = function(e) {
            if (e!=null && e.id != null) {
                angular.copy(e, vm.updateEntity);
                vm.activeEntity = vm.updateEntity;
            } else {
                vm.updateEntity = {};
                vm.activeEntity = vm.getNewEntity();
            }
            $timeout($mdSidenav('right').open, 0);
        };
        vm.getNewEntity = function () {
            return {
                user_id: vm.user.id,
                date: moment().format('YYYY-MM-DD'),
                discount: 0,
                note: ""
            };
        };
        vm.resetAll = function() {
            vm.activeEntity = {};
            vm.updateEntity = {};
            $scope.entityForm.$setPristine();
            $scope.entityForm.$setUntouched();
        };
        vm.closeSidebar = function() {
            vm.resetAll();
            $mdSidenav('right').close();
        };


        vm.save = function(e) {
            $log.info('Salva');
            if (angular.isDefined(e)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler creare un nuovo preventivo?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {
                            
                            vm.activeEntity.year = parseInt(moment(vm.activeEntity.date).format('YYYY'));
                            vm.activeEntity.month = parseInt(moment(vm.activeEntity.date).format('MM'));
                            vm.activeEntity.dicsount = 0;
                            vm.activeEntity.min_deposit = 0;
                            vm.activeEntity.max_rate = 1;

                            CrudService
                                .save(
                                    'customer_quotations',
                                    vm.activeEntity,
                                    vm,
                                    function(response) {
                                        vm.closeSidebar();
                                        $state.go("home.customer-quotations-details", {
                                            customer_quotation_id: response.data.data.id,
                                            closed: false
                                        });
                                        return;
                                        //vm.eListLoad();
                                    },
                                    function(response) {
                                    });
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };


        vm.openEmailPopup = function(mainEntity) {

            vm.loading = true;

            $http
                .get(  env.API + '/customer-quotation-view/' + mainEntity.id, null )
                .then(function(response) {

                    vm.loading = false;

                    if ( response.data &&
                         mainEntity.customer &&
                         mainEntity.customer.email
                    ) {

                        var useFullScreen = $mdMedia('xs');
                        var confirm = $mdDialog.confirm({
                            title: 'Info',
                            ariaLabel: 'Info',
                            templateUrl: 'app/customer-quotations/dialogs/email-dialog.html',
                            fullscreen: useFullScreen,
                            escapeToClose: false,
                            controller: [ '$scope', '$mdDialog', function( $scope, $mdDialog ) {

                                vm.saveDocument = true;
                                vm.customerQuotationDocument = mainEntity.id;

                                $scope.mainEntity = mainEntity;
                                $scope.view = $sce.trustAsHtml(response.data.view);
                                $scope.token = vm.token;
                                $scope.postUrl =  $sce.trustAsResourceUrl( env.API + '/signed-quotations' );

                                $scope.close = function() {
                                    $mdDialog.hide( true );
                                };

                            }]
                        });
                        return $mdDialog
                            .show( confirm );

                    } else {

                        var confirm = $mdDialog.confirm()
                            .title('Attenzione')
                            .ariaLabel('Attenzione')
                            .textContent('Non è possibile inviare l\'email al cliente.')
                            .cancel('Ok');

                        return $mdDialog
                            .show(confirm);

                    }

                });

        };


        vm.del = function ( id ) {
            $log.info( 'Del' );
            if( angular.isDefined( id ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler eliminare questo preventivo?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            CrudService.del( 'customer_quotations', id, vm,
                                function( response ) {
                                    vm.eListLoad();
                                },
                                function( response ) {
                                }
                            );
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };


        vm.openDocumentPage = function(id, url) {
            vm.saveDocument = true;
            vm.customerQuotationDocument = id;
            window.open(url, '_blank');
        };


        vm.onKeyUpCustomersSearch = function (evento, obj) {
            if (evento.keyCode==13)  {
                vm.customersLoad(null);
                evento.stopPropagation();
                evento.preventDefault();
            }
        };


        /* Elenco Clienti */
        vm.customersList = [];
        vm.query.filter_customer = '';

        vm.customersLoad = function(customer_id) {

            vm.customersLoading = true;

            vm.customersList = [];
            var pars = {limit:30, orderBy: 'firstname', 'with': 'customer_subscriptions'};
            var search = [];
            var searchFields = [];

            if (customer_id!=null) {
                search.push("id:"+customer_id);
                searchFields.push("id:=");
            }

            if (vm.query.filter_customer!=null && vm.query.filter_customer!='') {
                pars.filtro = vm.query.filter_customer;
            }

            if (search.length>0) {
                pars.search = search.join(";");
                pars.searchFields = searchFields.join(";");
            }

            return CustomerService
                .users_for_appointment(pars).then(
                    function( response ) {
                        if( response.data && response.data.data ) {
                            vm.customersList = response.data.data.map(
                                function( customer ) {
                                    customer.fullName =  (
                                        ( customer.firstname || '' )
                                        + ' '
                                        + ( customer.lastname || '' )
                                    ).toUpperCase();

                                    return customer;
                                }
                            );
                            if (vm.customersList.length==0) {
                                vm.showActionToast("Nessun elemento trovato.");
                            }
                            if( customer_id )
                                vm.customer_id = customer_id;

                            vm.customersLoading = false;

                        };
                    }
                );
        };


        $window.onfocus = function (event) {
            if( vm.saveDocument && vm.saveDocument == true ) {
                CrudService.get("customer_quotations", vm.customerQuotationDocument, {}, vm,
                    function (response) {
                        if( response.data.data.status != 'draft' ) {
                            vm.eListLoad();
                        }
                    },
                    function (response) {
                    }
                );
            }
        };

    }



    CustomerQuotationsController
        .$inject = [
            '$window',
            '$scope',
            '$log',
            '$http',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdMedia',
            '$mdToast',
            '$filter',
            '$state',
            '$sce',
            'env',
            'CrudService',
            'UsersService',
            'CustomerService'
        ];

})();

(function() {
    'use strict';
    angular
        .module('admin')
        // Restituisce solo l'ora da un datetime
        .filter( 'toDate', function() {
            return function(items) {
                return new Date(items);
            };
        })
    ;
})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('CustomerPictureController', CustomerPictureController);

    /** @ngInject */
    function CustomerPictureController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdMedia,
        $mdToast,
        $filter,
        $sce,
        CustomerService,
        env,
        customer_id,
        UsersService,
        CrudService
    ) {
        var vm = this;
        $log.info('CustomerPictureController');
        /**
         * Per crud service
         */
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;

        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }

        vm.env = env;

        /* Controllo se c'è un Customer Id nell'URL */
        vm.customer_id = null;
        if (customer_id && angular.isDefined(customer_id)) {
            vm.customer_id = customer_id;
        }


        //IMAGE ZOOM
        vm.imageZoom1 = null;
        vm.imageZoom2 = null;
        vm.imageIndex1 = 0;
        vm.imageIndex2 = 0;
        vm.element = null;

        vm.zoomImage = function(image, index) {

            var cropie = false;

            if( vm.imageZoom1 == null ) {

                cropie = true;
                vm.imageZoom1 = image;
                vm.imageIndex1 = index;
                vm.element = "zoom-image-1";

                document.getElementById('image-preview-box-'+index).classList.add("preview-1");

            } else if(vm.imageZoom2 == null) {

                cropie = true;
                vm.imageZoom2 = image;
                vm.imageIndex2 = index;
                vm.element = "zoom-image-2";

                document.getElementById('image-preview-box-'+index).classList.add("preview-2");

            }

            if( cropie ) {
                $timeout(function() {
                    new Croppie(document.getElementById(vm.element), {
                        viewport: { width: 200, height: 200, type: 'circle' },
                        showZoomer: true,
                        enableOrientation: true
                    });
                }, 0);
            }

        };

        vm.removeZoomImage = function(imageNumber) {
            if(imageNumber == 1){

                vm.imageZoom1 = null;
                document.getElementById('image-preview-box-'+vm.imageIndex1).classList.remove("preview-1");

            } else {

                vm.imageZoom2 = null;
                document.getElementById('image-preview-box-'+vm.imageIndex2).classList.remove("preview-2");

            }
        };

        vm.getImageUrl = function(id) {
            return env.API + '/documents/' + id + '/download?token='+vm.token;
        };



        vm.loading = true;
        vm.customerLoad = function() {

            vm.loading = true;


            vm.customer = null;
            vm.pictures = [];


            var pars = {
                with: 'appointments;customerPictures'
            };

            CustomerService.get(
                vm.customer_id,
                pars
            ).then(
                function(response) {

                    if (response.data && response.data.data) {
                        var apps = response.data.data.appointments.data;
                        response.data.data.appointments = {'data': []};
                        var ad = moment().format('YYYY-MM-DD 23:59');
                        angular.forEach( apps, function( app ) {
                            if (app.recalled<3 && ad>app.date_start) {
                                response.data.data.appointments.data.push(app);
                            }
                        });

                        vm.customer = response.data.data;

                        var i = 0;
                        angular.forEach( response.data.data.customerPictures.data, function( picture ) {
                            picture['api_url'] = vm.getImageUrl(picture.id);
                            vm.pictures[i] = picture;
                            i++;
                        });

                        vm.loading = false;
                    }
                    vm.loading = false;

                },
                function (response) {

                    var errMsg = "";
                    if (response.data!=null && response.data.message!=null) {
                        errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                        var url = response.config!=null && response.config.url!=null?response.config.url:"";
                        if (url!=null) {
                            errMsg+= "\nUrl: " + url;
                        }
                    }
                    alert ("Si è verificato un errore nel caricamento cliente: " + errMsg);
                    vm.loading = false;

                });
        };


        /* Load customer */
        vm.customerLoad();


        vm.del = function (customerPicture) {
            $log.info('Del');
            if (angular.isDefined(customerPicture)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler eliminare la foto del ' + customerPicture.date +
                        ((customerPicture.treatment)? ', trattamento ' + customerPicture.treatment.name : "") + '?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato')
                ;
                return $mdDialog
                    .show(confirm)
                    .then(
                        function () {

                            var position = vm.pictures.map(function (x) {
                                return x.id;
                            }).indexOf(customerPicture.id);

                            var image = document.getElementById('image-preview-box-' + position);
                            image = image.getElementsByTagName('img')[0];
                            image.style.zIndex = "-1";

                            CrudService.del('customer_pictures', customerPicture.id, vm,
                                function (response) {

                                    image.style.zIndex = "1";

                                    vm.pictures.splice( position, 1 );

                                    //REMOVE SELECTED PICTURE
                                    if( position == vm.imageIndex1 ){
                                        vm.imageZoom1 = null;
                                        vm.imageIndex1 = 0;
                                    }

                                    if( position == vm.imageIndex2 ){
                                        vm.imageZoom2 = null;
                                        vm.imageIndex2 = 0;
                                    }
                                },
                                function (response) {
                                    image.style.zIndex = "1";
                                    alert("Errore durante l'elaborazione delle richiesta.");
                                }
                            );
                        }
                    )
                    .finally(
                        function () {
                            confirm = undefined;
                        }
                    );
            }
        };


        vm.setCreationDate = function () {

            var appointmentId = vm.createPictureAction.appointment_id;
            if( appointmentId ){

                var position = vm.customer.appointments.data.map(function (x) {
                    return x.id;
                }).indexOf(appointmentId);

                vm.createPictureAction.date = vm.customer.appointments.data[position].date_start;

            }
        };



        //-----------DIALOGS--------------------------------------//
        vm.showPopupInfo = function( data ) {
            var useFullScreen = $mdMedia('xs');
            var confirm = $mdDialog.confirm({
                title: 'Info',
                ariaLabel: 'Info',
                templateUrl: 'app/customer-pictures/dialogs/info-dialog.html',
                fullscreen: useFullScreen,
                escapeToClose: false,
                controller: [ '$scope', '$mdDialog', function( $scope, $mdDialog ) {
                    $scope.close = function() {
                        $mdDialog.hide( true );
                    };
                }]
            });
            return $mdDialog
                .show( confirm );
        };


        //---------- Sidebar -------------------------------------//
        vm.createPictureAction = {'date': new Date()};
        vm.toggleRight = function(command, label) {
            vm.command = command;
            vm.commandLabel = label;
            vm.createPictureAction = {
                user_id: vm.user.id,
                customer_id: vm.customer.id,
                appointment_id: vm.customer && vm.customer.appointments && vm.customer.appointments.data && vm.customer.appointments.data.length>0?vm.customer.appointments.data[0].id:null,
                date: new Date(),
                parameter: null,
                attachments: [],
                description: null
            };
            $mdSidenav('right').open();
        };
        vm.closeSidebar = function() {
            $mdSidenav('right').close();
        };


        vm.saving = false;
        vm.save = function() {
            $log.info('Salva');
            var confirm = $mdDialog.confirm()
                .title('Attenzione')
                .ariaLabel('Attenzione')
                .textContent('Sicuro di voler inserire queste foto?')
                .ok('Si')
                .cancel('Ops, ho sbagliato');

            return $mdDialog
                .show(confirm)
                .then(
                    function() {
                        vm.saving = true;
                        if ($scope.img.fileObj && $scope.img.fileObj.length > 0) {

                            vm.createPictureAction.attachments = new Array($scope.img.fileObj.length);

                            vm.uploadImages(
                                0,
                                $scope.img.fileObj.length
                            );

                        }
                    }
                ).finally(
                    function() {
                        confirm = undefined;
                    }
                );
        };


        vm.uploadImages = function( currentImage, totalImages ) {

            vm.createPictureAction.attachments[currentImage] = {
                document_name: null,
                document_type: null,
                document_file: null
            };

            vm.createPictureAction.attachments[currentImage].document_name = $scope.img.fileObj[currentImage].name;
            vm.createPictureAction.attachments[currentImage].document_type = $scope.img.fileObj[currentImage].type;
                            var reader = new FileReader();

                            reader.onload = function () {

                vm.createPictureAction.attachments[currentImage].document_file = reader.result;

                if( (currentImage+1) < totalImages ) { //ADD ANOTHER IMAGE TO SEND

                    vm.uploadImages(
                        currentImage+1,
                        $scope.img.fileObj.length
                    );

                } else { //UPLOAD IMAGES TO SERVER

                                vm.createPictureAction.date = moment(vm.createPictureAction.date).format("DD/MM/YYYY");

                                CrudService.save('customer_pictures', vm.createPictureAction, vm,
                                    function(response) {

                                        if (response.data && response.data.data) {
                                angular.forEach(response.data.data, function(picture) {
                                    picture['api_url'] = vm.getImageUrl(picture.id);
                                    vm.pictures[vm.pictures.length] = picture;
                                });

                                        }

                                        vm.saving = false;
                                        vm.closeSidebar();
                                    },
                                    function(response) {
                                        vm.saving = false;
                                    });

                }

                            };

                            reader.onerror = function (error) {
                                $log.info('Error: ', error);
                                vm.saving = false;
                            };

            reader.readAsDataURL($scope.img.fileObj[currentImage]);

        };


        $scope.trustSrc = function(src) {
            return $sce.trustAsResourceUrl(src);
        }

    };

    CustomerPictureController
        .$inject = [
        '$scope',
        '$log',
        '$location',
        '$timeout',
        '$mdSidenav',
        '$mdDialog',
        '$mdMedia',
        '$mdToast',
        '$filter',
        '$sce',
        'CustomerService',
        'env',
        'customer_id',
        'UsersService',
        'CrudService'
    ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('CustomerDetailController', CustomerDetailController);

    /** @ngInject */
    function CustomerDetailController(
        $scope,
        $element,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        CrudService,
        CustomerService,
        StoreService,
        SubscriptionService,
        TreatmentService,
        UsersService,
        env,
        phone,
        customer_id,
        current_tab,
        CallState,
        Italia
    ) {
        var vm = this;
        $log.info('CustomerDetailController');
        vm.call_state = CallState;
        /**
         * Per crud service
         */
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;

        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.env = env;

        //SET CURRENT TAB FROM PARAMETER
        vm.currentTab = 'app-tab';
        if (current_tab) {
            vm.currentTab = current_tab;
        }    

        vm.treatmentsList = [];

        $scope.treatmentSearchTerm = '';

        $element.find('input').on('keydown', function (ev) {
            ev.stopPropagation();
        });
        $scope.clearTreatmentSearchTerm = function () {
            $scope.treatmentSearchTerm = '';
        };

        /* Controllo se c'è un Customer Id nell'URL */
        vm.customer_id = null;
        vm.phone = null;

        if (customer_id && angular.isDefined(customer_id)) {
            vm.customer_id = customer_id;
        } else if (phone && angular.isDefined(phone)) {
            vm.phone = phone;
        }

        var today = moment();

        vm.loading = true;

        vm.userRoles = [];

        vm.backup_customer = {};

        vm.update_customer = {};

        vm.responseStatusSuccessful = [200, 201, 202];

        /***********/
        /* Users */
        /*********/
        vm.userRolesList = [];
        vm.userRolesListAll = []
        vm.userRolesListCall = [];
        vm.userRolesLoad = function () {
            console.log("UserRolesLoad partito");
            if (vm.userRolesListAll.length==0) {
                var pars = {with: 'user'};
                return UsersService.allRoles( pars ).then( function( response ) {
                    if( response.data && response.data.data ) {
                        vm.userRolesListAll = response.data.data;
                        //$log.info(vm.userRolesListAll);
                        vm.userRolesList = vm.filterRolesXStore();
                        vm.userRoles = vm.userRolesList;
                        //console.log("Prima userRoles", vm.userRoles);
                        //$log.info(vm.userRolesList);
                        vm.userRolesListCall = vm.filterRolesXRole('callcenter');

                        vm.userRoles = vm.userRolesList;
                        //$log.info(vm.userRolesListCall);
                        //vm.appointmentsListLoad(null);//carico solo ora perchè serve la lista utenti
                    }
                });
            } else {
                vm.userRolesList = vm.filterRolesXStore();
                vm.userRolesListCall = vm.filterRolesXRole('callcenter');
                //vm.appointmentsListLoad(null);//carico solo ora perchè serve la lista utenti
            }

        };

        vm.setUserRole = function(elem) {
            if (elem.user_id) {
                angular.forEach(vm.userRolesListAll, function (r) {
                      if (r.user_id == elem.user_id && r.store_id == elem.store_id) {
                        elem.role = {data: r};
                      }
                });
            }
        };


        vm.filterRolesXStore = function() {
            var fs = {active: true};
            if (vm.storeId) {
                fs.store_id = vm.storeId;
            } else {
                //fs.store_id = '>0';
            }
            return $filter('filter')(vm.userRolesListAll, fs, true);
        };
        vm.filterRolesXRole = function (role) {
            var fs = {active: true, role: role};
            return $filter('filter')(vm.userRolesListAll, fs, true);
        };

        vm.getUserRole = function(user_id, store_id, role_id) {
          var res = null;
            angular.forEach(vm.userRolesList, function (r){
                if (r.user_id == user_id && r.store_id == store_id && (!role_id || r.id == role_id)) {
                    res = r;
                }
            });
            if (res != null) {
              return res;
            }
            $log.error("non trovato ruolo per utente " + user_id + "/" + store_id);
            return {id: user_id, color: '#888888'};
        };

        vm.getUser = function(user_id, store_id) {
            if (!user_id) {
                return {
                    user: {
                        firstname: "Nessuno",
                        lastname: "",
                    }
                };
            }
            var res = null;
            angular.forEach(vm.userRolesList, function (r){
                if (r.user_id == user_id && (!store_id || r.store_id == store_id)) {
                    res = r;
                    //console.log("response getuser:", res);
                }
            });
            if (res != null) {
              return res;
            }
            //$log.error("non trovato utente " + user_id + "/" + store_id);
            var res = {
                user: {
                    firstname: "Non trovato",
                    lastname: "",
                }
            }
            return res;
        }

        vm.detectSurveyExpires = function(customerSurveys) {
            var surTypes = [];
            customerSurveys.forEach(function(survey) {
                surTypes[survey.survey_id] = true;
            });

            var expired = false;
            var now = new Date().getTime();
            surTypes.forEach(function(surveyType, index) {
                var arrSur = customerSurveys.filter(function (el) { return el.survey_id == index });
                for (var i = 0; i < arrSur.length; i++) {
                    if ((arrSur[i].expires_at * 1000) > now) {
                        return;
                    } else {
                        if (arrSur[i].expires_at > expired) {
                            expired = true;
                        }
                    }
                }
            });
            
            if (expired) {
                setTimeout(function() {
                    alert ("Questo paziente ha un'anamnesi scaduta!");
                }, 300);
            }
        }
        
        vm.dateFormat = function (elem, deleteCreatedAt) {

            elem.updated_at_frmt = moment( elem.updated_at.date ).format('DD/MM/YYYY HH:mm');

            var createdR = moment( elem.created_at_r);
            elem.createdRecently = moment().diff(createdR,'hours')<12;
            //$log.info(elem);
            elem.created_at_frmt = moment( elem.created_at.date ).format('DD/MM/YYYY HH:mm');

            elem.date_start_frmt = moment( elem.date_start ).format('DD/MM/YYYY HH:mm');
            elem.date_end_frmt = moment( elem.date_end ).format('HH:mm');

            if (elem.moved_at!=null) {
              elem.moved_at_frmt = moment( elem.moved_at ).format('DD/MM/YYYY HH:mm');
            }
            if (elem.cancelled_at!=null) {
              elem.cancelled_at_frmt = moment( elem.cancelled_at ).format('DD/MM/YYYY HH:mm');
            }

            if (deleteCreatedAt) {
              delete elem.created_at;
              delete elem.updated_at;
            }

            if (elem.lead!=null && elem.lead.data!=null && elem.lead.data.created_at!=null) {
              elem.lead.data.created_at_frmt = moment( elem.lead.data.created_at.date ).format('DD/MM/YYYY HH:mm');
            }

          };


        /*********/
        vm.userRolesLoad();

        vm.customerLoad = function() {

            /**
             * se sono xstore e faccio next su uno store non mio setto lo store corrente al mio
             */
            if (vm.user.store_id!=null && vm.user.store_id>0) {
                if (vm.storeId!=vm.user.store_id) {
                    $scope.$parent.selectedStore = vm.user.store_id;
                }
            }
            vm.loading = true;

            var pars = {c_role: vm.user.type,
                    c_sid: vm.user.store_id,
                    'allapps': true,
                    with: 'customerPictures;documents;customerSurveysV2'
                };
            if (vm.phone) {
                pars.searchFields = 'phone:=';
                pars.search = 'phone:'+vm.phone;
                pars.filtro = phone;
            } else {
                pars.searchFields = 'id:=';
                pars.search = 'id:'+vm.customer_id;
                pars.filtro = "id="+vm.customer_id;
            }
            CrudService.all('customers', pars, vm,
                function(response) {
                    console.log(response);
                    if (response && response.data && response.data.data && response.data.data.length>0) {
                        vm.customer = response.data.data[0];
                        vm.customer.created_at_frm=moment(vm.customer.created_at.date).format("DD/MM/YYYY");
                        vm.detectSurveyExpires(vm.customer.customerSurveysV2.data);
                    }
                    vm.loading = false;
                },
                function (response) {
                    console.log(response);

                    var errMsg = "";
                    if (response.data!=null && response.data.message!=null) {
                        errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                        var url = response.config!=null && response.config.url!=null?response.config.url:"";
                        if (url!=null) {
                            errMsg+= "\nUrl: " + url;
                        }
                    }
                    alert ("Si è verificato un errore nel caricamento cliente: " + errMsg);
                    vm.loading = false;
                }
            );
        };

        vm.customer = null;


        /*            vm.customer = response.data.data;
                    vm.customer.tot = [[0],[0],[0],[0],[0],[0]];
                    vm.customer.total = 0;
                    vm.customer.tot_app = 0;
                    vm.customer.tot_app_paid = 0;
                    vm.activeCustomer = vm.customer;
                    vm.customer.firstApp = null;
                    vm.customer.lastApp = null;
                    vm.customer.created_at_frm=moment(vm.customer.created_at.date).format("DD/MM/YYYY");
                    vm.today = moment();

                    //console.log("Customer caricato: ", vm.customer);

                    vm.day_birthdate=moment(vm.customer.birthdate).format("DD");
                    vm.month_birthdate=moment(vm.customer.birthdate).format("MM");;
                    vm.year_birthdate=moment(vm.customer.birthdate).format("YYYY");;

                    vm.setPhotoArray = function(appointment_id) {
                        var photoArray = [];
                        for(i=0; i<response.data.data.customerPictures.data.length; i++) {

                            //console.log("customerPictures.data[i]", response.data.data.customerPictures.data[i]);
                            if (response.data.data.customerPictures.data[i].appointment_id==appointment_id){
                                photoArray.push(response.data.data.customerPictures.data[i]);
                            }
                        }
                        return photoArray;
                    }

                    vm.user_phone = response.data.data.phone;

                    //console.log("response.data.data.appointments", response.data.data.appointments);

                    angular.forEach(response.data.data.appointments.data, function(element) {
                        var appointment = {
                                "id": element.id,
                                'entity': 'appointment',
                                "date_start": new Date(element.date_start),
                                "date_fmt": moment( element.date_start ).format('DD/MM/YYYY'),
                                "start_hour_fmt": moment( element.date_start ).format('HH:mm'),
                                "end_hour_fmt": moment( element.date_end).format('HH:mm'),
                                "treatment_id": element.treatment_id,
                                "customer_id": element.customer_id,
                                "user_firstname": vm.getUser(element.user_id, vm.storeId).user.firstname,
                                "user_lastname": vm.getUser(element.user_id, vm.storeId).user.lastname,
                                "commercial_user_firstname": vm.getUser(element.commercial_user_id, vm.storeId).user.firstname,
                                "commercial_user_lastname": vm.getUser(element.commercial_user_id, vm.storeId).user.lastname,
                                "assist_user_firstname": vm.getUser(element.assist_user_id, vm.storeId).user.firstname,
                                "assist_user_lastname": vm.getUser(element.assist_user_id, vm.storeId).user.lastname,
                                "confirmed_flag": element.confirmed,
                                "photo_array": vm.setPhotoArray(element.id),
                                "treatment": $filter('filter')( vm.treatmentsList, {id: element.treatment_id}, true)[0],
                                "moved_at": element.moved_at,
                                "canceled_at": element.canceled_at,
                                "notes": element.note,
                                "store_id": element.store_id,
                                "user_times": element.user_times,
                                "user_color": null,
                                "price": element.price,
                                "recalled": element.recalled,
                                "customer_subscription_id": element.customer_subscription_id,
                                "appointment_id": element.appointment_id,
                                "paid": element.paid,
                                "created_at": element.created_at,
                                "updated_at": element.updated_at,
                                "future": moment(element.date_end).diff(vm.today)>0,
                                "fromNow": moment(element.date_start).fromNow(),
                                "actions": [],
                                "originalData": element, //L'uso di questa variabile è da rivedere
                            };


                        delete appointment.originalData.treatment; //Necessario per non trascinarsi dietro tutti i dati del left outer join
                        appointment.originalData.created_at = appointment.originalData.created_at_r; //Necessario per formattare opportunamente la trasmissione delle modifiche nei modal che usano updateData()
                        appointment.originalData.updated_at = appointment.originalData.updated_at_r; //Necessario per formattare opportunamente la trasmissione delle modifiche nei modal che usano updateData()

            /*

                        /**
                         * Controllo se è uno Spostamento
                         */
/*
                        var prevApp = null;
                        if ( element.appointment_id!=null ) {//è uno spostamento
                          var prevAppArr = $filter('filter')(response.data.data.appointments.data, {id: element.appointment_id}, true);
                          //$log.info(newApp);
                          if (prevAppArr.length==1) {
                            prevApp = prevAppArr[0];
                          }
                        }

*/
                        /**
                         * Prenotazione appuntamento o spostamento
                         */
 /*
                        var act = {
                                'call_date':  element.created_at_r,
                                'entity': element.appointment_id!=null?'action_spostamento':'action_booking',
                                'user_id': element.created_by,
                                'store_id': element.store_id,
                                'type': element.appointment_id!=null?'schedule':'book',
                                'note': element.appointment_id!=null?"Spost. " + appointment.treatment.name +  " del "  + (prevApp?moment(prevApp.date_start).format("DD/MM/YYYY"):'????')
                                                                    + ' al ' + moment(element.date_start).format("DD/MM/YYYY")
                                                                    :appointment.treatment.name + " del "  + moment(element.date_start).format("DD/MM/YYYY")
                        };
*/
                        /**
                         * Disdetta appuntamento
                         */
/*
                        var actD = null;
                        if (element.recalled == 3 && element.cancelled_at != null) {
                          var actD = {
                              'call_date':  element.cancelled_at,
                              'user_id': element.cancelled_by,
                              'store_id': element.store_id,
                              'type': 'cancel',
                              'entity': 'action_disdetta',
                              'note': "Disd. " + appointment.treatment.name + " del "  + moment(element.date_start).format("DD/MM/YYYY")
                          };
                        }

                        angular.forEach(vm.operatorsList, function(operator) {
                          if (operator.user_id == element.user_id && operator.store_id == element.store_id) {
                            appointment.user_color = operator.color;
                          }
                        });

                        if (!appointment.future) {
                            vm.customer.tot_app++;
                            if (appointment.paid) {
                                vm.customer.tot_app_paid++;
                            }
                        }

                        if (!appointment.future && element.paid) {
                            vm.customer.firstApp = vm.customer.firstApp==null?appointment:
                                (
                                        moment(element.date_start).diff(moment(vm.customer.firstApp.date_start))<0?appointment:vm.customer.firstApp
                                );
                            vm.customer.lastApp = vm.customer.lastApp==null?appointment:
                                (
                                        moment(element.date_start).diff(moment(vm.customer.lastApp.date_start))>0?appointment:vm.customer.lastApp
                                );
                        }
                        if (!appointment.future && element.paid) {
                            vm.customer.tot[appointment.treatment.treatment_category_id-1][0]+=element.price;
                            vm.customer.total+=element.price;
                            vm.months.addEvent('flags', appointment.treatment.treatment_category_id, moment(element.date_start));
                        }

                        vm.appointmentsForCustomer.push(appointment);
                        response.data.data.customer_actions.data.push(act);
                        if (actD!=null) {
                          response.data.data.customer_actions.data.push(actD);
                        }
                    });
*/

        //Funzione di controllo menu laterale

        vm.toggleRight = function ( appointment, isRowClick ) {
            vm.currentParamsT = [];
            vm.subscriptionsListFiltered = vm.subscriptionsList;
            vm.maxRate = 6;
            //vm.rolesOperators = $filter('filter')(vm.userRolesList, {store_id: appointment?appointment.store_id:vm.storeId, active: true, role: 'operator'}, true);
            //$log.info(vm.rolesOperators);
            var customer_subscription_id = '';
            vm.isNewAppointment = !isRowClick;//angular.isUndefined( appointment );
            if (!isRowClick) {
                vm.updatingField = '';
            }
            if( ! vm.isNewAppointment ) {
                vm.customer_id = appointment.customer_id;
                if (appointment.treatment_id == 99) {
                    vm.card.init(appointment);
                }
                vm.checkSubscriptionByUserAndSetSubscriptionName( appointment.customer_id, appointment,
                    function () {
                        vm.treatmentdate = new Date( appointment.date_start );
                        vm.treatment = $filter("treatment")(appointment.treatment_id, vm.treatmentsList);
                        vm.storno = vm.isStorno(appointment);
                        //filtro abbonamenti in base a zone
                        vm.subscriptionsListFiltered = [];
                        angular.forEach(vm.subscriptionsList, function (s) {
                            if (vm.treatment.zone === 0) {
                                if (s.zone === 0) {
                                    vm.subscriptionsListFiltered.push(s);
                                }
                            } else {
                                if (s.zone > 0 ) {
                                    vm.subscriptionsListFiltered.push(s);
                                }
                            }
                        });
                        vm.activeAppointment = appointment;
                        //$log.info(vm.activeAppointment);
                        angular.copy( vm.activeAppointment, vm.backup_appointment );
                        return $mdSidenav( 'right' ).open();
                    }
                );
            }
            else {
                vm.treatmentdate = new Date();
                vm.customer_id = null;
                /**
                 * Svuoto la ricerca customers e la lista
                */
                vm.customersReset();
                appointment = {
                    payment_type:'C',
                    f_over:vm.portaEnabled?true:false,
                    start: moment(),
                    price_treatment:0,
                    product_price: 0,
                    product_price10:0,
                    discount:0,
                    type: null,
                    ratePayment: 0,
                    paid: 1
                };
                vm.activeAppointment = appointment;
                //$log.info(vm.activeAppointment);
                angular.copy( vm.activeAppointment, vm.backup_appointment );
                return $mdSidenav( 'right' ).open();
            }
        };


        vm.setUser = function(element) {
            angular.forEach(vm.operatorsList, function(operator) {
              if (operator.user_id == element.user_id) {
                  if (operator.store_id == element.store_id) {
                      element.user_color = operator.color;
                  }
                  element.user = operator.user;
              }
          });
        };
        vm.setStore = function(element) {
          if (element.store_id!=null) {
            angular.forEach(vm.storesList, function(store) {
                if (store.id == element.store_id) {
                  element.store = store;
                }
            });
          }
        };
        vm.reset = function() {
            angular.forEach(vm.months.data, function(month) {
                month.flags = [false,false,false];
                month.calls = [false,false,false];
            });
        }
        vm.prossimo = function () {
            vm.customer_id = null;
            vm.phone = null;
            vm.reset();
            /*if (!vm.paid) {
                vm.dormientiDa = undefined;
            }*/
            vm.customerLoad();
        };
        vm.setAppSelected = function (app) {
          //$log.info(app);
          if (vm.appXSub != null && vm.appXSub.id == app.id || !app.paid) {
            vm.appXSub = null;
          } else {
            vm.appXSub = app;
          }
        };
        vm.addAppToSub = function (sub) {
          //salvo l'appuntamento con il sub_id
          //$log.info(vm.appXSub);
          //$log.info(sub.id);
          CrudService.update( 'appointments', {
                id: vm.appXSub.id,
                customer_id: vm.appXSub.customer_id,
                treatment_id: vm.appXSub.treatment_id,
                customer_subscription_id: sub.id,
                type: 'abb',
                updatingField: 'price',
                changeAbb: true
              }, vm,
              function (response) {
                vm.appXSub.customer_subscription_id = sub.id;
                sub.app_remaining = sub.app_remaining-1;
                sub.zone_remaining = sub.zone_remaining - vm.appXSub.treatment.zone;
              },
              function (response) {
              }
          );
        };
        vm.delAppFromSub = function (sub) {
        //salvo l'appuntamento con il sub_id
          //$log.info(vm.appXSub);
          CrudService.update( 'appointments',
              {id: vm.appXSub.id,
                customer_id: vm.appXSub.customer_id,
                customer_subscription_id: null,
                treatment_id: vm.appXSub.treatment_id,
                type: null,
                updatingField: 'price',
                changeAbb: true
              }, vm,
              function (response) {
                vm.appXSub.customer_subscription_id = null;
                sub.app_remaining = sub.app_remaining+1;
                sub.zone_remaining = sub.zone_remaining + vm.appXSub.treatment.zone;
              },
              function (response) {
              }
          );
        };
        vm.removeSub = function (sub) {
            var confirm = $mdDialog.confirm()
            .title( 'Attenzione' )
            .textContent( 'Sei sicuro di voler eliminare l\'abbobamento numero '+sub.id+'?' )
            .ariaLabel( 'Attenzione' )
            .ok( 'Si' )
            .cancel( 'Ops, ho sbagliato' );
        return $mdDialog
            .show( confirm )
            .then( function() {
                CrudService.del( 'customer_subscriptions', sub.id, vm,
                        function (response) {
                          var ns = vm.activeCustomer.customer_subscriptions.data;
                          vm.activeCustomer.customer_subscriptions.data = [];
                          angular.forEach(ns, function (s){
                            if (s.id != sub.id) {
                              vm.activeCustomer.customer_subscriptions.data.push(s);
                            }
                          });
                        },
                        function (response) {
                        }
                    );
            })
            .finally(
                function() {
                    confirm = undefined;
                }
            )
         };

        vm.chartCassaBar = {
            series: ['Epilazione', 'Viso', 'Corpo'],
            labels: [(vm.env.currency?vm.env.currency.label:'Spesa') +' cliente per categoria'],
            options: {
                legend: {display: true}
            }
        };


        vm.update = function ( appointment ) {
            $log.info( 'Update' );
            if( angular.isDefined( appointment ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sei sicuro delle modifiche?' )
                    .ok( 'Si' )
                    .cancel( 'No' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            angular.copy( appointment, vm.update_appointment );
                            //vm.update_appointment.updatingField = vm.updatingField;
                            /*
                            if( vm.selectedAvaibility !== null ) {
                                vm.update_appointment.date_start = vm.availabilitiesList[ vm.selectedAvaibility ].date_start;
                                vm.update_appointment.date_end = vm.availabilitiesList[ vm.selectedAvaibility ].date_end;
                            };
                            */
                            CrudService.update( 'appointments', vm.update_appointment, vm,
                                    function (response) {
                                        var data = response.data.data;
                                        /*
                                        if( vm.selectedAvaibility !== null ) {
                                            var date_start = moment( data.date_start )
                                                , date_end = moment( data.date_end );
                                            appointment.date_start = new Date( date_start );
                                            appointment.date_end = new Date( date_end );
                                        };
                                        */
                                        appointment.customer_subscription_id = data.customer_subscription_id;
                                        appointment.subscription_new_id = null;
                                        appointment.updated_by = vm.user.id;
                                        appointment.updatedBy = {data: vm.user};
                                        appointment.updated_at = moment();
                                        appointment.updated_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                                        /**
                                         * Aggiorno user.data con il nuovo valore
                                         */
                                        //vm.operatorChange.complete(appointment);
                                        //vm.resetAll();
                                        //vm.calcsOnVisibileElements();
                                        //appointent.customer_subscriprion_id = response.data.data.customer_subscription_id;
                                    },
                                    function (response) {
                                        //vm.resetAll();
                                        /**
                                         * Ripristino il valore precedente contenuto in appointment.user.data
                                         */
                                        //vm.operatorChange.reset(appointment);
                                    }
                            );
                            /*AppointmentsService.update( vm.update_appointment ).then( function( response ) {
                                if( vm.selectedAvaibility !== null ) {
                                    var data = response.data.data
                                        , date_start = moment( data.date_start )
                                        , date_end = moment( data.date_end )
                                    ;
                                    appointment.date_start = new Date( date_start );
                                    appointment.date_end = new Date( date_end );
                                };
                                vm.checkResponse( response, appointment );
                                vm.calcsOnVisibileElements();
                            }, function (response) {//in caso di errore
                                vm.checkResponse( response, appointment );
                            });*/
                        },
                        function () {
                            //vm.operatorChange.reset(appointment);
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            }
        };


        vm.operatorChange = {
            complete: function(appointment) {
                if (appointment!=null && appointment.user_id
                    && (!appointment.role || !appointment.role.data || appointment.user_id!=appointment.role.data.user_id)) {
                    appointment.role = {data: vm.getUserRole(appointment.user_id, appointment.store_id)};
                    appointment.newOperatorCandidates = [appointment.role.data];
                    appointment.newOperatorId = appointment.user_id;
                } else if (appointment!=null && !appointment.user_id) {
                    appointment.role = null;
                    appointment.newOperatorCandidates = [];
                }
                if (appointment!=null && appointment.assist_user_id
                    && (!appointment.assistRole || !appointment.assistRole.data || appointment.assist_user_id!=appointment.assistRole.data.user_id)) {
                    appointment.assistRole = {data: vm.getUserRole(appointment.assist_user_id, appointment.store_id)};
                } else if (appointment!=null && !appointment.assist_user_id) {
                    appointment.assistRole = null;
                }
                if (appointment!=null && appointment.commercial_user_id
                    && (!appointment.commercialRole || !appointment.commercialRole.data || appointment.commercial_user_id!=appointment.commercialRole.data.user_id)) {
                    appointment.commercialRole = {data: vm.getUserRole(appointment.commercial_user_id, appointment.store_id)};
                } else if (appointment!=null && !appointment.commercial_user_id) {
                    appointment.commercialRole = null;
                }
            },
            reset: function(appointment) {
                if (appointment!=null && appointment.user_id!=appointment.role.data.user_id) {
                    appointment.user_id = appointment.role.data.user_id;
                    appointment.newOperatorCandidates = [appointment.role.data];
                    appointment.newOperatorId = appointment.user_id;
                }
            },
             doChange: function(appointment) {
                 //alert (appointment.id + " change from " + appointment.user_id + " to " + appointment.newOperatorId);
                 if (appointment.closed) {
                     vm.showActionToast("Cassa chiusa.");
                     return;
                 }
                 if (vm.user.type!='admin') {
                     vm.showActionToast("Operazione non consentita. Contattare l'assistenza.");
                     return;
                 }
                 appointment.user_id = appointment.newOperatorId;
                 appointment.uncovered = 0;
                 //vm.selectedAvaibility = null;
                 vm.update(appointment);
                 /**
                  * devo salvare il cambio operatore
                  */
             },
             gotFocus: function(appointment) {
                 /**
                  * devo caricare gli operatori disponibili per il cambio su questo appuntamento
                  */
                 if (appointment.closed) {
                     vm.showActionToast("Cassa chiusa.");
                     return;
                 }
                 if (vm.user.type!='admin') {
                     vm.showActionToast("Operazione non consentita. Contattare l'assistenza.");
                     return;
                 }
                 if (appointment.recalled!=null && appointment.recalled>=3) {
                     if (appointment.recalled==4) {
                         vm.showActionToast("Appuntamento spostato.");
                     } else if (appointment.recalled==3) {
                         vm.showActionToast("Appuntamento disdetto.");
                     }
                     return;
                 }
                 appointment.newOperatorId = appointment.user_id;
                 appointment.newOperatorCandidates = [];
                 if (appointment.role && appointment.role.data) {
                     appointment.newOperatorCandidates.push(appointment.role.data);
                 }
                 UsersService.availablesForChange(appointment.store_id, appointment.id, appointment.user_id, moment(appointment.date_start).format('YYYY-MM-DD')).then(
                    function( response ) {
                        if( response.data && response.data ) {
                            if (response.data.length==0) {
                                vm.showActionToast("Nessuna disponibilità per il cambio.");
                            } else {
                                response.data.forEach(function(op) {
                                    appointment.newOperatorCandidates.push(vm.getUserRole(op.id, appointment.store_id, op.role_id));
                                });
                            }
                        }
                });
             }
         };



        //---------- Sidebar -------------------------------------//

        vm.activeCustomer = {};
        vm.activeCustomerAction = {};
        vm.toggleRight = function(command, label) {
            vm.command = command;
            vm.commandLabel = label;
            vm.activeCustomerAction = {
                  call_date: moment(),
                  user_id: vm.user.id,
                  c_sid: vm.user.store_id,
                  c_role: vm.user.type,
                  store_id: vm.user.store_id,
                  type: command,
                  customer_id: vm.customer.id,
                  interest: 0,
                  created_at_frm: moment().format("DD/MM/YYYY HH:mm")
            };
            $mdSidenav('right').open();
        };
        vm.closeSidebar = function() {
            $mdSidenav('right').close();
        };

        vm.saving = false;
        vm.save = function(prenota, archivia) {
            $log.info('Salva');
            var confirm = $mdDialog.confirm()
                .title('Attenzione')
                .ariaLabel('Attenzione')
                .textContent('Sicuro di voler inserire questa azione?')
                .ok('Si')
                .cancel('Ops, ho sbagliato');
            return $mdDialog
                .show(confirm)
                .then(
                    function() {
                        vm.saving = true;
                        if (vm.activeCustomerAction.call_date) {
                            vm.activeCustomerAction.call_date = $filter('date')(new Date(vm.activeCustomerAction.call_date), 'yyyy-MM-dd HH:mm')+":00";
                        };
                        if (archivia) {
                          vm.activeCustomerAction.archived = 1;
                        }
                        CrudService.save('customer_actions', vm.activeCustomerAction, vm,
                            function(response) {
                               if (response.data && response.data.data) {
                                   var rec = response.data.data;
                                   rec.user = vm.user;
                                   rec.user_color = "#000000";
                                   rec.entity = 'customer_action';
                                   if (vm.user.store_id!=null) {
                                       rec.user_color = vm.user.color;
                                   }
                                   angular.forEach(vm.storesList, function(store) {
                                       if (store.id == rec.store_id) {
                                           rec.store = store;
                                       }
                                   });
                                   if (rec.call_date!=null) {
                                       rec.call_date = new Date(rec.call_date);
                                   }
                                   vm.customer.customer_actions.data.push(rec);
                                   if (rec.type == 'call') {
                                       //console.log(rec);
                                       vm.months.addEvent('calls', rec.treatment_category_id, moment(rec.call_date));
                                   }
                               }
                               vm.saving = false;
                               vm.closeSidebar();
                               if (prenota) {
                                 var caid = "";
                                 if (vm.isRullo && rec && rec.id) {
                                   caid="caid="+rec.id+"&";
                                 } else {
                                   caid="";
                                 }
                                   var nl = vm.env.booking +"/operator?"+caid+"store=" +vm.storeId
                                     + "&c_sid=" + vm.user.store_id
                                     + "&c_role=" + vm.user.type
                                     + "&customer=" +vm.activeCustomer.phone + "&token=" + vm.token;
                                   window.location.href = nl;
                               }
                            },
                            function(response) {
                                vm.saving = false;
                            });
                    }
                ).finally(
                    function() {
                        confirm = undefined;
                    }
               );
        };
        $scope.$watch( 'ab.paid', function ( newValue ) {
            if (newValue) {
                vm.noshow = false;
            }
        });
        $scope.$watch( 'ab.noshow', function ( newValue ) {
            if (newValue) {
                vm.paid = false;
            }
        });

        /* WATCHO Lo Store */
        vm.storesList = [];
        vm.storeId = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                if (vm.storeId==null) {//è il primo caricamento
                    vm.storeId = id;
                    vm.storesList = $scope.$parent.main.storesList;
                    vm.operatorLoad();
                } else {
                    vm.storeId = id;
                    /*if (vm.user.store_id == null && vm.paid) {
                        vm.customerLoad();
                    }*/
                }
            };
        });

        vm.iconByType = function (type, call_type) {
            if (type=='comment') {
                return "dehaze";
            } else if (type=='call') {
                if (call_type=='whatsapp') {
                    return 'question_answer';
                } else if (call_type=='messenger') {
                    return 'message';
                } else {
                    return call_type;
                }
            } else {
                return type;
            }
        };

        vm.iconByCategory = function (cat, call_type) {
          if (cat=='1') {
            return "gesture";
          } else if (cat=='2') {
            return 'face';
          } else if (cat=='3') {
            return 'accessibility';
          } else {
              return 'polymer';
          }
        };

        /* Treatments */
        vm.treatmentsList = [];

        vm.subscriptionsList = [];

        /* Operators */
        vm.operatorsList = [];
        vm.operatorLoad = function() {
            vm.operatorsList = [];
            UsersService.allRoles({with: 'user'}).then(function(response) {
                if (response.data && response.data.data) {
                    vm.operatorsList = response.data.data;
                    TreatmentService.treatments().then(function(data) {
                        vm.treatmentsList = data;
                        SubscriptionService.all({}).then(function(response) {
                            vm.subscriptionsList = response.data.data;
                            vm.customerLoad();
                        });
                    });
                };
            });
        };


        // MODAL INSERISCI PAGAMENTO
        vm.openInsertPaymentModal = function() {
            var dialog = $mdDialog.confirm({
                  title: 'Pagamenti preventivo n.13 del 23/03/2021',
                  ariaLabel: 'Pagamenti preventivo n.13 del 23/03/2021',
                  templateUrl: 'app/customer-detail/dialogs/insert-payment.html',
                  escapeToClose: true,
                  controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {

                      $scope.loadOrigin = function () {
                        var pars = {};


                      }

                      $scope.close = function() {
                          $mdDialog.hide( true );
                      };
                      $scope.loadOrigin();
                  }]
            });

            return $mdDialog
                .show( dialog )
                .finally(
                    function() {
                        dialog = undefined;
                    }
                )
            ;
        };

        // MODAL VISUALIZZAZIONE FOTO
        vm.openViewPhotoModal = function (photoId) {
            var dialog = $mdDialog.confirm({
                title: 'Visualizza Foto',
                ariaLabel: 'Visualizza Foto',
                templateUrl: 'app/customer-detail/dialogs/view-photo.html',
                escapeToClose: true,
                controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {

                    $scope.loadOrigin = function () {
                      $scope.loading= true;
                      $scope.selectedPhotoUrl = env.API + '/documents/' + photoId + '/download?token='+vm.token;

                    }

                    $scope.close = function() {
                        $mdDialog.hide( true );
                    };
                    $scope.loadOrigin();
                }]
            });

            return $mdDialog
                .show( dialog )
                .finally(
                    function() {
                        dialog = undefined;
                    }
                )
            ;

        };



        // MODAL CONFERMA CAMBIAMENTI ANAGRAFICA
        vm.openConfirmCustomerdataChanges = function() {
            var dialog = $mdDialog.confirm({
                title: 'Attenzione!',
                ariaLabel: 'Attenzione!',
                templateUrl: 'app/customer-detail/dialogs/confirm-customerdata-changes.html',
                escapeToClose: true,
                controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {

                    $scope.loadOrigin = function () {
                        var pars = {};


                    }

                    $scope.close = function() {
                        $mdDialog.hide( true );
                    };
                    $scope.loadOrigin();
                }]
            });

            return $mdDialog
                .show( dialog )
                .finally(
                    function() {
                        dialog = undefined;
                    }
                )
            ;
        };



        vm.showActionToast = function( text) {
            text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent(text)
                .action('')
                .highlightAction(true)
                .position('bottom right');
            return $mdToast
                .show(toast)
                .finally(
                    function() {
                        toast = undefined;
                    }
                );
        };


        vm.resetAll = function() {
            vm.undoVisible = false;
            vm.backup_customer = {};
            vm.update_customer = {};
            //vm.activeCustomer = {};
            $timeout(vm.resetForm,0);
        };

        vm.checkResponse = function(response) {
            vm.saving = false;
            if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
                var errMsg = "";
                if (response.data!=null && response.data.message!=null) {
                    errMsg = response.data!=null && response.data.message!=null?response.data.message:"";
                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    vm.showActionToast("KO: " + errMsg + " " + url);
                }
                var alert = $mdDialog.alert()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent("C'è stato un problema: "+errMsg)
                    .ok('Ok');
                return $mdDialog
                    .show(alert)
                    .finally(
                        function() {
                            alert = undefined;
                        }
                    );
            } else {
                vm.showActionToast();
                return vm.resetAll();
            };
        };

        //FUNZIONI PER APPUNTAMENTI
        vm.treatmentsLoad = function() {
            vm.treatmentsQuery = {
                filter: '',
                order: 'name',
                active: 1
            };
            vm.treatmentsList = [];
            //vm.loading = true;
            vm.treatmentsQuery.filter = '';
            var pars = {with: 'category;capability'};
            CrudService.all('treatments', pars, vm,
                function(response) {
                    if (response.data && response.data.data && response.data.data.length) {
                        vm.treatmentsList = response.data.data;
                    }
                    //vm.loading = false;
                },
                function () {
                    //vm.loading = false;
                }
            );
        };
        vm.treatmentsLoad();





        //FUNZIONI PER ANAGRAFICA

        vm.updateCustomerData = function(customer) {
            $log.info('Update');
            if (angular.isDefined(customer)) {
                if (!angular.equals(customer, vm.backup_customer)) {
                    var confirm = $mdDialog.confirm()
                        .title('Attenzione')
                        .ariaLabel('Attenzione')
                        .textContent('Applicare davvero i cambiamenti effettuati all\'anagrafica?')
                        .ok('Conferma')
                        .cancel('Annulla');
                    return $mdDialog
                        .show(confirm)
                        .then(
                            function() {
                                vm.saving = true;
                                angular.copy(customer, vm.update_customer);
                                vm.update_customer.with = 'card';
                                if (customer.birthdate) {
                                    vm.update_customer.birthdate = $filter('date')(new Date(vm.update_customer.birthdate), 'yyyy-MM-dd');
                                };
                                if (customer.call_date) {
                                    vm.update_customer.call_date = $filter('date')(new Date(vm.update_customer.call_date), 'yyyy-MM-dd HH:mm');
                                };

                                //ADD SURVEYS TO REQUEST
                                //vm.update_customer.customerSurvey = $scope.customerSurvey.data;

                                CustomerService.update(vm.update_customer).then(
                                    function (response) {
                                      vm.checkResponse(response);
                                      if (response.data!=null && response.data.data!=null) {
                                        customer.card = response.data.data.card;
                                      }
                                    },
                                    vm.checkResponse);
                            }
                        )
                        .finally(
                            function() {
                                confirm = undefined;
                            }
                        );
                };
            };
        };
    };

    CustomerDetailController
        .$inject = [
            '$scope',
            '$element',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'CrudService',
            'CustomerService',
            'StoreService',
            'SubscriptionService',
            'TreatmentService',
            'UsersService',
            'env',
            'phone',
            'customer_id',
            'current_tab',
            'CallState',
            'Italia',
        ];

})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .controller( 'CustomerCallsController', CustomerCallsController )
    ;

    /** @ngInject */
    function CustomerCallsController(
        $scope,
        customer_id,
        UsersService
    ) {

        var vm = this;
        vm.customer_id = customer_id;

        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }

    };

    CustomerCallsController
        .$inject = [
            '$scope',
            'customer_id',
            'UsersService'
        ]
    ;
})(); 
(function() {
    'use strict';

    angular
        .module('admin')
        .controller('CustomerController', CustomerController);

    /** @ngInject */
    function CustomerController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        CustomerService,
        env,
        phone,
        customer_id,
        CallState,
        Italia,
        TreatmentService,
        StoreService,
        SubscriptionService,
        UsersService,
        CrudService
    ) {
        var vm = this;
        $log.info('CustomerController');
        vm.call_state = CallState;
        /**
         * Per crud service
         */
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;

        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }

        vm.env = env;

        if (vm.user.store_id!=null) {
            vm.paid = true;
            vm.noshow = false;
        } else {
            vm.paid = false;
            vm.noshow = true;
        }
        vm.dormientiDa = vm.user.type == 'callcenter'?{from:5, to:12}:undefined;
        console.log(vm.dormientiDa);
        vm.onlyPaidApp = false;
        vm.visNoteApp = true;

        /* Controllo se c'è un Customer Id nell'URL */
        vm.customer_id = null;
        vm.phone = null;
        vm.isRullo = false;
        if (customer_id && angular.isDefined(customer_id)) {
            vm.customer_id = customer_id;
        } else if (phone && angular.isDefined(phone)) {
            vm.phone = phone;
        } else {
            vm.isRullo = true;
        }
        vm.filter = {
            options: {
                'debounce': 0,
                'updateOn': 'default'
            }
        };
        vm.months = {
                data: [],
                addEvent: function(type, cat, date) {
                    var monthsAgo = Math.round(moment.duration(moment().endOf('month').diff(date.endOf('month'))).asMonths());
                    var mInd = 11 - monthsAgo;
                    /*console.log(type);
                    console.log(date);
                    console.log(monthsAgo);
                    console.log(mInd);
                    */
                    if (monthsAgo>=0 && mInd>=0) {
                        this.data[mInd][type][cat-1] = true;
                    }
                }

        };
        var today = moment();
        for (var i=1; i<=12; i++) {
            var date = moment().subtract(12-i, 'month');
            var month = {
                    date: date,
                    flags: [false,false,false],
                    calls: [false,false,false],
                    nothing: function (cat) {
                        return !this.flags[cat] && !this.calls[cat];
                    },
                    name: date.format('MMM'),
                    month: parseInt(date.format('MM')),
                    year: parseInt(date.format('YYYY'))
            };
            vm.months.data.push(month);
        }
        vm.appointmentsForCustomer = [];
        vm.loading = true;
        vm.customerLoad = function() {
            /**
             * se sono xstore e faccio next su uno store non mio setto lo store corrente al mio
             */
            if (vm.user.store_id!=null && vm.user.store_id>0) {
                if (vm.storeId!=vm.user.store_id) {
                    $scope.$parent.selectedStore = vm.user.store_id;
                }
            }
            vm.loading = true;
            var pars = {c_role: vm.user.type,
                    c_sid: vm.user.store_id,
                    birthdate: vm.birthdate,
                    'allapps': true,
                    with: 'appointments;entitytags;leads;referral;by;customer_subscriptions;customer_actions'
            };
            if (vm.user.type=='admin'||vm.user.type=='callcenter') {
                pars.with = 'calls;' + pars.with;
            }
            vm.appointmentsForCustomer = [];
            vm.customer = null;
            vm.activeCustomer = null;
            CustomerService.rotation(
                          vm.phone,
                          vm.customer_id,
                          vm.user.store_id == null || vm.user.store_id == 0 ? vm.storeId: vm.user.store_id,
                                        vm.paid,
                                        vm.noshow,
                                        vm.dormientiDa!=undefined?vm.dormientiDa.from + '-' + vm.dormientiDa.to:undefined,
                                        pars
                                    ).then(function(response) {
                if (response.data && response.data.data) {
                    vm.appointmentsForCustomer = [];
                    vm.customer = response.data.data;
                    vm.customer.tot = [[0],[0],[0],[0],[0],[0]];
                    vm.customer.total = 0;
                    vm.customer.tot_app = 0;
                    vm.customer.tot_app_paid = 0;
                    vm.activeCustomer = vm.customer;
                    vm.customer.firstApp = null;
                    vm.customer.lastApp = null;
                    vm.customer.created_at_frm=moment(vm.customer.created_at.date).format("DD/MM/YYYY");

                    angular.forEach(vm.customer.entitytags.data, function(etag) {
                      if (etag.flagged) {
                        etag.flagged_at_frmt = moment(etag.flagged_at).format('DD/MM/YYYY H:m');
                      }
                    });

                    vm.today = moment();
                    angular.forEach(response.data.data.appointments.data, function(element) {

                        var appointment = {
                                "id": element.id,
                                'entity': 'appointment',
                                "date_start": new Date(element.date_start),
                                "treatment_id": element.treatment_id,
                                "customer_id": element.customer_id,
                                "treatment": $filter('filter')( vm.treatmentsList, {id: element.treatment_id}, true)[0],
                                "store_id": element.store_id,
                                "user_color": null,
                                "price": element.price,
                                "recalled": element.recalled,
                                "customer_subscription_id": element.customer_subscription_id,
                                "paid": element.paid,
                                "created_at": element.created_at,
                                "payment_type": element.payment_type,
                                "payment_bon":element.payment_bon,
                                "payment_check":element.payment_check,
                                "payment_dil":element.payment_dil,
                                "payment_gift":element.payment_gift,
                                "payment_pos":element.payment_pos,
                                "payment_satis":element.payment_satis,
                                "payment_small":element.payment_small,
                                "future": moment(element.date_end).diff(vm.today)>0,
                                "fromNow": moment(element.date_start).fromNow(),
                                "note": element.note,
                                "note_diagnosi": element.note_diagnosi,
                                "f_moved_same_day": element.f_moved_same_day
                            };


                        /**
                         * Controllo se è uno Spostamento
                         */
                        var prevApp = null;
                        if ( element.appointment_id!=null ) {//è uno spostamento
                          var prevAppArr = $filter('filter')(response.data.data.appointments.data, {id: element.appointment_id}, true);
                          //$log.info(newApp);
                          if (prevAppArr.length==1) {
                            prevApp = prevAppArr[0];
                          }
                        }


                        /**
                         * Prenotazione appuntamento o spostamento
                         */
                        var act = {
                                'call_date':  element.created_at_r,
                                'entity': element.appointment_id!=null?'action_spostamento':'action_booking',
                                'user_id': element.created_by,
                                'store_id': element.store_id,
                                'type': element.appointment_id!=null?'schedule':'book',
                                'note': element.appointment_id!=null?"Spost. " + appointment.treatment.name +  " del "  + (prevApp?moment(prevApp.date_start).format("DD/MM/YYYY"):'????')
                                                                    + ' al ' + moment(element.date_start).format("DD/MM/YYYY")
                                                                    :appointment.treatment.name + " del "  + moment(element.date_start).format("DD/MM/YYYY")
                        };

                        /**
                         * Disdetta appuntamento
                         */
                        var actD = null;
                        if (element.recalled == 3 && element.cancelled_at != null) {
                          var actD = {
                              'call_date':  element.cancelled_at,
                              'user_id': element.cancelled_by,
                              'store_id': element.store_id,
                              'type': 'cancel',
                              'entity': 'action_disdetta',
                              'note': "Disd. " + appointment.treatment.name + " del "  + moment(element.date_start).format("DD/MM/YYYY")
                          };
                        }

                        angular.forEach(vm.operatorsList, function(operator) {
                          if (operator.user_id == element.user_id && operator.store_id == element.store_id) {
                            appointment.user_color = operator.color;
                          }
                        });

                        if (!appointment.future) {
                            vm.customer.tot_app++;
                            if (appointment.paid) {
                                vm.customer.tot_app_paid++;
                            }
                        }

                        if (!appointment.future && element.paid) {
                            vm.customer.firstApp = vm.customer.firstApp==null?appointment:
                                (
                                        moment(element.date_start).diff(moment(vm.customer.firstApp.date_start))<0?appointment:vm.customer.firstApp
                                );
                            vm.customer.lastApp = vm.customer.lastApp==null?appointment:
                                (
                                        moment(element.date_start).diff(moment(vm.customer.lastApp.date_start))>0?appointment:vm.customer.lastApp
                                );
                        }
                        if (!appointment.future && element.paid) {
                            vm.customer.tot[appointment.treatment.treatment_category_id-1][0]+=element.price;
                            vm.customer.total+=element.price;
                            vm.months.addEvent('flags', appointment.treatment.treatment_category_id, moment(element.date_start));
                        }

                        vm.appointmentsForCustomer.push(appointment);
                        response.data.data.customer_actions.data.push(act);
                        if (actD!=null) {
                          response.data.data.customer_actions.data.push(actD);
                        }
                    });

                    /**
                     * Inserisco i leads tra le customer_actions
                     */
                    angular.forEach(response.data.data.leads.data, function(element) {
                      element.call_date =  element.created_at;
                      element.type = 'input';
                      element.entity='lead';
                      var msg = element.campagna;
                      if (element.note == null || element.note.trim()=='' ) {
                        element.note = msg;
                      } else {
                        element.note = msg + " / Nota: " + element.note;
                      }
                      vm.setUser(element);
                      response.data.data.customer_actions.data.push(element);
                  });

                  /**
                     * Inserisco le chiamate tra le customer_actions
                     */
                if(response.data.data.calls && response.data.data.calls.data) {
                    angular.forEach(response.data.data.calls.data, function(element) {
                        element.call_date =  element.date_start;
                        element.created_at = element.date_start;
                        var type = element.type;
                        element.type = 'phone';
                        element.entity='customer_call';
                        element.call_state = element.direction.toUpperCase();
                        element.on_master = element.on_master?true:false;
                        /*
                        direction
                        duration
                        type
                        tenant
                        date_start
                        3cx_id
                        3cx_extension
                        agent_email
                        agent_firstname
                        agent_lastname
                        3cx_phone
                        */
                       element.user = {
                            id: 1000000,
                            firstname: element.agent_firstname,
                            lastname: element.agent_lastname,
                            email: element.agent_email
                       };
                       var msg = element.duration+' sec. ' + (type&&type!='0'?type+' ':'') + (element.on_master?' (Italia)':'');
                        element.note = msg;
                        //vm.setUser(element);
                        response.data.data.customer_actions.data.push(element);
                    });
                }


                    //vm.chartCassaBubble.data[0][0].r = vm.customer.tot[0][0];
                    //vm.chartCassaBubble.data[1][0].r = vm.customer.tot[1][0];
                    //vm.chartCassaBubble.data[2][0].r = vm.customer.tot[2][0];

                    angular.forEach(response.data.data.customer_actions.data, function(element) {
                        element.user_color = "#FFFFFF";
                        if (element.entity==null) {
                          element.entity = 'customer_action';

                          //se cè un search nei 15 gg allora metto isRullo = true
                          if (element.type=='pageview') {
                              var d = moment(element.created_at.date);
                              //$log.info(element);
                              //$log.info(d);
                              var diff = moment().diff(d,'days');
                              //$log.info(moment().diff(d,'days'));
                              if (diff<=15) {
                                  vm.isRullo = true;
                              }
                          }
                        }
                        if (element.call_date!=null && element.call_date.date!=null) {
                            element.call_date = new Date(element.call_date.date);
                        } else if (element.call_date!=null) {
                          element.call_date = new Date(element.call_date);
                        }
                        if (element.created_at!=null && element.created_at.date!=null) {
                        element.call_date = new Date(element.created_at.date);
                      } else if (element.created_at!=null) {
                        element.call_date = new Date(element.created_at);
                      }
                        angular.forEach(vm.operatorsList, function(operator) {
                            if (operator.user_id == element.user_id) {
                                if (operator.store_id == element.store_id) {
                                        element.user_color = operator.color
                                }
                                if (!element.user) {
                                    element.user = operator.user;
                                }
                            }
                        });
                        //vm.setStore(element);
                        if (element.type == 'call') {
                            vm.months.addEvent('calls', element.treatment_category_id, moment(element.call_date));
                        }
                    });

                    angular.forEach(response.data.data.customer_subscriptions.data, function(element) {
                        angular.forEach(vm.subscriptionsList, function(subscription) {
                            if (subscription.id == element.subscription_id) {
                                element.subscription = subscription;
                            }
                        });
                    });

                    vm.loading = false;
                }
                vm.loading = false;
            },
            function (response) {
                var errMsg = "";
                if (response.data!=null && response.data.message!=null) {
                    errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    if (url!=null) {
                        errMsg+= "\nUrl: " + url;
                    }
                }
                alert ("Si è verificato un errore nel caricamento cliente: " + errMsg);
                vm.loading = false;
            });
        };
        vm.setUser = function(element) {
            angular.forEach(vm.operatorsList, function(operator) {
              if (operator.user_id == element.user_id) {
                  if (operator.store_id == element.store_id) {
                      element.user_color = operator.color;
                  }
                  if (!element.user) {
                      element.user = operator.user;
                  }
              }
          });
        };
        vm.setStore = function(element) {
          if (element.store_id!=null) {
            angular.forEach(vm.storesList, function(store) {
                if (store.id == element.store_id) {
                  element.store = store;
                }
            });
          }
        };
        vm.reset = function() {
            angular.forEach(vm.months.data, function(month) {
                month.flags = [false,false,false];
                month.calls = [false,false,false];
            });
        }
        vm.prossimo = function () {
            vm.customer_id = null;
            vm.phone = null;
            vm.reset();
            /*if (!vm.paid) {
                vm.dormientiDa = undefined;
            }*/
            vm.customerLoad();
        };
        vm.setAppSelected = function (app) {
          //$log.info(app);
          if (vm.appXSub != null && vm.appXSub.id == app.id || !app.paid) {
            vm.appXSub = null;
          } else {
            vm.appXSub = app;
          }
        };
        vm.addAppToSub = function (sub) {
          //salvo l'appuntamento con il sub_id
          //$log.info(vm.appXSub);
          //$log.info(sub.id);
          CrudService.update( 'appointments', {
                id: vm.appXSub.id,
                customer_id: vm.appXSub.customer_id,
                treatment_id: vm.appXSub.treatment_id,
                customer_subscription_id: sub.id,
                type: 'abb',
                updatingField: 'price',
                changeAbb: true
              }, vm,
              function (response) {
                vm.appXSub.customer_subscription_id = sub.id;
                sub.app_remaining = sub.app_remaining-1;
                sub.zone_remaining = sub.zone_remaining - vm.appXSub.treatment.zone;
              },
              function (response) {
              }
          );
        };
        vm.delAppFromSub = function (sub) {
        //salvo l'appuntamento con il sub_id
          //$log.info(vm.appXSub);
          CrudService.update( 'appointments',
              {id: vm.appXSub.id,
                customer_id: vm.appXSub.customer_id,
                customer_subscription_id: null,
                treatment_id: vm.appXSub.treatment_id,
                type: null,
                updatingField: 'price',
                changeAbb: true
              }, vm,
              function (response) {
                vm.appXSub.customer_subscription_id = null;
                sub.app_remaining = sub.app_remaining+1;
                sub.zone_remaining = sub.zone_remaining + vm.appXSub.treatment.zone;
              },
              function (response) {
              }
          );
        };
        vm.removeSub = function (sub) {
            var confirm = $mdDialog.confirm()
            .title( 'Attenzione' )
            .textContent( 'Sei sicuro di voler eliminare l\'abbobamento numero '+sub.id+'?' )
            .ariaLabel( 'Attenzione' )
            .ok( 'Si' )
            .cancel( 'Ops, ho sbagliato' );
        return $mdDialog
            .show( confirm )
            .then( function() {
                CrudService.del( 'customer_subscriptions', sub.id, vm,
                        function (response) {
                          var ns = vm.activeCustomer.customer_subscriptions.data;
                          vm.activeCustomer.customer_subscriptions.data = [];
                          angular.forEach(ns, function (s){
                            if (s.id != sub.id) {
                              vm.activeCustomer.customer_subscriptions.data.push(s);
                            }
                          });
                        },
                        function (response) {
                        }
                    );
            })
            .finally(
                function() {
                    confirm = undefined;
                }
            )
         };

        vm.chartCassaBar = {
            series: ['Epilazione', 'Viso', 'Corpo'],
            labels: [(vm.env.currency?vm.env.currency.label:'Spesa') +' cliente per categoria'],
            options: {
                legend: {display: true}
            }
        };

        //---------- Sidebar -------------------------------------//

        vm.activeCustomer = {};
        vm.activeCustomerAction = {};
        vm.toggleRight = function(command, label) {
            vm.command = command;
            vm.commandLabel = label;
            vm.activeCustomerAction = {
                call_date: moment(),
                user_id: vm.user.id,
                c_sid: vm.user.store_id,
                c_role: vm.user.type,
                store_id: vm.user.store_id,
                type: command,
                customer_id: vm.customer.id,
                interest: 0,
                created_at_frm: moment().format("DD/MM/YYYY HH:mm")
            };
            $mdSidenav('right').open();
        };
        vm.closeSidebar = function() {
            $mdSidenav('right').close();
        };

        vm.saving = false;
        vm.save = function(prenota, archivia) {
            $log.info('Salva');
            var confirm = $mdDialog.confirm()
                .title('Attenzione')
                .ariaLabel('Attenzione')
                .textContent('Sicuro di voler inserire questa azione?')
                .ok('Si')
                .cancel('Ops, ho sbagliato');
            return $mdDialog
                .show(confirm)
                .then(
                    function() {
                        vm.saving = true;
                        if (vm.activeCustomerAction.call_date) {
                            vm.activeCustomerAction.call_date = $filter('date')(new Date(vm.activeCustomerAction.call_date), 'yyyy-MM-dd HH:mm')+":00";
                        };
                        if (archivia) {
                          vm.activeCustomerAction.archived = 1;
                        }
                        CrudService.save('customer_actions', vm.activeCustomerAction, vm,
                            function(response) {
                               if (response.data && response.data.data) {
                                   var rec = response.data.data;
                                   rec.user = vm.user;
                                   rec.user_color = "#000000";
                                   rec.entity = 'customer_action';
                                   if (vm.user.store_id!=null) {
                                       rec.user_color = vm.user.color;
                                   }
                                   angular.forEach(vm.storesList, function(store) {
                                       if (store.id == rec.store_id) {
                                           rec.store = store;
                                       }
                                   });
                                   if (rec.call_date!=null) {
                                       rec.call_date = new Date(rec.call_date);
                                   }
                                   vm.customer.customer_actions.data.push(rec);
                                   if (rec.type == 'call') {
                                       //console.log(rec);
                                       vm.months.addEvent('calls', rec.treatment_category_id, moment(rec.call_date));
                                   }
                               }
                               vm.saving = false;
                               vm.closeSidebar();
                               if (prenota) {
                                 var caid = "";
                                 if (vm.isRullo && rec && rec.id) {
                                   caid="caid="+rec.id+"&";
                                 } else {
                                   caid="";
                                 }
                                   var nl = vm.env.booking +"/operator?"+caid+"store=" +vm.storeId
                                     + "&c_sid=" + vm.user.store_id
                                     + "&c_role=" + vm.user.type
                                     + "&customer=" +vm.activeCustomer.phone + "&token=" + vm.token;
                                   window.location.href = nl;
                               }
                            },
                            function(response) {
                                vm.saving = false;
                            });
                    }
                ).finally(
                    function() {
                        confirm = undefined;
                    }
               );
        };
        $scope.$watch( 'ab.paid', function ( newValue ) {
            if (newValue) {
                vm.noshow = false;
            }
        });
        $scope.$watch( 'ab.noshow', function ( newValue ) {
            if (newValue) {
                vm.paid = false;
            }
        });

        /* WATCHO Lo Store */
        vm.storesList = [];
        vm.storeId = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                if (vm.storeId==null) {//è il primo caricamento
                    vm.storeId = id;
                    vm.storesList = $scope.$parent.main.storesList;
                    vm.operatorLoad();
                } else {
                    vm.storeId = id;
                    /*if (vm.user.store_id == null && vm.paid) {
                        vm.customerLoad();
                    }*/
                }
            };
        });

        vm.iconByType = function (type, call_type) {
            if (type=='comment') {
                return "dehaze";
            } else if (type=='call') {
                if (call_type=='whatsapp') {
                    return 'question_answer';
                } else if (call_type=='messenger') {
                    return 'message';
                } else {
                    return call_type;
                }
            } else {
                return type;
            }
        };

        vm.iconByCategory = function (cat, call_type) {
          if (cat=='1') {
            return "gesture";
          } else if (cat=='2') {
            return 'face';
          } else if (cat=='3') {
            return 'accessibility';
          } else {
              return 'polymer';
          }
        };

        /* Treatments */
        vm.treatmentsList = [];

        vm.subscriptionsList = [];

        /* Operators */
        vm.operatorsList = [];
        vm.operatorLoad = function() {
            vm.operatorsList = [];
            UsersService.allRoles({with: 'user'}).then(function(response) {
                if (response.data && response.data.data) {
                    vm.operatorsList = response.data.data;
                    TreatmentService.treatments().then(function(data) {
                        vm.treatmentsList = data;
                        SubscriptionService.all({}).then(function(response) {
                            vm.subscriptionsList = response.data.data;
                            vm.customerLoad();
                        });
                    });
                };
            });
        };
    };

    CustomerController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'CustomerService',
            'env',
            'phone',
            'customer_id',
            'CallState',
            'Italia',
            'TreatmentService',
            'StoreService',
            'SubscriptionService',
            'UsersService',
            'CrudService'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('CusSubscrController', CusSubscrController);

    /** @ngInject */
    function CusSubscrController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        StoreService,
        UsersService, 
        CrudService
    ) {
        var vm = this;
        vm.env = env;
        $log.info('CusSubscrController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
        	return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        vm.today = new Date( moment().hour(8).minute(0).second(0) );
        vm.removeSearch = function () {
            vm.query.filter = '';
            //vm.query.order = 'date_start';
            vm.query.page = 1;
            vm.eStatus.filter_date_start = vm.today;
            //vm.eStatus.filter_time_start = new Date(moment().subtract(1,'hour')).getTime();
            vm.eStatus.filter_created_at = false;
            vm.eStatus.filter_date_end = null;
            vm.eStatus.selectedFilter = null;
            vm.eStatus.selectedOperatorId = null;
            vm.eStatus.selectedByOperatorId = null;
            vm.eStatus.selectedFilterFreq = null;
            vm.eStatus.selectedFilterActiveTerm = null;
            vm.eStatus.selectedFilterRit = null;
            vm.eStatus.uncoveredFilter = null;
            //vm.treatmentdate = null;
            vm.eListLoad(1);
        };
        vm.filtersListActiveTerm = [
            {
                value: "A",
                name: "Attivi",
            },
            {
                value: "T",
                name: "Terminati",
            }
          ];
        vm.filtersListFreq = [
            {
                value: 7,
                name: "Settimanale"
            },
            {
                value: 28,
                name: "Mensile"
            }
          ];

        vm.filtersListRit = [
            {
                value: 15,
                name: ">15gg"
            },
            {
                value: 30,
                name: ">30gg"
            },
            {
                value: 60,
                name: ">60gg"
            },
            {
                value: 120,
                name: ">120gg"
            },
            {
                value: 240,
                name: ">240gg"
            },
            {
                value: 480,
                name: ">480gg"
            }
            ];
        
        vm.options = {
            autoSelect: false,
            boundaryLinks: true,
            pageSelector: true,
            rowSelection: false,
        };
        vm.filter = {
            options: {
            	'debounce': 0,
            	'updateOn': 'default'
            }
        };
        vm.eStatus = {};
        vm.eStatus.filter_date_start = vm.today;
        vm.eStatus.filter_date_end = undefined;
        vm.eStatus.selectedFilter = null;
        vm.eStatus.selectedOperatorId = null;
        vm.eStatus.selectedByOperatorId = null;
        vm.eStatus.selectedFilterFreq = null;
        vm.eStatus.selectedFilterActiveTerm = null;
        vm.eStatus.selectedFilterRit = null;
        vm.eStatus.uncoveredFilter = null;
        vm.query = {
            filter: '',
            //filter_customer: '',
            //order: 'date_start',
            limit: 10,
            limitOptions: [ 5, 10, 15, 20 ],
            page: 1
        };
        vm.saveStatus = function () {
          //if (true) return;
          localStorage.setItem( 'cussubscr_eStatus', angular.toJson( vm.eStatus, false ) );
          localStorage.setItem( 'cussubscr_query', angular.toJson( vm.query, false ) );
        };
        vm.restoreStatus = function () {
          //if (true) return;
          var eStatus = angular.fromJson(localStorage.getItem('cussubscr_eStatus'));
          if (eStatus!=null) {
            vm.eStatus = eStatus;
          }
          var query = angular.fromJson(localStorage.getItem('cussubscr_query'));
          if (query!=null) {
            vm.query =  query;
          }
        };
        vm.today = moment();
        vm.restoreStatus();
        vm.onKeyPressSearch = function (event) {
        	if (event.keyCode==13) {
        		vm.eListLoad(1);
        		event.stopPropagation();
        		event.preventDefault();
        	}
        }
        vm.onChangeDateStart = function() {
            vm.query.page = 1;
            if( vm.eStatus.filter_date_start && vm.eStatus.filter_date_end ) {
                if( moment( vm.eStatus.filter_date_end ).hour(23).minute(59).second(59).isBefore( vm.eStatus.filter_date_start ) ) {
                    vm.eStatus.filter_date_end = null;
                }
            }
            vm.eListLoad(null);
        };
        vm.onChangeDateEnd = function() {
          vm.query.page = 1;
          if( vm.eStatus.filter_date_start && vm.eStatus.filter_date_end ) {
              if( moment( vm.eStatus.filter_date_end ).hour(23).minute(59).second(59).isBefore( vm.eStatus.filter_date_start ) ) {
                  vm.eStatus.filter_date_start = vm.eStatus.filter_date_end;
              }
          }
          vm.eListLoad(null);
        };
        vm.loading = true;
        vm.eList = [];
    	vm.eListPag = {"total":0,"count":10,"per_page":10,"current_page":1,"total_pages":0,"links":{} }; 
        vm.eListLoad = function(p, s) {
          vm.eList = [];
        	vm.loading = true;
        	if (p==null) {
        		p = vm.query.page;
        	}
        	vm.query.page = p;
        	if (s==null) {
        		s = parseInt(vm.eListPag.per_page);
        	}
        	var pars = {page:p, s: s, searchJoin: 'and', with: 'subscription;customer;appointments'};
        	var search = [];
        	var searchFields = [];
        	if (vm.query.filter!=null && vm.query.filter!='') {
        		pars.filtro=vm.query.filter;
        	}
        	if (vm.eStatus.filter_date_start!=null && vm.eStatus.filter_date_start!='') {
          	  var dField = 'customer_subscription.created_at';
          	  search.push(dField+":"+moment(vm.eStatus.filter_date_start).format("YYYY-MM-DD"));
              searchFields.push(dField+":>=");
          	}
          	if (vm.eStatus.filter_date_end!=null && vm.eStatus.filter_date_end!='') {
          	  var date_end = moment(vm.eStatus.filter_date_end).format("YYYY-MM-DD 23:59:59.9");
          	  pars.created_at_to=date_end;
          	}
        	if (vm.eStatus.selectedFilterRit) {
        		pars.rit = vm.eStatus.selectedFilterRit;
        		vm.eStatus.selectedFilterActiveTerm = "A";
        	}
        	if (vm.eStatus.selectedFilterActiveTerm) {
        		pars.active = vm.eStatus.selectedFilterActiveTerm;
        	}
        	if (vm.eStatus.selectedFilterFreq) {
        		pars.freq = vm.eStatus.selectedFilterFreq;
        	}
        	vm.saveStatus();
        	pars.search = search.join(";");
        	pars.searchFields = searchFields.join(";");
        	CrudService.all('customer_subscriptions', pars, vm, 
        		function(response) {
	                if (response.data && response.data.data && response.data.data.length) {
	                	angular.forEach(response.data.data, function(cs) {
	                		if (cs.appointments.data.length>0) {
	                			cs.lastappointment = cs.appointments.data[0];
	                			var lastDate = moment(cs.lastappointment.date_start);
	                			cs.haveFutureApp = lastDate.isAfter(vm.today);
	                			cs.lastappointment.date_start_frmt = moment(cs.lastappointment.date_start).format("DD/MM/YYYY HH:mm");
	                			cs.isEnded = cs.f_over || cs.app_remaining==0 || (cs.zone_total>0 && cs.zone_remaining==0);
	                			cs.daysLastApp = !cs.haveFutureApp && !cs.isEnded? lastDate.diff(vm.today,'days'):'';
	                		}
	                		
	                	});
	                    vm.eListPag = response.data.meta.pagination;
	                    vm.eList = response.data.data;
	                    
	                }
					vm.loading = false;
        		},
        		function () {
					vm.loading = false;
        		}
            );
        };
        vm.eListLoad();
        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(e) {
          if (vm.env.isMaster &&  (vm.user.type == 'admin' || vm.user.type=='backoffice')) {
            vm.toggleRight(e);
          }
        };
        vm.activeEntity = {};
        vm.updateEntity = {};
        vm.toggleRight = function(e) {
        	if (e!=null && e.id != null) {
				angular.copy(e, vm.updateEntity)
                vm.activeEntity = vm.updateEntity;
				/*if (vm.activeEntity.active==1) {
					vm.activeEntity.active = true;
				} else if (vm.activeEntity.active==0) {
					vm.activeEntity.active = false;
				}*/
            } else {
				vm.updateEntity = {};
				vm.activeEntity = {
                	id: null,
                	active: 1
                };
            }
            $timeout($mdSidenav('right').open, 0);
        };
        vm.resetAll = function() {
			vm.activeEntity = {}
			vm.updateEntity = {}
            $scope.entityForm.$setPristine();
            $scope.entityForm.$setUntouched();
        };
        vm.closeSidebar = function() {
			vm.resetAll();
        	$mdSidenav('right').close();
        };
        vm.saving = false;
        vm.save = function(e) {
        	if (true) return;
        	$log.info('Salva');
            if (angular.isDefined(e)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler salvare?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {	
                        		vm.saving = true;
								CrudService
                                    .save( 'customer_subscriptions', vm.activeEntity, vm ,
										function(response) {
                                    		if (vm.activeEntity.id) {
                                    			var id = vm.activeEntity.id;
                                    			vm.activeEntity.max_app = parseInt(response.data.data.max_app);
                                    			var position = vm.eList.map( function( x ) { return x.id; } ).indexOf( id );
                                        		angular.copy(vm.activeEntity, vm.eList[position]);
                                    		} else {
                                    			vm.eList.push(response.data.data);	
                                    		}
                                    		vm.closeSidebar();
                                    		vm.saving = false;
										},
										function(response) {
											vm.saving = false;
										});
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };
		
        
        vm.end = function(e) {
        	$log.info('Termina');
            if (angular.isDefined(e.id)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler terminare questo abbonamento?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {	
                        		CrudService
                                    .update( 'customer_subscriptions', {id: e.id, f_over: true}, vm ,
										function(response) {
                                    		e.f_over = true; 
                                    	},
										function(response) {
										});
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };
		
        
        
		vm.del = function ( id ) {
            $log.info( 'Del' );
            if( angular.isDefined( id ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler eliminare questo abbonamento?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            CrudService.del( 'customer_subscriptions', id, vm, 
								function( response ) {
                            		var position = vm.eList.map( function( x ) { return x.id; } ).indexOf( id );
                            		vm.eList.splice(position, 1);
								},
								function( response ) {
								}
							);
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };
        
        vm.storeId = null;
        vm.store = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                vm.storeId = id;
                angular.forEach($scope.$parent.main.storesList, function (s) {
  			      if (s.id == vm.storeId) {
  			        vm.store = s;
  			      }
  			    });
            }
        });
        
    };

    CusSubscrController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',            
            'StoreService',
            'UsersService',
            'CrudService'
        ];

})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .controller( 'CustomerPaymentsController', CustomerPaymentsController )
    ;

    /** @ngInject */
    function CustomerPaymentsController(
        $scope,
        $log,
        $mdDialog,
        moment,
        StoreService,
        CustomerService,
        $filter,
        $timeout,
        $location,
        $mdSidenav,
        $mdToast,
        UsersService,
        env,
        customer_id,
        CrudService
    ) {
        var vm = this;
        
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
        	return;
        }
        
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        $log.info( 'CustomerPaymentsController' );
        //---------- Appointments -------------------------------------//
        vm.viewAction = false;
        vm.customersLoading = false;
        vm.isNewAppointment = false;
        vm.customer_id = undefined;
        vm.paymentDateTMP = null;
        vm.selected = [];
        vm.recall_types = [
            {
            	value: 0,
                text: "NO",
                text_esteso: "Non ricordato",
            },
            {
                value: 1,
                text: "SI",
                text_esteso: "Ricordato con risposta",
            },
            {
                value: 2,
                text: "NO RISP",
                text_esteso: "Ricordato senza risposta",
            }
        ];
        vm.options = {
            autoSelect: false,
            boundaryLinks: true,
            pageSelector: true,
            rowSelection: false,
        };
        vm.filter = {
            options: {
            	'debounce': 0,
            	'updateOn': 'default'
            }
        };
        vm.query = {
                filter: '',
                filter_customer: '',
                month: moment().format('MM'),
                year: moment().format('YYYY'),
                order: 'date',
                limit: 100,
                limitOptions: [ 5, 10, 15, 20],
                page: 1
        };
        vm.years = [];
        for (var i=2017; i-1<=parseInt(vm.query.year); i++) {
        	vm.years.push(''+i);
        }
        vm.eStatus = {};
        
        vm.saveStatus = function () {
          //if (true) return;
          localStorage.setItem( 'cuspaym_eStatus', angular.toJson( vm.eStatus, false ) );
          localStorage.setItem( 'cuspaym_query', angular.toJson( vm.query, false ) );
        };
        vm.restoreStatus = function () {
          //if (true) return;
          var eStatus = angular.fromJson(localStorage.getItem('cuspaym_eStatus'));
          if (eStatus!=null) {
            vm.eStatus = eStatus;
          }
          var query = angular.fromJson(localStorage.getItem('cuspaym_query'));
          if (query!=null) {
            vm.query =  query;
          }
        };
        vm.restoreStatus();
        vm.resetTable = function() {
            vm.query.page = 1;
            //vm.calcsOnVisibileElements();
        };
        vm.removeSearch = function () {
            vm.query.filter = '';
            vm.query.order = 'date';
            vm.query.month = moment().format('MM');
            vm.query.year = moment().format('YYYY');
            vm.query.page = 1;
            vm.entitiesListLoad(1);
        };
        
        vm.totFirstTime = 0;
        vm.totPrices = 0;
        vm.appointmentsList = [];
        vm.loading = true;
        vm.entitiesListPag = {"total":0,"count":10,"per_page":10000,"current_page":1,"total_pages":0,"links":{} }; 
        vm.entitiesListLoad = function(p, s) {
        	vm.entitiesList = [];
        	if (!vm.storeId) {
        		vm.loading = false;
            	return;
        	}
        	vm.loading = true;
        	if (p==null) {
        		p = vm.query.page;
        	}
        	vm.query.page = p;
        	vm.saveStatus();
        	if (s==null) {
        		s = parseInt(vm.entitiesListPag.per_page);
        	}
        	var pars = {page:p, s: s, searchJoin: 'and'};
        	var search = ['year:'+parseInt(vm.query.year)];
        	var searchFields = ['year:='];
        	search.push("store_id:"+vm.storeId);
        	searchFields.push("store_id:=");
        	if (vm.query.month) {
        		search.push('month:'+parseInt(vm.query.month));
            	searchFields.push("month:=");
        	}
        	/*search.push('year:'+vm.eStatus.filterYear);
            searchFields.push("year:=");
            search.push('month:'+vm.eStatus.filterYear);
            searchFields.push("month:=");
        	*/
            if (vm.query.filter!=null && vm.query.filter!='') {
        		pars.filtro=vm.query.filter;
        	}
        	if (vm.query.order!=null && vm.query.order!='') {
        		if (vm.query.order.indexOf("-")==0) {
        			pars.orderBy = vm.query.order.substring(1);
        			pars.sortedBy = "desc";
        		} else {
        			pars.orderBy = vm.query.order;
        			pars.sortedBy = "asc";
        		}
        	}
        	pars.search = search.join(";");
        	pars.searchFields = searchFields.join(";");
        	pars.with = "customer";
            CrudService.all( 
            		'customer_payments',
            		pars,
            		vm,
            		function( response ) {
        				vm.entitiesList = [];
		                if( response.data && response.data.data ) {
		                	vm.entitiesListPag = response.data.meta.pagination;
		                	angular.forEach( response.data.data, function( elem ) {
		                        //$log.info(elem);
		                		elem.date_frmt = moment(elem.date.date).format('DD/MM/YYYY');
		                        vm.entitiesList.push( elem );
		                    });
		                    vm.loading = false;
		                    vm.calcsOnVisibileElements();
		                };
            		},
			        function (response) {
			        	var errMsg = "";
			        	if (response.data!=null && response.data.message!=null) {
			        		errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
			        		var url = response.config!=null && response.config.url!=null?response.config.url:"";
			        		if (url!=null) {
			        			errMsg+= "\nUrl: " + url;
			        		}
			        	}
			        	alert ("Si è verificato un errore nel caricamento appuntamenti: " + errMsg);
			        	vm.loading = false;
			        });
        };
        
        vm.onChangeFilterCreatedAt = function () {
          if (vm.eStatus.filter_created_at) {
            vm.query.order = 'created_at';
          } else {
            vm.query.order = 'date_start';
          }
          vm.query.page=1;
          vm.entitiesListLoad(1);
        };
        
        vm.appointmentsListReOrder = function (column) {
        	vm.query.order = column;
        	vm.entitiesListLoad(1);
        };
        vm.onKeyPressSearch = function (event) {
        	if (event.keyCode==13) {
        		vm.entitiesListLoad(1);
        		event.stopPropagation();
        		event.preventDefault();
        	}
        }
        vm.delAp = function ( id ) {
            $log.info( 'Del' );
            if( angular.isDefined( id ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler eliminare questa rata in scadenza?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            var position = vm.entitiesList.map( function( x ) { return x.id; } ).indexOf( id );
                            /*AppointmentsService.del( vm.entitiesList[ position ] ).then( function( response ) {
                                vm.calcsOnVisibileElements();
                                if( response.status === 204 ) {
                                    vm.entitiesList.splice( position, 1 );
                                } else {
                                    alert("Errore durante l'elaborazione delle richiesta.");
                                };
                            });*/
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };

        /* Ricordato Non-Ricordato ... disdetto spostato */
        vm.rememberApSelect = function ( id, old_value ) {
            $log.info( 'Ricordato Non-Ricordato' );
            vm.activeE = null;
            var position = vm.entitiesList.map( function( x ) { return x.id; } ).indexOf( id );
            if( position !== -1 ) {
            	var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent(
                        'Sicuro di voler segnare come "' +
                        vm.recall_types[ vm.entitiesList[ position ].recalled ].text_esteso.toUpperCase() +
                        '" questa rata in scadenza?'
                    )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                        	  angular.copy( vm.entitiesList[ position ], vm.update_appointment );
                        	  	//$log.info(vm.user);
                        		CrudService.update('customer_payments',  {id: vm.update_appointment.id, 
                        		                              recalled: vm.update_appointment.recalled}, vm,
                        		    function (response) {
                        		        vm.checkResponse(response, vm.entitiesList[ position ]);
                        		    },
                        		    function (response) {
                        		    	vm.entitiesList[ position ].recalled = old_value;
                        		    	vm.checkResponse(response, vm.entitiesList[ position ]);
                        		    }
                        		) ;
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };

        vm.showInfoApps = function( cp ) {
        	var dialog = $mdDialog.confirm({
                  title: 'Info rata '+cp.num+'/'+cp.num_total+' del ' + cp.date_frmt + ' di ' + (cp.customer.data.firstname!=null?cp.customer.data.firstname.toUpperCase():'') 
                  + ' ' + (cp.customer.data.lastname!=null?cp.customer.data.lastname.toUpperCase():'') + " (cpid="+cp.id+")",
                  ariaLabel: 'Info rata',
                  templateUrl: 'app/cuspaym/dialogs/appointments-info.html',
                  escapeToClose: true,
                  controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                      $scope.title = this.title;
                      $scope.button_ok = 'Chiudi';
                      $scope.questo = cp;
                      $scope.close = function() {
                          $mdDialog.hide( true );
                      };
                      $scope.origin = null;
                      $scope.payment = null;
                      $scope.loading = true;
                      $scope.loadOrigin = function () {
                          var pars = {};
                          pars.with = "treatment;user";
                          if (cp.appointment_id != null) {
                            CrudService.get('appointments', cp.appointment_id, pars, vm, 
                            		function (response) {
	                                    $scope.origin = response.data.data;
	                                    vm.dateFormat($scope.origin);
	                                },
	                                 function (response) {
	                                });
	                      }
                       };
                       
                       $scope.loadPayment = function () {
                    	   var pars = {};
                           pars.with = "treatment;user";
                           if (cp.app_id_payment != null) {
                             CrudService.get('appointments', cp.app_id_payment, pars, vm, 
                             		function (response) {
 	                                    $scope.payment = response.data.data;
 	                                    vm.dateFormat($scope.payment);
 	                                    $scope.loading=false;
 	                                },
 	                                 function (response) {
 	                                    $scope.loading = false;
 	                                });
 	                      } else {
 	                    	  if (cp.total_paid==0) {
 	                    		  /**
 		                    	   * carico quelli nel mese 15gg prima e 15gg dopo la data
 		                    	   */
 		                    	  var de = moment(cp.date.date).add(15, 'days').format('YYYY-MM-DD');
 		                    	  var ds = moment(cp.date.date).add(-15, 'days').format('YYYY-MM-DD');
 		                    	  pars.search = "date_start:"+ds+";date_end:"+de+";customer_id:"+cp.customer.data.id+";recalled:3";
 		                    	  pars.searchFields = "date_start:>=;date_end:<=;customer_id:=;recalled:<";
 		                    	  CrudService.all('appointments', pars, vm, 
 	                        		function (response) {
 		                    		  if (response.data) {
 	                                    $scope.paymentCandidates = response.data.data;
 	                                    angular.forEach($scope.paymentCandidates, function (app) {
 	                                    	vm.dateFormat(app);	
 	                                    });
 		                    		  }
 	                                  $scope.loading=false;
 	                                },
 	                                 function (response) {
 	                             });
 	                    	  } else {
 	                    		 $scope.loading=false;
 	                    	  }
 	                    	 
 	                      }
                      };
                      $scope.loadOrigin();
                      $scope.loadPayment();
                  }]
            });
            return $mdDialog
            .show( dialog )
            .finally(
                function() {
                    dialog = undefined;
                }
            );
        };
        vm.dateFormat = function(elem) {
        	elem.date_start_frmt = moment( elem.date_start ).format('DD/MM/YYYY HH:mm');
            elem.date_end_frmt = moment( elem.date_end ).format('HH:mm');
            
        };
        
        
        //---------- Sidebar -------------------------------------//
        vm.testsVisible = false;
        vm.currentSubscription = '';
        vm.isDeleteAllowed = true;
        vm.undoVisible = false;
        vm.img_loading = false;
        vm.activeAppointment = null;
        vm.backup_appointment = {};
        vm.update_appointment = {};
        vm.empty_appointment = {};
        /* Element Clicked */
        vm.updatingField = '';
        vm.rowClicked = function ( appointment , field) {
        	vm.updatingField = (field==null?'':field);
        	vm.toggleRight( appointment, true);
        	//$log.info(appointment);
        };
        vm.toggleRight = function ( appointment, isRowClick ) {
        	var customer_subscription_id = '';
            vm.isNewAppointment = !isRowClick;//angular.isUndefined( appointment );
            if (!isRowClick) {
            	vm.updatingField = '';
            }

            if( ! vm.isNewAppointment ){
                vm.paymentDateTMP = new Date( appointment.date.date );
            }
            else {
                vm.paymentDateTMP = new Date();
                /**
                 * Svuoto la ricerca customers e la lista
                */
                vm.customersReset();
                appointment = {
                    payment_type:'C',
                    recalled: 0,
                    total_paid: 0
                 };
            }

            vm.activeE = appointment;
            angular.copy( vm.activeE, vm.backup_appointment );

            return $mdSidenav( 'right' ).open();
        };
        vm.closeSidebar = function () {
            if( vm.undoVisible ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .textContent( 'Ci sono delle modifiche non commissionate, proseguire?' )
                    .ariaLabel( 'Attenzione' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then( vm.undo )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            } else {
                vm.resetAll();
            };
        };

        vm.angularFormReset = function() {
            $scope.appointmentForm.$setPristine();
            $scope.appointmentForm.$setUntouched();
        };
        vm.resetForm = function() {
            vm.undoVisible = false;
            return $mdSidenav( 'right' ).close().then(function() {
                vm.activeE = null;
                vm.update_appointment = {};
                vm.paymentDateTMP = null;
                vm.angularFormReset();
            });
        };
        vm.resetAll = function () {
            return $timeout( vm.resetForm, 10 );
        };
        vm.undo = function () {
            $log.info( 'Undo' );
            if( ! angular.equals( vm.activeE, vm.backup_appointment ) ) {
                angular.copy( vm.backup_appointment, vm.activeE );
            };
            vm.resetAll();
        };
        /* Response */
        vm.showActionToast = function( text ) {
            text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent( text )
                .action( '' )
                .highlightAction( true )
                .position( 'bottom right' )
            ;
            return $mdToast
                .show( toast )
                .finally(
                    function() {
                        toast = undefined;
                    }
                )
            ;
        };
        vm.responseStatusSuccessful = [ 200, 201, 202 ];
        vm.checkResponse = function ( response, appointment ) {
            if( vm.responseStatusSuccessful.indexOf( response.status ) === -1) {
            	var errMsg = "";
            	if (response.data!=null && response.data.message!=null) {
            		errMsg = response.data!=null && response.data.message!=null?response.data.message:"";
            		var url = response.config!=null && response.config.url!=null?response.config.url:"";
            		vm.showActionToast("KO: " + errMsg + " " + url);
            	}
                var alert = $mdDialog.alert()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( "C'è stato un problema: "+errMsg)
                    .ok( 'Ok' )
                ;
                return $mdDialog
                    .show( alert )
                    .then( function () { 
                    	vm.resetAll();
                    })
                    .finally(
                        function() {
                            alert = undefined;
                        }
                    )
                ;
            } else {
            	/**
            	 * Aggiorno user.data con il nuovo valore
            	 */
            	vm.showActionToast();
                return vm.resetAll();
            };
        };

        // Salva e Aggiorna
        vm.save = function ( appointment ) {
            $log.info( 'Salva' );
            if( angular.isDefined( appointment ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler inserire questa rata in scadenza?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            angular.copy( appointment, vm.update_appointment );
                            vm.update_appointment.customer_id = vm.customer_id;
                            vm.update_appointment.by_operator = vm.userId;
                            vm.update_appointment.store_id = vm.storeId;
                            var dataApp = moment(vm.paymentDateTMP).format('YYYY-MM-DD');
                            vm.update_appointment.date = dataApp + ' 00:00:00';
                            CrudService
                                .save( 'customer_payments', vm.update_appointment, vm, 
                                    function( response ) {

                                        vm.checkResponse( response );
                                        if( response && response.data && response.data.data ) {
                                            var elem = response.data.data
                                                , position = vm.customersList.map( function( x ) { return x.id; } ).indexOf( vm.customer_id );
                                            ;

                                            elem.date_frmt = moment(elem.date).format('DD/MM/YYYY');
                                            
                                            elem.customer = {
                                                data: vm.customersList[ position ]
                                            };
                                            vm.entitiesList.push( elem );
                                            vm.calcsOnVisibileElements();
                                        };
                                    },
                                    vm.checkResponse
                                );
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };
       
        vm.update = function ( appointment ) {
            $log.info( 'Update' );
            if( angular.isDefined( appointment ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler aggiornare?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            angular.copy( appointment, vm.update_appointment );
                            var dataApp = moment(vm.paymentDateTMP).format('YYYY-MM-DD');
                            vm.update_appointment.date = dataApp + ' 00:00:00';
                            CrudService.update( 'customer_payments', vm.update_appointment, vm,
                            		function (response) {
                            			var elem = response.data.data;
                            			elem.date_frmt = moment(elem.date).format('DD/MM/YYYY');
                            			appointment.date_frmt = elem.date_frmt;
                                    	vm.resetAll();
                            			vm.calcsOnVisibileElements();
                            		},
                            		function (response) {
                            			vm.resetAll();
	                                }
                            );

                        },
                    	function () {
                        	
                		}
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            }
        };


        /* Load Customers */
        vm.customersList = [];
        vm.query.filter_customer = '';        
        vm.customersLoad = function ( customer_id ) {
            vm.customersList = [];
            var pars = {limit:30, orderBy: 'firstname'};
            var search = [];
            var searchFields = [];
            if (customer_id!=null) {
            	search.push("id:"+customer_id);
            	searchFields.push("id:=");
            }
            if (vm.query.filter_customer!=null && vm.query.filter_customer!='') {
            	pars.filtro = vm.query.filter_customer; 
            }
            if (search.length>0) {
            	pars.search = search.join(";");
            	pars.searchFields = searchFields.join(";");
            }
            return CustomerService
                .users_for_appointment(pars).then(
                    function( response ) {
                        if( response.data && response.data.data ) {
                            vm.customersList = response.data.data.map(
                                function( customer ) {
                                    customer.fullName =  (
                                        ( customer.firstname || '' )
                                        + ' '
                                        + ( customer.lastname || '' )
                                    ).toUpperCase();

                                    return customer;
                                }
                            );
                            if (vm.customersList.length==0) {
                            	vm.showActionToast("Nessun elemento trovato.");
                            }
                            if( customer_id )
                                vm.customer_id = customer_id;

                            /*$timeout(
                                function() {*/
                                    vm.customersLoading = false;
                            /*    }, 60
                            )*/
                        };
                    }
                )
            ;
        };
        vm.customersReset = function () {
        	vm.customersList = [];
        	vm.query.filter_customer = '';
        };
        vm.onKeyUpCustomersSearch = function (evento, obj) {
        	if (evento.keyCode==13)  {
        		/*if (evento.currentTarget.value != vm.query.filter_customer) {
        			vm.query.filter_customer = evento.currentTarget.value;
        		}*/
        		vm.customersLoad(null);
        		evento.stopPropagation();
        		evento.preventDefault();
        	}
        };
        /* Controllo se c'è un Customer Id nell'URL */
        if( customer_id && angular.isDefined( customer_id ) ) {
            vm.customersLoading = true;
            $timeout(
                function() {
                    vm.toggleRight(null, false).then(
                        function() {
                            vm.customersLoad( customer_id );
                        }
                    );
                },
                200
            );
        }

        /* WATCHO Lo Store */
        vm.storeId = -1;
        vm.store = {};
        $scope.$watch( '$parent.selectedStore', function( id ) {
        if( angular.isDefined( id ) ) {
			    vm.storeId = id;
			    angular.forEach($scope.$parent.main.storesList, function (s) {
			      if (s.id == vm.storeId) {
			        vm.store = s;
			      }
			    });
			    vm.entitiesListLoad(1);
			 }
		});

     vm.calcsOnVisibileElements = function() {
        $timeout(function () {
           vm.totFirstTime = 0;
           vm.totPrices = 0;
           vm.totPricesPaid = 0;
           vm.entitiesList.forEach(function(item) {
             //console.log(item);
        	 vm.totPrices = vm.totPrices + item.total;
        	 vm.totPricesPaid = vm.totPricesPaid + item.total_paid;    
           });
           vm.deltaPrices = vm.totPricesPaid - vm.totPrices;
        });
     };

    
     vm.filterPhone = function (phone) {
    	 vm.query.filter = phone;
    	 vm.entitiesListLoad(1);
     };
     
     vm.showNote = function (a) {
    	 if (a.note==null || a.note.trim()=='') return; 
    	 var p = $mdDialog.confirm()
    	 		.title("Nota su " + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'') 
              + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'')
           ).textContent(a.note)
    	 		.ok( 'Ok' );
    	 return $mdDialog.show( p );
     };
     
    };

    CustomerPaymentsController
        .$inject = [
            '$scope',
            '$log',
            '$mdDialog',
            'moment',
            'StoreService',
            'CustomerService',
            '$filter',
            '$timeout',
            '$location',
            '$mdSidenav',
            '$mdToast',
            'UsersService',
            'env',
            'customer_id',
            'CrudService'
        ]
    ;
})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .service(
            'CusactService',
            [
                '$log',
                'env',
                '$http',
                function(
                    $log,
                    env,
                    $http
                ) {
                    return {
                        all : function(pars) {
                            var apiURI = env.API + '/customer_actions';
                            return $http.get( apiURI, { params:  pars } );
                        },
                        get : function( id, withAppointments ) {
                            if( angular.isDefined( id ) && id ) {
                                var apiURI = env.API + '/customer_actions/' + id + ((withAppointments) ? '?with=appointments' : '');
                                return $http.get( apiURI );
                            }
                        },
                        counters : function(pars, uid) {
                          var apiURI = env.API + '/customer_actions/counters/'+uid;
                          return $http.get( apiURI, { params:  pars } );
                        },
                        update : function( data ) {
                            if(
                                angular.isDefined( data ) &&
                                angular.isObject( data ) &&
                                data.id
                            ) {
                                var apiURI = env.API + '/customer_actions/' + data.id;
                                return $http.put( apiURI, data );
                            };
                        },
                        assignTo : function( data, uid ) {
                          if(
                              angular.isDefined( data ) &&
                              angular.isObject( data ) 
                          ) {
                              var apiURI = env.API + '/customer_actions/assignto/' + uid;
                              return $http.put( apiURI, data );
                          };
                        },
                        del : function( id ) {
                            if( id ) {
                                var apiURI = env.API + '/customer_actions/' + id;
                                return $http.delete( apiURI );
                            };
                        },
                        save : function( data ) {
                            if(
                                angular.isDefined( data ) &&
                                angular.isObject( data )
                            ) {
                                var apiURI = env.API + '/customer_actions';
                                return $http.post( apiURI, data );
                            };
                        },
                    };
                }
            ]
        );
})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('CusactsController', CusactsController);

    /** @ngInject */
    function CusactsController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        CusactService,
        env,
        CallState,
        TreatmentService,
        /*
        Italia,
        StoreService,
        SubscriptionService,*/
        UsersService
    ) {
        var vm = this;
        $log.info('CusactController');

        vm.mdDialog = $mdDialog;

        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        /* Treatments */
        vm.treatmentsList = [];
        TreatmentService.categories().then(function(data) {
            vm.treatmentsList = data;
        });
        /*
        vm.subscriptionsList = [];
        SubscriptionService.all({
            search: 1,
            searchFields: 'active:='
        }).then(function(response) {
            vm.subscriptionsList = response.data.data;
        });
        */

        //---------- Cusacts Table -------------------------------------//
        vm.env = env;
        vm.today = new Date(moment().hours(0).minutes(0).seconds(0));
        //vm.yesterday = new Date(moment(vm.today).subtract(1, 'days'));
        vm.filtersFNew = [
          {
              value: '0',
              name: "Rientri",
          },
          {
              value: '1',
              name: "Primo ingresso",
          },
        ];
        vm.filtersFClosed = [
          {
              value: '0',
              name: "Non chiusi",
          },
          {
              value: '1',
              name: "Chiusi",
          },
        ];
        vm.filtersFArchived = [
          {
              value: '0',
              name: "Inbox",
          },
          {
              value: '1',
              name: "Archivio",
          },
        ];

        vm.call_state = CallState;

        vm.eStatus = {
            call_state: null,//undefined;//'da chiamare',//da chiamare
            filter_from: null,
            filter_to: null,
            userId: null,
            fClosed: null,
            fArchived: null
        };
        vm.options = {
            autoSelect: false,
            boundaryLinks: true,
            pageSelector: true,
            rowSelection: false
        };
        vm.filter = {
            options: {
                'debounce': 0,
                'updateOn': 'default'
            }
        };
        vm.query = {
            filter: '',
            order: '-customer_actions.created_at',
            limit: 10,
            page: 1
        };
        vm.removeSearch = function(filter) {
          if (filter) {
            vm.query.filter = filter;
          } else {
            vm.query.filter = '';
          }
            vm.query.order = '-customer_actions.created_at';
            vm.eStatus.filter_from = null;
            vm.eStatus.filter_to = null;
            vm.eStatus.userId = null;
            vm.eStatus.fClosed = null;
            vm.eStatus.fArchived = null;
            vm.eStatus.call_state = null;
            vm.query.page = 1;
            vm.eListLoad(1);
        };
        vm.saveStatus = function () {
          //if (true) return;
          localStorage.setItem( 'cusacts_eStatus', angular.toJson( vm.eStatus, false ) );
          localStorage.setItem( 'cusacts_query', angular.toJson( vm.query, false ) );
        };
        vm.restoreStatus = function () {
          //if (true) return;
          var eStatus = angular.fromJson(localStorage.getItem('cusacts_eStatus'));
          if (eStatus!=null) {
            angular.merge(vm.eStatus, eStatus);
          }
          var query = angular.fromJson(localStorage.getItem('cusacts_query'));
          if (query!=null) {
            angular.merge(vm.query, query);
          }
        };
        vm.iconByType = function (type, call_type) {
          if (type=='comment') {
            return "dehaze";
          } else if (type=='call') {
            if (call_type=='whatsapp') {
              return 'question_answer';
            } else if (call_type=='messenger') {
                return 'message';
            } else {
              return call_type;
            }
          } else {
            return type;
          }
        };

        vm.iconByCategory = function (cat, call_type) {
          if (cat=='1') {
            return "gesture";
          } else if (cat=='2') {
            return 'face';
          } else if (cat=='3') {
            return 'accessibility';
          } else {
              return 'polymer';
          }
        };
        vm.restoreStatus();
        vm.eList = [];
        vm.eListLoading = true;
        vm.eListPag = {"total":0,"count":10,"per_page":10,"current_page":1,"total_pages":0,"links":{} };
        vm.eListLoad = function(p,s) {
          vm.saveStatus();
            vm.eListLoading = true;
            vm.eList = [];
            if (p==null) {
                p = 1;
            }
            if (s==null) {
                s = parseInt(vm.eListPag.per_page);
            }
            var pars = {page: p, s:s, with: 'appointments;user;customer', searchJoin: 'and', c_role: vm.user.type, c_sid: vm.user.store_id};

            if (vm.query.filter!=null && vm.query.filter!='') {
                pars.filtro=vm.query.filter;
            }
            var search = new Array();
            var searchFields = new Array();
            if (vm.eStatus.call_state!=null && vm.eStatus.call_state!='') {
              pars.call_state = vm.eStatus.call_state;
            }

            if (vm.user.store_id!=null) {
              search.push("customer_actions.store_id:"+vm.storeId);
            searchFields.push("customer_actions.store_id:=");
            }

            if (vm.eStatus.fArchived!=undefined && vm.eStatus.fArchived!='') {
            search.push('archived:'+vm.eStatus.fArchived);
            searchFields.push('archived:=');
          }
            if (vm.eStatus.userId!=undefined && vm.eStatus.userId=='-1') {//non assegnati
            pars.assigned = 0;
            } else if (vm.eStatus.userId!=undefined && vm.eStatus.userId=='-2') {//assegnati
              pars.assigned = 1;
          } else if (vm.eStatus.userId!=undefined && vm.eStatus.userId!='') {
            search.push('customer_actions.user_id:'+vm.eStatus.userId);
            searchFields.push('customer_actions.user_id:=');
          }
            if (vm.eStatus.filter_from!=null && vm.eStatus.filter_from!='') {
              pars.created_from = moment(vm.eStatus.filter_from).format('YYYY-MM-DD');
          }
            if (vm.eStatus.filter_to!=null && vm.eStatus.filter_to!='') {
              pars.created_to = moment(vm.eStatus.filter_to).add('day',1).format("YYYY-MM-DD");
          }
            if (vm.eStatus.fClosed!=undefined && vm.eStatus.fClosed!='') {
            pars.chiusi = vm.eStatus.fClosed;
          }
            pars.search = search.join(';');
            pars.searchFields = searchFields.join(';');
            if (vm.query.order!=null && vm.query.order!='') {
                pars.orderBy = vm.query.order.indexOf('-')==0?vm.query.order.substring(1):vm.query.order;
                pars.sortedBy = vm.query.order.indexOf('-')==0?'desc':null;
            }
          CusactService.all(pars).then( function(response) {
                if (response.data && response.data.data) {
                    vm.eList = [];
                    //response.data.meta.pagination.per_page = vm.eListPag.per_page;
                    vm.eListPag = response.data.meta.pagination;
                    angular.forEach(response.data.data, function(elem) {

                        elem.created_at_frm = moment(elem.created_at.date).format("DD/MM/YYYY HH:mm");

                        if (elem.call_state == 'da chiamare' || elem.call_state == 'da richiamare') {
                          var call_date = elem.call_date ? (elem.call_date.date!=null?moment(elem.call_date.date):moment(elem.call_date)) : null;
                          elem.call_date = call_date ? new Date(call_date) : null;
                        } else {
                          elem.call_date = null;
                        }
                        if (elem.user!=null && elem.user.data!=null) {
                          vm.setUserAlias(elem, elem.user.data);
                        }
                        if (elem.appointments.data.length>0) {
                          elem.indata = new Date(moment(elem.appointments.data[0].created_at.date));
                          elem.closed = true;
                          elem.call_state = 'ha preso appuntamento';
                        } else {
                          elem.call_date = null;
                          elem.indata = null;
                          elem.closed = false;
                        }
                        vm.eList.push(elem);
                    });
                }
                vm.eListLoading = false;
            },
            function (response) {
                var errMsg = "";
                if (response.data!=null && response.data.message!=null) {
                    errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    if (url!=null) {
                        errMsg+= "\nUrl: " + url;
                    }
                }
                alert ("Si è verificato un errore nel caricamento contatti: " + errMsg);
                vm.eListLoading = false;
            });
        };
        vm.onKeyPressSearch = function (event) {
            if (event.keyCode==13) {
              if (vm.query.filter!=null) {
                vm.query.filter = vm.query.filter.trim();
                if (vm.query.filter.length==1) {
                    vm.query.order = 'customers.lastname';
                }
              }
              vm.eListLoad(1);
              event.preventDefault();
              event.stopPropagation();
            }
        };
        vm.setUserAlias = function (elem, user) {
          if (user.id == 0) {
            elem.user_alias = 'Online';
          } else {
            elem.user_alias = "";
            elem.user_alias = ((user.firstname!=null?user.firstname:'')+'   ').substring(0,3).trim();
            elem.user_alias += '.';
            elem.user_alias += ((user.lastname!=null?user.lastname:'')+'   ').substring(0,3).trim();
          }
        };
        vm.eListReOrder = function (column) {
            vm.query.order = column;
            vm.eListLoad(1);
        };
        vm.archivia = function (lead) {
          vm.saving = true;
          CusactService.update({id: lead.id, store_id: lead.store_id, archived: true}).then(
              function (response) {
                vm.checkResponse(response);
                lead.archived = response.data.data.archived;
                lead.archived_by = response.data.data.archived_by;
                vm.removeIfArchived('0', lead);
              },
              vm.checkResponse
          );
        };
        vm.removeIfArchived = function (val, lead) {
          if (vm.eStatus.fArchived == val) {
            var ind = vm.eList.indexOf(lead);
            if (ind>=0) {
              vm.eList.splice(ind, 1);
            }
          }
        };
        vm.disarchivia = function (lead) {
          vm.saving = true;
          CusactService.update({id: lead.id, store_id: lead.store_id, archived: false}).then(
              function (response) {
                vm.checkResponse(response);
                /**
                 * Se sono in archivio tolgo questa entry
                 */
                lead.archived = response.data.data.archived;
                vm.removeIfArchived('1', lead);
              },
              vm.checkResponse
          );
        };
        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(lead) {
            vm.toggleRight(lead);
        };
        //vm.undoVisible = false;
        vm.img_loading = false;
        vm.loading = false;
        vm.activeE = {};
        vm.backupE = {};
        vm.toggleRight = function(lead) {
            angular.forEach(lead.appointments.data, function(element) {
              if (element.rebuilded==null) {
                var color = '';
                angular.forEach(vm.operatorsList, function(operator) {
                    if (operator.id == element.user_id) {
                        color = operator.color;
                    }
                });
                element.date_start = new Date(element.date_start);
                element.user_color = color;
                element.rebuilded = true;
              }
            });
            vm.activeE = lead;
            angular.copy(lead, vm.backupE);
            //$log.info(    vm.activeE);
            $timeout($mdSidenav('right').open, 0);
        };
        vm.resetAll = function() {
          vm.resetForm();
          vm.activeE = {};
          vm.backupE = {};
          return ;
        };
        vm.closeSidebar = function() {
            vm.undo();
            return vm.resetAll();
        };
        vm.resetForm = function() {
            return $mdSidenav('right').close().then(function() {
                $scope.eForm.$setPristine();
                $scope.eForm.$setUntouched();
            });
        };
        vm.showActionToast = function( text) {
            text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent(text)
                .action('')
                .highlightAction(true)
                .position('bottom right');
            return $mdToast
                .show(toast)
                .finally(
                    function() {
                        toast = undefined;
                    }
                );
        };
        vm.responseStatusSuccessful = [200, 201, 202];
        vm.checkResponse = function(response) {
            vm.saving = false;
            if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
                var errMsg = "";
                if (response.data!=null && response.data.message!=null) {
                    errMsg = response.data!=null && response.data.message!=null?response.data.message:"";
                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    vm.showActionToast("KO: " + errMsg + " " + url);
                }
                var alert = $mdDialog.alert()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent("C'è stato un problema: "+errMsg)
                    .ok('Ok');
                return $mdDialog
                    .show(alert)
                    .finally(
                        function() {
                            alert = undefined;
                        }
                    );
            } else {
                vm.showActionToast();
                return vm.resetAll();
            };
        };
        vm.update = function(prenota, archivia) {
            $log.info('Update');
            var confirm = $mdDialog.confirm()
                .title('Attenzione')
                .ariaLabel('Attenzione')
                .textContent('Sicuro di voler aggiornare?')
                .ok('Si')
                .cancel('Ops, ho sbagliato');
            return $mdDialog
                .show(confirm)
                .then(
                    function() {
                        vm.saving = true;
                        var lead = vm.activeE;
                        //angular.copy(customer, vm.update_customer);
                        var call_date = null;
                        $log.info(lead.call_date);
                        var call_date = null;
                        if (lead.call_date) {
                          var nd = new Date(lead.call_date.date!=null?lead.call_date.date:lead.call_date);
                          $log.info(nd);
                          call_date = $filter('date')(nd, 'yyyy-MM-dd HH:mm:ss');
                          $log.info(call_date);
                          lead.indata = nd;
                        } else {
                          lead.indata = null;
                        }
                        var updObj = {id: lead.id,
                                      store_id: lead.store_id,
                                      call_date: call_date,
                                      call_state:
                                      lead.call_state,
                                      note: lead.note,
                                      cus_note: lead.cus_note
                                    };
                        if (!lead.archived && archivia) {
                          updObj.archived = true;
                          lead.archived = true;
                          updObj.archived_by = vm.user.id;
                          lead.archived_by = vm.user.id;
                        }
                        CusactService.update(updObj).then(
                          function (response) {
                              vm.checkResponse(response);
                              if (lead.archived) {
                                vm.removeIfArchived('0', lead);
                              }
                              if (prenota) {
                                var caid = "caid="+lead.id+"&";
                                var nl = vm.env.booking +"/operator?"
                                +caid+"store=" +vm.storeId
                                + "&tenant="+ (vm.env.tenant=='Italia'?(lead.customer.data.tenant?lead.customer.data.tenant:vm.env.currentTenant):vm.env.currentTenant)
                                + "&c_sid=" + vm.user.store_id
                                + "&c_role=" + vm.user.type
                                + "&customer=" +lead.customer.data.phone + "&token=" + vm.token;
                                window.location.href = nl;
                                return;
                              }
                          },
                          vm.checkResponse
                        );
                    }
                )
                .finally(
                    function() {
                        confirm = undefined;
                    }
                );

        };
        vm.undo = function() {
          $log.info('Undo');

          if (!angular.equals(vm.activeE, vm.backupE)) {
              angular.copy(vm.backupE, vm.activeE);
          };

          return vm.resetAll();
      };

        /* WATCHO Lo Store */
        vm.storesList = [];
        vm.storeId = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                if (vm.storeId==null) {//è il primo caricamento
                  vm.storesList = $scope.$parent.main.storesList;
                  vm.operatorLoad();
                  vm.storeId = id;
                  vm.eListLoad(1);
                } else {
                  vm.storeId = id;
                if (vm.user.store_id!=null) {
                  vm.eListLoad(1);
                }
                }
            };
        });

        vm.treatmentsList = [];
        TreatmentService.categories().then(function(data) {
            vm.treatmentsList = data;
        });

        /* Operators */
        vm.operatorsList = [];
        vm.operatorsFilterList = [];
        vm.operatorLoad = function() {
            vm.operatorsList = [];
            var search = null;
            /*if (vm.user.type=='operator') {
              search = "type:operator";
            } else {
              search = "type:callcenter";
            }
            //, search: search, searchFields: "type:="
            */
            UsersService.all({orderBy: 'lastname'}).then(function(response) {
                if (response.data && response.data.data) {
                    vm.operatorsList = response.data.data;
                    if (vm.user.store_id>0) {
                      vm.operatorsFilterList = $filter('filter')(vm.operatorsList, {type: 'operator', active: 1}, true);
                    } else {
                      vm.operatorsFilterList = $filter('filter')(vm.operatorsList, {type: 'callcenter', active: 1}, true);
                    }
                };
            });
        };
    };

    CusactsController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'CusactService',
            'env',
            'CallState',
            'TreatmentService',
            /*'Italia',
            'StoreService',
            'SubscriptionService',*/
            'UsersService'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('CostsController', CostsController);

    /** @ngInject */
    function CostsController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        $state,
        env,
        StoreService,
        UsersService,
        CrudService,
        MONTHS
    ) {
        var vm = this;
        $log.info('CostiController');
        vm.MONTHS = MONTHS;
        vm.$state = $state;
        //$log.info("mesi", vm.MONTHS);
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        vm.query = {
            filter: '',
            month: parseInt(moment().format('MM')),
            year: parseInt(moment().format('YYYY')),
            order: '-date',
            period: null,
            causal_id: null
        };
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.period = null;
            vm.query.causal_id = null;
            vm.query.month = parseInt(moment().format('MM'));
            vm.query.year = parseInt(moment().format('YYYY'));
            vm.query.order = '-date';
            vm.eListLoad();
        };
        vm.years = [];
        for (var i=2015; i-1<=parseInt(vm.query.year); i++) {
            vm.years.push(''+i);
        }
        vm.eList = [];
        vm.eListTotal = 0;
        vm.loading = true;
        vm.eListLoad = function() {
            vm.eList = [];
            vm.eListTotal = 0;
            if (!vm.perm.canRead('costs', {store_id: vm.storeId})) {
                CrudService.showActionToast(vm, "Visualizzazione dati non consentita.");
                vm.loading = false;
                return;
            }
            vm.loading = true;
            vm.query.filter = '';
            var pars = {};
            pars.with = "user;causal";
            var search = [];
            var searchFields = [];
            if (vm.storeId) {
                searchFields.push("store_id:=");
                search.push("store_id:"+vm.storeId);
            }
            searchFields.push("year:=");
            search.push("year:"+vm.query.year);
            if(vm.query.month) {
                searchFields.push("month:=");
                search.push("month:"+vm.query.month);
            }
            if(vm.query.causal_id) {
                searchFields.push("causal_id:=");
                search.push("causal_id:"+vm.query.causal_id);
            }
            if (vm.query.period) {
                if (vm.query.period == 'A') {
                    searchFields.push("day_to:<=");
                    search.push("day_to:15");
                } else if (vm.query.period == 'B') {
                    searchFields.push("day_from:>=");
                    search.push("day_from:16");
                }
            }
            pars.searchFields = searchFields.join(';');
            pars.search = search.join(';');
            CrudService.all('costs', pars, vm,
                function(response) {
                    if (response.data && response.data.data && response.data.data.length) {
                        angular.forEach(response.data.data, function(elem) {
                            vm.eListTotal+=elem.total;
                            elem.tipo = elem.prev?'Previsione':'Reale';
                            elem.nome_mese = vm.MONTHS.getName(elem.month);
                            elem.repeat = false;
                            elem.repeat_month = 1
                            if (elem.store_id) {
                                angular.forEach(vm.storesList, function(s) {
                                      if (elem.store_id == s.id) {
                                        elem.store = {data: s};
                                      }
                                });
                            } else {
                                elem.store = {data: { id: null, alias: 'Globale ' + vm.env.currentTenant } };
                            }
                        });
                        vm.eList = response.data.data;
                    }
                    vm.loading = false;
                },
                function () {
                    vm.loading = false;
                }
            );
        };
        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(e) {
            vm.toggleRight(e);
        };
        vm.activeEntity = {};
        vm.updateEntity = {};
        vm.toggleRight = function(e) {
            if (e!=null && e.id != null) {
                angular.copy(e, vm.updateEntity)
                vm.activeEntity = vm.updateEntity;
            } else {
                vm.updateEntity = {};
                vm.activeEntity = vm.getNewEntity();
            }
            if (vm.perm.canSave('costs', vm.activeEntity)) {
                $timeout($mdSidenav('right').open, 0);
            } else {
                CrudService.showActionToast(vm, "Modifica non consentita.");
            }
        };
        vm.getNewEntity = function () {
            var res = {
                    store_id: null,
                    user_id: vm.user.id,
                    month: vm.query.month,
                    year: vm.query.year,
                    prev: false,
                    store: {data: vm.store},
                    repeat: false,
                    repeat_month: 1
                };
            if (vm.storeId) {
                res.store_id = vm.storeId;
            }
            return res;
        };
        vm.repeatChange = function() {
            if (!vm.activeEntity.repeat && vm.activeEntity.repeat_month<1) {
                vm.activeEntity.repeat_month = 1;
            }
        };
        vm.resetAll = function() {
            vm.activeEntity = {}
            vm.updateEntity = {}
            $scope.entityForm.$setPristine();
            $scope.entityForm.$setUntouched();
        };
        vm.closeSidebar = function() {
            vm.resetAll();
            $mdSidenav('right').close();
        };
        vm.setPeriodo = function(e, day_from, day_to) {
            if (e.day_from!=day_from) {
                $scope.entityForm.$setDirty();
                $scope.entityForm.day_from.$dirty = true;
            }
            if (e.day_to!=day_to) {
                $scope.entityForm.$setDirty();
                $scope.entityForm.day_to.$dirty = true;
            }
            e.day_from = day_from;
            e.day_to = day_to;
            if (day_from!=null && day_to == null) {//imposto ultimo giorno del mese
                var first = moment(e.year+'-'+e.month+'-01','Y-M-DD');
                e.day_to = first.daysInMonth();
            }
        };
        vm.save = function(e) {
            $log.info('Salva');
            if (angular.isDefined(e)) {
                var msg="Sicuro di voler salvare?";
                if (!e.id && e.repeat && e.repeat_month>1) {
                    msg = "Sicuro di voler salvare, inserendo il medesimo costo anche per i "+ (e.repeat_month-1) +" mesi successivi?";
                }
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent(msg)
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {
                            //$log.info(vm.activeEntity);
                                CrudService
                                    .save( 'costs', vm.activeEntity, vm ,
                                        function(response) {
                                            vm.closeSidebar();
                                            vm.eListLoad();
                                        },
                                        function(response) {
                                        });
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };

        vm.del = function ( id ) {
            $log.info( 'Del' );
            if( angular.isDefined( id ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler eliminare questo costo?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            CrudService.del( 'costs', id, vm,
                                function( response ) {
                                    vm.eListLoad();
                                },
                                function( response ) {
                                }
                            );
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };
        $scope.$watch('ab.query.filter', function() {
            if (!vm.loading) {
                vm.calcsOnVisibileElements();
            }
        });

        vm.calcsOnVisibileElements = function() {
            $timeout(function () {
               vm.eListTotal = 0;
               vm.filteredItems.forEach(function(item) {
                  vm.eListTotal += item.total;
               });
             });
         };
        /* WATCHO Lo Store */
        vm.storeId = null;
        vm.storesList = [];
        vm.store = {id: 0, alias: 'Globale '  + vm.env.currentTenant };
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                vm.storeId = id;
                vm.storesList = $scope.$parent.main.storesList;
                angular.forEach(vm.storesList, function(s) {
                    if (s.id == id) {
                        vm.store = s;
                    }
                });
                vm.eListLoad();
                vm.causaliLoad();
            } else {
                vm.store = {id: 0, alias: 'Globale ' + vm.env.currentTenant };
            }
        });

        /* Causali */
        vm.causaliList = [];
        vm.causaliLoading = true;
        vm.causaliLoad = function() {
            vm.causaliList = [];
            vm.causaliLoading = true;
            CrudService.all('causals', {search: 'active:1;type:C',searchFields: 'active:=;type:=',orderBy: 'name'}, vm,
                    function(response) {
                        if (response.data && response.data.data) {
                            vm.causaliList = response.data.data;
                        }
                        vm.causaliLoading = false;
                    },
                    function () {
                        vm.causaliLoading = false;
                    }
            );
        };
        vm.perm = {
                canFire: function (id, ent) {
                    return $scope.$parent.main.perm.canFire(id, ent);
                },
                canRead: function (id, ent) {
                    return $scope.$parent.main.perm.canRead(id, ent);
                },
                canCreate: function (id, ent) {
                    return $scope.$parent.main.perm.canCreate(id, vm.getNewEntity());
                },
                canUpdate: function (id, ent) {
                    return $scope.$parent.main.perm.canUpdate(id, ent);
                },
                canDelete: function (id, ent) {
                    return $scope.$parent.main.perm.canDelete(id, ent);
                },
                canSave: function (id, ent) {
                    return $scope.$parent.main.perm.canSave(id, ent);
                }
       };
    };

    CostsController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            '$state',
            'env',
            'StoreService',
            'UsersService',
            'CrudService',
            'MONTHS'
        ];

})();

(function () {
    'use strict';

    angular
            .module('admin')
            .controller('CashoutController', CashoutController)
            ;

    /** @ngInject */
    function CashoutController(
            $scope,
            $log,
            $mdDialog,
            moment,
            StoreService,
            CustomerService,
            $filter,
            $timeout,
            $location,
            $mdSidenav,
            $mdToast,
            UsersService,
            env,
            CrudService
            ) {
        var vm = this;

        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }

        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        $log.info('CashoutController');
        //---------- Cashouts -------------------------------------//
        vm.minModifDate = '1970-01-01';
        var today = moment();
        if (vm.user.type!='admin') {
            vm.minModifDate = today.date()>15?today.format('YYYY-MM')+'-01':moment().subtract(1,'month').format('YYYY-MM')+'-01';
        }
        $log.info('minModifDate: '+vm.minModifDate);
        vm.viewAction = false;
        vm.causaliLoading = false;
        vm.isNewCashout = false;
        vm.paymentDateTMP = null;
        vm.selected = [];
        var file_selected = null;
        vm.options = {
            autoSelect: false,
            boundaryLinks: true,
            pageSelector: true,
            rowSelection: false,
        };
        vm.filter = {
            options: {
                'debounce': 0,
                'updateOn': 'default'
            }
        };
        vm.query = {
            filter: '',
            filter_customer: '',
            from_date: moment(new Date()).startOf('month').toDate(),
            to_date: moment(new Date()).endOf('month').toDate(),
            order: 'date',
            limit: 100,
            limitOptions: [5, 10, 15, 20],
            page: 1
        };
        vm.eStatus = {};

        vm.saveStatus = function () {
            //if (true) return;
            localStorage.setItem('cashout_eStatus', angular.toJson(vm.eStatus, false));
            localStorage.setItem('cashout_query', angular.toJson(vm.query, false));
        };
        vm.restoreStatus = function () {
            //if (true) return;
            var eStatus = angular.fromJson(localStorage.getItem('cashout_eStatus'));
            if (eStatus != null) {
                vm.eStatus = eStatus;
            }
            var query = angular.fromJson(localStorage.getItem('cashout_query'));
            if (query != null) {
                vm.query = query;
                vm.query.from_date = moment(vm.query.from_date).toDate();
                vm.query.to_date = moment(vm.query.to_date).toDate();
            }
        };
        vm.restoreStatus();
        vm.resetTable = function () {
            vm.query.page = 1;
            //vm.calcsOnVisibileElements();
        };
        vm.removeSearch = function () {
            vm.query.filter = '';
            vm.query.order = 'date';
            vm.query.from_date = moment(new Date()).startOf('month').toDate();
            vm.query.to_date = moment(new Date()).endOf('month').toDate();
            vm.query.page = 1;
            vm.entitiesListLoad(1);
        };

        vm.totFirstTime = 0;
        vm.totPrices = 0;
        vm.entitiesList = [];
        vm.loading = true;
        vm.entitiesListPag = {"total": 0, "count": 10, "per_page": 10000, "current_page": 1, "total_pages": 0, "links": {}};
        vm.entitiesListLoad = function (p, s) {
            vm.entitiesList = [];
            if (!vm.storeId) return;
            vm.loading = true;
            if (p == null) {
                p = vm.query.page;
            }
            vm.query.page = p;
            vm.saveStatus();
            if (s == null) {
                s = parseInt(vm.entitiesListPag.per_page);
            }
            var pars = {page: p, s: s, searchJoin: 'and'};
            var search = [];
            var searchFields = [];
            if (vm.storeId) {
                search.push("store_id:" + vm.storeId);
                searchFields.push("store_id:=");
            }
            /*search.push('year:'+vm.eStatus.filterYear);
             searchFields.push("year:=");
             search.push('month:'+vm.eStatus.filterYear);
             searchFields.push("month:=");
             */
            pars.from_date = moment(vm.query.from_date).format('YYYY-MM-DD');
            pars.to_date = moment(vm.query.to_date).format('YYYY-MM-DD');
            pars.store_id = vm.storeId;
            vm.exportUrl = env.API+'/cashouts?from_date='+pars.from_date
            +'&to_date='+pars.to_date
            +'&store_id='+pars.store_id
            +'&export=true'
            +'&token='+vm.token;
            vm.exportZipUrl = vm.exportUrl+'&zip=true';
            CrudService.all(
                    'cashouts',
                    pars,
                    vm,
                    function (response) {
                        vm.entitiesList = [];
                        if (response.data && response.data.data) {
                            //vm.entitiesListPag = response.data.meta.pagination;
                            angular.forEach(response.data.data, function (elem) {
//                                $log.info(elem);
                                elem.date_frmt = moment(elem.date).format('DD/MM/YYYY');
                                elem.total = parseFloat(elem.total, 2);
                                vm.entitiesList.push(elem);
                            });
                            vm.loading = false;
                            //$log.info(vm.entitiesList);
                            //ordinamento lato server
                            //vm.entitiesList = $filter('orderBy')(vm.entitiesList, ['date','order'], false);
                            //$log.info(vm.entitiesList);
                            vm.calcsOnVisibileElements();
                        }
                        //console.log(vm.storeId);
                    },
                    function (response) {
                        var errMsg = "";
                        if (response.data != null && response.data.message != null) {
                            errMsg = response.data != null && response.data.message != null ? response.data.message + "." : ".";
                            var url = response.config != null && response.config.url != null ? response.config.url : "";
                            if (url != null) {
                                errMsg += "\nUrl: " + url;
                            }
                        }
                        //alert("Si è verificato un errore nel caricamento uscite cassa: " + errMsg);
                        vm.loading = false;
                    });
        };

        vm.downloadDocument = function (ent) {
            if (!ent) {
                ent = vm.activeE;
            }
            window.open(vm.env.API + "/documents/"+ent.document.id + "/download?token="+vm.token);
        }
        vm.openDocument = function (ent) {
            //$log.info(ent);
            if (ent.document) {
                if (ent.document.type!='img') {
                    window.open(vm.env.API + "/documents/"+ent.document.id + "/download?token="+vm.token);
                } else {
                    vm.showDocument(ent);
                }
            }
        };

        vm.showDocument = function (a) {
            var testo = "<div>" +
                    "<img width='99%'" +
                    "src='"+vm.env.API+"/documents/"+a.document.id+"/download?token="+vm.token+"' />" +
                    "<br/><br/>" +
                    "<a target='_blank' href='"+vm.env.API+"/documents/"+a.document.id+"/download?token="+vm.token+"'>Scarica</a>" +
                    "</div>";
               var p = $mdDialog.confirm()
                    .title("Allegato "+ a.causal.name)
                .htmlContent(testo)
                .ok( 'Ok' );
               return $mdDialog.show( p );
        };

        /**
         * Visualizzo activities su app
         */
        vm.showActivities = function( a ) {
            if (vm.user.type != 'admin' || a.id<=0) {
                return;
            }
            if (cashout.causal_id==-1 || cashout.type=='NC') {return;}
            var dialog = $mdDialog.confirm({
                  title: 'Storico Modifiche: ' + a.causal.name + ' del ' + a.date_frmt
                  + " (cid="+a.id+")",
                  ariaLabel: 'Storia Modifiche Movimento',
                  templateUrl: 'app/components/dialogs/activity-log.html',
                  escapeToClose: true,
                  controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                      $scope.title = this.title;
                      $scope.button_ok = 'Chiudi';
                      $scope.activities = [];
                      $scope.loadActivities = function () {
                      var pars = {
                              'log_name': 'default',
                              'subject_type':'App\\Entities\\Cashout',
                              'subject_id': a.id,
                              with: 'causer;subject'
                            };
                      $scope.loading = true;
                      CrudService.all('activity_log', pars, vm,
                            function (response) {
                              angular.forEach(response.data.data, function(act) {
                                  act.created_at_frmt = moment(act.created_at).format('D/M/YYYY HH:mm:ss');
                                  $scope.activities.push(act);
                              });
                              $scope.loading = false;
                            },
                            function (response) {
                              var errMsg = "";
                              if (response.data!=null
                                      && response.data.message!=null) {
                                errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                                var url = response.config!=null && response.config.url!=null?response.config.url:"";
                                if (url!=null) {
                                  errMsg+= "\nUrl: " + url;
                                }
                              }
                              alert ("Si è verificato un errore nel caricamento delle attività: " + errMsg);
                              $scope.loading = false;
                           });
                      }
                      $scope.close = function() {
                          $mdDialog.hide( true );
                      };
                      $scope.loadActivities();
                  }]
            });

            return $mdDialog
                .show( dialog )
                .finally(
                    function() {
                        dialog = undefined;
                    }
                )
            ;
        };

        vm.onKeyPressSearch = function (event) {
            if (event.keyCode == 13) {
                vm.entitiesListLoad(1);
                event.stopPropagation();
                event.preventDefault();
            }
        }
        vm.filterDate = function (event) {
            vm.entitiesListLoad(1);
            if (event) {
                event.stopPropagation();
                event.preventDefault();
            }
        }
        vm.del = function (cashout) {
            $log.info('Del');
            if (angular.isDefined(cashout)) {
                var confirm = $mdDialog.confirm()
                        .title('Attenzione')
                        .ariaLabel('Attenzione')
                        .textContent('Sicuro di voler eliminare il movimento \''+cashout.causal.name+'\' del '+cashout.date_frmt+'?')
                        .ok('Si')
                        .cancel('Ops, ho sbagliato')
                        ;
                return $mdDialog
                        .show(confirm)
                        .then(
                                function () {
                                    var position = vm.entitiesList.map(function (x) {
                                        return x.id;
                                    }).indexOf(cashout.id);
                                    CrudService.del('cashouts', cashout.id, vm,
                                        function (response) {
                                            vm.entitiesList.splice( position, 1 );
                                            vm.calcsOnVisibileElements();
                                        },
                                        function (response) {
                                            alert("Errore durante l'elaborazione delle richiesta.");
                                        }
                                     );
                                }
                        )
                        .finally(
                                function () {
                                    confirm = undefined;
                                }
                        );
            }
            ;
        };

        vm.updateDate = function () {
            $log.info(vm.query.from_date);
            vm.query.to_date = moment(vm.query.from_date).endOf("month").toDate();
            $log.info(vm.query.to_date);
            vm.filterDate();
        }

        //---------- Sidebar -------------------------------------//
        vm.testsVisible = false;
        vm.currentSubscription = '';
        vm.isDeleteAllowed = true;
        vm.undoVisible = false;
        vm.img_loading = false;
        vm.activeCashout = null;
        vm.backup_cashout = {};
        vm.update_cashout = {};
        vm.empty_cashout = {};
        /* Element Clicked */
        vm.updatingField = '';
        vm.rowClicked = function (cashout, field) {
            $log.info(cashout);
            if (cashout.causal_id==-1 || cashout.type=='NC') {return;}
            vm.toggleRight(cashout, true);
        };
//        console.log($scope.$parent.main);
        vm.toggleRight = function (cashout, isRowClick) {
            $scope.img.fileObj = null;
            $scope.img.fileName = null;
            vm.isNewCashout = !isRowClick;//angular.isUndefined( cashout );
            if (!vm.isNewCashout) {
                vm.paymentDateTMP = new Date(cashout.date);
            } else {
                vm.paymentDateTMP = vm.query.from_date;
                cashout = {
                    type: 'C'
                };
            }

            vm.activeE = cashout;
            $log.info(vm.activeE);

            angular.copy(vm.activeE, vm.backup_cashout);

            return $mdSidenav('right').open();
        };
        vm.closeSidebar = function () {
            if (vm.undoVisible) {
                var confirm = $mdDialog.confirm()
                        .title('Attenzione')
                        .textContent('Ci sono delle modifiche non commissionate, proseguire?')
                        .ariaLabel('Attenzione')
                        .ok('Si')
                        .cancel('Ops, ho sbagliato')
                        ;
                return $mdDialog
                        .show(confirm)
                        .then(vm.undo)
                        .finally(
                                function () {
                                    confirm = undefined;
                                }
                        )
                        ;
            } else {
                vm.resetAll();
            }
            ;
        };
        vm.angularFormReset = function () {
            $scope.movimentoForm.$setPristine();
            $scope.movimentoForm.$setUntouched();
        };
        vm.resetForm = function () {
            vm.undoVisible = false;
            return $mdSidenav('right').close().then(function () {
                vm.activeE = null;
                vm.update_cashout = {};
                vm.paymentDateTMP = null;
                vm.angularFormReset();
            });
        };
        vm.resetAll = function () {
            return $timeout(vm.resetForm, 10);
        };
        vm.undo = function () {
            $log.info('Undo');
            if (!angular.equals(vm.activeE, vm.backup_cashout)) {
                angular.copy(vm.backup_cashout, vm.activeE);
            }
            ;
            vm.resetAll();
        };
        /* Response */
        vm.showActionToast = function (text) {
            text = text && angular.isDefined(text) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                    .textContent(text)
                    .action('')
                    .highlightAction(true)
                    .position('bottom right')
                    ;
            return $mdToast
                    .show(toast)
                    .finally(
                            function () {
                                toast = undefined;
                            }
                    )
                    ;
        };
        vm.responseStatusSuccessful = [200, 201, 202];
        vm.checkResponse = function (response, checkout) {
            vm.saving = false;
            if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
                var errMsg = "";
                if (response.data != null && response.data.message != null) {
                    errMsg = response.data != null && response.data.message != null ? response.data.message : "";
                    var url = response.config != null && response.config.url != null ? response.config.url : "";
                    vm.showActionToast("KO: " + errMsg + " " + url);
                }
                var alert = $mdDialog.alert()
                        .title('Attenzione')
                        .ariaLabel('Attenzione')
                        .textContent("C'è stato un problema: " + errMsg)
                        .ok('Ok')
                        ;
                return $mdDialog
                        .show(alert)
                        .then(function () {
                            vm.resetAll();
                        })
                        .finally(
                                function () {
                                    alert = undefined;
                                }
                        )
                        ;
            } else {
                /**
                 * Aggiorno user.data con il nuovo valore
                 */
                vm.showActionToast();
                return vm.resetAll();
            }
            ;
        };

        // Salva e Aggiorna
        vm.save = function (cashout) {
            $log.info('Salva');
            if (angular.isDefined(cashout)) {
                var confirm = $mdDialog.confirm()
                        .title('Attenzione')
                        .ariaLabel('Attenzione')
                        .textContent('Sicuro di voler inserire questo movimento?')
                        .ok('Si')
                        .cancel('Ops, ho sbagliato')
                        ;
                return $mdDialog
                        .show(confirm)
                        .then(
                                function () {
                                    vm.saving = true;
                                    angular.copy(cashout, vm.update_cashout);
                                    vm.update_cashout.by_operator = $scope.$parent.main.userId;
                                    vm.update_cashout.store_id = vm.storeId;
                                    var dataApp = moment(vm.paymentDateTMP).format('YYYY-MM-DD');
                                    vm.update_cashout.date = dataApp + ' 00:00:00';
                                    //$log.info('vm',vm);
                                    //$log.info('scope',$scope);
                                    if ($scope.img.fileObj && $scope.img.fileObj[0]) {
                                        vm.update_cashout.fileName = $scope.img.fileObj[0].name;
                                        vm.update_cashout.fileType = $scope.img.fileObj[0].type;
                                      var reader = new FileReader();
                                      reader.onload = function () {
                                          //$log.info(reader.result);
                                          vm.update_cashout.fileBase64 = reader.result;
                                          /**
                                           * salvataggio
                                           */
                                          CrudService.save('cashouts', vm.update_cashout, vm,
                                                  function (response) {
                                                  vm.checkResponse(response);
                                                  if (response && response.data && response.data.data) {
                                                      var elem = response.data.data;
                                                      elem.causal = $filter('filter')(vm.causaliList, {'id': elem.causal_id}, true)[0];
                                                      //$log.info(elem);
                                                      elem.date_frmt = moment(elem.date).format('DD/MM/YYYY');
                                                      if (elem.document && elem.document.data) {
                                                        elem.document = elem.document.data;
                                                        elem.document_id = elem.document.id;
                                                      }
                                                      vm.entitiesList.push(elem);
                                                      vm.resetAll();
                                                      vm.calcsOnVisibileElements(true);
                                                  }
                                                  ;
                                              },
                                              vm.checkResponse
                                          );
                                    };
                                    reader.onerror = function (error) {
                                      $log.info('Error: ', error);
                                      vm.saving = false;
                                    };
                                    reader.readAsDataURL($scope.img.fileObj[0]);
                                   } else {
                                       CrudService.save('cashouts', vm.update_cashout, vm,
                                           function (response) {
                                               vm.checkResponse(response);
                                               if (response && response.data && response.data.data) {
                                                   var elem = response.data.data;
                                                   elem.causal = $filter('filter')(vm.causaliList, {'id': elem.causal_id}, true)[0];
                                                   //$log.info(elem);
                                                   elem.date_frmt = moment(elem.date).format('DD/MM/YYYY');
                                                   if (elem.document && elem.document.data) {
                                                       elem.document = elem.document.data;
                                                       elem.document_id = elem.document.id;
                                                   }
                                                   vm.entitiesList.push(elem);
                                                   vm.resetAll();
                                                   vm.calcsOnVisibileElements(true);
                                               }
                                               ;
                                           },
                                           vm.checkResponse
                                       );
                                   }
                                }
                        )
                        .finally(
                                function () {
                                    confirm = undefined;
                                }
                        )
                        ;
            }
            ;
        };

        vm.update = function (cashout) {
            $log.info('Update');
            if (angular.isDefined(cashout)) {
                var confirm = $mdDialog.confirm()
                        .title('Attenzione')
                        .ariaLabel('Attenzione')
                        .textContent('Sicuro di voler aggiornare?')
                        .ok('Si')
                        .cancel('Ops, ho sbagliato')
                        ;
                return $mdDialog
                        .show(confirm)
                        .then(
                                function () {
                                    vm.saving = true;
                                    angular.copy(cashout, vm.update_cashout);
                                    vm.update_cashout.by_operator = $scope.$parent.main.userId;
                                    vm.update_cashout.store_id = vm.storeId;
                                    var dataApp = moment(vm.paymentDateTMP).format('YYYY-MM-DD');
                                    vm.update_cashout.date = dataApp + ' 00:00:00';
                                    //MOD
                                    //$log.info('vm',vm);
                                    //$log.info('scope',$scope);
                                    if ($scope.img.fileObj && $scope.img.fileObj[0]) {
                                        vm.update_cashout.fileName = $scope.img.fileObj[0].name;
                                        vm.update_cashout.fileType = $scope.img.fileObj[0].type;
                                      var reader = new FileReader();
                                      reader.onload = function () {
                                          //$log.info(reader.result);
                                          vm.update_cashout.fileBase64 = reader.result;
                                          /**
                                           * salvataggio
                                           */
                                          CrudService.update('cashouts', vm.update_cashout, vm,
                                                  function (response) {
                                                      var elem = response.data.data;
                                                      cashout.date = elem.date;
                                                      elem.date_frmt = moment(elem.date).format('DD/MM/YYYY');
                                                      cashout.date_frmt = elem.date_frmt;
                                                      if (elem.document && elem.document.data) {
                                                          cashout.document = elem.document.data;
                                                          cashout.document_id = elem.document.id;
                                                      }
                                                      //vm.entitiesList.push(elem);
                                                      vm.resetAll();
                                                      vm.calcsOnVisibileElements(true);
                                                      vm.saving = false;
                                                  },
                                                  function (response) {
                                                      vm.resetAll();
                                                      vm.saving = false;
                                                  }
                                          );
                                    };
                                    reader.onerror = function (error) {
                                      $log.info('Error: ', error);
                                      vm.saving = false;
                                    };
                                    reader.readAsDataURL($scope.img.fileObj[0]);
                                   } else {
                                       CrudService.update('cashouts', vm.update_cashout, vm,
                                               function (response) {
                                                   var elem = response.data.data;
                                                   elem.date_frmt = moment(elem.date).format('DD/MM/YYYY');
                                                   cashout.date = elem.date;
                                                   cashout.date_frmt = elem.date_frmt;
                                                   if (elem.document && elem.document.data) {
                                                       cashout.document = elem.document.data;
                                                       cashout.document_id = cashout.document.id;
                                                   }
                                                   $log.info(cashout);
                                                   //vm.entitiesList.push(elem);
                                                   vm.resetAll();
                                                   vm.calcsOnVisibileElements(true);
                                                   vm.saving = false;
                                               },
                                               function (response) {
                                                   vm.resetAll();
                                                   vm.saving = false;
                                               }
                                       );
                                   }
                                }
                        )
                        .

                                    //ENDMOD
                        finally(
                                function () {
                                    confirm = undefined;
                                }
                        )
                        ;
            }
        };

        /* Causali */
        vm.causaliList = [];
        vm.causaliLoading = true;
        vm.causaliLoad = function () {
            vm.causaliList = [];
            if (vm.user.type == 'admin') {
                vm.causaliList.push({'id': 900, 'name': 'Fondo cassa', 'type': 'E'});
            }
            vm.causaliLoading = true;
            CrudService.all('causals', {search: 'active:1;type:U', searchFields: 'active:=;type:=', orderBy: 'name'}, vm,
                    function (response) {
                        if (response.data && response.data.data) {
                            angular.forEach(response.data.data, function (elem) {
                                vm.causaliList.push(elem);
                            });
                        }
                        vm.causaliLoading = false;
                    },
                    function () {
                        vm.causaliLoading = false;
                    }
            );
        };
        vm.changeCausal = function () {
            if (vm.activeE.causal_id == 901)
                vm.activeE.type = 'A';
            else
                vm.activeE.type = 'C';
        }

        /* WATCHO Lo Store */
        vm.storeId = null;
        vm.storesList = [];
        vm.store = {id: 0, alias: 'Globale'};
        $scope.$watch('$parent.selectedStore', function (id) {
            if (angular.isDefined(id)) {
                vm.storeId = id;
                vm.storesList = $scope.$parent.main.storesList;
                angular.forEach(vm.storesList, function (s) {
                    if (s.id == id) {
                        vm.store = s;
                    }
                });
            } else {
                vm.storeId = 0;
                vm.store = {id: 0, alias: 'Globale'};
            }
            vm.entitiesListLoad(1);
        });

        vm.causaliLoad();

        vm.calcsOnVisibileElements = function (sort) {
            $timeout(function () {
                vm.totEntrateA = 0;
                vm.totUsciteA = 0;
                vm.totEntrateC = 0;
                vm.totUsciteC = 0;
                if (sort) {
                    vm.entitiesList = $filter('orderBy')(vm.entitiesList, ['date','order'], false);
                }
                angular.forEach(vm.entitiesList, function (item) {
                    if(!item.type || item.type!='NC') {
                        if (item.causal.type == 'U') {
                            if (item.type=='A') {
                                vm.totUsciteA += parseFloat(item.total, 2);
                            } else if (item.type=='C') {
                                vm.totUsciteC += parseFloat(item.total, 2);
                            }
                        } else {
                            if (item.causal_id < 0) {
                                vm.totEntrateC += parseFloat(item.total_cash, 2);
                                vm.totEntrateA += parseFloat(item.total_check, 2);
                            } else {//fondo cassa
                                vm.totEntrateC += parseFloat(item.total, 2);
                            }
                        }
                        item.saldo = {'C':vm.totEntrateC - vm.totUsciteC, 'A': vm.totEntrateA - vm.totUsciteA};
                    }
                });
                vm.deltaEU_A = vm.totEntrateA - vm.totUsciteA;
                vm.deltaEU_C = vm.totEntrateC - vm.totUsciteC;
            });
        };

//        vm.filterCausal = function (causal_id) {
//            vm.query.filter = causal_id;
//            vm.entitiesListLoad(1);
//        };
    }
    ;

    CashoutController
            .$inject = [
                '$scope',
                '$log',
                '$mdDialog',
                'moment',
                'StoreService',
                'CustomerService',
                '$filter',
                '$timeout',
                '$location',
                '$mdSidenav',
                '$mdToast',
                'UsersService',
                'env',
                'CrudService'
            ]
            ;
})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .service(
            'ClosingCashService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    all : function( options ) {
                        if( ! options ) {
                            options = {};
                        }
                        var apiURI = env.API + '/closing-cash?with=user;operator;operatorRole';
                        return $http.get( apiURI, { params: options } );
                    },
                    allGroupByStore : function( month, year, groupbyMonth, store_id) {
                      return $http.get( this.allGroupByStoreUrl(month, year, groupbyMonth, store_id) );
                    },
                    allGroupByStoreUrl : function( month, year, groupbyMonth, store_id) {
                        var apiURI = env.API + '/closing-cash-groupby-store?year='+year;
                        if (month) {
                        	apiURI =  apiURI + "&month="+month;
                        } else {
                        	if (groupbyMonth) {
                        		apiURI =  apiURI + "&groupby=month";
                        	}
                        }
                        if (store_id) {
                    		apiURI =  apiURI + "&store_id="+store_id;
                    	}
                        
                        return apiURI;
                    },
                    allGroupByDate : function( month, year) {
                        return $http.get( this.allGroupByDateUrl(month, year) );
                    },
                    allGroupByDateUrl : function( month, year) {
                        var apiURI = env.API + '/closing-cash-groupby-date?year='+year;
                        if (month) {
                        	apiURI =  apiURI + "&month="+month;
                        }
                        return apiURI;
                    },
                    getTotal : function( storeId ) {
                        var apiURI = env.API + '/closing-cash-total-today?store_id=' + storeId;
                        return $http.get( apiURI);
                    },
                    save : function( data ) {
                        if(
                            angular.isDefined( data ) &&
                            angular.isObject( data )
                        ) {
                            var apiURI = env.API + '/closing-cash';
                            return $http.post( apiURI, data );
                        }
                    },
                    update : function( data ) {
                        if(
                            angular.isDefined( data ) &&
                            angular.isObject( data ) && data.id 
                        ) {
                            var apiURI = env.API + '/closing-cash';
                            return $http.put( apiURI, data );
                        }
                    },
                    undo : function ( e, user ) {
                    	var apiURI = env.API + '/closing-cash-undo';
                        return $http.post( apiURI, {store_id: e.store_id, date: e.date, operator_id: e.operator_id, c_sid: user.store_id, c_role: user.type } );
                    }
                };
            }
        )
})();
(function() {
    'use strict';

    angular
        .module('admin')
        .controller('CashController', CashController);

    /** @ngInject */
    function CashController(
        $scope,
        $http,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        env,
        CallState,
        Italia,
        TreatmentService,
        StoreService,
        SubscriptionService,
        UsersService,
        ClosingCashService,
        AppointmentsService
    ) {
        var vm = this;
        vm.showDeltaRullo = false;
        $log.info('CashController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.env = env;
        vm.today = new Date(moment().hours(0).minutes(0).seconds(0));
        vm.yesterday = new Date(moment(vm.today).subtract(1, 'days'));
        vm.eStatus = {
            filter_date_start: moment().format('YYYY-MM-DD')
        };
        vm.query = {
            filter: '',
            order: 'firstname'
        };
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.eStatus.filter_date_start = moment().format('YYYY-MM-DD');
            vm.loadAvailab();
        };

        vm.relLoading = true;
        vm.relatedsForEntity = [];
        vm.operatorsWithApps = {};
        vm.operatorsApps = {};
        /**
         * Questa funzione viene rieseguita alla modifica dello store e il caricamento parte da qui
         */
        vm.loadAppointments = function() {
            if (vm.storeId == null) {
                vm.relLoading = false;
                vm.eListLoading = false;
                return;
            }
            var pars = {page:1, s: 1000, with: 'treatment;customer;giftcard', orderBy: 'date_start'};
            var search = [];
            var searchFields = [];
            if (vm.storeId) {
                search.push("store_id:"+vm.storeId);
                searchFields.push("store_id:=");
            }
            if (vm.eStatus.filter_date_start==null) {
                vm.eStatus.filter_date_start = moment().format('YYYY-MM-DD');
            }
            search.push("date_start:"+moment(vm.eStatus.filter_date_start).format("YYYY-MM-DD 00:00:00.0"));
            searchFields.push("date_start:>=");
            search.push("date_end:"+moment(vm.eStatus.filter_date_start).format("YYYY-MM-DD 23:59:59.9"));
            searchFields.push("date_end:<=");
            pars.search=search.join(";");
            pars.searchFields=searchFields.join(";");
            pars.orderBy = 'user_id';
            pars.sortedBy = 'desc';
            AppointmentsService.all(pars).then(function(response) {
                if (response.data && response.data.data) {
                    var eTotTot = null;
                    if (vm.storeId == 0) {
                        eTotTot = vm.operatorsApps['sid_0'];
                    } else {
                        delete vm.operatorsApps['sid_0'];
                    }
                     angular.forEach(response.data.data, function(app) {
                         angular.forEach(vm.usersList, function(role) {
                             if (role.user_id == app.user_id) {
                                 app.role = {data: role};
                                 app.user = {data: role.user };
                             }
                             if (role.user_id == app.by_operator) {
                               app.byOperatorRole = {data: role};
                               app.byOperator = {data: role.user };
                           }
                             if (role.user_id == app.user_id_sm) {
                               app.roleSm = {data: role};
                               app.userSm = {data: role.user };
                           }
                         });
                         if (!app.user || !app.user.data) {
                             app.user = {data: {id: app.user_id, type: 'operator', color: 'grey'}};
                             $log.info("App senza user.data: uid="+app.user_id+"/aid="+app.id);
                         }
                           if (!vm.operatorsApps['sid_'+app.store_id]) {
                               vm.initOperatorsApps(app.store_id);
                          }
                           var eTot = vm.operatorsApps['sid_'+app.store_id];
                         if (app.role!=null) {
                            app.user.data.color = app.role.data.color;
                            app.user.data.type = app.role.data.role;
                        } else {
                            if (app.user!=null) {
                                app.user.data.type = 'operator';
                                app.user.data.color = 'grey';
                            } else {
                                app.user = {data: {type: 'operator', color: 'grey'}};
                                $log.info("utente senza ruolo: "+app.user_id);
                            }
                        }
                        app.date_start_ora = moment(app.date_start).format('HH:mm');
                        if (app.user_times<2) {
                            app.pricePrev = app.treatment.data.price_first;
                            //primavolta
                        } else {
                           app.pricePrev = app.treatment.data.price_normal;
                        }
                        if (!app.closed && vm.operatorsWithApps['id_'+app.user_id]==null) {
                            vm.operatorsWithApps['id_'+app.user_id] = app.user.data;
                        }
                        if (vm.storeId) {
                            if (vm.operatorsApps['id_'+app.user_id] == null
                                    || vm.operatorsApps['id_'+app.user_id].id==null) {
                                app.user.data.store_id = app.store_id;
                                var e = vm.newOperApp(app.user);
                                vm.operatorsApps['id_'+app.user_id] = e;
                            }
                            var e2 = vm.operatorsApps['id_'+app.user_id];
                            vm.addOperApp(e2, app);
                        }

                        vm.addOperApp(eTot, app);
                        if (vm.storeId == 0) {
                           vm.addOperApp(eTotTot, app);
                        }
                        vm.relatedsForEntity.push(app);
                    });
                    angular.forEach(vm.operatorsApps , function(e) {
                      vm.endOperApp(e);
                    });
                    //  vm.endOperApp(eTot);
                    vm.relLoading = false;
                }
                vm.eListLoad();
            }, function(error) {
                vm.checkResponse(error);
                vm.relLoading = false;
                vm.eListLoading = false;
            });
        };

    vm.addOperApp = function (e, app) {
        var isGp = app.treatment.data.name.match(" GP$");
        if (!app.f_ref && app.recalled<4) {
            e.app_count_all += 1;
            if (isGp) {
                e.app_count_gp_all += 1;
            }
            if (app.user_times<2) {
                //primavolta
                if (isGp) {
                    e.app_count_gp_first_all+=1;
                }
                e.app_count_first_all+=1;
            }
        }
        if (!app.f_ref && app.recalled<3) {
            var min = moment(app.date_end).diff(moment(app.date_start), 'minutes');
            e.app_minutes += min;
            var user_times = app.user_times>0?app.user_times:1;
            var app_times = app.app_times>0?app.app_times:user_times;
            if (app_times<user_times) {
                app_times = user_times;
            }
                if ((app.appointment_id!=null || app_times==1) && app_times==user_times) {
                app_times++;
            }
                var r = 0;
                if (user_times == 1) {
                    r = 0-app.relevance;
                }
                e.sum_affidabilita += min*user_times/(app_times+r);
        }
        if (app.paid) {
            /**
             * aggiungo in minuti lavorati
             */
            if (app.treatment.data.min_duration!=undefined) {
            e.workedMinutes += (app.treatment.data.min_duration-app.treatment.data.min_exposure-app.treatment.data.min_assist);
            } else {
            e.workedMinutes += moment(app.date_end).diff(moment(app.date_start), 'minutes');
            }
            if (!app.f_ref) {
                var priceToAdd = app.price;
                /**
                 * total_gift_rel e total_gift
                 */
                if (app.treatment_id==99) {
                    if (app.giftcard && app.giftcard.data && !app.giftcard.data.f_free) {
                        if(app.giftcard.data.f_receipt) {
                            e.total_rel_gift_s += app.price;
                        } else {
                            e.total_rel_gift += app.price;
                            priceToAdd = 0;
                        }
                    }
                } else {
                    if (app.payment_gift>0 && app.giftcard && app.giftcard.data && !app.giftcard.data.f_free) {
                        if (app.giftcard.data.f_receipt) {
                            e.total_gift_ns += app.payment_gift;
                            priceToAdd = app.price - app.payment_gift;
                        } else {
                            e.total_gift += app.payment_gift;
                        }
                    } else { //free ma devo scalare i punti
                        priceToAdd = app.price - app.payment_gift;
                    }
                }
                e.total += priceToAdd;
                if ((app.cus_act_id || app.lead_id)
                        && app.byOperatorRole
                        && app.byOperatorRole.data
                        && app.byOperatorRole.data.store_id) {
                    e.totalAzComm += priceToAdd;
                }
                e.total_pos+=app.payment_pos;
                e.total_card+=app.payment_card;
                e.total_app+=app.payment_app;
                e.total_dil+=app.payment_dil;
                e.total_apppago+=app.payment_apppago;
                e.total_light+=app.payment_light;
                e.total_small+=app.payment_small;
                e.total_satis+=app.payment_satis;
                e.total_stripe+=app.payment_stripe;
                e.total_bon+=app.payment_bon;
                e.total_check+=app.payment_check;
                e.total_prev+=app.pricePrev;
                e.app_count+=1;
                if (isGp) {
                    e.app_count_gp += 1;
                }
                if (app.user_times<2) {
                    //primavolta
                    if (isGp) {
                    e.app_count_gp_first+=1;
                    }
                    e.app_count_first+=1;
                }
            } else {//f_ref=1
                app.price = 0;
                app.payment_pos = 0;
                app.payment_card = 0;
                app.payment_app = 0;
                app.payment_dil = 0;
                app.payment_apppago = 0;
                app.payment_light = 0;
                app.payment_small = 0;
                app.payment_satis = 0;
                app.payment_stripe = 0;
                app.payment_bon = 0;
                app.payment_check = 0;
                app.payment_gift = 0;
            }
        } else {//paid=0
            if (app.recalled == 3) {
                e.app_count_disd += 1;
            } else if (app.recalled == 4) {
                e.app_count_spost += 1;
            } else {
                e.app_count_nonpres += 1;
            }
        }
      };
      vm.endOperApp = function (e) {
        if (e.app_minutes) {
            e.affidabilita = e.sum_affidabilita*100/e.app_minutes;
        }
        if (!e.workedMinutes) {
          e.workedMinutes = 0;
        }
        if (e.app_count_all>0) {
          e.app_count_pres_perc = (e.app_count)*100/(e.app_count_all);
          e.app_count_spost_perc = (e.app_count_spost)*100/(e.app_count_all+e.app_count_spost);
          e.app_count_disd_perc = (e.app_count_disd)*100/(e.app_count_all);
          e.app_count_nonpres_perc = (e.app_count_all-e.app_count)*100/(e.app_count_all);
          e.delta = e.total - e.total_prev;
          if (e.total_prev!=0) {
            e.delta_perc = e.delta*100/e.total_prev;
          }
        } else {
          e.app_count_pres_perc = 0;
          e.app_count_spost_perc = 0;
          e.app_count_disd_perc = 0;
          e.app_count_nonpres_perc = 0;
        }
        var sid = 'sid_'+e.store_id;
        if (vm.availabUserData[sid] && vm.availabUserData[sid]["id_" + (e.operator_id<0?0:e.operator_id)]) {
          var ud = vm.availabUserData[sid]["id_" + (e.operator_id<0?0:e.operator_id)];
          e.availabMinutes = ud.minutes;
          e.availabDuration = moment.duration({'minutes' : e.availabMinutes});
          e.availabDurationFrmt = moment.utc(e.availabDuration.asMilliseconds()).format("HH:mm");
          e.availabHours = e.availabMinutes/60;
          e.workedPerc = e.workedMinutes*100/e.availabMinutes;
          e.freeMinutes = e.availabMinutes - e.workedMinutes;
          e.freeMinutesReal = e.freeMinutes;
          e.numAppDaRullo = parseInt(ud.num_app);
          e.numAppPF = parseInt(ud.num_app_pf);
          e.numAppCross = parseInt(ud.num_app_cross);
          e.numVisDaRullo = parseInt(ud.num_view);
          e.numContDaRullo = parseInt(ud.num_call);
          e.numLeads = parseInt(ud.num_lead);

          /*
           *
           * se volessi considerare il tempo usato in altro modo
          e.freeMinutesReal = e.freeMinutes - 20 - e.app_count*5 - e.availabMinutes*0.05;
          if (e.freeMinutesReal<0) {
            e.freeMinutesReal = 0;
          }
          */
          /**
           * Calcolo delta rullo num_app*40 - tariffa_oraria*minuti/60 == num_app*40 - freeMinutes
           * valuto 45 min. per ogni appuntamento preso
           * 5 min. per ogni chiamata
           * 1 min. per ogni visualizzazione
           */
          //var valH = 60;
          //e.deltaRullo = 45*e.numAppDaRullo + 5*e.numContDaRullo - e.freeMinutesReal*valH/60;
          //e.deltaRulloPerc = e.deltaRullo*100/e.freeMinutesReal*valH/60;
          //cambiato tutto a maggio 2018 1 app ogni 40 minuti liberi con soglia 66% occupato
          e.deltaRulloPerc = 0;
          if (e.workedPerc<66) {
            e.deltaRulloPerc =  (e.numAppDaRullo*40-e.freeMinutes)*100/e.freeMinutes
          }
          $log.info("e: ");
          $log.info(e);
        }
    };
    vm.initOperApp = function (e) {
      e.availabMinutes = 0;
      e.workedMinutes = 0;
      e.workedPerc = 0;
      e.freeMinutes = 0;
      e.numAppDaRullo = 0;
      e.numAppPF = 0;
      e.numAppCross = 0;
      e.numVisDaRullo = 0;
      e.numContDaRullo = 0;
      e.numLeads = 0;
      e.availabDurationFrmt = "00:00";
      e.deltaRullo = 0;
      e.deltaRulloPerc = 0;
      e.total = 0;
      e.totalAzComm = 0;
      e.total_rel_gift = 0;
      e.total_rel_gift_s = 0;
      e.delta = 0;
      e.delta_perc = 0;
      e.total_pos = 0;
      e.total_card = 0;
      e.total_app = 0;
      e.total_dil = 0;
      e.total_apppago = 0;
      e.total_light = 0;
      e.total_small = 0;
      e.total_satis = 0;
      e.total_stripe = 0;
      e.total_bon = 0;
      e.total_check = 0;
      e.total_gift = 0;
      e.total_gift_ns = 0;
      e.app_count_first = 0;
      e.app_count_first_all = 0;
      e.app_count = 0;
      e.app_count_all = 0;
      e.app_count_gp_first = 0;
      e.app_count_gp_first_all = 0;
      e.app_count_gp = 0;
      e.app_count_gp_all = 0;
      e.total_prev = 0;
      e.app_count_spost = 0;
      e.app_count_disd = 0;
      e.app_count_nonpres = 0;
      e.app_minutes = 0;
      e.sum_affidabilita = 0;
      return e;
    };
    vm.newOperApp = function (op) {
      var e = {id: -1, operator: op, operator_id: op.data.id, store: op.data.store, store_id: op.data.store_id, lastname: op.data.lastname};
      return vm.initOperApp(e);
    };

    vm.loadClosingCashXStoreManager = function() {
        //cassa chiusa
        //vm.cashClosed=true;
        $http.get(env.API+"/statistics/closing_cash_x_store_manager/"+vm.storeId+"/"+moment(vm.eStatus.filter_date_start).format('YYYY-MM-DD'))
            .then(
                function (response) {
                    //$log.info(response);
                    angular.forEach(response.data.data, function(el){
                        /**
                         * Imposto il colore
                         */
                        angular.forEach(vm.usersList, function(role) {
                              if (role.user_id == el.app_sm_id && role.role == 'storemngr') {
                                  el.role = role;
                                  el.user = role.user;
                              }
                           });
                    });
                    vm.eListSm = response.data.data;
                },
                function(response) {
                    $log.info(response);
                }
            );
    };
    vm.eListLoading = true;
    vm.eList = [];
    vm.eListSm = [];
    vm.cashClosed = true;
    vm.showSm=false;
    vm.eListLoad = function() {
          vm.eList = [];
          vm.cashClosed = true;
          vm.showSm=false;
          if (vm.storeId == null) {
              vm.eListLoading = false;
              return;
          }
          vm.eListLoading = true;

            var pars = {};
            var search = [];
            var searchFields = [];
            if (vm.storeId == 0) {
                search = ["operator_id:"+vm.storeId];
                searchFields = ["operator_id:="];
            } else {
                search = ["store_id:"+vm.storeId];
                searchFields = ["store_id:="];
            }
            if (vm.eStatus.filter_date_start==null) {
                vm.eStatus.filter_date_start = moment().format('YYYY-MM-DD');
            }
            searchFields.push("date:=");
            search.push("date:"+moment(vm.eStatus.filter_date_start).format('YYYY-MM-DD'));
            pars.searchFields = searchFields.join(';');
            pars.search = search.join(';');
            pars.orderBy = 'operator_id';
            pars.sortedBy = 'desc';
            if (false && vm.query.order!=null && vm.query.order!='') {
                pars.orderBy = vm.query.order.indexOf('-')==0?vm.query.order.substring(1):vm.query.order;
                pars.sortedBy = vm.query.order.indexOf('-')?'desc':null;
            }
            ClosingCashService.all(pars).then(
                  function(response) {
                    if (response.data && response.data.data) {
                        vm.eList = [];
                        vm.eListSm = [];
                        //vm.pagOpts = response.data.meta.pagination;
                        /**
                         * se storeId == 0 devo calcolare il totale dell'area
                         */
                        //$log.info(response.data.data);
                        var totArea = {
                                app_count: 0,
                                app_count_all: 0,
                                app_count_first: 0,
                                app_count_first_all: 0,
                                app_count_gp: 0,
                                app_count_gp_all: 0,
                                app_count_gp_first: 0,
                                app_count_gp_first_all: 0,
                                total: 0,
                                totalAzComm: 0,
                                total_rel_gift: 0,
                                total_rel_gift_s: 0,
                                total_10: 0,
                                total_coupon: 0,
                                total_dil: 0,
								total_apppago: 0,
                                total_light: 0,
                                total_small: 0,
                                total_satis: 0,
                                total_stripe: 0,
                                total_bon: 0,
                                total_check: 0,
                                total_gift: 0,
                                total_gift_ns: 0,
                                total_pos: 0,
                                total_card: 0,
                                total_app: 0,
                                total_prev: 0,
                                date: null,
                                id: 0,
                                store: {id: 0, alias: "Totale area"},
                                operator_id: 0,
                                store_id: 0
                        };
                        var cashClosed = false;
                        angular.forEach(response.data.data, function(elem) {
                            if (elem.operator_id == 0) {
                                cashClosed = true;
                                vm.loadClosingCashXStoreManager();
                            }
                            elem.created_at_formatted = moment(elem.created_at.date).format('DD/MM HH:mm');
                            if (vm.storeId == 0) {
                                if (!totArea.date) {
                                    totArea.date = elem.date;
                                }
                                totArea.app_count+=elem.app_count;
                                totArea.app_count_all+=elem.app_count_all;
                                totArea.app_count_first+=elem.app_count_first;
                                totArea.app_count_first_all+=elem.app_count_first_all;
                                totArea.app_count_gp+=elem.app_count_gp;
                                totArea.app_count_gp_all+=elem.app_count_gp_all;
                                totArea.app_count_gp_first+=elem.app_count_gp_first;
                                totArea.app_count_gp_first_all+=elem.app_count_gp_first_all;
                                totArea.total+=elem.total;
                                totArea.totalAzComm+=elem.totalAzComm;
                                totArea.total_rel_gift+=elem.total_rel_gift;
                                totArea.total_rel_gift_s+=elem.total_rel_gift_s;
                                totArea.total_10+=elem.total_10;
                                totArea.total_coupon+=elem.total_coupon;
                                totArea.total_dil+=elem.total_dil;
                                totArea.total_apppago+=elem.total_apppago;
                                totArea.total_light+=elem.total_light;
                                totArea.total_small+=elem.total_small;
                                totArea.total_satis+=elem.total_satis;
                                totArea.total_stripe+=elem.total_stripe;
                                totArea.total_bon+=elem.total_bon;
                                totArea.total_check+=elem.total_check;
                                totArea.total_gift+=elem.total_gift;
                                totArea.total_gift_ns+=elem.total_gift_ns;
                                totArea.total_pos+=elem.total_pos;
                                totArea.total_card+=elem.total_card;
                                totArea.total_app+=elem.total_app;
                                totArea.total_prev+=elem.total_prev;
                                angular.forEach($scope.$parent.main.storesList, function (s) {
                                  if (s.id == elem.store_id) {
                                    elem.store = s;
                                    elem.lastname = s.alias;
                                  }
                                });
                            }
                        });
                        vm.cashClosed = cashClosed;
                        vm.eList = response.data.data;
                        if (vm.storeId == 0 && vm.eList.length>0) {
                            vm.eList.push(totArea);
                        }
                    }
                    vm.eListLoading = false;
                  },
                  function (response) {
                      vm.checkResponse(response);
                      vm.eListLoading = false;
                  }
            );
        };

        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(e) {
            vm.toggleRight(e);
        };
        vm.activeEntity = {};
        vm.toggleRight = function(e) {
            vm.isNewEntity = e!=null && e.id==null;
            vm.activeEntity = e;
            e.c_sid = vm.user.store_id;
            e.c_role = vm.user.type;
            if (e.appointments == null) {
                if (e.operator_id == 0) {
                    vm.activeEntity.appointments = vm.relatedsForEntity;
                } else if (e.operator_id>0) {
                    vm.activeEntity.appointments = $filter('filter')( vm.relatedsForEntity, {user_id: e.operator_id}, true);
                } else {
                    vm.activeEntity.appointments = $filter('filter')( vm.relatedsForEntity, {user_id_sm: e.app_sm_id}, true);
                }
          }
          if (vm.isNewEntity) {
              e.store_id = vm.storeId;
              e.user_id = vm.user.id;
              e.store = vm.store;
              e.date = moment(vm.eStatus.filter_date_start).format('YYYY-MM-DD');
              e.year = parseInt(moment(vm.eStatus.filter_date_start).format('YYYY'));
              e.month = parseInt(moment(vm.eStatus.filter_date_start).format('MM'));
              vm.initOperApp(e);
              angular.forEach(e.appointments, function (app) {
                if (!e.operator_id || app.user_id == e.operator_id) {
                  vm.addOperApp(e, app);
                }
              });
              vm.endOperApp(e);
           }
           $timeout($mdSidenav('right').open, 0);
        };
        vm.closeSidebar = function() {
            if (vm.loading) return;
            $mdSidenav('right').close();
        };
        vm.showActionToast = function( text) {
            text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent(text)
                .action('')
                .highlightAction(true)
                .position('bottom right');
            return $mdToast
                .show(toast)
                .finally(
                    function() {
                        toast = undefined;
                    }
                );
        };
        vm.responseStatusSuccessful = [200, 201, 202, 203, 204];
        vm.checkResponse = function(response) {
            if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
                var errMsg = "";
                if (response.data!=null && response.data.message!=null) {
                    errMsg = response.data!=null && response.data.message!=null?response.data.message:"";
                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    vm.showActionToast("KO: " + errMsg + " " + url);
                }
                var alert = $mdDialog.alert()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent("C'è stato un problema: "+errMsg)
                    .ok('Ok');
                return $mdDialog
                    .show(alert)
                    .finally(
                        function() {
                            alert = undefined;
                        }
                    );
            } else {
                vm.showActionToast();
                return;
            };
        };
        vm.saving = false;
        vm.save = function(e) {
            $log.info('Salva');
            if (angular.isDefined(e)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler eseguire la chiusura?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {
                            vm.saving = true;
                            if (vm.activeEntity.id==null) {
                                angular.forEach(vm.eList, function (cc) {
                                    if (vm.activeEntity.operator_id == cc.operator_id
                                            && vm.activeEntity.date==cc.date) {
                                        vm.activeEntity.id = cc.id;
                                    }
                                });
                            }
                            ClosingCashService
                                .save( vm.activeEntity )
                                .then(
                                function(response) {
                                    vm.checkResponse(response);
                                    if (vm.responseStatusSuccessful.indexOf(response.status) !== -1) {
                                        vm.closeSidebar();
                                        angular.forEach(response.data.data, function (elem)  {
                                            if (elem.operator_id>0) {
                                                elem.operator = {data: vm.operatorsWithApps['id_'+elem.operator_id]};
                                                elem.operatorRole = {data: vm.operatorsWithApps['id_'+elem.operator_id]};
                                                delete vm.operatorsWithApps['id_'+elem.operator_id];
                                            } else {
                                                vm.cashClosed = true;
                                            }
                                            elem.created_at_formatted = moment(elem.created_at.date).format('DD/MM HH:mm');
                                            /**
                                             * se presente sostituire
                                             */
                                            var found = false;
                                            for (var i=0; i<vm.eList.length; i++) {
                                              var el = vm.eList[i];
                                              if (el.operator_id == elem.operator_id) {
                                                found = true;
                                                vm.eList[i] = elem;
                                              }
                                            }
                                            if (!found) {
                                              vm.eList.push(elem);
                                            }
                                            if (elem.operator_id == 0) {
                                                vm.loadClosingCashXStoreManager();
                                            }
                                        });
                                    }
                                    vm.saving = false;
                                },
                                function(response) {
                                    vm.checkResponse(response);
                                    vm.saving = false;
                                });

                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };
        vm.undo = function(e) {
            $log.info('Undo');
            if (angular.isDefined(e)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler annullare la chiusura di '
                            +(e.operator_id ==0 ? vm.store.alias:e.operator.data.firstname)
                            +'?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {
                            vm.saving = true;
                            ClosingCashService
                                .undo( e, vm.user )
                                .then(
                                function(response) {
                                    vm.checkResponse(response);
                                    if (vm.responseStatusSuccessful.indexOf(response.status) !== -1) {
                                        vm.loadAvailab();
                                    }
                                    vm.saving = false;
                                },
                                function(response) {
                                    vm.checkResponse(response);
                                    vm.saving = false;
                                });

                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };
        /* WATCHO Lo Store */
        vm.storeId = null;
        vm.availabUserData = {};
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                vm.storeId = id;
                angular.forEach($scope.$parent.main.storesList, function (s) {
                    if (s.id == vm.storeId) {
                      vm.store = s;
                    }
                  });
                /**
                 * Carico i minuti operatore e dopo carico il resto
                 */
                vm.userLoad();
            }
        });

        /* Users */
        vm.usersList = [];
        vm.userLoad = function () {
            vm.initLoading();
            var pars = {
                    with: 'user',
            };
            if (vm.storeId) {
                pars.search ='store_id:' + vm.storeId;
                pars.searchFields = 'store_id:=';
            }
            UsersService.allRoles(pars).then( function( response ) {
                if( response.data && response.data.data ) {
                    vm.usersList = response.data.data;
                    vm.loadAvailab();
                };
            });
        };

        vm.initLoading = function () {
          vm.relatedsForEntity = [];
          vm.operatorsWithApps = {};
          vm.operatorsApps = {};
          vm.eList = [];
          vm.relLoading = true;
          vm.eListLoading = true;
          vm.availabPresent = false;
          vm.availabUserData = {};
        };
        vm.loadAvailab = function () {
          vm.initLoading();
          $http.get(env.API+"/operator-availability-day/"+vm.storeId+"/"+moment(vm.eStatus.filter_date_start).format('YYYY-MM-DD'))
          .then(function (response) {
                //$log.info(response.data.data);

                  vm.initAvailabUserData(0,0);
                  vm.initOperatorsApps(0);
                angular.forEach(response.data.data, function(m) {
                    angular.forEach(vm.usersList, function(role) {
                          if (role.user_id == m.user_id) {
                              m.role = role;
                              m.user = role.user;
                          }
                      });
                    vm.availabPresent = true;
                    var sid = 'sid_'+m.store_id;
                    if (!vm.availabUserData[sid]) {
                        vm.initAvailabUserData(m.store_id,response.data.leads_total);
                    }
                    if (!vm.operatorsApps[sid]) {
                        vm.initOperatorsApps(m.store_id);
                    }
                  if (m.user && m.role && m.role.color) {
                    m.user.color = m.role.color;
                  }
                  m.num_app = 0;
                  m.num_app_pf = 0;
                  m.num_app_cross = 0;
                  m.num_call = 0;
                  m.num_view = 0;
                  m.num_lead = 0;
                  m.minutes = parseInt(m.minutes);
                  vm.availabUserData[sid]['id_'+m.user_id] = m;
                  if (vm.storeId>0) {
                      //m.user.data.store_id = vm.storeId;
                      vm.operatorsApps['id_'+m.user_id] = {operator: {data: m.user }, operator_id: m.user_id, store_id: vm.storeId };
                      vm.availabUserData[sid]['id_0'].minutes += m.minutes;
                  } else {
                      vm.availabUserData['sid_0']['id_0'].minutes += m.minutes;
                  }
                });
                angular.forEach(response.data.prenotati, function(el) {
                    var sid = 'sid_';
                    if (vm.storeId) {
                        sid+=vm.storeId;
                    } else {
                        sid+=el.store_id;
                    }
                    if (vm.availabUserData[sid] && vm.availabUserData[sid]['id_'+el.by_operator] != null) {
                        vm.availabUserData[sid]['id_'+el.by_operator].num_app = el.num_app;
                        if (vm.storeId>0) {
                            vm.availabUserData[sid]['id_0'].num_app+=el.num_app;
                        } else {
                            vm.availabUserData['sid_0']['id_0'].num_app+=el.num_app;
                        }
                    }
                });
                angular.forEach(response.data.prenotatipf, function(el) {
                    var sid = 'sid_';
                    if (vm.storeId) {
                        sid+=vm.storeId;
                    } else {
                        sid+=el.store_id;
                    }
                    if (vm.availabUserData[sid] && vm.availabUserData[sid]['id_'+el.by_operator] != null) {
                        vm.availabUserData[sid]['id_'+el.by_operator].num_app_pf = el.num_app;
                        if (vm.storeId>0) {
                            vm.availabUserData[sid]['id_0'].num_app_pf+=el.num_app;
                        } else {
                            vm.availabUserData['sid_0']['id_0'].num_app_pf+=el.num_app;
                        }
                    }
                });
                angular.forEach(response.data.prenotaticross, function(el) {
                    var sid = 'sid_';
                    if (vm.storeId) {
                        sid+=vm.storeId;
                    } else {
                        sid+=el.store_id;
                    }
                    if (vm.availabUserData[sid] && vm.availabUserData[sid]['id_'+el.by_operator] != null) {
                        vm.availabUserData[sid]['id_'+el.by_operator].num_app_cross = el.num_app;
                        if (vm.storeId>0) {
                            vm.availabUserData[sid]['id_0'].num_app_cross+=el.num_app;
                        } else {
                            vm.availabUserData['sid_0']['id_0'].num_app_cross+=el.num_app;
                        }
                    }
                });
                /*angular.forEach(response.data.actions, function(el) {
                  if (vm.availabUserData['id_'+el.user_id] != null) {
                    vm.availabUserData['id_'+el.user_id].num_call = el.num_call;
                    vm.availabUserData['id_'+el.user_id].num_view = el.num_view;
                    vm.availabUserData['id_0'].num_call+=parseInt(el.num_call);
                    vm.availabUserData['id_0'].num_num_view+=parseInt(el.num_view);
                  }
                });
                angular.forEach(response.data.leads, function(el) {
                  if (vm.availabUserData['id_'+el.user_id] != null) {
                    vm.availabUserData['id_'+el.user_id].num_lead = el.num_lead;
                  }
                });
                */
                //$log.info(vm.minutes);
                vm.loadAppointments();
                vm.loadStatistics();

          }, function (response) {
            vm.checkResponse(response);
          });
        };
        vm.initAvailabUserData = function(store_id, leads_total) {
            var sid = 'sid_'+store_id;
            vm.availabUserData[sid] = {};
            vm.availabUserData[sid]['id_0'] = {num_app_pf: 0, num_app_cross: 0, num_app: 0, num_call: 0, num_view: 0, num_lead: leads_total, minutes:0, store_id: store_id};
        };
        vm.initOperatorsApps = function(store_id) {
            var store = null;
            if (store_id==0) {
                store = {alias: 'Totale area'};
            } else {
                angular.forEach($scope.$parent.main.storesList, function (s) {
                      if (s.id == store_id) {
                        store = s;
                      }
                  });
            }
            vm.operatorsApps['sid_'+store_id] = vm.newOperApp({data: {id:0, lastname:store.alias, store:store, store_id: store_id }});

        };

        vm.statistics = null;
        vm.trendings = [];
        vm.delta = null;
        vm.eventsStatistics = null;
        vm.statisticsScorp = null;
        vm.statsLoading = false;
        vm.loadStatistics = function () {
          vm.statistics = null;
          vm.trendings = [];
          vm.eventsStatistics = null;
          vm.statisticsScorp = null;
          if (vm.env.menu && !vm.env.menu.expcash) {
            return;
          }
          vm.statsLoading = true;
          $http.get(env.API+"/proiezionemese/"
              +vm.storeId+"/"+moment(vm.eStatus.filter_date_start).format('YYYY')
              +"/"+moment(vm.eStatus.filter_date_start).format('MM')
              +"/"+moment(vm.eStatus.filter_date_start).format('DD')+'?cash=1')
          .then(function (response) {
              //$log.info(response);
                vm.statistics = response.data.data;
                if (response.data.visoCorpoData) {
                    vm.trendings.push(vm.statistics);
                    vm.eventsStatistics = response.data.visoCorpoData;
                    vm.eventsStatistics.title = "Viso e Corpo";
                    vm.trendings.push(vm.eventsStatistics);
                    vm.statisticsScorp = response.data.epilData;
                    vm.statisticsScorp.title = "Epilazione";
                    vm.trendings.push(vm.statisticsScorp);
                } else if (response.data.trendings) {
                    vm.trendings = response.data.trendings;
                }
                if (response.data.delta) {
                    vm.delta = response.data.delta;
                    vm.delta.realizzato = parseFloat(vm.delta.realizzato);
                    vm.delta.previsto = parseFloat(vm.delta.previsto);
                    vm.delta.delta = parseFloat(vm.delta.delta);
                    vm.delta.delta_perc = parseFloat(vm.delta.delta_perc);
                }
                if (response.data.riporto) {
                    vm.riporto = parseFloat(response.data.riporto);
                } else {
                    vm.riporto = 0;
                }
                if (response.data.target) {
                    vm.target = response.data.target;
                }

                //$log.info(vm.delta);
                vm.statsLoading = false;
                  }, function (response) {
                      vm.checkResponse(response);
                      vm.statsLoading = false;
                  });
        };
        vm.operatorsAppsValues = function () {
          var res = [];
          $log.info(vm.operatorsApps);
          angular.forEach(vm.operatorsApps, function (e, k) {
            //$log.info(e);
            $log.info(e);
            res.push(e);
          });
          return res;
        }


        vm.perm = {
            canFire: function (id, ent) {
                return $scope.$parent.main.perm.canFire(id, ent);
            },
            canRead: function (id, ent) {
                return $scope.$parent.main.perm.canRead(id, ent);
            },
            canCreate: function (id, ent) {
                return $scope.$parent.main.perm.canCreate(id, ent);
            },
            canUpdate: function (id, ent) {
                return $scope.$parent.main.perm.canUpdate(id, ent);
            },
            canDelete: function (id, ent) {
                return $scope.$parent.main.perm.canDelete(id, ent);
            },
            canSave: function (id, ent) {
                return $scope.$parent.main.perm.canSave(id, ent);
            }
       };
        vm.soglie = {
            delta: {green: 10, normal: {min: -10, max: 10}, orange: {min: -35, max: -10}, red: -35},
            spost: {green: 10, normal: {min: 10, max: 15}, orange: {min: 15, max: 20}, red: 20},
            nonpres: {green: 10, normal: {min: 10, max: 20}, orange: {min: 20, max: 30}, red: 30},
            pres: {green: 90,  normal: {min: 80, max: 90}, orange: {min: 70, max: 80}, red: 70},
            dentro: function (val, range) {
              return val < range.max && val >= range.min;
            }
        };

        vm.scalaPerc     = [30,20,10,0,-10,-20,-30];
        vm.scalaOb         = [15,10,5,0,-5,-10,-15];
        vm.scalaRH         = [130,120,110,100,90,80,70];
        vm.scalaPres     = [74,68,62,55,47,40,33];
        vm.scalaSpost     = vm.scalaPres;
        vm.scalaAff     = vm.scalaPres;

        vm.colors = [
          "#009688",
          "#5AB963",
          "#8BC34A",
          "#CDDC39",
          "#FFEB3B",
          "#FFC107",
          "#FF9800",
          "#FF0000"
        ];
        vm.colorRH = function (val) {
          return vm.color(val, vm.scalaRH);
        };
        vm.colorAff = function (val) {
            return vm.color(val, vm.scalaAff);
        };
        vm.colorSpost = function (val) {
          return vm.color(94-2*val, vm.scalaSpost);
        };
        vm.colorPres = function (val) {
            return vm.color(val, vm.scalaPres);
        };
        vm.colorPerc = function (val) {
          return vm.color(val, vm.scalaPerc);
        };
        vm.colorOb = function (val) {
          return vm.color(val, vm.scalaOb);
        };
        vm.color = function (val, scala) {
          if (val>=scala[0]) return vm.colors[0];
          for (var i=1;i<7;i++) {
            if (val>=scala[i] && val<scala[i-1]) return vm.colors[i];
          }
          if (val<scala[6]) return vm.colors[7];
        };
    };

    CashController
        .$inject = [
            '$scope',
            '$http',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            'env',
            'CallState',
            'Italia',
            'TreatmentService',
            'StoreService',
            'SubscriptionService',
            'UsersService',
            'ClosingCashService',
            'AppointmentsService'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('BlankController', BlankController);

    /** @ngInject */
    function BlankController(
        $scope,
        $log,
        $location,
        $state,
        env,
        UsersService,
        redirectTo
    ) {
        var vm = this;
        vm.env = env;
        $log.info('BlankController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.title = "Caricamento in corso ..."
        if (redirectTo) {
            $state.go (redirectTo);
        } else {
            $state.go ('home.addressbook');
        }
    };

    BlankController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$state',
            'env',
            'UsersService',
            'redirectTo'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('BalanceController', BalanceController);

    /** @ngInject */
    function BalanceController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        $state,
        env,
        StoreService,
        UsersService,
        CrudService,
        MONTHS
    ) {
        var vm = this;
        $log.info('BalanceController');
        vm.MONTHS = MONTHS;
        vm.$state = $state;
        //$log.info("mesi", vm.MONTHS);
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        vm.selected = [];
        vm.query = {
            filter: '',
            month: parseInt(moment().format('MM')),
            year: parseInt(moment().format('YYYY')),
            order: '-date',
            period: null,
            causal_id: null
        };
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.period = null;
            vm.query.causal_id = null;
            vm.query.month = parseInt(moment().format('MM'));
            vm.query.year = parseInt(moment().format('YYYY'));
            vm.query.order = '-date';
            vm.eListLoad();
        };
        vm.years = [];
        for (var i=2015; i-1<=parseInt(vm.query.year); i++) {
            vm.years.push(''+i);
        }
        vm.eList = [];
        vm.eListTotal = 0;
        vm.eCostsTotal = 0;
        vm.loading = true;
        vm.eListLoad = function() {
            vm.eList = [];
            vm.eListTotal = 0;
            vm.eCostsTotal = 0;
            vm.prodotti = [];
            vm.costoProdotti = 0;
            vm.loading = true;
            vm.query.filter = '';
            var pars = {};
            if (vm.storeId) {
                pars.store_id=vm.storeId;
            }
            pars.year=vm.query.year;
            if(vm.query.month) {
                pars.month = vm.query.month;
            }
            CrudService.all('balance', pars, vm,
                function(response) {
                    if (response.data && response.data.data && response.data.data.length) {
                        angular.forEach(response.data.data, function(elem) {
                            elem.tipo = elem.prev?'Previsione':'Reale';
                            elem.nome_mese = vm.MONTHS.getName(elem.month);
                            elem.repeat = false;
                            elem.repeat_month = 1
                            if (elem.store_id) {
                                angular.forEach(vm.storesList, function(s) {
                                      if (elem.store_id == s.id) {
                                        elem.store = {data: s};
                                      }
                                });
                            } else {
                                elem.store = {data: { id: null, alias: 'Globale ' + vm.env.currentTenant } };
                            }
                            if (elem.tipo == 'Reale' && elem.causal_id == 22) {
                                if (!vm.costoProdotti.length) {
                                     vm.prodotti = elem;
                                     elem.causal.name = 'Costo prodotti';
                                }
                                vm.costoProdotti += parseFloat(elem.total);
                            }
                            else if (elem.causal.name == 'Servizi bancari') {
                                elem.causal.name = 'Costi finanziari';
                                vm.eList.push(elem);

                            }
                            else {
                                vm.eList.push(elem);
                            }

                        });
                        vm.prodotti.total = vm.costoProdotti;
                        vm.prodotti.order_id = '';
                        vm.eList.push(vm.prodotti);
                       // vm.eList = response.data.data;
                        vm.obiettivo = response.data.ob;
                        vm.ricavi = response.data.ricavi;
                        vm.riporto = response.data.riporto;
                        vm.risultato = {total: 0, gglav: 0, ggmese:25, price: 0, perc: 0};
                        vm.calcsOnVisibileElements();
                    }
                    vm.loading = false;
                },
                function () {
                    vm.loading = false;
                }
            );
        };
        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(e) {
        };
        vm.activeEntity = {};
        vm.updateEntity = {};
        vm.toggleRight = function(e) {
        };
        $scope.$watch('ab.query.filter', function() {
            if (!vm.loading) {
                vm.calcsOnVisibileElements();
            }
        });

        vm.calcsOnVisibileElements = function() {
            $timeout(function () {
                vm.eListTotal = 0;
                vm.eCostsTotal = 0;
                if (vm.riporto) {
                    vm.eListTotal+=parseFloat(vm.riporto.total);
                }
                if(vm.ricavi) {
                    vm.eListTotal+=vm.ricavi.total;
                }
                vm.filteredItems.forEach(function(item) {
                    var v = parseFloat(item.total);
                    vm.eListTotal -= v;
                    vm.eCostsTotal += v;
                });
                vm.risultato.total = vm.eListTotal - vm.obiettivo.total;
                vm.risultato.perc = (vm.eListTotal - vm.obiettivo.total)*100/vm.obiettivo.total;
                if (!vm.obiettivo.total) {
                    vm.risultato.color = vm.colorOb(vm.eListTotal>0?10:-10);
                } else {
                    vm.risultato.color = vm.colorOb(vm.risultato.perc);
                }
            });
        };
        vm.scalaPerc     = [30,20,10,0,-10,-20,-30];
        vm.scalaOb         = [15,10,5,0,-5,-10,-15];
        vm.scalaRH         = [130,120,110,100,90,80,70];
        vm.scalaPres     = [74,68,62,55,47,40,33];
        vm.scalaSpost     = vm.scalaPres;
        vm.scalaAff     = vm.scalaPres;

        vm.colors = [
          "#009688",
          "#5AB963",
          "#8BC34A",
          "#CDDC39",
          "#FFEB3B",
          "#FFC107",
          "#FF9800",
          "#FF0000"
        ];
        vm.colorRH = function (val) {
          return vm.color(val, vm.scalaRH);
        };
        vm.colorAff = function (val) {
            return vm.color(val, vm.scalaAff);
        };
        vm.colorSpost = function (val) {
          return vm.color(94-2*val, vm.scalaSpost);
        };
        vm.colorPres = function (val) {
            return vm.color(val, vm.scalaPres);
        };
        vm.colorPerc = function (val) {
          return vm.color(val, vm.scalaPerc);
        };
        vm.colorOb = function (val) {
          var res = vm.color(val, vm.scalaOb);
          //$log.info(res);
          return res;
        };
        vm.color = function (val, scala) {
          if (val>=scala[0]) return vm.colors[0];
          for (var i=1;i<7;i++) {
            if (val>=scala[i] && val<scala[i-1]) return vm.colors[i];
          }
          if (val<scala[6]) return vm.colors[7];
        };
        /* WATCHO Lo Store */
        vm.storeId = null;
        vm.storesList = [];
        vm.store = {id: 0, alias: 'Globale '  + vm.env.currentTenant };
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                vm.storeId = id;
                vm.storesList = $scope.$parent.main.storesList;
                angular.forEach(vm.storesList, function(s) {
                    if (s.id == id) {
                        vm.store = s;
                    }
                });
                vm.eListLoad();
            } else {
                vm.store = {id: 0, alias: 'Globale ' + vm.env.currentTenant };
            }
        });

        vm.perm = {
                canFire: function (id, ent) {
                    return $scope.$parent.main.perm.canFire(id, ent);
                },
                canRead: function (id, ent) {
                    return $scope.$parent.main.perm.canRead(id, ent);
                },
                canCreate: function (id, ent) {
                    return $scope.$parent.main.perm.canCreate(id, vm.getNewEntity());
                },
                canUpdate: function (id, ent) {
                    return $scope.$parent.main.perm.canUpdate(id, ent);
                },
                canDelete: function (id, ent) {
                    return $scope.$parent.main.perm.canDelete(id, ent);
                },
                canSave: function (id, ent) {
                    return $scope.$parent.main.perm.canSave(id, ent);
                }
       };
    };

    BalanceController
        .$inject = [
            '$scope',
            '$log',
            '$location',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            '$state',
            'env',
            'StoreService',
            'UsersService',
            'CrudService',
            'MONTHS'
        ];

})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .controller( 'AvailabilityAnalysisController', AvailabilityAnalysisController )
    ;

    /** @ngInject */
    function AvailabilityAnalysisController(
        $log,
        $http,
        $scope,
        $window,
        $interval,
        $timeout,
        $mdDialog,
        $filter,
        moment,
        TodayService,
        env,
        UsersService,
        OperatorAvailabilityService
    ) {
        var vm = this;
        $log.info( 'AvailabilityAnalysisController' );
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.env = env;

        vm.date = {startDate: moment(), endDate: moment()};

        $scope.$watch( 'dashboard.date', function( newDate ) {
            if (vm.storeId == null) return;
            $log.info( 'New date set: ', newDate );
            vm.load();
        }, false );

        vm.options = {
            buttonClasses: 'md-button md-raised',
            applyClass: 'md-accent',
            cancelClass: 'md-warn',
            format: 'DD/MM/YYYY',
            customRangeLabel: "asd",
            opens: "right",
            locale: {
                format: 'DD/MM/YYYY',
                separator: " - ",
                applyLabel: "Conferma",
                cancelLabel: "Annulla",
                fromLabel: "Dal",
                toLabel: "Al",
                customRangeLabel: "Scegli un range",
            },
            parentEl: ".page-dashboard",
            ranges: {
                'Oggi': [moment(), moment()],
                'Domani': [moment().add(1, 'days'), moment().add(1, 'days')],
                'Tra 2 gg': [moment().add(2, 'days'), moment().add(2, 'days')],
                'Tra 3 gg': [moment().add(3, 'days'), moment().add(3, 'days')],
                'Tra 4 gg': [moment().add(4, 'days'), moment().add(4, 'days')],
                'Tra 5 gg': [moment().add(5, 'days'), moment().add(5, 'days')],
                'Tra 6 gg': [moment().add(6, 'days'), moment().add(6, 'days')],
                'Tra 7 gg': [moment().add(7, 'days'), moment().add(7, 'days')],
                //'Prossima sett.': [moment(), moment().add(7, 'days')],
                //'Prossime 2 sett.': [moment(), moment().add(14, 'days')],
                //'Prossimi 30 giorni': [moment(), moment().add(30, 'days')],
                //'Questo mese': [moment().startOf('month'), moment().endOf('month')]
            }
        };


        vm.newSetEvents = function( events ) {
            // return $timeout(
            // function() {
                    vm.appointmentsList = events;
                    vm.buildResourceUsage(events);
                    vm.loading = false;
                    vm.filterChange();
           // }
           // , 50 );
        };
        /**
         * Classe Usage
         */
        vm.usageDateFormat = 'D MMMM - YYYY';
        vm.usageFirst = 480;
        vm.usageLast = 21*60; //== fino alle 21
        vm.usageSteps =(vm.usageLast-vm.usageFirst)/5;

        function Usage(type) {
            this.type = type;
            this.chart = null;
            this.usedCount = 0;
            this.availabilityCount = 0;
            this.minutes = [];
            this.available = [];
            // array dalle 8 == 480 che sarà lo 0 alle 21.55 == 1315 che sarà
            for (var i=0; i<vm.usageSteps; i++) {
                this.minutes.push(0);
                this.available.push(0);
            }
        };
        Usage.prototype.addAvailability = function(from, to, val) {
            if (!val) {
                val = 1;
            }
            if (!from) {
                from = vm.usageFirst;
            }
            if (!to) {
                to = vm.usageLast-5;
            }
            while(from<=to) {
                  var i = from/5-vm.usageFirst/5;
                  if (i>=0 && i<vm.usageSteps) {
                      this.available[i] = this.available[i] + val;
                      this.availabilityCount++;
                  }
              from+=5;
            }
        };
        Usage.prototype.addUsage = function (from, to) {
          // $log.info(this.type + " -> addUsage: " + from + ".." + to);
          while(from<=to) {
            var i = from/5-vm.usageFirst/5;
            // $log.info(this.type + " -> addUsage: " + from + "=>" + i);
            if (i>=0 && i<vm.usageSteps) {
                this.minutes[i] = this.minutes[i] + 1;
                this.usedCount++;
            }
          from+=5;
          }
       };
       Usage.prototype.setChart = function (c) {
           this.chart = c;
       };

       Usage.prototype.loadMachineryAvailability = function(sid, mid, df) {
           var q = this;
           $http.get(vm.env.API+"/machinery_store_available/"+sid+"/"+mid+"/"+df).then(
                   function(response) {
                       q.addAvailability(null, null, response.data.data.quantity);
                       if(q.chart!=null) {
                           q.chart.update();
                       }
                   },
                   function(response){
                     $log.info(response);
                   }
           );
       };
       Usage.prototype.loadOperatorAvailability = function(sid, uid, df) {
           var q = this;
           OperatorAvailabilityService.all(
                   {     search: "store_id:"+sid + ";date:"+df+";user_id:"+uid,
                       searchFields: "store_id:=;date:=;user_id:="
                   }
               ).then(
                   function( data ) {
                    //$log.info(data);
                        angular.forEach(data, function(r) {
                       q.addAvailability(r.minute_start, r.minute_end-5);
                        });
                    if(q.chart!=null) {
                       q.chart.update();
                    }
                },
                function(response){
                  $log.info(response);
                }
           );
       };
       Usage.prototype.loadAssistAvailability = function(sid, df) {
           var q = this;
           OperatorAvailabilityService.all(
                   {     search: "store_id:"+sid + ";date:"+df+";reserved:4",
                       searchFields: "store_id:=;date:=;reserved:="
                   }
               ).then(
                   function( data ) {
                    //$log.info(data);
                        angular.forEach(data, function(r) {
                       q.addAvailability(r.minute_start, r.minute_end-5);
                        });
                    if(q.chart!=null) {
                       q.chart.update();
                    }
                },
                function(response){
                  $log.info(response);
                }
           );
       };
        vm.usageUsers = [];
        vm.usageUsersGet = function(df, d, app) {
            // $log.info(app.role.data);
            var key = 'user_'+app.role.data.user_id;
            var label = app.role.data.user.lastname + " " + app.role.data.user.firstname;
            if (!vm.usageUsers[df]) {
                vm.usageUsers[df] = [];
            }
            var uu = vm.usageUsers[df];
            if (!uu[key]) {
                uu[key] = {
                    'label': label,
                    'user_id': app.role.data.user_id,
                    'color': app.role.data.color,
                    'usage': new Usage('operator')
                };
                /**
                 * TODO caricare availability per utente in questa data
                 */
                uu[key].usage.loadOperatorAvailability(vm.storeId, app.role.data.user_id, d.format('YYYY-MM-DD'));
            }
            return uu[key];
        };
        vm.usageLabels = [];
        for(var i=vm.usageFirst; i<vm.usageLast; i=i+5) {
              var min = "0"+(i % 60);
              min = min.substring(min.length-2);
              var all = i - (i % 60);
              vm.usageLabels.push(''+Math.round(all/60)+":"+min);
              // $log.info(''+Math.round(all/60)+":" + min + " == "+ i);
          }
          // $log.info(vm.usageLabels);
        vm.usageAssists = [];
        vm.usageAssistsGet = function(df, d) {
            if (!vm.usageAssists[df]) {
                vm.usageAssists[df] = {
                    'label': 'Assistenti',
                    'usage': new Usage('assist')
                }
                vm.usageAssists[df].usage.loadAssistAvailability(vm.storeId, d.format('YYYY-MM-DD'));
            }
            return vm.usageAssists[df];
        };
        vm.usageRooms = [];
        vm.usageRoomsGet = function(d) {
            if (!vm.usageRooms[d]) {
                vm.usageRooms[d] = {
                    'label': 'Cabine',
                    'usage': new Usage('room')
                }
                vm.usageRooms[d].usage.addAvailability(null, null, vm.store.rooms);
            }
            return vm.usageRooms[d];
        };
        vm.usageMachineries = [];
        vm.usageMachineriesGet = function(df, d, act) {
            var key = act.machinery.name;
            var label = act.machinery.name;
            if (!vm.usageMachineries[df]) {
                vm.usageMachineries[df] = [];
            }
            var uu = vm.usageMachineries[df];
            if (!uu[key]) {
                uu[key] = {
                    'label': label,
                    'machinery_id': act.machinery_id,
                    'usage': new Usage('machinery')
                };
                uu[key].usage.loadMachineryAvailability(vm.storeId, act.machinery_id,d.format('YYYY-MM-DD'));
            }
            return uu[key];
        };
        vm.resetUsage = function() {
            vm.usageUsers = [];
            vm.usageRooms = [];
            vm.usageAssists = [];
            vm.showRooms = false;
            vm.showAssists = false;
            vm.chartIndex = [];
            vm.usageMachineries = [];
            $('#operChartContainer').html("");
            $('#areaChartContainer').html("");
        };
        vm.buildResourceUsage = function(apps) {
            vm.resetUsage();
            var firstD = null;
            angular.forEach(apps, function(app) {
                var d = app.date_start?moment(app.date_start):moment(app.start);
                var df = d.format(vm.usageDateFormat);
                if (firstD == null) {
                    firstD = df;
                }
                var uUser = vm.usageUsersGet(df, d, app);
                var uUserAssist = null;
                if (app.assist_user) {
                    uUserAssist = vm.usageUsersGet(df, d, app, 'assist');
                }
                var uRoom = vm.usageRoomsGet(df);
                var uAssist = vm.usageAssistsGet(df, d);
                var from = d.get('hour')*60+d.get('minute');
                var begin = d.get('hour')*60+d.get('minute');
                from = from - from % 5;
                begin = begin - begin % 5;
                var to = from+app.treatment.data.min_duration-5;
                if (uRoom) {
                    uRoom.usage.addUsage(from, to);
                }
                angular.forEach(app.treatment.data.activities.data, function(act) {
                    var dur = moment.duration(act.duration).asMinutes();
                    if (dur<5) {dur = 5};
                    from = begin + act.minute_start;
                    to = from + dur - 5;
                    if (act.machinery_id) {
                        var uMachinery = vm.usageMachineriesGet(df, d, act);
                        if (uMachinery) {
                            uMachinery.usage.addUsage(from, to);
                        }
                    }
                    if (act.type == 'operator') {
                        if (uUser) {
                            uUser.usage.addUsage(from, to);
                        }
                    } else if (act.type == 'assist') {
                        if (uAssist) {
                            uAssist.usage.addUsage(from, to);
                        }
                    }
                    //$log.info("from="+from+" to="+to+" done!");
                    from = to+5;
                });
            });
            if(firstD) {
                vm.renderUsage(firstD);
            }
            //$log.info(vm.usageUsers);
            // $log.info(vm.usageRooms);
            // $log.info(vm.usageAssists);
            // $log.info(vm.usageMachineries);
        };

        /*
         * Grafici utilizzo risorse
         */
        vm.usageSelected = null;
        vm.renderUsage = function(d) {
            vm.usageSelected = d;
            var areaChartOptions = {
                      maintainAspectRatio : false,
                      responsive : true,
                      legend: {
                        display: true
                      },
                      scales: {
                        xAxes: [{
                          gridLines : {
                            display : true,
                          }
                        }],
                        yAxes: [{
                          gridLines : {
                            display : true,
                          },
                          ticks: {
                              beginAtZero: true,
                              callback: function(value) {if (value % 1 === 0) {return value;}}
                          }
                        }]
                      }
                    };


            /**
             * Grafici operatrici
             */
            // $log.info("html->"+$('#operChartContainer').html());

            var i=0;
            for(var k in vm.usageUsers[d]) {
                var us = vm.usageUsers[d][k];
                $log.info(k,us);
                $('#areaChartU_'+us.user_id).remove();
                $('#operChartContainer').append('<canvas id="areaChartU_'+us.user_id+'" style="min-height: 150px; height: 150px; max-height: 150px; max-width: 100%;"></canvas>');
                var areaChartUCanvas = $('#areaChartU_'+us.user_id).get(0).getContext('2d');
                vm.chartIndex['areaChartU_'+us.user_id] = true;
                var areaChartUData = {
                  labels  : vm.usageLabels,
                  datasets: [
                    {
                          label               : us.label + " occ.",
                          backgroundColor     : us.color,
                          borderColor         : us.color,
                          pointRadius          : 1,
                          pointColor          : '#3b8bba',
                          pointStrokeColor    : us.color,
                          pointHighlightFill  : '#fff',
                          pointHighlightStroke: us.color,
                          data                : us.usage.minutes
                    },
                      {
                            label               : us.label + " disp.",
                        backgroundColor     : 'rgba(210,214,222,1)',
                        borderColor         : 'rgba(210,214,222,1)',
                        pointRadius         : 1,
                        pointColor          : 'rgba(210,214,222,1)',
                        pointStrokeColor    : '#c1c7d1',
                        pointHighlightFill  : '#fff',
                        pointHighlightStroke: 'rgba(220,220,220,1)',
                            data                : us.usage.available
                      }
                  ]
                };
                var c = new Chart(areaChartUCanvas, {
                      type: 'line',
                      data: areaChartUData,
                      options: areaChartOptions
                    });
                us.usage.setChart(c);
                i++;
            };

            // REMOVE OLD CHART IF EXIST
            $('#areaChartContainer').append('<canvas id="areaChartR" style="min-height: 250px; height: 250px; max-height: 250px; max-width: 100%;"></canvas>');
            $('#areaChartContainer').append('<canvas id="areaChartA" style="min-height: 250px; height: 250px; max-height: 250px; max-width: 100%;"></canvas>');
            //$('#areaChartContainer').append('<canvas id="areaChartL" style="min-height: 250px; height: 250px; max-height: 250px; max-width: 100%;"></canvas>');

            var areaChartRCanvas = $('#areaChartR').get(0).getContext('2d');
            var areaChartACanvas = $('#areaChartA').get(0).getContext('2d');
            vm.chartIndex['areaChartR'] = true;
            vm.chartIndex['areaChartA'] = true;
            //var areaChartLCanvas = $('#areaChartL').get(0).getContext('2d');

            var areaChartRData = {
              labels  : vm.usageLabels,
              datasets: [
                {
                      label               : vm.usageRooms[d].label + " occ.",
                      backgroundColor     : 'rgba(60,141,188,0.5)',
                      borderColor         : 'rgba(60,141,188,0.5)',
                      pointRadius          : 1,
                      pointColor          : '#3b8bba',
                      pointStrokeColor    : 'rgba(60,141,188,0.5)',
                      pointHighlightFill  : '#fff',
                      pointHighlightStroke: 'rgba(60,141,188,0.5)',
                      data                : vm.usageRooms[d].usage.minutes
                },
                {
                      label               : vm.usageRooms[d].label + " disp.",
                    backgroundColor     : 'rgba(210,214,222,1)',
                    borderColor         : 'rgba(210,214,222,1)',
                    pointRadius         : 1,
                    pointColor          : 'rgba(210,214,222,1)',
                    pointStrokeColor    : '#c1c7d1',
                    pointHighlightFill  : '#fff',
                    pointHighlightStroke: 'rgba(220,220,220,1)',
                      data                : vm.usageRooms[d].usage.available
                }
              ]
            };
            new Chart(areaChartRCanvas, {
                  type: 'line',
                  data: areaChartRData,
                  options: areaChartOptions,
                });
            var areaChartAData = {
                labels  : vm.usageLabels,
                datasets: [
                  {
                        label               : vm.usageAssists[d].label +" occ.",
                      backgroundColor     : 'rgba(0,166,90,0.5)',
                    borderColor         : 'rgba(0,166,90,0.5)',
                    pointRadius         : 1,
                    pointColor          : '#00A65A',
                    pointStrokeColor    : 'rgba(0,166,90,0.5)',
                    pointHighlightFill  : '#fff',
                    pointHighlightStroke: 'rgba(0,166,90,0.5)',
                    data                : vm.usageAssists[d].usage.minutes
                  },
                {
                      label               : vm.usageAssists[d].label + " disp.",
                    backgroundColor     : 'rgba(210,214,222,1)',
                    borderColor         : 'rgba(210,214,222,1)',
                    pointRadius         : 1,
                    pointColor          : 'rgba(210,214,222,1)',
                    pointStrokeColor    : '#c1c7d1',
                    pointHighlightFill  : '#fff',
                    pointHighlightStroke: 'rgba(220,220,220,1)',
                      data                : vm.usageAssists[d].usage.available
                }
                ]
              };
            var c = new Chart(areaChartACanvas, {
                  type: 'line',
                  data: areaChartAData,
                  options: areaChartOptions,
                });
            vm.usageAssists[d].usage.setChart(c);
            console.log(vm.usageMachineries);
            /**
             * per ogni macchinario presente in questa data creo un grafico
             */
            for(var k in vm.usageMachineries[d]) {

                //if (vm.usageMachineries && vm.usageMachineries[d] && vm.usageMachineries[d]['Laser']) {
                var areaChartLData = {
                        labels  : vm.usageLabels,
                        datasets: [{
                        label               : vm.usageMachineries[d][k].label + ' occ.',
                        backgroundColor     : 'rgba(243,156,18,0.5)',
                        borderColor         : 'rgba(243,156,18,0.5)',
                        pointRadius         : 1,
                        pointColor          : '#f39c12',
                        pointStrokeColor    : 'rgba(243,156,18,0.5)',
                        pointHighlightFill  : '#fff',
                        pointHighlightStroke: 'rgba(243,156,18,0.5)',
                        data                : vm.usageMachineries[d][k].usage.minutes
                        },
                      {
                            label               : vm.usageMachineries[d][k].label + " disp.",
                        backgroundColor     : 'rgba(210,214,222,1)',
                        borderColor         : 'rgba(210,214,222,1)',
                        pointRadius         : 1,
                        pointColor          : 'rgba(210,214,222,1)',
                        pointStrokeColor    : '#c1c7d1',
                        pointHighlightFill  : '#fff',
                        pointHighlightStroke: 'rgba(220,220,220,1)',
                            data                : vm.usageMachineries[d][k].usage.available
                      }
                        ]
                };
                //$log.info(vm.usageMachineries[d]['Laser'].usage.available);
                var kns = vm.usageMachineries[d][k].machinery_id;
                $('#areaChartM_'+kns).remove();
                $('#areaChartContainer').append('<canvas id="areaChartM_'+kns+'" style="min-height: 150px; height: 150px; max-height: 150px; max-width: 100%;"></canvas>');
                vm.chartIndex['areaChartM_'+kns] = true;
                //console.log($('#areaChartM_'+kns));
                var areaChartMCanvas = $('#areaChartM_'+kns).get(0).getContext('2d');
                var c = new Chart(areaChartMCanvas, {
                    type: 'line',
                    data: areaChartLData,
                    options: areaChartOptions,
                  });
                vm.usageMachineries[d][k].usage.setChart(c);
            }
    };


        vm.loading = true;
        vm.load = function() {
            $log.info( 'Caricamento appuntamenti: ', vm.date );
            vm.resetUsage();
            vm.loading = true;
            vm.appointmentsList = [];
            vm.eventSources = [];
            vm.chartIndex = [];
            if (!vm.storeId) {
                return;
            }
            var options = {
                with : 'role;treatment;customer;treatment.activities;treatment.commercials',
                search :
                    'recalled:3' +
                    ';date_start:' + moment( vm.date.startDate ).format( 'YYYY-MM-DD' ) +
                    ';date_end:' + moment( vm.date.endDate?vm.date.endDate:vm.date.startDate ).add( 1, 'd' ).format( 'YYYY-MM-DD' ) +
                    ';store_id:' + vm.storeId
                ,
                searchFields : 'confirmed:=;date_start:>;date_end:<;store_id:=;recalled:<',
                s: 9999 // per bypassare la paginazione
            };
            TodayService
                .all( options )
                .then( vm.newSetEvents )
            ;
        };

        vm.chartIndex = [];
        vm.showRooms = false;
        vm.showAssists = false;

        vm.filterChange = function() {
            /**
             * Nascondo quelli non selezionati
             */

            var selectedUser = null;
            if (vm.user_id_selected) {
                selectedUser = 'areaChartU_'+vm.user_id_selected;
            }
            var selectedMachinery = null;
            if (vm.machinery_id_selected) {
                selectedMachinery = 'areaChartM_'+vm.machinery_id_selected;
            }
            var showRooms = vm.showRooms;
            var showAssists = vm.showAssists;
            for(var k in vm.chartIndex) {
                if (k.indexOf('areaChartM_') == 0) {
                    if (selectedMachinery && k == selectedMachinery) {
                        $('#'+k).show();
                    } else if (selectedMachinery) {
                        $('#'+k).hide();
                    } else {
                        $('#'+k).show();
                    }
                }
                if (k.indexOf('areaChartU_') == 0) {
                    if (selectedUser && k == selectedUser) {
                        $('#'+k).show();
                    } else if (selectedUser) {
                        $('#'+k).hide();
                    } else {
                        $('#'+k).show();
                    }
                }
                if (k.indexOf('areaChartR') == 0) {
                    if (showRooms) {
                        $('#'+k).show();
                    } else {
                        $('#'+k).hide();
                    }
                }
                if (k.indexOf('areaChartA') == 0) {
                    if (showAssists) {
                        $('#'+k).show();
                    } else {
                        $('#'+k).hide();
                    }
                }
            }

        };

        vm.machinery_id_selected = undefined;
        vm.user_id_selected = undefined;

        vm.machineries = [];
        vm.loadMachineries = function() {
            $log.info( 'Caricamento macchinari: ', vm.storeId );
            var date = moment( vm.date.startDate ).format( 'YYYY-MM-DD' );
            $http.get(vm.env.API+'/machinery_store?searchFields=store_id:=;date_from:<;date_to:>&search=store_id:'+vm.storeId+";date_to:"+date+";date_from:"+date).then(function(response){
                vm.machineries = response.data.data;
                $log.info(response.data.data);
            }, function(response){
                $log.info(response);
            });
        };
        /* Users */
        vm.userRolesList = [];
        vm.userRolesListAll = []
        vm.userRolesListCall = [];
        vm.userRolesLoad = function () {
            if (vm.userRolesListAll.length==0) {
                $log.info( 'Caricamento utenti' );
                var pars = {with: 'user'};
                return UsersService.allRoles( pars ).then( function( response ) {
                    if( response.data && response.data.data ) {
                        vm.userRolesListAll = response.data.data;
                        //$log.info(vm.userRolesListAll);
                        vm.userRolesList = vm.filterRolesXStore();
                        //$log.info(vm.userRolesList);
                        vm.userRolesListCall = vm.filterRolesXRole('callcenter');
                        //$log.info(vm.userRolesListCall);
                        vm.load(null); //carico solo ora perchè serve la lista utenti
                    }
                });
            } else {
                vm.userRolesList = vm.filterRolesXStore();
                vm.userRolesListCall = vm.filterRolesXRole('callcenter');
                vm.load();//carico solo ora perchè serve la lista utenti
            }
        };
        vm.filterRolesXStore = function() {
            var fs = {active: true};
            if (vm.storeId) {
                fs.store_id = vm.storeId;
            } else {
                //fs.store_id = '>0';
            }
            return $filter('filter')(vm.userRolesListAll, fs, true);
        };
        vm.filterRolesXRole = function (role) {
            var fs = {active: true, role: role};
            return $filter('filter')(vm.userRolesListAll, fs, true);
        };

        vm.getUserRole = function(user_id, store_id) {
          var res = null;
            angular.forEach(vm.userRolesList, function (r){
                if (r.user_id == user_id && r.store_id == store_id) {
                    res = r;
                }
            });
            if (res != null) {
              return res;
            }
            $log.error("non trovato ruolo per utente " + user_id + "/" + store_id);
            return {id: user_id, color: '#888888'};
        };

        vm.availabilityIntervalDailyReport = function () {
            window.open(env.API+"/operator-availability-interval-daily"
                +"?store_id="+(vm.storeId)
                +"&start="+moment( vm.filter_date_start ).format( 'YYYY-MM-DD' )
                +"&end="+moment( vm.filter_date_end?vm.filter_date_end:vm.filter_date_start ).format( 'YYYY-MM-DD' )
                +"&token="+vm.token
                +"&assist=0"
            );
        };
        /* Watcho lo Store */
        vm.storeId = null;
        vm.storesList = null;
        vm.store = null;
        $scope.$watch( '$parent.selectedStore', function( id ) {
            if( angular.isDefined( id ) ) {
                vm.storeId = id;
                if (vm.storesList == null) {
                    vm.storesList = $scope.$parent.main.storesList;
                }
                angular.forEach(vm.storesList, function(el) {
                    if (el.id == id) {
                        vm.store = el;
                    }
                });
                vm.userRolesLoad();
                vm.loadMachineries();
            };
        });
    };
})();

(function() {
    'use strict';

    angular
        .module('admin')

        .factory('OperatorAvailabilityService', function(Restangular, moment, $http, env) {

            var service = Restangular
                .withConfig(function(RestangularConfigurer) {
                    RestangularConfigurer.addElementTransformer('operator-availability', false, function(element) {

                       element.start = moment(element.date_start).toDate();
                       delete element.date_start;
                       element.end = moment(element.date_end).toDate();
                       delete element.date_end;
                       // $log.info(element);

                       return element;
                    })
                    .setRequestInterceptor(function(element, operation) {
                       // $log.info(operation);
                       if(operation == 'put' || operation == 'post') {
                           element.date_start = moment(element.start).format('YYYY-MM-DD HH:mm:ss');
                           delete element.start;
                           element.date_end = moment(element.end).format('YYYY-MM-DD HH:mm:ss');
                           delete element.end;
                           // $log.info(element);

                           return element;
                        }
                    });
                })
                .all('operator-availability');

            service.all = function(options){
                return service.getList(options);
            };

            service.save = function(data){
                return service.post(data);
            };

            service.replace = function(availab, user1, user2, availabXChange1, availabXChange2) {
                return $http.post(env.API + '/operator-availability-replace',
                    {
                        availab: availab,
                        user1: {id: user1.id},
                        user2: {id: user2.id},
                        availabXChange1: availabXChange1,
                        availabXChange2: availabXChange2
                    }
                );
            }

            return service;
        })
        .service(
            'UsersService',
            function(
            $log,
            env,
            $http,
            $auth,
            $state,
            $timeout
        ) {
            return {
                all : function( options ) {
                    var apiURI = env.API + '/users';
                    return $http.get( apiURI, { params: options } );
                },
                searchByEmail : function( email ) {
                    var apiURI = env.API + '/users_by_email/'+email;
                    return $http.get( apiURI );
                },
                allRoles : function( options ) {
                  var apiURI = env.API + '/user_roles';
                  return $http.get( apiURI, { params: options } );
                },
                put : function( options ) {
                    if(
                        angular.isDefined( options ) &&
                        angular.isObject( options ) &&
                        options.id
                    ) {
                        var apiURI = env.API + '/users/' + options.id;
                        return $http.put( apiURI, options );
                    };
                },
                save : function( options ) {
                    var apiURI = env.API + '/users';
                    return $http.post( apiURI, options );
                },
                availablesForChange: function(storeId, appointmentId, currentUid,date) {
                    var apiURI = env.API + '/users/availables_for_change/' + storeId + "/" + appointmentId + "/" + currentUid + "/" + date;
                    return $http.get( apiURI );
                },
                loadUserFromLocalStorage: function (vm, main) {
                    if (main) {
                        $log.info("loadUserFromLocalStorage main.nextTickPromise", main.nextTickPromise);
                        if (!main.nextTickPromise) {
                            $log.info("loadUserFromLocalStorage NO main.nextTickPromise");
                            $log.info(main);
                        }
                    } else {
                        $log.info("loadUserFromLocalStorage NO main");
                    }
                    var token = localStorage.getItem('Biolaser_token');
                    var user = angular.fromJson(localStorage.getItem('user'));
                    $log.info('loadUserFromLocalStorage: vm.user.tenant='+user.tenant + ' vm.env.currentTenant='+((vm.env)? vm.env.currentTenant : ''))
                    if (!user || user==null || !user.logon_at || !token) {
                        this.doLogout("InvalidUserOrTokenFromStorage", main).then (
                                function () {
                                    $state.go( 'login' );
                                    return false;
                                },
                                function () {
                                    $state.go( 'login' );
                                    return false;
                                }
                        );
                        return false;
                    }
                    var minuteDiff = moment().diff(user.logon_at,'minutes');
                    if (minuteDiff > 720 /*720*/) {//12 ore poi scade la sessione
                        this.doLogout("ExpiredUserLogonGt720Minutes", main).then (
                                function () {
                                    $state.go( 'login' );
                                    return false;
                                },
                                /*devo fare stessa cosa anche se va in errore la doLogout metodo invalidate */
                                function () {
                                    $state.go( 'login' );
                                    return false;
                                }
                        );
                        return false;
                    }
                    vm.token = token;
                    vm.userId = user.id;
                    vm.isCallCenter = (user.type === 'callcenter') ? true : false;
                    vm.isAdmin = (user.type === 'admin') ? true : false;
                    vm.isOperator = (user.type === 'operator') ? true : false;
                    vm.isManager = (user.type === 'manager') ? true : false;
                    vm.isBackoffice = (user.type === 'backoffice') ? true : false;
                    vm.isStoremngr = (user.type === 'storemngr') ? true : false;
                    vm.user = user;
                    vm.user_type = user.type;
                    vm.user_name = user.firstname + ' ' + user.lastname;
                    vm.user_store = "";
                    vm.user_image = user.image;
                    return true;
                },
                invalidateToken: function(token, reason) {
                    var apiURI = env.API + '/invalidate';
                    $log.info("invalidateToken: "+reason);
                    var data = {
                        token: token,
                        reason: reason
                    };
                    return $http.post( apiURI, data );
                },
                doLogout: function (reason, main) {
                    /**
                     * devo cancellare tick schedule da main
                     */
                    if (main) {
                        $log.info("main.tick next execution cancellation ...");
                        var promise = main.nextTickPromise;
                        if (promise) {
                            var res = $timeout.cancel(promise);
                            $log.info("main.tick cancel result: " + res);
                        } else {
                            $log.info("main.tick cancel nothing to do.");
                        }
                    }

                    var token = localStorage.getItem( 'Biolaser_token' );
                    return this.invalidateToken(token, reason).finally (
                            function () {
                                $auth.logout();
                                $log.info("deleting auth info");
                                localStorage.removeItem( 'Biolaser_token' );
                                localStorage.removeItem( 'leads_eStatus' );
                                localStorage.removeItem( 'leads_query' );
                                localStorage.removeItem( 'appointments_eStatus' );
                                localStorage.removeItem( 'appointments_query' );
                                localStorage.removeItem( 'cusacts_eStatus' );
                                localStorage.removeItem( 'cusacts_query' );
                                localStorage.removeItem( 'orders_query' );
                                localStorage.removeItem( 'user' );
                            });

                }
            };
        }
    );

})();

(function() {
    'use strict';
    angular
        .module('admin')
        .controller('AvailabilitiesController', AvailabilitiesController)
    ;
    /** @ngInject */
    function AvailabilitiesController(
        $log,
        $timeout,
        $scope,
        $window,
        $mdDialog,
        $mdMedia,
        $mdDateLocale,
        uiCalendarConfig,
        $state,
        $filter,
        $http,
        env,
        $mdSidenav,
        $mdToast,
        moment,
        UsersService,
        AppointmentsService,
        OperatorAvailabilityService,
        CrudService
    ) {
        var vm = this;
        vm.env = env;
        $log.info('AvailabilitiesController');
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.today = moment();
        var dayNowInThisMonth = vm.today.date()-1;
        var daysInPrevMonth = moment().add(-1, 'months').daysInMonth();
        var daysInPrev2Month = moment().add(-2, 'months').daysInMonth();


        if (vm.user.type=='admin' || vm.user.type=='backoffice') {
            vm.daysMod = 3650; //10 anni
        } else if (dayNowInThisMonth<=15) {
            vm.daysMod = daysInPrevMonth + dayNowInThisMonth;
        } else {
            vm.daysMod = dayNowInThisMonth;
        }
        $log.info("daysMod",vm.daysMod);
        vm.mdDialog = $mdDialog;
        vm.mdToast = $mdToast;
        vm.today = moment();
        vm.minDate = moment().add(0-vm.daysMod,'days');
        vm.todayStr = vm.today.format('YYYY-MM-DD');
        //$log.info(vm.todayStr);
        /* Users */
        vm.usersList = [];
        vm.usersListFiltered = [];
        vm.userTags = [];
        vm.usersListActiveStore = [];

        vm.userLoad = function () {
            var pars = {
            };
            /*if (vm.storeId) {
                pars.search ='store_id:' + vm.storeId;
                pars.searchFields = 'store_id:=';
            }*/
            if (vm.storeId) {
                pars.search ='store_id:0';
                pars.searchFields = 'store_id:>';
                vm.filter.leaveType = null;
                pars.with = 'user;currentDesignation';
                pars.withminutesrec = true;
            } else if (vm.env.isMaster) {
                vm.filter.leaveType = null;
                pars.with = 'user';
            }
            UsersService.allRoles(pars).then( function( response ) {
                if( response.data && response.data.data ) {
                    vm.usersList = response.data.data;
                    if (vm.storeId) {
                        vm.usersListActiveStore = $filter('filter')(vm.usersList, {store_id: vm.storeId, active: true}, true);
                    } else if (vm.env.isMaster) {
                        vm.usersListFiltered = vm.usersList;
                        angular.forEach(vm.usersList, function(r) {
                            //$log.info(r);
                            if (r.user && r.user.tag_area && vm.userTags.indexOf(r.user.tag_area)<0) {
                                vm.userTags.push(r.user.tag_area);
                                //$log.info("added tag: " + r.user.tag_area)
                            }
                        });
                        vm.userTags.sort();
                        vm.usersListActiveStore = $filter('filter')(vm.usersList, {active: true}, true);
                    }
                    if (vm.query.start!=null) {
                        vm.avaibilityLoad();
                    }
                }
            });
        };
        /* Events */
        vm.eventSources = [ { events: [] } ];
        vm.query = {
            start: null,
            end: null,
            allstores: false
        }
        vm.initLoading = function() {
            vm.availabilitiesList = [];
            vm.eventSources = [ { events: [] } ];
            vm.reRenderEvents();
            vm.loading = true;
        };
        vm.loading = true;
        vm.saving = false;
        //vm.avaibilityLoaded = [];
        vm.availabilitiesList = [];
        vm.avaibilityLoad = function () {
            //vm.initLoading();
            if (!vm.storeId && !vm.env.isMaster) {
                vm.loading = false;
                return;
            }
            vm.loading = true;
            var start = vm.query.start.format("YYYY-MM-DD");
            var end = vm.query.end.format("YYYY-MM-DD");
            var key = vm.storeId+"*"+start + "*" + end;
            /*if (vm.avaibilityLoaded[key]!=null) {
                $log.info("avaibilityLoad", "Uso cache per " + key);
                vm.availabilitiesList = vm.avaibilityLoaded[key];
                vm.reRenderEvents();
                vm.loading = false;
                return;
            }*/
            $log.info("avaibilityLoad: " + vm.today.diff(vm.query.start,'days'));
            if (vm.today.diff(vm.query.start,'days')>36 && vm.user.store_id) {
                vm.availabilitiesList =  [];
                vm.reRenderEvents();
                vm.loading = false;
                return;
            }
            var pars = {
                    search: (vm.storeId || !vm.env.isMaster ?"store_id:"+vm.storeId + ";":"")+"date_start:"+start+";date_end:"+end,
                    searchFields: (vm.storeId || !vm.env.isMaster?"store_id:=;":"")+"date_start:>=;date_end:<",
                    orderBy: 'date_end'
                };
            if (vm.filter.deleted) {
                pars.deleted = 1;
            }
            OperatorAvailabilityService.all(pars).then(
                    function( data ){
                        //vm.avaibilityLoaded[key] = results;
                        //calcolo il numero ore mese e weeks
                      //if (vm.view.type == 'month') {
                        var ids = [];
                        var month = vm.view.intervalStart.format("MM");
                        //$log.info(vm.view.intervalStart);
                        angular.forEach(data, function (obj) {
                            //$log.info(obj);
                            if (obj.reserved == 6 && vm.user.type!='admin') {
                                obj.reserved = 0;
                            }
                            obj.role = null;
                            var u = $filter('filter')(vm.usersList, {user_id: obj.user_id, store_id: obj.store_id?obj.store_id:null}, true);
                            //$log.info(u);
                            if (u!=null && u.length>=1) {
                                var sel = u[0];
                                if (u.length>1) {
                                    for(var i=0; i<u.length; i++) {
                                        if (u.active) {
                                            sel = u[i];
                                            break;
                                        }
                                    }
                                }
                                obj.role = {data: sel};
                                obj.user = {data: sel.user};
                            }
                            //$log.info(obj);
                            if (obj.role == null) {
                                $log.info("Ruolo non trovato in questo centro per: " + obj.user_id);
                            }
                          if (ids['id_'+obj.user_id] == null) {
                            ids['id_'+obj.user_id] = {
                                total: {hcount: 0}
                            };
                          }
                          var d = moment(obj.start);
                          var to = moment(obj.end);
                          var hc = to.diff(d, 'minutes');
                          var week = d.week();
                          if (ids['id_'+obj.user_id]['w'+week] == null) {
                              ids['id_'+obj.user_id]['w'+week] = 0;
                          }
                          ids['id_'+obj.user_id]['w'+week]+=hc;
                          obj.hwcount = $filter('number')(ids['id_'+obj.user_id]['w'+week]/60,1);
                          if (d.format("MM")==month) {
                            ids['id_'+obj.user_id].total.hcount+=hc;
                            obj.hcount = $filter('number')(ids['id_'+obj.user_id].total.hcount/60,1);
                          }
                        });
                      //}
                      var results = data.map( function( obj ){
                          obj.leave_type_id=0;
                          obj.type="availability";
                          obj.className = 'md-button md-raised '
                            + ( obj.user_id === vm.userId ? 'md-accent' : 'md-primary' )
                            + ( obj.reserved ? ' av-reserved' : '' );
                          return obj;
                      });

                      vm.availabilitiesList = results;
                      //$log.info(vm.availabilitiesList);
                      /**
                       * Carico leaves
                       */
                      CrudService.all("leaves", {
                              with: 'leave_type',
                            date_from: start,
                            date_to: end,
                            store_id: vm.storeId?vm.storeId:null
                        }, vm,
                        function(response){
                            var format = "DD/MM/YYYY";
                            angular.forEach(response.data.data, function(el) {
                                var uSid = $filter('filter')(vm.usersList, {user_id: el.user_id, store_id: (vm.storeId?vm.storeId:null)}, true);
                                var uAct = $filter('filter')(vm.usersList, {user_id: el.user_id, active: true}, true);
                                var uActStore = [];
                                angular.forEach(uAct, function (u) {
                                    if (u.store_id) {
                                        uActStore.push(u);
                                    }
                                });
                                var uNAct = $filter('filter')(vm.usersList, {user_id: el.user_id, active: false}, true);
                                var uNActStore = [];
                                angular.forEach(uNAct, function (u) {
                                    if (u.store_id) {
                                        uNActStore.push(u);
                                    }
                                });

                                if (uSid!=null && uSid.length>=1) {
                                    var sel = uSid[0];
                                    for(var i=0; i<uSid.length; i++) {
                                        if (uSid[i].active == true) {
                                            sel = uSid[i];
                                            break;
                                        }
                                    }
                                    if (!sel.active && uActStore.length>0) {//se attivo su altro store non faccio vedere nulla
                                        sel = null;
                                        //$log.info("non visualizzo (sid="+vm.storeId+"): ");
                                        //$log.info(el);
                                    } else if (!sel.active && uNActStore.length>0
                                            && vm.storeId!=uNActStore[0].store_id) {//faccio vedere leave solo nel primo store non attivo
                                        sel = null;
                                    }
                                    if (sel) {
                                        el.type="leave";
                                        el.role = {data: sel};
                                        el.user = {data: sel.user};
                                        el.store_id = vm.storeId;
                                        if (!el.leave_type.hourly) {
                                            el.start = moment(el.date_from, format).toDate();
                                            el.date = moment(el.date_from, format).toDate();
                                            el.end = moment(el.date_to, format).add(1, 'days').toDate();
                                            el.allDay = true;
                                        } else {
                                            el.allDay = false;
                                            el.date = moment(el.date_from, format).toDate();
                                            el.start = moment(el.date_from + ' ' + el.time_from, format + ' HH:mm:ss').toDate();
                                            el.end = moment(el.date_to + ' ' + el.time_to, format + ' HH:mm:ss').toDate();
                                        }
                                        el.date_from = moment(el.date_from, format).toDate(); //da db arriva formattato it
                                        el.date_to = moment(el.date_to, format).toDate();     //da db arriva formattato it
                                        el.className = 'md-button md-raised av-leave '
                                            + ( el.user_id === vm.userId ? 'md-accent' : 'md-primary md-hue-1' );
                                        //el.date = moment(el.date_from, "MM/DD/YYYY").format('YYYY-MM-DD');
                                        //$log.info("visualizzo (sid="+vm.storeId+"): ");
                                        //$log.info(el);
                                        vm.availabilitiesList.push(el);
                                    }
                                }
                            });
                            vm.reRenderEvents();
                                vm.loading = false;
                        },
                        function(res){
                        });
                    },
                    function (response) {
                        var errMsg = "";
                        if (response.data!=null && response.data.message!=null) {
                            errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                            var url = response.config!=null && response.config.url!=null?response.config.url:"";
                            if (url!=null) {
                                errMsg+= "\nUrl: " + url;
                            }
                        }
                        $log.error(errMsg);
                        alert ("Si è verificato un errore nel caricamento disponibilità: " + errMsg);
                        vm.loading = false;
                    }
            );
        };
        vm.backupEvent = {};
        vm.openSidebar = function() {
            vm.backupEvent = {};
            angular.copy(vm.activeEvent,vm.backupEvent);
            vm.activeEvent.copyDate = null;
            return $mdSidenav('right').open();
        };
        vm.closeSidebar = function(ok) {
            if (!ok) {
                angular.copy(vm.backupEvent, vm.activeEvent);
                //$log.info("closeSidebar");
                //$log.info(vm.backupEvent);
            }
            vm.backupEvent = {};
            vm.activeEvent = {};
            vm.saving = false;
            return $mdSidenav('right').close();
        };
        //---------- Calendar Height -------------------------------------//
        // calcolo l'altezza del calendario e quella del dettaglio trattamenti in base a quella della pagina
        vm.calendarHeight = function(){
            vm.headerHeight = angular.element('.header').outerHeight(true);
            vm.calHeight = $window.innerHeight - vm.headerHeight - 95;
        };
        vm.calendarHeight();
        angular.element(window).resize(function(){
            vm.calendarHeight();
            if( uiCalendarConfig.calendars.myCalendar ) {
                uiCalendarConfig.calendars.myCalendar.fullCalendar('option', 'height', vm.calHeight);
            };
        });
        //---------- Add Event -------------------------------------//
        vm.reRenderEvents = function(){
            var calendar = angular.element('#availabilitiesCalendar');
            if( calendar ) {
                return $timeout( function () {
                    // altrimenti il calendario non si aggiorna in tempo
                    calendar.fullCalendar( 'removeEvents' );
                    var filt = [];
                    var pars = {};
                    if (vm.filter.operatorId != undefined) {
                        pars.user_id = vm.filter.operatorId;
                    }
                    if (!vm.filter.leaveType) {
                      if (vm.filter.leaveType===0) {
                          pars.type="availability";
                      }
                      if (vm.filter.reserved) {
                          pars.reserved = 1;
                      }
                      if (vm.filter.reserved_store) {
                          pars.reserved = 2;
                      }
                      if (vm.filter.overtime) {
                          pars.overtime = 1;
                          if (vm.filter.f_recup) {
                              pars.f_recup = 1;
                          } else {
                              pars.f_recup = 0;
                          }
                      }
                      filt =  $filter('filter')(vm.availabilitiesList, pars, true) ;
                    } else if (vm.filter.leaveType) {
                        if (vm.filter.leaveType==1000) {
                            pars.type = "leave";
                            if (vm.filter.daApprovare) {
                                pars.leave_status_id = 1;
                                //$log.info(vm.availabilitiesList);
                            }
                        } else {
                            pars.leave_type_id = vm.filter.leaveType;
                        }
                        filt = $filter('filter')(vm.availabilitiesList, pars, true) ;
                    } else {
                        filt = $filter('filter')(vm.availabilitiesList, pars, true);
                    }
                    calendar.fullCalendar( 'addEventSource', filt );
                    calendar.fullCalendar( 'rerenderEvents' );
                    if (vm.scrollTo) {
                        /*calendar.fullCalendar(
                           {
                               scrollTime: vm.scrollTo.date.getTime(),
                           });
                        */
                        //$log.info(vm.scrollTo.date);
                        var d = vm.scrollTo.date;
                        //alert(d);
                        var row = $("[data-date='"+d+"']").closest(".fc-row");
                        if (row!=null) {
                            var top = row.position().top;
                            //alert(top);
                            $('.fc-scroller').animate({scrollTop: top}, 10);
                            //calendar.fullCalendar( 'gotoDate', vm.scrollTo.date );
                        }
                        vm.scrollTo = null;
                    }
                }, 400 );
            };
        };
        vm.hourBeginEnd = function(begin, end) {
            vm.activeEvent.start = moment(vm.activeEvent.start).set(begin).toDate();
            vm.activeEvent.end = moment(vm.activeEvent.end).set(end).toDate();
        };
        vm.computeRepeats = function() {
            vm.activeEvent.repetitions = [
                vm.activeEvent.repeat_tutti || vm.activeEvent.repeat_dispari || vm.activeEvent.repeat_begin_w || vm.activeEvent.repeat_lun_ven_nomar,
                vm.activeEvent.repeat_tutti || vm.activeEvent.repeat_pari     || vm.activeEvent.repeat_begin_w || vm.activeEvent.repeat_mar_sab,
                vm.activeEvent.repeat_tutti || vm.activeEvent.repeat_dispari || vm.activeEvent.repeat_begin_w || vm.activeEvent.repeat_lun_ven_nomar,
                vm.activeEvent.repeat_tutti || vm.activeEvent.repeat_pari     || vm.activeEvent.repeat_end_w   || vm.activeEvent.repeat_lun_ven_nomar,
                vm.activeEvent.repeat_tutti || vm.activeEvent.repeat_dispari || vm.activeEvent.repeat_end_w   || vm.activeEvent.repeat_lun_ven_nomar,
                vm.activeEvent.repeat_tutti || vm.activeEvent.repeat_pari     || vm.activeEvent.repeat_end_w   || vm.activeEvent.repeat_mar_sab,
                vm.activeEvent.repetitions[6] /*,
                vm.activeEvent.repeat_tutti || vm.activeEvent.repeat_dispari,
                vm.activeEvent.repeat_tutti || vm.activeEvent.repeat_pari,
                vm.activeEvent.repeat_tutti || vm.activeEvent.repeat_dispari,
                vm.activeEvent.repeat_tutti || vm.activeEvent.repeat_pari,
                vm.activeEvent.repeat_tutti || vm.activeEvent.repeat_dispari,
                vm.activeEvent.repeat_tutti || vm.activeEvent.repeat_pari,
                vm.activeEvent.repetitions[13]*/
            ];
        };
        vm.activeEvent = {};
        vm.clickedDate = null;
        vm.isFirstDayOfWeek = false;
        vm.onDayClick = function( date ){
            if (!vm.storeId) {
                if (vm.user.type!='admin' || !vm.env.isMaster) {
                    return;
                }
            }
            var mD = moment(date);
            //$log.info(vm.today.diff(mD, 'days'));
            if (vm.today.diff(mD, 'days')>vm.daysMod || !vm.perm.canCreate('availability')) {
                return;
            }
            vm.isFirstDayOfWeek = mD.weekday() == 0;
            vm.activeEvent = {};
            vm.activeAppointments = [];
            vm.hoursOK = true;
            vm.isNewEvent = true;
            vm.selectMeOrZero();
            vm.momentSelected = mD;
            vm.dateSelected = mD.format('dddd D MMMM');
            vm.activeEvent.type = 'availability';
            vm.activeEvent.start = moment(mD.format()).set({'hour': 8, 'minute': 30, 'second': 0});
            vm.activeEvent.end = moment(mD.format()).set({'hour': 14, 'minute': 30, 'second': 0});
            vm.activeEvent.user_id = vm.selectedUser.user_id;
            vm.activeEvent.reserved = 0;
            vm.activeEvent.meet_type='live';
            vm.activeEvent.c_sid = vm.user.store_id;
            vm.activeEvent.c_role = vm.user.type;
            vm.activeEvent.repeat = false;
            vm.activeEvent.repetitions = [false,false,false,false,false,false,false];
            vm.clickedDate = vm.activeEvent.start.format("YYYY-MM-DD");
            vm.openSidebar();
        };
        vm.addLeave = function( ){
            vm.activeEvent = {};
            vm.activeAppointments = [];
            vm.activeEventDisabled = false;
            vm.hoursOK = true;
            vm.isNewEvent = true;
            vm.selectMeOrZero();
            var mD = moment();
            vm.isFirstDayOfWeek = mD.weekday() == 0;
            vm.dateSelected = moment().format('dddd D MMMM');
            vm.activeEvent.start = moment(moment().format()).set({'hour': 9, 'minute': 0, 'second': 0});
            vm.activeEvent.end = moment(moment().format()).set({'hour': 20, 'minute': 0, 'second': 0});
            vm.activeEvent.type = "leave";
            vm.activeEvent.leave_type_id = 1;
            vm.activeEvent.date_from = vm.activeEvent.start.toDate();
            vm.activeEvent.date_to = vm.activeEvent.end.toDate();
            vm.activeEvent.leave_status_id = 1;
            vm.activeEvent.c_sid = vm.user.store_id;
            vm.activeEvent.c_role = vm.user.type;
            vm.activeEvent.repeat = false;
            vm.activeEvent.repetitions = [false,false,false,false,false,false,false];
            if (vm.user.type == 'callcenter') {
                vm.selectUser(vm.user.id);
                //vm.selectedUserChange();
            }
            vm.openSidebar();
        };
        vm.eliminateOrChange = function(replace){
            if (!vm.storeId) {
                return;
            }
            var mD = moment();
            vm.availabilitiesXChange = [];
            vm.availabilitiesXChange2 = [];
            vm.activeEvent = {};
            vm.activeAppointments = [];
            vm.hoursOK = true;
            vm.isNewEvent = true;
            vm.selectedUser = null;
            vm.selectedUserChange = null;
            vm.dateSelected = mD.format('dddd D MMMM');
            vm.activeEvent.type = 'change';
            vm.activeEvent.replace = replace;
            vm.activeEvent.start = moment(mD.format()).set({'hour': 8, 'minute': 30, 'second': 0});
            vm.activeEvent.end = moment(mD.format()).set({'hour': 14, 'minute': 30, 'second': 0});
            vm.activeEvent.date_from = vm.activeEvent.start.toDate();
            vm.activeEvent.date_to = vm.activeEvent.end.toDate();
            vm.activeEvent.user_id = null;
            vm.activeEvent.c_sid = vm.user.store_id;
            vm.activeEvent.c_role = vm.user.type;
            vm.openSidebar();
        };

        vm.selectMeOrZero = function() {
            if (vm.usersList.length>0) {
                vm.selectedUser = vm.usersList[0];
                vm.leaveTypeXTablet();
            } else {
                vm.selectedUser = {};
            }
            angular.forEach(vm.usersList, function(u) {
                if (u.user_id == vm.user.id && u.active && u.store_id == vm.storeId) {
                    vm.selectedUser = u;
                }
            });
        }
        vm.selectUser = function(user_id) {
            angular.forEach(vm.usersList, function(u) {
                if (u.user_id == user_id) {
                    vm.selectedUser = u;
                    vm.leaveTypeXTablet();
                    if(u.active) {
                        return;
                    }
                }
            });
        }
        vm.addEvent = function() {
            $log.info('----- SALVO -----');
            if (vm.saving) {return;}
            vm.saving = true;
            vm.scrollTo = {date: moment( vm.activeEvent.start ).format('YYYY-MM-DD')};
               if (vm.activeEvent.type=='leave') {
                var leave = {
                        leave_type_id: vm.activeEvent.leave_type_id,
                        leave_type: $filter('filter')(vm.leaveTypeList, {id: vm.activeEvent.leave_type_id}, true)[0],
                        date_from: moment(vm.activeEvent.date_from).format('DD/MM/YYYY'),
                        date_to: moment(vm.activeEvent.date_to).format('DD/MM/YYYY'),
                        time_from: moment(vm.activeEvent.start).format('HH:mm:ss'),
                        time_to: moment(vm.activeEvent.end).format('HH:mm:ss'),
                        user_id: vm.selectedUser.user_id,
                        leave_status_id: vm.activeEvent.leave_status_id,
                        reason: vm.activeEvent.reason,
                        c_role: vm.activeEvent.c_role,
                        c_sid: vm.activeEvent.c_sid,
                        repeat: vm.activeEvent.repeat,
                        repetitions: vm.activeEvent.repetitions
                };
                if (leave.leave_type.hourly) {
                    vm.activeEvent.allDay = false;
                    leave.date_to = leave.date_from;
                    if( leave.time_from>leave.time_to ) {
                        vm.saving = false;
                        var dialog = $mdDialog.alert()
                        .title( 'Attenzione' )
                        .ariaLabel( 'Attenzione' )
                        .textContent( "L'orario di inizio è maggiore dell'orario di fine!" )
                        .ok( 'Ho capito' );
                        return $mdDialog
                            .show( dialog )
                            .finally(
                                function() {
                                    vm.saving = false;
                                    dialog = undefined;
                                }
                        );
                    }
                    var dates = [];
                    if (vm.activeEvent.repeat) {
                        for(var i=0; i<vm.activeEvent.repetitions.length ; i++) {
                            if (vm.activeEvent.repetitions[i]) {
                                dates.push(moment(vm.activeEvent.date_from).add(i,'days').format('YYYY-MM-DD'));
                            }
                        }
                    } else {
                        dates.push(moment(vm.activeEvent.date_from).format('YYYY-MM-DD'));
                    }
                    leave.dates = dates;
                } else {
                    vm.activeEvent.allDay = true;
                    leave.time_to = null;
                    leave.time_from = null;
                }
                CrudService.save('leaves', leave, vm,
                        function( response ){
                            var datas = response.data.data;
                            if (!angular.isArray(datas)) {
                                datas = [datas];
                            }
                            angular.forEach(datas, function(data) {
                                if (!data.leave_type) {
                                    data.leave_type = $filter('filter')(vm.leaveTypeList, {id: data.leave_type_id}, true)[0];
                                }
                                data.className = 'md-button md-raised ';
                                data.allDay = !data.leave_type.hourly;
                                data.type ='leave';
                                data.start = moment(data.date_from + " " + (data.time_from!=null?data.time_from.substring(0,5):'00:00'), 'DD/MM/YYYY HH:mm').toDate();
                                if (!data.leave_type.hourly) {
                                    data.end = moment(data.date_to + " " + (data.time_to!=null?data.time_to.substring(0,5):'23:59'), 'DD/MM/YYYY HH:mm').add(1,'days').toDate();
                                } else {
                                    data.end = moment(data.date_from + " " + (data.time_to!=null?data.time_to.substring(0,5):'23:59'), 'DD/MM/YYYY HH:mm').toDate();
                                }
                                data.date_from = moment(data.date_from, 'DD/MM/YYYY').toDate();
                                data.date_to = moment(data.date_to, 'DD/MM/YYYY').toDate();
                                if( data.user_id === vm.userId ) {
                                    data.className += 'md-accent';
                                } else {
                                    data.className += 'md-primary';
                                }
                                angular.forEach(vm.usersList, function (u) {
                                if (data.user_id == u.user_id && (vm.storeId == u.store_id || vm.env.isMaster)) {
                                    data.user = {'data': u.user};
                                    data.role = {'data':u};
                                    data.store_id = u.store_id;
                                }
                                });
                                //$log.info(data);
                                vm.availabilitiesList.push( data );
                            });
                            vm.saving = false;
                            vm.reRenderEvents();
                            return vm.closeSidebar(true);
                },
                function() {
                    vm.saving = false;
                }
                 );
            } else {
                vm.addThisEvent = {
                    start:  vm.activeEvent.start,
                    end: vm.activeEvent.end,
                    date: moment(vm.activeEvent.start).format('YYYY-MM-DD'),
                    store_id: vm.storeId,
                    user_id: vm.selectedUser.user_id,
                    reserved: vm.activeEvent.reserved,
                    repeat: vm.activeEvent.repeat,
                    copyPrevWeek: vm.activeEvent.copyPrevWeek,
                    copyWeekNum: vm.activeEvent.copyWeekNum,
                    copyAll: vm.activeEvent.copyAll,
                    copyOver: vm.activeEvent.copyOver,
                    copyDate: vm.activeEvent.copyDate?moment(vm.activeEvent.copyDate).format('YYYY-MM-DD'):null,
                    repetitions: vm.activeEvent.repetitions,
                    overtime: vm.activeEvent.overtime,
                    f_recup: vm.activeEvent.f_recup,
                    meet_type: vm.activeEvent.meet_type,
                    meet_url: vm.activeEvent.meet_url,
                    meet_limit: vm.activeEvent.meet_limit,
                    note: vm.activeEvent.note,
                    c_role: vm.activeEvent.c_role,
                    c_sid: vm.activeEvent.c_sid
                };
                //$log.info(vm.activeEvent);
                var dates = [];
                if (vm.activeEvent.repeat) {
                    for(var i=0; i<vm.activeEvent.repetitions.length ; i++) {
                        if (vm.activeEvent.repetitions[i]) {
                            dates.push(moment(vm.activeEvent.start).add(i,'days').format('YYYY-MM-DD'));
                        }
                    }
                } else if (vm.activeEvent.copyPrevWeek) {
                        //andrebbero calcolate tutte le date interessate
                } else {
                    dates.push(vm.addThisEvent.date);
                }
                vm.addThisEvent.dates = dates;
                vm.activeEvent.date = vm.addThisEvent.date;
                vm.activeEvent.dates = vm.addThisEvent.dates;
                vm.activeEvent.store_id = vm.addThisEvent.store_id;
                vm.activeEvent.user_id = vm.addThisEvent.user_id;
                //$log.info(vm.activeEvent);
                var check_in = moment( vm.addThisEvent.start )
                    , check_out = moment( vm.addThisEvent.end )
                ;
                if( check_out.isAfter( check_in ) ) {
                    vm.hoursOK = true;
                    /**
                     * se ho più inserimenti contemporanei faccio in parallelo poi aspetto che tutti siano terminati e aggiorno il calendario
                     */
                    OperatorAvailabilityService.post( vm.addThisEvent ).then(
                        vm.availabilitySave,
                      function (error) {
                        alert(error.data.message);
                        vm.saving = false;
                        vm.closeSidebar(false);
                      });

                } else {
                    vm.hoursOK = false;
                    var dialog = $mdDialog.alert()
                        .title( 'Attenzione' )
                        .ariaLabel( 'Attenzione' )
                        .textContent( "L'orario di fine è maggiore dell'orario di inizio!" )
                        .ok( 'Ho capito' )
                    ;
                    return $mdDialog
                        .show( dialog )
                        .finally(
                            function() {
                                dialog = undefined;
                            }
                    );
                }
            }
        };
        vm.overrideAvailabilities = function(e, data) {
            if (e.copyPrevWeek) {
                vm.avaibilityLoad();
                return;
            }
            var availabTmp = [];
            angular.forEach(vm.availabilitiesList, function(s) {
                if (s.store_id != e.store_id || e.dates.indexOf(s.date)<0 || s.user_id != e.user_id) {
                    availabTmp.push(s);
                }
            });
            angular.forEach(data, function(el) {
                availabTmp.push(el);
            });
            vm.availabilitiesList = availabTmp;
        };

        // Appuntamenti Uncovered - Orfani
        vm.showPopupAppointments = function( appointments ) {
            var useFullScreen = $mdMedia( 'xs' )
                , dialog
            ;
            var ok=false;
            if( appointments && appointments.data && appointments.data.data.length ) {
                appointments = appointments.data.data;
                dialog = $mdDialog.confirm({
                    title: 'Attenzione',
                    ariaLabel: 'Attenzione',
                    templateUrl: 'app/appointments/dialogs/appointments-dialog-nextday.html',
                    fullscreen: useFullScreen,
                    escapeToClose: false,
                    controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                        $scope.title = 'Appuntamenti rimasti Scoperti';
                        $scope.button_ok = 'Ho preso nota';
                        $scope.button_cancel = 'Ignora';
                        $scope.uncovered = true;
                        $scope.appointmentsList = [];
                        angular.forEach( appointments, function( elem ) {
                            delete elem.updated_at;
                            delete elem.created_at;
                            elem.date_start = $filter('date')( new Date( moment( elem.date_start ) ), 'yyyy-MM-ddTHH:mm' );
                            elem.date_end = $filter('date')( new Date( moment( elem.date_end ) ), 'yyyy-MM-ddTHH:mm' );
                            $scope.appointmentsList.push( elem );
                        });
                        $scope.close = function() {
                            $mdDialog.cancel( false );
                        };
                        $scope.open = function() {
                            $mdDialog.hide( true );
                        };
                    }],
                });
                return $mdDialog
                    .show( dialog )
                    .finally(
                        function() {
                            dialog = undefined;
                            useFullScreen = undefined;
                            appointments = undefined;
                        }
                    )
                ;
            } else {
                /*ok=true;
                dialog = $mdDialog.alert()
                    .title( 'Ottimo!' )
                    .ariaLabel( 'Ottimo!' )
                    .textContent( 'Questa modifica non ha generato alcun appuntamento Scoperto.' )
                    .fullscreen( useFullScreen )
                    .ok( 'Va bene' )
                ;*/
            }
        };

        vm.checkUncovered = function() {
            //$log.info(vm.activeEvent);
            var options = {
                search :
                    'uncovered:1' +
                    ';store_id:' + vm.storeId +
                    ';date_start:' + vm.activeEvent.date + " 00:00:00.000" +
                    ';date_end:' + vm.activeEvent.date +" 23:59:59.999"
                ,
                searchFields: 'store_id:=;uncovered:=;date_start:>=;date_end:<=',
                with: 'treatment;customer;user',
                orderBy: 'date_start',
                size: 1000
            };
            return AppointmentsService
                .all( options )
                .then( vm.showPopupAppointments )
                .finally(
                    function() {
                        options = undefined;
                    }
                )
            ;
        };

        vm.loadActivityLogs = function() {
            vm.activityLogs = [];
            if (vm.user.type!='admin') return;
            vm.activityLoading = true;
            var pars = {
                'log_name': 'default',
                'subject_type':'App\\Entities\\OperatorAvailability',
                'subject_id': vm.activeEvent.id,
                with: 'causer;subject'
           };
           CrudService.all('activity_log', pars, vm,
             function (response) {
               angular.forEach(response.data.data, function(act) {
                   act.created_at_frmt = moment(act.created_at).format('D/M/YYYY HH:mm:ss');
                   vm.activityLogs.push(act);
               });
               vm.activityLoading = false;
             },
             function (response) {
               var errMsg = "";
               if (response.data!=null
                       && response.data.message!=null) {
                 errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                 var url = response.config!=null && response.config.url!=null?response.config.url:"";
                 if (url!=null) {
                   errMsg+= "\nUrl: " + url;
                 }
               }
               alert ("Si è verificato un errore nel caricamento delle attività: " + errMsg);
               vm.activityLoading = false;
            });
        };

        vm.loadEventAppointments = function() {
            vm.activeAppointments = [];
            if (!vm.storeId) return;
            if (!vm.activeEvent || !vm.activeEvent.start || !vm.activeEvent.end) {
                return;
            }
            var options = {
                search :
                    'store_id:' + vm.storeId +
                    ';date_start:' + vm.activeEvent.start.format('YYYY-MM-DD HH') + // i : non sono consentiti
                    ';date_end:' + vm.activeEvent.end.add(1,'hours').format('YYYY-MM-DD HH') + // i : non sono consentiti metto sempre un'ora in più
                    ';user_id:' + vm.activeEvent.user_id +
                    ';recalled:3'
                ,
                searchFields: 'store_id:=;user_id:=;recalled:<;date_start:>=;date_end:<=', //;date_end:<=;
                with: 'treatment;customer;user',
                orderBy: 'date_start',
                s: 1000
            };
            vm.appointmentsLoading = true;
            AppointmentsService
                .all( options )
                .then( function(appointments) {
                    if( appointments && appointments.data && appointments.data.data && appointments.data.data.length ) {
                        angular.forEach(appointments.data.data, function(a) {
                            var sf = "HH:mm";
                            if (vm.activeEvent.type == 'leave') {
                                sf = "DD/MM/YYYY "+sf;
                            }
                            a.date_start_frmt = moment(a.date_start).format(sf);
                            a.date_end_frmt = moment(a.date_end).format("HH:mm");
                            vm.activeAppointments.push(a);
                        });
                    }
                    vm.appointmentsLoading = false;
                })
            ;
        };

        vm.availabilitySave = function (dataArr) {
            angular.forEach(dataArr, function(data) {
                data.className = 'md-button md-raised ';
                  if( data.user_id === vm.userId ) {
                      data.className += 'md-accent';
                  } else {
                      data.className += 'md-primary';
                  }
                  if( data.reserved ) {
                    data.className += ' av-reserved';
                  }
                  angular.forEach(vm.usersList, function (u) {
                    if (data.user_id == u.user_id && data.store_id == u.store_id) {
                      data.user = {'data': u.user};
                      data.role = {'data':u};
                    }
                  });
                  data.start = moment(data.date_start);
                  data.end = moment(data.date_end);
            });
          //TODO occorre sostituire i precedenti
            //$log.info(vm.activeEvent);
            //$log.info(dataArr);
            vm.overrideAvailabilities(vm.activeEvent, dataArr);
          //vm.availabilitiesList.push( data );
          vm.reRenderEvents();
          vm.saving = false;
          return vm.closeSidebar(true);
        };

        //---------- Update Event -------------------------------------//
        vm.hoursOK = true;
        vm.activeEventDisabled = false;
        vm.eventClick = function( event ) {
            vm.isNewEvent = false;
            vm.hoursOK = true;
            vm.selectUser(event.user_id);
            vm.dateSelected = moment( event.start ).format( 'dddd D MMMM' );
            vm.activeEvent = event;
            //$log.info(event);
            //$log.info(vm.activeEvent.start);
            //$log.info(vm.activeEvent.end);
            //$log.info(vm.activeEvent.start.format("HH:mm"));
            //$log.info(vm.activeEvent.end.format("HH:mm"));
            vm.activeEventDisabled = vm.activeEvent.deleted_at
                            || vm.today.diff(vm.activeEvent.start, 'days')>vm.daysMod
                            || !vm.perm.canUpdate(vm.activeEvent.type);
            event.c_role = vm.user.type;
            event.c_sid = vm.user.store_id;
            vm.clickedDate = vm.activeEvent.start.format("YYYY-MM-DD");
            vm.loadEventAppointments();
            vm.loadActivityLogs();
            return vm.openSidebar();
        };
        vm.updateEvent = function(approve) {
            $log.info( '----- AGGIORNO -----') ;
            if (vm.saving) {return;}
            vm.saving = true;
            //$log.info( vm.activeEvent );
            vm.thisEvent = _.find( vm.availabilitiesList, [ 'id', vm.activeEvent.id ] );
            vm.thisEvent.user_id = vm.selectedUser.user_id;
            if (vm.activeEvent.type!='leave') {
                vm.thisEvent.start = vm.activeEvent.start;
                vm.thisEvent.end = vm.activeEvent.end;
                vm.thisEvent.reserved = vm.activeEvent.reserved;
                vm.thisEvent.overtime = vm.activeEvent.overtime;
                vm.thisEvent.f_recup = vm.activeEvent.f_recup;
                vm.thisEvent.meet_type = vm.activeEvent.meet_type;
                vm.thisEvent.meet_url = vm.activeEvent.meet_url;
                vm.thisEvent.meet_limit = vm.activeEvent.meet_limit;
                vm.thisEvent.note = vm.activeEvent.note;
                vm.thisEvent.c_sid = vm.user.store_id;
                vm.thisEvent.c_role = vm.user.type;
                vm.thisEvent.date = moment(vm.activeEvent.start).format('YYYY-MM-DD');
                vm.thisEvent.dates = [vm.thisEvent.date];
                var mS = moment(vm.activeEvent.start);
                var mE = moment(vm.activeEvent.end);
                vm.thisEvent.date_start = mS.format('YYYY-MM-DD HH:mm:ss');
                vm.scrollTo = {date: mS.format('YYYY-MM-DD')};
                vm.thisEvent.date_end = mE.format('YYYY-MM-DD HH:mm:ss');
                vm.thisEvent.minute_start = parseInt(mS.format('HH'))*60+parseInt(mS.format('mm'));
                vm.thisEvent.minute_end = parseInt(mE.format('HH'))*60+parseInt(mE.format('mm'));
                var check_in = moment( vm.thisEvent.start )
                    , check_out = moment( vm.thisEvent.end )
                ;
                vm.activeEvent.date = vm.thisEvent.date;
                vm.activeEvent.dates = vm.thisEvent.dates;
                if( check_out.isAfter( check_in ) ) {
                    vm.hoursOK = true;
                    if (vm.thisEvent.put) {
                        vm.thisEvent.put().then(
                            vm.availabilitySave
                            , function( error ) {
                                alert( error.data.message );
                                vm.saving = false;
                                return vm.closeSidebar(false);
                            }
                        ).then( vm.checkUncovered );
                    } else {
                        CrudService.update("operator-availability", vm.thisEvent, vm,
                            function (response) {
                                if (response.data && response.data.data) {
                                    vm.availabilitySave(response.data.data);
                                }
                                vm.saving = false;
                            },
                            function( error ) {
                                //alert( error.data.message );
                                vm.saving = false;
                                return vm.closeSidebar(false);
                        }).then( vm.checkUncovered );
                    }
                } else {
                    vm.hoursOK = false;
                    var dialog = $mdDialog.alert()
                        .title( 'Attenzione' )
                        .ariaLabel( 'Attenzione' )
                        .textContent( "L'orario di fine è maggiore dell'orario di inizio!" )
                        .ok( 'Ho capito' )
                    ;
                    return $mdDialog
                        .show( dialog )
                        .finally(
                            function() {
                                dialog = undefined;
                            }
                        )
                    ;
                }
            } else {//si tratti di assenza aggiorno leaves solo se in stato "da approvare"
                if (vm.activeEvent.leave_status_id==1) {
                    //$log.info(vm.activeEvent);
                    var o = {
                            id: vm.activeEvent.id,
                            leave_type_id: vm.activeEvent.leave_type_id,
                            leave_type: $filter('filter')(vm.leaveTypeList, {id: vm.activeEvent.leave_type_id}, true)[0],
                            c_role: vm.user.type,
                            c_sid: vm.user.store_id,
                            date_from: moment(vm.activeEvent.date_from).format('DD/MM/YYYY'),
                            reason: vm.activeEvent.reason
                    };
                    if (o.leave_type.hourly) {
                        o.time_from = moment(vm.activeEvent.start).format('HH:mm:ss');
                        o.time_to = moment(vm.activeEvent.end).format('HH:mm:ss');
                        o.date_to = o.date_from;
                        var check_in = moment( vm.activeEvent.start )
                        , check_out = moment( vm.activeEvent.end );
                        if( !check_out.isAfter( check_in ) ) {
                            var dialog = $mdDialog.alert()
                            .title( 'Attenzione' )
                            .ariaLabel( 'Attenzione' )
                            .textContent( "L'orario di fine è maggiore dell'orario di inizio!" )
                            .ok( 'Ho capito' );
                            return $mdDialog
                                .show( dialog )
                                .finally(
                                    function() {
                                        dialog = undefined;
                                    }
                            );
                        }
                    } else {
                        o.date_to = moment(vm.activeEvent.date_to).format('DD/MM/YYYY');
                    }
                    vm.scrollTo = {date: moment( vm.activeEvent.start ).format('YYYY-MM-DD')};
                    var msg = "aggiornare";
                    if (approve!=null) {
                        if (approve) {
                            o.leave_status_id = 2;
                            msg = "approvare";
                        } else {
                            o.leave_status_id = 3;
                            msg = "negare";
                        }
                    }
                    var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler '+msg+' questa assenza?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' );
                    return $mdDialog
                        .show( confirm )
                        .then(
                            function() {
                            CrudService.update("leaves", o, vm,
                            function( response ){
                                $log.info( 'Aggiornato' );
                                var data = response.data.data;
                                //$log.info( data );
                                if (!data.leave_type) {
                                    data.leave_type = $filter('filter')(vm.leaveTypeList, {id: data.leave_type_id}, true)[0];
                                    $log.info('update: !data.leave_type', data);
                                }
                                var position = vm.availabilitiesList.map( function( x ) { return x.id; } ).indexOf( data.id );
                                if( position !== -1 ) {
                                    vm.availabilitiesList[ position ].allDay = !data.leave_type.hourly;
                                    vm.availabilitiesList[ position ].leave_type_id = data.leave_type_id;
                                    vm.availabilitiesList[ position ].leave_status_id = data.leave_status_id;
                                    vm.availabilitiesList[ position ].start = moment(data.date_from + " " + (data.time_from!=null?data.time_from.substring(0,5):'00:00'), 'DD/MM/YYYY HH:mm').toDate();

                                    if (!data.leave_type.hourly) {
                                        vm.availabilitiesList[ position ].end = moment(data.date_to + " " + (data.time_to!=null?data.time_to.substring(0,5):'23:59'), 'DD/MM/YYYY HH:mm').add(1,'days').toDate();
                                    } else {
                                        vm.availabilitiesList[ position ].end = moment(data.date_from + " " + (data.time_to!=null?data.time_to.substring(0,5):'23:59'), 'DD/MM/YYYY HH:mm').toDate();
                                    }
                                    vm.availabilitiesList[ position ].leave_type = data.leave_type;
                                    vm.availabilitiesList[ position ].reason = data.reason;
                                    vm.availabilitiesList[ position ].date_from = moment(data.date_from, 'DD/MM/YYYY').toDate();
                                    vm.availabilitiesList[ position ].date_to = moment(data.date_to, 'DD/MM/YYYY').toDate();
                                    vm.availabilitiesList[ position ].className = 'md-button md-raised ' +
                                        ( data.user_id === vm.userId
                                        ? 'md-accent'
                                        : 'md-primary md-hue-1') +
                                        ( data.reserved
                                            ? ' av-reserved'
                                            : '');

                                    vm.reRenderEvents();
                                    // da sistemare gli utenti.
                                    // $window.location.reload();
                                };
                                vm.saving = false;
                                return vm.closeSidebar(true);
                            },
                            function( error ) {
                                //alert( error.data.message );
                                vm.saving = false;
                                return vm.closeSidebar(false);
                            });
                        })
                        .finally(
                                function() {
                                    confirm = undefined;
                                }
                            )
                        ;
                } else {
                    alert('Assenza non modificabile (modifica consentita solo in stato "Da approvare").');
                    return vm.closeSidebar(false);
                }
            }
        };
        //---------- Remove Event -------------------------------------//
        vm.removeEvent = function() {
            $log.info('----- ELIMINO -----');
            //$log.info(vm.activeEvent);
            var msg = 'Sicuro di voler ';
            if (vm.activeEvent.type == 'change') {
                if (vm.selectedUserChange) {
                    msg+= 'sostituire';
                } else {
                    msg+= 'eliminare';
                }
                msg+= ' le disponibilità del periodo selezionato?';
            } else {
                msg += "eliminare questa "+ (vm.activeEvent.type=='leave'?'assenza?':'disponibilità?');
            }
            var dialog = $mdDialog.confirm()
                .title( 'Attenzione' )
                .ariaLabel( 'Attenzione' )
                .textContent( msg )
                .ok( 'Si' )
                .cancel( 'Ops, ho sbagliato' )
            ;
            return $mdDialog
                .show( dialog )
                .then( function() {
                    vm.scrollTo = {date: moment( vm.activeEvent.start ).format('YYYY-MM-DD')};
                       if (vm.activeEvent.type=='leave') {
                        if (vm.activeEvent.leave_status_id==1) {
                            vm.saving = true;
                            CrudService.del("leaves", vm.activeEvent.id, vm,
                            function(){
                                $log.info( 'Eliminato' );
                                vm.availabilitiesList = _.without( vm.availabilitiesList, _.find( vm.availabilitiesList, [ 'id', vm.activeEvent.id ] ) );
                                   vm.reRenderEvents();
                                   vm.saving = false;
                                return vm.closeSidebar(true);
                            },
                            function( error ) {
                                //alert( error.data.message );
                                vm.saving = false;
                                return vm.closeSidebar(false);
                            });
                        } else {
                            alert('Assenza non eliminabile (eliminazione consentita solo in stato "Da approvare").');
                            return vm.closeSidebar(false);
                        }
                    } else if (vm.activeEvent.type!='change') {
                        if (false && vm.activeEvent.remove) {
                            vm.activeEvent.remove();
                        } else {
                            vm.saving = true;
                            CrudService.del("operator-availability", vm.activeEvent.id, vm,
                                    function(){
                                        $log.info( 'Eliminato' );
                                        vm.availabilitiesList = _.without( vm.availabilitiesList, _.find( vm.availabilitiesList, [ 'id', vm.activeEvent.id ] ) );
                                        vm.reRenderEvents();
                                        vm.checkUncovered();
                                        vm.saving = false;
                                        return vm.closeSidebar(true);
                                    },
                                    function( error ) {
                                        //alert( error.data.message );
                                        vm.saving = false;
                                        return false;
                                        //return vm.closeSidebar(false);
                                    });
                        }
                    } else if (vm.activeEvent.type == 'change') {
                        if (!vm.activeEvent.replace) {
                            vm.saving = true;
                            vm.availabilitiesXChangeIndex = 0;
                            vm.availabilitiesXChangeProcess();
                        } else {
                            //todo inverti delle disponibilità selezionata
                            vm.saving = true;
                            OperatorAvailabilityService
                                .replace(vm.activeEvent, vm.selectedUser.user, vm.selectedUserChange.user, vm.availabilitiesXChange, vm.availabilitiesXChange2)
                                .then(
                                    function(response) {
                                        //$log.info(response);
                                        vm.closeSidebar();
                                        vm.avaibilityLoad();
                                        vm.showActionToast("Fatto");
                                    },
                                    function(response) {
                                        $log.error(response);
                                        vm.showActionToast("Errore: " + response.data.message);
                                        vm.saving = false;
                                        return false;
                                    }
                                );
                        }

                    }
                })
                /*.then( function() {
                    if (vm.activeEvent.type!='leave' && vm.activeEvent.remove) {
                        $log.info( 'Eliminato' );
                        vm.availabilitiesList = _.without( vm.availabilitiesList, _.find( vm.availabilitiesList, [ 'id', vm.activeEvent.id ] ) );
                        vm.reRenderEvents();
                        return vm.closeSidebar(true);
                    }
                }, function( error ) {
                    alert( error.data.message );
                    return vm.closeSidebar(false);
                }  )
                .then( function () {
                    if (vm.activeEvent.type!='leave') { vm.checkUncovered(); }
                })*/
                .finally(
                    function() {
                        dialog = undefined;
                    }
                )
            ;
        };
        vm.availabilitiesXChangeProcess = function() {
            var a = vm.availabilitiesXChange[vm.availabilitiesXChangeIndex];
            CrudService.del("operator-availability", a.id, vm,
                function(){
                    $log.info( 'Eliminato ', a.id);
                    vm.availabilitiesList = _.without( vm.availabilitiesList, _.find( vm.availabilitiesList, [ 'id', a.id ] ) );
                    if (vm.selectedUserChange) {
                        a.user_id = vm.selectedUserChange.user_id;
                        a.role = {data:vm.selectedUserChange};
                        a.user = {data:vm.selectedUserChange.user};
                        OperatorAvailabilityService.post( a ).then(
                                vm.availabilitiesXChangeNext
                        );
                    } else {
                        a.deleted = true;
                        vm.availabilitiesXChangeNext();
                    }
                }
            );
        };
        vm.availabilitiesXChangeNext = function() {
            if ((vm.availabilitiesXChangeIndex+1)<vm.availabilitiesXChange.length) {
                vm.availabilitiesXChangeIndex++;
                vm.availabilitiesXChangeProcess();
            } else {
                //termino
                if (vm.selectedUserChange) {
                    vm.avaibilityLoad();
                } else {//senza cambio ma solo eliminazione
                    vm.reRenderEvents();
                }
                vm.saving = false;
                return vm.closeSidebar(true);
            }
        };

        vm.allMonths = [
            {id:"01", value:0},
            {id:"02", value:1},
            {id:"03", value:2},
            {id:"04", value:3},
            {id:"05", value:4},
            {id:"06", value:5},
            {id:"07", value:6},
            {id:"08", value:7},
            {id:"09", value:8},
            {id:"10", value:9},
            {id:"11", value:10},
            {id:"12", value:11},
        ];

        vm.dropDownMonthYear = function() {

            if($("#availabilitiesCalendar").find(".select-month-wrapper").length>0) {
                $("#availabilitiesCalendar").find(".select-month-wrapper").remove();
            }

            var currentMonth = $("#availabilitiesCalendar").fullCalendar('getDate');
            var months = []
            var dateStart = currentMonth.clone().subtract(11, 'months');
            var dateEnd = currentMonth.clone().add(11, 'months');
            var i;
            var selected;

            var cloneMonth = currentMonth.clone();

            while(cloneMonth.isAfter(dateStart, "day")) {
                months.push( {label: cloneMonth.format("MMMM YYYY"), value: cloneMonth.format("MM YYYY")});
                cloneMonth.subtract(1, 'month');
            }
            cloneMonth = currentMonth.clone();
            cloneMonth.add(1, 'month');
            while(cloneMonth.isBefore(dateEnd, "day")) {
                months.unshift( {label: cloneMonth.format("MMMM YYYY"), value: cloneMonth.format("MM YYYY")});
                cloneMonth.add(1, 'month');
            }

            var htmlSelect = '<div class="select-month-wrapper"><select class="select_month form-control" ng-change="av.monthselected">';
            for(i=0; i<months.length; i++) {
                selected = "";
                if(months[i].value == currentMonth.format("MM YYYY")) {
                    selected = " selected='selected'";
                }
                htmlSelect += "<option value='"+months[i].value+"'"+selected+">"+months[i].label+"</option>";
            }

            htmlSelect += "</select></div>";

            return htmlSelect;

        }

        //---------- Calendar Config -------------------------------------//
        vm.uiConfig = {
            calendar: {
                height: vm.calHeight,
                defaultView: 'month',
                editable: false,
                dayNamesShort: ['Dom\n', 'Lun\n', 'Mar\n', 'Mer\n', 'Gio\n', 'Ven\n', 'Sab\n'],
                firstDay: 1,
                header: {
                    right: 'month agendaWeek agendaDay',
                    left: 'prev,next today title'
                },
                businessHours: {
                    start: '08:00',
                    end: '21:00',
                    dow: [ 1, 2, 3, 4, 5, 6 ]
                },
                minTime: '08:00:00',
                maxTime: '21:00:00',
                timeFormat: 'H:mm',
                axisFormat: 'H',
                allDaySlot: false,
                dayClick: vm.onDayClick,
                eventClick: vm.eventClick,
                viewRender: function(view, element) {
                    $log.info("View Changed:");
                    //$log.info(view);
                    //$log.info(element);
                    vm.view = view;
                    //$log.info("Start: ", view.start.format('YYYY-MM-DD HH:mm'));
                    //$log.info("End: ", view.end.format('YYYY-MM-DD HH:mm'));
                    vm.query.start = view.start;
                    //$log.info(moment(vm.query.start).toDate());
                    vm.query.end = view.end;
                    vm.query.end_s = moment(vm.query.end).add(-1,'days');
                    //$log.info(vm.query.end_s.toDate());

                    if (!vm.loading) {
                        vm.avaibilityLoad();
                    }
                    //$log.info(element.parent().parent().find('.fc-center'));
                    var ck = $("#filtroReserved");
                    $("#filtroReserved").detach();
                    element.parent().parent().find('.fc-center').append(ck);
                    ck = $("#filtroOperatrici");
                    $("#filtroOperatrici").detach();
                    element.parent().parent().find('.fc-center').append(ck);

                    var customSelect = vm.dropDownMonthYear();

                    $(".fc-left").append(customSelect).ready(function() {
                        //console.log("La select è appesa"); console.log(element); console.log(thisObject);
                        $(".select_month").change(function() {
                            var value_selected = $(this).val().split(" ");
                            var newMonth = (parseInt(value_selected[0]))-1;
                            var newYear = parseInt(value_selected[1]);
                            var startDate = value_selected[1]+"-"+value_selected[0]+"-01";

                            $("#availabilitiesCalendar").fullCalendar('gotoDate', startDate);
                        });
                    });
                    if(view.name == "month") {
                        $("#availabilitiesCalendar").find(".fc-left h2").addClass("invisible");
                        $("#availabilitiesCalendar").find(".fc-left .select-month-wrapper").removeClass("invisible");
                    } else {
                        $("#availabilitiesCalendar").find(".fc-left h2").removeClass("invisible");
                        $("#availabilitiesCalendar").find(".fc-left .select-month-wrapper").addClass("invisible");
                    }
                },
                eventRender: function( event, element ) {
                  if (!event.leave_type_id) {//si tratta di operator availability
                      if (event.reserved==1) {
                        element
                            .find('.fc-time')
                            .html("<div layout='row'><md-icon class='material-icons'>input</md-icon> " +
                                moment( event.start ).format('HH:mm') + ' - ' +
                                moment( event.end ).format('HH:mm') + (event.overtime?" *":'') + (event.overtime && event.f_recup?"*":'') + "</div>"
                            );
                      } else if (event.reserved==2) {
                          element
                              .find('.fc-time')
                              .html("<div layout='row'><md-icon class='material-icons'>not_interested</md-icon> " +
                                    moment( event.start ).format('HH:mm') + ' - ' +
                                    moment( event.end ).format('HH:mm') + (event.overtime?" *":'') + (event.overtime && event.f_recup?"*":'') + "</div>"
                              );
                      } else if (event.reserved==3) {
                          element
                          .find('.fc-time')
                          .html("<div layout='row'><md-icon class='material-icons'>work</md-icon> " +
                              moment( event.start ).format('HH:mm') + ' - ' +
                              moment( event.end ).format('HH:mm') + (event.overtime?" *":'') + (event.overtime && event.f_recup?"*":'') +  "</div>"
                          );
                      } else if (event.reserved==4) {
                          element
                          .find('.fc-time')
                          .html("<div layout='row'><md-icon class='material-icons'>brightness_auto</md-icon> " +
                              moment( event.start ).format('HH:mm') + ' - ' +
                              moment( event.end ).format('HH:mm') + (event.overtime?" *":'') + (event.overtime && event.f_recup?"*":'') +  "</div>"
                          );
                      } else if (event.reserved==5) {
                          element
                          .find('.fc-time')
                          .html("<div layout='row'><md-icon class='material-icons'>school</md-icon> " +
                              moment( event.start ).format('HH:mm') + ' - ' +
                              moment( event.end ).format('HH:mm') + (event.overtime?" *":'') + (event.overtime && event.f_recup?"*":'') +  "</div>"
                          );
                      } else if (event.reserved==6 && vm.user.type == 'admin') {
                          element
                          .find('.fc-time')
                          .html("<div layout='row'><md-icon class='material-icons'>build</md-icon> " +
                              moment( event.start ).format('HH:mm') + ' - ' +
                              moment( event.end ).format('HH:mm') + (event.overtime?" *":'') + (event.overtime && event.f_recup?"*":'') +  "</div>"
                          );
                      } else if (event.reserved==8) {
                        element
                        .find('.fc-time')
                        .html("<div layout='row'><md-icon class='material-icons'>groups</md-icon> " +
                            moment( event.start ).format('HH:mm') + ' - ' +
                            moment( event.end ).format('HH:mm') + (event.overtime?" *":'') + (event.overtime && event.f_recup?"*":'') +  "</div>"
                        );
                      } else {
                        element
                        .find('.fc-time')
                        .text(
                            moment( event.start ).format('HH:mm') + ' - ' +
                            moment( event.end ).format('HH:mm') + (event.overtime?" *":'') + (event.overtime && event.f_recup?"*":'')
                        );
                      }
                      if (event.role) {
                          var color = event.role.data.color;
                          /*if (vm.env.isMaster) {
                              color = ''+event.role.id*event.role.id;
                          }*/
                          element.css("background-color", color);
                          /*
                          //andrebbe cambiato in base al colore dello sfondo
                          */
                         if (color && color!='white') {
                          element.css("color", 'white');
                         }

                      }
                      if (event.deleted_at) {
                          element.css("opacity", '0.5');
                      }
                      element.find('.fc-title')
                        .html("<div layout='row' " + (event.role.data.current_designation
                                      /*&& event.start.format('YYYY-MM-DD')>=vm.todayStr*/
                                      && (event.role.data.current_designation.job_title_id==2
                                        || event.role.data.current_designation.job_title_id==4
                                        || event.role.data.current_designation.job_title_id==9
                                        || event.role.data.current_designation.job_title_id==10
                                         )
                                  ? "style='text-decoration: underline;'>"
                                    +"<md-icon class='material-icons'>verified_user</md-icon> "
                                  :"> "
                              )+

                              event.user.data.lastname + ' ' +
                              (event.user.data.firstname!=null && event.user.data.firstname!=""?(event.user.data.firstname.substring(0,1)+". "):"")+

                              (event.hwcount?' ('+event.hwcount+')':'') +
                              (false && event.hcount?' ('+event.hwcount+')':'')

                              +"</div>"
                        );

                    } else {
                        var color = event.role.data.color;
                        /*if (vm.env.isMaster) {
                          color = ""+event.role.data.user_id+"FFFFFF";
                          color = '#'+color.substring(2,6)+color.substring(0,4);
                          $log.info(color);
                        }*/
                        element.css("background-color", color);
                        /*
                          //andrebbe cambiato in base al colore dello sfondo
                          */
                        if (color && color!='white') {
                            element.css("color", 'white');
                        }
                        if (!event.allDay) {
                            element
                            .find('.fc-time')
                            .text(
                                moment( event.start ).format('HH:mm') + ' - ' +
                                moment( event.end ).format('HH:mm')
                            );
                        }

                        element.find('.fc-title')
                            .html("<div layout='row'><md-icon class='material-icons'>"+vm.getIconLeaveStatus(event)+"</md-icon>" +
                                    event.leave_type.name + ": " +
                                    event.user.data.lastname+ " " +
                                    ((event.user.data.firstname!=null && event.user.data.firstname!="")?event.user.data.firstname.substring(0,1)+".":"")+

                                  "</div>"
                              );

                             /*
                              element.find('.fc-title')
                              .html("<div layout='row'><md-icon class='material-icons'>"+vm.getIconLeaveStatus(event)+"</md-icon>" +
                                      event.leave_type.name + ": " + (event.user.data.firstname.substring(0,1))+"." + ' ' +
                                    (event.user.data.lastname!=null && event.user.data.lastname!="")?event.user.data.lastname:""+
                                    "</div>"
                                );
                                */
                  }
                  element.addClass("disponibilita-container");
            }
        }
        };
        vm.changeDateFrom = function () {
            if (vm.activeEvent.type && vm.activeEvent.type == 'leave' || vm.activeEvent.type == 'change') {
                vm.isFirstDayOfWeek = vm.activeEvent.date_from.getDay()==1;
                /**
                 * se la data to minore data from la metto vuota
                 */
                if (vm.activeEvent.date_to.getTime()<vm.activeEvent.date_from.getTime()) {
                    vm.activeEvent.date_to = null;
                }
            }
            if (vm.activeEvent.type && vm.activeEvent.type == 'change') {
                vm.selectedUserChanged();
                vm.selectedUserChangeChanged();
            }
        };
        vm.changeDateTo = function () {
            if (vm.activeEvent.type && vm.activeEvent.type == 'change') {
                vm.selectedUserChanged();
                vm.selectedUserChangeChanged();
            }
        };
        $scope.$watch( 'av.activeEvent.leave_type_id', function ( newValue, oldValue ) {
            //$log.info(newValue);
            //$log.info(oldValue);
            var lt = $filter('filter')(vm.leaveTypeList, {id: newValue}, true)[0];
            vm.activeEvent.leave_type = lt;
            if (oldValue && newValue!=oldValue) {
                //filtro
                var olt = $filter('filter')(vm.leaveTypeList, {id: oldValue}, true)[0];
                if (!olt.hourly && lt.hourly) {
                    vm.activeEvent.start = moment(vm.activeEvent.date_from).set({'hour': 9, 'minute': 0, 'second': 0});
                    vm.activeEvent.end = moment(vm.activeEvent.date_from).set({'hour': 20, 'minute': 0, 'second': 0});
                }
            }
        });
        vm.getIconLeaveStatus = function(leave) {
            if (leave.leave_status_id == 1) {
                return "hourglass_empty";
            } else if (leave.leave_status_id==2) {
                return "check";
            } else if (leave.leave_status_id==3) {
                return "cancel";
            } else {
                return "unknown";
            }
        };
        vm.filter = {
            reserved: false,
            reserved_store: false,
            operatorId: null,
            leaveType: null,
            daApprovare: false,
            tagArea: null
        };
        vm.filterChangeTagArea = function () {
            //$log.info(vm.filter.tagArea);
            if (vm.filter.tagArea) {
                vm.filter.operatorId = null;
                vm.usersListFiltered = $filter('filter')(vm.usersList, {user: {tag_area: vm.filter.tagArea}}, true)
            } else {
                vm.usersListFiltered = vm.usersList;
            }
            //$log.info(vm.usersListFiltered);
            vm.fiterReserved();
        };
        vm.fiterReserved = function () {
            vm.reRenderEvents();
        };

        vm.leaveTypeList = [];
        vm.leaveTypesLoad = function() {
            var params = {orderBy: "name"};
            CrudService.all("leave_types", params, vm,
                    function(response) {
                        //$log.info(response.data);
                        if (vm.env.isMaster && vm.env.company == 'Biolaser') {
                            vm.leaveTypeList = $filter('filter')(response.data.data, {hourly: 0}, true)
                        } else {
                            vm.leaveTypeList = response.data.data;
                        }
                        vm.leaveTypeListXTablet = vm.leaveTypeList;
                    },
                    function(response) {}
            );
        };
        vm.leaveTypesLoad();
        vm.leaveTypeListXTablet = [];
        vm.leaveTypeXTablet = function() {
            //$log.info('leaveTypeXTablet',vm.selectedUser);
            var userRole = vm.selectedUser;
            if (false && userRole.current_designation && userRole.current_designation.f_tablet) { //f tablet è uguale agli altri
                vm.leaveTypeListXTablet = $filter('filter')(vm.leaveTypeList, {code: '!R'}, true);
                //$log.info('leaveTypeXTablet2',vm.leaveTypeListXTablet);
            } else {
                vm.leaveTypeListXTablet = vm.leaveTypeList;
            }
        }
        vm.selectedUserChanged = function() {
            //$log.info("availab list ",vm.availabilitiesList);
            vm.availabilitiesXChange = [];
            vm.availabilitiesXChangeMinutes = 0;
            if (!vm.selectedUser || !vm.selectedUser.user_id) {
                return;
            }
            var filt =  $filter('filter')(vm.availabilitiesList, {user_id: vm.selectedUser.user_id, type:'availability'}, true) ;
            //$log.info("availab di ",vm.selectedUser);
            //$log.info('filtered: ',filt);
            //$log.info('active: ',vm.activeEvent);
            if (vm.selectedUser.role == 'operator') {
                vm.activeEvent.reserved = 0;
            } else if (vm.selectedUser.role == 'storemngr') {
                vm.activeEvent.reserved = 5;
            } else if (vm.selectedUser.role == 'assist') {
                vm.activeEvent.reserved = 4;
            } else if (vm.selectedUser.role == 'admin' || vm.selectedUser.role == 'manager') {
                vm.activeEvent.reserved = 7;
            }
            var from = moment(vm.activeEvent.date_from).format('YYYY-MM-DD');
            var to = moment(vm.activeEvent.date_to).format('YYYY-MM-DD');
            angular.forEach(filt, function(elem) {
                if (elem.date<=to && elem.date>=from) {
                    vm.availabilitiesXChange.push(elem);
                    vm.availabilitiesXChangeMinutes+=(elem.minute_end-elem.minute_start);
                }
            });
            $log.info('elenco: ', vm.availabilitiesXChange);
        };
        vm.selectedUserChangeChanged = function() {
            //$log.info("availab list ",vm.availabilitiesList);
            vm.availabilitiesXChange2 = [];
            vm.availabilitiesXChange2Minutes = 0;
            if (!vm.selectedUserChange || !vm.selectedUserChange.user_id) {
                return;
            }
            var filt =  $filter('filter')(vm.availabilitiesList, {user_id: vm.selectedUserChange.user_id, type:'availability'}, true) ;
            //$log.info("availab di ",vm.selectedUser);
            //$log.info('filtered: ',filt);
            //$log.info('active: ',vm.activeEvent);
            if (vm.selectedUserChange.role == 'operator') {
                vm.activeEvent.reserved = 0;
            } else if (vm.selectedUserChange.role == 'storemngr') {
                vm.activeEvent.reserved = 5;
            } else if (vm.selectedUserChange.role == 'assist') {
                vm.activeEvent.reserved = 4;
            } else if (vm.selectedUserChange.role == 'admin' || vm.selectedUserChange.role == 'manager') {
                vm.activeEvent.reserved = 7;
            }
            var from = moment(vm.activeEvent.date_from).format('YYYY-MM-DD');
            var to = moment(vm.activeEvent.date_to).format('YYYY-MM-DD');
            vm.availabilitiesXChange2 = [];
            angular.forEach(filt, function(elem) {
                if (elem.date<=to && elem.date>=from) {
                    vm.availabilitiesXChange2.push(elem);
                    vm.availabilitiesXChange2Minutes+=(elem.minute_end-elem.minute_start);
                }
            });
            $log.info('elenco2: ', vm.availabilitiesXChange2);
        };
        vm.availabilityHoursMonthPrompt = function (pdf) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.prompt()
                .title('Vuoi scaricare il file o inviarlo per mail?')
                .placeholder('Indirizzo Email')
                .ariaLabel('email')
                .initialValue('')
                .required(true)
                //.targetEvent(ev)
                .ok('Email')
                .cancel('Download')

            $mdDialog.show(confirm).then(function(emailAddress) {
                //EMAIL
                var EMAIL_REGEXP = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;

                if (!emailAddress.match(EMAIL_REGEXP)) {
                    var dialog = $mdDialog.alert()
                        .title( 'Attenzione' )
                        .ariaLabel( 'Attenzione' )
                        .textContent( "Email non valida" )
                        .ok( 'Chiudi' );
                    return $mdDialog
                        .show( dialog );

                }
                else {
                    var url = env.API+"/operator-availability"
                        +"?pdf="+'email'
                        +"&store_id="+(vm.storeId)
                        +"&start="+vm.getStartMonthDay()
                        +"&end="+vm.query.end.format("YYYY-MM-01")
                        +"&token="+vm.token
                        +"&search="+vm.getSearch()
                        +"&searchFields="+vm.getSearchFields()
                        +"&emailAddress="+emailAddress;
                    $http
                        .get(url)
                        .then(function (response) {
                            if (response.data && response.data.success) {
                                var dialog = $mdDialog.alert()
                                    .title( 'Successo' )
                                    .textContent( "Email inviata con successo" )
                                    .ok( 'Chiudi' )
                                ;
                                return $mdDialog
                                    .show( dialog );
                            }
                        });
                    ;
                }
                //  $scope.status = 'You decided to name your dog ' + result + '.';
            }, function() {
                // DOWNLOAD
                vm.availabilityHoursMonth(pdf);
            });
        }

        vm.availabilityHoursMonth = function (pdf) {
            window.open(env.API+"/operator-availability"
                    +"?pdf="+pdf
                    +"&store_id="+(vm.storeId)
                    +"&start="+vm.getStartMonthDay()
                    +"&end="+vm.query.end.format("YYYY-MM-01")
                    +"&token="+vm.token
                    +"&search="+vm.getSearch()
                    +"&searchFields="+vm.getSearchFields());
        };
        vm.costsHoursMonth = function () {
            var url = env.API+"/operator-availability-costs"
            //+"?pdf="+pdf
            +"?store_id="+(vm.storeId?0:0)//vm.storeId
            +"&start="+vm.getStartMonthDay()
            +"&end="+vm.query.end.format("YYYY-MM-01")
            +"&token="+vm.token;
            window.open(url);
        };

        vm.costsHoursMonth_New = function () {
            var url = env.API+"/operator-availability-costs-new"
            //+"?pdf="+pdf
            +"?store_id="+(vm.storeId?0:0)//vm.storeId
            +"&start="+vm.getStartMonthDay()
            +"&end="+vm.query.end.format("YYYY-MM-01")
            +"&token="+vm.token;
            window.open(url);
        };

        vm.getStartMonthDay = function () {
            if (vm.query.start.format("DD") == '01') {
                return vm.query.start.format("YYYY-MM-DD");
            } else {
                return vm.query.start.clone().add(1,'months').format("YYYY-MM-01");
            }
        };
        vm.getSearch = function() {
            var start = vm.getStartMonthDay();
            var end = vm.query.end.format("YYYY-MM-01");
            var search = [];
            if (!vm.query.allstores && vm.storeId) {
                search.push("store_id:"+vm.storeId);
            }
            search.push("date_start:"+start);
            search.push("date_end:"+end);
            return search.join(';');
        };
        vm.getSearchFields = function() {
            var searchFields = [];
            if (!vm.query.allstores) {
                searchFields.push("store_id:=");
            }
            searchFields.push("data_start:>=");
            searchFields.push("date_end:<");
            return searchFields.join(';');
        }

        vm.showActionToast = function( text) {
            text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent(text)
                .action('')
                .highlightAction(true)
                .position('bottom right');
            return $mdToast
                .show(toast)
                .finally(
                    function() {
                        toast = undefined;
                    }
                );
        };

        $scope.$watch( 'av.activeEvent.start', function( newValue, oldValue ) {
            if (oldValue && newValue && (oldValue!=newValue) && (vm.activeEvent.type !='leave')) {
                var nD = moment(newValue).format("YYYY-MM-DD");
                //$log.info("new d: " + nD);
                var nH = moment(newValue).format("HH:mm:00");
                //$log.info("new h: " + nH);
                //$log.info("clickedDate: " +vm.clickedDate);
                if (nD!=vm.clickedDate) {
                    vm.activeEvent.start = moment(vm.clickedDate + " " + nH).toDate();
                    //$log.info("overridden: " + vm.activeEvent.start);
                } else {
                    //$log.info("ok");
                }
            }
        });
        $scope.$watch( 'av.activeEvent.end', function( newValue, oldValue ) {
            if (oldValue && newValue && (oldValue!=newValue) && (vm.activeEvent.type !='leave')) {
                var nD = moment(newValue).format("YYYY-MM-DD");
                //$log.info("END new d: " + nD);
                var nH = moment(newValue).format("HH:mm:00");
                //$log.info("END new h: " + nH);
                //$log.info("END clickedDate: " +vm.clickedDate);
                if (nD!=vm.clickedDate) {
                    vm.activeEvent.end = moment(vm.clickedDate + " " + nH).toDate();
                    //$log.info("END overridden: " + vm.activeEvent.end);
                } else {
                    //$log.info("END ok");
                }
            }
        });
        /* Watcho lo Store */
        vm.storeId = null;
        vm.storesList = null;
        $scope.$watch( '$parent.selectedStore', function( id ) {
            if( angular.isDefined( id ) ) {
                if (vm.storeId == null) {
                    vm.storesList = $scope.$parent.main.storesList;
                }
                vm.storeId = id;
                angular.forEach(vm.storesList, function(el) {
                    if (el.id == id) {
                        vm.store = el;
                    }
                });
                vm.initLoading();
                vm.userLoad();
            };
        });

        vm.perm = {
            /*canFire: function (id, ent) {
                return $scope.$parent.main.perm.canFire(id, ent);
            },
            canRead: function (id, ent) {
                return $scope.$parent.main.perm.canRead(id, ent);
            },*/
            canCreate: function (type) {
                var res = true;
                if (type == 'leave') {
                    res = vm.user.type=='admin'
                        || vm.user.type=='manager'
                        || vm.user.type=='callcenter'
                        || (vm.user.type=='storemngr' && vm.user.store_id == vm.storeId && vm.store.f_availab_open>-1)
                        || (vm.user.type=='operator' && vm.user.store_id == vm.storeId && vm.store.f_availab_open>-1)
                        || (vm.user.type=='assist' && vm.user.store_id == vm.storeId && vm.store.f_availab_open>-1);
                } else {
                    res = vm.user.type=='admin'
                        || vm.user.type=='manager'
                        || (vm.user.type=='storemngr' && vm.user.store_id == vm.storeId && vm.store.f_availab_open>-1)
                        || (vm.user.type=='operator' && vm.user.store_id == vm.storeId && vm.store.f_availab_open>0)
                        || (vm.user.type=='assist' && vm.user.store_id == vm.storeId && vm.store.f_availab_open>0);
                }
                //$log.info("cancreate " + type + " -> "+res);
                return res;
            },
            canUpdate: function (type) {
                return vm.perm.canCreate(type);
            }/*,
            canDelete: function (id, ent) {
                return $scope.$parent.main.perm.canDelete(id, ent);
            },
            canSave: function (id, ent) {
                return $scope.$parent.main.perm.canSave(id, ent);
            }*/
        };

        vm.getNewEntity = function () {
           return {
               store_id: vm.storeId,
               user_id: vm.user.id
            };
        };

    };

})();

(function() {
    'use strict';
    
    angular
        .module( 'admin' )
;

})();
(function() {
    'use strict';
    angular
        .module('admin')
        .filter( 'validTags', function() {
            return function( tags, items) {
                // Filtra "tags" con gli elementi presenti in "items"
                var filtredTags = [];
                if (items && items.length) {
                    for (var i = 0; i < items.length; ++i) {
                        for (var y = 0; y < tags.length; ++y) {
                            if(tags[y]['id'] == items[i]['tag_id']) {
                                filtredTags.push(tags[y]);
                            }
                        }
                    }
                }
                return filtredTags;
            };
        })
        .filter( 'splitTimeFilter', function() {
            return function( datetime ) {
                var time = '';

                if ( angular.isDefined( datetime ) ) {
                    var partsOfStr = datetime.split( ' ' );
                    time = partsOfStr[1];
                };

                return time;
            };
        })
        .filter('unique', function() {
          return function (arr, field) {
            var o = {}, i;
            var l = 0;
            if (arr && arr.length) {
                l = arr.length;
            }
            var r = [];
            for(i=0; i<l;i+=1) {
              o[arr[i][field]] = arr[i];
            }
            for(i in o) {
              r.push(o[i]);
            }
            return r;
          };
})
    ;
})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .controller( 'AppointmentsController', AppointmentsController )
    ;

    /** @ngInject */
    function AppointmentsController(
        $scope,
        $log,
        $http,
        $mdDialog,
        moment,
        TreatmentService,
        StoreService,
        AppointmentsService,
        CustomerService,
        $filter,
        $timeout,
        $location,
        $mdSidenav,
        $mdToast,
        UsersService,
        env,
        customer_id,
        filter,
        store_id,
        filter_date,
        visite,
        SubscriptionService,
        CustomerSubscriptionService,
        OperatorAvailabilityService,
        CrudService,
        RecallTypes
    ) {
        var vm = this;

        vm.scope = $scope;
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        vm.maxDiscountConf = $scope.$parent.main.config.get("appointment.maxdiscount", 20);
        vm.paymentBonEnabled = $scope.$parent.main.config.get("appointment.payment_bon.enabled", true);
        vm.maxDiscount = vm.maxDiscountConf;
        vm.maxRate = 6;
        vm.sogliaRateizzazione = $scope.$parent.main.config.get("appointment.sogliarateizzazione", 0);
        vm.minAccontoPerc = $scope.$parent.main.config.get("appointment.minaccontoperc", 0);
        vm.minAcconto = $scope.$parent.main.config.get("appointment.minacconto", 0);
        vm.sogliaAcconto = $scope.$parent.main.config.get("appointment.sogliaacconto", 0);
        vm.canEdit = {
            'price_treatment': $scope.$parent.main.config.get("appointment.editenabled.price_treatment", false),
            'price_due': $scope.$parent.main.config.get("appointment.editenabled.price_due", false)

        };
        vm.refEnabled = $scope.$parent.main.config.get("appointment.ref.enabled", false);

        vm.canOperatorMove = $scope.$parent.main.config.get("appointment.operator.candomove", null);
        $log.info('canOperatorMove: '+vm.canOperatorMove);

        vm.disdSpostEnabled = vm.canOperatorMove == true && vm.user.type == 'operator' || vm.user.type != 'operator' ;
        $log.info('disdSpostEnabled: '+vm.disdSpostEnabled);
        vm.env = env;
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        $log.info( 'AppointmentsController' );
        //---------- Appointments -------------------------------------//
        vm.viewAction = false;
        vm.customersLoading = false;
        vm.isNewAppointment = false;
        vm.customer_id = undefined;
        vm.selected = [];
        vm.recall_types = RecallTypes;
        vm.options = {
            autoSelect: false,
            boundaryLinks: true,
            pageSelector: true,
            rowSelection: false
        };
        vm.filter = {
            options: {
                'debounce': 0,
                'updateOn': 'default'
            }
        };
        vm.treatmentdate = null;
        vm.today = new Date( moment().hour(8).minute(0).second(0) );
        vm.yesterday = new Date( moment( vm.today ).subtract( 1, 'days' ) );
        vm.minday = vm.user.type != 'admin'?new Date( moment( vm.today ).subtract( 1, 'days' ) )
                                            :null;

        vm.eStatus = {};
        vm.eStatus.filter_created_at = false;
        vm.eStatus.filter_date_start = filter_date?moment(filter_date):vm.today;
        vm.eStatus.filter_time_start = filter_date?null:new Date(moment().subtract(1,'hour')).getTime();
        vm.eStatus.filter_date_end = null;
        vm.eStatus.selectedFilter = null;
        vm.eStatus.selectedOperatorId = null;
        vm.eStatus.selectedByOperatorId = null;
        vm.eStatus.selectedFilterUT = null;
        vm.eStatus.selectedFilterCOM = null;
        vm.eStatus.selectedFilterAnom = null;
        vm.eStatus.uncoveredFilter = null;
        vm.eStatus.pricing = null;
        vm.query = {
            filter: filter?filter:'',
            filter_customer: '',
            filter_treatment: '',
            order: 'date_start',
            limit: 10,
            limitOptions: [ 5, 10, 15, 20 ],
            page: 1,
            per_page: 10,
            showLastname: false
        };

        /**
         * Gestione tags
         */

        vm.tags = [];
        if (vm.env.customertags) {
            $http.get(vm.env.API+"/tags", {params: {searchFields: 'entity:=', search: 'entity:app-customer', sortBy: 'name'}}).then(
                function(response) {
                    $log.info(response.data);
                    vm.tags = response.data.data;
                },
                function (error) {
                    $log.info(error);
                }
            );
        }

        vm.visite = visite;
        vm.saveStatus = function () {
          //if (true) return;
          localStorage.setItem( 'appointments_eStatus', angular.toJson( vm.eStatus, false ) );
          localStorage.setItem( 'appointments_query', angular.toJson( vm.query, false ) );
        };
        vm.restoreStatus = function () {
          //if (true) return;
          var eStatus = angular.fromJson(localStorage.getItem('appointments_eStatus'));
          if (eStatus!=null) {
            vm.eStatus = eStatus;
          }
          var query = angular.fromJson(localStorage.getItem('appointments_query'));
          if (query!=null) {
            vm.query =  query;
            vm.showLastname = vm.query.showLastname;
          }
        };
        if (!filter) {
            vm.restoreStatus();
        }
        vm.filtersList = [
            {
                value: 3,
                name: "In agenda",
            },
            {
                value: 7,
                name: "Da chiamare",
            },
            {
                value: 8,
                name: "Non risp.",
            },
            {
                value: 0,
                name: "Non present.",
            },
            {
                value: 1,
                name: "Presentato",
            },
            {
                value: 2,
                name: "Pagato",
            },
            {
                value: 4,
                name: "In Agenda + Disd.",
            },
            {
                value: 5,
                name: "Disdetti",
            },
            {
                value: 6,
                name: "Spostati",
            },
            {
                value: 9,
                name: "Scoperti",
            },
            {
                value: 17,
                name: "Pag. Assegno",
            },
            {
                value: 11,
                name: "Pag. Bonifico",
            },
            {
                value: 14,
                name: "Pag. Contanti",
            },
            {
                value: 16,
                name: "Pag. Gift",
            },
            {
                value: 12,
                name: "Pag. Pagodil",
            },
            {
                value: 13,
                name: "Pag. Pos",
            }
        ];
        if (env.smallpayEnabled) {
            vm.filtersList.push({value: 15, name: 'Pag. PagoLight'});
        }
        if (env.satispayEnabled) {
            vm.filtersList.push({value: 18, name: 'Pag. Satispay'});
        }
        vm.filtersListUT = [
            {
                value: 1,
                name: "1a volta",
            },
            {
                value: 2,
                name: "Smaltimento",
            },
            {
                value: 3,
                name: "Bronze",
            },
            {
                value: 4,
                name: "Silver",
            },
            {
                value: 5,
                name: "Gold",
            },
        ];
        vm.filtersListCOM = [
          {
              value: 1,
              name: "Commerc.",
          },
          {
              value: 4,
              name: "Comm. da bidoni",
          },
          {
              value: 8,
              name: "Comm. da lead",
          },
          {
              value: 9,
              name: "Comm. Phone Friend",
          },
          {
              value: 11,
              name: "Comm. rullo o nuovi cli.",
          },
          {
              value: 2,
              name: "Non Comm.",
          },
          {
              value: 3,
              name: "Rullo e lead centro",
          },
          {
              value: 10,
              name: "Non fidelizzati",
          },
          {
              value: 7,
              name: "Rate insolute",
          },
          {
              value: 5,
              name: "Online Booking",
          },
          {
              value: 6,
              name: "Bot Booking",
          },

        ];
        vm.filtersListAnom = [
            {
                value: 'CN',
                name: "Con note",
            },
            {
                value: 'SN',
                name: "Senza note",
            },
            {
                value: 'A',
                name: "Con anomalia",
            },
            {
                value: 'N',
                name: "Non risolte",
            },
            {
              value: 'RP',
              name: "Recensioni positive",
            },
            {
                value: 'RN',
                name: "Recensioni negative",
            }
        ];
        vm.appointmentTypologies = [
            {value:null,label:'Prezzo pieno'},
            {value:'promo',label:'Promo'},
            {value:'free',label:'Omaggio'},
            {value:'app', label: 'Punti App'}
        ];        vm.sconti = [
          {sconto: 5, credit: 800, limit: 20 },
          {sconto: 10, credit: 1500, limit: 30 },
          {sconto: 25, credit: 3000, limit: 50 },
          {sconto: 50, credit: 5000, limit: 80 },
          {sconto: 80, credit: 7500, limit: 150 },
          {sconto: 115, credit: 10000, limit: 230 },
          {sconto: 250, credit: 20000, limit: 400 },
          {sconto: 500, credit: 30000, limit: 800 }
        ];
        vm.resetTable = function() {
            vm.query.page = 1;
            vm.query.per_page = 10;
            //vm.calcsOnVisibileElements();
        };
        vm.dateSelected = function() {
            return function( item ) {
                var start = null
                    , end = null
                ;

                if( vm.vm.eStatus.filter_date_start && ! vm.eStatus.filter_date_end ) {

                    start = moment( vm.eStatus.filter_date_start ).hours( 0 ).minutes( 0 ).seconds( 0 );
                    return moment( item.date_start ).isAfter( start );

                } else if( ! vm.eStatus.filter_date_start && vm.eStatus.filter_date_end ) {

                    end = moment( vm.eStatus.filter_date_end ).hours( 23 ).minutes( 59 ).seconds( 59 );
                    return moment( item.date_start ).isBefore( end );

                } else if ( vm.eStatus.filter_date_start && vm.eStatus.filter_date_end ) {

                    start = moment( vm.eStatus.filter_date_start ).hours( 0 ).minutes( 0 ).seconds( 0 );
                    end = moment( vm.eStatus.filter_date_end ).hours( 23 ).minutes( 59 ).seconds( 59 );

                    return moment( item.date_start ).isBetween( start, end );

                }

                return true;
            };
        };
        vm.onChangeDateStart = function() {
            vm.query.page = 1;
            vm.query.order = 'date_start';
            if( vm.eStatus.filter_date_start && vm.eStatus.filter_date_end ) {
                if( moment( vm.eStatus.filter_date_end ).hour(23).minute(59).second(59).isBefore( vm.eStatus.filter_date_start ) ) {
                    vm.eStatus.filter_date_end = null;
                }
            }
            vm.eStatus.filter_time_start = new Date(vm.today).getTime();
            vm.appointmentsListLoad(null);
        };
        vm.onChangeDateEnd = function() {
          vm.query.page = 1;
          vm.query.order = 'date_start';
          if( vm.eStatus.filter_date_start && vm.eStatus.filter_date_end ) {
              if( moment( vm.eStatus.filter_date_end ).hour(23).minute(59).second(59).isBefore( vm.eStatus.filter_date_start ) ) {
                  vm.eStatus.filter_date_start = vm.eStatus.filter_date_end;
                  vm.eStatus.filter_time_start = new Date(vm.today).getTime();
              }
          }
          vm.appointmentsListLoad(null);
        };
        vm.onChangeTimeStart = function() {
          //$log.info(vm.eStatus.filter_time_start);
          //$log.info(new Date(vm.eStatus.filter_time_start).getTime());
          vm.eStatus.filter_time_start = new Date(vm.eStatus.filter_time_start).getTime();
          vm.query.page = 1;
          vm.query.order = 'date_start';
          vm.appointmentsListLoad(null);
        };
        vm.removeSearch = function () {
            vm.query.filter = '';
            vm.query.filter_customer = '';
            vm.query.filter_treatment = '';
            vm.query.order = 'date_start';
            vm.query.page = 1;
            vm.query.per_page = 10;
            vm.query.showLastname = false;
            vm.eStatus.filter_date_start = vm.today;
            vm.eStatus.filter_time_start = new Date(moment().subtract(1,'hour')).getTime();
            vm.eStatus.filter_created_at = false;
            vm.eStatus.filter_date_end = null;
            vm.eStatus.selectedFilter = null;
            vm.eStatus.selectedOperatorId = null;
            vm.eStatus.selectedByOperatorId = null;
            vm.eStatus.selectedFilterUT = null;
            vm.eStatus.selectedFilterCOM = null;
            vm.eStatus.selectedFilterAnom = null;
            vm.eStatus.uncoveredFilter = null;
            vm.eStatus.pricing = null;
            vm.treatmentdate = null;
            vm.appointmentsListLoad(1);
        };
        /* Treatments */
        vm.treatmentsList = [];
        vm.treatmentsListStoreId = null;
        vm.treatmentsListAll = [];
        vm.laserTreatmentsList = [];
        vm.portaEnabled = true;
        vm.filterTreatments = function() {
            if (!vm.treatmentsLoaded || vm.treatmentsListStoreId == vm.storeId) {
                return;
            }
            vm.treatmentsListStoreId = vm.storeId;
            vm.treatmentsList = [];
            //$log.info("vm.filterTreatments: "+ vm.storeId);
            var filterCategory = vm.storeId && vm.env.stores!=null && vm.env.stores[vm.storeId]!=null && vm.env.stores[vm.storeId].categories!=null;
            //$log.info("vm.filterTreatments: filterCategory="+ filterCategory);
            angular.forEach(vm.treatmentsListAll, function(ct) {
                //$log.info(ct);
                if(filterCategory) {
                    //$log.info(vm.env.stores[vm.storeId].categories);
                    //$log.info(vm.env.stores[vm.storeId].categories.includes(ct.id));
                }
                if (!filterCategory || vm.env.stores[vm.storeId].categories.includes(ct.id)) {
                    vm.treatmentsList.push(ct);
                }
            });
        }
        vm.pricings = [];
        vm.pricingsLoad = function () {
            vm.pricings = [];
            $http
                .get(env.API + "/leads_campaign_pricings")
                .then(function (response) {
                    if (response.data && response.data.data) {
                        vm.pricings = response.data.data;
                    }
                });
        };
        //vm.pricingsLoad();
        vm.treatmentsLoaded = false;
        TreatmentService.categories().then(function( data ) {
            vm.treatmentsListAll = data;
            var ids = [1,2,3,4,5,6,126,127,128,129];
            for (var i = 0; i < ids.length; i++) {
                //console.log(ids[i]);
                var t = $filter('treatment')(ids[i], vm.treatmentsListAll);
                //$log.info("trattamento "+ ids[i]);
                //$log.info(t);
                if (t != null && t!='') {
                    vm.laserTreatmentsList.push(t);
                }
            }
            vm.treatmentsLoaded = true;
            vm.filterTreatments();
        });
        /* Subscriptions */
        vm.subscriptionsList = [];
        SubscriptionService.all( {search: 1, searchFields: 'active:='} ).then(function( response ){
            vm.subscriptionsList = response.data.data;
        });

        vm.subscriptionsListByCustomer = [];
        vm.customerSubscriptionService = CustomerSubscriptionService;
        vm.checkSubscriptionByUser = function(item) {
            var options = {
                with : 'subscription',
                search :
                    'customer_id:' + item +
                    ';app_remaining:1',
                    exclude_old: true
                ,
                searchFields : 'customer_id:=;app_remaining:>='
            };

            vm.subscriptionsListByCustomer = [];

            vm.customerSubscriptionService.get( options ).then(function( response ){
                angular.forEach( response.data.data, function( elem ) {
                    if((elem.customer_id == item) && (elem.app_remaining >= 1)) {
                        vm.subscriptionsListByCustomer.push(elem);
                    }
                });
            });
        };

        vm.checkSubscriptionByUserAndSetSubscriptionName = function(item, appointment, callback) {
            var options = {
                with : 'subscription',
                search :
                    'customer_id:' + item
                ,
                searchFields : 'customer_id:=;',
                exclude_old: true,
            };

            vm.subscriptionsListByCustomer = [];

            vm.customerSubscriptionService.get( options ).then(
                function( response ){
                    angular.forEach( response.data.data, function( elem ) {
                        if((elem.customer_id == item) && (elem.app_remaining >= 1)) {
                            vm.subscriptionsListByCustomer.push(elem);
                        }
                        else{
                            if (appointment.customer_subscription_id == elem.id) {
                                vm.subscriptionsListByCustomer.push(elem);
                            }
                        }
                    });
                }
            ).then(callback);
        };

        vm.filterCustomer = function(phone) {
            vm.query.filter = phone;
            vm.eStatus.filter_date_end = null;
            vm.appointmentsListLoad(1);
        };

        /* Appointments */
        vm.totFirstTime = 0;
        vm.totPrices = 0;
        vm.appointmentsList = [];
        vm.loading = true;
        vm.appointmentsListPag = {"total":0,"count":10,"per_page":vm.query.per_page,"current_page":1,"total_pages":0,"links":{} };
        vm.appointmentsListLoad = function(p, s) {
          vm.appointmentsList = [];
          $scope.$parent.main.appointmentsList = []; //notifiche messaggi wa
            vm.loading = true;
            if (p==null) {
                p = vm.query.page;
            }
            vm.query.page = p;
            if (s==null) {
                s = parseInt(vm.appointmentsListPag.per_page);
            }
            vm.query.per_page = s;
            vm.saveStatus();

            var pars = {page:p, s: s, searchJoin: 'and', visite: vm.visite};
            var search = [];
            var searchFields = [];
            if (vm.storeId) {
                search.push("appointments.store_id:"+vm.storeId);
                searchFields.push("appointments.store_id:=");
            }
            if (vm.eStatus.pricing) {
                search.push("leads.categoria:"+vm.eStatus.pricing);
                searchFields.push("leads.categoria:=");
            }
            if (vm.eStatus.filter_date_start!=null && vm.eStatus.filter_date_start!='') {
                var dField = vm.eStatus.filter_created_at?'appointments.created_at':'date_start';
                search.push(dField+":"+moment(vm.eStatus.filter_date_start).format("YYYY-MM-DD ")+moment(vm.eStatus.filter_time_start).format("HH:mm:ss"));
                searchFields.push(dField+":>=");
            }
            if (vm.eStatus.filter_date_end!=null && vm.eStatus.filter_date_end!='') {
              var date_end = moment(vm.eStatus.filter_date_end).format("YYYY-MM-DD 23:59:59.9");
              if (vm.eStatus.filter_created_at) {
                pars.created_at_to=date_end;
              } else {
                  search.push("date_end:"+date_end);
              searchFields.push("date_end:<");
              }
            }
            if (vm.eStatus.selectedOperatorId!=undefined) {
                search.push("appointments.user_id:"+vm.eStatus.selectedOperatorId);
                searchFields.push("appointments.user_id:=");
            }
            if (vm.eStatus.selectedByOperatorId!=undefined && vm.eStatus.selectedByOperatorId) {
                if (vm.eStatus.selectedFilterCOM!=undefined
                        && (vm.eStatus.selectedFilterCOM == '5'
                         || vm.eStatus.selectedFilterCOM == '6')) {
                    vm.eStatus.selectedByOperatorId='0';
                } else {
                    search.push("by_operator:"+vm.eStatus.selectedByOperatorId);
                    searchFields.push("by_operator:=");
                }
            }
            if (vm.eStatus.selectedFilter!=undefined) {
                var f = parseInt(vm.eStatus.selectedFilter);
                if (f<2) {//presentati o non presentati
                    searchFields.push("paid:=");
                    search.push("paid:"+vm.eStatus.selectedFilter);
                    if (f==0) {//solo bidoni
                        searchFields.push("recalled:<");
                        search.push("recalled:3");
                    }
                } else if (f == 2) {//price >0 e presentati
                    searchFields.push("paid:=");
                    search.push("paid:1");
                    searchFields.push("price:>");
                    search.push("price:0");
                } else if (f==3) {//escludo disdetti e spostati == In agenda
                    searchFields.push("recalled:<");
                    search.push("recalled:3");
                } else if (f==4) {//In agenda + disdetti
                    searchFields.push("recalled:<=");
                    search.push("recalled:3");
                } else if (f==5) {//disdetti
                    searchFields.push("recalled:=");
                    search.push("recalled:3");
                } else if (f==6) {
                    searchFields.push("recalled:=");
                    search.push("recalled:4");
                } else if (f==7) {
                    searchFields.push("recalled:=");
                    search.push("recalled:0");
                } else if (f==8) {
                    searchFields.push("recalled:=");
                    search.push("recalled:2");
                } else if (f==9) {
                    searchFields.push("uncovered:=");
                    search.push("uncovered:1");
                } else if (f==11) {//bonifico
                    searchFields.push("price:>");
                    search.push("price:0");
                    searchFields.push("recalled:<");
                    search.push("recalled:3");
                    searchFields.push("paid:=");
                    search.push("paid:1");
                    searchFields.push("payment_bon:>");
                    search.push("payment_bon:0");
                } else if (f==12) {//dil
                    searchFields.push("price:>");
                    search.push("price:0");
                    searchFields.push("recalled:<");
                    search.push("recalled:3");
                    searchFields.push("paid:=");
                    search.push("paid:1");
                    searchFields.push("payment_dil:>");
                    search.push("payment_dil:0");
                } else if (f==13) {//pos
                    searchFields.push("price:>");
                    search.push("price:0");
                    searchFields.push("paid:=");
                    search.push("paid:1");
                    searchFields.push("payment_pos:>");
                    search.push("payment_pos:0");
                    searchFields.push("recalled:<");
                    search.push("recalled:3");
                } else if (f==14) {//cassa
                    searchFields.push("price:>");
                    search.push("price:0");
                    searchFields.push("paid:=");
                    search.push("paid:1");
                    searchFields.push("payment_type:=");
                    search.push("payment_type:C");
                    searchFields.push("recalled:<");
                    search.push("recalled:3");
                } else if (f==15) {//small
                    searchFields.push("price:>");
                    search.push("price:0");
                    searchFields.push("recalled:<");
                    search.push("recalled:3");
                    searchFields.push("paid:=");
                    search.push("paid:1");
                    searchFields.push("payment_small:>");
                    search.push("payment_small:0");
                } else if (f==16) {//gift
                    searchFields.push("price:>");
                    search.push("price:0");
                    searchFields.push("recalled:<");
                    search.push("recalled:3");
                    searchFields.push("paid:=");
                    search.push("paid:1");
                    searchFields.push("payment_gift:>");
                    search.push("payment_gift:0");
                } else if (f==17) {//check
                    searchFields.push("price:>");
                    search.push("price:0");
                    searchFields.push("recalled:<");
                    search.push("recalled:3");
                    searchFields.push("paid:=");
                    search.push("paid:1");
                    searchFields.push("payment_check:>");
                    search.push("payment_check:0");
                }  else if (f==18) {//satis
                    searchFields.push("price:>");
                    search.push("price:0");
                    searchFields.push("recalled:<");
                    search.push("recalled:3");
                    searchFields.push("paid:=");
                    search.push("paid:1");
                    searchFields.push("payment_satis:>");
                    search.push("payment_satis:0");
                }

            }
            if (vm.eStatus.selectedFilterUT!=undefined) {
                search.push("appointments.user_times:1");
                if (vm.eStatus.selectedFilterUT==1) {
                    search.push("appointments.user_times:1");
                    searchFields.push("appointments.user_times:<=");
                } else if (vm.eStatus.selectedFilterUT==2){
                    search.push("appointments.user_times:1");
                    searchFields.push("appointments.user_times:>");
                } else if (vm.eStatus.selectedFilterUT==3){
                    search.push("appointments.user_times:70");
                    searchFields.push("appointments.user_times:>=");
                } else if (vm.eStatus.selectedFilterUT==4){
                    search.push("appointments.user_times:85");
                    searchFields.push("appointments.user_times:>=");
                } else if (vm.eStatus.selectedFilterUT==5){
                    search.push("appointments.user_times:100");
                    searchFields.push("appointments.user_times:>=");
                }
            }
            if (vm.eStatus.selectedFilterAnom!=undefined) {
                if (vm.eStatus.selectedFilterAnom=='A') {
                  search.push("appointments.anom:0");
                  searchFields.push("appointments.anom:>");
                } else if (vm.eStatus.selectedFilterAnom=='N') {
                  search.push("appointments.anom:1");
                  searchFields.push("appointments.anom:=");
                } else if (vm.eStatus.selectedFilterAnom=='RP') {
                  search.push("appointments.review:3");
                  searchFields.push("appointments.review:>=");
                } else if (vm.eStatus.selectedFilterAnom=='RN') {
                  search.push("appointments.review:1");
                  searchFields.push("appointments.review:=");
                } else if(vm.eStatus.selectedFilterAnom=='CN') {//con nota
                    pars.withNote = true;
                } else if(vm.eStatus.selectedFilterAnom=='SN') {//senza nota
                    pars.withNote = false;
                }
            }
            if (vm.eStatus.selectedFilterCOM!=undefined) {
                if (vm.eStatus.selectedFilterCOM == '4') {
                    search.push("appointments.relevance:0");
                    searchFields.push("appointments.relevance:<");
                } else if (vm.eStatus.selectedFilterCOM == '5') {//online booking
                    search.push("appointments.by_operator:0");
                    searchFields.push("appointments.by_operator:=");
                } else if (vm.eStatus.selectedFilterCOM == '6') {//bot booking
                    //search.push("appointments.by_operator:36");
                    //searchFields.push("appointments.by_operator:=");
                    search.push("appointments.by_operator:0");
                    searchFields.push("appointments.by_operator:=");
                    pars.botbooking = true;
                } else if (vm.eStatus.selectedFilterCOM=='7') {
                    pars.unpaid = true;
                } else if (vm.eStatus.selectedFilterCOM=='10') {
                    pars.notfidel = true;
                } else {
                    pars.filtro_com=vm.eStatus.selectedFilterCOM;
                }
            }
            if (vm.query.filter!=null && vm.query.filter!='') {
                pars.filtro=vm.query.filter;
            }
            if (vm.query.order!=null && vm.query.order!='') {
                if (vm.query.order.indexOf("-")==0) {
                    pars.orderBy = vm.query.order.substring(1);
                    pars.sortedBy = "desc";
                } else {
                    pars.orderBy = vm.query.order;
                    pars.sortedBy = "asc";
                }
            }
            if(vm.visite) {
                pars.sortedBy = "desc";
                pars.search = null;
                pars.s = 1000;
                pars.searchJoin = null;
                pars.searchFields = null;
            } else {
                pars.search = search.join(";");
                pars.searchFields = searchFields.join(";");
            }
            pars.with = "operatorChangeHistory;payments;giftcard;customer.entitytags;customer.unreadedMessages;customer.payments;anomalie;customer;card_pf;byOperator;lead_recall;lead;movedBy;cancelledBy;updatedBy;includedProducts";
            if (vm.env.documentsEnabled) {
                pars.with = pars.with+";documents";
            }
            AppointmentsService.all( pars ).then( function( response ) {
                vm.appointmentsList = [];
                if( response.data && response.data.data ) {
                    vm.appointmentsListPag = response.data.meta.pagination;
                    var appCreditXuser = [];
                    angular.forEach( response.data.data, function( elem ) {
                        vm.dateFormat(elem, true);
                        if (!vm.storeId) {
                            angular.forEach($scope.$parent.main.storesList, function (s) {
                                if (s.id == elem.store_id) {
                                  elem.store = {data: s};
                                }
                              });
                        }
                        elem.treatment = {'data': $filter('treatment')(elem.treatment_id, vm.treatmentsList)};
                        vm.setUserRole(elem);
                        vm.setAssistUserRole(elem);
                        vm.setCommercialUserRole(elem);
                        vm.setUserRoleSm(elem);
                        vm.initRatePayment(elem);
                        vm.initTreatmentCanChange(elem);
                        vm.initDocuments(elem);
                      //per il cambio operatore
                        //$log.vinfo(elem);
                        //$log.info(vm.user);
                        elem.haveCard = elem.card_pf!=null;
                        elem.deliverCard = elem.card_pf!=null && !elem.card_pf.data.delivered;
                        elem.newOperatorId = elem.user_id;
                        if (elem.role) {
                            elem.newOperatorCandidates = [elem.role.data];
                        }
                        elem.treatment_name = $filter('treatmentIdtoName')(elem.treatment_id, vm.treatmentsList);
                        if (elem.credit==null) {
                          elem.credit = 0;
                        }
                        if (elem.discount==null) {
                          elem.discount = 0;
                        }
                        elem.usecredit = elem.credit>0;
                        if (elem.credit>0) {
                          elem.credit_usage = $filter('filter')(vm.sconti, {sconto: elem.discount}, true)[0];
                        }
                        if (appCreditXuser['uid_'+elem.customer.data.id]==null) {
                          elem.totalcredit = elem.credit+elem.customer.data.credit;
                          appCreditXuser['uid_'+elem.customer.data.id] = 'S';
                        } else {
                          elem.totalcredit = elem.credit;
                        }
                        vm.initPriceFullPriceDiscounted(elem);
                        vm.initGSB(elem);
                        /*if (elem.price_full == null) {
                          elem.price_full = elem.price+elem.discount;
                        }
                        elem.price_discounted = elem.price+elem.price_due-elem.ratePayment;
                        if (elem.price_treatment == null) {
                            if (vm.isAcquistoDip(elem)) {
                                elem.price_treatment = elem.price_full - elem.product_price/2 - elem.product_price10/2;
                            } else if (vm.isStorno(elem)) {
                                elem.price_treatment = 0-elem.price_full;
                            } else {
                                elem.price_treatment = elem.price_full - elem.product_price - elem.product_price10;
                            }
                        }*/
                        if (elem.f_smallpay) {
                            elem.rateizzazione_type = "S";
                        } else {
                            if (elem.price_due>0) {
                                elem.rateizzazione_type = "M";
                            }
                        }
                        //$log.info(elem);
                        vm.appointmentsList.push( elem );
                    });
                    vm.loading = false;
                    /**
                     * Per inserire notifiche unreaded
                     */
                    $scope.$parent.main.appointmentsList = vm.appointmentsList;

                    vm.calcsOnVisibileElements();
                };
            },
            function (response) {
                var errMsg = "";
                if (response.data!=null && response.data.message!=null) {
                    errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    if (url!=null) {
                        errMsg+= "\nUrl: " + url;
                    }
                }
                alert ("Si è verificato un errore nel caricamento appuntamenti: " + errMsg);
                vm.loading = false;
            });
        };

        vm.initGSB = function(elem) {
            /**
                Init Gold Silver Bronze Tags
            */
            elem.goldtag = $filter('filter')(elem.customer.data.entitytags.data, {tag_id: 1}, true);
            elem.silvertag = $filter('filter')(elem.customer.data.entitytags.data, {tag_id: 2}, true);
            elem.bronzetag = $filter('filter')(elem.customer.data.entitytags.data, {tag_id: 3}, true);
            var entitytag = {id: null, tag_id: null, customer_id: elem.customer_id, flagged: false, flagged_at: null, flagged_by: null};
            if (elem.user_times>=70 && elem.user_times<85 && elem.bronzetag.length==0) {
                entitytag.tag_id = 3;
                elem.bronzetag.push(entitytag);
            } else if (elem.user_times>=85 && elem.user_times<100 && elem.silvertag.length==0) {
                entitytag.tag_id = 2;
                elem.silvertag.push(entitytag);
            } else if (elem.user_times>=100 && elem.goldtag.length==0) {
                entitytag.tag_id = 1;
                elem.goldtag.push(entitytag);
            }
            if (entitytag.tag_id) {
                elem.customer.data.entitytags.data.push(entitytag);
            }
            angular.forEach(elem.customer.data.entitytags.data, function(elem) {
                if (elem.flagged_at) {
                    elem.flagged_at_frmt = moment(elem.flagged_at).format('DD/MM/YYYY HH:mm');
                }
            });
        }

        vm.inviaMessaggioReferral = function(app) {
            $log.info('invio primo msg referral',app);
            vm.sending = true;
            var store = vm.storeId?vm.store:app.store.data;
            var message = {
                'customer_id':  app.customer_id,
                'template':  'referral_first',
                'phone': app.customer.data.phone,
                'message': '',
                'parameters': [
                    app.customer.data.firstname,
                    vm.user.firstname,
                    store.alias
                ]
            }
            $log.info('Salva');
            CrudService
                .save( 'customer_messages', message, vm ,
                    function(response) {
                        $log.info(response)
                        vm.showActionToast("Primo messaggio inviato correttamente!");
                        vm.inviaMessaggioReferralLink(app);
                    },
                    function(response) {
                        vm.sending = false;
                        vm.showActionToast(response.data.message?response.data.message:response.data.error);
                        $log.info(response);
                    }
            );
        }

        vm.inviaMessaggioReferralLink = function(app) {
            $log.info('invio secondo msg referral',app);
            vm.sending = true;
            var store = vm.storeId?vm.store:app.store.data;
            var message = {
                'customer_id':  app.customer_id,
                'template':  'referral_link_'+store.alias.toLowerCase()+'_link',
                'phone': app.customer.data.phone,
                'message': '',
                'parametersCount': 2
            }
            $log.info('Salva');
            CrudService
                .save( 'customer_messages', message, vm ,
                    function(response) {
                        $log.info(response)
                        vm.showActionToast("Secondo messaggio inviato correttamente!");
                        CrudService.update('customers', {
                            'id': app.customer_id,
                            'referral_sent_at': moment().format('YYYY-MM-DD HH:mm:ss'),
                            'referral_user_id': vm.user.id
                        }, vm, function(response) {
                            $log.info(response);
                            vm.showActionToast("Dati invio salvati correttamente!");
                            app.customer.data.referral_sent_at = moment().format('YYYY-MM-DD HH:mm:ss');
                            app.customer.data.referral_sent_at_days = 0;
                            app.customer.data.referral_user_id = vm.user.id;
                            vm.sending = false;
                        }, function(response) {
                            vm.sending = false;
                            vm.showActionToast(response.data.message?response.data.message:response.data.error);
                            $log.info(response);
                        });

                    },
                    function(response) {
                        vm.sending = false;
                        vm.showActionToast(response.data.message?response.data.message:response.data.error);
                        $log.info(response);
                    }
            );
        }

        vm.emettiCardPf = function (app) {
            CrudService.save(
                    'cards',
                    {'store_id': app.store_id,
                    'appointment_id': app.id,
                    'customer_id': app.customer_id,
                    'campaign': 'PhoneFriend'}, vm,
                    function(response) {
                        //$log.info(response);
                        app.card = {'data': response.data.data};
                        app.haveCard = true;
                        app.deliverCard = true;
                        var nl = vm.env.booking +
                        "/pf?store=" + vm.storeId +
                        "&c_sid=" + vm.user.store_id +
                        "&c_role=" + vm.user.type +
                        "&cph=" + app.customer.data.phone +
                        "&crdid=" + app.card.data.id +
                        "&token="+vm.token;
                        //alert (nl);
                        window.open(nl,'_blank');
                    },
                    function(response) {

                    });
        };

        vm.setUserRole = function(elem) {
            if (elem.user_id) {
                angular.forEach(vm.userRolesListAll, function (r) {
                      if (r.user_id == elem.user_id && r.store_id == elem.store_id) {
                        elem.role = {data: r};
                      }
                });
            }
        };
        vm.setAssistUserRole = function(elem) {
            if (elem.assist_user_id) {
                angular.forEach(vm.userRolesListAll, function (r) {
                      if (r.user_id == elem.assist_user_id && r.store_id == elem.store_id) {
                        elem.assistRole = {data: r};
                      }
                });
            }
        };
        vm.setCommercialUserRole = function(elem) {
            if (elem.commercial_user_id) {
                angular.forEach(vm.userRolesListAll, function (r) {
                      if (r.user_id == elem.commercial_user_id && r.store_id == elem.store_id) {
                        elem.commercialRole = {data: r};
                      }
                });
            }
        };
        vm.setUserRoleSm = function(elem) {
            if (elem.user_id_sm) {
                angular.forEach(vm.userRolesListAll, function (r) {
                      if (r.role == 'storemngr' && r.user_id == elem.user_id_sm && r.store_id == elem.store_id) {
                        elem.roleSm = {data: r};
                      }
                });
            }
        };

        vm.onChangeFilterCreatedAt = function () {
          if (vm.eStatus.filter_created_at) {
            vm.query.order = 'created_at';
          } else {
            vm.query.order = 'date_start';
          }
          vm.query.page=1;
          vm.appointmentsListLoad();
        };

        vm.appointmentsListReOrder = function (column) {
            vm.query.order = column;
            vm.appointmentsListLoad(1);
        };
        vm.onKeyPressSearch = function (event) {
            if (event.keyCode==13) {
                vm.appointmentsListLoad(1);
                event.stopPropagation();
                event.preventDefault();
            }
        };
        vm.delAp = function ( id ) {
            $log.info( 'Del' );
            if( angular.isDefined( id ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler eliminare questo appuntamento?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            var position = vm.appointmentsList.map( function( x ) { return x.id; } ).indexOf( id );
                            AppointmentsService.del( vm.appointmentsList[ position ] ).then( function( response ) {
                                vm.calcsOnVisibileElements();
                                if( response.status === 204 ) {
                                    vm.appointmentsList.splice( position, 1 );
                                } else {
                                    alert("Errore durante l'elaborazione delle richiesta.");
                                };
                            });
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };
        vm.confirmAp = function ( id ) {
            $log.info( 'Confirmed' );
            vm.activeAppointment = null;
            var position = vm.appointmentsList.map( function( x ) { return x.id; } ).indexOf( id );
            if( position !== -1 ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent(
                        'Sicuro di voler ' +
                        (
                            vm.appointmentsList[ position ].confirmed
                            ? 'Annullare'
                            : 'Confermare'
                        ) +
                        ' questo appuntamento?'
                    )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            if( vm.appointmentsList[ position ].confirmed ){
                                vm.appointmentsList[ position ].confirmed = 0;
                            }else{
                                vm.appointmentsList[ position ].confirmed = 1;
                            };

                            angular.copy( vm.appointmentsList[ position ], vm.update_appointment );
                            vm.appointmentsList[ position ].updated_by = vm.user.id;
                            vm.appointmentsList[ position ].updatedBy = {data: vm.user};
                            vm.appointmentsList[ position ].updated_at = moment();
                            vm.appointmentsList[ position ].updated_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                            AppointmentsService.update( {id: vm.update_appointment.id, confirmed: vm.update_appointment.confirmed} );
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };

        /* Ricordato Non-Ricordato ... disdetto spostato */
        vm.rememberApSelect = function ( id, old_value, store_id ) {
            $log.info( 'Ricordato Non-Ricordato' );
            vm.activeAppointment = null;
            var position = vm.appointmentsList.map( function( x ) { return x.id; } ).indexOf( id );
            if( position !== -1 ) {
                if (false && vm.appointmentsList[ position ].user_times<2
                         && vm.appointmentsList[ position ].byOperator.data.id>0
                         && vm.appointmentsList[ position ].byOperator.data.store_id == 0
                         && vm.user.store_id != null) {
                    vm.appointmentsList[ position ].recalled = old_value;
                     vm.showActionToast("Operazione non consentita su appuntamento commerciale");
                     return;
                }

                // Se è una disdetta mostro il form per generare il lead
                var appointment = vm.appointmentsList[ position ];
                console.log(appointment.byOperator.data);

                if( appointment.byOperator && appointment.byOperator.data
                    && appointment.byOperator.data.id>0
                    //&& appointment.byOperator.type == 'callcenter'
                    && !appointment.byOperator.data.store_id
                    && parseInt(vm.recall_types[ appointment.recalled ].value) == 3) {

                    var dialog = $mdDialog.confirm({
                        title: "Info appuntamento disdetto",
                        ariaLabel: 'Disdetta',
                        templateUrl: 'app/appointments/dialogs/appointment-cancellation.html',
                        escapeToClose: true,
                        controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                            $scope.title = this.title;
                            //$scope.show = show;
                            $scope.button_cancel = 'Chiudi';
                            $scope.appointment = appointment;
                            $scope.dateTimeStart = moment( appointment.date_start ).format('DD/MM/YYYY HH:mm');
                            $scope.minDate = vm.today;
                            $scope.call_date = new Date(moment().add('weeks', 2));;

                            $scope.save = function () {

                                var call_date = moment($scope.call_date).format('YYYY-MM-DD HH:mm');

                                $scope.loading = true;

                                angular.copy( vm.appointmentsList[ position ], vm.update_appointment );

                                AppointmentsService.update( {
                                    id: vm.update_appointment.id,
                                    recalled: vm.update_appointment.recalled,
                                    paid: 0,
                                    call_date: call_date,
                                    reason: $scope.reason
                                }).then(

                                    function(response) {

                                        $scope.loading = false;
                                        vm.appointmentsList[ position ].cancelled_at = moment();
                                        vm.appointmentsList[ position ].cancelled_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                                        vm.appointmentsList[ position ].cancelledBy = {data: vm.user};
                                        vm.appointmentsList[ position ].cancelled_by = vm.user.id;
                                        if (vm.appointmentsList[ position ].paid && vm.appointmentsList[ position ].paid==1) {
                                            vm.appointmentsList[ position ].paid=0;
                                            vm.calcsOnVisibileElements();
                                        }
                                        vm.showActionToast();
                                        $mdDialog.hide( true );
                                    },
                                    function (response) {
                                        $scope.loading = false;
                                        vm.appointmentsList[ position ].recalled = old_value;
                                        vm.checkResponse(response, vm.appointmentsList[ position ]);
                                    }
                                );
                            };
                            $scope.close = function() {
                                vm.appointmentsList[ position ].recalled = old_value;
                                $mdDialog.hide( true );
                            };
                        }]
                  });

                  return $mdDialog
                      .show( dialog )
                      .finally(
                          function() {
                              dialog = undefined;
                          }
                      );
                }

                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent(
                        'Sicuro di voler segnare come "' +
                        vm.recall_types[ vm.appointmentsList[ position ].recalled ].text_esteso.toUpperCase() +
                        '" questo appuntamento?'
                    )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' );
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            if (vm.appointmentsList[ position ].recalled != 4) {
                              angular.copy( vm.appointmentsList[ position ], vm.update_appointment );
                                AppointmentsService.update( {
                                                              id: vm.update_appointment.id,
                                                              recalled: vm.update_appointment.recalled,
                                                              paid: vm.update_appointment.recalled<3?vm.update_appointment.paid:0
                                                            }
                                ).then (
                                    function (response) {
                                      if (vm.appointmentsList[ position ].recalled == 3) {
                                            vm.appointmentsList[ position ].cancelled_at = moment();
                                            vm.appointmentsList[ position ].cancelled_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                                            vm.appointmentsList[ position ].cancelledBy = {data: vm.user};
                                            vm.appointmentsList[ position ].cancelled_by = vm.user.id;
                                            if (vm.appointmentsList[ position ].paid && vm.appointmentsList[ position ].paid==1) {
                                            vm.appointmentsList[ position ].paid=0;
                                            vm.calcsOnVisibileElements();
                                            }
                                        } else {
                                            vm.appointmentsList[ position ].cancelled_at = null;
                                            vm.appointmentsList[ position ].cancelled_at_frmt = null;
                                            vm.appointmentsList[ position ].cancelledBy = null;
                                            vm.appointmentsList[ position ].cancelled_by = null;
                                        }
                                        vm.appointmentsList[ position ].updated_by = vm.user.id;
                                        vm.appointmentsList[ position ].updatedBy = {data: vm.user};
                                        vm.appointmentsList[ position ].updated_at = moment();
                                        vm.appointmentsList[ position ].updated_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                                        vm.initTreatmentCanChange(vm.appointmentsList[ position ]);
                                        vm.showActionToast();
                                },
                                    function (response) {
                                        vm.appointmentsList[ position ].recalled = old_value;
                                        vm.checkResponse(response, vm.appointmentsList[ position ]);
                                    }
                                ) ;
                            } else {
                                //vado in booking passando id appuntamento e una volta preso il nuovo appuntamento setto come disdetto questo
                                var nl = vm.env.booking +
                                "/operator?store=" + store_id +
                                "&tenant=" + vm.env.currentTenant +
                                "&c_sid=" + vm.user.store_id +
                                "&c_role=" + vm.user.type +
                                "&callcenter=" + (vm.user.type == 'callcenter') +
                                "&appointment=" + vm.appointmentsList[ position ].id +
                                "&treatment=" + vm.appointmentsList[ position ].treatment_id +
                                "&customer=" + vm.appointmentsList[ position ].customer.data.phone +
                                "&appointmentDate=" + moment(vm.appointmentsList[ position ].date_start).format('YYYY-MM-DD HH:mm') +
                                "&token="+vm.token;
                                //alert (nl);
                                window.location.href = nl;
                            }
                        },
                        function() {
                            vm.appointmentsList[ position ].recalled = old_value;
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };

        /**
         * Non usata
         */
        vm.rememberAp = function ( id ) {
            $log.info( 'Ricordato Non-Ricordato' );
            vm.activeAppointment = null;
            var position = vm.appointmentsList.map( function( x ) { return x.id; } ).indexOf( id );
            if( position !== -1 ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent(
                        'Sicuro di voler ' +
                        (
                            vm.appointmentsList[ position ].recalled
                            ? 'Segnare come RICORDATO'
                            : 'Segnare come NON Ricordato'
                        ) +
                        ' questo appuntamento?'
                    )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            if( vm.appointmentsList[ position ].recalled ){
                                vm.appointmentsList[ position ].recalled = 0;
                            }else{
                                vm.appointmentsList[ position ].recalled = 1;
                            };
                            vm.appointmentsList[ position ].updated_at = moment();
                            vm.appointmentsList[ position ].updated_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                            angular.copy( vm.appointmentsList[ position ], vm.update_appointment );
                            AppointmentsService.update( {id: vm.update_appointment.id, recalled: vm.update_appointment.recalled } );
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };
        vm.minPrice = function() {
            if (vm.activeAppointment && vm.activeAppointment.price_discounted) {
                return (vm.activeAppointment.price_discounted<vm.sogliaAcconto?(vm.minAccontoPerc/100)*vm.activeAppointment.price_discounted:vm.minAcconto);
            } else {
                return 0;
            }
        }
        /* Pagato Non-Pagato */
        vm.payAp = function ( id ) {
            $log.info( 'Pagato Non-Pagato' );
            vm.activeAppointment = null;
            var position = vm.appointmentsList.map( function( x ) { return x.id; } ).indexOf( id );
            if( position !== -1 ) {
                if (vm.appointmentsList[ position ].recalled == 3) {
                       vm.showActionToast( "Appuntamento disdetto." );
                       return;
                }
                if (vm.appointmentsList[ position ].recalled == 4) {
                      vm.showActionToast( "Appuntamento spostato." );
                      return;
               }
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent(
                        'Sicuro di voler ' +
                        (
                            vm.appointmentsList[ position ].paid
                            ? 'Segnare come NON PAGATO'
                            : 'Segnare come Pagato'
                        ) +
                        ' questo appuntamento?'
                    )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            var newpaid = 1;
                            if( vm.appointmentsList[ position ].paid ){
                              newpaid = 0;
                            };
                            AppointmentsService.update( {id: vm.appointmentsList[ position ].id, paid: newpaid, updatingField: 'price' } ).then(
                                function (response) {
                                  vm.appointmentsList[ position ].paid = newpaid;
                                  vm.calcsOnVisibileElements();
                                  vm.appointmentsList[ position ].updated_by = vm.user.id;
                                  vm.appointmentsList[ position ].updatedBy = {data: vm.user};
                                  vm.appointmentsList[ position ].updated_at = moment();
                                  vm.appointmentsList[ position ].updated_at_frmt = moment().format("DD/MM/YYYY HH:mm");
                                },
                                function (response) {
                                  vm.checkResponse(response, vm.appointmentsList[ position ]);
                                }
                            );
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };
        /* Date Changed - Load Availabilities */
        vm.selectedAvaibilityRequired = false;
        vm.selectedAvaibility = null;
        vm.availabilitiesList = [];
        vm.treatment = {};
        vm.availabilityLoad = function() {
            vm.availabilitiesList = [];

            var date_start = moment( vm.treatmentdate ).format( 'YYYY-MM-DD' );

            /*
            if( moment( moment().format( 'YYYY-MM-DD' ) ).isSame( date_start ) ) {
                date_start += ' ' + moment().format( 'HH:mm' );
            } else {
                date_start += ' 00:00:00';
            };
            */
            date_start += ' 00:00:00';

            var options = {
                date_start: date_start,
                treatment_id: vm.activeAppointment.treatment_id,
                user_id: vm.activeAppointment.user_id,
                store_id: vm.storeId,
                available: true,
                all: true,
            };
            return AppointmentsService
                .all( options )
                .then(
                    function( response ){
                        if( response.data && response.data.data ) {
                            if( response.data.data.length > 0 ) {
                              angular.forEach(response.data.data, function (el) {
                                el.customer_id = null;
                                if (el.date_start==null && el.hours!=null) {
                                  el.store_id = options.store_id;
                                  el.treatment_id = vm.activeAppointment.treatment_id;
                                  el.price = vm.treatment.start_price;
                                  el.price_full = vm.treatment.start_price;
                                  el.price_treatment = vm.treatment.start_price;
                                  el.date_start = el.date + ' ' + el.hours;
                                  el.date_end = moment(el.date_start).add(vm.treatment.duration, 'minutes').format("YYYY-MM-DD HH:mm:ss");
                                  delete el.date;
                                  delete el.minute;
                                  delete el.hours;
                                }
                                el.role = {data: vm.getUserRole(el.user_id, options.store_id)};
                                vm.availabilitiesList.push(el);
                              });
                            } else {
                                vm.showActionToast( "Nessuna disponibilità in questo periodo." );
                            };
                          }
                        },
                        function( rejection ){
                            angular.element( "md-backdrop.md-select-backdrop" ).click();
                            if( rejection.data.message === "The given data failed to pass validation." ) {
                               rejection.data.message = "Controllare la data inserita!";
                            };
                            var alert = $mdDialog.alert()
                                .title( 'Attenzione' )
                                .ariaLabel( 'Attenzione' )
                                .textContent( rejection.data.message )
                                .ok( 'Ok' )
                            ;
                            return $mdDialog
                                .show( alert )
                                .finally(
                                    function() {
                                        alert = undefined;
                                        angular.element( "#treatmentdate" ).removeClass( 'md-datepicker-remove-red-border' );
                                    }
                                )
                            ;
                        }
                    )
                ;
            };

            //return vm.showActionToast( "Impostare correttamente l'oeratrice e il trattamento." );
        //};
        $scope.$watch( 'ap.selectedAvaibility', function ( newValue ) {
            if( newValue !== null ) {
                vm.undoVisible = true;
                if( vm.isNewAppointment && vm.availabilitiesList.length ) {
                    vm.activeAppointment.price = vm.availabilitiesList[ 0 ].price;
                    vm.activeAppointment.price_full = vm.availabilitiesList[ 0 ].price;
                    vm.activeAppointment.price_treatment = vm.availabilitiesList[ 0 ].price;
                }
            }
        });

        $scope.$watch( 'ap.showLastname', function ( newValue ) {
            if( newValue !== null ) {
                vm.query.showLastname = newValue;
                vm.saveStatus();
            }
        });

        vm.subscriptionNewIdChange = function () {
            if(vm.activeAppointment) {
                var newValue = vm.activeAppointment.subscription_new_id;
                if (( newValue !== null )
                    && (newValue !== undefined)) {
                    //vm.activeAppointment.customer_subscription_id = null;
                    vm.genericPaymentChangeAny(false);
                }
            }
        };

        vm.newSubscriptionIdChange = function () {
            if(vm.activeAppointment) {
                var newValue = vm.activeAppointment.new_subscription_id;
                if (( newValue !== null )
                    && (newValue !== undefined)) {
                    //vm.activeAppointment.customer_subscription_id = null;
                    vm.genericPaymentChangeAny(false);
                }
            }
        };

        vm.appointmentTypeChange = function () {
            vm.genericPaymentChangeAny(false);
        };

        vm.appointmentTypeAppChange = function () {
            var newValue = vm.activeAppointment.type;
            vm.maxDiscount = vm.maxDiscountConf;
            if (!newValue || newValue!='abb') {
                vm.activeAppointment.customer_subscription_id = null;
                vm.activeAppointment.subscription_new_id = null;
            }
            if (vm.activeAppointment.type_app == 'app') {
                vm.activeAppointment.payment_type = 'C';
                vm.maxDiscount = vm.maxDiscountConf*3;
            }
            vm.genericPaymentChangeAny(false);
            vm.priceDiscountedCheck();
        };

        vm.initPriceFullPriceDiscounted = function(elem) {
            /**
             * elem.price_treatment se non inizializzato caso pregresso
             */
            var priceProd = 0;
            if (vm.isAcquistoDip(elem)) {
                priceProd = elem.product_price/2 + elem.product_price10/2;
            } else {
                priceProd = elem.product_price + elem.product_price10;
            }
            if (!elem.price_discounted) {
                elem.price_discounted = elem.price + elem.price_due - elem.ratePayment;
            }
            if (vm.isStorno(elem)) {
                elem.price_discounted = 0 - elem.price_discounted;
            }
            if (elem.price_treatment===null) {
                elem.price_treatment = elem.price_discounted - priceProd;
            }
            elem.price_full = parseFloat(new Number(elem.price_treatment + priceProd).toFixed(2));
            if (vm.isStorno(elem)) {
                elem.price_full = 0 - elem.price_full;
            }
            if (elem.type_app == 'app') {
                vm.maxDiscount = vm.maxDiscountConf*3;
            } else {
                vm.maxDiscount = vm.maxDiscountConf;
            }
        };

        vm.paymentDiscountPriceRateUpdate = function (isInit) {
            vm.initPriceFullPriceDiscounted(vm.activeAppointment);
            if (!isInit) {
              /**
               * va controllato che il prezzo non possa essere 0 se non in abbonamento e non ritiro prodotti
               */
              //$log.info(vm.activeAppointment);
              $scope.appointmentForm.price_treatment.$setValidity('notzero', true);
              if ('abb' != vm.activeAppointment.type
                  && !vm.activeAppointment.type_app=='free'
                  && !vm.activeAppointment.treatment_name.endsWith('GP')
                  && !vm.activeAppointment.treatment_name.startsWith('Ritiro')
                  && !vm.activeAppointment.treatment_name.startsWith('Colloquio')
                  && !vm.activeAppointment.treatment_name.startsWith('Accademy')
                  && !vm.activeAppointment.treatment_name.endsWith('omaggio')
                  && !vm.activeAppointment.treatment_name.endsWith('conoscitivo')
                  && !vm.isAcquistoDip(vm.activeAppointment)
                  ) {
                if (vm.activeAppointment.price_treatment==0) {
                  $scope.appointmentForm.price_treatment.$setValidity('notzero', false);
                }
              }
              /*$scope.appointmentForm.price_treatment.$setValidity('infcompresi', true);
              if ((vm.activeAppointment.product_price_in + vm.activeAppointment.product_price10_in)>vm.activeAppointment.price_treatment) {
                  if (vm.activeAppointment.type!='abb' && vm.activeAppointment) {//TODO <1
                      $log.info("checkInfoCompresi");
                      $log.info(vm.activeAppointment);
                      $scope.appointmentForm.price_treatment.$setValidity('infcompresi', false);
                  }
              }*/

              /*if (vm.activeAppointment.totalcredit>0
                  && vm.activeAppointment.credit_usage!=null
                  && vm.activeAppointment.credit_usage.sconto<vm.activeAppointment.price_full) {
                    vm.activeAppointment.credit = vm.activeAppointment.credit_usage.credit;
                    vm.activeAppointment.price = vm.activeAppointment.price_full-vm.activeAppointment.credit_usage.sconto;
                    vm.activeAppointment.discount = vm.activeAppointment.credit_usage.sconto;
              } else {
                vm.activeAppointment.credit = 0;
                vm.activeAppointment.discount = 0;
                vm.activeAppointment.credit_usage = undefined;
                vm.activeAppointment.price = vm.activeAppointment.price_full;
              }*/
              /*if (vm.activeAppointment.customer!=null) {
                vm.activeAppointment.customer.data.credit = vm.activeAppointment.totalcredit - vm.activeAppointment.credit;
              }*/
                vm.activeAppointment.price_discounted = vm.activeAppointment.price_full;
                vm.activeAppointment.price = vm.activeAppointment.ratePayment+vm.activeAppointment.price_discounted;
                $scope.appointmentForm.price.$setValidity('lowerpayment', true);
                  vm.activeAppointment.price_due = 0;
                  vm.activeAppointment.num_rate = 0;
                  vm.activeAppointment.rateizzazione_type = null;
            }
        };

        /**
         * Aggiorna abbonamento, tipo app treatment price e tutto a cascata in base a f_exclude
         */
        vm.genericPaymentChangeAny = function(isInit) {
            if (!isInit) {
                vm.activeAppointment.price_treatment = 0;
                if (vm.activeAppointment.type=='abb') {
                    // New subscription with union
                    if (vm.activeAppointment.new_subscription_id && vm.activeAppointment.union) {
                        angular.forEach(vm.subscriptionsList, function (subscription) {
                            if((subscription.id == vm.activeAppointment.new_subscription_id)) {
                                vm.newSubscription = subscription;
                                vm.maxRate = vm.user.type=='admin'?99:vm.newSubscription.max_rate;
                                vm.minAcconto = vm.user.type=='admin'?0:vm.newSubscription.min_deposit;
                                if (!vm.maxRate) {
                                    vm.activeAppointment.f_abb_payall = 1;
                                }
                                if (vm.activeAppointment.f_abb_payall) {
                                    vm.activeAppointment.price_treatment = parseFloat(subscription.price_promo);
                                } else {
                                    vm.activeAppointment.price_treatment = parseFloat(subscription.price);
                                }
                            }
                        });
                    }
                    else if (vm.activeAppointment.subscription_new_id) {
                        angular.forEach(vm.subscriptionsList, function (subscription) {
                            if((subscription.id == vm.activeAppointment.subscription_new_id)) {
                                vm.newSubscription = subscription;
                                vm.maxRate = vm.user.type=='admin'?99:vm.newSubscription.max_rate;
                                vm.minAcconto = vm.user.type=='admin'?0:vm.newSubscription.min_deposit;
                                if (!vm.maxRate) {
                                    vm.activeAppointment.f_abb_payall = 1;
                                }
                                if (vm.activeAppointment.f_abb_payall) {
                                    vm.activeAppointment.price_treatment = parseFloat(subscription.price_promo);
                                } else {
                                    vm.activeAppointment.price_treatment = parseFloat(subscription.price);
                                }
                            }
                        });
                    }  else if (vm.activeAppointment.customer_subscription_id) {
                        angular.forEach(vm.subscriptionsListByCustomer,
                            function (cs) {
                                if((cs.id == vm.activeAppointment.customer_subscription_id)) {
                                    vm.customerSubscription = cs;
                                    vm.maxRate = 6;
                                    if (vm.activeAppointment.id == cs.appointment_id) {
                                        vm.maxRate = vm.user.type=='admin'?99:cs.subscription.data.max_rate;
                                        vm.minAcconto = vm.user.type=='admin'?0:cs.subscription.data.min_deposit;
                                        if (!vm.maxRate) {
                                            vm.activeAppointment.f_abb_payall = 1;
                                        }
                                        if (vm.activeAppointment.f_abb_payall) {
                                            vm.activeAppointment.price_treatment = parseFloat(cs.subscription.data.price_promo);
                                        } else {
                                            vm.activeAppointment.price_treatment = parseFloat(cs.subscription.data.price);
                                        }
                                    }
                                }
                            }
                        );
                    }
                    if (vm.activeAppointment.f_exclude) {
                        vm.activeAppointment.price_treatment += vm.getTreatmentPrice();
                    }
                } else {
                    vm.newSubscription = null;
                    vm.customerSubscription = null;
                    vm.activeAppointment.customer_subscription_id = null;
                    vm.activeAppointment.subscription_new_id = null;
                    vm.activeAppointment.f_exclude = 0;
                    vm.activeAppointment.price_treatment += vm.getTreatmentPrice();
                }
            }
            vm.paymentDiscountPriceRateUpdate(isInit);
            vm.paymentPosUpdate();
        };

        vm.customerSubscriptionIdChange = function () {
            if (vm.activeAppointment) {
                var newValue = vm.activeAppointment.customer_subscription_id;
                if ( ( newValue !== null )
                    && (newValue !== undefined)) {
                    //vm.activeAppointment.subscription_new_id = null;
                    vm.genericPaymentChangeAny(false);
                }
            }

            if (vm.activeAppointment.customer_subscription_id && vm.activeAppointment.new_subscription_id) {
                vm.activeAppointment.union = 1;
            }

        };

        vm.getTreatmentPrice = function() {
            if (vm.activeAppointment && vm.treatment) {
                if (!vm.activeAppointment.type_app || vm.activeAppointment.type_app=='app') {
                    return vm.treatment.start_price;
                }
                if (vm.activeAppointment.type_app == 'promo') {
                    return vm.treatment.promo_price?vm.treatment.promo_price:vm.treatment.start_price*0.75;
                }
                if (vm.activeAppointment.type_app == 'free') {
                    return 0;
                }
            }
            return 0;
        }

        /*vm.removeOldSubscription = function() {
            if (!vm.activeAppointment.union) {
                vm.activeAppointment.customer_subscription_id = null;
            }
        };*/

        vm.removeNewSubscriptionId = function() {
            if (!vm.activeAppointment.union) {
                vm.activeAppointment.new_subscription_id = null;
            }
        };

        vm.fExcludeChange = function() {
            if (vm.activeAppointment && vm.activeAppointment.type=='abb') {
                if (vm.activeAppointment.customer_subscription_id) {
                    vm.customerSubscriptionIdChange(vm.activeAppointment.customer_subscription_id,vm.activeAppointment.customer_subscription_id);
                } else if (vm.activeAppointment.subscription_new_id) {
                    vm.subscriptionNewIdChange(vm.activeAppointment.subscription_new_id,vm.activeAppointment.subscription_new_id);
                }
            }
        };

        /**
         * verifico se è presente documento firmato associato al trattamento (se il trattamento lo richiede)
         */
        vm.initDocuments = function(app) {
            if (!vm.env.documentsEnabled) {
                return;
            }
            //$log.info('trt',app.treatment);
            //$log.info("docs",app.documents);
            /**
             * verifico se presente privacy + autorizzazione foto + consenso al trattamento corrente
             */
            app.docPrivacyOk = false;
            app.docCovidOk = false;
            app.docPicturesOk = false;
            app.docContrPicturesOk = false;
            app.docTreatmentOk = false;
            if (!app.treatment.data.document_template_id) {
                app.docTreatmentOk = true;
            }
            angular.forEach(app.documents.data, function(doc) {
                if (doc.document_type_id == 301 && !app.docPrivacyOk) {
                    app.docPrivacyOk = true;
                    app.docPrivacy = {'data':doc};
                } else if (doc.document_type_id == 302 && !app.docPicturesOk) {
                    app.docPicturesOk = true;
                    app.docPictures = {'data':doc};
                } else if (doc.document_type_id == 306 && !app.docContrPicturesOk) {
                    app.docContrPicturesOk = true;
                    app.docContrPictures = {'data':doc};
                } else if (doc.document_type_id == 305 && !app.docCovidOk) {
                    //deve essere della data dell'appuntamento
                    $log.info(app);
                    $log.info(doc);
                    var cd = moment(doc.created_at.date).format('YYYY-MM-DD');
                    var ad = moment(app.date_start).format('YYYY-MM-DD');

                    //$log.info('CD: '+cd);
                    //$log.info('AD: '+ad);

                    app.docCovidOk = cd==ad;
                    app.docCovid = {'data':doc};
                } else if (doc.document_template_id == app.treatment.data.document_template_id && !app.docTreatmentOk) {
                    app.docTreatmentOk = true;
                    app.docTreatment = {'data':doc};
                }
            });
            //$log.info("docPrivacy "+app.id,app.docPrivacyOk);
            //$log.info("docCovid "+app.id,app.docCovidOk);
            //$log.info("docPictures "+app.id,app.docPicturesOk);
            //$log.info("docTreatmentOk "+app.id,app.docTreatmentOk);
        };

        vm.initTreatmentCanChange = function(app) {
            app.treatmentCanChange = false;
            if (app.treatment_id) {
                //$log.info("App "+app.id+" recalled is "+app.recalled);
                app.treatmentCanChange = !app.closed
                    && app.recalled<3
                    && app.treatment_id != 99
                    && (vm.user.type == 'admin'
                    || app.treatment_id <=6
                     || (app.treatment_id >= 126 && app.treatment_id <= 129)
                     || (app.treatment_id >= 601 && app.treatment_id <= 610)
                    );
            }
        };
        vm.initRatePayment = function(app) {
            app.ratePayment = 0;
            app.ratePaymentIds = [];
            if (app.customer && app.customer.data && app.customer.data.payments) {
                angular.forEach(app.customer.data.payments.data, function(payment) {
                    if (payment.selected) {
                        app.ratePayment+=payment.total;
                        payment.selected = true;
                        app.ratePaymentIds.push(payment.id);
                    }
                });
            }
            if (app.payments && app.payments.data) {
                angular.forEach(app.payments.data, function(payment) {
                    if (payment.selected===undefined) {
                        payment.selected = true;
                    }
                    if (payment.selected) {
                        app.ratePayment+=payment.total;
                        app.ratePaymentIds.push(payment.id);
                    }
                });
            }
        };

        vm.rataSelectionChange = function(p) {
            vm.activeAppointment.price = vm.activeAppointment.price_discounted;
            vm.initRatePayment(vm.activeAppointment);
            vm.activeAppointment.price+=vm.activeAppointment.ratePayment;
            vm.activeAppointment.price_due = 0;
            vm.activeAppointment.num_rate = 0;
            vm.paymentPosUpdate();
        };

        /* Users */
        vm.userRolesList = [];
        vm.userRolesListAll = []
        vm.userRolesListCall = [];
        vm.userRolesLoad = function () {
            if (vm.userRolesListAll.length==0) {
                var pars = {with: 'user'};
                return UsersService.allRoles( pars ).then( function( response ) {
                    if( response.data && response.data.data ) {
                        vm.userRolesListAll = response.data.data;
                        //$log.info(vm.userRolesListAll);
                        vm.userRolesList = vm.filterRolesXStore();
                        //$log.info(vm.userRolesList);
                        vm.userRolesListCall = vm.filterRolesXRole('callcenter');
                        //$log.info(vm.userRolesListCall);
                        vm.appointmentsListLoad(null);//carico solo ora perchè serve la lista utenti
                    }
                });
            } else {
                vm.userRolesList = vm.filterRolesXStore();
                vm.userRolesListCall = vm.filterRolesXRole('callcenter');
                vm.appointmentsListLoad(null);//carico solo ora perchè serve la lista utenti
            }
        };
        vm.filterRolesXStore = function() {
            var fs = {active: true};
            if (vm.storeId) {
                fs.store_id = vm.storeId;
            } else {
                //fs.store_id = '>0';
            }
            return $filter('filter')(vm.userRolesListAll, fs, true);
        };
        vm.filterRolesXRole = function (role) {
            var fs = {active: true, role: role};
            return $filter('filter')(vm.userRolesListAll, fs, true);
        };

        vm.getUserRole = function(user_id, store_id) {
          var res = null;
            angular.forEach(vm.userRolesList, function (r){
                if (r.user_id == user_id && r.store_id == store_id) {
                    res = r;
                }
            });
            if (res != null) {
              return res;
            }
            $log.error("non trovato ruolo per utente " + user_id + "/" + store_id);
            return {id: user_id, color: '#888888'};
        };
        //---------- Sidebar -------------------------------------//
        vm.testsVisible = false;
        vm.currentSubscription = '';
        vm.isDeleteAllowed = true;
        vm.undoVisible = false;
        vm.img_loading = false;
        vm.activeAppointment = null;
        vm.backup_appointment = {};
        vm.update_appointment = {};
        vm.empty_appointment = {};
        /* Element Clicked */
        vm.updatingField = '';
        vm.rowClicked = function ( appointment , field) {
            /**
             * Check if payment_pos
             */
            if (appointment.payment_type == 'P' && appointment.payment_pos_type == 'C') {
                appointment.payment_pos = appointment.price;
                appointment.payment_card = 0;
                //appointment.payment_card =
            }
            if (appointment.payment_type == 'P' && appointment.payment_pos_type == 'A') {
                appointment.payment_pos = appointment.price;
                appointment.payment_app = 0;
                //appointment.payment_card =
            }

            vm.updatingField = (field==null?'':field);
            vm.toggleRight( appointment, true);
            //$log.info(appointment);
        };
        vm.toggleRight = function ( appointment, isRowClick ) {
            vm.subscriptionsListFiltered = vm.subscriptionsList;
            vm.maxDiscount = vm.maxDiscountConf;
            vm.maxRate = 6;
            var customer_subscription_id = '';
            vm.isNewAppointment = !isRowClick;//angular.isUndefined( appointment );
            if (!isRowClick) {
                vm.updatingField = '';
            }
            if( ! vm.isNewAppointment ) {
                vm.customer_id = appointment.customer_id;
                vm.activeAppointment = appointment;

                if (appointment.treatment_id == 99) {
                    vm.card.init(appointment);
                } else if (appointment.gift_number) {
                    vm.card.filter_number_pay = appointment.gift_number;
                    vm.card.load(true);
                }

                if (vm.activeAppointment.new_subscription_id) {
                    vm.activeAppointment.subscription_new_id = vm.activeAppointment.new_subscription_id
                }

                vm.activeAppointment.union = vm.activeAppointment.customer_subscription_id && vm.activeAppointment.subscription_new_id ? 1 : 0;

                vm.checkSubscriptionByUserAndSetSubscriptionName( appointment.customer_id, appointment,
                    function () {
                        vm.treatmentdate = new Date( appointment.date_start );
                        vm.treatment = $filter("treatment")(appointment.treatment_id, vm.treatmentsList);
                        vm.storno = vm.isStorno(appointment);
                        //filtro abbonamenti in base a zone
                        vm.subscriptionsListFiltered = [];
                        angular.forEach(vm.subscriptionsList, function (s) {
                            if (vm.treatment.zone === 0) {
                                if (s.zone === 0) {
                                    vm.subscriptionsListFiltered.push(s);
                                }
                            } else {
                                if (s.zone > 0 ) {
                                    vm.subscriptionsListFiltered.push(s);
                                }
                            }
                        });
                        //$log.info(vm.activeAppointment);
                        angular.copy( vm.activeAppointment, vm.backup_appointment );
                        return $mdSidenav( 'right' ).open();
                    }
                );
            }
            else {
                vm.treatmentdate = new Date();
                vm.customer_id = null;
                /**
                 * Svuoto la ricerca customers e la lista
                */
                vm.customersReset();
                appointment = {
                    payment_type:'C',
                    f_over:vm.portaEnabled?true:false,
                    start: moment(),
                    price_treatment:0,
                    product_price: 0,
                    product_price10:0,
                    discount:0,
                    type: null,
                    ratePayment: 0,
                    paid: 1
                };
                vm.activeAppointment = appointment;
                //$log.info(vm.activeAppointment);
                angular.copy( vm.activeAppointment, vm.backup_appointment );
                return $mdSidenav( 'right' ).open();
            }
        };
        /**
         * Verifica sconto in base ad autonomia
         */
        vm.priceDiscountedCheck = function ()  {
            if (vm.storno) {
                vm.activeAppointment.price_treatment = vm.activeAppointment.price_discounted;
                vm.activeAppointment.price_full = 0-vm.activeAppointment.price_discounted;
                vm.activeAppointment.price = vm.activeAppointment.price_full;
                vm.paymentPosUpdate();
            } else {
                //$log.info("---------------- priceDiscountedCheck ----------");
                var md = vm.maxDiscount;
                var pMin = vm.activeAppointment.price_full/100*(100-md);
                var tri = vm.tri(vm.activeAppointment);
                if ((pMin-tri)>vm.activeAppointment.price_discounted) {
                    $scope.appointmentForm.price_discounted.$setValidity('overdiscount', false);
                } else {
                    $scope.appointmentForm.price_discounted.$setValidity('overdiscount', true);
                    //vm.paymentDiscountPriceRateUpdate(false);
                    var p = vm.activeAppointment.ratePayment+vm.activeAppointment.price_discounted;
                    vm.activeAppointment.price = parseFloat(p.toFixed(2));
                    $scope.appointmentForm.price.$setValidity('lowerpayment', true);
                      vm.activeAppointment.price_due = 0;
                      vm.activeAppointment.num_rate = 0;
                      vm.activeAppointment.rateizzazione_type = null;
                      vm.paymentPosUpdate();
                }
            }
        };
        vm.tri = function(app) {
            app.tri = 0;
            if (app.includedProducts
                    && app.includedProducts.data
                    && app.includedProducts.data.length>0) {
                angular.forEach(app.includedProducts.data, function (s) {
                  if (!s.product_id) {
                    app.tri += (s.price*s.qty);
                  }
                });
            }
            return app.tri;
        };
        /**
         * Verifica prezzo (acconto) in base a regole predefinite
         * E aggiorna importo rateizzato
         */
        vm.priceCheck = function ()  {
            $scope.appointmentForm.price.$setValidity('lowerpayment', true);
            var tri = vm.tri(vm.activeAppointment);
            var minPayment = (vm.activeAppointment.price_discounted+tri)<vm.sogliaAcconto
                    ?(vm.minAccontoPerc/100)*(vm.activeAppointment.price_discounted+tri)
                    :vm.minAcconto;
            minPayment = minPayment - tri;
            minPayment+=vm.activeAppointment.ratePayment;
            if (minPayment<0) {
                minPayment = 0;
            }
            var minPaymentStr = $filter('number')(minPayment,2);
            var ratePaymentStr = $filter('number')(vm.activeAppointment.ratePayment,2);
            if (vm.activeAppointment.price>vm.activeAppointment.ratePayment+vm.activeAppointment.price_discounted) {
                vm.activeAppointment.price = vm.activeAppointment.ratePayment+vm.activeAppointment.price_discounted;
                vm.activeAppointment.rateizzazione_type = undefined;
                vm.activeAppointment.price_due = 0;
                vm.activeAppointment.num_rate = 0;
            } else if (vm.activeAppointment.price==vm.activeAppointment.ratePayment+vm.activeAppointment.price_discounted) {
                vm.activeAppointment.rateizzazione_type = undefined;
                vm.activeAppointment.price_due = 0;
                vm.activeAppointment.num_rate = 0;
            } else if (vm.activeAppointment.price<minPayment) {
                vm.messageLowerPayment = " "
                    + minPaymentStr + "&euro;"
                    +(vm.activeAppointment.price_discounted<vm.sogliaAcconto?', cio&egrave; al '+vm.minAccontoPerc+'% del prezzo':
                        (vm.activeAppointment.ratePayment>0?', cio&egrave; a '+vm.minAcconto+'&euro;':'.'))
                    + (vm.activeAppointment.ratePayment>0?', pi&ugrave; l\'importo delle rate di ' + ratePaymentStr + "&euro;." :'');
                $scope.appointmentForm.price.$setValidity('lowerpayment', false);
                //$log.info("message = "+vm.messageLowerPayment);
                return;
            } else {
                if (!vm.activeAppointment.rateizzazione_type) {
                    vm.activeAppointment.rateizzazione_type = 'M';
                }
                var pd = vm.activeAppointment.ratePayment+vm.activeAppointment.price_discounted-vm.activeAppointment.price;
                vm.activeAppointment.price_due = parseFloat(pd.toFixed(2));
                if (!vm.activeAppointment.num_rate) {
                    vm.activeAppointment.num_rate = 1;
                }
            }
            vm.paymentPosUpdate();
        };

        vm.paymentPosUpdate = function ()  {
          /**
          * verifica f_abb_payall
          */
          if (vm.activeAppointment.f_abb_payall) {
              vm.activeAppointment.payment_dil = 0;
                            vm.activeAppointment.installments_dil = null;
                            vm.activeAppointment.payment_light = 0;
                            vm.activeAppointment.installments_light = null;
                vm.activeAppointment.payment_small = 0;
                if (vm.activeAppointment.payment_type=='D'
                  || vm.activeAppointment.payment_type=='S') {
                  vm.activeAppointment.payment_type = 'C';
              }
          }
          if (vm.activeAppointment.f_ref) {
            vm.activeAppointment.payment_type = 'C';
          }
          if (vm.activeAppointment.payment_type == 'C') {//contanti
                vm.activeAppointment.payment_pos = 0;
                vm.activeAppointment.payment_card = 0;
                vm.activeAppointment.payment_app = 0;
                vm.activeAppointment.payment_pos_type = null;
                vm.activeAppointment.payment_dil = 0;
                vm.activeAppointment.installments_dil = null;
                vm.activeAppointment.payment_apppago = 0;
                vm.activeAppointment.installments_apppago = null;
                vm.activeAppointment.payment_light = 0;
                vm.activeAppointment.installments_light = null;
                vm.activeAppointment.payment_small = 0;
                vm.activeAppointment.payment_gift = 0;
                vm.activeAppointment.gift_number = null;
                vm.activeAppointment.payment_satis = 0;
                vm.activeAppointment.payment_stripe = 0;
                vm.activeAppointment.payment_bon = 0;
                vm.activeAppointment.payment_check = 0;
          } else if (vm.activeAppointment.payment_type == 'P') {//pos
              vm.activeAppointment.payment_pos = vm.activeAppointment.price;
              vm.activeAppointment.payment_card = 0;
              vm.activeAppointment.payment_app = 0;
              vm.activeAppointment.payment_dil = 0;
              vm.activeAppointment.installments_dil = null;
              vm.activeAppointment.payment_apppago = 0;
              vm.activeAppointment.installments_apppago = null;
              vm.activeAppointment.payment_light = 0;
              vm.activeAppointment.installments_light = null;
              vm.activeAppointment.payment_small = 0;
              vm.activeAppointment.payment_satis = 0;
              vm.activeAppointment.payment_stripe = 0;
              vm.activeAppointment.payment_gift = 0;
              vm.activeAppointment.gift_number = null;
              vm.activeAppointment.payment_bon = 0;
              vm.activeAppointment.payment_check = 0;
          } else if (vm.activeAppointment.payment_type == 'D') {//pagodil
              vm.activeAppointment.payment_dil = vm.activeAppointment.price;
              vm.activeAppointment.payment_apppago = 0;
              vm.activeAppointment.installments_apppago = null;
              vm.activeAppointment.payment_light = 0;
              vm.activeAppointment.installments_light = null;
              vm.activeAppointment.payment_small = 0;
              vm.activeAppointment.payment_satis = 0;
              vm.activeAppointment.payment_stripe = 0;
              vm.activeAppointment.payment_gift = 0;
              vm.activeAppointment.gift_number = null;
              vm.activeAppointment.payment_pos = 0;
              vm.activeAppointment.payment_card = 0;
              vm.activeAppointment.payment_app = 0;
              vm.activeAppointment.payment_pos_type = null;
              vm.activeAppointment.payment_bon = 0;
              vm.activeAppointment.payment_check = 0;
          } else if (vm.activeAppointment.payment_type == 'L') {//pagolight
                vm.activeAppointment.payment_light = vm.activeAppointment.price;
                vm.activeAppointment.payment_dil = 0;
                vm.activeAppointment.installments_dil = null;
                vm.activeAppointment.payment_apppago = 0;
                vm.activeAppointment.installments_apppago = null;
                vm.activeAppointment.payment_small = 0;
                vm.activeAppointment.payment_satis = 0;
                vm.activeAppointment.payment_stripe = 0;
                vm.activeAppointment.payment_gift = 0;
                vm.activeAppointment.gift_number = null;
                vm.activeAppointment.payment_pos = 0;
                vm.activeAppointment.payment_card = 0;
                vm.activeAppointment.payment_app = 0;
                vm.activeAppointment.payment_pos_type = null;
                vm.activeAppointment.payment_bon = 0;
                vm.activeAppointment.payment_check = 0;
          } else if (vm.activeAppointment.payment_type == 'B') {//bonifico
              vm.activeAppointment.payment_bon = vm.activeAppointment.price;
              vm.activeAppointment.payment_pos = 0;
              vm.activeAppointment.payment_card = 0;
              vm.activeAppointment.payment_app = 0;
              vm.activeAppointment.payment_pos_type = null;
              vm.activeAppointment.payment_dil = 0;
              vm.activeAppointment.installments_dil = null;
              vm.activeAppointment.payment_apppago = 0;
              vm.activeAppointment.installments_apppago = null;
              vm.activeAppointment.payment_light = 0;
              vm.activeAppointment.installments_light = null;
              vm.activeAppointment.payment_small = 0;
              vm.activeAppointment.payment_satis = 0;
              vm.activeAppointment.payment_stripe = 0;
              vm.activeAppointment.payment_gift = 0;
              vm.activeAppointment.gift_number = null;
              vm.activeAppointment.payment_check = 0;
          } else if (vm.activeAppointment.payment_type == 'S') {//smallpay
              vm.activeAppointment.payment_small = vm.activeAppointment.price;
              vm.activeAppointment.payment_gift = 0;
              vm.activeAppointment.gift_number = null;
              vm.activeAppointment.payment_satis = 0;
              vm.activeAppointment.payment_stripe = 0;
              vm.activeAppointment.payment_dil = 0;
              vm.activeAppointment.installments_dil = null;
              vm.activeAppointment.payment_apppago = 0;
              vm.activeAppointment.installments_apppago = null;
              vm.activeAppointment.payment_light = 0;
              vm.activeAppointment.installments_light = null;
              vm.activeAppointment.payment_pos = 0;
              vm.activeAppointment.payment_card = 0;
              vm.activeAppointment.payment_app = 0;
              vm.activeAppointment.payment_pos_type = null;
              vm.activeAppointment.payment_bon = 0;
              vm.activeAppointment.payment_check = 0;
          } else if (vm.activeAppointment.payment_type == 'G') {//gift
              vm.activeAppointment.payment_gift = vm.activeAppointment.price;
              vm.activeAppointment.payment_small = 0;
              vm.activeAppointment.payment_satis = 0;
              vm.activeAppointment.payment_stripe = 0;
              vm.activeAppointment.payment_dil = 0;
              vm.activeAppointment.installments_dil = null;
              vm.activeAppointment.payment_apppago = 0;
              vm.activeAppointment.installments_apppago = null;
              vm.activeAppointment.payment_light = 0;
              vm.activeAppointment.installments_light = null;
              vm.activeAppointment.payment_pos = 0;
              vm.activeAppointment.payment_card = 0;
              vm.activeAppointment.payment_app = 0;
              vm.activeAppointment.payment_pos_type = null;
              vm.activeAppointment.payment_bon = 0;
              vm.activeAppointment.payment_check = 0;
          } else if (vm.activeAppointment.payment_type == 'A') {//assegno
              vm.activeAppointment.payment_check = vm.activeAppointment.price;
              vm.activeAppointment.payment_gift = 0;
              vm.activeAppointment.gift_number = null;
              vm.activeAppointment.payment_small = 0;
              vm.activeAppointment.payment_satis = 0;
              vm.activeAppointment.payment_stripe = 0;
              vm.activeAppointment.payment_dil = 0;
              vm.activeAppointment.installments_dil = null;
              vm.activeAppointment.payment_apppago = 0;
              vm.activeAppointment.installments_apppago = null;
              vm.activeAppointment.payment_light = 0;
              vm.activeAppointment.installments_light = null;
              vm.activeAppointment.payment_pos = 0;
              vm.activeAppointment.payment_card = 0;
              vm.activeAppointment.payment_app = 0;
              vm.activeAppointment.payment_pos_type = null;
              vm.activeAppointment.payment_bon = 0;
          } else if (vm.activeAppointment.payment_type == 'T') {//satispay
              vm.activeAppointment.payment_satis = vm.activeAppointment.price;
              vm.activeAppointment.payment_gift = 0;
              vm.activeAppointment.gift_number = null;
              vm.activeAppointment.payment_small = 0;
              vm.activeAppointment.payment_stripe = 0;
              vm.activeAppointment.payment_dil = 0;
              vm.activeAppointment.installments_dil = null;
              vm.activeAppointment.payment_apppago = 0;
              vm.activeAppointment.installments_apppago = null;
              vm.activeAppointment.payment_light = 0;
              vm.activeAppointment.installments_light = null;
              vm.activeAppointment.payment_pos = 0;
              vm.activeAppointment.payment_card = 0;
              vm.activeAppointment.payment_app = 0;
              vm.activeAppointment.payment_pos_type = null;
              vm.activeAppointment.payment_bon = 0;
              vm.activeAppointment.payment_check = 0;
          }
          else if (vm.activeAppointment.payment_type == 'M') {
              vm.activeAppointment.payment_pos_type = null;
          } else if (vm.activeAppointment.payment_type == 'E') {//pago app
            vm.activeAppointment.payment_dil = 0;
            vm.activeAppointment.installments_dil = null;
            vm.activeAppointment.payment_apppago = vm.activeAppointment.price;
            //vm.activeAppointment.installments_apppago = null;
            vm.activeAppointment.payment_light = 0;
            vm.activeAppointment.installments_light = null;
            vm.activeAppointment.payment_small = 0;
            vm.activeAppointment.payment_satis = 0;
            vm.activeAppointment.payment_stripe = 0;
            vm.activeAppointment.payment_gift = 0;
            vm.activeAppointment.gift_number = null;
            vm.activeAppointment.payment_pos = 0;
            vm.activeAppointment.payment_card = 0;
            vm.activeAppointment.payment_app = 0;
            vm.activeAppointment.payment_pos_type = null;
            vm.activeAppointment.payment_bon = 0;
            vm.activeAppointment.payment_check = 0;
          } else if (vm.activeAppointment.payment_type == 'I') {//stripe
                vm.activeAppointment.payment_stripe = vm.activeAppointment.price;
                vm.activeAppointment.payment_dil = 0;
                vm.activeAppointment.installments_dil = null;
                vm.activeAppointment.payment_apppago = 0;
                vm.activeAppointment.installments_apppago = null;
                vm.activeAppointment.payment_light = 0;
                vm.activeAppointment.installments_light = null;
                vm.activeAppointment.payment_cc = 0;
                vm.activeAppointment.payment_small = 0;
                vm.activeAppointment.payment_satis = 0;
                vm.activeAppointment.payment_gift = 0;
                vm.activeAppointment.gift_number = null;
                vm.activeAppointment.payment_pos = 0;
                vm.activeAppointment.payment_card = 0;
                vm.activeAppointment.payment_app = 0;
                vm.activeAppointment.payment_pos_type = null;
                vm.activeAppointment.payment_bon = 0;
                vm.activeAppointment.payment_check = 0;
            }
        };

        vm.isStorno = function (elem) {
            return elem && elem.treatment_id &&
                    (elem.treatment_id == 85 ||
                            elem.treatment_id == 86 ||
                            elem.treatment_id == 87 ||
                            elem.treatment_id == 156 ||
                            elem.treatment_id == 157 ||
                            elem.treatment_id == 158 ||
                            elem.treatment_id == 159
                    );
        };

        vm.closeSidebar = function () {
            if( vm.undoVisible ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .textContent( 'Ci sono delle modifiche non commissionate, proseguire?' )
                    .ariaLabel( 'Attenzione' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then( vm.undo )
                    .finally(
                        function() {
                            confirm = undefined;
                            //vm.hidePreview();
                        }
                    )
                ;
            } else {
                vm.resetAll();
            };
        };
//         /* Load Customers */
//        vm.customersList = [];
//        vm.customersLoad = function ( customer_id ) {
//            vm.customersList = [];
//            vm.query.filter_customer = '';
//
//            return CustomerService.all( { search: "store_id:"+vm.storeId + (customer_id!=null?";id:"+customer_id:""),
//                                        searchFields: 'store_id:='+(customer_id!=null?";id:=":"") } ).then( function( response ) {
//                if( response.data && response.data.data ) {
//                    vm.customersList = response.data.data.map(
//                        function( customer ) {
//                            customer.fullName =  (
//                                ( customer.firstname || '' )
//                                + ' '
//                                + ( customer.lastname || '' )
//                            ).toUpperCase();
//
//                            return customer;
//                        }
//                    );
//
//                    if( customer_id )
//                        vm.customer_id = customer_id;
//
//                    $timeout(
//                        function() {
//                            vm.customersLoading = false;
//                        }, 60
//                    )
//                };
//            });
//        };
//        /* Controllo se c'è un Customer Id nell'URL */
//        if( customer_id && angular.isDefined( customer_id ) ) {
//            vm.customersLoading = true;
//            $timeout(
//                function() {
//                    vm.toggleRight().then(
//                        function() {
//                            vm.customersLoad( customer_id );
//                        }
//                    );
//                },
//                200
//            );
//        };
        /* Form Reset */
       vm.activeStartChange = function(trt) {
         if (vm.activeAppointment.start!=null && vm.activeAppointment.treatment_id!=null){
           var t = trt!=null?trt:$filter('treatment')(vm.activeAppointment.treatment_id, vm.treatmentsList);
           vm.activeAppointment.end = moment(vm.activeAppointment.start).add(t.min_duration, 'minutes');
         }
       };
       vm.storno = false;
       vm.activeTreatmentChange = function() {
         vm.resetAvailabilities();
         var t = $filter('treatment')(vm.activeAppointment.treatment_id, vm.treatmentsList);
         vm.treatment = t;
         if(vm.treatment.id == 99) {
             vm.treatment.start_price = 0;
         }
         vm.activeAppointment.treatment_name = t.name;
         vm.storno = vm.isStorno(vm.activeAppointment);
         vm.appointmentTypeChange();
         vm.activeStartChange(t);
       };
       vm.resetAvailabilities = function() {
            vm.selectedAvaibility = null;
            vm.availabilitiesList = [];
            if( angular.isDefined( $scope.appointmentForm.availability ) ) {
                $scope.appointmentForm.availability.$setPristine();
                $scope.appointmentForm.availability.$setUntouched();
            };
        };
        vm.angularFormReset = function() {
            $scope.appointmentForm.$setPristine();
            $scope.appointmentForm.$setUntouched();
        };
        vm.resetForm = function() {
            vm.undoVisible = false;
            return $mdSidenav( 'right' ).close().then(function() {
                vm.activeAppointment = null;
                vm.update_appointment = {};
                vm.treatmentdate = null;
                vm.selectedAvaibilityRequired = false;
                vm.resetAvailabilities();
                vm.angularFormReset();
                vm.card.filter_number = null;
                vm.card.filter_number_pay = null;
                vm.card.list = [];
                vm.card.value = null;
            });
        };
        vm.resetAll = function () {
            return $timeout( vm.resetForm, 10 );
        };
        vm.undo = function () {
            $log.info( 'Undo' );
            if( ! angular.equals( vm.activeAppointment, vm.backup_appointment ) ) {
                angular.copy( vm.backup_appointment, vm.activeAppointment );
            };
            vm.resetAll();
        };
        /* Response */
        vm.showActionToast = function( text ) {
            text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent( text )
                .action( '' )
                .highlightAction( true )
                .position( 'bottom right' )
            ;
            return $mdToast
                .show( toast )
                .finally(
                    function() {
                        toast = undefined;
                    }
                )
            ;
        };
        vm.responseStatusSuccessful = [ 200, 201, 202 ];
        vm.checkResponse = function ( response, appointment ) {
            if( vm.responseStatusSuccessful.indexOf( response.status ) === -1) {
                var errMsg = "";
                if (response.data!=null && response.data.message!=null) {
                    errMsg = response.data!=null && response.data.message!=null?response.data.message:"";
                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    vm.showActionToast("KO: " + errMsg + " " + url);
                }
                var alert = $mdDialog.alert()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( "C'è stato un problema: "+errMsg)
                    .ok( 'Ok' )
                ;
                return $mdDialog
                    .show( alert )
                    .then( function () {
                        vm.resetAll();
                        /**
                         * Ripristino il valore precedente contenuto in appointment.user.data
                         */
                        vm.operatorChange.reset(appointment);
                    })
                    .finally(
                        function() {
                            alert = undefined;
                        }
                    )
                ;
            } else {
                /**
                 * Aggiorno user.data con il nuovo valore
                 */
                vm.operatorChange.complete(appointment);
                vm.showActionToast();
                return vm.resetAll();
            };
        };

        // Salva e Aggiorna
        vm.save = function ( appointment ) {
            $log.info( 'Salva' );
            if( angular.isDefined( appointment ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler inserire questo appuntamento?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            angular.copy( appointment, vm.update_appointment );
                            vm.update_appointment.customer_id = vm.customer_id;
                            vm.update_appointment.by_operator = vm.userId;
                            vm.update_appointment.confirmed = 1;
                            //vm.update_appointment.paid = 0;
                            vm.update_appointment.new_customer = 0;
                            vm.update_appointment.store_id = vm.storeId;

                            if( vm.selectedAvaibility !== null ) {
                                vm.update_appointment.date_start = vm.availabilitiesList[ vm.selectedAvaibility ].date_start;
                                vm.update_appointment.date_end = vm.availabilitiesList[ vm.selectedAvaibility ].date_end;
                            } else if (vm.activeAppointment.f_over) {
                              var dataApp = moment(vm.treatmentdate).format('YYYY-MM-DD');
                              vm.update_appointment.date_start = dataApp + ' ' + moment(appointment.start).format('HH:mm:ss');
                              vm.update_appointment.date_end = dataApp + ' ' + moment(appointment.end).format('HH:mm:ss');
                            }
                            delete vm.update_appointment.start;
                            delete vm.update_appointment.end;

                            AppointmentsService
                                .save( vm.update_appointment )
                                .then(
                                    function( response ) {

                                        vm.checkResponse( response );
                                        if( response && response.data && response.data.data ) {
                                            var elem = response.data.data
                                                , position = vm.customersList.map( function( x ) { return x.id; } ).indexOf( vm.customer_id );
                                            ;

                                            vm.dateFormat(elem, true);

                                            elem.subscription_new_id = null;
                                            elem.treatment_name = $filter('treatmentIdtoName')(elem.treatment_id, vm.treatmentsList);

                                            elem.treatment = {data: {name: elem.treatment_name}};
                                            elem.by_operator = vm.user.id;
                                            elem.byOperator = {data: vm.user};
                                            elem.created_by = vm.user.id;
                                            elem.createdBy = {data: vm.user};
                                            elem.anomalie = {data:[]};
                                            vm.initTreatmentCanChange(elem);
                                            vm.initRatePayment(elem);

                                            elem.customer = {
                                                data: vm.customersList[ position ],
                                            };

                                            elem.user_times = elem.customer.data.user_times+1;
                                            /**
                                             * Setto i dati per il cambio operatore
                                             */
                                            elem.newOperatorId = elem.user_id;
                                            if (elem.role==null || elem.role.data == null) {
                                                elem.role = {data: vm.getUserRole(elem.user_id, elem.store_id) };
                                            }
                                            elem.newOperatorCandidates = [elem.role.data];
                                            elem.price_full = elem.price+elem.discount;
                                            if (vm.isAcquistoDip(elem)) {
                                                elem.price_treatment = elem.price_full - elem.product_price/2 - elem.product_price10/2;
                                            } else {
                                                elem.price_treatment = elem.price_full - elem.product_price - elem.product_price10;
                                            }
                                            if (vm.isStorno(elem)) {
                                                elem.price_treatment = 0-elem.price_treatment;
                                                elem.price_discounted = elem.price_treatment;
                                            }
                                            vm.appointmentsList.push( elem );
                                            vm.calcsOnVisibileElements();
                                        };
                                    },
                                    vm.checkResponse
                                )
                            ;
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            };
        };
        vm.isAcquistoDip = function (app) {
            return app.treatment_id == 67 || app.treatment_id == 68 || app.treatment_id == 69;
        };
        vm.update = function ( appointment ) {
            $log.info( 'Update' );
            if( angular.isDefined( appointment ) ) {
                var confirm = $mdDialog.confirm()
                    .title( 'Attenzione' )
                    .ariaLabel( 'Attenzione' )
                    .textContent( 'Sicuro di voler aggiornare?' )
                    .ok( 'Si' )
                    .cancel( 'Ops, ho sbagliato' )
                ;
                return $mdDialog
                    .show( confirm )
                    .then(
                        function() {
                            angular.copy( appointment, vm.update_appointment );
                            vm.update_appointment.updatingField = vm.updatingField;
                            if( vm.selectedAvaibility !== null ) {
                                vm.update_appointment.date_start = vm.availabilitiesList[ vm.selectedAvaibility ].date_start;
                                vm.update_appointment.date_end = vm.availabilitiesList[ vm.selectedAvaibility ].date_end;
                            };
                            CrudService.update( 'appointments', vm.update_appointment, vm,
                                    function (response) {
                                        var data = response.data.data;
                                        if( vm.selectedAvaibility !== null ) {
                                            var date_start = moment( data.date_start )
                                                , date_end = moment( data.date_end );
                                            appointment.date_start = new Date( date_start );
                                            appointment.date_end = new Date( date_end );
                                        };
                                        appointment.customer_subscription_id = data.customer_subscription_id;
                                        appointment.subscription_new_id = null;
                                        appointment.updated_by = vm.user.id;
                                        appointment.updatedBy = {data: vm.user};
                                        appointment.updated_at = moment();
                                        appointment.updated_at_frmt = moment().format("DD/MM/YYYY HH:mm");

                                        /**
                                         * Check if payment_pos
                                         */
                                        if (appointment.payment_type == 'P' && (appointment.payment_pos_type == 'C' || appointment.payment_pos_type == 'A')) {
                                            appointment.payment_pos = appointment.price;
                                            //appointment.payment_card =
                                        }

                                        /**
                                         * Aggiorno user.data con il nuovo valore
                                         */
                                        vm.operatorChange.complete(appointment);
                                        vm.resetAll();
                                        vm.calcsOnVisibileElements();
                                        //appointent.customer_subscriprion_id = response.data.data.customer_subscription_id;
                                    },
                                    function (response) {
                                        vm.resetAll();
                                        /**
                                         * Ripristino il valore precedente contenuto in appointment.user.data
                                         */
                                        vm.operatorChange.reset(appointment);
                                    }
                            );
                            /*AppointmentsService.update( vm.update_appointment ).then( function( response ) {
                                if( vm.selectedAvaibility !== null ) {
                                    var data = response.data.data
                                        , date_start = moment( data.date_start )
                                        , date_end = moment( data.date_end )
                                    ;
                                    appointment.date_start = new Date( date_start );
                                    appointment.date_end = new Date( date_end );
                                };
                                vm.checkResponse( response, appointment );
                                vm.calcsOnVisibileElements();
                            }, function (response) {//in caso di errore
                                vm.checkResponse( response, appointment );
                            });*/
                        },
                        function () {
                            vm.operatorChange.reset(appointment);
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    )
                ;
            }
        };

        $scope.$watch( 'ap.activeAppointment.rateizzazione_type', function ( newValue ) {
            if( newValue && newValue !== null && newValue=='S') {
                if (vm.activeAppointment && !vm.activeAppointment.f_smallpay) {
                    vm.activeAppointment.f_smallpay = true;
                }
            } else {
                if (vm.activeAppointment && vm.activeAppointment.f_smallpay) {
                    vm.activeAppointment.f_smallpay = false;
                }
            }
            //$log.info(newValue);
            //$log.info(vm.activeAppointment);
        }, true );


        $scope.$watch( 'ap.activeAppointment', function ( newValue ) {
            if( newValue && newValue !== null && newValue.price_full!=undefined) {
                vm.undoVisible = ( angular.equals( newValue, vm.backup_appointment ) ) ? false : true;
                if( vm.undoVisible ) {
                    if ( newValue.user_id !== vm.backup_appointment.user_id || newValue.treatment_id !== vm.backup_appointment.treatment_id ) {
                        vm.selectedAvaibilityRequired = true;
                    }
                } else {
                    vm.selectedAvaibilityRequired = false;
                }
            }
        }, true );

        /* Load Customers */
        vm.customersList = [];
        vm.query.filter_customer = '';
        vm.query.filter_treatment = '';

        vm.customersLoad = function ( customer_id ) {
            vm.customersList = [];
            var pars = {limit:30, orderBy: 'firstname', 'with': 'customer_subscriptions'};
            var search = [];
            var searchFields = [];
            if (customer_id!=null) {
                search.push("id:"+customer_id);
                searchFields.push("id:=");
            }
            if (vm.query.filter_customer!=null && vm.query.filter_customer!='') {
                pars.filtro = vm.query.filter_customer;
            }
            if (search.length>0) {
                pars.search = search.join(";");
                pars.searchFields = searchFields.join(";");
            }
            return CustomerService
                .users_for_appointment(pars).then(
                    function( response ) {
                        if( response.data && response.data.data ) {
                            vm.customersList = response.data.data.map(
                                function( customer ) {
                                    customer.fullName =  (
                                        ( customer.firstname || '' )
                                        + ' '
                                        + ( customer.lastname || '' )
                                    ).toUpperCase();

                                    return customer;
                                }
                            );
                            if (vm.customersList.length==0) {
                                vm.showActionToast("Nessun elemento trovato.");
                            }
                            if( customer_id )
                                vm.customer_id = customer_id;

                            /*$timeout(
                                function() {*/
                                    vm.customersLoading = false;
                            /*    }, 60
                            )*/
                        };
                    }
                )
            ;
        };
        vm.customersReset = function () {
            vm.customersList = [];
            vm.query.filter_customer = '';
        };
        vm.onKeyUpCustomersSearch = function (evento, obj) {
            if (evento.keyCode==13)  {
                /*if (evento.currentTarget.value != vm.query.filter_customer) {
                    vm.query.filter_customer = evento.currentTarget.value;
                }*/
                vm.customersLoad(null);
                evento.stopPropagation();
                evento.preventDefault();
            }
        };
        vm.onKeyUpTreatmentsSearch = function (evento, obj) {
            //$log.info(evento);
            //$log.info(obj);
        };
        /* Controllo se c'è un Customer Id nell'URL */
        if( customer_id && angular.isDefined( customer_id )) {
            vm.customersLoading = true;
            $timeout(
                function() {
                    vm.toggleRight(null, false).then(
                        function() {
                            vm.customersLoad( customer_id );
                        }
                    );
                },
                200
            );
        }
       /* Filtro attivi from url */
       var confirmedFilter = $location.search().confirmed;
        if( confirmedFilter ) {
            $timeout( function() {
                vm.eStatus.selectedFilter = parseInt( confirmedFilter );
            }, 0 );
        }

        var uncovered = $location.search().uncovered;
        if( uncovered ) {
            $timeout( function() {
                vm.eStatus.uncoveredFilter = parseInt( uncovered );
            }, 0 );
        }
        vm.canDelete = false;
        /* WATCHO Lo Store */
        vm.storeId = undefined;
        vm.store = {};
        $scope.$watch( '$parent.selectedStore', function( id ) {
            vm.storeId = id;
            vm.store = {};
            if( angular.isDefined( id )) {
                if (id>0) {
                    if ((vm.canOperatorMove == null && vm.user.type == 'operator') || vm.user.type == 'storemngr' && vm.user.store_id != vm.storeId) {
                        vm.disdSpostEnabled = false;
                        $log.info('disdSpostEnabled: '+vm.disdSpostEnabled);
                        /**
                         * Carico presenza store manager per questo store
                         * se non è presente storemngr allora posso spostare e disdire
                         */
                        var adesso = moment().format('YYYY-MM-DD HH:mm:ss');
                        OperatorAvailabilityService.all(
                                {     search: "store_id:"+vm.storeId + ";date_start:"+adesso+";date_end:"+adesso+";reserved:5",
                                    searchFields: "store_id:=;date_start:<=;date_end:>;reserved:="
                                }
                            ).then(
                                function( data ){
                                    if (data.length==0) {
                                        //store manager assente abilito la disdetta e lo spostamento
                                        vm.disdSpostEnabled = true;
                                        $log.info('storemngr not available at '+adesso);
                                    } else {
                                        //store manager presente disabilito la disdetta e lo spostamento
                                        vm.disdSpostEnabled = false;
                                        $log.info('storemngr available at '+adesso);
                                    }
                                    $log.info('disdSpostEnabled: '+vm.disdSpostEnabled);
                                });

                    }
                    angular.forEach($scope.$parent.main.storesList, function (s) {
                      if (s.id == vm.storeId) {
                        vm.store = s;
                      }
                    });
                }
                vm.userRolesLoad();
                vm.filterTreatments();
            }
        });

      /*$scope.$watch('ap.query.page', function() {
         vm.calcsOnVisibileElements();
      });

      $scope.$watch('ap.query.order', function() {
         vm.calcsOnVisibileElements();
      });
      $scope.$watch('ap.query.filter', function() {
         vm.calcsOnVisibileElements();
      });
      $scope.$watch('ap.query.limit', function(a) {
        console.log(a);
         vm.calcsOnVisibileElements();
      });*/
     vm.calcsOnVisibileElements = function() {
        $timeout(function () {
           vm.totFirstTime = 0;
           vm.totPrices = 0;
           vm.totApps = 0;
           vm.totMinutes = 0;
           vm.tmpAff = 0
           vm.affidabilita = 0;
           vm.appointmentsList.forEach(function(item) {
               item.affidabilita = null;
             if (item.recalled==null || item.recalled<3) {
                var user_times = item.user_times>0?item.user_times:1;
                var app_times = item.app_times>0?item.app_times:user_times;
                if (app_times<user_times) {
                    app_times = user_times;
                }
                 if ((item.appointment_id!=null || app_times==1) && app_times==user_times) {
                    app_times++;
                }
                var min = moment(item.date_end).diff(moment(item.date_start), 'minutes');
                 vm.totMinutes += min;
                 var r = 0;
                 if (user_times == 1) {
                     r = 0-item.relevance;
                 }
                 item.affidabilita = user_times*100/(app_times+r);
                vm.tmpAff += min*user_times/(app_times+r);
                if (item.paid) {
                    vm.totPrices = vm.totPrices + item.price;
                 }
                 if (item.user_times <= 1) {
                    vm.totFirstTime++;
                 }
             }
          });
           vm.affidabilita = vm.tmpAff*100/vm.totMinutes;

         });
     };
     /*vm.showPhone_0 = function (a) {
         var p = $mdDialog.confirm()
                 .title(a.customer.data.phone)
                 .textContent(
                     (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
                     + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'')
                     + '<br/>' + 'altre info'
                  ).ok( 'Ok' );
         return $mdDialog.show( p );
     };*/
     // Info Appuntamento
     /*vm.showPhone = function( a ) {
         var dialog = $mdDialog.confirm({
               title: 'Info appuntamento ' + a.treatment_name + ' di ' + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
               + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():''),
               ariaLabel: 'Info appuntamento',
               templateUrl: 'app/appointments/dialogs/appointment-info.html',
               escapeToClose: true,
               controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                   $scope.title = this.title;
                   $scope.button_ok = 'Chiudi';
                   $scope.appointment = a;

                   $scope.close = function() {
                       $mdDialog.hide( true );
                   };
               }]
         });

         return $mdDialog
             .show( dialog )
             .finally(
                 function() {
                     dialog = undefined;
                 }
             )
         ;
     };*/
     vm.dateFormat = function (elem, deleteCreatedAt) {


       elem.updated_at_frmt = moment( elem.updated_at.date ).format('DD/MM/YYYY HH:mm');

       var createdR = moment( elem.created_at_r);
       elem.createdRecently = moment().diff(createdR,'hours')<12;
       //$log.info(elem);
       elem.created_at_frmt = moment( elem.created_at.date ).format('DD/MM/YYYY HH:mm');

       elem.date_start_frmt = moment( elem.date_start ).format('DD/MM/YYYY HH:mm');
       elem.date_end_frmt = moment( elem.date_end ).format('HH:mm');

       if (elem.moved_at!=null) {
         elem.moved_at_frmt = moment( elem.moved_at ).format('DD/MM/YYYY HH:mm');
       }
       if (elem.cancelled_at!=null) {
         elem.cancelled_at_frmt = moment( elem.cancelled_at ).format('DD/MM/YYYY HH:mm');
       }

       if (deleteCreatedAt) {
         delete elem.created_at;
         delete elem.updated_at;
       }

       if (elem.lead!=null && elem.lead.data!=null && elem.lead.data.created_at!=null) {
         elem.lead.data.created_at_frmt = moment( elem.lead.data.created_at.date ).format('DD/MM/YYYY HH:mm');
       }

     };

     /**
      * Storico cambi operatore
      */
     vm.showOpHistory = function( a ) {
         var dialog = $mdDialog.confirm({
               title: 'Storico cambi: ' + a.treatment_name + ' di ' + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
               + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'') + " (aid="+a.id+")",
               ariaLabel: 'Storia cambi op.',
               templateUrl: 'app/appointments/dialogs/appointment-op-history.html',
               escapeToClose: true,
               controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                   $scope.title = this.title;
                   $scope.button_ok = 'Chiudi';
                   $scope.appointmentQuesto = a;
                   $scope.close = function() {
                       $mdDialog.hide( true );
                   };
               }]
         });

         return $mdDialog
             .show( dialog )
             .finally(
                 function() {
                     dialog = undefined;
                 }
             )
         ;
     };

     /**
      * Documenti cliente
      */
     vm.showDocuments = function( a ) {
         var dialog = $mdDialog.confirm({
               title: 'Elenco documenti: ' + a.treatment_name + ' di ' + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
               + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'') + " (aid="+a.id+" cid="+a.customer_id+" tid="+a.treatment_id+")",
               ariaLabel: 'Storia cambi op.',
               templateUrl: 'app/appointments/dialogs/appointment-documents.html',
               escapeToClose: true,
               controller: [ '$scope', '$mdDialog', '$filter', '$http', '$log',  function( $scope, $mdDialog, $filter, $http, $log ) {
                   $scope.title = this.title;
                   $scope.button_ok = 'Chiudi';
                   $scope.app = a;
                   $scope.env = vm.env;
                   $scope.token = vm.token;
                   $scope.refresh = function() {
                       /**
                       * ricarico documenti cliente
                       */
                       //$log.info("http.get: "+$scope.env.API+"/documents?customer_id="+$scope.app.customer_id);
                       $scope.loading = true;
                       $http.get($scope.env.API+"/documents?customer_id="+$scope.app.customer_id).then(
                           function (response) {
                               //$log.info(response.data.data);
                               $scope.app.documents = {'data': response.data.data };
                               vm.initDocuments($scope.app);
                               $scope.loading = false;
                           },
                           function (response) {
                               //$log.info(response);
                               $scope.loading = false;
                           }
                       );
                   };
                   $scope.close = function() {
                       $mdDialog.hide( true );
                   };
               }]
         });

         return $mdDialog
             .show( dialog )
             .finally(
                 function() {
                     dialog = undefined;
                 }
             )
         ;
     };

     vm.openMenuTags = function($mdMenu, ev) {
       $mdMenu.open(ev);
     };

     vm.toggleTag = function(ev,  a, tag ) {
         var filteredTags = $filter('filter')(a.customer.data.entitytags.data,{tag_id: tag.id},true);
        if ( filteredTags.length>0) {
            var toDel = filteredTags[0];
            CrudService.del('entitytags', toDel.id, vm, function (response) {
                var newETags = [];
                angular.forEach(a.customer.data.entitytags.data, function(e) {
                    if (e.id!=toDel.id) {
                        newETags.push(e);
                        console.log("rimane "+e.id);
                    }
                });
                angular.forEach(vm.appointmentsList, function(app) {
                    if (app.customer_id == a.customer_id) {
                        var newETagsClone = [];
                        angular.copy(newETags, newETagsClone);
                        app.customer.data.entitytags.data = newETagsClone;
                    }
                });
            },
            function (response) {
            });
        } else {
            CrudService.save('entitytags', {tag_id: tag.id, customer_id: a.customer_id}, vm, function (response) {
                angular.forEach(vm.appointmentsList, function(app) {
                    if (app.customer_id == a.customer_id) {
                        app.customer.data.entitytags.data.push(response.data.data);
                        console.log('aggiungo: ' +response.data.data.id);
                    }
                });
            },
            function (response) {
            });
        }
     }

     //TODO: API to add tag record ?

     // Info Appuntamento
     // Storia modifiche
     vm.showInfo = function( a ) {
         var dialog = $mdDialog.confirm({
               title: 'Info: ' + a.treatment_name + ' di ' + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
               + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'') + " (aid="+a.id+")",
               ariaLabel: 'Storia spostamenti',
               templateUrl: 'app/appointments/dialogs/appointment-moves.html',
               escapeToClose: true,
               controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                   $scope.title = this.title;
                   $scope.button_ok = 'Chiudi';
                   $scope.recall_types = vm.recall_types;
                   $scope.appointmentQuesto = a;
                   $scope.appointment = null;
                   $scope.customer = null;
                   $scope.appointmentsList = [];
                   $scope.loading = true;
                   $scope.loadingPf = true;
                   $scope.loadOrigin = function () {

                    /**
                     * Carico customer con pf data
                     */
                    CustomerService.get(a.customer_id, {'with': 'sourceCustomer;phonefriends;phonefriends.appointments'}).then(
                        function(response) {
                            $scope.customer = response.data.data;
                            angular.forEach( $scope.customer.phonefriends.data, function( pf ) {
                                angular.forEach( pf.appointments.data, function( app ) {
                                    vm.dateFormat(app);
                                    angular.forEach(vm.scope.$parent.main.storesList, function (s) {
                                        if (s.id == app.store_id) {
                                          app.store = {data: s};
                                        }
                                    });
                                });
                            });
                            $scope.loadingPf = false;
                        }
                    );

                     var pars = {};
                     pars.with = "customer;byOperator;movedBy;cancelledBy;updatedBy;lead;treatment";
                     /*if (a.treatment_id == 99) {
                         vm.card.find(a);
                     }*/
                     if (a.appointment_id == null) {//questo è l'origine
                       $scope.appointment = a;
                       $scope.appointmentsList.push(a);
                       var elem = $scope.appointment;
                       if (elem.recalled == 4) {
                         $scope.loading = true;
                         $scope.loadAppointments(a.id, a);
                       } else {
                        $scope.loading = false;
                       }
                     } else {
                       $scope.loading = true;
                       AppointmentsService.get(a.appointment_id, pars).then( function (response) {
                                   $scope.appointment = response.data.data;
                                   vm.setUserRole($scope.appointment);
                                   var elem = $scope.appointment;
                                   vm.dateFormat($scope.appointment);
                                   $scope.loadAppointments(a.appointment_id, elem);
                                 },
                                 function (response) {
                                   var errMsg = "";
                                   if (response.data!=null && response.data.message!=null) {
                                     errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                                     var url = response.config!=null && response.config.url!=null?response.config.url:"";
                                     if (url!=null) {
                                       errMsg+= "\nUrl: " + url;
                                     }
                                   }
                                   alert ("Si è verificato un errore nel caricamento appuntamenti: " + errMsg);
                                   $scope.loading = false;
                                 });
                     }
                   }

                   /**
                    * Tutti gli spostati
                    */
                   $scope.loadAppointments = function (aid, origine) {
                       $scope.appointmentsList = [];
                       var pars = {page:1, s: 1000};
                       var search = [];
                       var searchFields = [];
                       search.push("appointment_id:"+aid);
                       searchFields.push("appointment_id:=");
                       pars.orderBy = 'id';
                       pars.sortedBy = "desc";
                       pars.search = search.join(";");
                       pars.searchFields = searchFields.join(";");
                       pars.with = "movedBy;cancelledBy;createdBy;updatedBy;treatment;user";
                         AppointmentsService.all( pars ).then( function( response ) {
                             $scope.appointmentsList = [];
                             if( response.data && response.data.data ) {
                               var nextApp = null;
                               /**
                                * Itero dal più nuovo al più vecchio
                                */
                                 angular.forEach( response.data.data, function( elem ) {
                                     vm.setUserRole(elem);
                                   if (nextApp != null) {
                                        if (elem.recalled == 4) {
                                            /*elem.sposInDay = moment(nextApp.date_start).format('YYYY-MM-DD') == moment(elem.date_start).format('YYYY-MM-DD')
                                                && moment(elem.date_start).format('YYYY-MM-DD') == moment(elem.moved_at).format('YYYY-MM-DD');*/
                                            if (elem.moved_by==null) {
                                                elem.moved_by = nextApp.created_by;
                                                elem.movedBy = nextApp.createdBy;
                                            }
                                        }
                                   }
                                   vm.dateFormat(elem);
                                   nextApp = elem;
                                   $scope.appointmentsList.push(elem);
                                 });
                                 /**
                                  * Imposto sposInDay per l'originale
                                  */
                                 if(nextApp!=null) { //è l'ultimo prima dell'origine
                                    if (origine.recalled == 4) {
                                        /*origine.sposInDay = moment(nextApp.date_start).format('YYYY-MM-DD') == moment(origine.date_start).format('YYYY-MM-DD')
                                            && moment(origine.date_start).format('YYYY-MM-DD') == moment(origine.moved_at).format('YYYY-MM-DD');*/
                                    }
                                 }
                                    /**
                                  * L'ultimo selezionato è il primo spostamento dell'originale
                                  */
                                 var elem = $scope.appointment;
                                 if (nextApp != null) {
                                   if (elem.moved_by == null) {
                                     elem.moved_by = nextApp.created_by;
                                     elem.movedBy = nextApp.createdBy;
                                   }
                                 }
                                 /**
                                  * Metto anche il primo in elenco
                                  */
                                 $scope.appointmentsList.push($scope.appointment);
                                 //$log.info($scope.appointment);
                                 //$log.info($scope.appointmentsList);
                                 $scope.loading = false;
                             };
                         },
                         function (response) {
                           var errMsg = "";
                           if (response.data!=null && response.data.message!=null) {
                             errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                             var url = response.config!=null && response.config.url!=null?response.config.url:"";
                             if (url!=null) {
                               errMsg+= "\nUrl: " + url;
                             }
                           }
                           alert ("Si è verificato un errore nel caricamento appuntamenti: " + errMsg);
                           $scope.loading = false;
                         });
                     };
                   $scope.close = function() {
                       $mdDialog.hide( true );
                   };
                   $scope.loadOrigin();
               }]
         });

         return $mdDialog
             .show( dialog )
             .finally(
                 function() {
                     dialog = undefined;
                 }
             )
         ;
     };

     /**
      * Visualizzo activities su app
      */
     vm.showActivities = function( a ) {
         if (vm.user.type != 'admin') {
             return    vm.showInfo(a);
         }
         var dialog = $mdDialog.confirm({
               title: 'Storico Modifiche: ' + a.treatment_name + ' di ' + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
               + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'') + " (aid="+a.id+")",
               ariaLabel: 'Storia Modifiche Appuntamento',
               templateUrl: 'app/components/dialogs/activity-log.html',
               escapeToClose: true,
               controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                   $scope.title = this.title;
                   $scope.button_ok = 'Chiudi';
                   $scope.activities = [];
                   $scope.loadActivities = function () {
                   var pars = {
                           'log_name': 'default',
                           'subject_type':'App\\Entities\\Appointment',
                           'subject_id': a.id,
                           with: 'causer;subject'
                         };
                   $scope.loading = true;
                   CrudService.all('activity_log', pars, vm,
                         function (response) {
                           angular.forEach(response.data.data, function(act) {
                               act.created_at_frmt = moment(act.created_at).format('D/M/YYYY HH:mm:ss');
                               $scope.activities.push(act);
                           });
                           $scope.loading = false;
                         },
                         function (response) {
                           var errMsg = "";
                           if (response.data!=null
                                   && response.data.message!=null) {
                             errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                             var url = response.config!=null && response.config.url!=null?response.config.url:"";
                             if (url!=null) {
                               errMsg+= "\nUrl: " + url;
                             }
                           }
                           alert ("Si è verificato un errore nel caricamento delle attività: " + errMsg);
                           $scope.loading = false;
                        });
                   }
                   $scope.close = function() {
                       $mdDialog.hide( true );
                   };
                   $scope.loadActivities();
               }]
         });

         return $mdDialog
             .show( dialog )
             .finally(
                 function() {
                     dialog = undefined;
                 }
             )
         ;
     };

    vm.showBSG = function( a, type, entitytag ) {
        var dialog = $mdDialog.confirm({
                title: 'Cliente '+ type + ':  ' + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
                + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'') + " (aid="+a.id+")",
                ariaLabel: 'Cliente '+type,
                templateUrl: 'app/appointments/dialogs/consegna-gsb.html',
                escapeToClose: true,
                controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                    $scope.title = this.title;
                    $scope.button_ok = 'Chiudi';
                    $scope.appointmentQuesto = a;
                    $scope.customer = a.customer.data;
                    $scope.entitytag = entitytag;
                    if (!entitytag.flagged) {
                        entitytag.flagged_at = moment($scope.appointmentQuesto.date_end);
                        entitytag.flagged_at_frmt = moment(entitytag.flagged_at).format('DD/MM/YYYY HH:mm');
                        //alert(entitytag.flagged_at);
                    }
                    $scope.save = function () {
                        $scope.loading = true;
                        //faccio copia da salvare se tutto ok setto flagged = 1
                        var entitytagCopy = {};
                        angular.copy(entitytag, entitytagCopy);
                        entitytagCopy.flagged = 1;
                        entitytagCopy.flagged_by = vm.user.id;
                        entitytagCopy.appointment_id = $scope.appointmentQuesto.id;
                        CrudService.save('entitytags', entitytagCopy, vm, function (response) {
                            $scope.entitytag.flagged = 1;
                            $scope.loading = false;
                            $scope.close();
                        },
                        function (response) {
                            $scope.loading = false;
                        });
                    };
                    $scope.close = function() {
                        $mdDialog.hide( true );
                    };
                }]
        });

        return $mdDialog
            .show( dialog )
            .finally(
                function() {
                    dialog = undefined;
                }
            )
        ;
    };


     vm.anomalia = function( a, show ) {
       var dialog = $mdDialog.confirm({
             title: (!show?'Inserimento anomalia':'Elenco anomalie')+': ' + a.treatment_name + ' di ' + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
             + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'') + " (aid="+a.id+")",
             ariaLabel: 'Inserimento anomalia',
             templateUrl: 'app/appointments/dialogs/anomalia.html',
             escapeToClose: true,
             controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                 $scope.title = this.title;
                 $scope.show = show;
                 $scope.button_ok = 'Chiudi';
                 $scope.appointmentQuesto = a;
                 $scope.anomaliesList = [];
                 a.treatment = {data: {name: a.treatment_name}};
                 $scope.activeAnomalia = {
                     log_name: 'anomalie',
                     subject_id: a.id,
                     type: null,
                     sendto: null,
                     subject_type: 'App\\Entities\\Appointment',
                     store_id: a.store_id
                 };
                 $scope.loadActivities = function () {
                   var pars = {
                       'subject_type':'App\\Entities\\Appointment',
                       'subject_id': a.id,
                       'log_name': 'anomalie',
                       with: 'causer;subject'
                     };
                     $scope.loading = true;
                     CrudService.all('activity_log', pars, vm, function (response) {
                       $scope.anomaliesList = response.data.data;
                       $scope.loading = false;
                     },
                     function (response) {
                       $scope.loading = false;
                     });
                 };
                 $scope.save = function () {
                   $scope.loading = true;
                   CrudService.save('activity_log', $scope.activeAnomalia, vm, function (response) {
                       if ($scope.appointmentQuesto.anomalie!=null && $scope.appointmentQuesto.anomalie.data!=null) {
                         $scope.appointmentQuesto.anomalie.data.push(response.data.data);
                       } else {
                         $scope.appointmentQuesto.anomalie = {data: [response.data.data]};
                       }
                       console.log($scope.activeAnomalia);
                       if ($scope.activeAnomalia.type == 'ncpc') {
                           $scope.appointmentQuesto.f_ref = 1;
                       }
                       $scope.anomaliesList.push( response.data.data );
                       $scope.close();
                       $scope.loading = false;
                     },
                     function (response) {
                       $scope.loading = false;
                     });
                 };
                 $scope.delete = function (anomalia) {
                    $scope.loading = true;
                    CrudService.del('activity_log', anomalia.id, vm, function (response) {
                        $scope.appointmentQuesto.anomalie = {data: []};
                        console.log(anomalia);
                        if (anomalia.type == 'ncpc') {
                            $scope.appointmentQuesto.f_ref = 0;
                        }
                        $scope.close();
                        $scope.loading = false;
                      },
                      function (response) {
                        $scope.loading = false;
                      });
                  };
                 $scope.close = function() {
                   $mdDialog.hide( true );
                 };
                 $scope.loadActivities();
             }]
       });

       return $mdDialog
           .show( dialog )
           .finally(
               function() {
                   dialog = undefined;
               }
           )
       ;
   };


   vm.manageProducts = function( a ) {
     var dialog = $mdDialog.confirm({
           title: 'Carrello prodotti: ' + a.treatment_name + ' di ' + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
           + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'') + " (aid="+a.id+")",
           ariaLabel: 'Carrello prodotti',
           templateUrl: 'app/appointments/dialogs/appointmentProducts.html',
           escapeToClose: true,
           controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
               $scope.title = this.title;
               $scope.button_ok = 'Chiudi';
               $scope.appointmentQuesto = a;
               $scope.mainEntity = a;
               $scope.productsList = [];
               $scope.suppliersList = [];
               $scope.appProductsList = [];
               a.treatment = {data: {name: a.treatment_name}};
               $scope.loadSuppliers = function (a) {
                 var pars = {
                   };
                   $scope.loading = true;
                   CrudService.all('suppliers', pars, vm, function (response) {
                     $scope.suppliersList = response.data.data;
                     $scope.loading = false;
                     $scope.loadProducts();
                   },
                   function (response) {
                     $scope.loading = false;
                   });
               };
               $scope.loadProducts = function () {
                 var pars = {
                     'active': 1
                   };
                   $scope.loading = true;
                   CrudService.all('products', pars, vm, function (response) {
                     angular.forEach (response.data.data, function (p) {
                       if (p.price_pub) {
                         $scope.productsList.push(p);
                         $scope.setSupplier(p);
                       }
                     });
                     $scope.loading = false;
                     $scope.loadAppProducts($scope.appointmentQuesto)
                   },
                   function (response) {
                     $scope.loading = false;
                   });
               };
               $scope.loadAppProducts = function (a) {
                 var pars = {
                     'search': a.id,
                     'searchFields': 'appointment_id',
                     'orderBy': 'id',
                     'with': 'product'
                   };
                   $scope.loading = true;
                   CrudService.all('appointment_products', pars, vm, function (response) {
                     $scope.appProductsList = response.data.data;
                     angular.forEach ($scope.appProductsList, function (ap) {
                       $scope.setSupplier(ap.product);
                     });
                     $scope.computeTotals();
                     $scope.loading = false;
                   },
                   function (response) {
                     $scope.loading = false;
                   });
               };
               $scope.setSupplier = function (e) {
                 angular.forEach ($scope.suppliersList, function (s) {
                   if (s.id == e.supplier_id) {
                     e.supplier = s;
                   }
                 });
               };

               $scope.addProduct = function(p) {
                 var trov = false;
                 var nap = null;
                 angular.forEach($scope.appProductsList, function (ap) {
                   if (ap.product_id == p.id) {
                     ap.qty = ap.qty+1;
                     trov = true;
                     nap = ap;
                   }
                 });
                 if (!trov) {
                   nap = {
                         'id': null,
                         'product_id': p.id,
                         'store_id': $scope.mainEntity.store_id,
                         'appointment_id': $scope.mainEntity.id,
                         'qty': 1,
                         'price': p.price_pub, /*todo va messa la logica dei prodotti operatrice*/
                         'in_treatment': p.id?0:1,
                         'product': p,
                         'subblier': p.supplier
                   };
                   $scope.appProductsList.push(nap);
                 }
                 $scope.save(nap);
               }
               $scope.save = function (row) {
                 $scope.loading = true;
                 $scope.mainEntity.includedProducts = {data: $filter('filter')($scope.appProductsList, {'in_treatment': 1}, true) };
                 if (row.qty == 0) {
                     $scope.deleteProduct(row);
                     return;
                 }
                 CrudService.save('appointment_products', row, vm, function (response) {
                     row.id = response.data.data.id;
                     $scope.loading = false;
                     //vanno ricalcolati i totali
                     $scope.computeTotals();
                   },
                   function (response) {
                     $scope.loading = false;
                 });

               };

               $scope.deleteProduct = function (ap) {
                 $scope.loading = true;
                 CrudService.del('appointment_products', ap.id, vm, function (response) {
                   var tmpList = $scope.appProductsList;
                   $scope.appProductsList = [];
                   angular.forEach(tmpList, function (e) {
                     if (e.id != ap.id) {
                       $scope.appProductsList.push(e);
                     }
                   });
                   $scope.loading = false;
                   //vanno ricalcolati i totali
                   $scope.mainEntity.includedProducts = {data: $filter('filter')($scope.appProductsList, {'in_treatment': 1}, true) };
                   $scope.computeTotals();
                  },
                   function (response) {
                     $scope.loading = false;
                 });
               };

               $scope.computeTotals = function () {
                 var t = 0;
                 var t_in = 0;
                 var t10 = 0;
                 var t10_in = 0;
                 angular.forEach($scope.appProductsList, function (ap) {
                   if (!ap.in_treatment) {
                      if (ap.product.supplier.vat == 10) {
                        t10 += (ap.price * ap.qty);
                      } else {
                        t += (ap.price * ap.qty);
                      }
                   } else {
                     if (ap.product.supplier.vat == 10) {
                       t10_in += (ap.price * ap.qty);
                     } else {
                       t_in += (ap.price * ap.qty);
                     }
                  }
                 });
                 $scope.mainEntity.product_price = parseFloat(new Number(t).toFixed(2));
                 $scope.mainEntity.product_price10 = parseFloat(new Number(t10).toFixed(2));
                 $scope.mainEntity.product_price_in = parseFloat(new Number(t_in).toFixed(2));
                 $scope.mainEntity.product_price10_in = parseFloat(new Number(t10_in).toFixed(2));
                 //$scope.mainEntity.tri = vm.tri($scope.mainEntity);
                 //$log.info("computedTri: ");
                 //$log.info($scope.mainEntity.includedProducts);
                 vm.paymentDiscountPriceRateUpdate(false);
                 vm.paymentPosUpdate();
               };

               $scope.close = function() {
                 $mdDialog.hide( true );
               };
               $scope.loadSuppliers();
           }]
     });

     return $mdDialog
         .show( dialog )
         .finally(
             function() {
                 dialog = undefined;
             }
         )
     ;
 };



     vm.showNote = function (a) {
         if ((a.note==null || a.note.trim()=='')
            && (a.note_diagnosi==null || a.note_diagnosi.trim()=='')
            && (a.note_terapia==null || a.note_terapia.trim()=='')
            && (a.note_val_clinica==null || a.note_val_clinica.trim()=='')
            && (a.parameters==null || a.parameters.trim()=='')
            && (a.customer.data.note==null || a.customer.data.note.trim()=='')
            && (a.lead_recall == null || a.lead_recall.data == null || a.lead_recall.data.note.trim()==''))
         {
            return;
         }
         var testo = "";
         if (a.note!=null && a.note.trim()!='') {
             testo = "<h3>Nota pre:</h3><p>"+a.note.trim()+"</p>";
         }
         if (a.note_diagnosi!=null && a.note_diagnosi.trim()!='') {
             testo += "<h3>Nota post:</h3><p>"+a.note_diagnosi.trim()+"</p>";
         }
         if (a.note_terapia!=null && a.note_terapia.trim()!='') {
             testo += "<h3>Nota terapia:</h3><p>"+a.note_terapia.trim()+"</p>";
         }
         if (a.note_val_clinica!=null && a.note_val_clinica.trim()!='') {
             testo += "<h3>Nota valutazione clinica:</h3><p>"+a.note_val_clinica.trim()+"</p>";
         }
         if (a.parameters!=null && a.parameters.trim()!='') {
             testo += "<h3>Parametri tecnici:</h3><p>"+a.parameters.trim()+"</p>";
         }
         if (a.customer.data.note!=null && a.customer.data.note.trim()!='') {
            testo += "<h3>Nota cliente:</h3><p>"+a.customer.data.note.trim()+"</p>";
         }
         if (a.lead_recall && a.lead_recall.data && a.lead_recall.data.note!=null && a.lead_recall.data.note.trim()!='') {
            testo += "<h3>Nota Conferma:</h3><p>"+a.lead_recall.data.note.trim()+"</p>";
         }
         var p = $mdDialog.confirm()
                 .title("Note su " + (a.customer.data.firstname!=null?a.customer.data.firstname.toUpperCase():'')
              + ' ' + (a.customer.data.lastname!=null?a.customer.data.lastname.toUpperCase():'')
           ).htmlContent(testo)
             .ok( 'Ok' );
         return $mdDialog.show( p );
     };
     vm.operatorChange = {
        complete: function(appointment) {
            if (appointment!=null && appointment.role && appointment.role.data && appointment.user_id!=appointment.role.data.user_id) {
                appointment.role.data = vm.getUserRole(appointment.user_id, appointment.store_id);
                appointment.newOperatorCandidates = [appointment.role.data];
                appointment.newOperatorId = appointment.user_id;
            }
        },
        reset: function(appointment) {
            if (appointment!=null && appointment.user_id!=appointment.role.data.user_id) {
                appointment.user_id = appointment.role.data.user_id;
                appointment.newOperatorCandidates = [appointment.role.data];
                appointment.newOperatorId = appointment.user_id;
            }
        },
        doChange: function(appointment) {
             //alert (appointment.id + " change from " + appointment.user_id + " to " + appointment.newOperatorId);
             if (appointment.closed) {
                 vm.showActionToast("Cassa chiusa.");
                 return;
             }
             if (vm.user.type!='admin' && vm.user.type!='storemngr') {
                 vm.showActionToast("Operazione non consentita. Contattare l'assistenza.");
                 return;
             }
             appointment.user_id = appointment.newOperatorId;
             appointment.uncovered = 0;
             //vm.selectedAvaibility = null;
             vm.update(appointment);
             /**
              * devo salvare il cambio operatore
              */
         },
        gotFocus: function(appointment) {
             /**
              * devo caricare gli operatori disponibili per il cambio su questo appuntamento
              */
             if (appointment.closed) {
                 vm.showActionToast("Cassa chiusa.");
                 return;
             }
             if (vm.user.type!='admin' && vm.user.type!='storemngr') {
                 vm.showActionToast("Operazione non consentita. Contattare l'assistenza.");
                 return;
             }
             if (appointment.recalled!=null && appointment.recalled>=3) {
                 if (appointment.recalled==4) {
                     vm.showActionToast("Appuntamento spostato.");
                 } else if (appointment.recalled==3) {
                     vm.showActionToast("Appuntamento disdetto.");
                 }
                 return;
             }
             appointment.newOperatorId = appointment.user_id;
             appointment.newOperatorCandidates = [];
             if (appointment.role && appointment.role.data) {
                 appointment.newOperatorCandidates.push(appointment.role.data);
             }
             UsersService.availablesForChange(appointment.store_id, appointment.id, appointment.user_id, moment(appointment.date_start).format('YYYY-MM-DD')).then(
                function( response ) {
                    if( response.data && response.data ) {
                        if (response.data.length==0) {
                            vm.showActionToast("Nessuna disponibilità per il cambio.");
                        } else {
                            response.data.forEach(function(op) {
                                appointment.newOperatorCandidates.push(vm.getUserRole(op.id, appointment.store_id));

                            });
                        }
                    }
            });
         }
     };

     vm.onElencoAppuntamenti = function() {
         vm.visite = 0;
         vm.eStatus.filter_date_start = null;
         vm.appointmentsListLoad(null);
     }

     /**
      * Iniizalizzo qrcode reader
      */
     /*angular.element('#reader').html5_qrcode(function(data) { // start webcam
         console.log(data); // print QR code content
         angular.element("#reader").html5_qrcode_stop(); // stop webcam
       },
       function(error) {
         console.log(error);
       },
       function(videoError) {
         console.log(videoError);
       }
       );*/
     vm.preview = document.getElementById('preview');
     if (false && vm.env.giftcardEnabled) {
         vm.scanner = new Instascan.Scanner({ video: vm.preview, scanPeriod: 5 });
         //console.log(vm.preview);
         vm.scanner.addListener('scan', function (content, image) {
             //console.log(content);
             //console.log(vm);
             //console.log(vm.activeAppointment);
             if (vm.activeAppointment) {
                 //$scope.appointmentForm.gift_number.val(content);
                 vm.activeAppointment.gift_number = content;
                 $scope.$digest();
                 vm.hidePreview();
             }
             //console.log("setted: "+vm.activeAppointment.gift_number);
         });
         Instascan.Camera.getCameras().then(function (cameras) {
           vm.cameras = cameras;
           if (cameras.length > 0) {
             vm.activeCameraId = cameras[0].id;
             console.log("starting scanner on ");
             console.log(cameras[0]);
             vm.scanner.start(cameras[0]);
           } else {
             console.error('No cameras found.');
           }
         }).catch(function (e) {
             console.error(e);
         });
     }
     vm.showPreview = function(obj) {
         //console.log(obj.target);
         vm.preview.style.visibility = 'visible';
         vm.preview.style.display = '';
         vm.preview.style.position = 'absolute';
         vm.preview.style.top = '50%';
         vm.preview.style.left= '50%';
         vm.preview.style['margin-top'] = '-200px';
         vm.preview.style['margin-left'] = '-350px';
     };
     vm.hidePreview = function() {
         vm.preview.style.visibility = 'hidden';
         vm.preview.style.display = 'none';
     };

     vm.n_installments = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];

     vm.n_installments_pagodil = [1,2,3,4,5,6,7,8,9,10,11,12];

     vm.n_installments_apppago = [3,4,5,6,7,8,9,10,11,12];

     vm.n_installments_light = [1,2,3,4,5,6,7,8,9,10,11,12];

     vm.n_consumerCredit = [6,12,18,24,30,36,42,48];

     /**
      * Gestione card gift
      */
     vm.card = {
             area: vm.env.tenant_giftcode,
             value: null,
             filter_number: null,
             filter_number_pay: null,
             card: {balance: 0},
             list: [],
             init: function(app) {
                if (app.treatment_id == 99) {
                    if (app.gift_number && app.gift_number.length>3) {
                        this.value = app.gift_number.substring(2,5);
                        this.area = app.gift_number.substring(0,2);
                        app.treatment.data.start_price = parseFloat(this.value);
                    } else {
                        app.treatment.data.start_price = 0;
                    }
                }
             },
             setValue: function() {
                 vm.treatment.start_price = parseFloat(vm.card.value);
                 this.list = [];
                 this.number = null;
                 vm.appointmentTypeChange();
             },
             onKeyUpSearch: function (evento, obj) {
                if (evento.keyCode==13)  {
                    this.load();
                    evento.stopPropagation();
                    evento.preventDefault();
                }
             },
             format: function(card_number) {
                 if (card_number!=null && card_number!='' && card_number.length==11) {
                     return card_number.substring(0,2)+"-"+card_number.substring(2,5)+"-"+card_number.substring(5,11);
                 } else {
                     return card_number;
                 }
             },
             select: function() {
                 vm.card.card = {balance: 0};
                 if (vm.activeAppointment.gift_number) {
                    angular.forEach(this.list, function(el) {
                        if (el.number == vm.activeAppointment.gift_number) {
                            vm.card.card = el;
                            //$log.info("selected card: " + el);
                            //$log.info(el);
                        }
                    });
                 }
             },
             load: function(isToggle) {
                var pars = {
                       'searchJoin': 'and',
                       'searchFields': 'number:like;released:=',
                 };
                 if (vm.activeAppointment.treatment_id == 99) {
                     if (this.filter_number.substring(0,5) == this.area + this.value ) {
                         this.filter_number = this.filter_number.substring(5);
                     }
                     pars.search = 'released:0;number:' + this.area + this.value + '%' + this.filter_number+ "%";
                 } else {
                     pars.search = 'released:1;number:%' + this.filter_number_pay+ "%";
                 }
                 this.loading = true;
                 CrudService.all('giftcards', pars, vm,
                    function (response) {
                        vm.card.list = response.data.data;
                        if(isToggle) {
                            vm.card.select();
                            if (vm.activeAppointment.payment_gift) {
                                vm.card.card.balance = vm.card.card.balance+vm.activeAppointment.payment_gift;
                            }
                        }
                        vm.card.loading = false;
                    },
                    function (response) {
                        vm.card.loading = false;
                    }
                 );
             },
             find: function(app) {
                 var pars = {
                       'searchJoin': 'and',
                       'searchFields': 'rel_tenant:=;rel_appointment_id:=',
                       'search': 'rel_tenant:' + vm.env.currentTenant+';rel_appointment_id:'+app.id,
                 };
                 this.loading = true;
                 CrudService.all('giftcards', pars, vm,
                     function (response) {
                       var list = response.data.data;
                       if (list.length>=1) {
                           app.giftcard = {data: list[0]};
                           //app.gift_number = app.giftcard.data.number;
                       } else {
                           //app.gift_number = -1;
                       }
                       vm.card.loading = false;
                     },
                     function (response) {
                         vm.card.loading = false;
                     }
                 );
             },
     };//fine def card

    };

    AppointmentsController
        .$inject = [
            '$scope',
            '$log',
            '$http',
            '$mdDialog',
            'moment',
            'TreatmentService',
            'StoreService',
            'AppointmentsService',
            'CustomerService',
            '$filter',
            '$timeout',
            '$location',
            '$mdSidenav',
            '$mdToast',
            'UsersService',
            'env',
            'customer_id',
            'filter',
            'store_id',
            'filter_date',
            'visite',
            'SubscriptionService',
            'CustomerSubscriptionService',
            'OperatorAvailabilityService',
            'CrudService',
            'RecallTypes'
        ]
    ;
})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('AddressBookPController', AddressBookPController);

    /** @ngInject */
    function AddressBookPController(
        $scope,
        $log,
        $location,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        $http,
        CustomerService,
        env,
        phone,
        CallState,
        Italia,
        Countries,
        TreatmentService,
        StoreService,
        SubscriptionService,
        UsersService,
        CrudService,
        AppointmentsService
    ) {

        $scope.customerSurvey = {};

        try {
            var vm = this;
            vm.env = env;
            $log.info('AddressBookPController');
            vm.mdToast = $mdToast;
            vm.mdDialog = $mdDialog;
            /* Operatore connesso */
            if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
                return;
            }

            if(!localStorage.hasOwnProperty( 'addressbookp-search' )){
                vm.searchInStorage = Array();
            } else {
                vm.searchInStorage = JSON.parse(localStorage.getItem( 'addressbookp-search' ));
            }

            vm.showLastname = true;
            vm.showPhone = true;
            /* Treatments */
            vm.treatmentsList = [];
            TreatmentService.categories().then(function(data) {
                vm.treatmentsList = data;
            });
            vm.subscriptionsList = [];
            SubscriptionService.all({
                search: 1,
                searchFields: 'active:='
            }).then(function(response) {
                vm.subscriptionsList = response.data.data;
            });
            /**
             * Carico document templates
             */
            vm.documentTemplates = [];
            vm.loadDocumentTemplates = function() {
                var pars = {
                    'search': 'document_template_id:4',
                    'searchFields': 'document_template_id:=',
                    'orderBy': 'name'
                };
                CrudService.all('document_templates',pars,vm, function (response) {
                    $log.info(response);
                    vm.documentTemplates = response.data.data;
                }, function (response) {
                    $log.info(response);
                });
            }
            vm.loadDocumentTemplates();

            //---------- Customers Table -------------------------------------//
            vm.env = env;
            vm.today = new Date(moment().hours(0).minutes(0).seconds(0));
            vm.yesterday = new Date(moment(vm.today).subtract(1, 'days'));
            vm.customerStatus = {
                showDatePicker: false,
                selectedIndexFilter: undefined,
                selectedIndex: undefined,
                filter_date_start: null,
                call_state: CallState,
                needDatePicker: function() {
                    this.showDatePicker = true;
                },
                onChange: function() {

                    vm.query.page = 1;

                    if (vm.activeCustomer && angular.isDefined(this.selectedIndex))
                        vm.activeCustomer.call_state = this.call_state[this.selectedIndex]

                    this.needDatePicker();

                },
                onChangeDateFilter: function() {

                    var date = this.filter_date_start;

                    return function(item) {

                        if (!date)
                            return true;

                        if (date && !item.call_date)
                            return false;

                        if (item.call_date)
                            return moment(date).isSame(moment(item.call_date)) || moment(date).isBefore(moment(item.call_date));

                        return true;

                    };
                },
                setIndex: function() {

                    if (vm.activeCustomer && vm.activeCustomer.call_state && ~this.call_state.indexOf(vm.activeCustomer.call_state))
                        vm.customerStatus.selectedIndex = this.call_state.indexOf(vm.activeCustomer.call_state);
                    else
                        vm.customerStatus.selectedIndex = undefined;

                    this.needDatePicker();

                },
            };
            vm.selected = [];
            vm.options = {
                autoSelect: false,
                boundaryLinks: true,
                pageSelector: true,
                rowSelection: false
            };
            vm.filter = {
                options: {
                    'debounce': 0,
                    'updateOn': 'default'
                }
            };
            vm.query = {
                filter: '',
                off: 0,
                order: '',
                limit: 10,
                page: 1
            };
            /* Controllo se c'è un Customer Id nell'URL */
            vm.phone = null;
            if (phone && angular.isDefined(phone)) {
                vm.query.filter = phone.toString();
                vm.phone = phone.toString();
            };
            vm.removeSearch = function() {
                vm.removeSearchInStorage();
                vm.query.filter = '';
                vm.query.filter_merge_ok = '';
                vm.query.filter_merge_ko = '';
                vm.query.order = '';
                vm.query.off = 0;
                vm.customerStatus.filter_date_start = null;
                vm.query.page = 1;
                vm.customersListLoad(1);
            };
            vm.customersList = [];
            vm.eListLoading = false;
            vm.firstLoad = false;
            vm.mergeCheckOk = false;
            vm.customersListPag = {"total":0,"count":10,"per_page":10,"current_page":1,"total_pages":0,"links":{} };
            vm.customersListLoad = function(p, s, fad) {
                vm.mergeCheckOk = false;
                vm.customersList = [];
                if (
                    (vm.query.filter==null || vm.query.filter.trim()=='')
                    && (!vm.query.filter_merge_ok || !vm.query.filter_merge_ko)
                    && !fad) {
                    return;
                }
                vm.eListLoading = true;
                vm.customersList = [];
                if (p==null) {
                    p = 1;
                }
                if (s==null) {
                    s = parseInt(vm.customersListPag.per_page);
                }
                var pars = {page: p, s:s, 'with':'nextAppointment;lastAppointment;sourceCustomer;customer_subscriptions_active;card;referral;lastStore'};
                if (vm.env.documentsEnabled) {
                    pars.with += ';documents';
                }
                if (vm.query.filter_merge_ok && vm.query.filter_merge_ko) {
                    pars.filtro_merge_ok=vm.query.filter_merge_ok;
                    pars.filtro_merge_ko=vm.query.filter_merge_ko;
                    vm.query.filter = null;
                }
                if(fad) {
                    pars.filter_appointments_date=moment().format('YYYY-MM-DD');
                    vm.query.filter = null;
                }
                if (vm.query.filter!=null && vm.query.filter!='') {
                    pars.filtro=vm.query.filter.trim();
                }
                if (vm.customerStatus.filter_date_start!=null && vm.customerStatus.filter_date_start!='') {
                    pars.data_richiamo= moment(vm.customerStatus.filter_date_start).format('YYYY-MM-DD');
                }
                if (vm.customerStatus.selectedIndexFilter!=null && vm.customerStatus.selectedIndexFilter!='') {
                    pars.search='call_state:'+vm.customerStatus.selectedIndexFilter;
                    pars.searchFields='call_state:=';
                }
                if (vm.query.off) {//se non vedo tutti
                    pars.search='off:'+vm.query.off;
                    pars.searchFields='off:=';
                }
                if (vm.query.order!=null && vm.query.order!='') {
                    pars.orderBy = vm.query.order.indexOf('-')==0?vm.query.order.substring(1):vm.query.order;
                    pars.sortedBy = vm.query.order.indexOf('-')==0?'desc':null;
                }

                CustomerService.all(pars).then(function(response) {
                        if (response.data && response.data.data) {
                            vm.customersList = [];
                            var customersList = [];
                            //response.data.meta.pagination.per_page = vm.customersListPag.per_page;
                            vm.customersListPag = response.data.meta.pagination;
                            angular.forEach(response.data.data, function(elem) {
                                delete elem.updated_at;
                                delete elem.created_at;
                                elem.firstname = elem.firstname || '';
                                elem.lastname = elem.lastname || '';

                                var birthdate = elem.birthdate ? moment(elem.birthdate) : null;
                                elem.birthdate = birthdate ? new Date(birthdate) : null;

                                var call_date = elem.call_date ? moment(elem.call_date) : null;
                                elem.call_date = call_date ? new Date(call_date) : null;
                                if (vm.env.isMaster && elem.tenant && elem.tenant!=vm.env.tenant && vm.env.admins) {
                                    elem.urlCustomer = vm.env.admins[elem.tenant] + "/customer?phone="+elem.phone;
                                }
                                vm.initDocuments(elem);
                                elem.age = vm.calculateAge(elem.birthdate);
                                elem.birthdate_formatted = (elem.birthdate)?
                                    moment(elem.birthdate).format('DD/MM/YYYY'):
                                    "";
                                if(elem.lastAppointment){
                                    elem.lastAppointment.data.date_start_converted = moment(elem.lastAppointment.data.date_start).format('DD/MM/YYYY');
                                    elem.lastAppointment.data.date_end_converted = moment(elem.lastAppointment.data.date_end).format('DD/MM/YYYY');
                                }
                                if(elem.nextAppointment){
                                    elem.nextAppointment.data.date_start_converted = moment(elem.nextAppointment.data.date_start).format('DD/MM/YYYY HH:mm');
                                    elem.nextAppointment.data.date_end_converted = moment(elem.nextAppointment.data.date_end).format('DD/MM/YYYY HH:mm');
                                }
                                if(elem.scontrino_medio) {
                                    var scontrino_medio_arrotondato = parseFloat(elem.scontrino_medio).toFixed(2);
                                    elem.scontrino_medio = scontrino_medio_arrotondato;
                                }
                                if(elem.media_minuti) {
                                    var media_minuti_arrotondato = Math.round(elem.media_minuti);
                                    elem.media_minuti = media_minuti_arrotondato;
                                }
                                customersList.push(elem);
                            });
                            vm.customersList = customersList;
                            if (vm.customersList.length==1) {
                                //vm.rowClicked(vm.customersList[0]);
                            } else if (
                                vm.customersList.length==0 &&
                                !fad && //EXCLUDE CASE FILTER TODAY APPOINTMENTS
                                vm.query.filter.trim().match("^[0-9]{9}[0-9]?$")
                            ) {
                                vm.toggleRight();
                            } else if (vm.customersList.length==2) {
                                var c0 = vm.customersList[0];
                                var c1 = vm.customersList[1];
                                if (c0.phone == vm.query.filter_merge_ok
                                    || c0.phone == vm.query.filter_merge_ko ) {
                                    if (c1.phone == vm.query.filter_merge_ok
                                        || c1.phone == vm.query.filter_merge_ko ) {
                                        vm.mergeCheckOk = true;
                                    }
                                }
                            }
                        }
                        vm.eListLoading = false;
                        vm.firstLoad = true;
                    },
                    function (response) {
                        var errMsg = "";
                        if (response.data!=null && response.data.message!=null) {
                            errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                            var url = response.config!=null && response.config.url!=null?response.config.url:"";
                            if (url!=null) {
                                errMsg+= "\nUrl: " + url;
                            }
                        }
                        alert ("Si è verificato un errore nel caricamento clienti: " + errMsg);
                        vm.eListLoading = false;
                    });
            };
            vm.customersListLoad(vm.query.page,10);
            vm.onKeyPressSearch = function (event) {
                if (!event || event.keyCode==13) {
                    vm.addSearchInStorage();
                    vm.customersListLoad(1);
                    if (event) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }
            }

            /**
             * Visualizzo activities su app
             */
            vm.showActivities = function( ent ) {
                if (vm.user.type != 'admin') {
                    return    vm.rowClicked(ent);
                }
                var dialog = $mdDialog.confirm({
                    title: 'Storico Modifiche: ' + (ent.firstname!=null?ent.firstname.toUpperCase():'')
                        + ' ' + (ent.lastname!=null?ent.lastname.toUpperCase():'') + " (cid="+ent.id+")",
                    ariaLabel: 'Storia Modifiche Cliente',
                    templateUrl: 'app/components/dialogs/activity-log.html',
                    escapeToClose: true,
                    controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                        $scope.title = this.title;
                        $scope.button_ok = 'Chiudi';
                        $scope.activities = [];
                        $scope.loadActivities = function () {
                            var pars = {
                                'log_name': 'default',
                                'subject_type':'App\\Entities\\Customer',
                                'subject_id': ent.id,
                                with: 'causer;subject'
                            };
                            $scope.loading = true;
                            CrudService.all('activity_log', pars, vm,
                                function (response) {
                                    angular.forEach(response.data.data, function(act) {
                                        act.created_at_frmt = moment(act.created_at).format('D/M/YYYY HH:mm:ss');
                                        $scope.activities.push(act);
                                    });
                                    $scope.loading = false;
                                },
                                function (response) {
                                    var errMsg = "";
                                    if (response.data!=null
                                        && response.data.message!=null) {
                                        errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                                        var url = response.config!=null && response.config.url!=null?response.config.url:"";
                                        if (url!=null) {
                                            errMsg+= "\nUrl: " + url;
                                        }
                                    }
                                    alert ("Si è verificato un errore nel caricamento delle attività: " + errMsg);
                                    $scope.loading = false;
                                });
                        }
                        $scope.close = function() {
                            $mdDialog.hide( true );
                        };
                        $scope.loadActivities();
                    }]
                });

                return $mdDialog
                    .show( dialog )
                    .finally(
                        function() {
                            dialog = undefined;
                        }
                    )
                    ;
            };

            /**
             * Documenti cliente
             */
            /**
             * verifico se è presente documento firmato associato al trattamento (se il trattamento lo richiede)
             */
            vm.initDocuments = function(customer) {
                if (!vm.env.documentsEnabled) {
                    return;
                }
                $log.info("docs",customer.documents);
                /**
                 * verifico se presente privacy + autorizzazione foto + consenso al trattamento corrente
                 */
                customer.docPrivacyOk = false;
                customer.docCovidOk = false;
                customer.docPicturesOk = false;
                customer.documents.templates = [];
                angular.copy(vm.documentTemplates, customer.documents.templates);
                angular.forEach(customer.documents.data, function(doc) {
                    doc.time = moment(doc.created_at.date?doc.created_at.date:doc.created_at).format('H:mm');
                    if (doc.document_type_id == 301 && !customer.docPrivacyOk) {
                        customer.docPrivacyOk = true;
                        doc.title = 'Privacy';
                        customer.docPrivacy = {'data':doc};
                    } else if (doc.document_type_id == 302 && !customer.docPicturesOk) {
                        customer.docPicturesOk = true;
                        doc.title = 'Consenso fotografie';
                        customer.docPictures = {'data':doc};
                    } else if (doc.document_type_id == 305 && !customer.docCovidOk) {
                        customer.docCovidOk = true;
                        doc.title = 'Autocertificazione COVID-19';
                        customer.docCovid = {'data':doc};
                    } else {
                        if (doc.description) {
                            var sA = doc.description.split('|');
                            doc.title = sA[0];
                        }
                        if (doc.document_type_id == 303) {
                            for(var i=0;i<customer.documents.templates.length; i++) {
                                if (customer.documents.templates[i].id == doc.document_template_id) {
                                    customer.documents.templates.splice(i,1);
                                    break;
                                }
                            }
                        }
                    }
                });
                $log.info("docTemplates",customer.documents.templates);
                $log.info("docPrivacy "+customer.id,customer.docPrivacyOk);
                $log.info("docPictures "+customer.id,customer.docPicturesOk);
            };
            vm.showDocuments = function( customer ) {
                var dialog = $mdDialog.confirm({
                    title: 'Elenco documenti: di ' + (customer.firstname!=null?customer.firstname.toUpperCase():'')
                        + ' ' + (customer.lastname!=null?customer.lastname.toUpperCase():'') + " (cid="+customer.id+")",
                    ariaLabel: 'Elenco documenti cliente',
                    templateUrl: 'app/addressbook/dialogs/customer-documents.html',
                    escapeToClose: true,
                    controller: [ '$scope', '$mdDialog', '$filter', '$http', '$log',  function( $scope, $mdDialog, $filter, $http, $log ) {
                        $scope.title = this.title;
                        $scope.button_ok = 'Chiudi';
                        $scope.customer = customer;
                        $scope.env = vm.env;
                        $scope.token = vm.token;
                        $scope.refresh = function() {
                            /**
                             * ricarico documenti cliente
                             */
                            $scope.loading = true;
                            $http.get($scope.env.API+"/documents?customer_id="+$scope.customer.id).then(
                                function (response) {
                                    $scope.customer.documents = {'data': response.data.data };
                                    vm.initDocuments($scope.customer);
                                    $scope.loading = false;
                                },
                                function (response) {
                                    $log.info(response);
                                    $scope.loading = false;
                                }
                            );
                        };
                        $scope.close = function() {
                            $mdDialog.hide( true );
                        };
                    }]
                });

                return $mdDialog
                    .show( dialog )
                    .finally(
                        function() {
                            dialog = undefined;
                        }
                    )
                    ;
            };
            vm.showNote = function (c) {
                if (c.note==null || c.note.trim()=='' ) return;
                var testo = "";
                if (c.note!=null && c.note.trim()!='') {
                    testo += "<p>"+c.note.trim()+"</p>";
                }
                var p = $mdDialog.confirm()
                    .title("Note su " + (c.firstname!=null?c.firstname.toUpperCase():'')
                        + ' ' + (c.lastname!=null?c.lastname.toUpperCase():'')
                    ).htmlContent(testo)
                    .ok( 'Ok' );
                return $mdDialog.show( p );
            };
            vm.merging = false;
            vm.merge = function() {
                vm.merging = true;
                vm.eListLoading = true;
                $http.post(env.API + "/customers_merge/"
                    +vm.query.filter_merge_ok
                    +"/"+vm.query.filter_merge_ko,{}).then(
                    function(response) {
                        //$log.info(response);
                        vm.merging = false;
                        vm.customersListLoad(1);
                    },
                    function(response) {
                        $log.info(response);
                        vm.merging = false;
                        vm.eListLoading = false;
                        alert("Errore!");
                    }
                );
            };
            vm.customersListReOrder = function (column) {
                vm.query.order = column;
                vm.customersListLoad(1);
            };
            vm.richiestaCard = function (customer) {
                customer.isCardRequest = true;
                vm.toggleRight(customer);
                //customer.card = {data: {id: 1, delivered: false}};
            };
            //---------- Sidebar -------------------------------------//
            vm.rowClicked = function(customer) {
                delete customer.isCardRequest;
                vm.toggleRight(customer);
            };
            vm.testsVisible = false;
            vm.isDeleteAllowed = true;
            vm.undoVisible = false;
            vm.img_loading = false;
            vm.loading = false;
            vm.isNewCustomer = false;
            vm.activeCustomer = {};
            vm.backup_customer = {};
            vm.update_customer = {};
            vm.empty_customer = {};
            vm.toggleRight = function(customer) {
                vm.appointmentsForCustomer = [];
                vm.isNewCustomer = angular.isUndefined(customer);
                if (angular.isDefined(customer)) {
                    if (customer.src_cid!=null) {
                        vm.activeRelCustomer = customer.sourceCustomer.data;
                        vm.relCustomersList = [customer.sourceCustomer.data].map(
                            function( customer ) {
                                customer.fullName =  (
                                    ( customer.firstname || '' )
                                    + ' '
                                    + ( customer.lastname || '' )
                                ).toUpperCase();
                                return customer;
                            }
                        );
                    }
                    if (customer.zip_code!=null) {
                        if (customer.zip_code!='') {
                            customer.zip_code = parseInt(''+customer.zip_code);
                        } else {
                            customer.zip_code = null;
                        }
                    }
                    vm.customerStatus.setIndex();
                    vm.loading = true;
                    angular.copy(customer, vm.backup_customer);
                    vm.activeCustomer = customer;
                    CustomerService.get(customer.id, {'allapps': true,
                        'with': 'appointments.assist_user;appointments.role;customerSurveysV2;card;appointments;recharges;invited'
                    }).then(function(response) {
                        if (response.data && response.data.data) {
                            if (response.data.data.card!=null) {
                                response.data.data.card.data.created_at_frmt = response.data.data.card.data.created_at!=null?
                                    moment(response.data.data.card.data.created_at.data).format('DD/MM/YYYY'):null;
                                response.data.data.card.data.delivered_at_frmt = response.data.data.card.data.delivered_at!=null?
                                    moment(response.data.data.card.data.delivered_at.data).format('DD/MM/YYYY'):null;
                                vm.backup_customer.card = response.data.data.card;
                                vm.activeCustomer.card = response.data.data.card;

                            }
                            /**
                             * Setto data creazione e invitato per ogni ricarica
                             */
                            angular.forEach(response.data.data.recharges.data, function(elem) {
                                elem.created_at_frmt = moment(elem.created_at.date).format("DD/MM/YYYY");
                                angular.forEach(response.data.data.invited.data, function(inv) {
                                    if (elem.from_customer_id == inv.id) {
                                        elem.customer = {data: inv};
                                    }
                                });
                            });
                            /**
                             * Setto total amount per ogni invitato
                             */
                            angular.forEach(response.data.data.invited.data, function(elem) {
                                elem.created_at_frmt = moment(elem.created_at.date).format("DD/MM/YYYY");
                                elem.rechargeAmount = 0;
                                angular.forEach(response.data.data.recharges.data, function(rec) {
                                    if (rec.from_customer_id == elem.id) {
                                        elem.rechargeAmount += rec.amount;
                                    }
                                });
                            });
                            vm.backup_customer.credit = response.data.data.credit;
                            vm.activeCustomer.credit = response.data.data.credit;
                            angular.forEach(response.data.data.appointments.data, function(element) {
                                var color = '';
                                /*angular.forEach(vm.operatorsList, function(operator) {
                                    if (operator.id == element.user_id)
                                        color = operator.color
                                });*/
                                var appointment = {
                                    "date_start": new Date(element.date_start),
                                    "treatment_id": element.treatment_id,
                                    "store_id": element.store_id,
                                    "user_color": color,
                                    "price": element.price,
                                    "recalled": element.recalled,
                                    "customer_subscription_id": element.customer_subscription_id,
                                    "paid": element.paid,
                                    "credit": element.credit
                                }
                                vm.appointmentsForCustomer.push(appointment);
                            });
                            vm.backup_customer.invited = response.data.data.invited;
                            vm.activeCustomer.invited = response.data.data.invited;
                            vm.backup_customer.recharges = response.data.data.recharges;
                            vm.activeCustomer.recharges = response.data.data.recharges;
                            if(response.data.data.appointments && response.data.data.appointments.data) {
                                vm.activeCustomer.appointments = response.data.data.appointments;
                                angular.forEach( vm.activeCustomer.appointments.data, function( elem ) {
                                    elem.date_start_frmt = moment( elem.date_start).format('DD/MM/YYYY HH:mm')
                                });
                            }
                            vm.activeCustomer.customerSurveysV2 = response.data.data.customerSurveysV2.data;
                            vm.loading = false;

                            vm.detectSurveyExpires(vm.activeCustomer.customerSurveysV2);
                        }
                    }, function(response) {
                        var errMsg = "";
                        if (response.data!=null && response.data.message!=null) {
                            errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                            var url = response.config!=null && response.config.url!=null?response.config.url:"";
                            if (url!=null) {
                                errMsg+= "\nUrl: " + url;
                            }
                        }
                        alert ("Si è verificato un errore nel caricamento dei dati del paziente: " + errMsg);
                        vm.loading = false;
                    });
                } else {
                    var phone = null;
                    if (vm.customersList==0) {
                        var s = vm.query.filter.trim();
                        var m = s.match("^[0-9]{9}[0-9]?$");
                        if (m && m.length>=1 && m[0]==s) {
                            phone = s;
                        }
                    }
                    vm.empty_customer = {
                        id: null,
                        firstname: '',
                        lastname: '',
                        phone: phone,
                        gender: 'F',
                        email: '',
                        referral_code: '',
                        note: '',
                        campaign: '',
                        birthdate: null,
                        city: null,
                        call_state: null,
                        call_date: null,
                        customerSurvey: null //customerSurvey: vm.mergeAnswerStructure()
                    };
                    angular.copy(vm.empty_customer, vm.backup_customer);
                    vm.activeCustomer = vm.empty_customer;
                };
                $timeout($mdSidenav('right').open, 0);
            };
            vm.phoneChecking = false;
            vm.checkPhoneExists = function() {
                vm.phoneChecking = true;
                vm.customerExists = {};
                if (vm.activeCustomer
                    && vm.activeCustomer.phone
                    && vm.activeCustomer.phone.trim()!='')
                {
                    CustomerService.all(
                        {'filtro': vm.activeCustomer.phone,
                            'search': 'phone:'+vm.activeCustomer.phone,
                            'searchFields':'phone:='
                        }).then(
                        function(response) {
                            vm.phoneChecking = false;
                            if(response.data.data.length >= 1 && (vm.activeCustomer.id==null || vm.activeCustomer.id!=response.data.data[0].id)) {
                                $scope.customerForm.phone.$setValidity('alreadyexists', false);
                                vm.customerExists = response.data.data[0];
                            } else {
                                $scope.customerForm.phone.$setValidity('alreadyexists', true);
                            }
                        },
                        function(response) {
                            vm.phoneChecking = false;
                        }
                    );
                }
            };

            vm.resetAll = function() {
                vm.undoVisible = false;
                vm.backup_customer = {};
                vm.update_customer = {};
                vm.activeCustomer = {};
                $timeout(vm.resetForm,0);
            };
            vm.closeSidebar = function() {
                if (vm.undoVisible) {
                    var confirm = $mdDialog.confirm()
                        .title('Attenzione')
                        .textContent('Ci sono delle modifiche non commissionate, proseguire?')
                        .ariaLabel('Attenzione')
                        .ok('Si')
                        .cancel('Ops, ho sbagliato');
                    return $mdDialog
                        .show(confirm)
                        .then(vm.undo)
                        .finally(
                            function() {
                                confirm = undefined;
                            }
                        );
                } else {
                    return vm.resetAll();
                };
            };
            vm.resetForm = function() {
                return $mdSidenav('right').close().then(
                    function() {
                        $scope.customerForm.$setPristine();
                        $scope.customerForm.$setUntouched();
                        vm.relCustomersReset();
                    });
            };
            vm.undo = function() {
                $log.info('Undo');

                if (!angular.equals(vm.activeCustomer, vm.backup_customer)) {
                    angular.copy(vm.backup_customer, vm.activeCustomer);
                };

                vm.customerStatus.selectedIndex = undefined;
                vm.customerStatus.showDatePicker = false;

                return vm.resetAll();
            };
            vm.fakeDelForced = function(customer) {
                $log.info('Del Forced');
                if (angular.isDefined(customer)) {
                    var index = vm.customersList.indexOf(customer);
                    vm.customersList.splice(index, 1);
                };
            };

            vm.detectSurveyExpires = function(customerSurveys) {
                var surTypes = [];
                customerSurveys.forEach(function(survey) {
                    surTypes[survey.survey_id] = true;
                });

                var expired = false;
                var now = new Date().getTime();
                surTypes.forEach(function(surveyType, index) {
                    var arrSur = customerSurveys.filter(function (el) { return el.survey_id == index });
                    for (var i = 0; i < arrSur.length; i++) {
                        if ((arrSur[i].expires_at * 1000) > now) {
                            return;
                        } else {
                            if (arrSur[i].expires_at > expired) {
                                expired = true;
                            }
                        }
                    }
                });

                if (expired) {
                    setTimeout(function() {
                        alert ("Questo paziente ha un'anamnesi scaduta!");
                    }, 300);
                }
            }

            vm.del = function(customer) {
                $log.info('Del');
                if (angular.isDefined(customer)) {
                    var message = 'Sicuro di voler Cancellare '+ customer.lastname + ' ' +  customer.firstname + '(cell: ' + customer.phone + ')'+ '?'
                    var confirm = $mdDialog.confirm()
                        .title('Attenzione')
                        .htmlContent('<p class="md-title">'+message+'</p>')
                        .ariaLabel('Attenzione')
                        .ok('Si')
                        .cancel('Ops, ho sbagliato');
                    return $mdDialog
                        .show(confirm)
                        .then(
                            function() {
                                CustomerService.del(customer.id).then(function(response) {
                                    if (response.data.deleted) {
                                        vm.fakeDelForced(customer);
                                        vm.resetAll();
                                    }

                                    var alert = $mdDialog.alert()
                                        .title('Cancellazione')
                                        // .ariaLabel('Attenzione')
                                        .textContent(response.data.message)
                                        .ok('Ok');
                                    return $mdDialog
                                        .show(alert)
                                        .finally(
                                            function() {
                                                alert = undefined;
                                            }
                                        );
                                });
                            }
                        )
                        .finally(
                            function() {
                                confirm = undefined;
                            }
                        );
                };
            };
            vm.showActionToast = function( text) {
                text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
                var toast = $mdToast.simple()
                    .textContent(text)
                    .action('')
                    .highlightAction(true)
                    .position('bottom right');
                return $mdToast
                    .show(toast)
                    .finally(
                        function() {
                            toast = undefined;
                        }
                    );
            };
            vm.responseStatusSuccessful = [200, 201, 202];
            vm.checkResponse = function(response) {
                vm.saving = false;
                if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
                    var errMsg = "";
                    if (response.data!=null && response.data.message!=null) {
                        errMsg = response.data!=null && response.data.message!=null?response.data.message:"";
                        var url = response.config!=null && response.config.url!=null?response.config.url:"";
                        vm.showActionToast("KO: " + errMsg + " " + url);
                    }
                    var alert = $mdDialog.alert()
                        .title('Attenzione')
                        .ariaLabel('Attenzione')
                        .textContent("C'è stato un problema: "+errMsg)
                        .ok('Ok');
                    return $mdDialog
                        .show(alert)
                        .finally(
                            function() {
                                alert = undefined;
                            }
                        );
                } else {
                    vm.showActionToast();
                    return vm.resetAll();
                };
            };
            vm.saving = false;
            vm.save = function(customer, book) {
                $log.info('Salva');
                if (angular.isDefined(customer)) {
                    var confirm = $mdDialog.confirm()
                        .title('Attenzione')
                        .ariaLabel('Attenzione')
                        .textContent('Sicuro di voler inserire questo utente?')
                        .ok('Si')
                        .cancel('Ops, ho sbagliato');
                    return $mdDialog
                        .show(confirm)
                        .then(
                            function() {
                                vm.saving = true;
                                angular.copy(customer, vm.update_customer);
                                if (customer.birthdate) {
                                    vm.update_customer.birthdate = $filter('date')(new Date(vm.update_customer.birthdate), 'yyyy-MM-dd');
                                };
                                if (customer.call_date) {
                                    vm.update_customer.call_date = $filter('date')(new Date(vm.update_customer.call_date), 'yyyy-MM-dd HH:mm');
                                };
                                delete(vm.update_customer.id);
                                CustomerService.save(vm.update_customer).then(
                                    function(response) {
                                        vm.checkResponse(response);
                                        if (vm.responseStatusSuccessful.indexOf(response.status) !== -1) {
                                            if (response.data && response.data.data) {
                                                vm.customersList.push(response.data.data);
                                                $log.info("todo dovrei aprire booking");
                                                vm.query.filter = response.data.data.phone;
                                                if (!book) {
                                                    vm.custometListLoad(1);
                                                } else {
                                                    location = vm.env.booking +"/operator?c_sid="+vm.user.store_id+
                                                        "&c_role="+vm.user.type+
                                                        "&customer="+response.data.data.phone+
                                                        "&store="+vm.storeId+
                                                        "&callcenter="+vm.isCallCenter+
                                                        "&token="+vm.token;
                                                }
                                                //ng-href="{{ ap.env.booking }}/operator?c_sid={{ ap.user.store_id }}&amp;c_role={{ ap.user.type }}&amp;store={{ ap.storeId }}&amp;callcenter={{ ap.isCallCenter }}&amp;token={{ ap.token }}"

                                            };
                                        };
                                        vm.saving = false;
                                    },
                                    function(response) {
                                        vm.checkResponse(response);
                                        vm.saving = false;
                                    });
                            }
                        )
                        .finally(
                            function() {
                                confirm = undefined;
                            }
                        );
                };
            };
            vm.update = function(customer) {
                $log.info('Update');
                if (angular.isDefined(customer)) {
                    if (!angular.equals(customer, vm.backup_customer)) {
                        var confirm = $mdDialog.confirm()
                            .title('Attenzione')
                            .ariaLabel('Attenzione')
                            .textContent('Sicuro di voler aggiornare?')
                            .ok('Si')
                            .cancel('Ops, ho sbagliato');
                        return $mdDialog
                            .show(confirm)
                            .then(
                                function() {
                                    vm.saving = true;
                                    angular.copy(customer, vm.update_customer);
                                    vm.update_customer.with = 'card';
                                    if (customer.birthdate) {
                                        vm.update_customer.birthdate = $filter('date')(new Date(vm.update_customer.birthdate), 'yyyy-MM-dd');
                                    };
                                    if (customer.call_date) {
                                        vm.update_customer.call_date = $filter('date')(new Date(vm.update_customer.call_date), 'yyyy-MM-dd HH:mm');
                                    };

                                    //ADD SURVEYS TO REQUEST
                                    // vm.update_customer.customerSurvey = $scope.customerSurvey.data;

                                    CustomerService.update(vm.update_customer).then(
                                        function (response) {
                                            vm.checkResponse(response);
                                            if (response.data!=null && response.data.data!=null) {
                                                customer.card = response.data.data.card;
                                            }
                                        },
                                        vm.checkResponse);
                                }
                            )
                            .finally(
                                function() {
                                    confirm = undefined;
                                }
                            );
                    };
                };
            };
            $scope.$watch('abp.activeCustomer', function(newValue) {
                vm.undoVisible = (angular.equals(newValue, vm.backup_customer) || vm.isNewCustomer) ? false : true;
            }, true);
            vm.Italia = Italia;
            vm.Countries = Countries;
            /**
             * Gestione invitato da
             */
            vm.filter_relcustomer = '';
            vm.relCustomersList = [];
            vm.activeRelCustomer = null;
            vm.activeRelCustomerChange = function () {
                vm.activeCustomer.src_cid = vm.activeRelCustomer.id;
                vm.activeCustomer.sourceCustomer = {data: vm.activeRelCustomer};
            }
            vm.onKeyUpRelCustomersSearch = function (evento, obj) {
                if (evento.keyCode==13)  {
                    vm.relCustomersLoad();
                    evento.stopPropagation();
                    evento.preventDefault();
                }
            };
            vm.relCustomersReset = function () {
                vm.relCustomersList = [];
                vm.filter_relcustomer = '';
                vm.activeRelCustomer = null;
            };
            vm.relCustomersLoad = function ( ) {
                vm.relCustomersList = [];
                vm.relCustomersLoading = true;
                var pars = {page:1, s:10, orderBy: 'firstname'};
                var search = [];
                var searchFields = [];
                if (vm.filter_relcustomer!=null && vm.filter_relcustomer!='') {
                    pars.filtro = vm.filter_relcustomer;
                }
                if (search.length>0) {
                    pars.search = search.join(";");
                    pars.searchFields = searchFields.join(";");
                }
                return CustomerService
                    .all(pars).then(
                        function( response ) {
                            if( response.data && response.data.data ) {
                                vm.relCustomersList = response.data.data.map(
                                    function( customer ) {
                                        customer.fullName =  (
                                            ( customer.firstname || '' )
                                            + ' '
                                            + ( customer.lastname || '' )
                                        ).toUpperCase();
                                        return customer;
                                    }
                                );
                                if (vm.relCustomersList.length==0) {
                                    vm.showActionToast("Nessun elemento trovato.");
                                }
                                vm.relCustomersLoading = false;
                            };
                        },
                        function (response) {
                            vm.checkResponse(response);
                            vm.relCustomersLoading = false;
                        }
                    )
                    ;
            };



            /* WATCHO Lo Store */
            vm.storesList = [];
            vm.storeId = null;
            $scope.$watch('$parent.selectedStore', function(id) {
                if (angular.isDefined(id)) {
                    if (vm.storeId==null) {//è il primo caricamento
                        vm.storesList = $scope.$parent.main.storesList;
                        //vm.operatorLoad();
                    }
                    vm.storeId = id;
                };
            });

            /* Operators */
            /*vm.operatorsList = [];
            vm.operatorLoad = function() {
                vm.operatorsList = [];
                UsersService.all({
                    search: 'active:1;type:operator',
                    searchFields: 'active:=;type:='
                }).then(function(response) {
                    if (response.data && response.data.data) {
                        vm.operatorsList = response.data.data;
                    };
                });
            };*/
        } catch(err) {
            $log.info('error:',err);
        }

        vm.calculateAge = function(customerBirthdate) {
            var age = '';
            if(customerBirthdate) {
                var customerBYear = Number(customerBirthdate.getFullYear());
                var actualYear = Number(new Date().getFullYear());
                age = actualYear  - customerBYear;
            }
            return age;
        }

        /*vm.surveyQuestions = [];
        vm.loadSurveyQuestion = function(){
            vm.eListLoading = true;
            var pars = {
                'search': 'survey_id:1',
                'searchFields': 'survey_id:>',
            };
            pars.surveyName='customer';
            pars.orderBy='position';
            pars.with = 'survey'
            CrudService.all('survey_questions', pars, vm, function (response) {
               vm.surveyQuestions = response.data.data;
               angular.forEach(vm.surveyQuestions, function(elem) {
                   if(elem.answer_type && elem.answer_type !="open" && elem.answer_choices) {
                        var answer_choices_toArray = elem.answer_choices.split(";");
                        elem.answer_choices_toArray = answer_choices_toArray;
                   }
               });
               vm.eListLoading = false;
             },
             function (response) {
                vm.eListLoading = false;
               var errMsg = "";
               if (response.data!=null
                       && response.data.message!=null) {
                 errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                 var url = response.config!=null && response.config.url!=null?response.config.url:"";
                 if (url!=null) {
                   errMsg+= "\nUrl: " + url;
                 }
               }
               alert ("Si è verificato un errore nel caricamento delle attività: " + errMsg);
               $scope.loading = false;
            });
        }
        vm.loadSurveyQuestion();

        vm.mergeAnswerStructure = function (customerSurvey) {
            var surveyQuestions = vm.surveyQuestions;
            var newCustomerSurvey = {'data': []};

            if (!customerSurvey) {
                customerSurvey = {'data': []};
            }
            angular.forEach(surveyQuestions, function(elem) {
                var answerCustomer = {
                        id: null,
                        answer: null,
                        customer_id: vm.activeCustomer.id,
                        survey_id: elem.survey_id,
                        survey_question_id: elem.id,
                        created_at: null,
                        updated_at: null,
                        surveyQuestion: elem
                    };
                if(customerSurvey && customerSurvey.data && customerSurvey.data.length > 0) {
                    angular.forEach(customerSurvey.data, function(custSurvey) {
                        if(custSurvey.survey_question_id == elem.id) {
                            answerCustomer.id = custSurvey.id;
                            answerCustomer.answer = custSurvey.answer;
                            answerCustomer.created_at = custSurvey.created_at;
                            answerCustomer.updated_at = custSurvey.updated_at;
                        }
                    });
                }
                newCustomerSurvey.data.push(answerCustomer);

            });
            return newCustomerSurvey;
        }*/

        vm.addSearchInStorage = function() {
            var search = vm.query.filter;
            if( search ) {

                //ADD IN FIRST POSITION
                vm.searchInStorage.unshift(search);

                //REMOVE LAST ITEM
                if( vm.searchInStorage.length > 5 ) {
                    vm.searchInStorage.splice(-1);
                }

                localStorage.setItem( 'addressbookp-search', JSON.stringify(vm.searchInStorage) );

            }
        }

        vm.removeSearchInStorage = function(){
            var search = vm.query.filter;
            if( search ) {
                angular.forEach(vm.searchInStorage, function(value, key) {
                    if( value == search ) {
                        vm.searchInStorage.splice(key, 1);
                    }
                });

                localStorage.setItem( 'addressbookp-search', JSON.stringify(vm.searchInStorage) );
            }
        }

        vm.searchTag = function(search) {
            vm.query.filter = search;
            vm.customersListLoad(1);
        }

        vm.onScaricaPdf = function() {
            var url =
                env.API+"/customer_cartella_clinica_pdf"
                +"/"+vm.activeCustomer.id
                +"?token="+vm.token;
            window.open(url);
        }
        vm.onScaricaZip = function() {
            var url =
                env.API+"/customer_cartella_clinica_zip"
                +"/"+vm.activeCustomer.id
                +"?token="+vm.token;
            window.open(url);
        }

    };

    AddressBookPController
        .$inject = [
        '$scope',
        '$log',
        '$location',
        '$timeout',
        '$mdSidenav',
        '$mdDialog',
        '$mdToast',
        '$filter',
        '$http',
        'CustomerService',
        'env',
        'phone',
        'CallState',
        'Italia',
        'Countries',
        'TreatmentService',
        'StoreService',
        'SubscriptionService',
        'UsersService',
        'CrudService',
        'AppointmentsService'
    ];

})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .service(
            'CustomerService',
            [
                '$log',
                'env',
                '$http',
                function(
                    $log,
                    env,
                    $http
                ) {
                    return {
                        users_for_appointment : function(pars) {
                            var apiURI = env.API + '/customers/users_for_appointment';
                            //?with=customer_subscriptions
                            return $http.get( apiURI, { params:  pars } );
                        },
                        all : function(pars) {
                            var apiURI = env.API + '/customers';
                            //?with=customer_subscriptions
                            return $http.get( apiURI,  { params:  pars } );
                        },
                        /*allWithSubscriptionActive : function(pars) {
                        	  //pars.with = 'customer_subscriptions_active';
                            var apiURI = env.API + '/customers'
                            return $http.get( apiURI, { params:  pars } );
                        },*/
                        get : function( id, pars ) {
                            if( angular.isDefined( id ) && id ) {
                                var apiURI = env.API + '/customers/' + id;
                                return $http.get( apiURI,  { params:  pars } );
                            }
                        },
                        rotation : function(phone, id, store_id , paid, noshow, dormientiDa, pars) {
                            if( id && angular.isDefined( id ) ) {
                                var apiURI = env.API + '/customers/' + id;
                                return $http.get( apiURI, { params:  pars } );
                            } else if ( phone && angular.isDefined( phone ) ) {
                                var apiURI = env.API + '/customers_by_phone/' + phone;
                                return $http.get( apiURI, { params:  pars } );
                            } else {
                            	var apiURI = env.API + '/customers/rotation/' + store_id + "/" + paid + "/" + dormientiDa + "/" + noshow;
                                return $http.get( apiURI, { params:  pars } );
                            }
                        },
                        update : function( data ) {
                            if(
                                angular.isDefined( data ) &&
                                angular.isObject( data ) &&
                                data.id
                            ) {
                                var transformer = data;

                                if( transformer.hasOwnProperty( "$readonly" ) )
                                    delete( transformer.$readonly );

                                if( transformer.hasOwnProperty( "$selectedIndex" ) )
                                    delete( transformer.$selectedIndex );

                                var apiURI = env.API + '/customers/' + transformer.id;
                                return $http.put( apiURI, transformer );
                            };
                        },
                        del : function( id ) {
                            if( id ) {
                                var apiURI = env.API + '/customers/' + id;
                                return $http.delete( apiURI );
                            };
                        },
                        save : function( data ) {
                            if(
                                angular.isDefined( data ) &&
                                angular.isObject( data )
                            ) {
                                var transformer = data;

                                if( transformer.hasOwnProperty( "$readonly" ) )
                                    delete( transformer.$readonly );

                                if( transformer.hasOwnProperty( "$selectedIndex" ) )
                                    delete( transformer.$selectedIndex );

                                var apiURI = env.API + '/customers';
                                return $http.post( apiURI, transformer );
                            };
                        },
                    };
                }
            ]
        );

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .controller('AddressBookController', AddressBookController);

    /** @ngInject */
    function AddressBookController(
        $scope,
        $log,
        $window,
        $timeout,
        $mdSidenav,
        $mdDialog,
        $mdToast,
        $filter,
        $http,
        CustomerService,
        env,
        phone,
        CallState,
        Italia,
        TreatmentService,
        SubscriptionService,
        UsersService,
        CrudService,
        WkflowService
    ) {
        try {
        var vm = this;
        vm.env = env;
        $log.info('AddressBookController');
        vm.mdToast = $mdToast;
        vm.mdDialog = $mdDialog;
        /* Operatore connesso */
        if (!UsersService.loadUserFromLocalStorage(vm, $scope.$parent.main)) {
            return;
        }
        /* Treatments */
        vm.treatmentsList = [];
        TreatmentService.categories().then(function(data) {
            vm.treatmentsList = data;
        });
        vm.subscriptionsList = [];
        SubscriptionService.all({
            search: 1,
            searchFields: 'active:='
        }).then(function(response) {
            vm.subscriptionsList = response.data.data;
        });

        vm.wkflowSbox = null;
        vm.wkflowSboxStates = null;
        WkflowService.loadOne(vm, 'SBOX',
            function(wkflows, wkstates) {
                if (wkflows && wkflows.length>0) {
                    vm.wkflowSbox = wkflows[0];
                    vm.wkflowSboxStates = wkstates;
                }
            }
        );

        //---------- Customers Table -------------------------------------//
        vm.env = env;
        vm.today = new Date(moment().hours(0).minutes(0).seconds(0));
        vm.yesterday = new Date(moment(vm.today).subtract(1, 'days'));
        vm.guaranteeDisabled = false;
        vm.customerStatus = {
            showDatePicker: false,
            selectedIndexFilter: undefined,
            selectedIndex: undefined,
            filter_date_start: null,
            call_state: CallState,
            needDatePicker: function() {
                this.showDatePicker = true;
            },
            onChange: function() {

                vm.query.page = 1;

                if (vm.activeCustomer && angular.isDefined(this.selectedIndex))
                    vm.activeCustomer.call_state = this.call_state[this.selectedIndex]

                this.needDatePicker();

            },
            onChangeDateFilter: function() {

                var date = this.filter_date_start;

                return function(item) {

                    if (!date)
                        return true;

                    if (date && !item.call_date)
                        return false;

                    if (item.call_date)
                        return moment(date).isSame(moment(item.call_date)) || moment(date).isBefore(moment(item.call_date));

                    return true;

                };
            },
            setIndex: function() {

                if (vm.activeCustomer && vm.activeCustomer.call_state && ~this.call_state.indexOf(vm.activeCustomer.call_state))
                    vm.customerStatus.selectedIndex = this.call_state.indexOf(vm.activeCustomer.call_state);
                else
                    vm.customerStatus.selectedIndex = undefined;

                this.needDatePicker();

            },
        };
        vm.selected = [];
        vm.options = {
            autoSelect: false,
            boundaryLinks: true,
            pageSelector: true,
            rowSelection: false
        };
        vm.filter = {
            options: {
                'debounce': 0,
                'updateOn': 'default'
            }
        };
        vm.query = {
            filter: '',
            off: 0,
            order: '',
            limit: 10,
            page: 1
        };
        /* Controllo se c'è un Customer Id nell'URL */
        vm.phone = null;
        if (phone && angular.isDefined(phone)) {
            vm.query.filter = phone.toString();
            vm.phone = phone.toString();
        };
        vm.removeSearch = function() {
            vm.query.filter = '';
            vm.query.filter_merge_ok = '';
            vm.query.filter_merge_ko = '';
            vm.query.order = '';
            vm.query.off = 0;
            vm.customerStatus.filter_date_start = null;
            vm.query.page = 1;
            vm.customersListLoad(1);
        };
        vm.customersList = [];
        vm.eListLoading = false;
        vm.firstLoad = false;
        vm.mergeCheckOk = false;
        vm.customersListPag = {"total":0,"count":10,"per_page":10,"current_page":1,"total_pages":0,"links":{} };
        vm.customersListLoad = function(p,s) {
            vm.mergeCheckOk = false;
            vm.customersList = [];
            if (
                    (vm.query.filter==null || vm.query.filter.trim()=='')
                && (!vm.query.filter_merge_ok || !vm.query.filter_merge_ko)) {
                return;
            }
            vm.eListLoading = true;
            vm.customersList = [];
            if (p==null) {
                p = 1;
            }
            if (s==null) {
                s = parseInt(vm.customersListPag.per_page);
            }
            var pars = {page: p, s:s, 'with':'sourceCustomer;customer_subscriptions_active;card;user;operator;documents'};
            if (vm.query.filter_merge_ok && vm.query.filter_merge_ko) {
                pars.filtro_merge_ok=vm.query.filter_merge_ok;
                pars.filtro_merge_ko=vm.query.filter_merge_ko;
                vm.query.filter = null;
            }
            if (vm.query.filter!=null && vm.query.filter!='') {
                pars.filtro=vm.query.filter.trim();
            }
            if (vm.customerStatus.filter_date_start!=null && vm.customerStatus.filter_date_start!='') {
                pars.data_richiamo= moment(vm.customerStatus.filter_date_start).format('YYYY-MM-DD');
            }
            if (vm.customerStatus.selectedIndexFilter!=null && vm.customerStatus.selectedIndexFilter!='') {
                pars.search='call_state:'+vm.customerStatus.selectedIndexFilter;
                pars.searchFields='call_state:=';
            }
            if (vm.query.off) {//se non vedo tutti
                pars.search='off:'+vm.query.off;
                pars.searchFields='off:=';
            }
          if (vm.query.order!=null && vm.query.order!='') {
                pars.orderBy = vm.query.order.indexOf('-')==0?vm.query.order.substring(1):vm.query.order;
                pars.sortedBy = vm.query.order.indexOf('-')==0?'desc':null;
            }
            CustomerService.all(pars).then(function(response) {
                if (response.data && response.data.data) {
                    vm.customersList = [];
                    var customersList = [];
                    //response.data.meta.pagination.per_page = vm.customersListPag.per_page;
                    vm.customersListPag = response.data.meta.pagination;
                    angular.forEach(response.data.data, function(elem) {
                        delete elem.updated_at;
                        delete elem.created_at;
                        elem.firstname = elem.firstname || '';
                        elem.lastname = elem.lastname || '';

                        var birthdate = elem.birthdate ? moment(elem.birthdate) : null;
                        elem.birthdate = birthdate ? new Date(birthdate) : null;

                        var call_date = elem.call_date ? moment(elem.call_date) : null;
                        elem.call_date = call_date ? new Date(call_date) : null;
                        if (vm.env.isMaster && elem.tenant && elem.tenant!=vm.env.currentTenant && vm.env.admins) {
                            elem.urlCustomer = vm.env.admins[elem.tenant] + "/customer?phone="+elem.phone;
                        }
                        vm.initDocuments(elem);
                        customersList.push(elem);
                    });
                    vm.customersList = customersList;
                    if (vm.customersList.length==1) {
                        //vm.rowClicked(vm.customersList[0]);
                    } else if (vm.customersList.length==0 && vm.query.filter.trim().match("^[0-9]{9}[0-9]?$")) {
                      vm.toggleRight();
                    } else if (vm.customersList.length==2) {
                        var c0 = vm.customersList[0];
                        var c1 = vm.customersList[1];
                        if (c0.phone == vm.query.filter_merge_ok
                                || c0.phone == vm.query.filter_merge_ko ) {
                            if (c1.phone == vm.query.filter_merge_ok
                                || c1.phone == vm.query.filter_merge_ko ) {
                                vm.mergeCheckOk = true;
                            }
                        }
                    }
                }
                vm.eListLoading = false;
                vm.firstLoad = true;
            },
            function (response) {
                var errMsg = "";
                if (response.data!=null && response.data.message!=null) {
                    errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    if (url!=null) {
                        errMsg+= "\nUrl: " + url;
                    }
                }
                alert ("Si è verificato un errore nel caricamento clienti: " + errMsg);
                vm.eListLoading = false;
            });
        };
        vm.customersListLoad(vm.query.page,10);
        vm.onKeyPressSearch = function (event) {
            if (!event || event.keyCode==13) {
                vm.customersListLoad(1);
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        }

        /**
         * Visualizzo activities su app
         */
        vm.showActivities = function( ent ) {
               if (vm.user.type != 'admin') {
                    return vm.rowClicked(ent);
               }
               var dialog = $mdDialog.confirm({
                  title: 'Storico Modifiche: ' + (ent.firstname!=null?ent.firstname.toUpperCase():'')
                  + ' ' + (ent.lastname!=null?ent.lastname.toUpperCase():'') + " (cid="+ent.id+")",
                  ariaLabel: 'Storia Modifiche Cliente',
                  templateUrl: 'app/components/dialogs/activity-log.html',
                  escapeToClose: true,
                  controller: [ '$scope', '$mdDialog', '$filter', function( $scope, $mdDialog, $filter ) {
                      $scope.title = this.title;
                      $scope.button_ok = 'Chiudi';
                      $scope.activities = [];
                      $scope.loadActivities = function () {
                      var pars = {
                              'log_name': 'default',
                           'subject_type':'App\\Entities\\Customer',
                           'subject_id': ent.id,
                           with: 'causer;subject'
                      };
                      $scope.loading = true;
                      CrudService.all('activity_log', pars, vm,
                            function (response) {
                              angular.forEach(response.data.data, function(act) {
                                  act.created_at_frmt = moment(act.created_at).format('D/M/YYYY HH:mm:ss');
                                  $scope.activities.push(act);
                              });
                              $scope.loading = false;
                            },
                            function (response) {
                              var errMsg = "";
                              if (response.data!=null
                                      && response.data.message!=null) {
                                errMsg = response.data!=null && response.data.message!=null?response.data.message+".":".";
                                var url = response.config!=null && response.config.url!=null?response.config.url:"";
                                if (url!=null) {
                                  errMsg+= "\nUrl: " + url;
                                }
                              }
                              alert ("Si è verificato un errore nel caricamento delle attività: " + errMsg);
                              $scope.loading = false;
                           });
                      }
                      $scope.close = function() {
                          $mdDialog.hide( true );
                      };
                      $scope.loadActivities();
                  }]
            });

            return $mdDialog
                .show( dialog )
                .finally(
                    function() {
                        dialog = undefined;
                    }
                )
            ;
        };

        /**
         * Documenti cliente
         */
        /**
         * verifico se è presente documento firmato associato al trattamento (se il trattamento lo richiede)
         */
        vm.initDocuments = function(customer) {
            //$log.info("docs",customer.documents);
            /**
             * verifico se presente privacy + autorizzazione foto + consenso al trattamento corrente
             */
            customer.docPrivacyOk = false;
            customer.docCovidOk = false;
            customer.docPicturesOk = false;
            if (customer.documents && customer.documents.data) {
                angular.forEach(customer.documents.data, function(doc) {
                    if (doc.document_type_id == 301 && !customer.docPrivacyOk) {
                        customer.docPrivacyOk = true;
                        doc.title = 'Privacy';
                        customer.docPrivacy = {'data':doc};
                    } else if (doc.document_type_id == 302 && !customer.docPicturesOk) {
                        customer.docPicturesOk = true;
                        doc.title = 'Consenso fotografie';
                        customer.docPictures = {'data':doc};
                    } else if (doc.document_type_id == 305 && !customer.docCovidOk) {
                        customer.docCovidOk = true;
                        doc.title = 'Autocertificazione COVID-19';
                        customer.docCovid = {'data':doc};
                    } else {
                        if (doc.description) {
                            var sA = doc.description.split('|');
                            doc.title = sA[0];
                        }
                    }
                });
            }
            $log.info("docPrivacy "+customer.id,customer.docPrivacyOk);
            $log.info("docPictures "+customer.id,customer.docPicturesOk);
        };
        vm.showDocuments = function( customer ) {
            var dialog = $mdDialog.confirm({
                  title: 'Elenco documenti: di ' + (customer.firstname!=null?customer.firstname.toUpperCase():'')
                  + ' ' + (customer.lastname!=null?customer.lastname.toUpperCase():'') + " (cid="+customer.id+")",
                  ariaLabel: 'Elenco documenti cliente',
                  templateUrl: 'app/addressbook/dialogs/customer-documents.html',
                  escapeToClose: true,
                  controller: [ '$scope', '$mdDialog', '$filter', '$http', '$log',  function( $scope, $mdDialog, $filter, $http, $log ) {
                      $scope.title = this.title;
                      $scope.button_ok = 'Chiudi';
                      $scope.customer = customer;
                      $scope.env = vm.env;
                      $scope.token = vm.token;
                      $scope.env = vm.env;
                      $scope.refresh = function() {
                          /**
                          * ricarico documenti cliente
                          */
                          $scope.loading = true;
                          $http.get($scope.env.API+"/documents?customer_id="+$scope.customer.id).then(
                              function (response) {
                                  $scope.customer.documents = {'data': response.data.data };
                                  vm.initDocuments($scope.customer);
                                  $scope.loading = false;
                              },
                              function (response) {
                                  $log.info(response);
                                  $scope.loading = false;
                              }
                          );
                      };
                      $scope.close = function() {
                          $mdDialog.hide( true );
                      };
                  }]
            });

            return $mdDialog
                .show( dialog )
                .finally(
                    function() {
                        dialog = undefined;
                    }
                )
            ;
        };
        vm.showNote = function (c) {
            if (c.note==null || c.note.trim()=='' ) return;
            var testo = "";
            if (c.note!=null && c.note.trim()!='') {
                testo += "<p>"+c.note.trim()+"</p>";
            }
            var p = $mdDialog.confirm()
                    .title("Note su " + (c.firstname!=null?c.firstname.toUpperCase():'')
                 + ' ' + (c.lastname!=null?c.lastname.toUpperCase():'')
              ).htmlContent(testo)
                .ok( 'Ok' );
            return $mdDialog.show( p );
        };
        vm.merging = false;
        vm.merge = function() {
            vm.merging = true;
            vm.eListLoading = true;
            $http.post(env.API + "/customers_merge/"
                    +vm.query.filter_merge_ok
                    +"/"+vm.query.filter_merge_ko,{}).then(
                            function(response) {
                                //$log.info(response);
                                vm.merging = false;
                                vm.customersListLoad(1);
                            },
                            function(response) {
                                $log.info(response);
                                vm.merging = false;
                                vm.eListLoading = false;
                                alert("Errore!");
                            }
            );
        };
        vm.customersListReOrder = function (column) {
            vm.query.order = column;
            vm.customersListLoad(1);
        };
        vm.richiestaCard = function (customer) {
          customer.isCardRequest = true;
          vm.toggleRight(customer);
          //customer.card = {data: {id: 1, delivered: false}};
        };
        //---------- Sidebar -------------------------------------//
        vm.rowClicked = function(customer) {
            delete customer.isCardRequest;
            vm.toggleRight(customer);
        };
        vm.testsVisible = false;
        vm.isDeleteAllowed = true;
        vm.undoVisible = false;
        vm.img_loading = false;
        vm.loading = false;
        vm.isNewCustomer = false;
        vm.activeCustomer = {};
        vm.backup_customer = {};
        vm.update_customer = {};
        vm.empty_customer = {};
        vm.toggleRight = function(customer) {
            vm.appointmentsForCustomer = [];
            vm.isNewCustomer = angular.isUndefined(customer);
            if (angular.isDefined(customer)) {
              vm.guaranteeDisabled = customer.f_guarantee && vm.user.type!='admin';
              if (customer.src_cid!=null) {
                vm.activeRelCustomer = customer.sourceCustomer.data;
                vm.relCustomersList = [customer.sourceCustomer.data].map(
                    function( customer ) {
                        customer.fullName =  (
                            ( customer.firstname || '' )
                            + ' '
                            + ( customer.lastname || '' )
                        ).toUpperCase();
                        return customer;
                    }
                );
              }
                if (customer.zip_code!=null) {
                    if (customer.zip_code!='') {
                        customer.zip_code = parseInt(''+customer.zip_code);
                    } else {
                        customer.zip_code = null;
                    }
                }
                vm.customerStatus.setIndex();
                vm.loading = true;
                angular.copy(customer, vm.backup_customer);
                vm.activeCustomer = customer;
                CustomerService.get(customer.id, {'with': 'card;appointments;recharges;invited'}).then(function(response) {
                    if (response.data && response.data.data) {
                      if (response.data.data.card!=null) {
                        response.data.data.card.data.created_at_frmt = response.data.data.card.data.created_at!=null?
                            moment(response.data.data.card.data.created_at.data).format('DD/MM/YYYY'):null;
                        response.data.data.card.data.delivered_at_frmt = response.data.data.card.data.delivered_at!=null?
                                moment(response.data.data.card.data.delivered_at.data).format('DD/MM/YYYY'):null;
                        vm.backup_customer.card = response.data.data.card;
                        vm.activeCustomer.card = response.data.data.card;

                      }
                      /**
                       * Setto data creazione e invitato per ogni ricarica
                       */
                      angular.forEach(response.data.data.recharges.data, function(elem) {
                        elem.created_at_frmt = moment(elem.created_at.date).format("DD/MM/YYYY");
                        angular.forEach(response.data.data.invited.data, function(inv) {
                          if (elem.from_customer_id == inv.id) {
                            elem.customer = {data: inv};
                          }
                        });
                      });
                      /**
                       * Setto total amount per ogni invitato
                       */
                      angular.forEach(response.data.data.invited.data, function(elem) {
                        elem.created_at_frmt = moment(elem.created_at.date).format("DD/MM/YYYY");
                        elem.rechargeAmount = 0;
                        angular.forEach(response.data.data.recharges.data, function(rec) {
                            if (rec.from_customer_id == elem.id) {
                              elem.rechargeAmount += rec.amount;
                            }
                        });
                      });
                      vm.backup_customer.credit = response.data.data.credit;
                      vm.activeCustomer.credit = response.data.data.credit;
                        angular.forEach(response.data.data.appointments.data, function(element) {
                            var color = '';
                            /*angular.forEach(vm.operatorsList, function(operator) {
                                if (operator.id == element.user_id)
                                    color = operator.color
                            });*/
                            var appointment = {
                                "date_start": new Date(element.date_start),
                                "treatment_id": element.treatment_id,
                                "store_id": element.store_id,
                                "user_color": color,
                                "price": element.price,
                                "recalled": element.recalled,
                                "customer_subscription_id": element.customer_subscription_id,
                                "paid": element.paid,
                                "credit": element.credit
                            }
                            vm.appointmentsForCustomer.push(appointment);
                        });
                        vm.backup_customer.invited = response.data.data.invited;
                        vm.activeCustomer.invited = response.data.data.invited;
                        vm.backup_customer.recharges = response.data.data.recharges;
                        vm.activeCustomer.recharges = response.data.data.recharges;
                        vm.loading = false;
                    }
                }, function() {
                    vm.loading = false;
                });
            } else {
              var phone = null;
              if (vm.customersList==0) {
                var s = vm.query.filter.trim();
                var m = s.match("^[0-9]{9}[0-9]?$");
                if (m && m.length>=1 && m[0]==s) {
                  phone = s;
                }
              }
                vm.empty_customer = {
                    id: null,
                    firstname: '',
                    lastname: '',
                    phone: phone,
                    gender: 'F',
                    email: '',
                    referral_code: '',
                    note: '',
                    campaign: '',
                    birthdate: null,
                    city: null,
                    call_state: null,
                    call_date: null,
                };
                angular.copy(vm.empty_customer, vm.backup_customer);
                vm.activeCustomer = vm.empty_customer;
            };
            $timeout($mdSidenav('right').open, 0);
        };
        vm.phoneChecking = false;
        vm.checkPhoneExists = function() {
          vm.phoneChecking = true;
          vm.customerExists = {};
          if (vm.activeCustomer
                  && vm.activeCustomer.phone
                  && vm.activeCustomer.phone.trim()!='')
          {
              CustomerService.all(
                  {'filtro': vm.activeCustomer.phone,
                  'search': 'phone:'+vm.activeCustomer.phone,
                  'searchFields':'phone:='
                }).then(
                    function(response) {
                        vm.phoneChecking = false;
                        if(response.data.data.length >= 1 && (vm.activeCustomer.id==null || vm.activeCustomer.id!=response.data.data[0].id)) {
                          $scope.customerForm.phone.$setValidity('alreadyexists', false);
                          vm.customerExists = response.data.data[0];
                        } else {
                          $scope.customerForm.phone.$setValidity('alreadyexists', true);
                        }
                    },
                    function(response) {
                        vm.phoneChecking = false;
                    }
                );
          }
        };

        vm.resetAll = function() {
            vm.undoVisible = false;
            vm.backup_customer = {};
            vm.update_customer = {};
            vm.activeCustomer = {};
            $timeout(vm.resetForm,0);
        };
        vm.closeSidebar = function() {
            if (vm.undoVisible) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .textContent('Ci sono delle modifiche non commissionate, proseguire?')
                    .ariaLabel('Attenzione')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(vm.undo)
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            } else {
                return vm.resetAll();
            };
        };
        vm.resetForm = function() {
            return $mdSidenav('right').close().then(
                function() {
                  $scope.customerForm.$setPristine();
                  $scope.customerForm.$setUntouched();
                  vm.relCustomersReset();
                });
        };
        vm.undo = function() {
            $log.info('Undo');

            if (!angular.equals(vm.activeCustomer, vm.backup_customer)) {
                angular.copy(vm.backup_customer, vm.activeCustomer);
            };

            vm.customerStatus.selectedIndex = undefined;
            vm.customerStatus.showDatePicker = false;

            return vm.resetAll();
        };
        vm.fakeDelForced = function(customer) {
            $log.info('Del Forced');
            if (angular.isDefined(customer)) {
                var index = vm.customersList.indexOf(customer);
                vm.customersList.splice(index, 1);
            };
        };
        /*vm.del = function(customer) {
            $log.info('Del');
            if (angular.isDefined(customer)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .htmlContent('<p class="md-title">Sicuro di voler Cancellare questo utente?<br/><strong>Verranno eleminati anche tutti i suoi appuntamenti.</strong></p>')
                    .ariaLabel('Attenzione')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {
                            CustomerService.del(customer.id).then(function(response) {
                                if (response.status === 204) {
                                    vm.fakeDelForced(customer);
                                    vm.resetAll();
                                } else {
                                    alert("Errore durante l'elaborazione delle richiesta.");
                                };
                            });
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };
        */
        vm.showActionToast = function( text) {
            text = text && angular.isDefined( text ) ? text : 'Tutto Ok!';
            var toast = $mdToast.simple()
                .textContent(text)
                .action('')
                .highlightAction(true)
                .position('bottom right');
            return $mdToast
                .show(toast)
                .finally(
                    function() {
                        toast = undefined;
                    }
                );
        };
        vm.responseStatusSuccessful = [200, 201, 202];
        vm.checkResponse = function(response) {
            vm.saving = false;
            if (vm.responseStatusSuccessful.indexOf(response.status) === -1) {
                var errMsg = "";
                if (response.data!=null && response.data.message!=null) {
                    errMsg = response.data!=null && response.data.message!=null?response.data.message:"";
                    var url = response.config!=null && response.config.url!=null?response.config.url:"";
                    vm.showActionToast("KO: " + errMsg + " " + url);
                }
                var alert = $mdDialog.alert()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent("C'è stato un problema: "+errMsg)
                    .ok('Ok');
                return $mdDialog
                    .show(alert)
                    .finally(
                        function() {
                            alert = undefined;
                        }
                    );
            } else {
                vm.showActionToast();
                return vm.resetAll();
            };
        };
        vm.saving = false;
        vm.save = function(customer, book) {
            $log.info('Salva');
            if (angular.isDefined(customer)) {
                var confirm = $mdDialog.confirm()
                    .title('Attenzione')
                    .ariaLabel('Attenzione')
                    .textContent('Sicuro di voler inserire questo utente?')
                    .ok('Si')
                    .cancel('Ops, ho sbagliato');
                return $mdDialog
                    .show(confirm)
                    .then(
                        function() {
                            vm.saving = true;
                            angular.copy(customer, vm.update_customer);
                            if (customer.birthdate) {
                                vm.update_customer.birthdate = $filter('date')(new Date(vm.update_customer.birthdate), 'yyyy-MM-dd');
                            };
                            if (customer.call_date) {
                                vm.update_customer.call_date = $filter('date')(new Date(vm.update_customer.call_date), 'yyyy-MM-dd HH:mm');
                            };
                            delete(vm.update_customer.id);
                            CustomerService.save(vm.update_customer).then(
                                    function(response) {
                                        vm.checkResponse(response);
                                        if (vm.responseStatusSuccessful.indexOf(response.status) !== -1) {
                                            if (response.data && response.data.data) {
                                                vm.customersList.push(response.data.data);
                                                //$log.info("todo dovrei aprire booking");
                                                vm.query.filter = response.data.data.phone;
                                                vm.customersListLoad(1);
                                                var w = $window.open(vm.env.booking +"/operator?tenant="+vm.env.currentTenant+
                                                    "&c_sid="+vm.user.store_id+
                                                    "&c_role="+vm.user.type+
                                                    "&customer="+response.data.data.phone+
                                                    "&store="+vm.storeId+
                                                    "&callcenter="+vm.isCallCenter+
                                                    "&token="+vm.token,
                                                    "_self" /*vm.env.company+"_Booking_"+vm.env.tenant*/
                                                );
                                                //w.focus();
                                                //ng-href="{{ ap.env.booking }}/operator?c_sid={{ ap.user.store_id }}&amp;c_role={{ ap.user.type }}&amp;store={{ ap.storeId }}&amp;callcenter={{ ap.isCallCenter }}&amp;token={{ ap.token }}"

                                            };
                                        };
                                        vm.saving = false;
                                    },
                                    function(response) {
                                        vm.checkResponse(response);
                                        vm.saving = false;
                                    });
                        }
                    )
                    .finally(
                        function() {
                            confirm = undefined;
                        }
                    );
            };
        };
        vm.update = function(customer) {
            $log.info('Update');
            if (angular.isDefined(customer)) {
                if (!angular.equals(customer, vm.backup_customer)) {
                    var confirm = $mdDialog.confirm()
                        .title('Attenzione')
                        .ariaLabel('Attenzione')
                        .textContent('Sicuro di voler aggiornare?')
                        .ok('Si')
                        .cancel('Ops, ho sbagliato');
                    return $mdDialog
                        .show(confirm)
                        .then(
                            function() {
                                vm.saving = true;
                                angular.copy(customer, vm.update_customer);
                                vm.update_customer.with = 'card';
                                if (customer.birthdate) {
                                    vm.update_customer.birthdate = $filter('date')(new Date(vm.update_customer.birthdate), 'yyyy-MM-dd');
                                };
                                if (customer.call_date) {
                                    vm.update_customer.call_date = $filter('date')(new Date(vm.update_customer.call_date), 'yyyy-MM-dd HH:mm');
                                };
                                CustomerService.update(vm.update_customer).then(
                                    function (response) {
                                      vm.checkResponse(response);
                                      if (response.data!=null && response.data.data!=null) {
                                        customer.card = response.data.data.card;
                                        if (response.data.data.f_guarantee) {
                                            vm.guaranteeDisabled = vm.user.type!='admin';
                                        }
                                      }
                                    },
                                    vm.checkResponse);
                            }
                        )
                        .finally(
                            function() {
                                confirm = undefined;
                            }
                        );
                };
            };
        };
        $scope.$watch('ab.activeCustomer', function(newValue) {
            vm.undoVisible = (angular.equals(newValue, vm.backup_customer) || vm.isNewCustomer) ? false : true;
        }, true);
        vm.Italia = Italia;
        /**
         * Gestione invitato da
         */
        vm.filter_relcustomer = '';
        vm.relCustomersList = [];
        vm.activeRelCustomer = null;
        vm.activeRelCustomerChange = function () {
          vm.activeCustomer.src_cid = vm.activeRelCustomer.id;
          vm.activeCustomer.sourceCustomer = {data: vm.activeRelCustomer};
        }
        vm.onKeyUpRelCustomersSearch = function (evento, obj) {
          if (evento.keyCode==13)  {
            vm.relCustomersLoad();
            evento.stopPropagation();
            evento.preventDefault();
          }
        };
        vm.relCustomersReset = function () {
          vm.relCustomersList = [];
          vm.filter_relcustomer = '';
          vm.activeRelCustomer = null;
        };
        vm.relCustomersLoad = function ( ) {
          vm.relCustomersList = [];
          vm.relCustomersLoading = true;
          var pars = {page:1, s:10, orderBy: 'firstname'};
          var search = [];
          var searchFields = [];
          if (vm.filter_relcustomer!=null && vm.filter_relcustomer!='') {
            pars.filtro = vm.filter_relcustomer;
          }
          if (search.length>0) {
            pars.search = search.join(";");
            pars.searchFields = searchFields.join(";");
          }
          return CustomerService
              .all(pars).then(
                  function( response ) {
                      if( response.data && response.data.data ) {
                          vm.relCustomersList = response.data.data.map(
                              function( customer ) {
                                  customer.fullName =  (
                                      ( customer.firstname || '' )
                                      + ' '
                                      + ( customer.lastname || '' )
                                  ).toUpperCase();
                                  return customer;
                              }
                          );
                          if (vm.relCustomersList.length==0) {
                            vm.showActionToast("Nessun elemento trovato.");
                          }
                          vm.relCustomersLoading = false;
                      };
                  },
                  function (response) {
                    vm.checkResponse(response);
                    vm.relCustomersLoading = false;
                  }
              )
          ;
      };



        /* WATCHO Lo Store */
        vm.storesList = [];
        vm.storeId = null;
        $scope.$watch('$parent.selectedStore', function(id) {
            if (angular.isDefined(id)) {
                if (vm.storeId==null) {//è il primo caricamento
                    vm.storesList = $scope.$parent.main.storesList;
                    //vm.operatorLoad();
                }
                vm.storeId = id;
            };
        });

        /* Operators */
        /*vm.operatorsList = [];
        vm.operatorLoad = function() {
            vm.operatorsList = [];
            UsersService.all({
                search: 'active:1;type:operator',
                searchFields: 'active:=;type:='
            }).then(function(response) {
                if (response.data && response.data.data) {
                    vm.operatorsList = response.data.data;
                };
            });
        };*/
        } catch(err) {
            $log.info('error:',err);
        }
    };

    AddressBookController
        .$inject = [
            '$scope',
            '$log',
            '$window',
            '$timeout',
            '$mdSidenav',
            '$mdDialog',
            '$mdToast',
            '$filter',
            '$http',
            'CustomerService',
            'env',
            'phone',
            'CallState',
            'Italia',
            'TreatmentService',
            'SubscriptionService',
            'UsersService',
            'CrudService',
            'WkflowService'
        ];

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .run(runBlock);

    /** @ngInject */
    function runBlock(
        $log,
        $rootScope,
        $location,
        $state,
        env
    ) {
        $log.info('RunBlock');
        var locationChange = $rootScope.$on( "$locationChangeStart", function ( e,a,b,c ) {

            //$log.info(e);
            //$log.info("to->" +a);
            //$log.info("from->" +b);

            //$log.info($rootScope);
            //$log.info($rootScope.$$childHead);
            //$log.info($rootScope.$$childHead.main);
            if ($rootScope.$$childHead.main && $rootScope.$$childHead.main.loadFLeadOnline) {
                $rootScope.$$childHead.main.loadFLeadOnline();
            }
            //$log.info($location.path());
            //$log.info($rootScope.$childScope);
           $rootScope.isTodayRoute = false;
            var user = angular.fromJson( localStorage.getItem( 'user' ) );
            if( user && user !== null ) {
               $rootScope.isTodayRoute = ($location.path() === "/today");
                if( $location.path() === '/' ) {
                    e.preventDefault();
                    var redirect = $location.search().redirect;
                    if (redirect) {
                        var token = localStorage.getItem( 'Biolaser_token' );
                        window.location = "https://wiki."+env.domain+"?destination="+redirect+"&c_sid="+user.store_id+"&c_role="+user.type+"&store=0&token="+token;
                        return;
                    }
                    if(env.home && env.home.default) {
                        return $state.go( 'home.'+env.home.default);
                    } else {
                        return $state.go( 'home.addressbook' );
                    }
                };
                if( $location.path() === '/login' ) {
                    e.preventDefault();
                    return $state.go( 'home.addressbook' );
                };
            } else {
                // Login Forzato.
                //$log.info($location.path());
                if ($location.path()!='/login') {
                    localStorage.setItem( 'destination', $location.path().substring(1) );
                } else {
                    //localStorage.removeItem( 'destination' );
                }
                //$log.info($location.search());
                return $location.path( '/login' );
            };
            return;
        });
    };

})();

(function() {
    'use strict';

    angular
        .module( 'admin' )
        .config( routerConfig );

    /** @ngInject */
    function routerConfig($locationProvider, $stateProvider, $urlRouterProvider ) {
        //console.log('routerConfig');
        $locationProvider.html5Mode( true );
        $stateProvider
            .state('home', {
                url: '/?logout&store_id',
                views: {
                    'main': {
                        templateUrl: 'app/main/main.html',
                        controller: 'MainController',
                        controllerAs: 'main'
                    }
                },
                params: {
                    store_id: null
                },
                resolve: {
                    store_id: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.store_id;
                    }],
                    logout: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.logout;
                    }],
                },
            })
            .state('home.dashboard', {
                url: 'dashboard',
                views: {
                    'menuContent': {
                        templateUrl: 'app/dashboard/dashboard.html',
                        controller: 'DashboardController',
                        controllerAs: 'dashboard'
                    }
                }
            })
            .state('home.kpi', {
                url: 'kpi',
                views: {
                    'menuContent': {
                        templateUrl: 'app/kpi/kpi.html',
                        controller: 'KpiController',
                        controllerAs: 'dashboard'
                    }
                }
            })
            .state('home.whatsapp', {
                url: 'whatsapp?phone',
                views: {
                    'menuContent': {
                        templateUrl: 'app/whatsapp/whatsapp.html',
                        controller: 'WhatsappController',
                        controllerAs: 'whatsapp'
                    }
                },
                params: {
                    phone: null
                },
                resolve: {
                    phone: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.phone;
                    }],
                },
            })
            .state('home.addressbook', {
                url: 'addressbook?phone',
                views: {
                    'menuContent': {
                        templateUrl: 'app/addressbook/addressbook.html',
                        controller: 'AddressBookController',
                        controllerAs: 'ab'
                    }
                },
                params: {
                    phone: null
                },
                resolve: {
                    phone: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.phone;
                    }],
                },
            })
            .state('home.addressbookp', {
                url: 'addressbookp?phone',
                views: {
                    'menuContent': {
                        templateUrl: 'app/addressbookp/addressbookp.html',
                        controller: 'AddressBookPController',
                        controllerAs: 'abp'
                    }
                },
                params: {
                    phone: null
                },
                resolve: {
                    phone: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.phone;
                    }],
                },
            })
            .state('home.referrals', {
                url: 'referrals',
                views: {
                    'menuContent': {
                        templateUrl: 'app/referrals/referrals.html',
                        controller: 'ReferralsController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.blank', {
                url: 'blank?redirectTo',
                views: {
                    'menuContent': {
                        templateUrl: 'app/blank/blank.html',
                        controller: 'BlankController',
                        controllerAs: 'ab'
                    }
                },
                params: {
                    redirectTo: null
                },
                resolve: {
                    redirectTo: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.redirectTo;
                    }],
                },
            })
            .state('home.giftcards', {
                url: 'giftcards',
                views: {
                    'menuContent': {
                        templateUrl: 'app/giftcards/giftcards.html',
                        controller: 'GiftCardsController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.reviews', {
                url: 'reviews',
                views: {
                    'menuContent': {
                        templateUrl: 'app/reviews/reviews.html',
                        controller: 'ReviewsController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.leads', {
                url: 'leads?phone',
                views: {
                    'menuContent': {
                        templateUrl: 'app/leads/leads.html',
                        controller: 'LeadsController',
                        controllerAs: 'ab'
                    }
                },
                params: {
                  call_state: null,
                  f_oper: null,
                  phone: null
                },
                resolve: {
                  call_state: [ '$stateParams', function( $stateParams ) {
                      return $stateParams.call_state;
                  }],
                  f_oper: [ '$stateParams', function( $stateParams ) {
                      return $stateParams.f_oper;
                  }],
                  phone: [ '$stateParams', function( $stateParams ) {
                      return $stateParams.phone;
                  }],
                },
            })
            .state('home.wklist', {
                url: 'wklist',
                views: {
                    'menuContent': {
                        templateUrl: 'app/wklist/wklist.html',
                        controller: 'WklistController',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('home.lead', {
                url: 'lead?lead_id&phone',
                views: {
                    'menuContent': {
                        templateUrl: 'app/lead/lead.html',
                        controller: 'LeadController',
                        controllerAs: 'ab'
                    }
                },
                params: {
                  lead_id: null,
                  phone: null
                },
                resolve: {
                    lead_id: [ '$stateParams', function( $stateParams ) {
                      return $stateParams.lead_id;
                  }],
                  phone: [ '$stateParams', function( $stateParams ) {
                    return $stateParams.phone;
                }],
                }
            })
            .state('home.leadcash', {
                url: 'leadcash',
                views: {
                    'menuContent': {
                        templateUrl: 'app/leadcash/leadcash.html',
                        controller: 'LeadCashController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.leadcash1', {
                url: 'leadcash1',
                views: {
                    'menuContent': {
                        templateUrl: 'app/leadcash1/leadcash1.html',
                        controller: 'LeadCash1Controller',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.leadcash2', {
                url: 'leadcash2',
                views: {
                    'menuContent': {
                        templateUrl: 'app/leadcash2/leadcash2.html',
                        controller: 'LeadCash2Controller',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.customer', {
                url: 'customer?customer_id&phone',
                views: {
                    'menuContent': {
                        templateUrl: 'app/customer/customer.html',
                        controller: 'CustomerController',
                        controllerAs: 'ab'
                    }
                },
                params: {
                    customer_id: null,
                    phone: null,
                },
                resolve: {
                    customer_id: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.customer_id;
                    }],
                    phone: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.phone;
                    }]
                },
            })
            .state('home.customer-detail', {
                url: 'customer-detail?customer_id&phone',
                views: {
                    'menuContent': {
                        templateUrl: 'app/customer-detail/customer-detail.html',
                        controller: 'CustomerDetailController',
                        controllerAs: 'ab'
                    }
                },
                params: {
                    customer_id: null,
                    current_tab: null,
                    phone: null,
                },
                resolve: {
                    customer_id: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.customer_id;
                    }],
                    current_tab: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.current_tab;
                    }],
                    phone: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.phone;
                    }]
                },
            })
            .state('home.customer-pictures', {
                url: 'customer-pictures?customer_id',
                views: {
                    'menuContent': {
                        templateUrl: 'app/customer-pictures/customer-pictures.html',
                        controller: 'CustomerPictureController',
                        controllerAs: 'ab'
                    }
                },
                params: {
                    customer_id: null
                },
                resolve: {
                    customer_id: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.customer_id;
                    }]
                },
            })
            .state('home.customer-calls', {
                url: 'customer-calls?customer_id&phone',
                views: {
                    'menuContent': {
                        templateUrl: 'app/customer-calls/customer-calls.html',
                        controller: 'CustomerCallsController',
                        controllerAs: 'ab'
                    }
                },
                params: {
                    customer_id: null,
                    phone: null,
                },
                resolve: {
                    customer_id: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.customer_id;
                    }],
                    phone: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.phone;
                    }]
                },
            })
            .state('home.cusacts', {
                url: 'cusacts',
                views: {
                    'menuContent': {
                        templateUrl: 'app/cusacts/cusacts.html',
                        controller: 'CusactsController',
                        controllerAs: 'ab'
                    }
                },
            })
            .state('home.today', {
                url: 'today',
                views: {
                    'menuContent': {
                        templateUrl: 'app/today/today.html',
                        controller: 'TodayController',
                        controllerAs: 'today'
                    }
                }
            })
            .state('home.availability-analysis', {
                url: 'availability-analysis',
                views: {
                    'menuContent': {
                        templateUrl: 'app/availability-analysis/availability-analysis.html',
                        controller: 'AvailabilityAnalysisController',
                        controllerAs: 'today'
                    }
                }
            })
            .state('home.appointments', {
                url: 'appointments?customer_id&filter&store_id&filter_date&visite',
                views: {
                    'menuContent': {
                        templateUrl: 'app/appointments/appointments.html',
                        controller: 'AppointmentsController',
                        controllerAs: 'ap'
                    }
                },
                params: {
                    customer_id: null,
                    filter: null,
                    store_id: null,
                    filter_date: null,
                    visite: null
                },
                resolve: {
                    customer_id: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.customer_id;
                    }],
                    filter: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.filter;
                    }],
                    store_id: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.store_id;
                    }],
                    filter_date: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.filter_date;
                    }],
                    visite: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.visite;
                    }],
                },
            })
            .state('home.wire-transfer', {
                url: 'wire-transfer',
                views: {
                    'menuContent': {
                        templateUrl: 'app/wire-transfer/wire-transfer.html',
                        controller: 'WireTransferController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.wire-transfer-cofidis-history', {
                url: 'wire-transfer-cofidis-history',
                views: {
                    'menuContent': {
                        templateUrl: 'app/wire-transfer-cofidis-history/wire-transfer-cofidis-history.html',
                        controller: 'WireTransferCofidisHistoryController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.wire-transfer-consumer-credit-history', {
                url: 'wire-transfer-consumer-credit-history',
                views: {
                    'menuContent': {
                        templateUrl: 'app/wire-transfer-consumer-credit-history/wire-transfer-consumer-credit-history.html',
                        controller: 'WireTransferConsumerCreditHistoryController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.wire-transfer-history', {
                url: 'wire-transfer-history?type',
                views: {
                    'menuContent': {
                        templateUrl: 'app/wire-transfer-history/wire-transfer-history.html',
                        controller: 'WireTransferHistoryController',
                        controllerAs: 'ab'
                    }
                },
                params: {
                    type: null
                },
                resolve: {
                    type: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.type;
                    }]
                },
            })
            .state('home.cussubscr', {
                url: 'cussubscr',
                views: {
                    'menuContent': {
                        templateUrl: 'app/cussubscr/cussubscr.html',
                        controller: 'CusSubscrController',
                        controllerAs: 'ab'
                    }
                },
                params: {
                    customer_id: null
                },
                resolve: {
                    customer_id: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.customer_id;
                    }],
                },
            })
            .state('home.cashout', {
                url: 'cashout',
                views: {
                    'menuContent': {
                        templateUrl: 'app/cashout/cashout.html',
                        controller: 'CashoutController',
                        controllerAs: 'ap'
                    }
                }
            })
            .state('home.cuspaym', {
                url: 'cuspaym',
                views: {
                    'menuContent': {
                        templateUrl: 'app/cuspaym/cuspaym.html',
                        controller: 'CustomerPaymentsController',
                        controllerAs: 'ap'
                    }
                },
                params: {
                    customer_id: null
                },
                resolve: {
                    customer_id: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.customer_id;
                    }],
                },
            })
            .state('home.availabilities', {
                url: 'availabilities',
                views: {
                    'menuContent': {
                        templateUrl: 'app/availabilities/availabilities.html',
                        controller: 'AvailabilitiesController',
                        controllerAs: 'av'
                    }
                }
            })
            .state('home.cash', {
                url: 'cash',
                views: {
                    'menuContent': {
                        templateUrl: 'app/cash/cash.html',
                        controller: 'CashController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.monthcash', {
                url: 'monthcash',
                views: {
                    'menuContent': {
                        templateUrl: 'app/monthcash/monthcash.html',
                        controller: 'MonthCashController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.expcash', {
                url: 'expcash',
                views: {
                    'menuContent': {
                        templateUrl: 'app/expcash/expcash.html',
                        controller: 'ExpcashController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.balance', {
                url: 'balance',
                views: {
                    'menuContent': {
                        templateUrl: 'app/balance/balance.html',
                        controller: 'BalanceController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.costs', {
                url: 'costs',
                views: {
                    'menuContent': {
                        templateUrl: 'app/costs/costs.html',
                        controller: 'CostsController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.treatments', {
                url: 'treatments',
                views: {
                    'menuContent': {
                        templateUrl: 'app/treatments/treatments.html',
                        controller: 'TreatmentsController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.subscriptions', {
                url: 'subscriptions',
                views: {
                    'menuContent': {
                        templateUrl: 'app/subscriptions/subscriptions.html',
                        controller: 'SubscriptionsController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.products', {
                url: 'products',
                views: {
                    'menuContent': {
                        templateUrl: 'app/products/products.html',
                        controller: 'ProductsController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.storage', {
                url: 'storage',
                views: {
                    'menuContent': {
                        templateUrl: 'app/storage/storage.html',
                        controller: 'StorageController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.storage_state', {
                url: 'storage_state',
                views: {
                    'menuContent': {
                        templateUrl: 'app/storage_state/storage_state.html',
                        controller: 'StorageStateController',
                        controllerAs: 'ab'
                    }
                }
            })

            .state('home.inventories', {
                url: 'inventories',
                views: {
                    'menuContent': {
                        templateUrl: 'app/inventories/inventories.html',
                        controller: 'InventoriesController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.orders', {
                url: 'orders',
                views: {
                    'menuContent': {
                        templateUrl: 'app/orders/orders.html',
                        controller: 'OrdersController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.orderdetails', {
                url: 'orderdetails',
                views: {
                    'menuContent': {
                        templateUrl: 'app/orderdetails/orderdetails.html',
                        controller: 'OrderDetailsController',
                        controllerAs: 'ab'
                    }
                },
                params: {
                    order_id: null
                },
                resolve: {
                    order_id: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.order_id;
                    }],
                },
            })
            .state('home.landings', {
                url: 'landings',
                views: {
                    'menuContent': {
                        templateUrl: 'app/landings/landings.html',
                        controller: 'LandingsController',
                        controllerAs: 'landings'
                    }
                }
            })
            .state('home.operators', {
                url: 'operators',
                views: {
                    'menuContent': {
                        templateUrl: 'app/operators/operators.html',
                        controller: 'OperatorController',
                        controllerAs: 'op',
                    }
                }
            })
            .state('home.groups', {
                url: 'groups',
                views: {
                    'menuContent': {
                        templateUrl: 'app/groups/groups.html',
                        controller: 'GroupsController',
                        controllerAs: 'ab',
                    }
                }
            })
            .state('home.customer-quotations', {
                url: 'customer-quotations',
                views: {
                    'menuContent': {
                        templateUrl: 'app/customer-quotations/customer-quotations.html',
                        controller: 'CustomerQuotationsController',
                        controllerAs: 'ab'
                    }
                }
            })
            .state('home.customer-quotations-details', {
                url: 'customer-quotations-details',
                views: {
                    'menuContent': {
                        templateUrl: 'app/customer-quotations-details/customer-quotations-details.html',
                        controller: 'CustomerQuotationsDetailsController',
                        controllerAs: 'ab'
                    }
                },
                params: {
                    customer_quotation_id: null,
                    closed: null,
                },
                resolve: {
                    customer_quotation_id: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.customer_quotation_id;
                    }],
                    closed: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.closed;
                    }],
                },
            })
            .state('login', {
                url: '/login?redirect',
                views: {
                    'main': {
                        templateUrl: 'app/login/login.html',
                        controller: 'LoginController',
                        controllerAs: 'login'
                    }
                },
                params: {
                    redirect: null
                },
                resolve: {
                    redirect: [ '$stateParams', function( $stateParams ) {
                        return $stateParams.redirect;
                    }]
                }
            })
            .state('home.reports', {
                url: 'reports',
                views: {
                    'menuContent': {
                        templateUrl: 'app/reports/reports.html',
                        controller: 'ReportsController',
                        controllerAs: 'rep'
                    }
                }
            })
        ;
        $urlRouterProvider.otherwise('/login');
    };

})();

(function () { 
 return angular.module('admin')
.constant('env', {"tenant":"Bologna","company":"Folto","domain":"folto.it","logo":"assets/images/logo-folto.png","tenant_giftcode":"00","countryCode":39,"isMaster":true,"shoppingPlusEnabled":false,"captcha":"6Lc7ytgaAAAAAKHRJmrlsssAcP2f0rJTifv4idoN","pusher_key":"e946bebf4488532aad97","API":"https://api.folto.it/api","booking":"https://booking.folto.it","admin":"https://admin.folto.it","wiki":"https://wiki.folto.it","smallpayEnabled":false,"giftcardEnabled":true,"hideSlogan":true,"menu":{"whatsapp":true,"leads":true,"storage":true,"inventories":true,"storage_state":true,"landings":true},"theme":{"primary":{"default":"grey","palette":{"50":"#e7e7e7","100":"#c5c5c5","200":"#b2b2b2","300":"#afafaf","400":"#9d9d9d","500":"#808080","600":"#7a7a7a","700":"#676767","800":"#555555","900":"#4e4e4e"}},"secondary":{"default":"rose","palette":{"500":"#cbcbcb","contrastDefaultColor":"light"}}}});

})();

(function() {
    'use strict';

    angular
        .module('admin')
        .config(config)
        .constant('malarkey', malarkey)
        .constant('moment', moment)
        .constant('version', "4.0")
        .constant('RecallTypes', [
            {
                value: 0,
                text: "NO",
                text_esteso: "Non ricordato",
            },
            {
                value: 1,
                text: "SI",
                text_esteso: "Ricordato con risposta",
            },
            {
                value: 2,
                text: "NO RISP",
                text_esteso: "Ricordato senza risposta",
            },
            {
                value: 3,
                text: "DISD",
                text_esteso: "Disdetto",
            },
            {
                value: 4,
                text: "SPOS",
                text_esteso: "Spostato",
            }

        ])
        .constant(
            'MONTHS', {
                'months':[
                    {'v':1, 'l': 'Gennaio'},
                    {'v':2, 'l': 'Febbraio'},
                    {'v':3, 'l': 'Marzo'},
                    {'v':4, 'l': 'Aprile'},
                    {'v':5, 'l': 'Maggio'},
                    {'v':6, 'l': 'Giugno'},
                    {'v':7, 'l': 'Luglio'},
                    {'v':8, 'l': 'Agosto'},
                    {'v':9, 'l': 'Settembre'},
                    {'v':10, 'l': 'Ottobre'},
                    {'v':11, 'l': 'Novembre'},
                    {'v':12, 'l': 'Dicembre'}
                ],
                'getName': function (v) {
                    for(var i=0; i<this.months.length; i++) {
                        if (this.months[i].v==v) {
                            return this.months[i].l;
                        }
                    }
                    return v;
                }
            }
          )
         .constant(
            'ROLES', {
                'roles':[
                    {'name':'admin', 'home': 'addressbook', 'cross': true, 'managed': ['admin','callcenter','operator','manager','backoffice','storemngr']},
                    {'name':'callcenter', 'home': 'addressbook', 'cross': true, 'managed': ['callcenter']},
                    {'name':'assist', 'home': 'appointments', 'cross': false, 'managed': ['assist']},
                    {'name':'operator', 'home': 'appointments', 'cross': false, 'managed': ['operator','assist']},
                    {'name':'manager', 'home': 'addressbook', 'cross': true, 'managed': ['operator', 'manager','storemngr']},
                    {'name':'backoffice', 'home': 'addressbook', 'cross': true, 'managed': ['backoffice']},
                    {'name':'storemngr', 'home': 'appointments', 'cross': false, 'managed': ['operator', 'storemngr']}
                ],
                'get': function(role) {
                    for(var i=0; i<this.roles.length; i++) {
                        if (this.roles[i].name == role) {
                            return this.roles[i];
                        }
                    }
                    return {};
                }
            }
         )
        .constant(
            'CallState',
            [
                'da richiamare',
                'fuori zona',
                'inviato WhatsApp 1',
                'occupato',
                'NR',
                'ha già preso appuntamento',
                'fake',
                'no download',
                'non interessato',
                //'ko stato salute',
                'non idoneo',
                'ko prezzo',
                'Freddo',
                'Lista Nera',
                'inviato WhatsApp 2',
                'inviato WhatsApp 3',
                'NR 2',
                'NR 3',
                'NR 4',
                'NR 5',//tentativi esauriti
                'inviata Mail 1',
                'inviata Mail 2',
                'inviata Mail 3',
                'inviato SMS 1',
                'inviato SMS 2',
                'inviato SMS 3',
                'inviato Messenger 1',
                'inviato Messenger 2',
                'inviato Messenger 3',
            ]
        )
        .constant(
            'Italia',
            {
                "Abruzzo": [
                    {
                       "nome": "Chieti",
                       "sigla": "CH"
                    },
                    {
                       "nome": "L'Aquila",
                       "sigla": "AQ"
                    },
                    {
                       "nome": "Pescara",
                       "sigla": "PE"
                    },
                    {
                       "nome": "Teramo",
                       "sigla": "TE"
                    }
                ],
               "Basilicata": [
                    {
                       "nome": "Matera",
                       "sigla": "MT"
                    },
                    {
                       "nome": "Potenza",
                       "sigla": "PZ"
                    }
                ],
                "Calabria": [
                    {
                       "nome": "Catanzaro",
                       "sigla": "CZ"
                    },
                    {
                       "nome": "Cosenza",
                       "sigla": "CS"
                    },
                    {
                       "nome": "Crotone",
                       "sigla": "KR"
                    },
                    {
                       "nome": "Reggio Calabria",
                       "sigla": "RC"
                    },
                    {
                       "nome": "Vibo Valentia",
                       "sigla": "VV"
                    }
                ],
               "Campania": [
                    {
                       "nome": "Avellino",
                       "sigla": "AV"
                    },
                    {
                       "nome": "Benevento",
                       "sigla": "BN"
                    },
                    {
                       "nome": "Caserta",
                       "sigla": "CE"
                    },
                    {
                       "nome": "Napoli",
                       "sigla": "NA"
                    },
                    {
                       "nome": "Salerno",
                       "sigla": "SA"
                    }
                ],
                "Emilia-Romagna": [
                    {
                       "nome": "Bologna",
                       "sigla": "BO"
                    },
                    {
                       "nome": "Ferrara",
                       "sigla": "FE"
                    },
                    {
                       "nome": "Forl-0043esena",
                       "sigla": "FC"
                    },
                    {
                       "nome": "Modena",
                       "sigla": "MO"
                    },
                    {
                       "nome": "Parma",
                       "sigla": "PR"
                    },
                    {
                       "nome": "Piacenza",
                       "sigla": "PC"
                    },
                    {
                       "nome": "Ravenna",
                       "sigla": "RA"
                    },
                    {
                       "nome": "Reggio Emilia",
                       "sigla": "RE"
                    },
                    {
                       "nome": "Rimini",
                       "sigla": "RN"
                    }
                ],
               "Friuli-Venezia-Giulia": [
                    {
                       "nome": "Gorizia",
                       "sigla": "GO"
                    },
                    {
                       "nome": "Pordenone",
                       "sigla": "PN"
                    },
                    {
                       "nome": "Trieste",
                       "sigla": "TS"
                    },
                    {
                       "nome": "Udine",
                       "sigla": "UD"
                    }
                ],
                "Lazio": [
                    {
                       "nome": "Frosinone",
                       "sigla": "FR"
                    },
                    {
                       "nome": "Latina",
                       "sigla": "LT"
                    },
                    {
                       "nome": "Rieti",
                       "sigla": "RI"
                    },
                    {
                       "nome": "Roma",
                       "sigla": "RM"
                    },
                    {
                       "nome": "Viterbo",
                       "sigla": "VT"
                    }
                ],
                "Liguria": [
                    {
                       "nome": "Genova",
                       "sigla": "GE"
                    },
                    {
                       "nome": "Imperia",
                       "sigla": "IM"
                    },
                    {
                       "nome": "La Spezia",
                       "sigla": "SP"
                    },
                    {
                       "nome": "Savona",
                       "sigla": "SV"
                    }
                ],
               "Lombardia": [
                    {
                       "nome": "Bergamo",
                       "sigla": "BG"
                    },
                    {
                       "nome": "Brescia",
                       "sigla": "BS"
                    },
                    {
                       "nome": "Como",
                       "sigla": "CO"
                    },
                    {
                       "nome": "Cremona",
                       "sigla": "CR"
                    },
                    {
                       "nome": "Lecco",
                       "sigla": "LC"
                    },
                    {
                       "nome": "Lodi",
                       "sigla": "LO"
                    },
                    {
                       "nome": "Monza e Brianza",
                       "sigla": "MB"
                    },
                    {
                       "nome": "Mantova",
                       "sigla": "MN"
                    },
                    {
                       "nome": "Milano",
                       "sigla": "MI"
                    },
                    {
                       "nome": "Pavia",
                       "sigla": "PV"
                    },
                    {
                       "nome": "Sondrio",
                       "sigla": "SO"
                    },
                    {
                       "nome": "Varese",
                       "sigla": "VA"
                    }
                ],
               "Marche": [
                    {
                       "nome": "Ancona",
                       "sigla": "AN"
                    },
                    {
                       "nome": "Ascoli Piceno",
                       "sigla": "AP"
                    },
                    {
                       "nome": "Macerata",
                       "sigla": "MC"
                    },
                    {
                       "nome": "Pesaro e Urbino",
                       "sigla": "PU"
                    }
                ],
                "Molise": [
                    {
                       "nome": "Campobasso",
                       "sigla": "CB"
                    },
                    {
                       "nome": "Isernia",
                       "sigla": "IS"
                    }
                ],
               "Piemonte": [
                    {
                       "nome": "Alessandria",
                       "sigla": "AL"
                    },
                    {
                       "nome": "Asti",
                       "sigla": "AT"
                    },
                    {
                       "nome": "Biella",
                       "sigla": "BI"
                    },
                    {
                       "nome": "Cuneo",
                       "sigla": "CN"
                    },
                    {
                       "nome": "Novara",
                       "sigla": "NO"
                    },
                    {
                       "nome": "Torino",
                       "sigla": "TO"
                    },
                    {
                       "nome": "Verbano-Cusio-Ossola",
                       "sigla": "VB"
                    },
                    {
                       "nome": "Vercelli",
                       "sigla": "VC"
                    }
                ],
                "Puglia": [
                    {
                       "nome": "Bari",
                       "sigla": "BA"
                    },
                    {
                       "nome": "Brindisi",
                       "sigla": "BR"
                    },
                    {
                       "nome": "Foggia",
                       "sigla": "FG"
                    },
                    {
                       "nome": "Lecce",
                       "sigla": "LE"
                    },
                    {
                       "nome": "Taranto",
                       "sigla": "TA"
                    }
                ],
                "Sardegna": [
                    {
                       "nome": "Cagliari",
                       "sigla": "CA"
                    },
                    {
                       "nome": "Carbonia-Iglesias",
                       "sigla": "CI"
                    },
                    {
                       "nome": "Nuoro",
                       "sigla": "NU"
                    },
                    {
                       "nome": "Olbia-Tempio",
                       "sigla": "OT"
                    },
                    {
                       "nome": "Oristano",
                       "sigla": "OR"
                    },
                    {
                       "nome": "Medio Campidano",
                       "sigla": "VS"
                    },
                    {
                       "nome": "Sassari",
                       "sigla": "SS"
                    },
                    {
                       "nome": "Ogliastra",
                       "sigla": "OG"
                    }
                ],
                "Sicilia": [
                    {
                       "nome": "Agrigento",
                       "sigla": "AG"
                    },
                    {
                       "nome": "Caltanissetta",
                       "sigla": "CL"
                    },
                    {
                       "nome": "Catania",
                       "sigla": "CT"
                    },
                    {
                       "nome": "Enna",
                       "sigla": "EN"
                    },
                    {
                       "nome": "Messina",
                       "sigla": "ME"
                    },
                    {
                       "nome": "Palermo",
                       "sigla": "PA"
                    },
                    {
                       "nome": "Ragusa",
                       "sigla": "RG"
                    },
                    {
                       "nome": "Siracusa",
                       "sigla": "SR"
                    },
                    {
                       "nome": "Trapani",
                       "sigla": "TP"
                    }
                ],
                "Toscana": [
                    {
                       "nome": "Arezzo",
                       "sigla": "AR"
                    },
                    {
                       "nome": "Firenze",
                       "sigla": "FI"
                    },
                    {
                       "nome": "Grosseto",
                       "sigla": "GR"
                    },
                    {
                       "nome": "Livorno",
                       "sigla": "LI"
                    },
                    {
                       "nome": "Lucca",
                       "sigla": "LU"
                    },
                    {
                       "nome": "Massa-Carrara",
                       "sigla": "MS"
                    },
                    {
                       "nome": "Pisa",
                       "sigla": "PI"
                    },
                    {
                       "nome": "Pistoia",
                       "sigla": "PT"
                    },
                    {
                       "nome": "Prato",
                       "sigla": "PO"
                    },
                    {
                       "nome": "Siena",
                       "sigla": "SI"
                    }
                ],
                "Trentino-Alto-Adige": [
                    {
                       "nome": "Bolzano",
                       "sigla": "BZ"
                    },
                    {
                       "nome": "Trento",
                       "sigla": "TN"
                    }
                ],
                "Umbria": [
                    {
                       "nome": "Perugia",
                       "sigla": "PG"
                    },
                    {
                       "nome": "Terni",
                       "sigla": "TR"
                    }
                ],
               "Valle-Aosta": [
                    {
                       "nome": "Aosta",
                       "sigla": "AO"
                    }
                ],
                "Veneto": [
                    {
                       "nome": "Belluno",
                       "sigla": "BL"
                    },
                    {
                       "nome": "Padova",
                       "sigla": "PD"
                    },
                    {
                       "nome": "Rovigo",
                       "sigla": "RO"
                    },
                    {
                       "nome": "Treviso",
                       "sigla": "TV"
                    },
                    {
                       "nome": "Venezia",
                       "sigla": "VE"
                    },
                    {
                       "nome": "Verona",
                       "sigla": "VR"
                    },
                    {
                       "nome": "Vicenza",
                       "sigla": "VI"
                    }
                ],
            }
        )
                   .constant(
            'Countries', [
                {code: 'AF', name: 'Afghanistan'},
                {code: 'AX', name: 'Åland Islands'},
                {code: 'AL', name: 'Albania'},
                {code: 'DZ', name: 'Algeria'},
                {code: 'AS', name: 'American Samoa'},
                {code: 'AD', name: 'Andorra'},
                {code: 'AO', name: 'Angola'},
                {code: 'AI', name: 'Anguilla'},
                {code: 'AQ', name: 'Antarctica'},
                {code: 'AG', name: 'Antigua and Barbuda'},
                {code: 'AR', name: 'Argentina'},
                {code: 'AM', name: 'Armenia'},
                {code: 'AW', name: 'Aruba'},
                {code: 'AU', name: 'Australia'},
                {code: 'AT', name: 'Austria'},
                {code: 'AZ', name: 'Azerbaijan'},
                {code: 'BS', name: 'Bahamas'},
                {code: 'BH', name: 'Bahrain'},
                {code: 'BD', name: 'Bangladesh'},
                {code: 'BB', name: 'Barbados'},
                {code: 'BY', name: 'Belarus'},
                {code: 'BE', name: 'Belgium'},
                {code: 'BZ', name: 'Belize'},
                {code: 'BJ', name: 'Benin'},
                {code: 'BM', name: 'Bermuda'},
                {code: 'BT', name: 'Bhutan'},
                {code: 'BO', name: 'Bolivia (Plurinational State of)'},
                {code: 'BQ', name: 'Bonaire, Sint Eustatius and Saba'},
                {code: 'BA', name: 'Bosnia and Herzegovina'},
                {code: 'BW', name: 'Botswana'},
                {code: 'BV', name: 'Bouvet Island'},
                {code: 'BR', name: 'Brazil'},
                {code: 'IO', name: 'British Indian Ocean Territory'},
                {code: 'BN', name: 'Brunei Darussalam'},
                {code: 'BG', name: 'Bulgaria'},
                {code: 'BF', name: 'Burkina Faso'},
                {code: 'BI', name: 'Burundi'},
                {code: 'CV', name: 'Cabo Verde'},
                {code: 'KH', name: 'Cambodia'},
                {code: 'CM', name: 'Cameroon'},
                {code: 'CA', name: 'Canada'},
                {code: 'KY', name: 'Cayman Islands'},
                {code: 'CF', name: 'Central African Republic'},
                {code: 'TD', name: 'Chad'},
                {code: 'CL', name: 'Chile'},
                {code: 'CN', name: 'China'},
                {code: 'CX', name: 'Christmas Island'},
                {code: 'CC', name: 'Cocos (Keeling) Islands'},
                {code: 'CO', name: 'Colombia'},
                {code: 'KM', name: 'Comoros'},
                {code: 'CG', name: 'Congo'},
                {code: 'CD', name: 'Congo (Democratic Republic of the)'},
                {code: 'CK', name: 'Cook Islands'},
                {code: 'CR', name: 'Costa Rica'},
                {code: 'CI', name: 'Côte d\'Ivoire'},
                {code: 'HR', name: 'Croatia'},
                {code: 'CU', name: 'Cuba'},
                {code: 'CW', name: 'Curaçao'},
                {code: 'CY', name: 'Cyprus'},
                {code: 'CZ', name: 'Czech Republic'},
                {code: 'DK', name: 'Denmark'},
                {code: 'DJ', name: 'Djibouti'},
                {code: 'DM', name: 'Dominica'},
                {code: 'DO', name: 'Dominican Republic'},
                {code: 'EC', name: 'Ecuador'},
                {code: 'EG', name: 'Egypt'},
                {code: 'SV', name: 'El Salvador'},
                {code: 'GQ', name: 'Equatorial Guinea'},
                {code: 'ER', name: 'Eritrea'},
                {code: 'EE', name: 'Estonia'},
                {code: 'ET', name: 'Ethiopia'},
                {code: 'FK', name: 'Falkland Islands (Malvinas)'},
                {code: 'FO', name: 'Faroe Islands'},
                {code: 'FJ', name: 'Fiji (Republic of)'},
                {code: 'FI', name: 'Finland'},
                {code: 'FR', name: 'France'},
                {code: 'GF', name: 'French Guiana'},
                {code: 'PF', name: 'French Polynesia'},
                {code: 'TF', name: 'French Southern Territories'},
                {code: 'GA', name: 'Gabon'},
                {code: 'GM', name: 'Gambia'},
                {code: 'GE', name: 'Georgia'},
                {code: 'DE', name: 'Germany'},
                {code: 'GH', name: 'Ghana'},
                {code: 'GI', name: 'Gibraltar'},
                {code: 'GR', name: 'Greece'},
                {code: 'GL', name: 'Greenland'},
                {code: 'GD', name: 'Grenada'},
                {code: 'GP', name: 'Guadeloupe'},
                {code: 'GU', name: 'Guam'},
                {code: 'GT', name: 'Guatemala'},
                {code: 'GG', name: 'Guernsey'},
                {code: 'GN', name: 'Guinea'},
                {code: 'GW', name: 'Guinea-Bissau'},
                {code: 'GY', name: 'Guyana'},
                {code: 'HT', name: 'Haiti'},
                {code: 'HM', name: 'Heard Island and McDonald Islands'},
                {code: 'VA', name: 'Holy See'},
                {code: 'HN', name: 'Honduras'},
                {code: 'HK', name: 'Hong Kong'},
                {code: 'HU', name: 'Hungary'},
                {code: 'IS', name: 'Iceland'},
                {code: 'IN', name: 'India'},
                {code: 'ID', name: 'Indonesia'},
                {code: 'IR', name: 'Iran (Islamic Republic of)'},
                {code: 'IQ', name: 'Iraq'},
                {code: 'IE', name: 'Ireland'},
                {code: 'IM', name: 'Isle of Man'},
                {code: 'IL', name: 'Israel'},
                {code: 'IT', name: 'Italy'},
                {code: 'JM', name: 'Jamaica'},
                {code: 'JP', name: 'Japan'},
                {code: 'JE', name: 'Jersey'},
                {code: 'JO', name: 'Jordan'},
                {code: 'KZ', name: 'Kazakhstan'},
                {code: 'KE', name: 'Kenya'},
                {code: 'KI', name: 'Kiribati'},
                {code: 'KP', name: 'Korea (Democratic People\'s Republic of)'},
                {code: 'KR', name: 'Korea (Republic of)'},
                {code: 'KW', name: 'Kuwait'},
                {code: 'KG', name: 'Kyrgyzstan'},
                {code: 'LA', name: 'Lao People\'s Democratic Republic'},
                {code: 'LV', name: 'Latvia'},
                {code: 'LB', name: 'Lebanon'},
                {code: 'LS', name: 'Lesotho'},
                {code: 'LR', name: 'Liberia'},
                {code: 'LY', name: 'Libya'},
                {code: 'LI', name: 'Liechtenstein'},
                {code: 'LT', name: 'Lithuania'},
                {code: 'LU', name: 'Luxembourg'},
                {code: 'MO', name: 'Macao'},
                {code: 'MK', name: 'Macedonia (the former Yugoslav Republic of)'},
                {code: 'MG', name: 'Madagascar'},
                {code: 'MW', name: 'Malawi'},
                {code: 'MY', name: 'Malaysia'},
                {code: 'MV', name: 'Maldives'},
                {code: 'ML', name: 'Mali'},
                {code: 'MT', name: 'Malta'},
                {code: 'MH', name: 'Marshall Islands'},
                {code: 'MQ', name: 'Martinique'},
                {code: 'MR', name: 'Mauritania'},
                {code: 'MU', name: 'Mauritius'},
                {code: 'YT', name: 'Mayotte'},
                {code: 'MX', name: 'Mexico'},
                {code: 'FM', name: 'Micronesia (Federated States of)'},
                {code: 'MD', name: 'Moldova (Republic of)'},
                {code: 'MC', name: 'Monaco'},
                {code: 'MN', name: 'Mongolia'},
                {code: 'ME', name: 'Montenegro'},
                {code: 'MS', name: 'Montserrat'},
                {code: 'MA', name: 'Morocco'},
                {code: 'MZ', name: 'Mozambique'},
                {code: 'MM', name: 'Myanmar'},
                {code: 'NA', name: 'Namibia'},
                {code: 'NR', name: 'Nauru'},
                {code: 'NP', name: 'Nepal'},
                {code: 'NL', name: 'Netherlands'},
                {code: 'NC', name: 'New Caledonia'},
                {code: 'NZ', name: 'New Zealand'},
                {code: 'NI', name: 'Nicaragua'},
                {code: 'NE', name: 'Niger'},
                {code: 'NG', name: 'Nigeria'},
                {code: 'NU', name: 'Niue'},
                {code: 'NF', name: 'Norfolk Island'},
                {code: 'MP', name: 'Northern Mariana Islands'},
                {code: 'NO', name: 'Norway'},
                {code: 'OM', name: 'Oman'},
                {code: 'PK', name: 'Pakistan'},
                {code: 'PW', name: 'Palau'},
                {code: 'PS', name: 'Palestine, State of'},
                {code: 'PA', name: 'Panama'},
                {code: 'PG', name: 'Papua New Guinea'},
                {code: 'PY', name: 'Paraguay'},
                {code: 'PE', name: 'Peru'},
                {code: 'PH', name: 'Philippines'},
                {code: 'PN', name: 'Pitcairn'},
                {code: 'PL', name: 'Poland'},
                {code: 'PT', name: 'Portugal'},
                {code: 'PR', name: 'Puerto Rico'},
                {code: 'QA', name: 'Qatar'},
                {code: 'RE', name: 'Réunion'},
                {code: 'RO', name: 'Romania'},
                {code: 'RU', name: 'Russian Federation'},
                {code: 'RW', name: 'Rwanda'},
                {code: 'BL', name: 'Saint Barthélemy'},
                {code: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha'},
                {code: 'KN', name: 'Saint Kitts and Nevis'},
                {code: 'LC', name: 'Saint Lucia'},
                {code: 'MF', name: 'Saint Martin (French part)'},
                {code: 'PM', name: 'Saint Pierre and Miquelon'},
                {code: 'VC', name: 'Saint Vincent and the Grenadines'},
                {code: 'WS', name: 'Samoa'},
                {code: 'SM', name: 'San Marino'},
                {code: 'ST', name: 'Sao Tome and Principe'},
                {code: 'SA', name: 'Saudi Arabia'},
                {code: 'SN', name: 'Senegal'},
                {code: 'RS', name: 'Serbia'},
                {code: 'SC', name: 'Seychelles'},
                {code: 'SL', name: 'Sierra Leone'},
                {code: 'SG', name: 'Singapore'},
                {code: 'SX', name: 'Sint Maarten (Dutch part)'},
                {code: 'SK', name: 'Slovakia'},
                {code: 'SI', name: 'Slovenia'},
                {code: 'SB', name: 'Solomon Islands'},
                {code: 'SO', name: 'Somalia'},
                {code: 'ZA', name: 'South Africa'},
                {code: 'GS', name: 'South Georgia and the South Sandwich Islands'},
                {code: 'SS', name: 'South Sudan'},
                {code: 'ES', name: 'Spain'},
                {code: 'LK', name: 'Sri Lanka'},
                {code: 'SD', name: 'Sudan'},
                {code: 'SR', name: 'Suriname'},
                {code: 'SJ', name: 'Svalbard and Jan Mayen'},
                {code: 'SZ', name: 'Swaziland'},
                {code: 'SE', name: 'Sweden'},
                {code: 'CH', name: 'Switzerland'},
                {code: 'SY', name: 'Syrian Arab Republic'},
                {code: 'TW', name: 'Taiwan, Province of China'},
                {code: 'TJ', name: 'Tajikistan'},
                {code: 'TZ', name: 'Tanzania, United Republic of'},
                {code: 'TH', name: 'Thailand'},
                {code: 'TL', name: 'Timor-Leste'},
                {code: 'TG', name: 'Togo'},
                {code: 'TK', name: 'Tokelau'},
                {code: 'TO', name: 'Tonga'},
                {code: 'TT', name: 'Trinidad and Tobago'},
                {code: 'TN', name: 'Tunisia'},
                {code: 'TR', name: 'Turkey'},
                {code: 'TM', name: 'Turkmenistan'},
                {code: 'TC', name: 'Turks and Caicos Islands'},
                {code: 'TV', name: 'Tuvalu'},
                {code: 'UG', name: 'Uganda'},
                {code: 'UA', name: 'Ukraine'},
                {code: 'AE', name: 'United Arab Emirates'},
                {code: 'GB', name: 'United Kingdom of Great Britain and Northern Ireland'},
                {code: 'US', name: 'United States of America'},
                {code: 'UM', name: 'United States Minor Outlying Islands'},
                {code: 'UY', name: 'Uruguay'},
                {code: 'UZ', name: 'Uzbekistan'},
                {code: 'VU', name: 'Vanuatu'},
                {code: 'VE', name: 'Venezuela (Bolivarian Republic of)'},
                {code: 'VN', name: 'Vietnam'},
                {code: 'VG', name: 'Virgin Islands (British)'},
                {code: 'VI', name: 'Virgin Islands (U.S.)'},
                {code: 'WF', name: 'Wallis and Futuna'},
                {code: 'EH', name: 'Western Sahara'},
                {code: 'YE', name: 'Yemen'},
                {code: 'ZM', name: 'Zambia'},
                {code: 'ZW', name: 'Zimbabwe'},
            ]
        )
    ;

    /** @ngInject */
    function config(
        $logProvider,
        $mdThemingProvider,
        RestangularProvider,
        env,
        $authProvider,
        $provide,
        $mdDateLocaleProvider,
        $httpProvider,
        ChartJsProvider,
        $compileProvider
    ) {
        $compileProvider.imgSrcSanitizationWhitelist(/^\s*((https?|ftp|file|blob|chrome-extension):|data:image\/)/);
        // Enable log
        //console.log('config');
        $logProvider.debugEnabled( false );
        /* Date Settings */
        $mdDateLocaleProvider.parseDate = function( dateString ) {
           var m = moment( dateString, 'DD/MM/YYYY', true );
           return m.isValid() ? m.toDate() : new Date( NaN );
        };
        $mdDateLocaleProvider.formatDate = function( date ) {
            if( date ) return moment( date ).format( 'DD/MM/YYYY' );
            else return date;
        };
        /* Auth Settings */
        $authProvider.tokenPrefix = 'Biolaser';
        $authProvider.loginUrl = env.API+'/auth/token';
        /* Factory Interceptor */
        $provide.factory( 'redirectWhenLoggedOut', function( $q, $injector ) {
            return {
                responseError: function( rejection ) {
                    var rejectionReasons = [
                           'Token not provided',
                           'Wrong number of segments',
                            'token_not_provided',
                            'token_expired',
                            'token_absent',
                            'token_invalid',
                        ]
                        , $log =  $injector.get('$log')
                        , $state =  $injector.get('$state')
                    ;
                    angular.forEach( rejectionReasons, function( value ) {
                        if( rejection.data ) {
                            if( rejection.data.error === value ||
                                    rejection.data.message === value ) {
                                $log.info( 'Rejection Reasons:', rejection.data.error );
                                /* Rimozione token in ogni caso o solo in quelli specificati nelle rejectionReasons? */
                                localStorage.removeItem( 'user' );
                                localStorage.removeItem( 'Biolaser_token' );
                                $state.go( 'login' );
                            };
                        };
                    });
                    // if( rejection.data.status_code === 404 ) { alert("Elemento non trovato!"); };
                    return $q.reject( rejection );
                },
            };
        });
        $httpProvider.interceptors.push( 'redirectWhenLoggedOut' );
        //colors
        var customPrimaryTheme = $mdThemingProvider.extendPalette(
                env.theme?env.theme.primary.default:'purple',
                env.theme?env.theme.primary.palette:{
                '50' : '#EDDEF2',
                '100' : '#d6c7d9',
                '200' : '#B8ACBB',
                '300' : '#AB7AB7',
                '400' : '#9E72A8',
                '500' : '#85608D',
                '600' : '#674A6F',
                '700' : '#543C5B',
                '800' : '#38283D',
                '900' : '#231926'
            }
        );

        var customSecondaryTheme = $mdThemingProvider.extendPalette(
                env.theme?env.theme.primary.default:'green',
                env.theme?env.theme.primary.palette:{
                    '500' : '#94C01F',
                    'contrastDefaultColor': 'light'
                }
        );

        $mdThemingProvider.definePalette('custom-primary', customPrimaryTheme);
        $mdThemingProvider.definePalette('custom-secondary', customSecondaryTheme);
        $mdThemingProvider
            .theme('default')
            .primaryPalette('custom-primary')
            .accentPalette( 'custom-secondary', { 'default' : '500' } )
            .warnPalette('red')
            .backgroundPalette(
                'grey',
                {
                    'default' : '50'
                }
            )
        ;
        /* Chart */
        var chart_colors = [
            '#85608D',
            '#AB7AB7',
            '#EDDEF2',
            '#674A6F',
            '#B8ACBB',
            '#9E72A8',
            '#38283D',
        ];
        ChartJsProvider.setOptions({ colors : chart_colors });
        Chart.defaults.global.colours = chart_colors;
        /* Restangular */
        RestangularProvider.setBaseUrl(env.API);
        RestangularProvider.setResponseExtractor(function(response) {
            return response.data;
        });
        RestangularProvider.setDefaultHeaders( { 'Authorization': 'Bearer ' + localStorage.getItem( 'Biolaser_token' ) } );
    };

})();

angular.module("admin").run(["$templateCache", function($templateCache) {$templateCache.put("app/addressbook/addressbook.html","<md-backdrop ng-click=\"ab.closeSidebar()\" ng-show=\"ab.undoVisible && ! ab.isNewCustomer\" class=\"md-sidenav-backdrop md-opaque\"></md-backdrop><md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"contacts\">contacts</md-icon><span class=\"inset\">Rubrica Clienti</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo cliente\" ng-click=\"ab.toggleRight()\"><md-icon md-font-icon=\"person_add\">person_add</md-icon>Nuovo cliente</md-button></div></md-toolbar><md-card><md-card-header><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-checkbox flex=\"20\" style=\"margin-left: 10px;\" ng-model=\"ab.showLastname\">Vis. cognome</md-checkbox><md-checkbox flex=\"20\" style=\"margin-left: 10px;\" ng-model=\"ab.showPhone\">Vis. cell.</md-checkbox><md-checkbox flex=\"20\" style=\"margin-left: 10px;\" ng-model=\"ab.query.off\" ng-change=\"ab.customersListLoad(1)\" ng-true-value=\"1\" ng-false-value=\"0\" ng-if=\"ab.user.type==\'admin\'\">Da non contattare</md-checkbox><md-input-container flex=\"60\" md-no-float=\"\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" ng-keypress=\"ab.onKeyPressSearch($event)\" placeholder=\"Cerca\"></md-input-container><span flex=\"\" hide-xs=\"\"></span><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div></div></md-toolbar></md-card-header><div ng-if=\"ab.user.type==\'admin\'\">&nbsp;&nbsp;&nbsp;<md-input-container flex=\"30\" md-no-float=\"\"><md-icon md-font-icon=\"delete_forever\">delete_forever</md-icon><input ng-model=\"ab.query.filter_merge_ko\" ng-model-options=\"ab.filter.options\" ng-disabled=\"ab.mergeCheckOk\" placeholder=\"Numero da eliminare\"></md-input-container><md-input-container flex=\"30\" md-no-float=\"\"><md-icon md-font-icon=\"done\">done</md-icon><input ng-model=\"ab.query.filter_merge_ok\" ng-disabled=\"ab.mergeCheckOk\" ng-model-options=\"ab.filter.options\" placeholder=\"Numero da mantenere\"></md-input-container><md-button class=\"md-accent md-raised\" aria-label=\"Cerca\" ng-click=\"ab.onKeyPressSearch()\" ng-if=\"!ab.mergeCheckOk\" ng-disabled=\"ab.eListLoading || !ab.query.filter_merge_ok || !ab.query.filter_merge_ko\"><md-icon md-font-icon=\"check_circle\">check_circle</md-icon>Verifica</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Unisci\" ng-click=\"ab.merge()\" ng-if=\"ab.mergeCheckOk\" ng-disabled=\"ab.merging || ab.query.filter_merge_ok==ab.query.filter_merge_ko\"><md-icon md-font-icon=\"call_merge\">call_merge</md-icon>Unisci</md-button></div><md-card-content style=\"overflow: auto\"><md-table-container ng-if=\"ab.firstLoad || ab.eListLoading\"><table md-table=\"\" md-row-select=\"ab.options.rowSelection\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\" md-on-reorder=\"ab.customersListReOrder\"><tr md-row=\"\"><th md-column=\"\" ng-if=\"ab.user.type==\'admin\'\"></th><th md-column=\"\" md-order-by=\"firstname\"><span>Nome</span></th><th md-column=\"\" md-order-by=\"lastname\"><span>Cognome</span></th><th ng-if=\"ab.user.type==\'admin\'\" md-column=\"\"><span>Mod.</span></th><th md-column=\"\"><span>By</span></th><th md-column=\"\" md-order-by=\"phone\" ng-show=\"ab.showPhone\"><span>Tel.</span></th><th md-column=\"\" ng-if=\"ab.env.documentsEnabled || ab.wkflowSbox\">D</th><th md-column=\"\">#</th><th md-column=\"\"></th><th md-column=\"\"><span>Card</span></th><th md-column=\"\" md-order-by=\"tenant\"><span>Ar.</span></th><th md-column=\"\" md-order-by=\"city\"><span>Città</span></th><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"campaign\"><span>Origine</span></th><th md-column=\"\"><span>Op.</span></th><th md-column=\"\"><span>Azioni</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.eListLoading\"><td md-cell=\"\" colspan=\"10\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.eListLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" md-select=\"customer\" md-auto-select=\"ab.options.autoSelect\" md-select-id=\"customer.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"customer in ab.customersList\"><td md-cell=\"\" ng-if=\"ab.user.type==\'admin\'\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Numero da eliminare\" ng-disabled=\"ab.query.filter_merge_ko == customer.phone\" ng-click=\"ab.query.filter_merge_ko = customer.phone\"><md-icon md-font-icon=\"delete_forever\">delete_forever</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Numero da eliminare\" ng-disabled=\"ab.query.filter_merge_ok == customer.phone\" ng-click=\"ab.query.filter_merge_ok = customer.phone\"><md-icon md-font-icon=\"done\">done</md-icon></md-button></td><td md-cell=\"\" ng-click=\"ab.rowClicked(customer)\"><md-icon title=\"Cliente con Abbonamenti Attivi\" md-font-icon=\"autorenew\" ng-if=\"customer.customer_subscriptions_active.data.length > 0\">autorenew</md-icon><md-icon title=\"Cliente con Garanzia\" md-font-icon=\"verified_user\" ng-if=\"customer.f_guarantee\">verified_user</md-icon>{{ customer.firstname }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(customer)\">{{ ab.showLastname?customer.lastname:((customer.lastname!=null && customer.lastname!=\'\')?((customer.lastname+\' \').substring(0,1)+\'.\'):\'\') }}</td><td md-cell=\"\" ng-if=\"ab.user.type==\'admin\'\"><bl-btn-customer-history entity=\"customer\" user=\"ab.user\"></bl-btn-customer-history></td><td md-cell=\"\" ng-click=\"ab.showActivities(customer)\">{{ customer.user!=null?customer.user.data.alias: \'\' }}</td><td md-cell=\"\" ng-show=\"ab.showPhone\" ng-click=\"ab.rowClicked(customer)\">{{ customer.phone}}</td><td md-cell=\"\" ng-if=\"ab.env.documentsEnabled || ab.wkflowSbox && ab.user.type == \'admin\'\" ng-click=\"ab.showDocuments(customer)\"><md-icon title=\"Documenti\" md-font-icon=\"assignment\" class=\"md-accent\">assignment</md-icon></td><td md-cell=\"\" ng-click=\"ab.rowClicked(customer)\">{{customer.user_times}}/{{customer.app_times}}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(customer)\"><md-icon md-font-icon=\"not_interested\" ng-if=\"customer.off\">not_interested</md-icon></td><td md-cell=\"\" ng-click=\"ab.rowClicked(customer)\"><md-icon md-font-icon=\"card_giftcard\" ng-if=\"customer.card!=null\">card_giftcard</md-icon><md-icon md-font-icon=\"done\" ng-if=\"customer.card!=null && customer.card.data.delivered\">done</md-icon></td><td md-cell=\"\" ng-click=\"ab.rowClicked(customer)\">{{ customer.tenant?customer.tenant.substring(0,2):\'\' }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(customer)\">{{ customer.city }}</td><td md-cell=\"\" ng-click=\"ab.showNote(customer)\"><md-icon title=\"Nota\" md-font-icon=\"event_note\" ng-if=\"customer.note != null && customer.note.trim() != \'\'\">event_note</md-icon></td><td md-cell=\"\" ng-click=\"ab.rowClicked(customer)\">{{ customer.campaign?customer.campaign:customer.source }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(customer)\" class=\"first-uppercase\"><span ng-if=\"customer.operator && customer.operator.data\">{{ customer.operator.data.alias }}</span></td><td md-cell=\"\"><xipny-wkflow-entity-list-buttons ng-if=\"ab.wkflowSbox && ab.user.type == \'admin\'\" token=\"ab.token\" user=\"ab.user\" entity=\"customer\" wkflow=\"ab.wkflowSbox\" hideundo=\"true\"></xipny-wkflow-entity-list-buttons><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Chiama\" ng-disabled=\"customer.off\" ng-href=\"tel:{{customer.phone}}\"><md-icon md-font-icon=\"call\">call</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Prendi appuntamento\" ng-href=\"{{ ab.env.booking }}/operator?tenant={{ (ab.env.tenant==\'Italia\'?(customer.tenant?customer.tenant:ab.env.currentTenant):ab.env.currentTenant) }}&amp;c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;store={{ ab.storeId }}&amp;customer={{ customer.phone }}&amp;token={{ ab.token }}\" target=\"_self\" ng-disabled=\"customer.off\"><md-icon md-font-icon=\"today\">today</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Inserisci Amici\" ng-if=\"ab.storesList.length>0\" ng-href=\"{{ ab.env.booking }}/pf?tenant={{ (ab.env.tenant==\'Italia\'?(customer.tenant?customer.tenant:ab.env.currentTenant):ab.env.currentTenant) }}&amp;cph={{ customer.phone }}&amp;c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;store={{ ab.storeId }}&amp;token={{ ab.token }}\" target=\"_self\"><md-icon title=\"Inserisci Amici\" md-font-icon=\"card_giftcard\">card_giftcard</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Scheda cliente\" ng-if=\"ab.env.isMaster && customer.tenant && customer.tenant!=ab.env.currentTenant\" href=\"{{ customer.urlCustomer }}\" target=\"{{ab.env.company}}_Admin_{{customer.tenant}}\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Scheda cliente\" ng-if=\"!ab.env.isMaster || !customer.tenant || customer.tenant==ab.env.currentTenant\" ui-sref=\"home.customer( { customer_id : customer.id } )\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"ab.query.filter && !ab.eListLoading\" md-limit=\"ab.customersListPag.per_page\" md-page=\"ab.customersListPag.current_page\" md-total=\"{{ ab.customersListPag.total }}\" md-on-paginate=\"ab.customersListLoad\" md-boundary-links=\"ab.options.boundaryLinks\"></md-table-pagination><div><h2>Inserire un criterio di ricerca nel campo \"Cerca\" e premere invio</h2><p>La ricerca pu&ograve; essere effettuata per:</p><ul><li>nome</li><li>cognome</li><li>email</li><li>numero di telefono</li></ul><p>anche parzialmente specificati, separati da spazio.<br></p><p>Esempio: \"gi la 328\" per cercare Giovanna Lasi con numero di cell. contenente le cifre 328</p></div></md-card-content></md-card></md-content><md-sidenav md-is-locked-open=\"ab.undoVisible && ! ab.isNewCustomer\" md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"account_circle\">account_circle</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"ab.activeCustomer.id\">{{ ab.activeCustomer.firstname }} {{ ab.activeCustomer.lastname }} (cid: {{ab.activeCustomer.id}})</span> <span class=\"inset\" ng-if=\"! ab.activeCustomer.id\">Aggiunta nuovo Cliente</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"customerForm\" id=\"customerForm\" layout=\"row\" layout-wrap=\"\"><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"firstname\">Nome *</label> <input type=\"text\" id=\"firstname\" name=\"firstname\" ng-model=\"ab.activeCustomer.firstname\" required=\"\" ng-model-options=\"ab.filter.options\" md-autofocus=\"\"><div ng-messages=\"customerForm.firstname.$error\" ng-show=\"customerForm.firstname.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"lastname\">Cognome *</label> <input type=\"text\" id=\"lastname\" name=\"lastname\" ng-model=\"ab.activeCustomer.lastname\" required=\"\" ng-model-options=\"ab.filter.options\"><div ng-messages=\"customerForm.lastname.$error\" ng-show=\"customerForm.lastname.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container flex=\"50\" ng-if=\"!ab.isNewCustomer\" style=\"margin-top: 0px;\"><md-checkbox ng-model=\"ab.activeCustomer.off\" ng-true-value=\"1\" ng-false-value=\"0\">Da non contattare</md-checkbox></md-input-container><md-input-container flex=\"50\" ng-if=\"!ab.isNewCustomer\" style=\"margin-top: 0px;\"><md-checkbox ng-model=\"ab.activeCustomer.f_prospect\" ng-true-value=\"1\" ng-false-value=\"0\">Prospect</md-checkbox></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"phone\">Telefono *</label> <input type=\"text\" id=\"phone\" name=\"phone\" required=\"\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-model=\"ab.activeCustomer.phone\" ng-blur=\"ab.checkPhoneExists()\" ng-model-options=\"ab.filter.options\" ng-disabled=\"ab.phoneChecking\"><div ng-messages=\"customerForm.phone.$error\" ng-show=\"customerForm.phone.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div><div ng-message=\"pattern\"><small>Inserisci un numero di cellulare valido.</small><br>Inserisci il tuo numero di cellulare (9 o 10 cifre) senza spazi ne altri caratteri.</div><div ng-message=\"alreadyexists\">Numero di cellulare usato da altro cliente: {{ab.customerExists.lastname}} {{ab.customerExists.firstname}}<md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Rubrica\" ui-sref=\"home.addressbook({ phone : ab.customerExists.phone })\"><md-icon md-font-icon=\"person\">person</md-icon></md-button></div></div></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"email\">Email</label> <input type=\"email\" id=\"email\" name=\"email\" ng-model=\"ab.activeCustomer.email\" ng-model-options=\"ab.filter.options\"></md-input-container><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\"><label for=\"birthdate\">Data di Nascita {{ab.activeCustomer.isCardRequest || ab.activeCustomer.isCardDelivery?\'*\':\'\'}}</label><md-datepicker id=\"birthdate\" name=\"birthdate\" ng-required=\"(ab.activeCustomer.isCardRequest || ab.activeCustomer.isCardDelivery) ?true:false\" ng-model=\"ab.activeCustomer.birthdate\" md-placeholder=\"Data di nascita\" ng-class=\"{ \'modify\' : ab.isNewCustomer }\"></md-datepicker></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\"><br hide-gt-sm=\"\"><br hide-gt-sm=\"\"><label for=\"gender\" style=\"margin-bottom: 8px;\">Sesso *</label><md-radio-group id=\"gender\" name=\"gender\" ng-model=\"ab.activeCustomer.gender\" ng-required=\"true\" required=\"\"><md-radio-button value=\"F\">Femmina</md-radio-button><md-radio-button value=\"M\" class=\"md-primary\">Maschio</md-radio-button></md-radio-group></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"address\">Indirizzo</label> <input type=\"text\" id=\"address\" name=\"address\" ng-model=\"ab.activeCustomer.address\" ng-model-options=\"ab.filter.options\"></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"city\">Città</label> <input type=\"text\" id=\"city\" name=\"city\" ng-model=\"ab.activeCustomer.city\" ng-model-options=\"ab.filter.options\"></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"zip_code\">CAP</label> <input type=\"number\" id=\"zip_code\" name=\"zip_code\" max=\"99999\" ng-max=\"99999\" ng-model=\"ab.activeCustomer.zip_code\" ng-model-options=\"ab.filter.options\"><div ng-messages=\"customerForm.zip_code.$error\" ng-hide=\"customerForm.zip_code.$valid\"><div ng-message=\"max\">Massima lunghezza 5 caratteri</div></div></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"province\">Provincia</label><md-select id=\"province\" name=\"province\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"province\" ng-model=\"ab.activeCustomer.province\" ng-model-options=\"ab.filter.options\"><md-option ng-value=\"null\">Nessuna provincia</md-option><md-optgroup label=\"{{ regione }}\" ng-repeat=\"( regione, province ) in ::ab.Italia track by regione\"><md-option ng-value=\"provincia.sigla\" ng-repeat=\"provincia in ::province track by provincia.sigla | orderBy: provincia.sigla\">{{ provincia.nome }}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"!ab.activeCustomer.id || ab.activeCustomer.src_cid\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"availability\">Invitato da</label><md-select aria-label=\"Invitato da\" id=\"src_cid\" name=\"scr_cid\" ng-model=\"ab.activeRelCustomer\" ng-change=\"ab.activeRelCustomerChange()\" ng-disabled=\"ab.relCustomersLoading || ab.activeCustomer.id\" md-container-class=\"with-search\"><md-select-header><span class=\"md-select-search-container\"><input type=\"{{ ab.relCustomersLoading? \'hidden\' : \'search\' }}\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_relcustomer\" name=\"filter_relcustomer\" ng-click=\"$event.stopPropagation()\" ng-keydown=\"$event.stopPropagation()\" ng-keyup=\"ab.onKeyUpRelCustomersSearch($event, this)\" ng-model=\"ab.filter_relcustomer\"></span></md-select-header><md-option ng-value=\"undefined\">Nessuno</md-option><md-option ng-value=\"customer\" ng-repeat=\"customer in ab.relCustomersList | orderBy: fullName track by customer.id\">{{ customer.fullName }} (Cell: {{ customer.phone }})</md-option></md-select></md-input-container><md-progress-circular md-diameter=\"30\" ng-if=\"ab.relCustomersLoading\" md-mode=\"indeterminate\"></md-progress-circular></div><div flex=\"100\" ng-if=\"!ab.isNewCustomer\" layout=\"row\" style=\"margin-bottom: 15px;\"><div flex=\"50\" style=\"margin-top: 27px;\"><md-checkbox ng-model=\"ab.activeCustomer.f_guarantee\" ng-disabled=\"ab.guaranteeDisabled\" ng-true-value=\"1\" ng-false-value=\"0\">Garanzia</md-checkbox></div><div layout=\"column\"><label for=\"guarantee_at\">Data rilascio garanzia</label><md-datepicker id=\"guarantee_at\" ng-disabled=\"ab.guaranteeDisabled\" name=\"guarantee_at\" ng-model=\"ab.activeCustomer.guarantee_at\" md-placeholder=\"Data rilascio garanzia\"></md-datepicker></div></div><div flex=\"100\"><span ng-if=\"ab.activeCustomer.card!=null && !ab.activeCustomer.card.data.delivered\">Data richiesta card: {{ ab.activeCustomer.card.data.created_at_frmt }}</span> <span ng-if=\"ab.activeCustomer.card!=null && ab.activeCustomer.card.data.delivered\">Data consegna card: {{ ab.activeCustomer.card.data.delivered_at_frmt }}</span><md-input-container class=\"md-block\" ng-if=\"(ab.activeCustomer.card!=null && ab.activeCustomer.card.data.delivered)\"><label for=\"credit\">Saldo punti</label> <input type=\"text\" id=\"credit\" name=\"credit\" ng-model=\"ab.activeCustomer.credit\" ng-model-options=\"ab.filter.options\" ng-disabled=\"true\"></md-input-container><md-checkbox ng-if=\"ab.activeCustomer.isCardRequest || ab.activeCustomer.card==null\" ng-model=\"ab.activeCustomer.isCardRequest\" ng-disabled=\"ab.activeCustomer.off\">Emissione Card</md-checkbox><md-checkbox ng-if=\"ab.activeCustomer.isCardRequest || (ab.activeCustomer.card!=null && !ab.activeCustomer.card.data.delivered)\" ng-model=\"ab.activeCustomer.isCardDelivery\" ng-disabled=\"ab.activeCustomer.off\">Consegna Card</md-checkbox></div><div flex=\"100\"><md-input-container class=\"md-block\"><label for=\"note\">Note</label> <textarea rows=\"2\" id=\"note\" name=\"note\" ng-model=\"ab.activeCustomer.note\" ng-model-options=\"ab.filter.options\"></textarea></md-input-container></div><div flex=\"100\" ng-if=\"ab.isNewCustomer || ab.undoVisible\" style=\"margin-top: 0px;\"><md-progress-circular ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\" style=\"margin-top: 0px;\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ab.update( ab.activeCustomer )\" ng-disabled=\"customerForm.$invalid || ab.saving || ab.phoneChecking\" ng-if=\"ab.undoVisible && ! ab.isNewCustomer\"><md-icon md-font-icon=\"check\">check</md-icon>Aggiorna</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Salva\" ng-click=\"ab.undo()\" ng-if=\"ab.undoVisible && ! ab.isNewCustomer\" ng-disabled=\"ab.saving\">Annulla</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Aggiungi\" ng-click=\"ab.save( ab.activeCustomer )\" ng-disabled=\"customerForm.$invalid || ab.saving || ab.phoneChecking\" ng-if=\"ab.isNewCustomer\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva e prenota\" ng-click=\"ab.save( ab.activeCustomer, true )\" ng-disabled=\"customerForm.$invalid || ab.saving || ab.phoneChecking\" ng-if=\"ab.isNewCustomer\"><md-icon md-font-icon=\"book\">book</md-icon>Salva e prenota appuntamento</md-button></md-input-container></div></form><div ng-if=\"! ab.isNewCustomer\" layout-margin=\"\"><md-button class=\"md-primary md-raised\" aria-label=\"Prendi nuovo appuntamento\" ng-href=\"{{ ab.env.booking }}/operator?tenant={{ (ab.env.tenant==\'Italia\'?(customer.tenant?customer.tenant:ab.env.currentTenant):ab.env.currentTenant) }}&amp;c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;store={{ ab.storeId }}&amp;customer={{ customer.phone }}&amp;token={{ ab.token }}\" target=\"{{ab.env.company}}_Booking_{{ab.env.tenant}}\" ng-disabled=\"ab.activeCustomer.off\" ng-if=\"!ab.env.isMaster\"><md-icon md-font-icon=\"today\">today</md-icon>Crea appuntamento per <strong>{{ ab.activeCustomer.firstname }} {{ ab.activeCustomer.lastname }}</strong></md-button></div><md-content ng-hide=\"!ab.loading\" layout=\"row\" layout-align=\"center center\" style=\"min-height: 80px;\"><md-progress-circular ng-disabled=\"!ab.loading\" md-diameter=\"40\"></md-progress-circular></md-content><span flex=\"100\" style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"ab.activeCustomer.invited.data.length > 0 && !ab.loading\">Invitati</span><md-table-container class=\"addressbook-invited\" ng-if=\"ab.activeCustomer.invited.data.length > 0 && !ab.loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Cognome</span></th><th md-column=\"\"><span>Nome</span></th><th md-column=\"\"><span>Cell</span></th><th md-column=\"\" md-numeric=\"\"><span>Punti</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"customer in ab.activeCustomer.invited.data | orderBy: \'lastname\'\"><td>{{ customer.created_at_frmt }}</td><td>{{ customer.lastname }}</td><td>{{ customer.firstname }}</td><td>{{ customer.phone }}</td><td style=\"text-align: right;\">{{ customer.rechargeAmount | number: 0 }}</td></tr></tbody></table></md-table-container><span flex=\"100\" style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"ab.activeCustomer.customer_subscriptions_active.data.length > 0 && !ab.loading\">Abbonamenti attivi</span><md-table-container class=\"addressbook-appointments\" ng-if=\"ab.activeCustomer.customer_subscriptions_active.data.length > 0 && !ab.loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Creato il</span></th><th md-column=\"\"><span>Abbonamento</span></th><th md-column=\"\" md-numeric=\"\"><span>Sedute Rimaste</span></th></tr></thead><tbody md-body=\"\" style=\"font-size: 12px;\"><tr md-row=\"\" ng-repeat=\"subscription in ab.activeCustomer.customer_subscriptions_active.data | orderBy: \'-date_start\'\"><td>{{ subscription.created_at }}</td><td>{{ subscription.subscription_id | subscriptionIdtoName : ab.subscriptionsList }}</td><td style=\"text-align: right;\">{{ subscription.app_remaining }}</td></tr></tbody></table></md-table-container><span flex=\"100\" style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"ab.appointmentsForCustomer.length > 0 && !ab.loading\">Storico appuntamenti</span><md-table-container class=\"addressbook-appointments\" ng-if=\"ab.appointmentsForCustomer.length > 0 && !ab.loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\" md-numeric=\"\"><span>{{ab.env.currency?ab.env.currency.label:\'Prezzo\'}}</span></th><th md-column=\"\"><span></span></th><th md-column=\"\"><span>Pres.</span></th><th md-column=\"\"><span>Centro</span></th></tr></thead><tbody md-body=\"\" style=\"font-size: 12px;\"><tr md-row=\"\" ng-repeat=\"appointment in ab.appointmentsForCustomer | orderBy: \'-date_start\'\" class=\"{{appointment.recalled>=3?\'recalled_\'+appointment.recalled:( appointment.paid? \'\':\'app_notpaid\')}}\"><td>{{ appointment.date_start | date : \'dd/MM/yyyy HH:mm\' }}</td><td>{{ appointment.treatment_id | treatmentIdtoName : ab.treatmentsList }}<md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.customer_subscription_id !== null\">autorenew</md-icon></td><td style=\"text-align: right;\"><span ng-if=\"appointment.paid\">{{ appointment.price | number:2 }} {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</span></td><td><span ng-if=\"appointment.credit>0\">{{ appointment.credit | number:2 }} {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</span></td><td><span ng-if=\"appointment.paid\">SI</span> <span ng-if=\"!appointment.paid\">NO</span></td><td>{{ appointment.store_id | storeIdtoName : ab.storesList }}</td></tr></tbody></table></md-table-container></md-content></md-sidenav>");
$templateCache.put("app/addressbookp/addressbookp.html","<md-backdrop ng-click=\"abp.closeSidebar()\" ng-show=\"abp.undoVisible && ! abp.isNewCustomer\" class=\"md-sidenav-backdrop md-opaque\"></md-backdrop><md-content class=\"page-addressbook-p\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon style=\"color: black;\" md-font-icon=\"contacts\">contacts</md-icon><span style=\"font-size:xx-large;\" class=\"inset\">Pazienti</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Pazienti Del Giorno\" ng-click=\"abp.customersListLoad(1,10,true)\"><md-icon md-font-icon=\"event\">event</md-icon>Pazienti Del Giorno</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo cliente\" ng-click=\"abp.toggleRight()\"><md-icon md-font-icon=\"person_add\">person_add</md-icon>Nuovo paziente</md-button></div></md-toolbar><md-card><md-card-header><md-button class=\"md-accent md-raised\" ng-repeat=\"search in abp.searchInStorage track by $index\" ng-click=\"abp.searchTag(search)\" style=\"font-size: 12px;\">#{{search}}</md-button></md-card-header><md-card-header><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container flex=\"95\" md-no-float=\"\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"abp.query.filter\" ng-keypress=\"abp.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" style=\"background-color: white !important;\" aria-label=\"Annulla\" ng-click=\"abp.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div></div></md-toolbar></md-card-header><md-card-content style=\"overflow: auto\"><md-table-container ng-if=\"abp.firstLoad || abp.eListLoading\"><table md-table=\"\" md-row-select=\"abp.options.rowSelection\" ng-model=\"abp.selected\"><thead md-head=\"\" md-order=\"abp.query.order\" md-on-reorder=\"abp.customersListReOrder\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"lastname\"><span>Nome</span></th><th md-column=\"\" md-order-by=\"birthdate\"><span>Età</span></th><th md-column=\"\"><span>Data Di Nascita</span></th><th md-column=\"\"><span>Telefono</span></th><th md-column=\"\"><span>Ultimo Trattamento</span></th><th md-column=\"\" md-numeric=\"\"><span>Ultimo Centro</span></th><th md-column=\"\" md-numeric=\"\"><span>Ultima Visita</span></th><th md-column=\"\" md-numeric=\"\"><span>Prossima Visita</span></th><th md-column=\"\" class=\"center\"><span>Azioni</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"abp.eListLoading\"><td md-cell=\"\" colspan=\"8\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"abp.eListLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr style=\"background-color: rgba(0, 0, 0, 0.05);\" md-row=\"\" md-select=\"customer\" md-auto-select=\"abp.options.autoSelect\" md-select-id=\"customer.id\" md-on-select=\"abp.rowClicked\" ng-repeat=\"customer in abp.customersList\"><td md-cell=\"\" ng-click=\"abp.rowClicked(customer)\">{{ customer.lastname }} {{customer.firstname}}</td><td md-cell=\"\" ng-click=\"abp.rowClicked(customer)\">{{customer.age}}</td><td md-cell=\"\" ng-click=\"abp.rowClicked(customer)\">{{customer.birthdate_formatted}}</td><td md-cell=\"\" ng-click=\"abp.rowClicked(customer)\">{{customer.phone}}</td><td md-cell=\"\" ng-click=\"abp.rowClicked(customer)\">{{customer.lastAppointment.data.treatment.name}}</td><td md-cell=\"\" ng-click=\"abp.rowClicked(customer)\">{{customer.lastStore.data.alias}}</td><td md-cell=\"\" md-numeric=\"\" ng-click=\"abp.rowClicked(customer)\">{{customer.lastAppointment.data.date_start_converted}}</td><td md-cell=\"\" md-numeric=\"\">{{customer.nextAppointment.data.date_start_converted}}</td><td md-cell=\"\" class=\"center\"><md-button style=\"display: flex; margin: auto\" class=\"md-button md-primary md-raised\" ui-sref=\"home.customer-detail( { customer_id : customer.id } )\"><img src=\"assets/images/person-lines-fill.svg\" alt=\"\" width=\"20\" height=\"20\"> Scheda paziente</md-button></td><td md-cell=\"\" class=\"center\" style=\"width: 190px;\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Elenco visite\" ui-sref=\"home.appointments({ filter : customer.phone,visite: \'1\'})\"><md-icon md-font-icon=\"view_list\" title=\"Elenco visite\">view_list</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Scheda cliente\" ui-sref=\"home.customer( { customer_id : customer.id } )\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button><md-button class=\"md-icon-button md-warn md-raised\" aria-label=\"Elimina Paziente\" ng-click=\"abp.del(customer)\"><md-icon md-font-icon=\"delete\" title=\"Elimina Paziente\">delete</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"abp.query.filter && !abp.eListLoading\" md-limit=\"abp.customersListPag.per_page\" md-page=\"abp.customersListPag.current_page\" md-total=\"{{ abp.customersListPag.total }}\" md-on-paginate=\"abp.customersListLoad\" md-boundary-links=\"abp.options.boundaryLinks\"></md-table-pagination></md-card-content></md-card></md-content><md-sidenav md-is-locked-open=\"p.undoVisible && ! abp.isNewCustomer\" md-whiteframe=\"4\" class=\"page-addressbook-p md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"account_circle\">account_circle</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"abp.activeCustomer.id\">{{ abp.activeCustomer.firstname }} {{ abp.activeCustomer.lastname }} (cid: {{abp.activeCustomer.id}})</span> <span class=\"inset\" ng-if=\"! abp.activeCustomer.id\">Aggiunta nuovo Cliente</span></h2><span flex=\"\"></span><md-button style=\"margin-left: 10px; margin-top:10px;\" class=\"md-accent md-raised\" aria-label=\"PDF Cartella Clinica\" ng-click=\"abp.onScaricaPdf()\"><md-icon md-font-icon=\"file_download\">file_download</md-icon>PDF</md-button><span flex=\"\"></span><md-button style=\"margin-left: 10px; margin-top:10px;\" class=\"md-accent md-raised\" aria-label=\"Export Dati Cliente\" ng-click=\"abp.onScaricaZip()\"><md-icon md-font-icon=\"attach_file\">attach_file</md-icon>Export</md-button><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"abp.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"customerForm\" id=\"customerForm\" layout=\"row\" layout-wrap=\"\"><md-tabs class=\"md-dynamic-height\"><md-tab label=\"Anagrafica\"><div class=\"addressbook-anagrafica\"><h3 flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\">Anagrafica</h3><div><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"firstname\">Nome *</label> <input type=\"text\" id=\"firstname\" name=\"firstname\" ng-model=\"abp.activeCustomer.firstname\" required=\"\" ng-model-options=\"abp.filter.options\" md-autofocus=\"\"><div ng-messages=\"customerForm.firstname.$error\" ng-show=\"customerForm.firstname.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"lastname\">Cognome *</label> <input type=\"text\" id=\"lastname\" name=\"lastname\" ng-model=\"abp.activeCustomer.lastname\" required=\"\" ng-model-options=\"abp.filter.options\"><div ng-messages=\"customerForm.lastname.$error\" ng-show=\"customerForm.lastname.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container flex=\"50\" ng-if=\"!abp.isNewCustomer\" style=\"margin-top: 0px;\"><md-checkbox ng-model=\"abp.activeCustomer.f_prospect\" ng-true-value=\"1\" ng-false-value=\"0\">Prospect</md-checkbox></md-input-container></div><div><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"phone\">Telefono *</label> <input type=\"text\" id=\"phone\" name=\"phone\" required=\"\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-model=\"abp.activeCustomer.phone\" ng-blur=\"abp.checkPhoneExists()\"><div ng-messages=\"customerForm.phone.$error\" ng-show=\"customerForm.phone.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div><div ng-message=\"pattern\"><small>Inserisci un numero di cellulare valido.</small><br>Inserisci il tuo numero di cellulare (9 o 10 cifre) senza spazi ne altri caratteri.</div><div ng-message=\"alreadyexists\">Numero di cellulare usato da altro cliente: {{abp.customerExists.lastname}} {{abp.customerExists.firstname}}<md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Rubrica\" ui-sref=\"home.addressbookp({ phone : abp.customerExists.phone })\"><md-icon md-font-icon=\"person\">person</md-icon></md-button></div></div></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"email\">Email</label> <input type=\"email\" id=\"email\" name=\"email\" ng-model=\"abp.activeCustomer.email\" ng-model-options=\"abp.filter.options\"></md-input-container><md-input-container flex=\"50\" ng-if=\"!abp.isNewCustomer\" style=\"margin-top: 0px;\"><md-checkbox ng-model=\"abp.activeCustomer.off\" ng-true-value=\"1\" ng-false-value=\"0\">Da non contattare</md-checkbox></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"100\" style=\"display: flex;\"><div flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"30\"><br hide-gt-sm=\"\"><br hide-gt-sm=\"\"><label for=\"gender\" style=\"margin-bottom: 8%;\">Sesso *</label><md-radio-group id=\"gender\" name=\"gender\" ng-model=\"abp.activeCustomer.gender\" ng-required=\"true\" required=\"\"><md-radio-button value=\"F\">Femmina</md-radio-button><md-radio-button value=\"M\" class=\"md-primary\">Maschio</md-radio-button></md-radio-group></div><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"30\" style=\"max-width: 30%;\"><label style=\"left:0;width: 200px;\" for=\"birthdate\">Data di Nascita {{abp.activeCustomer.isCardRequest || abp.activeCustomer.isCardDelivery?\'*\':\'\'}}</label><md-datepicker id=\"birthdate\" name=\"birthdate\" ng-required=\"(abp.activeCustomer.isCardRequest || abp.activeCustomer.isCardDelivery) ?true:false\" ng-model=\"abp.activeCustomer.birthdate\" md-placeholder=\"Data di nascita\" ng-class=\"{ \'modify\' : abp.isNewCustomer }\"></md-datepicker></md-input-container></div><div><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"birthcity\">Citt&agrave; di Nascita</label> <input type=\"text\" id=\"birthcity\" name=\"birthcity\" ng-model=\"abp.activeCustomer.birthcity\"></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"cf\">Cod. Fisc.</label> <input type=\"text\" id=\"cf\" name=\"cf\" ng-model=\"abp.activeCustomer.cf\"></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"30\"><label for=\"country\">Nazionalit&agrave;</label><md-select id=\"country\" name=\"country\" aria-label=\"Nazionalità\" ng-model=\"abp.activeCustomer.country\"><md-option ng-value=\"country.code\" ng-repeat=\"country in ::abp.Countries track by country.code\">{{ country.name }}</md-option></md-select></md-input-container></div><div><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"city\">Citt&agrave; di residenza</label> <input type=\"text\" id=\"city\" name=\"city\" ng-model=\"abp.activeCustomer.city\" ng-model-options=\"abp.filter.options\"></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"address\">Indirizzo</label> <input type=\"text\" id=\"address\" name=\"address\" ng-model=\"abp.activeCustomer.address\" ng-model-options=\"abp.filter.options\"></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"zip_code\">CAP</label> <input type=\"number\" id=\"zip_code\" name=\"zip_code\" max=\"99999\" ng-max=\"99999\" ng-model=\"abp.activeCustomer.zip_code\" ng-model-options=\"abp.filter.options\"><div ng-messages=\"customerForm.zip_code.$error\" ng-hide=\"customerForm.zip_code.$valid\"><div ng-message=\"max\">Massima lunghezza 5 caratteri</div></div></md-input-container></div><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"province\">Provincia</label><md-select id=\"province\" name=\"province\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"province\" ng-model=\"abp.activeCustomer.province\" ng-model-options=\"abp.filter.options\"><md-option ng-value=\"null\">Nessuna provincia</md-option><md-optgroup label=\"{{ regione }}\" ng-repeat=\"( regione, province ) in ::abp.Italia track by regione\"><md-option ng-value=\"provincia.sigla\" ng-repeat=\"provincia in ::province track by provincia.sigla | orderBy: provincia.sigla\">{{ provincia.nome }}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\" style=\"max-width: 30%;\"><label for=\"info\">Come ci hai conosciuto?</label><md-select id=\"info\" name=\"info\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Note\" ng-model=\"abp.activeCustomer.source\" ng-model-options=\"abp.filter.options\"><md-option ng-if=\"abp.activeCustomer.source==null\" ng-value=\"null\">Nessuna scelta</md-option><md-option ng-value=\"\'Campagna\'\">Lead</md-option><md-option ng-value=\"\'PhoneFriends\'\">Phone Friends</md-option><md-option ng-value=\"\'Porta\'\">Porta</md-option><md-option ng-value=\"\'Commerciale\'\">Commerciale</md-option></md-select></md-input-container></div></md-tab><md-tab label=\"Anamnesi\"><h3 flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\">Anamnesi</h3><md-table-container flex=\"100\"><new-survey ng-if=\"abp.activeCustomer.customerSurveysV2\" control=\"customerSurvey\" customerid=\"abp.activeCustomer.id\" user=\"abp.user\" token=\"abp.token\" customersurveys=\"abp.activeCustomer.customerSurveysV2\"></new-survey></md-table-container></md-tab><md-tab label=\"Statistiche\"><h3 flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\">Statistiche</h3><span flex=\"100\" class=\"md-subhead\" ng-if=\"abp.activeCustomer.trat_frequenti.length > 0 && !abp.loading\">Trattamenti Frequenti</span><md-table-container class=\"addressbook-invited\" ng-if=\"false && abp.activeCustomer.trat_frequenti.length > 0 && !abp.loading\" style=\"margin-right: auto;\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right;\"><span>N.</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"trattamento in abp.activeCustomer.trat_frequenti\" style=\"width: 100vw;\"><td md-cell=\"\">{{ trattamento.name }}</td><td md-cell=\"\" md-numeric=\"\" style=\"text-align: right;\">{{ trattamento.totale }}</td></tr></tbody></table></md-table-container><div><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"spesa_totale\">Spesa totale</label> <input type=\"text\" id=\"spesa_totale\" name=\"spesa_totale\" ng-model=\"abp.activeCustomer.spesa_totale\" ng-model-options=\"abp.filter.options\" readonly=\"\"></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"scontrino_medio\">Scontrino medio</label> <input type=\"text\" id=\"scontrino_medio\" name=\"scontrino_medio\" ng-model=\"abp.activeCustomer.scontrino_medio\" ng-model-options=\"abp.filter.options\" readonly=\"\"></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"spesa_totale\">N° visite</label> <input type=\"text\" id=\"numero_visite\" name=\"numero_visite\" ng-model=\"abp.activeCustomer.numero_visite\" ng-model-options=\"abp.filter.options\" readonly=\"\"></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"media_minuti\">Tempo medio</label> <input type=\"text\" id=\"media_minuti\" name=\"media_minuti\" ng-model=\"abp.activeCustomer.media_minuti\" ng-model-options=\"abp.filter.options\" readonly=\"\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"false && !abp.activeCustomer.id || abp.activeCustomer.src_cid\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"availability\">Invitato da</label><md-select aria-label=\"Invitato da\" id=\"src_cid\" name=\"scr_cid\" ng-model=\"abp.activeRelCustomer\" ng-change=\"abp.activeRelCustomerChange()\" ng-disabled=\"abp.relCustomersLoading || abp.activeCustomer.id\" md-container-class=\"with-search\"><md-select-header><span class=\"md-select-search-container\"><input type=\"{{ abp.relCustomersLoading? \'hidden\' : \'search\' }}\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_relcustomer\" name=\"filter_relcustomer\" ng-click=\"$event.stopPropagation()\" ng-keydown=\"$event.stopPropagation()\" ng-keyup=\"abp.onKeyUpRelCustomersSearch($event, this)\" ng-model=\"abp.filter_relcustomer\"></span></md-select-header><md-option ng-value=\"undefined\">Nessuno</md-option><md-option ng-value=\"customer\" ng-repeat=\"customer in abp.relCustomersList | orderBy: fullName track by customer.id\">{{ customer.fullName }} (Cell: {{ customer.phone }})</md-option></md-select></md-input-container><md-progress-circular md-diameter=\"30\" ng-if=\"abp.relCustomersLoading\" md-mode=\"indeterminate\"></md-progress-circular></div><div flex=\"100\" ng-if=\"false\"><span ng-if=\"abp.activeCustomer.card!=null && !abp.activeCustomer.card.data.delivered\">Data richiesta card: {{ abp.activeCustomer.card.data.created_at_frmt }}</span> <span ng-if=\"abp.activeCustomer.card!=null && abp.activeCustomer.card.data.delivered\">Data consegna card: {{ abp.activeCustomer.card.data.delivered_at_frmt }}</span><md-input-container class=\"md-block\" ng-if=\"(abp.activeCustomer.card!=null && abp.activeCustomer.card.data.delivered)\"><label for=\"credit\">Saldo punti</label> <input type=\"text\" id=\"credit\" name=\"credit\" ng-model=\"abp.activeCustomer.credit\" ng-model-options=\"abp.filter.options\" ng-disabled=\"true\"></md-input-container><md-checkbox ng-if=\"abp.activeCustomer.isCardRequest || abp.activeCustomer.card==null\" ng-model=\"abp.activeCustomer.isCardRequest\" ng-disabled=\"abp.activeCustomer.off\">Emissione Card</md-checkbox><md-checkbox ng-if=\"abp.activeCustomer.isCardRequest || (abp.activeCustomer.card!=null && !abp.activeCustomer.card.data.delivered)\" ng-model=\"abp.activeCustomer.isCardDelivery\" ng-disabled=\"abp.activeCustomer.off\">Consegna Card</md-checkbox></div></md-tab><md-tab label=\"Storico Appuntamenti\"><md-table-container ng-if=\"abp.activeCustomer.appointments && abp.activeCustomer.appointments.data && abp.activeCustomer.appointments.data.length >0\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data e Ora inizio</span></th><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\"><span>Operatore</span></th><th md-column=\"\"><span>Assistente</span></th><th md-column=\"\"><span>Note Diagnosi</span></th><th md-column=\"\"><span>Note Terapia</span></th><th md-column=\"\"><span>Note Valutazione Clinica</span></th><th md-column=\"\"><span>Specifiche tecniche (prodotti/parametri)</span></th><th md-column=\"\"><span>Pagato</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"appointment in abp.activeCustomer.appointments.data | orderBy : \'-date_start\'\" ng-if=\"appointment.paid == 1 && appointment.recalled < 3\"><td md-cell=\"\">{{ appointment.date_start_frmt}}</td><td md-cell=\"\">{{ appointment.treatment.name}}</td><td md-cell=\"\">{{appointment.role.data.user.lastname}} {{appointment.role.data.user.firstname}}</td><td md-cell=\"\">{{appointment.assist_user.data.lastname}} {{appointment.assist_user.data.firstname}}</td><td md-cell=\"\">{{appointment.note_diagnosi}}</td><td md-cell=\"\">{{appointment.note_terapia}}</td><td md-cell=\"\">{{appointment.note_val_clinica}}</td><td md-cell=\"\">{{appointment.parameters}}</td><td md-cell=\"\">{{appointment.price}}&euro;</td></tr></tbody></table></md-table-container></md-tab><md-tab label=\"Consensi\"><md-table-container ng-if=\"abp.activeCustomer.documents && abp.activeCustomer.documents.data && abp.activeCustomer.documents.data.length >0\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"><span>Documento</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"doc in abp.activeCustomer.documents.data\" ng-if=\"doc.document_type_id!=304\"><td md-cell=\"\"><md-icon md-font-icon=\"check\" class=\"md-accent\">check</md-icon></td><td md-cell=\"\">{{ doc.title }}</td><td md-cell=\"\"><span>{{ doc.date }}</span></td><td md-cell=\"\"><md-button class=\"md-button md-raised md-accent\" ng-href=\"{{ abp.env.API }}/documents/{{doc.id}}/download?token={{ abp.token }}\" target=\"_blank\"><md-icon md-font-icon=\"get_app\">get_app</md-icon></md-button></td></tr></tbody></table></md-table-container></md-tab></md-tabs><div flex=\"100\" ng-if=\"abp.isNewCustomer || abp.undoVisible\" style=\"margin-top: 0px;\"><md-progress-circular ng-if=\"abp.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"abp.update( abp.activeCustomer )\" ng-disabled=\"customerForm.$invalid || abp.saving || abp.phoneChecking\" ng-if=\"abp.undoVisible && ! abp.isNewCustomer\"><md-icon md-font-icon=\"check\">check</md-icon>Aggiorna</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Salva\" ng-click=\"abp.undo()\" ng-if=\"abp.undoVisible && ! abp.isNewCustomer\" ng-disabled=\"abp.saving\">Annulla</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Aggiungi\" ng-click=\"abp.save( abp.activeCustomer )\" ng-disabled=\"customerForm.$invalid || abp.saving || abp.phoneChecking\" ng-if=\"abp.isNewCustomer\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva e prenota\" ng-click=\"abp.save( abp.activeCustomer, true )\" ng-disabled=\"customerForm.$invalid || abp.saving || abp.phoneChecking\" ng-if=\"abp.isNewCustomer\"><md-icon md-font-icon=\"book\">book</md-icon>Salva e prenota appuntamento</md-button></div></form><div ng-if=\"false && !abp.isNewCustomer\" layout-margin=\"\"><md-button class=\"md-primary md-raised\" aria-label=\"Prendi nuovo appuntamento\" ng-href=\"{{ abp.env.booking }}/operator?c_sid={{ abp.user.store_id }}&amp;c_role={{ abp.user.type }}&amp;store={{ abp.storeId }}&amp;customer={{ abp.activeCustomer.phone }}&amp;token={{ abp.token }}\" target=\"_self\" ng-disabled=\"abp.activeCustomer.off\" ng-if=\"!abp.env.isMaster\"><md-icon md-font-icon=\"today\">today</md-icon>Crea appuntamento per <strong>{{ abp.activeCustomer.firstname }} {{ abp.activeCustomer.lastname }}</strong></md-button></div><md-content ng-hide=\"!abp.loading\" layout=\"row\" layout-align=\"center center\" style=\"min-height: 80px;\"><md-progress-circular ng-disabled=\"!abp.loading\" md-diameter=\"40\"></md-progress-circular></md-content><span flex=\"100\" style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"false && abp.activeCustomer.invited.data.length > 0 && !abp.loading\">Invitati</span><md-table-container class=\"addressbook-invited\" ng-if=\"false && abp.activeCustomer.invited.data.length > 0 && !abp.loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Cognome</span></th><th md-column=\"\"><span>Nome</span></th><th md-column=\"\"><span>Cell</span></th><th md-column=\"\" md-numeric=\"\"><span>Punti</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"customer in abp.activeCustomer.invited.data | orderBy: \'lastname\'\"><td>{{ customer.created_at_frmt }}</td><td>{{ customer.lastname }}</td><td>{{ customer.firstname }}</td><td>{{ customer.phone }}</td><td style=\"text-align: right;\">{{ customer.rechargeAmount | number: 0 }}</td></tr></tbody></table></md-table-container><span flex=\"100\" style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"false && abp.activeCustomer.customer_subscriptions_active.data.length > 0 && !abp.loading\">Abbonamenti attivi</span><md-table-container class=\"addressbook-appointments\" ng-if=\"false && abp.activeCustomer.customer_subscriptions_active.data.length > 0 && !abp.loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Creato il</span></th><th md-column=\"\"><span>Abbonamento</span></th><th md-column=\"\" md-numeric=\"\"><span>Sedute Rimaste</span></th></tr></thead><tbody md-body=\"\" style=\"font-size: 12px;\"><tr md-row=\"\" ng-repeat=\"subscription in abp.activeCustomer.customer_subscriptions_active.data | orderBy: \'-date_start\'\"><td>{{ subscription.created_at }}</td><td>{{ subscription.subscription_id | subscriptionIdtoName : abp.subscriptionsList }}</td><td style=\"text-align: right;\">{{ subscription.app_remaining }}</td></tr></tbody></table></md-table-container><span flex=\"100\" style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"false && abp.appointmentsForCustomer.length > 0 && !abp.loading\">Storico appuntamenti</span><md-table-container class=\"addressbook-appointments\" ng-if=\"false && abp.appointmentsForCustomer.length > 0 && !abp.loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\" md-numeric=\"\"><span>{{abp.env.currency?abp.env.currency.label:\'Prezzo\'}}</span></th><th md-column=\"\"><span></span></th><th md-column=\"\"><span>Pres.</span></th><th md-column=\"\"><span>Centro</span></th></tr></thead><tbody md-body=\"\" style=\"font-size: 12px;\"><tr md-row=\"\" ng-repeat=\"appointment in abp.appointmentsForCustomer | orderBy: \'-date_start\'\" class=\"{{appointment.recalled>=3?\'recalled_\'+appointment.recalled:( appointment.paid? \'\':\'app_notpaid\')}}\"><td>{{ appointment.date_start | date : \'dd/MM/yyyy HH:mm\' }}</td><td>{{ appointment.treatment_id | treatmentIdtoName : abp.treatmentsList }}<md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.customer_subscription_id !== null\">autorenew</md-icon></td><td style=\"text-align: right;\"><span ng-if=\"appointment.paid\">{{ appointment.price | number:2 }} {{abp.env.currency?abp.env.currency.symbol:\'&euro;\'}}</span></td><td><span ng-if=\"appointment.credit>0\">{{ appointment.credit | number:2 }} {{abp.env.currency?abp.env.currency.symbol:\'&euro;\'}}</span></td><td><span ng-if=\"appointment.paid\">SI</span> <span ng-if=\"!appointment.paid\">NO</span></td><td>{{ appointment.store_id | storeIdtoName : abp.storesList }}</td></tr></tbody></table></md-table-container></md-content></md-sidenav>");
$templateCache.put("app/appointments/appointments.html","<md-backdrop ng-click=\"ap.closeSidebar()\" ng-show=\"ap.undoVisible\" class=\"md-sidenav-backdrop md-opaque\"></md-backdrop><md-content class=\"page-appointments\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\" flex=\"nogrow\" show-gt-md=\"\" ng-if=\"ap.store.id\"><md-icon md-font-icon=\"book\">book</md-icon><span class=\"inset\">{{ap.store.address}}<br>tel. {{ap.store.phone}}</span></h2><span flex=\"\" hide-xs=\"\"></span><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" show-gt-md=\"\" ng-if=\"ap.user.store_id==null || ap.user.store_id==0\"><md-select aria-label=\"Presi da\" placeholder=\"Presi da\" ng-model=\"ap.eStatus.selectedByOperatorId\" ng-change=\"ap.appointmentsListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"ap.user.id\">Presi da me</md-option><md-option ng-value=\"u.user_id\" ng-repeat=\"u in ap.userRolesListCall | orderBy: \'user.lastname\'\">{{ u.user.lastname }} {{ u.user.firstname }}</md-option></md-select></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" show-gt-md=\"\"><md-select aria-label=\"Operatrice\" placeholder=\"Operatrice\" ng-model=\"ap.eStatus.selectedOperatorId\" ng-change=\"ap.appointmentsListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"operator.user_id\" ng-repeat=\"operator in ap.userRolesList | unique: \'user_id\' | orderBy: \'user.lastname\'\" ng-if=\"operator.store_id\"><div ng-if=\"ap.storeId\" class=\"operator-circle\" style=\"background-color: {{ operator.color }};\"></div>{{ operator.user.lastname }} {{ operator.user.firstname }}</md-option></md-select></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select aria-label=\"Pres./Non pres.\" placeholder=\"Pres./Non pres.\" ng-model=\"ap.eStatus.selectedFilter\" ng-change=\"ap.appointmentsListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ap.filtersList track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select aria-label=\"1a v./Smalt.\" placeholder=\"1a v./Smalt.\" ng-model=\"ap.eStatus.selectedFilterUT\" ng-change=\"ap.appointmentsListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ap.filtersListUT track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo appuntamento\" ng-click=\"ap.toggleRight()\" ng-disabled=\"!ap.storeId\"><md-icon md-font-icon=\"collections_bookmark\">collections_bookmark</md-icon>{{ ap.portaEnabled ?\'App. Porta\':\'Nuovo app.\' }}</md-button><md-button aria-label=\"Nuovo appuntamento\" class=\"md-accent md-raised\" target=\"_self\" ng-href=\"{{ ap.env.booking }}/operator?c_sid={{ ap.user.store_id }}&amp;c_role={{ ap.user.type }}&amp;store={{ ap.storeId }}&amp;callcenter={{ ap.isCallCenter }}&amp;token={{ ap.token }}\"><md-icon md-font-icon=\"book\">book</md-icon>Booking</md-button></div></md-toolbar><md-card><md-card-header style=\"padding-bottom: 6px; padding-top: 6px;\"><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container md-no-float=\"\" class=\"md-accent\" flex=\"20\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ap.query.filter\" ng-keypress=\"ap.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ap.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select aria-label=\"Com./Non com.\" placeholder=\"Com./Non com.\" ng-model=\"ap.eStatus.selectedFilterCOM\" ng-change=\"ap.appointmentsListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ap.filtersListCOM track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select aria-label=\"Anomalie/Note\" placeholder=\"Anomalie/Note\" ng-model=\"ap.eStatus.selectedFilterAnom\" ng-change=\"ap.appointmentsListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ap.filtersListAnom track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><div flex=\"20\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" id=\"filter_date_start\" name=\"filter_date_start\" md-placeholder=\"Filtra per data iniziale\" ng-model=\"ap.eStatus.filter_date_start\" ng-change=\"ap.onChangeDateStart()\"></md-datepicker></div><div><md-input-container class=\"md-accent\" style=\"width:60px; margin-left:35px;\"><input mdc-datetime-picker=\"\" type=\"text\" id=\"filter_time_start\" time=\"true\" date=\"false\" name=\"filter_time_start\" md-placeholder=\"Filtra per ora iniziale\" ng-model=\"ap.eStatus.filter_time_start\" ng-change=\"ap.onChangeTimeStart()\"></md-input-container></div><div flex=\"20\" hide-xs=\"\" hide-sm=\"\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" id=\"filter_date_end\" name=\"filter_date_end\" md-placeholder=\"Filtra per data finale\" md-min-date=\"ap.filter_date_start\" ng-model=\"ap.eStatus.filter_date_end\" ng-change=\"ap.onChangeDateEnd()\"></md-datepicker></div><md-checkbox style=\"margin-left: 30px;\" ng-if=\"ap.user.type!=\'operator\'\" ng-model=\"ap.eStatus.filter_created_at\" ng-change=\"ap.onChangeFilterCreatedAt()\"></md-checkbox></div></md-toolbar></md-card-header><md-card-content style=\"overflow-y: auto; padding-top: 0px;\"><md-table-container><table md-table=\"\" md-row-select=\"ap.options.rowSelection\" ng-model=\"ap.selected\"><thead md-head=\"\" md-order=\"ap.query.order\" md-on-reorder=\"ap.appointmentsListReOrder\"><tr md-row=\"\"><th md-column=\"\"><md-checkbox style=\"margin-left: 10px;\" ng-model=\"ap.showLastname\"></md-checkbox></th><th md-column=\"\"></th><th md-column=\"\" ng-if=\"ap.env.shoppingPlusEnabled\"></th><th md-column=\"\" md-order-by=\"customers.lastname\"><span>Cliente</span></th><th md-column=\"\"><span>1° v.</span></th><th md-column=\"\"><span></span></th><th md-column=\"\"><span>By</span></th><th md-column=\"\"><span>Sm</span></th><th md-column=\"\" md-order-by=\"created_at\" ng-if=\"ap.eStatus.filter_created_at\"><span>Creato il</span></th><th md-column=\"\" md-order-by=\"date_start\"><span>Data inizio</span></th><th md-column=\"\" md-order-by=\"date_end\" ng-if=\"ap.storeId\"><span>Fine</span></th><th md-column=\"\" md-order-by=\"store_id\" ng-if=\"!ap.storeId\"><span>Centro</span></th><th md-column=\"\" ng-if=\"ap.env.documentsEnabled\"><span>D</span></th><th md-column=\"\" md-order-by=\"treatments.name\"><span>Trattamento</span></th><th md-column=\"\"><span>N</span></th><th md-column=\"\" md-numeric=\"\"><span>{{ap.env.currency?ap.env.currency.label:\"Prezzo\"}}</span></th><th md-column=\"\"><span>Contatta</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"ap.showLastname && (!ap.env.currency || ap.env.currency.pos)\"><span>Pag</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"recalled\" class=\"cell-button\" style=\"text-align: center;\"><span>Ricord.</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"paid\" class=\"cell-button\" style=\"text-align: center;\"><span>Pres.</span></th><th md-column=\"\" class=\"icon-button\"><md-icon md-font-icon=\"settings\">settings</md-icon></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ap.loading\"><td md-cell=\"\" colspan=\"10\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ap.loading\" md-mode=\"indeterminate\"></md-progress-circular></td><td md-cell=\"\" ng-if=\"ap.canDelete\"></td></tr><tr md-row=\"\" md-select=\"appointment\" md-auto-select=\"ap.options.autoSelect\" md-select-id=\"appointment.id\" md-on-select=\"ap.rowClicked\" ng-repeat-start=\"appointment in ap.appointmentsList\"><td md-cell=\"\"><md-select ng-disabled=\"appointment.recalled>=3 || appointment.closed\" aria-label=\"Operatore\" ng-model=\"appointment.newOperatorId\" ng-change=\"ap.operatorChange.doChange(appointment)\" ng-click=\"ap.operatorChange.gotFocus(appointment)\"><md-option ng-value=\"op.user_id\" ng-repeat=\"op in appointment.newOperatorCandidates track by op.id\"><div class=\"operator-circle\" style=\"background-color: {{ op.color }};\"></div></md-option></md-select></td><td md-cell=\"\" class=\"cell-button md-cell md-numeric\"><md-icon title=\"Storico modifiche\" md-font-icon=\"change_history\" ng-click=\"ap.showOpHistory( appointment )\" ng-if=\"appointment.operatorChangeHistory && appointment.operatorChangeHistory.data && appointment.operatorChangeHistory.data.length>0\">change_history</md-icon></td><td md-cell=\"\" class=\"cell-button\" ng-if=\"ap.env.shoppingPlusEnabled\"><bl-app-appointment ng-if=\"appointment.source == \'app\'\" appointment=\"appointment\"></bl-app-appointment></td><td md-cell=\"\" class=\"cell-button\" style=\"text-align:left;\"><md-button class=\"user-find\" ng-class=\"{ \'md-warn\' : appointment.uncovered || appointment.uncovered_assist || appointment.f_over }\" ui-sref=\"home.addressbook({ phone : appointment.customer.data.phone })\"><md-icon title=\"Appuntamento scoperto assist.\" md-font-icon=\"warning\" ng-if=\"appointment.uncovered_assist && appointment.user_id_assist\" style=\"color: grey;\">warning</md-icon><md-icon title=\"Appuntamento scoperto\" md-font-icon=\"warning\" ng-if=\"appointment.uncovered\">warning</md-icon><md-icon title=\"Appuntamento overbooking\" md-font-icon=\"grid_off\" ng-if=\"appointment.f_over == 1 && appointment.by_operator!=36\">grid_off</md-icon><md-icon title=\"Appuntamento overbooking\" md-font-icon=\"border_clear\" ng-if=\"appointment.f_over == 2\">border_clear</md-icon><md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.type == \'abb\' && appointment.customer_subscription_id !== null\">autorenew</md-icon><md-icon title=\"Cliente con Garanzia\" md-font-icon=\"verified_user\" ng-if=\"appointment.customer.data.f_guarantee\">verified_user</md-icon>{{ appointment.customer.data.firstname }} {{ ap.showLastname?appointment.customer.data.lastname:(appointment.customer.data.lastname!=null?(appointment.customer.data.lastname+\' \').substring(0,1)+\'.\':\'\') }}</md-button><br><span ng-if=\"ap.env.customertags\" ng-repeat=\"tag in ap.tags | validTags:appointment.customer.data.entitytags[\'data\']\"><div class=\"operator-square\" style=\"background-color: {{ tag.color }};\"></div>&nbsp;{{ tag[\'label\'] }}&nbsp;</span><md-menu ng-if=\"ap.env.customertags && ap.tags && ap.tags.length>0\"><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"ap.openMenuTags($mdMenu, $event)\"><md-icon>label</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"tag in ap.tags\"><md-button ng-click=\"ap.toggleTag($event, appointment, tag)\"><div class=\"operator-square\" style=\"background-color: {{ tag.color }};\"></div>&nbsp;{{tag.label}}</md-button></md-menu-item></md-menu-content></md-menu></td><td md-cell=\"\"><span ng-click=\"ap.showInfo( appointment )\" ng-if=\"2 > appointment.user_times\">Si</span> <span ng-click=\"ap.showInfo( appointment )\" ng-if=\"appointment.user_times>1 && appointment.user_times<70\">No</span> <span ng-click=\"ap.showBSG( appointment,\'Bronze\', appointment.bronzetag[0])\" ng-if=\"appointment.user_times>=70 && appointment.user_times<85\"><md-icon ng-if=\"appointment.bronzetag && appointment.bronzetag.length>0 && appointment.bronzetag[0].flagged\" style=\"color: goldenrod;\">verified_user</md-icon><md-icon ng-if=\"!(appointment.bronzetag && appointment.bronzetag.length>0 && appointment.bronzetag[0].flagged)\" style=\"color: goldenrod;\">shopping_basket</md-icon></span> <span ng-click=\"ap.showBSG( appointment,\'Silver\', appointment.silvertag[0])\" ng-if=\"appointment.user_times>=85 && appointment.user_times<100\"><md-icon ng-if=\"appointment.silvertag && appointment.silvertag.length>0 && appointment.silvertag[0].flagged\" style=\"color: silver;\">verified_user</md-icon><md-icon ng-if=\"!(appointment.silvertag && appointment.silvertag.length>0 && appointment.silvertag[0].flagged)\" style=\"color: silver;\">shopping_basket</md-icon></span> <span ng-click=\"ap.showBSG( appointment, \'Gold\', appointment.goldtag[0])\" ng-if=\"appointment.user_times>=100\"><md-icon ng-if=\"appointment.goldtag && appointment.goldtag.length>0 && appointment.goldtag[0].flagged\" style=\"color: gold;\">verified_user</md-icon><md-icon ng-if=\"!(appointment.goldtag && appointment.goldtag.length>0 && appointment.goldtag[0].flagged)\" style=\"color: gold;\">shopping_basket</md-icon></span></td><td md-cell=\"\"><md-button ng-click=\"ap.showInfo( appointment )\" aria-label=\"Info\" ng-class=\"{\'md-icon-button\': true, \'md-accent\': appointment.by_operator>0 && !appointment.byOperator.data.store_id, \'md-warn\': appointment.byOperator.data.store_id && (appointment.cus_act_id || appointment.lead_id) || appointment.lead_id && appointment.lead && appointment.lead.data && appointment.lead.data.f_oper }\"><md-icon ng-if=\"appointment.appointment_id!=null || appointment.recalled==4\" title=\"Spostamento\" md-font-icon=\"schedule\">schedule</md-icon><md-icon ng-if=\"appointment.appointment_id==null && appointment.recalled!=4 && appointment.lead_id != null && appointment.lead.data.campagna!=\'Non fidelizzato\'\" title=\"Da Lead\" md-font-icon=\"input\">input</md-icon><md-icon ng-if=\"appointment.appointment_id==null && appointment.recalled!=4 && appointment.lead_id != null && appointment.lead.data.campagna==\'Non fidelizzato\'\" title=\"Da Lead\" md-font-icon=\"published_with_changes\">published_with_changes</md-icon><md-icon ng-if=\"(appointment.by_operator > 0 && appointment.by_operator!=36) && appointment.appointment_id==null && appointment.recalled!=4 && appointment.lead_id == null\" title=\"Info booking\" md-font-icon=\"book\">book</md-icon><md-icon ng-if=\"appointment.by_operator == 0 && appointment.appointment_id==null && appointment.recalled!=4 && appointment.lead_id == null\" title=\"Online Booking\" md-font-icon=\"web\">web</md-icon><md-icon ng-if=\"appointment.by_operator == 36 && appointment.appointment_id==null && appointment.recalled!=4 && appointment.lead_id == null\" title=\"Bot Booking\" md-font-icon=\"message\">message</md-icon></md-button><span style=\"font-size: 13px;\" ng-if=\"ap.showLastname && appointment.recalled<3 && appointment.affidabilita\">{{ appointment.affidabilita | number:0 }}%</span> <span ng-if=\"appointment.relevance<0\" style=\"font-size: 13px;\">({{ 0-appointment.relevance }})</span></td><td md-cell=\"\" ng-click=\"ap.showActivities( appointment )\">{{ appointment.byOperator.data.alias }}</td><td md-cell=\"\" ng-click=\"ap.showActivities( appointment )\"><div class=\"operator-circle\" ng-if=\"appointment.roleSm\" style=\"background-color: {{ appointment.roleSm.data.color }};\"></div></td><td md-cell=\"\" ng-if=\"ap.eStatus.filter_created_at\" ng-click=\"ap.rowClicked( appointment, \'price\')\">{{ appointment.created_at_frmt }}</td><td md-cell=\"\" ng-click=\"ap.rowClicked( appointment, \'price\')\">{{ appointment.date_start_frmt }}</td><td ng-if=\"ap.storeId\" md-cell=\"\" ng-click=\"ap.rowClicked( appointment, \'price\')\">{{ appointment.date_end_frmt }}</td><td ng-if=\"!ap.storeId\" md-cell=\"\" ng-click=\"ap.rowClicked( appointment, \'price\')\">{{ appointment.store.data.alias }}</td><td md-cell=\"\" ng-if=\"ap.env.documentsEnabled\" ng-click=\"ap.showDocuments( appointment )\"><md-icon title=\"Documenti\" md-font-icon=\"assignment\" class=\"md-accent\" ng-if=\"appointment.docPrivacyOk && appointment.docPicturesOk && appointment.docTreatmentOk\">assignment</md-icon><md-icon title=\"Documenti mancanti\" md-font-icon=\"assignment_late\" class=\"md-warn\" ng-if=\"!appointment.docPrivacyOk || !appointment.docPicturesOk || !appointment.docTreatmentOk\">assignment_late</md-icon></td><td md-cell=\"\" ng-click=\"ap.rowClicked( appointment, \'price\')\">{{ appointment.treatment_id | treatmentIdtoName : ap.treatmentsList }}</td><td md-cell=\"\" ng-if=\"false\" ng-click=\"ap.rowClicked( appointment, \'price\')\">{{ appointment.store_id | storeIdtoName : ap.storesList }}</td><td md-cell=\"\" ng-click=\"ap.showNote( appointment )\"><md-icon title=\"Nota\" md-font-icon=\"event_note\" ng-if=\"appointment.lead_recall && appointment.lead_recall.data && appointment.lead_recall.data.note && appointment.lead_recall.data.note.trim()!=\'\' && appointment.lead_recall.data.note.trim().indexOf(\'Da confermare appuntamento \')!=0 || appointment.note != null && appointment.note.trim() != \'\' || appointment.note_diagnosi != null && appointment.note_diagnosi.trim() != \'\' || appointment.note_terapia != null && appointment.note_terapia.trim() != \'\' || appointment.customer.data.note != null && appointment.customer.data.note.trim() != \'\'\">event_note</md-icon><md-button style=\"margin-top: 15px; padding: 0px;\" class=\"md-icon-button md-primary\" aria-label=\"Inserisci amici\" ng-if=\"appointment.haveCard\" ng-href=\"{{ ap.env.booking }}/pf?tenant={{ (ab.env.tenant==\'Italia\'?(appointment.customer.data.tenant?appointment.customer.data.tenant:ap.env.currentTenant):ap.env.currentTenant) }}&amp;crdid={{ appointment.card.data.id }}&amp;cph={{ appointment.customer.data.phone }}&amp;c_sid={{ ap.user.store_id }}&amp;c_role={{ ap.user.type }}&amp;store={{ ap.storeId }}&amp;token={{ ap.token }}\" target=\"_blank\"><md-icon title=\"Consegnare card\" md-font-icon=\"card_giftcard\">card_giftcard</md-icon></md-button><md-icon title=\"Card consegnata\" md-font-icon=\"done\" ng-if=\"appointment.haveCard && !appointment.deliverCard\">done</md-icon></td><td md-cell=\"\" ng-click=\"ap.rowClicked(appointment, \'price\')\"><md-icon title=\"Prezzo cambiato da operatrice\" md-font-icon=\"trending_down\" ng-if=\"appointment.price_changed_by_operator !== 0 && appointment.price_changed_by_operator !== null\">trending_down</md-icon><span ng-if=\"ap.showLastname && ((!appointment.closed && appointment.recalled<3) || appointment.paid)\">{{ appointment.price | number:2 }} {{ap.env.currency?ap.env.currency.symbol:\'&euro;\'}}</span><md-icon ng-class=\"{ \'md-warn md-icon-button\' : (appointment.ratePaymentIds && appointment.ratePaymentIds.length==0) || appointment.price_due > 0, \'md-accent md-icon-button\' : appointment.ratePaymentIds && appointment.ratePaymentIds.length>0 && appointment.price_due == 0 }\" ng-if=\"(appointment.customer.data.payments && appointment.customer.data.payments.data && appointment.customer.data.payments.data.length>0) || (appointment.payments && appointment.payments.data && appointment.payments.data.length>0)\" title=\"Rate non pagate\" md-font-icon=\"warning\">warning</md-icon><md-icon style=\"margin-right:10px;\" class=\"md-primary md-icon-button\" md-font-icon=\"create\" title=\"Modifica\" ng-if=\"!ap.showLastname && !appointment.closed && appointment.recalled<3\">create</md-icon></td><td md-cell=\"\" class=\"icon-button\"><md-button class=\"md-icon-button md-primary\" aria-label=\"Chiama\" title=\"Chiama\" href=\"tel:+39{{appointment.customer.data.phone}}\"><md-icon md-font-icon=\"call\">call</md-icon></md-button><md-button class=\"md-icon-largebutton\" style=\"padding:5px;\" aria-label=\"Whatsapp\" ui-sref=\"home.whatsapp({phone: appointment.customer.data.phone})\"><notification-icon count=\"appointment.customer.data.unreadedMessages.data.length\"><md-icon title=\"Whatsapp\" md-font-icon=\"chat\">chat</md-icon></notification-icon></md-button></td><td md-cell=\"\" ng-click=\"ap.rowClicked(appointment, \'price\')\" ng-if=\"ap.showLastname && (!ap.env.currency || ap.env.currency.pos)\"><md-icon title=\"{{ appointment.payment_type==\'M\'? \'Misto\' : (appointment.payment_type==\'P\' ? \'Pos\' : (appointment.payment_type==\'D\' ? \'Pagodil\' : (appointment.payment_type==\'T\' ? \'Satispay\' : (appointment.payment_type==\'L\' ? \'PagoLight\' : (appointment.payment_type==\'S\' ? \'SmallPay\' : \'Bonifico\')))))}}\" md-font-icon=\"credit_card\" ng-if=\"appointment.payment_pos>0.009 || appointment.payment_dil>0.009 || appointment.payment_apppago>0.009 || appointment.payment_light>0.009 || appointment.payment_small>0.009 || appointment.payment_satis>0.009 || appointment.payment_stripe>0.009 || appointment.payment_card>0.009\" ng-class=\"{ \'md-accent\': appointment.payment_type==\'D\' || appointment.payment_type==\'E\' || appointment.payment_type==\'L\' || appointment.payment_type==\'S\' || appointment.payment_type==\'T\' || appointment.payment_type==\'I\', \'md-warn\' : appointment.payment_type==\'M\'}\">credit_card</md-icon><md-icon title=\"Bonifico/Assegno\" md-font-icon=\"account_balance\" ng-if=\"appointment.payment_bon>0.009 || appointment.payment_check>0.009\" ng-class=\"{\'md-warn\' : appointment.payment_type==\'M\'}\">account_balance</md-icon><md-icon title=\"Gift\" md-font-icon=\"card_giftcard\" ng-if=\"appointment.payment_gift>0.009\" ng-class=\"{\'md-warn\' : appointment.payment_type==\'M\'}\">card_giftcard</md-icon></td><td class=\"cell-select\" md-cell=\"\"><md-input-container class=\"md-block\" ng-class=\"{ \'md-warn\' : appointment.recalled == 0 && !appointment.createdRecently, \'md-warnRecent\' : appointment.recalled == 0 && appointment.createdRecently, \'md-accent\' : appointment.recalled == 1, \'md-background\' : appointment.recalled == 2, \'md-disd\': appointment.recalled == 3, \'md-spos\': appointment.recalled == 4, \'md-sposInDay\' : appointment.recalled == 4 && appointment.sposInDay, }\"><md-select ng-disabled=\"appointment.recalled==4 || appointment.closed || ((ap.user.type == \'operator\' || ap.user.type == \'storemngr\') && ap.storeId!=ap.user.store_id)\" ng-model=\"appointment.recalled\" aria-label=\"Ricordato\" id=\"recalled\" name=\"recalled\" ng-change=\"ap.rememberApSelect( appointment.id, \'{{ appointment.recalled }}\', appointment.store_id )\"><md-option ng-if=\"recall_type.value<3 || (recall_type.value == 3 && (appointment.recalled == 3 || ap.disdSpostEnabled)) || (recall_type.value == 4 && (appointment.recalled == 4 || ap.disdSpostEnabled))\" ng-value=\"recall_type.value\" ng-repeat=\"recall_type in ap.recall_types track by recall_type.value\">{{ recall_type.text }}</md-option></md-select></md-input-container></td><td md-cell=\"\" class=\"cell-button\"><md-button class=\"md-raised md-accent\" ng-disabled=\"appointment.recalled>=3 || appointment.closed || ((ap.user.type == \'operator\' || ap.user.type == \'storemngr\') && ap.storeId!=ap.user.store_id)\" ng-click=\"ap.payAp( appointment.id )\" aria-label=\"Appuntamento Pagato\" ng-if=\"appointment.paid\">SI</md-button><md-button class=\"md-raised md-warn\" ng-disabled=\"appointment.recalled>=3 || appointment.closed || ((ap.user.type == \'operator\' || ap.user.type == \'storemngr\') && ap.storeId!=ap.user.store_id)\" ng-click=\"ap.payAp( appointment.id )\" aria-label=\"Appuntamento Non Pagato\" ng-if=\"! appointment.paid\">NO</md-button></td><td md-cell=\"\" class=\"icon-button\"><md-button class=\"md-icon-button md-primary\" aria-label=\"Filtra\" ng-click=\"ap.filterCustomer(appointment.customer.data.phone)\"><md-icon md-font-icon=\"filter_list\">filter_list</md-icon></md-button><md-button style=\"margin-top: 15px; padding: 0px;\" title=\"Link a booking\" class=\"md-icon-button md-primary\" aria-label=\"Prendi appuntamento\" ng-href=\"{{ ap.env.booking }}/operator?tenant={{ (ab.env.tenant==\'Italia\'?(appointment.customer.data.tenant?appointment.customer.data.tenant:ap.env.currentTenant):ap.env.currentTenant) }}&amp;c_sid={{ ap.user.store_id }}&amp;c_role={{ ap.user.type }}&amp;store={{ appointment.store_id }}&amp;customer={{ appointment.customer.data.phone }}&amp;token={{ ap.token }}\" target=\"_self\"><md-icon md-font-icon=\"today\">today</md-icon></md-button><md-button style=\"margin-top: 13px;\" class=\"md-icon-button md-primary\" aria-label=\"Scheda cliente\" ui-sref=\"home.customer( { customer_id : appointment.customer.data.id } )\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button><md-button class=\"md-icon-button md-primary\" aria-label=\"Emetti card amici\" ng-if=\"!appointment.haveCard\" ng-click=\"ap.emettiCardPf(appointment);\"><md-icon title=\"Emetti card amici\" md-font-icon=\"card_giftcard\">card_giftcard</md-icon></md-button><md-button ng-class=\"{ \'md-icon-button md-primary md-accent\': appointment.customer.data.referral_sent_at_days!=null, \'md-icon-button md-primary\': appointment.customer.data.referral_sent_at_days==null }\" aria-label=\"Invia messaggio per invito amici progetto Referral\" ng-click=\"ap.inviaMessaggioReferral(appointment);\" ng-if=\"ap.env.referralEnabled && (!appointment.treatment || !appointment.treatment.data || appointment.treatment.data.f_contab == null || appointment.treatment.data.f_contab == 0)\" ng-disabled=\"ap.sending || appointment.customer.data.referral_sent_at_days!=null && appointment.customer.data.referral_sent_at_days<30\"><md-icon title=\"Invia messaggio per invito amici progetto Referral\" md-font-icon=\"group_add\">group_add</md-icon></md-button><md-button ng-if=\"ap.canDelete\" ng-disabled=\"appointment.closed\" class=\"md-icon-button md-warn\" ng-click=\"ap.delAp( appointment.id )\" aria-label=\"Cancella prenotazione\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button><md-button ng-if=\"appointment.anomalie.data.length==0 || (appointment.anomalie.data[0].type!=\'review.pos\' && appointment.anomalie.data[0].type!=\'review.neg\')\" ng-class=\"appointment.anomalie.data.length==0 ? \'md-icon-button md-primary\': (appointment.anomalie.data[appointment.anomalie.data.length-1].properties.type.match(\'.*fix.*\') ? \'md-icon-button md-primary md-accent\' : (appointment.anomalie.data[0].to_id == ap.user.id ? \'md-icon-button md-primary md-raised md-warn\' : \'md-icon-button md-primary md-warn\'))\" ng-click=\"ap.anomalia( appointment )\" aria-label=\"Inserisci anomalia\"><md-icon md-font-icon=\"bug_report\">bug_report</md-icon></md-button><md-button ng-if=\"appointment.anomalie.data.length>0 && appointment.anomalie.data[0].type==\'review.pos\'\" ng-class=\"\'md-icon-button md-primary md-accent\'\" ng-click=\"ap.anomalia( appointment )\" aria-label=\"Recensione positiva\"><md-icon md-font-icon=\"rate_review\">rate_review</md-icon></md-button><md-button ng-if=\"appointment.anomalie.data.length>0 && appointment.anomalie.data[0].type==\'review.neg\'\" ng-class=\"\'md-icon-button md-primary md-warn\'\" ng-click=\"ap.anomalia( appointment )\" aria-label=\"Recensione negativa\"><md-icon md-font-icon=\"rate_review\">rate_review</md-icon></md-button></td></tr><tr ng-repeat-end=\"\"><td colspan=\"16\" ng-if=\"ap.eStatus.selectedFilterAnom && ap.eStatus.selectedFilterAnom!=\'CN\' && ap.eStatus.selectedFilterAnom!=\'SN\' && appointment.anomalie.data.length>0\"><md-table-container ng-if=\"appointment.anomalie.data.length>0\" style=\"padding-bottom: 15px;\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" colspan=\"2\"><span>Info Anomalia</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"anomalia in appointment.anomalie.data\"><td md-cell=\"\" width=\"20%\">{{ anomalia.properties.type }}</td><td md-cell=\"\">{{ anomalia.description }}</td></tr></tbody></table></md-table-container></td><td colspan=\"16\" ng-if=\"ap.eStatus.selectedFilterAnom && ap.eStatus.selectedFilterAnom==\'CN\'\"><md-table-container style=\"padding-bottom: 15px;\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Nota pre</span></th><th md-column=\"\"><span>Nota post</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" width=\"50%\">{{ appointment.note }}</td><td md-cell=\"\">{{ appointment.note_diagnosi }}</td></tr></tbody></table></md-table-container></td></tr><tr md-row=\"\" ng-show=\"ap.appointmentsList.length > 0\" style=\"background-color: #D9D9D9;\"><td md-cell=\"\" colspan=\"5\" style=\"text-align: right\"><span ng-if=\"ap.showLastname\">Affidabilit&agrave;: {{ap.affidabilita | number:0 }}%</span></td><td md-cell=\"\" colspan=\"1\" ng-if=\"ap.env.shoppingPlusEnabled\"></td><td md-cell=\"\" colspan=\"{{ ap.env.documentsEnabled?5:4 }}\" ng-if=\"!ap.showLastname\"></td><td md-cell=\"\" colspan=\"{{ ap.env.documentsEnabled?5:4 }}\" ng-if=\"ap.showLastname\" style=\"text-align: right\"><strong>Totale {{ap.env.currency?ap.env.currency.label:\'Prezzo\'}}:</strong></td><td md-cell=\"\" colspan=\"{{ ap.eStatus.filter_created_at?4:3 }}\" style=\"text-align: right\"><span ng-if=\"ap.showLastname\">{{ ap.totPrices | number:2 }} {{ ap.env.currency?ap.env.currency.symbol:\'&euro;\' }}</span></td><td md-cell=\"\" colspan=\"{{ ap.showLastname?5:4}}\"></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"! ap.loading\" md-limit=\"ap.appointmentsListPag.per_page\" md-limit-options=\"ap.query.limitOptions\" md-page=\"ap.appointmentsListPag.current_page\" md-total=\"{{ ap.appointmentsListPag.total }}\" md-boundary-links=\"ap.options.boundaryLinks\" md-on-paginate=\"ap.appointmentsListLoad\"></md-table-pagination><h3>Legenda:</h3><md-table-container><table width=\"100%\" border=\"0\" style=\"vertical-align: top;\"><thead><tr><th style=\"text-align: left;\">Icone appuntamento</th><th style=\"text-align: left;\">Icone prenotazione</th><th style=\"text-align: left;\">Icone pagamento</th><th style=\"text-align: left;\">Icone azioni</th></tr></thead><tbody><tr><td><table><tr><td><md-button class=\"md-warn\"><md-icon title=\"Appuntamento scoperto\" md-font-icon=\"warning\">warning</md-icon></md-button></td><td>Appuntamento scoperto</td></tr><tr><td><md-button class=\"md-warn\"><md-icon title=\"Appuntamento overbooking\" md-font-icon=\"grid_off\">grid_off</md-icon></md-button></td><td>Appuntamento overbooking</td></tr><tr><td><md-button class=\"md-warn\"><md-icon title=\"Appuntamento overbooking sistema\" md-font-icon=\"border_clear\">border_clear</md-icon></md-button></td><td>Appuntamento overbooking sistema</td></tr><tr><td><md-button><md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\">autorenew</md-icon></md-button></td><td>Appuntamento con Abbonamento</td></tr><tr><td><md-button><md-icon title=\"Cliente con Garanzia\" md-font-icon=\"verified_user\">verified_user</md-icon></md-button></td><td>Cliente con Garanzia</td></tr><tr><td><md-button><md-icon style=\"color: goldenrod;\">verified_user</md-icon></md-button></td><td>Client Bronze: regalo gi&agrave; consegnato</td></tr><tr><td><md-button><md-icon style=\"color: goldenrod;\">shopping_basket</md-icon></md-button></td><td>Client Bronze: consegnare regalo</td></tr><tr><td><md-button><md-icon style=\"color: silver;\">verified_user</md-icon></md-button></td><td>Client Silver: regalo gi&agrave; consegnato</td></tr><tr><td><md-button><md-icon style=\"color: silver;\">shopping_basket</md-icon></md-button></td><td>Client Silver: consegnare regalo</td></tr><tr><td><md-button><md-icon style=\"color: gold;\">verified_user</md-icon></md-button></td><td>Client Gold: regalo gi&agrave; consegnato</td></tr><tr><td><md-button><md-icon style=\"color: gold;\">shopping_basket</md-icon></md-button></td><td>Client Gold: consegnare regalo</td></tr></table></td><td><table><tr><td><md-button aria-label=\"App. centro\" class=\"md-icon-button\"><md-icon title=\"App. centro\" md-font-icon=\"book\">book</md-icon></md-button></td><td>App. centro</td></tr><tr><td><md-button aria-label=\"App. centro rischedulato\" class=\"md-icon-button\"><md-icon title=\"App. centro rischedulato\" md-font-icon=\"schedule\">schedule</md-icon></md-button></td><td>App. centro rischedulato</td></tr><tr><td><md-button aria-label=\"App. centro da rullo\" class=\"md-icon-button md-warn\"><md-icon title=\"App. centro da rullo\" md-font-icon=\"book\">book</md-icon></md-button></td><td>App. centro da rullo</td></tr><tr><td><md-button aria-label=\"App. centro da lead\" class=\"md-icon-button md-warn\"><md-icon title=\"App. centro da lead\" md-font-icon=\"input\">input</md-icon></md-button></td><td>App. da Lead Centro</td></tr><tr><td><md-button aria-label=\"App. centro da lead o rullo rischedulato\" class=\"md-icon-button md-warn\"><md-icon title=\"Normale\" md-font-icon=\"schedule\">schedule</md-icon></md-button></td><td>App. centro, da lead o rullo, rischedulato</td></tr><tr><td><md-button aria-label=\"App. commerciale da lead\" class=\"md-icon-button md-accent\"><md-icon title=\"App. commerciale da lead\" md-font-icon=\"input\">input</md-icon></md-button></td><td>App. commerciale da Lead</td></tr><tr><td><md-button aria-label=\"App. commerciale da lead\" class=\"md-icon-button md-accent\"><md-icon title=\"App. commerciale CS\" md-font-icon=\"published_with_changes\">published_with_changes</md-icon></md-button></td><td>App. commerciale CS</td></tr><tr><td><md-button aria-label=\"App. commerciale non da lead\" class=\"md-icon-button md-accent\"><md-icon title=\"App. commerciale non da lead\" md-font-icon=\"book\">book</md-icon></md-button></td><td>App. commerciale non da lead</td></tr><tr><td><md-button aria-label=\"App. commerciale rischedulato\" class=\"md-icon-button md-accent\"><md-icon title=\"App. commerciale rischedulato\" md-font-icon=\"schedule\">schedule</md-icon></md-button></td><td>App. commerciale rischedulato</td></tr><tr><td><md-button aria-label=\"Online Booking\" class=\"md-icon-button\"><md-icon title=\"Online Booking\" md-font-icon=\"web\">web</md-icon></md-button></td><td>Online Booking</td></tr><tr><td><md-button aria-label=\"Bot Booking\" class=\"md-icon-button\"><md-icon title=\"Bot Booking\" md-font-icon=\"message\">message</md-icon></md-button></td><td>Bot Booking</td></tr></table></td><td><table><tr><td><md-button aria-label=\"Prezzo cambiato alla prenotazione\" class=\"md-icon-button\"><md-icon title=\"Prezzo cambiato alla prenotazione\" md-font-icon=\"trending_down\">trending_down</md-icon></md-button></td><td>Prezzo cambiato alla prenotazione</td></tr><tr><td><md-button aria-label=\"Presenti rate non pagate\" class=\"md-icon-button\"><md-icon class=\"md-warn md-icon-button\" title=\"Presenti rate non pagate\" md-font-icon=\"warning\">warning</md-icon></md-button></td><td>Presenti rate non pagate</td></tr><tr><td><md-button aria-label=\"Presenti rate pagate in questo appuntamento\" class=\"md-icon-button\"><md-icon class=\"md-icon-button md-accent\" title=\"Presenti rate pagate in questo appuntamento\" md-font-icon=\"warning\">warning</md-icon></md-button></td><td>Una o pi&ugrave; rate pagate in questo appuntamento</td></tr><tr><td><md-button aria-label=\"Modifica appuntamento\" class=\"md-icon-button\"><md-icon class=\"md-primary md-icon-button\" md-font-icon=\"create\" title=\"Modifica appuntamento\">create</md-icon></md-button></td><td>Modifica appuntamento</td></tr><tr><td><md-button aria-label=\"Pagamento pos o card\" class=\"md-icon-button\"><md-icon title=\"Pagamento pos o card\" md-font-icon=\"credit_card\">credit_card</md-icon></md-button></td><td>Pagamento pos/card</td></tr><tr><td><md-button aria-label=\"Pagamento apppago, pagodil, pagoligth o satispay\" class=\"md-icon-button\"><md-icon title=\"Pagamento apppago, pagodil, pagoligth o satispay\" md-font-icon=\"credit_card\" class=\"md-accent\">credit_card</md-icon></md-button></td><td>Pagamento apppago, pagodil, pagoligth o satispay</td></tr><tr><td><md-button aria-label=\"Pagamento misto con pos, apppago, pagodil, pagoligth o satispay\" class=\"md-icon-button\"><md-icon title=\"Pagamento misto con pos, apppago, pagodil, pagoligth o satispay\" md-font-icon=\"credit_card\" class=\"md-warn\">credit_card</md-icon></md-button></td><td>Pagamento misto con pos, apppago, pagodil, pagoligth o satispay</td></tr><tr><td><md-button aria-label=\"Pagamento bonifico o assegno\" class=\"md-icon-button\"><md-icon title=\"Pagamento Bonifico o Assegno\" md-font-icon=\"account_balance\">account_balance</md-icon></md-button></td><td>Pagamento bonifico o assegno</td></tr><tr><td><md-button aria-label=\"Pagamento misto con bonifico/assegno\" class=\"md-icon-button\"><md-icon title=\"Pagamento Misto Bonifico o Assegno\" md-font-icon=\"account_balance\" class=\"md-warn\">account_balance</md-icon></md-button></td><td>Pagamento misto con bonifico/assegno</td></tr><tr><td><md-button aria-label=\"Pagamento con giftcard\" class=\"md-icon-button\"><md-icon title=\"Pagamento con Giftcard\" md-font-icon=\"card_giftcard\">card_giftcard</md-icon></md-button></td><td>Pagamento con giftcard</td></tr><tr><td><md-button aria-label=\"Pagamento misto con giftcard\" class=\"md-icon-button\"><md-icon title=\"Pagamento misto con Giftcard\" md-font-icon=\"card_giftcard\" class=\"md-warn\">card_giftcard</md-icon></md-button></td><td>Pagamento misto con giftcard</td></tr></table></td><td><table><tr><td><md-button class=\"md-icon-button md-primary\" aria-label=\"Filtra\"><md-icon md-font-icon=\"filter_list\">filter_list</md-icon></md-button></td><td>Filtro su cliente</td></tr><tr><td><md-button class=\"md-icon-button md-primary\" aria-label=\"Prendi appuntamento\"><md-icon md-font-icon=\"today\">today</md-icon></md-button></td><td>Link a booking su cliente</td></tr><tr><td><md-button class=\"md-icon-button md-primary\" aria-label=\"Invia messaggio per invito amici progetto Referral\"><md-icon title=\"Invia messaggio per invito amici progetto Referral\" md-font-icon=\"group_add\">group_add</md-icon></md-button></td><td>Invio messaggio per invito amici progetto Referral</td></tr><tr><td><md-button class=\"md-icon-button md-primary\" aria-label=\"Inserisci anomalia\"><md-icon md-font-icon=\"bug_report\">bug_report</md-icon></md-button></td><td>Inserimento anomalia</td></tr><tr><td><md-button class=\"md-icon-button md-primary md-warn\" aria-label=\"Presente anomalia\"><md-icon md-font-icon=\"bug_report\">bug_report</md-icon></md-button></td><td>Presente anomalia</td></tr><tr><td><md-button class=\"md-icon-button md-primary md-accent\" aria-label=\"Anomalia risolta\"><md-icon md-font-icon=\"bug_report\">bug_report</md-icon></md-button></td><td>Anomalia risolta</td></tr><tr><td><md-button class=\"md-icon-button md-primary md-accent\" aria-label=\"Recensione positiva\"><md-icon md-font-icon=\"rate_review\">rate_review</md-icon></md-button></td><td>Recensione positiva</td></tr><tr><td><md-button class=\"md-icon-button md-primary md-warn\" aria-label=\"Recensione negativa\"><md-icon md-font-icon=\"rate_review\">rate_review</md-icon></md-button></td><td>Recensione negativa</td></tr><tr><td><md-button class=\"md-icon-button md-primary\" aria-label=\"Invio messaggio referral\"><md-icon md-font-icon=\"group_add\">group_add</md-icon></md-button></td><td>Invio messaggio referral</td></tr><tr><td><md-button class=\"md-icon-button md-primary md-accent\" aria-label=\"Messaggio referral inviato\"><md-icon md-font-icon=\"group_add\">group_add</md-icon></md-button></td><td>Messaggio referral inviato</td></tr></table></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-appointments md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"book\">book</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"! ap.isNewAppointment && ap.updatingField == null\">Modifica appuntamento per {{ ap.activeAppointment.customer.data.firstname ? ap.activeAppointment.customer.data.firstname + \" (aid:\" + ap.activeAppointment.id + \" cid:\" + ap.activeAppointment.customer.data.id + \")\" : \'questo utente\' }}</span> <span class=\"inset\" ng-if=\"! ap.isNewAppointment && ap.updatingField == \'price\'\">Modifica {{ap.env.currency?ap.env.currency.label.toLowerCase():\'prezzo\'}} per {{ ap.activeAppointment.customer.data.firstname ? ap.activeAppointment.customer.data.firstname + \" (aid:\" + ap.activeAppointment.id + \" cid:\" + ap.activeAppointment.customer.data.id + \")\" : \'questo utente\' }}</span> <span class=\"inset\" ng-if=\"ap.isNewAppointment\">Crea appuntamento</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ap.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"appointmentForm\" id=\"appointmentForm\" layout=\"column\"><div flex=\"100\" layout=\"column\" class=\"fix-margins-3 min-height-60\" ng-if=\"ap.updatingField != \'price\'\"><label class=\"md-label\" for=\"treatmentdate\">Data del trattamento</label><md-datepicker class=\"md-datepicker-full-width md-datepicker-remove-red-border\" id=\"treatmentdate\" name=\"treatmentdate\" md-placeholder=\"Data del trattamento\" md-min-date=\"ap.minday\" ng-model=\"ap.treatmentdate\" ng-change=\"ap.resetAvailabilities()\" required=\"\"></md-datepicker></div><br ng-if=\"ap.updatingField != \'price\'\"><div ng-if=\"! appointmentForm.treatmentdate.$error.mindate && ap.updatingField != \'price\'\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"{{ ap.portaEnabled?\'70\':\'100\'}}\"><label for=\"user_id\">Operatrice</label><md-select ng-model=\"ap.activeAppointment.user_id\" aria-label=\"Operatrice\" id=\"user_id\" name=\"user_id\" ng-change=\"ap.resetAvailabilities()\" required=\"\"><md-option ng-value=\"user.user_id\" ng-repeat=\"user in ap.userRolesList track by user.id\"><div class=\"operator-circle\" style=\"background-color: {{ user.color }};\"></div>{{ user.user.firstname }} {{ user.user.lastname }}</md-option></md-select><div ng-messages=\"appointmentForm.user_id.$error\" ng-if=\"appointmentForm.user_id.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><span ng-if=\"ap.portaEnabled\" flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"30\" ng-if=\"ap.portaEnabled\"><md-checkbox ng-model=\"ap.activeAppointment.f_over\" aria-label=\"Porta\" id=\"f_over\" name=\"f_over\">Porta</md-checkbox></md-input-container></div></div><div><md-input-container class=\"md-block\"><label for=\"id_servizio\">Trattamento</label><md-select ng-model=\"ap.activeAppointment.treatment_id\" aria-label=\"Trattamento\" id=\"id_servizio\" name=\"id_servizio\" ng-change=\"ap.activeTreatmentChange()\" ng-disabled=\"!ap.isNewAppointment && !ap.activeAppointment.treatmentCanChange\" md-container-class=\"with-search\" required=\"\"><md-select-header ng-if=\"ap.isNewAppointment || (ap.user.type==\'admin\' && ap.activeAppointment.treatmentCanChange)\"><span class=\"md-select-search-container\"><input type=\"search\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_treatment\" name=\"filter_treatment\" ng-model=\"ap.query.filter_treatment\" ng-keyup=\"ap.onKeyUpTreatmentsSearch($event, this)\" ng-keydown=\"$event.stopPropagation()\" ng-click=\"$event.stopPropagation()\"></span></md-select-header><md-optgroup ng-if=\"ap.isNewAppointment || ap.user.type==\'admin\'\" label=\"{{ group.name }}\" ng-repeat=\"group in ap.treatmentsList track by group.id\"><md-option ng-value=\"treatment.id\" ng-repeat=\"treatment in group.treatments.data | filter: ap.query.filter_treatment | filter: {\'active\': 1, \'promo\': 0} : true | orderBy: [\'order\',\'name\',\'f_first_time\']\">{{ treatment.name }} {{treatment.f_first_time == 1 ? \'(1a volta)\':\'\'}}</md-option></md-optgroup><md-option ng-if=\"!ap.isNewAppointment && !ap.activeAppointment.treatmentCanChange\" ng-value=\"ap.activeAppointment.treatment_id\">{{ ap.activeAppointment.treatment_id | treatmentIdtoName : ap.treatmentsList }}</md-option><md-option ng-if=\"!ap.isNewAppointment && ap.activeAppointment && ap.activeAppointment.treatmentCanChange && ap.user.type!=\'admin\'\" ng-value=\"treatment.id\" ng-repeat=\"treatment in ap.laserTreatmentsList | orderBy: \'name\'\">{{ treatment.name }}</md-option></md-select><div ng-messages=\"appointmentForm.id_servizio.$error\" ng-if=\"appointmentForm.id_servizio.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><div ng-if=\"ap.activeAppointment.treatment_id == 99 && ap.activeAppointment.type_app != \'free\'\" layout=\"row\"><b>Ricordarsi di emettere lo scontrino!</b></div><div ng-if=\"ap.activeAppointment.treatment_id == 99\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"20\"><label for=\"card_area\">Area *</label> <input ng-disabled=\"ap.activeAppointment.id\" type=\"text\" id=\"card_area\" placeholder=\"Area\" ng-model=\"ap.card.area\"></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"20\"><label for=\"card_taglio\">Taglio</label><md-select ng-model=\"ap.card.value\" aria-label=\"Taglio\" id=\"card_taglio\" name=\"card_taglio\" ng-change=\"ap.card.setValue()\" ng-disabled=\"ap.activeAppointment.id\" required=\"\"><md-option ng-value=\"\'025\'\">025</md-option><md-option ng-value=\"\'050\'\">050</md-option><md-option ng-value=\"\'100\'\">100</md-option><md-option ng-value=\"\'150\'\">150</md-option><md-option ng-value=\"\'200\'\">200</md-option><md-option ng-value=\"\'250\'\">250</md-option><md-option ng-value=\"\'300\'\">300</md-option><md-option ng-value=\"\'350\'\">350</md-option><md-option ng-value=\"\'400\'\">400</md-option><md-option ng-value=\"\'450\'\">450</md-option><md-option ng-value=\"\'500\'\">500</md-option></md-select><div ng-messages=\"appointmentForm.card_taglio.$error\" ng-if=\"appointmentForm.card_taglio.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"45\"><label for=\"availability\">Ultime 6 cifre Giftcard</label><md-select aria-label=\"Numero\" id=\"card_number\" name=\"card_number\" ng-model=\"ap.activeAppointment.gift_number\" ng-disabled=\"ap.activeAppointment.id || ap.card.loading || !ap.card.value\" md-container-class=\"with-search\" required=\"\"><md-select-header ng-if=\"!ap.activeAppointment.id\"><span class=\"md-select-search-container\"><input type=\"{{ ap.card.loading? \'hidden\' : \'search\' }}\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_card_number\" name=\"filter_card_number\" ng-keydown=\"$event.stopPropagation()\" ng-click=\"$event.stopPropagation()\" ng-keyup=\"ap.card.onKeyUpSearch($event, this)\" ng-model=\"ap.card.filter_number\"></span></md-select-header><md-option ng-if=\"!ap.activeAppointment.id\" ng-value=\"card.number\" ng-repeat=\"card in ap.card.list | orderBy: number\">{{ card.number.substring(5,11) }} <span ng-if=\"card.f_free\">(Omaggio)</span></md-option><md-option ng-if=\"ap.activeAppointment.id\" ng-value=\"ap.activeAppointment.gift_number\">{{ ap.activeAppointment.gift_number.substring(5,11) }}</md-option></md-select><div ng-messages=\"appointmentForm.card_number.$error\" ng-if=\"appointmentForm.card_number.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-progress-circular md-diameter=\"25\" ng-if=\"ap.card.loading\" md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"ap.updatingField != \'price\' && !ap.activeAppointment.f_over\"><div ng-if=\"appointmentForm.treatmentdate.$error.mindate\"><p>Per cambiare la disponibilità è necessario controllare la data del Trattamento.</p></div><md-input-container class=\"md-block\" ng-if=\"! appointmentForm.treatmentdate.$error.mindate\"><label for=\"availability\">Disponibilità</label><md-select aria-label=\"Cambia la Disponibilità\" id=\"availability\" name=\"availability\" md-on-open=\"ap.availabilityLoad()\" ng-model=\"ap.selectedAvaibility\" ng-required=\"ap.selectedAvaibilityRequired\"><md-option ng-value=\"$index\" ng-repeat=\"availability in ap.availabilitiesList track by $index\"><span>dalle</span> <strong>{{ availability.date_start | splitTimeFilter | limitTo:5 }}</strong> <span>alle</span> <strong>{{ availability.date_end | splitTimeFilter | limitTo:5 }}</strong></md-option></md-select><div ng-messages=\"appointmentForm.availability.$error\" ng-if=\"appointmentForm.availability.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container></div><div layout=\"row\" ng-if=\"ap.updatingField != \'price\' && ap.activeAppointment.f_over\"><md-input-container flex=\"50\" class=\"md-block\"><label for=\"startTime\">Inizio</label> <input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"startTime\" short-time=\"false\" placeholder=\"Inizio\" format=\"HH:mm\" ng-model=\"ap.activeAppointment.start\" ng-change=\"ap.activeStartChange()\"></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container flex=\"50\" class=\"md-block\"><label for=\"endTime\">Fine</label> <input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" ng-disabled=\"true\" type=\"text\" id=\"endTime\" short-time=\"false\" placeholder=\"Fine\" format=\"HH:mm\" ng-model=\"ap.activeAppointment.end\"></md-input-container></div><div ng-if=\"ap.isNewAppointment\" layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"availability\">Cliente</label><md-select aria-label=\"Cliente\" id=\"customer_id\" name=\"customer_id\" ng-model=\"ap.customer_id\" ng-change=\"ap.checkSubscriptionByUser(ap.customer_id)\" ng-model-options=\"ap.filter.options\" ng-disabled=\"ap.customersLoading\" md-container-class=\"with-search\" required=\"\"><md-select-header><span class=\"md-select-search-container\"><input type=\"{{ ap.customersLoading? \'hidden\' : \'search\' }}\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_customer\" name=\"filter_customer\" ng-keydown=\"$event.stopPropagation()\" ng-click=\"$event.stopPropagation()\" ng-keyup=\"ap.onKeyUpCustomersSearch($event, this)\" ng-model=\"ap.query.filter_customer\"></span></md-select-header><md-option ng-value=\"customer.id\" ng-repeat=\"customer in ap.customersList | orderBy: fullName track by customer.id\">{{ customer.fullName }} [{{customer.phone}}]</md-option></md-select><div ng-messages=\"appointmentForm.availability.$error\" ng-if=\"appointmentForm.availability.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-progress-circular md-diameter=\"30\" ng-if=\"ap.customersLoading\" md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\"><md-input-container ng-if=\"!ap.storno && ap.treatment.f_abb\" class=\"md-block\" flex=\"50\" style=\"margin: 0px;\"><md-checkbox aria-label=\"Abbonamento\" id=\"type\" name=\"type\" ng-change=\"ap.appointmentTypeChange()\" ng-model=\"ap.activeAppointment.type\" ng-true-value=\"\'abb\'\" ng-false-value=\"null\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\">Abbonamento</md-checkbox></md-input-container><md-input-container ng-if=\"!ap.storno\" class=\"md-block\" flex=\"50\" style=\"margin-top: 0px;\"><label for=\"type\">Tipologia</label><md-select aria-label=\"Tipologia\" id=\"type_app\" name=\"type_app\" ng-change=\"ap.appointmentTypeAppChange()\" ng-model=\"ap.activeAppointment.type_app\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-option ng-value=\"typology.value\" ng-repeat=\"typology in ap.appointmentTypologies\">{{typology.label}}</md-option></md-select></md-input-container></div><div layout=\"row\" style=\"margin: 0px;\" ng-if=\"ap.activeAppointment.type == \'abb\'\"><md-input-container class=\"md-block\" flex=\"50\" ng-if=\"ap.subscriptionsListByCustomer.length > 0\"><label for=\"customer_subscription_id\">Abbonamenti selezionabili</label><md-select ng-model=\"ap.activeAppointment.customer_subscription_id\" aria-label=\"Abbonamenti Attivi\" id=\"customer_subscription_id\" name=\"customer_subscription_id\" ng-change=\"ap.customerSubscriptionIdChange()\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-option ng-value=\"customerSubscription.id\" ng-repeat=\"customerSubscription in ap.subscriptionsListByCustomer\">{{ customerSubscription.subscription.data.name }} ( {{ customerSubscription.app_total-customerSubscription.app_remaining }} eseguit{{customerSubscription.app_total-customerSubscription.app_remaining==1?\'a\':\'e\'}}/prenotat{{customerSubscription.app_total-customerSubscription.app_remaining==1?\'a\':\'e\'}} ) [id:{{customerSubscription.id}}]</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\" ng-if=\"ap.subscriptionsListByCustomer.length <= 0\"><span class=\"color-grey\">Nessun Abbonamento attivo</span></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label for=\"id_servizio\">Nuovo Abbonamento</label><md-select ng-model=\"ap.activeAppointment.subscription_new_id\" aria-label=\"Nuovo Abbonamento\" id=\"subscription_new_id\" name=\"subscription_new_id\" ng-change=\"ap.subscriptionNewIdChange()\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-option ng-value=\"subscriptionNew.id\" ng-repeat=\"subscriptionNew in ap.subscriptionsListFiltered | filter: {active: 1}: true | orderBy: \'name\'\">{{ subscriptionNew.name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"ap.activeAppointment.type == \'abb\' && ap.activeAppointment.subscription_new_id && ap.activeAppointment.customer_subscription_id\"><md-checkbox flex=\"25\" ng-true-value=\"1\" ng-false-value=\"0\" ng-change=\"ap.removeNewSubscriptionId()\" ng-model=\"ap.activeAppointment.union\">Unisci abbonamenti</md-checkbox><md-input-container class=\"md-block\" flex=\"25\" style=\"margin-bottom:0px; margin-top: 25px\" ng-if=\"ap.activeAppointment.union\"><label for=\"price_full\">Sedute residue</label> <input type=\"number\" name=\"new_subscription_app_remaining\" id=\"new_subscription_app_remaining\" step=\"1\" ng-model=\"ap.activeAppointment.new_subscription_app_remaining\" ng-model-options=\"ap.filter.options\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\" ng-if=\"ap.activeAppointment.union\"><label for=\"new_subscription_id\">Nome nuovo Abbonamento</label><md-select ng-model=\"ap.activeAppointment.new_subscription_id\" aria-label=\"Nome nuovo Abbonamento\" id=\"new_subscription_id\" name=\"new_subscription_id\" ng-change=\"ap.newSubscriptionIdChange()\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" required=\"\"><md-option ng-value=\"subscriptionNew.id\" ng-repeat=\"subscriptionNew in ap.subscriptionsListFiltered | filter: {active: 1}: true | orderBy: \'name\'\">{{ subscriptionNew.name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\" style=\"margin-bottom: 0px;\"><md-checkbox ng-if=\"ap.activeAppointment.type == \'abb\'\" flex=\"50\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-change=\"ap.fExcludeChange()\" ng-model=\"ap.activeAppointment.f_exclude\">Escludi seduta da abbonamento</md-checkbox><md-checkbox ng-if=\"ap.activeAppointment.type == \'abb\'\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"!ap.maxRate || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-change=\"ap.fExcludeChange()\" ng-model=\"ap.activeAppointment.f_abb_payall\">Pagamento non rateizzato</md-checkbox></div><div ng-if=\"ap.refEnabled\" layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"50\" style=\"margin-bottom: 0px;\" ng-if=\"!ap.storno\"><label for=\"price_treatment\">{{ap.env.currency?ap.env.currency.label:\'Prezzo trattamento (in &euro;)\'}}</label> <input type=\"number\" name=\"price_treatment\" id=\"price_treatment\" step=\"0.01\" min=\"0\" ng-disabled=\"!ap.canEdit.price_treatment\" ng-model=\"ap.activeAppointment.price_treatment\" ng-model-options=\"ap.filter.options\" required=\"\" ng-blur=\"ap.paymentPosUpdate()\"><div ng-messages=\"appointmentForm.price_treatment.$error\" ng-show=\"appointmentForm.price_treatment.$dirty\"><div ng-message=\"notzero\">Il prezzo non pu&ograve; essere zero per trattamenti non groupon e non in abbonamento</div><div ng-message=\"infcompresi\">Il prezzo non pu&ograve; essere inferiore al valore dei prodotti compresi: {{ ap.activeAppointment.product_price_in + ap.activeAppointment.product_price10_in | number:2 }}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\" ng-if=\"!ap.storno && ap.activeAppointment.treatment_name.endsWith(\' GP\')\" style=\"margin-bottom: 0px;\"><label ng-disabled=\"!ap.activeAppointment.treatment_name.endsWith(\' GP\')\" for=\"coupon_price\">{{ap.env.currency?ap.env.currency.label + \' coupon\':\'Coupon (&euro;)\'}}</label> <input ng-disabled=\"!ap.activeAppointment.treatment_name.endsWith(\' GP\')\" type=\"number\" name=\"coupon_price\" id=\"coupon_price\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.coupon_price\" ng-model-options=\"ap.filter.options\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"ap.treatment.f_prod && !ap.isNewAppointment && !ap.storno && (ap.activeAppointment.product_price_in>0 || ap.activeAppointment.product_price10_in>0)\"><md-input-container class=\"md-block\" flex=\"45\" style=\"margin-bottom:0px; margin-top:0px;\"><label for=\"product_price\">{{ap.env.currency?ap.env.currency.label + \' prodotti compresi\':\'Prodotti compresi (iva 22%)\'}}</label> <input type=\"number\" name=\"product_price_in\" id=\"product_price_in\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.product_price_in\" ng-model-options=\"ap.filter.options\" ng-disabled=\"\'true\'\"></md-input-container><md-button style=\"margin-left: 10px; margin-bottom: 30px;\" ng-class=\"\'md-raised md-icon-button md-primary\'\" aria-label=\"Prodotti\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-click=\"ap.manageProducts( ap.activeAppointment )\"><md-icon md-font-icon=\"shopping_cart\">shopping_cart</md-icon></md-button><md-input-container class=\"md-block\" flex=\"45\"><label for=\"product_price10\">{{ap.env.currency?ap.env.currency.label + \' prodotti compresi\':\'Prodotti compresi (iva 10%)\'}}</label> <input type=\"number\" name=\"product_price10_in\" id=\"product_price10_in\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.product_price10_in\" ng-model-options=\"ap.filter.options\" ng-disabled=\"\'true\'\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"ap.treatment.f_prod && !ap.isNewAppointment && !ap.storno\"><md-input-container class=\"md-block\" flex=\"45\" style=\"margin-bottom:0px; margin-top:0px;\"><label for=\"product_price\">{{ap.env.currency?ap.env.currency.label + \' prodotti venduti\':\'Prodotti venduti (iva 22%)\'}}</label> <input type=\"number\" name=\"product_price\" id=\"product_price\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.product_price\" ng-model-options=\"ap.filter.options\" ng-disabled=\"\'true\'\"></md-input-container><md-button style=\"margin-left: 10px; margin-bottom: 30px;\" ng-class=\"\'md-raised md-icon-button md-primary\'\" aria-label=\"Prodotti\" ng-click=\"ap.manageProducts( ap.activeAppointment )\"><md-icon md-font-icon=\"shopping_cart\">shopping_cart</md-icon></md-button><md-input-container class=\"md-block\" flex=\"45\"><label for=\"product_price10\">{{ap.env.currency?ap.env.currency.label + \' prodotti venduti\':\'Prodotti venduti (iva 10%)\'}}</label> <input type=\"number\" name=\"product_price10\" id=\"product_price10\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.product_price10\" ng-model-options=\"ap.filter.options\" ng-disabled=\"\'true\'\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:0px;\"><md-input-container class=\"md-block\" flex=\"50\" style=\"margin-bottom:0px; margin-top:0px;\" ng-if=\"ap.treatment.f_prod\"><label for=\"price_full\">{{ap.env.currency?ap.env.currency.label:\'Prezzo totale (in &euro;)\'}}</label> <input type=\"number\" name=\"price_full\" id=\"price_full\" step=\"0.01\" ng-model=\"ap.activeAppointment.price_full\" ng-model-options=\"ap.filter.options\" ng-disabled=\"\'true\'\" required=\"\" ng-change=\"ap.paymentPosUpdate()\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\" style=\"margin-bottom:0px; margin-top:0px;\" ng-if=\"ap.treatment.f_discount\"><label for=\"price_discounted\">{{ap.env.currency?ap.env.currency.label + \" con sconto\" :(ap.storno?\'Importo rimborso (in &euro;)\':\'Prezzo scontato (in &euro;)\')}}</label> <input type=\"number\" name=\"price_discounted\" id=\"price_discounted\" step=\"0.01\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model=\"ap.activeAppointment.price_discounted\" required=\"\" ng-change=\"ap.priceDiscountedCheck()\"><div ng-messages=\"appointmentForm.price_discounted.$error\" ng-show=\"appointmentForm.price_discounted.$dirty\"><div ng-message=\"overdiscount\">Lo sconto non pu&ograve; essere maggiore del {{ ap.maxDiscount }}%, quindi il prezzo minimo &egrave; {{ (ap.activeAppointment.price_full*(100-ap.maxDiscount)/100) - (ap.activeAppointment.tri?ap.activeAppointment.tri:0) | number: 2 }}&euro;</div></div></md-input-container></div><div ng-if=\"(ap.activeAppointment.customer.data.payments && ap.activeAppointment.customer.data.payments.data && ap.activeAppointment.customer.data.payments.data.length>0) || (ap.activeAppointment.payments && ap.activeAppointment.payments.data && ap.activeAppointment.payments.data.length>0)\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Rate in scadenziario</th><th md-column=\"\" style=\"text-align: right;\">Scadenza</th><th md-column=\"\" style=\"text-align: right;\">Importo</th><th md-column=\"\" style=\"text-align: right;\">N.</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"p in payments = ap.activeAppointment.customer.data.payments.data.concat(ap.activeAppointment.payments.data) | orderBy: \'date\'\"><td md-cell=\"\"><md-checkbox style=\"margin-left: 10px;\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model=\"p.selected\" ng-change=\"ap.rataSelectionChange(p)\"></md-checkbox></td><td md-cell=\"\" style=\"text-align: right;\">{{ p.month }}/{{ p.year }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ p.total }}&euro;</td><td md-cell=\"\" style=\"text-align: right;\">{{ p.num }}/{{ p.num_total }}</td></tr></tbody></table></md-table-container></div><md-input-container ng-show=\"true || !ap.storno && ( ap.activeAppointment.price_discounted>=ap.sogliaRateizzazione || (ap.activeAppointment.customer.data.payments && ap.activeAppointment.customer.data.payments.data && ap.activeAppointment.customer.data.payments.data.length>0) || (ap.activeAppointment.payments && ap.activeAppointment.payments.data && ap.activeAppointment.payments.data.length>0) )\" class=\"md-block\" flex=\"50\" style=\"margin-bottom:0px;\"><label for=\"price\">{{ap.env.currency?ap.env.currency.label +\' acconto\':\'Totale pagato (in &euro;)\'}}</label> <input type=\"number\" name=\"price\" id=\"price\" step=\"0.01\" ng-model=\"ap.activeAppointment.price\" required=\"\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3 || ap.activeAppointment.price_discounted<ap.sogliaRateizzazione || ap.activeAppointment.f_abb_payall || ap.activeAppointment.type!=\'abb\'\" ng-change=\"ap.priceCheck()\"><div ng-messages=\"appointmentForm.price.$error\" ng-show=\"appointmentForm.price.$dirty\"><div ng-message=\"lowerpayment\">Il totale pagato non pu&ograve; essere inferiore a <span ng-bind-html=\"ap.messageLowerPayment\"></span></div></div></md-input-container><div layout=\"row\" layout-align=\"start center\" ng-if=\"ap.activeAppointment.haveCard && ap.activeAppointment.totalcredit>0\"><md-input-container class=\"md-block\" flex=\"50\"><label for=\"credit\">Saldo punti</label> <input type=\"number\" name=\"customer_credit\" id=\"customer_credit\" ng-model=\"ap.activeAppointment.customer.data.credit\" ng-disabled=\"true\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label for=\"credit_usage\">Sconti disponibili</label><md-select style=\"margin-bottom: 20px;\" ng-model=\"ap.activeAppointment.credit_usage\" aria-label=\"Punti da usare\" id=\"credit_usage\" name=\"credit_usage\" ng-change=\"ap.paymentPosUpdate()\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-option ng-value=\"undefined\"></md-option><md-option ng-value=\"sconto\" ng-repeat=\"sconto in ap.sconti track by sconto.sconto\" ng-show=\"ap.activeAppointment.totalcredit>=sconto.credit && ap.activeAppointment.price_full>=sconto.limit\">{{sconto.credit}}pt. sconto {{sconto.sconto}}&euro; su spesa &gt;{{sconto.limit}}&euro;</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"false && ap.activeAppointment.haveCard && ap.activeAppointment.totalcredit>0\"><md-input-container class=\"md-block\" flex=\"50\"><label for=\"credit\">Sconto (in &euro;)</label> <input type=\"number\" name=\"discount\" id=\"discount\" ng-model=\"ap.activeAppointment.discount\" ng-disabled=\"true\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label for=\"price\">Totale scontato (in &euro;)</label> <input type=\"number\" name=\"price\" id=\"price\" step=\"0.01\" ng-model=\"ap.activeAppointment.price\" ng-model-options=\"ap.filter.options\" required=\"\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" ng-if=\"!ap.env.currency || ap.env.currency.pos\"><div flex=\"45\"><style>\n                            #payment_type md-radio-button {\n                                margin-bottom: 45px;\n                            }\n                        </style><md-input-container class=\"md-block\"><md-radio-group id=\"payment_type\" name=\"payment_type\" ng-change=\"ap.paymentPosUpdate()\" ng-required=\"true\" ng-model=\"ap.activeAppointment.payment_type\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-radio-button value=\"C\">Contanti</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref || ap.activeAppointment.type_app==\'app\'\" value=\"P\" ng-if=\"!ap.storno\">Pos/Carta/App</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref || ap.activeAppointment.type_app==\'app\'\" value=\"D\" ng-if=\"ap.env.company == \'Folto\' || ap.storno || !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\' || ap.activeAppointment.treatment_id >= 91 && ap.activeAppointment.treatment_id <= 93 || ap.activeAppointment.treatment_id >= 191 && ap.activeAppointment.treatment_id <= 193\">Pagodil</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref || ap.activeAppointment.type_app==\'app\'\" value=\"E\" ng-if=\"ap.env.company == \'Folto\' || ap.storno || !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\' || ap.activeAppointment.treatment_id >= 91 && ap.activeAppointment.treatment_id <= 93 || ap.activeAppointment.treatment_id >= 191 && ap.activeAppointment.treatment_id <= 193\">App Pago</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref || ap.activeAppointment.type_app==\'app\'\" value=\"L\" ng-if=\"ap.env.company == \'Folto\' || ap.storno || !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\' || ap.activeAppointment.treatment_id >= 91 && ap.activeAppointment.treatment_id <= 93 || ap.activeAppointment.treatment_id >= 191 && ap.activeAppointment.treatment_id <= 193\">PagoLight</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref || ap.activeAppointment.type_app==\'app\'\" value=\"S\" ng-if=\"ap.env.smallpayEnabled && !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\'\">Smallpay</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref || ap.activeAppointment.type_app==\'app\' || !ap.paymentBonEnabled\" value=\"B\">Bonifico</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref || ap.activeAppointment.type_app==\'app\'\" value=\"A\">Assegno</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref || ap.activeAppointment.type_app==\'app\'\" value=\"T\" ng-if=\"ap.env.satispayEnabled\">Satispay</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref || ap.activeAppointment.type_app==\'app\'\" value=\"I\" ng-if=\"ap.env.stripeEnabled && ap.activeAppointment.paidappointments && ap.activeAppointment.paidappointments.data && ap.activeAppointment.paidappointments.data.length>0\">Stripe</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref || ap.activeAppointment.type_app==\'app\'\" value=\"M\" ng-if=\"!ap.storno\">Misto</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref || ap.activeAppointment.type_app==\'app\'\" value=\"G\" ng-if=\"!ap.storno\">Giftcard</md-radio-button></md-radio-group></md-input-container></div><div flex=\"50\" class=\"payment-section\"><md-input-container class=\"md-block\"><label style=\"font-weight: bold; color: #ff5000;\">Contanti (in &euro;):</label> <input type=\"number\" name=\"payment_cash\" id=\"payment_cash\" step=\"0.01\" ng-value=\"(ap.activeAppointment.price - ap.activeAppointment.payment_pos - ap.activeAppointment.payment_card - ap.activeAppointment.payment_app - ap.activeAppointment.payment_dil - ap.activeAppointment.payment_apppago - ap.activeAppointment.payment_light - ap.activeAppointment.payment_small - ap.activeAppointment.payment_satis - ap.activeAppointment.payment_stripe - ap.activeAppointment.payment_gift - ap.activeAppointment.payment_bon - ap.activeAppointment.payment_check).toFixed(2)\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"!ap.storno\"><label for=\"payment_pos\" style=\"font-weight: bold; color: #ff5000;\">Importo POS (in &euro;)</label> <input type=\"number\" name=\"payment_pos\" id=\"payment_pos\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.payment_pos\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"ap.activeAppointment.payment_type == \'M\' && !ap.storno\"><label for=\"payment_card\" style=\"font-weight: bold; color: #ff5000;\">Importo Carta (in &euro;)</label> <input type=\"number\" name=\"payment_card\" id=\"payment_card\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.payment_card\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"!ap.storno && ap.activeAppointment.payment_type == \'P\'\"><label for=\"payment_dil\" style=\"font-weight: bold; color: #ff5000;\">Tipo Pagamento</label><md-select style=\"margin-bottom: 20px;\" ng-model=\"ap.activeAppointment.payment_pos_type\" id=\"payment_pos_type\" name=\"payment_pos_type\" ng-required=\"ap.activeAppointment.payment_type == \'P\'\"><md-option ng-value=\"\'P\'\">Pos</md-option><md-option ng-value=\"\'C\'\">Carta</md-option><md-option ng-value=\"\'A\'\">App</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"ap.env.company == \'Folto\' || ap.storno || !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\'\"><label for=\"payment_dil\" style=\"font-weight: bold; color: #ff5000;\">Importo Pagodil (in &euro;)</label> <input type=\"number\" name=\"payment_dil\" id=\"payment_dil\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_dil\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3 || ap.activeAppointment.payment_light || ap.activeAppointment.installments_light || ap.activeAppointment.payment_apppago || ap.activeAppointment.installments_apppago\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"(ap.env.company == \'Folto\' || ap.storno || !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\') && (ap.activeAppointment.payment_type == \'D\' || ap.activeAppointment.payment_type == \'M\')\"><label for=\"installments_dil\" style=\"font-weight: bold; color: #ff5000;\">Rate Pagodil</label><md-select style=\"margin-bottom: 20px;\" ng-model=\"ap.activeAppointment.installments_dil\" id=\"installments_dil\" name=\"installments_dil\" ng-change=\"ap.paymentPosUpdate()\" ng-disabled=\"ap.activeAppointment.payment_light || ap.activeAppointment.installments_light || ap.activeAppointment.payment_apppago || ap.activeAppointment.installments_apppago\" ng-required=\"ap.activeAppointment.payment_type == \'D\' || (ap.activeAppointment.payment_type == \'M\' && ap.activeAppointment.payment_dil > 0)\"><md-option ng-value=\"n\" ng-repeat=\"n in ap.n_installments_pagodil\">{{ n }}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"ap.env.company == \'Folto\' || ap.storno || !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\'\"><label for=\"payment_apppago\" style=\"font-weight: bold; color: #ff5000;\">Importo App Pago (in &euro;)</label> <input type=\"number\" name=\"payment_apppago\" id=\"payment_apppago\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_apppago\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3 || ap.activeAppointment.payment_dil || ap.activeAppointment.installments_dil || ap.activeAppointment.payment_light || ap.activeAppointment.installments_light\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"(ap.env.company == \'Folto\' || ap.storno || !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\') && (ap.activeAppointment.payment_type == \'E\' || ap.activeAppointment.payment_type == \'M\')\"><label for=\"payment_dil\" style=\"font-weight: bold; color: #ff5000;\">Rate App Pago</label><md-select style=\"margin-bottom: 20px;\" ng-model=\"ap.activeAppointment.installments_apppago\" id=\"installments_apppago\" name=\"installments_apppago\" ng-change=\"ap.paymentPosUpdate()\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3 || ap.activeAppointment.payment_dil || ap.activeAppointment.installments_dil || ap.activeAppointment.payment_light || ap.activeAppointment.installments_light\" ng-required=\"ap.activeAppointment.payment_type == \'E\' || (ap.activeAppointment.payment_type == \'M\' && ap.activeAppointment.payment_apppago > 0)\"><md-option ng-value=\"n\" ng-repeat=\"n in ap.n_installments_apppago\">{{ n }}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"ap.env.company == \'Folto\' || ap.storno || !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\'\"><label for=\"payment_light\" style=\"font-weight: bold; color: #ff5000;\">Importo PagoLight (in &euro;)</label> <input type=\"number\" name=\"payment_light\" id=\"payment_light\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_light\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3 || ap.activeAppointment.payment_dil || ap.activeAppointment.installments_dil || ap.activeAppointment.payment_apppago || ap.activeAppointment.installments_apppago\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"(ap.env.company == \'Folto\' || ap.storno || !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\') && (ap.activeAppointment.payment_type == \'L\' || ap.activeAppointment.payment_type == \'M\')\"><label for=\"installments_light\" style=\"font-weight: bold; color: #ff5000;\">Rate PagoLight</label><md-select style=\"margin-bottom: 20px;\" ng-model=\"ap.activeAppointment.installments_light\" id=\"installments_light\" name=\"installments_light\" ng-change=\"ap.paymentPosUpdate()\" ng-disabled=\"ap.activeAppointment.payment_dil || ap.activeAppointment.installments_dil || ap.activeAppointment.payment_apppago || ap.activeAppointment.installments_apppago\" ng-required=\"ap.activeAppointment.payment_type == \'L\' || (ap.activeAppointment.payment_type == \'M\' && ap.activeAppointment.payment_light > 0)\"><md-option ng-value=\"n\" ng-repeat=\"n in ap.n_installments_light\">{{ n }}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"ap.env.smallpayEnabled && !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\'\"><label for=\"payment_small\" style=\"font-weight: bold; color: #ff5000;\">Importo Smallpay (in &euro;)</label> <input type=\"number\" name=\"payment_small\" id=\"payment_small\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_small\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" style=\"margin-bottom: 0px;\"><label for=\"payment_bon\" style=\"font-weight: bold; color: #ff5000;\">Importo Bonifico (in &euro;)</label> <input type=\"number\" name=\"payment_bon\" id=\"payment_bon\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_bon\" ng-disabled=\"!ap.paymentBonEnabled || ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" style=\"margin-bottom: 0px;\"><label for=\"payment_check\" style=\"font-weight: bold; color: #ff5000;\">Importo Assegno (in &euro;)</label> <input type=\"number\" name=\"payment_check\" id=\"payment_check\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_check\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"ap.env.satispayEnabled\"><label for=\"payment_satis\" style=\"font-weight: bold; color: #ff5000;\">Importo Satispay (in &euro;)</label> <input type=\"number\" name=\"payment_satis\" id=\"payment_satis\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_satis\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container ng-if=\"ap.env.stripeEnabled && ap.activeAppointment.paidappointments && ap.activeAppointment.paidappointments.data && ap.activeAppointment.paidappointments.data.length>0\" class=\"md-block\"><label for=\"payment_stripe\" style=\"font-weight: bold; color: #ff5000;\">Importo Stripe (in &euro;)</label> <input type=\"number\" name=\"payment_stripe\" id=\"payment_stripe\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_stripe\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container></div></div><div layout=\"row\" ng-if=\"ap.env.giftcardEnabled && ap.activeAppointment.treatment_id!=99\"><md-input-container class=\"md-block\" flex=\"45\"><label for=\"gift_number\" style=\"font-weight: bold; color: #ff5000;\">Numero Giftcard</label><md-select aria-label=\"Numero giftcard\" id=\"gift_number\" name=\"gift_number\" ng-model=\"ap.activeAppointment.gift_number\" ng-change=\"ap.card.select()\" ng-disabled=\"(ap.activeAppointment.payment_type!= \'G\' && ap.activeAppointment.payment_type!=\'M\') || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" md-container-class=\"with-search\"><md-select-header><span class=\"md-select-search-container\"><input type=\"{{ ap.card.loading? \'hidden\' : \'search\' }}\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_card_number_pay\" name=\"filter_card_number_pay\" ng-keydown=\"$event.stopPropagation()\" ng-click=\"$event.stopPropagation()\" ng-keyup=\"ap.card.onKeyUpSearch($event, this)\" ng-model=\"ap.card.filter_number_pay\"></span></md-select-header><md-option ng-value=\"undefined\"></md-option><md-option ng-value=\"card.number\" ng-repeat=\"card in ap.card.list | orderBy: number\">{{ ap.card.format(card.number) }}</md-option><md-option ng-if=\"ap.activeAppointment.gift_number && (!ap.card.list || ap.card.list.length==0)\" ng-value=\"ap.activeAppointment.gift_number\">{{ ap.card.format(ap.activeAppointment.gift_number) }}</md-option></md-select><div ng-show=\"ap.card.card && ap.card.card.balance>0\"><div class=\"md-input-message-animation ng-scope\" style=\"color: black;\">Credito: {{ap.card.card.balance}}&euro;</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label for=\"payment_gift\" style=\"font-weight: bold; color: #ff5000;\">Importo Giftcard (in &euro;)</label> <input type=\"number\" name=\"payment_gift\" id=\"payment_gift\" step=\"0.01\" ng-max=\"ap.card.card.balance\" ng-model=\"ap.activeAppointment.payment_gift\" ng-disabled=\"(ap.activeAppointment.payment_type!= \'G\' && ap.activeAppointment.payment_type!=\'M\') || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><div ng-messages=\"appointmentForm.payment_gift.$error\"><div ng-message=\"max\"><span>Credito insufficiente</span></div></div></md-input-container></div><b ng-if=\"ap.card && ap.card.card && ap.card.card.f_receipt==1 && ap.activeAppointment.price>0 && ap.activeAppointment.price-ap.activeAppointment.payment_gift>0\">Attenzione: l\'importo dello scontrino &egrave; {{ ap.activeAppointment.price-ap.activeAppointment.payment_gift }}&euro; (va escluso l\'importo pagato con giftcard)</b> <b ng-if=\"ap.card && ap.card.card && ap.card.card.f_receipt==1 && ap.activeAppointment.price>0 && ap.activeAppointment.price==ap.activeAppointment.payment_gift\">Attenzione: non va emesso lo scontrino (perch&egrave; gi&agrave; effettuato per la gift indicata)</b> <b ng-if=\"ap.card && ap.card.card && ap.card.card.f_receipt==0 && ap.activeAppointment.price>0 && ap.activeAppointment.payment_gift>0\">Attenzione: va emesso lo scontrino per l\'intero importo</b><div ng-if=\"(!ap.env.currency || ap.env.currency.pos) && !ap.storno && ap.activeAppointment.price_discounted>=ap.sogliaRateizzazione && ap.activeAppointment.price_due>0 && ap.maxRate > 0\"><label><b>Rateizzazione</b> (inserire la modalit&agrave; di pagamento dell\'importo rimanente)</label></div><div ng-if=\"(!ap.env.currency || ap.env.currency.pos) && !ap.storno && (ap.activeAppointment.price_discounted<ap.sogliaRateizzazione || !ap.maxRate) && !ap.activeAppointment.closed && ap.activeAppointment.recalled<3\"><label><b>Rateizzazione</b> non abilitata <span ng-if=\"ap.maxRate && ap.activeAppointment.price_discounted<ap.sogliaRateizzazione\">per importi inferiori a {{ap.sogliaRateizzazione}}&euro;</span> <span ng-if=\"!ap.maxRate\">per questa tipologia di abbonamento</span></label></div><div layout=\"row\" ng-if=\"(!ap.env.currency || ap.env.currency.pos) && !ap.storno && ap.maxRate > 0 && ap.activeAppointment.price_discounted>=ap.sogliaRateizzazione && ap.activeAppointment.price_due>0\"><md-input-container class=\"md-block\" flex=\"50\"><md-radio-group id=\"rateizzazione_type\" name=\"rateizzazione_type\" ng-change=\"ap.paymentPosUpdate()\" ng-model=\"ap.activeAppointment.rateizzazione_type\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-radio-button value=\"S\">Small Pay</md-radio-button><md-radio-button value=\"M\">Rate gestite dal centro</md-radio-button></md-radio-group></md-input-container><div flex=\"50\" style=\"margin-top: 20px;\"><md-input-container class=\"md-block\"><label for=\"price_due\" style=\"font-weight: bold; color: #ff5000;\">Importo {{ap.activeAppointment.rateizzazione_type==\'S\'?\'totale\':\'rateizzato\'}} (in &euro;)</label> <input type=\"number\" name=\"price_due\" id=\"price_due\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.price_due\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3 || !ap.canEdit.price_due\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\"><label for=\"num_rate\" style=\"font-weight: bold; color: #ff5000;\">Numero rate (max {{ap.maxRate}})</label> <input type=\"number\" name=\"numrate\" id=\"num_rate\" step=\"1\" min=\"0\" max=\"{{ ap.maxRate }}\" ng-model=\"ap.activeAppointment.num_rate\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container></div></div><div><md-input-container class=\"md-block\"><label for=\"note\">Note pre</label> <textarea name=\"note\" id=\"note\" rows=\"2\" ng-model=\"ap.activeAppointment.note\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" md-select-on-focus=\"\"></textarea></md-input-container></div><div><md-input-container class=\"md-block\"><label for=\"note\">Note post</label> <textarea name=\"note_diagnosi\" id=\"note_diagnosi\" rows=\"2\" ng-model=\"ap.activeAppointment.note_diagnosi\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" md-select-on-focus=\"\"></textarea></md-input-container></div><md-checkbox ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model=\"ap.activeAppointment.paid\" ng-true-value=\"1\" ng-false-value=\"0\">Si &egrave; presentato</md-checkbox><div flex=\"\"><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ap.update( ap.activeAppointment )\" ng-disabled=\"appointmentForm.$invalid || (ap.activeAppointment.type==\'abb\' && ap.activeAppointment.subscription_new_id == null && ap.activeAppointment.customer_subscription_id == null)\" ng-if=\"ap.undoVisible && !ap.isNewAppointment && !ap.activeAppointment.closed && ap.activeAppointment.recalled<3\"><md-icon md-font-icon=\"check\">check</md-icon>Aggiorna</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ap.save( ap.activeAppointment )\" ng-disabled=\"appointmentForm.$invalid || !ap.customer_id || !ap.activeAppointment.treatment_id\" ng-if=\"ap.undoVisible && ap.isNewAppointment\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ap.undo()\" ng-if=\"ap.undoVisible\">Annulla</md-button></md-input-container><span ng-if=\"ap.user.id == 20 && appointmentForm.$invalid\">{{appointmentForm.$error | json}}</span></div></div></form></md-content></md-sidenav>");
$templateCache.put("app/availabilities/availabilities.html","<md-content layout-margin=\"\" class=\"page-availabilities\" layout-fill=\"\"><div layout-gt-sm=\"row\" layout-xs=\"column\"><div flex=\"\"><div layout=\"row\" id=\"filtroOperatrici\"><md-input-container style=\"margin-left: 10px; margin-top:10px; margin-right: 10px;\" ng-if=\"av.storeId\"><md-select aria-label=\"Operatrice\" placeholder=\"Operatrice\" ng-model=\"av.filter.operatorId\" ng-disabled=\"av.loading\" ng-change=\"av.fiterReserved();\"><md-option ng-value=\"undefined\">Tutte</md-option><md-option ng-value=\"operator.user_id\" ng-repeat=\"operator in av.usersList | filter: {active: true, store_id: av.storeId}: true\"><div class=\"operator-circle\" style=\"background-color: {{ operator.color }};\"></div>{{ operator.user.firstname }} {{ operator.user.lastname }}</md-option></md-select></md-input-container><md-input-container style=\"margin-left: 10px; margin-top:10px; margin-right: 10px;\" ng-if=\"!av.storeId && av.env.isMaster\"><md-select aria-label=\"Tag area\" placeholder=\"Tag area\" ng-disabled=\"av.loading\" ng-model=\"av.filter.tagArea\" ng-change=\"av.filterChangeTagArea();\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"tag\" ng-repeat=\"tag in av.userTags\">{{ tag }}</md-option></md-select></md-input-container><md-input-container style=\"margin-left: 10px; margin-top:10px; margin-right: 10px;\" ng-if=\"!av.storeId && av.env.isMaster\"><md-select aria-label=\"Operatore\" placeholder=\"Operatore comm.\" ng-disabled=\"av.loading\" ng-model=\"av.filter.operatorId\" ng-change=\"av.fiterReserved();\"><md-option ng-value=\"undefined\">Tutte</md-option><md-option ng-value=\"operator.user_id\" ng-repeat=\"operator in av.usersListFiltered | orderBy: \'user.lastname\'\"><div class=\"operator-circle\" style=\"background-color: {{ operator.color }};\"></div>{{ operator.user.lastname }} {{ operator.user.firstname }} {{ operator.user.tag_area?\'| \'+operator.user.tag_area:\'\'}} {{ \'[\'+operator.role+\']\' }}</md-option></md-select></md-input-container><md-input-container style=\"margin-left: 10px; margin-top:10px; margin-right: 10px;\" ng-if=\"av.storeId\"><md-select aria-label=\"Causale\" placeholder=\"Causale\" ng-disabled=\"av.loading\" ng-model=\"av.filter.leaveType\" ng-change=\"av.fiterReserved();\"><md-option ng-value=\"undefined\">Tutte</md-option><md-option ng-value=\"0\">Disponibilit&agrave;</md-option><md-option ng-value=\"1000\">Assenze</md-option><md-option ng-value=\"lt.id\" ng-repeat=\"lt in av.leaveTypeList\">{{ lt.name }}</md-option></md-select></md-input-container><md-button style=\"margin-left: 10px; margin-top:10px;\" class=\"md-accent md-raised\" aria-label=\"Nuova assenza\" ng-disabled=\"av.loading\" ng-if=\"(av.storeId || av.env.isMaster) && av.perm.canCreate(\'leave\')\" ng-click=\"av.addLeave()\"><md-icon md-font-icon=\"perm_contact_calendar\">perm_contact_calendar</md-icon>Assenza</md-button><md-button ng-if=\"av.view.type==\'month\' && av.user.type==\'admin\'\" style=\"margin-left: 10px; margin-top:10px;\" class=\"md-accent md-raised\" aria-label=\"PDF Report Ore\" ng-disabled=\"av.loading\" ng-click=\"av.availabilityHoursMonth(true)\"><md-icon md-font-icon=\"file_download\">file_download</md-icon>PDF</md-button><md-button ng-if=\"av.view.type==\'month\' && av.user.type==\'admin\'\" style=\"margin-left: 10px; margin-top:10px;\" class=\"md-accent md-raised\" aria-label=\"Report Ore\" ng-disabled=\"av.loading\" ng-click=\"av.availabilityHoursMonth(false)\"><md-icon md-font-icon=\"list\">list</md-icon>Report</md-button><md-button ng-if=\"av.view.type==\'month\' && av.user.type==\'admin\'\" style=\"margin-left: 10px; margin-top:10px;\" class=\"md-accent md-raised\" aria-label=\"Cdl\" ng-disabled=\"av.loading\" ng-click=\"av.availabilityHoursMonthPrompt(\'cdl\')\"><md-icon md-font-icon=\"list\">list</md-icon>Cdl</md-button><md-button ng-if=\"av.view.type==\'month\' && (av.user.type==\'admin\' || av.user.type==\'backoffice\') && !av.storeId\" style=\"margin-left: 10px; margin-top:10px;\" class=\"md-accent md-raised\" aria-label=\"Report Costi\" ng-disabled=\"av.loading\" ng-click=\"av.costsHoursMonth(false)\"><md-icon md-font-icon=\"money_off\">money_off</md-icon>Costo</md-button><md-button ng-if=\"av.view.type==\'month\' && (av.user.type==\'admin\' || av.user.type==\'backoffice\') && !av.storeId\" style=\"margin-left: 10px; margin-top:10px;\" class=\"md-accent md-raised\" aria-label=\"Report Costi New\" ng-disabled=\"av.loading\" ng-click=\"av.costsHoursMonth_New()\"><md-icon md-font-icon=\"money_off\">money_off</md-icon>Costo New</md-button><md-button style=\"margin-left: 10px; margin-top:10px;\" class=\"md-accent md-raised\" aria-label=\"Eliminazione/sostituzione periodo\" ng-disabled=\"av.loading\" ng-if=\"av.storeId && (av.user.type == \'admin\' || av.user.type ==\'backoffice\')\" ng-click=\"av.eliminateOrChange(false)\"><md-icon md-font-icon=\"delete\">delete</md-icon>Elim.<md-icon md-font-icon=\"cached\">cached</md-icon>Sost.</md-button><md-button style=\"margin-left: 10px; margin-top:10px;\" class=\"md-accent md-raised\" aria-label=\"Inverti\" ng-disabled=\"av.loading\" ng-if=\"av.storeId && (av.user.type == \'admin\' || av.user.type ==\'backoffice\')\" ng-click=\"av.eliminateOrChange(true)\"><md-icon md-font-icon=\"find_replace\">find_replace</md-icon>Inverti</md-button></div><md-input-container id=\"filtroReserved\" style=\"margin-bottom: 0px;\"><md-checkbox ng-disabled=\"av.loading\" ng-if=\"av.user.type==\'admin\' && av.storeId\" ng-change=\"av.avaibilityLoad();\" ng-model=\"av.filter.deleted\">Eliminate</md-checkbox><md-checkbox ng-disabled=\"av.loading\" ng-if=\"av.filter.leaveType || av.env.isMaster && !av.storeId\" ng-change=\"av.fiterReserved();\" ng-model=\"av.filter.daApprovare\">Da approvare</md-checkbox><md-checkbox ng-disabled=\"av.loading\" ng-if=\"av.storeId && !av.filter.leaveType\" ng-change=\"av.fiterReserved();\" ng-model=\"av.filter.reserved\">Riserv. comm.</md-checkbox><md-checkbox ng-disabled=\"av.loading\" ng-if=\"av.storeId && !av.filter.leaveType\" ng-change=\"av.fiterReserved();\" ng-model=\"av.filter.reserved_store\">Riserv. centro</md-checkbox><md-checkbox ng-disabled=\"av.loading\" ng-if=\"av.storeId && !av.filter.leaveType\" ng-change=\"av.fiterReserved();\" ng-model=\"av.filter.overtime\">Straord.</md-checkbox><md-checkbox ng-disabled=\"av.loading\" ng-if=\"av.storeId && !av.filter.leaveType && av.filter.overtime\" ng-change=\"av.fiterReserved();\" ng-model=\"av.filter.f_recup\">A recup.</md-checkbox></md-input-container><md-progress-circular md-diameter=\"30\" ng-if=\"av.loading\" md-mode=\"indeterminate\"></md-progress-circular><div id=\"availabilitiesCalendar\" ui-calendar=\"av.uiConfig.calendar\" ng-model=\"av.eventSources\" calendar=\"availabilitiesCalendar\" class=\"calendar\"></div></div></div></md-content><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon class=\"material-icons\">today</md-icon><h1 ng-if=\"av.activeEvent.type==\'leave\'\" class=\"md-toolbar-tools\" flex=\"\">Assenza</h1><h1 ng-if=\"av.activeEvent.type==\'change\' && !av.activeEvent.replace\" class=\"md-toolbar-tools\" flex=\"\">Eliminazione / Cambio</h1><h1 ng-if=\"av.activeEvent.type==\'change\' && av.activeEvent.replace\" class=\"md-toolbar-tools\" flex=\"\">Inverti</h1><h1 ng-if=\"av.activeEvent.type==\'availability\'\" class=\"md-toolbar-tools\" flex=\"\">{{ av.dateSelected | date:\'shortDate\' }}</h1><md-button ng-click=\"av.closeSidebar(false)\"><md-icon class=\"material-icons\">close</md-icon></md-button></div></md-toolbar><md-content layout-padding=\"\"><h3>{{ av.isNewEvent && av.activeEvent.type!=\'change\'? \'Inserimento\' : (av.activeEvent.type==\'change\' && av.activeEvent.replace ? \'Inverti\' : \'Modifica\') }} {{ av.activeEvent.type==\'leave\'? \'assenza\' :\'disponibilit&agrave;\' }} {{ av.isNewEvent || av.activeEvent.type==\'change\' ?\'\': \' (id: \'+av.activeEvent.id+\', uid: \'+av.activeEvent.user_id+\')\' }}</h3><form autocomplete=\"off\" role=\"form\" name=\"availabilityForm\" id=\"availabilityForm\" layout-margin=\"\"><div ng-if=\"(true || !av.selectedUser.current_designation || !av.selectedUser.current_designation.f_tablet) && av.activeEvent.type==\'leave\' && av.activeEvent.leave_type_id == 14\" layout=\"row\" flex=\"100\" style=\"text-align: right; background-color: Gainsboro; border: solid 1px; padding: 5px;\">Ore da recuperare: {{ av.selectedUser.user.recMinutes/60 | number:2 }}</div><div layout=\"row\"><md-input-container ng-if=\"!(av.activeEventDisabled || !av.isNewEvent) && !(av.activeEvent.copyPrevWeek && av.activeEvent.copyAll)\" class=\"md-block md-block-select\" flex=\"50\" style=\"margin-bottom:0px;\"><label for=\"user_id\"><span ng-if=\"av.env.isMaster\">Op. Commerciale/Manager</span> <span ng-if=\"!av.env.isMaster\">Operatrice</span> <span ng-if=\"av.activeEvent.type==\'change\' && !av.activeEvent.replace\">da eliminare / sostituire</span> <span ng-if=\"av.activeEvent.type==\'change\' && av.activeEvent.replace\">da invertire</span></label><md-select aria-label=\"Operatore\" id=\"user_id\" name=\"user_id\" ng-model=\"av.selectedUser\" ng-disabled=\"av.saving || av.user.type==\'callcenter\'\" ng-change=\"av.leaveTypeXTablet(); av.selectedUserChanged()\" ng-required=\"true\"><md-option ng-value=\"user\" ng-repeat=\"user in av.usersListActiveStore | orderBy: \'user.lastname\'\" ng-if=\"user.role == \'callcenter\' && av.activeEvent.type==\'leave\' || user.role == \'operator\' || user.role == \'assist\' || user.role == \'storemngr\' || av.env.isMaster && user.role == \'admin\' && av.activeEvent.type==\'availability\'\"><div class=\"operator-circle\" ng-if=\"user.role == \'callcenter\' || user.role == \'operator\' || user.role == \'assist\' || user.role == \'storemngr\'\" style=\"background-color: {{ user.color }};\"></div>{{ user.user.lastname }} {{ user.user.firstname }} {{ user.role == \'storemngr\'?\'[SM]\':(user.role == \'operator\'?\'\':\'[\'+user.role+\']\')}}</md-option></md-select><div ng-messages=\"avaibilityForm.user_id.$error\" ng-if=\"avaibilityForm.user_id.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container ng-if=\"av.activeEvent.type==\'change\'\" class=\"md-block md-block-select\" flex=\"45\" style=\"margin-bottom:0px;\"><label for=\"user_id_change\">Operatrice sostitutiva</label><md-select aria-label=\"Operatrice\" id=\"user_id_change\" name=\"user_id_change\" ng-model=\"av.selectedUserChange\" ng-change=\"av.selectedUserChangeChanged()\" ng-disabled=\"av.saving\"><md-option ng-value=\"undefined\"></md-option><md-option ng-value=\"user\" ng-repeat=\"user in av.usersListActiveStore\"><div class=\"operator-circle\" style=\"background-color: {{ user.color }};\"></div>{{ user.user.firstname }} {{ user.user.lastname }}</md-option></md-select></md-input-container><md-input-container ng-if=\"(av.activeEventDisabled || !av.isNewEvent)\" class=\"md-block md-block-select\" flex=\"50\" style=\"margin-bottom:0px;\"><div class=\"operator-circle\" style=\"background-color: {{ av.selectedUser.color }};\"></div>{{ av.selectedUser.user.firstname }} {{ av.selectedUser.user.lastname }}</md-input-container><md-input-container flex=\"50\" ng-if=\"av.activeEvent.type==\'leave\'\" style=\"margin-bottom:0px;\"><md-select aria-label=\"Causale\" placeholder=\"Causale\" ng-model=\"av.activeEvent.leave_type_id\" ng-disabled=\"av.saving || (av.activeEvent.id && av.activeEvent.leave_status_id!=1) || av.activeEventDisabled\" required=\"\"><md-option ng-value=\"lt.id\" ng-repeat=\"lt in av.leaveTypeListXTablet\">{{ lt.name }}</md-option></md-select></md-input-container><md-input-container ng-if=\"!av.activeEvent.copyPrevWeek && av.activeEvent.type!=\'leave\' && av.activeEvent.type!=\'change\' && (true || !av.selectedUser.current_designation || !av.selectedUser.current_designation.f_tablet)\" class=\"md-block\" flex=\"50\" style=\"margin-left: 20px;\"><md-checkbox id=\"overtime\" name=\"overtime\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"av.activeEventDisabled\" ng-model=\"av.activeEvent.overtime\">Straordinario</md-checkbox><md-checkbox id=\"f_recup\" name=\"f_recup\" ng-true-value=\"1\" ng-false-value=\"0\" ng-if=\"av.activeEvent.overtime\" ng-disabled=\"av.activeEventDisabled\" ng-model=\"av.activeEvent.f_recup\">A recupero</md-checkbox></md-input-container></div><div ng-if=\"!av.activeEvent.copyPrevWeek && (av.activeEvent.type==\'leave\' || av.activeEvent.type==\'change\')\" layout=\"row\"><div flex=\"40\"><label class=\"md-label\" for=\"startDate\">{{av.activeEvent.type==\'leave\' && av.activeEvent.leave_type.hourly?\'Il\':\'Dal\'}}</label><md-datepicker class=\"md-datepicker-full-width md-datepicker-remove-red-border\" id=\"startDate\" name=\"startDate\" md-placeholder=\"Data inizio\" ng-model=\"av.activeEvent.date_from\" md-min-date=\"av.activeEvent.type == \'change\'? av.query.start.toDate():av.minDate.toDate()\" ng-disabled=\"av.saving || (av.activeEvent.id && av.activeEvent.type == \'leave\' && av.activeEvent.leave_status_id!=1) || av.activeEventDisabled\" ng-required=\"true\" ng-change=\"av.changeDateFrom()\"></md-datepicker></div><div ng-if=\"!av.activeEvent.leave_type.hourly\" flex=\"40\" style=\"margin-left: 65px;\"><label class=\"md-label\" for=\"endDate\">Al</label><md-datepicker class=\"md-datepicker-full-width md-datepicker-remove-red-border\" id=\"endDate\" name=\"endDate\" md-placeholder=\"Data fine\" ng-model=\"av.activeEvent.date_to\" md-min-date=\"av.activeEvent.date_from\" md-max-date=\"av.activeEvent.type == \'change\'? av.query.end_s.toDate():null\" ng-disabled=\"av.saving || (av.activeEvent.id && av.activeEvent.leave_status_id && av.activeEvent.leave_status_id!=1) || av.activeEventDisabled\" ng-change=\"av.changeDateTo()\" ng-required=\"true\"></md-datepicker></div></div><div layout=\"row\" ng-if=\"!av.activeEvent.copyPrevWeek && av.activeEvent.type!=\'leave\' && av.activeEvent.type!=\'change\'\" style=\"margin: 5px;\"><div layout=\"row\" class=\"md-block\"><md-button ng-disabled=\"av.activeEventDisabled\" ng-click=\"av.hourBeginEnd({\'hour\': 8, \'minute\': 30, \'second\': 0},{\'hour\': 14, \'minute\': 30, \'second\': 0})\">Matt. 8:30-14:30</md-button></div><div layout=\"row\" class=\"md-block\"><md-button ng-disabled=\"av.activeEventDisabled\" ng-click=\"av.hourBeginEnd({\'hour\': 14, \'minute\': 30, \'second\': 0},{\'hour\': 20, \'minute\': 30, \'second\': 0})\">Pom. 14:30-20:30</md-button></div><div layout=\"row\" class=\"md-block\"><md-button ng-disabled=\"av.activeEventDisabled\" ng-click=\"av.hourBeginEnd({\'hour\': 11, \'minute\': 0, \'second\': 0},{\'hour\': 17, \'minute\': 0, \'second\': 0})\">Matt. e Pom. 11:00-17:00</md-button></div></div><div layout=\"row\" ng-if=\"(av.activeEvent.type!=\'leave\' && av.activeEvent.type!=\'change\' && !av.activeEvent.copyPrevWeek) || av.activeEvent.leave_type.hourly\"><md-input-container layout=\"row\" class=\"md-block\" md-is-error=\"! av.hoursOK\" flex=\"50\"><label for=\"startTime\">Inizio</label> <input mdc-datetime-picker=\"\" date=\"false\" type=\"text\" id=\"startTime\" time=\"true\" placeholder=\"Inizio\" format=\"HH:mm\" ng-model=\"av.activeEvent.start\" ng-disabled=\"av.saving || av.activeEventDisabled || (av.activeEvent.id && av.activeEvent.type==\'leave\' && av.activeEvent.leave_status_id!=1)\"></md-input-container><md-input-container layout=\"row\" class=\"md-block\" md-is-error=\"! av.hoursOK\" flex=\"50\"><label for=\"endTime\">Fine</label> <input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"endTime\" short-time=\"false\" placeholder=\"Fine\" format=\"HH:mm\" ng-model=\"av.activeEvent.end\" ng-disabled=\"av.saving || av.activeEventDisabled || (av.activeEvent.id && av.activeEvent.type==\'leave\' && av.activeEvent.leave_status_id!=1)\"></md-input-container></div><md-input-container class=\"md-block\" style=\"margin-top: 30px;\" ng-if=\"av.activeEvent.type==\'leave\'\"><label for=\"note\">Motivo</label> <textarea name=\"reason\" id=\"reason\" rows=\"2\" ng-model=\"av.activeEvent.reason\" ng-disabled=\"av.saving || av.activeEventDisabled || (av.activeEvent.id && av.activeEvent.type==\'leave\' && av.activeEvent.leave_status_id!=1)\"></textarea></md-input-container><md-input-container class=\"md-block\" style=\"margin-top: 30px;\" ng-if=\"!av.activeEvent.copyPrevWeek && av.activeEvent.type!=\'leave\' && av.activeEvent.type!=\'change\'\"><label for=\"note\">Note</label> <textarea name=\"note\" id=\"note\" rows=\"2\" ng-model=\"av.activeEvent.note\" ng-disabled=\"av.activeEventDisabled\"></textarea></md-input-container><md-input-container class=\"md-block\" ng-if=\"!av.activeEvent.copyPrevWeek && av.activeEvent.type!=\'leave\' && av.activeEvent.type!=\'change\'\"><md-radio-group id=\"reserved\" name=\"reserved\" ng-disabled=\"av.activeEventDisabled || av.appointmentsLoading || av.activeAppointments.length>0\" ng-model=\"av.activeEvent.reserved\"><div layout=\"row\"><md-radio-button flex=\"50\" ng-value=\"0\">Non riservato</md-radio-button><md-radio-button flex=\"50\" ng-value=\"3\">Fuori sede</md-radio-button></div><div layout=\"row\"><md-radio-button flex=\"50\" ng-value=\"1\">Riservato commerciale</md-radio-button><md-radio-button flex=\"50\" ng-value=\"4\">Assistenza</md-radio-button></div><div layout=\"row\"><md-radio-button flex=\"50\" ng-value=\"2\">Riservato centro</md-radio-button><md-radio-button ng-value=\"5\" flex=\"50\">Store Manager</md-radio-button></div><div layout=\"row\"><md-radio-button flex=\"50\" ng-value=\"6\" ng-if=\"av.user.type == \'admin\'\">Uso interno</md-radio-button><md-radio-button ng-if=\"av.env.isMaster\" ng-disabled=\"av.selectedUser.role != \'admin\' && av.selectedUser.role != \'storemngr\' && av.selectedUser.role != \'manager\'\" ng-value=\"7\" flex=\"50\">Manager</md-radio-button></div><div ng-if=\"av.env.availability && av.env.availability.meet\" layout=\"row\"><md-radio-button style=\"margin-top:10px;\" flex=\"35\" ng-value=\"8\" ng-if=\"!av.env.availability.meet.role || av.user.type == av.env.availability.meet.role\">{{av.env.availability.meet.label}}</md-radio-button><md-input-container style=\"margin-top:0px; margin-left: 10px;\" flex=\"65\"><md-select aria-label=\"Tipo Meet\" placeholder=\"Tipo Meet\" ng-model=\"av.activeEvent.meet_type\" ng-if=\"av.activeEvent.reserved == 8\"><md-option ng-value=\"\'live\'\">In presenza</md-option><md-option ng-repeat=\"type in av.env.availability.meet.types\" ng-value=\"type.name\">{{type.label}}</md-option></md-select></md-input-container></div></md-radio-group></md-input-container><div layout=\"row\"><md-input-container flex=\"35\" class=\"md-block\" style=\"margin-top: 0px;\" ng-if=\"av.activeEvent.reserved==8\"><label for=\"note\">Meet Limit</label> <input type=\"number\" ng-min=\"1\" ng-max=\"100\" required=\"\" name=\"meet_limit\" id=\"meet_limit\" ng-model=\"av.activeEvent.meet_limit\" ng-disabled=\"av.saving || av.activeEventDisabled\"></md-input-container><md-input-container flex=\"70\" class=\"md-block\" style=\"margin-top: 0px; margin-left: 10px;\" ng-if=\"av.activeEvent.reserved==8 && av.activeEvent.meet_type!=\'live\'\"><label for=\"note\">Meet Url</label> <input type=\"url\" required=\"\" name=\"meet_url\" id=\"meet_url\" ng-model=\"av.activeEvent.meet_url\" ng-disabled=\"av.saving || av.activeEventDisabled\"></md-input-container></div><div layout=\"row\" ng-if=\"!av.activeEvent.id && (av.activeEvent.type!=\'leave\' || av.activeEvent.leave_type.hourly) && av.activeEvent.type!=\'change\' && av.isFirstDayOfWeek\"><md-checkbox name=\"repeat\" ng-model=\"av.activeEvent.repeat\" ng-hide=\"av.activeEvent.copyPrevWeek || av.activeEvent.copyPrevMonth\" ng-disabled=\"av.activeEvent.copyPrevWeek || av.activeEventDisabled\">Ripeti inserimento</md-checkbox><md-checkbox name=\"copyPrevWeek\" ng-model=\"av.activeEvent.copyPrevWeek\" ng-hide=\"av.activeEvent.repeat\" flex=\"20\" ng-change=\"av.copyPrevWeekChange()\" ng-disabled=\"av.activeEvent.repeat || av.activeEventDisabled\">Copia settimana</md-checkbox><md-checkbox name=\"copyAll\" flex=\"20\" ng-model=\"av.activeEvent.copyAll\" ng-hide=\"!av.activeEvent.copyPrevWeek\" ng-disabled=\"av.activeEventDisabled\">Tutti</md-checkbox><md-checkbox name=\"copyOver\" flex=\"20\" ng-model=\"av.activeEvent.copyOver\" ng-hide=\"!av.activeEvent.copyPrevWeek\" ng-disabled=\"av.activeEventDisabled\">Sovrascrivi</md-checkbox><md-input-container class=\"md-block\" ng-if=\"av.activeEvent.type!=\'leave\' && av.activeEvent.copyPrevWeek\"><label for=\"copyWeekNum\">N. volte</label> <input name=\"copyWeekNum\" type=\"number\" id=\"copyWeekNum\" min=\"1\" step=\"1\" required=\"\" ng-model=\"av.activeEvent.copyWeekNum\" ng-disabled=\"av.activeEventDisabled\"></md-input-container><md-checkbox name=\"dispari\" ng-change=\"av.computeRepeats()\" ng-model=\"av.activeEvent.repeat_dispari\" ng-if=\"av.activeEvent.repeat\" ng-disabled=\"av.activeEventDisabled\">Lun/Mer/Ven</md-checkbox><md-checkbox name=\"pari\" ng-change=\"av.computeRepeats()\" ng-model=\"av.activeEvent.repeat_pari\" ng-if=\"av.activeEvent.repeat\" ng-disabled=\"av.activeEventDisabled\">Mar/Gio/Sab</md-checkbox><md-checkbox name=\"lun_sab\" ng-change=\"av.computeRepeats()\" ng-model=\"av.activeEvent.repeat_tutti\" ng-if=\"av.activeEvent.repeat\" ng-disabled=\"av.activeEventDisabled\">Tutti</md-checkbox></div><div layoyt=\"row\" ng-if=\"av.activeEvent.type!=\'leave\' && av.activeEvent.copyPrevWeek\"><label>Seleziona settimana da copiare:</label><md-datepicker flex=\"60\" id=\"copyDate\" name=\"copyDate\" ng-model=\"av.activeEvent.copyDate\" ng-required=\"true\"></md-datepicker></div><div layout=\"row\" ng-if=\"!av.activeEvent.id && (av.activeEvent.type!=\'leave\' || av.activeEvent.leave_type.hourly) && av.activeEvent.type!=\'change\' && av.isFirstDayOfWeek\"><md-checkbox name=\"repeat_begin_w\" ng-change=\"av.computeRepeats()\" ng-model=\"av.activeEvent.repeat_begin_w\" ng-if=\"av.activeEvent.repeat\" ng-disabled=\"av.activeEventDisabled\">Lun/Mar/Mer</md-checkbox><md-checkbox name=\"repeat_end_w\" ng-change=\"av.computeRepeats()\" ng-model=\"av.activeEvent.repeat_end_w\" ng-if=\"av.activeEvent.repeat\" ng-disabled=\"av.activeEventDisabled\">Gio/Ven/Sab</md-checkbox><md-checkbox name=\"repeat_lun_ven_nomar\" ng-change=\"av.computeRepeats()\" ng-model=\"av.activeEvent.repeat_lun_ven_nomar\" ng-if=\"av.activeEvent.repeat\" ng-disabled=\"av.activeEventDisabled\">Lun/Mer/Gio/Ven</md-checkbox><md-checkbox name=\"repeat_mar_sab\" ng-change=\"av.computeRepeats()\" ng-model=\"av.activeEvent.repeat_mar_sab\" ng-if=\"av.activeEvent.repeat\" ng-disabled=\"av.activeEventDisabled\">Mar/Sab</md-checkbox></div><md-input-container layout=\"row\" ng-if=\"av.activeEvent.repeat && !av.activeEvent.id\"><md-checkbox ng-model=\"av.activeEvent.repetitions[0]\">Lun {{ av.momentSelected.format(\'D MMM\') }}</md-checkbox><md-checkbox ng-model=\"av.activeEvent.repetitions[1]\">M</md-checkbox><md-checkbox ng-model=\"av.activeEvent.repetitions[2]\">M</md-checkbox><md-checkbox ng-model=\"av.activeEvent.repetitions[3]\">G</md-checkbox><md-checkbox ng-model=\"av.activeEvent.repetitions[4]\">V</md-checkbox><md-checkbox ng-model=\"av.activeEvent.repetitions[5]\">S</md-checkbox><md-checkbox ng-model=\"av.activeEvent.repetitions[6]\">D</md-checkbox></md-input-container><md-input-container layout=\"row\" ng-if=\"false && av.activeEvent.repeat && !av.activeEvent.id\"><md-checkbox ng-model=\"av.activeEvent.repetitions[7]\">Lun {{ av.momentSelected.clone().add(7,\'days\').format(\'D MMM\') }}</md-checkbox><md-checkbox ng-model=\"av.activeEvent.repetitions[8]\">M</md-checkbox><md-checkbox ng-model=\"av.activeEvent.repetitions[9]\">M</md-checkbox><md-checkbox ng-model=\"av.activeEvent.repetitions[10]\">G</md-checkbox><md-checkbox ng-model=\"av.activeEvent.repetitions[11]\">V</md-checkbox><md-checkbox ng-model=\"av.activeEvent.repetitions[12]\">S</md-checkbox><md-checkbox ng-model=\"av.activeEvent.repetitions[13]\">D</md-checkbox></md-input-container></form><div ng-if=\"av.activeEvent.type==\'change\'\"><h3 ng-if=\"!av.activeEvent.replace\">Elenco disponibilit&agrave; da <span ng-if=\"!av.selectedUserChange\">eliminare</span><span ng-if=\"av.selectedUserChange\">sostituire</span>:</h3><h3 ng-if=\"av.activeEvent.replace\">Elenco disponibilit&agrave; da invertire:</h3><div layout=\"row\"><div flex=\"50\"><ul><li ng-repeat=\"availab in av.availabilitiesXChange\"><md-icon ng-if=\"availab.id && availab.deleted===true\" class=\"material-icons\">delete</md-icon><div ng-if=\"availab.id && availab.deleted!==true\" class=\"operator-circle\" style=\"background-color: {{ availab.role.data.color }};\"></div><span ng-if=\"availab.id\">{{availab.start | date:\'dd/MM/y\'}} - dalle {{availab.start | date:\'HH:mm\'}} alle {{availab.end | date:\'HH:mm\'}}</span> <span ng-if=\"!availab.id\">&nbsp;</span></li></ul></div><div flex=\"50\"><ul ng-if=\"av.activeEvent.replace\"><li ng-repeat=\"availab in av.availabilitiesXChange2\"><md-icon ng-if=\"availab.id && availab.deleted===true\" class=\"material-icons\">delete</md-icon><div ng-if=\"availab.id && availab.deleted!==true\" class=\"operator-circle\" style=\"background-color: {{ availab.role.data.color }};\"></div><span ng-if=\"availab.id\"></span>{{availab.start | date:\'dd/MM/y\'}} - dalle {{availab.start | date:\'HH:mm\'}} alle {{availab.end | date:\'HH:mm\'}} <span ng-if=\"!availab.id\">&nbsp;</span></li></ul></div></div><h4 ng-if=\"av.activeEvent.replace && (av.availabilitiesXChange2Minutes-av.availabilitiesXChangeMinutes)/60!=0\">Differenza ore: {{ (av.availabilitiesXChange2Minutes-av.availabilitiesXChangeMinutes)/60 }}</h4></div><div layout-margin=\"\"><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"av.addEvent()\" ng-disabled=\"availabilityForm.$invalid || av.saving\" ng-if=\"!av.activeEventDisabled && av.isNewEvent && av.activeEvent.type!=\'change\'\"><md-icon ng-if=\"av.activeEvent.type!=\'leave\'\" class=\"material-icons\">check</md-icon><md-icon ng-if=\"av.activeEvent.type==\'leave\'\" class=\"material-icons\">hourglass_empty</md-icon>Crea {{ av.activeEvent.type!=\'leave\'?\'Disponibilit&agrave;\':\'Assenza\' }}</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva e approva\" ng-click=\"av.activeEvent.leave_status_id = 2; av.addEvent()\" ng-disabled=\"availabilityForm.$invalid || av.saving\" ng-if=\"!av.activeEventDisabled && av.isNewEvent && av.activeEvent.type==\'leave\' && av.activeEvent.type!=\'change\' && (av.user.type == \'admin\' || av.user.type == \'manager\')\"><md-icon class=\"material-icons\">check</md-icon>Crea Assenza e Approva</md-button><md-button ng-if=\"!av.activeEventDisabled && !av.isNewEvent && av.activeEvent.type!=\'change\' && (av.activeEvent.type!=\'leave\' || av.activeEvent.leave_status_id==1)\" ng-disabled=\"availabilityForm.$invalid || av.saving\" class=\"md-primary md-raised\" aria-label=\"Aggiorna\" ng-click=\"av.updateEvent()\"><md-icon class=\"material-icons\">check</md-icon>Aggiorna</md-button><md-button ng-if=\"!av.activeEventDisabled && !av.isNewEvent && av.activeEvent.type==\'leave\' && av.activeEvent.type!=\'change\' && av.activeEvent.leave_status_id==1 && (av.user.type == \'admin\' || av.user.type == \'manager\')\" ng-disabled=\"availabilityForm.$invalid || av.saving\" class=\"md-primary md-raised\" aria-label=\"Approva\" ng-click=\"av.updateEvent(true)\"><md-icon class=\"material-icons\">check</md-icon>Approva</md-button><md-button ng-if=\"!av.activeEventDisabled && !av.isNewEvent && av.activeEvent.type==\'leave\' && av.activeEvent.type!=\'change\' && av.activeEvent.leave_status_id == 1 && (av.user.type == \'admin\' || av.user.type == \'manager\')\" ng-disabled=\"availabilityForm.$invalid || av.saving\" class=\"md-primary md-raised\" aria-label=\"Nega\" ng-click=\"av.updateEvent(false)\"><md-icon class=\"material-icons\">cancel</md-icon>Nega</md-button><md-button class=\"md-warn md-raised\" aria-label=\"Elimina\" ng-click=\"av.removeEvent()\" ng-disabled=\"av.saving || availabilityForm.$invalid || av.selectedUserChange\" ng-if=\"!av.activeEventDisabled && (!av.isNewEvent || av.activeEvent.type==\'change\' && !av.activeEvent.replace) && (av.activeEvent.type!=\'leave\' || av.activeEvent.leave_status_id == 1)\"><md-icon class=\"material-icons\">delete</md-icon>Elimina</md-button><md-button class=\"md-warn md-raised\" aria-label=\"Sostituisci\" ng-click=\"av.removeEvent()\" ng-disabled=\"av.saving || availabilityForm.$invalid || !av.selectedUserChange || av.selectedUserChange==av.selectedUser\" ng-if=\"av.activeEvent.type==\'change\' && !av.activeEvent.replace\"><md-icon class=\"material-icons\">cached</md-icon>Sostituisci</md-button><md-button class=\"md-warn md-raised\" aria-label=\"Inverti\" ng-click=\"av.removeEvent()\" ng-disabled=\"av.saving || availabilityForm.$invalid || !av.selectedUserChange || av.selectedUserChange==av.selectedUser\" ng-if=\"av.activeEvent.type==\'change\' && av.activeEvent.replace\"><md-icon class=\"material-icons\">find_replace</md-icon>Inverti</md-button></div><span flex=\"100\" style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"av.activeEvent.id && av.storeId\">Appuntamenti in agenda</span><md-table-container class=\"addressbook-appointments\" ng-if=\"av.activeEvent.id && av.storeId\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Cliente</span></th><th md-column=\"\"><span>Dalle</span></th><th md-column=\"\"><span>Alle</span></th><th md-column=\"\"><span>Trattamento</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"av.appointmentsLoading\"><td md-cell=\"\" colspan=\"4\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"av.appointmentsLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" ng-if=\"!av.appointmentsLoading && av.activeAppointments.length==0\"><td md-cell=\"\" colspan=\"4\">Nessun appuntamento presente</td></tr><tr md-row=\"\" ng-repeat=\"appointment in av.activeAppointments\"><td md-cell=\"\">{{ appointment.customer.data.firstname }} {{ appointment.customer.data.lastname }}</td><td md-cell=\"\">{{ appointment.date_start_frmt }}</td><td md-cell=\"\">{{ appointment.date_end_frmt }}</td><td md-cell=\"\">{{ appointment.treatment.data.name }}<md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.customer_subscription_id !== null\">autorenew</md-icon></td></tr></tbody></table></md-table-container><span flex=\"100\" style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"av.user.type==\'admin\' && av.activeEvent.id && av.storeId\">Storico delle modifiche</span><div flex=\"\" ng-if=\"av.user.type==\'admin\' && av.activeEvent.id && av.storeId\"><md-progress-circular md-diameter=\"30\" ng-if=\"av.activityLoading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!av.activityLoading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Id</span></th><th md-column=\"\"><span>Operazione</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Eseguito da</span></th><th md-column=\"\"><span>Dati modificati</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"activity in av.activityLogs\"><td md-cell=\"\">{{ activity.id }}</td><td md-cell=\"\">{{ activity.description }}</td><td md-cell=\"\">{{ activity.created_at_frmt }}</td><td md-cell=\"\">{{ activity.causer.lastname }} {{ activity.causer.firstname }}</td><td md-cell=\"\"><p ng-repeat=\"(key, value) in activity.properties.attributes\"><span ng-if=\"key!=\'created_at\' && key!=\'created_at_r\' && key!=\'updated_at\' && activity.properties.old && !(value==0 && activity.properties.old[key]==null) && value!=activity.properties.old[key]\"><b>{{ key }}</b>: da {{activity.properties.old[key]==null?\'(vuoto)\':\"\'\"+activity.properties.old[key]+\"\'\"}} a \'{{ value }}\'</span></p></td></tr></tbody></table></md-table-container></div></md-content></md-sidenav>");
$templateCache.put("app/availabilities/dtp.html","<md-dialog class=\"dtp\" layout=\"column\" style=\"width: 300px;\"><md-dialog-content class=\"dtp-content\"><div class=\"dtp-date-view\"><header class=\"dtp-header\"><div class=\"dtp-actual-day\" ng-show=\"picker.dateMode\">{{picker.currentDate.format(\"dddd\")}}</div><div class=\"dtp-actual-day\" ng-show=\"picker.timeMode\">{{picker.params.shortTime ? picker.currentDate.format(\"A\") : \" \"}}</div><div class=\"dtp-close text-right\"><a href=\"#\" mdc-dtp-noclick=\"\" ng-click=\"picker.hide()\">&times;</a></div></header><div class=\"dtp-date\" ng-show=\"picker.params.date\"><div layout=\"column\"><div class=\"dtp-actual-month\">{{picker.currentDate.format(\"MMM\") | uppercase}}</div></div><div class=\"dtp-actual-num\">{{picker.currentDate.format(\"DD\")}}</div><div layout=\"row\"><div ng-click=\"picker.incrementYear(-1)\" class=\"dtp-year-btn dtp-year-btn-prev\" flex=\"30\"><span ng-if=\"picker.isPreviousYearVisible()\">&#x25B2;</span></div><div class=\"dtp-actual-year\" flex=\"\">{{picker.currentDate.format(\"YYYY\")}}</div><div ng-click=\"picker.incrementYear(1)\" class=\"dtp-year-btn dtp-year-btn-next\" flex=\"30\"><span ng-if=\"picker.isNextYearVisible()\">&#x25BC;</span></div></div></div><div class=\"dtp-time\" ng-show=\"picker.params.time && !picker.params.date\"><div class=\"dtp-actual-maxtime\">{{picker.currentNearest5Minute().format(picker.params.shortTime ? \"hh:mm\" : \"HH:mm\")}}</div></div><div class=\"dtp-picker\"><mdc-datetime-picker-calendar date=\"picker.currentDate\" picker=\"picker\" class=\"dtp-picker-calendar\" ng-show=\"picker.currentView === picker.VIEWS.DATE\"></mdc-datetime-picker-calendar><div class=\"dtp-picker-datetime\" ng-cloak=\"\" ng-if=\"picker.currentView !== picker.VIEWS.DATE\"><div class=\"dtp-actual-meridien\"><div class=\"left p20\"><a href=\"#\" mdc-dtp-noclick=\"\" class=\"dtp-meridien-am\" ng-class=\"{selected: picker.meridien == \\\'AM\\\'}\" ng-click=\"picker.selectAM()\">{{picker.params.amText}}</a></div><div ng-show=\"!picker.timeMode\" class=\"dtp-actual-time p60\">{{picker.currentNearest5Minute().format(picker.params.shortTime ? \"hh:mm\" : \"HH:mm\")}}</div><div class=\"right p20\"><a href=\"#\" mdc-dtp-noclick=\"\" class=\"dtp-meridien-pm\" ng-class=\"{selected: picker.meridien == \\\'PM\\\'}\" ng-click=\"picker.selectPM()\">{{picker.params.pmText}}</a></div><div class=\"clearfix\"></div></div><mdc-datetime-picker-clock mode=\"hours\" ng-if=\"picker.currentView === picker.VIEWS.HOUR\"></mdc-datetime-picker-clock><mdc-datetime-picker-clock mode=\"minutes\" ng-if=\"picker.currentView === picker.VIEWS.MINUTE\"></mdc-datetime-picker-clock></div></div></div></md-dialog-content><md-dialog-actions class=\"dtp-buttons\"><md-button class=\"dtp-btn-ok md-button\"></md-button><md-button class=\"dtp-btn-cancel md-button\" ng-click=\"picker.cancel()\">{{picker.params.cancelText}}</md-button><md-button class=\"dtp-btn-ok md-button\" ng-click=\"picker.ok()\">{{picker.params.okText}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/availability-analysis/availability-analysis.html","<md-content layout-margin=\"\" class=\"page-dashboard\" layout-fill=\"\"><div><div layout=\"row\"><h2 flex=\"\">Analisi Occupazione Risorse</h2><md-input-container class=\"md-block\" flex=\"\" layout-align=\"end center\"><label>Operatore</label><md-select ng-model=\"today.user_id_selected\" aria-label=\"Operatore\" id=\"user_id\" name=\"user_id\" ng-change=\"today.filterChange()\" ng-disabled=\"today.loading\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"user.user_id\" ng-repeat=\"user in today.userRolesList | filter: {store_id: today.storeId, active: true, role: \'operator\'} : true | orderBy: \'user.lastname\' track by user.user_id\"><div class=\"operator-circle\" style=\"background-color: {{ user.color }};\"></div>{{ user.user.lastname }} {{ user.user.firstname }}</md-option><md-option ng-value=\"user.user_id\" ng-repeat=\"user in today.userRolesList | filter: {store_id: today.storeId, active: true, role: \'storemngr\'} : true | orderBy: \'user.lastname\' track by user.user_id\"><div class=\"operator-circle\" style=\"background-color: {{ user.color }};\"></div><md-icon>school</md-icon>{{ user.user.lastname }} {{ user.user.firstname }}</md-option></md-select></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"\" layout-align=\"end center\"><label>Macchinario</label><md-select ng-model=\"today.machinery_id_selected\" ng-change=\"today.filterChange()\" aria-label=\"Macchinario\" id=\"machinery_id\" ng-disabled=\"today.loading\" name=\"machinery_id\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"m.machinery_id\" ng-repeat=\"m in today.machineries | orderBy: \'machinery.name\' track by m.machinery_id\">{{m.machinery.name}}</md-option></md-select></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"\" layout-align=\"end center\"><label>Periodo</label> <input ng-disabled=\"today.storeId==null\" ng-if=\"today.user && today.user.id\" aria-label=\"Date Range Picker\" date-range-picker=\"\" class=\"date-picker\" type=\"text\" ng-model=\"today.date\" options=\"today.options\" ng-change=\"today.load()\"></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"10\" layout-align=\"end center\"><md-checkbox ng-model=\"today.showRooms\" ng-change=\"today.filterChange()\" ng-disabled=\"today.loading\">Cabine</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex=\"10\" layout-align=\"end center\"><md-checkbox ng-model=\"today.showAssists\" ng-change=\"today.filterChange()\" ng-disabled=\"today.loading\">Assistenti</md-checkbox></md-input-container></div><div flex-gt-sm=\"85\" flex-xs=\"100\" class=\"content\"><div class=\"content-body\"><md-progress-circular md-diameter=\"30\" ng-if=\"today.loading\" md-mode=\"indeterminate\"></md-progress-circular></div></div><i><h3 ng-if=\"!today.loading && today.appointmentsList.length == 0\">Nessun appuntamento trovato</h3></i><div ng-show=\"!today.loading\" class=\"chart\" id=\"operChartContainer\"></div><div ng-show=\"!today.loading\" class=\"chart\" id=\"areaChartContainer\"></div></div></md-content>");
$templateCache.put("app/balance/balance.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"account_balance_wallet\">account_balance_wallet</md-icon>&nbsp;&nbsp;<h2 class=\"md-headline\"><span class=\"inset\">Saldo</span></h2><span flex=\"\" hide-xs=\"\"></span><div><md-input-container><md-select aria-label=\"Mese\" placeholder=\"Mese\" ng-model=\"ab.query.month\" ng-change=\"ab.eListLoad()\"><md-option ng-value=\"undefined\">Tutti i mesi</md-option><md-option ng-value=\"month.v\" ng-repeat=\"month in ab.MONTHS.months track by month.v\">{{ month.l }}</md-option></md-select></md-input-container></div>&nbsp;&nbsp;&nbsp;&nbsp;<div><md-input-container><md-select aria-label=\"Anno\" placeholder=\"Anno\" ng-model=\"ab.query.year\" ng-change=\"ab.eListLoad()\"><md-option ng-value=\"year\" ng-repeat=\"year in ab.years\">{{ year }}</md-option></md-select></md-input-container></div><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\" style=\"width: 10px;\">&nbsp;</th><th md-column=\"\"></th><th md-column=\"\" ng-if=\"!ab.storeId\"></th><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\"><span>Importo &euro;</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"7\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr class=\"table-header-title\" ng-if=\"!ab.loading && ab.query.month % 3 != 1\"><td colspan=\"3\" md-cell=\"\"><h3>Riporto</h3></td><td ng-if=\"!ab.storeId\" md-cell=\"\"></td><td colspan=\"5\" style=\"text-align: right; padding-right: 24px;\" md-cell=\"\"><h2>{{ab.riporto.total | number:2}}</h2></td></tr><tr md-row=\"\" class=\"table-header-title\" ng-if=\"!ab.loading\"><td colspan=\"3\" md-cell=\"\"><h3>Proiezione ricavi</h3></td><td ng-if=\"!ab.storeId\" md-cell=\"\"></td><td colspan=\"4\" style=\"text-align: right; padding-right: 24px;\" md-cell=\"\"><h3>{{ ab.ricavi.price | number:2 }} / {{ab.ricavi.gglav}} x {{ab.ricavi.ggmese}} =</h3></td><td colspan=\"1\" style=\"text-align: right; padding-right: 24px;\" md-cell=\"\"><h2>{{ ab.ricavi.total | number:2 }}</h2></td></tr><tr md-row=\"\" class=\"table-header-title\" ng-if=\"!ab.loading\"><td colspan=\"3\" md-cell=\"\"><h3>Costi</h3></td><td ng-if=\"!ab.storeId\" md-cell=\"\"></td><td colspan=\"5\" style=\"text-align: right; padding-right: 24px;\" md-cell=\"\"></td></tr><tr md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in (ab.filteredItems = (ab.eList | filter: { $: ab.query.filter } | orderBy: ab.query.order )) track by e.id\" class=\"{{ e.prev?\'row_prev\':\'\' }}\"><td md-cell=\"\">{{ e.year }}</td><td md-cell=\"\"></td><td md-cell=\"\">{{ e.nome_mese }}</td><td md-cell=\"\" ng-if=\"!ab.storeId\" ng-click=\"ab.rowClicked(e)\">{{ e.store.data.alias }}</td><td md-cell=\"\">{{ e.causal.name }}</td><td md-cell=\"\">{{ e.tipo }}</td><td md-cell=\"\" ng-if=\"e.order_id\" ng-click=\"ab.$state.go(\'home.orderdetails\', {order_id: e.order_id})\">Ordine {{ e.order_id }}</td><td md-cell=\"\" ng-if=\"!e.order_id\"></td><td md-cell=\"\">{{ e.description }}</td><td md-cell=\"\" style=\"text-align: right; padding-right: 24px;\">{{ e.total ? e.total:0 | number : 2 }}</td></tr><tr md-row=\"\" class=\"table-header-title\" ng-if=\"!ab.loading\"><td colspan=\"3\" md-cell=\"\"><h3>Proiezione costi</h3></td><td ng-if=\"!ab.storeId\" md-cell=\"\"></td><td colspan=\"4\" style=\"text-align: right; padding-right: 24px;\" md-cell=\"\"></td><td colspan=\"1\" style=\"text-align: right; padding-right: 24px;\" md-cell=\"\"><h2>{{ ab.eCostsTotal | number:2 }}</h2></td></tr><tr class=\"table-header-title\" md-row=\"\" style=\"background-color: #D9D9D9;\" ng-if=\"ab.eList.length>0\"><td colspan=\"6\" md-cell=\"\"><h3>Saldo</h3></td><td md-cell=\"\" ng-if=\"!ab.storeId\"></td><td md-cell=\"\" style=\"text-align: right;\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 24px;\"><h2>{{ ab.eListTotal | number:2 }}</h2></td></tr><tr md-row=\"\" class=\"table-header-title\" ng-if=\"!ab.loading\"><td colspan=\"3\" md-cell=\"\"><h3>Obiettivo</h3></td><td ng-if=\"!ab.storeId\" md-cell=\"\"></td><td colspan=\"5\" style=\"text-align: right; padding-right: 24px;\" md-cell=\"\"><h2>{{ab.obiettivo.total | number: 2}}</h2></td></tr><tr md-row=\"\" class=\"table-header-title\" ng-if=\"!ab.loading\"><td colspan=\"3\" md-cell=\"\"><h3>Risultato</h3></td><td ng-if=\"!ab.storeId\" md-cell=\"\"></td><td colspan=\"4\" md-cell=\"\" style=\"text-align: right; padding-right: 24px;\"><h2><span ng-if=\"ab.risultato.perc>=0\">+</span> {{ab.risultato.perc | number:2}}%</h2></td><td style=\"text-align: right; padding-right: 24px; background-color: {{ab.risultato.color}}\" md-cell=\"\"><h2><span ng-if=\"ab.risultato.perc>=0\">+</span> {{ ab.risultato.total | number:2}}</h2></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"account_circle\">account_circle</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"ab.activeEntity.id!=null\">Modifica costo {{ab.activeEntity.store.data.alias}}:</span> <span class=\"inset\" ng-if=\"ab.activeEntity.id==null\">Nuovo costo {{ab.activeEntity.store.data.alias}}:</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"entityForm\" id=\"entityForm\" layout=\"column\"><div layout=\"row\" layout-align=\"end\" style=\"margin: 5px;\"><div layout=\"row\" class=\"md-block\"><md-button ng-class=\"{\'md-primary\':ab.activeEntity.day_from>0, \'md-accent\':ab.activeEntity.day_from==null,\'md-raised\':true }\" ng-click=\"ab.setPeriodo(ab.activeEntity,null, null)\">Tutto</md-button></div><div layout=\"row\" class=\"md-block\"><md-button ng-class=\"{\'md-primary\':ab.activeEntity.day_from!=1, \'md-accent\':ab.activeEntity.day_from==1,\'md-raised\':true }\" ng-click=\"ab.setPeriodo(ab.activeEntity,1,15)\">A</md-button></div><div layout=\"row\" class=\"md-block\"><md-button ng-class=\"{\'md-primary\':ab.activeEntity.day_from!=16, \'md-accent\':ab.activeEntity.day_from==16,\'md-raised\':true }\" ng-click=\"ab.setPeriodo(ab.activeEntity,16,null)\">B</md-button></div></div><div flex=\"100\" layout=\"row\" class=\"fix-margins-3 min-height-60\" style=\"margin-top: 0px;\"><md-input-container class=\"md-block\" flex=\"30\"><label for=\"year\">Anno</label><md-select required=\"\" id=\"year\" name=\"year\" aria-label=\"Anno\" placeholder=\"Anno\" ng-model=\"ab.activeEntity.year\"><md-option ng-value=\"year\" ng-repeat=\"year in ab.years\">{{year}}</md-option></md-select></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"70\"><label for=\"month\">Mese</label><md-select ng-model=\"ab.activeEntity.month\" aria-label=\"Mese\" id=\"month\" name=\"month\" required=\"\"><md-option ng-value=\"month.v\" ng-repeat=\"month in ab.MONTHS.months track by month.v\">{{ month.l }}</md-option></md-select></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"15\"><label for=\"day_from\">Dal</label> <input type=\"number\" name=\"day_from\" id=\"day_from\" step=\"1\" min=\"1\" ng-disabled=\"\'true\'\" ng-model=\"ab.activeEntity.day_from\"></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"15\"><label for=\"day_to\">Al</label> <input type=\"number\" name=\"day_to\" id=\"day_to\" ng-disabled=\"\'true\'\" step=\"1\" min=\"1\" ng-model=\"ab.activeEntity.day_to\"></md-input-container></div><div layout=\"row\" ng-if=\"!ab.activeEntity.id\"><div flex=\"40\" style=\"margin-top: 25px;\"><md-checkbox name=\"repeat\" ng-model=\"ab.activeEntity.repeat\" ng-change=\"ab.repeatChange()\">Ripeti inserimento</md-checkbox></div><div ng-show=\"ab.activeEntity.repeat\"><md-input-container class=\"md-block\"><label for=\"repeat_month\"># Mesi</label> <input type=\"number\" name=\"repeat_month\" id=\"repeat_month\" step=\"1\" min=\"1\" max=\"60\" ng-model=\"ab.activeEntity.repeat_month\" required=\"\"><div ng-messages=\"entityForm.repeat_month.$error\" ng-show=\"entityForm.repeat_month.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div><div ng-message=\"max\">Il valore massimo &egrave; 60</div><div ng-message=\"min\">Il valore minimo &egrave; 1</div></div></md-input-container></div></div><div><md-input-container class=\"md-block\"><label for=\"causal_id\">Causale</label><md-select ng-model=\"ab.activeEntity.causal_id\" aria-label=\"Causale\" id=\"causal_id\" name=\"causal_id\" required=\"\"><md-option ng-value=\"causal.id\" ng-repeat=\"causal in ab.causaliList track by causal.id\">{{ causal.name }}</md-option></md-select><div ng-messages=\"entityForm.causal_id.$error\" ng-if=\"entityForm.causal_id.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><br></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"30\"><md-radio-group id=\"prev\" name=\"prev\" ng-model=\"ab.activeEntity.prev\"><md-radio-button value=\"0\">Reale</md-radio-button><md-radio-button value=\"1\">Previsto</md-radio-button></md-radio-group></md-input-container><md-input-container class=\"md-block\" flex=\"70\"><label for=\"price\">Importo (in &euro;)</label> <input type=\"number\" name=\"total\" id=\"total\" step=\"0.01\" min=\"0\" ng-model=\"ab.activeEntity.total\" required=\"\"></md-input-container></div><div><md-input-container class=\"md-block\"><label for=\"description\">Nota</label> <textarea maxlength=\"255\" name=\"description\" id=\"description\" rows=\"3\" ng-model=\"ab.activeEntity.description\" md-select-on-focus=\"\"></textarea></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ab.save( ab.activeEntity )\" ng-disabled=\"entityForm.$invalid\" ng-show=\"entityForm.$dirty\"><md-icon md-font-icon=\"check\">check</md-icon>{{ ab.activeEntity.id == null ? \'Salva\' : \'Aggiorna\' }}</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/blank/blank.html","<md-content class=\"page-giftcard\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ab.title}}</span></h2></div></md-toolbar><md-card><md-card-header style=\"padding-bottom: 6px; padding-top: 6px;\"><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"></div></md-toolbar></md-card-header><md-card-content style=\"overflow: auto\"></md-card-content></md-card></md-content>");
$templateCache.put("app/cash/cash.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"{{ab.env.currency?ab.env.currency.icon:\'attach_money\'}}\">{{ ab.env.currency?ab.env.currency.icon:\'attach_money\'}}</md-icon><span class=\"inset\">{{ab.env.currency?ab.env.currency.label:\'Cassa\'}}</span></h2><span flex=\"\" hide-xs=\"\"></span><div flex=\"40\" hide-xs=\"\"><md-datepicker class=\"md-datepicker-filter-bar md-datepicker-full-width\" id=\"filter_date_start\" name=\"filter_date_start\" md-placeholder=\"Da\" ng-model=\"ab.eStatus.filter_date_start\" ng-change=\"ab.loadAvailab()\"></md-datepicker></div><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-table-container ng-if=\"ab.storeId>0\"><table md-table=\"\" md-row-select=\"false\"><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"!ab.env.closing_cash_form\" ng-repeat=\"(key, user) in ab.operatorsWithApps\"><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ user.color }};\"></div></td><td md-cell=\"\">{{ user.lastname }} {{ user.firstname }}</td><td md-cell=\"\"><md-button class=\"md-accent md-raised\" aria-label=\"Chiusura cassa {{user.firstname}}\" ng-click=\"ab.toggleRight({operator_id: user.id, operator: {data: user}})\" ng-disabled=\"ab.eListLoading || ab.relLoading || !ab.perm.canCreate(\'closing_cash\', {store_id: ab.storeId, operator_id: user.id})\"><md-icon md-font-icon=\"{{ab.env.currency?ab.env.currency.icon:\'attach_money\'}}\">{{ab.env.currency?ab.env.currency.icon:\'attach_money\'}}</md-icon>Chiusura {{ab.env.currency?ab.env.currency.label.toLowerCase():\'cassa\'}}</md-button></td></tr><tr md-row=\"\" ng-if=\"ab.relatedsForEntity.length>0 && !ab.cashClosed && !ab.env.closing_cash_form && ab.user.type == \'admin\'\"><td md-cell=\"\"></td><td md-cell=\"\">Tutti</td><td md-cell=\"\"><md-button class=\"md-accent md-raised\" aria-label=\"Chiusura cassa Tutti\" ng-click=\"ab.toggleRight({operator_id: 0, operator: {data: {id: 0}}})\" ng-disabled=\"ab.eListLoading || ab.relLoading || !ab.perm.canCreate(\'closing_cash\', {store_id: ab.storeId, operator_id: 0})\"><md-icon md-font-icon=\"{{ab.env.currency?ab.env.currency.icon:\'attach_money\'}}\">{{ab.env.currency?ab.env.currency.icon:\'attach_money\'}}</md-icon>Chiusura {{ab.env.currency?ab.env.currency.label.toLowerCase():\'cassa\'}}</md-button></td></tr><tr md-row=\"\" ng-if=\"ab.env.closing_cash_form\"><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: grey\"></div></td><td md-cell=\"\">{{ ab.store.alias }}</td><td md-cell=\"\"><md-button class=\"md-accent md-raised\" aria-label=\"Chiusura cassa {{ ab.store.alias }}\" ng-click=\"ab.toggleRight({operator_id: 0, operator: {data: {id: 0} }})\" ng-disabled=\"ab.eListLoading || ab.relLoading || !ab.perm.canCreate(\'closing_cash\', { store_id: ab.storeId, operator_id: 0 })\"><md-icon md-font-icon=\"{{ ab.env.currency?ab.env.currency.icon:\'attach_money\'}}\">{{ ab.env.currency?ab.env.currency.icon:\'attach_money\'}}</md-icon>Chiusura {{ ab.env.currency?ab.env.currency.label.toLowerCase():\'cassa\'}}</md-button></td></tr></tbody></table></md-table-container><md-progress-circular md-diameter=\"30\" ng-if=\"ab.eListLoading || ab.statsLoading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!ab.eListLoading && ab.availabPresent\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><h3>ANALISI APPUNTAMENTI</h3></th><th md-column=\"\"><span>Disp. H</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>% Lav.</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>App. tot.</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>App. 1v.</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>App. smal.</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Pres. tot.</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Pres. 1v.</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Pres. smal.</span></th></tr></thead><tbody md-body=\"\" ng-init=\"operatorsApps=ab.operatorsAppsValues()\"><tr md-row=\"\" ng-repeat=\"e in operatorsApps | orderBy: [\'-operator_id\',\'lastname\']\" ng-if=\"!(ab.storeId == 0 && e.operator.data.id > 0)\" style=\"{{ e.operator.data.id > 0 || (ab.storeId == 0 && e.store_id > 0) ? \'\' : \'background-color: rgb(217, 217, 217);\' }}\" class=\"cash-table-padding\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><div ng-if=\"e.operator.data.id > 0\" class=\"operator-circle\" style=\"background-color: {{ e.operator.data.color }};\"></div>&nbsp; <span ng-if=\"e.operator.data.id > 0\">{{ e.operator.data.lastname }} {{ e.operator.data.firstname }}</span> <span ng-if=\"!ab.storeId && e.operator.data.id <= 0\">{{ e.operator.data.store.alias }}</span> <span ng-if=\"ab.storeId && e.operator.data.id <= 0\">Totale gruppo</span></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><span ng-if=\"e.operator.data.id<=0\">{{ e.availabHours | number: 1}}</span> <span ng-if=\"e.operator.data.id>0\">{{ e.availabDurationFrmt }}</span></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\" class=\"perc\">{{ e.workedPerc | number : 0 }}%</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count_all>0 ? e.app_count_all : 0 | number : 0}}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count_first_all>0 ? e.app_count_first_all : 0 | number : 0}}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count_all>0 ? e.app_count_all-e.app_count_first_all : 0 | number : 0}}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count>0 ? e.app_count : 0 | number : 0}} ({{ e.app_count_all>0 ? e.app_count*100/e.app_count_all : 0 | number : 0}}%)</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count_first>0 ? e.app_count_first : 0 | number : 0}} ({{ e.app_count_first_all>0 ? e.app_count_first*100/e.app_count_first_all : 0 | number : 0}}%)</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count>0 ? e.app_count-e.app_count_first : 0 | number : 0}} ({{ (e.app_count_all-e.app_count_first_all)>0 ? (e.app_count-e.app_count_first)*100/(e.app_count_all-e.app_count_first_all) : 0 | number : 0}}%)</td></tr></tbody></table></md-table-container><br><md-table-container ng-if=\"!ab.eListLoading && ab.eList!=null && ab.eList.length>0\"><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\" border=\"0\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\"><h3>DATI ECONOMICI</h3></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right;\"><span>Realizz. ({{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}})</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right;\"><span>Scontr. medio ({{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}})</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>Pos</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>Carta</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>App</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>PagoDil</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>App Pago</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>PagoLight</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"ab.env.smallpayEnabled && (!ab.env.currency || ab.env.currency.pos)\"><span>SmallPay</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>Bonifico</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>Assegno</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"ab.env.satispayEnabled && (!ab.env.currency || ab.env.currency.pos)\"><span>SatisPay</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"ab.env.stripeEnabled && && (!ab.env.currency || ab.env.currency.pos)\"><span>Stripe</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>Contanti</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>Gift</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>Gift Em.</span></th><th md-column=\"\"></th></tr></thead><tr md-row=\"\" md-select=\"e\" md-auto-select=\"ab.options.autoSelect\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in ab.eList | orderBy: [\'-operator_id\',\'lastname\']\" ng-if=\"!ab.showSm || e.operator_id == 0\" style=\"{{ e.operator.data.id > 0 || (ab.storeId == 0 && e.store_id!=0) ? \'\' : \'background-color: rgb(217, 217, 217);\' }}\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><div ng-if=\"e.operator.data.id > 0\" class=\"operator-circle\" style=\"background-color: {{ e.operatorRole.data.color }};\"></div>&nbsp; <span ng-if=\"e.operator_id > 0\">{{ e.operator.data.lastname }} {{ e.operator.data.firstname }}</span> <span ng-if=\"e.operator_id == 0 && ab.storeId\">Totale gruppo</span> <span ng-if=\"e.operator_id == 0 && !ab.storeId\">{{e.store.alias}}</span></td><td md-cell=\"\" style=\"text-align: right; background-color: {{ e.operator_id == 0?ab.colorPerc((ab.statistics.realizzatoDay-ab.statistics.obDay)*100/ab.statistics.obDay):\'white\' }};\" ng-click=\"ab.rowClicked(e)\">{{ e.total ? e.total:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count && e.total ? e.total/e.app_count : 0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_pos ? e.total_pos:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_card ? e.total_card:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_app ? e.total_app:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_dil ? e.total_dil:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_apppago ? e.total_apppago:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_light ? e.total_light:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"ab.env.smallpayEnabled && (!ab.env.currency || ab.env.currency.pos)\">{{ e.total_small ? e.total_small:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_bon ? e.total_bon:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_check ? e.total_check:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"ab.env.satispayEnabled && (!ab.env.currency || ab.env.currency.pos)\">{{ e.total_satis ? e.total_satis:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"ab.env.stripeEnabled && (!ab.env.currency || ab.env.currency.pos)\">{{ e.total_stripe ? e.total_stripe:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total + e.total_rel_gift - e.total_pos - e.total_card - e.total_app - e.total_dil - e.total_apppago - e.total_light - e.total_small - e.total_satis - e.total_stripe - e.total_bon - e.total_check - e.total_gift | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\">{{ e.total_gift || e.total_gift_ns ? (e.total_gift+e.total_gift_ns) : 0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ e.operator_id == 0?ab.colorPerc((ab.statistics.realizzatoDayGift-ab.statistics.obDayGift)*100/ab.statistics.obDayGift):\'white\' }};\" ng-click=\"ab.rowClicked(e)\">{{ e.total_rel_gift || e.total_rel_gift_s ? (e.total_rel_gift + e.total_rel_gift_s) : 0 | number : 2 }}</td><td md-cell=\"\" class=\"icon-button\"><md-button ng-if=\"e.operator_id>0 || ab.user.type==\'admin\'\" ng-disabled=\"!ab.perm.canDelete(\'closing_cash\', e)\" class=\"md-icon-button md-warn\" ng-click=\"ab.undo( e )\" aria-label=\"Cancella chiusura\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr></table></md-table-container><br><md-table-container ng-if=\"!ab.eListLoading && ab.availabPresent\"><table md-table=\"\" border=\"0\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><h3>OPERATIVITA\'</h3></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right;\"><span>Gift</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>PhoneFriends</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>%Cross</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Azioni comm.</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Cassa azioni comm. (&euro;)</span></th></tr></thead><tbody md-body=\"\" ng-init=\"operatorsApps=ab.operatorsAppsValues()\"><tr md-row=\"\" ng-repeat=\"e in operatorsApps | orderBy: [\'-operator_id\',\'lastname\']\" ng-if=\"!(ab.storeId == 0 && e.operator.data.id > 0)\" style=\"{{ e.operator.data.id > 0 || (ab.storeId == 0 && e.store_id > 0) ? \'\' : \'background-color: rgb(217, 217, 217);\' }}\" class=\"cash-table-padding\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><div ng-if=\"e.operator.data.id > 0\" class=\"operator-circle\" style=\"background-color: {{ e.operator.data.color }};\"></div>&nbsp; <span ng-if=\"e.operator.data.id > 0\">{{ e.operator.data.lastname }} {{ e.operator.data.firstname }}</span> <span ng-if=\"!ab.storeId && e.operator.data.id <= 0\">{{ e.operator.data.store.alias }}</span> <span ng-if=\"ab.storeId && e.operator.data.id <= 0\">Totale gruppo</span></td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_gift ? e.total_gift:0 | number : 2 }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.numAppPF }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.numAppCross?e.numAppCross*100/e.app_count:0 | number:0 }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.numAppDaRullo }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.totalAzComm?e.totalAzComm:0 | number:2 }}</td></tr></tbody></table></md-table-container><br><md-table-container ng-if=\"!ab.eListLoading\"><table md-table=\"\" border=\"0\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><h3>OBIETTIVI</h3></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right;\"><span>Oggi</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Periodo</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Valore Medio</span></th></tr></thead><tbody md-body=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><tr md-row=\"\" class=\"cash-table-padding\"><td md-cell=\"\">Scontrino medio 1a v.</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ ab.target.today.sm_1av_color }};\">{{ ab.target.today.sm_1av | number : 0 }} &euro;</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ ab.target.month.sm_1av_color }};\">{{ ab.target.month.sm_1av | number : 0 }} &euro;</td><td md-cell=\"\" style=\"text-align: right;\">{{ ab.target.target.sm_1av | number : 0 }} &euro;</td></tr><tr md-row=\"\" class=\"cash-table-padding\"><td md-cell=\"\">Scontrino medio smalt.</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ ab.target.today.sm_sm_color }};\">{{ ab.target.today.sm_sm | number : 0 }} &euro;</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ ab.target.month.sm_sm_color }};\">{{ ab.target.month.sm_sm | number : 0 }} &euro;</td><td md-cell=\"\" style=\"text-align: right;\">{{ ab.target.target.sm_sm | number : 0 }} &euro;</td></tr><tr md-row=\"\" class=\"cash-table-padding\" ng-if=\"ab.user.type == \'admin\' || ab.user.type == \'storemngr\'\"><td md-cell=\"\">% viso su incasso</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ ab.target.today.perc_1_color }};\">{{ ab.target.today.perc_1 | number : 0 }} %</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ ab.target.month.perc_1_color }};\">{{ ab.target.month.perc_1 | number : 0 }} %</td><td md-cell=\"\" style=\"text-align: right;\">{{ ab.target.target.perc_1 | number : 0 }} %</td></tr><tr md-row=\"\" class=\"cash-table-padding\" ng-if=\"ab.user.type == \'admin\' || ab.user.type == \'storemngr\'\"><td md-cell=\"\">% corpo su incasso</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ ab.target.today.perc_2_color }};\">{{ ab.target.today.perc_2 | number : 0 }} %</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ ab.target.month.perc_2_color }};\">{{ ab.target.month.perc_2 | number : 0 }} %</td><td md-cell=\"\" style=\"text-align: right;\">{{ ab.target.target.perc_2 | number : 0 }} %</td></tr><tr md-row=\"\" class=\"cash-table-padding\" ng-if=\"ab.user.type == \'admin\' || ab.user.type == \'storemngr\'\"><td md-cell=\"\">App. esitati/gg</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ ab.target.today.num_app_day_color }};\">{{ ab.target.today.num_app_day | number : 0 }}</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ ab.target.month.num_app_day_color }};\">{{ ab.target.month.num_app_day | number : 0 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ ab.target.target.num_app_day | number : 0 }}</td></tr><tr md-row=\"\" class=\"cash-table-padding\" ng-if=\"ab.user.type == \'admin\' || ab.user.type == \'storemngr\'\"><td md-cell=\"\">Incasso medio/gg.</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ ab.target.today.total_day_color }};\">{{ ab.target.today.total_day | number : 0 }} &euro;</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ ab.target.month.total_day_color }};\">{{ ab.target.month.total_day | number : 0 }} &euro;</td><td md-cell=\"\" style=\"text-align: right;\">{{ ab.target.target.total_day | number : 0 }} &euro;</td></tr></tbody></table></md-table-container><div ng-repeat=\"trending in ab.trendings\"><md-table-container style=\"padding:10px; margin-top: 20px; text-align:center;\" ng-if=\"(!ab.env.menu || ab.env.menu.expcash) && !ab.eListLoading\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" colspan=\"3\" align=\"center\" valign=\"bottom\" bgcolor=\"#0070C0\"><b><font color=\"#FFFFFF\">Andamento e proiezione su obiettivo {{trending.title}}</font></b></td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"width: 33%; border-left: 3px solid #4472c4\" align=\"center\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">Realizzato</font></td><td style=\"width: 33%;\" md-cell=\"\" align=\"center\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">Proiezione</font></td><td md-cell=\"\" style=\"width: 34%; border-right: 3px solid #4472c4; text-align: center;\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">%</font></td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"border-left: 3px solid #4472c4\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><font face=\"Montserrat\" color=\"#FFFFFF\" size=\"6\">{{ trending.real | number : 0}}</font></td><td md-cell=\"\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><i><font face=\"Montserrat\" color=\"#FFFFFF\" size=\"6\">{{ trending.proiezione | number : 0}}</font></i></td><td md-cell=\"\" style=\"border-bottom: 3px solid #4472c4; border-right: 3px solid #4472c4; text-align: center;\" rowspan=\"3\" valign=\"middle\" bgcolor=\"{{ab.colorOb(trending.psaldoperc)}}\"><b><font face=\"Arial Black\" size=\"6\">{{trending.psaldoperc>0?\'+\':\'\'}}{{ trending.psaldoperc | number : 0}}%</font></b></td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"border-left: 3px solid #4472c4\" align=\"center\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">Obiettivo</font></td><td md-cell=\"\" align=\"center\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">Differenza</font></td><td></td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"border-bottom: 3px solid #4472c4; border-left: 3px solid #4472c4\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><i><font face=\"Montserrat\" color=\"#FFFFFF\" size=\"6\">{{ trending.obiettivo | number : 0}}</font></i></td><td md-cell=\"\" style=\"border-bottom: 3px solid #4472c4\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><b><font face=\"Montserrat\" color=\"{{ab.colorOb(trending.psaldoperc)}}\" size=\"6\">{{ trending.psaldo | number : 0}}</font></b></td><td></td></tr></tbody></table></md-table-container></div></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" style=\"max-width: 75%;\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"{{ ab.env.currency?ab.env.currency.icon:\'attach_money\'}}\">{{ ab.env.currency?ab.env.currency.icon:\'attach_money\'}}</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"!ab.isNewEntity\">Report chisura {{ ab.env.currency?ab.env.currency.label.toLowerCase():\'cassa\'}} {{ ab.activeEntity.operator.data.id>0?\'di \'+ab.activeEntity.operator.data.firstname:\"del centro \" +ab.store.alias}}</span> <span class=\"inset\" ng-if=\"ab.isNewEntity\">Chiusura {{ ab.env.currency?ab.env.currency.label.toLowerCase():\'cassa\'}} {{ ab.activeEntity.operator.data.id>0?\'di \'+ab.activeEntity.operator.data.firstname:\"del centro \" +ab.store.alias}}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><div flex=\"100\"><md-input-container class=\"md-block\"><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\" ng-disabled=\"ab.relLoading\">Annulla</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Chiudi cassa\" ng-click=\"ab.save( ab.activeEntity )\" ng-if=\"ab.isNewEntity\" ng-disabled=\"ab.activeEntity.appointments.length == 0 || ab.relLoading || ab.saving\"><md-icon md-font-icon=\"check\">check</md-icon>Chiudi {{ ab.env.currency?ab.env.currency.label.toLowerCase():\'cassa\'}} {{ab.activeEntity.date | date: \'dd/MM/yyyy\'}}</md-button></md-input-container></div><div layout=\"row\" ng-if=\"!ab.env.closing_cash_form\"><div flex=\"50\" style=\"padding: 20px;\"><md-table-container class=\"cash-sidenav-table\" ng-if=\"!ab.relLoading\"><table md-table=\"\"><thead md-head=\"\"><tr><th colspan=\"2\" style=\"background-color: rgb(227,227,227);\">Totali {{ab.env.currency?ab.env.currency.label.toLowerCase():\'&euro;\'}}</th></tr></thead><tbody md-body=\"\"><tr class=\"odd\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>POS</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_pos | number:2 }}</td></tr><tr class=\"even\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>Carta</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_card | number:2 }}</td></tr><tr class=\"odd\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>App</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_app | number:2 }}</td></tr><tr class=\"even\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>Bonifico</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_bon | number:2 }}</td></tr><tr class=\"odd\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>Assegno</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_check | number:2 }}</td></tr><tr class=\"even\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>PagoDil</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_dil | number:2 }}</td></tr><tr class=\"odd\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>APP Pago</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_apppago | number:2 }}</td></tr><tr class=\"even\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>PagoLight</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_light | number:2 }}</td></tr><tr class=\"odd\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>Gift (n.s.)</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_gift_ns | number:2 }}</td></tr><tr class=\"even\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>Gift (s.)</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_gift | number:2 }}</td></tr><tr class=\"odd\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>Contanti</td><td style=\"text-align:right;\">{{ ab.activeEntity.total + ab.activeEntity.total_rel_gift - ab.activeEntity.total_pos - ab.activeEntity.total_card - ab.activeEntity.total_app - ab.activeEntity.total_dil - ab.activeEntity.total_apppago - ab.activeEntity.total_light - ab.activeEntity.total_small - ab.activeEntity.total_satis - ab.activeEntity.total_stripe - ab.activeEntity.total_bon - ab.activeEntity.total_check - ab.activeEntity.total_gift | number:2 }}</td></tr><tr class=\"even\" ng-if=\"ab.env.smallpayEnabled && (!ab.env.currency || ab.env.currency.pos)\"><td>SmallPay</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_small | number:2 }}</td></tr><tr class=\"odd\" ng-if=\"ab.env.satispayEnabled && (!ab.env.currency || ab.env.currency.pos)\"><td>SatisPay</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_satis | number:2 }}</td></tr><tr class=\"even\" ng-if=\"ab.env.stripeEnabled && (!ab.env.currency || ab.env.currency.pos)\"><td>Stripe</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_stripe | number:2 }}</td></tr><tr style=\"background-color: rgb(227,227,227);\"><td>Realizz. ({{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}})</td><td style=\"text-align:right;\">{{ ab.activeEntity.total | number:2 }}</td></tr><tr style=\"background-color: rgb(227,227,227);\"><td style=\"border-top: 1px solid rgb(250,250,250) !important;\">Gift Emesse (n.s.) ({{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}})</td><td style=\"text-align:right; border-top: 1px solid rgb(250,250,250) !important;\">{{ ab.activeEntity.total_rel_gift | number:2 }}</td></tr><tr style=\"background-color: rgb(227,227,227);\"><td style=\"border-top: 1px solid rgb(250,250,250) !important;\">Gift Emesse (s.) ({{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}})</td><td style=\"text-align:right; border-top: 1px solid rgb(250,250,250) !important;\">{{ ab.activeEntity.total_rel_gift_s | number:2 }}</td></tr></tbody></table></md-table-container></div><div flex=\"50\" style=\"padding: 20px;\" ng-if=\"!ab.env.closing_cash_form\"><md-table-container class=\"cash-sidenav-table\" ng-if=\"!ab.relLoading\"><table md-table=\"\"><thead md-head=\"\"><tr><th colspan=\"{{ab.env.gp?\'3\':\'2\'}}\" style=\"background-color: rgb(227,227,227);\">Conteggio appuntamenti</th></tr><tr ng-if=\"ab.env.gp\"><th></th><th style=\"text-align:right;\">Totale</th><th style=\"text-align:right;\">GP</th></tr></thead><tbody md-body=\"\"><tr class=\"odd\"><td>In agenda</td><td style=\"text-align:right;\">{{ ab.activeEntity.app_count_all }}</td><td ng-if=\"ab.env.gp\" style=\"text-align:right;\">{{ ab.activeEntity.app_count_gp_all }}</td></tr><tr class=\"even\"><td>Presentati</td><td style=\"text-align:right;\">{{ ab.activeEntity.app_count }}</td><td ng-if=\"ab.env.gp\" style=\"text-align:right;\">{{ ab.activeEntity.app_count_gp }}</td></tr><tr class=\"odd\"><td>% Pres.</td><td style=\"text-align:right;\">{{ ab.activeEntity.app_count*100/ab.activeEntity.app_count_all | number:0 }}%</td><td ng-if=\"ab.env.gp\" style=\"text-align:right;\">{{ ab.activeEntity.app_count_gp*100/ab.activeEntity.app_count_gp_all | number:0 }}%</td></tr><tr class=\"even\"><td>Prima volta</td><td style=\"text-align:right;\">{{ ab.activeEntity.app_count_first_all }}</td><td ng-if=\"ab.env.gp\" style=\"text-align:right;\">{{ ab.activeEntity.app_count_gp_first_all }}</td></tr><tr class=\"odd\"><td>Presentati 1a v.</td><td style=\"text-align:right;\">{{ ab.activeEntity.app_count_first }}</td><td ng-if=\"ab.env.gp\" style=\"text-align:right;\">{{ ab.activeEntity.app_count_gp_first }}</td></tr><tr class=\"even\"><td>% Pres. 1a v.</td><td style=\"text-align:right;\">{{ ab.activeEntity.app_count_first*100/ab.activeEntity.app_count_first_all | number:0 }}%</td><td ng-if=\"ab.env.gp\" style=\"text-align:right;\">{{ ab.activeEntity.app_count_gp_first*100/ab.activeEntity.app_count_gp_first_all | number:0 }}%</td></tr></tbody></table></md-table-container></div></div><br><span style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"!ab.env.closing_cash_form && ab.activeEntity.appointments.length == 0 && !ab.relLoading\">Nessun appuntamento trovato.</span> <span style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"!ab.env.closing_cash_form && ab.activeEntity.appointments.length > 0 && !ab.relLoading\">Elenco appuntamenti</span><md-content ng-hide=\"!ab.relLoading\" layout=\"row\" layout-align=\"center center\" style=\"min-height: 80px;\" ng-if=\"!ab.env.closing_cash_form\"><md-progress-circular ng-disabled=\"!ab.relLoading\" md-diameter=\"40\"></md-progress-circular></md-content><md-table-container class=\"addressbook-appointments\" ng-if=\"!ab.relLoading && !ab.env.closing_cash_form\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Op.</th><th md-column=\"\">Cliente</th><th md-column=\"\">Sm</th><th md-column=\"\">Ora</th><th md-column=\"\">Tratt.</th><th md-column=\"\" md-numeric=\"\">Pres.</th><th md-column=\"\" md-numeric=\"\">1° v.</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">Pos</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">Card</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">App</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">Bon.</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">Ass.</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">Gift</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">PDil</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">APP Pago</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">PLight</th><th md-column=\"\" md-numeric=\"\" ng-if=\"ab.env.smallpayEnabled && (!ab.env.currency || ab.env.currency.pos)\">SmallP</th><th md-column=\"\" md-numeric=\"\" ng-if=\"ab.env.satispayEnabled && (!ab.env.currency || ab.env.currency.pos)\">SatisP</th><th md-column=\"\" md-numeric=\"\" ng-if=\"ab.env.stripeEnabled && (!ab.env.currency || ab.env.currency.pos)\">Stripe</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">Contanti</th><th md-column=\"\" md-numeric=\"\">Real.</th><th md-column=\"\" md-numeric=\"\">Gift Em.</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"appointment in ab.activeEntity.appointments | orderBy: \'date_start\'\" class=\"{{appointment.recalled>=3?\'recalled_\'+appointment.recalled:( appointment.paid? \'\':\'app_notpaid\')}}\"><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ appointment.role.data.color }};\"></div></td><td md-cell=\"\">{{ appointment.customer.data.firstname }} {{ appointment.customer.data.lastname }}{{appointment.f_ref?\'*\':\'\'}}</td><td md-cell=\"\"><div class=\"operator-circle\" ng-if=\"appointment.user_id_sm\" style=\"background-color: {{ appointment.roleSm.data.color }};\"></div></td><td md-cell=\"\">{{ appointment.date_start_ora }}</td><td md-cell=\"\">{{ appointment.treatment.data.name }}<md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.customer_subscription_id !== null\">autorenew</md-icon></td><td align=\"center\" md-cell=\"\">{{ appointment.paid?\'Si\' : \'No\' }}</td><td align=\"right\" md-cell=\"\">{{ 2 > appointment.user_times ? \'Si\' : \'No\' }}</td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_pos | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_card | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_app | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_bon | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_check | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid && (!appointment.payment_gift || !appointment.giftcard || !appointment.giftcard.data || !appointment.giftcard.data.f_free)\">{{ appointment.payment_gift | number:2 }} <b ng-if=\"appointment.payment_gift && appointment.giftcard && appointment.giftcard.data && appointment.giftcard.data.f_receipt\">n.s.</b> <b ng-if=\"appointment.payment_gift && appointment.giftcard && appointment.giftcard.data && !appointment.giftcard.data.f_receipt\">s.</b></span> <span ng-if=\"appointment.paid && appointment.payment_gift && appointment.giftcard && appointment.giftcard.data && appointment.giftcard.data.f_free\">{{ appointment.payment_gift | number:2 }} Om.</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_dil | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_apppago | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_light | number:2 }}</span></td><td align=\"right\" ng-if=\"ab.env.smallpayEnabled && (!ab.env.currency || ab.env.currency.pos)\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_small | number:2 }}</span></td><td align=\"right\" ng-if=\"ab.env.satispayEnabled && (!ab.env.currency || ab.env.currency.pos)\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_satis | number:2 }}</span></td><td align=\"right\" ng-if=\"ab.env.stripeEnabled && (!ab.env.currency || ab.env.currency.pos)\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_stripe | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid && (appointment.treatment_id != 99 || !appointment.giftcard || !appointment.giftcard.data || !appointment.giftcard.data.f_free)\">{{ appointment.price - appointment.payment_pos - appointment.payment_card - appointment.payment_app - appointment.payment_dil - appointment.payment_apppago - appointment.payment_light - appointment.payment_small - appointment.payment_satis - appointment.payment_stripe - appointment.payment_bon - appointment.payment_check - appointment.payment_gift | number:2 }}</span> <span ng-if=\"appointment.paid && appointment.treatment_id == 99 && appointment.giftcard && appointment.giftcard.data && appointment.giftcard.data.f_free\">0,00</span></td><td align=\"right\" md-cell=\"\"><span ng-if=\"appointment.paid && appointment.treatment_id != 99 && (!appointment.giftcard || !appointment.giftcard.data || (!appointment.giftcard.data.f_free && !appointment.giftcard.data.f_receipt))\">{{ appointment.price | number:2 }}</span> <span ng-if=\"appointment.paid && appointment.treatment_id != 99 && appointment.giftcard && appointment.giftcard.data && (appointment.giftcard.data.f_free || appointment.giftcard.data.f_receipt)\">{{ (appointment.price-appointment.payment_gift) | number:2 }}</span> <span ng-if=\"appointment.paid && appointment.treatment_id == 99\">0,00</span></td><td align=\"right\" md-cell=\"\"><span ng-if=\"appointment.paid && appointment.treatment_id == 99 && (!appointment.giftcard || !appointment.giftcard.data || !appointment.giftcard.data.f_free)\">{{ appointment.price | number:2 }} <b ng-if=\"appointment.giftcard && appointment.giftcard.data && appointment.giftcard.data.f_receipt\">s.</b> <b ng-if=\"appointment.giftcard && appointment.giftcard.data && !appointment.giftcard.data.f_receipt\">n.s.</b></span> <span ng-if=\"appointment.paid && appointment.treatment_id == 99 && appointment.giftcard && appointment.giftcard.data && appointment.giftcard.data.f_free\">{{ appointment.price | number:2 }} Om.</span> <span ng-if=\"appointment.paid && appointment.treatment_id != 99\">0,00</span></td></tr></tbody></table></md-table-container></md-content></md-sidenav>");
$templateCache.put("app/cash/cash_20200619.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"{{ab.env.currency?ab.env.currency.icon:\'attach_money\'}}\">{{ ab.env.currency?ab.env.currency.icon:\'attach_money\'}}</md-icon><span class=\"inset\">{{ab.env.currency?ab.env.currency.label:\'Cassa\'}}</span></h2><span flex=\"\" hide-xs=\"\"></span><div flex=\"40\" hide-xs=\"\"><md-datepicker class=\"md-datepicker-filter-bar md-datepicker-full-width\" id=\"filter_date_start\" name=\"filter_date_start\" md-placeholder=\"Da\" ng-model=\"ab.eStatus.filter_date_start\" ng-change=\"ab.loadAvailab()\"></md-datepicker></div><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-table-container ng-if=\"ab.storeId>0\"><table md-table=\"\" md-row-select=\"false\"><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"!ab.env.closing_cash_form\" ng-repeat=\"(key, user) in ab.operatorsWithApps\"><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ user.color }};\"></div></td><td md-cell=\"\">{{ user.lastname }} {{ user.firstname }}</td><td md-cell=\"\"><md-button class=\"md-accent md-raised\" aria-label=\"Chiusura cassa {{user.firstname}}\" ng-click=\"ab.toggleRight({operator_id: user.id, operator: {data: user}})\" ng-disabled=\"ab.eListLoading || ab.relLoading || !ab.perm.canCreate(\'closing_cash\', {store_id: ab.storeId, operator_id: user.id})\"><md-icon md-font-icon=\"{{ab.env.currency?ab.env.currency.icon:\'attach_money\'}}\">{{ab.env.currency?ab.env.currency.icon:\'attach_money\'}}</md-icon>Chiusura {{ab.env.currency?ab.env.currency.label.toLowerCase():\'cassa\'}}</md-button></td></tr><tr md-row=\"\" ng-if=\"ab.relatedsForEntity.length>0 && !ab.cashClosed && !ab.env.closing_cash_form && ab.user.type == \'admin\'\"><td md-cell=\"\"></td><td md-cell=\"\">Tutti</td><td md-cell=\"\"><md-button class=\"md-accent md-raised\" aria-label=\"Chiusura cassa Tutti\" ng-click=\"ab.toggleRight({operator_id: 0, operator: {data: {id: 0}}})\" ng-disabled=\"ab.eListLoading || ab.relLoading || !ab.perm.canCreate(\'closing_cash\', {store_id: ab.storeId, operator_id: 0})\"><md-icon md-font-icon=\"{{ab.env.currency?ab.env.currency.icon:\'attach_money\'}}\">{{ab.env.currency?ab.env.currency.icon:\'attach_money\'}}</md-icon>Chiusura {{ab.env.currency?ab.env.currency.label.toLowerCase():\'cassa\'}}</md-button></td></tr><tr md-row=\"\" ng-if=\"ab.env.closing_cash_form\"><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: grey\"></div></td><td md-cell=\"\">{{ ab.store.alias }}</td><td md-cell=\"\"><md-button class=\"md-accent md-raised\" aria-label=\"Chiusura cassa {{ ab.store.alias }}\" ng-click=\"ab.toggleRight({operator_id: 0, operator: {data: {id: 0} }})\" ng-disabled=\"ab.eListLoading || ab.relLoading || !ab.perm.canCreate(\'closing_cash\', { store_id: ab.storeId, operator_id: 0 })\"><md-icon md-font-icon=\"{{ ab.env.currency?ab.env.currency.icon:\'attach_money\'}}\">{{ ab.env.currency?ab.env.currency.icon:\'attach_money\'}}</md-icon>Chiusura {{ ab.env.currency?ab.env.currency.label.toLowerCase():\'cassa\'}}</md-button></td></tr></tbody></table></md-table-container><md-progress-circular md-diameter=\"30\" ng-if=\"ab.eListLoading || ab.statsLoading\" md-mode=\"indeterminate\"></md-progress-circular><div ng-if=\"ab.storeId && !ab.eListLoading && ab.cashClosed\"><md-button class=\"md-accent md-raised\" aria-label=\"Totale\" ng-click=\"ab.showSm = false\" ng-disabled=\"!ab.showSm\">x Operatrice</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Totale\" ng-click=\"ab.showSm = true\" ng-disabled=\"ab.showSm\"><md-icon md-font-icon=\"school\">school</md-icon>x Store Manager</md-button></div><md-table-container ng-if=\"!ab.eListLoading && ab.eList!=null && ab.eList.length>0\"><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\" border=\"0\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\"><span>{{ ab.storeId?(ab.showSm?\'Store manager\':\'Operatrice\'):\'Centro\'}}</span></th><th md-column=\"\" md-numeric=\"\"><span>n° app. {{ab.env.gp?\'/GP\':\'\'}}</span></th><th md-column=\"\" md-numeric=\"\"><span>Pres.</span></th><th md-column=\"\" md-numeric=\"\"><span>1° v.</span></th><th md-column=\"\" md-numeric=\"\"><span>1° v. Pres.</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>Pos</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>PagoDil</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"ab.env.smallpayEnabled && (!ab.env.currency || ab.env.currency.pos)\"><span>PagoLight</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>Bonifico</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>Assegno</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"ab.env.satispayEnabled && (!ab.env.currency || ab.env.currency.pos)\"><span>SatisPay</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>Gift</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><span>Cassa</span></th><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\"><span>Realizz. ({{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}})</span></th><th md-column=\"\" md-numeric=\"\"><span>Gift emesse ({{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}})</span></th><th md-column=\"\" ng-if=\"!ab.env.currency || ab.env.currency.delta\"></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.delta\"><span>Delta</span></th><th md-column=\"\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\"></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\"><span>R./H</span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"e in ab.eListSm\" ng-if=\"ab.showSm\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><div class=\"operator-circle\" style=\"background-color: {{ e.role.color }};\"></div>&nbsp; <span>{{ e.app_sm_fn }}</span></td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count_all ? e.app_count_all : 0}}{{ (ab.env.gp && e.app_count_gp_all) ? \'/\'+e.app_count_gp_all : (ab.env.gp?\'/0\':\'\')}}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count ? e.app_count : 0}}{{ ab.env.gp && e.app_count_gp ? \'/\'+e.app_count_gp : (ab.env.gp?\'/0\':\'\')}}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count_first_all ? e.app_count_first_all : 0}}{{ ab.env.gp && e.app_count_gp_first_all ? \'/\'+e.app_count_gp_first_all : (ab.env.gp?\'/0\':\'\')}}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count_first ? e.app_count_first : 0}}{{ ab.env.gp && e.app_count_gp_first ? \'/\'+e.app_count_gp_first : (ab.env.gp?\'/0\':\'\')}}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_pos ? e.total_pos:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_dil ? e.total_dil:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"ab.env.smallpayEnabled && (!ab.env.currency || ab.env.currency.pos)\">{{ e.total_small ? e.total_small:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_bon ? e.total_bon:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_check ? e.total_check:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"ab.env.satispayEnabled && (!ab.env.currency || ab.env.currency.pos)\">{{ e.total_satis ? e.total_satis:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_gift ? e.total_gift:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ parseFloat(e.total) + parseFloat(e.total_rel_gift) - parseFloat(e.total_pos) - parseFloat(e.total_dil) - parseFloat(e.total_small) - parseFloat(e.total_satis) - parseFloat(e.total_bon) - parseFloat(e.total_check) - parseFloat(e.total_gift) | number : 2 }}</td><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; background-color: {{ e.operator_id == 0?ab.colorPerc((ab.statistics.realizzatoDay-ab.statistics.obDay)*100/ab.statistics.obDay):\'white\' }};\" ng-click=\"ab.rowClicked(e)\">{{ e.total ? e.total:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ e.operator_id == 0?ab.colorPerc((ab.statistics.realizzatoDayGift-ab.statistics.obDayGift)*100/ab.statistics.obDayGift):\'white\' }};\" ng-click=\"ab.rowClicked(e)\">{{ e.total_rel_gift ? e.total_rel_gift:0 | number : 2 }}</td><td md-cell=\"\" ng-if=\"!ab.env.currency || ab.env.currency.delta\"></td><td md-cell=\"\" ng-if=\"!ab.env.currency || ab.env.currency.delta\" ng-click=\"ab.rowClicked(e)\" style=\"text-align: right; background-color: {{ e.operator_id == 0?ab.colorPerc((e.total - e.total_prev)*100/e.total_prev):\'white\' }};\">{{ e.total - e.total_prev | number : 2 }}</td><td md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\"></td><td md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\" ng-click=\"ab.rowClicked(e)\" style=\'text-align: right; background-color: {{ e.operator_id == 0?ab.colorRH(e.total*60/ab.availabUserData[\"sid_\"+e.store_id][\"id_\" + e.operator_id].minutes):\"white\" }};\'>{{ e.redd_h | number:0 }}</td><td md-cell=\"\" class=\"icon-button\"></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"ab.options.autoSelect\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in ab.eList | orderBy: [\'-operator_id\',\'lastname\']\" ng-if=\"!ab.showSm || e.operator_id == 0\" style=\"{{ e.operator.data.id > 0 || (ab.storeId == 0 && e.store_id!=0) ? \'\' : \'background-color: rgb(217, 217, 217);\' }}\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><div ng-if=\"e.operator.data.id > 0\" class=\"operator-circle\" style=\"background-color: {{ e.operatorRole.data.color }};\"></div>&nbsp; <span ng-if=\"e.operator_id > 0\">{{ e.operator.data.lastname }} {{ e.operator.data.firstname }}</span> <span ng-if=\"e.operator_id == 0 && ab.storeId\">Totale gruppo</span> <span ng-if=\"e.operator_id == 0 && !ab.storeId\">{{e.store.alias}}</span></td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count_all ? e.app_count_all : 0}}{{ (ab.env.gp && e.app_count_gp_all) ? \'/\'+e.app_count_gp_all : (ab.env.gp?\'/0\':\'\')}}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count ? e.app_count : 0}}{{ ab.env.gp && e.app_count_gp ? \'/\'+e.app_count_gp : (ab.env.gp?\'/0\':\'\')}}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count_first_all ? e.app_count_first_all : 0}}{{ ab.env.gp && e.app_count_gp_first_all ? \'/\'+e.app_count_gp_first_all : (ab.env.gp?\'/0\':\'\')}}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\">{{ e.app_count_first ? e.app_count_first : 0}}{{ ab.env.gp && e.app_count_gp_first ? \'/\'+e.app_count_gp_first : (ab.env.gp?\'/0\':\'\')}}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_pos ? e.total_pos:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_dil ? e.total_dil:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"ab.env.smallpayEnabled && (!ab.env.currency || ab.env.currency.pos)\">{{ e.total_small ? e.total_small:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_bon ? e.total_bon:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_check ? e.total_check:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"ab.env.satispayEnabled && (!ab.env.currency || ab.env.currency.pos)\">{{ e.total_satis ? e.total_satis:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total_gift ? e.total_gift:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.rowClicked(e)\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">{{ e.total + e.total_rel_gift - e.total_pos - e.total_dil - e.total_small - e.total_satis - e.total_bon - e.total_check - e.total_gift | number : 2 }}</td><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; background-color: {{ e.operator_id == 0?ab.colorPerc((ab.statistics.realizzatoDay-ab.statistics.obDay)*100/ab.statistics.obDay):\'white\' }};\" ng-click=\"ab.rowClicked(e)\">{{ e.total ? e.total:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right; background-color: {{ e.operator_id == 0?ab.colorPerc((ab.statistics.realizzatoDayGift-ab.statistics.obDayGift)*100/ab.statistics.obDayGift):\'white\' }};\" ng-click=\"ab.rowClicked(e)\">{{ e.total_rel_gift ? e.total_rel_gift:0 | number : 2 }}</td><td md-cell=\"\" ng-if=\"!ab.env.currency || ab.env.currency.delta\"></td><td md-cell=\"\" ng-if=\"!ab.env.currency || ab.env.currency.delta\" ng-click=\"ab.rowClicked(e)\" style=\"text-align: right; background-color: {{ e.operator_id == 0?ab.colorPerc((e.total - e.total_prev)*100/e.total_prev):\'white\' }};\">{{ e.total - e.total_prev | number : 2 }}</td><td md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\"></td><td md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\" ng-click=\"ab.rowClicked(e)\" style=\'text-align: right; background-color: {{ e.operator_id == 0?ab.colorRH(e.total*60/ab.availabUserData[\"sid_\"+e.store_id][\"id_\" + e.operator_id].minutes):\"white\" }};\'>{{ e.total*60/ab.availabUserData[\"sid_\"+e.store_id][\"id_\" + e.operator_id].minutes | number:0 }}</td><td md-cell=\"\" class=\"icon-button\"><md-button ng-if=\"e.operator_id>0 || ab.user.type==\'admin\'\" ng-disabled=\"!ab.perm.canDelete(\'closing_cash\', e)\" class=\"md-icon-button md-warn\" ng-click=\"ab.undo( e )\" aria-label=\"Cancella chiusura\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-container style=\"margin-top: 15px;\" ng-if=\"!ab.eListLoading && ab.availabPresent\"><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"></th><th colspan=\"7\" md-column=\"\" style=\"text-align: center;\">Analisi appuntamenti</th><th md-column=\"\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\"></th><th colspan=\"3\" md-column=\"\" style=\"text-align: center;\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\"><span>Operativit&agrave;</span></th><th md-column=\"\"></th><th colspan=\"2\" md-column=\"\" style=\"text-align: center;\"><span ng-if=\"!ab.env.menu || ab.env.menu.availabilities\">Az. comm. 1 app./40\' liberi</span> <span ng-if=\"ab.env.menu && !ab.env.menu.availabilities\">Azione commerciale rullo</span></th></tr><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\"><span>% Affidab.</span></th><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\"><span>% Spost.</span></th><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>% Non pres.</span></th><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>% Pres.</span></th><th md-column=\"\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\"></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\" class=\"border-left\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\"><span>Disp. H</span></th><th md-column=\"\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\"></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\"><span>% Lav.</span></th><th md-column=\"\"></th><th md-column=\"\" class=\"border-left\"></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><md-icon md-font-icon=\"book\">book</md-icon></th><th ng-if=\"ab.showDeltaRullo\" md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>% &Delta; Rullo</span></th><th ng-if=\"ab.showDeltaRullo\" md-column=\"\"></th></tr></thead><tbody md-body=\"\" ng-init=\"operatorsApps=ab.operatorsAppsValues()\"><tr md-row=\"\" md-select=\"e\" md-auto-select=\"ab.options.autoSelect\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in operatorsApps | orderBy: [\'-operator_id\',\'lastname\']\" ng-if=\"!(ab.storeId == 0 && e.operator.data.id > 0)\" style=\"{{ e.operator.data.id > 0 || (ab.storeId == 0 && e.store_id > 0) ? \'\' : \'background-color: rgb(217, 217, 217);\' }}\" class=\"cash-table-padding\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><div ng-if=\"e.operator.data.id > 0\" class=\"operator-circle\" style=\"background-color: {{ e.operator.data.color }};\"></div>&nbsp; <span ng-if=\"e.operator.data.id > 0\">{{ e.operator.data.lastname }} {{ e.operator.data.firstname }}</span> <span ng-if=\"!ab.storeId && e.operator.data.id <= 0\">{{ e.operator.data.store.alias }}</span> <span ng-if=\"ab.storeId && e.operator.data.id <= 0\">Totale gruppo</span></td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\" ng-click=\"ab.rowClicked(e)\" style=\"background-color: {{ e.operator.data.id<=0?ab.colorAff(e.affidabilita):\'white\' }}\">{{ e.affidabilita | number : 0}}%</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\" ng-click=\"ab.rowClicked(e)\" style=\"text-align: right; background-color: {{ e.operator.data.id<=0?ab.colorSpost(e.app_count_spost_perc):\'white\' }}\">{{ e.app_count_all>0 ? e.app_count_spost_perc : 0 | number : 0}}%</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\" ng-click=\"ab.rowClicked(e)\" style=\"text-align: right;\">{{ e.app_count_all>0 ? e.app_count_nonpres_perc : 0 | number : 0}}%</td><td md-cell=\"\"></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\" class=\"perc\" style=\"background-color: {{ e.operator.data.id<=0?ab.colorPres(e.app_count_pres_perc):\'white\' }}\">{{ e.app_count_all>0 ? e.app_count_pres_perc : 0 | number : 0}}%</td><td md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\"></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\" class=\"perc border-left\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\"><span ng-if=\"e.operator.data.id<=0\">{{ e.availabHours | number: 1}}</span> <span ng-if=\"e.operator.data.id>0\">{{ e.availabDurationFrmt }}</span></td><td md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\"></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\" class=\"perc\" ng-if=\"!ab.env.menu || ab.env.menu.availabilities\">{{ e.workedPerc | number : 0 }}%</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc border-left\"></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\" class=\"perc\" style=\"background-color: {{ ab.colorPerc(e.deltaRulloPerc) }};\">{{ e.numAppDaRullo }}</td><td ng-if=\"ab.showDeltaRullo\" md-cell=\"\" ng-click=\"ab.rowClicked(e)\" class=\"perc\" style=\"background-color: {{ ab.colorPerc(e.deltaRulloPerc) }};\">{{ e.deltaRulloPerc | number : 0 }}%</td><td ng-if=\"ab.showDeltaRullo\" md-cell=\"\"></td></tr></tbody></table></md-table-container><div ng-repeat=\"trending in ab.trendings\"><md-table-container style=\"padding:10px; margin-top: 20px; text-align:center;\" ng-if=\"(!ab.env.menu || ab.env.menu.expcash) && !ab.eListLoading\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" colspan=\"3\" align=\"center\" valign=\"bottom\" bgcolor=\"#0070C0\"><b><font color=\"#FFFFFF\">Andamento e proiezione su obiettivo {{trending.title}}</font></b></td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"width: 33%; border-left: 3px solid #4472c4\" align=\"center\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">Realizzato</font></td><td style=\"width: 33%;\" md-cell=\"\" align=\"center\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">Proiezione</font></td><td md-cell=\"\" style=\"width: 34%; border-right: 3px solid #4472c4; text-align: center;\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">%</font></td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"border-left: 3px solid #4472c4\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><font face=\"Montserrat\" color=\"#FFFFFF\" size=\"6\">{{ trending.real | number : 0}}</font></td><td md-cell=\"\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><i><font face=\"Montserrat\" color=\"#FFFFFF\" size=\"6\">{{ trending.proiezione | number : 0}}</font></i></td><td md-cell=\"\" style=\"border-bottom: 3px solid #4472c4; border-right: 3px solid #4472c4; text-align: center;\" rowspan=\"3\" valign=\"middle\" bgcolor=\"{{ab.colorOb(trending.psaldoperc)}}\"><b><font face=\"Arial Black\" size=\"6\">{{trending.psaldoperc>0?\'+\':\'\'}}{{ trending.psaldoperc | number : 0}}%</font></b></td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"border-left: 3px solid #4472c4\" align=\"center\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">Obiettivo</font></td><td md-cell=\"\" align=\"center\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">Differenza</font></td><td></td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"border-bottom: 3px solid #4472c4; border-left: 3px solid #4472c4\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><i><font face=\"Montserrat\" color=\"#FFFFFF\" size=\"6\">{{ trending.obiettivo | number : 0}}</font></i></td><td md-cell=\"\" style=\"border-bottom: 3px solid #4472c4\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><b><font face=\"Montserrat\" color=\"{{ab.colorOb(trending.psaldoperc)}}\" size=\"6\">{{ trending.psaldo | number : 0}}</font></b></td><td></td></tr></tbody></table></md-table-container></div><md-table-container style=\"padding:10px; margin-top: 20px; text-align:center;\" ng-if=\"(!ab.env.menu || ab.env.menu.expcash) && !ab.eListLoading\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" colspan=\"3\" align=\"center\" valign=\"bottom\" bgcolor=\"#0070C0\"><b><font color=\"#FFFFFF\">Riporto mese precedente</font></b></td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"width: 33%; border-bottom: 3px solid #4472c4; border-left: 3px solid #4472c4\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><i><font face=\"Montserrat\" color=\"#FFFFFF\" size=\"6\"></font></i></td><td md-cell=\"\" style=\"width: 33%; border-bottom: 3px solid #4472c4\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><b><font face=\"Montserrat\" color=\"{{ab.colorPerc(ab.riporto)}}\" size=\"6\">{{ ab.riporto | number : 0}}</font></b></td><td md-cell=\"\" style=\"width: 34%; border-bottom: 3px solid #4472c4; border-right: 3px solid #4472c4\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><i><font face=\"Montserrat\" color=\"#FFFFFF\" size=\"6\"></font></i></td></tr></tbody></table></md-table-container><md-table-container style=\"padding:10px; margin-top: 20px; text-align:center;\" ng-if=\"(!ab.env.menu || ab.env.menu.expcash) && !ab.eListLoading\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" colspan=\"3\" align=\"center\" valign=\"bottom\" bgcolor=\"#0070C0\"><b><font color=\"#FFFFFF\">Andamento delta</font></b></td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"width: 33%; border-left: 3px solid #4472c4\" align=\"center\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">Realizzato</font></td><td style=\"width: 33%;\" md-cell=\"\" align=\"center\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\"></font></td><td md-cell=\"\" style=\"width: 34%; border-right: 3px solid #4472c4; text-align: center;\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">%</font></td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"border-left: 3px solid #4472c4\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><font face=\"Montserrat\" color=\"#FFFFFF\" size=\"6\">{{ ab.delta.realizzato | number : 0}}</font></td><td md-cell=\"\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><i><font face=\"Montserrat\" color=\"#FFFFFF\" size=\"6\"></font></i></td><td md-cell=\"\" style=\"border-bottom: 3px solid #4472c4; border-right: 3px solid #4472c4; text-align: center;\" rowspan=\"3\" valign=\"middle\" bgcolor=\"{{ab.colorPerc(ab.delta.delta_perc)}}\"><b><font face=\"Arial Black\" size=\"6\">{{ab.delta.delta_perc>0?\'+\':\'\'}}{{ ab.delta.delta_perc | number : 0}}%</font></b></td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"border-left: 3px solid #4472c4\" align=\"center\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">Previsto</font></td><td md-cell=\"\" align=\"center\" valign=\"bottom\" bgcolor=\"#404040\"><font color=\"#A6A6A6\">Delta</font></td><td></td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"border-bottom: 3px solid #4472c4; border-left: 3px solid #4472c4\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><i><font face=\"Montserrat\" color=\"#FFFFFF\" size=\"6\">{{ ab.delta.previsto | number : 0}}</font></i></td><td md-cell=\"\" style=\"border-bottom: 3px solid #4472c4\" align=\"center\" valign=\"middle\" bgcolor=\"#404040\"><b><font face=\"Montserrat\" color=\"{{ab.colorPerc(ab.delta.delta_perc)}}\" size=\"6\">{{ ab.delta.delta | number : 0}}</font></b></td><td></td></tr></tbody></table></md-table-container><md-table-container style=\"margin-top: 15px;\" ng-if=\"ab.user.email==\'beppause@gmail.com\' && (!ab.env.menu || ab.env.menu.expcash) && !ab.eListLoading && ab.user.type==\'admin\'\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" style=\"width:20%\">Andamento periodo e proiezione mese</th><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Importo (&euro;)</span></th><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Media (&euro;)/G</span></th><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Redd./H</span></th><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Giorni</span></th><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right\"><span>Ore</span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" class=\"cash-table-padding\"><td md-cell=\"\" class=\"perc\">Realizzato periodo prec.</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.realizzatoPrec | number : 1}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.realizzatoPrec/(ab.statistics.gglav-1) | number : 1}}</td><td md-cell=\"\" colspan=\"7\"></td></tr><tr md-row=\"\" class=\"cash-table-padding\" style=\"background-color: yellow;\"><td md-cell=\"\" class=\"perc\">Per raggiungere obiettivo no gp</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.obiettivo-ab.statistics.gp-ab.statistics.realizzatoPrec | number : 1}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ (ab.statistics.obiettivo-ab.statistics.gp-ab.statistics.realizzatoPrec)/(ab.statistics.ggmese-(ab.statistics.gglav-1)) | number : 1}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\"></td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.ggmese-(ab.statistics.gglav-1) | number : 0}}</td><td md-cell=\"\" colspan=\"3\">a fine mese compreso oggi</td></tr><tr md-row=\"\" class=\"cash-table-padding\"><td md-cell=\"\" class=\"perc\">Realizzato oggi</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.realizzatoDay | number : 1}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\" style=\"background-color: {{ ab.colorPerc((ab.statistics.realizzatoDay-ab.statistics.obDay)*100/ab.statistics.obDay) }};\">{{ (ab.statistics.realizzatoDay-ab.statistics.obDay)*100/ab.statistics.obDay | number:0}}%</td><td md-cell=\"\" colspan=\"7\"></td></tr><tr md-row=\"\" class=\"cash-table-padding\"><td md-cell=\"\" class=\"perc\">Realizz. GP periodo</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.realgp | number : 1}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.realgp/ab.statistics.gglav | number : 1}}</td><td md-cell=\"\" colspan=\"7\"></td></tr><tr md-row=\"\" style=\"background-color: rgb(217, 217, 217);\" class=\"cash-table-padding\"><td md-cell=\"\" class=\"perc\">Tot. realiz. periodo</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.real | number : 1}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.real/ab.statistics.gglav | number : 1}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.realh | number : 0}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.gglav | number : 0}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.hdisp | number : 0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\" class=\"cash-table-padding\"><td md-cell=\"\" class=\"perc\">Obiettivo periodo</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.obiettivo*ab.statistics.gglav/ab.statistics.ggmese | number : 1}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.obiettivo/ab.statistics.ggmese | number : 0}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.obiettivoh | number : 0}}</td><td md-cell=\"\" colspan=\"5\"></td></tr><tr md-row=\"\" class=\"cash-table-padding\"><td md-cell=\"\" class=\"perc\">&Delta; periodo</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\" style=\"background-color: {{ ab.statistics.saldo>0 ? \'rgb(148,192,31)\' : ( ab.statistics.saldo<=0 ? \'rgb(244,67,54)\': \'rgb(217, 217, 217)\') }};\">{{ ab.statistics.saldo | number : 1}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\" style=\"background-color: {{ ab.statistics.psaldoperc>0 ? \'rgb(148,192,31)\' : ( ab.statistics.psaldoperc<0 ? \'rgb(244,67,54)\': \'rgb(217, 217, 217)\') }};\">{{ab.statistics.psaldoperc>0?\'+\':\'\'}}{{ ab.statistics.psaldoperc | number : 0}}%</td><td md-cell=\"\" colspan=\"7\"></td></tr><tr md-row=\"\" class=\"cash-table-padding\" style=\"background-color: yellow;\"><td md-cell=\"\" class=\"perc\">Obiettivo mese</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.obiettivo | number : 1}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.obiettivo/ab.statistics.ggmese | number : 0}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.obiettivoh | number : 0}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.ggmese | number : 0}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.hdispmese | number : 0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\" class=\"cash-table-padding\" style=\"background-color: yellow;\"><td md-cell=\"\" class=\"perc\">Obiettivo mese no gp</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.obiettivo-ab.statistics.gp | number : 1}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ (ab.statistics.obiettivo-ab.statistics.gp)/ab.statistics.ggmese | number : 0}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.obiettivoh | number : 0}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.ggmese | number : 0}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.hdispmese | number : 0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\" class=\"cash-table-padding\"><td md-cell=\"\" class=\"perc\">Proiezione mese</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\">{{ ab.statistics.proiezione | number : 1}}</td><td md-cell=\"\" colspan=\"9\"></td></tr><tr md-row=\"\" class=\"cash-table-padding\"><td md-cell=\"\" class=\"perc\">&Delta; proiezione mese</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\" style=\"background-color: {{ ab.statistics.psaldo>0 ? \'rgb(148,192,31)\' : ( ab.statistics.psaldo<0 ? \'rgb(244,67,54)\': \'rgb(217, 217, 217)\') }};\">{{ ab.statistics.psaldo | number : 1}}</td><td md-cell=\"\"></td><td md-cell=\"\" class=\"perc\" style=\"background-color: {{ ab.statistics.psaldoperc>0 ? \'rgb(148,192,31)\' : ( ab.statistics.psaldoperc<0 ? \'rgb(244,67,54)\': \'rgb(217, 217, 217)\') }};\">{{ab.statistics.psaldoperc>0?\'+\':\'\'}}{{ ab.statistics.psaldoperc | number : 0}}%</td><td md-cell=\"\" colspan=\"7\"></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" style=\"max-width: 75%;\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"{{ ab.env.currency?ab.env.currency.icon:\'attach_money\'}}\">{{ ab.env.currency?ab.env.currency.icon:\'attach_money\'}}</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"!ab.isNewEntity\">Report chisura {{ ab.env.currency?ab.env.currency.label.toLowerCase():\'cassa\'}} {{ ab.activeEntity.operator.data.id>0?\'di \'+ab.activeEntity.operator.data.firstname:\"del centro \" +ab.store.alias}}</span> <span class=\"inset\" ng-if=\"ab.isNewEntity\">Chiusura {{ ab.env.currency?ab.env.currency.label.toLowerCase():\'cassa\'}} {{ ab.activeEntity.operator.data.id>0?\'di \'+ab.activeEntity.operator.data.firstname:\"del centro \" +ab.store.alias}}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><div flex=\"100\"><md-input-container class=\"md-block\"><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\" ng-disabled=\"ab.relLoading\">Annulla</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Chiudi cassa\" ng-click=\"ab.save( ab.activeEntity )\" ng-if=\"ab.isNewEntity\" ng-disabled=\"ab.activeEntity.appointments.length == 0 || ab.relLoading || ab.saving\"><md-icon md-font-icon=\"check\">check</md-icon>Chiudi {{ ab.env.currency?ab.env.currency.label.toLowerCase():\'cassa\'}} {{ab.activeEntity.date | date: \'dd/MM/yyyy\'}}</md-button></md-input-container></div><div layout=\"row\" ng-if=\"!ab.env.closing_cash_form\"><div flex=\"50\" style=\"padding: 20px;\"><md-table-container class=\"cash-sidenav-table\" ng-if=\"!ab.relLoading\"><table md-table=\"\"><thead md-head=\"\"><tr><th colspan=\"2\" style=\"background-color: rgb(227,227,227);\">Totali {{ab.env.currency?ab.env.currency.label.toLowerCase():\'&euro;\'}}</th></tr></thead><tbody md-body=\"\"><tr class=\"odd\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>POS</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_pos | number:2 }}</td></tr><tr class=\"even\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>Bonifico</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_bon | number:2 }}</td></tr><tr class=\"odd\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>Assegno</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_check | number:2 }}</td></tr><tr class=\"even\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>PagoDil</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_dil | number:2 }}</td></tr><tr class=\"odd\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>Gift</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_gift | number:2 }}</td></tr><tr class=\"even\" ng-if=\"!ab.env.currency || ab.env.currency.pos\"><td>Cassa</td><td style=\"text-align:right;\">{{ ab.activeEntity.total + ab.activeEntity.total_rel_gift - ab.activeEntity.total_pos - ab.activeEntity.total_dil - ab.activeEntity.total_small - ab.activeEntity.total_satis - ab.activeEntity.total_bon - ab.activeEntity.total_check - ab.activeEntity.total_gift | number:2 }}</td></tr><tr class=\"odd\" ng-if=\"ab.env.smallpayEnabled && (!ab.env.currency || ab.env.currency.pos)\"><td>PagoLight</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_small | number:2 }}</td></tr><tr class=\"odd\" ng-if=\"ab.env.satispayEnabled && (!ab.env.currency || ab.env.currency.pos)\"><td>SatisPay</td><td style=\"text-align:right;\">{{ ab.activeEntity.total_satis | number:2 }}</td></tr><tr style=\"background-color: rgb(227,227,227);\"><td>Realizz. ({{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}})</td><td style=\"text-align:right;\">{{ ab.activeEntity.total | number:2 }}</td></tr><tr style=\"background-color: rgb(227,227,227);\"><td style=\"border-top: 1px solid rgb(250,250,250) !important;\">Gift emesse ({{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}})</td><td style=\"text-align:right; border-top: 1px solid rgb(250,250,250) !important;\">{{ ab.activeEntity.total_rel_gift | number:2 }}</td></tr></tbody></table></md-table-container></div><div flex=\"50\" style=\"padding: 20px;\" ng-if=\"!ab.env.closing_cash_form\"><md-table-container class=\"cash-sidenav-table\" ng-if=\"!ab.relLoading\"><table md-table=\"\"><thead md-head=\"\"><tr><th colspan=\"{{ab.env.gp?\'3\':\'2\'}}\" style=\"background-color: rgb(227,227,227);\">Conteggio appuntamenti</th></tr><tr ng-if=\"ab.env.gp\"><th></th><th style=\"text-align:right;\">Totale</th><th style=\"text-align:right;\">GP</th></tr></thead><tbody md-body=\"\"><tr class=\"odd\"><td>In agenda</td><td style=\"text-align:right;\">{{ ab.activeEntity.app_count_all }}</td><td ng-if=\"ab.env.gp\" style=\"text-align:right;\">{{ ab.activeEntity.app_count_gp_all }}</td></tr><tr class=\"even\"><td>Presentati</td><td style=\"text-align:right;\">{{ ab.activeEntity.app_count }}</td><td ng-if=\"ab.env.gp\" style=\"text-align:right;\">{{ ab.activeEntity.app_count_gp }}</td></tr><tr class=\"odd\"><td>% Pres.</td><td style=\"text-align:right;\">{{ ab.activeEntity.app_count*100/ab.activeEntity.app_count_all | number:0 }}%</td><td ng-if=\"ab.env.gp\" style=\"text-align:right;\">{{ ab.activeEntity.app_count_gp*100/ab.activeEntity.app_count_gp_all | number:0 }}%</td></tr><tr class=\"even\"><td>Prima volta</td><td style=\"text-align:right;\">{{ ab.activeEntity.app_count_first_all }}</td><td ng-if=\"ab.env.gp\" style=\"text-align:right;\">{{ ab.activeEntity.app_count_gp_first_all }}</td></tr><tr class=\"odd\"><td>Presentati 1a v.</td><td style=\"text-align:right;\">{{ ab.activeEntity.app_count_first }}</td><td ng-if=\"ab.env.gp\" style=\"text-align:right;\">{{ ab.activeEntity.app_count_gp_first }}</td></tr><tr class=\"even\"><td>% Pres. 1a v.</td><td style=\"text-align:right;\">{{ ab.activeEntity.app_count_first*100/ab.activeEntity.app_count_first_all | number:0 }}%</td><td ng-if=\"ab.env.gp\" style=\"text-align:right;\">{{ ab.activeEntity.app_count_gp_first*100/ab.activeEntity.app_count_gp_first_all | number:0 }}%</td></tr></tbody></table></md-table-container></div></div><br><span style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"!ab.env.closing_cash_form && ab.activeEntity.appointments.length == 0 && !ab.relLoading\">Nessun appuntamento trovato.</span> <span style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"!ab.env.closing_cash_form && ab.activeEntity.appointments.length > 0 && !ab.relLoading\">Elenco appuntamenti</span><md-content ng-hide=\"!ab.relLoading\" layout=\"row\" layout-align=\"center center\" style=\"min-height: 80px;\" ng-if=\"!ab.env.closing_cash_form\"><md-progress-circular ng-disabled=\"!ab.relLoading\" md-diameter=\"40\"></md-progress-circular></md-content><md-table-container class=\"addressbook-appointments\" ng-if=\"!ab.relLoading && !ab.env.closing_cash_form\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Op.</th><th md-column=\"\">Cliente</th><th md-column=\"\">Sm</th><th md-column=\"\">Ora</th><th md-column=\"\">Tratt.</th><th md-column=\"\" md-numeric=\"\">Pres.</th><th md-column=\"\" md-numeric=\"\">1° v.</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">Pos</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">Bon.</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">Ass.</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">Gift</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">PDil</th><th md-column=\"\" md-numeric=\"\" ng-if=\"ab.env.smallpayEnabled && (!ab.env.currency || ab.env.currency.pos)\">PLigth</th><th md-column=\"\" md-numeric=\"\" ng-if=\"ab.env.satispayEnabled && (!ab.env.currency || ab.env.currency.pos)\">SatisP</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.pos\">Cassa</th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.delta\">Prev.</th><th md-column=\"\" md-numeric=\"\">Real.</th><th md-column=\"\" md-numeric=\"\">Em. Gift</th><th md-column=\"\" style=\"padding-right: 5px;\" md-numeric=\"\" ng-if=\"!ab.env.currency || ab.env.currency.delta\">Delta</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"appointment in ab.activeEntity.appointments | orderBy: \'date_start\'\" class=\"{{appointment.recalled>=3?\'recalled_\'+appointment.recalled:( appointment.paid? \'\':\'app_notpaid\')}}\"><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ appointment.role.data.color }};\"></div></td><td md-cell=\"\">{{ appointment.customer.data.firstname }} {{ appointment.customer.data.lastname }}</td><td md-cell=\"\"><div class=\"operator-circle\" ng-if=\"appointment.user_id_sm\" style=\"background-color: {{ appointment.roleSm.data.color }};\"></div></td><td md-cell=\"\">{{ appointment.date_start_ora }}</td><td md-cell=\"\">{{ appointment.treatment.data.name }}<md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.customer_subscription_id !== null\">autorenew</md-icon></td><td align=\"center\" md-cell=\"\">{{ appointment.paid?\'Si\' : \'No\' }}</td><td align=\"right\" md-cell=\"\">{{ 2 > appointment.user_times ? \'Si\' : \'No\' }}</td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_pos | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_bon | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_check | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_gift | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_dil | number:2 }}</span></td><td align=\"right\" ng-if=\"ab.env.smallpayEnabled && (!ab.env.currency || ab.env.currency.pos)\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_small | number:2 }}</span></td><td align=\"right\" ng-if=\"ab.env.satispayEnabled && (!ab.env.currency || ab.env.currency.pos)\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.payment_satis | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.pos\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.price - appointment.payment_pos - appointment.payment_dil - appointment.payment_small - appointment.payment_satis - appointment.payment_bon - appointment.payment_check - appointment.payment_gift | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.delta\" md-cell=\"\"><span ng-if=\"appointment.paid\">{{ appointment.pricePrev | number:2 }}</span></td><td align=\"right\" md-cell=\"\"><span ng-if=\"appointment.paid && appointment.treatment_id != 99\">{{ appointment.price | number:2 }}</span></td><td align=\"right\" md-cell=\"\"><span ng-if=\"appointment.paid && appointment.treatment_id == 99\">{{ appointment.price | number:2 }}</span></td><td align=\"right\" ng-if=\"!ab.env.currency || ab.env.currency.delta\" style=\"padding-right: 5px;\" md-cell=\"\"><span ng-if=\"appointment.paid && appointment.treatment_id != 99\">{{ appointment.price-appointment.pricePrev | number:2 }}</span> <span ng-if=\"appointment.paid && appointment.treatment_id == 99\">0,00</span></td></tr></tbody></table></md-table-container></md-content></md-sidenav>");
$templateCache.put("app/cashout/cashout.html","<md-backdrop ng-click=\"ap.closeSidebar()\" ng-show=\"ap.undoVisible\" class=\"md-sidenav-backdrop md-opaque\"></md-backdrop><md-content class=\"page-appointments\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\" flex=\"nogrow\" show-gt-md=\"\"><md-icon md-font-icon=\"money_off\">money_off</md-icon><span class=\"inset\">Uscite di cassa</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo\" ng-click=\"ap.toggleRight()\" ng-disabled=\"!ap.storeId || ap.loading\"><md-icon md-font-icon=\"attach_money\">money_off</md-icon>Nuovo movimento</md-button><md-button class=\"md-accent md-raised\" ng-disabled=\"!ap.storeId || ap.loading\" ng-if=\"ap.user.type==\'admin\'\" ng-href=\"{{ ap.exportUrl }}\"><md-icon md-font-icon=\"save\">save</md-icon>Excel</md-button><md-button class=\"md-accent md-raised\" ng-if=\"ap.user.type==\'admin\'\" ng-disabled=\"!ap.storeId || ap.loading\" ng-href=\"{{ ap.exportZipUrl }}\"><md-icon md-font-icon=\"file_download\">file_download</md-icon>Zip</md-button></div></md-toolbar><md-card><md-card-header style=\"padding-bottom: 6px; padding-top: 6px;\"><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container md-no-float=\"\" class=\"md-accent\" flex=\"40\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ap.query.filter\" ng-keypress=\"ap.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ap.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-datepicker ng-model=\"ap.query.from_date\" md-placeholder=\"Data inizio\" ng-change=\"ap.updateDate()\"></md-datepicker><md-datepicker ng-model=\"ap.query.to_date\" md-placeholder=\"Data fine\" md-min-date=\"ap.query.from_date\" ng-change=\"ap.filterDate()\"></md-datepicker><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar></md-card-header><md-card-content style=\"overflow-y: auto; padding-top: 0px;\"><md-table-container><style>\n                .cashout_table tr td,\n                .cashout_table tr th {\n                    border: solid grey 1px ;\n                }\n\n                </style><table class=\"cashout_table\" md-table=\"\" md-row-select=\"ap.options.rowSelection\" ng-model=\"ap.selected\"><thead md-head=\"\" md-order=\"ap.query.order\" md-on-reorder=\"ap.entitiesListReOrder\"><tr md-row=\"\"><th md-column=\"\" ng-if=\"!ap.storeId\"><span></span></th><th md-column=\"\" ng-if=\"ap.user.type!=\'admin\'\" colspan=\"3\"><span></span></th><th md-column=\"\" ng-if=\"ap.user.type==\'admin\'\" colspan=\"4\"><span></span></th><th md-column=\"\" colspan=\"2\" style=\"text-align: center;\"><span>Entrate</span></th><th md-column=\"\" colspan=\"2\" style=\"text-align: center;\"><span>Uscite</span></th><th md-column=\"\" colspan=\"2\" style=\"text-align: center;\"><span>Saldo</span></th><th md-column=\"\" style=\"text-align: center; width: 22px;\">&nbsp;Elim.</th></tr><tr md-row=\"\"><th md-column=\"\" style=\"width: 150px;\"><span>Data</span></th><th md-column=\"\" ng-if=\"ap.user.type==\'admin\'\" style=\"text-align: center;\"><span>M.</span></th><th md-column=\"\" ng-if=\"!ap.storeId\"><span>Centro</span></th><th md-column=\"\"><span>Causale</span></th><th md-column=\"\"><span>Note</span></th><th md-column=\"\" style=\"text-align: center;\"><span>Contanti</span></th><th md-column=\"\" style=\"text-align: center;\"><span>Assegni</span></th><th md-column=\"\" style=\"text-align: center;\"><span>Contanti</span></th><th md-column=\"\" style=\"text-align: center;\"><span>Assegni</span></th><th md-column=\"\" style=\"text-align: center;\"><span>Contanti</span></th><th md-column=\"\" style=\"text-align: center;\"><span>Assegni</span></th><th md-column=\"\" style=\"text-align: center;\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ap.loading\"><td md-cell=\"\" colspan=\"11\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ap.loading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" ng-repeat=\"cashout in ap.entitiesList\" ng-style=\"cashout.type==\'NC\'?{\'background-color\': \'rgb(244,67,54)\', \'font-weight\': \'bold\'}:{}\"><td md-cell=\"\" ng-style=\"cashout.type==\'NC\'?{\'color\':\'white\'}:{}\"><button ng-if=\"cashout.document\" ng-click=\"ap.openDocument(cashout)\"><md-icon md-font-icon=\"save_alt\" style=\"width: 20px;\">save_alt</md-icon></button>{{ cashout.date_frmt}}</td><td ng-if=\"ap.user.type==\'admin\'\" ng-click=\"ap.showActivities(cashout)\" style=\"text-align: center;\" ng-style=\"cashout.type==\'NC\'?{\'color\':\'white\'}:{}\"><md-icon ng-if=\"cashout.id>0 && cashout.causal_id>0\" title=\"Storico modifiche\" md-font-icon=\"change_history\">change_history</md-icon></td><td md-cell=\"\" ng-if=\"!ap.storeId\" ng-click=\"ap.rowClicked(cashout)\" ng-style=\"cashout.type==\'NC\'?{\'color\':\'white\'}:{}\">{{ cashout.store.data.alias}}</td><td md-cell=\"\" ng-click=\"ap.rowClicked(cashout)\" ng-style=\"cashout.type==\'NC\'?{\'color\':\'white\'}:{}\">{{ cashout.causal.name}}</td><td md-cell=\"\" ng-click=\"ap.rowClicked(cashout)\"><span ng-if=\"cashout.causal_id > 0\">{{ cashout.note }}</span></td><td md-cell=\"\" ng-click=\"ap.rowClicked(cashout)\" style=\"text-align: right\"><span ng-if=\"cashout.causal_id != -1 && cashout.type == \'C\' && cashout.causal.type == \'E\'\">{{ cashout.total | number: 2}} &euro;</span> <span ng-if=\"cashout.causal_id < 0 && cashout.total_cash!=null\">{{ cashout.total_cash | number: 2}} &euro;</span></td><td md-cell=\"\" ng-click=\"ap.rowClicked(cashout)\" style=\"text-align: right\"><span ng-if=\"cashout.causal_id != -1 && cashout.type == \'A\' && cashout.causal.type == \'E\'\">{{ cashout.total | number: 2}} &euro;</span> <span ng-if=\"cashout.causal_id < 0 && cashout.total_check!=null\">{{ cashout.total_check | number: 2}} &euro;</span></td><td md-cell=\"\" ng-click=\"ap.rowClicked(cashout)\" style=\"text-align: right\"><span ng-if=\"cashout.type == \'C\' && cashout.causal.type == \'U\'\">{{ cashout.total | number: 2}} &euro;</span></td><td md-cell=\"\" ng-click=\"ap.rowClicked(cashout)\" style=\"text-align: right\"><span ng-if=\"cashout.type == \'A\' && cashout.causal.type == \'U\'\">{{ cashout.total | number: 2}} &euro;</span></td><td md-cell=\"\" ng-click=\"ap.rowClicked(cashout)\" style=\"text-align: right\"><span ng-if=\"cashout.saldo\">{{ cashout.saldo.C | number: 2}} &euro;</span></td><td md-cell=\"\" ng-click=\"ap.rowClicked(cashout)\" style=\"text-align: right\"><span ng-if=\"cashout.saldo\">{{ cashout.saldo.A | number: 2}} &euro;</span></td><td><md-button class=\"md-icon-button md-warn\" ng-if=\"cashout.id && cashout.id>0 && cashout.causal_id && cashout.causal_id>0\" ng-disabled=\"cashout.date<ap.minModifDate\" ng-click=\"ap.del( cashout )\" aria-label=\"Elimina Movimento\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr><tr md-row=\"\" ng-show=\"ap.entitiesList.length > 0\" style=\"background-color: #D9D9D9;\"><td md-cell=\"\" ng-if=\"ap.user.type!=\'admin\'\" colspan=\"3\" style=\"text-align: right\"><strong>TOTALE ENTRATE/USCITE:</strong></td><td md-cell=\"\" ng-if=\"ap.user.type==\'admin\'\" colspan=\"4\" style=\"text-align: right\"><strong>TOTALE ENTRATE/USCITE:</strong></td><td md-cell=\"\" style=\"text-align: right\">{{ ap.totEntrateC | number: 2}} &euro;</td><td md-cell=\"\" style=\"text-align: right\">{{ ap.totEntrateA | number: 2}} &euro;</td><td md-cell=\"\" style=\"text-align: right\">{{ ap.totUsciteC | number: 2}} &euro;</td><td md-cell=\"\" style=\"text-align: right\">{{ ap.totUsciteA | number: 2}} &euro;</td><td md-cell=\"\" style=\"text-align: right; padding: 0px;\"><md-button class=\"md-raised md-accent\" aria-label=\"scarto\" ng-if=\"ap.deltaEU_C >= 0\">{{ap.deltaEU_C | number: 2}} &euro;</md-button><md-button class=\"md-raised md-warn\" aria-label=\"Scostamento negativo\" ng-if=\"ap.deltaEU_C < 0\">{{ap.deltaEU_C | number: 2}} &euro;</md-button></td><td md-cell=\"\" style=\"text-align: right; padding: 0px;\"><md-button class=\"md-raised md-accent\" aria-label=\"scarto\" ng-if=\"ap.deltaEU_A >= 0\">{{ap.deltaEU_A | number: 2}} &euro;</md-button><md-button class=\"md-raised md-warn\" aria-label=\"Scostamento negativo\" ng-if=\"ap.deltaEU_A < 0\">{{ap.deltaEU_A | number: 2}} &euro;</md-button></td><td></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content><md-sidenav md-is-locked-open=\"ap.undoVisible\" md-whiteframe=\"4\" class=\"page-appointments md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"book\">book</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"!ap.isNewCashout\">Modifica | {{ ap.activeE.causal.data.name}} | id={{ap.activeE.id}}</span> <span class=\"inset\" ng-if=\"ap.isNewCashout\">Crea nuovo movimento</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ap.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"movimentoForm\" id=\"movimentoForm\" layout=\"column\"><div flex=\"100\" layout=\"column\" class=\"fix-margins-3 min-height-60\"><label class=\"md-label\" for=\"date\">Data</label><md-datepicker class=\"md-datepicker-full-width md-datepicker-remove-red-border\" id=\"date\" name=\"date\" md-placeholder=\"Data\" ng-model=\"ap.paymentDateTMP\" md-min-date=\"ap.query.from_date\" md-max-date=\"ap.query.to_date\" required=\"\"></md-datepicker></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"availability\">Causale</label><md-select aria-label=\"Causale\" id=\"causal_id\" name=\"causal_id\" ng-model=\"ap.activeE.causal_id\" ng-change=\"ap.changeCausal()\" ng-disabled=\"!ap.isNewCashout\" required=\"\"><md-option ng-value=\"\'-1\'\" ng-if=\"ap.activeE.causal_id == -1\">Chiusura cassa</md-option><md-option ng-value=\"causal.id\" ng-repeat=\"causal in ap.causaliList track by causal.id\">{{ causal.name}}</md-option></md-select><div ng-messages=\"movimentoForm.availability.$error\" ng-if=\"movimentoForm.availability.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-progress-circular md-diameter=\"30\" ng-if=\"ap.causalsLoading\" md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"note\">Nota</label> <textarea rows=\"2\" ng-disabled=\"ap.activeE.causal_id == -1\" name=\"note\" id=\"note\" ng-model=\"ap.activeE.note\"></textarea></md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"!ap.activeE.id || ap.activeE.causal_id > 0\"><md-input-container class=\"md-block\" flex=\"50\"><md-radio-group id=\"type\" name=\"type\" ng-model=\"ap.activeE.type\"><md-radio-button value=\"C\" ng-disabled=\"true\">Contanti</md-radio-button><md-radio-button value=\"A\" ng-disabled=\"true\">Assegno</md-radio-button></md-radio-group></md-input-container><md-input-container class=\"md-block\" flex=\"50\" style=\"margin-bottom:0px; margin-top:0px;\"><label for=\"total\">Importo (in &euro;)</label> <input type=\"number\" name=\"total\" id=\"total\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeE.total\" ng-model-options=\"ap.filter.options\" required=\"\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"ap.activeE.causal_id == -1\"><md-input-container class=\"md-block\" flex=\"50\" style=\"margin-bottom:0px; margin-top:0px;\"><label for=\"total_cash\">Importo cassa (in &euro;)</label> <input type=\"number\" name=\"total_cash\" id=\"total_cash\" ng-disabled=\"true\" ng-model=\"ap.activeE.total_cash\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\" style=\"margin-bottom:0px; margin-top:0px;\"><label for=\"total_check\">Importo assegni (in &euro;)</label> <input type=\"number\" name=\"total_check\" id=\"total_check\" ng-disabled=\"true\" ng-model=\"ap.activeE.total_check\" ng-model-options=\"ap.filter.options\"></md-input-container></div><div layout=\"row\"><md-input-file-img></md-input-file-img></div><div layout=\"row\"><img ng-if=\"ap.activeE.document_id && ap.activeE.document.type == \'img\'\" src=\"{{ap.env.API}}/documents/{{ap.activeE.document_id}}/download?token={{ap.token}}\" width=\"100%\"></div><br><div layout=\"row\" ng-if=\"ap.activeE.document_id\"><button ng-click=\"ap.downloadDocument();\">{{ ap.activeE.document.file }}</button></div><div flex=\"\"><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ap.update(ap.activeE)\" ng-disabled=\"ap.saving || movimentoForm.$invalid\" ng-if=\"!ap.isNewCashout && ap.activeE.causal_id > 0\"><md-icon md-font-icon=\"check\">check</md-icon>Aggiorna</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ap.save(ap.activeE)\" ng-disabled=\"ap.saving || movimentoForm.$invalid\" ng-if=\"ap.isNewCashout\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ap.undo()\" ng-if=\"ap.undoVisible\">Annulla</md-button><md-progress-circular md-diameter=\"30\" ng-if=\"ap.saving\" md-mode=\"indeterminate\"></md-progress-circular></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/costs/costs.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Costi</span></h2><span flex=\"\" hide-xs=\"\"></span><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" type=\"search\" placeholder=\"Cerca\"> <span flex=\"\" hide-xs=\"\"></span><div><md-select ng-model=\"ab.query.causal_id\" aria-label=\"Causale\" placeholder=\"Causale\" ng-change=\"ab.eListLoad()\"><md-option ng-value=\"undefined\">Tutte</md-option><md-option ng-value=\"causal.id\" ng-repeat=\"causal in ab.causaliList track by causal.id\">{{ causal.name }}</md-option></md-select></div><span flex=\"\" hide-xs=\"\"></span><div><md-select ng-change=\"ab.eListLoad()\" ng-model=\"ab.query.period\" placeholder=\"Periodo\" aria-label=\"Periodo\"><md-option ng-value=\"undefined\">Tutto</md-option><md-option value=\"A\">A</md-option><md-option value=\"B\">B</md-option></md-select></div><span flex=\"\" hide-xs=\"\"></span><div><md-input-container><md-select aria-label=\"Mese\" placeholder=\"Mese\" ng-model=\"ab.query.month\" ng-change=\"ab.eListLoad()\"><md-option ng-value=\"undefined\">Tutti i mesi</md-option><md-option ng-value=\"month.v\" ng-repeat=\"month in ab.MONTHS.months track by month.v\">{{ month.l }}</md-option></md-select></md-input-container></div><span flex=\"\" hide-xs=\"\"></span><div><md-input-container><md-select aria-label=\"Anno\" placeholder=\"Anno\" ng-model=\"ab.query.year\" ng-change=\"ab.eListLoad()\"><md-option ng-value=\"year\" ng-repeat=\"year in ab.years\">{{ year }}</md-option></md-select></md-input-container></div><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo costo\" ng-disabled=\"ab.loading || ab.causaliLoading || !ab.perm.canCreate(\'costs\')\" ng-click=\"ab.toggleRight()\"><md-icon md-font-icon=\"money_off\">money_off</md-icon>Nuovo costo {{ ab.store.alias }}</md-button></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\"><span>Anno</span></th><th md-column=\"\" md-numeric=\"\" style=\"width: 25px;\"><span>Dal</span></th><th md-column=\"\" md-numeric=\"\" style=\"width: 25px;\"><span>Al</span></th><th md-column=\"\" md-numeric=\"\" style=\"width: 10px;\">&nbsp;</th><th md-column=\"\"><span>Mese</span></th><th md-column=\"\" ng-if=\"!ab.storeId\"><span>Centro</span></th><th md-column=\"\"><span>Tipo</span></th><th md-column=\"\" md-order-by=\"causal.data.name\"><span>Causale</span></th><th md-column=\"\"><span>Rif.</span></th><th md-column=\"\"><span>Nota</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"total\"><span>Importo &euro;</span></th><th md-column=\"\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"8\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in (ab.filteredItems = (ab.eList | filter: { $: ab.query.filter } | orderBy: ab.query.order )) track by e.id\" class=\"{{ e.prev?\'row_prev\':\'\' }}\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.year }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.day_from }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.day_to }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.nome_mese }}</td><td md-cell=\"\" ng-if=\"!ab.storeId\" ng-click=\"ab.rowClicked(e)\">{{ e.store.data.alias }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.tipo }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.causal.data.name }}</td><td md-cell=\"\" ng-if=\"e.order_id\" ng-click=\"ab.$state.go(\'home.orderdetails\', {order_id: e.order_id})\">Ordine {{ e.order_id }}</td><td md-cell=\"\" ng-if=\"!e.order_id\"><span ngif=\"e.causal_id == 3 && e.user_id\">{{e.user.data.lastname}} {{e.user.data.firstname}}</span></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.description }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.total ? e.total:0 | number : 2 }}</td><td md-cell=\"\" class=\"icon-button\"><md-button class=\"md-icon-button md-warn\" ng-click=\"ab.del( e.id )\" aria-label=\"Cancella\" ng-if=\"ab.perm.canDelete(\'costs\', e)\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr><tr md-row=\"\" style=\"background-color: #D9D9D9;\" ng-if=\"ab.eList.length>0\"><td colspan=\"8\" md-cell=\"\"></td><td md-cell=\"\" ng-if=\"!ab.storeId\"></td><td md-cell=\"\" style=\"text-align: right\"><strong>Totale &euro;:</strong></td><td md-cell=\"\">{{ ab.eListTotal | number:2 }}</td><td md-cell=\"\"></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"account_circle\">account_circle</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"ab.activeEntity.id!=null\">Modifica costo {{ab.activeEntity.store.data.alias}}:</span> <span class=\"inset\" ng-if=\"ab.activeEntity.id==null\">Nuovo costo {{ab.activeEntity.store.data.alias}}:</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"entityForm\" id=\"entityForm\" layout=\"column\"><div layout=\"row\" layout-align=\"end\" style=\"margin: 5px;\"><div layout=\"row\" class=\"md-block\"><md-button ng-class=\"{\'md-primary\':ab.activeEntity.day_from>0, \'md-accent\':ab.activeEntity.day_from==null,\'md-raised\':true }\" ng-click=\"ab.setPeriodo(ab.activeEntity,null, null)\">Tutto</md-button></div><div layout=\"row\" class=\"md-block\"><md-button ng-class=\"{\'md-primary\':ab.activeEntity.day_from!=1, \'md-accent\':ab.activeEntity.day_from==1,\'md-raised\':true }\" ng-click=\"ab.setPeriodo(ab.activeEntity,1,15)\">A</md-button></div><div layout=\"row\" class=\"md-block\"><md-button ng-class=\"{\'md-primary\':ab.activeEntity.day_from!=16, \'md-accent\':ab.activeEntity.day_from==16,\'md-raised\':true }\" ng-click=\"ab.setPeriodo(ab.activeEntity,16,null)\">B</md-button></div></div><div flex=\"100\" layout=\"row\" class=\"fix-margins-3 min-height-60\" style=\"margin-top: 0px;\"><md-input-container class=\"md-block\" flex=\"30\"><label for=\"year\">Anno</label><md-select required=\"\" id=\"year\" name=\"year\" aria-label=\"Anno\" placeholder=\"Anno\" ng-model=\"ab.activeEntity.year\"><md-option ng-value=\"year\" ng-repeat=\"year in ab.years\">{{year}}</md-option></md-select></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"70\"><label for=\"month\">Mese</label><md-select ng-model=\"ab.activeEntity.month\" aria-label=\"Mese\" id=\"month\" name=\"month\" required=\"\"><md-option ng-value=\"month.v\" ng-repeat=\"month in ab.MONTHS.months track by month.v\">{{ month.l }}</md-option></md-select></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"15\"><label for=\"day_from\">Dal</label> <input type=\"number\" name=\"day_from\" id=\"day_from\" step=\"1\" min=\"1\" ng-disabled=\"\'true\'\" ng-model=\"ab.activeEntity.day_from\"></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"15\"><label for=\"day_to\">Al</label> <input type=\"number\" name=\"day_to\" id=\"day_to\" ng-disabled=\"\'true\'\" step=\"1\" min=\"1\" ng-model=\"ab.activeEntity.day_to\"></md-input-container></div><div layout=\"row\" ng-if=\"!ab.activeEntity.id\"><div flex=\"40\" style=\"margin-top: 25px;\"><md-checkbox name=\"repeat\" ng-model=\"ab.activeEntity.repeat\" ng-change=\"ab.repeatChange()\">Ripeti inserimento</md-checkbox></div><div ng-show=\"ab.activeEntity.repeat\"><md-input-container class=\"md-block\"><label for=\"repeat_month\"># Mesi</label> <input type=\"number\" name=\"repeat_month\" id=\"repeat_month\" step=\"1\" min=\"1\" max=\"60\" ng-model=\"ab.activeEntity.repeat_month\" required=\"\"><div ng-messages=\"entityForm.repeat_month.$error\" ng-show=\"entityForm.repeat_month.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div><div ng-message=\"max\">Il valore massimo &egrave; 60</div><div ng-message=\"min\">Il valore minimo &egrave; 1</div></div></md-input-container></div></div><div><md-input-container class=\"md-block\"><label for=\"causal_id\">Causale</label><md-select ng-model=\"ab.activeEntity.causal_id\" aria-label=\"Causale\" id=\"causal_id\" name=\"causal_id\" required=\"\"><md-option ng-value=\"causal.id\" ng-repeat=\"causal in ab.causaliList track by causal.id\">{{ causal.name }}</md-option></md-select><div ng-messages=\"entityForm.causal_id.$error\" ng-if=\"entityForm.causal_id.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><br></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"30\"><md-radio-group id=\"prev\" name=\"prev\" ng-model=\"ab.activeEntity.prev\"><md-radio-button value=\"0\">Reale</md-radio-button><md-radio-button value=\"1\">Previsto</md-radio-button></md-radio-group></md-input-container><md-input-container class=\"md-block\" flex=\"70\"><label for=\"price\">Importo (in &euro;)</label> <input type=\"number\" name=\"total\" id=\"total\" step=\"0.01\" min=\"0\" ng-model=\"ab.activeEntity.total\" required=\"\"></md-input-container></div><div><md-input-container class=\"md-block\"><label for=\"description\">Nota</label> <textarea maxlength=\"255\" name=\"description\" id=\"description\" rows=\"3\" ng-model=\"ab.activeEntity.description\" md-select-on-focus=\"\"></textarea></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ab.save( ab.activeEntity )\" ng-disabled=\"entityForm.$invalid\" ng-show=\"entityForm.$dirty\"><md-icon md-font-icon=\"check\">check</md-icon>{{ ab.activeEntity.id == null ? \'Salva\' : \'Aggiorna\' }}</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/cusacts/cusacts.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"supervisor_account\">supervisor_account</md-icon><span class=\"inset\">Contatti Rullo</span></h2><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" hide-xs=\"\" hide-sm=\"\"><md-select id=\"user_id\" name=\"user_id\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Operatore\" placeholder=\"Operatore\" ng-model=\"ab.eStatus.userId\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"ab.user.id\" ng-if=\"ab.user.type!=\'callcenter\' && ab.user.type!=\'operator\'\">{{ ab.user.lastname }} {{ ab.user.firstname }}</md-option><md-option ng-value=\"user.id\" ng-repeat=\"user in ab.operatorsFilterList\">{{ user.lastname }} {{ user.firstname }} <span ng-if=\"ab.user.store_id==0 || ab.user.store_id==null\">({{ user.type }})</span></md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><div flex=\"\" hide-xs=\"\"><md-datepicker class=\"md-datepicker-filter-bar\" id=\"filter_date_from\" name=\"filter_date_from\" md-placeholder=\"Da\" md-max-date=\"ab.today\" ng-model=\"ab.eStatus.filter_from\" ng-change=\"ab.eListLoad(1)\"></md-datepicker></div><div flex=\"\" hide-xs=\"\"><md-datepicker class=\"md-datepicker-filter-bar\" id=\"filter_date_to\" name=\"filter_date_to\" md-placeholder=\"A\" md-min-date=\"ab.EStatus.filter_from\" md-max-date=\"ab.today\" ng-model=\"ab.eStatus.filter_to\" ng-change=\"ab.eListLoad(1)\"></md-datepicker></div><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar><md-card><md-card-header><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container flex=\"nogrow\" md-no-float=\"\" hide-xs=\"\" hide-sm=\"\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" ng-keypress=\"ab.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" hide-xs=\"\" hide-sm=\"\"><md-select id=\"fAcchived\" name=\"fArchived\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Inbox o archiviati\" placeholder=\"Inbox o archiviati\" ng-model=\"ab.eStatus.fArchived\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ab.filtersFArchived track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" hide-xs=\"\" hide-sm=\"\"><md-select id=\"call_state_filter\" name=\"call_state_filter\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Stato\" placeholder=\"Stato\" ng-model=\"ab.eStatus.call_state\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"call_state\" ng-repeat=\"call_state in ::ab.call_state track by call_state\">{{ call_state }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" hide-xs=\"\" hide-sm=\"\"><md-select id=\"fClosed\" name=\"fClosed\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Chiusi o non chiusi\" placeholder=\"Chiusi o non chiusi\" ng-model=\"ab.eStatus.fClosed\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ab.filtersFClosed track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar></md-card-header><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"ab.query.order\" md-on-reorder=\"ab.eListReOrder\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"customers.lastname\"><span>Nome</span></th><th md-column=\"\"><md-icon md-font-icon=\"phone_android\">phone_android</md-icon><span>Telefono</span></th><th md-column=\"\" md-order-by=\"customer_actions.created_at\"><span>Data</span></th><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\">Note</th><th md-column=\"\"><span>Stato</span></th><th md-column=\"\"><md-icon md-font-icon=\"today\">today</md-icon><span>Azioni</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.eListLoading\"><td md-cell=\"\" colspan=\"8\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.eListLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"ab.options.autoSelect\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in ab.eList\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><md-icon md-font-icon=\"{{ ab.iconByType(e.type,e.call_type) }}\">{{ ab.iconByType(e.type,e.call_type) }}</md-icon></td><td md-cell=\"\" ng-click=\"ab.removeSearch(e.customer.data.phone)\">{{ e.customer.data.lastname }} {{ e.customer.data.firstname }}</td><td md-cell=\"\"><md-icon ng-click=\"ab.removeSearch(e.customer.data.phone)\" md-font-icon=\"search\">search</md-icon><a href=\"tel:{{ e.customer.data.phone }}\">{{ e.customer.data.phone }}</a></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.created_at_frm }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.user_alias }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><md-icon ng-if=\"e.appointments.data.length>0\" md-font-icon=\"done\">done</md-icon></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><md-icon ng-if=\"e.type == \'call\'\" md-font-icon=\"{{ ab.iconByCategory(e.treatment_category_id) }}\">{{ ab.iconByCategory(e.treatment_category_id) }}</md-icon></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.note }}<md-divider ng-if=\"e.cus_note!=null\"></md-divider>{{ e.cus_note }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\" class=\"first-uppercase\">{{ e.call_state }}</td><td md-cell=\"\" layout=\"row\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Rullo\" ui-sref=\"home.customer( { customer_id : e.customer.data.id } )\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Rubrica\" ui-sref=\"home.addressbook({ phone : e.customer.data.phone })\"><md-icon md-font-icon=\"person\">person</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Prendi nuovo appuntamento\" ng-if=\"!ab.env.isMaster && !e.closed\" ng-href=\"{{ ab.env.booking }}/operator?c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;caid={{e.id}}&amp;store={{ ab.storeId }}&amp;customer={{ e.customer.data.phone }}&amp;token={{ ab.token }}\" target=\"_self\"><md-icon md-font-icon=\"today\">today</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Inserisci Amici\" ng-if=\"!ab.env.isMaster\" ng-href=\"{{ ab.env.booking }}/pf?cph={{ e.customer.data.phone }}&amp;c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;store={{ ab.storeId }}&amp;token={{ ab.token }}\"><md-icon title=\"Inserisci Amici\" md-font-icon=\"card_giftcard\">card_giftcard</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"!ab.eListLoading\" md-limit=\"ab.eListPag.per_page\" md-page=\"ab.eListPag.current_page\" md-total=\"{{ ab.eListPag.total }}\" md-on-paginate=\"ab.eListLoad\" md-boundary-links=\"ab.options.boundaryLinks\"></md-table-pagination></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"{{ ab.iconByType(ab.activeE.type,ab.activeE.call_type) }}\">{{ ab.iconByType(ab.activeE.type,ab.activeE.call_type) }}</md-icon><h2 class=\"md-headline\"><span class=\"inset\">{{ ab.activeE.customer.data.firstname }} {{ ab.activeE.customer.data.lastname }} (cid: {{ ab.activeE.customer.data.id }} / caid: {{ ab.activeE.id }})</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"eForm\" id=\"eActionForm\" layout=\"column\" layout-wrap=\"\"><div layout=\"row\"><div flex=\"50\"><md-input-container><label for=\"phone\">Telefono</label> <input type=\"text\" id=\"phone\" name=\"phone\" ng-disabled=\"true\" ng-model=\"ab.activeE.customer.data.phone\"></md-input-container></div><div flex=\"50\"><md-input-container><label for=\"phone\">Data contatto</label> <input type=\"text\" id=\"created_at\" name=\"created_at\" ng-disabled=\"true\" ng-model=\"ab.activeE.created_at_frm\"></md-input-container></div></div><div layout=\"row\"><div flex=\"50\" ng-if=\"ab.activeE.type == \'call\'\"><p><label for=\"treatment_category_id\">Categoria proposta</label></p><md-radio-group id=\"treatment_category_id\" name=\"treatment_category_id\" aria-label=\"Categoria proposta\" ng-disabled=\"true\" ng-model=\"ab.activeE.treatment_category_id\"><md-radio-button ng-if=\"ab.activeE.treatment_category_id==\'1\'\" value=\"1\">Epilazione</md-radio-button><md-radio-button ng-if=\"ab.activeE.treatment_category_id==\'2\'\" value=\"2\">Viso</md-radio-button><md-radio-button ng-if=\"ab.activeE.treatment_category_id==\'3\'\" value=\"3\">Corpo</md-radio-button></md-radio-group></div><div flex=\"50\" ng-if=\"ab.activeE.type == \'call\'\"><p><label for=\"call_type\">Tipo contatto</label></p><md-radio-group id=\"call_type\" name=\"call_type\" aria-label=\"Tipo contatto\" ng-required=\"true\" ng-model=\"ab.activeE.call_type\"><md-radio-button ng-if=\"ab.activeE.call_type==\'call\'\" value=\"call\">Chiamata</md-radio-button><md-radio-button ng-if=\"ab.activeE.call_type==\'whatsapp\'\" value=\"whatsapp\">Whatsapp</md-radio-button><md-radio-button ng-if=\"ab.activeE.call_type==\'sms\'\" value=\"sms\">Sms</md-radio-button><md-radio-button ng-if=\"ab.activeE.call_type==\'email\'\" value=\"email\">Email</md-radio-button><md-radio-button ng-if=\"ab.activeE.call_type==\'messenger\'\" value=\"messenger\">Messenger</md-radio-button></md-radio-group></div></div><div flex=\"100\"><md-input-container class=\"md-block\"><label for=\"call_state\">Stato cliente</label><md-select id=\"call_state\" name=\"call_state\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"call_state\" ng-model=\"ab.activeE.call_state\" ng-disabled=\"ab.activeE.closed\"><md-option ng-if=\"!ab.activeE.closed\" ng-value=\"call_state\" ng-repeat=\"call_state in ::ab.call_state track by call_state\">{{ call_state }}</md-option><md-option ng-if=\"ab.activeE.closed\" ng-value=\"ab.activeE.call_state\">{{ ab.activeE.call_state }}</md-option></md-select></md-input-container></div><div layout=\"row\"><div flex=\"50\"><md-input-container class=\"md-block\"><label for=\"note\">Nota</label> <textarea rows=\"2\" id=\"note\" name=\"note\" maxlength=\"255\" ng-model=\"ab.activeE.note\" ng-disabled=\"ab.activeE.closed\"></textarea></md-input-container></div><div flex=\"50\" ng-if=\"ab.activeE.type == \'call\'\"><md-input-container class=\"md-block\"><label for=\"cus_note\">Risposta cliente</label> <textarea rows=\"2\" id=\"cus_note\" name=\"cus_note\" maxlength=\"255\" ng-model=\"ab.activeE.cus_note\" ng-disabled=\"ab.activeE.closed\"></textarea></md-input-container></div></div><div flex=\"100\" ng-if=\"!ab.activeE.closed\"><md-progress-circular ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\"><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\" ng-disabled=\"ab.saving\">Annulla</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ab.update( ab.activeCustomerAction, false )\" ng-disabled=\"eForm.$invalid || ab.saving\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva e archivia\" ng-click=\"ab.update( false, true)\" ng-disabled=\"eForm.$invalid || ab.saving\"><md-icon md-font-icon=\"check\">check</md-icon>Salva e archivia</md-button></md-input-container></div><div ng-if=\"!ab.activeE.closed\"><md-input-container class=\"md-block\"><md-button class=\"md-primary md-raised\" aria-label=\"Salva e prendi nuovo appuntamento\" ng-click=\"ab.update( true, false )\" target=\"_self\" ng-disabled=\"eForm.$invalid || ab.saving\"><md-icon md-font-icon=\"today\">today</md-icon>Salva e Crea appuntamento per <strong>{{ ! ab.activeE.customer.data.firstname ? \"Questo utente\" : ab.activeE.customer.data.firstname }}</strong></md-button></md-input-container></div></form><span style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"ab.activeE.appointments.data.length > 0 && !ab.loading\">Appuntamenti collegati</span><md-content ng-hide=\"!ab.loading\" layout=\"row\" layout-align=\"center center\" style=\"min-height: 80px;\"><md-progress-circular ng-disabled=\"!ab.loading\" md-diameter=\"40\"></md-progress-circular></md-content><md-table-container class=\"addressbook-appointments\" ng-if=\"ab.activeE.appointments.data.length > 0 && !ab.loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Op.</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\"><span>Prezzo</span></th><th md-column=\"\"><span>Pres.</span></th><th md-column=\"\"><span>Centro</span></th></tr></thead><tbody md-body=\"\" style=\"font-size: 12px;\"><tr md-row=\"\" ng-repeat=\"appointment in ab.activeE.appointments.data | orderBy: \'-date_start\'\" class=\"{{appointment.recalled>=3?\'recalled_\'+appointment.recalled:( appointment.paid? \'\':\'app_notpaid\')}}\"><td><div class=\"operator-circle\" style=\"background-color: {{ appointment.user_color }};\"></div></td><td>{{ appointment.date_start | date : \'dd/MM/yyyy HH:mm\' }}</td><td>{{ appointment.treatment_id | treatmentIdtoName : ab.treatmentsList }}<md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.customer_subscription_id !== null\">autorenew</md-icon></td><td>{{ appointment.price | number:2 }} €</td><td><span ng-if=\"appointment.paid\">SI</span> <span ng-if=\"!appointment.paid\">NO</span></td><td>{{ appointment.store_id | storeIdtoName : ab.storesList }}</td></tr></tbody></table></md-table-container></md-content></md-sidenav>");
$templateCache.put("app/cuspaym/cuspaym.html","<md-backdrop ng-click=\"ap.closeSidebar()\" ng-show=\"ap.undoVisible\" class=\"md-sidenav-backdrop md-opaque\"></md-backdrop><md-content class=\"page-appointments\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\" flex=\"nogrow\" show-gt-md=\"\"><md-icon md-font-icon=\"alarm\">alarm</md-icon><span class=\"inset\">Scadenziario</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo\" ng-click=\"ap.toggleRight()\"><md-icon md-font-icon=\"collections_bookmark\">alarm_add</md-icon>Nuova scad. rata</md-button></div></md-toolbar><md-card><md-card-header style=\"padding-bottom: 6px; padding-top: 6px;\"><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container md-no-float=\"\" class=\"md-accent\" flex=\"50\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ap.query.filter\" ng-keypress=\"ap.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ap.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-input-container><md-select aria-label=\"Mese\" placeholder=\"Mese\" ng-model=\"ap.query.month\" ng-change=\"ap.entitiesListLoad()\"><md-option ng-value=\"undefined\"></md-option><md-option ng-value=\"\'01\'\">Gennaio</md-option><md-option ng-value=\"\'02\'\">Febbraio</md-option><md-option ng-value=\"\'03\'\">Marzo</md-option><md-option ng-value=\"\'04\'\">Aprile</md-option><md-option ng-value=\"\'05\'\">Maggio</md-option><md-option ng-value=\"\'06\'\">Giugno</md-option><md-option ng-value=\"\'07\'\">Luglio</md-option><md-option ng-value=\"\'08\'\">Agosto</md-option><md-option ng-value=\"\'09\'\">Settembre</md-option><md-option ng-value=\"\'10\'\">Ottobre</md-option><md-option ng-value=\"\'11\'\">Novembre</md-option><md-option ng-value=\"\'12\'\">Dicembre</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container><md-select aria-label=\"Anno\" placeholder=\"Anno\" ng-model=\"ap.query.year\" ng-change=\"ap.entitiesListLoad()\"><md-option ng-value=\"year\" ng-repeat=\"year in ap.years\">{{ year }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar></md-card-header><md-card-content style=\"overflow-y: auto; padding-top: 0px;\"><md-table-container><table md-table=\"\" md-row-select=\"ap.options.rowSelection\" ng-model=\"ap.selected\"><thead md-head=\"\" md-order=\"ap.query.order\" md-on-reorder=\"ap.entitiesListReOrder\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span></span></th><th md-column=\"\"><span>Cliente</span></th><th md-column=\"\"><span>Tel.</span></th><th md-column=\"\"><span>N</span></th><th md-column=\"\" md-numeric=\"\"><span>Rata &euro;</span></th><th md-column=\"\" md-numeric=\"\"><span>Num. rata</span></th><th md-column=\"\" md-numeric=\"\"><span>Residuo &euro;</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"recalled\" class=\"cell-button\" style=\"text-align: center;\"><span>Ricord.</span></th><th md-column=\"\" md-numeric=\"\"><span>Mod. pag.</span></th><th md-column=\"\" md-numeric=\"\"><span>Pagato</span></th><th md-column=\"\" md-numeric=\"\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ap.loading\"><td md-cell=\"\" colspan=\"90\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ap.loading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" md-select=\"appointment\" md-auto-select=\"ap.options.autoSelect\" md-select-id=\"appointment.id\" md-on-select=\"ap.rowClicked\" ng-repeat=\"appointment in ap.entitiesList\"><td md-cell=\"\" ng-click=\"ap.rowClicked( appointment, \'price\')\">{{ appointment.date_frmt }}</td><td md-cell=\"\" ng-click=\"ap.showInfoApps( appointment )\" style=\"text-align: center;\"><img ng-if=\"appointment.f_smallpay\" src=\"assets/images/smallpay_ico.png\" width=\"40px\"><md-icon ng-if=\"!appointment.f_smallpay\" md-font-icon=\"book\">book</md-icon></td><td md-cell=\"\" ng-click=\"ap.filterPhone(appointment.customer.data.phone)\">{{ appointment.customer.data.firstname }} {{ appointment.customer.data.lastname }}</td><td md-cell=\"\"><a href=\"tel:{{ appointment.customer.data.phone }}\">{{ appointment.customer.data.phone }}</a></td><td md-cell=\"\" ng-click=\"ap.showNote( appointment )\"><md-icon title=\"Nota\" md-font-icon=\"event_note\" ng-if=\"appointment.note != null && appointment.note != \'\'\">event_note</md-icon></td><td md-cell=\"\" ng-click=\"ap.rowClicked( appointment, \'price\')\">{{ appointment.total }} &euro;</td><td md-cell=\"\" ng-click=\"ap.rowClicked( appointment, \'price\')\">{{ appointment.num }}/{{ appointment.num_total }}</td><td md-cell=\"\" ng-click=\"ap.rowClicked( appointment, \'price\')\">{{ appointment.remaining }} &euro;</td><td class=\"cell-select\" md-cell=\"\"><md-input-container class=\"md-block\" ng-class=\"{ \'md-warn\' : appointment.recalled == 0, \'md-accent\' : appointment.recalled == 1, \'md-background\' : appointment.recalled == 2, \'md-disd\': appointment.recalled == 3, \'md-spos\': appointment.recalled == 4 && !appointment.sposInDay, \'md-sposInDay\' : appointment.recalled == 4 && appointment.sposInDay, }\"><md-select ng-disabled=\"appointment.recalled==4 || appointment.closed || (ap.user.store_id!=null && appointment.byOperator.data.store_id==0)\" ng-model=\"appointment.recalled\" aria-label=\"Operatrice\" id=\"recalled\" name=\"recalled\" ng-change=\"ap.rememberApSelect( appointment.id, \'{{ appointment.recalled }}\' )\"><md-option ng-value=\"recall_type.value\" ng-repeat=\"recall_type in ap.recall_types track by recall_type.value\">{{ recall_type.text }}</md-option></md-select></md-input-container></td><td md-cell=\"\" ng-click=\"ap.rowClicked( appointment, \'price\')\"><md-icon ng-if=\"appointment.total_paid && (appointment.payment_type==\'P\' || appointment.payment_type==\'S\' || appointment.payment_type==\'M\')\" md-font-icon=\"credit_card\">credit_card</md-icon><md-icon ng-if=\"appointment.total_paid && (appointment.payment_type==\'C\' || appointment.payment_type==\'M\')\" md-font-icon=\"attach_money\">attach_money</md-icon></td><td md-cell=\"\" class=\"cell-select\" style=\"text-align: right\"><md-button class=\"md-raised md-accent\" ng-click=\"ap.rowClicked( appointment, \'price\')\" aria-label=\"Appuntamento Pagato\" ng-if=\"appointment.total_paid\">{{appointment.total_paid}} &euro;</md-button><md-button class=\"md-raised md-warn\" ng-click=\"ap.rowClicked( appointment, \'price\')\" aria-label=\"Appuntamento Non Pagato\" ng-if=\"! appointment.total_paid\">NO</md-button></td><td md-cell=\"\" layout=\"row\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Scheda cliente\" ui-sref=\"home.customer( { customer_id : appointment.customer.data.id } )\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Prendi nuovo appuntamento\" ng-href=\"{{ ap.env.booking }}/operator?c_sid={{ ap.user.store_id }}&amp;c_role={{ ap.user.type }}&amp;store={{ ap.storeId }}&amp;customer={{ appointment.customer.data.phone }}&amp;token={{ ap.token }}\" target=\"_self\"><md-icon md-font-icon=\"today\">today</md-icon></md-button></td></tr><tr md-row=\"\" ng-show=\"ap.entitiesList.length > 0\" style=\"background-color: #D9D9D9;\"><td md-cell=\"\" colspan=\"5\" style=\"text-align: right\"><strong>TOTALE INCASSI PREVISTI:</strong></td><td md-cell=\"\" style=\"text-align: right\">{{ ap.totPrices }} &euro;</td><td md-cell=\"\" colspan=\"4\" style=\"text-align: right\"><strong>TOTALE INCASSI AVVENUTI:</strong></td><td md-cell=\"\" style=\"text-align: right\">{{ ap.totPricesPaid }} &euro;</td><td md-cell=\"\" style=\"text-align: right\"></td></tr><tr md-row=\"\" ng-show=\"ap.entitiesList.length > 0\"><td md-cell=\"\" colspan=\"4\" style=\"text-align: right\"></td><td md-cell=\"\" style=\"text-align: right\"></td><td md-cell=\"\" colspan=\"5\" style=\"text-align: right\"><strong>SCOSTAMENTO INCASSO:</strong></td><td md-cell=\"\" style=\"text-align: right; padding: 0px;\"><md-button class=\"md-raised md-accent\" aria-label=\"scarto\" ng-if=\"ap.deltaPrices>=0\">{{ap.deltaPrices}} &euro;</md-button><md-button class=\"md-raised md-warn\" aria-label=\"Scostamento negativo\" ng-if=\"ap.deltaPrices<0\">{{ap.deltaPrices}} &euro;</md-button></td><td md-cell=\"\" style=\"text-align: right\"></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content><md-sidenav md-is-locked-open=\"ap.undoVisible\" md-whiteframe=\"4\" class=\"page-appointments md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"book\">book</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"!ap.isNewAppointment\">Modifica scadenza rata per {{ ap.activeE.customer.data.firstname ? ap.activeE.customer.data.firstname + \" (cpid:\" + ap.activeE.id + \")\" : \'questo utente\' }}</span> <span class=\"inset\" ng-if=\"ap.isNewAppointment\">Crea nuova scadenza rata</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ap.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"appointmentForm\" id=\"appointmentForm\" layout=\"column\"><div flex=\"100\" layout=\"column\" class=\"fix-margins-3 min-height-60\"><label class=\"md-label\" for=\"treatmentdate\">Data</label><md-datepicker class=\"md-datepicker-full-width md-datepicker-remove-red-border\" id=\"date\" name=\"date\" md-placeholder=\"Data\" ng-model=\"ap.paymentDateTMP\" required=\"\"></md-datepicker></div><div ng-if=\"ap.isNewAppointment\" layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"availability\">Cliente *</label><md-select aria-label=\"Cliente\" id=\"customer_id\" name=\"customer_id\" ng-model=\"ap.customer_id\" ng-model-options=\"ap.filter.options\" ng-disabled=\"ap.customersLoading\" md-container-class=\"with-search\" required=\"\"><md-select-header><span class=\"md-select-search-container\"><input type=\"{{ ap.customersLoading? \'hidden\' : \'search\' }}\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_customer\" name=\"filter_customer\" ng-keydown=\"$event.stopPropagation()\" ng-click=\"$event.stopPropagation()\" ng-keyup=\"ap.onKeyUpCustomersSearch($event, this)\" ng-model=\"ap.query.filter_customer\"></span></md-select-header><md-option ng-value=\"customer.id\" ng-repeat=\"customer in ap.customersList | orderBy: fullName track by customer.id\">{{ customer.fullName }}</md-option></md-select><div ng-messages=\"appointmentForm.availability.$error\" ng-if=\"appointmentForm.availability.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-progress-circular md-diameter=\"30\" ng-if=\"ap.customersLoading\" md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"50\"><label for=\"total\">Importo rata (in &euro;)</label> <input type=\"number\" name=\"total\" id=\"total\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeE.total\" ng-model-options=\"ap.filter.options\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label for=\"total\">Importo residuo (in &euro;)</label> <input type=\"number\" name=\"total\" id=\"total\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeE.remaining\" ng-model-options=\"ap.filter.options\" required=\"\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"50\"><label for=\"total\">Numero rata</label> <input type=\"number\" name=\"total\" id=\"total\" step=\"1\" min=\"1\" ng-model=\"ap.activeE.num\" ng-model-options=\"ap.filter.options\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label for=\"total\">Numero totale rate</label> <input type=\"number\" name=\"total\" id=\"total\" step=\"1\" min=\"1\" ng-model=\"ap.activeE.num_total\" ng-model-options=\"ap.filter.options\" required=\"\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"50\"><md-radio-group id=\"payment_type\" name=\"payment_type\" ng-model=\"ap.activeE.payment_type\"><md-radio-button value=\"C\">Contanti/Assegno/Bonifico</md-radio-button><md-radio-button value=\"P\">Pos/Carta/App</md-radio-button><md-radio-button value=\"S\">PagoLight</md-radio-button><md-radio-button value=\"M\" class=\"md-primary\">Misto</md-radio-button></md-radio-group></md-input-container><md-input-container class=\"md-block\" flex=\"50\" style=\"margin-bottom:0px; margin-top:0px;\"><label for=\"total\">Importo pagato (in &euro;)</label> <input type=\"number\" name=\"total\" id=\"total\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeE.total_paid\" ng-model-options=\"ap.filter.options\"></md-input-container></div><div><md-input-container class=\"md-block\"><label for=\"note\">Note</label> <textarea name=\"note\" id=\"note\" rows=\"2\" ng-model=\"ap.activeE.note\" md-select-on-focus=\"\"></textarea></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ap.update( ap.activeE )\" ng-disabled=\"appointmentForm.$invalid\" ng-if=\"!ap.isNewAppointment\"><md-icon md-font-icon=\"check\">check</md-icon>Aggiorna</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ap.save( ap.activeE )\" ng-disabled=\"appointmentForm.$invalid\" ng-if=\"ap.isNewAppointment\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ap.undo()\" ng-if=\"ap.undoVisible\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/cussubscr/cussubscr.html","<md-content class=\"page-appointments\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Abbonamenti Clienti</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo prodotto\" ng-disabled=\"ab.loading\" ng-click=\"ab.toggleRight()\" ng-if=\"false && ab.env.isMaster && (ab.user.type==\'admin\' || ab.user.type==\'backoffice\')\"><md-icon md-font-icon=\"view_list\">view_list</md-icon>Nuovo abbonamento</md-button><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select aria-label=\"Attivi/Terminati\" placeholder=\"Attivi/Terminati\" ng-model=\"ab.eStatus.selectedFilterActiveTerm\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ab.filtersListActiveTerm track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select aria-label=\"Frequenza\" placeholder=\"Frequenza\" ng-model=\"ab.eStatus.selectedFilterFreq\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ab.filtersListFreq track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select aria-label=\"Ritardo\" placeholder=\"Ritardo\" ng-model=\"ab.eStatus.selectedFilterRit\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ab.filtersListRit track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar><md-card><md-card-header style=\"padding-bottom: 6px; padding-top: 6px;\"><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container md-no-float=\"\" class=\"md-accent\" flex=\"30\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" ng-keypress=\"ab.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><div flex=\"30\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" id=\"filter_date_start\" name=\"filter_date_start\" md-placeholder=\"Data emissione dal\" ng-model=\"ab.eStatus.filter_date_start\" ng-change=\"ab.onChangeDateStart()\"></md-datepicker></div><div flex=\"30\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" id=\"filter_date_end\" name=\"filter_date_end\" md-placeholder=\"Al\" md-min-date=\"ab.eStatus.filter_date_start\" ng-model=\"ab.eStatus.filter_date_end\" ng-change=\"ab.onChangeDateEnd()\"></md-datepicker></div></div></md-toolbar></md-card-header><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"id\"><span>Id</span></th><th md-column=\"\" md-order-by=\"f_over\"><span></span></th><th md-column=\"\" md-order-by=\"customers.lastname\"><span>Cognome</span></th><th md-column=\"\" md-order-by=\"customers.firstname\"><span>Nome</span></th><th md-column=\"\" md-order-by=\"subscriptions.name\"><span>Abb.</span></th><th md-column=\"\" md-order-by=\"created_at\"><span>Creato il</span></th><th md-column=\"\"><span>Ultimo App.</span></th><th md-column=\"\" md-numeric=\"\"><span>Rit.</span></th><th md-column=\"\" md-numeric=\"\"><span>App.</span></th><th md-column=\"\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"9\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular></td><td md-cell=\"\" ng-if=\"ab.user.type == \'backoffice\' || ab.user.type == \'admin\'\"></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in ab.eList\" style=\"{{e.haveFutureApp ?\'background-color: yellow;\':\'\' }}\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.id }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><md-icon ng-if=\"e.f_over || e.app_remaining==0 || (e.zone_total>0 && e.zone_remaining==0)\" md-font-icon=\"done_all\">done_all</md-icon></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.customer.data.lastname }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.customer.data.firstname }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.subscription.data.name }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.created_at}}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.lastappointment?e.lastappointment.date_start_frmt:\'\' }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.lastappointment && !e.haveFutureApp?e.daysLastApp:\'\' }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.app_total-e.app_remaining }}</td><td md-cell=\"\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Filtra\" ng-if=\"ab.query.filter!=e.customer.data.phone\" ng-click=\"ab.query.filter=e.customer.data.phone; ab.eStatus.selectedFilterActiveTerm = null; ab.eStatus.selectedFilterFreq = null; ab.eStatus.selectedFilterRit=null ;ab.eListLoad(1);\"><md-icon md-font-icon=\"filter_list\">filter_list</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Prendi appuntamento\" ng-href=\"{{ ab.env.booking }}/operator?c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;store={{ ab.storeId }}&amp;customer={{ e.customer.data.phone }}&amp;subscr={{ e.id }}&amp;token={{ ab.token }}\" target=\"_self\" ng-disabled=\"e.f_over || e.app_remaining==0 || (e.zone_total>0 && e.zone_remaining==0)\"><md-icon md-font-icon=\"today\">today</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Rullo\" ui-sref=\"home.customer( { customer_id : e.customer_id } )\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button><md-button ng-if=\"!e.f_over && e.app_remaining>0 && e.app_total>e.app_remaining && (e.zone_total==0 || e.zone_remaining>0)\" class=\"md-icon-button md-primary md-raised\" ng-click=\"ab.end( e )\" aria-label=\"Termina\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button><md-button ng-if=\"e.app_total == e.app_remaining\" class=\"md-icon-button md-warn md-raised\" ng-click=\"ab.del( e.id )\" aria-label=\"Cancella\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"! ab.loading\" md-limit=\"ab.eListPag.per_page\" md-limit-options=\"ab.query.limitOptions\" md-page=\"ab.eListPag.current_page\" md-total=\"{{ ab.eListPag.total }}\" md-boundary-links=\"ab.options.boundaryLinks\" md-on-paginate=\"ab.eListLoad\"></md-table-pagination></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"view_list\">view_list</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"ab.activeEntity.id!=null\">Modifica abbonamento (aid: {{ab.activeEntity.id}})</span> <span class=\"inset\" ng-if=\"ab.activeEntity.id==null\">Nuovo abbonamento</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"entityForm\" id=\"entityForm\" layout=\"column\"><div flex=\"100\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"70\"><label class=\"md-label\" for=\"name\">Nome</label> <input id=\"name\" name=\"name\" md-placeholder=\"Nome\" ng-model=\"ab.activeEntity.name\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><md-checkbox id=\"active\" name=\"active\" aria-label=\"Attivo\" ng-model=\"ab.activeEntity.active\" ng-true-value=\"1\" ng-false-value=\"0\">Attivo</md-checkbox></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"30\"><label for=\"qta_xct\">Sedute</label> <input type=\"integer\" name=\"quantity\" id=\"quantity\" step=\"1\" min=\"1\" ng-model=\"ab.activeEntity.quantity\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"70\"><label for=\"price\">Prezzo (in &euro;)</label> <input type=\"number\" name=\"price\" id=\"price\" step=\"0.01\" min=\"0\" ng-model=\"ab.activeEntity.price\" required=\"\"></md-input-container></div><div ng-if=\"!ab.activeEntity.id || ab.activeEntity.name.indexOf(\'Laser\')!=-1\" layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"30\"><label for=\"zone\">Zone</label> <input name=\"zone\" id=\"zone\" ng-model=\"ab.activeEntity.zone\"></md-input-container><md-input-container class=\"md-block\" flex=\"70\"><label for=\"max_app\">Massimo numero sedute compresi richiami</label> <input name=\"max_app\" id=\"max_app\" ng-model=\"ab.activeEntity.max_app\"></md-input-container></div><div flex=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ab.save( ab.activeEntity )\" ng-disabled=\"entityForm.$invalid || ab.saving\" ng-show=\"entityForm.$dirty\"><md-icon md-font-icon=\"check\">check</md-icon>{{ ab.activeEntity.id == null ? \'Salva\' : \'Aggiorna\' }}</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\" ng-disabled=\"ab.saving\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/customer/customer.html","<md-backdrop ng-click=\"ab.closeSidebar()\" ng-show=\"ab.undoVisible && ! ab.isNewCustomer\" class=\"md-sidenav-backdrop md-opaque\"></md-backdrop><md-content class=\"page-customer\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon><span class=\"inset\">{{ab.isRullo?\'Rullo\':\'Scheda\'}}</span></h2><span flex=\"\" hide-xs=\"\"></span><div layout=\"row\"><md-icon md-font-icon=\"person\">person</md-icon><h3>{{ ab.customer.lastname.toUpperCase() }} {{ ab.customer.firstname.toUpperCase() }}</h3></div><span flex=\"\" hide-xs=\"\"></span><div ng-if=\"ab.customer.tot_app>0\" layout=\"row\"><md-icon md-font-icon=\"done\">done</md-icon><span>{{ab.customer.tot_app_paid*100/ab.customer.tot_app | number:0 }}%</span></div><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" ui-sref=\"home.addressbook({ phone : ab.customer.phone })\" ng-disabled=\"ab.loading\"><md-icon md-font-icon=\"person\">person</md-icon>Rubrica</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Calls\" ui-sref=\"home.customer-calls({ customer_id : ab.customer.id })\" ng-disabled=\"ab.loading || ab.customer.off\" ng-if=\"main.user.type == \'admin\'\"><md-icon md-font-icon=\"mic\">mic</md-icon>Calls</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Contatto\" ng-click=\"ab.toggleRight(\'call\', \'Contatto\')\" ng-disabled=\"ab.loading || ab.customer.off\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon>Contatto</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Commento\" ng-click=\"ab.toggleRight(\'comment\', \'Nota\')\" ng-disabled=\"ab.loading\"><md-icon md-font-icon=\"dehaze\">dehaze</md-icon>Nota</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Prossimo\" ng-click=\"ab.prossimo()\" ng-disabled=\"ab.loading\"><md-icon md-font-icon=\"keyboard_arrow_right\">keyboard_arrow_right</md-icon>Next</md-button></div></md-toolbar><md-card><md-card-header style=\"padding-top: 0px; padding-bottom: 0px;\"><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container flex=\"15\" ng-if=\"ab.user.store_id==null\"><md-checkbox ng-model=\"ab.paid\">Gi&agrave; clienti</md-checkbox><md-checkbox ng-model=\"ab.noshow\">Mai pres.</md-checkbox></md-input-container><md-input-container flex=\"15\" ng-if=\"ab.user.store_id!=null\"><md-checkbox ng-model=\"ab.birthdate\">Compleanno</md-checkbox></md-input-container><md-input-container layout=\"row\" flex=\"25\" ng-if=\"ab.user.store_id==null\"><span style=\"margin-right: 10px; text-align: right; vertica-align: bottom;\">{{ab.paid?\'Ultimo app.\':\'Data creazione\'}}:</span><md-select aria-label=\"Dormienti da\" placeholder=\"{{ab.paid?\'Dormienti da\':\'Creati da\'}}\" ng-model=\"ab.dormientiDa\"><md-option ng-if=\"ab.user.type!=\'callcenter\'\" ng-value=\"undefined\">{{ab.paid?\'Dormienti da\':\'Creati da\'}}</md-option><md-option ng-selected=\"ab.dormientiDa && ab.dormientiDa.from==5\" ng-value=\'{ \"from\": 5, \"to\": 12 }\'>da 5 a 12 mesi</md-option><md-option ng-selected=\"ab.dormientiDa && ab.dormientiDa.from==12\" ng-value=\'{ \"from\": 12, \"to\": 999 }\'>oltre 12 mesi</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><div flex=\"20\" layout=\"row\"><a href=\"tel:{{ ab.customer.phone }}\"><h3><md-icon md-font-icon=\"call\">call</md-icon>&nbsp;{{ ab.customer.phone }}</h3></a></div><div flex=\"20\" layout=\"row\" ng-if=\"ab.customer.birthdate\"><h3><img src=\"assets/images/birthdate.svg\" style=\"float: left; width: 24px; !important\">&nbsp;{{ ab.customer.birthdate | date: \'dd/MM/yyyy\'}}</h3></div><div flex=\"30\" layout=\"row\" ng-if=\"ab.customer.off\"><h3><strong>Da non contattare</strong></h3></div><span flex=\"\" hide-xs=\"\"></span><div layout=\"row\"><h3>{{ ab.customer.campaign }}</h3>&nbsp; {{ ab.customer.created_at_frm }} &nbsp;<md-icon ng-if=\"ab.customer.by_user_id != null\" md-font-icon=\"input\">input</md-icon>&nbsp; <span ng-if=\"ab.customer.by!=null && ab.customer.by_user_id>0\">{{ ab.customer.by.data.firstname }} {{ ab.customer.by.data.lastname }}</span> <span ng-if=\"ab.customer.by_user_id == 0\">Online Booking</span></div></div></md-toolbar></md-card-header><md-card-content layout=\"column\"><md-content ng-hide=\"!ab.loading\" layout=\"row\" layout-align=\"center center\" style=\"min-height: 80px;\"><md-progress-circular ng-disabled=\"!ab.loading\" md-diameter=\"40\"></md-progress-circular></md-content><div style=\"padding: 5px;\" layout=\"row\"><div flex=\"45\" style=\"padding: 5px;\"><canvas ng-if=\"!ab.loading\" id=\"charCassaBar\" class=\"chart chart-bar\" chart-data=\"ab.customer.tot\" chart-labels=\"ab.chartCassaBar.labels\" chart-series=\"ab.chartCassaBar.series\" chart-options=\"ab.chartCassaBar.options\"></canvas></div><div flex=\"55\" layout=\"column\" layout-align=\"center\" class=\"rotation-months\" style=\"padding: 5px;\"><div ng-if=\"ab.customer.note\"><h3>Note cliente:</h3><p>{{ab.customer.note}}</p></div><div ng-if=\"!ab.loading\" class=\"md-subhead\" style=\"text-align: center; margin-top: 10px;\"><b>Ultimo anno</b></div><md-table-container ng-if=\"!ab.loading\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td>Epilazione</td><td ng-repeat=\"month in ab.months.data\"><div layout=\"column\"><md-icon ng-if=\"month.flags[0]\" md-font-icon=\"done\">done</md-icon><md-icon ng-if=\"month.calls[0]\" md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon><md-icon ng-if=\"month.nothing(0)\" md-font-icon=\"highlight_off\">highlight_off</md-icon></div></td></tr><tr md-row=\"\"><td>Viso</td><td ng-repeat=\"month in ab.months.data\"><div layout=\"column\"><md-icon ng-if=\"month.flags[1]\" md-font-icon=\"done\">done</md-icon><md-icon ng-if=\"month.calls[1]\" md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon><md-icon ng-if=\"month.nothing(1)\" md-font-icon=\"highlight_off\">highlight_off</md-icon></div></td></tr><tr md-row=\"\"><td>Corpo</td><td ng-repeat=\"month in ab.months.data\"><div layout=\"column\"><md-icon ng-if=\"month.flags[2]\" md-font-icon=\"done\">done</md-icon><md-icon ng-if=\"month.calls[2]\" md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon><md-icon ng-if=\"month.nothing(2)\" md-font-icon=\"highlight_off\">highlight_off</md-icon></div></td></tr><tr md-row=\"\"><td></td><td ng-repeat=\"month in ab.months.data\">{{month.name}}</td></tr></tbody></table></md-table-container><md-table-container ng-if=\"ab.customer.entitytags.data.length>0\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Tipo</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Consegnato</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"etag in ab.customer.entitytags.data | orderBy : \'-tag_id\'\"><td md-cell=\"\"><span ng-if=\"etag.tag_id == 1\">Gold</span> <span ng-if=\"etag.tag_id == 2\">Silver</span> <span ng-if=\"etag.tag_id == 3\">Bronze</span></td><td md-cell=\"\">{{ etag.flagged_at_frmt }}</td><td md-cell=\"\" class=\"cell-button\" style=\"text-align: left;\">{{ etag.flagged?\'Si\':\'No\' }}</td></tr></tbody></table></md-table-container></div></div><div layout=\"row\" flex=\"100\"><md-table-container class=\"rotation-spent\" ng-if=\"ab.appointmentsForCustomer.length > 0 && !ab.loading\" flex=\"100\"><table md-table=\"\" flex=\"100\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>{{ab.env.currency?ab.env.currency.label + \' totali\':\'Spesa totale\'}}</span></th><th md-column=\"\" align=\"center\"><span>Prima volta</span></th><th md-column=\"\">{{ab.customer.firstApp.fromNow}}</th><th md-column=\"\" align=\"center\"><span>Ultima volta</span></th><th md-column=\"\">{{ab.customer.lastApp.fromNow}}</th></tr></thead><tbody><tr md-row=\"\" align=\"center\" class=\"{{ab.customer.firstApp.future?\'row_prev\':\'\'}}\"><td><h1 ng-if=\"!ab.loading\">{{ab.customer.total | number:2 }} {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}} (={{ab.customer.total/ab.customer.tot_app_paid | number:2 }}x{{ab.customer.tot_app_paid}})</h1></td><td><h2>{{ab.customer.firstApp.treatment.name }}</h2></td><td><h2 ng-if=\"!ab.loading\">{{ab.customer.firstApp.date_start | date: \'dd/MM/yyyy\' }}</h2></td><td><h2 ng-if=\"ab.customer.lastApp!=null && ab.customer.lastApp.id!=ab.customer.firstApp.id\">{{ab.customer.lastApp.treatment.name }}</h2></td><td><h2 ng-if=\"ab.customer.lastApp!=null && ab.customer.lastApp.id!=ab.customer.firstApp.id\">{{ab.customer.lastApp.date_start | date: \'dd/MM/yyyy\' }}</h2></td></tr></tbody></table></md-table-container></div><mb-referral-list ng-if=\"ab.env.referralEnabled && !ab.loading && ab.customer_id\" customer=\"ab.customer\" user=\"ab.user\"></mb-referral-list><div layout=\"row\"><div flex=\"50\" style=\"padding: 10px;\" layout=\"column\"><span ng-if=\"!ab.loading && ab.activeCustomer.customer_subscriptions.data.length > 0\" style=\"padding-top: 10px;\" class=\"md-subhead\"><b>Abbonamenti</b></span><md-table-container class=\"rotation-subscriptions\" ng-if=\"!ab.loading && ab.activeCustomer.customer_subscriptions.data.length > 0\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Id</span></th><th md-column=\"\"><span>Creato il</span></th><th md-column=\"\"><span>Abbonamento</span></th><th md-column=\"\" md-numeric=\"\"><span>Sed.</span></th><th md-column=\"\" md-numeric=\"\"><span>S. Res.</span></th><th md-column=\"\" md-numeric=\"\"><span>Zone</span></th><th md-column=\"\" md-numeric=\"\"><span>Z. Res.</span></th><th md-column=\"\" md-numeric=\"\"><span>Azioni</span></th></tr></thead><tbody md-body=\"\" style=\"font-size: 15px;\"><tr md-row=\"\" ng-repeat=\"subscription in ab.activeCustomer.customer_subscriptions.data | orderBy: \'-date_start\'\"><td>{{ subscription.id }}</td><td>{{ subscription.created_at }}</td><td>{{ subscription.subscription_id | subscriptionIdtoName : ab.subscriptionsList }}</td><td md-cell=\"\">{{ subscription.app_total }}</td><td md-cell=\"\">{{ subscription.app_remaining }}</td><td md-cell=\"\">{{ subscription.zone_total>0?subscription.zone_total:\'\' }}</td><td md-cell=\"\">{{ subscription.zone_total>0?subscription.zone_remaining:\'\' }}</td><td md-cell=\"\" style=\"text-align: right;\"><md-button class=\"md-icon-button md-primary md-raised\" ng-if=\"ab.appXSub!=null && ab.appXSub.customer_subscription_id == null && subscription.app_remaining>0 && (subscription.zone_total>0 && ab.appXSub.treatment.zone>0 && subscription.zone_remaining>=ab.appXSub.treatment.zone || subscription.zone_total==0 && ab.appXSub.treatment.zone==0)\" aria-label=\"Aggiungi appuntamento\" ng-click=\"ab.addAppToSub(subscription)\"><strong>+</strong></md-button><md-button class=\"md-icon-button md-primary md-raised\" ng-if=\"ab.appXSub!=null && ab.appXSub.customer_subscription_id == subscription.id\" aria-label=\"Togli appuntamento\" ng-click=\"ab.delAppFromSub(subscription)\"><strong>-</strong></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Elimina abbonamento\" ng-if=\"subscription.app_total == subscription.app_remaining\" ng-click=\"ab.removeSub(subscription)\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></td></tr></tbody></table></md-table-container><div layout=\"row\" ng-if=\"ab.appointmentsForCustomer.length > 0 && !ab.loading\" class=\"align-right\"><span class=\"md-subhead\"><b>Appuntamenti</b></span><md-input-container class=\"align-checkbox\" style=\"margin: 0px;\"><md-checkbox ng-model=\"ab.visNoteApp\">Visualizza Note</md-checkbox></md-input-container><md-input-container class=\"align-checkbox\" style=\"margin: 0px;\"><md-checkbox ng-model=\"ab.onlyPaidApp\">Solo presentati</md-checkbox></md-input-container></div><md-table-container class=\"rotation-appointments\" ng-if=\"ab.appointmentsForCustomer.length > 0 && !ab.loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Op.</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Abb.</span></th><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\" md-numeric=\"\"><span>Zone</span></th><th md-column=\"\"><span></span></th><th md-column=\"\" style=\"text-align: right; padding-right: 20px;\"><span>{{ab.env.currency?ab.env.currency.label:\'Prezzo\'}}</span></th><th md-column=\"\"><span>Pres.</span></th><th md-column=\"\"><span>Centro</span></th></tr></thead><tbody md-body=\"\" style=\"font-size: 15px;\"><tr md-row=\"\" ng-repeat-start=\"appointment in ab.appointmentsForCustomer | orderBy: \'-date_start\'\" class=\"{{ appointment.recalled>=3? \'md-row ng-scope recalled_\'+appointment.recalled +\'\'+ (appointment.f_moved_same_day?\'_same\':\'\'): (appointment.future? \'md-row ng-scope app_future\' : ( appointment.paid? \'md-row ng-scope\':\'md-row ng-scope app_notpaid\') ) }}\" ng-if=\"!ab.onlyPaidApp || appointment.paid && appointment.recalled<3\" ng-click=\"ab.setAppSelected(appointment)\" ng-class=\"{selected: ab.appXSub!=null && appointment.id == ab.appXSub.id}\"><td md-cell=\"\" ng-if=\"!ab.onlyPaidApp || appointment.paid && appointment.recalled<3\"><div class=\"operator-circle\" style=\"background-color: {{ appointment.user_color }};\"></div></td><td md-cell=\"\" ng-if=\"!ab.onlyPaidApp || appointment.paid && appointment.recalled<3\">{{ appointment.date_start | date : \'dd/MM/yyyy\' }}</td><td md-cell=\"\" ng-if=\"!ab.onlyPaidApp || appointment.paid && appointment.recalled<3\"><md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.customer_subscription_id !== null\">autorenew</md-icon><span ng-if=\"appointment.customer_subscription_id !== null\">{{ appointment.customer_subscription_id }}</span></td><td md-cell=\"\" ng-if=\"!ab.onlyPaidApp || appointment.paid && appointment.recalled<3\">{{ appointment.treatment.name }}</td><td md-cell=\"\" ng-if=\"!ab.onlyPaidApp || appointment.paid && appointment.recalled<3\">{{ appointment.treatment.zone>0?appointment.treatment.zone:\'\' }}</td><td md-cell=\"\" ng-if=\"!ab.onlyPaidApp || appointment.paid && appointment.recalled<3\"><div ng-if=\"appointment.paid && appointment.price>0\">{{appointment.payment_type}}<md-icon title=\"{{ appointment.payment_type==\'M\'? \'Misto\':(appointment.payment_type==\'P\'?\'Pos\':(appointment.payment_type==\'D\'?\'Pagodil\':(appointment.payment_type==\'T\'?\'Satispay\':\'Bonifico\')))}}\" md-font-icon=\"credit_card\" ng-if=\"appointment.payment_pos>0.009 || appointment.payment_dil>0.009 || appointment.payment_small>0.009 || appointment.payment_satis>0.009\" ng-class=\"{ \'md-accent\': appointment.payment_type==\'D\' || appointment.payment_type==\'S\' || appointment.payment_type==\'T\', \'md-warn\' : appointment.payment_type==\'M\'}\">credit_card</md-icon><md-icon title=\"Bonifico/Assegno\" md-font-icon=\"account_balance\" ng-if=\"appointment.payment_bon>0.009 || appointment.payment_check>0.009\" ng-class=\"{\'md-warn\' : appointment.payment_type==\'M\'}\">account_balance</md-icon><md-icon title=\"Gift\" md-font-icon=\"card_giftcard\" ng-if=\"appointment.payment_gift>0.009\" ng-class=\"{\'md-warn\' : appointment.payment_type==\'M\'}\">card_giftcard</md-icon></div></td><td md-cell=\"\" ng-if=\"!ab.onlyPaidApp || appointment.paid && appointment.recalled<3\" align=\"right\" style=\"padding-right: 20px;\"><span ng-if=\"appointment.paid\">{{ appointment.price | number:2 }} {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</span></td><td md-cell=\"\" ng-if=\"!ab.onlyPaidApp || appointment.paid && appointment.recalled<3\"><span ng-if=\"appointment.paid\">SI</span> <span ng-if=\"!appointment.paid\">NO</span></td><td md-cell=\"\" ng-if=\"!ab.onlyPaidApp || appointment.paid && appointment.recalled<3\">{{ appointment.store_id | storeIdtoName : ab.storesList }}</td></tr><tr ng-repeat-end=\"\" ng-if=\"ab.visNoteApp && (!ab.onlyPaidApp || appointment.paid && appointment.recalled<3) && (appointment.note || appointment.note_diagnosi)\"><td colspan=\"4\"><i>Nota pre:</i> {{appointment.note}}</td><td colspan=\"5\"><i>Nota post:</i> {{appointment.note_diagnosi}}</td></tr></tbody></table></md-table-container></div><div flex=\"50\" layout=\"column\" style=\"padding: 10px;\" ng-if=\"!ab.loading\"><span class=\"md-subhead\"><b>Azioni</b></span><md-table-container class=\"rotation-actions\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Op.</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\" style=\"text-align: center;\"><span>Cat.</span></th><th md-column=\"\" style=\"text-align: center;\"><span>Tipo</span></th><th md-column=\"\"><span>Note</span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\" style=\"font-size: 15px;\"><tr md-row=\"\" ng-repeat=\"act in ab.activeCustomer.customer_actions.data | orderBy: \'-call_date\'\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\"><td><div ng-if=\"act.user.store_id!=null && act.user.store_id!=0\" class=\"operator-circle\" style=\"background-color: {{ act.user_color }};\"></div><span ng-if=\"act.user.id==0\">Online Booking</span> <span ng-if=\"act.user.id>0\">{{act.user.firstname}} {{act.user.lastname}}</span></td><td>{{ act.call_date | date : \'dd/MM/yyyy HH:mm\' }}</td><td style=\"text-align: center;\"><md-icon ng-if=\"act.type == \'call\'\" md-font-icon=\"{{ ab.iconByCategory(act.treatment_category_id) }}\">{{ ab.iconByCategory(act.treatment_category_id) }}</md-icon></td><td style=\"text-align: center;\"><md-icon md-font-icon=\"{{ ab.iconByType(act.type,act.call_type) }}\">{{ ab.iconByType(act.type,act.call_type) }}</md-icon></td><td><span ng-if=\"act.call_state!=\'\'\">{{ act.call_state }}</span><md-divider ng-if=\"act.note!=null\"></md-divider><span ng-if=\"act.note!=\'\'\">{{ act.note }}</span><md-divider ng-if=\"act.cus_note!=null\"></md-divider><span ng-if=\"act.cus_note!=\'\'\">{{ act.cus_note }}</span></td><td><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Prendi nuovo appuntamento\" ng-disabled=\"(!act.f_oper && act.user_id != ab.user.id)\" ng-if=\"!ab.env.isMaster && act.entity==\'lead\' && !act.f_dup && act.call_state!=\'ha preso appuntamento\' && act.call_state!=\'ha gi� preso appuntamento\'\" ng-href=\"{{ ab.env.booking }}/operator?c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;lead={{act.id}}&amp;store={{ ab.storeId }}&amp;customer={{ ab.customer.phone }}&amp;token={{ ab.token }}\" target=\"_self\"><md-icon md-font-icon=\"today\">today</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Prendi nuovo appuntamento\" ng-if=\"!ab.env.isMaster && act.entity==\'customer_action\' && act.type!=\'pageview\' && act.call_state!=\'ha preso appuntamento\'\" ng-href=\"{{ ab.env.booking }}/operator?c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;caid={{act.id}}&amp;store={{ ab.storeId }}&amp;customer={{ ab.customer.phone }}&amp;token={{ ab.token }}\" target=\"_self\"><md-icon md-font-icon=\"today\">today</md-icon></md-button><md-button ng-if=\"ab.user.type == \'admin\' && act.filename && !act.hide\" class=\"md-icon-button md-primary md-raised\" aria-label=\"Download File\" ng-href=\"{{ ab.env.API }}/customer-calls/download/{{act.id}}?c_role={{ab.user.type}}&on_master={{act.on_master}}&token={{ ab.token }}\"><md-icon md-font-icon=\"file_download\">file_download</md-icon></md-button></td></tr></tbody></table></md-table-container></div></div></md-card-content></md-card></md-content><md-sidenav md-is-locked-open=\"ab.undoVisible && ! ab.isNewCustomer\" md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon><h2 class=\"md-headline\"><span class=\"inset\">{{ ab.commandLabel }}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"customerActionForm\" id=\"customerActionForm\" layout=\"column\" layout-wrap=\"\" ng-if=\"ab.command != \'edit\'\"><div layout=\"row\" ng-if=\"ab.command == \'call\'\"><div flex=\"50\"><md-input-container><label for=\"phone\">Telefono</label> <input type=\"text\" id=\"phone\" name=\"phone\" ng-disabled=\"true\" ng-model=\"ab.activeCustomer.phone\"></md-input-container></div><div flex=\"50\"><md-input-container><label for=\"phone\">Data contatto</label> <input type=\"text\" id=\"created_at\" name=\"created_at\" ng-disabled=\"true\" ng-model=\"ab.activeCustomerAction.created_at_frm\"></md-input-container></div></div><div layout=\"row\" ng-if=\"ab.command == \'call\'\"><div flex=\"50\"><p><label for=\"treatment_category_id\">Categoria proposta *</label></p><md-radio-group id=\"treatment_category_id\" name=\"treatment_category_id\" aria-label=\"Categoria proposta\" ng-required=\"true\" required=\"\" ng-model=\"ab.activeCustomerAction.treatment_category_id\"><md-radio-button value=\"1\">Epilazione</md-radio-button><md-radio-button value=\"2\">Viso</md-radio-button><md-radio-button value=\"3\">Corpo</md-radio-button></md-radio-group></div><div flex=\"50\"><p><label for=\"call_type\">Tipo contatto *</label></p><md-radio-group id=\"call_type\" name=\"call_type\" aria-label=\"Tipo contatto\" ng-required=\"true\" required=\"\" ng-model=\"ab.activeCustomerAction.call_type\"><md-radio-button value=\"call\">Chiamata</md-radio-button><md-radio-button value=\"whatsapp\">Whatsapp</md-radio-button><md-radio-button value=\"sms\">Sms</md-radio-button><md-radio-button value=\"email\">Email</md-radio-button><md-radio-button value=\"messenger\">Messenger</md-radio-button></md-radio-group></div></div><div flex=\"100\"><md-input-container class=\"md-block\"><label for=\"call_state\">Stato cliente</label><md-select id=\"call_state\" name=\"call_state\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"call_state\" ng-model=\"ab.activeCustomerAction.call_state\"><md-option ng-value=\"call_state\" ng-repeat=\"call_state in ::ab.call_state track by call_state\">{{ call_state }}</md-option></md-select></md-input-container></div><div layout=\"row\"><div flex=\"50\"><md-input-container class=\"md-block\"><label for=\"note\">Nota</label> <textarea rows=\"2\" id=\"note\" name=\"note\" maxlength=\"255\" ng-model=\"ab.activeCustomerAction.note\"></textarea></md-input-container></div><div flex=\"50\" ng-if=\"ab.command == \'call\'\"><md-input-container class=\"md-block\"><label for=\"cus_note\">Risposta cliente</label> <textarea rows=\"2\" id=\"cus_note\" name=\"cus_note\" maxlength=\"255\" ng-model=\"ab.activeCustomerAction.cus_note\"></textarea></md-input-container></div></div><div flex=\"100\"><md-progress-circular ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\"><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\" ng-disabled=\"ab.saving\">Annulla</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ab.save( false, false )\" ng-disabled=\"customerActionForm.$invalid || ab.saving\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva e archivia\" ng-click=\"ab.save( false, true)\" ng-disabled=\"customerActionForm.$invalid || ab.saving\"><md-icon md-font-icon=\"check\">check</md-icon>Salva e archivia</md-button></md-input-container></div><div><md-input-container class=\"md-block\"><md-button class=\"md-primary md-raised\" aria-label=\"Salva e prendi nuovo appuntamento\" ng-click=\"ab.save( true, false )\" target=\"_self\" ng-disabled=\"customerActionForm.$invalid || ab.saving\"><md-icon md-font-icon=\"today\">today</md-icon>Salva e Crea appuntamento per <strong>{{ ! ab.activeCustomer.firstname ? \"Questo utente\" : ab.activeCustomer.firstname }}</strong></md-button><md-input-container class=\"md-block\"></md-input-container></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/customer-calls/customer-calls.html","<md-content class=\"page-customer-calls\" layout-fill=\"\"><main><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-12\"><bl-customer-calls-list user=\"ab.user\" customerid=\"ab.customer_id\" token=\"ab.token\"></bl-customer-calls-list></div></div></div></main></md-content>");
$templateCache.put("app/customer-detail/customer-detail.html","<link rel=\"stylesheet\" href=\"assets/css/main.min.css\"><md-content class=\"page-customer-detail\" layout-fill=\"\"><main><div class=\"container-fluid py-4\"><div class=\"row align-items-center\"><div class=\"col-6\"><h2>{{ab.customer.lastname}} {{ab.customer.firstname}}</h2><md-progress-circular md-diameter=\"50\" md-mode=\"indeterminate\" ng-if=\"ab.loading\"></md-progress-circular></div></div></div><div class=\"container-fluid\" ng-if=\"!ab.loading\"><div class=\"row\"><div class=\"col-12\"><div class=\"\"><ul class=\"nav nav-tabs\" id=\"myTab\" role=\"tablist\"><li class=\"nav-item\" role=\"presentation\"><button ng-click=\"ab.currentTab = \'app-tab\'\" ng-class=\"{\'active\': ab.currentTab==\'app-tab\'}\" class=\"nav-link\" id=\"home-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#appuntamenti\" type=\"button\" role=\"tab\" aria-controls=\"appuntamenti\" aria-selected=\"true\">Appuntamenti</button></li><li class=\"nav-item\" role=\"presentation\"><button ng-click=\"ab.currentTab = \'cassa-tab\'; ab.eCustomerQuotationsListLoad(1,10)\" ng-class=\"{\'active\': ab.currentTab==\'cassa-tab\'}\" class=\"nav-link\" id=\"cassa-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#cassa\" type=\"button\" role=\"tab\" aria-controls=\"cassa\" aria-selected=\"false\">Cassa</button></li><li class=\"nav-item\" role=\"presentation\"><button ng-click=\"ab.currentTab = \'anamnesi-tab\'\" ng-class=\"{\'active\': ab.currentTab==\'anamnesi-tab\'}\" class=\"nav-link\" id=\"anamnesi-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#anamnesi\" type=\"button\" role=\"tab\" aria-controls=\"anamnesi\" aria-selected=\"false\">Anamnesi</button></li><li class=\"nav-item\" role=\"presentation\"><button ng-click=\"ab.currentTab = \'storico-tab\'\" ng-class=\"{\'active\': ab.currentTab==\'storico-tab\'}\" class=\"nav-link\" id=\"storico-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#storico\" type=\"button\" role=\"tab\" aria-controls=\"note\" aria-selected=\"false\">Storico</button></li><li class=\"nav-item\" role=\"presentation\"><button ng-click=\"ab.currentTab = \'foto-tab\'\" ng-class=\"{\'active\': ab.currentTab==\'foto-tab\'}\" class=\"nav-link\" id=\"foto-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#foto\" type=\"button\" role=\"tab\" aria-controls=\"foto\" aria-selected=\"false\">Foto</button></li><li class=\"nav-item\" role=\"presentation\"><button ng-click=\"ab.currentTab = \'anagrafica-tab\'\" ng-class=\"{\'active\': ab.currentTab==\'anagrafica-tab\'}\" class=\"nav-link\" id=\"anagrafica-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#anagrafica\" type=\"button\" role=\"tab\" aria-controls=\"note\" aria-selected=\"false\">Anagrafica</button></li></ul><div class=\"tab-content bg-body border border-top-0\"><div ng-if=\"ab.currentTab == \'app-tab\'\" ng-class=\"{\'active\': ab.currentTab == \'app-tab\'}\" class=\"tab-pane\" id=\"appuntamenti\" role=\"tabpanel\" aria-labelledby=\"appuntamenti-tab\"><bl-appointments-list user=\"ab.user\" customer=\"ab.customer\" token=\"ab.token\"></bl-appointments-list></div><div ng-if=\"ab.currentTab == \'preventivi-tab\'\" ng-class=\"{\'active\': ab.currentTab == \'preventivi-tab\'}\" class=\"tab-pane\" id=\"preventivi\" role=\"tabpanel\" aria-labelledby=\"preventivi-tab\"><bm-quotations-list token=\"{{ab.token}}\" customerid=\"{{ab.customer.id}}\"></bm-quotations-list></div><div ng-if=\"ab.currentTab==\'cassa-tab\'\" ng-class=\"{\'active\': ab.currentTab==\'cassa-tab\'}\" class=\"tab-pane\" id=\"cassa\" role=\"tabpanel\" aria-labelledby=\"cassa-tab\"><div class=\"p-3\"><div class=\"row align-items-center mb-3\"><div class=\"col-12\"><h3 class=\"mb-0\">Dati contabili</h3></div></div><div class=\"row\"><div class=\"col-12\"><table style=\"width: 100% !important;\"><thead><tr><th scope=\"col\">Preventivo</th><th scope=\"col\">Data</th><th scope=\"col\" class=\"text-center\">Totale (con sconto già detratto)</th><th scope=\"col\" class=\"text-center\">Saldato</th><th scope=\"col\" class=\"text-end\">Azioni</th></tr></thead><tbody><tr ng-repeat=\"cq in (ab.eCustomerQuotationsList | orderBy: ab.customerQuotationsQuery.order ) track by cq.id\"><td>{{cq.id}}</td><td>{{cq.date_formatted}}</td><td class=\"text-center\">{{cq.price-cq.total_discount}}</td><td class=\"text-center\">cq.min_deposit?</td><td class=\"text-end\"><button ng-click=\"ab.openInsertPaymentModal()\" type=\"button\" class=\"btn btn-primary\" data-bs-toggle=\"modal\"><i class=\"bi bi-credit-card-2-front\"></i> Inserisci pagamento</button></td></tr></tbody></table><nav><ul class=\"pagination justify-content-end mb-0\"><li class=\"page-item disabled\"><a class=\"page-link\" href=\"#\" tabindex=\"-1\" aria-disabled=\"true\">Precedente</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">1</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">Successiva</a></li></ul></nav></div></div></div></div><div ng-if=\"ab.currentTab==\'anamnesi-tab\'\" ng-class=\"{\'active\': ab.currentTab==\'anamnesi-tab\'}\" class=\"tab-pane\" id=\"anamnesi\" role=\"tabpanel\" aria-labelledby=\"anamnesi-tab\"><div class=\"p-3\"><div class=\"row align-items-center mb-3\"><div class=\"col-6\"><h3 class=\"mb-0\">Anamnesi</h3></div></div><new-survey ng-if=\"ab.customer.id\" control=\"customerSurvey\" customerid=\"ab.customer.id\" user=\"ab.user\" token=\"ab.token\" customersurveys=\"ab.customer.customerSurveysV2.data\"></new-survey></div></div><div ng-if=\"ab.currentTab==\'consensi-tab\'\" ng-class=\"{\'active\': ab.currentTab==\'consensi-tab\'}\" class=\"tab-pane\" id=\"consensi\" role=\"tabpanel\" aria-labelledby=\"consensi-tab\"><div class=\"p-3\"><div class=\"row align-items-center mb-3\"><div class=\"col-6\"><h3 class=\"mb-0\">Consensi</h3></div><div class=\"col-6 text-end align-self-end\"><form class=\"row justify-content-end\"><div class=\"col-8\"><input class=\"form-control\" list=\"consensiOptions\" id=\"consensiDataList\" placeholder=\"Digita per selezionare tipo di consenso da creare\"><datalist id=\"consensiOptions\"><option value=\"Privacy\"></option><option value=\"Fotografie\"></option><option value=\"Autocertificazione COVID-19\"></option><option value=\"Botox\"></option><option value=\"Carbossiterapia viso\"></option><option value=\"Carbossiterapia vulvare\"></option><option value=\"Cellule Staminali\"></option><option value=\"Acido ialuronico, Vitamine, Minerali Aminoacidi, Sostanze omeopatiche\"></option><option value=\"Tossina Botulinica\"></option></datalist></div><div class=\"col-auto\"><button type=\"submit\" class=\"btn btn-primary mb-3\">Crea consenso</button></div></form></div></div><div class=\"row\"><div class=\"col-12\"><table style=\"width: 100% !important;\"><thead><tr><th scope=\"col\">Data</th><th scope=\"col\">Tipo documento</th><th scope=\"col\" class=\"text-end\">Azioni</th></tr></thead><tbody><tr><td>22/03/2021</td><td>Privacy (lasciare sempre questi tre modelli?)</td><td class=\"text-end\"><button type=\"button\" class=\"btn btn-primary\"><i class=\"bi bi-file-earmark-text\"></i> Esporta</button> <button type=\"button\" class=\"btn btn-primary\"><i class=\"bi bi-envelope\"></i> Invia</button></td></tr><tr><td>22/03/2021</td><td>Consenso fotografie</td><td class=\"text-end\"><button type=\"button\" class=\"btn btn-primary\"><i class=\"bi bi-file-earmark-text\"></i> Esporta</button> <button type=\"button\" class=\"btn btn-primary\"><i class=\"bi bi-envelope\"></i> Invia</button></td></tr><tr><td>22/03/2021</td><td>Autocertificazione COVID-19</td><td class=\"text-end\"><button type=\"button\" class=\"btn btn-primary\"><i class=\"bi bi-file-earmark-text\"></i> Esporta</button> <button type=\"button\" class=\"btn btn-primary\"><i class=\"bi bi-envelope\"></i> Invia</button></td></tr></tbody></table></div></div></div></div><div ng-if=\"ab.currentTab==\'storico-tab\'\" ng-class=\"{\'active\': ab.currentTab==\'storico-tab\'}\" class=\"tab-pane\" id=\"storico\" role=\"tabpanel\" aria-labelledby=\"storico-tab\"><div class=\"p-3\"><div class=\"row align-items-center mb-3\"><div class=\"col-6\"><h3 class=\"mb-0\">Storico appuntamenti</h3></div></div><div class=\"row\"><div class=\"col-12\"><bm-appointments-history user=\"ab.user\" customer=\"ab.customer\" token=\"ab.token\"></bm-appointments-history></div></div></div></div><div ng-if=\"ab.currentTab==\'foto-tab\'\" ng-class=\"{\'active\': ab.currentTab==\'foto-tab\'}\" class=\"tab-pane\" id=\"foto\" role=\"tabpanel\" aria-labelledby=\"foto-tab\"><bm-pictures-list user=\"ab.user\" customer=\"ab.customer\" token=\"ab.token\"></bm-pictures-list></div><div ng-if=\"ab.currentTab==\'anagrafica-tab\'\" ng-class=\"{\'active\': ab.currentTab==\'anagrafica-tab\'}\" class=\"tab-pane\" id=\"anagrafica\" role=\"tabpanel\" aria-labelledby=\"anagrafica-tab\"><div class=\"p-3\"><div class=\"row align-items-center mb-3\"><div class=\"col-6\"><h3 class=\"mb-0\">Anagrafica</h3></div><div class=\"col-6 text-end\"></div></div><div class=\"row\"><div class=\"col-12\"><div class=\"row g-2\"><div class=\"col-3\"><div class=\"mb-3\"><label for=\"nome\" class=\"form-label\">Nome</label> <input ng-model=\"ab.customer.firstname\" type=\"text\" class=\"form-control\" id=\"nome\" placeholder=\"\"></div></div><div class=\"col-3\"><div class=\"mb-3\"><label for=\"cognome\" class=\"form-label\">Cognome</label> <input ng-model=\"ab.customer.lastname\" type=\"text\" class=\"form-control\" id=\"cognome\" placeholder=\"\"></div></div><div class=\"col-1\"><div class=\"mb-3\"><label for=\"sesso\" class=\"d-block form-label\">Sesso</label><select ng-model=\"ab.customer.gender\" class=\"form-select\" aria-label=\"sesso\"><option selected=\"\">Seleziona</option><option value=\"M\">Uomo</option><option value=\"F\">Donna</option></select></div></div><div class=\"col-1\"><div class=\"mb-3\"><label for=\"nazionalita\" class=\"d-block form-label\">Nazionalità</label><select class=\"form-select\" aria-label=\"nazionalita\"><option selected=\"\">Seleziona</option></select></div></div><div class=\"col-2\"><div class=\"mb-3\"><label for=\"citta-nascita\" class=\"form-label\">Città di nascita</label> <input ng-model=\"ab.customer.birthcity\" type=\"text\" class=\"form-control\" id=\"citta-nascita\" placeholder=\"\"></div></div><div class=\"col-2\"><div class=\"mb-3\"><label for=\"\" class=\"form-label\">Data di nascita</label><div class=\"input-group mb-3\"><input ng-model=\"ab.day_birthdate\" type=\"text\" class=\"form-control\" id=\"\" placeholder=\"gg\"> <input ng-model=\"ab.month_birthdate\" type=\"text\" class=\"form-control\" id=\"\" placeholder=\"mm\"> <input ng-model=\"ab.year_birthdate\" type=\"text\" class=\"form-control\" id=\"\" placeholder=\"aaaa\"></div></div></div></div><div class=\"row g-2\"><div class=\"col-3\"><div class=\"mb-3\"><label for=\"cf\" class=\"form-label\">Codice Fiscale</label> <input ng-model=\"ab.customer.cf\" type=\"text\" class=\"form-control\" id=\"cf\" placeholder=\"\"></div></div><div class=\"col-3\"><div class=\"mb-3\"><label for=\"telefono\" class=\"form-label\">Telefono</label> <input ng-model=\"ab.customer.phone\" type=\"text\" class=\"form-control\" id=\"telefono\" placeholder=\"\"></div></div><div class=\"col-3\"><div class=\"mb-3\"><label for=\"email\" class=\"form-label\">Email</label> <input ng-model=\"ab.customer.email\" type=\"text\" class=\"form-control\" id=\"email\" placeholder=\"\"></div></div><div class=\"col-3\"><div class=\"mb-3\"><label for=\"cap\" class=\"form-label\">Come ci ha conosciuto</label><select ng-model=\"ab.customer.source\" class=\"form-select\" aria-label=\"sesso\"><option selected=\"\">Seleziona</option><option value=\"Lead\">Lead</option><option value=\"Commerciale\">Commerciale</option><option value=\"Porta\">Porta</option><option value=\"PhoneFriends\">Phone friends</option></select></div></div></div><div class=\"row g-2\"><div class=\"col-4\"><div class=\"mb-3\"><label for=\"indirizzo\" class=\"form-label\">Indirizzo</label> <input ng-model=\"ab.customer.address\" type=\"text\" class=\"form-control\" id=\"indirizzo\" placeholder=\"\"></div></div><div class=\"col-2\"><div class=\"mb-3\"><label for=\"cap\" class=\"form-label\">Cap</label> <input ng-model=\"ab.customer.zip_code\" type=\"text\" class=\"form-control\" id=\"cap\" placeholder=\"\"></div></div><div class=\"col-3\"><div class=\"mb-3\"><label for=\"citta\" class=\"form-label\">Città</label> <input ng-model=\"ab.customer.city\" type=\"text\" class=\"form-control\" id=\"citta\" placeholder=\"\"></div></div><div class=\"col-3\"><div class=\"mb-3\"><label for=\"provincia\" class=\"form-label\">Provincia</label><select ng-model=\"ab.customer.province\" class=\"form-select\" aria-label=\"provincia\"><option selected=\"\">Seleziona</option><option value=\"AG\">Agrigento</option><option value=\"AL\">Alessandria</option><option value=\"AN\">Ancona</option><option value=\"AO\">Aosta</option><option value=\"AR\">Arezzo</option><option value=\"AP\">Ascoli Piceno</option><option value=\"AT\">Asti</option><option value=\"AV\">Avellino</option><option value=\"BA\">Bari</option><option value=\"BT\">Barletta-Andria-Trani</option><option value=\"BL\">Belluno</option><option value=\"BN\">Benevento</option><option value=\"BG\">Bergamo</option><option value=\"BI\">Biella</option><option value=\"BO\">Bologna</option><option value=\"BZ\">Bolzano</option><option value=\"BS\">Brescia</option><option value=\"BR\">Brindisi</option><option value=\"CA\">Cagliari</option><option value=\"CL\">Caltanissetta</option><option value=\"CB\">Campobasso</option><option value=\"CI\">Carbonia-iglesias</option><option value=\"CE\">Caserta</option><option value=\"CT\">Catania</option><option value=\"CZ\">Catanzaro</option><option value=\"CH\">Chieti</option><option value=\"CO\">Como</option><option value=\"CS\">Cosenza</option><option value=\"CR\">Cremona</option><option value=\"KR\">Crotone</option><option value=\"CN\">Cuneo</option><option value=\"EN\">Enna</option><option value=\"FM\">Fermo</option><option value=\"FE\">Ferrara</option><option value=\"FI\">Firenze</option><option value=\"FG\">Foggia</option><option value=\"FC\">Forl&igrave;-Cesena</option><option value=\"FR\">Frosinone</option><option value=\"GE\">Genova</option><option value=\"GO\">Gorizia</option><option value=\"GR\">Grosseto</option><option value=\"IM\">Imperia</option><option value=\"IS\">Isernia</option><option value=\"SP\">La spezia</option><option value=\"AQ\">L\'aquila</option><option value=\"LT\">Latina</option><option value=\"LE\">Lecce</option><option value=\"LC\">Lecco</option><option value=\"LI\">Livorno</option><option value=\"LO\">Lodi</option><option value=\"LU\">Lucca</option><option value=\"MC\">Macerata</option><option value=\"MN\">Mantova</option><option value=\"MS\">Massa-Carrara</option><option value=\"MT\">Matera</option><option value=\"VS\">Medio Campidano</option><option value=\"ME\">Messina</option><option value=\"MI\">Milano</option><option value=\"MO\">Modena</option><option value=\"MB\">Monza e della Brianza</option><option value=\"NA\">Napoli</option><option value=\"NO\">Novara</option><option value=\"NU\">Nuoro</option><option value=\"OG\">Ogliastra</option><option value=\"OT\">Olbia-Tempio</option><option value=\"OR\">Oristano</option><option value=\"PD\">Padova</option><option value=\"PA\">Palermo</option><option value=\"PR\">Parma</option><option value=\"PV\">Pavia</option><option value=\"PG\">Perugia</option><option value=\"PU\">Pesaro e Urbino</option><option value=\"PE\">Pescara</option><option value=\"PC\">Piacenza</option><option value=\"PI\">Pisa</option><option value=\"PT\">Pistoia</option><option value=\"PN\">Pordenone</option><option value=\"PZ\">Potenza</option><option value=\"PO\">Prato</option><option value=\"RG\">Ragusa</option><option value=\"RA\">Ravenna</option><option value=\"RC\">Reggio di Calabria</option><option value=\"RE\">Reggio nell\'Emilia</option><option value=\"RI\">Rieti</option><option value=\"RN\">Rimini</option><option value=\"RM\">Roma</option><option value=\"RO\">Rovigo</option><option value=\"SA\">Salerno</option><option value=\"SS\">Sassari</option><option value=\"SV\">Savona</option><option value=\"SI\">Siena</option><option value=\"SR\">Siracusa</option><option value=\"SO\">Sondrio</option><option value=\"TA\">Taranto</option><option value=\"TE\">Teramo</option><option value=\"TR\">Terni</option><option value=\"TO\">Torino</option><option value=\"TP\">Trapani</option><option value=\"TN\">Trento</option><option value=\"TV\">Treviso</option><option value=\"TS\">Trieste</option><option value=\"UD\">Udine</option><option value=\"VA\">Varese</option><option value=\"VE\">Venezia</option><option value=\"VB\">Verbano-Cusio-Ossola</option><option value=\"VC\">Vercelli</option><option value=\"VR\">Verona</option><option value=\"VV\">Vibo valentia</option><option value=\"VI\">Vicenza</option><option value=\"VT\">Viterbo</option></select></div></div></div><div class=\"row\"><div class=\"col-12 text-end\"><button ng-click=\"ab.updateCustomerData(ab.customer)\" class=\"btn btn-primary\">Salva</button></div></div></div></div></div></div></div></div></div></div></div></main></md-content><bm-appointment-sidenav customer=\"ab.customer\"></bm-appointment-sidenav><bm-picture-sidenav customer=\"ab.customer\" user=\"ab.user\" token=\"ab.token\"></bm-picture-sidenav><div class=\"modal fade\" id=\"whatsapp\" tabindex=\"-1\" aria-labelledby=\"whatsapp\" aria-hidden=\"true\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\">Messaggi WhatsApp</h5><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-12 mb-2\"><textarea class=\"form-control\" id=\"exampleFormControlTextarea1\" rows=\"6\"></textarea></div><div class=\"col-12 mb-2\"><textarea class=\"form-control\" id=\"exampleFormControlTextarea1\" rows=\"6\"></textarea></div><div class=\"col-12 mb-2\"><select class=\"form-select\" aria-label=\"template\"><option selected=\"\" disabled=\"\">Scegli template</option><option value=\"\">lorem ipsum dolor</option></select></div></div></div><div class=\"modal-footer text-end\"><button class=\"btn btn-primary\">Invia Messaggio</button></div></div></div></div>");
$templateCache.put("app/customer-pictures/customer-pictures.html","<md-backdrop ng-click=\"ab.closeSidebar()\" ng-show=\"ab.undoVisible && ! ab.isNewCustomer\" class=\"md-sidenav-backdrop md-opaque\"></md-backdrop><md-content class=\"page-customer-picture\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"collections\">collections</md-icon><span class=\"inset\">Foto Cliente</span></h2><span flex=\"\" hide-xs=\"\"></span><div layout=\"row\"><md-icon md-font-icon=\"person\">person</md-icon><h3>{{ ab.customer.lastname.toUpperCase() }} {{ ab.customer.firstname.toUpperCase() }}</h3></div><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" ng-click=\"ab.toggleRight(\'createPicture\', \'Inserisci Foto\')\" ng-disabled=\"ab.loading\"><md-icon md-font-icon=\"add\">add</md-icon>Inserisci Foto</md-button></div></md-toolbar><md-card class=\"previews-container\"><md-content ng-hide=\"!ab.loading\" layout=\"row\" layout-align=\"center center\" style=\"min-height: 80px;\"><md-progress-circular ng-disabled=\"!ab.loading\" md-diameter=\"40\"></md-progress-circular></md-content><md-card-content ng-hide=\"ab.loading\" class=\"main-container\"><div layout=\"row\" style=\"height: 100%\"><div flex=\"50\" ng-if=\"ab.imageZoom1 == null\" class=\"zoom-empty zoom-left\"><p><img src=\"/assets/images/placeholder-240x164.jpg\"><br><br>Seleziona una foto in basso o caricane una!</p></div><div flex=\"50\" ng-if=\"ab.imageZoom1 != null\" class=\"zoom-left\"><a class=\"md-icon-button md-primary md-raised md-button md-ink-ripple close-icon\" aria-label=\"Rimuovi Foto\" ng-click=\"ab.removeZoomImage(1)\"><md-icon md-font-icon=\"close\" title=\"Rimuovi Foto\" class=\"ng-scope md-font material-icons close\" role=\"img\" aria-hidden=\"true\">close</md-icon><div class=\"md-ripple-container\"></div></a><div class=\"image-zoom-details {{(ab.imageZoom1[\'parameter\'] && ab.imageZoom1[\'parameter\'] == \'1\') ? \'preview-before\' : \'preview-after\'}}\">{{ab.imageZoom1[\'date\']}} <span ng-if=\"ab.imageZoom1[\'treatment\']\">{{\' - \' + ab.imageZoom1[\'treatment\'][\'name\']}}</span></div><img src=\"{{ab.imageZoom1[\'api_url\']}}\" id=\"zoom-image-1\"></div><div flex=\"50\" ng-if=\"ab.imageZoom2 == null\" class=\"zoom-empty zoom-right\"><p><img src=\"/assets/images/placeholder-240x164.jpg\"><br><br>Seleziona una foto in basso o caricane una!</p></div><div flex=\"50\" ng-if=\"ab.imageZoom2 != null\" class=\"zoom-right\"><a class=\"md-icon-button md-primary md-raised md-button md-ink-ripple close-icon\" aria-label=\"Rimuovi Foto\" ng-click=\"ab.removeZoomImage(2)\"><md-icon md-font-icon=\"close\" title=\"Rimuovi Foto\" class=\"ng-scope md-font material-icons close\" role=\"img\" aria-hidden=\"true\">close</md-icon><div class=\"md-ripple-container\"></div></a><div class=\"image-zoom-details {{(ab.imageZoom2[\'parameter\'] && ab.imageZoom2[\'parameter\'] == \'1\') ? \'preview-before\' : \'preview-after\'}}\">{{ab.imageZoom2[\'date\']}} <span ng-if=\"ab.imageZoom2[\'treatment\']\">{{\' - \' + ab.imageZoom2[\'treatment\'][\'name\']}}</span></div><img src=\"{{ab.imageZoom2[\'api_url\']}}\" id=\"zoom-image-2\"></div></div></md-card-content></md-card><footer class=\"footer blue pt-4\"><div class=\"thumbnail-container\"><ul class=\"thumbnail-list\"><li ng-repeat=\"picture in ab.pictures track by $index\"><div class=\"image-box\" id=\"image-preview-box-{{$index}}\"><a class=\"md-icon-button md-primary md-raised md-button md-ink-ripple close-icon\" aria-label=\"Rimuovi Foto\" ng-click=\"ab.del(picture)\"><md-icon md-font-icon=\"close\" title=\"Elimina Foto\" class=\"ng-scope md-font material-icons close\" role=\"img\" aria-hidden=\"true\">close</md-icon><div class=\"md-ripple-container\"></div></a> <img src=\"{{picture[\'api_url\']}}\" ng-click=\"ab.zoomImage(picture, $index)\" class=\"image-preview\"><div class=\"image-preview-details {{(picture[\'parameter\'] && picture[\'parameter\'] == \'1\') ? \'preview-before\' : \'preview-after\'}}\">{{picture[\'date\']}} <span ng-if=\"picture[\'treatment\']\">{{\' - \' + picture[\'treatment\'][\'name\']}}</span></div><md-progress-circular md-diameter=\"40\" class=\"image-preview-spinner\"></md-progress-circular></div></li></ul></div></footer><a class=\"float-button\" ng-click=\"ab.showPopupInfo()\"><md-icon md-font-icon=\"info\" title=\"Info\" class=\"ng-scope md-font material-icons info my-float-button\" role=\"img\" aria-hidden=\"true\">info</md-icon><div class=\"md-ripple-container\"></div></a></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"collections\">collections</md-icon><h2 class=\"md-headline\"><span class=\"inset\">{{ ab.commandLabel }}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"createPictureAction\" id=\"createPictureAction\" layout=\"column\" layout-wrap=\"\"><div flex=\"100\"><md-input-container class=\"md-block\"><label for=\"appointment_id\">Appuntamento</label><md-select id=\"appointment_id\" name=\"appointment_id\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"appointment_id\" ng-change=\"ab.setCreationDate()\" ng-model=\"ab.createPictureAction.appointment_id\"><md-option ng-value=\"\"></md-option><md-option ng-value=\"appointment.id\" ng-repeat=\"appointment in ab.customer.appointments.data track by appointment.id\">{{ appointment.date_start | toDate | date:\'dd/MM/yyyy HH:mm\' }} - {{ appointment.treatment.name }}</md-option></md-select></md-input-container></div><div layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><md-radio-group id=\"parameter\" name=\"parameter\" aria-label=\"Foto Scattata\" ng-required=\"true\" required=\"\" ng-model=\"ab.createPictureAction.parameter\"><md-radio-button value=\"1\">Foto Scattata prima dell\'appuntamento</md-radio-button><md-radio-button value=\"2\">Foto Scattata dopo l\'appuntamento</md-radio-button></md-radio-group></md-input-container></div></div><div layout=\"row\"><div flex=\"100\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" id=\"date\" name=\"date\" md-placeholder=\"Data\" ng-required=\"true\" required=\"\" ng-model=\"ab.createPictureAction.date\" style=\"margin-left: 0px;\"></md-datepicker></div></div><div layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><md-input-file-img multiple=\"true\" accept=\"image/*\"></md-input-file-img></md-input-container></div></div><div layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><label for=\"description\">Descrizione</label> <textarea rows=\"2\" id=\"description\" name=\"description\" maxlength=\"255\" ng-model=\"ab.createPictureAction.description\"></textarea></md-input-container></div></div><div flex=\"100\"><md-progress-circular ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\"><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\" ng-disabled=\"ab.saving\">Annulla</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ab.save(createPictureAction)\" ng-disabled=\"createPictureAction.$invalid || ab.saving\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/customer-quotations/customer-quotations.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"content_paste\">content_paste</md-icon><span class=\"inset\">Preventivi</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo preventivo\" ng-disabled=\"ab.loading || ab.customersLoading\" ng-click=\"ab.toggleRight()\"><md-icon md-font-icon=\"content_paste\">content_paste</md-icon>Nuovo Preventivo</md-button></div></md-toolbar><md-card><md-card-header><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container flex=\"60\" md-no-float=\"\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" ng-keypress=\"ab.onKeyPressSearch($event)\" placeholder=\"Cerca\"></md-input-container><md-input-container flex=\"20\" style=\"margin-left: 20px;\" md-no-float=\"\"><md-icon md-font-icon=\"search\">search</md-icon><md-select aria-label=\"Stato\" placeholder=\"Stato\" ng-change=\"ab.onKeyPressSearch($event)\" ng-model=\"ab.query.status\"><md-option value=\"\">tutti</md-option><md-option value=\"draft\">bozza</md-option><md-option value=\"signed\">sottoscritto</md-option></md-select></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div></div></md-toolbar></md-card-header></md-card><md-card><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\"><span>Id</span></th><th md-column=\"\" md-order-by=\"date\"><span>Data</span></th><th md-column=\"\"><span>Cliente</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"total\"><span>Importo &euro;</span></th><th md-column=\"\" md-numeric=\"\"><span>Sconto</span></th><th md-column=\"\" md-numeric=\"\"><span>Totale &euro;</span></th><th md-column=\"\" md-numeric=\"\"><span>Stato</span></th><th md-column=\"\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"6\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in (ab.filteredItems = (ab.eList | orderBy: ab.query.order )) track by e.id\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.id }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.date_formatted }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.customer.firstname + \" \" + e.customer.lastname }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.price? e.price : 0 | number : 2 }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.discount? e.discount : 0 | number : 2 }}%</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ (e.price - ((e.price * e.discount) / 100) ) | number : 2 }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ ab.getStatusName(e.status) }}</td><td md-cell=\"\" class=\"icon-button\"><md-button class=\"md-icon-button md-primary md-raised\" ng-click=\"ab.openDocumentPage( e.id, ab.env.API + \'/signed-quotations/?customer_quotation_id=\' + e.id + \'&token=\' + ab.token )\" target=\"_blank\" aria-label=\"Firma\" ng-if=\"e.status == \'draft\'\"><md-icon md-font-icon=\"border_color\" style=\"font-size: 20px\">border_color</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" ng-click=\"ab.openEmailPopup(e)\" aria-label=\"Invia Email\" ng-if=\"e.status == \'draft\'\"><md-icon md-font-icon=\"email\" style=\"font-size: 20px\">email</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" ng-href=\"{{ ab.env.API }}/documents/{{e.document.id}}/download?token={{ ab.token }}\" aria-label=\"Scarica PDF\" ng-if=\"e.status == \'signed\' && e.document\"><md-icon md-font-icon=\"get_app\">get_app</md-icon></md-button><md-button class=\"md-icon-button md-warn md-raised\" ng-if=\"e.status == \'draft\'\" ng-click=\"ab.del( e.id )\" aria-label=\"Cancella\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"!ab.loading && !ab.customersLoading\" md-limit=\"ab.listPagination.per_page\" md-page=\"ab.listPagination.current_page\" md-total=\"{{ ab.listPagination.total }}\" md-on-paginate=\"ab.eListLoad\" md-boundary-links=\"true\"></md-table-pagination></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"content_paste\">content_paste</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"ab.activeEntity.id==null\">Nuovo Preventivo</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"entityForm\" id=\"entityForm\" layout=\"column\"><div flex=\"100\" layout=\"column\" class=\"fix-margins-3 min-height-60\"><label class=\"md-label\" for=\"date\">Data</label><md-datepicker class=\"md-datepicker-full-width md-datepicker-remove-red-border\" id=\"date\" name=\"date\" md-placeholder=\"Data\" ng-model=\"ab.activeEntity.date\" required=\"\" ng-disabled=\"true\"></md-datepicker></div><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"customer_id\">Cliente</label><md-select ng-model=\"ab.activeEntity.customer_id\" aria-label=\"Cliente\" id=\"customer_id\" name=\"customer_id\" md-container-class=\"with-search\" required=\"\"><md-select-header><span class=\"md-select-search-container\"><input type=\"{{ ap.customersLoading? \'hidden\' : \'search\' }}\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_customer\" name=\"filter_customer\" ng-keydown=\"$event.stopPropagation()\" ng-click=\"$event.stopPropagation()\" ng-keyup=\"ab.onKeyUpCustomersSearch($event, this)\" ng-model=\"ab.query.filter_customer\"></span></md-select-header><md-option ng-value=\"customer.id\" ng-repeat=\"customer in ab.customersList | orderBy: fullName track by customer.id\">{{ customer.fullName }} [{{customer.phone}}]</md-option></md-select><div ng-messages=\"entityForm.customer_id.$error\" ng-if=\"entityForm.customer_id.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><br></div><div><md-input-container class=\"md-block\"><label for=\"note\">Nome</label> <textarea maxlength=\"255\" name=\"note\" id=\"note\" rows=\"3\" ng-model=\"ab.activeEntity.note\" md-select-on-focus=\"\"></textarea></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Crea\" ng-click=\"ab.save( ab.activeEntity )\" ng-disabled=\"entityForm.$invalid\" ng-show=\"entityForm.$dirty\"><md-icon md-font-icon=\"check\">check</md-icon>Crea Preventivo</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/customer-quotations-details/customer-quotations-details.html","<md-content class=\"page-orderdetails\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Dettaglio Preventivo</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Elenco Preventivi\" ui-sref=\"home.customer-quotations()\"><md-icon md-font-icon=\"list\">list</md-icon><span>Elenco Preventivi</span></md-button><md-button class=\"md-accent md-raised\" aria-label=\"Modifica\" ng-click=\"ab.edit()\" ng-if=\"ab.mainEntity.closed && ab.mainEntity.status == \'draft\'\"><md-icon md-font-icon=\"done\">done</md-icon><span>Modifica</span></md-button><md-button class=\"md-accent md-raised\" aria-label=\"Chiudi Preventivo\" ng-click=\"ab.updateCustomerQuotation()\" ng-if=\"ab.mainEntity.status==\'draft\' && !ab.mainEntity.closed\"><md-icon md-font-icon=\"done\">done</md-icon><span>Salva Preventivo</span></md-button><md-button class=\"md-accent md-raised\" ng-click=\"ab.openDocumentPage( ab.env.API + \'/signed-quotations/?customer_quotation_id=\' + ab.mainEntity.id + \'&token=\' + ab.token)\" target=\"_blank\" aria-label=\"Sottoscrivi\" ng-if=\"ab.mainEntity.status==\'draft\' && ab.mainEntity.closed\"><md-icon md-font-icon=\"done\">done</md-icon><span>Sottoscrivi</span></md-button><md-button class=\"md-accent md-raised\" ng-click=\"ab.openEmailPopup(ab.mainEntity)\" aria-label=\"Invia Email\" ng-if=\"ab.mainEntity.status==\'draft\' && ab.mainEntity.closed\"><md-icon md-font-icon=\"email\">email</md-icon><span>Invia Email</span></md-button><md-button class=\"md-accent md-raised\" ng-href=\"{{ ab.env.API }}/documents/{{ab.mainEntity.document.id}}/download?token={{ ab.token }}\" aria-label=\"Scarica PDF\" ng-if=\"ab.mainEntity.status==\'signed\'\"><md-icon md-font-icon=\"get_app\">get_app</md-icon><span>Scarica PDF</span></md-button><md-button class=\"md-accent md-raised\" aria-label=\"Annulla\" ng-click=\"ab.removeDocument(ab.mainEntity)\" ng-if=\"ab.mainEntity.status==\'signed\'\"><md-icon md-font-icon=\"undo\">undo</md-icon><span>Annulla</span></md-button></div></md-toolbar><md-card><md-card-content layout=\"column\"><md-tabs class=\"md-dynamic-height\"><md-tab label=\"Preventivo\"><div class=\"\"><h3 flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\">Preventivo</h3><md-table-container flex=\"100\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" style=\"border: none;\">Preventivo n.<md-input-container style=\"margin: 0px; width: 60px;\"><input aria-label=\"Id\" ng-value=\"ab.mainEntity.id\" ng-disabled=\"true\"></md-input-container>Del<md-input-container style=\"margin: 0px;\"><md-datepicker aria-label=\"Data\" md-placeholder=\"Data\" name=\"data\" id=\"data\" ng-model=\"ab.mainEntity.date\" disabled=\"true\"></md-datepicker></md-input-container>Cliente<md-input-container style=\"margin: 0px;\"><input ng-value=\"ab.mainEntity.customer.firstname + \' \' + ab.mainEntity.customer.lastname\" ng-disabled=\"true\"></md-input-container>Stato<md-input-container style=\"margin: 0px;\"><input aria-label=\"Stato\" ng-value=\"ab.getStatusName(ab.mainEntity.status)\" ng-disabled=\"true\"></md-input-container></th></tr></thead><tbody md-body=\"\"><tr><td md-cell=\"\" style=\"border: none;\" colspan=\"2\">Nome<md-input-container style=\"margin: 0px; width: 300px;\"><textarea maxlength=\"255\" ng-disabled=\"e.prodInv.saving || ab.loading || ab.quotationEntriesLoading || ab.mainEntity.closed\" ng-model=\"ab.mainEntity.note\">{{ab.mainEntity.note}}</textarea></md-input-container>Sconto<md-input-container style=\"margin: 0px; width: 70px;\"><input aria-label=\"Sconto\" type=\"number\" name=\"discount\" id=\"discount\" step=\"1\" min=\"0\" ng-value=\"ab.mainEntity.discount\" ng-model=\"ab.mainEntity.discount\" ng-disabled=\"true\"></md-input-container>Importo Scontato<md-input-container style=\"margin: 0px; width: 150px;\"><input aria-label=\"Importo Scontato\" type=\"number\" name=\"total_discount\" id=\"total_discount\" step=\"1\" min=\"0\" max=\"{{ab.eListTotal}}\" ng-change=\"ab.updateDiscount()\" ng-value=\"ab.mainEntity.total_discount\" ng-model=\"ab.mainEntity.total_discount\" ng-disabled=\"e.prodInv.saving || ab.loading || ab.quotationEntriesLoading || ab.mainEntity.closed\"></md-input-container>Importo Minimo Acconto<md-input-container style=\"margin: 0px; width: 150px;\"><input aria-label=\"Importo Minimo Acconto\" md-placeholder=\"Importo Minimo Acconto\" type=\"number\" name=\"min_deposit\" id=\"min_deposit\" ng-value=\"ab.mainEntity.min_deposit\" ng-model=\"ab.mainEntity.min_deposit\" ng-disabled=\"e.prodInv.saving || ab.loading || ab.quotationEntriesLoading || ab.mainEntity.closed\" step=\"1\" min=\"0\" max=\"{{ (ab.mainEntity.discount)? (ab.eListTotal - (ab.eListTotal*ab.mainEntity.discount)/100) : (ab.eListTotal) | number:2 }}\"></md-input-container>Numero Massimo Rate<md-input-container style=\"margin: 0px; width: 60px;\"><input aria-label=\"Numero Massimo Rate\" md-placeholder=\"Numero Massimo Rate\" type=\"number\" name=\"max_rate\" id=\"max_rate\" ng-value=\"ab.mainEntity.max_rate\" ng-model=\"ab.mainEntity.max_rate\" ng-disabled=\"e.prodInv.saving || ab.loading || ab.quotationEntriesLoading || ab.mainEntity.closed\" step=\"1\" min=\"1\" max=\"20\"></md-input-container></td></tr></tbody></table></md-table-container><span flex=\"\" hide-xs=\"\"></span><md-table-container flex=\"100\"><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\" style=\"width: 5%\"><span>Check</span></th><th md-column=\"\" md-order-by=\"id\" style=\"width: 10%\"><span>Id</span></th><th md-column=\"\" md-order-by=\"name\"><span>Trattamenti</span></th><th md-column=\"\"><span>Note</span></th><th md-column=\"\" style=\"width: 10%; text-align: right;\"><span>Numero Sedute</span></th><th md-column=\"\" style=\"width: 10%; text-align: right;\"><span>Prezzo Unitario &euro;</span></th><th md-column=\"\" md-numeric=\"\" style=\"width: 10%\"><span>Importo &euro;</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading || ab.quotationEntriesLoading\"><td md-cell=\"\" colspan=\"5\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading || ab.quotationEntriesLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" style=\"background-color: #D9D9D9;\"><td colspan=\"5\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" placeholder=\"Cerca\"></td><td md-cell=\"\" style=\"text-align: right\">Totale Trattamenti &euro;:</td><td md-cell=\"\" style=\"text-align: right\">{{ ab.eListTotal | number:2 }} &euro;</td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" ng-repeat=\"e in (ab.filteredItems = (ab.quotationEntriesList | filter: ab.getQueryChecked | filter: { $: ab.query.filter } | orderBy: ab.query.order ) ) track by e.id\"><td md-cell=\"\"><md-input-container style=\"margin-left: 20px; padding-bottom: 0px; margin: 0px; width: 60px;\"><md-checkbox aria-label=\"Check\" type=\"number\" name=\"total\" id=\"total\" ng-model=\"e.prodInv.checked\" ng-click=\"ab.saveCustomerQuotationEntry(e.prodInv)\" ng-disabled=\"e.prodInv.saving || ab.loading || ab.quotationEntriesLoading || ab.mainEntity.closed\" required=\"\"></md-checkbox></md-input-container></td><td md-cell=\"\">{{ e.id }}</td><td md-cell=\"\">{{ e.name }}</td><td md-cell=\"\"><md-input-container style=\"width: 100%; margin-bottom: 0px;\" ng-if=\"e.prodInv.checked\"><input aria-label=\"Note\" name=\"note\" id=\"note\" ng-model=\"e.prodInv.note\" ng-disabled=\"e.prodInv.saving || ab.loading || ab.quotationEntriesLoading || ab.mainEntity.closed\"></md-input-container></td><td md-cell=\"\" style=\"text-align: right;\"><md-input-container style=\"margin-left: 20px; padding-bottom: 0px; margin-bottom: 0px; width: 60px;\" ng-if=\"e.prodInv.checked\"><input aria-label=\"Quantità\" style=\"text-align: right;\" type=\"number\" name=\"quantity\" id=\"quantity\" step=\"1\" min=\"1\" ng-model=\"e.prodInv.quantity\" ng-change=\"ab.calcsOnVisibileElements()\" ng-disabled=\"e.prodInv.saving || ab.loading || ab.quotationEntriesLoading || ab.mainEntity.closed\" required=\"\"></md-input-container></td><td md-cell=\"\" style=\"text-align: right;\"><md-input-container style=\"margin-left: 20px; padding-bottom: 0px; margin-bottom: 0px; width: 60px;\" ng-if=\"e.prodInv.checked\"><input aria-label=\"Prezzo\" style=\"text-align: right;\" type=\"number\" name=\"price\" id=\"price\" step=\"0.1\" min=\"0\" ng-model=\"e.prodInv.price\" ng-change=\"ab.calcsOnVisibileElements()\" ng-disabled=\"e.prodInv.saving || ab.loading || ab.quotationEntriesLoading || ab.mainEntity.closed\" required=\"\"></md-input-container></td><td md-cell=\"\" style=\"text-align: right; padding: 0 24px 0 0\"><span ng-if=\"e.prodInv.checked\">{{e.prodInv.price * e.prodInv.quantity | number:2 }} &euro;</span></td></tr><tr md-row=\"\"><td md-cell=\"\" colspan=\"5\"></td><td md-cell=\"\" style=\"text-align: right\">Totale Trattamenti &euro;:</td><td md-cell=\"\" style=\"text-align: right; padding: 0 24px 0 0\">{{ ab.eListTotal | number:2 }} &euro;</td></tr><tr md-row=\"\"><td md-cell=\"\" style=\"text-align: right\" colspan=\"6\">Sconto {{ ab.mainEntity.discount | number:2 }} %</td><td md-cell=\"\" style=\"text-align: right; padding: 0 24px 0 0\">-{{ (ab.mainEntity.discount)? ((ab.eListTotal*ab.mainEntity.discount)/100) : 0 | number:2 }} &euro;</td></tr><tr md-row=\"\" style=\"background-color: #D9D9D9;\"><td md-cell=\"\" colspan=\"6\" style=\"text-align: right\">Totale &euro;:</td><td md-cell=\"\" style=\"text-align: right; padding: 0 24px 0 0;\">{{ (ab.mainEntity.discount)? (ab.eListTotal - (ab.eListTotal*ab.mainEntity.discount)/100) : (ab.eListTotal) | number:2 }} &euro;</td></tr></tbody></table></md-table-container><surveys ng-if=\"ab.mainEntity && ab.mainEntity.customer_id\" editable=\"false\" control=\"customerSurvey\" customerid=\"{{ab.mainEntity.customer_id}}\"></surveys></div></md-tab></md-tabs></md-card-content></md-card></md-content>");
$templateCache.put("app/dashboard/dashboard.html","<md-content class=\"page-dashboard\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">DASHBOARD</span></h2><span flex=\"20\" hide-xs=\"\"></span><h2 class=\"md-headline\">{{dashboard.store.alias}}</h2><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar><md-progress-circular style=\"margin: 20px;\" md-diameter=\"30\" ng-if=\"dashboard.loading\" md-mode=\"indeterminate\"></md-progress-circular><md-tabs class=\"md-dynamic-height\" md-selected=\"dashboard.selectedIndex\"><md-tab ng-if=\"false\" label=\"Beauty Days - prossime date\"><md-content ng-if=\"false\" layout-margin=\"\" layout-padding=\"\" layout=\"column\" flex=\"\" layout-align=\"center center\"><md-table-container style=\"width:100%;\"><table md-table=\"\" class=\"dashboard-events\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Centro</span></th><th md-column=\"\" style=\"text-align: right;\"><span>GG</span></th><th md-column=\"\" style=\"text-align: right;\"><span>In Agenda</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Viso</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Corpo</span></th><th md-column=\"\" style=\"text-align: right;\"><span>GP Viso</span></th><th md-column=\"\" style=\"text-align: right;\"><span>GP Corpo</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Da fissare</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"event in dashboard.futureEvents\"><td md-cell=\"\">{{event.date_frmt}}</td><td md-cell=\"\">{{ event.store.alias }}</td><td md-cell=\"\" style=\"text-align: right;\">-{{ event.statistics.days_to_event }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.num_app | number:0 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_viso | number:0 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_corpo | number:0 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_viso_gp | number:0 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_corpo_gp | number:0 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_to_target | number:0 }}</td></tr></tbody></table></md-table-container></md-content></md-tab><md-tab ng-if=\"false\" label=\"Beauty Days - consuntivo\"><md-content ng-if=\"false\" layout-margin=\"\" layout-padding=\"\" layout=\"column\" flex=\"\" layout-align=\"center center\"><md-table-container style=\"width:100%;\"><table md-table=\"\" class=\"dashboard-events\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Centro</span></th><th md-column=\"\" style=\"text-align: right;\"><span>In Agenda</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Viso</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Corpo</span></th><th md-column=\"\" style=\"text-align: right;\"><span>GP Viso</span></th><th md-column=\"\" style=\"text-align: right;\"><span>GP Corpo</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Incassato</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Da incassare</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat-start=\"event in dashboard.pastEvents | orderBy: \'-datetime\'\"><td md-cell=\"\" style=\"padding: 30px;\">{{event.date_frmt}}</td><td md-cell=\"\">{{ event.store.alias }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.num_app | number:0 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_viso | number:0 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_corpo | number:0 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_viso_gp | number:0 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_corpo_gp | number:0 }}</td><td md-cell=\"\" style=\"text-align: right; padding: 0px 10px 0px 10px;\"></td><td md-cell=\"\"></td></tr><tr md.row=\"\" style=\"background-color: #eeeeee; padding: 8px;\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding: 8px;\">presentati</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.num_app_paid*100/event.statistics.num_app | number:1 }}%</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_viso_paid*100/event.statistics.app_viso | number:1 }}%</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_corpo_paid*100/event.statistics.app_corpo | number:1 }}%</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_viso_gp_paid*100/event.statistics.app_viso_gp | number:1 }}%</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_corpo_gp_paid*100/event.statistics.app_corpo_gp | number:1 }}%</td><td md-cell=\"\" style=\"text-align: right; padding: 0px 10px 0px 10px;\">{{ event.statistics.incasso | number:0 }} &euro;</td><td md-cell=\"\" style=\"text-align: right; padding: 0px 10px 0px 10px;\">{{ event.statistics.da_incassare?event.statistics.da_incassare+\" &euro;\":\'\' }}</td></tr><tr md.row=\"\" ng-repeat-end=\"\" ng-if=\"false\" style=\"background-color: rgb(217, 217, 217); padding: 8px;\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding: 8px;\">chiusi</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.num_app_chiusi*100/event.statistics.num_app | number:1 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_viso_chiusi*100/event.statistics.app_viso | number:1 }}%</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_corpo_chiusi*100/event.statistics.app_corpo | number:1 }}%</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_viso_gp_chiusi*100/event.statistics.app_viso_gp | number:1 }}%</td><td md-cell=\"\" style=\"text-align: right;\">{{ event.statistics.app_corpo_gp_chiusi*100/event.statistics.app_corpo_gp | number:1 }}%</td><td md-cell=\"\" style=\"text-align: right; padding: 0px 10px 0px 10px;\">{{ event.statistics.incasso | number:0 }} &euro;</td><td md-cell=\"\" style=\"text-align: right; padding: 0px 10px 0px 10px;\">{{ event.statistics.da_incassare?event.statistics.da_incassare+\" &euro;\":\'\' }}</td></tr></tbody></table></md-table-container></md-content></md-tab><md-tab label=\"Dashboard SM\" ng-if=\"dashboard.user.type==\'admin\' || dashboard.user.type==\'operator\' || dashboard.user.type==\'storemngr\'\"><md-content layout=\"column\" flex=\"\" layout-align=\"center center\"><iframe width=\"100%\" height=\"800px\" src=\"{{dashboard.saldoUrl}}\" style=\"border: none;\"></iframe></md-content></md-tab><md-tab label=\"Consuntivo appuntamenti\" md-on-select=\"dashboard.reload()\"><md-content layout=\"column\" flex=\"\" layout-align=\"center center\"><div flex=\"\" layout-fill=\"\" ng-if=\"false\"><h1 class=\"md-display-3 text-center custom-color md-contrast\">Benvenuta</h1><h2 class=\"md-display-3 md-contrast custom-color text-center\"><span class=\"md-accent\">Epilazione.</span> Veloce. <span class=\"md-accent\">Indolore.</span> Efficace.</h2><h3 class=\"md-headline text-center custom-color md-contrast\">Utilizza il menù di sinistra per le varie funzioni utilizzabili.</h3><div class=\"text-center\" ng-if=\"dashboard.isCallCenter\"><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo appuntamento\" ui-sref=\"home.appointments\"><md-icon md-font-icon=\"collections_bookmark\">collections_bookmark</md-icon>Nuovo appuntamento</md-button></div></div><div flex=\"\" layout-fill=\"\"><md-content flex=\"\" layout=\"column\" layout-gt-md=\"row\" layout-margin=\"\"><div flex=\"100\" flex-gt-md=\"30\"><div class=\"text-center\" ng-if=\"dashboard.isCallCenter\"><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo appuntamento\" ui-sref=\"home.appointments\"><md-icon md-font-icon=\"collections_bookmark\">collections_bookmark</md-icon>Nuovo appuntamento</md-button></div><form autocomplete=\"off\" role=\"form\"><md-input-container class=\"md-block\"><input ng-disabled=\"dashboard.storeId==null\" ng-if=\"dashboard.user && dashboard.user.id\" aria-label=\"Date Range Picker\" date-range-picker=\"\" class=\"date-picker\" type=\"text\" ng-model=\"dashboard.date\" options=\"dashboard.options\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"false && dashboard.user.type === \'admin\'\"><md-button class=\"md-accent md-raised\" ng-href=\"{{ dashboard.exportAppointmentsUrl }}\">Esporta appuntamenti</md-button></md-input-container><md-input-container class=\"md-block\" ng-if=\"false && dashboard.user.type === \'admin\'\"><md-button class=\"md-accent md-raised\" ng-href=\"{{ dashboard.exportCustomersUrl }}\">Esporta clienti</md-button></md-input-container></form><div><h3>Consuntivo appuntamenti</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">Totale app. / mese</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.app_count | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.app_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% 1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Smaltimento</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.app_count_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Presentati</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.app_count_paid | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Pres.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.paid_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Pres. 1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.app_count_paid_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Pres. 1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.paid_perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Pres. Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.app_count_paid_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Pres. Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.paid_perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Spostati</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.app_count_spostati | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Spostati</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.app_count_spostati_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Realizzato</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.app_total | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Realizzzato 1a v.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.app_total_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">% Realizz. 1a v.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.perc_total_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Realizzzato Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.app_total_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">% Realizz. Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.perc_total_sm*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Scontrino medio</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.media_scontrino | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Scontr. medio 1a v.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.media_scontrino_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Scontr. medio Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.media_scontrino_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Disponibilit&agrave;</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.availab_minutes/60 | number:0}}</td><td md-cell=\"\">h</td></tr><tr md-row=\"\"><td md-cell=\"\">Redd./h su disp.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.app_total*60/dashboard.statistics.general.availab_minutes | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">% Occupato</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.worked_minutes_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Redd./h su occ.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.data.app_total*60/dashboard.statistics.general.worked_minutes | number:0}}</td><td md-cell=\"\">&euro;</td></tr></tbody></table></md-table-container><h3 ng-if=\"dashboard.storeId\">Utilizzo laser</h3><md-table-container ng-if=\"dashboard.storeId\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">N&deg; laser</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.laser_au.num_laser | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">N&deg; cabine</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.laser_au.num_rooms | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Utilizzo laser</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.laser_au.min_laser_used_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">% Over</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.laser_au.min_over_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">% Down</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.laser_au.min_down_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container><h3>Nuovi clienti da lead</h3><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">Leads 1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.lead_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">Leads 1a v. chiusi</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.lead_count_1av_chiusi | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Redemption</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.statistics.general.redemption_lead_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr></tbody></table></div><div ng-if=\"false\"><h3>Statistiche generali sui clienti</h3><ul><li ng-repeat=\"(key, value) in dashboard.statistics.customers\">{{key}} : {{value}}</li></ul></div></div><div flex=\"100\" flex-gt-md=\"70\" layout=\"column\"><md-card md-whiteframe=\"1\"><md-card-title><md-card-title-text><div layout-gt-sm=\"row\"><span flex-gt-sm=\"60\" class=\"md-headline\">Fidelizzazione 1a v.</span><md-button ng-click=\"dashboard.change_chart5()\" class=\"md-accent md-raised\" aria-label=\"Cambia grafico\">Cambia grafico</md-button></div><span class=\"md-subhead\">Percentuale dei clienti 1° volta presentati che prendono un secondo appuntamento</span></md-card-title-text></md-card-title><md-card-content><canvas id=\"bar5\" class=\"chart chart-bar\" chart-options=\"dashboard.chart5.options\" chart-data=\"dashboard.chart5.data\" chart-labels=\"dashboard.chart5.labels\" chart-series=\"dashboard.chart5.series\"></canvas></md-card-content></md-card><md-card md-whiteframe=\"1\"><md-card-title><md-card-title-text><div layout-gt-sm=\"row\"><span flex-gt-sm=\"60\" class=\"md-headline\">Fidelizzazione smalt.</span><md-button ng-click=\"dashboard.change_chart5sm()\" class=\"md-accent md-raised\" aria-label=\"Cambia grafico\">Cambia grafico</md-button></div><span class=\"md-subhead\">Percentuale dei clienti smaltimento presentati che prendono un appuntamento successivo</span></md-card-title-text></md-card-title><md-card-content><canvas id=\"bar5sm\" class=\"chart chart-bar\" chart-options=\"dashboard.chart5sm.options\" chart-data=\"dashboard.chart5sm.data\" chart-labels=\"dashboard.chart5sm.labels\" chart-series=\"dashboard.chart5sm.series\"></canvas></md-card-content></md-card><md-card md-whiteframe=\"1\"><md-card-title><md-card-title-text><div layout-gt-sm=\"row\"><span flex-gt-sm=\"60\" class=\"md-headline\">Incassi</span><md-button ng-click=\"dashboard.change_chart3()\" class=\"md-accent md-raised\" aria-label=\"Cambia grafico\">Cambia grafico</md-button></div><span class=\"md-subhead\">Qui visualizzati gli incassi totali e l\'incasso medio per appuntamento (in €)</span></md-card-title-text></md-card-title><md-card-content><canvas id=\"bar3\" class=\"chart chart-bar\" chart-options=\"dashboard.chart3.options\" chart-data=\"dashboard.chart3.data\" chart-labels=\"dashboard.chart3.labels\" chart-series=\"dashboard.chart3.series\"></canvas></md-card-content></md-card><md-card md-whiteframe=\"1\"><md-card-title><md-card-title-text><span class=\"md-headline\">Appuntamenti gestiti</span> <span class=\"md-subhead\">Qui visualizzati gli appuntamenti gestiti</span></md-card-title-text></md-card-title><md-card-content><canvas id=\"bar2\" class=\"chart chart-bar\" chart-options=\"dashboard.chart2.options\" chart-data=\"dashboard.chart2.data\" chart-labels=\"dashboard.chart2.labels\" chart-series=\"dashboard.chart2.series\"></canvas></md-card-content></md-card><md-card md-whiteframe=\"1\"><md-card-title><md-card-title-text><span class=\"md-headline\">Minuti lavorati</span> <span class=\"md-subhead\">Qui visualizzati i minuti di lavoro</span></md-card-title-text></md-card-title><md-card-content><canvas id=\"bar1\" class=\"chart chart-bar\" chart-options=\"dashboard.chart1.options\" chart-data=\"dashboard.chart1.data\" chart-labels=\"dashboard.chart1.labels\" chart-series=\"dashboard.chart1.series\"></canvas></md-card-content></md-card><md-card md-whiteframe=\"1\" ng-if=\"false\"><md-card-title><md-card-title-text><span class=\"md-headline\">Trattamenti</span> <span class=\"md-subhead\">Qui visualizzati il num dei trattamenti prenotati</span></md-card-title-text></md-card-title><md-card-content><canvas id=\"bar4\" class=\"chart chart-bar\" chart-options=\"dashboard.chart4.options\" chart-data=\"dashboard.chart4.data\" chart-labels=\"dashboard.chart4.labels\" chart-series=\"dashboard.chart4.series\"></canvas></md-card-content></md-card></div></md-content></div></md-content></md-tab><md-tab label=\"Previsione {{dashboard.today.format(\'MMMM\')}}\" ng-if=\"dashboard.user.type==\'admin\'\" md-on-select=\"dashboard.loadPrevisione()\"><md-content layout=\"column\" flex=\"\" layout-align=\"center center\"><div flex=\"\" layout-fill=\"\"><md-content flex=\"\" layout=\"row\" layout-margin=\"\"><div><div><h3 style=\"text-align: left;\">Statistiche di riferimento</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"3\">Media ultimi {{dashboard.refMonths}} mesi / su {{dashboard.refDays}} gg</td></tr><tr md-row=\"\"><td md-cell=\"\">Totale app. / mese</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% 1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Smaltimento</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Presentati</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_paid | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Pres.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.paid_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Pres. 1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_paid_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Pres. 1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.paid_perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Pres. Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_paid_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Pres. Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.paid_perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Spostati</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_spostati | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Spostati</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_spostati_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Realizzato</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_total | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Realizzzato 1a v.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_total_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">% Realizz. 1a v.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.perc_total_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Realizzzato Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_total_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">% Realizz. Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.perc_total_sm*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Scontrino medio</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.media_scontrino | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Scontr. medio 1a v.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.media_scontrino_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Scontr. medio Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.media_scontrino_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Disponibilit&agrave;</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.availab_minutes/60 | number:0}}</td><td md-cell=\"\">h</td></tr><tr md-row=\"\"><td md-cell=\"\">Redd./h</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.redd_h | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">% Occupato</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.worked_minutes_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Redd./h su occ.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.redd_h_w | number:0}}</td><td md-cell=\"\">&euro;</td></tr></tbody></table></md-table-container><h3 ng-if=\"dashboard.storeId\">Utilizzo laser</h3><md-table-container ng-if=\"dashboard.storeId\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">N&deg; laser</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.laser_au.num_laser | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">N&deg; cabine</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.laser_au.num_rooms | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Utilizzo laser</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.laser_au.min_laser_used_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">% Over</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.laser_au.min_over_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">% Down</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.laser_au.min_down_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container><h3>Costi</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">Costo personale</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.costo_pers | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">% su realizzato</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.costo_pers_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container><h3>Nuovi clienti da lead</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">Leads 1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.lead_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">Leads 1a v. chiusi</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.lead_count_1av_chiusi | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Redemption</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.redemption_lead_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container></div></div><div><div><h3>Fino a ieri</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"3\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.work_days}} gg dall\'1 al {{dashboard.yesterday.format(\"DD/MM\")}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_paid | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.paid_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_paid_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.paid_perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_paid_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.paid_perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_spostati | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_spostati_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_total | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_total_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.perc_total_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_total_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.perc_total_sm*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.media_scontrino | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.media_scontrino_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.media_scontrino_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.availab_minutes/60 | number:0}}</td><td md-cell=\"\">h</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.redd_h | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.worked_minutes_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_total*60/dashboard.currentMonthPastStats.worked_minutes | number:0}}</td><td md-cell=\"\">&euro;</td></tr></tbody></table></md-table-container><h3 ng-if=\"dashboard.storeId\">&nbsp;&nbsp;</h3><md-table-container ng-if=\"dashboard.storeId\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.laser_au.num_laser | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.laser_au.num_rooms | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.laser_au.min_laser_used_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.laser_au.min_over_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.laser_au.min_down_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.lead_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.lead_count_1av_chiusi | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.redemption_lead_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container></div></div><div><div><h3>Resto del mese</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"3\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.work_days}} gg dal {{dashboard.currentMonthFutureStatsOpts.date_start_frmt}} al {{dashboard.currentMonthFutureStatsOpts.date_end_frmt}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_count | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_count_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_count_paid | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.paid_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_count_paid_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.paid_perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_count_paid_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.paid_perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_total | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_total_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.perc_total_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_total_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.perc_total_sm*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.media_scontrino | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.media_scontrino_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.media_scontrino_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.availab_minutes/60 | number:0}}</td><td md-cell=\"\">h</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.redd_h | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.worked_minutes_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_total*60/dashboard.currentMonthFutureStats.worked_minutes | number:0}}</td><td md-cell=\"\">&euro;</td></tr></tbody></table></md-table-container><h3 ng-if=\"dashboard.storeId\">&nbsp;&nbsp;</h3><md-table-container ng-if=\"dashboard.storeId\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.laser_au.num_laser | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.laser_au.num_rooms | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.laser_au.min_laser_used_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.laser_au.min_over_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.laser_au.min_down_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.lead_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.lead_count_1av_chiusi | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.redemption_lead_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container></div></div><div><div><h3>Previsione</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"3\" style=\"text-align: right; padding-right: 10px;\">{{dashboard.today.format(\"MMMM\")}} {{dashboard.today.format(\"YYYY\")}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_count | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_count_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_count_paid | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.paid_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_count_paid_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.paid_perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_count_paid_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.paid_perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_total | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_total_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.perc_total_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_total_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.perc_total_sm*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.media_scontrino | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.media_scontrino_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.media_scontrino_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.availab_minutes/60 | number:0}}</td><td md-cell=\"\">h</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.redd_h | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.worked_minutes_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_total*60/dashboard.currentMonthFutureStats.total.worked_minutes | number:0}}</td><td md-cell=\"\">&euro;</td></tr></tbody></table></md-table-container><h3 ng-if=\"dashboard.storeId\">&nbsp;&nbsp;</h3><md-table-container ng-if=\"dashboard.storeId\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.num_laser | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.num_rooms | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.min_laser_used_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.min_over_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.min_down_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.costo_pers | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.costo_pers_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.lead_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.lead_count_1av_chiusi | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.redemption_lead_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container></div></div><div><div><h3>Trend</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"2\" style=\"border: solid 2px orange; text-align: right; padding-right: 10px;\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_count>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_count | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_count_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_count_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.perc_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.perc_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_count_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_count_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.perc_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.perc_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_count_paid>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_count_paid | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.paid_perc>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.paid_perc | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_count_paid_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_count_paid_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.paid_perc_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.paid_perc_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_count_paid_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_count_paid_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.paid_perc_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.paid_perc_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_total>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_total | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_total_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_total_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.perc_total_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.perc_total_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_total_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_total_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.perc_total_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.perc_total_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.media_scontrino>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.media_scontrino | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.media_scontrino_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.media_scontrino_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.media_scontrino_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.media_scontrino_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.availab_minutes>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.availab_minutes | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.redd_h>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.redd_h | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.worked_minutes_perc>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.worked_minutes_perc | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.redd_h_w>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.redd_h_w | number:1}} %</td></tr></tbody></table></md-table-container><h3 ng-if=\"dashboard.storeId\">&nbsp;&nbsp;</h3><md-table-container ng-if=\"dashboard.storeId\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.num_laser>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.num_laser | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.num_rooms>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.num_rooms | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.min_laser_used_perc>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.min_laser_used_perc | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.min_over_perc>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.min_over_perc | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.min_down_perc>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.min_down_perc | number:1}} %</td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.costo_pers>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.costo_pers | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.costo_pers_perc>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.costo_pers_perc | number:1}} %</td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.lead_count_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.lead_count_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.lead_count_1av_chiusi>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.lead_count_1av_chiusi | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.redemption_lead_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.redemption_lead_1av | number:1}} %</td></tr></tbody></table></md-table-container></div></div><div ng-if=\"false\"><div><h3>&Delta;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"2\" style=\"border: solid 2px orange; text-align: right; padding-right: 10px;\">Da fare</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaCurr.app_count>0?\'+\':\'\'}}{{ dashboard.deltaCurr.app_count | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaCurr.app_count_1av>0?\'+\':\'\'}}{{ dashboard.deltaCurr.app_count_1av | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaCurr.app_count_paid>0?\'+\':\'\'}}{{ dashboard.deltaCurr.app_count_paid | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaCurr.app_count_paid_1av>0?\'+\':\'\'}}{{ dashboard.deltaCurr.app_count_paid_1av | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaCurr.app_total>0?\'+\':\'\'}}{{ dashboard.deltaCurr.app_total | number:0}} &euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaCurr.app_total_1av>0?\'+\':\'\'}}{{ dashboard.deltaCurr.app_total_1av | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaCurr.media_scontrino>0?\'+\':\'\'}}{{ dashboard.deltaCurr.media_scontrino | number:0 }} &euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaCurr.media_scontrino_1av>0?\'+\':\'\'}}{{ dashboard.deltaCurr.media_scontrino_1av | number:0 }}</td></tr></tbody></table></md-table-container></div></div><div ng-if=\"false\"><div><h3>Simulazione</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{dashboard.today.format(\'MMMM\')}} {{dashboard.today.format(\'YYYY\')}}</td></tr><tr md-row=\"\"><td md-cell=\"\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"curr_target_app_count\">Totale app.</label> <input type=\"number\" name=\"curr_target_app_count\" id=\"curr_target_app_count\" step=\"1\" min=\"0\" ng-model=\"dashboard.currentMonthFutureStats.simulate.app_count\" ng-blur=\"dashboard.onBlurCurrentAppCount()\"></md-input-container></td></tr><tr md-row=\"\"><td md-cell=\"\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"curr_target_media_scontrino\">Media scontrino</label> <input type=\"number\" name=\"curr_target_media_scontrino\" id=\"curr_target_media_scontrino\" step=\"0.01\" min=\"0\" ng-model=\"dashboard.currentMonthFutureStats.simulate.media_scontrino\" ng-blur=\"dashboard.onBlurCurrentMediaScontrino()\"></md-input-container></td></tr><tr md-row=\"\"><td md-cell=\"\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"curr_target_app_total\">Obiettivo</label> <input type=\"number\" name=\"curr_target_app_total\" id=\"curr_target_app_total\" step=\"1\" min=\"0\" ng-model=\"dashboard.currentMonthFutureStats.simulate.app_total\" ng-disabled=\"true\"></md-input-container></td></tr></tbody></table></md-table-container></div></div></md-content></div></md-content></md-tab><md-tab label=\"Previsione {{dashboard.nextMonth.format(\'MMMM\')}}\" ng-if=\"false && (dashboard.user.email==\'beppause@gmail.com\' || dashboard.user.email==\'serrymat@gmail.com\' || dashboard.user.email==\'matteo@biolaser.it\')\"><md-content layout=\"column\" flex=\"\" layout-align=\"center center\"><div flex=\"\" layout-fill=\"\"><md-content flex=\"\" layout=\"row\" layout-margin=\"\"><div flex=\"34\"><div><h3 style=\"text-align: left;\">Statistiche di riferimento</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"2\">Ultimi {{dashboard.refMonths}} mesi</td></tr><tr md-row=\"\"><td md-cell=\"\">Totale app.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\">1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_1av | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\">Presentati</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_paid | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\">Pres. 1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_paid_1av | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\">Realizzato</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_total | number:0}} &euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Realizzzato 1a v.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_total_1av | number:0}} &euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Scontrino medio</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.media_scontrino | number:0}} &euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Scontrino medio 1a v.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.media_scontrino_1av | number:0}} &euro;</td></tr></tbody></table></md-table-container></div></div><div flex=\"22\"><div><h3>Previsione</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"2\" style=\"text-align: right; padding-right: 10px;\">{{dashboard.nextMonthStatsOpts.date_start_frmt}} {{dashboard.nextMonthStatsOpts.date_end_frmt}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.nextMonthStats.data.app_count | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.nextMonthStats.data.app_count_1av | number:0}}</td></tr><tr md-row=\"\" style=\"background-color: yellow;\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.nextMonthStats.prev.app_count_paid | number:0}}</td></tr><tr md-row=\"\" style=\"background-color: yellow;\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.nextMonthStats.prev.app_count_paid_1av | number:0}}</td></tr><tr md-row=\"\" style=\"background-color: yellow;\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.nextMonthStats.prev.app_total | number:0}} &euro;</td></tr><tr md-row=\"\" style=\"background-color: yellow;\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.nextMonthStats.prev.app_total_1av | number:0}} &euro;</td></tr><tr md-row=\"\" style=\"background-color: yellow;\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.media_scontrino | number:0}} &euro;</td></tr><tr md-row=\"\" style=\"background-color: yellow;\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.media_scontrino_1av | number:0}} &euro;</td></tr></tbody></table></md-table-container></div></div><div flex=\"22\"><div><h3>&Delta;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"2\" style=\"border: solid 2px orange; text-align: right; padding-right: 10px;\">Da fare</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaNext.app_count>0?\'+\':\'\'}}{{ dashboard.deltaNext.app_count | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaNext.app_count_1av>0?\'+\':\'\'}}{{ dashboard.deltaNext.app_count_1av | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaNext.app_count_paid>0?\'+\':\'\'}}{{ dashboard.deltaNext.app_count_paid | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaNext.app_count_paid_1av>0?\'+\':\'\'}}{{ dashboard.deltaNext.app_count_paid_1av | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaNext.app_total>0?\'+\':\'\'}}{{ dashboard.deltaNext.app_total | number:0}} &euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaNext.app_total_1av>0?\'+\':\'\'}}{{ dashboard.deltaNext.app_total_1av | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaNext.media_scontrino>0?\'+\':\'\'}}{{ dashboard.deltaNext.media_scontrino | number:0 }} &euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaNext.media_scontrino_1av>0?\'+\':\'\'}}{{ dashboard.deltaNext.media_scontrino_1av | number:0 }}</td></tr></tbody></table></md-table-container></div></div><div flex=\"22\"><div><h3>Obiettivo: {{dashboard.nextMonthStats.obiettivo | number:0}}</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"2\" style=\"text-align: right; padding-right: 10px;\">{{dashboard.nextMonthStatsOpts.date_start_frmt}} {{dashboard.nextMonthStatsOpts.date_end_frmt}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"next_target_app_count\">Totale app.</label> <input type=\"number\" name=\"next_target_app_count\" id=\"next_target_app_count\" step=\"1\" min=\"0\" ng-model=\"dashboard.nextMonthStats.target.app_count\" ng-blur=\"dashboard.onBlurNextAppCount()\"></md-input-container></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"next_target_media_scontrino\">Media scontrino</label> <input type=\"number\" name=\"next_target_media_scontrino\" id=\"next_target_media_scontrino\" step=\"0.01\" min=\"0\" ng-model=\"dashboard.nextMonthStats.target.media_scontrino\" ng-blur=\"dashboard.onBlurNextMediaScontrino()\"></md-input-container></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"next_target_app_total\">Obiettivo</label> <input type=\"number\" name=\"next_target_app_total\" id=\"next_target_app_total\" step=\"1\" min=\"0\" ng-model=\"dashboard.nextMonthStats.target.app_total\" ng-disabled=\"true\"></md-input-container></td></tr></tbody></table></md-table-container></div></div></md-content></div></md-content></md-tab></md-tabs></md-content>");
$templateCache.put("app/expcash/expcash.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Ricavi</span></h2><span flex=\"\" hide-xs=\"\"></span><div><md-select ng-change=\"ab.eListLoad()\" ng-model=\"ab.query.type\" placeholder=\"Tipo\" aria-label=\"Tipo\"><md-option value=\"\">Tutti</md-option><md-option value=\"O\">Obiettivo</md-option><md-option value=\"R\">Ricavo</md-option></md-select></div><span flex=\"\" hide-xs=\"\"></span><div><md-select ng-change=\"ab.eListLoad()\" ng-model=\"ab.query.period\" placeholder=\"Periodo\" aria-label=\"Periodo\"><md-option ng-value=\"undefined\">Tutto</md-option><md-option value=\"A\">A</md-option><md-option value=\"B\">B</md-option></md-select></div><span flex=\"\" hide-xs=\"\"></span><div><md-input-container><md-select aria-label=\"Mese\" placeholder=\"Mese\" ng-model=\"ab.query.month\" ng-change=\"ab.eListLoad()\"><md-option ng-value=\"undefined\">Tutti i mesi</md-option><md-option ng-value=\"month.v\" ng-repeat=\"month in ab.MONTHS.months track by month.v\">{{ month.l }}</md-option></md-select></md-input-container></div><span flex=\"\" hide-xs=\"\"></span><div><md-input-container><md-select aria-label=\"Anno\" placeholder=\"Anno\" ng-model=\"ab.query.year\" ng-change=\"ab.eListLoad()\"><md-option ng-value=\"year\" ng-repeat=\"year in ab.years\">{{ year }}</md-option></md-select></md-input-container></div><span flex=\"\" hide-xs=\"\"></span><div><md-input-container><md-select aria-label=\"BD\" placeholder=\"Gruppo\" ng-model=\"ab.query.grp_name\" ng-change=\"ab.eListLoad()\"><md-option ng-value=\"undefined\"></md-option><md-option ng-value=\"\'Biosnella\'\">Biosnella</md-option></md-select></md-input-container></div><span flex=\"\" hide-xs=\"\"></span><div><md-input-container><md-select aria-label=\"Categoria\" placeholder=\"Categoria\" ng-model=\"ab.query.treatment_category_id\" ng-change=\"ab.eListLoad()\"><md-option ng-value=\"undefined\"></md-option><md-option ng-value=\"category.id\" ng-repeat=\"category in ab.categoriesList\">{{ category.name }}</md-option></md-select></md-input-container></div><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo obiettivo\" ng-disabled=\"ab.loading || !ab.storeId\" ng-click=\"ab.toggleRight(null, true)\"><md-icon md-font-icon=\"nfc\">nfc</md-icon>Nuovo obiettivo</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo ricavo\" ng-disabled=\"ab.loading || !ab.storeId\" ng-click=\"ab.toggleRight(null, false)\"><md-icon md-font-icon=\"nfc\">nfc</md-icon>Nuovo ricavo</md-button></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Anno</span></th><th md-column=\"\" md-numeric=\"\" style=\"width: 25px;\"><span>Dal</span></th><th md-column=\"\" md-numeric=\"\" style=\"width: 25px;\"><span>Al</span></th><th md-column=\"\" md-numeric=\"\" style=\"width: 10px;\">&nbsp;</th><th md-column=\"\"><span>Mese</span></th><th md-column=\"\" ng-if=\"!ab.storeId\"><span>Centro</span></th><th md-column=\"\"><span>Tipo</span></th><th md-column=\"\"><span>Causale</span></th><th md-column=\"\"><span>Gruppo</span></th><th md-column=\"\"><span>Categoria</span></th><th md-column=\"\"><span>Nota</span></th><th md-column=\"\" md-numeric=\"\"><span>Importo &euro;</span></th><th md-column=\"\" md-numeric=\"\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"6\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in ab.eList\" class=\"{{ e.prev ? \'row_prev\':\'\'}}\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.year }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.day_from }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.day_to }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ ab.MONTHS.getName(e.month) }}</td><td md-cell=\"\" ng-if=\"!ab.storeId\" ng-click=\"ab.rowClicked(e)\">{{ e.store.data.alias }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.target ? \'Obiettivo\': (e.prev ? \'Previsione\':\'Reale\') }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><span ng-if=\"e.causal && e.causal.data\">{{ e.causal.data.name }}</span> <span ng-if=\"e.target && e.f_balance\"><md-icon md-font-icon=\"account_balance_wallet\">account_balance_wallet</md-icon>A saldo</span></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.grp_name }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.category.data.name }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.description }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.total ? e.total:0 | number : 2 }}</td><td md-cell=\"\" class=\"icon-button\"><md-button class=\"md-icon-button md-warn\" ng-click=\"ab.del( e.id )\" aria-label=\"Cancella\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr><tr md-row=\"\" style=\"background-color: #D9D9D9;\" ng-if=\"ab.eList.length>0 && ab.monoType\"><td colspan=\"{{ ab.storeId?5:6 }}\" md-cell=\"\" style=\"text-align: right\"></td><td md-cell=\"\" colspan=\"6\" style=\"text-align: right\"><strong>Totale &euro;</strong> {{ ab.eListTotal | number:2 }}</td><td md-cell=\"\"></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"account_circle\">account_circle</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"ab.activeEntity.id!=null\">Modifica {{ab.activeEntity.target?\'obiettivo\':\'ricavo\'}} {{ab.activeEntity.store.data.alias}}</span> <span class=\"inset\" ng-if=\"ab.activeEntity.id==null\">Nuovo {{ab.activeEntity.target?\'obiettivo\':\'ricavo\'}} {{ab.activeEntity.store.data.alias}}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"entityForm\" id=\"entityForm\" layout=\"column\"><div layout=\"row\" layout-align=\"end\" style=\"margin: 5px;\"><div layout=\"row\" class=\"md-block\"><md-button ng-class=\"{\'md-primary\':ab.activeEntity.day_from>0, \'md-accent\':ab.activeEntity.day_from==null,\'md-raised\':true }\" ng-click=\"ab.setPeriodo(ab.activeEntity,null, null)\">Tutto</md-button></div><div layout=\"row\" class=\"md-block\"><md-button ng-class=\"{\'md-primary\':ab.activeEntity.day_from!=1, \'md-accent\':ab.activeEntity.day_from==1,\'md-raised\':true }\" ng-click=\"ab.setPeriodo(ab.activeEntity,1,15)\">A</md-button></div><div layout=\"row\" class=\"md-block\"><md-button ng-class=\"{\'md-primary\':ab.activeEntity.day_from!=16, \'md-accent\':ab.activeEntity.day_from==16,\'md-raised\':true }\" ng-click=\"ab.setPeriodo(ab.activeEntity,16,null)\">B</md-button></div></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"25\"><label for=\"year\">Anno</label><md-select required=\"\" id=\"year\" name=\"year\" aria-label=\"Anno\" placeholder=\"Anno\" ng-model=\"ab.activeEntity.year\"><md-option ng-value=\"year\" ng-repeat=\"year in ab.years\">{{year}}</md-option></md-select></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"35\"><label for=\"month\">Mese</label><md-select ng-model=\"ab.activeEntity.month\" aria-label=\"Mese\" id=\"month\" name=\"month\" required=\"\"><md-option ng-value=\"month.v\" ng-repeat=\"month in ab.MONTHS.months track by month.v\">{{ month.l }}</md-option></md-select><div ng-messages=\"entityForm.month.$error\" ng-if=\"entityForm.month.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"15\"><label for=\"day_from\">Dal</label> <input type=\"number\" name=\"day_from\" id=\"day_from\" step=\"1\" min=\"1\" ng-disabled=\"\'true\'\" ng-model=\"ab.activeEntity.day_from\"></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"15\"><label for=\"day_to\">Al</label> <input type=\"number\" name=\"day_to\" id=\"day_to\" ng-disabled=\"\'true\'\" step=\"1\" min=\"1\" ng-model=\"ab.activeEntity.day_to\"></md-input-container></div><div layout=\"row\" ng-if=\"!ab.activeEntity.target\"><md-input-container class=\"md-block\"><label for=\"causal\">Causale</label><md-select id=\"causal_id\" name=\"causal_id\" ng-model=\"ab.activeEntity.causal_id\"><md-option value=\"1000\">Groupon</md-option><md-option value=\"999\">Riporto</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\" ng-if=\"!ab.activeEntity.target\"><md-radio-group id=\"prev\" name=\"prev\" ng-model=\"ab.activeEntity.prev\"><md-radio-button value=\"0\">Reale</md-radio-button><md-radio-button value=\"1\">Previsto</md-radio-button></md-radio-group></md-input-container>&nbsp;&nbsp;<md-input-container class=\"md-block\"><label for=\"total\">{{ ab.activeEntity.target ? \'Obiettivo\': \'Ricavo\' }} (in &euro;)</label> <input type=\"number\" name=\"total\" id=\"total\" step=\"0.01\" ng-model=\"ab.activeEntity.total\" required=\"\"></md-input-container>&nbsp;&nbsp;<md-input-container><md-checkbox ng-model=\"ab.activeEntity.f_balance\" ng-true-value=\"1\" ng-false-value=\"0\">Su saldo</md-checkbox></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"50\"><label for=\"grp_name\">Gruppo trattamenti:</label><md-select ng-model=\"ab.activeEntity.grp_name\" aria-label=\"Gruppo trattamenti\" id=\"grp_name\" name=\"grp_name\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"grp_name\" ng-repeat=\"grp_name in ab.groupNamesList\">{{ grp_name }}</md-option></md-select></md-input-container><span ng-if=\"ab.activeEntity.target\" flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"50\"><label for=\"treatment_category_id\">Categoria trattamenti:</label><md-select ng-model=\"ab.activeEntity.treatment_category_id\" aria-label=\"Categoria\" id=\"treatment_category_id\" name=\"treatment_category_id\"><md-option ng-value=\"undefined\">Tutte</md-option><md-option ng-value=\"category.id\" ng-repeat=\"category in ab.categoriesList\">{{ category.name }}</md-option></md-select></md-input-container></div><div><md-input-container class=\"md-block\"><label for=\"description\">Nota</label> <textarea maxlength=\"255\" name=\"description\" id=\"description\" rows=\"3\" ng-model=\"ab.activeEntity.description\" md-select-on-focus=\"\"></textarea></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ab.save( ab.activeEntity )\" ng-disabled=\"entityForm.$invalid\" ng-show=\"entityForm.$dirty\"><md-icon md-font-icon=\"check\">check</md-icon>{{ ab.activeEntity.id == null ? \'Salva\' : \'Aggiorna\' }}</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/giftcards/giftcards.html","<md-content class=\"page-giftcard\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ ab.entity.plural.charAt(0).toUpperCase() + ab.entity.plural.substring(1).toLowerCase() }}</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Crea\" ng-disabled=\"ab.loading\" ng-click=\"ab.toggleRight()\" ng-if=\"ab.env.isMaster && (ab.user.type==\'admin\' || ab.user.type==\'backoffice\')\"><md-icon md-font-icon=\"view_list\">view_list</md-icon>Nuov{{ab.entity.gender==\'F\'?\'a\':\'o\'}} {{ab.entity.name}}</md-button></div></md-toolbar><md-card><md-card-header style=\"padding-bottom: 6px; padding-top: 6px;\"><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container md-no-float=\"\" class=\"md-accent\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" ng-keypress=\"ab.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Numero gift\"></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select aria-label=\"Area\" placeholder=\"Area\" ng-model=\"ab.eStatus.tenant\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutte</md-option><md-option ng-value=\"tenant.tenant\" ng-repeat=\"tenant in ab.tenantsList track by tenant.tenant\">{{ tenant.tenant }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><div flex=\"20\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" id=\"filter_date_start\" name=\"filter_date_start\" md-placeholder=\"Filtra per data iniziale\" ng-model=\"ab.eStatus.filter_date_start\" ng-change=\"ab.onChangeDateStart()\"></md-datepicker></div><span flex=\"\" hide-xs=\"\"></span><md-checkbox style=\"margin-left: 30px;\" ng-model=\"ab.eStatus.filter_date_expire\" ng-change=\"ab.onChangeFilterDateExpire()\">Scadenza</md-checkbox></div></md-toolbar></md-card-header><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\" md-on-reorder=\"ab.eListReOrder\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"number\"><span>Numero</span></th><th md-column=\"\" md-order-by=\"released\"></th><th md-column=\"\" md-order-by=\"rel_tenant\">Area</th><th md-column=\"\" md-order-by=\"rel_store_id\">Centro</th><th md-column=\"\" md-order-by=\"released_at\">Emissione</th><th md-column=\"\" md-order-by=\"date_expire\">Scadenza</th><th md-column=\"\" md-numeric=\"\" md-order-by=\"value\" style=\"text-align: right;\"><span>Valore</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"balance\"><span>Saldo</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"3\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular></td><td md-cell=\"\" ng-if=\"ab.env.isMaster && (ab.user.type == \'backoffice\' || ab.user.type == \'admin\')\"></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in ab.eList track by e.id\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.number.substring(0,2)+\"-\"+e.number.substring(2,5)+\"-\"+e.number.substring(5,11) }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><md-icon ng-if=\"e.released\" md-font-icon=\"check\">check</md-icon></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.rel_tenant }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.rel_store.data.alias }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.released_at_frmt }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.date_expire_frmt }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\" style=\"text-align: right;\">{{ e.value }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.balance | number : 2}}</td><td md-cell=\"\" class=\"icon-button\"><md-button ng-if=\"ab.env.isMaster\" class=\"md-icon-button md-warn\" ng-click=\"ab.del( e.id )\" aria-label=\"Cancella\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"! ab.loading\" md-limit=\"ab.eListPag.per_page\" md-limit-options=\"ab.query.limitOptions\" md-page=\"ab.eListPag.current_page\" md-total=\"{{ ab.eListPag.total }}\" md-boundary-links=\"ab.options.boundaryLinks\" md-on-paginate=\"ab.eListLoad\"></md-table-pagination></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"view_list\">view_list</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"ab.activeEntity.id!=null\">Modifica {{ab.entity.name}} ({{ab.activeEntity.id}})</span> <span class=\"inset\" ng-if=\"ab.activeEntity.id==null\">Nuov{{ab.entity.gender==\'F\'?\'a\':\'o\'}} {{ab.entity.name}}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"entityForm\" id=\"entityForm\" layout=\"column\"><div flex=\"100\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"100\"><label class=\"md-label\" for=\"name\">Numero</label> <input id=\"number\" name=\"number\" md-placeholder=\"Numero\" ng-model=\"ab.activeEntity.number\" required=\"\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"value\">Importo</label> <input type=\"number\" name=\"value\" id=\"value\" step=\"5\" min=\"20\" ng-model=\"ab.activeEntity.value\" required=\"\"></md-input-container></div><div flex=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ab.save( ab.activeEntity )\" ng-disabled=\"entityForm.$invalid || ab.saving\" ng-show=\"entityForm.$dirty\"><md-icon md-font-icon=\"check\">check</md-icon>{{ ab.activeEntity.id == null ? \'Salva\' : \'Aggiorna\' }}</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\" ng-disabled=\"ab.saving\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/groups/groups.html","<md-content ng-if=\"ab.user.type==\'admin\' || ab.user.type==\'callcenter\'\" class=\"page-wire-transfer\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"group\">group</md-icon><span class=\"inset\">Gruppi Utenti</span></h2><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar><md-progress-circular style=\"margin: 20px;\" md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular><md-card><md-card-header></md-card-header><md-card-content style=\"overflow-y: auto; padding-top: 0px;\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">ID</th><th md-column=\"\">Gruppo</th><th md-column=\"\">Tipo</th><th md-column=\"\">Descrizione</th><th md-column=\"\">Utenti</th></tr></thead><tbody><tr md-row=\"\" ng-if=\"ab.eListLoading\"><td md-cell=\"\" colspan=\"8\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.eListLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" ng-repeat=\"group in ab.groups\"><td md-cell=\"\">{{ group.id }}</td><td md-cell=\"\">{{ group.name}}</td><td md-cell=\"\">{{ group.type}}</td><td md-cell=\"\">{{ group.description}}</td><td md-cell=\"\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Rubrica\" ng-click=\"ab.showUsers(group)\"><md-icon md-font-icon=\"person\">person</md-icon></md-button></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content>");
$templateCache.put("app/groups/users-list.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span><b>Cognome</b></span></th><th md-column=\"\"><span><b>Nome</b></span></th><th md-column=\"\"><span><b>Ruolo</b></span></th><th md-column=\"\"><span><b>Email</b></span></th><th md-column=\"\"><span><b>Store</b></span></th></tr></thead><tbody ng-if=\"groupUsers\"><tr md-row=\"\" ng-repeat=\"user in groupUsers\"><td md-cell=\"\" style=\"text-align: left;\">{{ user.lastname }}</td><td md-cell=\"\" style=\"text-align: left;\">{{ user.firstname }}</td><td md-cell=\"\" style=\"text-align: left;\">{{ user.type }}</td><td md-cell=\"\" style=\"text-align: left;\">{{ user.email }}</td><td md-cell=\"\" style=\"text-align: left;\">{{ user.store.alias }}</td></tr></tbody></table></md-table-container></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/inventories/inventories.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Inventario</span></h2><span flex=\"\" hide-xs=\"\"></span><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" type=\"search\" placeholder=\"Cerca\"> <span flex=\"\" hide-xs=\"\"></span><div><md-input-container><md-select aria-label=\"Mese\" placeholder=\"Mese\" ng-model=\"ab.query.month\" ng-change=\"ab.eListLoad()\"><md-option value=\"01\">Gennaio</md-option><md-option value=\"02\">Febbraio</md-option><md-option value=\"03\">Marzo</md-option><md-option value=\"04\">Aprile</md-option><md-option value=\"05\">Maggio</md-option><md-option value=\"06\">Giugno</md-option><md-option value=\"07\">Luglio</md-option><md-option value=\"08\">Agosto</md-option><md-option value=\"09\">Settembre</md-option><md-option value=\"10\">Ottobre</md-option><md-option value=\"11\">Novembre</md-option><md-option value=\"12\">Dicembre</md-option></md-select></md-input-container></div><div><md-input-container><md-select aria-label=\"Anno\" placeholder=\"Anno\" ng-model=\"ab.query.year\" ng-change=\"ab.eListLoad()\"><md-option ng-value=\"year\" ng-repeat=\"year in ab.years\">{{ year }}</md-option></md-select></md-input-container></div><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Da magazzino\" ng-if=\"ab.storeId && !ab.mainEntity.id\" ng-disabled=\"ab.loading || ab.productsLoading || ab.storeId==null\" ng-click=\"ab.loadFromStorage()\"><span>Da magazz.</span></md-button><md-button class=\"md-accent md-raised\" aria-label=\"Chiudi inventario\" ng-disabled=\"ab.loading || ab.productsLoading || ab.storeId==null || ab.mainEntity.id==null\" ng-if=\"ab.storeId\" ng-click=\"ab.toggleInventario()\"><md-icon md-font-icon=\"done\">done</md-icon><span ng-if=\"! ab.mainEntity.closed\">Chiudi inventario</span> <span ng-if=\"ab.mainEntity.closed\">Modifica inventario</span></md-button><md-button class=\"md-accent md-raised\" aria-label=\"Invia PDF\" ng-if=\"ab.mainEntity.id!=null && ab.mainEntity.closed && ab.query.month==12\" ng-click=\"ab.pdf()\"><md-icon md-font-icon=\"file_download\">file_download</md-icon>Scarica PDF</md-button></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Fornitore</span></th><th md-column=\"\" md-order-by=\"category\"><span>Categoria</span></th><th md-column=\"\" md-order-by=\"name\"><span>Prodotto</span></th><th md-column=\"\"><span>Confezione</span></th><th md-column=\"\"><span>Qta</span></th><th md-column=\"\" md-numeric=\"\"><span>Prezzo &euro;</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading || ab.productsLoading\"><td md-cell=\"\" colspan=\"7\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading || ab.productsLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" style=\"background-color: #D9D9D9;\"><td md-cell=\"\"></td><td md-cell=\"\"><md-select aria-label=\"Fornitore\" placeholder=\"Filtra\" ng-model=\"ab.query.supplierName\"><md-option value=\"\">Tutti</md-option><md-option value=\"ACCADEMIA COSMECEUTICA\">ACCADEMIA</md-option><md-option value=\"BIOSKIN\">BIOSKIN</md-option><md-option value=\"BIOSNELLA\">BIOSNELLA</md-option><md-option value=\"CARTARIA FORLIVESE\">CARTARIA FORLIVESE</md-option><md-option value=\"CONSORZIO ESTETICA\">CONSORZIO ESTETICA</md-option><md-option value=\"COSMETHIC\">COSMETHIC</md-option><md-option value=\"DOCTOR LIFTING\">DOCTOR LIFTING</md-option><md-option value=\"EPILZONE\">EPILZONE</md-option><md-option value=\"LYNPHALIFE\">LYNPHALIFE</md-option><md-option value=\"PLANTS AND NATURE\">PLANTS AND NATURE</md-option></md-select></td><td md-cell=\"\" colspan=\"2\" style=\"text-align: right\"><strong>Totale &euro;:</strong></td><td md-cell=\"\"></td><td md-cell=\"\" colspan=\"2\" style=\"text-align: right\">{{ ab.eListTotal | number:2 }}</td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" ng-repeat=\"e in (ab.filteredItems = (ab.productsList | filter: ab.gtQueryQty | filter: { supplier: { name: ab.query.supplierName } } | filter: { $: ab.query.filter } | orderBy: ab.query.order ) ) track by e.id\"><td md-cell=\"\">{{ ab.mainEntity.month }}/{{ ab.mainEntity.year }}</td><td md-cell=\"\">{{ e.supplier.name }}</td><td md-cell=\"\">{{ e.category }}</td><td md-cell=\"\">{{ e.name }}</td><td md-cell=\"\">{{ e.conf }}</td><td md-cell=\"\"><md-input-container style=\"margin-left: 20px; padding-bottom: 0px; margin-bottom: 0px; width: 60px;\"><input aria-label=\"Qta\" style=\"text-align: right;\" type=\"number\" name=\"total\" id=\"total\" step=\"1\" min=\"0\" ng-model=\"e.prodInv.qty\" ng-blur=\"ab.saveProdInv(e.prodInv)\" ng-disabled=\"!ab.storeId || e.prodInv.saving || ab.loading || ab.productsLoading || ab.mainEntity.closed\" required=\"\"></md-input-container></td><td md-cell=\"\">{{ e.prodInv.price | number:2 }}</td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content>");
$templateCache.put("app/kpi/kpi.html","<md-content class=\"page-dashboard\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">KPI</span></h2><span flex=\"20\" hide-xs=\"\"></span><h2 class=\"md-headline\">{{dashboard.store.alias}}</h2><span flex=\"\" hide-xs=\"\"></span><div><md-input-container><md-select aria-label=\"Mese\" placeholder=\"Mese\" ng-model=\"dashboard.selectedMonth\" ng-change=\"dashboard.onChangeDate()\"><md-option ng-value=\"month\" ng-repeat=\"month in dashboard.months\">{{month}}</md-option></md-select></md-input-container></div><div><md-input-container><md-select aria-label=\"Anno\" placeholder=\"Anno\" ng-model=\"dashboard.selectedYear\" ng-change=\"dashboard.onChangeDate()\"><md-option ng-value=\"year\" ng-repeat=\"year in dashboard.years\">{{ year }}</md-option></md-select></md-input-container></div><span flex=\"\" hide-xs=\"\"></span><md-checkbox ng-model=\"dashboard.annoPrecedente\" ng-true-value=\"1\" ng-false-value=\"0\" ng-change=\"dashboard.onAnnoPrecedente()\">Anno Precedente</md-checkbox><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar><md-progress-circular style=\"margin: 20px;\" md-diameter=\"30\" ng-if=\"dashboard.loading\" md-mode=\"indeterminate\"></md-progress-circular><md-tabs class=\"md-dynamic-height\" md-selected=\"dashboard.selectedIndex\"><md-tab label=\"Simulazione appuntamenti necessari\"></md-tab><md-tab label=\"Previsione mese\"></md-tab></md-tabs><md-content ng-if=\"dashboard.selectedIndex == 0\" layout-margin=\"\" layout-padding=\"\" layout=\"column\" flex=\"\" layout-align=\"center center\"><ng-include src=\"\'app/kpi/kpi2.html\'\"></ng-include></md-content><md-content ng-if=\"dashboard.selectedIndex == 1\" layout-margin=\"\" layout-padding=\"\" layout=\"column\" flex=\"\" layout-align=\"center center\"><ng-include src=\"\'app/kpi/kpi1.html\'\"></ng-include></md-content></md-content>");
$templateCache.put("app/kpi/kpi1.html","<md-content layout=\"column\" flex=\"\" layout-align=\"center center\"><div flex=\"\" layout-fill=\"\"><md-content flex=\"\" layout=\"row\" layout-margin=\"\"><div><div><h3 style=\"text-align: left;\">Statistiche di riferimento</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"3\">Media ultimi {{dashboard.refMonths}} mesi / su {{dashboard.refDays}} gg</td></tr><tr md-row=\"\"><td md-cell=\"\">Totale app. / mese</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% 1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Smaltimento</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Presentati</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_paid | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Pres.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.paid_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Pres. 1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_paid_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Pres. 1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.paid_perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Pres. Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_paid_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Pres. Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.paid_perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Spostati</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_spostati | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Spostati</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_count_spostati_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Realizzato</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_total | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Realizzzato 1a v.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_total_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">% Realizz. 1a v.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.perc_total_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Realizzzato Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.app_total_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">% Realizz. Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.perc_total_sm*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Scontrino medio</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.media_scontrino | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Scontr. medio 1a v.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.media_scontrino_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Scontr. medio Smalt.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.data.media_scontrino_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">Disponibilit&agrave;</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.availab_minutes/60 | number:0}}</td><td md-cell=\"\">h</td></tr><tr md-row=\"\"><td md-cell=\"\">Redd./h</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.redd_h | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">% Occupato</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.worked_minutes_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">Redd./h su occ.</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.redd_h_w | number:0}}</td><td md-cell=\"\">&euro;</td></tr></tbody></table></md-table-container><h3 ng-if=\"dashboard.storeId\">Utilizzo laser</h3><md-table-container ng-if=\"dashboard.storeId\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">N&deg; laser</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.laser_au.num_laser | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">N&deg; cabine</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.laser_au.num_rooms | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Utilizzo laser</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.laser_au.min_laser_used_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">% Over</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.laser_au.min_over_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\">% Down</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.laser_au.min_down_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container><h3>Costi</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">Costo personale</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.costo_pers | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\">% su realizzato</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.costo_pers_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container><h3>Nuovi clienti da lead</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\">Leads 1a volta</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.lead_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">Leads 1a v. chiusi</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.lead_count_1av_chiusi | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">% Redemption</td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.referenceStats.redemption_lead_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container></div></div><div><div><h3>Fino a ieri</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td ng-if=\"dashboard.currentMonthSelected\" imd-cell=\"\" colspan=\"3\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.work_days}} gg dall\'1 al {{dashboard.yesterday.format(\"DD/MM\")}}</td><td ng-if=\"dashboard.pastMonthSelected\" imd-cell=\"\" colspan=\"3\" style=\"text-align: right; padding-right: 10px;\">dal {{ dashboard.currentMonthPastStatsOpts.date_start}} al {{dashboard.currentMonthPastStatsOpts.date_end}}</td><td ng-if=\"dashboard.futureMonthSelected\" imd-cell=\"\" colspan=\"3\" style=\"text-align: right; padding-right: 10px;\">dal {{ dashboard.currentMonthPastStatsOpts.date_start}} al {{dashboard.currentMonthPastStatsOpts.date_end}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_paid | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.paid_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_paid_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.paid_perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_paid_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.paid_perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_spostati | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_count_spostati_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_total | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_total_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.perc_total_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_total_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.perc_total_sm*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.media_scontrino | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.media_scontrino_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.media_scontrino_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.availab_minutes/60 | number:0}}</td><td md-cell=\"\">h</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.redd_h | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.worked_minutes_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.data.app_total*60/dashboard.currentMonthPastStats.worked_minutes | number:0}}</td><td md-cell=\"\">&euro;</td></tr></tbody></table></md-table-container><h3 ng-if=\"dashboard.storeId\">&nbsp;&nbsp;</h3><md-table-container ng-if=\"dashboard.storeId\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.laser_au.num_laser | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.laser_au.num_rooms | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.laser_au.min_laser_used_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.laser_au.min_over_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.laser_au.min_down_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.lead_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.lead_count_1av_chiusi | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthPastStats.redemption_lead_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container></div></div><div ng-if=\"!dashboard.pastMonthSelected\"><div><h3>Resto del mese</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"3\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.work_days}} gg dal {{dashboard.currentMonthFutureStatsOpts.date_start_frmt}} al {{dashboard.currentMonthFutureStatsOpts.date_end_frmt}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_count | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_count_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_count_paid | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.paid_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_count_paid_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.paid_perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_count_paid_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.paid_perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_total | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_total_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.perc_total_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_total_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.perc_total_sm*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.media_scontrino | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.media_scontrino_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.media_scontrino_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.availab_minutes/60 | number:0}}</td><td md-cell=\"\">h</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.redd_h | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.worked_minutes_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.data.app_total*60/dashboard.currentMonthFutureStats.worked_minutes | number:0}}</td><td md-cell=\"\">&euro;</td></tr></tbody></table></md-table-container><h3 ng-if=\"dashboard.storeId\">&nbsp;&nbsp;</h3><md-table-container ng-if=\"dashboard.storeId\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.laser_au.num_laser | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.laser_au.num_rooms | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.laser_au.min_laser_used_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.laser_au.min_over_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.laser_au.min_down_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.lead_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.lead_count_1av_chiusi | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.redemption_lead_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container></div></div><div ng-if=\"!dashboard.pastMonthSelected\"><div><h3>Previsione</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"3\" style=\"text-align: right; padding-right: 10px;\">{{dashboard.selectedMonth}} {{dashboard.selectedYear}}</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_count | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_count_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_count_paid | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.paid_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_count_paid_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.paid_perc_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_count_paid_sm | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.paid_perc_sm*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_total | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_total_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.perc_total_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_total_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.perc_total_sm*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.media_scontrino | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.media_scontrino_1av | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.media_scontrino_sm | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.availab_minutes/60 | number:0}}</td><td md-cell=\"\">h</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.redd_h | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.worked_minutes_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.app_total*60/dashboard.currentMonthFutureStats.total.worked_minutes | number:0}}</td><td md-cell=\"\">&euro;</td></tr></tbody></table></md-table-container><h3 ng-if=\"dashboard.storeId\">&nbsp;&nbsp;</h3><md-table-container ng-if=\"dashboard.storeId\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.num_laser | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.num_rooms | number:1}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.min_laser_used_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.min_over_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.min_down_perc*100 | number:1}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.costo_pers | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.costo_pers_perc*100 | number:0}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.lead_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.lead_count_1av_chiusi | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.total.redemption_lead_1av*100 | number:0}}</td><td md-cell=\"\">%</td></tr></tbody></table></md-table-container></div></div><div ng-if=\"true\"><div><h3>Trend</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"2\" style=\"border: solid 2px orange; text-align: right; padding-right: 10px;\">%</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_count>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_count | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_count_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_count_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.perc_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.perc_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_count_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_count_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.perc_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.perc_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_count_paid>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_count_paid | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.paid_perc>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.paid_perc | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_count_paid_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_count_paid_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.paid_perc_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.paid_perc_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_count_paid_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_count_paid_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.paid_perc_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.paid_perc_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_total>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_total | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_total_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_total_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.perc_total_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.perc_total_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.app_total_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.app_total_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.perc_total_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.perc_total_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.media_scontrino>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.media_scontrino | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.media_scontrino_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.media_scontrino_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.media_scontrino_sm>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.media_scontrino_sm | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.availab_minutes>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.availab_minutes | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.redd_h>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.redd_h | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.worked_minutes_perc>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.worked_minutes_perc | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.redd_h_w>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.redd_h_w | number:1}} %</td></tr></tbody></table></md-table-container><h3 ng-if=\"dashboard.storeId\">&nbsp;&nbsp;</h3><md-table-container ng-if=\"dashboard.storeId\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.num_laser>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.num_laser | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.num_rooms>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.num_rooms | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.min_laser_used_perc>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.min_laser_used_perc | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.min_over_perc>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.min_over_perc | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.min_down_perc>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.min_down_perc | number:1}} %</td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.costo_pers>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.costo_pers | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.costo_pers_perc>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.costo_pers_perc | number:1}} %</td></tr></tbody></table></md-table-container><h3>&nbsp;&nbsp;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.lead_count_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.lead_count_1av | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.lead_count_1av_chiusi>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.lead_count_1av_chiusi | number:1}} %</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.currentMonthFutureStats.trendPerc.redemption_lead_1av>0?\'+\':\'\'}}{{ dashboard.currentMonthFutureStats.trendPerc.redemption_lead_1av | number:1}} %</td></tr></tbody></table></md-table-container></div></div><div ng-if=\"true\"><div><h3>&Delta;</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" colspan=\"2\" style=\"border: solid 2px orange; text-align: right; padding-right: 10px;\">A obiettivo</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaCurr.app_count>0?\'+\':\'\'}}{{ dashboard.deltaCurr.app_count | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaCurr.app_count_1av>0?\'+\':\'\'}}{{ dashboard.deltaCurr.app_count_1av | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaCurr.app_smaltimento>0?\'+\':\'\'}}{{ dashboard.deltaCurr.app_smaltimento | number:0}}</td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{ dashboard.deltaCurr.media_scontrino | number:0}}</td><td md-cell=\"\">&euro;</td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container></div></div><div ng-if=\"true\"><div><h3>Simulazione</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"background-color: #eeeeee;\"><td md-cell=\"\" style=\"text-align: right; padding-right: 10px;\">{{dashboard.selectedMonth}} {{dashboard.selectedYear}}</td></tr><tr md-row=\"\"><td md-cell=\"\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"curr_target_app_count\">Crescita %</label> <input type=\"number\" name=\"curr_target_app_count\" id=\"curr_target_app_count\" step=\"1\" min=\"0\" ng-model=\"dashboard.currentMonthFutureStats.simulate.crescita\" ng-blur=\"dashboard.onBlurCrescita()\"></md-input-container></td></tr><tr md-row=\"\"><td md-cell=\"\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"curr_target_media_scontrino\">Media scontrino</label> <input type=\"number\" name=\"curr_target_media_scontrino\" id=\"curr_target_media_scontrino\" step=\"0.01\" min=\"0\" ng-model=\"dashboard.currentMonthFutureStats.simulate.media_scontrino\" ng-blur=\"dashboard.onBlurCurrentMediaScontrino()\"></md-input-container></td></tr><tr md-row=\"\"><td md-cell=\"\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"curr_target_app_total\">Obiettivo</label> <input type=\"number\" name=\"curr_target_app_total\" id=\"curr_target_app_total\" step=\"1\" min=\"0\" ng-model=\"dashboard.currentMonthFutureStats.simulate.app_total\" ng-disabled=\"true\"></md-input-container></td></tr><tr md-row=\"\"><td md-cell=\"\"><md-button class=\"md-accent md-raised\" aria-label=\"Ricalcola\" ng-click=\"dashboard.onRicalcola()\"><md-icon md-font-icon=\"check_circle\">check_circle</md-icon>Ricalcola</md-button></td></tr></tbody></table></md-table-container></div></div></md-content></div></md-content>");
$templateCache.put("app/kpi/kpi2.html","<md-content layout=\"column\" flex=\"\" layout-align=\"center center\"><div flex=\"\" layout-fill=\"\"><md-content flex=\"\" layout=\"row\" layout-margin=\"\"><div><div ng-if=\"true\"><div><h3>Simulazione</h3><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" rowspan=\"2\">1-{{dashboard.currentMonthFutureStatsOpts.date_end_frmt1}}</td><td md-cell=\"\"><md-input-container class=\"md-block no-margin-bottom\" flex=\"100\"><label for=\"curr_target_obiettivo\">Obiettivo</label> <input type=\"number\" name=\"curr_target_obiettivo\" id=\"curr_target_obiettivo\" step=\"1\" min=\"0\" ng-change=\"dashboard.abilitaForm()\" ng-model=\"dashboard.currentMonthFutureStats.simulate.obiettivo\"></md-input-container></td><td md-cell=\"\"><md-input-container class=\"md-block no-margin-bottom\" flex=\"100\"><label for=\"curr_target_perc_categoria_1v\">% 1a v.</label> <input type=\"number\" name=\"curr_target_perc_categoria_1v\" id=\"curr_target_perc_categoria_1v\" step=\"1\" min=\"0\" max=\"100\" ng-change=\"dashboard.abilitaForm()\" ng-model=\"dashboard.currentMonthFutureStats.simulate.perc_categoria_1v\" ng-blur=\"dashboard.onBlurPercCategoria()\"></md-input-container></td><td md-cell=\"\"><md-input-container class=\"md-block no-margin-bottom\" flex=\"100\"><label for=\"curr_target_sm_backup_1v\">SM 1a v.</label> <input type=\"number\" name=\"curr_target_sm_backup_1v\" id=\"curr_target_sm_backup_1v\" step=\"1\" min=\"1\" ng-change=\"dashboard.abilitaForm()\" ng-model=\"dashboard.currentMonthFutureStats.simulate.sm_backup_1v\"></md-input-container></td><td md-cell=\"\"><md-input-container class=\"md-block no-margin-bottom\" flex=\"100\"><label for=\"curr_target_perc_presentazione_1v\">% Pres. 1a v.</label> <input type=\"number\" name=\"curr_target_perc_presentazione_1v\" id=\"curr_target_perc_presentazione_1v\" step=\"1\" min=\"0\" max=\"100\" ng-change=\"dashboard.abilitaForm()\" ng-model=\"dashboard.currentMonthFutureStats.simulate.perc_presentazione_1v\"></md-input-container></td></tr><tr md-row=\"\"><td md-cell=\"\" class=\"border-top-none\"></td><td md-cell=\"\" class=\"border-top-none\"><md-input-container class=\"md-block no-margin-bottom\" flex=\"100\"><label for=\"curr_target_perc_categoria_sm\">% Smalt.</label> <input type=\"number\" name=\"curr_target_perc_categoria_sm\" id=\"curr_target_perc_categoria_sm\" step=\"1\" min=\"0\" max=\"100\" ng-model=\"dashboard.currentMonthFutureStats.simulate.perc_categoria_sm\" readonly=\"true\"></md-input-container></td><td md-cell=\"\" class=\"border-top-none\"><md-input-container class=\"md-block no-margin-bottom\" flex=\"100\"><label for=\"curr_target_sm_backup_sm\">SM Smalt.</label> <input type=\"number\" name=\"curr_target_sm_backup_sm\" id=\"curr_target_sm_backup_sm\" step=\"1\" min=\"1\" ng-change=\"dashboard.abilitaForm()\" ng-model=\"dashboard.currentMonthFutureStats.simulate.sm_backup_sm\"></md-input-container></td><td md-cell=\"\" class=\"border-top-none\"><md-input-container class=\"md-block no-margin-bottom\" flex=\"100\"><label for=\"curr_target_perc_presentazione_sm\">% Pres. smalt.</label> <input type=\"number\" name=\"curr_target_perc_presentazione_sm\" id=\"curr_target_perc_presentazione_sm\" step=\"1\" min=\"0\" max=\"100\" ng-change=\"dashboard.abilitaForm()\" ng-model=\"dashboard.currentMonthFutureStats.simulate.perc_presentazione_sm\"></md-input-container></td></tr><tr md-row=\"\"><td md-cell=\"\" colspan=\"5\" style=\"text-align: right\"><md-button class=\"md-accent md-raised\" aria-label=\"Ricalcola\" ng-disabled=\"dashboard.currentMonthFutureStats.simulate.disabilita_form\" ng-click=\"dashboard.onRicalcola2()\"><md-icon md-font-icon=\"check_circle\">check_circle</md-icon>Ricalcola</md-button></td></tr></tbody></table></md-table-container></div></div><div><h3 style=\"text-align: left;\">Consuntivo</h3><md-table-container><table md-table=\"\" class=\"table-text-center full-border\"><thead><tr md-row=\"\"><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 6%\"><b>Periodo</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Tipo</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Obiettivo</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>App. in Ag.</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>App. pres.</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>% pres</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Realizz.</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>% per tipo</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Scon. medio</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Scost.</b></td></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" rowspan=\"3\">1-{{dashboard.yesterday.format(\"DD\")}}</td><td md-cell=\"\">1a v.</td><td md-cell=\"\">&euro;{{dashboard.currentMonthPastStats.data.tot_obiettivo_1v | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthPastStats.data.app_count_1av | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthPastStats.data.app_count_paid_1av | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthPastStats.data.paid_perc_1av*100 | number:0}}%</td><td md-cell=\"\">&euro;{{dashboard.currentMonthPastStats.data.app_total_1av | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthPastStats.data.perc_total_1av*100 | number:0}}%</td><td md-cell=\"\">&euro;{{dashboard.currentMonthPastStats.data.media_scontrino_1av | number:0}}</td><td md-cell=\"\">&euro;{{dashboard.currentMonthPastStats.data.scostamento_1v | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\">Smalt.</td><td md-cell=\"\">&euro;{{dashboard.currentMonthPastStats.data.tot_obiettivo_sm | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthPastStats.data.app_count_sm | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthPastStats.data.app_count_paid_sm | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthPastStats.data.paid_perc_sm*100 | number:0}}%</td><td md-cell=\"\">&euro;{{dashboard.currentMonthPastStats.data.app_total_sm | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthPastStats.data.perc_total_sm*100 | number:0}}%</td><td md-cell=\"\">&euro;{{dashboard.currentMonthPastStats.data.media_scontrino_sm | number:0}}</td><td md-cell=\"\">&euro;{{dashboard.currentMonthPastStats.data.scostamento_sm | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\"><b>Totale</b></td><td md-cell=\"\"><b>&euro;{{dashboard.currentMonthPastStats.data.tot_obiettivo | number:0}}</b></td><td md-cell=\"\"><b>{{dashboard.currentMonthPastStats.data.app_count | number:0}}</b></td><td md-cell=\"\"><b>{{dashboard.currentMonthPastStats.data.app_count_paid | number:0}}</b></td><td md-cell=\"\"><b>{{dashboard.currentMonthPastStats.data.paid_perc*100 | number:0}}%</b></td><td md-cell=\"\"><b>&euro;{{dashboard.currentMonthPastStats.data.app_total | number:0}}</b></td><td md-cell=\"\"></td><td md-cell=\"\"><b>&euro;{{(dashboard.currentMonthPastStats.data.media_scontrino) | number:0}}</b></td><td md-cell=\"\"><b>&euro;{{dashboard.currentMonthPastStats.data.scostamento | number:0}}</b></td></tr></tbody></table></md-table-container></div><div><h3 style=\"text-align: left;\">Preventivo</h3><md-table-container><table md-table=\"\" class=\"table-text-center full-border\"><thead><tr md-row=\"\"><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 6%\"><b>Periodo</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Tipologia</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Obiettivo</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>App. ag.<br>necessari</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>App. pres.<br>necessari</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>% pres.</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Obiett. per tipo</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>% per tipo</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"></td></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" rowspan=\"3\">{{dashboard.currentMonthFutureStatsOpts.date_start_frmt}}-{{dashboard.currentMonthFutureStatsOpts.date_end_frmt1}}</td><td md-cell=\"\">1a v.</td><td md-cell=\"\"></td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.data.app_agendati_necessari_1v | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.data.app_presentati_necessari_1v | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.simulate.perc_presentazione_1v | number:0}}%</td><td md-cell=\"\">&euro;{{dashboard.currentMonthFutureStats.data.incasso_tipologia_1v | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.simulate.perc_categoria_1v | number:0}}%</td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\">Smalt.</td><td md-cell=\"\"></td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.data.app_agendati_necessari_sm | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.data.app_presentati_necessari_sm | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.simulate.perc_presentazione_sm | number:0}}%</td><td md-cell=\"\">&euro;{{dashboard.currentMonthFutureStats.data.incasso_tipologia_sm | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.simulate.perc_categoria_sm | number:0}}%</td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\"><td md-cell=\"\"><b>Totale</b></td><td md-cell=\"\"><b>&euro;{{dashboard.currentMonthFutureStats.data.obiettivo | number:0}}</b></td><td md-cell=\"\"><b>{{dashboard.currentMonthFutureStats.data.app_agendati_necessari | number:0}}</b></td><td md-cell=\"\"><b>{{dashboard.currentMonthFutureStats.data.app_presentati_necessari | number:0}}</b></td><td md-cell=\"\"></td><td md-cell=\"\"><b>&euro;{{ dashboard.currentMonthFutureStats.data.incasso_tipologia | number:0}}</b></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container></div><div><h3 style=\"text-align: left;\">Previsione</h3><md-table-container><table md-table=\"\" class=\"table-text-center full-border\"><thead><tr md-row=\"\"><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 8%\"></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Tipo</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Obiett. per tipo</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>App. in ag.</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>App. pres.</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>% pres.</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Potenziale<br>Agenda</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Scost. app. ag.</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Scost. app. pres.</b></td><td md-cell=\"\" class=\"tr-kpi1-title\" style=\"width: 10%\"><b>Scost.</b></td></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" rowspan=\"3\"></td><td md-cell=\"\">1a v.</td><td md-cell=\"\">&euro;{{dashboard.currentMonthFutureStats.data.incasso_tipologia_1v | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.data.app_count_1av | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.data.appuntamenti_presenteranno_1v | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.simulate.perc_presentazione_1v | number:0}}%</td><td md-cell=\"\">&euro;{{dashboard.currentMonthFutureStats.data.potenziale_agenda_1v | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.data.scostamento_appuntamenti_1v | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.data.scostamento_presentati_1v | number:0}}</td><td md-cell=\"\">&euro;{{dashboard.currentMonthFutureStats.data.scostamento_1v | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\">Smalt.</td><td md-cell=\"\">&euro;{{dashboard.currentMonthFutureStats.data.incasso_tipologia_sm | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.data.app_count_sm | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.data.appuntamenti_presenteranno_sm | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.simulate.perc_presentazione_sm | number:0}}%</td><td md-cell=\"\">&euro;{{dashboard.currentMonthFutureStats.data.potenziale_agenda_sm | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.data.scostamento_appuntamenti_sm | number:0}}</td><td md-cell=\"\">{{dashboard.currentMonthFutureStats.data.scostamento_presentati_sm | number:0}}</td><td md-cell=\"\">&euro;{{dashboard.currentMonthFutureStats.data.scostamento_sm | number:0}}</td></tr><tr md-row=\"\"><td md-cell=\"\"><b>Totale</b></td><td md-cell=\"\"><b>&euro;{{dashboard.currentMonthFutureStats.data.obiettivo | number:0}}</b></td><td md-cell=\"\"><b>{{dashboard.currentMonthFutureStats.data.app_count | number:0}}</b></td><td md-cell=\"\"><b>{{dashboard.currentMonthFutureStats.data.appuntamenti_presenteranno | number:0}}</b></td><td md-cell=\"\"></td><td md-cell=\"\"><b>&euro;{{dashboard.currentMonthFutureStats.data.potenziale_agenda | number:0}}</b></td><td md-cell=\"\"><b>{{dashboard.currentMonthFutureStats.data.scostamento_appuntamenti | number:0}}</b></td><td md-cell=\"\"><b>{{dashboard.currentMonthFutureStats.data.scostamento_presentati | number:0}}</b></td><td md-cell=\"\"><b>&euro;{{dashboard.currentMonthFutureStats.data.scostamento | number:0}}</b></td></tr></tbody></table></md-table-container></div></div></md-content></div></md-content>");
$templateCache.put("app/landings/landings.html","<md-backdrop ng-click=\"landings.closeSidebar()\" ng-show=\"landings.undoVisible && ! landings.itsNew\" class=\"md-sidenav-backdrop md-opaque\"></md-backdrop><md-content class=\"page-landings\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Landing Pages</span></h2><span flex=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuova Landing Page\" ng-click=\"landings.toggleRight()\"><md-icon md-font-icon=\"note_add\">note_add</md-icon>Nuova Landing Page</md-button></div></md-toolbar><md-card><md-toolbar class=\"md-table-toolbar md-default search-toolbar\"><div class=\"md-toolbar-tools\"><md-input-container md-no-float=\"\" class=\"md-accent\" flex=\"\"><md-icon md-font-icon=\"search\">search</md-icon><input type=\"search\" placeholder=\"Cerca..\" ng-model=\"landings.query.filter\"></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div></div></md-toolbar><md-table-container><table md-table=\"\" ng-model=\"landings.selected\" md-row-select=\"landings.options.rowSelection\"><thead md-head=\"\" md-order=\"landings.query.order\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"alias\"><span>Alias</span></th><th md-column=\"\" md-order-by=\"title\"><span>Titolo</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"treatment_id\"><span>Servizio</span></th><th md-column=\"\" class=\"text-center\" md-order-by=\"store_id\"><span>Centro</span></th><th md-column=\"\" md-order-by=\"code\"><span>Codice</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"price\"><span>Prezzo &euro;</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"landing\" md-select-id=\"landing.id\" md-on-select=\"landings.rowClicked\" ng-click=\"landings.rowClicked( landing )\" md-auto-select=\"landings.options.autoSelect\" ng-repeat=\"landing in landings.landings | filter: landings.query.filter | orderBy: landings.query.order track by landing.id\"><td md-cell=\"\">{{ landing.alias }}</td><td md-cell=\"\">{{ landing.title }}</td><td md-cell=\"\">{{ landing.treatment_id | treatmentIdtoName:landings.treatmentsList }}</td><td md-cell=\"\" class=\"md-caption-container\"><div class=\"md-caption\" ng-repeat=\"store in landing.stores.data\">{{ store.id | storeIdtoName:landings.storesList }}</div></td><td md-cell=\"\">{{ landing.code }}</td><td md-cell=\"\">{{ landing.price }}</td></tr></tbody></table></md-table-container></md-card></md-content><md-sidenav md-is-locked-open=\"landings.undoVisible && ! landings.itsNew\" md-whiteframe=\"4\" class=\"page-landings md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"view_carousel\">view_carousel</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"landings.activeLanding.alias\">{{ landings.activeLanding.alias }}</span> <span class=\"inset\" ng-if=\"! landings.activeLanding.alias\">Aggiunta nuova Landing Page</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"landings.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"landingForm\" id=\"landingForm\" layout=\"column\" enctype=\"multipart/form-data\"><md-input-container class=\"md-block\"><label for=\"alias\">Alias *</label> <input type=\"text\" name=\"alias\" id=\"alias\" required=\"\" md-autofocus=\"\" ng-model=\"landings.activeLanding.alias\" ng-model-options=\"landings.filter.options\"><div ng-messages=\"landingForm.alias.$error\" ng-if=\"landingForm.alias.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container class=\"md-block\"><label for=\"titolo\">Titolo *</label> <input type=\"text\" name=\"titolo\" id=\"titolo\" required=\"\" ng-model=\"landings.activeLanding.title\" ng-model-options=\"landings.filter.options\"><div ng-messages=\"landingForm.titolo.$error\" ng-if=\"landingForm.titolo.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container class=\"md-block\"><label for=\"codice\">Codice *</label> <input type=\"text\" name=\"codice\" id=\"codice\" required=\"\" ng-model=\"landings.activeLanding.code\" ng-model-options=\"landings.filter.options\"><div ng-messages=\"landingForm.codice.$error\" ng-if=\"landingForm.codice.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container class=\"md-block\"><label for=\"id_servizio\">{{ landings.treatmentsTitle }} *</label><md-select ng-model=\"landings.activeLanding.treatment_id\" aria-label=\"{{ landings.treatmentsTitle }}\" id=\"id_servizio\" name=\"id_servizio\" required=\"\"><md-optgroup label=\"{{ group.name }}\" ng-repeat=\"group in landings.treatmentsList track by group.id\"><md-option ng-value=\"treatment.id\" ng-repeat=\"treatment in group.treatments.data track by treatment.id\">{{ treatment.name }}</md-option></md-optgroup></md-select><div ng-messages=\"landingForm.id_servizio.$error\" ng-if=\"landingForm.id_servizio.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container class=\"md-block\"><label for=\"id_centro\">{{ landings.storesTitle }} *</label><md-select ng-model=\"landings.activeLanding.store_id\" aria-label=\"{{ landings.storesTitle }}\" id=\"id_centro\" name=\"id_centro\" multiple=\"\"><md-optgroup label=\"Seleziona uno o più Store\"><md-option ng-value=\"store.id\" ng-repeat=\"store in landings.storesList track by store.id\">{{ store.name }} - {{ store.city }} - {{ store.address }}</md-option></md-optgroup></md-select><div ng-messages=\"landingForm.id_centro.$error\" ng-if=\"landingForm.id_centro.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container class=\"md-block\"><label for=\"price\">Prezzo (in &euro;)</label> <input type=\"number\" step=\"0.01\" min=\"0\" name=\"price\" id=\"price\" ng-model=\"landings.activeLanding.price\" ng-model-options=\"landings.filter.options\"><div ng-messages=\"landingForm.price.$error\" ng-if=\"landingForm.price.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container class=\"md-block\"><label for=\"description\">Descrizione</label> <textarea name=\"description\" id=\"description\" ng-model=\"landings.activeLanding.description\"></textarea></md-input-container><div layout=\"row\" layout-align=\"center center\" ng-if=\"false\"><md-input-file-img flex=\"\" ng-show=\"! landings.activeLanding.image\"></md-input-file-img><md-progress-circular md-mode=\"indeterminate\" ng-if=\"landings.img_loading\"></md-progress-circular></div><div ng-if=\"false\"><md-card class=\"position-relative md-card-margin\" ng-if=\"landings.activeLanding.img\" md-whiteframe=\"2\" layout-margin=\"\"><img class=\"md-card-image md-image-responsive\" ng-src=\"{{ landings.activeLanding.image }}\" alt=\"Immagine\"><md-button title=\"Cambia\" class=\"md-fab-top-right md-fab md-mini md-warn md-raised\" aria-label=\"Change\" ng-click=\"landings.delImg()\"><md-icon md-font-icon=\"undo\">undo</md-icon></md-button></md-card></div><div flex=\"100\"><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"landings.save( landings.activeLanding )\" ng-disabled=\"landingForm.$invalid\" ng-if=\"landings.undoVisible && ! landings.itsNew\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button><md-button class=\"md-warn md-raised\" aria-label=\"Salva\" ng-click=\"landings.del( landings.activeLanding )\" ng-if=\"! landings.itsNew\"><md-icon md-font-icon=\"delete\">delete</md-icon>Cancella</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Salva\" ng-click=\"landings.undo()\" ng-if=\"landings.undoVisible && ! landings.itsNew\">Annulla</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Aggiungi\" ng-click=\"landings.add( landings.activeLanding )\" ng-disabled=\"landingForm.$invalid\" ng-if=\"landings.itsNew\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Tests\" ng-click=\"landings.tests()\" ng-if=\"landings.testsVisible\">TESTS</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/lead/lead.html","<md-content class=\"page-addressbook page-lead\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"input\">input</md-icon><span class=\"inset\">Prossimo Lead | {{ ab.currentLead.customer.lastname }} {{ ab.currentLead.customer.firstname }} | {{ab.currentLead.tenant }}</span> <span ng-if=\"ab.user.type == \'admin\'\">(cid: {{ab.currentLead.cid}} lid: {{ab.currentLead.id}}/{{ab.currentLead.type}})</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button ng-class=\"{\'md-accent md-raised\' : !button.isFinal, \'md-accent md-raised md-warn\' : button.isFinal}\" ng-repeat=\"button in ab.buttons\" ng-show=\"button.condition\" ng-disabled=\"ab.isWorkingByOther\" ng-click=\"ab.buttonClick(button)\" aria-label=\"{{button.tip}}\"><md-icon md-font-icon=\"{{button.icon}}\">{{button.icon}}</md-icon>{{button.label}}</md-button></div></md-toolbar><md-card><md-card-header style=\"padding-bottom: 6px; padding-top: 6px;\"><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.search\" ng-keypress=\"ab.onKeyPressSearch($event)\" placeholder=\"Cerca\"></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><md-input-container class=\"md-block\" flex=\"25\" md-no-float=\"\" layout=\"row\" ng-if=\"ab.searchTailEnabled\"><md-select id=\"searchTail\" name=\"searchTail\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Selezione coda\" placeholder=\"Selezione coda\" ng-model=\"ab.searchTail\" ng-change=\"ab.filterTail()\"><md-option ng-value=\"\"></md-option><md-option ng-value=\"\'hot\'\">Da chiamare</md-option><md-option ng-value=\"\'hot-cs\'\">Da chiamare (CS)</md-option><md-option ng-value=\"\'recall\'\">Da richiamare</md-option><md-option ng-value=\"\'nr\'\">NR</md-option><md-option ng-value=\"\'nr23n\'\">NR2 o NR3</md-option><md-option ng-value=\"\'hot-wa1\'\">Inviato WhatsApp 1</md-option><md-option ng-value=\"\'conf-wa1\'\">Inviato WhatsApp 1 (da conferma)</md-option><md-option ng-value=\"\'tail\'\">Altro</md-option></md-select></md-input-container>&nbsp;&nbsp;<md-input-container class=\"md-block\" flex=\"25\" md-no-float=\"\" layout=\"row\" ng-if=\"ab.searchTypeEnabled\"><md-select id=\"searchType\" name=\"searchType\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Selezione categoria\" placeholder=\"Selezione categoria\" ng-model=\"ab.searchType\" ng-change=\"ab.filterType()\"><md-option ng-value=\"\"></md-option><md-option ng-value=\"\'other\'\">Lead Caldo</md-option><md-option ng-value=\"\'non fidelizzato\'\">CS</md-option><md-option ng-value=\"\'disdetto\'\">Disdetto</md-option><md-option ng-value=\"\'non presentato\'\">Non presentato</md-option><md-option ng-value=\"\'phonefriend\'\">Phone Friend</md-option><md-option ng-value=\"\'referential\'\">Referral Referenzianti</md-option><md-option ng-value=\"\'rullo\'\">Rullo</md-option></md-select></md-input-container>&nbsp;&nbsp;<md-input-container class=\"md-block\" flex=\"15\" md-no-float=\"\" layout=\"row\" ng-if=\"true\"><md-select id=\"searchNr\" name=\"searchNr\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Selezione stato\" placeholder=\"Selezione stato\" ng-model=\"ab.searchNr\" ng-change=\"ab.filterNr()\"><md-option ng-value=\"\"></md-option><md-option ng-value=\"\'da chiamare\'\">Da chiamare</md-option><md-option ng-value=\"\'da richiamare\'\">Da richiamare</md-option><md-option ng-value=\"\'inviato whatsapp 1\'\">Inviato WhatsApp</md-option><md-option ng-value=\"\'nr\'\">NR</md-option><md-option ng-value=\"\'nr 2\'\">NR 2</md-option><md-option ng-value=\"\'nr 3\'\">NR 3</md-option><md-option ng-value=\"\'nr 4\'\">NR 4</md-option></md-select></md-input-container>&nbsp;&nbsp;<md-input-container class=\"md-block\" flex=\"15\" md-no-float=\"\" layout=\"row\" ng-if=\"ab.searchNr\"><md-select id=\"searchCutDays\" name=\"searchCutDays\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Selezione n. giorni\" placeholder=\"Selezione n. giorni\" ng-model=\"ab.searchCutDays\" ng-change=\"ab.filterNr()\"><md-option ng-value=\"\"></md-option><md-option ng-value=\"\'30\'\">30 giorni</md-option><md-option ng-value=\"\'60\'\">60 giorni</md-option><md-option ng-value=\"\'90\'\">90 giorni</md-option><md-option ng-value=\"\'120\'\">120 giorni</md-option></md-select></md-input-container><span flex=\"\"></span><md-button aria-label=\"Online\" ng-if=\"ab.user.type == \'callcenter\' && ab.fLeadHotOnline && !ab.user.store_id\" class=\"md-raised md-accent\" ng-click=\"ab.setFLeadHotOnline(false)\"><md-icon title=\"Online\" md-font-icon=\"place\">place</md-icon>Online</md-button><md-button aria-label=\"Offline\" ng-if=\"ab.user.type == \'callcenter\' && !ab.fLeadHotOnline && !ab.user.store_id\" class=\"md-raised md-accent md-warn\" ng-click=\"ab.setFLeadHotOnline(true)\"><md-icon title=\"Offline\" md-font-icon=\"place\">place</md-icon>Offline</md-button></div></md-toolbar></md-card-header><md-card-content style=\"overflow-y: auto; padding-top: 0px;\"><h2 ng-if=\"ab.eList.length == 0 && !ab.eListLoading\">Nessun lead trovato</h2><md-progress-circular ng-if=\"ab.eListLoading\" md-diameter=\"30\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container><table md-table=\"\" ng-repeat=\"e in ab.eList\"><thead><tr ng-if=\"ab.isWorkingByOther\" style=\"background-color: #e3e3e3;\" class=\"lead-detail\"><th colspan=\"4\" md-cell=\"\"><h2><label>In lavorazione da {{ ab.currentLead.working_user.lastname }} {{ ab.currentLead.working_user.firstname }}</label><md-button class=\"md-primary md-raised\" aria-label=\"Modifica\" ng-click=\"ab.isWorkingByOther = false\"><md-icon md-font-icon=\"edit\">edit</md-icon>Modifica</md-button></h2></th></tr><tr ng-if=\"(e.category==\'confermacomm\' || e.category==\'confermaop\') && e.appointment && e.appointment.closed\" style=\"background-color: #e3e3e3;\" class=\"lead-detail\"><th colspan=\"4\" md-cell=\"\"><h2><label>Cassa chiusa</label></h2></th></tr><tr style=\"background-color: {{e.bgColor}}; color: {{e.textColor}}\"><th colspan=\"4\"><h3><md-icon ng-if=\"e.icon\" md-font-icon=\"{{e.icon}}\" style=\"background-color: white; color:{{e.iconColor}};\">{{e.icon}}</md-icon>{{ e.typeDescr }} {{ e.call_state }} in data: {{ e.call_date | date : \'dd/MM/yyyy HH:mm\' }} {{ e.recall_delay ? \'(\'+e.recall_delay+\')\' : \'\'}}<md-button class=\"md-primary md-raised\" ng-disabled=\"ab.isWorkingByOther\" ng-if=\"e.category!=\'confermacomm\' && e.category!=\'confermaop\' && e.campagna != \'Referral Referenziante\'\" aria-label=\"Prendi nuovo appuntamento\" ng-href=\"{{ ab.env.booking }}/operator?tenant={{ ab.env.currentTenant }}&amp;c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;lead={{e.id}}&amp;tag={{e.tag}}&amp;store={{ ab.storeId }}&amp;customer={{ e.customer.phone }}&amp;token={{ ab.token }}&amp;campagna={{e.campagna}}\" target=\"_self\"><md-icon md-font-icon=\"today\">today</md-icon>Prenota</md-button><md-button class=\"md-primary md-raised\" ng-disabled=\"ab.isWorkingByOther || e.appointment.closed || e.call_state == \'spostato\'\" ng-if=\"e.category==\'confermacomm\' || e.category==\'confermaop\'\" aria-label=\"Sposta appuntamento\" ng-href=\"{{ ab.env.bookings[ab.env.currentTenant] }}/operator?c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;store={{ e.appointment.store_id }}&amp;customer={{ e.customer.phone }}&amp;callcenter=true&amp;appointment={{e.appointment.id}}&amp;treatment={{e.appointment.treatment_id}}&amp;appointmentDate={{e.appointment.date_start}}&amp;token={{ ab.token }}\" target=\"_self\"><md-icon md-font-icon=\"today\">today</md-icon>Sposta</md-button><md-button class=\"md-primary md-raised\" ng-disabled=\"ab.isWorkingByOther\" ng-if=\"e.category==\'confermacomm\' || e.category==\'confermaop\' || e.category==\'disdetto\'\" aria-label=\"Visualizza appuntamento\" ui-sref=\"home.appointments({ filter : \'id=\'+e.appointment.id, filter_date: e.appointment.date_start})\" target=\"_self\"><md-icon md-font-icon=\"book\">book</md-icon>Visualizza</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Invia messaggio per invito amici progetto Referral\" ng-click=\"ab.inviaMessaggioReferral(e.customer);\" ng-if=\"(ab.user.type == \'admin\' || ab.user.type == \'callcenter\') && e.campagna == \'Referral Referenziante\'\" ng-disabled=\"ab.sending || e.customer.referral_sent_at_days!==null && e.customer.referral_sent_at_days<30\"><md-icon title=\"Invia messaggio per invito amici progetto Referral\" md-font-icon=\"group_add\">group_add</md-icon>Invia messaggio referral</md-button></h3></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.eListLoading\"><td md-cell=\"\" colspan=\"4\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.eListLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" class=\"lead-detail\"><td md-cell=\"\" flex=\"25\" width=\"25%\"><h3><md-icon title=\"Appuntamento scoperto\" md-font-icon=\"warning\" class=\"md-warn\" ng-if=\"e.appointment && e.appointment.uncovered\">warning</md-icon><md-icon title=\"Appuntamento overbooking\" md-font-icon=\"grid_off\" class=\"md-warn\" ng-if=\"e.appointment && e.appointment.f_over == 1 && e.appointment.by_operator!=36\">grid_off</md-icon><md-icon title=\"Appuntamento overbooking\" md-font-icon=\"border_clear\" class=\"md-warn\" ng-if=\"e.appointment && e.appointment.f_over == 2\">border_clear</md-icon><md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"e.appointment && e.appointment.type == \'abb\' && e.appointment.customer_subscription_id !== null\">autorenew</md-icon>{{ e.customer.lastname }} {{ e.customer.firstname }}<bl-btn-lead-history entity=\"e\" user=\"ab.user\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Scheda cliente\" ui-sref=\"home.customer( { customer_id : e.customer.id } )\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button></bl-btn-lead-history></h3><label ng-if=\"e.customer.city\">Citt&agrave;:</label> <span ng-if=\"e.customer.city\">{{ e.customer.city }}</span> <label ng-if=\"e.region\">Zona:</label> <span ng-if=\"e.region\">{{ e.region }}</span></td><td md-cell=\"\" flex=\"25\" width=\"25%\"><a href=\"tel:{{ e.customer.phone }}\"><span class=\"md-input\">{{ e.customer.phone }}</span></a><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Chiama\" href=\"tel:+39{{e.customer.phone}}\"><md-icon md-font-icon=\"call\">call</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"WhatsApp\" ui-sref=\"home.whatsapp({phone: e.customer.phone})\"><md-icon md-font-icon=\"chat\">chat</md-icon></md-button><span ng-if=\"e.customer.email\"><br><a href=\"mailto:{{e.customer.email}}\">{{e.customer.email}}</a></span></td><td md-cell=\"\" flex=\"25\" width=\"25%\"><label ng-if=\"!e.appointment\">Data:</label> <span ng-if=\"!e.appointment\">{{ e.created_at_frm }}</span> <label ng-if=\"e.appointment\">Data app.:</label> <span ng-if=\"e.appointment\" class=\"md-input\">{{ e.appointment.date_start_frm?e.appointment.date_start_frm:e.appointment.date_start }}<br><br>{{ e.appointment.treatment.name }}</span></td><td md-cell=\"\" flex=\"25\" width=\"25%\"><label>Centro e area:</label><br><br><span ng-if=\"!e.appointment && e.customer.last_store\" class=\"md-input\">{{ e.customer.last_store.alias }}<br>{{ e.customer.last_store.address }} - {{ e.customer.last_store.city }}</span> <span ng-if=\"e.appointment && e.appointment.store\" class=\"md-input\">{{ e.appointment.store.alias }}<br>{{ e.appointment.store.address }} - {{ e.appointment.store.city }}</span> <span ng-if=\"e.customer.tenant\" class=\"md-input\">{{ e.customer.tenant.substring(0,2) }}</span></td></tr><tr class=\"lead-detail\"><td md-cell=\"\" flex=\"25\" ng-if=\"!e.appointment\">{{ e.campagna }}<br><i>({{ e.category }}<span ng-if=\"e.categoria\">/{{ e.categoria }}</span>)</i></td><td md-cell=\"\" flex=\"25\" ng-if=\"!e.appointment\"><p><b>{{ e.call_state }}</b></p><p ng-if=\"e.user\">Assegnato a: <b>{{ e.user.lastname }} {{ e.user.firstname }}</b></p></td><td flex=\"25\" md-cell=\"\" ng-if=\"e.appointment\"><label ng-if=\"e.category!=\'disdetto\'\">Verr&agrave; gestito da:</label><br><br><label ng-if=\"e.category==\'disdetto\'\">Operatrice:</label><br><br><div layout=\"row\"><div class=\"operator-circle\" style=\"background-color: {{ e.appointment.role?e.appointment.role.color:e.appointment.user.color }};\"></div>&nbsp;&nbsp;<span class=\"md-input\">{{ e.appointment.user.lastname }} {{ e.appointment.user.firstname }}</span></div></td><td flex=\"25\" md-cell=\"\" ng-if=\"e.appointment\"><label>Fissato da:</label><br><div class=\"md-input\" ng-if=\"e.appointment\"><bl-btn-appointment-info customer=\"e.customer\" lead=\"e\" byoperator=\"e.appointment.byOperator\" appointment=\"e.appointment\" user=\"ab.user\"></bl-btn-appointment-info>{{ e.appointment.byOperator.lastname }} {{ e.appointment.byOperator.firstname }} il {{e.appointment.created_at_frm?e.appointment.created_at_frm:e.appointment.created_at}}</div></td><td flex=\"25\" md-cell=\"\"><label>Note lead:</label><br><br><span class=\"md-input\">{{ e.note }}</span></td><td flex=\"25\" md-cell=\"\"><label>Note cliente:</label><br><br><span class=\"md-input\">{{ e.customer.note }}</span> <span ng-if=\"e.customer.referral_sent_at\" class=\"md-input\"><br>Messaggio referral inviato il {{ e.customer.referral_sent_at_frmt }}, {{e.customer.referral_sent_at_days}} giorni f&agrave;</span></td></tr><tr class=\"lead-detail\" ng-if=\"e.appointment\"><td md-cell=\"\" colspan=\"2\" flex=\"50\"><label>Note appuntamento:</label><br><br><span class=\"md-input\">{{ e.appointment.note }}</span></td><td md-cell=\"\" colspan=\"2\" flex=\"50\"><label>Anomalie:</label><br><br><span ng-repeat=\"anomalia in e.appointment.anomalie\" class=\"md-input\">{{ anomalia.description }}</span></td></tr><tr ng-if=\"false\"><td md-cell=\"\" colspan=\"4\">{{ e.customer | json }}</td></tr><tr class=\"lead-detail\"><td md-cell=\"\" colspan=\"2\" flex=\"50\" style=\"vertical-align: top;\"><label>Altri leads:</label><br><br><md-table-container class=\"addressbook-appointments\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Ar.</th><th md-column=\"\">Data</th><th md-column=\"\">Campagna</th><th md-column=\"\">N.</th><th md-column=\"\">Dup.</th><th align=\"center\" md-column=\"\">1° v.</th><th md-column=\"\">Stato</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"e in e.customer.leads | orderBy: \'-created_at\'\" ng-if=\"e.uid != ab.currentLead.uid && e.id != ab.currentLead.id\"><td md-cell=\"\">{{ (e.tenant?e.tenant.substring(0,2):\'\') }}</td><td md-cell=\"\">{{ e.created_at_frm?e.created_at_frm:e.created_at }}</td><td md-cell=\"\">{{ e.campagna }}</td><td md-cell=\"\" ng-click=\"ab.showNoteLead( e )\"><md-icon title=\"Nota\" md-font-icon=\"event_note\" ng-if=\"e.note != null && e.note != \'\'\">event_note</md-icon></td><td md-cell=\"\">{{ e.f_dup?\'Si\' : \'No\' }}</td><td align=\"center\" md-cell=\"\">{{ 2 > e.user_times ? \'Si\' : \'No\' }}</td><td md-cell=\"\">{{ e.call_state }}</td></tr></tbody></table></md-table-container></td><td md-cell=\"\" colspan=\"2\" flex=\"50\" style=\"vertical-align: top;\"><label>Appuntamenti:</label><br><br><md-table-container class=\"page-lead addressbook-appointments\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th align=\"center\" md-column=\"\">Pres.</th><th md-column=\"\">Centro</th><th md-column=\"\">Data</th><th md-column=\"\">Tratt.</th><th md-column=\"\">N.</th><th align=\"center\" md-column=\"\">1° v.</th><th md-column=\"\" md-numeric=\"\">Real.</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"appointment in e.customer.appointments | orderBy: \'-date_start\'\" ng-class=\"{\'current_app\': appointment.id == ab.currentLead.appointment_id}\"><td align=\"center\" md-cell=\"\" class=\"{{appointment.recalled>=3?\'recalled_\'+appointment.recalled:( appointment.paid? \'\':\'app_notpaid\')}}\">{{ appointment.recalled==3?\'Disd\':(appointment.recalled==4?\'Spost\':(appointment.paid? \'Si\' :\'No\')) }}</td><td md-cell=\"\">{{ appointment.store.alias }}</td><td md-cell=\"\">{{ appointment.date_start_frm?appointment.date_start_frm:appointment.date_start }}</td><td md-cell=\"\">{{ appointment.treatment.name }}<md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.customer_subscription_id !== null\">autorenew</md-icon></td><td md-cell=\"\" ng-click=\"ab.showNoteApp( appointment )\"><md-icon title=\"Nota\" md-font-icon=\"event_note\" ng-if=\"appointment.note != null && appointment.note != \'\' || appointment.anomalie != null && appointment.anomalie.length>0 || appointment.note_diagnosi != null && appointment.note_diagnosi != \'\' || appointment.note_terapia != null && appointment.note_terapia != \'\'\">event_note</md-icon></td><td align=\"center\" md-cell=\"\">{{ 2 > appointment.user_times ? \'Si\' : \'No\' }}</td><td align=\"right\" md-cell=\"\">{{ appointment.price | number:2 }}</td></tr></tbody></table></md-table-container></td></tr><tr class=\"lead-detail\"><td md-cell=\"\" colspan=\"2\" flex=\"50\" style=\"vertical-align: top;\"><label>Segnalato da:</label><br><br><span class=\"md-input\" ng-if=\"e.customer.source_customer\">{{ e.customer.source_customer.lastname }} {{ e.customer.source_customer.lastname }} | <a href=\"tel:+39{{ e.customer.source_customer.phone }}\">{{ e.customer.source_customer.phone }}</a></span><br><br><label>Phonefriends:</label><br><br><md-tabs class=\"md-dynamic-height\" md-selected=\"ab.selectedPf\"><md-tab ng-repeat=\"friend in e.customer.phonefriends\" label=\"{{ friend.lastname }} {{ friend.firstname }} - {{ friend.phone }}\"></md-tab></md-tabs><div ng-repeat=\"friend in e.customer.phonefriends\" ng-if=\"ab.selectedPf == $index\"><label class=\"md-input\">&nbsp;</label><md-table-container class=\"page-lead addressbook-appointments\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th align=\"center\" md-column=\"\">Pres.</th><th md-column=\"\">Centro</th><th md-column=\"\">Data</th><th md-column=\"\">Tratt.</th><th md-column=\"\">N.</th><th align=\"center\" md-column=\"\">1° v.</th><th md-column=\"\" md-numeric=\"\">Real.</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"appointment in friend.appointments | orderBy: \'-date_start\'\" ng-class=\"{\'current_app\': appointment.id == ab.currentLead.appointment_id}\"><td align=\"center\" md-cell=\"\" class=\"{{appointment.recalled>=3?\'recalled_\'+appointment.recalled:( appointment.paid? \'\':\'app_notpaid\')}}\">{{ appointment.recalled==3?\'Disd\':(appointment.recalled==4?\'Spost\':(appointment.paid? \'Si\' :\'No\')) }}</td><td md-cell=\"\">{{ appointment.store.alias }}</td><td md-cell=\"\">{{ appointment.date_start_frm?appointment.date_start_frm:appointment.date_start }}</td><td md-cell=\"\">{{ appointment.treatment.name }}<md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.customer_subscription_id !== null\">autorenew</md-icon></td><td md-cell=\"\" ng-click=\"ab.showNoteApp( appointment )\"><md-icon title=\"Nota\" md-font-icon=\"event_note\" ng-if=\"appointment.note != null && appointment.note != \'\' || appointment.anomalie != null && appointment.anomalie.length>0\">event_note</md-icon></td><td align=\"center\" md-cell=\"\">{{ 2 > appointment.user_times ? \'Si\' : \'No\' }}</td><td align=\"right\" md-cell=\"\">{{ appointment.price | number:2 }}</td></tr></tbody></table></md-table-container></div></td><td md-cell=\"\" colspan=\"2\" flex=\"50\" style=\"vertical-align: top;\" class=\"page-whatsapp\"><label>Whatsapp:</label><br><br><bl-whatsapp user=\"ab.user\" customer=\"e.customer\" reset=\"false\" pusher=\"true\"></bl-whatsapp></td></tr></tbody></table></md-table-container></md-card-content></md-card><md-card class=\"page-lead\"><md-card-header style=\"padding-bottom: 6px; padding-top: 6px;\"><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><h3>Coda <span ng-if=\"ab.codaList.length>0 && ab.codaList[0].type==\'2.hot30m\'\">lead caldi (ultimi 30 min.)</span> <span ng-if=\"ab.codaList.length>0 && ab.codaList[0].type==\'4.hot\'\">lead caldi</span> <span ng-if=\"ab.codaList.length>0 && ab.codaList[0].type==\'hotA\'\">lead caldi (da non assegnati)</span> <span ng-if=\"ab.codaList.length>0 && ab.codaList[0].type==\'1.recall\'\">richiami</span> <span ng-if=\"ab.codaList.length>0 && ab.codaList[0].type==\'rullo\'\">rullo</span> <span ng-if=\"ab.codaList.length>0 && ab.codaList[0].type==\'6.nr\'\">NR</span> <span ng-if=\"ab.codaList.length>0 && ab.codaList[0].type==\'3.nr23p\'\">NR2 o NR3</span> <span ng-if=\"ab.codaList.length>0 && ab.codaList[0].type==\'8.nr23n\'\">NR2 o NR3</span> <span ng-if=\"ab.codaList.length>0 && ab.codaList[0].type==\'5.conf-wa1\'\">Inviato WhatsApp 1 (da conferma)</span> <span ng-if=\"ab.codaList.length>0 && ab.codaList[0].type==\'7.hot-wa1\'\">Inviato WhatsApp 1</span> <span ng-if=\"ab.codaList.length>0 && ab.codaList[0].type==\'9.tail\'\">Altro</span></h3><div class=\"md-toolbar-tools\"></div></md-toolbar></md-card-header><md-card-content style=\"overflow-y: auto; padding-top: 0px;\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" ng-if=\"ab.user.store_id==null\"></th><th md-column=\"\"><span>Nome</span></th><th md-column=\"\"><md-icon md-font-icon=\"phone_android\">phone_android</md-icon><span>Telefono</span></th><th md-column=\"\"><span>Ar.</span></th><th md-column=\"\"><span>Campagna</span></th><th md-column=\"\"><span>N.</span></th><th md-column=\"\"><span>Stato</span></th><th md-column=\"\"><span>In data</span></th><th md-column=\"\"><span>R</span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"e in ab.codaList\" ng-class=\"{\'selected\': e.uid == ab.currentLead.uid && e.id == ab.currentLead.id }\" ng-style=\"e.deleted?{opacity: 0.6}:(!e.deleted && e.color?{ \'background-color\': e.color }:{})\"><td md-cell=\"\"><md-icon ng-if=\"e.f_many_times && e.user_times==0 && !e.f_oper && !e.f_dup\" md-font-icon=\"repeat\" style=\"color:red;\">repeat</md-icon><md-icon ng-if=\"!e.f_new && !(e.f_many_times && e.user_times==0) && !e.f_oper && !e.f_dup\" md-font-icon=\"repeat\">repeat</md-icon><md-icon ng-if=\"e.f_dup\" md-font-icon=\"looks_two\">looks_two</md-icon><md-icon ng-if=\"e.f_oper\" md-font-icon=\"not_interested\">not_interested</md-icon></td><td md-cell=\"\">{{ e.lastname }} {{ e.firstname }}</td><td md-cell=\"\">{{ e.phone }}</td><td md-cell=\"\">{{ (e.tenant?e.tenant.substring(0,2):\'\') }}</td><td md-cell=\"\">{{ e.campagna }}</td><td md-cell=\"\" ng-click=\"ab.showNoteSucc( e )\"><md-icon title=\"Nota\" md-font-icon=\"event_note\" ng-if=\"e.note != null && e.note != \'\'\">event_note</md-icon></td><td md-cell=\"\">{{ e.call_state }}</td><td md-cell=\"\">{{ e.call_date | date : \'dd/MM/yyyy HH:mm\' }}</td><td md-cell=\"\">{{ e.recall_delay }}</td><td md-cell=\"\" ng-click=\"ab.selectByPhone(e.phone, e.tenant, e.id)\"><md-button class=\"md-icon-button md-primary\" aria-label=\"Seleziona\"><md-icon title=\"Seleziona\" md-font-icon=\"open_in_new\">open_in_new</md-icon></md-button></td></tr><tr><td colspan=\"10\" ng-if=\"!ab.eListLoading && ab.ab.codaList.length==0\"><h3>Coda vuota</h3></td></tr><tr><td colspan=\"19\"><hr></td></tr><tr><td colspan=\"10\"><h3>Richiami futuri</h3></td></tr><tr md-row=\"\" ng-repeat=\"e in ab.richiamiList\" ng-class=\"{\'selected\': e.uid == ab.currentLead.uid}\" ng-style=\"e.deleted?{opacity: 0.6}:(!e.deleted && e.color?{ \'background-color\': e.color }:{})\"><td md-cell=\"\"><md-icon ng-if=\"e.f_many_times && e.user_times==0 && !e.f_oper && !e.f_dup\" md-font-icon=\"repeat\" style=\"color:red;\">repeat</md-icon><md-icon ng-if=\"!e.f_new && !(e.f_many_times && e.user_times==0) && !e.f_oper && !e.f_dup\" md-font-icon=\"repeat\">repeat</md-icon><md-icon ng-if=\"e.f_dup\" md-font-icon=\"looks_two\">looks_two</md-icon><md-icon ng-if=\"e.f_oper\" md-font-icon=\"not_interested\">not_interested</md-icon></td><td md-cell=\"\">{{ e.lastname }} {{ e.firstname }}</td><td md-cell=\"\">{{ e.phone }}</td><td md-cell=\"\">{{ (e.tenant?e.tenant.substring(0,2):\'\') }}</td><td md-cell=\"\">{{ e.campagna }}</td><td md-cell=\"\" ng-click=\"ab.showNoteSucc( e )\"><md-icon title=\"Nota\" md-font-icon=\"event_note\" ng-if=\"e.note != null && e.note != \'\'\">event_note</md-icon></td><td md-cell=\"\">{{ e.call_state }}</td><td md-cell=\"\">{{ e.call_date | date : \'dd/MM/yyyy HH:mm\' }}</td><td md-cell=\"\">{{ e.recall_delay }}</td><td md-cell=\"\" ng-click=\"ab.selectByPhone(e.phone)\"><md-button class=\"md-icon-button md-primary\" aria-label=\"Seleziona\"><md-icon title=\"Seleziona\" md-font-icon=\"open_in_new\">open_in_new</md-icon></md-button></td></tr><tr><td colspan=\"10\" ng-if=\"!ab.eListLoading && ab.richiamiList.length==0\"><h3>Nessun richiamo futuro pianificato</h3></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"input\">input</md-icon><h2 class=\"md-headline\"><span class=\"inset\">{{ ab.activeE.customer.firstname }} {{ ab.activeE.customer.lastname }} (cid: {{ ab.activeE.customer.id }} / lid: {{ ab.activeE.id }})</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"eForm\" id=\"eForm\" layout=\"row\" layout-wrap=\"\"><div flex=\"100\" layout=\"row\"><md-input-container class=\"md-block\" flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"call_state\">Stato cliente</label><md-select id=\"call_state\" name=\"call_state\" class=\"first-uppercase\" ng-disabled=\"true || !ab.activeE.isMine || ab.activeE.closed || ab.activeE.f_dup || ab.activeE.deleted\" md-container-class=\"first-uppercase\" aria-label=\"Stato\" ng-model=\"ab.backupE.call_state\" ng-change=\"ab.eStatus.onChange()\"><md-option ng-if=\"ab.activeE.f_dup || ab.activeE.closed || ab.activeE.deleted || ab.activeE.call_state == \'da chiamare\' || ab.activeE.call_state == \'non lavorato\'\" ng-value=\"ab.backupE.call_state\">{{ ab.backupE.call_state }}</md-option><md-option ng-value=\"\'confermato\'\">confermato</md-option><md-option ng-value=\"\'disdetto\'\">disdetto</md-option><md-option ng-if=\"!ab.activeE.f_dup && !ab.activeE.closed\" ng-value=\"call_state\" ng-repeat=\"call_state in ::ab.call_state track by call_state\">{{ call_state }}</md-option></md-select></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\" ng-if=\"ab.activeE.user_times == 0\"><label for=\"phone\">Telefono</label> <input type=\"text\" id=\"phone\" name=\"phone\" required=\"\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-model=\"ab.backupE.customer.phone\" ng-blur=\"ab.checkPhoneExists()\" ng-disabled=\"ab.phoneChecking\"><div ng-messages=\"eForm.phone.$error\" ng-show=\"eForm.phone.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div><div ng-message=\"pattern\"><small>Inserisci un numero di cellulare valido.</small><br>Inserisci il tuo numero di cellulare (9 o 10 cifre) senza spazi ne altri caratteri.</div><div ng-message=\"alreadyexists\">Numero di cellulare usato da altro cliente: {{ab.customerExists.lastname}} {{ab.customerExists.firstname}}<md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Rubrica\" ui-sref=\"home.addressbook({ phone : ab.customerExists.phone })\"><md-icon md-font-icon=\"person\">person</md-icon></md-button></div></div></md-input-container></div><div ng-if=\"ab.eStatus.showDatePicker\" flex=\"100\"><md-datetime-picker data=\"ab.backupE.call_date\" delay=\"ab.backupE.recall_delay\" withdelay=\"ab.eStatus.withdelay\" readonly=\"ab.activeE.closed || !ab.activeE.isMine\" editable=\"false\" label=\"\'Da richiamare\'\" style=\"padding: 0px 8px;\"></md-datetime-picker></div><div flex=\"100\" ng-if=\"ab.eStatus.ShowReason\"><md-input-container class=\"md-block\"><label for=\"note\">Motivo</label> <textarea rows=\"4\" id=\"reason\" ng-disabled=\"!ab.activeE.isMine || ab.activeE.closed || ab.activeE.f_dup || ab.activeE.deleted\" name=\"reason\" ng-model=\"ab.backupE.reason\" ng-model-options=\"ab.filter.options\" required=\"\"></textarea></md-input-container></div><div flex=\"100\"><md-input-container class=\"md-block\" ng-if=\"ab.activeE.call_state==\'fuori zona\' && ab.activeE.isMine && !ab.activeE.closed && !ab.activeE.deleted\"><label for=\"move_to\">Manda a</label><md-select id=\"move_to\" name=\"move_to\" class=\"first-uppercase\" ng-disabled=\"!ab.activeE.isMine || ab.activeE.closed || ab.activeE.deleted\" md-container-class=\"first-uppercase\" aria-label=\"Manda a\" placeholder=\"Selezionare area\" ng-model=\"ab.backupE.moveTo\"><md-option ng-value=\"undefined\"></md-option><md-option ng-value=\"tenant\" ng-repeat=\"tenant in ::ab.tenantsList\">{{ tenant.label }}</md-option></md-select></md-input-container></div><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"firstname\">Nome</label> <input type=\"text\" id=\"firstname\" name=\"firstname\" ng-disabled=\"!ab.activeE.isMine || ab.activeE.closed || ab.activeE.f_dup || ab.activeE.deleted\" ng-model=\"ab.backupE.customer.firstname\"><div ng-messages=\"eForm.firstname.$error\" ng-show=\"eForm.firstname.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"lastname\">Cognome</label> <input type=\"text\" id=\"lastname\" name=\"lastname\" ng-disabled=\"!ab.activeE.isMine || ab.activeE.closed || ab.activeE.f_dup || ab.activeE.deleted\" ng-model=\"ab.backupE.customer.lastname\"><div ng-messages=\"eForm.lastname.$error\" ng-show=\"eForm.lastname.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\"><label for=\"gender\" style=\"margin-bottom: 8px;\">Sesso *</label><md-radio-group id=\"gender\" name=\"gender\" ng-disabled=\"!ab.activeE.isMine || ab.activeE.closed || ab.activeE.f_dup || ab.activeE.deleted\" ng-model=\"ab.backupE.customer.gender\" ng-required=\"true\"><md-radio-button value=\"F\">Femmina</md-radio-button><md-radio-button value=\"M\" class=\"md-primary\">Maschio</md-radio-button></md-radio-group><div ng-messages=\"eForm.gender.$error\" ng-show=\"eForm.gender.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"province\">Provincia</label><md-select id=\"province\" name=\"province\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"province\" ng-model=\"ab.backupE.customer.province\" ng-required=\"ab.backupE.call_state == \'fuori zona\'\"><md-option ng-value=\"\"></md-option><md-optgroup label=\"{{ regione }}\" ng-repeat=\"( regione, province ) in ::ab.Italia track by regione\"><md-option ng-value=\"provincia.sigla\" ng-repeat=\"provincia in ::province track by provincia.sigla | orderBy: provincia.sigla\">{{ provincia.nome }}</md-option></md-optgroup></md-select><div ng-messages=\"eForm.province.$error\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\"><label for=\"birthdate\">Data di Nascita</label><md-datepicker id=\"birthdate\" name=\"birthdate\" ng-model=\"ab.backupE.customer.birthdate\" md-placeholder=\"Data di nascita\"></md-datepicker></div><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"email\">Email</label> <input type=\"email\" id=\"email\" name=\"email\" ng-model=\"ab.backupE.customer.email\" ng-model-options=\"ab.filter.options\"></md-input-container><br>&nbsp;<br>&nbsp;<div flex=\"100\"><md-input-container class=\"md-block\"><label for=\"note\">Note</label> <textarea rows=\"4\" id=\"note\" ng-disabled=\"!ab.activeE.isMine || ab.activeE.closed || ab.activeE.f_dup || ab.activeE.deleted\" name=\"note\" ng-model=\"ab.backupE.note\" ng-model-options=\"ab.filter.options\"></textarea></md-input-container></div><div flex=\"100\"><md-progress-circular ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\" ng-if=\"!ab.activeE.f_dup && !ab.activeE.closed && !ab.activeE.deleted && ab.activeE.isMine\"><md-button ng-class=\"{\'md-accent md-raised\': !ab.selectedStateIsFinal || (ab.backupE.call_state==\'fuori zona\' && ab.backupE.moveTo!=null), \'md-accent md-raised md-warn\': ab.selectedStateIsFinal && !(ab.backupE.call_state==\'fuori zona\' && ab.backupE.moveTo!=null)}\" aria-label=\"Salva\" ng-click=\"ab.update( ab.backupE, ab.selectedStateIsFinal )\" ng-disabled=\"eForm.$invalid || ab.saving || ab.phoneChecking\"><md-icon md-font-icon=\"check\">check</md-icon><span ng-if=\"!(ab.backupE.call_state==\'fuori zona\' && ab.backupE.moveTo!=null)\">Salva{{ab.selectedStateIsFinal?\' e archivia\':\'\'}}</span> <span ng-if=\"(ab.backupE.call_state==\'fuori zona\' && ab.backupE.moveTo!=null)\">Manda a {{ab.backupE.moveTo.label}} ed elimina lead</span></md-button><md-button ng-if=\"false\" ng-class=\"{\'md-accent md-raised\': !ab.selectedStateIsFinal, \'md-accent md-raised md-warn\': ab.selectedStateIsFinal}\" aria-label=\"Salva\" ng-click=\"ab.update( ab.backupE, ab.selectedStateIsFinal, true )\" ng-disabled=\"eForm.$invalid || ab.saving\"><md-icon md-font-icon=\"question_answer\">question_answer</md-icon>Salva e invia WhatsApp</md-button></md-input-container></div></form><span style=\"padding-top: 20px;\" class=\"md-subhead\" ng-if=\"ab.activeE.appointments.data.length > 0 && !ab.loading\">Appuntamenti collegati al lead</span><md-content ng-hide=\"!ab.loading\" layout=\"row\" layout-align=\"center center\" style=\"min-height: 80px;\"><md-progress-circular ng-disabled=\"!ab.loading\" md-diameter=\"40\"></md-progress-circular></md-content><md-table-container class=\"addressbook-appointments\" ng-if=\"ab.activeE.appointments.data.length > 0 && !ab.loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\"><span>Prezzo</span></th><th md-column=\"\"><span>Pres.</span></th><th md-column=\"\"><span>Centro</span></th></tr></thead><tbody md-body=\"\" style=\"font-size: 12px;\"><tr md-row=\"\" ng-repeat=\"appointment in ab.activeE.appointments.data | orderBy: \'-date_start\'\" class=\"{{appointment.recalled>=3?\'recalled_\'+appointment.recalled:( appointment.paid? \'\':\'app_notpaid\')}}\"><td>{{ appointment.date_start | date : \'dd/MM/yyyy HH:mm\' }}</td><td>{{ appointment.treatment_id | treatmentIdtoName : ab.treatmentsList }}<md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.customer_subscription_id !== null\">autorenew</md-icon></td><td>{{ appointment.price | number:2 }} €</td><td><span ng-if=\"appointment.paid\">SI</span> <span ng-if=\"!appointment.paid\">NO</span></td><td>{{ appointment.store_id | storeIdtoName : ab.storesList }}</td></tr></tbody></table></md-table-container></md-content></md-sidenav>");
$templateCache.put("app/leadcash/leadcash.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"{{!ab.env.menu?\'attach_money\':ab.env.menu.leadcash_icon}}\">{{!ab.env.menu?\'attach_money\':ab.env.menu.leadcash_icon}}</md-icon><span class=\"inset\">{{!ab.env.menu?\'Cassa leads\':ab.env.menu.leadcash_label}}</span></h2><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" hide-xs=\"\" hide-sm=\"\"><md-checkbox id=\"show_id\" name=\"show_id\" ng-model=\"ab.eStatus.showDett\">Vis. dettaglio</md-checkbox></md-input-container><span flex=\"\" hide-xs=\"\"></span> <span flex=\"\" hide-xs=\"\"></span><div flex=\"40\" hide-xs=\"\"><md-datepicker class=\"md-datepicker-filter-bar md-datepicker-full-width\" id=\"filter_date_start\" name=\"filter_date_start\" md-placeholder=\"Da\" ng-model=\"ab.eStatus.filter_date_start\" ng-change=\"ab.eListLoad()\"></md-datepicker></div><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.eListLoading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!ab.eListLoading && ab.eList!=null\"><table md-table=\"\" border=\"0\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th><span>Dati di {{ ab.eStatus.filter_date_start | date: \'MMMM\' }} fino a {{ab.eStatus.filter_date_start | date: \'EEEE d\'}}</span></th><th colspan=\"4\" style=\"text-align: center;\" class=\"col_disp\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><span>Lead</span></th><th colspan=\"2\" style=\"text-align: center;\" class=\"col_disp\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\"><span>Azione rullo</span></th><th colspan=\"{{(!ab.env.menu || ab.env.menu.leadcash_leads)?\'5\':\'2\'}}\" style=\"text-align: center;\" class=\"col_pari\"><span>App. presi</span></th><th colspan=\"{{(!ab.env.menu || ab.env.menu.leadcash_leads)?\'4\':\'5\'}}\" style=\"text-align: center;\" class=\"col_disp\"><span>Presentati</span></th><th colspan=\"1\" style=\"text-align: center;\" class=\"col_pari\"><span>App. futuri</span></th></tr><tr md-row=\"\"><th md-column=\"\"><span>Operatore</span></th><th md-column=\"\" style=\"text-align: right;\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><span>n°</span></th><th md-column=\"\" style=\"text-align: right;\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><span>Nuovi</span></th><th md-column=\"\" style=\"text-align: right;\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><span>Rientri</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><span>%S.</span></th><th md-column=\"\" style=\"text-align: right;\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\"><span>n° rullo</span></th><th md-column=\"\" style=\"text-align: right;\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\"><span>Contatti</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><span>n°L.</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><span>n°R.</span></th><th md-column=\"\" md-numeric=\"\"><span>Cli.ag.</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><span>%Red.L</span></th><th md-column=\"\" md-numeric=\"\"><span>%Red.</span></th><th md-column=\"\" md-numeric=\"\"><span>n°</span></th><th md-column=\"\" md-numeric=\"\"><span>n° P.</span></th><th md-column=\"\" md-numeric=\"\"><span>%P.</span></th><th md-column=\"\" md-numeric=\"\"><span>%Red.T.</span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\"><span>{{ab.env.currency.label}}</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right;\"><span>n°</span></th></tr></thead><tbody md-body=\"\" ng-repeat=\"e in ab.eList | orderBy: ab.query.order\"><tr md-row=\"\" class=\"row_totali\" style=\"{{!e.operator.data.active && ab.eStatus.isToday()?\'opacity: 0.5;\':\'\'}}\"><td md-cell=\"\"><div ng-if=\"e.operator.data.type == \'operator\'\" class=\"operator-circle\" style=\"background-color: {{ e.operator.data.color }};\"></div>{{ e.operator.data.id>0?e.operator.data.lastname:\'\' }} {{ e.operator.data.firstname }} <span ng-if=\"(!ab.env.menu || ab.env.menu.leadcash_leads) && e.operator.data.type == \'callcenter\' && ab.eStatus.isToday()\">({{e.operator.data.time_perc}}%)</span><md-button ng-if=\"(!ab.env.menu || ab.env.menu.leadcash_leads) && e.leadMonthDaChiamare>0\" class=\"md-icon-button md-raised md-accent\">{{ e.leadMonthDaChiamare }}</md-button></td><td class=\"col_disp\" md-cell=\"\" style=\"text-align: right;\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ e.leadMonth-e.leadMonthDup }}</td><td class=\"col_disp\" md-cell=\"\" style=\"text-align: right;\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ e.leadMonthNew-e.leadMonthNewDup }}</td><td class=\"col_disp\" md-cell=\"\" style=\"text-align: right;\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ e.leadMonthNotNew-e.leadMonthNotNewDup }}</td><td class=\"col_disp\" md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ e.leadMonthInvalid * 100/(e.leadMonth-e.leadMonthDup) | number:0 }}%</td><td class=\"col_pari\" md-cell=\"\" style=\"text-align: right;\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ e.appTookMonth - e.appTookOtherMonth}}</td><td class=\"col_pari\" md-cell=\"\" style=\"text-align: right;\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ e.appTookOtherMonth }}</td><td class=\"col_pari\" md-cell=\"\" style=\"text-align: right;\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\">{{ e.rulloMonth}}</td><td class=\"col_pari\" md-cell=\"\" style=\"text-align: right;\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\">{{ e.callMonth }}</td><td class=\"col_pari\" md-cell=\"\">{{ e.appTookCusMonth }}</td><td class=\"col_pari\" md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ ( e.appTookMonth - e.appTookOtherMonth) * 100/(e.leadMonth-e.leadMonthDup) | number: 0 }}%</td><td class=\"col_pari\" md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ ( e.appTookCusMonth) * 100/(e.leadMonth-e.leadMonthDup) | number: 0 }}%</td><td class=\"col_pari\" md-cell=\"\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\">{{ ( e.appTookCusMonth) * 100/(e.rulloMonth) | number: 2 }}%</td><td class=\"col_disp\" md-cell=\"\">{{ e.appMonth }}</td><td class=\"col_disp\" md-cell=\"\">{{ e.appPaidMonth }}</td><td class=\"col_disp\" md-cell=\"\">{{ e.appPaidMonth/(e.appMonth==0?1:e.appMonth)*100 | number: 0 }}%</td><td class=\"col_disp\" md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ e.appPaidMonth * 100 /(e.appMonth==0?1:e.appMonth) * ( e.appTookCusMonth )/(e.leadMonth-e.leadMonthDup) | number: 1 }}%</td><td class=\"col_disp\" md-cell=\"\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\">{{ e.appPaidMonth * 100 /(e.appMonth==0?1:e.appMonth) * ( e.appTookCusMonth)/(e.rulloMonth) | number: 2 }}%</td><td class=\"col_disp\" md-cell=\"\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\">{{ e.appPriceTotMonth | number: 2 }}</td><td class=\"col_pari\" md-cell=\"\" style=\"text-align: right;\">{{ e.appFutureMonth }}</td></tr><tr class=\"row_dett\" ng-repeat=\"elem in e.data | orderBy: \'-data\'\" ng-if=\"ab.eStatus.showDett\"><td md-cell=\"\" style=\"text-align: right;\"><md-button ng-if=\"(!ab.env.menu || ab.env.menu.leadcash_leads) && elem.lead.dachiamare>0\" class=\"md-icon-button md-raised md-accent\">{{elem.lead.daChiamare}}</md-button>{{ elem.data | date: \'EEEE d\' }}</td><td class=\"col_disp\" md-cell=\"\" style=\"text-align: right;\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ elem.lead.new+elem.lead.notNew-elem.lead.newDup-elem.lead.notNewDup }}</td><td class=\"col_disp\" md-cell=\"\" style=\"text-align: right;\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ elem.lead.new-elem.lead.newDup }}</td><td class=\"col_disp\" md-cell=\"\" style=\"text-align: right;\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ elem.lead.notNew-elem.lead.notNewDup }}</td><td class=\"col_disp\" md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ elem.lead.newInvalid+elem.lead.notNewInvalid }}</td><td class=\"col_pari\" md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ elem.appTook-elem.appTookOther }}</td><td class=\"col_pari\" md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ elem.appTookOther }}</td><td class=\"col_pari\" md-cell=\"\" style=\"text-align: right;\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\">{{ elem.rullo }}</td><td class=\"col_pari\" md-cell=\"\" style=\"text-align: right;\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\">{{ elem.call }}</td><td class=\"col_pari\" md-cell=\"\">{{ elem.appTookCus }}</td><td class=\"col_pari\" md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ (elem.appTook-elem.appTookOther)*100/(elem.lead.new+elem.lead.notNew-elem.lead.newDup-elem.lead.notNewDup) | number:0 }}%</td><td class=\"col_pari\" md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ (elem.appTookCus)*100/(elem.lead.new+elem.lead.notNew-elem.lead.newDup-elem.lead.notNewDup) | number:0 }}%</td><td class=\"col_pari\" md-cell=\"\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\">{{ (elem.appTookCus)*100/(elem.rullo) | number:2 }}%</td><td class=\"col_pari\" md-cell=\"\">{{ elem.app.num }}</td><td class=\"col_pari\" md-cell=\"\">{{ elem.app.paid }}</td><td class=\"col_pari\" md-cell=\"\">{{ elem.app.paid*100/elem.app.num | number: 0 }}%</td><td class=\"col_pari\" md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\">{{ elem.appTookCus*100/(elem.lead.new+elem.lead.notNew-elem.lead.newDup-elem.lead.notNewDup)*elem.app.paid/elem.app.num | number:0 }}%</td><td class=\"col_pari\" md-cell=\"\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\">{{ elem.appTookCus*100/(elem.rullo)*elem.app.paid/elem.app.num | number:0 }}%</td><td class=\"col_pari\" md-cell=\"\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\">{{ elem.app.priceTot | number: 2 }}</td><td md-cell=\"\"></td></tr></tbody></table></md-table-container><md-table-container><table md-table=\"\" class=\"legenda\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Legenda</span></th><th md-column=\"\"><span>Dato</span></th><th md-column=\"\"><span>Significato</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" colspan=\"2\"><span>Periodo</span></td><td md-cell=\"\"><span>Il periodo al quale si riferiscono i dati visualizzati &egrave; dal primo del mese fino alla data selezionata, nel caso specifico dal primo di {{ ab.eStatus.filter_date_start | date: \'MMMM\' }} fino a {{ab.eStatus.filter_date_start | date: \'EEEE d MMMM y\'}}</span></td></tr><tr md-row=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><td md-cell=\"\" colspan=\"2\"><md-button class=\"md-icon-button md-raised md-accent\">#</md-button></td><td md-cell=\"\"><span>Numero lead in stato \"Da chiamare\" entrati nel mese di {{ ab.eStatus.filter_date_start | date: \'MMMM\' }} fino a {{ab.eStatus.filter_date_start | date: \'EEEE d\'}}</span></td></tr><tr md-row=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><td md-cell=\"\" class=\"row_totali\"><span>Lead</span></td><td md-cell=\"\" class=\"col_disp\"><span>n°</span></td><td md-cell=\"\"><span>Numero totale dei lead assegnati (comprende anche quelli scartati ma non i duplicati)</span></td></tr><tr md-row=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><td md-cell=\"\"></td><td md-cell=\"\" class=\"col_disp\"><span>Nuovi</span></td><td md-cell=\"\"><span>Lead \"primo contatto\" assegnati, il cliente non era in precedenza presente nella rubrica (comprende anche quelli scartati ma non i duplicati)</span></td></tr><tr md-row=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><td md-cell=\"\"></td><td md-cell=\"\" class=\"col_disp\"><span>Rientri</span></td><td md-cell=\"\"><span>Lead rientri assegnati, il cliente era gi&agrave; presente nella rubrica prima di questo contatto (comprende anche quelli scartati ma non i duplicati), non comprende i gi&agrave; clienti frequentanti negli ultimi 120 gg</span></td></tr><tr md-row=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><td md-cell=\"\"></td><td md-cell=\"\" class=\"col_disp\"><span>%S.</span></td><td md-cell=\"\"><span>Percentuale di lead scartati, comprende lead con stato fake e fuori zona (nella riga di riassunto &egrave; indicata la percentuale, nel dettaglio &egrave; indicato il numero)</span></td></tr><tr md-row=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><td md-cell=\"\" class=\"row_totali\"><span>Apputamenti presi</span></td><td md-cell=\"\" class=\"col_pari\"><span>n°L.</span></td><td md-cell=\"\"><span>Numero appuntamenti presi da lead nel mese di {{ ab.eStatus.filter_date_start | date: \'MMMM\' }} fino a {{ab.eStatus.filter_date_start | date: \'EEEE d\'}} (gli appuntamenti spostati non vengono contati)</span></td></tr><tr md-row=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><td md-cell=\"\"><span></span></td><td md-cell=\"\" class=\"col_pari\"><span>n°R.</span></td><td md-cell=\"\"><span>Numero appuntamenti presi non da lead nel mese di {{ ab.eStatus.filter_date_start | date: \'MMMM\' }} fino a {{ab.eStatus.filter_date_start | date: \'EEEE d\'}} (gli appuntamenti spostati non vengono contati)</span></td></tr><tr md-row=\"\"><td md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><span></span></td><td md-cell=\"\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\" class=\"row_totali\"><span>Appuntamenti presi</span></td><td md-cell=\"\" class=\"col_pari\"><span>Cli. ag.</span></td><td md-cell=\"\"><span>Numero clienti agendati, due appuntemtni commerciali sul mededimo cliente presi il medesimo giorno vengono contati come un unico cliente agendato</span></td></tr><tr md-row=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><td md-cell=\"\"></td><td md-cell=\"\" class=\"col_pari\"><span>%Red.L</span></td><td md-cell=\"\"><span>Percentuale di conversione lead in appuntamento, sono esclusi i duplicati</span><br><span>= { [n° lead] } * 100 / [n° app. presi da lead]</span></td></tr><tr md-row=\"\"><td md-cell=\"\"><span></span></td><td md-cell=\"\" class=\"col_pari\"><span>%Red.</span></td><td md-cell=\"\" ng-if=\"!ab.env.menu || ab.env.menu.leadcash_leads\"><span>Percentuale calcolata come rapporto tra numero di clienti per cui &egrave; stato fissato un appuntamenti (sia da lead che non da lead) e lead assegnati (esclusi i duplicati)</span><br><span>= [Cli.ag.] *100 / ( [n° lead] ) )</span></td><td md-cell=\"\" ng-if=\"!(!ab.env.menu || ab.env.menu.leadcash_leads)\"><span>Percentuale calcolata come rapporto tra numero di clienti per cui &egrave; stato fissato un appuntamenti e numero di visuailzzazione da rullo</span><br><span>= [Cli.ag.] *100 / ( [n° rullo] ) )</span></td></tr><tr md-row=\"\"><td md-cell=\"\" class=\"row_totali\"><span>Apputamenti presentati</span></td><td md-cell=\"\" class=\"col_pari\"><span>n°</span></td><td md-cell=\"\"><span>Numero totale degli appuntamenti nel mese di {{ ab.eStatus.filter_date_start | date: \'MMMM\' }} fino a {{ab.eStatus.filter_date_start | date: \'EEEE d\'}}</span></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" class=\"col_pari\"><span>n°P.</span></td><td md-cell=\"\"><span>Numero totale degli appuntamenti presentati nel mese di {{ ab.eStatus.filter_date_start | date: \'MMMM\' }} fino a {{ab.eStatus.filter_date_start | date: \'EEEE d\'}}</span></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" class=\"col_pari\"><span>%P.</span></td><td md-cell=\"\"><span>Percentuale appuntamenti presentati nel periodo</span></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" class=\"col_pari\"><span>%Red.T.</span></td><td md-cell=\"\"><span>Percentuale calcolata come prodotto dei tra %Red. e %P.</span></td></tr><tr md-row=\"\"><td md-cell=\"\" class=\"row_totali\"><span>Apputamenti futuri nel mese</span></td><td md-cell=\"\" class=\"col_pari\"><span>n°</span></td><td md-cell=\"\"><span>Numero totale degli appuntamenti di questo mese fissati per i gg successivi a {{ab.eStatus.filter_date_start | date: \'EEEE d MMMM\'}}</span></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content>");
$templateCache.put("app/leadcash1/leadcash1.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"{{!ab.env.menu?\'attach_money\':ab.env.menu.leadcash_icon}}\">{{!ab.env.menu?\'attach_money\':ab.env.menu.leadcash1_icon}}</md-icon><span class=\"inset\">{{!ab.env.menu?\'Cassa leads I\':ab.env.menu.leadcash1_label}}</span></h2><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" hide-xs=\"\" hide-sm=\"\"><md-checkbox id=\"show_id\" name=\"show_id\" ng-model=\"ab.eStatus.showDett\">Vis. dettaglio</md-checkbox></md-input-container><span flex=\"\" hide-xs=\"\"></span> <span flex=\"\" hide-xs=\"\"></span><div flex=\"40\" hide-xs=\"\"><md-datepicker class=\"md-datepicker-filter-bar md-datepicker-full-width\" id=\"filter_date_start\" name=\"filter_date_start\" md-placeholder=\"Da\" ng-model=\"ab.eStatus.filter_date_start\" ng-change=\"ab.eListLoad()\"></md-datepicker></div><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.eListLoading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!ab.eListLoading && ab.eList!=null\"><table md-table=\"\" border=\"0\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th><span>Dati di {{ ab.eStatus.filter_date_start | date: \'MMMM\' }} fino a {{ab.eStatus.filter_date_start | date: \'EEEE d\'}}</span></th><th colspan=\"4\" style=\"text-align: center;\" class=\"col_disp\"><span>Lead</span></th><th colspan=\"3\" style=\"text-align: center;\" class=\"col_pari\"><span>App. presi</span></th></tr><tr md-row=\"\"><th md-column=\"\"><span>Operatore</span></th><th md-column=\"\" style=\"text-align: right;\"><span>n°</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Nuovi</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Rientri</span></th><th md-column=\"\" md-numeric=\"\"><span>%S.</span></th><th md-column=\"\" md-numeric=\"\"><span>n°App.</span></th><th md-column=\"\" md-numeric=\"\"><span>Cli.ag.</span></th><th md-column=\"\" md-numeric=\"\"><span>%Red.L</span></th></tr></thead><tbody md-body=\"\" ng-repeat=\"e in ab.eList | orderBy: ab.query.order\"><tr md-row=\"\" class=\"row_totali\" style=\"{{!e.operator.data.active && ab.eStatus.isToday()?\'opacity: 0.5;\':\'\'}}\"><td md-cell=\"\"><div ng-if=\"e.operator.data.type == \'operator\'\" class=\"operator-circle\" style=\"background-color: {{ e.operator.data.color }};\"></div>{{ e.operator.data.id>0?e.operator.data.lastname:\'\' }} {{ e.operator.data.firstname }} <span ng-if=\"(!ab.env.menu || ab.env.menu.leadcash1_leads) && e.operator.data.type == \'callcenter\' && ab.eStatus.isToday()\">({{e.operator.data.time_perc}}%)</span><md-button ng-if=\"(!ab.env.menu || ab.env.menu.leadcash1_leads) && e.leadMonthDaChiamare>0\" class=\"md-icon-button md-raised md-accent\">{{ e.leadMonthDaChiamare }}</md-button></td><td class=\"col_disp\" md-cell=\"\" style=\"text-align: right;\">{{ e.leadMonth-e.leadMonthDup }}</td><td class=\"col_disp\" md-cell=\"\" style=\"text-align: right;\">{{ e.leadMonthNew-e.leadMonthNewDup }}</td><td class=\"col_disp\" md-cell=\"\" style=\"text-align: right;\">{{ e.leadMonthNotNew-e.leadMonthNotNewDup }}</td><td class=\"col_disp\" md-cell=\"\">{{ e.leadMonthInvalid * 100/(e.leadMonth-e.leadMonthDup) | number:0 }}%</td><td class=\"col_pari\" md-cell=\"\" style=\"text-align: right;\">{{ e.appTookMonth - e.appTookOtherMonth}}</td><td class=\"col_pari\" md-cell=\"\">{{ e.appTookCusMonth }}</td><td class=\"col_pari\" md-cell=\"\">{{ ( e.appTookMonth - e.appTookOtherMonth) * 100/(e.leadMonth-e.leadMonthDup) | number: 0 }}%</td></tr><tr class=\"row_dett\" ng-repeat=\"elem in e.data | orderBy: \'-data\'\" ng-if=\"ab.eStatus.showDett\"><td md-cell=\"\" style=\"text-align: right;\"><md-button ng-if=\"(!ab.env.menu || ab.env.menu.leadcash1_leads) && elem.lead.dachiamare>0\" class=\"md-icon-button md-raised md-accent\">{{elem.lead.daChiamare}}</md-button>{{ elem.data | date: \'EEEE d\' }}</td><td class=\"col_disp\" md-cell=\"\" style=\"text-align: right;\">{{ elem.lead.new+elem.lead.notNew-elem.lead.newDup-elem.lead.notNewDup }}</td><td class=\"col_disp\" md-cell=\"\" style=\"text-align: right;\">{{ elem.lead.new-elem.lead.newDup }}</td><td class=\"col_disp\" md-cell=\"\" style=\"text-align: right;\">{{ elem.lead.notNew-elem.lead.notNewDup }}</td><td class=\"col_disp\" md-cell=\"\">{{ elem.lead.newInvalid+elem.lead.notNewInvalid }}</td><td class=\"col_pari\" md-cell=\"\">{{ elem.appTook-elem.appTookOther }}</td><td class=\"col_pari\" md-cell=\"\">{{ elem.appTookCus }}</td><td class=\"col_pari\" md-cell=\"\">{{ (elem.appTook-elem.appTookOther)*100/(elem.lead.new+elem.lead.notNew-elem.lead.newDup-elem.lead.notNewDup) | number:0 }}%</td></tr></tbody></table></md-table-container><md-table-container><table md-table=\"\" class=\"legenda\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Legenda</span></th><th md-column=\"\"><span>Dato</span></th><th md-column=\"\"><span>Significato</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" colspan=\"2\"><span>Periodo</span></td><td md-cell=\"\"><span>Il periodo al quale si riferiscono i dati visualizzati &egrave; dal primo del mese fino alla data selezionata, nel caso specifico dal primo di {{ ab.eStatus.filter_date_start | date: \'MMMM\' }} fino a {{ab.eStatus.filter_date_start | date: \'EEEE d MMMM y\'}}</span></td></tr><tr md-row=\"\"><td md-cell=\"\" colspan=\"2\"><md-button class=\"md-icon-button md-raised md-accent\">#</md-button></td><td md-cell=\"\"><span>Numero lead in stato \"Da chiamare\" entrati nel mese di {{ ab.eStatus.filter_date_start | date: \'MMMM\' }} fino a {{ab.eStatus.filter_date_start | date: \'EEEE d\'}}</span></td></tr><tr md-row=\"\"><td md-cell=\"\" class=\"row_totali\"><span>Lead</span></td><td md-cell=\"\" class=\"col_disp\"><span>n°</span></td><td md-cell=\"\"><span>Numero totale dei lead gestiti (comprende anche quelli scartati ma non i duplicati)</span></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" class=\"col_disp\"><span>Nuovi</span></td><td md-cell=\"\"><span>Lead \"primo contatto\" gestiti, il cliente non era in precedenza presente nella rubrica (comprende anche quelli scartati ma non i duplicati)</span></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" class=\"col_disp\"><span>Rientri</span></td><td md-cell=\"\"><span>Lead rientri gestiti, il cliente era gi&agrave; presente nella rubrica prima di questo contatto (comprende anche quelli scartati ma non i duplicati), non comprende i gi&agrave; clienti frequentanti negli ultimi 120 gg</span></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" class=\"col_disp\"><span>%S.</span></td><td md-cell=\"\"><span>Percentuale di lead scartati, comprende lead con stato fake e fuori zona (nella riga di riassunto &egrave; indicata la percentuale, nel dettaglio &egrave; indicato il numero)</span></td></tr><tr md-row=\"\"><td md-cell=\"\" class=\"row_totali\"><span>Apputamenti presi</span></td><td md-cell=\"\" class=\"col_pari\"><span>n°App.</span></td><td md-cell=\"\"><span>Numero appuntamenti presi da lead del mese di {{ ab.eStatus.filter_date_start | date: \'MMMM\' }} fino a {{ab.eStatus.filter_date_start | date: \'EEEE d\'}} (gli appuntamenti spostati non vengono contati)</span></td></tr><tr md-row=\"\"><td md-cell=\"\"><span></span></td><td md-cell=\"\" class=\"col_pari\"><span>Cli. ag.</span></td><td md-cell=\"\"><span>Numero clienti agendati, due appuntamenti commerciali sul mededimo cliente presi il medesimo giorno vengono contati come un unico cliente agendato</span></td></tr><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\" class=\"col_pari\"><span>%Red.L</span></td><td md-cell=\"\"><span>Percentuale di conversione lead in appuntamento, sono esclusi i duplicati</span><br><span>= { [n° lead] } * 100 / [n° app. presi da lead]</span></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content>");
$templateCache.put("app/leads/leads.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"input\">input</md-icon><span class=\"inset\" ng-if=\"!ab.user.store_id\">Leads</span> <span class=\"inset\" ng-if=\"ab.user.store_id\">Leads Centro</span></h2><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" hide-xs=\"\" hide-sm=\"\"><md-select id=\"user_id\" name=\"user_id\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Utente\" placeholder=\"Utente\" ng-model=\"ab.eStatus.userId\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"-1\" ng-if=\"ab.user.type==\'admin\' || ab.user.ext_f_bid\">Nessuno</md-option><md-option ng-value=\"-2\" ng-if=\"ab.user.type==\'admin\' || ab.user.ext_f_bid\">Qualcuno</md-option><md-option ng-value=\"ab.user.id\">Me</md-option><md-option ng-value=\"role.user_id\" ng-repeat=\"role in ab.operatorsCallList | orderBy: [\'user.lastname\']\">{{ role.user.lastname }} {{ role.user.firstname }} [{{role.user.type}}]</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\" ng-if=\"ab.user.type==\'admin\' || ab.user.ext_f_bid\"></span><md-radio-group ng-model=\"ab.eStatus.filterUserIdType\" ng-if=\"ab.user.type==\'admin\' || ab.user.ext_f_bid\" ng-change=\"ab.eListLoad(1)\" layout=\"row\"><md-radio-button ng-value=\"1\" aria-label=\"Assegnatario\">A</md-radio-button><md-radio-button ng-value=\"2\" aria-label=\"First\">F</md-radio-button><md-radio-button ng-value=\"3\" aria-label=\"Touch\">T</md-radio-button></md-radio-group><span flex=\"\" hide-xs=\"\" ng-if=\"!ab.user.store_id\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" hide-xs=\"\" hide-sm=\"\" ng-if=\"!ab.user.store_id\"><md-select id=\"f_new\" name=\"f_new\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Nuovi o rientri\" placeholder=\"Nuovi o rientri\" ng-model=\"ab.eStatus.fNew\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ab.filtersFNew track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" hide-xs=\"\" hide-sm=\"\"><md-select id=\"fClosed\" name=\"fClosed\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Chiusi o non chiusi\" placeholder=\"Chiusi o non chiusi\" ng-model=\"ab.eStatus.fClosed\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ab.filtersFClosed track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><div flex=\"\" hide-xs=\"\"><md-datepicker class=\"md-datepicker-filter-bar\" id=\"filter_date_from\" name=\"filter_date_from\" md-placeholder=\"Da\" md-max-date=\"ab.today\" ng-model=\"ab.eStatus.filter_from\" ng-change=\"ab.eListLoad(1)\"></md-datepicker></div><div flex=\"\" hide-xs=\"\"><md-datepicker class=\"md-datepicker-filter-bar\" id=\"filter_date_to\" name=\"filter_date_to\" md-placeholder=\"A\" md-min-date=\"ab.eStatus.filter_from\" md-max-date=\"ab.today\" ng-model=\"ab.eStatus.filter_to\" ng-change=\"ab.eListLoad(1)\"></md-datepicker></div><md-checkbox style=\"margin-left: 30px;\" ng-if=\"!ab.user.store_id\" ng-model=\"ab.eStatus.filter_assign_at\" ng-change=\"ab.eListLoad(1)\"></md-checkbox><md-button ng-if=\"ab.user.type==\'admin\'\" class=\"md-accent md-raised\" aria-label=\"Nuovo\" ng-click=\"ab.toggleRight()\"><md-icon md-font-icon=\"person_add\">person_add</md-icon>Nuovo</md-button></div></md-toolbar><md-card><md-card-header style=\"padding-bottom: 6px; padding-top: 6px;\"><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" ng-keypress=\"ab.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><span flex=\"\" hide-xs=\"\" ng-if=\"ab.env.isMaster\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" ng-if=\"ab.env.isMaster\"><md-select aria-label=\"Area\" placeholder=\"Area\" ng-model=\"ab.eStatus.tenant\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutte</md-option><md-option ng-value=\"tenant.tenant\" ng-repeat=\"tenant in ab.tenantsList | filter: {tenant: \'!Roma8\'} : true track by tenant.tenant\">{{ tenant.tenant }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\" ng-if=\"!ab.user.store_id\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" ng-if=\"!ab.user.store_id\"><md-select aria-label=\"Com./Non com.\" placeholder=\"Com./Non com.\" ng-model=\"ab.eStatus.fOper\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ab.filtersListFOper track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select id=\"fonte\" name=\"fonte\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Fonte\" placeholder=\"Fonte\" ng-model=\"ab.eStatus.category\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutte</md-option><md-option ng-value=\"category.category\" ng-repeat=\"category in ab.categories\">{{ category.category }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select id=\"category\" name=\"category\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Categoria\" placeholder=\"Categoria\" ng-model=\"ab.eStatus.pricing\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutte</md-option><md-option ng-value=\"category.pricing\" ng-repeat=\"category in ab.pricings\">{{ category.pricing }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select id=\"call_state_filter\" name=\"call_state_filter\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Stato\" placeholder=\"Stato\" ng-model=\"ab.eStatus.call_state\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\"></md-option><md-option ng-value=\"\'da chiamare\'\">da chiamare</md-option><md-option ng-value=\"\'confermato\'\">confermato</md-option><md-option ng-value=\"\'spostato\'\">spostato</md-option><md-option ng-value=\"\'disdetto\'\">disdetto</md-option><md-option ng-value=\"\'da verificare\'\">da verificare</md-option><md-option ng-value=\"call_state\" ng-repeat=\"call_state in ::ab.call_state track by call_state\">{{ call_state }}</md-option><md-option ng-value=\"\'duplicato\'\">duplicato</md-option><md-option ng-value=\"\'ha preso appuntamento\'\">ha preso appuntamento</md-option><md-option ng-value=\"\'non lavorato\'\">non lavorato</md-option><md-option ng-value=\"\'trasferiti\'\">trasferiti</md-option><md-option ng-value=\"\'escludi cancellati\'\">escludi \'Inviati a\'</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><div flex=\"\" hide-xs=\"\"><md-datepicker class=\"md-datepicker-filter-bar\" id=\"filter_date_start\" name=\"filter_date_start\" md-placeholder=\"Filtro data richiamo\" ng-model=\"ab.eStatus.filter_date_start\" ng-change=\"ab.dataRichiamoChanged()\"></md-datepicker></div><span flex=\"\" hide-xs=\"\"></span><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div></div></md-toolbar></md-card-header><md-card-content style=\"overflow-y: auto; padding-top: 0px;\"><md-table-container><div ng-if=\"ab.user.type == \'admin\' || ab.user.type == \'callcenter\'\" layout=\"row\"><div flex=\"50\">Assegna selezionati a:<md-input-container flex=\"nogrow\" md-no-float=\"\" hide-xs=\"\" hide-sm=\"\"><md-select id=\"assign_to\" name=\"assign_to\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Assegna a\" placeholder=\"Selezionare utente\" ng-model=\"ab.assignToUser\"><md-option ng-if=\"(ab.user.type == \'admin\' || ab.user.ext_f_bid) && (!ab.user.tag_area || ab.user.tag_area==\'INBOUND\')\" ng-value=\"role\" ng-repeat=\"role in ab.operatorsCallList | orderBy: [\'user.tag_area\',\'user.lastname\']\">{{ role.user.lastname }} {{ role.user.firstname }} [{{role.user.type}}{{role.user.tag_area?\' | \'+role.user.tag_area:\'\'}}]</md-option><md-option ng-if=\"(ab.user.type == \'admin\' || ab.user.ext_f_bid) && ab.user.tag_area && ab.user.tag_area!=\'INBOUND\'\" ng-value=\"role\" ng-repeat=\"role in ab.operatorsCallList | filter: {user: {tag_area:ab.user.tag_area}} : true | orderBy: [\'user.lastname\']\">{{ role.user.lastname }} {{ role.user.firstname }} [{{role.user.type}}{{role.user.tag_area?\' | \'+role.user.tag_area:\'\'}}]</md-option><md-option ng-if=\"(ab.user.type == \'admin\' || ab.user.ext_f_bid) && ab.user.tag_area && ab.user.tag_area!=\'INBOUND\'\" ng-value=\"role\" ng-repeat=\"role in ab.operatorsCallList | filter: {user: {tag_area: ab.user.tag_area + \'RULLO\'}} : true | orderBy: [\'user.lastname\']\">{{ role.user.lastname }} {{ role.user.firstname }} [{{role.user.type}}{{role.user.tag_area?\' | \'+role.user.tag_area:\'\'}}]</md-option><md-option ng-if=\"(ab.user.type == \'callcenter\' && !ab.user.ext_f_bid)\" ng-value=\"role\" ng-repeat=\"role in ab.operatorsCall2List | orderBy: \'store.alias\'\"><md-icon class=\"md-accent md-raised\" ng-if=\"role.online\" md-font-icon=\"place\">place</md-icon><span ng-if=\"!role.online\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> [{{ role.store.alias }}] {{ role.user.lastname }} {{ role.user.firstname }}</md-option></md-select></md-input-container><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Assegna selezionati\" ng-click=\"ab.assignTo()\" ng-if=\"ab.assignToUser!=null\"><md-icon md-font-icon=\"flag\">flag</md-icon></md-button></div><div flex=\"50\"><md-input-container class=\"md-block\" ng-if=\"false && ab.user.type === \'admin\'\"><md-button class=\"md-accent md-raised\" ng-href=\"{{ ab.exportLeadsUrl }}\">Esporta</md-button></md-input-container><md-input-container class=\"md-block\" ng-if=\"false && ab.user.type === \'admin\'\"><div ng-if=\"ab.eStatus.userId\">Reinvia a Send Service<md-button ng-disabled=\"ab.eListLoading\" class=\"md-icon-button md-primary md-raised\" aria-label=\"Invia selezionati a SendService\" ng-click=\"ab.resendToSendService()\"><md-icon md-font-icon=\"contact_phone\">contact_phone</md-icon></md-button></div></md-input-container></div></div><table md-table=\"\" md-row-select=\"ab.options.rowSelection\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\" md-on-reorder=\"ab.eListReOrder\"><tr md-row=\"\"><th md-column=\"\"><md-checkbox ng-if=\"ab.user.type==\'admin\' || ab.user.type==\'callcenter\'\" ng-checked=\"ab.allSelected\" ng-click=\"ab.toggleAllSelected()\" aria-label=\"Seleziona tutti\"></md-checkbox></th><th md-column=\"\" ng-if=\"ab.user.store_id==null\"></th><th md-column=\"\" md-order-by=\"customers.lastname\"><span>Nome</span></th><th md-column=\"\" md-order-by=\"customers.phone\"><md-icon md-font-icon=\"phone_android\">phone_android</md-icon><span>Telefono</span></th><th md-column=\"\"><span>Contatta</span></th><th md-column=\"\" md-order-by=\"customers.tenant\" ng-if=\"ab.env.currentTenant == \'Italia\'\"><span>Ar.</span></th><th md-column=\"\" md-order-by=\"customers.city\"><span>Citt&agrave;</span></th><th md-column=\"\" md-order-by=\"leads.store_id\"><span>Centro</span></th><th md-column=\"\"><span>Mod.</span></th><th md-column=\"\" md-order-by=\"leads.campagna\"><span>Campagna</span></th><th md-column=\"\" md-order-by=\"leads.note\"><span>N.</span></th><th md-column=\"\" md-order-by=\"leads.created_at\" ng-if=\"ab.user.type!=\'callcenter\'\"><span>Data cr.</span></th><th md-column=\"\" md-order-by=\"leads.first_assign_at\"><span>Data ass.</span></th><th md-column=\"\" md-order-by=\"user_id\">Op.</th><th md-column=\"\" md-order-by=\"first_user_id\">1&deg; Op.</th><th md-column=\"\" md-order-by=\"first_user_id\">1&deg; Mod.</th><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"call_state\"><span>Stato</span></th><th md-column=\"\" md-order-by=\"recall_delay\">de <span>R</span></th><th md-column=\"\" md-order-by=\"call_date\"><span>In data</span></th><th ng-if=\"false\" md-column=\"\" md-order-by=\"rt_min\" style=\"text-align: right;\"><span>RT</span></th><th md-column=\"\"><span>Pros.</span></th><th md-column=\"\"><span>Azioni</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.eListLoading\"><td md-cell=\"\" colspan=\"8\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.eListLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"ab.options.autoSelect\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in ab.eList\" ng-style=\"e.deleted?{opacity: 0.6}:(!e.deleted && e.color?{ \'background-color\': e.color }:{})\"><td md-cell=\"\"><md-checkbox ng-if=\"(ab.user.type==\'admin\' || ab.user.type==\'callcenter\') && !e.closed && !e.f_oper && !e.f_dup && !e.deleted\" ng-checked=\"e.isSelected\" ng-click=\"ab.toggleSelected(e)\" aria-label=\"Seleziona\"></md-checkbox></td><td md-cell=\"\" ng-click=\"ab.removeSearch(e.customer.data.phone)\" ng-if=\"ab.user.store_id==null\"><md-icon ng-if=\"!e.f_dup && e.f_dup_wrk\" md-font-icon=\"looks_two\" style=\"background-color: white; color:orange;\">looks_two</md-icon><md-icon ng-if=\"!e.f_dup && e.f_dup_regen\" md-font-icon=\"looks_two\" style=\"background-color: white; color:green\">looks_two</md-icon><md-icon ng-if=\"!e.f_dup_wrk && !e.f_dup_regen && e.f_many_times && e.user_times==0 && !e.f_oper && !e.f_dup\" md-font-icon=\"repeat\" style=\"color:red;\">repeat</md-icon><md-icon ng-if=\"!e.f_dup_wrk && !e.f_dup_regen && !e.f_new && !(e.f_many_times && e.user_times==0) && !e.f_oper && !e.f_dup\" md-font-icon=\"repeat\">repeat</md-icon><md-icon ng-if=\"e.f_dup\" md-font-icon=\"looks_two\">looks_two</md-icon><md-icon ng-if=\"e.f_oper\" md-font-icon=\"not_interested\">not_interested</md-icon></td><td md-cell=\"\" ng-click=\"ab.removeSearch(e.customer.data.phone)\">{{ e.customer.data.lastname }} {{ e.customer.data.firstname }}</td><td md-cell=\"\"><md-icon ng-click=\"ab.removeSearch(e.customer.data.phone)\" md-font-icon=\"search\">search</md-icon><a href=\"tel:{{ e.customer.data.phone }}\">{{ e.customer.data.phone }}</a></td><td md-cell=\"\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Chiama\" href=\"tel:+39{{e.customer.data.phone}}\"><md-icon md-font-icon=\"call\">call</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"WhatsApp\" ui-sref=\"home.whatsapp({phone: e.customer.data.phone})\"><md-icon md-font-icon=\"chat\">chat</md-icon></md-button></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\" ng-if=\"ab.env.currentTenant==\'Italia\'\">{{ e.customer.data.tenant?e.customer.data.tenant.substring(0,2):\'\' }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.customer.data.city }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.store.data.alias }}</td><td md-cell=\"\"><bl-btn-lead-history entity=\"e\" user=\"ab.user\"></bl-btn-lead-history></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.campagna }}</td><td md-cell=\"\" ng-click=\"ab.showNote( e )\"><md-icon title=\"Nota\" md-font-icon=\"event_note\" ng-if=\"e.note != null && e.note != \'\'\">event_note</md-icon></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\" ng-if=\"ab.user.type!=\'callcenter\'\">{{ e.created_at_frm }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.first_assign_at_frm }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.user.data.alias }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.firstUser.data.alias }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.firstChange.data.alias }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><md-icon ng-if=\"e.appointments.data.length>0\" md-font-icon=\"done\">done</md-icon></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\" class=\"first-uppercase\">{{ e.deleted && e.call_state==\'fuori zona\' && e.customer && e.customer.data && e.customer.data.tenant?\'Inviato a \'+e.customer.data.tenant:e.call_state }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.recall_delay }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.indata | date : \'dd/MM/yyyy HH:mm\' }}</td><td md-cell=\"\" ng-if=\"false\" ng-click=\"ab.rowClicked(e)\" style=\"text-align: right;\">{{ e.rt_min }}</td><td md-cell=\"\" class=\"cell-button\"><md-button class=\"md-raised md-accent\" ng-disabled=\"!e.isMine\" ng-click=\"ab.toggleProspect( e )\" aria-label=\"Appuntamento Pagato\" ng-if=\"e.customer.data.f_prospect\">SI</md-button><md-button class=\"md-raised md-warn\" ng-disabled=\"!e.isMine\" ng-click=\"ab.toggleProspect( e )\" aria-label=\"Prospect\" ng-if=\"! e.customer.data.f_prospect\">NO</md-button></td><td md-cell=\"\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Scheda cliente\" ng-if=\"e.customer.data.tenant && ab.env.isMaster && e.customer.data.tenant!=ab.env.currentTenant\" href=\"{{ e.urlCustomer }}\" target=\"{{ab.env.company}}_Admin_{{e.tenant}}\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Scheda cliente\" ng-if=\"!ab.env.isMaster || !e.customer.data.tenant || e.customer.data.tenant==ab.env.currentTenant\" ui-sref=\"home.customer( { customer_id : e.customer_id } )\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Rubrica\" ng-if=\"!ab.env.isMaster || !e.customer.data.tenant || e.customer.data.tenant==ab.env.currentTenant\" ui-sref=\"home.addressbook({ phone : e.customer.data.phone })\"><md-icon md-font-icon=\"person\">person</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Leads\" ng-if=\"ab.env.isMaster && e.customer.data.tenant && e.customer.data.tenant!=ab.env.currentTenant\" target=\"{{ab.env.company}}_Admin_{{e.tenant}}\" href=\"{{e.urlLeads}}\"><md-icon md-font-icon=\"filter_list\">filter_list</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Leads\" ng-if=\"!ab.env.isMaster || !e.customer.data.tenant || e.customer.data.tenant==ab.env.currentTenant\" ui-sref=\"home.leads({ phone: e.customer.data.phone })\"><md-icon md-font-icon=\"filter_list\">filter_list</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Prendi nuovo appuntamento\" ng-if=\"!e.deleted && !e.f_dup && !e.closed && e.isMine\" ng-href=\"{{ ab.env.booking }}/operator?tenant={{ ab.env.currentTenant }}&amp;c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;lead={{e.id}}&amp;tag={{e.tag}}&amp;store={{ ab.storeId }}&amp;customer={{ e.customer.data.phone }}&amp;token={{ ab.token }}&amp;campagna={{e.campagna}}\" target=\"_self\"><md-icon md-font-icon=\"today\">today</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Inserisci Amici\" ng-if=\"!ab.env.isMaster && !e.deleted && e.isMine\" ng-href=\"{{ ab.env.booking }}/pf?tenant={{ (ab.env.tenant==\'Italia\'?(e.customer.data.tenant?e.customer.data.tenant:ab.env.currentTenant):ab.env.currentTenant) }}&amp;cph={{ e.customer.data.phone }}&amp;c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;store={{ ab.storeId }}&amp;token={{ ab.token }}\"><md-icon title=\"Inserisci Amici\" md-font-icon=\"card_giftcard\">card_giftcard</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Assegna a me\" ng-click=\"ab.claim(e)\" ng-if=\"ab.user.type != \'callcenter\' && !e.f_dup && !e.closed && !e.deleted && e.user_id!=ab.user.id && (!e.f_oper || ab.user.store_id!=null)\"><md-icon md-font-icon=\"flag\">flag</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"!ab.eListLoading\" md-limit=\"ab.eListPag.per_page\" md-page=\"ab.eListPag.current_page\" md-total=\"{{ ab.eListPag.total }}\" md-on-paginate=\"ab.eListLoad\" md-boundary-links=\"ab.options.boundaryLinks\" md-page-select=\"ab.options.pageSelect\"></md-table-pagination><h3>Legenda:</h3><div ng-if=\"ab.user.type!=\'callcenter\'\"><md-button class=\"md-icon-button md-raised md-accent md-warn\">SC</md-button>Leads non commerciali (=centro) in stato da chiamare<br><br></div><div ng-if=\"ab.user.type!=\'operator\' && ab.user.type!=\'storemngr\'\"><md-button class=\"md-icon-button md-raised md-accent\" style=\"background-color: rgb(0, 102, 150);\">CC</md-button>Leads commerciali in stato da chiamare<br><br></div><div ng-if=\"ab.user.type!=\'callcenter\'\"><md-button class=\"md-icon-button\" style=\"background-color: orange;\">SR</md-button>Leads Centro in stato da richiamare<br><br></div><div ng-if=\"ab.user.type!=\'operator\' && ab.user.type!=\'storemngr\'\"><md-button class=\"md-icon-button\" style=\"background-color: gold;\">CR</md-button>Leads commerciali in stato da richiamare</div></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"input\">input</md-icon><h2 class=\"md-headline\"><span ng-if=\"ab.activeE.id\" class=\"inset\">{{ ab.activeE.customer.data.firstname }} {{ ab.activeE.customer.data.lastname }} (cid: {{ ab.activeE.customer.data.id }} / lid: {{ ab.activeE.id }})</span> <span ng-if=\"!ab.activeE.id\">Inserimento nuovo lead</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"eForm\" id=\"eForm\" layout=\"row\" layout-wrap=\"\"><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"firstname\">Nome</label> <input type=\"text\" id=\"firstname\" ng-disabled=\"ab.activeE.id\" name=\"firstname\" ng-model=\"ab.activeE.customer.data.firstname\" ng-model-options=\"ab.filter.options\"></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"lastname\">Cognome</label> <input type=\"text\" id=\"lastname\" name=\"lastname\" ng-disabled=\"ab.activeE.id\" ng-model=\"ab.activeE.customer.data.lastname\" ng-model-options=\"ab.filter.options\"></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"phone\">Telefono</label> <input type=\"text\" id=\"phone\" name=\"phone\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-disabled=\"ab.activeE.id\" ng-model=\"ab.activeE.customer.data.phone\" ng-required=\"true\" ng-model-options=\"ab.filter.options\"></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"email\">Email</label> <input type=\"text\" id=\"email\" ng-disabled=\"ab.activeE.id\" name=\"email\" ng-model=\"ab.activeE.customer.data.email\" ng-model-options=\"ab.filter.options\"></md-input-container><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"referral_code\">In carico a</label> <input type=\"text\" id=\"user_alias\" name=\"user_alias\" ng-disabled=\"true\" ng-if=\"ab.activeE.id\" ng-model=\"ab.activeE.user_alias\" ng-model-options=\"ab.filter.options\"></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"campagna\">Campagna</label> <input type=\"text\" id=\"campagna\" name=\"campagna\" ng-model=\"ab.activeE.campagna\" ng-disabled=\"ab.activeE.id\" ng-required=\"true\" ng-model-options=\"ab.filter.options\"></md-input-container></div><div flex=\"100\"><md-input-container class=\"md-block\"><label for=\"call_state\">Stato cliente</label><md-select id=\"call_state\" name=\"call_state\" class=\"first-uppercase\" ng-disabled=\"ab.activeE.id && ((ab.activeE.call_state == \'spostato\' && ab.activeE.appointment.data.recalled==4) || !ab.activeE.isMine || ab.activeE.closed || ab.activeE.f_dup || ab.activeE.deleted || ab.activeE.call_state==\'ha preso appuntamento\')\" md-container-class=\"first-uppercase\" aria-label=\"Stato\" ng-model=\"ab.activeE.call_state\" ng-change=\"ab.eStatus.onChange()\" ng-required=\"true\"><md-option ng-if=\"ab.activeE.f_dup || ab.activeE.closed || ab.activeE.deleted || ab.activeE.call_state == \'da chiamare\' || ab.activeE.call_state == \'non lavorato\' || ab.activeE.call_state == \'ha preso appuntamento\'\" ng-value=\"ab.activeE.call_state\">{{ ab.activeE.call_state }}</md-option><md-option ng-if=\"ab.activeE.categoria==\'conferma\' && ab.activeE.appointment_id\" ng-value=\"\'confermato\'\">confermato</md-option><md-option ng-if=\"ab.activeE.categoria==\'conferma\' && ab.activeE.appointment_id\" ng-value=\"\'spostato\'\">spostato</md-option><md-option ng-if=\"ab.activeE.categoria==\'conferma\' && ab.activeE.appointment_id\" ng-value=\"\'disdetto\'\">disdetto</md-option><md-option ng-if=\"!ab.activeE.id && ab.activeE.call_state!=\'da chiamare\'\" ng-value=\"\'da chiamare\'\">Da chiamare</md-option><md-option ng-if=\"!ab.activeE.f_dup && !ab.activeE.closed && ab.activeE.call_state!=\'ha preso appuntamento\'\" ng-value=\"call_state\" ng-repeat=\"call_state in ::ab.call_state track by call_state\">{{ call_state }}</md-option></md-select></md-input-container><div ng-if=\"ab.eStatus.showDatePicker\"><md-datetime-picker data=\"ab.activeE.call_date\" customer=\"ab.activeE\" readonly=\"ab.activeE.id && (ab.activeE.closed || !ab.activeE.isMine)\" editable=\"!ab.activeE.id\" label=\"\'Da chiamare il\'\" style=\"padding: 0px 8px;\"></md-datetime-picker></div><md-input-container class=\"md-block\" ng-if=\"ab.activeE.id && ab.activeE.call_state==\'fuori zona\' && ab.activeE.isMine && !ab.activeE.closed && !ab.activeE.deleted\"><label for=\"move_to\">Manda a</label><md-select id=\"move_to\" name=\"move_to\" class=\"first-uppercase\" ng-disabled=\"!ab.activeE.isMine || ab.activeE.closed || ab.activeE.deleted\" md-container-class=\"first-uppercase\" aria-label=\"Manda a\" placeholder=\"Selezionare area\" ng-model=\"ab.activeE.moveTo\"><md-option ng-value=\"undefined\"></md-option><md-option ng-value=\"tenant\" ng-repeat=\"tenant in ::ab.tenantsList\">{{ tenant.label }}</md-option></md-select></md-input-container></div><div flex=\"100\"><md-input-container class=\"md-block\"><label for=\"note\">Note</label> <textarea rows=\"2\" id=\"note\" ng-disabled=\"ab.activeE.id && (ab.activeE.call_state == \'spostato\' || !ab.activeE.isMine || ab.activeE.closed || ab.activeE.f_dup || ab.activeE.deleted || ab.activeE.call_state == \'ha preso appuntamento\')\" name=\"note\" ng-model=\"ab.activeE.note\" ng-model-options=\"ab.filter.options\"></textarea></md-input-container></div><div flex=\"100\" ng-if=\"ab.activeE.id && ab.activeE.referral_code!=null && ab.activeE.referral_code!=\'\'\"><md-input-container class=\"md-block\"><label for=\"referral_code\">Codice acquisizione cliente</label> <input type=\"text\" id=\"referral_code\" name=\"referral_code\" ng-disabled=\"true\" ng-model=\"ab.activeE.referral_code\" ng-model-options=\"ab.filter.options\"></md-input-container></div><div flex=\"100\"><md-progress-circular ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\" ng-if=\"!(ab.activeE.call_state == \'spostato\' && ab.activeE.appointment.data.recalled==4) && !ab.activeE.f_dup && !ab.activeE.closed && !ab.activeE.deleted && ab.activeE.isMine && ab.activeE.call_state!=\'ha preso appuntamento\'\"><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ab.update( ab.activeE )\" ng-disabled=\"eForm.$invalid || ab.saving\" ng-if=\"ab.activeE.call_state!=\'fuori zona\' && ab.activeE.call_state!=\'non interessato\' && ab.activeE.call_state!=\'fake\'\"><md-icon md-font-icon=\"check\">check</md-icon><span ng-if=\"!(ab.activeE.call_state==\'fuori zona\' && ab.activeE.moveTo!=null)\">Salva</span> <span ng-if=\"(ab.activeE.call_state==\'fuori zona\' && ab.activeE.moveTo!=null)\">Manda a {{ab.activeE.moveTo.label}} ed elimina lead</span></md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ab.update( ab.activeE, false, true )\" ng-disabled=\"eForm.$invalid || ab.saving\" ng-if=\"ab.activeE.call_state.startsWith(\'inviato WhatsApp\') && (ab.activeE.call_state!=\'fuori zona\' && ab.activeE.call_state!=\'non interessato\' && ab.activeE.call_state!=\'fake\')\"><md-icon md-font-icon=\"question_answer\">question_answer</md-icon>Salva e invia Whatsapp</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ab.update( ab.activeE, true )\" ng-disabled=\"eForm.$invalid || ab.saving\" ng-if=\"!ab.activeE.archived && !(ab.activeE.call_state==\'fuori zona\' && ab.activeE.moveTo!=null)\"><md-icon md-font-icon=\"check\">check</md-icon>Salva e archivia</md-button></md-input-container></div></form><span style=\"padding-top: 20px;\" class=\"md-subhead\" ng-if=\"ab.activeE.appointments.data.length > 0 && !ab.loading\">Appuntamenti collegati al lead</span><md-content ng-hide=\"!ab.loading\" layout=\"row\" layout-align=\"center center\" style=\"min-height: 80px;\"><md-progress-circular ng-disabled=\"!ab.loading\" md-diameter=\"40\"></md-progress-circular></md-content><md-table-container class=\"addressbook-appointments\" ng-if=\"ab.activeE.appointments.data.length > 0 && !ab.loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\"><span>Prezzo</span></th><th md-column=\"\"><span>Pres.</span></th><th md-column=\"\"><span>Centro</span></th></tr></thead><tbody md-body=\"\" style=\"font-size: 12px;\"><tr md-row=\"\" ng-repeat=\"appointment in ab.activeE.appointments.data | orderBy: \'-date_start\'\" class=\"{{appointment.recalled>=3?\'recalled_\'+appointment.recalled:( appointment.paid? \'\':\'app_notpaid\')}}\"><td>{{ appointment.date_start | date : \'dd/MM/yyyy HH:mm\' }}</td><td>{{ appointment.treatment_id | treatmentIdtoName : ab.treatmentsList }}<md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.customer_subscription_id !== null\">autorenew</md-icon></td><td>{{ appointment.price | number:2 }} €</td><td><span ng-if=\"appointment.paid\">SI</span> <span ng-if=\"!appointment.paid\">NO</span></td><td>{{ appointment.store_id | storeIdtoName : ab.storesList }}</td></tr></tbody></table></md-table-container><span style=\"padding-top: 50px;\" class=\"md-subhead\">Altri dati anagrafici</span><form autocomplete=\"off\" role=\"form\" name=\"customerForm\" id=\"customerForm\" layout=\"row\" layout-wrap=\"\"><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\"><label for=\"birthdate\">Data di Nascita</label><md-datepicker id=\"birthdate\" name=\"birthdate\" ng-model=\"ab.activeE.customer.data.birthdate\" md-placeholder=\"Data di nascita\" ng-disabled=\"ab.activeE.id\"></md-datepicker></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\"><br hide-gt-sm=\"\"><br hide-gt-sm=\"\"><label for=\"gender\" style=\"margin-bottom: 8px;\">Sesso</label><md-radio-group id=\"gender\" name=\"gender\" ng-disabled=\"ab.activeE.id\" ng-model=\"ab.activeE.customer.data.gender\"><md-radio-button value=\"F\">Femmina</md-radio-button><md-radio-button value=\"M\" class=\"md-primary\">Maschio</md-radio-button></md-radio-group></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"address\">Indirizzo</label> <input type=\"text\" id=\"address\" name=\"address\" ng-disabled=\"ab.activeE.id\" ng-model=\"ab.activeE.customer.data.address\" ng-model-options=\"ab.filter.options\"></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"city\">Città</label> <input type=\"text\" id=\"city\" ng-disabled=\"ab.activeE.id\" name=\"city\" ng-model=\"ab.activeE.customer.data.city\" ng-model-options=\"ab.filter.options\"></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"zip_code\">CAP</label> <input type=\"text\" id=\"zip_code\" name=\"zip_code\" ng-disabled=\"ab.activeE.id\" ng-model=\"ab.activeE.customer.data.zip_code\" ng-model-options=\"ab.filter.options\"></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"province\">Provincia</label><md-select id=\"province\" name=\"province\" class=\"first-uppercase\" ng-disabled=\"ab.activeE.id\" md-container-class=\"first-uppercase\" aria-label=\"province\" ng-model=\"ab.activeE.customer.data.province\" ng-model-options=\"ab.filter.options\"><md-option ng-value=\"null\">Nessuna provincia</md-option><md-optgroup label=\"{{ regione }}\" ng-repeat=\"( regione, province ) in ::ab.Italia track by regione\"><md-option ng-value=\"provincia.sigla\" ng-repeat=\"provincia in ::province track by provincia.sigla | orderBy: provincia.sigla\">{{ provincia.nome }}</md-option></md-optgroup></md-select></md-input-container></div></form><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ab.create( ab.activeE)\" ng-disabled=\"eForm.$invalid || customerForm.$invalid || ab.saving\" ng-if=\"!ab.activeE.id\"><md-icon md-font-icon=\"check\">check</md-icon>Crea lead</md-button></md-content></md-sidenav>");
$templateCache.put("app/login/login.html","<md-content layout-fill=\"\" flex=\"\" layout=\"row\" layout-align=\"center center\" class=\"page-login\"><div flex-xs=\"100\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"70\" layout=\"row\" layout-align=\"center center\"><div flex-xs=\"95\" flex-sm=\"70\" flex-gt-md=\"55\" layout=\"column\"><md-toolbar class=\"md-tall md-transparent\"><div class=\"md-toolbar-tools\" layout-align=\"center center\"><h1 class=\"md-text-center\"><img class=\"md-image-responsive\" src=\"{{login.env.logo?login.env.logo:\'assets/images/logo-simple-white.png\'}}\" alt=\"{{login.env.company}}\"><div ng-if=\"!login.env.hideSlogan\"><span class=\"md-accent\">Epilazione.</span> Veloce. <span class=\"md-accent\">Indolore.</span> Efficace.</div></h1></div></md-toolbar><div md-whiteframe=\"2\" class=\"container\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\" ng-click=\"login.setIsShowPsw(false)\" ng-style=\"login.isShowPsw ? { \'color\':\'white\', \'text-decoration\': \'underline\', \'cursor\':\'pointer\'} : { \'color\':\'white\', \'font-weight\': \'bold\'}\">Login | {{login.env.currentTenant?login.env.currentTenant:login.env.tenant}}</span> <span class=\"inset\" ng-click=\"login.setIsShowPsw(true)\" ng-style=\"login.isShowPsw ? { \'color\':\'white\', \'font-weight\': \'bold\'} : { \'color\':\'white\', \'text-decoration\': \'underline\', \'cursor\':\'pointer\'}\">Password dimenticata</span></h2></div></md-toolbar><md-content layout-padding=\"\" ng-if=\"! login.isShowPsw\"><form role=\"form\" id=\"loginForm\" name=\"loginForm\" layout-padding=\"\" layout-margin=\"\"><h3 style=\"text-align: center;\">Entra in <i><u>{{login.env.company}} {{login.env.currentTenant?login.env.currentTenant:login.env.tenant}}</u></i></h3><md-input-container class=\"md-block\"><label for=\"email\">Email</label><md-icon md-font-icon=\"email\">email</md-icon><input id=\"email\" type=\"email\" name=\"email\" ng-model=\"login.email\" required=\"\" md-autofocus=\"\"></md-input-container><md-input-container class=\"md-block\"><label for=\"password\">Password</label><md-icon md-font-icon=\"lock\">lock</md-icon><input id=\"password\" type=\"password\" name=\"password\" ng-model=\"login.password\" required=\"\" ng-keyup=\"login.keyUpLogin($event)\"></md-input-container><h3 ng-if=\"login.isExpiredPsw\">Password scaduta inserire una nuova password:</h3><md-input-container class=\"md-block\" ng-if=\"login.isExpiredPsw\"><label for=\"password\">Nuova Password</label><md-icon md-font-icon=\"lock\">lock</md-icon><input id=\"newpassword\" type=\"password\" name=\"newpassword\" ng-model=\"login.newpassword\" required=\"\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@$!%*?&;:_])[A-Za-z\\d$@$!%*?&;:_]{9,}/\"></md-input-container><div ng-if=\"login.isExpiredPsw\"><div class=\"error\"><span class=\"success\">La password deve essere</span> <span ng-class=\"{\'success\': loginForm.newpassword.$viewValue!=loginForm.password.$viewValue}\"><md-icon ng-if=\"loginForm.newpassword.$viewValue!=loginForm.password.$viewValue\" md-font-icon=\"done\">done</md-icon>diversa dalla precedente</span> <span class=\"success\">e deve contenere</span><ul><li ng-class=\"{\'success\': loginForm.newpassword.$viewValue.length>8}\"><md-icon ng-if=\"loginForm.newpassword.$viewValue.length>8\" md-font-icon=\"done\">done</md-icon>almeno 9 caratteri</li><li ng-class=\"{\'success\': login.containsMaiuscolo(loginForm.newpassword.$viewValue)}\"><md-icon ng-if=\"login.containsMaiuscolo(loginForm.newpassword.$viewValue)\" md-font-icon=\"done\">done</md-icon>una lettera maiuscola</li><li ng-class=\"{\'success\': login.containsMinuscolo(loginForm.newpassword.$viewValue)}\"><md-icon ng-if=\"login.containsMinuscolo(loginForm.newpassword.$viewValue)\" md-font-icon=\"done\">done</md-icon>una minuscola</li><li ng-class=\"{\'success\': login.containsNumero(loginForm.newpassword.$viewValue)}\"><md-icon ng-if=\"login.containsNumero(loginForm.newpassword.$viewValue)\" md-font-icon=\"done\">done</md-icon>un numero</li><li ng-class=\"{\'success\': login.containsSpeciale(loginForm.newpassword.$viewValue)}\"><md-icon ng-if=\"login.containsSpeciale(loginForm.newpassword.$viewValue)\" md-font-icon=\"done\">done</md-icon>un carattere speciale tra @$!%*?&;:_</li></ul></div></div><md-input-container class=\"md-block\" ng-if=\"login.isExpiredPsw\"><label for=\"password\">Conferma Nuova Password</label><md-icon md-font-icon=\"lock\">lock</md-icon><input id=\"cfnewpassword\" type=\"password\" name=\"cfnewpassword\" ng-model=\"login.cfnewpassword\" required=\"\"></md-input-container><md-input-container layout=\"row\" layout-align=\"end\"><md-button ng-click=\"login.doLogin()\" class=\"md-raised md-accent\" ng-disabled=\"loginForm.$invalid || login.loading || (login.isExpiredPsw && (loginForm.newpassword.$viewValue==loginForm.password.$viewValue || loginForm.newpassword.$viewValue!=loginForm.cfnewpassword.$viewValue))\"><md-icon md-font-icon=\"check\">check</md-icon>Login <span ng-if=\"login.isExpiredPsw\">e aggiornamento password</span></md-button><md-button ng-click=\"login.doLoginAuto()\" class=\"md-raised md-warn\" ng-if=\"false\"><md-icon md-font-icon=\"check\">check</md-icon>Login AUTO</md-button></md-input-container></form></md-content><md-content layout-padding=\"\" ng-if=\"login.isShowPsw\"><form role=\"form\" id=\"pswForm\" name=\"pswForm\" layout-padding=\"\" layout-margin=\"\"><md-input-container class=\"md-block\"><label for=\"phone\">Phone</label><md-icon md-font-icon=\"phone\">phone</md-icon><input id=\"phone\" type=\"text\" name=\"phone\" ng-model=\"login.phone\" required=\"\" ng-disabled=\"login.loading\"></md-input-container><md-input-container class=\"md-block\"><label for=\"reg_email\">Email</label><md-icon md-font-icon=\"email\">email</md-icon><input id=\"reg_email\" type=\"email\" name=\"reg_email\" ng-model=\"login.reg_email\" required=\"\" ng-disabled=\"login.loading\"></md-input-container><md-input-container class=\"md-block\"><div ng-if=\"!login.env.captcha || login.env.captcha.key\" vc-recaptcha=\"\" key=\"!login.env.captcha?\'6LfLty4UAAAAAGRLmlN7G7csoOGGLe75Q0ewkY9D\':login.env.captcha.key\" ng-model=\"login.captcha\" theme=\"light\" size=\"normal\" type=\"\'image\'\" lang=\"it\"></div></md-input-container><md-input-container layout=\"row\" layout-align=\"end\"><md-button ng-click=\"login.doRigeneraPassword()\" class=\"md-raised md-accent\" ng-disabled=\"pswForm.$invalid || login.loading\"><md-icon md-font-icon=\"check\">check</md-icon>Rigenera password</md-button></md-input-container></form></md-content></div></div></div></md-content>");
$templateCache.put("app/main/main.html","<md-content layout-fill=\"\"><md-toolbar class=\"first-toolbar\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button menu-btn width-auto\" aria-label=\"Menu\" ng-click=\"main.toggleLeft()\"><md-icon md-font-icon=\"menu\">menu</md-icon></md-button><div flex=\"nogrow\" class=\"logo\" hide-xs=\"\"><a href=\"\" ng-click=\"main.reload()\"><img ng-if=\"main.env && main.env.tenant==\'Bios\'\" class=\"md-image-responsive\" src=\"/assets/images/logo-bios.png\" alt=\"{{main.env.company}}\" style=\"height: 60px;\"> <img ng-if=\"main.env && main.env.tenant!=\'Bios\' && main.env.logo\" class=\"md-image-responsive\" src=\"{{ main.env.logo }}\" alt=\"{{main.env.company}}\"> <img ng-if=\"main.env && main.env.tenant!=\'Bios\' && !main.env.logo\" class=\"md-image-responsive\" src=\"/assets/images/logo-simple-white.png\" alt=\"{{main.env.company}}\"></a></div><span flex=\"\" hide-xs=\"\"></span><ng-gauge ng-if=\"main.env.tenant!=\'Bios\' && main.statistics && main.statistics.obDay\" size=\"80\" type=\"arch\" thick=\"15\" min=\"0\" max=\"200\" value=\"main.statistics.percDay\" cap=\"round\" label=\"\" foreground-color=\"#ffcc66\" background-color=\"rgba(255,255,255, 0.4)\" append=\"%\" thresholds=\"main.thresholds\"></ng-gauge><span ng-if=\"main.env.tenant!=\'Bios\' && main.statistics && main.statistics.obDay\">{{ main.statistics.statusDayK }}K</span> <span flex=\"\" hide-xs=\"\"></span><md-button ui-sref=\"home.leads({call_state: \'da chiamare\', f_oper: 1})\" ng-if=\"main.user.type != \'callcenter\' && main.alerts.leads.dachiamare>0\" class=\"md-icon-button md-raised md-accent md-warn\" ng-disabled=\"main.tenantLoading\">{{ main.alerts.leads.dachiamare }}</md-button><md-button ui-sref=\"home.leads({call_state: \'da chiamare\', f_oper: 0})\" ng-if=\"main.user.type != \'operator\' && main.user.type != \'storemngr\' && main.alerts.leads.dachiamareComm>0\" class=\"md-icon-button md-raised md-accent\" ng-disabled=\"main.tenantLoading || main.user.type == \'callcenter\'\" style=\"background-color: rgb(0, 102, 150);\">{{ main.alerts.leads.dachiamareComm }}</md-button><md-button ui-sref=\"home.leads({call_state: \'da richiamare\', f_oper: 1})\" ng-if=\"main.user.type != \'callcenter\' && main.alerts.leads.darichiamare>0\" ng-disabled=\"main.tenantLoading\" class=\"md-icon-button\" style=\"background-color: orange;\">{{ main.alerts.leads.darichiamare }}</md-button><md-button ui-sref=\"home.leads({call_state: \'da richiamare\', f_oper: 0})\" ng-if=\"main.user.type != \'operator\' && main.user.type != \'storemngr\' && main.alerts.leads.darichiamareComm>0\" class=\"md-icon-button\" ng-disabled=\"main.tenantLoading || main.user.type == \'callcenter\'\" style=\"background-color: gold;\">{{ main.alerts.leads.darichiamareComm }}</md-button><md-button ng-if=\"!main.user.store_id || main.user.type ==\'storemngr\'\" class=\"md-icon-largebutton\" style=\"padding:5px;\" ng-disabled=\"main.tenantLoading\" aria-label=\"Whatsapp\" ui-sref=\"home.whatsapp\"><notification-icon count=\"main.alerts.messagesUnreaded\"><md-icon title=\"Whatsapp\" md-font-icon=\"chat\">chat</md-icon></notification-icon></md-button><span flex=\"\" hide-xs=\"\"></span><md-button aria-label=\"Online\" ng-disabled=\"main.fLeadOnlineLoading\" ng-if=\"false && main.user.type == \'callcenter\' && main.user.f_lead_online && !main.user.store_id\" class=\"md-raised md-accent\" ng-click=\"main.setFLeadOnline(0)\"><md-icon title=\"Online\" md-font-icon=\"place\">place</md-icon>Online</md-button><md-button aria-label=\"Offline\" ng-disabled=\"main.fLeadOnlineLoading\" ng-if=\"false && main.user.type == \'callcenter\' && !main.user.f_lead_online && !main.user.store_id\" class=\"md-raised md-accent md-warn\" ng-click=\"main.setFLeadOnline(1)\"><md-icon title=\"Offline\" md-font-icon=\"place\">place</md-icon>Offline</md-button><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Moodle\" ng-href=\"{{ main.env.API }}/moodleSSO?token={{ main.token }}\" target=\"moodle\"><md-icon title=\"Moodle\" md-font-icon=\"school\">school</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Comunicazioni\" style=\"padding:5px;\" ng-click=\"main.openAdministration()\" ng-if=\"main.user.type == \'assist\' || main.user.type == \'operator\' || main.user.type == \'storemngr\'\"><notification-icon count=\"main.alerts.documentsUnreaded\"><md-icon title=\"Comunicazioni\" md-font-icon=\"mail\">mail</md-icon></notification-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Manuale\" ng-href=\"{{ main.env.wiki }}/?destination=manuale-utilizzo-software&rnd={{ main.random }}&amp;c_sid={{ main.user.store_id }}&amp;c_role={{ main.user.type }}&amp;store={{ selectedStore }}&amp;token={{ main.token }}\" target=\"_blank\"><md-icon title=\"Manuale\" md-font-icon=\"help\">help</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Feedback\" ng-href=\"{{ main.env.wiki }}/?destination=feedback&rnd={{ main.random }}&amp;c_sid={{ main.user.store_id }}&amp;c_role={{ main.user.type }}&amp;store={{ selectedStore }}&amp;token={{ main.token }}\" target=\"_blank\"><md-icon title=\"Feedback\" md-font-icon=\"feedback\">feedback</md-icon></md-button><md-button ng-if=\"false\" class=\"md-icon-button\" aria-label=\"Info\" ng-click=\"main.about()\"><md-icon title=\"Info\" md-font-icon=\"info\">info</md-icon></md-button><div flex=\"nogrow\" class=\"user-name\" hide-xs=\"\" style=\"text-align: center;\"><div ng-if=\"main.user.roles.length==1 && !main.user.f_dm && (main.user.type==\'assist\' || main.user.type==\'operator\' || main.user.type==\'storemngr\')\" class=\"operator-circle\" style=\"background-color: {{ main.user.color }};\"></div><md-icon ng-if=\"main.user.f_dm\" title=\"District Manager\" md-font-icon=\"group_work\">group_work</md-icon>&nbsp;{{ main.user.firstname }} {{ main.user.lastname }} <span ng-if=\"main.user.roles.length==1 && main.user.type!=\'assist\' && main.user.type!=\'operator\' && main.user.type!=\'storemngr\'\"><br>{{ main.user.type }} {{main.user.tag_area?\'[\'+main.user.tag_area+\']\':\'\'}}</span> <span ng-if=\"main.user.roles.length==1 && (main.user.type==\'assist\' || main.user.type==\'operator\' || main.user.type==\'storemngr\')\"><br><md-icon ng-if=\"main.user.type==\'storemngr\'\" md-font-icon=\"school\">school</md-icon>{{ main.user.store.alias }}</span><br><md-input-container ng-if=\"main.user.roles.length>1\" style=\"margin: 0px;\"><md-select aria-label=\"Seleziona un ruolo\" placeholder=\"Seleziona un ruolo\" ng-disabled=\"main.tenantLoading\" ng-model=\"main.user.role_id\" ng-change=\"main.setRole()\"><md-option ng-value=\"role.id\" ng-repeat=\"role in main.user.roles | filter : {active: true} : true\"><div ng-if=\"role.role==\'assist\' || role.role==\'operator\' || role.role==\'storemngr\'\" class=\"operator-circle\" style=\"background-color: {{ role.color }};\"></div><span ng-if=\"role.role==\'assist\' || role.role==\'operator\' || role.role==\'storemngr\'\"><md-icon ng-if=\"role.role==\'storemngr\'\" md-font-icon=\"school\">school</md-icon>{{ role.store.alias }}</span> <span ng-if=\"role.role!=\'assist\' && role.role!=\'operator\' && role.role!=\'storemngr\'\">{{ role.role }} {{main.user.tag_area?\'[\'+main.user.tag_area+\']\':\'\'}}</span></md-option></md-select></md-input-container></div><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\"></span><div flex=\"nogrow\" class=\"user-image\" ng-if=\"main.user_image\" hide-xs=\"\"><img class=\"md-image-responsive\" style=\"width: auto; max-height: 45px;\" ng-src=\"{{ main.user_image }}\" alt=\"{{ main.user_name }}\"></div><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><div flex=\"nogrow\" class=\"header-clock\" hide-xs=\"\" hide-sm=\"\">{{ main.clock | date:\'HH:mm\' }}</div><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container ng-if=\"main.env.tenant == \'Italia\'\"><md-select aria-label=\"Seleziona Area\" placeholder=\"Seleziona Area\" ng-model=\"main.selectedArea\" ng-disabled=\"main.tenantLoading\" ng-change=\"main.selectedAreaChange(true)\"><md-option ng-value=\"\'Italia\'\">Italia</md-option><md-option ng-repeat=\"(key,value) in main.env.apis\" ng-value=\"key\">{{ key }}</md-option></md-select></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\"></span><md-input-container flex=\"25\"><md-select aria-label=\"Seleziona uno Store\" placeholder=\"Seleziona uno Store\" ng-model=\"selectedStore\" ng-change=\"main.setStoreInLocalStorage()\" ng-disabled=\"main.tenantLoading || main.selectedStoreDisabled\"><md-option ng-value=\"0\" ng-if=\"main.user.type != \'operator\'\">Tutti i centri</md-option><md-option ng-value=\"store.id\" ng-repeat=\"store in main.storesList | orderBy: \'label\'\">{{ store.label }} <span ng-if=\"store.subtitle && store.subtitle != \'\'\" style=\"font-size:80%\"><br>{{ store.subtitle }}</span></md-option></md-select></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\"></span></div></md-toolbar><md-content layout=\"row\" class=\"main-content\"><md-sidenav class=\"menu-sidenav md-sidenav-left md-whiteframe-4dp\" md-component-id=\"left\" md-is-locked-open=\"$mdMedia(\'min-width: 1920px\')\"><md-content layout-margin=\"\"><md-list flex=\"\"><md-list-item ng-repeat=\"item in main.menu\" ng-if=\"main.checkVisibility( item )\"><md-button class=\"md-primary\" ui-sref-active=\"md-raised\" ui-sref=\"{{ item.link }}\" ng-click=\"main.toggleLeft()\" layout=\"row\"><div class=\"inset\"><md-icon md-font-icon=\"{{ item.icon }}\">{{ item.icon }}</md-icon></div><div class=\"inset\">{{ item.title }}</div></md-button></md-list-item><md-list-item ng-if=\"main.user.type==\'admin\'\"><md-button class=\"md-primary\" ng-click=\"main.openAnalytics()\" layout=\"row\"><div class=\"inset\"><md-icon md-font-icon=\"settings\">settings</md-icon></div><div class=\"inset\">Analytics & BI</div></md-button></md-list-item><md-list-item><md-button class=\"md-primary\" ng-click=\"main.openAdministration()\" layout=\"row\"><div class=\"inset\"><md-icon md-font-icon=\"settings\">settings</md-icon></div><div class=\"inset\">HRM</div></md-button></md-list-item><md-list-item><md-button class=\"md-primary\" ng-click=\"main.doLogout(\'MainHtmlMenuClicked\')\" layout=\"row\"><div class=\"inset\"><md-icon md-font-icon=\"lock\">lock</md-icon></div><div class=\"inset\">Logout</div></md-button></md-list-item></md-list></md-content></md-sidenav><md-content class=\"main-content-page\" flex=\"\"><div ui-view=\"menuContent\" layout-fill=\"\"></div></md-content></md-content></md-content>");
$templateCache.put("app/monthcash/monthcash.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Corrispettivi</span></h2><span flex=\"\" hide-xs=\"\"></span><md-checkbox ng-if=\"!ab.storeId && ab.query.month\" ng-model=\"ab.query.perDay\" ng-change=\"ab.eListLoad()\">Per giorno</md-checkbox><md-checkbox ng-if=\"!ab.query.month\" ng-model=\"ab.query.perMonth\" ng-change=\"ab.eListLoad()\">Per mese</md-checkbox><span flex=\"\" hide-xs=\"\"></span><div><md-input-container><md-select aria-label=\"Mese\" placeholder=\"Mese\" ng-model=\"ab.query.month\" ng-change=\"ab.eListLoad()\"><md-option ng-value=\"month.v\" ng-repeat=\"month in ab.MONTHS.months track by month.v\">{{ month.l }}</md-option><md-option ng-value=\"undefined\">Tutti i mesi</md-option></md-select></md-input-container></div>&nbsp;&nbsp;&nbsp;&nbsp;<div><md-input-container><md-select aria-label=\"Anno\" placeholder=\"Anno\" ng-model=\"ab.query.year\" ng-change=\"ab.eListLoad()\"><md-option ng-value=\"year\" ng-repeat=\"year in ab.years\">{{ year }}</md-option></md-select></md-input-container></div><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Scarica PDF\" ng-disabled=\"ab.loading || ab.storeId==null || ab.eList.length==0\" ng-click=\"ab.sendPdf()\" ng-if=\"ab.user.type==\'admin\' && ab.storeId && ab.query.month\"><md-icon md-font-icon=\"send\">send</md-icon>Invia PDF</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Invia PDF\" ng-disabled=\"ab.loading || ab.storeId==null || ab.eList.length==0\" ng-click=\"ab.pdf()\" ng-if=\"ab.user.type==\'admin\' && ab.storeId && ab.query.month\"><md-icon md-font-icon=\"file_download\">file_download</md-icon>Scarica PDF</md-button><md-button class=\"md-accent md-raised\" ng-if=\"ab.user.type==\'admin\'\" ng-href=\"{{ ab.exportUrl }}\"><md-icon md-font-icon=\"save\">save</md-icon>Excel</md-button></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\" ng-if=\"ab.storeId || ab.query.perDay || ab.query.perMonth\">Data</th><th md-column=\"\" ng-if=\"!ab.storeId && (!ab.query.perDay || ab.query.perMonth)\"><span ng-if=\"!ab.env.isMaster\">Centro</span> <span ng-if=\"ab.env.isMaster\">Area</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right;\"><span>Gift Em. (n.s.)</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right;\"><span>Gift Em. (s.)</span></th><th md-column=\"\" md-numeric=\"\" style=\"text-align: right;\"><span>Totale</span></th><th md-column=\"\" md-numeric=\"\"><span>22%</span></th><th md-column=\"\" md-numeric=\"\"><span>10%</span></th><th md-column=\"\" md-numeric=\"\"><span>Coupon</span></th><th md-column=\"\" md-numeric=\"\"><span>Pos</span></th><th md-column=\"\" md-numeric=\"\"><span>Carta</span></th><th md-column=\"\" md-numeric=\"\"><span>App</span></th><th md-column=\"\" md-numeric=\"\"><span>Pagodil</span></th><th md-column=\"\" md-numeric=\"\"><span>APP Pago</span></th><th md-column=\"\" md-numeric=\"\"><span>PagoLight</span></th><th ng-if=\"ab.env.smallpayEnabled\" md-column=\"\" md-numeric=\"\"><span>Smallpay</span></th><th md-column=\"\" md-numeric=\"\"><span>Bonifico</span></th><th md-column=\"\" md-numeric=\"\"><span>Assegno</span></th><th ng-if=\"ab.env.satispayEnabled\" md-column=\"\" md-numeric=\"\"><span>Satispay</span></th><th md-column=\"\" md-numeric=\"\"><span>Stripe</span></th><th md-column=\"\" md-numeric=\"\"><span>Gift (n.s.)</span></th><th md-column=\"\" md-numeric=\"\"><span>Gift (s.)</span></th><th md-column=\"\" md-numeric=\"\"><span>Cassa</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.eListLoading\"><td md-cell=\"\" colspan=\"4\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.eListLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" ng-repeat=\"e in ab.eList\"><td md-cell=\"\" ng-if=\"(ab.storeId || ab.query.perDay) && !ab.query.perMonth\">{{ e.date | date : \'dd/MM/yyyy\' }}</td><td md-cell=\"\" ng-if=\"ab.query.perMonth\">{{ e.month }}/{{ e.year }}</td><td md-cell=\"\" ng-if=\"!ab.storeId && (!ab.query.perDay || ab.query.perMonth)\">{{ e.store.alias }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ e.total_rel_gift ? e.total_rel_gift :0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ e.total_rel_gift_s ? e.total_rel_gift_s :0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ e.total ? e.total:0 | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ (e.total-e.total_10) | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ e.total_10 ? e.total_10:0 | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ e.total_coupon ? e.total_coupon:0 | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ e.total_pos | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ e.total_card | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ e.total_app | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ e.total_dil | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ e.total_apppago | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ e.total_light | number : 2 }}</td><td md-cell=\"\" align=\"right\" ng-if=\"ab.env.smallpayEnabled\">{{ e.total_small | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ e.total_bon | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ e.total_check | number : 2 }}</td><td md-cell=\"\" align=\"right\" ng-if=\"ab.env.satispayEnabled\">{{ e.total_satis | number : 2 }}</td><td md-cell=\"\" align=\"right\" ng-if=\"ab.env.stripeEnabled\">{{ e.total_stripe | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ e.total_gift_ns | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ e.total_gift | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ e.total + e.total_rel_gift - e.total_pos - e.total_card - e.total_app - e.total_dil - e.total_apppago - e.total_light - e.total_bon - e.total_check - e.total_gift - e.total_small - e.total_satis - e.total_stripe | number : 2 }}</td></tr><tr md-row=\"\" style=\"background-color: rgb(217, 217, 217);\"><td colspan=\"{{ab.query.perMonth?(!ab.storeId?\'2\':\'1\'):\'1\'}}\" md-cell=\"\">Totali:</td><td md-cell=\"\" style=\"text-align: right;\">{{ ab.total_rel_gift ? ab.total_rel_gift:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ ab.total_rel_gift_s ? ab.total_rel_gift_s:0 | number : 2 }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ ab.total ? ab.total:0 | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ (ab.total-ab.total_10) | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ ab.total_10 ? ab.total_10:0 | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ ab.total_coupon ? ab.total_coupon:0 | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ ab.total_pos | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ ab.total_card | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ ab.total_app | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ ab.total_dil | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ ab.total_apppago | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ ab.total_light | number : 2 }}</td><td md-cell=\"\" align=\"right\" ng-if=\"ab.env.smallpayEnabled\">{{ ab.total_small | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ ab.total_bon | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ ab.total_check | number : 2 }}</td><td md-cell=\"\" align=\"right\" ng-if=\"ab.env.satispayEnabled\">{{ ab.total_satis | number : 2 }}</td><td md-cell=\"\" align=\"right\" ng-if=\"ab.env.stripeEnabled\">{{ ab.total_stripe | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ ab.total_gift_ns | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ ab.total_gift | number : 2 }}</td><td md-cell=\"\" align=\"right\">{{ ab.total + ab.total_rel_gift - ab.total_pos - ab.total_card - ab.total_app - ab.total_dil - ab.total_apppago - ab.total_light - ab.total_bon - ab.total_gift - ab.total_small - ab.total_satis - ab.total_stripe - ab.total_check | number : 2 }}</td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content>");
$templateCache.put("app/operators/operators.html","<md-content class=\"page-operators\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\" flex=\"nogrow\" hide-xs=\"\"><span class=\"inset\">Utenti</span></h2><span flex=\"\" hide-xs=\"\"></span> <span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"op.query.filter\" ng-keypress=\"op.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Cerca\"><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" show-gt-md=\"\"><md-select aria-label=\"Ruolo\" placeholder=\"Ruolo\" ng-model=\"op.query.filterType\" ng-change=\"op.operatorLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option value=\"admin\">Amministratore</md-option><md-option value=\"callcenter\">Callcenter</md-option><md-option value=\"operator\">Operatrice</md-option><md-option value=\"storemngr\">Store Manager</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-checkbox ng-model=\"op.query.active\" ng-change=\"op.operatorLoad(1)\">Attivi</md-checkbox><span flex=\"\" hide-xs=\"\"></span><md-checkbox ng-model=\"op.query.online\" ng-change=\"op.operatorLoad(1)\">Online</md-checkbox><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo utente\" ng-click=\"op.toggleRight()\" ng-show=\"op.user.type == \'admin\'\"><md-icon md-font-icon=\"face\">face</md-icon>Nuovo utente</md-button></div></md-toolbar><md-card><md-toolbar class=\"md-table-toolbar md-default search-toolbar\"><div class=\"md-toolbar-tools\"></div></md-toolbar><md-table-container><table md-table=\"\" md-row-select=\"op.options.rowSelection\" ng-model=\"op.selected\"><thead md-head=\"\" md-order=\"op.query.order\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"id\"><span>Id</span></th><th md-column=\"\" ng-if=\"op.user.type == \'admin\'\"><span>M.</span></th><th md-column=\"\" md-order-by=\"firstname\"><span>Nome</span></th><th md-column=\"\" md-order-by=\"lastname\"><span>Cognome</span></th><th md-column=\"\" md-order-by=\"email\"><span>Email</span></th><th ng-if=\"op.query.filterType!=\'callcenter\'\" md-column=\"\" md-order-by=\"recMinutes\" style=\"text-align: right;\"><span>Rec. H</span></th><th md-column=\"\" ng-if=\"op.query.filterType == \'callcenter\'\"><span>Inquadr.</span></th><th md-column=\"\"></th><th md-column=\"\" ng-if=\"op.query.filterType == \'callcenter\'\" flex=\"15\">Abilitazioni</th><th md-column=\"\"><table style=\"width:100%;\"><tr><td style=\"width:10%;\"></td><td style=\"width:30%;\">Ruolo</td><td style=\"width:40%;\">Centro | %</td><td class=\"cell-button\" style=\"width:20%; text-align: right;\">Att.</td></tr></table></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"op.loading || op.saving\"><td md-cell=\"\" colspan=\"6\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"op.loading || op.saving\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" ng-if=\"!op.loading && !op.saving\" md-select=\"operator\" md-select-id=\"id\" md-auto-select=\"op.options.autoSelect\" md-on-select=\"op.rowClicked\" ng-repeat=\"operator in op.operatorsList\"><td md-cell=\"\"><div layout=\"row\"><md-icon class=\"md-accent md-raised\" ng-if=\"operator.online\" md-font-icon=\"place\">place</md-icon><md-icon class=\"md-accent md-raised\" ng-if=\"operator.f_lead_online\" md-font-icon=\"input\">input</md-icon></div><div ng-if=\"false\" class=\"operator-circle\" style=\"background-color: green;\"></div></td><td md-cell=\"\" ng-click=\"op.rowClicked( operator )\">{{operator.id}}</td><td md-cell=\"\" ng-click=\"op.showActivities( operator )\" ng-if=\"op.user.type == \'admin\'\"><md-icon title=\"Storico modifiche\" md-font-icon=\"change_history\">change_history</md-icon></td><td md-cell=\"\" ng-click=\"op.rowClicked( operator )\">{{ operator.firstname }}</td><td md-cell=\"\" ng-click=\"op.rowClicked( operator )\">{{ operator.lastname }}<md-icon ng-if=\"operator.f_dm\" title=\"District Manager\" md-font-icon=\"group_work\">group_work</md-icon></td><td md-cell=\"\" ng-click=\"op.rowClicked( operator )\">{{ operator.email }}</td><td md-cell=\"\" ng-if=\"op.query.filterType!=\'callcenter\'\" ng-click=\"op.rowClicked( operator )\" style=\"text-align: right;\"><span ng-if=\"(!operator.currentDesignation2 || !operator.currentDesignation2.data.f_tablet) && (operator.recMinutes!=0)\">{{ operator.recMinutes/60 | number:2 }}</span></td><td md-cell=\"\" ng-if=\"op.query.filterType == \'callcenter\'\" ng-click=\"op.rowClicked( operator )\"><span>{{ operator.designation_name }}</span></td><td md-cell=\"\"><md-button ng-click=\"op.editCapabilities( operator )\" aria-label=\"Abilitazioni\" ng-if=\"operator.isPerStore || operator.type==\'callcenter\'\" class=\"md-icon-button md-primary md-raised\"><md-icon title=\"Abilitazioni\" md-font-icon=\"extension\">extension</md-icon></md-button></td><td md-cell=\"\" ng-if=\"op.query.filterType==\'callcenter\'\" ng-click=\"op.rowClicked( operator )\"><span ng-if=\"operator.user_attr_current.data.f_lead_new_a\">A |</span> <span ng-if=\"operator.user_attr_current.data.f_lead_new_b\">B |</span> <span ng-if=\"operator.user_attr_current.data.f_lead_rientri\">R |</span> <span ng-if=\"operator.categories && operator.categories.length>0\">{{ operator.categories.join(\', \') }} |</span> <span ng-if=\"operator.regions && operator.regions.length>0\">{{ operator.regions.join(\', \') }}</span></td><td md-cell=\"\"><table style=\"width:100%;\"><tr ng-repeat=\"role in operator.roles.data\"><td style=\"width:10%;\" ng-click=\"op.rowClicked( operator, role )\"><div ng-if=\"role.color && (role.role==\'callcenter\' || role.store_id)\" class=\"operator-circle\" style=\"background-color: {{ role.color }};\"></div></td><td style=\"width:30%;\" ng-click=\"op.rowClicked( operator, role )\"><span style=\"{{ role.role==operator.type?\'font-style: italic;\':\'\' }}\">{{ role.role }}</span></td><td md-cell=\"\" style=\"width:40%; text-align: right;\" ng-click=\"op.rowClicked( operator, role )\"><span ng-show=\"role.store_id!=null && role.store\" style=\"{{ role.store_id==operator.store_id?\'font-style: italic;\':\'\' }}\">{{ role.store.alias }}</span> <span ng-show=\"role.role==\'callcenter\'\">{{ operator.user_attr_current.data.time_perc}}%</span></td><td md-cell=\"\" class=\"cell-button\" style=\"width:20%; text-align: right;\"><md-button class=\"md-raised md-accent\" ng-disabled=\"op.user.type!=\'admin\' && op.user.type!=\'backoffice\'\" ng-click=\"op.toggleActiveRole( role.user_id, role.role, role.store_id )\" aria-label=\"Ruolo attivo\" ng-if=\"role.active == 1\">SI</md-button><md-button class=\"md-raised md-warn\" ng-disabled=\"op.user.type!=\'admin\' && op.user.type!=\'backoffice\'\" ng-click=\"op.toggleActiveRole( role.user_id, role.role, role.store_id )\" aria-label=\"Ruolo non attivo\" ng-if=\"role.active == 0\">NO</md-button></td></tr></table></td><td md-cell=\"\"><md-button ng-if=\"op.user.type==\'admin\' || op.user.type==\'backoffice\'\" class=\"md-icon-button md-primary md-raised\" aria-label=\"Aggiungi ruolo\" ng-click=\"op.newRole( operator )\"><md-icon md-font-icon=\"playlist_add\">playlist_add</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"! op.loading\" md-limit=\"op.operatorsListPag.per_page\" md-limit-options=\"op.query.limitOptions\" md-page=\"op.operatorsListPag.current_page\" md-total=\"{{ op.operatorsListPag.total }}\" md-boundary-links=\"op.options.boundaryLinks\" md-on-paginate=\"op.operatorLoad\"></md-table-pagination></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-operators md-sidenav-right\" style=\"max-width: 50%;\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"book\">book</md-icon><h2 class=\"md-headline\"><span ng-if=\"op.activeRoleIsNew\">Nuovo ruolo per</span> <span ng-if=\"op.activeIsRole && !op.activeRoleIsNew\">Modifica ruolo \"{{op.activeRole.role}}\" per</span> <span ng-if=\"!op.activeIsRole && op.activeOperator.id\">Modifica</span> <span ng-if=\"op.activeOperator.id\">{{ op.activeOperator.firstname }} {{ op.activeOperator.lastname }} (uid:{{op.activeOperator.id}})</span> <span ng-if=\"op.activeOperatorIsNew\">Nuovo utente</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"op.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\" layout-padding=\"\"><form autocomplete=\"off\" role=\"form\" name=\"operatorForm\" id=\"operatorForm\"><md-input-container class=\"md-block\" ng-if=\"op.activeOperatorIsNew || op.activeIsRole\"><label for=\"ruolo\">Ruolo</label><md-select aria-label=\"Ruolo\" placeholder=\"Ruolo\" name=\"ruolo\" id=\"ruolo\" ng-model=\"op.activeRole.role\" ng-change=\"op.activeEntityRoleChanged()\" ng-disabled=\"op.activeIsRole && op.activeRole.id!=null && (op.activeRole.store_id==null || op.activeRole.store_id==0)\" required=\"\"><md-option ng-value=\"undefined\"></md-option><md-option value=\"admin\" ng-if=\"op.activeIsRole && op.activeRole.role==\'admin\' || op.user.type==\'admin\' && op.activeRole.id==null\">Administrator</md-option><md-option value=\"backoffice\" ng-if=\"op.activeIsRole && op.activeRole.role==\'backoffice\' || op.activeRole.id==null && (op.user.type==\'admin\' || op.user.type==\'backoffice\')\">Backoffice</md-option><md-option value=\"callcenter\" ng-if=\"op.activeIsRole && op.activeRole.role==\'callcenter\' || op.activeRole.id==null && (op.user.type==\'admin\' || op.user.type==\'callcenter\')\">Callcenter</md-option><md-option value=\"manager\" ng-if=\"op.activeIsRole && op.activeRole.role==\'manager\' || op.activeRole.id==null && (op.user.type==\'admin\' || op.user.type==\'manager\')\">Manager</md-option><md-option value=\"storemngr\" ng-if=\"op.activeIsRole && op.activeRole.role==\'storemngr\' || (op.activeRole.id==null || op.activeIsRole && op.activeRole.store_id!=null && op.activeRole.store_id>0) && (op.user.type==\'admin\' || op.user.type==\'manager\' || op.user.type==\'storemngr\')\">Store Manager</md-option><md-option value=\"operator\" ng-if=\"op.activeIsRole && op.activeRole.role==\'operator\' || (op.activeRole.id==null || op.activeIsRole && op.activeRole.store_id!=null && op.activeRole.store_id>0) && (op.user.type==\'admin\' || op.user.type==\'manager\' || op.user.type==\'operator\' || op.user.type==\'storemngr\')\">Operatrice</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"(op.activeRole.role==\'operator\' || op.activeRole.role==\'storemngr\' || op.activeRole.role==\'assist\')\"><label for=\"store_id\">Store</label><md-select ng-model=\"op.activeRole.store_id\" ng-disabled=\"op.activeRole.id!=null\" aria-label=\"Store\" id=\"store_id\" name=\"store_id\" ng-change=\"op.setStoreInActiveEntity()\" required=\"\"><md-option ng-value=\"store.id\" ng-repeat=\"store in op.storesList track by store.id\">{{ store.city }} - {{ store.address }}</md-option></md-select><div ng-messages=\"operatorForm.store_id.$error\" ng-if=\"operatorForm.store_id.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"60\" ng-if=\"op.activeRole.role==\'callcenter\' || op.activeRole.role==\'operator\' || op.activeRole.role==\'storemngr\'\"><label for=\"color\">Colore</label><div class=\"operator-circle\" style=\"background-color: {{ op.activeRole.color }};\"></div><input colorpicker=\"hex\" colorpicker-position=\"right\" type=\"text\" ng-model=\"op.activeRole.color\"></md-input-container><div layout=\"row\"><md-input-container flex=\"45\" class=\"md-block\" ng-if=\"!op.activeIsRole\"><label for=\"firstname\">Nome</label> <input type=\"text\" name=\"firstname\" id=\"firstname\" ng-model=\"op.activeOperator.firstname\" ng-disabled=\"op.activeOperator.id!=null && !op.activeOperator.firstnameEditable\" md-select-on-focus=\"\" required=\"\"></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"45\" \"40\"=\"\" class=\"md-block\" ng-if=\"!op.activeIsRole\"><label for=\"lastname\">Cognome</label> <input type=\"text\" name=\"lastname\" id=\"lastname\" ng-model=\"op.activeOperator.lastname\" ng-disabled=\"op.activeOperator.id!=null && !op.activeOperator.lastnameEditable\" required=\"\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"45\" ng-autocomplete=\"off\" class=\"md-block\" ng-if=\"!op.activeIsRole\"><label for=\"email\">Email</label> <input autocomplete=\"off\" type=\"email\" name=\"email\" id=\"email\" ng-model=\"op.activeOperator.email\" ng-disabled=\"op.activeOperator.id!=null || op.emailChecking\" ng-blur=\"op.checkEmailExists($event)\" ng-keypress=\"op.onKeyPressEmail($event)\" ng-focus=\"op.onFocusEmail($event)\" required=\"\"><div ng-messages=\"operatorForm.email.$error\" ng-show=\"operatorForm.email.$dirty\"><div ng-message=\"required\">Email obbligatoria</div><div ng-message=\"email\">Email non valida</div><div ng--message=\"alreadyexists\" ng-if=\"op.showEmailError\">Email usata da altro utente: {{op.userExists.lastname}} {{op.userExists.firstname}} <span ng-if=\"op.userExists.store_id!=null && op.userExists.store_id>0 && op.userExists.store\">({{op.userExists.store.data.alias}})</span> <span ng-if=\"op.env.currentTenant==\'Italia\' && op.userExists.tenant\">({{op.userExists.tenant}})</span></div></div></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"45\" class=\"md-block\" ng-if=\"!op.activeIsRole\"><label for=\"email\">Email Personale</label> <input type=\"email\" name=\"email2\" id=\"email2\" ng-model=\"op.activeOperator.email2\" ng-disabled=\"op.user.type!=\'admin\' && op.user.id!=op.activeOperator.id\"><div ng-messages=\"operatorForm.email2.$error\" ng-show=\"operatorForm.email2.$dirty\"><div ng-message=\"email\">Email non valida</div></div></md-input-container></div><div layout=\'row\"\'><md-input-container flex=\"45\" class=\"md-block\" ng-if=\"!op.activeIsRole\"><label for=\"phone\">Telefono</label> <input type=\"text\" name=\"phone\" id=\"phone\" ng-model=\"op.activeOperator.phone\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" required=\"\" ng-if=\"!op.activeIsRole\" ng-disabled=\"op.user.type!=\'admin\' && op.user.id!=op.activeOperator.id\"></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"45\" class=\"md-block\" ng-if=\"!op.activeIsRole && (op.activeOperator.type == \'callcenter\' || op.activeOperator.type == \'admin\' || op.activeOperatorIsNew && (op.activeRole.role == \'admin\' || op.activeRole.role == \'callcenter\'))\"><label for=\"tag_area\">Tag Area</label> <input ng-disabled=\"!op.env.isMaster || op.user.type!=\'admin\' || (op.user.tag_area && op.user.tag_area!=\'INBOUND\')\" type=\"text\" name=\"tag_area\" id=\"tag_area\" ng-model=\"op.activeOperator.tag_area\"></md-input-container><md-input-container flex=\"45\" class=\"md-block\" ng-if=\"!op.activeIsRole && (op.activeOperator.type == \'storemngr\' || op.activeOperator.type == \'operator\' || op.activeOperatorIsNew && (op.activeRole.role == \'operator\' || op.activeRole.role == \'storemngr\'))\"><md-checkbox ng-model=\"op.activeOperator.f_dm\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"op.user.type!=\'admin\'\">District Manager</md-checkbox></md-input-container></div><div layout=\"row\" ng-if=\"!op.activeIsRole && !op.activeOperatorIsNew && (op.user.type==\'admin\' || op.user.id==op.activeOperator.id)\"><md-input-container flex=\"45\" class=\"md-block\"><label for=\"phone\">Password</label> <input type=\"password\" name=\"password\" id=\"password\" ng-model=\"op.activeOperator.password\" ng-required=\"op.activeOperatorIsNew || op.activeOperator.password.length>0\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@$!%*?&;:_])[A-Za-z\\d$@$!%*?&;:_]{9,}/\" autocomplete=\"off\"><div ng-messages=\"operatorForm.password.$error\" ng-show=\"operatorForm.password.$dirty\"><div ng-message=\"pattern\"><span class=\"success\">La password deve essere</span> <span ng-class=\"{\'success\': operatorForm.password.$viewValue.length>8}\"><md-icon ng-if=\"operatorForm.password.$viewValue.length>8\" md-font-icon=\"done\">done</md-icon>di almeno 9 caratteri</span> <span class=\"success\">e deve contenere</span><ul><li ng-class=\"{\'success\': op.containsMaiuscolo(operatorForm.password.$viewValue)}\"><md-icon ng-if=\"op.containsMaiuscolo(operatorForm.password.$viewValue)\" md-font-icon=\"done\">done</md-icon>una lettera maiuscola</li><li ng-class=\"{\'success\': op.containsMinuscolo(operatorForm.password.$viewValue)}\"><md-icon ng-if=\"op.containsMinuscolo(operatorForm.password.$viewValue)\" md-font-icon=\"done\">done</md-icon>una minuscola</li><li ng-class=\"{\'success\': op.containsNumero(operatorForm.password.$viewValue)}\"><md-icon ng-if=\"op.containsNumero(operatorForm.password.$viewValue)\" md-font-icon=\"done\">done</md-icon>un numero</li><li ng-class=\"{\'success\': op.containsSpeciale(operatorForm.password.$viewValue)}\"><md-icon ng-if=\"op.containsSpeciale(operatorForm.password.$viewValue)\" md-font-icon=\"done\">done</md-icon>un carattere speciale tra @$!%*?&;:_</li></ul></div></div></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"45\" class=\"md-block\"><label for=\"phone\">Conferma password</label> <input type=\"password\" name=\"cfpsw\" id=\"cfpsw\" ng-model=\"op.activeOperator.cfPassword\" autocomplete=\"off\"> <span ng-show=\"op.activeOperator.password && op.activeOperator.password!=op.activeOperator.cfPassword\" style=\"color: red;\">Le password non coincidono</span></md-input-container></div><div layout=\"row\" ng-if=\"!op.activeIsRole && op.activeIsCallcenter\"><md-input-container flex=\"45\" class=\"md-block\"><label for=\"categories\">Delega 1</label><md-select ng-model=\"op.activeOperator.delegate1_user_id\" ng-disabled=\"op.user.type!=\'admin\' || !op.env.isMaster\" aria-label=\"Delega 1\" id=\"delegate1_user_id\" name=\"delegate1_user_id\"><md-option ng-value=\"user.id\" ng-repeat=\"user in op.usersListDelegate1\">{{ user.lastname }} {{ user.firstname }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"45\" class=\"md-block\"><label for=\"categories\">Delega 2</label><md-select ng-model=\"op.activeOperator.delegate2_user_id\" ng-disabled=\"op.user.type!=\'admin\' || !op.env.isMaster\" aria-label=\"Delega 2\" id=\"delegate2_user_id\" name=\"delegate2_user_id\"><md-option ng-value=\"user.id\" ng-repeat=\"user in op.usersListDelegate2\">{{ user.lastname }} {{ user.firstname }}</md-option></md-select></md-input-container></div><div layout=\"row\" ng-if=\"!op.activeIsRole || op.activeOperatorIsNew\"><md-input-container flex=\"45\" class=\"md-block\"><label for=\"telegram_user\">Username Telegram</label> <input ng-disabled=\"op.user.type!=\'admin\' && op.user.id!=op.activeOperator.id\" type=\"text\" name=\"telegram_user\" id=\"telegram_user\" ng-model=\"op.activeOperator.telegram_user\" autocomplete=\"off\"></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"45\" class=\"md-block\"><label for=\"telegram_chat_id\">Chat ID Telegram</label> <input ng-disabled=\"op.user.type!=\'admin\'\" type=\"text\" name=\"telegram_chat_id\" id=\"telegram_chat_id\" ng-model=\"op.activeOperator.telegram_chat_id\" autocomplete=\"off\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"45\" class=\"md-block\" ng-if=\"!op.activeIsRole || op.activeOperatorIsNew\"><label for=\"matr_fada\">Matricola dipendente</label> <input ng-disabled=\"op.user.type!=\'admin\'\" type=\"text\" name=\"matr_fada\" id=\"matr_fada\" ng-model=\"op.activeOperator.matr_fada\"></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"45\" class=\"md-block\" ng-if=\"!op.activeIsRole || op.activeOperatorIsNew\"><label for=\"designation_type_id\">Inqudramento</label><md-select aria-label=\"Inquadramento\" placeholder=\"Inquadramento\" name=\"designation_type_id\" ng-model=\"op.activeOperator.designation_type_id\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"6\">CoCoCo</md-option><md-option ng-value=\"7\">Partita Iva</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"45\" class=\"md-block\" ng-if=\"!op.activeIsRole || op.activeOperatorIsNew\"><label for=\"email\">Interno 3CX</label> <input type=\"text\" name=\"_3cx_extension\" id=\"_3cx_extension\" ng-model=\"op.activeOperator._3cx_extension\"></md-input-container></div><div layout=\"row\" ng-if=\"op.env.isMaster && !op.activeIsRole && op.activeOperator.type == \'callcenter\'\"><md-button class=\"md-accent md-raised\" aria-label=\"Tutte\" ng-click=\"op.extlistAll(true)\" ng-disabled=\"(op.loading || op.saving) || op.user.type!=\'admin\'\">Tutte</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Nessuna\" ng-click=\"op.extlistAll(false)\" ng-disabled=\"(op.loading || op.saving)|| op.user.type!=\'admin\'\">Nessuna</md-button></div><div layout=\"row\" ng-if=\"op.env.isMaster && !op.activeIsRole && op.activeOperator.type == \'callcenter\'\" ng-repeat=\"extlist in op.extlistData\"><md-input-container flex=\"90\" class=\"md-block\" style=\"margin: 5px;\"><md-checkbox ng-model=\"op.activeOperator[extlist.field_enable]\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"op.user.type!=\'admin\'\">Abilita {{extlist.name}}</md-checkbox></md-input-container><span flex=\"\" hide-xs=\"\"></span></div><div layout=\"row\" ng-if=\"false && op.env.isMaster && !op.activeIsRole && op.activeOperator.type == \'callcenter\'\"><md-button class=\"md-accent md-raised\" aria-label=\"Tutte\" ng-click=\"op.categoryAll(true)\" ng-disabled=\"op.loading || op.saving\">Tutte</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Nessuna\" ng-click=\"op.categoryAll(false)\" ng-disabled=\"op.loading || op.saving\">Nessuna</md-button></div><div layout=\"row\" ng-if=\"false && op.env.isMaster && !op.activeIsRole && op.activeOperator.type == \'callcenter\'\"><md-input-container flex=\"100\" class=\"md-block\"><label for=\"categories\">Campagne lead abilitate:</label><md-select ng-model=\"op.activeOperator.categories\" aria-label=\"Categorie Lead Abilitate\" id=\"categories\" name=\"categories\" multiple=\"true\"><md-option ng-value=\"cat.category\" ng-repeat=\"cat in op.categories\">{{ cat.category }}</md-option></md-select></md-input-container></div><div layout=\"row\" ng-if=\"false && op.env.isMaster && !op.activeIsRole && op.activeOperator.type == \'callcenter\'\"><md-input-container flex=\"30\" class=\"md-block\"><md-checkbox ng-model=\"op.activeOperator.f_lead_new_a\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"op.activeOperator.id!=null && op.user.type!=\'admin\'\">Riceve \"Nuovi [A]\"</md-checkbox></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"30\" class=\"md-block\"><md-checkbox ng-model=\"op.activeOperator.f_lead_new_b\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"op.activeOperator.id!=null && op.user.type!=\'admin\'\">Riceve \"Nuovi [B]\"</md-checkbox></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"30\" class=\"md-block\"><md-checkbox ng-model=\"op.activeOperator.f_lead_rientri\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"op.activeOperator.id!=null && op.user.type!=\'admin\'\">Riceve \"Rientri\"</md-checkbox></md-input-container></div><div layout=\"row\" ng-if=\"false && op.env.isMaster && !op.activeIsRole && op.activeOperator.type == \'callcenter\'\"><md-input-container flex=\"45\" class=\"md-block\"><label for=\"time_perc\">% su lead offline</label> <input type=\"number\" min=\"0\" step=\"5\" name=\"time_perc\" id=\"time_perc\" ng-model=\"op.activeOperator.time_perc\" ng-disabled=\"op.activeOperator.id!=null && op.user.type!=\'admin\'\"></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"45\" class=\"md-block\"><md-checkbox ng-model=\"op.activeOperator.f_lead_online\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"op.activeOperator.id!=null && op.user.type!=\'admin\'\">Riceve lead online</md-checkbox></md-input-container></div><span ng-show=\"op.activeOperatorIsNew\">La password verr&agrave; generata automaticamente e inviata via sms a {{op.activeOperator.firstname}}, al numero {{op.activeOperator.phone}}.</span><md-input-container class=\"md-block\" ng-if=\"!op.activeIsRole && (op.activeRole.role==\'operator\' || op.activeRole.role==\'storemngr\')\"><label for=\"description\">Descrizione</label> <textarea name=\"description\" id=\"description\" rows=\"3\" ng-model=\"op.activeOperator.description\"></textarea></md-input-container><div ng-if=\"operatorForm.$dirty && !operatorForm.$invalid\" layout=\"row\" layout-sm=\"column\"><md-progress-circular ng-if=\"op.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"op.update()\" ng-disabled=\"op.emailCheching || op.saving || (op.activeOperator.password && op.activeOperator.password!=op.activeOperator.cfPassword) || op.user.type!=\'admin\' && op.user.id!=op.activeOperator.id\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"op.undo()\" ng-disabled=\"op.loading || op.saving\">Annulla</md-button></div></form></md-content></md-sidenav>");
$templateCache.put("app/orderdetails/orderdetails.html","<md-content class=\"page-orderdetails\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Dettaglio ordine</span></h2><span flex=\"\" hide-xs=\"\"></span><div layout=\"row\" ng-if=\"!ab.loading && (ab.mainEntity.status==\'bozza\' || ab.mainEntity.status==\'chiuso\')\"><span ng-class=\"{\'violato\': ab.mainEntity.supplier.order_total_min>ab.eListTotal}\">Min: {{ab.mainEntity.supplier.order_total_min | number:0}} &euro;</span> / <span ng-class=\"{\'violato\': ab.storeBudget<ab.eListTotal}\">Max: {{ab.storeBudget | number:0}} &euro;</span></div><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Elenco ordini\" ui-sref=\"home.orders()\"><md-icon md-font-icon=\"list\">list</md-icon><span>Elenco ordini</span></md-button><md-button class=\"md-accent md-raised\" aria-label=\"Modifica\" ng-click=\"ab.edit()\" ng-if=\"ab.mainEntity.canUpdate && ab.mainEntity.closed\"><md-icon md-font-icon=\"done\">done</md-icon><span>Modifica</span></md-button><md-button class=\"md-accent md-raised\" aria-label=\"Chiudi\" ng-click=\"ab.close()\" ng-if=\"!ab.loading && ab.mainEntity.status!=\'bozza\' && !ab.mainEntity.closed\" ng-disabled=\"ab.mainEntity.status!=\'evaso\' && (ab.mainEntity.supplier.order_total_min>ab.eListTotal || ab.storeBudget<ab.eListTotal)\"><md-icon md-font-icon=\"done\">done</md-icon><span>Chiudi</span></md-button><md-button class=\"md-accent md-raised\" aria-label=\"Chiudi ordine\" ng-click=\"ab.chiudiOrdine()\" ng-if=\"ab.mainEntity.status==\'bozza\' && ab.perm.canFire(\'orders.chiudi\', ab.mainEntity)\" ng-disabled=\"ab.mainEntity.supplier.order_total_min>ab.eListTotal || ab.storeBudget<ab.eListTotal\"><md-icon md-font-icon=\"done\">done</md-icon><span>Chiudi ordine</span></md-button><md-button class=\"md-accent md-raised\" aria-label=\"Invia\" ng-if=\"ab.perm.canFire(\'orders.evadi\', ab.mainEntity)\" ng-click=\"ab.evadiOrdine()\" ng-disabled=\"ab.mainEntity.supplier.order_total_min>ab.eListTotal || ab.storeBudget<ab.eListTotal\"><md-icon md-font-icon=\"done\">done</md-icon><span>Invia</span></md-button><md-button class=\"md-accent md-raised\" aria-label=\"Consegnato\" ng-if=\"ab.perm.canFire(\'orders.consegnato\', ab.mainEntity)\" ng-click=\"ab.consegnatoOrdine()\"><md-icon md-font-icon=\"done\">done</md-icon><span>Consegnato</span></md-button></div></md-toolbar><md-card><md-card-content layout=\"column\"><md-table-container flex=\"30\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" style=\"border: none;\">Ordine n.<md-input-container style=\"margin: 0px; width: 60px;\"><input aria-label=\"Id\" ng-value=\"ab.mainEntity.id\" ng-disabled=\"true\"></md-input-container>del<md-input-container style=\"margin: 0px;\"><md-datepicker aria-label=\"Data\" md-placeholder=\"Data\" name=\"data\" id=\"data\" ng-model=\"ab.mainEntity.date\" disabled=\"true\"></md-datepicker></md-input-container></th><th md-column=\"\" style=\"border: none;\">Stato<md-input-container style=\"margin: 0px;\" ng-if=\"ab.mainEntity.status==\'evaso\'\"><input aria-label=\"Stato\" ng-value=\"\'inviato\'\" ng-disabled=\"true\"></md-input-container><span ng-if=\"ab.mainEntity.status==\'evaso\'\">Il</span><md-input-container style=\"margin: 0px;\"><md-datepicker ng-if=\"ab.mainEntity.status==\'evaso\'\" aria-label=\"Il\" md-placeholder=\"Il\" name=\"dataIl\" id=\"dataIl\" ng-model=\"ab.mainEntity.sent_at\" disabled=\"true\"></md-datepicker></md-input-container><md-input-container style=\"margin: 0px;\" ng-if=\"ab.mainEntity.status!=\'evaso\'\"><input aria-label=\"Stato\" ng-value=\"ab.mainEntity.status\" ng-disabled=\"true\"></md-input-container></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" style=\"border: none;\"><md-input-container class=\"md-block\" style=\"margin: 0px;\"><label>Fornitore</label> <input ng-value=\"ab.mainEntity.supplier.name\" ng-disabled=\"true\"></md-input-container></td><td md-cell=\"\" style=\"border: none;\"><md-input-container class=\"md-block\" style=\"margin: 0px;\"><label>Store</label> <input ng-value=\"ab.mainEntity.store.city + \' - \' + ab.mainEntity.store.address\" ng-disabled=\"true\"></md-input-container></td></tr><tr><td md-cell=\"\" style=\"border: none;\" colspan=\"2\"><md-input-container class=\"md-block\" style=\"margin: 0px;\"><label>Note</label> <textarea maxlength=\"255\" ng-disabled=\"true\" ng-model=\"ab.mainEntity.description\">{{ab.mainEntity.description}}</textarea></md-input-container></td></tr></tbody></table></md-table-container><span flex=\"\" hide-xs=\"\"></span><md-table-container flex=\"70\"><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"id\"><span>Id</span></th><th md-column=\"\" md-order-by=\"name\"><span>Prodotti</span></th><th md-column=\"\"><span>Confezione</span></th><th md-column=\"\"><span>Lotto</span></th><th md-column=\"\" md-numeric=\"\"><span>Qta</span></th><th md-column=\"\" md-numeric=\"\"><span>Prezzo &euro;</span></th><th md-column=\"\" md-numeric=\"\"><span>Importo &euro;</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading || ab.productsLoading\"><td md-cell=\"\" colspan=\"7\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading || ab.productsLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" style=\"background-color: #D9D9D9;\"><td md-cell=\"\" colspan=\"1\"></td><td colspan=\"1\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" placeholder=\"Cerca\"></td><td md-cell=\"\" colspan=\"3\" style=\"text-align: right\">Totale prodotti &euro;:</td><td md-cell=\"\" colspan=\"1\"></td><td md-cell=\"\" colspan=\"1\" style=\"text-align: right\">{{ ab.eListTotal | number:2 }}</td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" ng-repeat=\"e in (ab.filteredItems = (ab.productsList | filter: ab.gtQueryQty | filter: { $: ab.query.filter } | orderBy: ab.query.order ) ) track by e.id\"><td md-cell=\"\">{{ e.id }}</td><td md-cell=\"\">{{ e.name }}</td><td md-cell=\"\">{{ e.conf }}</td><td md-cell=\"\" style=\"text-align: right\">{{ e.qta_xct }}</td><td md-cell=\"\"><md-input-container style=\"margin-left: 20px; padding-bottom: 0px; margin-bottom: 0px; width: 60px;\"><input aria-label=\"Qta\" style=\"text-align: right;\" type=\"number\" name=\"total\" id=\"total\" step=\"{{e.qta_xct}}\" min=\"0\" ng-model=\"e.prodInv.qty\" ng-blur=\"ab.saveProdInv(e.prodInv, e.qta_xct)\" ng-disabled=\"e.prodInv.saving || ab.loading || ab.productsLoading || ab.mainEntity.closed\" required=\"\"></md-input-container></td><td md-cell=\"\" style=\"text-align: right\">{{ e.prodInv.price | number:2 }}</td><td md-cell=\"\" style=\"text-align: right\">{{ e.prodInv.price*e.prodInv.qty | number:2 }}</td></tr><tr md-row=\"\"><td md-cell=\"\" colspan=\"5\" style=\"text-align: right\">Totale prodotti &euro;:</td><td md-cell=\"\" colspan=\"1\"></td><td md-cell=\"\" colspan=\"1\" style=\"text-align: right\">{{ ab.eListTotal | number:2 }}</td></tr><tr md-row=\"\"><td md-cell=\"\" colspan=\"5\" style=\"text-align: right\">Iva:</td><td md-cell=\"\" colspan=\"1\" style=\"text-align: right\">{{ab.mainEntity.vat}}%</td><td md-cell=\"\" colspan=\"1\" style=\"text-align: right\">{{ (ab.eListTotal*ab.mainEntity.vat/100) | number:2 }}</td></tr><tr md-row=\"\"><td md-cell=\"\" colspan=\"5\" style=\"text-align: right\">Spese spedizione &euro;:</td><td md-cell=\"\" colspan=\"1\"></td><td md-cell=\"\" colspan=\"1\" style=\"text-align: right\">{{ ab.mainEntity.delivery_cost | number:2 }}</td></tr><tr md-row=\"\" style=\"background-color: #D9D9D9;\"><td md-cell=\"\" colspan=\"5\" style=\"text-align: right\">Totale &euro;:</td><td md-cell=\"\" colspan=\"1\"></td><td md-cell=\"\" colspan=\"1\" style=\"text-align: right\">{{ (ab.eListTotal + ab.eListTotal*ab.mainEntity.vat/100 + ab.mainEntity.delivery_cost) | number:2 }}</td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content>");
$templateCache.put("app/orders/orders.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Ordini</span></h2><span flex=\"\" hide-xs=\"\"></span><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" placeholder=\"Cerca\"> <span flex=\"\" hide-xs=\"\"></span><div><md-input-container><md-select aria-label=\"Mese\" placeholder=\"Mese\" ng-model=\"ab.query.month\" ng-change=\"ab.eListLoad()\"><md-option value=\"01\">Gennaio</md-option><md-option value=\"02\">Febbraio</md-option><md-option value=\"03\">Marzo</md-option><md-option value=\"04\">Aprile</md-option><md-option value=\"05\">Maggio</md-option><md-option value=\"06\">Giugno</md-option><md-option value=\"07\">Luglio</md-option><md-option value=\"08\">Agosto</md-option><md-option value=\"09\">Settembre</md-option><md-option value=\"10\">Ottobre</md-option><md-option value=\"11\">Novembre</md-option><md-option value=\"12\">Dicembre</md-option></md-select></md-input-container></div><div><md-input-container><md-select aria-label=\"Anno\" placeholder=\"Anno\" ng-model=\"ab.query.year\" ng-change=\"ab.eListLoad()\"><md-option ng-value=\"year\" ng-repeat=\"year in ab.years\">{{ year }}</md-option></md-select></md-input-container></div><span flex=\"\" hide-xs=\"\"></span><div><md-input-container><md-select aria-label=\"Stato\" placeholder=\"Stato\" ng-model=\"ab.query.status\"><md-option value=\"\">tutti</md-option><md-option value=\"bozza\">bozza</md-option><md-option value=\"chiuso\">chiuso</md-option><md-option value=\"evaso\">inviato</md-option><md-option value=\"consegnato\">consegnato</md-option></md-select></md-input-container></div><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo ordine\" ng-disabled=\"ab.loading || ab.causaliLoading || !ab.storeId || !ab.perm.canCreate(\'orders\')\" ng-click=\"ab.toggleRight()\"><md-icon md-font-icon=\"shopping_basket\">shopping_basket</md-icon>Nuovo ordine</md-button></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\"><span>Id</span></th><th md-column=\"\" md-order-by=\"store_id\"><span>Centro</span></th><th md-column=\"\" md-order-by=\"date\"><span>Data</span></th><th md-column=\"\"><span>Fornitore</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"total\"><span>Importo &euro;</span></th><th md-column=\"\" md-numeric=\"\"><span>Iva %</span></th><th md-column=\"\" md-numeric=\"\"><span>Sped. &euro;</span></th><th md-column=\"\" md-numeric=\"\"><span>Totale &euro;</span></th><th md-column=\"\" md-numeric=\"\"><span>Stato</span></th><th md-column=\"\" md-numeric=\"\"><span>Inviato il</span></th><th md-column=\"\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"6\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in (ab.filteredItems = (ab.eList | filter: { status: ab.query.status } | filter: { $: ab.query.filter } | orderBy: ab.query.order )) track by e.id\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.id }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.store.data.alias }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.date_formatted }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.supplier.name }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.total ? e.total:0 | number : 2 }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.vat ? e.vat:0 | number : 0 }}%</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.delivery_cost ? e.delivery_cost:0 | number : 2 }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ (e.total + e.total * e.vat / 100 + e.delivery_cost) | number : 2 }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.status == \'evaso\'?\'inviato\':e.status }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.sent_at_frmt }}</td><td md-cell=\"\" class=\"icon-button\"><md-button class=\"md-icon-button md-warn\" ng-click=\"ab.del( e.id )\" aria-label=\"Cancella\" ng-if=\"ab.perm.canDelete(\'orders\', e)\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr><tr md-row=\"\" style=\"background-color: #D9D9D9;\"><td md-cell=\"\" style=\"text-align: right\" colspan=\"3\"><strong>Budget trim. {{!ab.storeId?\' (\'+ab.storesList.length+\' centri)\':\'\'}} &euro;:</strong> {{ ab.storeBudget | number:0 }}</td><td md-cell=\"\" style=\"text-align: right\"><strong>Totale &euro;:</strong></td><td md-cell=\"\" style=\"text-align: right\">{{ ab.eListTotal | number:2 }}</td><td md-cell=\"\" style=\"text-align: right\">{{ ab.eListTotalVat | number:2 }}</td><td md-cell=\"\" style=\"text-align: right\">{{ ab.eListTotalDel | number:2 }}</td><td md-cell=\"\" style=\"text-align: right\">{{ ab.eListTotalTot | number:2 }}</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"shopping_basket\">shopping_basket</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"ab.activeEntity.id==null\">Nuovo ordine</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"entityForm\" id=\"entityForm\" layout=\"column\"><div flex=\"100\" layout=\"column\" class=\"fix-margins-3 min-height-60\"><label class=\"md-label\" for=\"date\">Data</label><md-datepicker class=\"md-datepicker-full-width md-datepicker-remove-red-border\" id=\"date\" name=\"date\" md-placeholder=\"Data\" ng-model=\"ab.activeEntity.date\" required=\"\" ng-disabled=\"true\"></md-datepicker></div><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"causal_id\">Fornitore</label><md-select ng-model=\"ab.activeEntity.supplier_id\" aria-label=\"Fornitore\" id=\"supplier_id\" name=\"supplier_id\" required=\"\"><md-option ng-value=\"supplier.id\" ng-repeat=\"supplier in ab.causaliList track by supplier.id\">{{ supplier.name }}</md-option></md-select><div ng-messages=\"entityForm.supplier_id.$error\" ng-if=\"entityForm.supplier_id.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><br></div><div><md-input-container class=\"md-block\"><label for=\"description\">Note</label> <textarea maxlength=\"255\" name=\"description\" id=\"description\" rows=\"3\" ng-model=\"ab.activeEntity.description\" md-select-on-focus=\"\"></textarea></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Crea\" ng-click=\"ab.save( ab.activeEntity )\" ng-disabled=\"entityForm.$invalid\" ng-show=\"entityForm.$dirty\"><md-icon md-font-icon=\"check\">check</md-icon>Crea ordine</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/products/products.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Prodotti</span></h2><span flex=\"\" hide-xs=\"\"></span><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" type=\"search\" placeholder=\"Cerca\"> <span flex=\"\" hide-xs=\"\"></span><div><md-input-container><md-select aria-label=\"Fornitore\" placeholder=\"Fornitore\" ng-model=\"ab.query.supplierName\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"supplier.name\" ng-repeat=\"supplier in ab.causaliList\">{{ supplier.name }}</md-option></md-select></md-input-container></div><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo prodotto\" ng-disabled=\"ab.loading || ab.causaliLoading\" ng-click=\"ab.toggleRight()\" ng-if=\"ab.env.isMaster && (ab.user.type==\'admin\' || ab.user.type==\'backoffice\')\"><md-icon md-font-icon=\"view_list\">view_list</md-icon>Nuovo prodotto</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo prodotto\" ng-disabled=\"ab.loading || ab.causaliLoading\" ng-click=\"ab.overrideFromMaster()\" ng-if=\"ab.env.isMaster && ab.env.currentTenant == \'Italia\' && (ab.user.type==\'admin\' || ab.user.type==\'backoffice\')\"><md-icon md-font-icon=\"send\">send</md-icon>Copia su altre aree</md-button></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"id\"><span>Id</span></th><th md-column=\"\" md-order-by=\"code\"><span>Cod.</span></th><th md-column=\"\" md-order-by=\"supplier.name\"><span>Fornitore</span></th><th md-column=\"\" md-order-by=\"category\"><span>Categoria</span></th><th md-column=\"\" md-order-by=\"active\"><span></span></th><th md-column=\"\" md-order-by=\"name\"><span>Nome</span></th><th md-column=\"\"><span>Confezione</span></th><th md-column=\"\" md-numeric=\"\"><span>Qta min.</span></th><th md-column=\"\" md-numeric=\"\"><span>Prz. acq. &euro;</span></th><th md-column=\"\" md-numeric=\"\"><span>Prz. vend.&euro;</span></th><th md-column=\"\" ng-if=\"ab.env.isMaster && (ab.user.type == \'backoffice\' || ab.user.type == \'admin\')\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"9\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular></td><td md-cell=\"\" ng-if=\"ab.user.type == \'backoffice\' || ab.user.type == \'admin\'\"></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in (ab.filteredItems = (ab.eList | filter: { supplier: {name: ab.query.supplierName }} | filter: { $: ab.query.filter } | orderBy: ab.query.order )) track by e.id\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.id }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.code }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.supplier.name }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.category }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><md-icon ng-if=\"!e.active\" md-font-icon=\"visibility_off\">visibility_off</md-icon></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.name }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.conf }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.qta_xct }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.price | number : 2}}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.price_pub | number : 2}}</td><td md-cell=\"\" class=\"icon-button\" ng-if=\"ab.env.isMaster && (ab.user.type == \'backoffice\' || ab.user.type == \'admin\')\"><md-button class=\"md-icon-button md-warn\" ng-click=\"ab.del( e.id )\" aria-label=\"Cancella\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"view_list\">view_list</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"ab.activeEntity.id!=null\">Modifica prodotto</span> <span class=\"inset\" ng-if=\"ab.activeEntity.id==null\">Nuovo prodotto</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"entityForm\" id=\"entityForm\" layout=\"column\"><div layout=\"row\"><div flex=\"20\"><md-input-container class=\"md-block\"><label class=\"md-label\" for=\"code\">Cod.</label> <input id=\"code\" name=\"code\" md-placeholder=\"Codice\" ng-model=\"ab.activeEntity.code\"></md-input-container></div><div flex=\"40\"><md-input-container class=\"md-block\"><label for=\"causal_id\">Fornitore</label><md-select ng-model=\"ab.activeEntity.supplier_id\" aria-label=\"Fornitore\" id=\"supplier_id\" name=\"supplier_id\" ng-disabled=\"ab.activeEntity.id!=null\" required=\"\"><md-option ng-value=\"supplier.id\" ng-repeat=\"supplier in ab.causaliList track by supplier.id\">{{ supplier.name }}</md-option></md-select><div ng-messages=\"entityForm.causal_id.$error\" ng-if=\"entityForm.causal_id.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container></div><div flex=\"40\"><md-input-container class=\"md-block\"><label class=\"md-label\" for=\"name\">Categoria</label> <input id=\"category\" name=\"category\" md-placeholder=\"Categoria\" ng-model=\"ab.activeEntity.category\"></md-input-container></div></div><div flex=\"100\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"70\"><label class=\"md-label\" for=\"name\">Nome</label> <input id=\"name\" name=\"name\" md-placeholder=\"Nome\" ng-model=\"ab.activeEntity.name\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><md-checkbox id=\"active\" name=\"active\" aria-label=\"Ordinabile\" ng-model=\"ab.activeEntity.active\">Ordinabile</md-checkbox></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"20\"><label for=\"qta_xct\">Qta xct</label> <input type=\"integer\" name=\"qta_xct\" id=\"qta_xct\" step=\"1\" min=\"1\" ng-model=\"ab.activeEntity.qta_xct\"></md-input-container><md-input-container class=\"md-block\" flex=\"40\"><label for=\"price\">Prezzo acq. (in &euro;)</label> <input type=\"number\" name=\"price\" id=\"price\" step=\"0.01\" min=\"0\" ng-model=\"ab.activeEntity.price\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"40\"><label for=\"price\">Prezzo vend. (in &euro;)</label> <input type=\"number\" name=\"price_pub\" id=\"price_pub\" step=\"0.01\" min=\"0\" ng-model=\"ab.activeEntity.price_pub\"></md-input-container></div><div><md-input-container class=\"md-block\"><label for=\"conf\">Confezione</label> <input name=\"conf\" id=\"conf\" ng-model=\"ab.activeEntity.conf\"></md-input-container></div><div><md-input-container class=\"md-block\"><label for=\"barcode\">Barcode</label> <input name=\"barcode\" id=\"barcode\" ng-model=\"ab.activeEntity.barcode\"></md-input-container></div><div flex=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ab.save( ab.activeEntity )\" ng-disabled=\"entityForm.$invalid || ab.saving\" ng-show=\"entityForm.$dirty\"><md-icon md-font-icon=\"check\">check</md-icon>{{ ab.activeEntity.id == null ? \'Salva\' : \'Aggiorna\' }}</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\" ng-disabled=\"ab.saving\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/referrals/referrals.html","<md-backdrop ng-click=\"ab.closeSidebar()\" ng-show=\"ab.undoVisible && ! ab.isNewCustomer\" class=\"md-sidenav-backdrop md-opaque\"></md-backdrop><md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"group_add\">group_add</md-icon><span class=\"inset\">Referrals</span></h2><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar><mb-referral-list user=\"ab.user\" token=\"ab.token\"></mb-referral-list></md-content><md-sidenav md-is-locked-open=\"ab.undoVisible && ! ab.isNewCustomer\" md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"account_circle\">account_circle</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"ab.activeCustomer.id\">{{ ab.activeCustomer.firstname }} {{ ab.activeCustomer.lastname }} (cid: {{ab.activeCustomer.id}})</span> <span class=\"inset\" ng-if=\"! ab.activeCustomer.id\">Aggiunta nuovo Cliente</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"customerForm\" id=\"customerForm\" layout=\"row\" layout-wrap=\"\"><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"firstname\">Nome *</label> <input type=\"text\" id=\"firstname\" name=\"firstname\" ng-model=\"ab.activeCustomer.firstname\" required=\"\" ng-model-options=\"ab.filter.options\" md-autofocus=\"\"><div ng-messages=\"customerForm.firstname.$error\" ng-show=\"customerForm.firstname.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"lastname\">Cognome *</label> <input type=\"text\" id=\"lastname\" name=\"lastname\" ng-model=\"ab.activeCustomer.lastname\" required=\"\" ng-model-options=\"ab.filter.options\"><div ng-messages=\"customerForm.lastname.$error\" ng-show=\"customerForm.lastname.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-input-container flex=\"50\" ng-if=\"!ab.isNewCustomer\" style=\"margin-top: 0px;\"><md-checkbox ng-model=\"ab.activeCustomer.off\" ng-true-value=\"1\" ng-false-value=\"0\">Da non contattare</md-checkbox></md-input-container><md-input-container flex=\"50\" ng-if=\"!ab.isNewCustomer\" style=\"margin-top: 0px;\"><md-checkbox ng-model=\"ab.activeCustomer.f_prospect\" ng-true-value=\"1\" ng-false-value=\"0\">Prospect</md-checkbox></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"phone\">Telefono *</label> <input type=\"text\" id=\"phone\" name=\"phone\" required=\"\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-model=\"ab.activeCustomer.phone\" ng-blur=\"ab.checkPhoneExists()\" ng-model-options=\"ab.filter.options\" ng-disabled=\"ab.phoneChecking\"><div ng-messages=\"customerForm.phone.$error\" ng-show=\"customerForm.phone.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div><div ng-message=\"pattern\"><small>Inserisci un numero di cellulare valido.</small><br>Inserisci il tuo numero di cellulare (9 o 10 cifre) senza spazi ne altri caratteri.</div><div ng-message=\"alreadyexists\">Numero di cellulare usato da altro cliente: {{ab.customerExists.lastname}} {{ab.customerExists.firstname}}<md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Rubrica\" ui-sref=\"home.addressbook({ phone : ab.customerExists.phone })\"><md-icon md-font-icon=\"person\">person</md-icon></md-button></div></div></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"email\">Email</label> <input type=\"email\" id=\"email\" name=\"email\" ng-model=\"ab.activeCustomer.email\" ng-model-options=\"ab.filter.options\"></md-input-container><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\"><label for=\"birthdate\">Data di Nascita {{ab.activeCustomer.isCardRequest || ab.activeCustomer.isCardDelivery?\'*\':\'\'}}</label><md-datepicker id=\"birthdate\" name=\"birthdate\" ng-required=\"(ab.activeCustomer.isCardRequest || ab.activeCustomer.isCardDelivery) ?true:false\" ng-model=\"ab.activeCustomer.birthdate\" md-placeholder=\"Data di nascita\" ng-class=\"{ \'modify\' : ab.isNewCustomer }\"></md-datepicker></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\"><br hide-gt-sm=\"\"><br hide-gt-sm=\"\"><label for=\"gender\" style=\"margin-bottom: 8px;\">Sesso *</label><md-radio-group id=\"gender\" name=\"gender\" ng-model=\"ab.activeCustomer.gender\" ng-required=\"true\" required=\"\"><md-radio-button value=\"F\">Femmina</md-radio-button><md-radio-button value=\"M\" class=\"md-primary\">Maschio</md-radio-button></md-radio-group></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"address\">Indirizzo</label> <input type=\"text\" id=\"address\" name=\"address\" ng-model=\"ab.activeCustomer.address\" ng-model-options=\"ab.filter.options\"></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"city\">Città</label> <input type=\"text\" id=\"city\" name=\"city\" ng-model=\"ab.activeCustomer.city\" ng-model-options=\"ab.filter.options\"></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"zip_code\">CAP</label> <input type=\"number\" id=\"zip_code\" name=\"zip_code\" max=\"99999\" ng-max=\"99999\" ng-model=\"ab.activeCustomer.zip_code\" ng-model-options=\"ab.filter.options\"><div ng-messages=\"customerForm.zip_code.$error\" ng-hide=\"customerForm.zip_code.$valid\"><div ng-message=\"max\">Massima lunghezza 5 caratteri</div></div></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"province\">Provincia</label><md-select id=\"province\" name=\"province\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"province\" ng-model=\"ab.activeCustomer.province\" ng-model-options=\"ab.filter.options\"><md-option ng-value=\"null\">Nessuna provincia</md-option><md-optgroup label=\"{{ regione }}\" ng-repeat=\"( regione, province ) in ::ab.Italia track by regione\"><md-option ng-value=\"provincia.sigla\" ng-repeat=\"provincia in ::province track by provincia.sigla | orderBy: provincia.sigla\">{{ provincia.nome }}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"!ab.activeCustomer.id || ab.activeCustomer.src_cid\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"availability\">Invitato da</label><md-select aria-label=\"Invitato da\" id=\"src_cid\" name=\"scr_cid\" ng-model=\"ab.activeRelCustomer\" ng-change=\"ab.activeRelCustomerChange()\" ng-disabled=\"ab.relCustomersLoading || ab.activeCustomer.id\" md-container-class=\"with-search\"><md-select-header><span class=\"md-select-search-container\"><input type=\"{{ ab.relCustomersLoading? \'hidden\' : \'search\' }}\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_relcustomer\" name=\"filter_relcustomer\" ng-click=\"$event.stopPropagation()\" ng-keydown=\"$event.stopPropagation()\" ng-keyup=\"ab.onKeyUpRelCustomersSearch($event, this)\" ng-model=\"ab.filter_relcustomer\"></span></md-select-header><md-option ng-value=\"undefined\">Nessuno</md-option><md-option ng-value=\"customer\" ng-repeat=\"customer in ab.relCustomersList | orderBy: fullName track by customer.id\">{{ customer.fullName }} (Cell: {{ customer.phone }})</md-option></md-select></md-input-container><md-progress-circular md-diameter=\"30\" ng-if=\"ab.relCustomersLoading\" md-mode=\"indeterminate\"></md-progress-circular></div><div flex=\"100\" ng-if=\"!ab.isNewCustomer\" layout=\"row\" style=\"margin-bottom: 15px;\"><div flex=\"50\" style=\"margin-top: 27px;\"><md-checkbox ng-model=\"ab.activeCustomer.f_guarantee\" ng-disabled=\"ab.guaranteeDisabled\" ng-true-value=\"1\" ng-false-value=\"0\">Garanzia</md-checkbox></div><div layout=\"column\"><label for=\"guarantee_at\">Data rilascio garanzia</label><md-datepicker id=\"guarantee_at\" ng-disabled=\"ab.guaranteeDisabled\" name=\"guarantee_at\" ng-model=\"ab.activeCustomer.guarantee_at\" md-placeholder=\"Data rilascio garanzia\"></md-datepicker></div></div><div flex=\"100\"><span ng-if=\"ab.activeCustomer.card!=null && !ab.activeCustomer.card.data.delivered\">Data richiesta card: {{ ab.activeCustomer.card.data.created_at_frmt }}</span> <span ng-if=\"ab.activeCustomer.card!=null && ab.activeCustomer.card.data.delivered\">Data consegna card: {{ ab.activeCustomer.card.data.delivered_at_frmt }}</span><md-input-container class=\"md-block\" ng-if=\"(ab.activeCustomer.card!=null && ab.activeCustomer.card.data.delivered)\"><label for=\"credit\">Saldo punti</label> <input type=\"text\" id=\"credit\" name=\"credit\" ng-model=\"ab.activeCustomer.credit\" ng-model-options=\"ab.filter.options\" ng-disabled=\"true\"></md-input-container><md-checkbox ng-if=\"ab.activeCustomer.isCardRequest || ab.activeCustomer.card==null\" ng-model=\"ab.activeCustomer.isCardRequest\" ng-disabled=\"ab.activeCustomer.off\">Emissione Card</md-checkbox><md-checkbox ng-if=\"ab.activeCustomer.isCardRequest || (ab.activeCustomer.card!=null && !ab.activeCustomer.card.data.delivered)\" ng-model=\"ab.activeCustomer.isCardDelivery\" ng-disabled=\"ab.activeCustomer.off\">Consegna Card</md-checkbox></div><div flex=\"100\"><md-input-container class=\"md-block\"><label for=\"note\">Note</label> <textarea rows=\"2\" id=\"note\" name=\"note\" ng-model=\"ab.activeCustomer.note\" ng-model-options=\"ab.filter.options\"></textarea></md-input-container></div><div flex=\"100\" ng-if=\"ab.isNewCustomer || ab.undoVisible\" style=\"margin-top: 0px;\"><md-progress-circular ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\" style=\"margin-top: 0px;\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ab.update( ab.activeCustomer )\" ng-disabled=\"customerForm.$invalid || ab.saving || ab.phoneChecking\" ng-if=\"ab.undoVisible && ! ab.isNewCustomer\"><md-icon md-font-icon=\"check\">check</md-icon>Aggiorna</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Salva\" ng-click=\"ab.undo()\" ng-if=\"ab.undoVisible && ! ab.isNewCustomer\" ng-disabled=\"ab.saving\">Annulla</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Aggiungi\" ng-click=\"ab.save( ab.activeCustomer )\" ng-disabled=\"customerForm.$invalid || ab.saving || ab.phoneChecking\" ng-if=\"ab.isNewCustomer\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva e prenota\" ng-click=\"ab.save( ab.activeCustomer, true )\" ng-disabled=\"customerForm.$invalid || ab.saving || ab.phoneChecking\" ng-if=\"ab.isNewCustomer\"><md-icon md-font-icon=\"book\">book</md-icon>Salva e prenota appuntamento</md-button></md-input-container></div></form><div ng-if=\"! ab.isNewCustomer\" layout-margin=\"\"><md-button class=\"md-primary md-raised\" aria-label=\"Prendi nuovo appuntamento\" ng-href=\"{{ ab.env.booking }}/operator?tenant={{ (ab.env.tenant==\'Italia\'?(customer.tenant?customer.tenant:ab.env.currentTenant):ab.env.currentTenant) }}&amp;c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;store={{ ab.storeId }}&amp;customer={{ customer.phone }}&amp;token={{ ab.token }}\" target=\"{{ab.env.company}}_Booking_{{ab.env.tenant}}\" ng-disabled=\"ab.activeCustomer.off\" ng-if=\"!ab.env.isMaster\"><md-icon md-font-icon=\"today\">today</md-icon>Crea appuntamento per <strong>{{ ab.activeCustomer.firstname }} {{ ab.activeCustomer.lastname }}</strong></md-button></div><md-content ng-hide=\"!ab.loading\" layout=\"row\" layout-align=\"center center\" style=\"min-height: 80px;\"><md-progress-circular ng-disabled=\"!ab.loading\" md-diameter=\"40\"></md-progress-circular></md-content><span flex=\"100\" style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"ab.activeCustomer.invited.data.length > 0 && !ab.loading\">Invitati</span><md-table-container class=\"addressbook-invited\" ng-if=\"ab.activeCustomer.invited.data.length > 0 && !ab.loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Cognome</span></th><th md-column=\"\"><span>Nome</span></th><th md-column=\"\"><span>Cell</span></th><th md-column=\"\" md-numeric=\"\"><span>Punti</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"customer in ab.activeCustomer.invited.data | orderBy: \'lastname\'\"><td>{{ customer.created_at_frmt }}</td><td>{{ customer.lastname }}</td><td>{{ customer.firstname }}</td><td>{{ customer.phone }}</td><td style=\"text-align: right;\">{{ customer.rechargeAmount | number: 0 }}</td></tr></tbody></table></md-table-container><span flex=\"100\" style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"ab.activeCustomer.customer_subscriptions_active.data.length > 0 && !ab.loading\">Abbonamenti attivi</span><md-table-container class=\"addressbook-appointments\" ng-if=\"ab.activeCustomer.customer_subscriptions_active.data.length > 0 && !ab.loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Creato il</span></th><th md-column=\"\"><span>Abbonamento</span></th><th md-column=\"\" md-numeric=\"\"><span>Sedute Rimaste</span></th></tr></thead><tbody md-body=\"\" style=\"font-size: 12px;\"><tr md-row=\"\" ng-repeat=\"subscription in ab.activeCustomer.customer_subscriptions_active.data | orderBy: \'-date_start\'\"><td>{{ subscription.created_at }}</td><td>{{ subscription.subscription_id | subscriptionIdtoName : ab.subscriptionsList }}</td><td style=\"text-align: right;\">{{ subscription.app_remaining }}</td></tr></tbody></table></md-table-container><span flex=\"100\" style=\"padding-top: 50px;\" class=\"md-subhead\" ng-if=\"ab.appointmentsForCustomer.length > 0 && !ab.loading\">Storico appuntamenti</span><md-table-container class=\"addressbook-appointments\" ng-if=\"ab.appointmentsForCustomer.length > 0 && !ab.loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\" md-numeric=\"\"><span>{{ab.env.currency?ab.env.currency.label:\'Prezzo\'}}</span></th><th md-column=\"\"><span></span></th><th md-column=\"\"><span>Pres.</span></th><th md-column=\"\"><span>Centro</span></th></tr></thead><tbody md-body=\"\" style=\"font-size: 12px;\"><tr md-row=\"\" ng-repeat=\"appointment in ab.appointmentsForCustomer | orderBy: \'-date_start\'\" class=\"{{appointment.recalled>=3?\'recalled_\'+appointment.recalled:( appointment.paid? \'\':\'app_notpaid\')}}\"><td>{{ appointment.date_start | date : \'dd/MM/yyyy HH:mm\' }}</td><td>{{ appointment.treatment_id | treatmentIdtoName : ab.treatmentsList }}<md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.customer_subscription_id !== null\">autorenew</md-icon></td><td style=\"text-align: right;\"><span ng-if=\"appointment.paid\">{{ appointment.price | number:2 }} {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</span></td><td><span ng-if=\"appointment.credit>0\">{{ appointment.credit | number:2 }} {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</span></td><td><span ng-if=\"appointment.paid\">SI</span> <span ng-if=\"!appointment.paid\">NO</span></td><td>{{ appointment.store_id | storeIdtoName : ab.storesList }}</td></tr></tbody></table></md-table-container></md-content></md-sidenav>");
$templateCache.put("app/reviews/reviews.html","<md-content class=\"page-appointments\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Recensioni & Survey</span></h2><span flex=\"\" hide-xs=\"\"></span> {{ab.store.gmb_rating | number:1}} &nbsp;&nbsp;<ng-rate-it ng-model=\"ab.store.gmb_rating\" min=\"0\" max=\"5\" read-only=\"true\"></ng-rate-it>&nbsp;&nbsp; {{ab.store.gmb_reviews }} recensioni &nbsp;&nbsp;|&nbsp;&nbsp; {{ab.store.survey1av_rating | number:1}} &nbsp;&nbsp;<ng-rate-it ng-model=\"ab.store.survey1av_rating\" min=\"0\" max=\"5\" read-only=\"true\"></ng-rate-it>&nbsp;&nbsp; {{ab.store.survey1av_reviews }} sondaggi 1a V.<md-button class=\"md-accent md-raised\" aria-label=\"Nuova recensione\" ng-disabled=\"ab.loading\" ng-click=\"ab.toggleRight()\" ng-if=\"false && ab.env.isMaster && (ab.user.type==\'admin\' || ab.user.type==\'backoffice\')\"><md-icon md-font-icon=\"view_list\">view_list</md-icon>Nuova recensione</md-button></div></md-toolbar><md-tabs class=\"md-dynamic-height\" md-selected=\"ab.selectedTabIndex\"><md-tab label=\"Recensioni\"><md-content layout-margin=\"\" layout-padding=\"\" layout=\"column\" flex=\"\" layout-align=\"center center\"><md-card style=\"width: 100%;\"><md-card-header style=\"padding-bottom: 6px; padding-top: 6px;\"><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container md-no-float=\"\" class=\"md-accent\" flex=\"40\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" ng-keypress=\"ab.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select aria-label=\"Rating\" placeholder=\"Rating\" ng-model=\"ab.eStatus.selectedFilterStelle\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ab.filtersListStelle track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><div flex=\"30\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" id=\"filter_date_start\" name=\"filter_date_start\" md-placeholder=\"Dal\" ng-model=\"ab.eStatus.filter_date_start\" ng-change=\"ab.onChangeDateStart()\"></md-datepicker></div><span flex=\"\" hide-xs=\"\"></span><div flex=\"30\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" id=\"filter_date_end\" name=\"filter_date_end\" md-placeholder=\"Al\" ng-model=\"ab.eStatus.filter_date_end\" ng-change=\"ab.onChangeDateEnd()\"></md-datepicker></div></div></md-toolbar></md-card-header><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\" md-on-reorder=\"ab.eListReorder\"><tr md-row=\"\"><th md-column=\"\"><span></span></th><th md-column=\"\" md-order-by=\"createTime\"><span>Creato il</span></th><th ng-if=\"!ab.storeId\" md-column=\"\" md-order-by=\"store_id\"><span>Centro</span></th><th md-column=\"\"><span>Nome</span></th><th md-column=\"\"><span>Rating</span></th><th md-column=\"\" style=\"text-align: center;\"><span>Recensione</span></th><th md-column=\"\" style=\"text-align: center;\"><span>Note</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"10\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular></td><td md-cell=\"\" ng-if=\"ab.user.type == \'backoffice\' || ab.user.type == \'admin\'\"></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in ab.eList\"><td md-cell=\"\"><img width=\"50\" src=\"{{ e.profilePhotoUrl }}\"></td><td md-cell=\"\">{{ e.createTimeLong | date : \'dd/MM/yyyy HH:mm\'}}</td><td md-cell=\"\" ng-if=\"!ab.storeId\">{{ e.store.data.alias }}</td><td style=\"padding: 10px;\" md-cell=\"\">{{ e.displayName }}</td><td md-cell=\"\"><ng-rate-it ng-model=\"e.rate\" min=\"0\" max=\"5\" read-only=\"true\" step=\"1\"></ng-rate-it></td><td style=\"padding: 10px;\" md-cell=\"\">{{ e.comment }}</td><td style=\"padding: 10px; min-width:250px;\" md-cell=\"\"><span>{{ e.notes }}</span><md-button ng-if=\"ab.userCanSetNotes\" aria-label=\"Modifica Note\" class=\"md-icon-button\" ng-click=\"ab.editNotes(e)\"><md-icon class=\"md-primary md-icon-button\" md-font-icon=\"create\" title=\"Modifica Note\">create</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"! ab.loading\" md-limit=\"ab.eListPag.per_page\" md-limit-options=\"ab.query.limitOptions\" md-page=\"ab.eListPag.current_page\" md-total=\"{{ ab.eListPag.total }}\" md-boundary-links=\"ab.options.boundaryLinks\" md-on-paginate=\"ab.eListLoad\"></md-table-pagination></md-card-content></md-card></md-content></md-tab><md-tab label=\"Survey 1a V.\"><md-content layout-margin=\"\" layout-padding=\"\" layout=\"column\" flex=\"\" layout-align=\"center center\"><md-card style=\"width: 100%;\"><md-card-header style=\"padding-bottom: 6px; padding-top: 6px;\"><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container md-no-float=\"\" class=\"md-accent\" flex=\"40\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.queryS1.filter\" ng-keypress=\"ab.onKeyPressSearch($event,\'S1\')\" type=\"search\" placeholder=\"Cerca\"></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch(\'S1\')\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select aria-label=\"Rating Min\" placeholder=\"Rating Min\" ng-model=\"ab.eStatus.surveis[\'S1\'].selectedFilterStelle\" ng-change=\"ab.onChangeRateMin(\'S1\')\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ab.filtersListStelleSurvey track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select aria-label=\"Rating Max\" placeholder=\"Rating Max\" ng-model=\"ab.eStatus.surveis[\'S1\'].selectedFilterStelleMax\" ng-change=\"ab.onChangeRateMax(\'S1\')\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"filter.value\" ng-repeat=\"filter in ab.filtersListStelleSurvey track by filter.value\">{{ filter.name }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><div flex=\"30\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" id=\"filter_date_start\" name=\"filter_date_start\" md-placeholder=\"Dal\" ng-model=\"ab.eStatus.surveis[\'S1\'].filter_date_start\" ng-change=\"ab.onChangeDateStartSurveis(\'S1\')\"></md-datepicker></div><span flex=\"\" hide-xs=\"\"></span><div flex=\"30\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" id=\"filter_date_end\" name=\"filter_date_end\" md-placeholder=\"Al\" ng-model=\"ab.eStatus.surveis[\'S1\'].filter_date_end\" ng-change=\"ab.onChangeDateEndSurveis(\'S1\')\"></md-datepicker></div></div></md-toolbar></md-card-header><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selectedSurveis[\'S1\']\"><thead md-head=\"\" md-order=\"ab.query.surveis[\'S1\'].order\" md-on-reorder=\"ab.eListReorderSurveis[\'S1\']\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"created_at\"><span>Creato il</span></th><th ng-if=\"!ab.storeId\" md-column=\"\" md-order-by=\"store_id\"><span>Centro</span></th><th md-column=\"\" md-order-by=\"operator_user_id\"><span>Op.</span></th><th md-column=\"\"><span>Nome</span></th><th md-column=\"\"><span>Domanda</span></th><th md-column=\"\" style=\"text-align: center;\"><span>Rating</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loadingSurveis[\'S1\']\"><td md-cell=\"\" colspan=\"10\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loadingSurveis[\'S1\']\" md-mode=\"indeterminate\"></md-progress-circular></td><td md-cell=\"\" ng-if=\"ab.user.type == \'backoffice\' || ab.user.type == \'admin\'\"></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" md-on-select=\"ab.rowClickeds[\'S1\']\" ng-repeat=\"e in ab.eListSurveis[\'S1\']\"><td md-cell=\"\">{{ e.created_at_frmt }}</td><td md-cell=\"\" ng-if=\"!ab.storeId\">{{ e.store.data.alias }}</td><td style=\"padding: 10px;\" md-cell=\"\">{{ e.operator.data.firstname }} {{ e.operator.data.lastname }} <span ng-if=\"e.appointment && e.appointment.data && e.appointment.data.treatment\"><br>{{ e.appointment.data.treatment.name }}<br>{{ e.appointment.data.date_start_ftmt }}</span></td><td style=\"padding: 10px;\" md-cell=\"\">{{ e.customer.data.firstname }} {{ e.customer.data.lastname }} <span ng-if=\"e.hash\"><br><i>Codice Sconto:</i><b>{{e.hash}}</b></span></td><td style=\"padding: 10px;\" md-cell=\"\"><div layout=\"row\" ng-repeat=\"q in e.customerSurveyQuestions.data\"><span>{{ q.question }}</span></div></td><td md-cell=\"\"><div layout=\"row\" ng-repeat=\"q in e.customerSurveyQuestions.data\"><ng-rate-it ng-model=\"q.answer\" ng-if=\"q.answer == \'1\' || q.answer == \'2\' || q.answer == \'3\' || q.answer == \'4\' || q.answer == \'5\'\" min=\"0\" max=\"5\" read-only=\"true\" step=\"1\"></ng-rate-it><span ng-if=\"q.answer != \'1\' && q.answer != \'2\' && q.answer != \'3\' && q.answer != \'4\' && q.answer != \'5\'\">{{ q.answer }}</span></div></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"! ab.loadingSurveis[\'S1\']\" md-limit=\"ab.eListPagSurveis[\'S1\'].per_page\" md-limit-options=\"ab.query.surveis[\'S1\'].limitOptions\" md-page=\"ab.eListPagSurveis[\'S1\'].current_page\" md-total=\"{{ ab.eListPagSurveis[\'S1\'].total }}\" md-boundary-links=\"ab.options.boundaryLinks\" md-on-paginate=\"ab.eListLoads[\'S1\']\"></md-table-pagination></md-card-content></md-card></md-content></md-tab></md-tabs></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"view_list\">view_list</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"ab.activeEntity.id!=null\">Modifica abbonamento (aid: {{ab.activeEntity.id}})</span> <span class=\"inset\" ng-if=\"ab.activeEntity.id==null\">Nuovo abbonamento</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"entityForm\" id=\"entityForm\" layout=\"column\"><div flex=\"100\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"70\"><label class=\"md-label\" for=\"name\">Nome</label> <input id=\"name\" name=\"name\" md-placeholder=\"Nome\" ng-model=\"ab.activeEntity.name\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><md-checkbox id=\"active\" name=\"active\" aria-label=\"Attivo\" ng-model=\"ab.activeEntity.active\" ng-true-value=\"1\" ng-false-value=\"0\">Attivo</md-checkbox></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"30\"><label for=\"qta_xct\">Sedute</label> <input type=\"integer\" name=\"quantity\" id=\"quantity\" step=\"1\" min=\"1\" ng-model=\"ab.activeEntity.quantity\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"70\"><label for=\"price\">Prezzo (in &euro;)</label> <input type=\"number\" name=\"price\" id=\"price\" step=\"0.01\" min=\"0\" ng-model=\"ab.activeEntity.price\" required=\"\"></md-input-container></div><div ng-if=\"!ab.activeEntity.id || ab.activeEntity.name.indexOf(\'Laser\')!=-1\" layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"30\"><label for=\"zone\">Zone</label> <input name=\"zone\" id=\"zone\" ng-model=\"ab.activeEntity.zone\"></md-input-container><md-input-container class=\"md-block\" flex=\"70\"><label for=\"max_app\">Massimo numero sedute compresi richiami</label> <input name=\"max_app\" id=\"max_app\" ng-model=\"ab.activeEntity.max_app\"></md-input-container></div><div flex=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ab.save( ab.activeEntity )\" ng-disabled=\"entityForm.$invalid || ab.saving\" ng-show=\"entityForm.$dirty\"><md-icon md-font-icon=\"check\">check</md-icon>{{ ab.activeEntity.id == null ? \'Salva\' : \'Aggiorna\' }}</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\" ng-disabled=\"ab.saving\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/storage/storage.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Movimenti Magazzino</span></h2><span flex=\"\" hide-xs=\"\"></span><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" type=\"search\" placeholder=\"Cerca\" ng-keypress=\"ab.onKeyPressSearch($event)\"><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\" ng-if=\"false && ab.user.type==\'admin\'\">Centro</th><th md-column=\"\"></th><th md-column=\"\"><span>Op.</span></th><th md-column=\"\"><span>Fornitore</span></th><th md-column=\"\" md-order-by=\"products.name\"><span>Prodotto</span></th><th md-column=\"\" md-order-by=\"products.category\"><span>Categoria</span></th><th md-column=\"\" md-order-by=\"products.conf\"><span>Conf.</span></th><th md-column=\"\"><span>Giac. prec.</span></th><th md-column=\"\"><span>&Delta; Q.ta</span></th><th md-column=\"\"><span>Giac.</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"10\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" style=\"background-color: #D9D9D9;\" ng-if=\"!ab.loading\"><td md-cell=\"\" colspan=\"3\"></td><td md-cell=\"\"><md-select aria-label=\"Fornitore\" placeholder=\"Filtra\" ng-model=\"ab.query.supplierId\" ng-change=\"ab.eListLoad(1)\"><md-option value=\"\">Tutti</md-option><md-option ng-value=\"s.id\" ng-repeat=\"s in ab.suppliersList\">{{ s.name }}</md-option></md-select></td><td colspan=\"6\" md-cell=\"\"></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" ng-repeat=\"e in ab.eList\" ng-if=\"!ab.loading\"><td md-cell=\"\">{{ e.created_at_frmt }}</td><td md-cell=\"\" ng-if=\"false && ab.user.type==\'admin\'\">{{e.store.alias}}</td><td md-cell=\"\" style=\"text-align: center;\"><md-button aria-label=\"Info acquisto vendita\" ng-if=\"e.order_id || e.appointment_id\" ng-click=\"e.order_id?ab.showInfoOrder( e ):ab.showInfoApp( e )\" ng-class=\"{\'md-icon-button\': true, \'md-accent\': true, \'md-warn\': false }\"><md-icon ng-if=\"e.appointment_id\" md-font-icon=\"book\">book</md-icon><md-icon ng-if=\"e.order_id\" md-font-icon=\"shopping_cart\">shopping_cart</md-icon></md-button><md-button ng-if=\"!e.order_id && !e.appointment_id && e.add_qty>0\" ng-click=\"ab.showInfo( e )\" aria-label=\"Info carico\" ng-class=\"{\'md-icon-button\': true, \'md-accent\': true, \'md-warn\': false }\"><md-icon>add_circle_outline</md-icon></md-button><md-button ng-if=\"!e.order_id && !e.appointment_id && e.add_qty<0\" ng-click=\"ab.showInfo( e )\" aria-label=\"Info scarico\" ng-class=\"{\'md-icon-button\': true, \'md-accent\': true, \'md-warn\': false }\"><md-icon>remove_circle_outline</md-icon></md-button></td><td md-cell=\"\">{{ e.user.data.alias }}</td><td md-cell=\"\">{{ e.supplier.data.name }}</td><td md-cell=\"\">{{ e.product.data.name }}</td><td md-cell=\"\">{{ e.product.data.category }}</td><td md-cell=\"\">{{ e.product.data.conf }}</td><td md-cell=\"\">{{ e.prev_qty }}</td><td md-cell=\"\">{{ e.add_qty }}</td><td md-cell=\"\">{{ e.prev_qty + e.add_qty }}</td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"! ab.loading\" md-limit=\"ab.eListPag.per_page\" md-limit-options=\"ab.query.limitOptions\" md-page=\"ab.eListPag.current_page\" md-total=\"{{ ab.eListPag.total }}\" md-boundary-links=\"ab.options.boundaryLinks\" md-on-paginate=\"ab.eListLoad\"></md-table-pagination></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-appointments md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"book\">book</md-icon><h2 class=\"md-headline\"><span class=\"inset\">Scarico prodotto</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"eForm\" id=\"eForm\" layout=\"column\"><div flex=\"100\" layout=\"column\" class=\"fix-margins-3 min-height-60\"><label class=\"md-label\" for=\"datetime\">Data ora scarico</label> <input class=\"md-datepicker-full-width md-datepicker-remove-red-border\" id=\"datetime\" name=\"datetime\" md-placeholder=\"Data ora scarico\" ng-model=\"ab.activeE.created_at\" ng-disabled=\"\'true\'\"></div><div layout=\"row\"><md-input-container class=\"md-block\"><label for=\"user_id\">Operatrice *</label><md-select ng-model=\"ab.activeE.user_id\" aria-label=\"Operatrice\" id=\"user_id\" name=\"user_id\" ng-disabled=\"\'true\'\" required=\"\"><md-option ng-value=\"ab.user.id\"><div ng-if=\"ab.user.store_id>0\" class=\"operator-circle\" style=\"background-color: {{ ab.user.color }};\"></div>{{ ab.user.store_id }} {{ ab.user.firstname }} {{ ab.user.lastname }}</md-option></md-select><div ng-messages=\"eForm.user_id.$error\" ng-if=\"eForm.user_id.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"product_id\">Prodotto *</label><md-select aria-label=\"Prodotto\" id=\"product_id\" name=\"product_id\" ng-model=\"ab.selectedPs\" ng-disabled=\"ab.productsLoading\" md-container-class=\"with-search\" required=\"\"><md-select-header><span class=\"md-select-search-container\"><input type=\"{{ ab.productsLoading? \'hidden\' : \'search\' }}\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_products\" name=\"filter_products\" ng-click=\"$event.stopPropagation()\" ng-keydown=\"$event.stopPropagation()\" ng-keyup=\"ab.onKeyUpProductsSearch($event, this)\" ng-model=\"ab.query.filter_product\"></span></md-select-header><md-option ng-value=\"ps\" ng-repeat=\"ps in ab.productsList track by ps.product.id\">{{ ps.product.id }} | {{ ps.product.supplier.name }} | {{ ps.product.name }} | {{ ps.qty }}</md-option></md-select><div ng-messages=\"eForm.product_id.$error\" ng-if=\"eForm.product_id.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-progress-circular md-diameter=\"30\" ng-if=\"ab.productsLoading\" md-mode=\"indeterminate\"></md-progress-circular></div><div><md-input-container class=\"md-block\"><label for=\"giacenza\">Giacenza</label> <input type=\"number\" name=\"giacenza\" id=\"giacenza\" ng-model=\"ab.selectedPs.qty\" ng-disabled=\"\'true\'\"></md-input-container></div><div><md-input-container class=\"md-block\"><label for=\"qty\">Qta scaricata</label> <input type=\"number\" name=\"qty\" id=\"qty\" step=\"1\" min=\"1\" max=\"{{ ab.selectedPs.qty }}\" ng-model=\"ab.activeE.qty\"></md-input-container></div><div><md-input-container class=\"md-block\" style=\"margin-top: 30px;\"><label for=\"note\">Motivo</label> <textarea name=\"note\" id=\"note\" rows=\"2\" ng-model=\"ab.activeE.note\" md-select-on-focus=\"\"></textarea></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ab.save( ab.activeE )\" ng-disabled=\"eForm.$invalid\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/storage_state/storage_state.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Stato Magazzino</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-raised md-accent\" ng-disabled=\"!ab.storeId || ab.loading\" ng-href=\"{{ ab.exportUrl }}\"><md-icon md-font-icon=\"save\">save</md-icon>Excel</md-button><span flex=\"\" hide-xs=\"\"></span><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" type=\"search\" placeholder=\"Cerca\" ng-keypress=\"ab.onKeyPressSearch($event)\"><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-checkbox flex=\"20\" style=\"margin-left: 10px;\" ng-model=\"ab.query.filterGiacenzaInfMin\" ng-change=\"ab.eListLoad(1)\">Giacenza insufficiente</md-checkbox><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Carico\" ng-disabled=\"ab.loading || !ab.storeId || (ab.user.store_id && ab.storeId!=ab.user.store_id)\" ng-click=\"ab.toggleRight(\'carico\')\"><md-icon md-font-icon=\"done\">add_circle_outline</md-icon><span>Carico</span></md-button><md-button class=\"md-accent md-raised\" aria-label=\"Scarico\" ng-disabled=\"ab.loading || !ab.storeId || (ab.user.store_id && ab.storeId!=ab.user.store_id)\" ng-click=\"ab.toggleRight(\'scarico\')\"><md-icon md-font-icon=\"done\">remove_circle_outline</md-icon><span>Scarico</span></md-button></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"9\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" ng-if=\"!ab.loading\" style=\"background-color: #D9D9D9;\"><td md-cell=\"\" colspan=\"1\"></td><td md-cell=\"\"><md-select aria-label=\"Fornitore\" placeholder=\"Filtra\" ng-model=\"ab.query.supplierId\" ng-change=\"ab.eListLoad(1)\"><md-option value=\"\">Tutti</md-option><md-option ng-value=\"s.id\" ng-repeat=\"s in ab.suppliersList\">{{ s.name }}</md-option></md-select></td><td colspan=\"4\" md-cell=\"\"></td><td md-cell=\"\" colspan=\"3\" style=\"text-align: right\"><b>Saldo totale magazzino :</b> {{ab.storage_balance | number:2 }} &euro;</td></tr></table><table md-table=\"\" md-row-select=\"false\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\"><span>Id</span></th><th md-column=\"\"><span>Fornitore</span></th><th md-column=\"\" md-order-by=\"products.category\"><span>Categoria</span></th><th md-column=\"\" md-order-by=\"products.name\"><span>Prodotto</span></th><th md-column=\"\" md-order-by=\"products.conf\"><span>Conf</span></th><th md-column=\"\" md-numeric=\"\"><span>Giac.</span></th><th md-column=\"\" md-numeric=\"\"><span>Min.</span></th><th md-column=\"\" md-numeric=\"\"><span>In Ord.</span></th><th md-column=\"\"><span>Azioni</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" ng-repeat=\"e in ab.eList\"><td md-cell=\"\">{{ e.id }}</td><td md-cell=\"\">{{ e.supplier.name }}</td><td md-cell=\"\">{{ e.product.category }}</td><td md-cell=\"\">{{ e.product.name }}</td><td md-cell=\"\">{{ e.product.conf }}</td><td md-cell=\"\">{{ e.qty }}</td><td md-cell=\"\">{{ e.product.qty_min }}</td><td md-cell=\"\">{{ e.ordersQtyPending?e.ordersQtyPending:\'\' }}</td><td md-cell=\"\" layout=\"row\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Ordine\" ng-disabled=\"ab.loading || ab.storeId==null || (ab.user.store_id && ab.storeId!=ab.user.store_id)\" ng-click=\"ab.toggleRight(\'ordine\',e)\"><md-icon md-font-icon=\"done\">add_shopping_cart</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Carico\" ng-disabled=\"ab.loading || ab.storeId==null || (ab.user.store_id && ab.storeId!=ab.user.store_id)\" ng-click=\"ab.toggleRight(\'carico\',e)\"><md-icon md-font-icon=\"add_circle_outline\">add_circle_outline</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Scarico\" ng-disabled=\"ab.loading || ab.storeId==null || (ab.user.store_id && ab.storeId!=ab.user.store_id) || e.qty==0\" ng-click=\"ab.toggleRight(\'scarico\',e)\"><md-icon md-font-icon=\"remove_circle_outline\">remove_circle_outline</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"! ab.loading\" md-limit=\"ab.eListPag.per_page\" md-limit-options=\"ab.query.limitOptions\" md-page=\"ab.eListPag.current_page\" md-total=\"{{ ab.eListPag.total }}\" md-boundary-links=\"ab.options.boundaryLinks\" md-on-paginate=\"ab.eListLoad\"></md-table-pagination></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-appointments md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"book\">book</md-icon><h2 class=\"md-headline\"><span class=\"inset\" style=\"text-transform: capitalize;\">{{ ab.activeE.type }} prodotto</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"eForm\" id=\"eForm\" layout=\"column\"><div flex=\"100\" layout=\"column\" class=\"fix-margins-3 min-height-60\"><label class=\"md-label\" for=\"datetime\">Data ora {{ab.activeE.type}}</label> <input class=\"md-datepicker-full-width md-datepicker-remove-red-border\" id=\"datetime\" name=\"datetime\" md-placeholder=\"Data ora scarico\" ng-model=\"ab.activeE.created_at\" ng-disabled=\"\'true\'\"></div><div layout=\"row\"><md-input-container class=\"md-block\"><label for=\"user_id\">Operatrice *</label><md-select ng-model=\"ab.activeE.user_id\" aria-label=\"Operatrice\" id=\"user_id\" name=\"user_id\" ng-disabled=\"\'true\'\" required=\"\"><md-option ng-value=\"ab.user.id\"><div ng-if=\"ab.user.store_id>0\" class=\"operator-circle\" style=\"background-color: {{ ab.user.color }};\"></div>{{ ab.user.store_id }} {{ ab.user.firstname }} {{ ab.user.lastname }}</md-option></md-select><div ng-messages=\"eForm.user_id.$error\" ng-if=\"eForm.user_id.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"product_id\">Prodotto *</label><md-select aria-label=\"Prodotto\" id=\"product_id\" name=\"product_id\" ng-model=\"ab.selectedPs\" ng-disabled=\"ab.productsLoading || ab.activeE.rowselection\" md-container-class=\"with-search\" required=\"\"><md-select-header><span class=\"md-select-search-container\"><input type=\"{{ ab.productsLoading? \'hidden\' : \'search\' }}\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_products\" name=\"filter_products\" ng-click=\"$event.stopPropagation()\" ng-keydown=\"$event.stopPropagation()\" ng-keyup=\"ab.onKeyUpProductsSearch($event, this)\" ng-model=\"ab.query.filter_product\"></span></md-select-header><md-option ng-value=\"ps\" ng-repeat=\"ps in ab.productsList track by ps.product.id\">{{ ps.product.id }} | {{ ps.product.supplier.name }} | {{ ps.product.name }} | {{ ps.qty }}</md-option></md-select><div ng-messages=\"eForm.product_id.$error\" ng-if=\"eForm.product_id.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-progress-circular md-diameter=\"30\" ng-if=\"ab.productsLoading\" md-mode=\"indeterminate\"></md-progress-circular></div><div><md-input-container class=\"md-block\"><label for=\"giacenza\">Giacenza</label> <input type=\"number\" name=\"giacenza\" id=\"giacenza\" ng-model=\"ab.selectedPs.qty\" ng-disabled=\"\'true\'\"></md-input-container></div><div><md-input-container class=\"md-block\" ng-if=\"ab.activeE.type==\'scarico\'\"><label for=\"qty\">Quantit&agrave; scaricata</label> <input type=\"number\" name=\"qty\" id=\"qty\" step=\"1\" min=\"1\" max=\"{{ ab.selectedPs.qty }}\" ng-model=\"ab.activeE.qty\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"ab.activeE.type==\'carico\'\"><label for=\"add_qty\">Quantit&agrave; caricata</label> <input type=\"number\" name=\"add_qty\" id=\"add_qty\" step=\"1\" min=\"1\" ng-model=\"ab.activeE.add_qty\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"ab.activeE.type==\'ordine\'\"><label for=\"ord_qty\">Quantit&agrave; da ordinare</label> <input type=\"number\" name=\"ord_qty\" id=\"ord_qty\" step=\"{{ ab.selectedPs.product.qta_xct }}\" min=\"{{ ab.selectedPs.product.qta_xct }}\" ng-model=\"ab.activeE.ord_qty\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"ab.activeE.type!=\'ordine\'\"><label for=\"note\">Motivo</label> <textarea name=\"note\" id=\"note\" rows=\"2\" ng-model=\"ab.activeE.note\" md-select-on-focus=\"\"></textarea></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ab.save( ab.activeE )\" ng-disabled=\"eForm.$invalid\"><md-icon md-font-icon=\"check\">check</md-icon>{{ ab.activeE.type==\'carico\'?\'Carica\':(ab.activeE.type==\'scarico\'?\'Scarica\':\'Aggiungi ad ordine\') }}</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/subscriptions/subscriptions.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Abbonamenti</span></h2><span flex=\"\" hide-xs=\"\"></span><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" type=\"search\" placeholder=\"Cerca\"><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-checkbox ng-model=\"ab.query.active\" ng-true-value=\"1\" ng-false-value=\"0\">Attivi</md-checkbox><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo prodotto\" ng-disabled=\"ab.loading\" ng-click=\"ab.toggleRight()\" ng-if=\"(ab.env.tenant == \'Morepa\' || ab.env.tenant==\'Lombardia\' || ab.env.isMaster) && (ab.user.type==\'admin\' || ab.user.type==\'backoffice\')\"><md-icon md-font-icon=\"view_list\">view_list</md-icon>Nuovo abbonamento</md-button></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"id\"><span>Id</span></th><th md-column=\"\" md-order-by=\"active\"><span></span></th><th md-column=\"\" md-order-by=\"name\"><span>Nome</span></th><th md-column=\"\" md-order-by=\"grp_name\"><span>Gruppo</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"quantity\"><span>Sedute</span></th><th md-column=\"\" md-numeric=\"\"><span>Tot. sedute con richiami</span></th><th md-column=\"\" md-numeric=\"\"><span>Zone</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"price\"><span>Prezzo &euro;</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"price_promo\"><span>Prezzo promo &euro;</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"max_rate\"><span>Max rate</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"min_deposit\"><span>Min acconto</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"points\"><span>Punti</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"days_interval\"><span>Periodicit&agrave;</span></th><th md-column=\"\" ng-if=\"ab.env.isMaster && (ab.user.type == \'backoffice\' || ab.user.type == \'admin\')\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"9\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular></td><td md-cell=\"\" ng-if=\"ab.user.type == \'backoffice\' || ab.user.type == \'admin\'\"></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in (ab.filteredItems = (ab.eList | filter: { $: ab.query.filter } | filter: { active: ab.query.active?1:0 } | orderBy: ab.query.order )) track by e.id\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.id }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><md-icon ng-if=\"!e.active\" md-font-icon=\"visibility_off\">visibility_off</md-icon></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.name }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.grp_name }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.quantity }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><span ng-if=\"e.name.indexOf(\'Laser\')!=-1\">{{ e.max_app }}</span></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><span ng-if=\"e.name.indexOf(\'Laser\')!=-1\">{{ e.zone }}</span></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.price | number : 2}}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.price_promo | number : 2}}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.max_rate }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.min_deposit }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.points }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.days_interval }}</td><td md-cell=\"\" class=\"icon-button\" ng-if=\"ab.env.isMaster && (ab.user.type == \'backoffice\' || ab.user.type == \'admin\')\"><md-button class=\"md-icon-button md-warn\" ng-click=\"ab.del( e.id )\" aria-label=\"Cancella\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"view_list\">view_list</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"ab.activeEntity.id!=null\">Modifica abbonamento (aid: {{ab.activeEntity.id}})</span> <span class=\"inset\" ng-if=\"ab.activeEntity.id==null\">Nuovo abbonamento</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"entityForm\" id=\"entityForm\" layout=\"column\"><div flex=\"100\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"70\"><label class=\"md-label\" for=\"name\">Nome</label> <input id=\"name\" name=\"name\" md-placeholder=\"Nome\" ng-model=\"ab.activeEntity.name\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><md-checkbox id=\"active\" name=\"active\" aria-label=\"Attivo\" ng-model=\"ab.activeEntity.active\" ng-true-value=\"1\" ng-false-value=\"0\">Attivo</md-checkbox></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"30\"><label for=\"quantity\">Sedute</label> <input type=\"integer\" name=\"quantity\" id=\"quantity\" step=\"1\" min=\"1\" ng-model=\"ab.activeEntity.quantity\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"70\"><label for=\"price\">Prezzo (in &euro;)</label> <input type=\"number\" name=\"price\" id=\"price\" step=\"0.01\" min=\"0\" ng-model=\"ab.activeEntity.price\" required=\"\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"30\"><label for=\"max_rate\">Max rate</label> <input type=\"integer\" name=\"max_rate\" id=\"max_rate\" step=\"1\" min=\"0\" ng-model=\"ab.activeEntity.max_rate\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"70\"><label for=\"price_promo\">Prezzo promo (in &euro;)</label> <input type=\"number\" name=\"price_promo\" id=\"price_promo\" step=\"0.01\" min=\"0\" ng-model=\"ab.activeEntity.price_promo\" required=\"\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"30\"><label for=\"points\">Punti</label> <input type=\"integer\" name=\"points\" id=\"points\" step=\"1\" min=\"0\" ng-model=\"ab.activeEntity.points\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"70\"><label for=\"min_deposit\">Acconto minimo (in &euro;)</label> <input type=\"number\" name=\"min_deposit\" id=\"min_deposit\" step=\"0.01\" min=\"0\" ng-model=\"ab.activeEntity.min_deposit\" required=\"\"></md-input-container></div><div ng-if=\"!ab.activeEntity.id || ab.activeEntity.name.indexOf(\'Laser\')!=-1\" layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"30\"><label for=\"zone\">Zone</label> <input name=\"zone\" id=\"zone\" ng-model=\"ab.activeEntity.zone\"></md-input-container><md-input-container class=\"md-block\" flex=\"70\"><label for=\"max_app\">Massimo numero sedute compresi richiami</label> <input name=\"max_app\" id=\"max_app\" ng-model=\"ab.activeEntity.max_app\"></md-input-container></div><div flex=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ab.save( ab.activeEntity )\" ng-disabled=\"entityForm.$invalid || ab.saving\" ng-show=\"entityForm.$dirty\"><md-icon md-font-icon=\"check\">check</md-icon>{{ ab.activeEntity.id == null ? \'Salva\' : \'Aggiorna\' }}</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\" ng-disabled=\"ab.saving\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/today/today.html","<md-content layout-margin=\"\" class=\"page-today\" layout-fill=\"\"><div layout-gt-sm=\"row\" layout-xs=\"column\" class=\"body\"><div flex-gt-sm=\"85\" flex-xs=\"100\" class=\"content\"><div class=\"content-body\"><div style=\"text-align: right\"><md-button ng-if=\"today.user_type==\'admin\'\" style=\"margin-left: 10px; margin-top:10px;\" class=\"md-accent md-raised\" aria-label=\"Occupazione operatori\" ng-disabled=\"today.loading\" ng-click=\"today.availabilityIntervalDailyReport()\"><md-icon md-font-icon=\"list\">list</md-icon>Occupazione operatori</md-button></div><md-progress-circular md-diameter=\"30\" ng-if=\"today.loading\" md-mode=\"indeterminate\"></md-progress-circular><div id=\"mycalendar\" ui-calendar=\"today.uiConfig.calendar\" ng-model=\"today.eventSources\" calendar=\"myCalendar\" class=\"calendar\"></div></div></div><div flex-gt-sm=\"15\" flex-xs=\"100\" class=\"aside\"><div ng-if=\"! today.appointmentSelected\" style=\"min-height: 57px;\"></div><div class=\"aside-header\" layout=\"row\" layout-align=\"end center\" ng-if=\"today.appointmentSelected\"><div flex=\"\">{{ today.appointmentSelected.customer.data.firstname }} {{ today.appointmentSelected.customer.data.lastname }}</div><md-button class=\"md-icon-button md-raised md-accent\" aria-label=\"Aggiungi Appuntamento\" ng-if=\"! today.isCallCenter\" ng-disabled=\"!today.appointmentSelected.customer.data.id\" ng-href=\"{{ today.env.booking }}/operator?c_sid={{ today.user.store_id }}&amp;c_role={{ today.user.type }}&amp;customer={{ today.appointmentSelected.customer.data.phone }}&amp;operator={{ today.userId }}&amp;store={{ today.storeId }}&amp;token={{ today.token }}\" target=\"_self\"><md-icon md-font-icon=\"book\">book</md-icon></md-button></div><div class=\"aside-body\"><div class=\"treatment\"><div class=\"treatment-th\" layout=\"row\"><div flex=\"20\">Min</div><div flex=\"80\">{{today.appointmentSelected.treatment.data.name}}</div></div><div class=\"treatment-content\"><div class=\"flex-container\"><div ng-repeat=\"activity in today.appointmentSelected.treatment.data.activities.data\" ng-class=\"{ \'machine\': activity.machinery_id, active: (activity | activeActivityFilter:today.appointmentSelected ) }\" class=\"flex-item activity type-{{today.appointmentSelected.type}} {{ activity.type }}\" ng-click=\"today.activityDetail(activity)\" style=\"-webkit-box-flex: {{activity.duration}}; -webkit-flex: {{activity.duration | splitMinutesFilter}} 1 auto; -ms-flex: {{activity.duration | splitMinutesFilter}} 1 auto; flex: {{activity.duration | splitMinutesFilter}} 1 auto; -webkit-order: {{activity.order}}; -ms-flex-order: {{activity.order}}; order: {{activity.order}};\"><div class=\"activity-row\"><div layout=\"row\"><div flex=\"20\" class=\"col min-col\">{{activity.duration | splitMinutesFilter}}</div><div flex=\"70\" class=\"col title-col\"><span ng-if=\"activity.type==\'operator\' && !activity.machinery_id\"><div class=\"operator-circle\" style=\"background-color: {{ today.appointmentSelected.role.data.color }};\"></div>Operatrice</span> <span ng-if=\"activity.type==\'operator\' && activity.machinery_id\"><div class=\"operator-circle\" style=\"background-color: {{ today.appointmentSelected.role.data.color }};\"></div><md-icon md-font-icon=\"power\">power</md-icon>{{activity.machinery.name}}</span> <span ng-if=\"activity.type==\'exposure\' && activity.machinery_id\"><md-icon md-font-icon=\"power\">power</md-icon>{{activity.machinery.name}}</span> <span ng-if=\"activity.type==\'exposure\'\">Posa</span> <span ng-if=\"activity.type==\'assist\' && activity.machinery_id\"><md-icon md-font-icon=\"power\">power</md-icon>{{activity.machinery.name}}</span> <span ng-if=\"activity.type==\'assist\' && !activity.machinery_id\">Assistente</span> <span class=\"times opacity-50\">{{activity | startendActivityFilter:today.appointmentSelected}}</span></div></div></div></div></div></div></div></div></div></div><div><h3>Utilizzo risorse del giorno: {{today.usageSelected}}</h3><div class=\"chart\" id=\"operChartContainer\"></div><div class=\"chart\" id=\"areaChartContainer\"></div></div></md-content>");
$templateCache.put("app/treatments/treatments.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Trattamenti</span></h2><span flex=\"\" hide-xs=\"\"></span><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" type=\"search\" placeholder=\"Cerca\"><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-checkbox ng-model=\"ab.query.active\" ng-true-value=\"1\" ng-false-value=\"0\">Attivi</md-checkbox><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Nuovo trattamento\" ng-disabled=\"ab.loading\" ng-click=\"ab.toggleRight()\" ng-if=\"false && ab.env.isMaster && (ab.user.type==\'admin\' || ab.user.type==\'backoffice\')\"><md-icon md-font-icon=\"view_list\">view_list</md-icon>Nuovo trattamento</md-button></div></md-toolbar><md-card><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"id\"><span>Id</span></th><th md-column=\"\" md-order-by=\"active\"><span></span></th><th md-column=\"\" md-order-by=\"treatment_category_id\"><span>Categoria</span></th><th md-column=\"\" md-order-by=\"name\"><span>Nome</span></th><th md-column=\"\" md-order-by=\"grp_name\"><span>Gruppo</span></th><th md-column=\"\" md-order-by=\"capability_id\"><span>Abilitazione</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"start_price\"><span>&euro;</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"promo_price\"><span>&euro; pr.</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"price_first\"><span>&delta; 1av.</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"price_normal\"><span>&delta;</span></th><th md-column=\"\" md-numeric=\"\"><span>Zone</span></th><th md-column=\"\" md-numeric=\"\"><span>Min.</span></th><th md-column=\"\" md-numeric=\"\"><span>Min. Ass.</span></th><th md-column=\"\" md-numeric=\"\"><span>Min. Exp.</span></th><th md-column=\"\" ng-if=\"false && ab.env.isMaster && (ab.user.type == \'backoffice\' || ab.user.type == \'admin\')\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"9\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular></td><td md-cell=\"\" ng-if=\"ab.user.type == \'backoffice\' || ab.user.type == \'admin\'\"></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat=\"e in (ab.filteredItems = (ab.eList | filter: { $: ab.query.filter } | filter: { active: ab.query.active?1:0 } | orderBy: ab.query.order )) track by e.id\"><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.id }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><md-icon ng-if=\"!e.active\" md-font-icon=\"visibility_off\" title=\"Non attivo\">visibility_off</md-icon><md-icon ng-if=\"!e.f_notify\" md-font-icon=\"remove_circle\" title=\"Notifica disabilitata\">remove_circle</md-icon><md-icon ng-if=\"!e.f_book\" md-font-icon=\"leak_remove\" title=\"Non presente in booking\">leak_remove</md-icon><md-icon ng-if=\"!e.f_abb\" md-font-icon=\"alarm_off\" title=\"Non disponibile in abbonamento\">alarm_off</md-icon></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.category.data.name }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.name }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.grp_name }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.capability.data.name }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.start_price?e.start_price:null | number : 2 }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.promo_price?e.promo_price:null | number : 2 }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.price_first?e.price_first:null | number : 0 }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.price_normal?e.price_normal:null | number : 0 }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><span ng-if=\"e.name.indexOf(\'Laser\')!=-1 && e.zone\">{{ e.zone }}</span></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.min_duration }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.min_assist?e.min_assist:null }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.min_exposure?e.min_exposure:null }}</td><td md-cell=\"\" class=\"icon-button\" ng-if=\"false && ab.env.isMaster && (ab.user.type == \'backoffice\' || ab.user.type == \'admin\')\"><md-button class=\"md-icon-button md-warn\" ng-click=\"ab.del( e.id )\" aria-label=\"Cancella\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"view_list\">view_list</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"ab.activeEntity.id!=null\">Modifica abbonamento (aid: {{ab.activeEntity.id}})</span> <span class=\"inset\" ng-if=\"ab.activeEntity.id==null\">Nuovo abbonamento</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"entityForm\" id=\"entityForm\" layout=\"column\"><div flex=\"100\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"70\"><label class=\"md-label\" for=\"name\">Nome</label> <input id=\"name\" name=\"name\" md-placeholder=\"Nome\" ng-model=\"ab.activeEntity.name\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><md-checkbox id=\"active\" name=\"active\" aria-label=\"Attivo\" ng-model=\"ab.activeEntity.active\" ng-true-value=\"1\" ng-false-value=\"0\">Attivo</md-checkbox></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"30\"><label for=\"qta_xct\">Sedute</label> <input type=\"integer\" name=\"quantity\" id=\"quantity\" step=\"1\" min=\"1\" ng-model=\"ab.activeEntity.quantity\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"70\"><label for=\"price\">Prezzo (in &euro;)</label> <input type=\"number\" name=\"price\" id=\"price\" step=\"0.01\" min=\"0\" ng-model=\"ab.activeEntity.price\" required=\"\"></md-input-container></div><div ng-if=\"!ab.activeEntity.id || ab.activeEntity.name.indexOf(\'Laser\')!=-1\" layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"30\"><label for=\"zone\">Zone</label> <input name=\"zone\" id=\"zone\" ng-model=\"ab.activeEntity.zone\"></md-input-container><md-input-container class=\"md-block\" flex=\"70\"><label for=\"max_app\">Massimo numero sedute compresi richiami</label> <input name=\"max_app\" id=\"max_app\" ng-model=\"ab.activeEntity.max_app\"></md-input-container></div><div flex=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ab.save( ab.activeEntity )\" ng-disabled=\"entityForm.$invalid || ab.saving\" ng-show=\"entityForm.$dirty\"><md-icon md-font-icon=\"check\">check</md-icon>{{ ab.activeEntity.id == null ? \'Salva\' : \'Aggiorna\' }}</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\" ng-disabled=\"ab.saving\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/whatsapp/whatsapp.html","<md-content class=\"page-whatsapp\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\" style=\"background-color: rgb(0, 150, 136);\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"chat\">chat</md-icon><span class=\"inset\" style=\"color: black;\">Whatsapp</span></h2><span flex=\"\" hide-xs=\"\"></span></div></md-toolbar><md-card><md-card-header><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container flex=\"40\" md-no-float=\"\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"whatsapp.query.filter\" ng-disabled=\"whatsapp.user.store_id && whatsapp.user.type!=\'storemngr\'\" ng-keypress=\"whatsapp.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\" show-gt-md=\"\" ng-if=\"whatsapp.user.store_id==null || whatsapp.user.store_id==0\"><md-select aria-label=\"Gestito da\" placeholder=\"Gestito da\" ng-model=\"whatsapp.query.filter_user_id\" ng-if=\"!whatsapp.user.store_id\" ng-change=\"whatsapp.onKeyPressSearch()\"><md-option ng-if=\"whatsapp.user.type!=\'callcenter\' || whatsapp.user.ext_f_cs\" ng-value=\"undefined\">Tutti</md-option><md-option ng-if=\"whatsapp.user.type==\'callcenter\' && !whatsapp.user.ext_f_cs\" ng-value=\"undefined\">Team</md-option><md-option ng-if=\"whatsapp.user.type==\'callcenter\' && !whatsapp.user.ext_f_cs\" ng-value=\"whatsapp.user.id\">Gestiti da me</md-option><md-option ng-if=\"whatsapp.user.type!=\'callcenter\' || whatsapp.user.ext_f_cs\" ng-value=\"u.user_id\" ng-repeat=\"u in whatsapp.userRolesListCall | orderBy: \'user.lastname\'\">{{ u.user.lastname }} {{ u.user.firstname }}</md-option></md-select></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><div flex=\"nogrow\" ng-if=\"!whatsapp.user.store_id || whatsapp.user.type==\'storemngr\'\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"whatsapp.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><md-checkbox style=\"margin-left: 30px;\" ng-show=\"whatsapp.user.type==\'admin\'\" ng-disabled=\"whatsapp.user.type==\'storemngr\'\" ng-model=\"whatsapp.exclude_callcenter\" ng-change=\"whatsapp.customersListLoad(1)\">Escludi callcenter</md-checkbox></div></md-toolbar></md-card-header><md-progress-circular md-diameter=\"30\" ng-if=\"whatsapp.loadingCustomersList\" md-mode=\"indeterminate\"></md-progress-circular><div class=\"whatsapp-card-content\" ng-if=\"whatsapp.customersList && whatsapp.customersList.length >0\"><md-card-content style=\"overflow: auto\" class=\"flex-50\"><md-table-container><table md-table=\"\" md-row-select=\"whatsapp.options.rowSelection\" ng-model=\"whatsapp.selected\" class=\"whatsapp-table\"><thead md-head=\"\" md-order=\"whatsapp.query.order\" md-on-reorder=\"whatsapp.customersListReOrder\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"lastname\"><span>Nome Cliente</span></th><th ng-if=\"whatsapp.env.currentTenant==\'Italia\'\" md-column=\"\" md-order-by=\"tenant\"><span>Ar.</span></th><th md-column=\"\" md-order-by=\"user_id\"><span>By</span></th><th md-column=\"\" md-order-by=\"phone\"><span>Tel.</span></th><th md-column=\"\"><span>Non letti</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span></span></th></tr></thead><tbody md-body=\"\" ng-if=\"whatsapp.customersList && whatsapp.customersList.length > 0\"><tr md-row=\"\" md-select=\"customer\" md-auto-select=\"whatsapp.options.autoSelect\" md-select-id=\"customer.customer_id\" md-on-select=\"whatsapp.rowClicked\" ng-repeat=\"customer in whatsapp.customersList\" ng-class=\"{\'whatsapp-customer-selected\': whatsapp.customerSelected && customer.customer_id == whatsapp.customerSelected.customer_id}\" ng-click=\"whatsapp.rowClicked(customer)\"><td md-cell=\"\">{{ customer.lastname }} {{ customer.firstname }}</td><td ng-if=\"whatsapp.env.currentTenant==\'Italia\'\" md-cell=\"\">{{ customer.tenant }}</td><td md-cell=\"\">{{ customer.user.data.alias }}</td><td md-cell=\"\"><a href=\"tel:{{customer.phone}}\">{{ customer.phone}}</a></td><td md-cell=\"\"><md-button ng-if=\"customer.unreaded_count\" class=\"md-icon-button md-primary md-raised\" style=\"background-color:rgb(0, 150, 136)\" ;=\"\">{{customer.unreaded_count}}</md-button></td><td md-cell=\"\"><span ng-if=\"customer.order_date>\'1970-01-01\'\">{{ customer.order_date_frmt }}</span></td><td md-cell=\"\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Appuntamenti cliente\" ng-if=\"whatsapp.env.currentTenant != \'Italia\'\" ui-sref=\"home.appointments( { filter : customer.phone, filter_date: whatsapp.query.filter_date_app } )\"><md-icon md-font-icon=\"filter_list\">filter_list</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Ultimo lead\" ng-if=\"whatsapp.user.type == \'callcenter\' || whatsapp.user.type == \'admin\'\" ui-sref=\"home.lead( { phone : customer.phone } )\"><md-icon md-font-icon=\"input\">input</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"whatsapp.customersList && whatsapp.customersList.length > 0\" md-limit=\"whatsapp.customersListPag.per_page\" md-page=\"whatsapp.customersListPag.current_page\" md-total=\"{{ whatsapp.customersListPag.total }}\" md-on-paginate=\"whatsapp.customersListLoad\" md-boundary-links=\"whatsapp.options.boundaryLinks\"></md-table-pagination></md-card-content><md-card-content style=\"overflow: auto\" class=\"flex-50\" ng-if=\"whatsapp.customerSelected\"><bl-whatsapp user=\"whatsapp.user\" customer=\"whatsapp.customerSelected\" reset=\"whatsapp.reset_unreaded\" pusher=\"false\"></bl-whatsapp></md-card-content></div></md-card></md-content>");
$templateCache.put("app/wire-transfer/wire-transfer.html","<md-backdrop ng-click=\"ab.closeSidebar()\" ng-show=\"ab.undoVisible && ! ab.isNewCustomer\" class=\"md-sidenav-backdrop md-opaque\"></md-backdrop><md-content class=\"page-wire-transfer\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"contacts\">account_balance</md-icon><span class=\"inset\">Controllo Bonifici</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Storico Bonifici\" ui-sref=\"home.wire-transfer-history({type: \'wire-transfer\'})\"><md-icon md-font-icon=\"history\">history</md-icon>Storico Bonifici</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Storico Cofidis\" ui-sref=\"home.wire-transfer-cofidis-history()\"><md-icon md-font-icon=\"history\">history</md-icon>Storico Cofidis</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Storico Credito Al Consumo\" ng-if=\"ab.env.wireTransfersConsumerCredit\" ui-sref=\"home.wire-transfer-consumer-credit-history()\"><md-icon md-font-icon=\"history\">history</md-icon>Storico Credito Al Consumo</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Importa File\" ng-click=\"ab.openImportSidebar()\"><md-icon md-font-icon=\"person_add\">file_upload</md-icon>Importa File</md-button></div></md-toolbar><md-progress-circular style=\"margin: 20px;\" md-diameter=\"30\" ng-if=\"ab.loading\" md-mode=\"indeterminate\"></md-progress-circular><md-tabs class=\"md-dynamic-height\"><md-tab label=\"APPUNTAMENTI - BONIFICI\"><md-content layout-margin=\"\" layout-padding=\"\" layout=\"row\" layout-sm=\"column\"><div flex=\"\"><bl-appointments-wire-transfers paymenttype=\"\'B\'\" token=\"ab.token\"></bl-appointments-wire-transfers></div><div flex=\"\"><bl-wire-transfers filtertype=\"\'wire-transfer\'\" archive=\"false\" token=\"ab.token\"></bl-wire-transfers></div></md-content><md-tab label=\"APPUNTAMENTI - COFIDIS\"><md-content layout-margin=\"\" layout-padding=\"\" layout=\"row\" layout-sm=\"column\"><div flex=\"\"><bl-wire-transfers-cofidis filtertype=\"\'cofidis\'\" archive=\"false\"></bl-wire-transfers-cofidis></div></md-content><md-tab label=\"APPUNTAMENTI - CREDITO AL CONSUMO\" ng-if=\"ab.env.wireTransfersConsumerCredit\"><md-content layout-margin=\"\" layout-padding=\"\" layout=\"row\" layout-sm=\"column\"><div flex=\"\"><bl-wire-transfers-consumer-credit filtertype=\"\'consumer-credit\'\" archive=\"false\"></bl-wire-transfers-consumer-credit></div></md-content></md-tab></md-tab></md-tab></md-tabs></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"collections\">collections</md-icon><h2 class=\"md-headline\"><span class=\"inset\">{{ ab.commandLabel }}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeImportSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"importFileAction\" id=\"importFileAction\" layout=\"column\" layout-wrap=\"\"><div layout=\"row\"><label for=\"my_file\">Seleziona un file</label> <input type=\"file\" file-input=\"files\" multiple=\"\"></div><div flex=\"100\"><md-progress-circular ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\"><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeImportSidebar()\" ng-disabled=\"ab.saving\">Annulla</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ab.save()\" ng-disabled=\"ab.saving\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/wire-transfer-cofidis-history/wire-transfer-cofidis-history.html","<md-content class=\"page-wire-transfer-history\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"contacts\">account_balance</md-icon><span class=\"inset\">Storico Cofidis</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Indietro\" ui-sref=\"home.wire-transfer\"><md-icon md-font-icon=\"arrow_back\">arrow_back</md-icon>Indietro</md-button></div></md-toolbar><md-content layout-margin=\"\" layout-padding=\"\" layout=\"row\" layout-sm=\"column\"><div flex=\"\"><bl-wire-transfers-cofidis filtertype=\"\'cofidis\'\" archive=\"true\"></bl-wire-transfers-cofidis></div></md-content></md-content>");
$templateCache.put("app/wire-transfer-consumer-credit-history/wire-transfer-consumer-credit-history.html","<md-content class=\"page-wire-transfer-history\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"contacts\">account_balance</md-icon><span class=\"inset\">Storico Credito Al Consumo</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Indietro\" ui-sref=\"home.wire-transfer\"><md-icon md-font-icon=\"arrow_back\">arrow_back</md-icon>Indietro</md-button></div></md-toolbar><md-content layout-margin=\"\" layout-padding=\"\" layout=\"row\" layout-sm=\"column\"><div flex=\"\"><bl-wire-transfers-consumer-credit filtertype=\"\'consumer-credit\'\" archive=\"true\"></bl-wire-transfers-consumer-credit></div></md-content></md-content>");
$templateCache.put("app/wire-transfer-history/wire-transfer-history.html","<md-content class=\"page-wire-transfer-history\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"contacts\">account_balance</md-icon><span class=\"inset\">Storico Bonifici</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button class=\"md-accent md-raised\" aria-label=\"Indietro\" ui-sref=\"home.wire-transfer\"><md-icon md-font-icon=\"arrow_back\">arrow_back</md-icon>Indietro</md-button></div></md-toolbar><md-content layout-margin=\"\" layout-padding=\"\" layout=\"row\" layout-sm=\"column\"><div flex=\"\"><bl-wire-transfers filtertype=\"\'wire-transfer\'\" archive=\"true\" token=\"ab.token\"></bl-wire-transfers></div></md-content></md-content>");
$templateCache.put("app/wklist/wklist.html","<xipny-wkflow-entity-list user=\"ctrl.user\"></xipny-wkflow-entity-list>");
$templateCache.put("app/addressbook/dialogs/customer-documents.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"><span>Documento</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"env.documentsEnabled && !customer.docPrivacyOk\"><td md-cell=\"\"><md-icon md-font-icon=\"assignment_late\" class=\"md-warn\">assignment_late</md-icon></td><td md-cell=\"\">Privacy</td><td md-cell=\"\"></td><td md-cell=\"\"><md-button class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/signed-docs/?customer_id={{customer.id}}&template_id={{env.documents.templateIdPrivacy}}&token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"note_add\">note_add</md-icon>Nuovo</md-button></td></tr><tr md-row=\"\" ng-if=\"env.documentsEnabled && !customer.docPicturesOk\"><td md-cell=\"\"><md-icon md-font-icon=\"assignment_late\" class=\"md-warn\">assignment_late</md-icon></td><td md-cell=\"\">Consenso fotografie</td><td md-cell=\"\"></td><td md-cell=\"\"><md-button class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/signed-docs/?customer_id={{customer.id}}&template_id={{env.documents.templateIdPictures}}&token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"note_add\">note_add</md-icon>Nuovo</md-button></td></tr><tr md-row=\"\" ng-if=\"env.documentsEnabled && !customer.docCovidOk\"><td md-cell=\"\"><md-icon md-font-icon=\"assignment_late\" class=\"md-warn\">assignment_late</md-icon></td><td md-cell=\"\">Autocertificazione COVID-19</td><td md-cell=\"\"></td><td md-cell=\"\"><md-button class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/signed-docs/?customer_id={{customer.id}}&template_id={{env.documents.templateIdCovid}}&token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"note_add\">note_add</md-icon>Nuovo</md-button></td></tr><tr md-row=\"\" ng-repeat=\"doc in customer.documents.data\" ng-if=\"doc.document_type_id!=304\"><td md-cell=\"\"><md-icon md-font-icon=\"check\" class=\"md-accent\">check</md-icon></td><td md-cell=\"\"><span ng-if=\"doc.title\">{{ doc.title }}</span> <span ng-if=\"!doc.title && doc.description\">{{ doc.description }}</span></td><td md-cell=\"\"><span>{{ doc.date }} {{doc.time}}</span></td><td md-cell=\"\"><md-button ng-if=\"doc.treatment_id\" class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/signed-docs/?customer_id={{customer.id}}&treatment_id={{doc.treatment_id}}&template_id={{env.documents.templateIdTreatments}}&template_content_id={{doc.document_template_id}}&token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"note_add\">note_add</md-icon>Nuovo</md-button><md-button ng-if=\"!doc.treatment_id\" class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/signed-docs/?customer_id={{customer.id}}&template_id={{doc.document_template_id}}&token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"note_add\">note_add</md-icon>Nuovo</md-button><md-button class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/documents/{{doc.id}}/download?token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"get_app\">get_app</md-icon></md-button></td></tr><tr md-row=\"\" ng-repeat=\"doc in customer.documents.templates\"><td md-cell=\"\"><md-icon md-font-icon=\"assignment_late\" class=\"md-warn\">assignment_late</md-icon></td><td md-cell=\"\">{{doc.name}}</td><td md-cell=\"\"></td><td md-cell=\"\"><md-button class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/signed-docs/?customer_id={{customer.id}}&template_id={{doc.id}}&token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"note_add\">note_add</md-icon>Nuovo</md-button></td></tr></tbody></table></md-table-container></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"refresh()\" class=\"md-button md-raised md-accent\"><md-icon md-font-icon=\"refresh\">refresh</md-icon></md-button><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/appointments/dialogs/anomalia.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"anomaliesList.length>0\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Creata da</span></th><th md-column=\"\"><span>il</span></th><th md-column=\"\"><span>Tipo</span></th><th md-column=\"\"><span>Note</span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"anomalia in anomaliesList\"><td md-cell=\"\" class=\"cell-button\" align=\"left\">{{ anomalia.causer.firstname }} {{ anomalia.causer.lastname }}</td><td md-cell=\"\">{{ anomalia.created_at_formatted }}</td><td md-cell=\"\">{{ anomalia.properties.type }}</td><td md-cell=\"\">{{ anomalia.description }}</td><td md-cell=\"\"><md-button class=\"md-icon-button md-warn\" ng-disabled=\"loading || appointmentQuesto.closed\" ng-if=\"anomalia.properties.type==\'ncpc\'\" ng-click=\"delete(anomalia)\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr></tbody></table></md-table-container><form autocomplete=\"off\" role=\"form\" name=\"anomaliaForm\" id=\"anomaliaForm\" layout=\"column\" ng-if=\"!loading && (anomaliesList.length==0 || (anomaliesList[0].type!=\'ncpc\' && anomaliesList[0].type!=\'review.pos\' && !anomaliesList[anomaliesList.length-1].properties.type.match(\'.*fix.*\')))\"><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"70\"><label for=\"tipo_anomalia\"><span ng-if=\"anomaliesList.length==0\">Tipo anomalia</span> <span ng-if=\"anomaliesList.length>0\">Risoluzione anomalia/Commento</span></label><md-select ng-model=\"activeAnomalia.type\" aria-label=\"Tipo anomalia\" id=\"tipo_anomalia\" name=\"tipo_anomalia\" ng-disabled=\"activeAnomalia.id!=undefined\" required=\"\"><md-option ng-value=\"\'cassa\'\" ng-if=\"anomaliesList.length==0\">Anomalia cassa</md-option><md-option ng-value=\"\'ncpc\'\" ng-if=\"anomaliesList.length==0 && appointmentQuesto.recalled<3\">Appuntamento non conforme ai protocolli commerciali</md-option><md-option ng-value=\"\'overlap\'\" ng-if=\"anomaliesList.length==0\">C\'&egrave una sovrapposizione</md-option><md-option ng-value=\"\'trattamento\'\" ng-if=\"anomaliesList.length==0\">Il cliente ha fatto un trattamento diverso</md-option><md-option ng-value=\"\'non eseguito\'\" ng-if=\"anomaliesList.length==0\">Il cliente non ha potuto fare il trattamento</md-option><md-option ng-value=\"\'presentato\'\" ng-if=\"anomaliesList.length==0\">Il cliente si &egrave; presentato</md-option><md-option ng-value=\"\'review.neg\'\" ng-if=\"anomaliesList.length==0\">Recensione negativa</md-option><md-option ng-value=\"\'review.pos\'\" ng-if=\"anomaliesList.length==0\">Recensione positiva</md-option><md-option ng-value=\"\'altro\'\" ng-if=\"anomaliesList.length==0\">Altro</md-option><md-option ng-value=\"\'commento\'\" ng-if=\"anomaliesList.length>0\">Commento</md-option><md-option ng-value=\"\'fixed\'\" ng-if=\"anomaliesList.length>0\">Anomalia risolta con modifica</md-option><md-option ng-value=\"\'wontfix\'\" ng-if=\"anomaliesList.length>0\">Anomalia risolta senza modifica</md-option></md-select></md-input-container></div><div flex=\"\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"70\"><label for=\"note\">Note</label> <textarea name=\"note\" id=\"note\" rows=\"2\" ng-model=\"activeAnomalia.note\" ng-required=\"activeAnomalia.type!=\'ncpc\'\"></textarea></md-input-container><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"save()\" ng-disabled=\"anomaliaForm.$invalid || loading\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button></md-input-container></div></form></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/appointments/dialogs/appointment-cancellation.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><div layout=\"row\"><div flex=\"30\"><span>Cliente</span><h3 style=\"margin-bottom:25px;\">{{ appointment.customer.data.firstname }} {{ appointment.customer.data.lastname }}</h3></div><div flex=\"30\"><span>Trattamento</span><h3>{{ appointment.treatment.data.name }}</h3></div><div flex=\"25\"><span>Data/ora appuntamento</span><h3>{{ dateTimeStart }}</h3></div></div><form autocomplete=\"off\" role=\"form\" name=\"disdettaForm\" id=\"disdettaForm\" layout=\"column\"><div flex=\"100\"><md-datetime-picker data=\"call_date\" delay=\"recall_delay\" withdelay=\"false\" editable=\"false\" label=\"\'Da richiamare il\'\" style=\"padding: 0px 8px;\"></md-datetime-picker></div><md-input-container class=\"md-block\" flex=\"70\"><label for=\"reason\">Motivo</label> <textarea name=\"reason\" id=\"reason\" rows=\"4\" ng-model=\"reason\" required=\"\"></textarea></md-input-container><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"save()\" ng-disabled=\"disdettaForm.$invalid || loading\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button></md-input-container></form></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_cancel }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/appointments/dialogs/appointment-documents.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"><span>Documento</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"><md-icon ng-if=\"app.docPrivacy\" md-font-icon=\"check\" class=\"md-accent\">check</md-icon><md-icon ng-if=\"!app.docPrivacy\" md-font-icon=\"assignment_late\" class=\"md-warn\">assignment_late</md-icon></td><td md-cell=\"\">Consenso Privacy</td><td md-cell=\"\"><span ng-if=\"app.docPrivacy\">{{ app.docPrivacy.data.date }}</span></td><td md-cell=\"\"><md-button class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/signed-docs/?customer_id={{app.customer_id}}&template_id={{env.documents.templateIdPrivacy}}&token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"note_add\">note_add</md-icon>Nuovo</md-button><md-button ng-if=\"app.docPrivacy\" class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/documents/{{app.docPrivacy.data.id}}/download?token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"get_app\">get_app</md-icon></md-button></td></tr><tr md-row=\"\"><td md-cell=\"\"><md-icon ng-if=\"app.docPictures\" md-font-icon=\"check\" class=\"md-accent\">check</md-icon><md-icon ng-if=\"!app.docPictures\" md-font-icon=\"assignment_late\" class=\"md-warn\">assignment_late</md-icon></td><td md-cell=\"\">Consenso Foto e Video</td><td md-cell=\"\"><span ng-if=\"app.docPictures\">{{ app.docPictures.data.date }}</span></td><td md-cell=\"\"><md-button class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/signed-docs/?customer_id={{app.customer_id}}&template_id={{env.documents.templateIdPictures}}&token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"note_add\">note_add</md-icon>Nuovo</md-button><md-button ng-if=\"app.docPictures\" class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/documents/{{app.docPictures.data.id}}/download?token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"get_app\">get_app</md-icon></md-button></td></tr><tr md-row=\"\"><td md-cell=\"\"><md-icon ng-if=\"app.docContrPictures\" md-font-icon=\"check\" class=\"md-accent\">check</md-icon><md-icon ng-if=\"!app.docContrPictures\" md-font-icon=\"assignment_late\" class=\"md-warn\">assignment_late</md-icon></td><td md-cell=\"\">Contratto Foto e Video</td><td md-cell=\"\"><span ng-if=\"app.docContrPictures\">{{ app.docContrPictures.data.date }}</span></td><td md-cell=\"\"><md-button class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/signed-docs/?customer_id={{app.customer_id}}&template_id={{env.documents.templateIdContrPictures}}&token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"note_add\">note_add</md-icon>Nuovo</md-button><md-button ng-if=\"app.docPictures\" class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/documents/{{app.docContrPictures.data.id}}/download?token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"get_app\">get_app</md-icon></md-button></td></tr><tr md-row=\"\" ng-if=\"app.treatment.data.document_template_id\"><td md-cell=\"\"><md-icon ng-if=\"app.docTreatment\" md-font-icon=\"check\" class=\"md-accent\">check</md-icon><md-icon ng-if=\"!app.docTreatment\" md-font-icon=\"assignment_late\" class=\"md-warn\">assignment_late</md-icon></td><td md-cell=\"\">Consenso Trattamento</td><td md-cell=\"\"><span ng-if=\"app.docTreatment\">{{ app.docTreatment.data.date }}</span></td><td md-cell=\"\"><md-button class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/signed-docs/?customer_id={{app.customer_id}}&treatment_id={{app.treatment_id}}&template_id={{env.documents.templateIdTreatments}}&template_content_id={{app.treatment.data.document_template_id}}&token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"note_add\">note_add</md-icon>Nuovo</md-button><md-button ng-if=\"app.docTreatment\" class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/documents/{{app.docTreatment.data.id}}/download?token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"get_app\">get_app</md-icon></md-button></td></tr></tbody></table></md-table-container></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"refresh()\" class=\"md-button md-raised md-accent\"><md-icon md-font-icon=\"refresh\">refresh</md-icon></md-button><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/appointments/dialogs/appointment-info.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\" layout-padding=\"\"><md-list class=\"md-dense\"><md-list-item class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon ng-href=\"tel:{{ appointment.customer.data.phone }}\" md-font-icon=\"phone\">phone</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"row\" flex=\"\"><a href=\"tel:{{ appointment.customer.data.phone }}\"><h3>{{ appointment.customer.data.phone }}</h3></a></div></div></md-list-item><md-list-item class=\"md-4-line\" ng-if=\"appointment.note!=null && appointment.note.trim()!=\'\'\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"event_note\">event_note</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\">{{ appointment.note }}</div></div></md-list-item></md-list></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/appointments/dialogs/appointment-moves.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-list class=\"md-dense\" layout=\"row\"><md-list-item class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button ng-href=\"tel:{{ appointmentQuesto.customer.data.phone }}\" class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"phone\">phone</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"row\" flex=\"\"><a href=\"tel:{{ appointmentQuesto.customer.data.phone }}\"><h3>{{ appointmentQuesto.customer.data.phone }}</h3></a></div></div></md-list-item><md-list-item class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"face\">face</md-icon></md-button><span flex=\"5\"></span><div class=\"operator-circle\" style=\"background-color: {{ appointmentQuesto.role.data.color }};\"></div><h3>&nbsp;&nbsp;{{ appointmentQuesto.role.data.user.firstname }} {{ appointmentQuesto.role.data.user.lastname }}<h3></h3></h3></div></md-list-item><md-list-item class=\"md-4-line\" ng-if=\"appointmentQuesto.note!=null && appointmentQuesto.note.trim()!=\'\'\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"event_note\">event_note</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\">{{ appointmentQuesto.note }}</div></div></md-list-item></md-list><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"><span>Data app.</span></th><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\"><span>Stato</span></th><th md-column=\"\"><span>In data</span></th><th md-column=\"\"><span>Da</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"app in appointmentsList\" ng-class=\"{\'md-current\' : app.id == appointmentQuesto.id}\"><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ app.role.data.color }};\"></div></td><td md-cell=\"\">{{ app.date_start_frmt }}</td><td md-cell=\"\">{{ app.treatment.data.name }}</td><td class=\"cell-select\" md-cell=\"\"><md-input-container class=\"md-block\" ng-if=\"app.recalled>2\" ng-class=\"{ \'md-disd\': app.recalled == 3, \'md-spos\': app.recalled == 4 && !app.sposInDay, \'md-sposInDay\': app.recalled == 4 && app.sposInDay }\"><md-select ng-disabled=\"true\" ng-model=\"app.recalled\" aria-label=\"Stato\" id=\"recalled\" name=\"recalled\"><md-option ng-value=\"recall_type.value\" ng-repeat=\"recall_type in recall_types track by recall_type.value\">{{ recall_type.text }}</md-option></md-select></md-input-container><md-button class=\"md-icon-button md-raised md-accent\" ng-if=\"app.paid && app.closed\"><md-icon md-font-icon=\"check\">check</md-icon></md-button><md-button class=\"md-icon-button md-raised md-accent\" ng-if=\"!app.paid && app.closed && app.recalled<3\"><md-icon md-font-icon=\"delete_forever\">delete_forever</md-icon></md-button></td><td md-cell=\"\"><span ng-if=\"app.recalled == 4\">{{ app.moved_at_frmt }}</span> <span ng-if=\"app.recalled == 3\">{{ app.cancelled_at_frmt }}</span> <span ng-if=\"false && app.recalled < 3\">{{ app.updated_at_frmt }}*</span></td><td md-cell=\"\"><span ng-if=\"app.recalled == 4\">{{ app.movedBy.data.lastname }} {{ app.movedBy.data.firstname }}</span> <span ng-if=\"app.recalled == 3\">{{ app.cancelledBy.data.lastname }} {{ app.cancelledBy.data.firstname }}</span> <span ng-if=\"app.recalled < 3 && app.updatedBy!=null\">{{ app.updatedBy.data.lastname }} {{ app.updatedBy.data.firstname }}*</span></td></tr><tr><td md-cell=\"\" colspan=\"6\" ng-if=\"appointmentsList.length>1 || appointmentQuesto.recalled<3\">* Indica l\'ultima modifica</td></tr></tbody></table></md-table-container><md-list class=\"md-dense\" ng-if=\"!loading\"><md-list-item ng-if=\"appointment.treatment_id == 99\" class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"gift_card\">gift_card</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\"><h3>Emissione gift card #{{ appointment.gift_number }}</h3></div></div></md-list-item><md-list-item class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"book\">book</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\"><h3>Prenotato il {{ appointment.created_at_frmt }} da {{ appointment.byOperator.data.id==0?((appointment.f_over?\"Bot\":\"Online\")+\" Booking\"):appointment.byOperator.data.lastname }} {{ appointment.byOperator.data.firstname }}</h3><span ng-if=\"appointment.byOperator.data.phone!=null\"><a href=\"tel:{{ appointment.byOperator.data.phone }}\">Tel.: {{ appointment.byOperator.data.phone }}</a></span></div></div></md-list-item><md-list-item class=\"md-4-line\" ng-if=\"appointment.lead_id\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"input\">input</md-icon></md-button><span flex=\"5\"></span><div layout=\"column\" ng-if=\"appointment.lead && appointment.lead.data\" flex=\"\"><h3>Lead <span ng-if=\"appointment.lead.data.f_oper\">Social</span> (id:{{appointment.lead_id}}) del {{ appointment.lead.data.created_at_frmt }}</h3><span>Campagna: {{ appointment.lead.data.campagna }} / <i>{{appointment.lead.data.category}}</i> / <i>{{appointment.lead.data.categoria}}</i></span></div><div layout=\"column\" ng-if=\"!appointment.lead || !appointment.lead.data\" flex=\"\"><h3>Lead (id:{{appointment.lead_id}}) non trovato</h3>Potrebbe essere stato cancellato o spostato in un\'altra area</div></div></md-list-item><md-list-item class=\"md-4-line\" ng-if=\"appointment.cus_act_id!=null\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button><span flex=\"5\"></span><div layout=\"column\" flex=\"\"><h3>Appuntamento da rullo</h3></div></div></md-list-item><md-list-item ng-if=\"loadingPf || customer && (customer.sourceCustomer && customer.sourceCustomer.data || customer.phonefriends && customer.phonefriends.data && customer.phonefriends.data.length>0)\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button><span flex=\"5\"></span><md-progress-circular md-diameter=\"30\" ng-if=\"loadingPf\" md-mode=\"indeterminate\"></md-progress-circular><div layout=\"column\" flex=\"\"><bl-pf-info customer=\"customer\"></bl-pf-info></div></div></md-list-item></md-list></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/appointments/dialogs/appointment-op-history.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-list class=\"md-dense\" layout=\"row\"><md-list-item class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"face\">face</md-icon></md-button><span flex=\"5\"></span><div class=\"operator-circle\" style=\"background-color: {{ appointmentQuesto.role.data.color }};\"></div><h3>&nbsp;&nbsp;{{ appointmentQuesto.role.data.user.firstname }} {{ appointmentQuesto.role.data.user.lastname }}<h3></h3></h3></div></md-list-item><md-list-item class=\"md-4-line\" ng-if=\"appointmentQuesto.note!=null && appointmentQuesto.note.trim()!=\'\'\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"event_note\">event_note</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\">{{ appointmentQuesto.note }}</div></div></md-list-item></md-list><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Da op.</span></th><th md-column=\"\"><span>A op.</span></th><th md-column=\"\"><span>Data cambio</span></th><th md-column=\"\"><span>Eseguito da</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"change in appointmentQuesto.operatorChangeHistory.data\"><td md-cell=\"\">{{ change.userFrom.lastname }} {{ change.userFrom.firstname }}</td><td md-cell=\"\">{{ change.userTo.lastname }} {{ change.userTo.firstname }}</td><td md-cell=\"\">{{ change.created_at_frmt }}</td><td md-cell=\"\">{{ change.userBy.lastname }} {{ change.userBy.firstname }}</td></tr></tbody></table></md-table-container></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/appointments/dialogs/appointmentProducts.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"60\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\" border=\"0\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\"><span>Fornitore</span></th><th md-column=\"\" md-order-by=\"name\"><span>Prodotto</span></th><th md-column=\"\"><span>Conf.</span></th><th md-column=\"\" md-numeric=\"\"><span>Qta</span></th><th md-column=\"\" md-numeric=\"\"><span>Compr. *</span></th><th md-column=\"\" md-numeric=\"\"><span>Prezzo &euro;</span></th><th md-column=\"\" md-numeric=\"\"></th><th md-column=\"\" md-numeric=\"\"><span>Iva</span></th><th md-column=\"\" md-numeric=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading || ab.productsLoading\"><td md-cell=\"\" colspan=\"8\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading || ab.productsLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" ng-repeat=\"e in appProductsList track by e.id\"><td md-cell=\"\">{{ e.product.supplier.name }}</td><td md-cell=\"\">{{ e.product.name }}</td><td md-cell=\"\">{{ e.product.conf }}</td><td md-cell=\"\"><md-input-container style=\"margin-left: 20px; padding-bottom: 0px; margin-bottom: 0px; width: 60px;\"><input aria-label=\"Qta\" style=\"text-align: right;\" type=\"number\" name=\"total\" id=\"total\" step=\"1\" min=\"0\" ng-model=\"e.qty\" ng-blur=\"save(e)\" ng-disabled=\"e.saving || loading || productsLoading || mainEntity.closed\" required=\"\"></md-input-container></td><td md-cell=\"\"><md-checkbox ng-model=\"e.in_treatment\" ng-disabled=\"!e.product.id\" ng-change=\"save(e)\" ng-true-value=\"1\" ng-false-value=\"0\"></md-checkbox></td><td md-cell=\"\">{{ e.price | number:2 }}</td><td md-cell=\"\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Elimina prodotto\" ng-click=\"deleteProduct( e )\" ng-disabled=\"mainEntity.closed\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></td><td md-cell=\"\" style=\"text-align: right\">{{ e.product.supplier.vat }}%</td><td md-cell=\"\" style=\"text-align: right\"></td></tr><tr md-row=\"\" style=\"background-color: #D9D9D9;\"><td md-cell=\"\" style=\"text-align: right\" colspan=\"5\"><strong>Totale al 22% &euro;:</strong></td><td md-cell=\"\" style=\"text-align: right\">{{ mainEntity.product_price | number:2 }}</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\" style=\"background-color: #D9D9D9;\"><td md-cell=\"\" style=\"text-align: right\" colspan=\"5\"><strong>Totale al 10% &euro;:</strong></td><td md-cell=\"\" style=\"text-align: right\">{{ mainEntity.product_price10 | number:2 }}</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\" style=\"background-color: #D9D9D9;\"><td md-cell=\"\" style=\"text-align: right\" colspan=\"5\"><strong>Compresi al 22% &euro;:</strong></td><td md-cell=\"\" style=\"text-align: right\">{{ mainEntity.product_price_in | number:2 }}</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\" style=\"background-color: #D9D9D9;\"><td md-cell=\"\" style=\"text-align: right\" colspan=\"5\"><strong>Compresi al 10% &euro;:</strong></td><td md-cell=\"\" style=\"text-align: right\">{{ mainEntity.product_price10_in | number:2 }}</td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr></tbody></table>* Prodotti compresi nel costo trattamento<md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"ab.selected\" border=\"0\"><thead md-head=\"\" md-order=\"ab.query.order\"><tr md-row=\"\"><th md-column=\"\" colspan=\"7\" style=\"background-color: rgb(133,96,141); color: rgba(255,255,255,0.87);\"><span>Elenco prodotti</span></th></tr><tr md-row=\"\"><th md-column=\"\"><span>Fornitore</span></th><th md-column=\"\" md-order-by=\"name\"><span>Prodotto</span></th><th md-column=\"\"><span>Conf.</span></th><th md-column=\"\" md-numeric=\"\"><span>Prezzo &euro;</span></th><th md-column=\"\" md-numeric=\"\"></th><th md-column=\"\" md-numeric=\"\"><span>Iva</span></th><th md-column=\"\" md-numeric=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading || ab.productsLoading\"><td md-cell=\"\" colspan=\"7\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loading || ab.productsLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\"><td md-cell=\"\"><md-select aria-label=\"Fornitore\" placeholder=\"Filtra\" ng-model=\"ab.query.supplierName\"><md-option value=\"\">Tutti</md-option><md-option value=\"ACCADEMIA COSMECEUTICA\">ACCADEMIA</md-option><md-option value=\"BIOSKIN\">BIOSKIN</md-option><md-option value=\"BIOSNELLA\">BIOSNELLA</md-option><md-option value=\"CARTARIA FORLIVESE\">CARTARIA FORLIVESE</md-option><md-option value=\"CONSORZIO ESTETICA\">CONSORZIO ESTETICA</md-option><md-option value=\"COSMETHIC\">COSMETHIC</md-option><md-option value=\"DOCTOR LIFTING\">DOCTOR LIFTING</md-option><md-option value=\"EPILZONE\">EPILZONE</md-option><md-option value=\"LYNPHALIFE\">LYNPHALIFE</md-option><md-option value=\"PLANTS AND NATURE\">PLANTS AND NATURE</md-option></md-select></td><td md-cell=\"\" colspan=\"2\"><md-input-container style=\"margin-bottom: 0px;\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" placeholder=\"Cerca\"></md-input-container></td><td md-cell=\"\" style=\"text-align: right\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"false\" md-select-id=\"e.id\" ng-repeat=\"e in (filteredItems = (productsList | filter: { supplier: { name: ab.query.supplierName } } | filter: { $: ab.query.filter } | orderBy: ab.query.order ) ) track by e.id\"><td md-cell=\"\">{{ e.supplier.name }}</td><td md-cell=\"\">{{ e.name }}</td><td md-cell=\"\">{{ e.conf }}</td><td md-cell=\"\">{{ e.price_pub | number:2 }}</td><td md-cell=\"\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Aggiungi prodotto\" ng-click=\"addProduct( e )\" ng-disabled=\"mainEntity.closed\"><md-icon md-font-icon=\"add_shopping_cart\">add_shopping_cart</md-icon></md-button></td><td md-cell=\"\" style=\"text-align: right\">{{ e.supplier.vat }}%</td><td md-cell=\"\" style=\"text-align: right\"></td></tr></tbody></table></md-table-container></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/appointments/dialogs/appointments-dialog-nextday.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"100\" flex-sm=\"80\" flex-md=\"70\" flex-gt-md=\"65\" role=\"dialog\" class=\"dialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Attenzione</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\" layout-padding=\"\"><md-list class=\"md-dense\" ng-if=\"appointmentsList\"><md-subheader class=\"md-no-sticky\"><span class=\"md-headline\">{{ title }}</span></md-subheader><md-list-item class=\"md-3-line\" ng-repeat=\"appointment in appointmentsList\" ng-click=\"null\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button ng-if=\"! uncovered\" class=\"md-icon-button md-raised\" ng-class=\"appointment.confirmed ? \'md-accent\' : \'md-warn\'\"><md-icon md-font-icon=\"check\">check</md-icon></md-button><md-button ng-if=\"uncovered\" class=\"md-icon-button md-raised md-warn\"><md-icon md-font-icon=\"warning\">warning</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\"><h3>{{ appointment.customer.data.firstname }} {{ appointment.customer.data.lastname }} - Tel.:{{ appointment.customer.data.phone }}</h3><h4>{{ appointment.date_start | date : \'dd/MM/yyyy HH:mm\' }} - {{ appointment.date_end | date : \'dd/MM/yyyy HH:mm\' }}</h4><p>{{ appointment.treatment.data.name }}</p></div></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list><h3 ng-if=\"! appointmentsList\">Ricordati di controllare gli appuntamenti in coda.</h3></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-warn\">{{ button_cancel }}</md-button><md-button ng-click=\"open()\" aria-label=\"Apri\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/appointments/dialogs/consegna-gsb.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"80\" flex-sm=\"60\" flex-md=\"50\" flex-gt-md=\"40\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-table-container ng-if=\"customer.entitytags.data.length>0\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Tipo</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Consegnato</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"etag in customer.entitytags.data | orderBy : \'-tag_id\'\"><td md-cell=\"\"><span ng-if=\"etag.tag_id == 1\">Gold</span> <span ng-if=\"etag.tag_id == 2\">Silver</span> <span ng-if=\"etag.tag_id == 3\">Bronze</span></td><td md-cell=\"\"><span nf-if=\"etag.flagged\">{{ etag.flagged_at_frmt }}</span></td><td md-cell=\"\" class=\"cell-button\" style=\"text-align: left;\">{{ etag.flagged?\'Si\':\'No\' }}</td></tr></tbody></table></md-table-container><form autocomplete=\"off\" role=\"form\" name=\"tagForm\" id=\"tagForm\" layout=\"column\" ng-if=\"!entitytag.flagged\"><div layout=\"row\" layout-align=\"start center\"><label for=\"flagged_at\">Data consegna</label><md-datepicker id=\"flagged_at\" name=\"flagged_at\" ng-required=\"true\" ng-model=\"entitytag.flagged_at\" md-placeholder=\"Data consegna\" ng-disabled=\"true\"></md-datepicker><md-button class=\"md-accent md-raised\" aria-label=\"Consegnato\" ng-click=\"save()\" ng-disabled=\"tagForm.$invalid || loading\"><md-icon md-font-icon=\"check\">check</md-icon>Consegnato</md-button></div></form></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/cashout/dialogs/appointments-info.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-list class=\"md-dense\" layout=\"row\"><md-list-item class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button ng-href=\"tel:{{ questo.customer.data.phone }}\" class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"phone\">phone</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"row\" flex=\"\"><a href=\"tel:{{ questo.customer.data.phone }}\"><h3>{{ questo.customer.data.phone }}</h3></a></div></div></md-list-item><md-list-item class=\"md-4-line\" ng-if=\"questo.note!=null && questo.note.trim()!=\'\'\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"event_note\">event_note</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\">{{ questo.note }}</div></div></md-list-item></md-list><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\"><span>Data app.</span></th><th md-column=\"\"><span>Trattamento</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"origin!=null\"><td md-cell=\"\">Origine</td><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ origin.data.user.data.color }};\"></div></td><td md-cell=\"\">{{ origin.date_start_frmt }}</td><td md-cell=\"\">{{ origin.treatment.data.name }}</td></tr><tr md-row=\"\" ng-if=\"payment!=null\"><td md-cell=\"\">Pagamento</td><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ payment.data.user.data.color }};\"></div></td><td md-cell=\"\">{{ payment.date_start_frmt }}</td><td md-cell=\"\">{{ payment.treatment.data.name }}</td></tr><tr md-row=\"\" ng-if=\"payment==null\" ng-repeat=\"capp in paymentCandidates\"><td md-cell=\"\">App. fissato</td><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ capp.data.user.data.color }};\"></div></td><td md-cell=\"\">{{ capp.date_start_frmt }}</td><td md-cell=\"\">{{ capp.treatment.data.name }}</td></tr></tbody></table></md-table-container></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/bl-app-appointment/bl-app-appointment.html","<md-button class=\"md-button md-ink-ripple md-icon-button\" title=\"Movimenti App\" ng-click=\"ab.openPointsModal()\"><md-icon md-font-icon=\"smartphone\">smartphone</md-icon></md-button>");
$templateCache.put("app/components/bl-appointments-wire-transfers/bl-appointments-wire-transfers.html","<md-table-header><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container md-no-float=\"\" class=\"md-accent\" flex=\"30\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.queryAppointments.filter\" ng-keypress=\"ab.onKeyPressSearchAppointment($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><div flex=\"30\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" md-placeholder=\"Filtra data iniziale\" md-min-date=\"ab.minDateFilter\" ng-model=\"ab.queryAppointments.filter_date_start\" ng-change=\"ab.onChangeDateStartAppointment()\"></md-datepicker></div><div flex=\"30\" hide-xs=\"\" hide-sm=\"\" style=\"margin-left:35px;\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" md-placeholder=\"Filtra data finale\" md-min-date=\"ab.queryAppointments.filter_date_start\" ng-model=\"ab.queryAppointments.filter_date_end\" ng-change=\"ab.onChangeDateEndAppointment()\"></md-datepicker></div><div flex=\"5\" hide-xs=\"\" hide-sm=\"\" style=\"margin-left:25px;\"><md-checkbox ng-model=\"ab.queryAppointments.filter_unassociated_cro\" ng-change=\"ab.onChangeFilterUnassociatedCRO()\"></md-checkbox></div><div flex=\"5\" hide-xs=\"\" hide-sm=\"\"><md-button title=\"Download\" aria-label=\"Download\" class=\"md-icon-button md-primary\" ng-click=\"ab.loadAppointments(null, null, true)\"><md-icon md-font-icon=\"save\">save</md-icon></md-button></div></div></md-toolbar></md-table-header><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"ab.queryAppointments.order\" md-on-reorder=\"ab.reorderAppointments\" class=\"tab-head\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"date_start\"><span>Data</span></th><th md-column=\"\" md-order-by=\"customers.firstname\"><span>Cliente</span></th><th md-column=\"\" md-order-by=\"treatments.name\"><span>Trattamento</span></th><th md-column=\"\" md-order-by=\"price\"><span>Importo</span></th><th md-column=\"\"><span>Azioni</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loadingAppointments\"><td md-cell=\"\" colspan=\"10\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loadingAppointments\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" ng-repeat=\"appointment in ab.appointments\"><td md-cell=\"\">{{appointment.date_frmt}}</td><td md-cell=\"\">{{appointment.customer.firstname}} {{appointment.customer.lastname}}</td><td md-cell=\"\">{{appointment.treatment.name}}</td><td md-cell=\"\"><span ng-if=\"appointment.payment_type == \'B\'\">{{appointment.price | number:2}}</span> <span ng-if=\"appointment.payment_type == \'M\'\">{{appointment.payment_bon | number:2}}</span> <span ng-if=\"appointment.payment_type == \'T\'\">{{appointment.payment_satis | number:2}}</span> {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</td><td md-cell=\"\" class=\"icon-button\"><md-button title=\"CRO Associati\" aria-label=\"CRO Associati\" class=\"md-icon-button md-primary\" ng-if=\"!ab.wireTransfer && (appointment.appointment_wire_transfers && appointment.appointment_wire_transfers.length > 0)\" ng-click=\"ab.showAssociatedCroModal(appointment)\"><md-icon md-font-icon=\"list\">list</md-icon></md-button><md-button title=\"Associa il CRO\" aria-label=\"Associa il CRO\" class=\"md-icon-button md-primary\" ng-if=\"!ab.wireTransfer\" ng-click=\"ab.showSetCroModal(appointment)\"><md-icon md-font-icon=\"add\">add</md-icon></md-button><md-button title=\"Associa Appuntamento\" aria-label=\"Associa Appuntamento\" class=\"md-icon-button md-primary\" ng-if=\"ab.wireTransfer && ab.checkAssociableAppointmentToWireTransferBtn(appointment) && ab.checkAssociateAppointmentToWireTransferBtn(appointment)\" ng-click=\"ab.setWireTransferAppointment(appointment)\"><md-icon md-font-icon=\"done\">done</md-icon></md-button><md-button title=\"Appuntamento Associato\" aria-label=\"Appuntamento Associato\" class=\"md-icon-button md-primary md-48\" ng-if=\"ab.wireTransfer && ab.checkAssociableAppointmentToWireTransferBtn(appointment) && !ab.checkAssociateAppointmentToWireTransferBtn(appointment)\"><md-icon md-font-icon=\"done\" style=\"color: green\">done</md-icon></md-button><md-button title=\"Archivia\" aria-label=\"Archivia\" class=\"md-icon-button md-primary\" ng-if=\"!ab.wireTransfer && ( (appointment.payment_type == \'B\' && appointment.price < 0) || (appointment.payment_type == \'M\' && appointment.payment_bon < 0) || (appointment.payment_type == \'T\' && appointment.payment_satis < 0))\" ng-click=\"ab.archiveAppointment(appointment)\"><md-icon md-font-icon=\"archive\">archive</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"!ab.loading\" md-limit=\"ab.appointmentsListPag.per_page\" md-limit-options=\"ab.queryAppointments.limitOptions\" md-page=\"ab.appointmentsListPag.current_page\" md-total=\"{{ ab.appointmentsListPag.total }}\" md-boundary-links=\"ab.options.boundaryLinks\" md-on-paginate=\"ab.loadAppointments\"></md-table-pagination>");
$templateCache.put("app/components/bl-btn-appointment-documents/bl-btn-appointment-documents.html","<a ng-if=\"!appointment.closed\" class=\"btn btn-danger\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Consensi mancanti\" ng-click=\"vm.showDocuments( appointment )\"><i class=\"bi bi-card-checklist\"></i></a>");
$templateCache.put("app/components/bl-btn-appointment-info/bl-btn-appointment-info.html","<md-button ng-if=\"!vm.newlayout\" ng-click=\"vm.showInfo( vm.appointment )\" aria-label=\"Info Appuntamento\" ng-class=\"{\'md-icon-button\': true, \'md-accent\': vm.appointment.by_operator>0 && !vm.byOperator.store_id, \'md-warn\': vm.byOperator.store_id && (vm.appointment.cus_act_id || vm.appointment.lead_id) }\"><md-icon ng-if=\"vm.appointment.appointment_id!=null || vm.appointment.recalled==4\" title=\"Spostamento\" md-font-icon=\"schedule\">schedule</md-icon><md-icon ng-if=\"vm.appointment.appointment_id==null && vm.appointment.recalled!=4 && vm.appointment.lead_id != null && vm.lead.campagna!=\'Non fidelizzato\'\" title=\"Da Lead\" md-font-icon=\"input\">input</md-icon><md-icon ng-if=\"vm.appointment.appointment_id==null && vm.appointment.recalled!=4 && vm.appointment.lead_id != null && vm.lead.campagna==\'Non fidelizzato\'\" title=\"Da Lead\" md-font-icon=\"published_with_changes\">published_with_changes</md-icon><md-icon ng-if=\"(vm.appointment.by_operator > 0 && vm.appointment.by_operator!=36) && vm.appointment.appointment_id==null && vm.appointment.recalled!=4 && vm.appointment.lead_id == null\" title=\"Info booking\" md-font-icon=\"book\">book</md-icon><md-icon ng-if=\"vm.appointment.by_operator == 0 && vm.appointment.appointment_id==null && vm.appointment.recalled!=4 && vm.appointment.lead_id == null\" title=\"Online Booking\" md-font-icon=\"web\">web</md-icon><md-icon ng-if=\"vm.appointment.by_operator == 36 && vm.appointment.appointment_id==null && vm.appointment.recalled!=4 && vm.appointment.lead_id == null\" title=\"Bot Booking\" md-font-icon=\"message\">message</md-icon></md-button><a ng-if=\"vm.newlayout\" ng-click=\"vm.showInfo( vm.appointment )\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Info Appuntamento\" class=\"btn\" ng-class=\"{\'btn-primary\': !vm.byOperator.store_id || (!vm.appointment.cus_act_id && !vm.appointment.lead_id), \'btn-warning\': vm.byOperator.store_id && (vm.appointment.cus_act_id || vm.appointment.lead_id) }\"><i ng-if=\"vm.appointment.appointment_id!=null || vm.appointment.recalled==4\" title=\"Spostamento\" class=\"bi bi-clock\"></i> <i ng-if=\"vm.appointment.appointment_id==null && vm.appointment.recalled!=4 && vm.appointment.lead_id != null && vm.lead.campagna!=\'Non fidelizzato\'\" title=\"Da Lead\" class=\"bi bi-box-arrow-in-right\"></i> <i ng-if=\"vm.appointment.appointment_id==null && vm.appointment.recalled!=4 && vm.appointment.lead_id != null && vm.lead.campagna==\'Non fidelizzato\'\" title=\"Da Lead\" class=\"bi bi-chevron-bar-up\"></i> <i ng-if=\"(vm.appointment.by_operator > 0 && vm.appointment.by_operator!=36) && vm.appointment.appointment_id==null && vm.appointment.recalled!=4 && vm.appointment.lead_id == null\" title=\"Info booking\" class=\"bi bi-bookmark\"></i> <i ng-if=\"vm.appointment.by_operator == 0 && vm.appointment.appointment_id==null && vm.appointment.recalled!=4 && vm.appointment.lead_id == null\" title=\"Online Booking\" class=\"bi bi-window-sidebar\"></i> <i ng-if=\"vm.appointment.by_operator == 36 && vm.appointment.appointment_id==null && vm.appointment.recalled!=4 && vm.appointment.lead_id == null\" title=\"Bot Booking\" class=\"bi bi-chat-left-text\"></i></a>");
$templateCache.put("app/components/bl-btn-customer-history/bl-btn-customer-history.html","<md-button ng-click=\"vm.showHistory(entity)\" class=\"md-icon-button md-primary md-raised\" aria-label=\"Storico modifiche Cliente\"><md-icon title=\"Storico modifiche\" md-font-icon=\"change_history\">change_history</md-icon></md-button>");
$templateCache.put("app/components/bl-btn-lead-history/bl-btn-lead-history.html","<md-button ng-click=\"vm.showHistory(entity)\" class=\"md-icon-button md-primary md-raised\" aria-label=\"Storico modifiche lead\"><md-icon title=\"Storico modifiche\" md-font-icon=\"change_history\">change_history</md-icon></md-button>");
$templateCache.put("app/components/bl-customer-calls-list/bl-customer-calls-list.html","<md-backdrop ng-click=\"ab.closeSidebar()\" ng-show=\"ab.undoVisible && ! ab.isNewCustomer\" class=\"md-sidenav-backdrop md-opaque\"></md-backdrop><md-content class=\"page-calls-list\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"mic\">mic</md-icon><span class=\"inset\">Calls</span></h2><span flex=\"\" hide-xs=\"\"></span><md-button aria-label=\"Cliente\" class=\"md-accent md-raised\" ng-if=\"ab.customer_id\" ui-sref=\"home.customer( { customer_id : ab.customer_id } )\"><md-icon md-font-icon=\"person\">person</md-icon>Cliente</md-button></div></md-toolbar><md-card><md-card-header><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container flex=\"60\" md-no-float=\"\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" ng-keypress=\"ab.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><span flex=\"\" hide-xs=\"\"></span><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div></div></md-toolbar></md-card-header><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"ab.query.order\" md-on-reorder=\"ab.eListReOrder\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"date_start\"><span>Data</span></th><th md-column=\"\" md-order-by=\"customers.name\" ng-if=\"!ab.customer_id\"><span>Cliente</span></th><th md-column=\"\" md-order-by=\"users.name\"><span>Utente</span></th><th md-column=\"\" md-order-by=\"direction\"><span>Direzione</span></th><th md-column=\"\" md-order-by=\"type\"><span>Tipo</span></th><th md-column=\"\" md-order-by=\"direction\"><span>Durata</span></th><th md-column=\"\" md-order-by=\"3cx_id\"><span>Id 3CX</span></th><th md-column=\"\" md-order-by=\"3cx_extension\"><span>Centralino 3CX</span></th><th md-column=\"\" md-order-by=\"3cx_phone\"><span>Telefono 3CX</span></th><th md-column=\"\"><span>Azioni</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"8\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr ng-repeat=\"customerCall in ab.customerCalls\"><td md-cell=\"\">{{customerCall.date_fmt}}</td><td md-cell=\"\" ng-if=\"!ab.customer_id\">{{customerCall.customer.firstname}} {{customerCall.customer.lastname}}</td><td md-cell=\"\">{{customerCall.user.firstname}} {{customerCall.user.lastname}}</td><td md-cell=\"\">{{customerCall.direction}}</td><td md-cell=\"\">{{customerCall.type}}</td><td md-cell=\"\">{{customerCall.duration}}</td><td md-cell=\"\">{{customerCall[\'3cx_id\']}}</td><td md-cell=\"\">{{customerCall[\'3cx_extension\']}}</td><td md-cell=\"\">{{customerCall[\'3cx_phone\']}}</td><td md-cell=\"\" layout=\"row\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Scheda cliente\" ui-sref=\"home.customer( { customer_id : customerCall.customer_id } )\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button><md-button ng-if=\"ab.user.type == \'admin\' && customerCall.filename && !customerCall.hide\" class=\"md-icon-button md-primary md-raised\" aria-label=\"Download File\" target=\"_blank\" ng-href=\"{{ ab.env.API }}/customer-calls/download/{{customerCall[\'id\']}}?c_role={{ab.user.type}}&token={{ ab.token }}\"><md-icon md-font-icon=\"file_download\">file_download</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"!ab.loading\" md-limit=\"ab.listPagination.per_page\" md-page=\"ab.listPagination.current_page\" md-total=\"{{ ab.listPagination.total }}\" md-on-paginate=\"ab.loadItems\" md-boundary-links=\"ab.options.boundaryLinks\"></md-table-pagination></md-card-content></md-card></md-content>");
$templateCache.put("app/components/bl-customer-calls-modal/bl-customer-calls-modal.html","<md-button class=\"md-accent md-raised\" aria-label=\"Calls\" ng-click=\"ab.openModal()\"><md-icon md-font-icon=\"mic\">mic</md-icon>Calls</md-button>");
$templateCache.put("app/components/bl-pf-info/bl-pf-info.html","<div ng-if=\"customer.sourceCustomer\" layout=\"column\" flex=\"\"><h3>Segnalato da:</h3><span class=\"md-input\">{{ customer.sourceCustomer.data.lastname }} {{ customer.source_customer.lastname }} | <a href=\"tel:+39{{ e.customer.source_customer.phone }}\">{{ customer.sourceCustomer.data.phone }}</a></span><br><br></div><div ng-if=\"customer.phonefriends.data && customer.phonefriends.data.length>0\" layout=\"column\" flex=\"\"><h3>PhoneFriends:</h3><md-tabs class=\"md-dynamic-height\" md-selected=\"selectedPf\"><md-tab ng-repeat=\"friend in customer.phonefriends.data\" label=\"{{ friend.lastname }} {{ friend.firstname }} - {{ friend.phone }}\"></md-tab></md-tabs><div ng-repeat=\"friend in customer.phonefriends.data\" ng-if=\"selectedPf == $index\"><label class=\"md-input\">&nbsp;</label><md-table-container class=\"page-lead addressbook-appointments\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th align=\"center\" md-column=\"\">Pres.</th><th md-column=\"\">Centro</th><th md-column=\"\">Data</th><th md-column=\"\">Tratt.</th><th align=\"center\" md-column=\"\">1° v.</th><th md-column=\"\" md-numeric=\"\">Real.</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"appointment in friend.appointments.data | orderBy: \'-date_start\'\"><td align=\"center\" md-cell=\"\" class=\"{{appointment.recalled>=3?\'recalled_\'+appointment.recalled:( appointment.paid? \'\':\'app_notpaid\')}}\">{{ appointment.recalled==3?\'Disd\':(appointment.recalled==4?\'Spost\':(appointment.paid? \'Si\' :\'No\')) }}</td><td md-cell=\"\">{{ appointment.store.data.alias }}</td><td md-cell=\"\">{{ appointment.date_start_frmt?appointment.date_start_frmt:appointment.date_start }}</td><td md-cell=\"\">{{ appointment.treatment.name }}<md-icon title=\"Appuntamento con Abbonamento\" md-font-icon=\"autorenew\" ng-if=\"appointment.customer_subscription_id !== null\">autorenew</md-icon></td><td align=\"center\" md-cell=\"\">{{ 2 > appointment.user_times ? \'Si\' : \'No\' }}</td><td align=\"right\" md-cell=\"\">{{ appointment.price | number:2 }}</td></tr></tbody></table></md-table-container></div></div>");
$templateCache.put("app/components/bl-whatsapp/bl-whatsapp.html","<md-card-content style=\"overflow: auto; padding-top: 0px;\" ng-if=\"whatsapp.customer\"><md-button class=\"md-accent md-raised\" aria-label=\"Presa visione\" ng-click=\"whatsapp.takeView()\"><md-icon md-font-icon=\"done\">done</md-icon>Presa visione</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Imposta da leggere\" ng-click=\"whatsapp.unTakeView()\"><md-icon md-font-icon=\"highlight_off\">highlight_off</md-icon>Da leggere</md-button><div class=\"whatsapp-customer-selected-data md-toolbar-tools\"><span><b>{{whatsapp.customer.lastname}} {{whatsapp.customer.firstname}}</b></span> <span class=\"ml-5\">&nbsp;&nbsp;<a href=\"tel:{{whatsapp.customer.phone}}\">{{whatsapp.customer.phone}}</a></span></div><div class=\"whatsapp-messages-container\"><md-progress-circular md-diameter=\"30\" ng-if=\"whatsapp.loadingMessagesList\" md-mode=\"indeterminate\"></md-progress-circular><md-list class=\"whatsapp-messages-list\"><div ng-repeat=\"message in whatsapp.userSelectedMessagesList\" class=\"whatsapp-message-container\" ng-class=\"message.f_sent == 0 ? \'whatsapp-message-customer\' : \'whatsapp-message-centro\'\" ng-init=\"whatsapp.scrollToId && message.id == whatsapp.scrollToId.id && whatsapp.finishedLoadMessages(message)\"><md-card class=\"md-2-line\"><div class=\"md-list-item-text whatsapp-single-message-container\" id=\"message-{{message.id}}\"><cite ng-if=\"message.user && message.user.id != 0\">{{message.f_sent == 0 ? \'Letto da \' : \'Inviato da \'}}{{message.user.firstname}} {{message.user.lastname}}</cite><p ng-bind-html=\"message.message | unsafe\" ng-if=\"message.ext_type!=\'voice\' && message.ext_type!=\'image\' && message.ext_type!=\'attachment\' && message.ext_type!=\'video\' && message.ext_type!=\'audio\'\"></p><audio controls=\"\" ng-if=\"message.ext_type==\'voice\' || message.ext_type==\'audio\'\"><source src=\"{{message.media_url}}\"><a ng-href=\"{{message.media_url}}\" target=\"_blank\" style=\"display:block; text-align:center;\"><span class=\"material-icons\">play_circle_outline</span></a></audio><p ng-if=\"message.ext_type==\'image\'\"><img src=\"{{message.media_url}}\" style=\"max-width:100%;\"><br></p><p ng-if=\"message.ext_type==\'attachment\'\"><a ng-bind-html=\"message.media_icon\" ng-href=\"{{message.media_url}}\" target=\"_blank\" style=\"display:block; text-align:center;\"></a><br></p><video ng-if=\"message.ext_type==\'video\'\" width=\"100%\" controls=\"\"><source src=\"{{message.media_url}}\" type=\"{{message.ext_mime_type}}\"><a ng-bind-html=\"message.media_icon\" ng-href=\"{{message.media_url}}\" target=\"_blank\" style=\"display:block; text-align:center;\"></a></video><span ng-if=\"message.caption\" ng-bind-html=\"message.caption\"></span><div layout=\"row\" style=\"text-align: right;\"><cite flex=\"100\" class=\"message-date\">{{message.created_at_formatted}}</cite><md-icon style=\"color:#53bdeb; font-size: 22px; font-weight: bold;\" ng-if=\"message.ext_status == \'read\'\" md-font-icon=\"done_all\">done_all</md-icon><md-icon style=\"color:#53bdeb; font-size: 22px; font-weight: bold;\" ng-if=\"message.ext_status == \'readed\'\" md-font-icon=\"done\">done</md-icon><md-icon style=\"color:grey; font-size: 22px; font-weight: bold;\" ng-if=\"message.ext_status == \'sent\'\" md-font-icon=\"done_all\">done</md-icon><md-icon style=\"color:grey; font-size: 22px; font-weight: bold;\" ng-if=\"message.ext_status == \'delivered\'\" md-font-icon=\"done_all\">done_all</md-icon><md-icon style=\"color:red; font-size: 22px; font-weight: bold;\" ng-if=\"message.ext_status == \'failed\'\" md-font-icon=\"cancel\">cancel</md-icon></div></div></md-card></div></md-list></div><div ng-if=\"whatsapp.lastMessage\"><i>Ultimo messaggio ricevuto: {{whatsapp.lastMessage.created_at_frmt}}</i></div><div layout=\"row\"><md-select flex=\"70\" id=\"waTemplate\" name=\"waTemplate\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"WApp Template\" placeholder=\"Seleziona un template\" ng-model=\"whatsapp.templateSelected\"><md-option ng-value=\"null\" ng-if=\"vm.isLastUserMessageInH24\"></md-option><md-option ng-value=\"waTemplate\" ng-repeat=\"waTemplate in whatsapp.waTemplatesList | orderBy: \'title\'\">{{ waTemplate.title }}</md-option></md-select></div><div class=\"whatsapp-text-area-container\"><div ng-if=\"whatsapp.templateSelected && whatsapp.templateSelected.url_image\"><img src=\"{{whatsapp.templateSelected.url_image}}\"></div><div ng-bind-html=\"whatsapp.templateSelected.blade_header\" ng-if=\"whatsapp.templateSelected\"></div><div layout=\"row\"><textarea ng-model=\"whatsapp.messageToSend\" ng-change=\"whatsapp.changeMessage()\"></textarea><md-button class=\"md-button md-primary\" aria-label=\"Invia\" ng-disabled=\"!whatsapp.templateSelected && !whatsapp.isLastUserMessageInH24 || whatsapp.sending\" ng-click=\"whatsapp.sendMessage(whatsapp.templateSelected)\"><md-icon ng-if=\"!whatsapp.sending\" md-font-icon=\"send\">send</md-icon><md-progress-circular md-diameter=\"20\" ng-if=\"whatsapp.sending\" md-mode=\"indeterminate\"></md-progress-circular></md-button></div><div layout=\"row\" style=\"margin-top:20px;\"><h4>Invia un audio</h4><md-button class=\"md-button md-primary\" ng-style=\"{\'display\':(!whatsapp.recording)?\'inline-block\':\'none\'}\" id=\"user_audio_play\" name=\"user_audio_play\" ng-click=\"whatsapp.sendAudio();\"><span class=\"material-icons\" ng-style=\"{\'font-size\':\'50px\', \'color\':\'green\'}\">play_circle_outline</span></md-button><md-button class=\"md-button md-primary\" ng-style=\"{\'display\':(whatsapp.recording)?\'inline-block\':\'none\'}\" id=\"user_audio_stop\" name=\"user_audio_stop\"><span class=\"material-icons\" ng-style=\"{\'font-size\':\'50px\', \'color\':\'red\'}\">send</span></md-button><md-button class=\"md-button md-primary\" ng-style=\"{\'display\':(whatsapp.recording)?\'inline-block\':\'none\'}\" id=\"user_audio_cancel\" name=\"user_audio_cancel\" ng-click=\"whatsapp.cancelAudio();\"><span class=\"material-icons\" ng-style=\"{\'font-size\':\'50px\', \'color\':\'red\'}\">cancel</span></md-button></div><div flex=\"100\" ng-bind-html=\"whatsapp.templateSelected.blade_footer\" ng-if=\"whatsapp.templateSelected\"></div></div></md-card-content>");
$templateCache.put("app/components/bl-wire-transfers/bl-wire-transfers.html","<md-table-header><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container md-no-float=\"\" class=\"md-accent\" flex=\"30\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.queryWireTransfers.filter\" ng-keypress=\"ab.onKeyPressSearchWireTransfer($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><div flex=\"30\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" md-placeholder=\"Filtra data iniziale\" ng-model=\"ab.queryWireTransfers.filter_date_start\" md-min-date=\"ab.minDateFilter\" ng-change=\"ab.onChangeDateStartWireTransfer()\"></md-datepicker></div><div flex=\"30\" hide-xs=\"\" hide-sm=\"\" style=\"margin-left:35px;\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" md-placeholder=\"Filtra data finale\" md-min-date=\"ab.queryWireTransfers.filter_date_start\" ng-model=\"ab.queryWireTransfers.filter_date_end\" ng-change=\"ab.onChangeDateEndWireTransfer()\"></md-datepicker></div><div flex=\"5\" hide-xs=\"\" hide-sm=\"\" style=\"margin-left:35px;\"><md-button title=\"Download\" aria-label=\"Download\" class=\"md-icon-button md-primary\" ng-click=\"ab.loadWireTransfers(null, null, true)\"><md-icon md-font-icon=\"save\">save</md-icon></md-button></div></div></md-toolbar></md-table-header><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"ab.queryWireTransfers.order\" md-on-reorder=\"ab.reorderWireTransfers\" class=\"tab-head\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"transfer_date\"><span>Data Bonifico</span></th><th md-column=\"\" md-order-by=\"customer\"><span>Cliente</span></th><th md-column=\"\" md-order-by=\"amount\"><span>Importo</span></th><th md-column=\"\" md-order-by=\"associated_amount\"><span>Associato</span></th><th md-column=\"\"><span>Azioni</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loadingWireTransfers\"><td md-cell=\"\" colspan=\"10\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loadingWireTransfers\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" ng-repeat=\"wireTransfer in ab.wireTransfers\"><td md-cell=\"\">{{wireTransfer.transfer_date_frmt}}</td><td md-cell=\"\">{{wireTransfer.customer}}</td><td md-cell=\"\">{{wireTransfer.amount | number:2 }} {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</td><td md-cell=\"\">{{wireTransfer.associated_amount | number:2 }} {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</td><td md-cell=\"\" class=\"icon-button\"><md-button title=\"Dettagli\" aria-label=\"Dettagli\" class=\"md-icon-button md-primary\" ng-click=\"ab.showDetailsModal(wireTransfer)\"><md-icon md-font-icon=\"book\">book</md-icon></md-button><md-button title=\"Associa il Bonifico\" aria-label=\"Associa il Bonifico\" class=\"md-icon-button md-primary\" ng-if=\"!ab.archive\" ng-click=\"ab.showAssignAppointmentsModal(wireTransfer)\"><md-icon md-font-icon=\"add\">add</md-icon></md-button><md-button title=\"Appuntamenti Associati\" aria-label=\"Appuntamenti Associati\" class=\"md-icon-button md-primary\" ng-if=\"wireTransfer.appointment_wire_transfers && wireTransfer.appointment_wire_transfers.length > 0\" ng-click=\"ab.showAssociatedAppointmentsModal(wireTransfer)\"><md-icon md-font-icon=\"list\">list</md-icon></md-button><md-button title=\"Elimina il Bonifico\" aria-label=\"Elimina il Bonifico\" class=\"md-icon-button md-primary\" ng-click=\"ab.deleteWireTransfer(wireTransfer)\" ng-if=\"!wireTransfer.appointment_wire_transfers || wireTransfer.appointment_wire_transfers.length == 0\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"!ab.loading\" md-limit=\"ab.wireTransfersListPag.per_page\" md-limit-options=\"ab.queryWireTransfers.limitOptions\" md-page=\"ab.wireTransfersListPag.current_page\" md-total=\"{{ ab.wireTransfersListPag.total }}\" md-boundary-links=\"ab.options.boundaryLinks\" md-on-paginate=\"ab.loadWireTransfers\"></md-table-pagination>");
$templateCache.put("app/components/bl-wire-transfers-cofidis/bl-wire-transfers-cofidis.html","<md-table-header><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><div flex=\"30\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" md-placeholder=\"Filtra data iniziale\" ng-model=\"ab.queryWireTransfers.filter_date_start\" md-min-date=\"ab.minDateFilter\" ng-change=\"ab.onChangeDateStartWireTransfer()\"></md-datepicker></div><div flex=\"30\" hide-xs=\"\" hide-sm=\"\" style=\"margin-left:35px;\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" md-placeholder=\"Filtra data finale\" md-min-date=\"ab.queryWireTransfers.filter_date_start\" ng-model=\"ab.queryWireTransfers.filter_date_end\" ng-change=\"ab.onChangeDateEndWireTransfer()\"></md-datepicker></div><div flex=\"30\" hide-xs=\"\" hide-sm=\"\"><md-button title=\"Elimina Importazione\" aria-label=\"Elimina Importazione\" class=\"md-icon-button md-primary\" ng-click=\"ab.deleteImport()\" ng-if=\"ab.user.type==\'admin\'\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></div></div></md-toolbar></md-table-header><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"ab.queryWireTransfers.order\" md-on-reorder=\"ab.reorderWireTransfers\" class=\"tab-head\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"transfer_date\"><span>Data Bonifico</span></th><th md-column=\"\" md-order-by=\"sum_wire_transfers\"><span>Totale Cofidis</span></th><th md-column=\"\" md-order-by=\"sum_appointments\"><span>Totale Appuntamenti</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loadingWireTransfers\"><td md-cell=\"\" colspan=\"10\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loadingWireTransfers\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" ng-repeat=\"wireTransfer in ab.wireTransfers\" style=\"{{ (wireTransfer.sum_wire_transfers != wireTransfer.sum_appointments)? \'background-color: #ffff99;\': \'\' }}\"><td md-cell=\"\">{{wireTransfer.transfer_date_frmt}}</td><td md-cell=\"\">{{wireTransfer.sum_wire_transfers | number:2 }} {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</td><td md-cell=\"\">{{(wireTransfer.sum_appointments? wireTransfer.sum_appointments : 0) | number:2 }} {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"!ab.loading\" md-limit=\"ab.wireTransfersListPag.per_page\" md-limit-options=\"ab.queryWireTransfers.limitOptions\" md-page=\"ab.wireTransfersListPag.current_page\" md-total=\"{{ ab.wireTransfersListPag.total }}\" md-boundary-links=\"ab.options.boundaryLinks\" md-on-paginate=\"ab.loadCofidis\"></md-table-pagination>");
$templateCache.put("app/components/bl-wire-transfers-consumer-credit/bl-wire-transfers-consumer-credit.html","<md-table-header><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><div flex=\"30\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" md-placeholder=\"Filtra data iniziale\" ng-model=\"ab.queryWireTransfers.filter_date_start\" md-min-date=\"ab.minDateFilter\" ng-change=\"ab.onChangeDateStartWireTransfer()\"></md-datepicker></div><div flex=\"30\" hide-xs=\"\" hide-sm=\"\" style=\"margin-left:35px;\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" md-placeholder=\"Filtra data finale\" md-min-date=\"ab.queryWireTransfers.filter_date_start\" ng-model=\"ab.queryWireTransfers.filter_date_end\" ng-change=\"ab.onChangeDateEndWireTransfer()\"></md-datepicker></div><div flex=\"30\" hide-xs=\"\" hide-sm=\"\"><md-button title=\"Elimina Importazione\" aria-label=\"Elimina Importazione\" class=\"md-icon-button md-primary\" ng-click=\"ab.deleteImport()\" ng-if=\"ab.user.type==\'admin\'\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></div></div></md-toolbar></md-table-header><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"ab.queryWireTransfers.order\" md-on-reorder=\"ab.reorderWireTransfers\" class=\"tab-head\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"transfer_date\"><span>Data Bonifico</span></th><th md-column=\"\" md-order-by=\"sum_wire_transfers\"><span>Totale Credito Al Consumo</span></th><th md-column=\"\" md-order-by=\"sum_appointments\"><span>Totale Appuntamenti</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loadingWireTransfers\"><td md-cell=\"\" colspan=\"10\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.loadingWireTransfers\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" ng-repeat=\"wireTransfer in ab.wireTransfers\" style=\"{{ (wireTransfer.sum_wire_transfers != wireTransfer.sum_appointments)? \'background-color: #ffff99;\': \'\' }}\"><td md-cell=\"\">{{wireTransfer.transfer_date_frmt}}</td><td md-cell=\"\">{{wireTransfer.sum_wire_transfers | number:2 }} {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</td><td md-cell=\"\">{{(wireTransfer.sum_appointments? wireTransfer.sum_appointments : 0) | number:2 }} {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"!ab.loading\" md-limit=\"ab.wireTransfersListPag.per_page\" md-limit-options=\"ab.queryWireTransfers.limitOptions\" md-page=\"ab.wireTransfersListPag.current_page\" md-total=\"{{ ab.wireTransfersListPag.total }}\" md-boundary-links=\"ab.options.boundaryLinks\" md-on-paginate=\"ab.loadCofidis\"></md-table-pagination>");
$templateCache.put("app/components/bm-appointment-sidenav/bm-appointment-sidenav.html","<md-sidenav md-whiteframe=\"4\" class=\"page-appointments md-sidenav-right\" md-disable-backdrop=\"\" md-component-id=\"bm-appointment-sidenav\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"book\">book</md-icon><h2 class=\"md-headline\"><span class=\"inset\" ng-if=\"! ap.isNewAppointment && ap.updatingField == null\">Modifica appuntamento per {{ ap.activeAppointment.customer.data.firstname ? ap.activeAppointment.customer.data.firstname + \" (aid:\" + ap.activeAppointment.id + \")\" : \'questo utente\' }}</span> <span class=\"inset\" ng-if=\"! ap.isNewAppointment && ap.updatingField == \'price\'\">Modifica {{ap.env.currency?ap.env.currency.label.toLowerCase():\'prezzo\'}} per {{ ap.activeAppointment.customer.data.firstname ? ap.activeAppointment.customer.data.firstname + \" (aid:\" + ap.activeAppointment.id + \")\" : \'questo utente\' }}</span> <span class=\"inset\" ng-if=\"ap.isNewAppointment\">Crea appuntamento</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ap.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><div layout=\"row\" class=\"app-customer-info soft-toolbar {{ ap.appCustomerParams.coupon_title ? \'app-customer-info-coupon\' : \'\' }}\" ng-if=\"(ap.env.shoppingPlusEnabled) && ((ap.appCustomerParams | json) != \'{}\')\"><div class=\"main-toolbar phone\"><md-icon md-font-icon=\"phone_iphone\">phone_iphone</md-icon></div><table><tr><th colspan=\"3\" ng-if=\"ap.appCustomerParams.coupon_title\"><span class=\"bold\">Coupon:</span> {{ ap.appCustomerParams.coupon_title }}</th></tr><tr><td class=\"app-customer-info-input\"><md-input-container class=\"md-block\"><label for=\"app_customer_points\">Punti accumulati</label> <input id=\"app_customer_points\" ng-disabled=\"true\" ng-model=\"ap.appCustomerParams.app_customer_points\"></md-input-container></td><td class=\"app-customer-info-input\"><md-input-container class=\"md-block\"><label for=\"app_customer_balance\">&euro;</label> <input id=\"app_customer_balance\" ng-disabled=\"true\" ng-model=\"ap.appCustomerParams.app_customer_balance\"></md-input-container></td><td class=\"app-customer-info-input\"><md-input-container class=\"md-block\"><label for=\"app_customer_card_date\">Data emissione CARD</label> <input type=\"text\" id=\"app_customer_card_date\" ng-disabled=\"true\" ng-model=\"ap.appCustomerParams.app_customer_card_date\"></md-input-container></td></tr></table></div><form autocomplete=\"off\" role=\"form\" name=\"appointmentForm\" id=\"appointmentForm\" layout=\"column\"><div flex=\"100\" layout=\"column\" class=\"fix-margins-3 min-height-60\" ng-if=\"ap.updatingField != \'price\'\"><label class=\"md-label\" for=\"treatmentdate\">Data del trattamento</label><md-datepicker class=\"md-datepicker-full-width md-datepicker-remove-red-border\" id=\"treatmentdate\" name=\"treatmentdate\" md-placeholder=\"Data del trattamento\" md-min-date=\"ap.minday\" ng-model=\"ap.treatmentdate\" ng-change=\"ap.resetAvailabilities()\" required=\"\"></md-datepicker></div><br ng-if=\"ap.updatingField != \'price\'\"><h3 ng-show=\"false\">Store id {{ap.activeAppointment.store_id}} / user id = {{ap.activeAppointment.user_id}}</h3><h3 ng-show=\"false\" ng-repeat=\"user in ap.userRolesList | filter: {store_id: ap.activeAppointment.store_id, active: true, role: \'operator\'} : true | orderBy: \'user.lastname\'\">{{ user.user.id }} {{ user.user.lastname }} {{ user.user.firstname }}</h3><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"{{ !ap.activeAppointment.id && ap.portaEnabled?\'70\':\'100\'}}\"><label for=\"user_id\">Operatore</label><md-select ng-model=\"ap.activeAppointment.user_id\" aria-label=\"Operatore\" id=\"user_id\" name=\"user_id\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-change=\"ap.resetAvailabilities()\" required=\"\"><md-option ng-value=\"user.user_id\" ng-repeat=\"user in ap.userRolesList | filter: {store_id: ap.activeAppointment.store_id, active: true, role: \'operator\'} : true | orderBy: \'user.lastname\' track by user.id\"><div class=\"operator-circle\" style=\"background-color: {{ user.color }};\"></div>{{ user.user.lastname }} {{ user.user.firstname }}</md-option></md-select><div ng-messages=\"appointmentForm.user_id.$error\" ng-if=\"appointmentForm.user_id.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><span ng-if=\"!ap.activeAppointment.id && ap.portaEnabled\" flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"30\" ng-if=\"ap.portaEnabled\"><md-checkbox ng-model=\"ap.activeAppointment.f_over\" ng-disabled=\"(ap.activeAppointment.closed || ap.activeAppointment.recalled>=3)\" aria-label=\"Porta\" id=\"f_over\" name=\"f_over\">Porta</md-checkbox></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"50\"><label for=\"assist_user_id\">Assistente</label><md-select ng-model=\"ap.activeAppointment.assist_user_id\" aria-label=\"Assistente\" id=\"assist_user_id\" name=\"assist_user_id\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"user.user_id\" ng-repeat=\"user in ap.userRolesList | filter: {store_id: ap.activeAppointment.store_id, active: true} : true | orderBy: \'user.lastname\'\"><div class=\"operator-circle\" style=\"background-color: {{ user.color }};\"></div>{{ user.user.lastname }} {{ user.user.firstname }}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label for=\"commercial_user_id\">Commerciale</label><md-select ng-model=\"ap.activeAppointment.commercial_user_id\" aria-label=\"Commerciale\" id=\"commercial_user_id\" name=\"commercial_user_id\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"user.user_id\" ng-repeat=\"user in ap.userRolesList | filter: {store_id: ap.activeAppointment.store_id, active: true, role: \'!callcenter\'} : true | filter: {active: true, role: \'!admin\'} : true | orderBy: \'lastname\'\"><div class=\"operator-circle\" style=\"background-color: {{ user.color }};\"></div>{{ user.user.lastname }} {{ user.user.firstname }}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"{{ap.activeAppointment.customer.data.numero_visite<2 && !ap.activeAppointment.treatment.data.f_contab}}\"><label for=\"id_servizio\">Trattamento</label><md-select ng-model=\"ap.activeAppointment.treatment_id\" aria-label=\"Trattamento\" id=\"id_servizio\" name=\"id_servizio\" ng-change=\"ap.activeTreatmentChange()\" ng-disabled=\"!ap.isNewAppointment && !ap.activeAppointment.treatmentCanChange\" md-container-class=\"with-search\" required=\"\"><md-select-header ng-if=\"ap.isNewAppointment || (ap.user.type==\'admin\' && ap.activeAppointment.treatmentCanChange)\"><span class=\"md-select-search-container\"><input type=\"search\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_treatment\" name=\"filter_treatment\" ng-model=\"ap.query.filter_treatment\" ng-keyup=\"ap.onKeyUpTreatmentsSearch($event, this)\" ng-keydown=\"$event.stopPropagation()\" ng-click=\"$event.stopPropagation()\"></span></md-select-header><md-optgroup ng-if=\"ap.isNewAppointment || ap.user.type==\'admin\'\" label=\"{{ group.name }}\" ng-repeat=\"group in ap.treatmentsList track by group.id\"><md-option ng-value=\"treatment.id\" ng-repeat=\"treatment in group.treatments.data | filter: ap.query.filter_treatment | filter: {\'active\': 1, \'promo\': 0} : true | orderBy: [\'order\',\'name\',\'f_first_time\']\">{{ treatment.name }} {{treatment.f_first_time == 1 ? \'(1a volta)\':\'\'}}</md-option></md-optgroup><md-option ng-if=\"!ap.isNewAppointment && !ap.activeAppointment.treatmentCanChange\" ng-value=\"ap.activeAppointment.treatment_id\">{{ ap.activeAppointment.treatment_id | treatmentIdtoName : ap.treatmentsList }}</md-option><md-optgroup ng-if=\"!ap.isNewAppointment && ap.activeAppointment && !ap.activeAppointment.closed && ap.activeAppointment.recalled<3 && ap.activeAppointment.treatmentCanChange && ap.user.type!=\'admin\'\" label=\"{{ group.name }}\" ng-repeat=\"group in ap.treatmentsList track by group.id\"><md-option ng-value=\"treatment.id\" ng-repeat=\"treatment in group.treatments.data | filter: ap.query.filter_treatment | filter: {\'active\': 1, \'promo\': 0} : true | orderBy: [\'order\',\'name\',\'f_first_time\']\">{{ treatment.name }}</md-option></md-optgroup></md-select><div ng-messages=\"appointmentForm.id_servizio.$error\" ng-if=\"appointmentForm.id_servizio.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><span ng-if=\"ap.activeAppointment.customer.data.numero_visite<2 && !ap.treatment.f_contab\" flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"30\" ng-if=\"ap.activeAppointment.customer.data.numero_visite<2 && !ap.treatment.f_contab\"><md-checkbox ng-model=\"ap.activeAppointment.f_notdone\" ng-disabled=\"(ap.activeAppointment.closed || ap.activeAppointment.recalled>=3)\" aria-label=\"Non eseguito\" id=\"f_notdone\" name=\"f_notdone\" ng-true-value=\"1\" ng-false-value=\"0\">Non eseguito</md-checkbox></md-input-container><md-button style=\"margin-left: 10px; margin-bottom: 30px;\" ng-class=\"\'md-raised md-icon-button md-primary\'\" aria-label=\"Prodotti del trattamento\" ng-click=\"ap.manageTreatmentProducts( ap.activeAppointment )\" ng-if=\"ap.activeAppointment.treatment_id && !ap.activeAppointment.treatment.data.f_contab && ap.activeAppointment.id && !ap.activeAppointment.closed && !(ap.activeAppointment.recalled>=3)\"><md-icon md-font-icon=\"view_list\" aria-label=\"Medicinali usati\">view_list</md-icon></md-button></div><div ng-if=\"ap.appointmentProducts.length>0 && !ap.hideAppointmentProducts\" layout=\"row\" style=\"margin-bottom:25px;\"><table flex=\"100\"><tr><th align=\"left\">Medicinali usati</th><th align=\"right\">Q.tà</th></tr><tr ng-repeat=\"product_item in ap.appointmentProducts\"><td style=\"border-bottom: 1px solid rgba(0,0,0,0.15);\" align=\"left\">{{product_item.product.name}}</td><td style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.15);\" align=\"right\">{{product_item.qty}}</td></tr></table></div><div ng-if=\"ap.activeAppointment.treatment_id == 99\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"20\"><label for=\"card_area\">Area *</label> <input ng-disabled=\"true\" type=\"text\" id=\"card_area\" placeholder=\"Area\" ng-model=\"ap.card.area\"></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"20\"><label for=\"card_taglio\">Taglio</label><md-select ng-model=\"ap.card.value\" aria-label=\"Taglio\" id=\"card_taglio\" name=\"card_taglio\" ng-change=\"ap.card.setValue()\" ng-disabled=\"ap.activeAppointment.id\" required=\"\"><md-option ng-value=\"\'025\'\">025</md-option><md-option ng-value=\"\'050\'\">050</md-option><md-option ng-value=\"\'100\'\">100</md-option><md-option ng-value=\"\'150\'\">150</md-option><md-option ng-value=\"\'200\'\">200</md-option><md-option ng-value=\"\'250\'\">250</md-option><md-option ng-value=\"\'300\'\">300</md-option><md-option ng-value=\"\'350\'\">350</md-option><md-option ng-value=\"\'400\'\">400</md-option><md-option ng-value=\"\'450\'\">450</md-option><md-option ng-value=\"\'500\'\">500</md-option></md-select><div ng-messages=\"appointmentForm.card_taglio.$error\" ng-if=\"appointmentForm.card_taglio.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container class=\"md-block\" flex=\"45\"><label for=\"availability\">Ultime 6 cifre Giftcard</label><md-select aria-label=\"Numero\" id=\"card_number\" name=\"card_number\" ng-model=\"ap.activeAppointment.gift_number\" ng-disabled=\"ap.activeAppointment.id || ap.card.loading || !ap.card.value\" md-container-class=\"with-search\" required=\"\"><md-select-header ng-if=\"!ap.activeAppointment.id\"><span class=\"md-select-search-container\"><input type=\"{{ ap.card.loading? \'hidden\' : \'search\' }}\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_card_number\" name=\"filter_card_number\" ng-keydown=\"$event.stopPropagation()\" ng-click=\"$event.stopPropagation()\" ng-keyup=\"ap.card.onKeyUpSearch($event, this)\" ng-model=\"ap.card.filter_number\"></span></md-select-header><md-option ng-if=\"!ap.activeAppointment.id\" ng-value=\"card.number\" ng-repeat=\"card in ap.card.list | orderBy: number\">{{ card.number.substring(5,11) }}</md-option><md-option ng-if=\"ap.activeAppointment.id\" ng-value=\"ap.activeAppointment.gift_number\">{{ ap.activeAppointment.gift_number.substring(5,11) }}</md-option></md-select><div ng-messages=\"appointmentForm.card_number.$error\" ng-if=\"appointmentForm.card_number.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-progress-circular md-diameter=\"25\" ng-if=\"ap.card.loading\" md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"ap.updatingField != \'price\' && !ap.activeAppointment.f_over\"><div ng-if=\"appointmentForm.treatmentdate.$error.mindate\"><p>Per cambiare la disponibilità è necessario controllare la data del Trattamento.</p></div><md-input-container class=\"md-block\" ng-if=\"! appointmentForm.treatmentdate.$error.mindate\"><label for=\"availability\">Disponibilità</label><md-select aria-label=\"Cambia la Disponibilità\" id=\"availability\" name=\"availability\" md-on-open=\"ap.availabilityLoad()\" ng-model=\"ap.selectedAvaibility\" ng-required=\"ap.selectedAvaibilityRequired\"><md-option ng-value=\"$index\" ng-repeat=\"availability in ap.availabilitiesList track by $index\"><span>dalle</span> <strong>{{ availability.date_start | splitTimeFilter | limitTo:5 }}</strong> <span>alle</span> <strong>{{ availability.date_end | splitTimeFilter | limitTo:5 }}</strong></md-option></md-select><div ng-messages=\"appointmentForm.availability.$error\" ng-if=\"appointmentForm.availability.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container></div><div layout=\"row\" ng-if=\"ap.updatingField != \'price\' && ap.activeAppointment.f_over\"><md-input-container flex=\"50\" class=\"md-block\"><label for=\"startTime\">Inizio</label> <input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"startTime\" short-time=\"false\" placeholder=\"Inizio\" format=\"HH:mm\" ng-model=\"ap.activeAppointment.start\" ng-change=\"ap.activeStartChange()\"></md-input-container><span flex=\"nogrow\" class=\"min-width-16\" hide-xs=\"\" hide-sm=\"\"></span><md-input-container flex=\"50\" class=\"md-block\"><label for=\"endTime\">Fine</label> <input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" ng-disabled=\"true\" type=\"text\" id=\"endTime\" short-time=\"false\" placeholder=\"Fine\" format=\"HH:mm\" ng-model=\"ap.activeAppointment.end\"></md-input-container></div><div ng-if=\"ap.isNewAppointment\" layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"100\"><label for=\"availability\">Cliente</label><md-select aria-label=\"Cliente\" id=\"customer_id\" name=\"customer_id\" ng-model=\"ap.customer_id\" ng-change=\"ap.checkSubscriptionByUserNewAppointment(ap.customer_id); ap.getCustomerAppId(ap.customer_id)\" ng-model-options=\"ap.filter.options\" ng-disabled=\"ap.customersLoading\" md-container-class=\"with-search\" required=\"\"><md-select-header><span class=\"md-select-search-container\"><input type=\"{{ ap.customersLoading? \'hidden\' : \'search\' }}\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_customer\" name=\"filter_customer\" ng-keydown=\"$event.stopPropagation()\" ng-click=\"$event.stopPropagation()\" ng-keyup=\"ap.onKeyUpCustomersSearch($event, this)\" ng-model=\"ap.query.filter_customer\"></span></md-select-header><md-option ng-value=\"customer.id\" ng-repeat=\"customer in ap.customersList | orderBy: fullName track by customer.id\">{{ customer.fullName }} [{{customer.phone}}]</md-option></md-select><div ng-messages=\"appointmentForm.availability.$error\" ng-if=\"appointmentForm.availability.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container><md-progress-circular md-diameter=\"30\" ng-if=\"ap.customersLoading\" md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\"><md-input-container ng-if=\"!ap.storno && ap.treatment.f_abb\" class=\"md-block\" flex=\"50\" style=\"margin: 0px;\"><md-checkbox aria-label=\"Abbonamento\" id=\"type\" name=\"type\" ng-change=\"ap.appointmentTypeChange()\" ng-model=\"ap.activeAppointment.type\" ng-true-value=\"\'abb\'\" ng-false-value=\"null\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3 || ap.activeAppointment.f_notdone\">Abbonamento</md-checkbox></md-input-container><md-input-container ng-if=\"!ap.storno && (ap.treatment.f_abb ||ap.treatment.id == 99)\" class=\"md-block\" flex=\"50\" style=\"margin-top: 0px;\"><label for=\"type\">Tipologia</label><md-select aria-label=\"Tipologia\" id=\"type_app\" name=\"type_app\" ng-change=\"ap.appointmentTypeAppChange()\" ng-model=\"ap.activeAppointment.type_app\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-option ng-value=\"typology.value\" ng-repeat=\"typology in ap.appointmentTypologies\">{{typology.label}}</md-option></md-select></md-input-container></div><div layout=\"row\" style=\"margin: 0px;\" ng-if=\"ap.activeAppointment.type == \'abb\'\"><md-input-container class=\"md-block\" flex=\"50\" ng-if=\"ap.subscriptionsListByCustomer.length > 0\"><label for=\"id_servizio\">Abbonamenti selezionabili</label><md-select ng-model=\"ap.activeAppointment.customer_subscription_id\" aria-label=\"Abbonamenti Attivi\" id=\"customer_subscription_id\" name=\"customer_subscription_id\" ng-change=\"ap.customerSubscriptionIdChange()\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-option ng-value=\"customerSubscription.id\" ng-repeat=\"customerSubscription in ap.subscriptionsListByCustomer\"><span ng-if=\"customerSubscription.subscription_id!=1000\">{{ customerSubscription.subscription.data.name }}</span> <span ng-if=\"customerSubscription.subscription_id==1000\">Percorso personalizzato n. {{ customerSubscription.quotation.data.id }} {{ customerSubscription.app_total }} sedute</span> ( {{ customerSubscription.app_total-customerSubscription.app_remaining }} eseguit{{customerSubscription.app_total-customerSubscription.app_remaining==1?\'a\':\'e\'}}/prenotat{{customerSubscription.app_total-customerSubscription.app_remaining==1?\'a\':\'e\'}} ) [id:{{customerSubscription.id}}]</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\" ng-if=\"ap.subscriptionsListByCustomer.length <= 0\"><span class=\"color-grey\">Nessun Abbonamento attivo</span></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label for=\"id_servizio\">Nuovo Abbonamento</label><md-select ng-model=\"ap.activeAppointment.subscription_new_id\" aria-label=\"Nuovo Abbonamento\" id=\"subscription_new_id\" name=\"subscription_new_id\" ng-change=\"ap.subscriptionNewIdChange()\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-option ng-value=\"subscriptionNew.id\" ng-repeat=\"subscriptionNew in ap.subscriptionsListFiltered | filter: {active: 1}: true | orderBy: \'name\'\">{{ subscriptionNew.name }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\" style=\"margin-bottom: 0px;\"><md-checkbox ng-if=\"ap.activeAppointment.type == \'abb\'\" flex=\"50\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-change=\"ap.fExcludeChange()\" ng-model=\"ap.activeAppointment.f_exclude\">Escludi seduta da abbonamento</md-checkbox><md-checkbox ng-if=\"ap.activeAppointment.type == \'abb\'\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"!ap.maxRate || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-change=\"ap.fExcludeChange()\" ng-model=\"ap.activeAppointment.f_abb_payall\">Pagamento non rateizzato</md-checkbox></div><div ng-if=\"ap.refEnabled\" layout=\"row\" layout-align=\"start center\"><md-checkbox flex=\"50\" ng-true-value=\"1\" ng-false-value=\"0\" ng-change=\"ap.paymentPosUpdate()\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model=\"ap.activeAppointment.f_ref\">Ref.</md-checkbox></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"50\" style=\"margin-bottom: 0px;\" ng-if=\"!ap.storno\"><label for=\"price_treatment\">{{ap.env.currency?ap.env.currency.label:\'Prezzo trattamento (in &euro;)\'}}</label> <input type=\"number\" name=\"price_treatment\" id=\"price_treatment\" step=\"0.01\" min=\"0\" ng-disabled=\"!ap.canEdit.price_treatment\" ng-model=\"ap.activeAppointment.price_treatment\" ng-model-options=\"ap.filter.options\" required=\"\" ng-blur=\"ap.paymentPosUpdate()\"><div ng-messages=\"appointmentForm.price_treatment.$error\" ng-show=\"appointmentForm.price_treatment.$dirty\"><div ng-message=\"notzero\">Il prezzo non pu&ograve; essere zero per trattamenti non groupon e non in abbonamento</div><div ng-message=\"infcompresi\">Il prezzo non pu&ograve; essere inferiore al valore dei prodotti compresi: {{ ap.activeAppointment.product_price_in + ap.activeAppointment.product_price10_in | number:2 }}</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\" ng-if=\"!ap.storno && ap.activeAppointment.treatment_name.endsWith(\' GP\')\" style=\"margin-bottom: 0px;\"><label ng-disabled=\"!ap.activeAppointment.treatment_name.endsWith(\' GP\')\" for=\"coupon_price\">{{ap.env.currency?ap.env.currency.label + \' coupon\':\'Coupon (&euro;)\'}}</label> <input ng-disabled=\"!ap.activeAppointment.treatment_name.endsWith(\' GP\')\" type=\"number\" name=\"coupon_price\" id=\"coupon_price\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.coupon_price\" ng-model-options=\"ap.filter.options\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"ap.treatment.f_prod && !ap.isNewAppointment && !ap.storno && (ap.activeAppointment.product_price_in>0 || ap.activeAppointment.product_price10_in>0)\"><md-input-container class=\"md-block\" flex=\"45\" style=\"margin-bottom:0px; margin-top:0px;\"><label for=\"product_price\">{{ap.env.currency?ap.env.currency.label + \' prodotti compresi\':\'Prodotti compresi (iva 22%)\'}}</label> <input type=\"number\" name=\"product_price_in\" id=\"product_price_in\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.product_price_in\" ng-model-options=\"ap.filter.options\" ng-disabled=\"\'true\'\"></md-input-container><md-button style=\"margin-left: 10px; margin-bottom: 30px;\" ng-class=\"\'md-raised md-icon-button md-primary\'\" aria-label=\"Prodotti\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-click=\"ap.manageProducts( ap.activeAppointment )\"><md-icon md-font-icon=\"shopping_cart\">shopping_cart</md-icon></md-button><md-input-container class=\"md-block\" flex=\"45\"><label for=\"product_price10\">{{ap.env.currency?ap.env.currency.label + \' prodotti compresi\':\'Prodotti compresi (iva 10%)\'}}</label> <input type=\"number\" name=\"product_price10_in\" id=\"product_price10_in\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.product_price10_in\" ng-model-options=\"ap.filter.options\" ng-disabled=\"\'true\'\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"ap.treatment.f_prod && !ap.isNewAppointment && !ap.storno\"><md-input-container class=\"md-block\" flex=\"45\" style=\"margin-bottom:0px; margin-top:0px;\"><label for=\"product_price\">{{ap.env.currency?ap.env.currency.label + \' prodotti venduti\':\'Prodotti venduti (iva 22%)\'}}</label> <input type=\"number\" name=\"product_price\" id=\"product_price\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.product_price\" ng-model-options=\"ap.filter.options\" ng-disabled=\"\'true\'\"></md-input-container><md-button style=\"margin-left: 10px; margin-bottom: 30px;\" ng-class=\"\'md-raised md-icon-button md-primary\'\" aria-label=\"Prodotti\" ng-click=\"ap.manageProducts( ap.activeAppointment )\"><md-icon md-font-icon=\"shopping_cart\">shopping_cart</md-icon></md-button><md-input-container class=\"md-block\" flex=\"45\"><label for=\"product_price10\">{{ap.env.currency?ap.env.currency.label + \' prodotti venduti\':\'Prodotti venduti (iva 10%)\'}}</label> <input type=\"number\" name=\"product_price10\" id=\"product_price10\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.product_price10\" ng-model-options=\"ap.filter.options\" ng-disabled=\"\'true\'\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:0px;\"><md-input-container class=\"md-block\" flex=\"50\" style=\"margin-bottom:0px; margin-top:0px;\" ng-if=\"ap.treatment.f_prod\"><label for=\"price_full\">{{ap.env.currency?ap.env.currency.label:\'Prezzo totale (in &euro;)\'}}</label> <input type=\"number\" name=\"price_full\" id=\"price_full\" step=\"0.01\" ng-model=\"ap.activeAppointment.price_full\" ng-model-options=\"ap.filter.options\" ng-disabled=\"\'true\'\" required=\"\" ng-change=\"ap.paymentPosUpdate()\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\" style=\"margin-bottom:0px; margin-top:0px;\" ng-if=\"ap.treatment.f_discount\"><label for=\"price_discounted\">{{ap.env.currency?ap.env.currency.label + \" con sconto\" :(ap.storno?\'Importo rimborso (in &euro;)\':\'Prezzo scontato (in &euro;)\')}}</label> <input type=\"number\" name=\"price_discounted\" id=\"price_discounted\" step=\"0.01\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model=\"ap.activeAppointment.price_discounted\" required=\"\" ng-change=\"ap.priceDiscountedCheck()\"><div ng-messages=\"appointmentForm.price_discounted.$error\" ng-show=\"appointmentForm.price_discounted.$dirty\"><div ng-message=\"overdiscount\">Lo sconto non pu&ograve; essere zero maggiore del {{ap.maxDiscount}}%, quindi il prezzo minimo &egrave; {{ (ap.activeAppointment.price_full*(100-ap.maxDiscount)/100) - (ap.activeAppointment.tri?ap.activeAppointment.tri:0) | number: 2 }}&euro;</div></div></md-input-container></div><div ng-if=\"(ap.activeAppointment.customer.data.payments && ap.activeAppointment.customer.data.payments.data && ap.activeAppointment.customer.data.payments.data.length>0) || (ap.activeAppointment.payments && ap.activeAppointment.payments.data && ap.activeAppointment.payments.data.length>0)\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Rate in scadenziario</th><th md-column=\"\" style=\"text-align: right;\">Scadenza</th><th md-column=\"\" style=\"text-align: right;\">Importo</th><th md-column=\"\" style=\"text-align: right;\">N.</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"p in payments = ap.activeAppointment.customer.data.payments.data.concat(ap.activeAppointment.payments.data) | orderBy: \'date\'\"><td md-cell=\"\"><md-checkbox style=\"margin-left: 10px;\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model=\"p.selected\" ng-change=\"ap.rataSelectionChange(p)\"></md-checkbox></td><td md-cell=\"\" style=\"text-align: right;\">{{ p.month }}/{{ p.year }}</td><td md-cell=\"\" style=\"text-align: right;\">{{ p.total }}&euro;</td><td md-cell=\"\" style=\"text-align: right;\">{{ p.num }}/{{ p.num_total }}</td></tr></tbody></table></md-table-container></div><md-input-container ng-show=\"true || !ap.storno && ( ap.activeAppointment.price_discounted>=ap.sogliaRateizzazione || (ap.activeAppointment.customer.data.payments && ap.activeAppointment.customer.data.payments.data && ap.activeAppointment.customer.data.payments.data.length>0) || (ap.activeAppointment.payments && ap.activeAppointment.payments.data && ap.activeAppointment.payments.data.length>0) )\" class=\"md-block\" flex=\"100\" style=\"margin-bottom:0px;\"><label for=\"price\">{{ap.env.currency?ap.env.currency.label +\' acconto\':\'Totale pagato (in &euro;)\'}}</label> <input type=\"number\" name=\"price\" id=\"price\" step=\"0.01\" ng-model=\"ap.activeAppointment.price\" required=\"\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3 || ap.activeAppointment.price_discounted<ap.sogliaRateizzazione || ap.activeAppointment.f_abb_payall || ap.activeAppointment.type!=\'abb\'\" ng-change=\"ap.priceCheck()\"><div ng-messages=\"appointmentForm.price.$error\" ng-show=\"appointmentForm.price.$dirty\"><div ng-message=\"lowerpayment\">Il totale pagato non pu&ograve; essere inferiore a <span ng-bind-html=\"ap.messageLowerPayment\"></span></div></div></md-input-container><div layout=\"row\" layout-align=\"start center\" ng-if=\"ap.activeAppointment.haveCard && ap.activeAppointment.totalcredit>0\"><md-input-container class=\"md-block\" flex=\"50\"><label for=\"credit\">Saldo punti</label> <input type=\"number\" name=\"customer_credit\" id=\"customer_credit\" ng-model=\"ap.activeAppointment.customer.data.credit\" ng-disabled=\"true\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label for=\"credit_usage\">Sconti disponibili</label><md-select style=\"margin-bottom: 20px;\" ng-model=\"ap.activeAppointment.credit_usage\" aria-label=\"Punti da usare\" id=\"credit_usage\" name=\"credit_usage\" ng-change=\"ap.paymentPosUpdate()\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-option ng-value=\"undefined\"></md-option><md-option ng-value=\"sconto\" ng-repeat=\"sconto in ap.sconti track by sconto.sconto\" ng-show=\"ap.activeAppointment.totalcredit>=sconto.credit && ap.activeAppointment.price_full>=sconto.limit\">{{sconto.credit}}pt. sconto {{sconto.sconto}}&euro; su spesa &gt;{{sconto.limit}}&euro;</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"false && ap.activeAppointment.haveCard && ap.activeAppointment.totalcredit>0\"><md-input-container class=\"md-block\" flex=\"50\"><label for=\"credit\">Sconto (in &euro;)</label> <input type=\"number\" name=\"discount\" id=\"discount\" ng-model=\"ap.activeAppointment.discount\" ng-disabled=\"true\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label for=\"price\">Totale scontato (in &euro;)</label> <input type=\"number\" name=\"price\" id=\"price\" step=\"0.01\" ng-model=\"ap.activeAppointment.price\" ng-model-options=\"ap.filter.options\" required=\"\" ng-disabled=\"true\"></md-input-container></div><div layout=\"row\" class=\"payment-section\" ng-if=\"!ap.env.currency || ap.env.currency.pos\"><div flex=\"45\"><style>\n                        #payment_type md-radio-button {\n                            margin-bottom: 54px;\n                        }\n                        </style><md-input-container class=\"md-block\" style=\"margin-top: 0\"><md-radio-group id=\"payment_type\" name=\"payment_type\" ng-change=\"ap.paymentPosUpdate()\" ng-required=\"true\" ng-model=\"ap.activeAppointment.payment_type\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-radio-button value=\"C\">Contanti</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref\" value=\"F\" ng-if=\"ap.env.consumerCreditEnabled\">Credito Al Consumo</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref\" value=\"P\" ng-if=\"!ap.storno\">Pos/Carta/App</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref\" value=\"D\" ng-if=\"ap.storno || !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\'\">Pagodil</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref\" value=\"S\" ng-if=\"ap.env.smallpayEnabled && !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\'\">Smallpay</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref\" value=\"B\">Bonifico</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref\" value=\"A\">Assegno</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref\" value=\"T\" ng-if=\"ap.env.satispayEnabled\">Satispay</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref\" value=\"M\" ng-if=\"!ap.storno\">Misto</md-radio-button><md-radio-button ng-disabled=\"ap.activeAppointment.f_ref\" value=\"G\" ng-if=\"!ap.storno && ap.env.giftcardEnabled && ap.activeAppointment.treatment_id!=99\">Giftcard</md-radio-button></md-radio-group></md-input-container></div><div flex=\"50\"><md-input-container class=\"md-block\"><label style=\"font-weight: bold; color: #ff5000;\">Contanti (in &euro;):</label> <input type=\"number\" name=\"payment_cash\" id=\"payment_cash\" step=\"0.01\" ng-value=\"(ap.activeAppointment.price - ap.activeAppointment.payment_pos - ap.activeAppointment.payment_dil - ap.activeAppointment.payment_cc - ap.activeAppointment.payment_card - ap.activeAppointment.payment_app - ap.activeAppointment.payment_small - ap.activeAppointment.payment_satis - ap.activeAppointment.payment_gift - ap.activeAppointment.payment_bon - ap.activeAppointment.payment_check).toFixed(2)\" ng-disabled=\"true\"></md-input-container><div layout=\"row\" ng-if=\"ap.env.consumerCreditEnabled\"><md-input-container class=\"flex-auto\"><label for=\"payment_cc\" style=\"font-weight: bold; color: #ff5000\">Importo Credito Al Consumo (in &euro;)</label> <input type=\"number\" name=\"payment_cc\" id=\"payment_cc\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_cc\" ng-disabled=\"(ap.activeAppointment.payment_type!=\'F\' && ap.activeAppointment.payment_type!=\'M\') || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container ng-if=\"ap.env.consumerCreditEnabled && (ap.activeAppointment.payment_type == \'F\' || ap.activeAppointment.payment_type == \'M\')\"><label for=\"installments_cc\" style=\"font-weight: bold; color: #ff5000;\">Rate CC</label><md-select ng-model=\"ap.activeAppointment.installments_cc\" id=\"installments_cc\" name=\"installments_cc\" ng-change=\"ap.paymentPosUpdate()\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-required=\"ap.activeAppointment.payment_type == \'F\'\"><md-option ng-value=\"n\" ng-repeat=\"n in ap.n_consumerCredit\">{{ n }}</md-option></md-select></md-input-container></div><div layout=\"row\" ng-if=\"!ap.storno\"><md-input-container class=\"flex-auto\"><label for=\"payment_pos\" style=\"font-weight: bold; color: #ff5000\">Importo POS (in &euro;)</label> <input type=\"number\" name=\"payment_pos\" id=\"payment_pos\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.payment_pos\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container ng-if=\"!ap.storno && ap.activeAppointment.payment_type == \'P\'\"><label for=\"payment_dil\" style=\"font-weight: bold; color: #ff5000;\">Tipo Pagamento</label><md-select ng-model=\"ap.activeAppointment.payment_pos_type\" id=\"payment_pos_type\" name=\"payment_pos_type\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" required=\"\"><md-option ng-value=\"\'P\'\">Pos</md-option><md-option ng-value=\"\'C\'\">Carta</md-option><md-option ng-value=\"\'A\'\">App</md-option></md-select></md-input-container></div><md-input-container class=\"md-block\" ng-if=\"ap.activeAppointment.payment_type == \'M\' && !ap.storno\"><label for=\"payment_card\" style=\"font-weight: bold; color: #ff5000;\">Importo Carta (in &euro;)</label> <input type=\"number\" name=\"payment_card\" id=\"payment_card\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.payment_card\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"ap.activeAppointment.payment_type == \'M\' && !ap.storno\"><label for=\"payment_app\" style=\"font-weight: bold; color: #ff5000;\">Importo APP (in &euro;)</label> <input type=\"number\" name=\"payment_app\" id=\"payment_app\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.payment_app\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><div layout=\"row\" ng-if=\"ap.storno || !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\'\"><md-input-container class=\"flex-auto\" ng-if=\"ap.storno || !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\'\"><label for=\"payment_dil\" style=\"font-weight: bold; color: #ff5000;\">Importo Pagodil (in &euro;)</label> <input type=\"number\" name=\"payment_dil\" id=\"payment_dil\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_dil\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container ng-if=\"(ap.storno || !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\') && (ap.activeAppointment.payment_type == \'D\' || ap.activeAppointment.payment_type == \'M\')\"><label for=\"payment_dil\" style=\"font-weight: bold; color: #ff5000;\">Rate Pagodil</label><md-select ng-model=\"ap.activeAppointment.installments_dil\" id=\"installments_dil\" name=\"installments_dil\" ng-change=\"ap.paymentPosUpdate()\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-required=\"ap.activeAppointment.payment_type == \'D\' || (ap.activeAppointment.payment_type == \'M\' && ap.activeAppointment.payment_dil > 0)\"><md-option ng-value=\"n\" ng-repeat=\"n in ap.n_installments\">{{ n }}</md-option></md-select></md-input-container></div><md-input-container class=\"md-block\" ng-if=\"ap.env.smallpayEnabled && !ap.activeAppointment.f_abb_payall && ap.activeAppointment.type==\'abb\'\"><label for=\"payment_small\" style=\"font-weight: bold; color: #ff5000;\">Importo Smallpay (in &euro;)</label> <input type=\"number\" name=\"payment_small\" id=\"payment_small\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_small\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" style=\"margin-bottom: 0px;\"><label for=\"payment_bon\" style=\"font-weight: bold; color: #ff5000;\">Importo Bonifico (in &euro;)</label> <input type=\"number\" name=\"payment_bon\" id=\"payment_bon\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_bon\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" style=\"margin-bottom: 0px;\"><label for=\"payment_check\" style=\"font-weight: bold; color: #ff5000;\">Importo Assegno (in &euro;)</label> <input type=\"number\" name=\"payment_check\" id=\"payment_check\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_check\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"ap.env.satispayEnabled\"><label for=\"payment_satis\" style=\"font-weight: bold; color: #ff5000;\">Importo Satispay (in &euro;)</label> <input type=\"number\" name=\"payment_satis\" id=\"payment_satis\" step=\"0.01\" ng-model=\"ap.activeAppointment.payment_satis\" ng-disabled=\"ap.activeAppointment.payment_type!=\'M\' || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container></div></div><div layout=\"row\" ng-if=\"ap.env.giftcardEnabled && ap.activeAppointment.treatment_id!=99\"><md-input-container class=\"md-block\" flex=\"45\"><label for=\"gift_number\" style=\"font-weight: bold; color: #ff5000;\">Numero Giftcard</label><md-select aria-label=\"Numero giftcard\" id=\"gift_number\" name=\"gift_number\" ng-model=\"ap.activeAppointment.gift_number\" ng-change=\"ap.card.select()\" ng-disabled=\"(ap.activeAppointment.payment_type!= \'G\' && ap.activeAppointment.payment_type!=\'M\') || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" md-container-class=\"with-search\"><md-select-header><span class=\"md-select-search-container\"><input type=\"{{ ap.card.loading? \'hidden\' : \'search\' }}\" placeholder=\"Cerca\" class=\"md-select-search\" id=\"filter_card_number_pay\" name=\"filter_card_number_pay\" ng-keydown=\"$event.stopPropagation()\" ng-click=\"$event.stopPropagation()\" ng-keyup=\"ap.card.onKeyUpSearch($event, this)\" ng-model=\"ap.card.filter_number_pay\"></span></md-select-header><md-option ng-value=\"undefined\"></md-option><md-option ng-value=\"card.number\" ng-repeat=\"card in ap.card.list | orderBy: number\">{{ ap.card.format(card.number) }}</md-option><md-option ng-if=\"ap.activeAppointment.gift_number && (!ap.card.list || ap.card.list.length==0)\" ng-value=\"ap.activeAppointment.gift_number\">{{ ap.card.format(ap.activeAppointment.gift_number) }}</md-option></md-select><div ng-show=\"ap.card.card && ap.card.card.balance>0\"><div class=\"md-input-message-animation ng-scope\" style=\"color: black;\">Credito: {{ap.card.card.balance}}&euro;</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label for=\"payment_gift\" style=\"font-weight: bold; color: #ff5000;\">Importo Giftcard (in &euro;)</label> <input type=\"number\" name=\"payment_gift\" id=\"payment_gift\" step=\"0.01\" ng-max=\"ap.card.card.balance\" ng-model=\"ap.activeAppointment.payment_gift\" ng-disabled=\"(ap.activeAppointment.payment_type!= \'G\' && ap.activeAppointment.payment_type!=\'M\') || ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><div ng-messages=\"appointmentForm.payment_gift.$error\" ng-show=\"appointmentForm.payment_gift.$dirty\"><div ng-message=\"max\"><span>Credito insufficiente</span></div></div></md-input-container></div><div ng-if=\"(!ap.env.currency || ap.env.currency.pos) && !ap.storno && ap.activeAppointment.price_discounted>=ap.sogliaRateizzazione && ap.activeAppointment.price_due>0 && ap.maxRate > 0\"><label><b>Rateizzazione</b> (inserire la modalit&agrave; di pagamento dell\'importo rimanente)</label></div><div ng-if=\"(!ap.env.currency || ap.env.currency.pos) && !ap.storno && (ap.activeAppointment.price_discounted<ap.sogliaRateizzazione || !ap.maxRate) && !ap.activeAppointment.closed && ap.activeAppointment.recalled<3\"><label><b>Rateizzazione</b> non abilitata <span ng-if=\"ap.maxRate && ap.activeAppointment.price_discounted<ap.sogliaRateizzazione\">per importi inferiori a {{ap.sogliaRateizzazione}}&euro;</span> <span ng-if=\"!ap.maxRate\">per questa tipologia di abbonamento</span></label></div><div layout=\"row\" ng-if=\"(!ap.env.currency || ap.env.currency.pos) && !ap.storno && ap.maxRate > 0 && ap.activeAppointment.price_discounted>=ap.sogliaRateizzazione && ap.activeAppointment.price_due>0\"><md-input-container class=\"md-block\" flex=\"50\"><md-radio-group id=\"rateizzazione_type\" name=\"rateizzazione_type\" ng-change=\"ap.paymentPosUpdate()\" ng-model=\"ap.activeAppointment.rateizzazione_type\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"><md-radio-button value=\"S\">Small Pay</md-radio-button><md-radio-button value=\"M\">Rate gestite dal centro</md-radio-button></md-radio-group></md-input-container><div flex=\"50\" style=\"margin-top: 20px;\"><md-input-container class=\"md-block\"><label for=\"price_due\" style=\"font-weight: bold; color: #ff5000;\">Importo {{ap.activeAppointment.rateizzazione_type==\'S\'?\'totale\':\'rateizzato\'}} (in &euro;)</label> <input type=\"number\" name=\"price_due\" id=\"price_due\" step=\"0.01\" min=\"0\" ng-model=\"ap.activeAppointment.price_due\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3 || !ap.canEdit.price_due\" ng-model-options=\"ap.filter.options\"></md-input-container><md-input-container class=\"md-block\"><label for=\"num_rate\" style=\"font-weight: bold; color: #ff5000;\">Numero rate (max {{ap.maxRate}})</label> <input type=\"number\" name=\"numrate\" id=\"num_rate\" step=\"1\" min=\"0\" max=\"{{ ap.maxRate }}\" ng-model=\"ap.activeAppointment.num_rate\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model-options=\"ap.filter.options\"></md-input-container></div></div><div><h4 style=\"padding-bottom: 10px;\">Dati visita</h4><md-input-container class=\"md-block\"><label for=\"note\">Note</label> <textarea name=\"note\" id=\"note\" rows=\"2\" ng-model=\"ap.activeAppointment.note\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"></textarea></md-input-container><md-input-container class=\"md-block\"><label for=\"diagnosi\">Diagnosi</label> <textarea name=\"diagnosi\" id=\"diagnosi\" rows=\"2\" ng-model=\"ap.activeAppointment.note_diagnosi\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"></textarea></md-input-container><md-input-container class=\"md-block\"><label for=\"terapia\">Terapia</label> <textarea name=\"terapia\" id=\"terapia\" rows=\"2\" ng-model=\"ap.activeAppointment.note_terapia\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"></textarea></md-input-container><md-input-container class=\"md-block\"><label for=\"valutazione_clinica\">Valutazione clinica</label> <textarea name=\"valutazione_clinica\" id=\"valutazioneClinica\" rows=\"2\" ng-model=\"ap.activeAppointment.note_val_clinica\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"></textarea></md-input-container><md-input-container class=\"md-block\"><label for=\"parametri_tecnici\">Parametri tecnici</label> <textarea name=\"parametri_tecnici\" id=\"parametriTecnici\" rows=\"2\" ng-model=\"ap.activeAppointment.parameters\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"></textarea></md-input-container><div layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:0px;\"><md-input-container class=\"md-block\" flex=\"50\" ng-repeat=\"param in ap.activeAppointment.params.data\" ng-if=\"($index) <= 2\"><label for=\"{{ap.treatmentParams[$index].param.nome}}\">{{ap.treatmentParams[$index].param.nome}}</label> <input name=\"{{param.param.nome}}\" id=\"{{param.param.nome}}\" ng-model=\"ap.activeAppointment.params.data[$index].value\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:0px;\"><md-input-container class=\"md-block\" flex=\"50\" ng-repeat=\"param in ap.activeAppointment.params.data\" ng-if=\"($index) > 2 && ($index) <= 5\"><label for=\"{{ap.treatmentParams[$index].param.nome}}\">{{ap.treatmentParams[$index].param.nome}}</label> <input name=\"{{param.param.nome}}\" id=\"{{param.param.nome}}\" ng-model=\"ap.activeAppointment.params.data[$index].value\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:0px;\"><md-input-container class=\"md-block\" flex=\"50\" ng-repeat=\"param in ap.activeAppointment.params.data\" ng-if=\"($index) > 5\"><label for=\"{{ap.treatmentParams[$index].param.nome}}\">{{ap.treatmentParams[$index].param.nome}}</label> <input name=\"{{param.param.nome}}\" id=\"{{param.param.nome}}\" ng-model=\"ap.activeAppointment.params.data[$index].value\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"></md-input-container></div><div layout=\"row\" ng-if=\"ap.treatment.f_with_product\"><md-input-container class=\"md-block\" flex=\"20\"><label for=\"Num_fiale\">Num. fiale</label> <input type=\"number\" step=\"0.5\" style=\"padding-bottom: 1px;line-height: 1.54; min-height: 52px;\" name=\"Num_fiale\" id=\"Num_fiale\" ng-model=\"ap.activeAppointment.num_fiale\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" md-select-on-focus=\"\"></md-input-container><span flex=\"10\">&nbsp;</span><md-input-container class=\"md-block\" flex=\"70\"><label for=\"codice_fiale\">Codici Fiale</label> <textarea name=\"codice_fiale\" id=\"codice_fiale\" rows=\"2\" ng-model=\"ap.activeAppointment.cod_fiale\" ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\"></textarea></md-input-container></div></div><md-checkbox ng-disabled=\"ap.activeAppointment.closed || ap.activeAppointment.recalled>=3\" ng-model=\"ap.activeAppointment.paid\" ng-true-value=\"1\" ng-false-value=\"0\">Si &egrave; presentato</md-checkbox><div flex=\"\"><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Aggiorna\" ng-click=\"ap.update( ap.activeAppointment )\" ng-disabled=\"appointmentForm.$invalid || (ap.activeAppointment.type==\'abb\' && ap.activeAppointment.subscription_new_id == null && ap.activeAppointment.customer_subscription_id == null)\" ng-if=\"ap.undoVisible && !ap.isNewAppointment && !ap.activeAppointment.closed && ap.activeAppointment.recalled<3\"><md-icon md-font-icon=\"check\">check</md-icon>Aggiorna</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ap.save( ap.activeAppointment )\" ng-disabled=\"appointmentForm.$invalid || !ap.customer_id || !ap.activeAppointment.treatment_id\" ng-if=\"ap.undoVisible && ap.isNewAppointment\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ap.undo()\" ng-if=\"ap.undoVisible\">Annulla</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/components/bm-appointments-history/bm-appointments-history.html","<md-table-container ng-if=\"ab.appointmentsAll && ab.appointmentsAll.length >0\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Data e Ora inizio</span></th><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\"><span>Medico</span></th><th md-column=\"\"><span>Assistente</span></th><th md-column=\"\"><span>Note Diagnosi</span></th><th md-column=\"\"><span>Note Terapia</span></th><th md-column=\"\"><span>Note Valutazione Clinica</span></th><th md-column=\"\"><span>Parametri tecnici</span></th><th md-column=\"\"><span>Pagato</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"appointment in ab.appointmentsAll\" ng-if=\"appointment.paid == 1\"><td md-cell=\"\">{{ appointment.date_fmt}}</td><td md-cell=\"\">{{ appointment.treatment.name}}</td><td md-cell=\"\">{{appointment.user.data.lastname}} {{appointment.user.data.firstname}}</td><td md-cell=\"\">{{appointment.assist_user.data.lastname}} {{appointment.assist_user.data.firstname}}</td><td md-cell=\"\">{{appointment.note_diagnosi}}</td><td md-cell=\"\">{{appointment.note_terapia}}</td><td md-cell=\"\">{{appointment.note_val_clinica}}</td><td md-cell=\"\">{{appointment.parameters}}</td><td md-cell=\"\">{{appointment.price}}&euro;</td></tr></tbody></table></md-table-container><bm-pagination loaditems=\"ab.loadItems\" listpagination=\"{{listPagination}}\"></bm-pagination>");
$templateCache.put("app/components/bm-appointments-list/bm-appointments-list.html","<div class=\"p-3\"><div class=\"row align-items-center mb-3\"><div class=\"col-6\"><h3 class=\"mb-0\">Appuntamenti</h3></div><div class=\"col-6 text-end\"><button ng-click=\"ab.toggleRight(null, false, null)\" class=\"btn btn-primary\"><i class=\"bi bi-plus\"></i> Appuntamento porta</button> <a class=\"btn btn-primary\" ng-href=\"{{ ab.env.booking }}/operator?c_sid={{ ab.user.store_id }}&amp;c_role={{ ab.user.type }}&amp;store={{ ab.storeId }}&amp;customer={{ (ab.customer)? ab.customer.phone : \'\' }}&amp;token={{ ab.token }}\"><i class=\"bi bi-plus\"></i> Nuovo appuntamento</a></div></div><div class=\"row mb-3\"><div class=\"col-12\"><div class=\"border-1 border-bottom border-top\"><div class=\"d-flex flex-row align-items-center py-2\"><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch(true)\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><div class=\"pe-1\">Filtra per</div><div class=\"p-1 flex-fill\"><input class=\"form-control\" list=\"trattamentoOptions\" id=\"trattamentoDataList\" placeholder=\"Cerca\" ng-keypress=\"ab.onKeyPressSearch($event)\" ng-model=\"ab.query.filter\"></div><div class=\"p-1 flex-fill\"><md-select ng-change=\"ab.loadItems()\" ng-model=\"ab.eStatus.filterReminder\" aria-label=\"Reminder\" placeholder=\"Reminder\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"1\">Confermato</md-option><md-option ng-value=\"4\">Spostato</md-option><md-option ng-value=\"2\">Non risposto</md-option><md-option ng-value=\"3\">Disdetto</md-option><md-option ng-value=\"5\">In Agenda</md-option><md-option ng-value=\"6\">Scoperto</md-option><md-option ng-value=\"7\">Da Pianificare</md-option></md-select></div><div class=\"p-1 flex-fill\"><md-select ng-change=\"ab.loadItems()\" ng-model=\"ab.eStatus.filterPresenza\" aria-label=\"Stato\" placeholder=\"Stato\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"0\">Assente</md-option><md-option ng-value=\"1\">Presente</md-option><md-option ng-value=\"2\">Pagato</md-option></md-select></div><div class=\"p-1 flex-fill\"><md-select ng-change=\"ab.loadItems()\" ng-model=\"ab.eStatus.filterEsito\" aria-label=\"Esito\" placeholder=\"Esito\"><md-option ng-value=\"undefined\">Tutti gli esiti</md-option><md-option ng-value=\"\'f_accepted\'\">Accettato</md-option><md-option ng-value=\"\'f_follow\'\">Follow up</md-option><md-option ng-value=\"\'f_cross\'\">Cross selling</md-option><md-option ng-value=\"\'f_up\'\">Up selling</md-option><md-option ng-value=\"\'f_ni\'\">Non interessato</md-option></md-select></div><div class=\"p-1 flex-fill\"><md-select ng-change=\"ab.loadItems()\" ng-model=\"ab.eStatus.filterAgenda\" aria-label=\"Filtro agenda\" placeholder=\"Filtro agenda\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"\'1\'\">1a volta</md-option><md-option ng-value=\"\'2\'\">Smaltimento</md-option></md-select></div></div></div></div><div class=\"col-12\"><div class=\"border-1 border-bottom\"><div class=\"d-flex flex-row align-items-center py-2\"><div class=\"p-1 flex-fill\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" style=\"margin-left: -10px;\" md-placeholder=\"Da Data\" ng-model=\"ab.eStatus.filterDateStart\" ng-change=\"ab.onChangeDateStart()\"></md-datepicker></div><div class=\"p-1\" style=\"width: 80px;\"><input mdc-datetime-picker=\"\" class=\"form-control\" type=\"text\" time=\"true\" date=\"false\" placeholder=\"Ora iniziale\" ng-model=\"ab.eStatus.filterTimeStart\" ng-change=\"ab.onChangeTimeStart()\" ng-style=\"{\'background-color\': \'#FFFFFF\'}\"></div><div class=\"p-1 flex-fill\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" style=\"margin-left: -10px;\" md-placeholder=\"A Data\" md-min-date=\"ab.eStatus.filterDateStart\" ng-model=\"ab.eStatus.filterDateEnd\" ng-change=\"ab.loadItems()\"></md-datepicker></div><div class=\"p-1 flex-fill\"><md-select aria-label=\"Medico\" placeholder=\"Medico\" ng-model=\"ab.eStatus.filterOperatorId\" ng-change=\"ab.loadItems()\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"operator.user_id\" ng-repeat=\"operator in ab.userRolesList | filter: {active: true, role: \'operator\'} : true | unique: \'user_id\' | orderBy: \'user.lastname\'\" ng-if=\"operator.store_id\"><div ng-if=\"ab.storeId\" class=\"operator-circle\" style=\"background-color: {{ operator.color }};\"></div>{{ operator.user.lastname }} {{ operator.user.firstname }}</md-option></md-select></div><div class=\"p-1 flex-fill\"><md-select aria-label=\"Commerciale\" placeholder=\"Commerciale\" ng-model=\"ab.eStatus.filterCommercialId\" ng-change=\"ab.loadItems()\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"operator.user_id\" ng-repeat=\"operator in ab.userRolesList | filter: {active: true, role: \'!operator\'} : true | filter: {active: true, role: \'!callcenter\'} : true | filter: {active: true, role: \'!admin\'} : true | unique: \'user_id\' | orderBy: \'user.lastname\'\" ng-if=\"operator.store_id\"><div ng-if=\"ab.storeId\" class=\"operator-circle\" style=\"background-color: {{ operator.color }};\"></div>{{ operator.user.lastname }} {{ operator.user.firstname }}</md-option></md-select></div><div class=\"p-1 flex-fill\"><md-select aria-label=\"Assistente\" placeholder=\"Assistente\" ng-model=\"ab.eStatus.filterAssistId\" ng-change=\"ab.loadItems()\"><md-option ng-value=\"undefined\">Tutti</md-option><md-option ng-value=\"operator.user_id\" ng-repeat=\"operator in ab.userRolesList | filter: {active: true, role: \'assist\'} : true | unique: \'user_id\' | orderBy: \'user.lastname\'\" ng-if=\"operator.store_id\"><div ng-if=\"ab.storeId\" class=\"operator-circle\" style=\"background-color: {{ operator.color }};\"></div>{{ operator.user.lastname }} {{ operator.user.firstname }}</md-option></md-select></div></div></div></div></div><div class=\"row\"><div class=\"col-12\"><table md-table=\"\" style=\"width: 100% !important;\"><thead md-head=\"\" md-order=\"ab.query.order\" md-on-reorder=\"orderItems\"><tr><th md-column=\"\" md-order-by=\"id\" ng-if=\"ab.customer\" scope=\"cole\">Id</th><th md-column=\"\" md-order-by=\"date_start\" scope=\"col\">Data</th><th scope=\"col\" ng-if=\"!ab.customer\">Paziente</th><th scope=\"col\">Inizio</th><th scope=\"col\" ng-if=\"ab.customer || !ab.storeId\">Clinica</th><th scope=\"col\">Trattamento</th><th scope=\"col\" width=\"135\">Prezzo {{ap.env.currency?ap.env.currency.symbol:\'&euro;\'}}</th><th scope=\"col\">Operatori</th><th scope=\"col\">Stato</th><th scope=\"col\" class=\"col-auto text-end\">Azioni</th></tr></thead><tbody><tr ng-repeat=\"appointment in appointments | orderBy: ab.query.order\"><td ng-if=\"ab.customer\">{{appointment.id}}</td><td ng-click=\"ab.rowClicked( appointment, \'price\')\">{{appointment.date_fmt}} <i ng-if=\"appointment.user_times==1\" class=\"bi bi-asterisk text-success\" data-bs-toggle=\"tooltip\" data-bs-placement=\"right\" title=\"Primo appuntamento\"></i></td><td ng-if=\"!ab.customer\" ui-sref=\"home.customer-detail( { customer_id : appointment.customer.data.id } )\" style=\"cursor: pointer;\">{{appointment.customer.data.firstname}} {{appointment.customer.data.lastname}}</td><td ng-click=\"ab.rowClicked( appointment, \'price\')\">{{appointment.start_hour_fmt}}</td><td ng-click=\"ab.rowClicked( appointment, \'price\')\" ng-if=\"ab.customer || !ab.storeId\">{{appointment.store.data.alias}}</td><td ng-click=\"ab.rowClicked( appointment, \'price\')\">{{appointment.treatment.data.name}}</td><td><span data-bs-toggle=\"modal\"><bl-btn-appointment-info customer=\"ab.customer\" appointment=\"appointment\" user=\"ab.user\" newlayout=\"false\"></bl-btn-appointment-info></span> <span ng-if=\"((!appointment.closed && appointment.recalled<3) || appointment.paid)\" ng-click=\"ab.rowClicked( appointment, \'price\')\">{{ appointment.price | number:2 }}</span></td><td><div class=\"d-flex justify-content-between\"><span>Medico:</span> <span><a data-bs-toggle=\"modal\" ng-click=\"ab.openChangeOperatorsModal(appointment)\">{{appointment.user.data.firstname}} {{appointment.user.data.lastname}}</a></span></div><div class=\"d-flex justify-content-between\"><span>Commerciale:</span> <span><a data-bs-toggle=\"modal\" ng-click=\"ab.openChangeOperatorsModal(appointment)\">{{appointment.commercial_user.data.firstname}} {{appointment.commercial_user.data.lastname}}</a></span></div><div class=\"d-flex justify-content-between\"><span>Assistente:</span> <span><a data-bs-toggle=\"modal\" ng-click=\"ab.openChangeOperatorsModal(appointment)\">{{appointment.assist_user.data.firstname}} {{appointment.assist_user.data.lastname}}</a></span></div></td><td><span ng-if=\"appointment.recalled == 1\" class=\"badge text-uppercase status status-bg-green d-block\">Confermato</span> <span ng-if=\"appointment.recalled == 4\" class=\"badge text-uppercase status status-bg-orange d-block\">Spostato</span> <span ng-if=\"appointment.recalled == 2\" class=\"badge text-uppercase status status-bg-yellow d-block\">Non risposto</span> <span ng-if=\"appointment.recalled == 3\" class=\"badge text-uppercase status status-bg-black d-block\">Disdetto</span> <span ng-if=\"appointment.f_over == 3\" class=\"badge text-uppercase status status-bg-yellow d-block\">Da pianificare</span> <span ng-if=\"appointment.paid == 1 && appointment.price>0 && appointment.recalled<3\" class=\"badge text-uppercase status status-bg-green d-block\">Pagato</span> <span ng-if=\"appointment.paid == 1 && appointment.price==0 && appointment.recalled<3\" class=\"badge text-uppercase status status-bg-red d-block\">Non pagato</span> <span ng-if=\"appointment.paid == 1 && appointment.recalled<3\" class=\"badge text-uppercase status status-bg-green d-block\">Presente</span> <span ng-if=\"appointment.paid == 0 || appointment.recalled>=3\" class=\"badge text-uppercase status status-bg-red d-block\">Assente</span> <span ng-if=\"appointment.f_accepted\" class=\"badge text-uppercase status status-bg-green d-block mt-1\">Accettato</span> <span ng-if=\"appointment.f_follow\" class=\"badge text-uppercase status status-bg-orange d-block mt-1\">Follow up</span> <span ng-if=\"appointment.f_cross\" class=\"badge text-uppercase status status-bg-azul d-block mt-1\">Cross selling</span> <span ng-if=\"appointment.f_up\" class=\"badge text-uppercase status status-bg-violet d-block mt-1\">Up selling</span> <span ng-if=\"appointment.f_ni\" class=\"badge text-uppercase status status-bg-black d-block mt-1\">Non interessato</span></td><td class=\"text-end\"><span data-bs-toggle=\"modal\" ng-if=\"appointment.f_over == 3 && appointment.recalled != 4\" ng-click=\"ab.planAppointment( appointment, \'{{ appointment.recalled }}\')\"><button type=\"button\" class=\"btn btn-warning\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Pianifica\"><i class=\"bi bi-calendar-check\"></i></button></span> <span data-bs-toggle=\"modal\" ng-if=\"appointment.f_over == 3 && appointment.recalled == 4\"><button disabled=\"\" type=\"button\" class=\"btn btn-secondary\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Pianificato\"><i class=\"bi bi-calendar-check\"></i></button></span> <span data-bs-toggle=\"modal\"><bl-btn-appointment-info customer=\"ab.customer\" appointment=\"appointment\" user=\"ab.user\" newlayout=\"true\"></bl-btn-appointment-info></span> <span data-bs-toggle=\"modal\"><bl-btn-appointment-documents customer=\"ab.customer\" appointment=\"appointment\" user=\"ab.user\"></bl-btn-appointment-documents></span> <span><a class=\"btn btn-primary\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Modifica\" ng-click=\"ab.rowClicked( appointment, \'price\')\"><i class=\"bi bi-pencil\"></i></a></span><span data-bs-toggle=\"modal\" ng-click=\"ab.openNoteModal(appointment)\"><button ng-if=\"appointment.notes==\'\' && appointment.closed\" disabled=\"\" type=\"button\" class=\"btn btn-secondary\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Note non presenti - cassa chiusa\"><i class=\"bi bi-clipboard-plus\"></i></button> <button ng-if=\"appointment.notes!=\'\' && appointment.closed\" disabled=\"\" type=\"button\" class=\"btn btn-primary\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Note non modificabili - cassa chiusa\"><i class=\"bi bi-clipboard-plus\"></i></button> <button ng-if=\"appointment.notes!=\'\' && !appointment.closed\" type=\"button\" class=\"btn btn-primary\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Modifica Nota\"><i class=\"bi bi-clipboard-plus\"></i></button> <button ng-if=\"appointment.notes==\'\' && !appointment.closed\" type=\"button\" class=\"btn btn-danger\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Nuova Nota\"><i class=\"bi bi-clipboard-plus\"></i></button></span> <span data-bs-toggle=\"modal\" ng-click=\"ab.openAnamnesisModal()\"><button ng-if=\"!appointment.closed\" type=\"button\" class=\"btn btn-primary\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Crea Anamnesi\"><i class=\"bi bi-card-heading\"></i></button> <button ng-if=\"appointment.closed\" type=\"button\" class=\"btn btn-secondary\" disabled=\"\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Anamnesi non modificabili - cassa chiusa\"><i class=\"bi bi-card-heading\"></i></button></span> <span ng-if=\"appointment.closed\" data-bs-toggle=\"modal\"><button type=\"button\" class=\"btn btn-secondary\" disabled=\"\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Azioni non modificabili - cassa chiusa\"><i class=\"bi bi-stars\"></i></button></span><div class=\"btn-group\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Azioni\"><button type=\"button\" ng-if=\"!appointment.closed\" ng-click=\"ab.toggleActionSelect(appointment)\" class=\"btn btn-primary dropdown-toggle\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"bi bi-stars\"></i></button><ul id=\"actionSelect_{{appointment.id}}\" class=\"dropdown-menu dropdown-menu-end\" style=\"position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(-124px, 40px);\"><li><h6 class=\"dropdown-header text-uppercase\">Reminder</h6></li><li><button ng-disabled=\"appointment.recalled == 1\" ng-click=\"ab.update(appointment, {recalled: 1})\" class=\"dropdown-item\" type=\"button\"><i class=\"bi bi-record-fill status status-txt-green\"></i> Confermato</button></li><li><button ng-disabled=\"appointment.recalled == 4\" ng-click=\"ab.moveAppointment(appointment)\" class=\"dropdown-item\" type=\"button\"><i class=\"bi bi-record-fill status status-txt-orange\"></i> Spostato</button></li><li><button ng-disabled=\"appointment.recalled == 2\" ng-click=\"ab.update(appointment, {recalled: 2})\" class=\"dropdown-item\" type=\"button\"><i class=\"bi bi-record-fill status status-txt-yellow\"></i> Non risposto</button></li><li><button ng-disabled=\"appointment.recalled == 3\" ng-click=\"ab.update(appointment, {recalled: 3})\" class=\"dropdown-item\" type=\"button\"><i class=\"bi bi-record-fill status status-txt-black\"></i> Disdetto</button></li><li><hr class=\"dropdown-divider\"></li><li><h6 class=\"dropdown-header text-uppercase\">Presenza</h6></li><li><button ng-disabled=\"appointment.paid==1\" ng-click=\"ab.update(appointment, {paid: 1})\" class=\"dropdown-item\" type=\"button\"><i class=\"bi bi-record-fill status status-txt-green\"></i> Presente</button></li><li><button ng-disabled=\"appointment.paid==0\" ng-click=\"ab.update(appointment, {paid: 0})\" class=\"dropdown-item\" type=\"button\"><i class=\"bi bi-record-fill status status-txt-red\"></i> Assente</button></li><li><hr class=\"dropdown-divider\"></li><li><h6 class=\"dropdown-header text-uppercase\">Esito</h6></li><li><button ng-click=\"ab.update(appointment, {f_accepted: appointment.f_accepted?0:1})\" class=\"dropdown-item\" type=\"button\"><i class=\"bi bi-record-fill status status-txt-green\"></i> Accettato</button></li><li><button ng-click=\"ab.update(appointment, {f_follow: appointment.f_follow?0:1})\" class=\"dropdown-item\" type=\"button\"><i class=\"bi bi-record-fill status status-txt-orange\"></i> Follow up</button></li><li><button ng-click=\"ab.update(appointment, {f_cross: appointment.f_cross?0:1})\" class=\"dropdown-item\" type=\"button\"><i class=\"bi bi-record-fill status status-txt-azul\"></i> Cross selling</button></li><li><button ng-click=\"ab.update(appointment, {f_up: appointment.f_up?0:1})\" class=\"dropdown-item\" type=\"button\"><i class=\"bi bi-record-fill status status-txt-violet\"></i> Up selling</button></li><li><button ng-click=\"ab.update(appointment, {f_ni: appointment.f_ni?0:1})\" class=\"dropdown-item\" type=\"button\"><i class=\"bi bi-record-fill status status-txt-black\"></i> Non interessato</button></li></ul></div></td></tr></tbody></table><bm-pagination loaditems=\"ab.loadItems\" listpagination=\"{{listPagination}}\"></bm-pagination></div></div><md-progress-circular md-diameter=\"50\" md-mode=\"indeterminate\" ng-if=\"loading\"></md-progress-circular></div>");
$templateCache.put("app/components/bm-pagination/bm-pagination.html","<ul class=\"pagination justify-content-end mb-0\" ng-if=\"listPagination.total > 0\"><li class=\"page-item {{(listPagination.current_page == 1)? \'disabled\' : \'\'}}\"><a class=\"page-link\" href=\"#\" tabindex=\"-1\" ng-disabled=\"listPagination.current_page == 1\" ng-click=\"setPagination(listPagination.current_page-1)\">Precedente</a></li><li class=\"page-item\" ng-repeat=\"n in [].constructor(maxPages) track by $index\"><a class=\"page-link\" ng-click=\"setPagination($index + listPagination.current_page - maxPages/2)\" ng-style=\"(listPagination.current_page == ($index + listPagination.current_page - maxPages/2)) && {\'background-color\':\'#e9ecef\'}\" ng-if=\"(($index + listPagination.current_page - maxPages/2) > 0) && (($index + listPagination.current_page - maxPages/2) <= listPagination.total_pages)\">{{$index + listPagination.current_page - maxPages/2}}</a></li><li class=\"page-item {{(listPagination.current_page == listPagination.total_pages)? \'disabled\' : \'\'}}\"><a class=\"page-link\" href=\"#\" ng-disabled=\"listPagination.current_page == listPagination.total_pages\" ng-click=\"setPagination(listPagination.current_page+1)\">Successiva</a></li></ul>");
$templateCache.put("app/components/bm-picture-sidenav/bm-picture-sidenav.html","<md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"bm-picture-sidenav\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"collections\">collections</md-icon><h2 class=\"md-headline\"><span class=\"inset\">{{ ab.commandLabel }}</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"createPictureAction\" id=\"createPictureAction\" layout=\"column\" layout-wrap=\"\"><div flex=\"100\"><md-input-container class=\"md-block\"><label for=\"appointment_id\">Appuntamento</label><md-select id=\"appointment_id\" name=\"appointment_id\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"appointment_id\" ng-change=\"ab.setCreationDate()\" ng-model=\"ab.createPictureAction.appointment_id\"><md-option ng-value=\"\"></md-option><md-option ng-value=\"appointment.id\" ng-repeat=\"appointment in ab.appointments track by appointment.id\">{{ appointment.date_start_frmt }} - {{ appointment.treatment.name }}</md-option></md-select></md-input-container></div><div layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><md-radio-group id=\"parameter\" name=\"parameter\" aria-label=\"Foto Scattata\" ng-required=\"true\" required=\"\" ng-model=\"ab.createPictureAction.parameter\"><md-radio-button value=\"1\">Foto Scattata prima dell\'appuntamento</md-radio-button><md-radio-button value=\"2\">Foto Scattata dopo l\'appuntamento</md-radio-button></md-radio-group></md-input-container></div></div><div layout=\"row\"><div flex=\"100\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" id=\"date\" name=\"date\" md-placeholder=\"Data\" ng-required=\"true\" required=\"\" ng-model=\"ab.createPictureAction.date\" style=\"margin-left: 0px;\"></md-datepicker></div></div><div layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><md-input-file-img multiple=\"true\" accept=\"image/*\"></md-input-file-img></md-input-container></div></div><div layout=\"row\"><div flex=\"100\"><md-input-container class=\"md-block\"><label for=\"description\">Descrizione</label> <textarea rows=\"2\" id=\"description\" name=\"description\" maxlength=\"255\" ng-model=\"ab.createPictureAction.description\"></textarea></md-input-container></div></div><div flex=\"100\"><md-progress-circular ng-if=\"ab.saving || ab.loading\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\"><md-button class=\"md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"ab.closeSidebar()\" ng-disabled=\"ab.saving\">Annulla</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ab.save(createPictureAction)\" ng-disabled=\"createPictureAction.$invalid || ab.saving\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/components/bm-pictures-list/bm-pictures-list.html","<div class=\"p-3\"><div class=\"row align-items-center mb-3\"><div class=\"col-6\"><h3 class=\"mb-0\">Foto</h3></div><div class=\"col-6 text-end\"><button class=\"btn btn-primary\" ng-click=\"ab.toggleRight()\"><i class=\"bi bi-plus\"></i> Nuova foto</button></div></div><div class=\"row\"><div class=\"col-12\"><table style=\"width: 100% !important;\"><thead><tr><th scope=\"col\">Data</th><th scope=\"col\">Trattamento</th><th scope=\"col\">Medico</th><th scope=\"col\" style=\"width: 55px;\">Foto</th><th scope=\"col\" class=\"text-end\" style=\"width: 110px;\">Azioni</th></tr></thead><tbody><tr ng-repeat=\"appointment in ab.appointments\"><td>{{appointment.date_fmt}}</td><td>{{appointment.treatment.name}}</td><td>{{appointment.user.data.firstname}} {{appointment.user.data.lastname}}</td><td><button ng-if=\"appointment.pictures.data.length > 0\" ui-sref=\"home.customer-pictures( { customer_id : appointment.customer_id, appointment_id : appointment.id } )\" style=\"margin-left: 5px;\" class=\"btn btn-success\"><i class=\"bi bi-card-image\"></i></button><button ng-if=\"appointment.pictures.data.length == 0\" ui-sref=\"home.customer-pictures( { customer_id : appointment.customer_id, appointment_id : appointment.id } )\" style=\"margin-left: 5px;\" class=\"btn btn-secondary\"><i class=\"bi bi-card-image\"></i></button></td><td class=\"text-end\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"ab.checkSendEmail(appointment)\"><i class=\"bi bi-envelope\"></i> Invia</button></td></tr></tbody></table><bm-pagination loaditems=\"ab.loadItems\" listpagination=\"{{listPagination}}\"></bm-pagination></div></div><md-progress-circular md-diameter=\"50\" md-mode=\"indeterminate\" ng-if=\"loading\"></md-progress-circular></div>");
$templateCache.put("app/components/bm-quotations-list/bm-quotations-list.html","<div class=\"p-3\"><div class=\"row align-items-center mb-3\"><div class=\"col-6\"><h3 class=\"mb-0\">Preventivi</h3></div><div class=\"col-6 text-end\"><a ng-click=\"create()\" class=\"btn btn-primary\"><i class=\"bi bi-plus\"></i> Nuovo preventivo</a></div></div><div class=\"row\"><div class=\"col-12\"><table md-table=\"\" style=\"width: 100% !important;\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"orderItems\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"id\" scope=\"col\">n</th><th md-column=\"\" md-order-by=\"date\" scope=\"col\">Data</th><th md-column=\"\" md-order-by=\"price\" scope=\"col\" class=\"text-center\">Importo</th><th md-column=\"\" md-order-by=\"discount\" scope=\"col\" class=\"text-center\">Sconto</th><th scope=\"col\" class=\"text-center\">Totale</th><th md-column=\"\" md-order-by=\"type\" scope=\"col\">Tipo</th><th md-column=\"\" md-order-by=\"status\" scope=\"col\">Stato</th><th scope=\"col\" class=\"text-end\">Azioni</th></tr></thead><tbody><tr ng-repeat=\"cq in (quotations | orderBy: quotations.order ) track by cq.id\"><td>{{cq.id}}</td><td>{{cq.date_formatted}}</td><td class=\"text-center\">{{cq.price | number : 2 }}&euro;</td><td class=\"text-center\">{{cq.discount }}%</td><td class=\"text-center\">{{cq.price-cq.total_discount | number : 2 }}&euro;</td><td><span ng-if=\"cq.type==\'cross-selling\'\" class=\"badge text-uppercase status status-bg-azul\">Cross Selling</span> <span ng-if=\"cq.type==\'up-selling\'\" class=\"badge text-uppercase status status-bg-violet\">Up Selling</span> <span ng-if=\"cq.type==\'first\'\" class=\"badge text-uppercase status status-bg-green\">Primo preventivo</span></td><td><span ng-if=\"cq.status==\'draft\'\" class=\"badge text-uppercase status status-bg-orange\">Bozza</span> <span ng-if=\"cq.status==\'signed\'\" class=\"badge text-uppercase status status-bg-green\">Sottoscritto</span> <span ng-if=\"cq.status==\'canceled\'\" class=\"badge text-uppercase status status-bg-black\">Annullato</span> <span ng-if=\"cq.status==\'suspended\'\" class=\"badge text-uppercase status status-bg-black\">Sospeso</span></td><td class=\"text-end\"><button type=\"button\" class=\"btn btn-primary\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Visualizza\" data-bs-original-title=\"Visualizza\" ng-click=\"view(cq)\"><i class=\"bi bi-eye\"></i></button> <a ui-sref=\"home.ntreatment( { customer_id : cq.customer_id, customer_quotation_id: cq.id } )\" class=\"btn btn-primary\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Programma trattamenti\" data-bs-original-title=\"Programma trattamenti\" ng-if=\"cq.status==\'signed\'\"><i class=\"bi bi-calendar3\"></i></a> <button type=\"button\" class=\"btn btn-primary\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Sottoscrizione\" data-bs-original-title=\"Sottoscrizione\" ng-if=\"cq.status==\'draft\'\" ng-click=\"openDocumentPage( cq.id )\"><i class=\"bi bi-pen\"></i></button> <button type=\"button\" class=\"btn btn-primary\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Invia\" data-bs-original-title=\"Invia\" ng-if=\"cq.status==\'draft\' || cq.status==\'signed\'\" ng-click=\"openEmailPopup(cq)\"><i class=\"bi bi-envelope\"></i></button> <button type=\"button\" class=\"btn btn-primary\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Modifica\" data-bs-original-title=\"Modifica\" ng-if=\"cq.status==\'draft\'\" ng-click=\"edit(cq)\"><i class=\"bi bi-gear\"></i></button> <button type=\"button\" class=\"btn btn-primary\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Ripristina\" data-bs-original-title=\"Ripristina\" ng-if=\"cq.status==\'suspended\'\" ng-click=\"openRestoreEstimateModal(cq)\"><i class=\"bi bi-arrow-counterclockwise\"></i></button> <span data-bs-toggle=\"modal\" ng-click=\"openCancelEstimateModal(cq)\"><button type=\"button\" class=\"btn btn-danger\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Annulla\" ng-if=\"cq.status==\'signed\'\"><i class=\"bi bi-exclamation-circle\"></i></button></span> <span data-bs-toggle=\"modal\" ng-click=\"openSuspendEstimateModal(cq)\"><button type=\"button\" class=\"btn btn-danger\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"Sospendi\" ng-if=\"cq.status==\'signed\'\"><i class=\"bi bi-pause-fill\"></i></button> <button type=\"button\" class=\"btn btn-danger\" title=\"Elimina\" ng-if=\"cq.status==\'draft\'\" ng-click=\"delete( cq.id )\"><i class=\"bi bi-trash\"></i></button></span></td></tr></tbody></table><bm-pagination loaditems=\"loadItems\" listpagination=\"{{listPagination}}\"></bm-pagination></div></div><md-progress-circular md-diameter=\"50\" md-mode=\"indeterminate\" ng-if=\"loading\"></md-progress-circular></div>");
$templateCache.put("app/components/dialogs/activity-log.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"80\" flex-md=\"70\" flex-gt-md=\"60\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Id</span></th><th md-column=\"\"><span>Operazione</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Eseguito da</span></th><th md-column=\"\"><span>Dati modificati</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"activity in activities\"><td md-cell=\"\">{{ activity.id }}</td><td md-cell=\"\">{{ activity.description }}</td><td md-cell=\"\">{{ activity.created_at_frmt }}</td><td md-cell=\"\">{{ activity.causer.lastname }} {{ activity.causer.firstname }}</td><td md-cell=\"\"><p ng-repeat=\"(key, value) in activity.properties.attributes\"><span ng-if=\"key!=\'created_at\' && key!=\'created_at_r\' && key!=\'updated_at\' && activity.properties.old && !(value==0 && activity.properties.old[key]==null) && value!=activity.properties.old[key]\"><b>{{ key }}</b>: da {{activity.properties.old[key]==null?\'(vuoto)\':\"\'\"+activity.properties.old[key]+\"\'\"}} a \'{{ value }}\'</span></p></td></tr></tbody></table></md-table-container></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogs/appointment-moves.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-list class=\"md-dense\" layout=\"row\"><md-list-item class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button ng-href=\"tel:{{ appointmentQuesto.customer.data.phone }}\" class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"phone\">phone</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"row\" flex=\"\"><a href=\"tel:{{ appointmentQuesto.customer.data.phone }}\"><h3>{{ appointmentQuesto.customer.data.phone }}</h3></a></div></div></md-list-item><md-list-item class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"face\">face</md-icon></md-button><span flex=\"5\"></span><div class=\"operator-circle\" style=\"background-color: {{ appointmentQuesto.role.data.color }};\"></div><h3>&nbsp;&nbsp;{{ appointmentQuesto.role.data.user.firstname }} {{ appointmentQuesto.role.data.user.lastname }}<h3></h3></h3></div></md-list-item><md-list-item class=\"md-4-line\" ng-if=\"appointmentQuesto.note!=null && appointmentQuesto.note.trim()!=\'\'\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"event_note\">event_note</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\">{{ appointmentQuesto.note }}</div></div></md-list-item></md-list><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"><span>Data app.</span></th><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\"><span>Stato</span></th><th md-column=\"\"><span>In data</span></th><th md-column=\"\"><span>Da</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"app in appointmentsList\" ng-class=\"{\'md-current\' : app.id == appointmentQuesto.id}\"><td md-cell=\"\"><div ng-if=\"app.role && app.role.data\" class=\"operator-circle\" style=\"background-color: {{ app.role.data.color }};\"></div></td><td md-cell=\"\">{{ app.date_start_frmt }}</td><td md-cell=\"\">{{ app.treatment.data.name }}</td><td class=\"cell-select\" md-cell=\"\"><md-input-container class=\"md-block\" ng-if=\"app.recalled>2\" ng-class=\"{ \'md-disd\': app.recalled == 3, \'md-spos\': app.recalled == 4 && !app.sposInDay, \'md-sposInDay\' : app.recalled == 4 && app.sposInDay, }\"><md-select ng-disabled=\"true\" ng-model=\"app.recalled\" aria-label=\"Stato\" id=\"recalled\" name=\"recalled\"><md-option ng-value=\"recall_type.value\" ng-repeat=\"recall_type in recall_types track by recall_type.value\">{{ recall_type.text }}</md-option></md-select></md-input-container><md-button class=\"md-icon-button md-raised md-accent\" ng-if=\"app.paid && app.closed\"><md-icon md-font-icon=\"check\">check</md-icon></md-button><md-button class=\"md-icon-button md-raised md-accent\" ng-if=\"!app.paid && app.closed && app.recalled<3\"><md-icon md-font-icon=\"delete_forever\">delete_forever</md-icon></md-button></td><td md-cell=\"\"><span ng-if=\"app.recalled == 4\">{{ app.moved_at_frmt }}</span> <span ng-if=\"app.recalled == 3\">{{ app.cancelled_at_frmt }}</span> <span ng-if=\"app.recalled < 3\">{{ app.updated_at_frmt }}*</span></td><td md-cell=\"\"><span ng-if=\"app.recalled == 4\">{{ app.movedBy.data.lastname }} {{ app.movedBy.data.firstname }}</span> <span ng-if=\"app.recalled == 3\">{{ app.cancelledBy.data.lastname }} {{ app.cancelledBy.data.firstname }}</span> <span ng-if=\"app.recalled < 3 && app.updatedBy!=null\">{{ app.updatedBy.data.lastname }} {{ app.updatedBy.data.firstname }}*</span></td></tr><tr><td md-cell=\"\" colspan=\"6\" ng-if=\"appointmentsList.length>1 || appointmentQuesto.recalled<3\">* Indica l\'ultima modifica</td></tr></tbody></table></md-table-container><md-list class=\"md-dense\" ng-if=\"!loading\"><md-list-item ng-if=\"appointment.treatment_id == 99\" class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"gift_card\">gift_card</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\"><h3>Emissione gift card #{{ appointment.gift_number }}</h3></div></div></md-list-item><md-list-item class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"book\">book</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\"><h3>Prenotato il {{ appointment.created_at_frmt }} da {{ appointment.byOperator.data.id==0?((appointment.f_over?\"Bot\":\"Online\")+\" Booking\"):appointment.byOperator.data.lastname }} {{ appointment.byOperator.data.firstname }}</h3><span ng-if=\"appointment.byOperator.data.phone!=null\"><a href=\"tel:{{ appointment.byOperator.data.phone }}\">Tel.: {{ appointment.byOperator.data.phone }}</a></span></div></div></md-list-item><md-list-item class=\"md-4-line\" ng-if=\"appointment.lead_id\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"input\">input</md-icon></md-button><span flex=\"5\"></span><div layout=\"column\" ng-if=\"appointment.lead && appointment.lead.data\" flex=\"\"><h3>Lead (id:{{appointment.lead_id}}) del {{ appointment.lead.data.created_at_frmt }}</h3>Campagna: {{ appointment.lead.data.campagna }}</div><div layout=\"column\" ng-if=\"!appointment.lead || !appointment.lead.data\" flex=\"\"><h3>Lead (id:{{appointment.lead_id}}) non trovato</h3>Potrebbe essere stato cancellato o spostato in un\'altra area</div></div></md-list-item><md-list-item class=\"md-4-line\" ng-if=\"appointment.cus_act_id!=null\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button><span flex=\"5\"></span><div layout=\"column\" flex=\"\"><h3>Appuntamento da rullo</h3></div></div></md-list-item></md-list></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogs/entity-history.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"80\" flex-md=\"70\" flex-gt-md=\"60\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"column\"><div flex=\"\"><md-content layout-margin=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"loading || loadingAct\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!loading && leadevents.length>0\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Id</span></th><th md-column=\"\"><span>Descr.</span></th><th md-column=\"\"><span>Stato in.</span></th><th md-column=\"\"><span>Stato fin.</span></th><th md-column=\"\"><span>Data Rich.</span></th><th md-column=\"\"><span>Area</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Eseguito da</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"e in leadevents\"><td md-cell=\"\">{{ e.id }}</td><td md-cell=\"\">{{ e.reason }}</td><td md-cell=\"\">{{ e.from_status }}</td><td md-cell=\"\">{{ e.to_status }}</td><td md-cell=\"\">{{ e.call_date_frmt }}</td><td md-cell=\"\">{{ e.tenant }}</td><td md-cell=\"\">{{ e.created_at_frmt }}</td><td md-cell=\"\"><span ng-if=\"e.by_user_id!=91\">{{ e.user.data.lastname }} {{ e.user.data.firstname }}</span></td></tr></tbody></table></md-table-container><hr ng-if=\"!loadingAct && user.type==\'admin\' && leadevents.length>0\"><h3 ng-if=\"!loadingAct && user.type==\'admin\' && leadevents.length>0\">Dettaglio dati modificati</h3><md-table-container ng-if=\"!loadingAct && user.type==\'admin\'\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Id</span></th><th md-column=\"\"><span>Operazione</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Eseguito da</span></th><th md-column=\"\"><span>Dati modificati</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"activity in activities\"><td md-cell=\"\">{{ activity.id }}</td><td md-cell=\"\">{{ activity.description }}</td><td md-cell=\"\">{{ activity.created_at_frmt }}</td><td md-cell=\"\">{{ activity.causer.lastname }} {{ activity.causer.firstname }}</td><td md-cell=\"\"><p ng-repeat=\"(key, value) in activity.properties.attributes\"><span ng-if=\"key!=\'created_at\' && key!=\'created_at_r\' && key!=\'updated_at\' && activity.properties.old && !(value==0 && activity.properties.old[key]==null) && value!=activity.properties.old[key]\"><b>{{ key }}</b>: da {{activity.properties.old[key]==null?\'(vuoto)\':\"\'\"+activity.properties.old[key]+\"\'\"}} a \'{{ value }}\'</span></p></td></tr></tbody></table></md-table-container><hr ng-if=\"user.type==\'admin\' && entity && entity.verifiedRuleLog && entity.verifiedRuleLog.data && entity.verifiedRuleLog.data.campaignLeadRule && entity.verifiedRuleLog.data.campaignLeadRule.data\"><h3 ng-if=\"user.type==\'admin\' && entity && entity.verifiedRuleLog && entity.verifiedRuleLog.data && entity.verifiedRuleLog.data.campaignLeadRule && entity.verifiedRuleLog.data.campaignLeadRule.data\">Regola Verificata</h3><textarea readonly=\"\" rows=\"15\" ng-if=\"user.type==\'admin\' && entity && entity.verifiedRuleLog && entity.verifiedRuleLog.data && entity.verifiedRuleLog.data.campaignLeadRule && entity.verifiedRuleLog.data.campaignLeadRule.data\" style=\"width: 80%; font-family: \\\" courier=\"\" new\\\",=\"\" courier,=\"\" monospace;=\"\" font-size:=\"\" 14px;\"=\"\">{{ entity.verifiedRuleLog.data.campaignLeadRule.data | json }}</textarea></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/mb-referral-list/mb-referral-list.html","<md-card><md-card-header><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\" ng-if=\"!ab.customer\"><md-input-container><md-checkbox ng-model=\"ab.eStatus.showChilds\">Visualizza segnalati</md-checkbox></md-input-container>&nbsp;&nbsp;<md-input-container flex=\"30\" md-no-float=\"\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" ng-keypress=\"ab.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select id=\"wkstate\" name=\"wkstate\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Workflow State\" placeholder=\"Workflow State\" ng-model=\"ab.eStatus.wkstate\" ng-change=\"ab.loadItems(1)\"><md-option ng-value=\"undefined\">Tutti gli stati</md-option><md-option ng-if=\"ab.wkstates && ab.wkstates.length>0\" ng-value=\"wkstate\" ng-repeat=\"wkstate in ab.wkstates | orderBy: \'label\'\">[{{wkstate.name}}] - {{ wkstate.label }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><div layout=\"column\"><div layout=\"row\"><div><md-datepicker class=\"md-datepicker-filter-bar\" id=\"filter_date_from\" name=\"filter_date_from\" md-placeholder=\"Transizione Da\" md-max-date=\"ab.today\" ng-model=\"ab.eStatus.filter_from\" ng-change=\"ab.loadItems(1)\"></md-datepicker></div><div><md-datepicker class=\"md-datepicker-filter-bar\" id=\"filter_date_to\" name=\"filter_date_to\" md-placeholder=\"A\" md-min-date=\"ab.eStatus.filter_from\" md-max-date=\"ab.today\" ng-model=\"ab.eStatus.filter_to\" ng-change=\"ab.loadItems(1)\"></md-datepicker></div></div></div></div><div ng-if=\"ab.customer\"><h3>Elenco referrals</h3></div></md-toolbar></md-card-header><md-card-content style=\"overflow: auto\"><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"ab.query.order\" md-on-reorder=\"ab.eListReOrder\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"customers.name\" ng-if=\"!ab.customer\"><span>Segnalante</span></th><th md-column=\"\" ng-if=\"!ab.customer && !ab.storeId\"><span>Centro</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Segnalato</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Prenotato Tel.</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Presentato Tel.</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Prenotato</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Presentato</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Abbonato</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Fascia</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Abb. Pagato</span></th><th md-column=\"\" style=\"text-align: right;\"><span>%</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Da consegnare</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Doc.</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Consegnato</span></th><th md-column=\"\" style=\"text-align: center;\"><span>Mod.</span></th><th md-column=\"\" style=\"text-align: center;\"><span>Azioni</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.loading\"><td md-cell=\"\" colspan=\"8\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr ng-repeat-start=\"customer in ab.customers\"><td md-cell=\"\" ng-if=\"!ab.customer\">{{customer.firstname}} {{customer.lastname}}</td><td md-cell=\"\" ng-if=\"!ab.customer && !ab.storeId\"><span ng-if=\"customer.lastStore && customer.lastStore.data\">{{customer.lastStore.data.alias}}</span></td><td md-cell=\"\" style=\"text-align: right;\">{{customer.referralPhoneFriends.data.length}}</td><td md-cell=\"\" style=\"text-align: right;\">{{customer.referralPhoneFriendsStats.bookPhoneCount}}</td><td md-cell=\"\" style=\"text-align: right;\">{{customer.referralPhoneFriendsStats.paidPhoneCount}}</td><td md-cell=\"\" style=\"text-align: right;\">{{customer.referralPhoneFriendsStats.bookCount}}</td><td md-cell=\"\" style=\"text-align: right;\">{{customer.referralPhoneFriendsStats.paidCount}}</td><td md-cell=\"\" style=\"text-align: right;\">{{customer.referralPhoneFriendsStats.subscrCount}}</td><td md-cell=\"\" style=\"text-align: right;\"></td><td md-cell=\"\" style=\"text-align: right;\">{{customer.referralPhoneFriendsStats.subscr50PaidCount}}</td><td md-cell=\"\" style=\"text-align: right;\"></td><td md-cell=\"\" style=\"text-align: right;\">{{customer.referralPhoneFriendsStats.readyCount}}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.showDocumentsRoot( customer )\"><md-button ng-if=\"customer.referralPhoneFriendsStats.readyCount>0\" class=\"md-icon-button md-primary md-raised\" aria-label=\"Documenti\"><md-icon title=\"Documenti\" md-font-icon=\"assignment\">assignment</md-icon></md-button></td><td md-cell=\"\" style=\"text-align: right;\">{{customer.referralPhoneFriendsStats.delivCount}}</td><td md-cell=\"\"></td><td md-cell=\"\" style=\"padding: 10px;\"><md-button ng-if=\"!ab.customer\" class=\"md-icon-button md-primary md-raised\" aria-label=\"Scheda cliente\" ui-sref=\"home.customer( { customer_id : customer.id } )\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button></td></tr><tr ng-repeat-end=\"\" ng-repeat=\"lead in customer.referralPhoneFriends.data\" ng-if=\"ab.eStatus.showChilds\"><td md-cell=\"\" ng-if=\"!ab.customer\">&nbsp;</td><td md-cell=\"\" ng-if=\"!ab.customer && !ab.storeId\"></td><td md-cell=\"\" style=\"text-align: right;\"><span ng-if=\"lead.customer && lead.customer.data\" title=\"lid: {{lead.id}}\">{{lead.customer.data.firstname}} {{lead.data.customer.lastname}}</span></td><td md-cell=\"\" style=\"text-align: right;\">{{ab.haveTransitionTo(\'BookPhone\',lead)?\'SI\':\'\'}}</td><td md-cell=\"\" style=\"text-align: right;\">{{ab.haveTransitionTo(\'ShowPhone\',lead)?\'SI\':\'\'}}</td><td md-cell=\"\" style=\"text-align: right;\">{{[\'Book\',\'Show\', \'Subscr\',\'SubscrPaid50\',\'Ready\',\'Delivered\'].indexOf(lead.status)>=0?\'SI\':\'\'}}</td><td md-cell=\"\" style=\"text-align: right;\">{{[\'Show\', \'Subscr\',\'SubscrPaid50\',\'Ready\',\'Delivered\'].indexOf(lead.status)>=0?\'SI\':\'\'}}</td><td md-cell=\"\" style=\"text-align: right;\">{{[\'Subscr\',\'SubscrPaid50\',\'Ready\',\'Delivered\'].indexOf(lead.status)>=0?\'SI\':\'\'}}</td><td md-cell=\"\" style=\"text-align: right;\">{{lead.coupon_code}}</td><td md-cell=\"\" style=\"text-align: right;\">{{[\'SubscrPaid50\',\'Ready\',\'Delivered\'].indexOf(lead.status)>=0?\'SI\':\'\'}}</td><td md-cell=\"\" style=\"text-align: right;\"><span ng-if=\"lead.theshold\">{{lead.theshold | number:1}}%</span> <span ng-if=\"!lead.theshold\">50,0%</span></td><td md-cell=\"\" style=\"text-align: right;\">{{[\'Ready\',\'Delivered\'].indexOf(lead.status)>=0?\'SI\':\'\'}}</td><td md-cell=\"\" style=\"text-align: right;\" ng-click=\"ab.showDocuments( lead )\"><md-button ng-if=\"false && [\'Ready\',\'Delivered\'].indexOf(lead.status)>=0\" class=\"md-icon-button md-primary md-raised\" aria-label=\"Documenti\"><md-icon title=\"Documenti\" md-font-icon=\"assignment\">assignment</md-icon></md-button></td><td md-cell=\"\" style=\"text-align: right;\">{{[\'Delivered\'].indexOf(lead.status)>=0?\'SI\':\'\'}}</td><td md-cell=\"\" style=\"text-align: center; padding: 10px;\"><xipny-wkflow-entity-history-button wkflow=\"ab.wkflow\" entity=\"lead\" user=\"ab.user\"></xipny-wkflow-entity-history-button></td><td md-cell=\"\" style=\"padding: 10px;\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Scheda cliente\" ui-sref=\"home.customer( { customer_id : lead.customer_id } )\"><md-icon md-font-icon=\"perm_phone_msg\">perm_phone_msg</md-icon></md-button><xipny-wkflow-entity-list-buttons hide-auto=\"true\" user=\"ab.user\" entity=\"lead\" wkflow=\"ab.wkflow\"></xipny-wkflow-entity-list-buttons></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"!ab.loading && !ab.customer\" md-limit=\"ab.listPagination.per_page\" md-page=\"ab.listPagination.current_page\" md-total=\"{{ ab.listPagination.total }}\" md-on-paginate=\"ab.loadItems\" md-boundary-links=\"ab.options.boundaryLinks\"></md-table-pagination></md-card-content></md-card>");
$templateCache.put("app/components/md-datetime-picker/md-datetime-picker.html","<div flex=\"100\" ng-class=\"{ \'readonly\' : vm.readonly, \'editable\' : vm.editable }\"><div flex=\"\" ng-if=\"vm.readonly\"><p flex=\"\" layout=\"row\" layout-align=\"start center\"><span ng-if=\"vm.data\">{{vm.label ? vm.label+\':\':\'\'}} {{ vm.data | date : \'dd/MM/yyyy HH:mm\' }}</span> <span ng-if=\"! vm.data\">Nessuna data disponibile.</span><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Salva\" ng-click=\"vm.readonly = ! vm.readonly\" ng-if=\"vm.editable\"><md-icon md-font-icon=\"mode_edit\">mode_edit</md-icon></md-button></p></div><div flex=\"\" ng-if=\"! vm.readonly\"><div flex=\"\"><label ng-if=\"!vm.label && vm.command == null\" for=\"datepicker\">Chiamare il</label> <label ng-if=\"!vm.label && vm.command == \'call\'\" for=\"datepicker\">Chiamato il</label> <label ng-if=\"vm.label\" for=\"datepicker\">{{vm.label}}</label></div><div flex=\"\" layout=\"row\" layout-align=\"center center\"><div flex=\"35\"><md-datepicker required=\"\" id=\"datepicker\" name=\"datepicker\" ng-model=\"vm.datepicker\" md-placeholder=\"Data\" ng-change=\"vm.changeDate()\"></md-datepicker></div><div flex=\"5\"></div><md-input-container flex=\"\" class=\"md-block\"><input required=\"\" type=\"number\" id=\"hours\" name=\"hours\" placeholder=\"Ore\" aria-label=\"hours\" min=\"0\" max=\"24\" ng-min=\"0\" ng-max=\"23\" ng-model=\"vm.hours\" ng-change=\"vm.changeDate()\"></md-input-container><div flex=\"5\"></div><md-input-container flex=\"\" class=\"md-block\"><input required=\"\" type=\"number\" id=\"minutes\" name=\"minutes\" placeholder=\"Minuti\" aria-label=\"number\" min=\"0\" max=\"59\" step=\"1\" ng-min=\"0\" ng-max=\"59\" ng-model=\"vm.minutes\" ng-change=\"vm.changeDate()\"></md-input-container><div flex=\"5\"></div><md-input-container flex=\"\" class=\"md-block\" ng-if=\"vm.withdelay\"><input type=\"number\" id=\"delay\" name=\"delay\" placeholder=\"Rit. min.\" aria-label=\"Rit.. min.\" ng-model=\"vm.delay\" min=\"0\" max=\"240\" step=\"1\" ng-min=\"0\" ng-max=\"240\"></md-input-container><div flex=\"5\"></div><div flex=\"\" ng-if=\"vm.editable && vm.customer\" class=\"button-container\"><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.editable && vm.customer\"><md-button class=\"md-icon-button md-accent md-raised\" aria-label=\"Salva\" ng-click=\"vm.save( vm.customer )\"><md-icon md-font-icon=\"save\">save</md-icon></md-button><md-button ng-if=\"false\" class=\"md-icon-button md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"vm.undo( vm.customer )\"><md-icon md-font-icon=\"undo\">undo</md-icon></md-button><md-button class=\"md-icon-button md-default md-raised\" aria-label=\"Posponi\" ng-click=\"vm.snooze( vm.customer, true )\"><md-icon md-font-icon=\"access_time\">access_time</md-icon></md-button><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loading\"></md-progress-circular></div></div></div><div layout=\"row\" layout-align=\"center center\"><h3>{{vm.datepicker | date : \"EEEE, dd MMMM y\" }} alle ore {{vm.data | date : \"HH:mm\" }} <span ng-if=\"vm.delay\">(+{{vm.delay}} min.)</span></h3></div><div layout=\"row\" layout-align=\"center center\"><md-input-container ng-if=\"vm.withdelay\"><md-checkbox style=\"margin-top: 10px;\" ng-model=\"vm.noDelay\" ng-change=\"vm.noDalayChange()\">No rit.</md-checkbox></md-input-container><md-button class=\"md-accent md-raised\" aria-label=\"Domani\" ng-click=\"vm.domani()\">Domani</md-button><md-button class=\"md-icon-button md-accent md-raised\" aria-label=\"Agg.\" ng-click=\"vm.addDays( 1 )\"><md-icon md-font-icon=\"add\">add</md-icon></md-button><md-button class=\"md-icon-button md-accent md-raised\" aria-label=\"Back\" ng-click=\"vm.subDays( 1 )\"><md-icon md-font-icon=\"remove\">remove</md-icon></md-button><md-button class=\"md-accent md-raised\" aria-label=\"Mattina\" ng-click=\"vm.setTime(8,30,240)\">Matt.</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Pranzo\" ng-click=\"vm.setTime(12,30,60)\">Pranzo</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Pomer.\" ng-click=\"vm.setTime(14,30,180)\">Pomer.</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Cena\" ng-click=\"vm.setTime(19,30,60)\">Cena</md-button></div></div></div>");
$templateCache.put("app/components/md-input-file-img/md-input-file-img.html","<md-content layout=\"row\"><md-button aria-label=\"Upload\" class=\"md-fab md-mini md-primary\"><md-icon md-font-set=\"material-icons\" md-font-icon=\"photo\">photo</md-icon></md-button><md-input-container flex=\"\" class=\"md-block\" style=\"margin-top: 25px;\"><label for=\"fileObj\">{{ label }}</label> <input id=\"fileName\" name=\"fileName\" type=\"text\" arita-label=\"fileName\" class=\"fileName\" ng-readonly=\"true\" ng-model=\"img.fileName\"></md-input-container><input id=\"fileObj\" name=\"fileObj\" type=\"file\" aria-label=\"fileObj\" class=\"ng-hide fileObj\" ng-model=\"img.fileObj\" accept=\"{{accept}}\"></md-content>");
$templateCache.put("app/components/new-survey/new-survey.html","<div class=\"justify-content-end row m-0\"><div class=\"col-md-4 col-sm-12\"><select class=\"form-select\" aria-label=\"Tipo di Anamnesi\" ng-model=\"surveyType\" ng-change=\"changeSurveyType()\"><option value=\"\" selected=\"\" disabled=\"\">Tipo di anamnesi</option><option ng-repeat=\"survey in surveys track by $index\" value=\"{{survey.id}}\" title=\"scad. il {{survey.expired * 1000 | date}}\" class=\"{{survey.expired >= 0 ? \'text-danger\' : \'\'}}\">{{survey.name}}</option></select></div><div class=\"col-auto\"><select class=\"form-select\" aria-label=\"\" ng-model=\"customerSurveySel\" ng-disabled=\"!surveyType || surveyType == null || editable || editable == \'true\'\" ng-change=\"changeDateCompilation()\"><option value=\"\" disabled=\"\">Data di compilazione</option><option ng-repeat=\"(key, custSurvey) in custSurveys track by $index\" value=\"{{custSurvey.id}}\">{{custSurvey.created_at * 1000 | date}}</option></select></div><div class=\"col-auto\"><select class=\"form-select\" aria-label=\"Lingua\" ng-model=\"selectedLanguage\"><option selected=\"\" disabled=\"\" value=\"\">Seleziona lingua</option><option value=\"{{lang.id}}\" ng-repeat=\"lang in languages track by lang.id\">{{ lang.name }}</option></select></div></div><div class=\"bg-light p-3\" ng-hide=\"editable || editable == \'true\'\"><div class=\"border-bottom border-white mb-3 row\"><div class=\"col-6\"><h4>{{ (customerSurvey && customerSurvey.created_at ? customerSurvey.created_at * 1000 : \'\') | date }}</h4></div><div class=\"col-6 text-end\" ng-hide=\"!surveyType || surveyType == null\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"editSurvey()\">{{ (custSurveys && custSurveys.length > 0) ? \'Aggiorna anamnesi\' : \'Crea anamnesi\'}}</button></div></div><div class=\"align-items-end row\"><div class=\"col-3\" ng-repeat=\"question in customerSurvey.customerSurveyQuestions track by question.id\"><div class=\"mb-3 form-group\" ng-if=\"question.survey_question.answer_type == \'radio\'\"><label for=\"\" class=\"form-label\">{{ translation(question.questions_trans) }}</label><p><strong>{{question[\'answer\'] ? question[\'answer\'] : \'&nbsp;\'}}</strong></p></div><div class=\"mb-3 form-group\" ng-if=\"question.survey_question.answer_type == \'open\'\"><label for=\"\" class=\"form-label\">{{ translation(question.questions_trans) }}</label><p><strong>{{question[\'answer\'] ? question[\'answer\'] : \'&nbsp;\'}}</strong></p></div></div></div><div class=\"row m-0\" ng-if=\"customerSurvey\"><div class=\"col-12 text-end\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"onScaricaPdf()\"><md-icon md-font-icon=\"file_download\" style=\"color: white;\">file_download</md-icon>Scarica</button></div></div></div><div class=\"bg-light p-3\" ng-hide=\"!editable || editable == \'false\'\"><form id=\"formSurvey\" data-ng-submit=\"saveCustomerSurvey()\"><div class=\"row border-bottom border-white mb-3\"><div class=\"col-6\"><h4>{{ survey.name }}</h4><p class=\"text-muted\">Per indicare una risposta negativa lasciare il campo vuoto</p></div></div><div class=\"row align-items-end\"><div class=\"col-3\" ng-repeat=\"question in survey.survey_questions track by question.id\"><div class=\"mb-3 form-check\" ng-if=\"question.answer_type == \'radio\'\"><label for=\"\" class=\"form-label\">{{ translation(question.questions_trans) }}</label><md-radio-group ng-model=\"question[\'answer\']\" ng-required=\"{{question.required}}\"><md-radio-button class=\"survey-radio\" ng-repeat=\"answer_choice in splitAnswersToArray(translation(question.answer_choices_trans))\" value=\"{{answer_choice}}\">{{answer_choice}}</md-radio-button></md-radio-group></div><div class=\"mb-3 form-group\" ng-if=\"question.answer_type == \'open\'\"><label for=\"\" class=\"form-label\">{{ translation(question.questions_trans) }}</label> <textarea rows=\"2\" type=\"text\" ng-model=\"question[\'answer\']\" ng-model-options=\"abp.filter.options\" ng-required=\"{{question.required}}\" class=\"form-control\"></textarea></div></div></div><div class=\"row m-0\"><div class=\"col-6 text-start\"><button type=\"button\" class=\"btn btn-dark\" ng-click=\"editable = false;\">Annulla</button></div><div class=\"col-6 text-end\"><button type=\"submit\" class=\"btn btn-primary\">Salva anamnesi</button></div></div></form></div><div class=\"p-3 mt-4\" ng-if=\"leastSurveySurveyExpired()\"><h4>Questionari scaduti</h4><table style=\"width: 100% !important;\"><thead><tr><th scope=\"col\">Data scadenza</th><th scope=\"col\">Tipo anamnesi</th><th scope=\"col\" class=\"text-end\">Azioni</th></tr></thead><tbody><tr class=\"bg-warning\" ng-repeat=\"survey in surveys track by $index\" ng-if=\"survey.expired > 0\"><td class=\"border-left\">{{ survey.expired * 1000 | date }}</td><td>{{ survey.name }}</td><td class=\"text-end\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"openCustomerSurvey(survey.id)\"><i class=\"bi bi-arrow-up\"></i> Apri</button></td></tr></tbody></table></div>");
$templateCache.put("app/components/surveys/surveys.html","<md-progress-circular md-diameter=\"30\" ng-if=\"saving\" md-mode=\"indeterminate\"></md-progress-circular><div ng-repeat=\"survey in surveys\" ng-if=\"!saving\"><md-tab label=\"{{survey.name}}\"><div class=\"anamnesi-survey-questions\"><h3 flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\">{{survey.name}}</h3><md-table-container flex=\"100\"><div class=\"survey-question-container\" ng-repeat=\"(i,customerAnswer) in customerSurvey.data.data\"><div ng-if=\"customerAnswer.surveyQuestion.survey_id == survey.id && customerAnswer.surveyQuestion.deleted_at == null\" class=\"survey-question\"><div ng-if=\"customerAnswer.surveyQuestion.position==100\"><label for=\"{{surveyQuestion.id}}\">{{customerAnswer.surveyQuestion.question}}</label></div><div class=\"survey-question-label\" ng-if=\"customerAnswer.surveyQuestion.position!=100\"><label for=\"{{surveyQuestion.id}}\">{{customerAnswer.surveyQuestion.position}}) {{customerAnswer.surveyQuestion.question}} {{customerAnswer.surveyQuestion.required ? \"*\" : \"\"}}</label></div><md-radio-group ng-if=\"customerAnswer.surveyQuestion.answer_type == \'radio\'\" id=\"{{customerAnswer.surveyQuestion.id}}\" name=\"{{customerAnswer.surveyQuestion.id}}\" ng-model=\"customerAnswer.answer\" ng-required=\"customerAnswer.surveyQuestion.required\" ng-disabled=\"!editable || editable == \'false\'\"><md-radio-button class=\"survey-radio\" ng-repeat=\"answer_choice in customerAnswer.surveyQuestion.answer_choices_toArray\" value=\"{{answer_choice}}\">{{answer_choice}}</md-radio-button></md-radio-group><textarea ng-if=\"customerAnswer.surveyQuestion.answer_type == \'open\'\" rows=\"2\" type=\"text\" id=\"{{customerAnswer.surveyQuestion.id}}\" name=\"{{customerAnswer.surveyQuestion.id}}\" ng-model=\"customerAnswer.answer\" ng-model-options=\"abp.filter.options\" ng-required=\"customerAnswer.surveyQuestion.required\" ng-disabled=\"!editable || editable == \'false\'\">\n                        </textarea></div></div></md-table-container></div></md-tab></div>");
$templateCache.put("app/components/test-directive-with-scope/test-directive-with-scope.html","<h1>Employees: {{vm.employees}}</h1><br><input ng-model=\"vm.employees\"><br><h1>Delay: {{vm.delay}}</h1><br><input ng-model=\"vm.delay\"><br><div flex=\"100\" ng-class=\"{ \'readonly\' : vm.readonly, \'editable\' : vm.editable }\"><div flex=\"\" ng-if=\"vm.readonly\"><p flex=\"\" layout=\"row\" layout-align=\"start center\"><span ng-if=\"vm.data\">{{vm.label ? vm.label+\':\':\'\'}} {{ vm.data | date : \'dd/MM/yyyy HH:mm\' }}</span> <span ng-if=\"! vm.data\">Nessuna data disponibile.</span><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Salva\" ng-click=\"vm.readonly = ! vm.readonly\" ng-if=\"vm.editable\"><md-icon md-font-icon=\"mode_edit\">mode_edit</md-icon></md-button></p></div><div flex=\"\" ng-if=\"! vm.readonly\"><div flex=\"\"><label ng-if=\"!vm.label && vm.command == null\" for=\"datepicker\">Chiamare il</label> <label ng-if=\"!vm.label && vm.command == \'call\'\" for=\"datepicker\">Chiamato il</label> <label ng-if=\"vm.label\" for=\"datepicker\">{{vm.label}}</label></div><div flex=\"\" layout=\"row\" layout-align=\"center center\"><div flex=\"35\"><md-datepicker id=\"datepicker\" name=\"datepicker\" ng-model=\"vm.datepicker\" md-placeholder=\"Data\" ng-change=\"vm.changeDate()\"></md-datepicker></div><div flex=\"5\"></div><div flex=\"\"><div flex=\"\" layout=\"row\"><md-input-container flex=\"\" class=\"md-block\"><input type=\"number\" id=\"hours\" name=\"hours\" placeholder=\"Ore\" aria-label=\"hours\" min=\"0\" max=\"24\" ng-min=\"0\" ng-max=\"23\" ng-model=\"vm.hours\" ng-change=\"vm.changeDate()\"></md-input-container><md-input-container flex=\"\" class=\"md-block\"><input type=\"number\" id=\"minutes\" name=\"minutes\" placeholder=\"Minuti\" aria-label=\"number\" min=\"0\" max=\"59\" ng-min=\"0\" ng-max=\"59\" ng-model=\"vm.minutes\" ng-change=\"vm.changeDate()\"></md-input-container></div><div flex=\"\" layout=\"row\"><md-input-container flex=\"\" class=\"md-block\"><input type=\"text\" id=\"delay\" name=\"delay\" placeholder=\"Delay\" aria-label=\"Delay\" ng-model=\"vm.delay\"></md-input-container></div></div><div flex=\"\" ng-if=\"vm.editable && vm.customer\" class=\"button-container\"><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.editable && vm.customer\"><md-button class=\"md-icon-button md-accent md-raised\" aria-label=\"Salva\" ng-click=\"vm.save( vm.customer )\"><md-icon md-font-icon=\"save\">save</md-icon></md-button><md-button ng-if=\"false\" class=\"md-icon-button md-primary md-raised\" aria-label=\"Annulla\" ng-click=\"vm.undo( vm.customer )\"><md-icon md-font-icon=\"undo\">undo</md-icon></md-button><md-button class=\"md-icon-button md-default md-raised\" aria-label=\"Posponi\" ng-click=\"vm.snooze( vm.customer, true )\"><md-icon md-font-icon=\"access_time\">access_time</md-icon></md-button><md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loading\"></md-progress-circular></div></div></div></div></div>");
$templateCache.put("app/cuspaym/dialogs/appointments-info.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-list class=\"md-dense\" layout=\"row\"><md-list-item class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button ng-href=\"tel:{{ questo.customer.data.phone }}\" class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"phone\">phone</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"row\" flex=\"\"><a href=\"tel:{{ questo.customer.data.phone }}\"><h3>{{ questo.customer.data.phone }}</h3></a></div></div></md-list-item><md-list-item class=\"md-4-line\" ng-if=\"questo.note!=null && questo.note.trim()!=\'\'\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"event_note\">event_note</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\">{{ questo.note }}</div></div></md-list-item></md-list><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\"><span>Data app.</span></th><th md-column=\"\"><span>Trattamento</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"origin!=null\"><td md-cell=\"\">Origine</td><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ origin.data.user.data.color }};\"></div></td><td md-cell=\"\">{{ origin.date_start_frmt }}</td><td md-cell=\"\">{{ origin.treatment.data.name }}</td></tr><tr md-row=\"\" ng-if=\"payment!=null\"><td md-cell=\"\">Pagamento</td><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ payment.data.user.data.color }};\"></div></td><td md-cell=\"\">{{ payment.date_start_frmt }}</td><td md-cell=\"\">{{ payment.treatment.data.name }}</td></tr><tr md-row=\"\" ng-if=\"payment==null\" ng-repeat=\"capp in paymentCandidates\"><td md-cell=\"\">App. fissato</td><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ capp.data.user.data.color }};\"></div></td><td md-cell=\"\">{{ capp.date_start_frmt }}</td><td md-cell=\"\">{{ capp.treatment.data.name }}</td></tr></tbody></table></md-table-container></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/customer-detail/dialogs/anamnesis.html","<md-dialog aria-label=\"new-anamnesis\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\"><md-toolbar><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\">Anamnesi</h5><button ng-click=\"close()\" type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div></md-toolbar><md-dialog-content layout=\"row\"><new-survey class=\"w-100\" ng-if=\"customer.id\" control=\"customerSurvey\" customerid=\"customer.id\" user=\"user\" token=\"token\" customersurveys=\"customer.customerSurveysV2.data\"></new-survey></md-dialog-content><md-dialog-actions layout-margin=\"\"><div class=\"modal-footer text-end\"><button type=\"button\" class=\"btn btn-primary\" data-bs-dismiss=\"modal\">Chiudi</button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/customer-detail/dialogs/appointment-history.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\"><md-toolbar><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\">Storico appuntamento {{ appointmentPassed.treatment.name }}</h5><button type=\"button\" ng-click=\"close()\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div></md-toolbar><md-dialog-content layout=\"row\"><md-progress-circular style=\"margin-left: auto; margin-right: auto; margin-top: 5%; margin-bottom: 5%;\" md-diameter=\"50\" md-mode=\"indeterminate\" ng-if=\"loading\"></md-progress-circular><div flex=\"\" ng-if=\"!loading\"><div class=\"modal-body\"><table style=\"width: 100% !important;\"><tr><td>RIGA D\'ESEMPIO Spostato dal <strong>01/04/2021</strong> ore <strong>15:30</strong> <i class=\"bi bi-arrow-right\"></i> <strong>09/04/2021</strong> ore <strong>15:30</strong></td><td class=\"text-end\"><strong>Iezzi Giulia</strong> in data <strong>30/03/2021</strong> ore <strong>09:14</strong></td></tr><tr ng-repeat=\"app in appointmentsList\"><td ng-if=\"$index<appointmentsList.length-1\">Spostato dal <strong>{{appointmentsList[$index + 1].date_start_frmt }}</strong> al <strong>{{ app.date_start_frmt }}</strong></td><td ng-if=\"$index==appointmentsList.length-1\">\"PRIMO?\" Spostato dal <strong>{{appointment.date_fmt}} {{appointment.start_hour_fmt}}</strong> al <strong>{{ appointmentsList[$index - 1].date_start_frmt }}</strong></td><td class=\"text-end\" ng-if=\"app.recalled == 4\"><strong>{{ app.movedBy.data.lastname }} {{ app.movedBy.data.firstname }}</strong> in data <strong>{{ app.moved_at_frmt }}</strong></td><td class=\"text-end\" ng-if=\"app.recalled == 3\"><strong>{{ app.cancelledBy.data.lastname }} {{ app.cancelledBy.data.firstname }}</strong> in data <strong>{{ app.cancelled_at_frmt }}</strong></td><td class=\"text-end\" ng-if=\"app.recalled < 3 && app.updatedBy!=null\"><strong>{{ app.updatedBy.data.lastname }} {{ app.updatedBy.data.firstname }}</strong> in data <strong>{{ app.updated_at_frmt }}</strong></td></tr><tr><td>Prenotato per il <strong>{{appointment.date_fmt}} {{appointment.start_hour_fmt}}</strong></td><td class=\"text-end\"><strong>{{ appointment.user_lastname }} {{ appointment.user_firstname }}</strong> in data <strong>{{ appointmentCreationDate }}</strong></td></tr></table></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/customer-detail/dialogs/cancel-estimate.html","<md-dialog aria-label=\"new-anamnesis\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\"><md-toolbar><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\">Annulla preventivo n. 13 del 20/03/2021</h5><button ng-click=\"close()\" type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div></md-toolbar><md-content layout-margin=\"\"><div class=\"modal-body\"><div class=\"row\"><div class=\"col-12\"><div class=\"mb-3\"><label for=\"rimborso\" class=\"d-block form-label\">Genera rimborso</label><select class=\"form-select\" aria-label=\"rimborso\"><option selected=\"\" disabled=\"\">Seleziona</option><option value=\"1\">Parziale</option><option value=\"2\">Totale</option></select></div><div class=\"mb-3\"><label for=\"importo-rimborso\" class=\"form-label\">Importo del rimborso</label> <input type=\"text\" class=\"form-control\" id=\"importo-rimborso\"></div></div></div></div></md-content><md-dialog-actions layout-margin=\"\"><div class=\"modal-footer text-end\"><button type=\"button\" class=\"btn btn-primary\" data-bs-dismiss=\"modal\">Conferma l\'annullamento del preventivo</button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/customer-detail/dialogs/insert-payment.html","<md-dialog aria-label=\"insert-payment\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\"><md-toolbar><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\">Pagamenti preventivo n.13 del 23/03/2021</h5><button ng-click=\"close()\" type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div></md-toolbar><md-content layout-margin=\"\"><div class=\"modal-body\"><table style=\"width: 100% !important;\"><thead><tr><th scope=\"col\">Data</th><th scope=\"col\">Trattamento</th><th scope=\"col\">Importo</th><th scope=\"col\">Modalità</th><th scope=\"col\" colspan=\"2\">Saldato</th></tr></thead><tbody><tr><td>23/03/2021</td><td>Botox</td><td>220</td><td><select class=\"form-select\" aria-label=\"reminder\"><option selected=\"\" disabled=\"\">Seleziona</option><option value=\"11\">Pagobill</option><option value=\"12\">Bonifico</option><option value=\"12\">Pos</option></select></td><td><input type=\"text\" class=\"form-control\" id=\"\" placeholder=\"220\"></td><td class=\"text-end\"><button class=\"btn btn-primary\"><i class=\"bi bi-check\"></i></button></td></tr><tr><td>23/09/2020</td><td>Botox</td><td>220</td><td>Pos</td><td>220</td><td class=\"text-end\"><button class=\"btn btn-primary\"><i class=\"bi bi-gear\"></i></button></td></tr><tr><td>23/03/2020</td><td>Botox</td><td>220</td><td>Pos</td><td>220</td><td class=\"text-end\"><button class=\"btn btn-primary\"><i class=\"bi bi-gear\"></i></button></td></tr><tr><td>23/03/2020</td><td>Anticipo</td><td>-</td><td>Pos</td><td>100</td><td class=\"text-end\"><button class=\"btn btn-primary\"><i class=\"bi bi-gear\"></i></button></td></tr></tbody></table><div class=\"row fw-bold mt-5 py-4 bg-light\"><div class=\"col-4\">Totale preventivo: 660 euro</div><div class=\"col-4\">Totale saldato: 540 euro</div><div class=\"col-4 text-end\">Residuo: 120 euro</div></div></div></md-content><md-dialog-actions layout-margin=\"\"><div class=\"modal-footer text-end\"><button type=\"button\" class=\"btn btn-primary\" data-bs-dismiss=\"modal\">Conferma l\'annullamento del preventivo</button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/customer-detail/dialogs/notes.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\"><md-toolbar><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\">{{title}}</h5><button ng-click=\"close()\" type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><label for=\"exampleFormControlTextarea1\" class=\"form-label\">{{label}}</label> <textarea ng-model=\"appointmentPassed.note\" class=\"form-control\" id=\"exampleFormControlTextarea1\" rows=\"6\"></textarea></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-if=\"!appointmentPassed.closed\" ng-click=\"update(appointmentPassed)\" aria-label=\"Salva\" class=\"md-accent md-raised\">Salva</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/customer-detail/dialogs/operators.html","<md-dialog aria-label=\"new-anamnesis\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\"><md-toolbar><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\">Modifica operatori</h5><button ng-click=\"close()\" type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div></md-toolbar><md-content layout-margin=\"\"><div class=\"modal-body\"><table style=\"width: 100% !important;\"><thead><tr><th scope=\"col\">Ruolo</th><th scope=\"col\">Operatore attuale</th><th scope=\"col\">Nuovo operatore</th></tr></thead><tr><td>Medico</td><td>{{activeAppointment.user.data.firstname}} {{activeAppointment.user.data.lastname}}</td><td><select class=\"form-select\" aria-label=\"medico\" ng-model=\"activeAppointment.user_id\"><option ng-repeat=\"user in users | filter: {store_id: activeAppointment.store_id, active: true, role: \'operator\'} : true | orderBy: \'user.firstname\' track by user.id\" ng-value=\"user.user_id\">{{user.user.firstname}} {{user.user.lastname}}</option></select></td></tr><tr><td>Commerciale</td><td>{{activeAppointment.commercial_user.data.firstname}} {{activeAppointment.commercial_user.data.lastname}}</td><td><select class=\"form-select\" aria-label=\"medico\" ng-model=\"activeAppointment.commercial_user_id\"><option ng-repeat=\"user in users | filter: {store_id: activeAppointment.store_id, active: true, role: \'!operator\'} : true | filter: {active: true, role: \'!callcenter\'} : true | filter: {active: true, role: \'!admin\'} : true | orderBy: \'user.firstname\'\" ng-value=\"user.user_id\">{{user.user.firstname}} {{user.user.lastname}}</option></select></td></tr><tr><td>Assistente</td><td>{{activeAppointment.assist_user.data.firstname}} {{activeAppointment.assist_user.data.lastname}}</td><td><select class=\"form-select\" aria-label=\"medico\" ng-model=\"activeAppointment.assist_user_id\"><option ng-repeat=\"user in users | filter: {store_id: activeAppointment.store_id, active: true, role: \'assist\'} : true | orderBy: \'user.firstanme\'\" ng-value=\"user.user_id\">{{user.user.firstname}} {{user.user.lastname}}</option></select></td></tr></table></div></md-content><md-dialog-actions layout-margin=\"\"><button ng-click=\"save()\" type=\"button\" class=\"btn btn-primary\" data-bs-dismiss=\"modal\">Salva</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/customer-detail/dialogs/view-photo.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\"><md-toolbar><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\">Foto</h5><button ng-click=\"close()\" type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div></md-toolbar><md-dialog-content layout=\"row\"><div class=\"image-box\"><img src=\"{{selectedPhotoUrl}}\" alt=\"\" imageonload=\"\"><md-progress-circular class=\"image-preview-spinner\" style=\"margin-left: auto; margin-right: auto; margin-top: 5%; margin-bottom: 5%;\" md-diameter=\"50\" md-mode=\"indeterminate\" ng-if=\"loading\"></md-progress-circular></div></md-dialog-content></md-dialog>");
$templateCache.put("app/customer-pictures/dialogs/info-dialog.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Info</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><ul><li>Le miniature in basso sono distinte tra foto scattate prima (colore verde) e foto scattate dopo (colore voletto);</li><li>Selezionando una foto in basso, questa viene riproposta nella parte alta dello schermo in modo da essere zoomata;</li><li>E\' possibile deselezionare un\'immagine zoomata, premendo sul pulsante X;</li><li>Sulle due foto selezionate è possibile fare lo zoom con la rotellina del mouse e spostarsi in una zona specifica, mantenendo premuto il tasto sx del mouse e trascinando la stessa;</li></ul></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/customer-quotations/dialogs/email-dialog.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Preview Email</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\" <iframe=\"\" ng-bind-html=\"view\"></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">Chiudi</md-button><form method=\"post\" target=\"_blank\" action=\"{{postUrl}}\"><input type=\"hidden\" name=\"id\" id=\"id\" value=\"{{mainEntity.id}}\"> <input type=\"hidden\" name=\"customer_id\" id=\"customer_id\" value=\"{{mainEntity.customer_id}}\"> <input type=\"hidden\" name=\"send_email\" id=\"send_email\" value=\"true\"> <input type=\"hidden\" name=\"token\" id=\"token\" value=\"{{token}}\"> <button type=\"submit\" aria-label=\"Salva\" class=\"md-accent md-raised md-button md-ink-ripple\" ng-click=\"close()\">Salva</button></form></md-dialog-actions></md-dialog>");
$templateCache.put("app/groups/dialogs/users-list.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><div flex=\"\"><md-content layout-margin=\"\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span><b>Cognome</b></span></th><th md-column=\"\"><span><b>Nome</b></span></th><th md-column=\"\"><span><b>Ruolo</b></span></th><th md-column=\"\"><span><b>Email</b></span></th><th md-column=\"\"><span><b>Store</b></span></th></tr></thead><tbody ng-if=\"groupUsers\"><tr md-row=\"\" ng-if=\"usersLoading\"><td md-cell=\"\" colspan=\"8\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"usersLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" ng-repeat=\"user in groupUsers\"><td md-cell=\"\" style=\"text-align: left;\">{{ user.lastname }}</td><td md-cell=\"\" style=\"text-align: left;\">{{ user.firstname }}</td><td md-cell=\"\" style=\"text-align: left;\">{{ user.type }}</td><td md-cell=\"\" style=\"text-align: left;\">{{ user.email }}</td><td md-cell=\"\" style=\"text-align: left;\">{{ user.store.alias }}</td></tr></tbody></table></md-table-container></md-content></div><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/dialogs/broadcast-message.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-release-notes\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><h3>{{data.message}}</h3></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/dialogs/release_notes.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-release-notes\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-tabs><md-tab label=\"4.0\"><p><b>Rilascio del 19 Marzo 2021</b></p><ol class=\"release-notes\"><li><b>Integrazione Whatsapp Business (Biosmed)</b><ul><li>Invio ricezione messaggi whatsapp business (Biosmed);</li></ul></li><li><b>Funzione prossimo lead:</b><ul><li>Inserito componente whatsapp per invio diretto messaggi;</li><li>Inserita visualizzazione appuntamenti phone friends;</li><li>Inserita visualizzazione dati cliente segnalante;</li></ul></li><li><b>Gestione prodotti e ordini</b><ul><li>Gestita iva diversa per prodotto;</li></ul></li><li><b>Gestione costi</b><ul><li>Calcolo costi del personale in base a stipendio mensile e assenze;</li></ul></li><li><b>Analitycs & BI</b><ul><li>Report Kpi Istituti - Operatori (Biosmed);</li><li>Report Kpi Istituti - Store Manager (Biosmed);</li><li>Importazione Facebok Ads Insights;</li><li>Iserito CPL su report Kpi Marketing;</li></ul></li><li><b>Backend & configurazione</b><ul><li>Gestione Ads accounts Facebook;</li><li>Generazione schedulata di campagne marketing CAVEAU;</li></ul></li></ol></md-tab><md-tab label=\"3.0\"><p><b>Rilascio del 26 Gennaio 2020</b></p><ol class=\"release-notes\"><li><b>Assenze operatori commerciali:</b><ul><li>Gestione assenza operatori commerciali;</li><li>Ogni operatore pu&ograve; inserire le proprie assenze;</li><li>Non vengono assegnati leads se l\'operatore &egrave; in ferie il giorno corrente e il giorno successivo;</li></ul></li><li><b>Abilitazioni operatori commerciali sul periodo:</b><ul><li>Profilazione categorie leads abilitate per periodo;</li></ul></li><li><b>Elenco leads: colorazione lead Da chiamare, Da richiamare e NR</b><ul><li>I leads negli stati suddetti appaiono con colori di sfondo giallo dopo 24 ore, arancio dopo 48 e rosso dopo 72ore;</li></ul></li><li><b>Generazione leads \"Non presentato\":</b><ul><li>Ogni cliente commerciale non presentato (esclusi i disdetti) genera il giorno seguente un lead \"Non presentato\" assegnato all\'operatore che ha fissato l\'appuntamento;</li><li>Se l\'operatore che ha fissato l\'appuntamento non &egrave; attivo il lead viene assegnato ad altro operatore che accetta la categoria \"non presentato\";</li><li>I leads di questa categoria non vengono contati nel totale assegnati (analogamente a quanto accade per i phonefriends)</li></ul></li></ol></md-tab><md-tab label=\"2.9\"><p><b>Rilascio del 7 Dicembre 2019</b></p><ol class=\"release-notes\"><li><b>Gestione Giftcard:</b><ul><li>Nuovo trattamento Emissione Giftcard;</li><li>Nuova modalit&agrave; di pagamento tramite Giftcard</li></ul></li><li><b>Elenco leads:</b><ul><li>Pallino giallo con numero leads da richiamare e link alla visualizzazione;</li></ul></li><li><b>Leads PhoneFriends:</b><ul><li>Creazione lead PhoneFriend da rubrica e da elenco lead;</li></ul></li><li><b>Prodotti:</b><ul><li>Aggiunta funzione copia prodotti da Italia a tutte le aree;</li></ul></li><li><b>Feedback:</b><ul><li>Aggiunta funzione inserisci feedback nella topbar (<md-icon title=\"Feedback\" md-font-icon=\"feedback\">feedback</md-icon>);</li></ul></li></ol></md-tab><md-tab label=\"2.8\"><p><b>Rilascio del 1 Ottobre 2019</b></p><ol class=\"release-notes\"><li><b>Chiusura cassa:</b><ul><li>Proiezione quindicinale in chiusura cassa;</li><li>Aggiunta proiezione delta mensile;</li></ul></li><li><b>Costi/Ricavi:</b><ul><li>Gestione costi e ricavi quindicinali anzich&egrave; mensili;</li><li>Calcolo costi personale quindicinale;</li><li>Inserimento multiplo;</li><li>Gestione costi globali (senza centro)</li></ul></li><li><b>Profilazione utenze commerciali:</b><ul><li>Aggiunte categorie leads assegnati nel profilo utente;</li><li>Aggiunte tipologie lead A/B/R nel profilo utente;</li></ul></li><li><b>Gestione clienti rullo tramite generazione leads:</b><ul><li>Disabilitata funzione rullo per i commerciali;</li><li>Generazione giornaliera leads rullo;</li></ul></li><li><b>Elenco Appuntamenti:</b><ul><li>Aggiunti filtri in base alla modalit&agrave di pagamento;</li><li>Aggiunto nome operatrice in popup appuntamento;</li><li>Aggiunta visualizzazione nota \"cliente\" assieme a nota \"apputamento\";</li></ul></li><li><b>Corrispettivi:</b><ul><li>Estrazione excel corrispettvi;</li><li>Modificati filtri e raggruppamenti;</li><li>Visualizzazione corrispettivi annuali;</li></ul></li><li><b>Google Reviews:</b><ul><li>Aggiunta importazione reviews da Google My Business;</li><li>Visualizzazione reviews importate da Google My Business;</li></ul></li></ol></md-tab><md-tab label=\"2.7\"><ol class=\"release-notes\"><li><b>Elenco apputamenti:</b><ul><li>Agggiunto filtro \"Non fidelizzati\";</li><li>Aggiunto filtro \"Rate insolute\";</li></ul></li><li><b>Modifica numero zone per appuntamenti epilazione laser (escluso \"Laser conoscitivo\"):</b><ul><li>Per gli appuntamenti \"Laser\" &egrave; possibile modificare il numero di zone es. da \"Laser 5 zone\" a \"Laser 3 zone\"</li></ul></li><li><b>Vincoli su pagamento appuntamento:</b> <a href=\"https://youtu.be/JAo7vCFzxIo\" target=\"_blank\"><i class=\"material-icons\">ondemand_video</i></a><ul><li>Aggiunto campo \"Prezzo scontato\" con autonomia di sconto in base al ruolo (20% operatrici, 30% store manager);</li><li>Aggiunto campo \"Prezzo pagato\" e compilazione automatica rateizzazione nel caso di prezzo pagato minore del prezzo scontato;</li></ul></li><li><b>Gestione rate insolute su appuntamento:</b> <a href=\"https://youtu.be/JAo7vCFzxIo\" target=\"_blank\"><i class=\"material-icons\">ondemand_video</i></a><ul><li>Aggiunto elenco rate insolute su dettaglio appuntamento;</li><li>Selezione rata e calcolo del totale dovuto su dettaglio appuntamento;</li></ul></li></ol></md-tab><md-tab label=\"2.6\"><ol class=\"release-notes\"><li><b>Rullo:</b><ul><li>Agggiunto filtro \"Compleanno\";</li></ul></li><li><b>Elenco appuntamenti:</b><ul><li>Agggiunta icona<md-icon title=\"Bonifico\" md-font-icon=\"account_balance\">account_balance</md-icon>per i pagameti con bonifico;</li></ul></li><li><b>Elenco abbonamenti:</b><ul><li>Aggiunto filtro data creazione abbonamento;</li></ul></li><li><b>Porta un amico (campagna PhoneFriend):</b><ul><li>Aggiunta icona phone friend in elenco appuntamenti, con link all\'inserimento amici;</li></ul></li><li><b>Assegnazione leads commerciali:</b><ul><li>Limite di assegnazione in base al tag area;</li><li>I team leader possono riassegnare leads solo all\'interno della propria area;</li></ul></li><li><b>Rubrica:</b><ul><li>Ordinamento alfabetico;</li><li>Pagina di help iniziale;</li><li>Attivazione ricerca solo se il campo di ricerca &egrave; valorizzato;</li></ul></li><li><b>Creati Trattamenti \"Sottoscrizione abbonamento\":</b><ul><li>Sottoscrizione abbonamento Epilazione;</li><li>Sottoscrizione abbonamento Viso;</li><li>Sottoscrizione abbonamento Corpo;</li></ul></li></ol></md-tab><md-tab label=\"2.5\"><ol class=\"release-notes\"><li><b>Disponibilit&agrave;/Assenze:</b><ul><li><a href=\"https://youtu.be/d3-Va3qNH9o\" target=\"_blank\"><i class=\"material-icons\">ondemand_video</i></a> Gestione \"straordinario a recupero\" e \"permessi recupero\" con contatore ore residue da recuperare;</li><li>Inserito bottone \"Approva\" in assenza, visibile alle store manager;</li></ul></li><li><b>Ordini:</b> Calcolo budget su base trimestrale per limite ordini;</li><li><b>Booking:</b> Gestione disponibilit&agrave; dei macchinari per data;</li><li><b>Magazzino:</b> Aggiunto campo \"Motivo\" in carico e scarico magazzino;</li><li><b>Inventario:</b><a href=\"https://youtu.be/AzzMRBSGFgo\" target=\"_blank\"><i class=\"material-icons\">ondemand_video</i></a> Inizializzazione inventario mensile partendo dalla giacenza di magazzino: pulsante \"Da magazz.\";</li><li><b>Elenco appuntamenti:</b><ul><li>Aggiunta filtri: \"In Agenda\", \"Da chiamare\", \"Non risp.\", \"In Agenda + disdetti\", \"Disdetti\", \"Spostati\";</li><li>Aggiunta filtro \"Preso da\" con gli operatori commerciali;</li><li>Aggiunta visualizzazione \"% affidabilit&agrave; del cliente\" calcolata come rapporto tra appuntamenti in cui il cliente si &egrave; presentato e il numero totale degli appuntamenti presi (il cliente prima volta parte da affidabilit&agrave; 50%)</li></ul></li><li ng-if=\"!xstore\"><b>Rullo:</b><ul><li>Filtro per data creazione contatto;</li><li>Filtro \"Mai presentati\": per selezionare clienti mai presentati ma con appuntamento disdetto o bidone;</li></ul></li><li ng-if=\"!xstore\"><b>Appuntamenti, Ordini, Costi, Ricavi:</b> Visualizzazione dei dati di tutti i centri selezionando \"Tutti i centri\" nel filtro in alto a destra;</li><li><b>Dashboard:</b> Inserimento statistiche su appuntamenti del periodo selezionato;</li><li><b>Note rilascio:</b> <a href=\"https://youtu.be/T5GSoiTrLmk\" target=\"_blank\"><i class=\"material-icons\">ondemand_video</i></a> Aggiunto elenco con le principali modifiche relative alla versione del software installata;</li></ol></md-tab><md-tab label=\"2.4\"><ol class=\"release-notes\"><li><b>Disponibilit&agrave;/Assenze:</b><ul><li><a href=\"https://youtu.be/Qyojcf85Siw\" target=\"_blank\"><i class=\"material-icons\">ondemand_video</i></a> Gestione assenze;</li><li><a href=\"https://youtu.be/owsXGrUBZh0\" target=\"_blank\"><i class=\"material-icons\">ondemand_video</i></a> Inserito multiplo disponibilit&agrave; selezionando il luned&igrave;;</li></ul></li><li><b>Magazzino:</b><ul><li><a href=\"https://youtu.be/AzzMRBSGFgo\" target=\"_blank\"><i class=\"material-icons\">ondemand_video</i></a> Giacenza magazzino, carico e scarico manuale e automatico su ordini e appuntamenti;</li><li>Visualizzazione movimenti di magazzino;</li></ul></li></ol></md-tab><md-tab label=\"2.3\" ng-if=\"false\"></md-tab></md-tabs></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/operators/dialogs/capabilities.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"capabilitiesForm\" id=\"capabilitiesForm\" layout=\"column\" ng-if=\"!loading\"><md-table-container ng-if=\"op.capabilities.length>0\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span><b>Abilitazione</b></span></th><th md-column=\"\"><span>Commerciale</span></th><th md-column=\"\"><span>Manuale</span></th><th md-column=\"\"><span>Relazione</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"cap in op.capabilities\"><td md-cell=\"\" class=\"cell-button\" style=\"text-align: left;\">{{cap.name}}</td><td md-cell=\"\" style=\"text-align: left;\"><ng-rate-it ng-model=\"cap.comm\" min=\"0\" max=\"3\" step=\"1\" rated=\"save(cap)\" reset=\"reset(cap, \'comm\')\"></ng-rate-it></td><td md-cell=\"\" style=\"text-align: left;\"><ng-rate-it ng-model=\"cap.man\" min=\"0\" max=\"3\" step=\"1\" rated=\"save(cap)\" reset=\"reset(cap, \'man\')\"></ng-rate-it></td><td md-cell=\"\" style=\"text-align: left;\"><ng-rate-it ng-model=\"cap.rel\" min=\"0\" max=\"3\" step=\"1\" rated=\"save(cap)\" reset=\"reset(cap, \'rel\')\"></ng-rate-it></td></tr></tbody><thead md-head=\"\" ng-if=\"op.kpi\"><tr md-row=\"\"><th md-column=\"\" style=\"text-align: left;\"><span><b>Redd./H</b></span></th><th md-column=\"\" style=\"text-align: right;\"><span>Epilazione</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Viso</span></th><th md-column=\"\" style=\"text-align: right;\"><span>Corpo</span></th></tr></thead><tbody md-body=\"\" ng-if=\"op.kpi\"><tr md-row=\"\"><td md-cell=\"\" class=\"cell-button\" style=\"text-align: left;\">Prima volta</td><td md-cell=\"\" style=\"text-align: right;\">{{op.kpi.reddh_1av_1}}</td><td md-cell=\"\" style=\"text-align: right;\">{{op.kpi.reddh_1av_2}}</td><td md-cell=\"\" style=\"text-align: right;\">{{op.kpi.reddh_1av_3}}</td></tr><tr md-row=\"\"><td md-cell=\"\" class=\"cell-button\" style=\"text-align: left;\">Smaltimento</td><td md-cell=\"\" style=\"text-align: right;\">{{op.kpi.reddh_sm_1}}</td><td md-cell=\"\" style=\"text-align: right;\">{{op.kpi.reddh_sm_2}}</td><td md-cell=\"\" style=\"text-align: right;\">{{op.kpi.reddh_sm_3}}</td></tr></tbody></table></md-table-container></form></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/operators/dialogs/capabilitiesComm.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"80\" flex-md=\"70\" flex-gt-md=\"60\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"capabilitiesForm\" id=\"capabilitiesForm\" layout=\"column\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Da</span></th><th md-column=\"\"><span>A</span></th><th md-column=\"\"><span>%</span></th><th md-column=\"\"><span>Nuovi [A]</span></th><th md-column=\"\"><span>Nuovi [B]</span></th><th md-column=\"\"><span>Rientri</span></th><th md-column=\"\"><span>Dupl. lav.bili</span></th><th md-column=\"\"><span>Dupl. rigen.</span></th><th md-column=\"\"><span>Categorie</span></th><th md-column=\"\"><span>Zone</span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"loading || deleting || saving\"><td md-cell=\"\" colspan=\"7\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" ng-repeat=\"ua in op.user_attrs\"><td md-cell=\"\">{{ ua.date_from_frmt }}</td><td md-cell=\"\">{{ ua.date_to_frmt }}</td><td md-cell=\"\">{{ua.time_perc}}%</td><td md-cell=\"\">{{ua.f_lead_new_a ? \'Si\':\'No\'}}</td><td md-cell=\"\">{{ua.f_lead_new_b ? \'Si\':\'No\'}}</td><td md-cell=\"\">{{ua.f_lead_rientri ? \'Si\':\'No\'}}</td><td md-cell=\"\">{{ua.f_lead_dup_wrk ? \'Si\':\'No\'}}</td><td md-cell=\"\">{{ua.f_lead_dup_regen ? \'Si\':\'No\'}}</td><td md-cell=\"\">{{ ua.categories.join(\', \') }}</td><td md-cell=\"\">{{ ua.regions.join(\', \') }}</td><td md-cell=\"\" class=\"icon-button\"><md-button ng-if=\"user.type==\'admin\'\" class=\"md-icon-button md-warn\" ng-click=\"del( ua )\" ng-disabled=\"deleting\" aria-label=\"Elimina\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr></tbody></table></md-table-container><div ng-if=\"user.type == \'admin\' && !loading\"><h3>Inserisci nuove abilitazioni</h3><div layout=\"row\"><div flex=\"50\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" id=\"date_from\" name=\"date_from\" md-placeholder=\"Data inizio\" ng-model=\"activeUserAttr.date_from\" ng-change=\"onChangeDateFrom()\"></md-datepicker></div><div flex=\"50\"><md-datepicker class=\"md-datepicker-filter-bar no-border md-datepicker-full-width\" id=\"date_to\" name=\"date_to\" md-placeholder=\"Data fine\" md-min-date=\"activeUserAttr.date_from\" ng-model=\"activeUserAttr.date_to\" ng-change=\"onChangeDateTo()\"></md-datepicker></div></div><div layout=\"row\"><md-button class=\"md-accent md-raised\" aria-label=\"Tutte le campagne\" ng-click=\"pricingsAll(true)\" style=\"font-size: 100%\" ng-disabled=\"loading || saving\">Tutte le campagne</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Nessuna campagna\" ng-click=\"pricingsAll(false)\" style=\"font-size: 100%\" ng-disabled=\"loading || saving\">Nessuna campagna</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Tutte le zone\" ng-click=\"regionsAll(true)\" style=\"font-size: 100%\" ng-disabled=\"loading || saving\">Tutte le zone</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Nessuna zona\" ng-click=\"regionsAll(false)\" style=\"font-size: 100%\" ng-disabled=\"loading || saving\">Nessuna zona</md-button></div><div layout=\"row\" ng-if=\"env.isMaster\"><md-input-container flex=\"60\" class=\"md-block\"><label for=\"categories\">Campagne lead abilitate:</label><md-select ng-model=\"activeUserAttr.categories\" aria-label=\"Categorie Lead Abilitate\" id=\"categories\" name=\"categories\" multiple=\"true\"><md-option ng-value=\"cat.category\" ng-repeat=\"cat in categories\">{{ cat.category }}</md-option></md-select></md-input-container><md-input-container flex=\"40\" class=\"md-block\"><label for=\"categories\">Zone lead abilitate:</label><md-select ng-model=\"activeUserAttr.regions\" aria-label=\"Zone Lead Abilitate\" id=\"categories\" name=\"categories\" multiple=\"true\"><md-option ng-value=\"\'non presente\'\">Non presente</md-option><md-option ng-value=\"cat.region\" ng-repeat=\"cat in regions\">{{ cat.region }}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"30\" class=\"md-block\"><md-checkbox ng-model=\"activeUserAttr.f_lead_new_a\" ng-true-value=\"1\" ng-false-value=\"0\">Riceve \"Nuovi [A]\"</md-checkbox></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"30\" class=\"md-block\"><md-checkbox ng-model=\"activeUserAttr.f_lead_new_b\" ng-true-value=\"1\" ng-false-value=\"0\">Riceve \"Nuovi [B]\"</md-checkbox></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"30\" class=\"md-block\"><md-checkbox ng-model=\"activeUserAttr.f_lead_rientri\" ng-true-value=\"1\" ng-false-value=\"0\">Riceve \"Rientri\"</md-checkbox></md-input-container></div><div layout=\"row\"><md-input-container flex=\"30\" class=\"md-block\"><md-checkbox ng-model=\"activeUserAttr.f_lead_dup_wrk\" ng-true-value=\"1\" ng-false-value=\"0\">Riceve \"Dupl. Lavorabili\"</md-checkbox></md-input-container><md-input-container flex=\"30\" class=\"md-block\"><md-checkbox ng-model=\"activeUserAttr.f_lead_dup_regen\" ng-true-value=\"1\" ng-false-value=\"0\">Riceve \"Dupl. Rigenerati\"</md-checkbox></md-input-container></div><div layout=\"row\"><md-input-container flex=\"45\" class=\"md-block\"><label for=\"time_perc\">% su lead offline</label> <input type=\"number\" min=\"0\" step=\"5\" name=\"time_perc\" id=\"time_perc\" ng-model=\"activeUserAttr.time_perc\" required=\"\"></md-input-container></div><div ng-if=\"capabilitiesForm.$dirty\" layout=\"row\" layout-sm=\"column\"><md-progress-circular ng-if=\"saving\" md-mode=\"indeterminate\"></md-progress-circular><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"save()\" ng-disabled=\"saving || capabilitiesForm.$invalid\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button></div></div></form></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/reports/dialogs/reports-dialog-call_state.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"100\" flex-sm=\"80\" flex-md=\"70\" flex-gt-md=\"65\" role=\"dialog\" class=\"dialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Attenzione</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\" layout-padding=\"\"><md-list ng-if=\"vm.customersList.length\"><md-subheader class=\"md-no-sticky\"><span class=\"md-headline\">{{ ::vm.title }}</span></md-subheader><md-list-item layout-padding=\"\" class=\"md-2-line\" ng-repeat=\"customer in ::vm.customersList track by customer.id\"><div class=\"md-list-item full-width\" ng-init=\"customer.$selectedIndex = vm.customerStatus.call_state.indexOf( customer.call_state ); customer.$readonly = true;\"><div class=\"md-list-item-text\"><h3>{{ ::customer.firstname }} {{ ::customer.lastname }} - Tel.:{{ ::customer.phone }}</h3><h4 layout=\"row\" layout-align=\"start center\" style=\"margin: 8px auto 16px;\"><md-input-container flex=\"30\"><label for=\"call_state\">Stato cliente</label><md-select id=\"call_state\" name=\"call_state\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"call_state\" ng-model=\"customer.$selectedIndex\" ng-change=\"vm.customerStatus.onChange( customer );\"><md-option ng-value=\"$index\" ng-repeat=\"call_state in ::vm.customerStatus.call_state track by call_state\">{{ call_state }}</md-option></md-select></md-input-container><md-datetime-picker ng-if=\"vm.customerStatus.needDatePicker( customer.$selectedIndex )\" customer=\"customer\" data=\"customer.call_date\" readonly=\"customer.$readonly\" editable=\"true\"></md-datetime-picker></h4></div></div><md-divider ng-if=\"! $last\"></md-divider></md-list-item></md-list><h3 ng-if=\"! vm.customersList.length\">Ricordati di controllare gli appuntamenti in coda.</h3></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"vm.close()\" ng-if=\"vm.button_cancel\" aria-label=\"Chiudi\" class=\"md-warn\">{{ ::vm.button_cancel }}</md-button><md-button ng-click=\"vm.open()\" aria-label=\"Apri\" class=\"md-accent md-raised\" ng-if=\"vm.button_ok\" ng-disabled=\"vm.customerStatus.someoneNeedDatePicker( vm.customersList )\">{{ ::vm.button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/reviews/dialogs/editNotes.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"60\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\" class=\"text-center\"><md-content layout-margin=\"\"><textarea ng-model=\"review.notes\" style=\"width:450px; height:100px;\">\n                    {{review.notes}}\n                </textarea></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"save(review)\" aria-label=\"Salva\" class=\"md-accent md-raised\">{{ button_save }}</md-button><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-primary md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/storage/dialogs/appointment-info.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-list class=\"md-dense\" layout=\"row\"><md-list-item class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"book\">book</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"row\" flex=\"\"><h3>Appuntamento</h3></div></div></md-list-item><md-list-item class=\"md-4-line\" ng-if=\"questo.note!=null && questo.note.trim()!=\'\'\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"event_note\">event_note</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\">{{ origin.note }}</div></div></md-list-item></md-list><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\">Cliente</th><th md-column=\"\">Tel.</th><th md-column=\"\"><span>Data app.</span></th><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\"><span>Q.t&agrave;</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"origin!=null\"><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ origin.user.data.color }};\"></div></td><td md-cell=\"\">{{ origin.customer.data.firstname }} {{ origin.customer.data.lastname }}</td><td md-cell=\"\">{{ origin.customer.data.phone }}</td><td md-cell=\"\">{{ origin.date_start_frmt }}</td><td md-cell=\"\">{{ origin.treatment.data.name }}</td><td md-cell=\"\">{{ questo.add_qty }}</td></tr></tbody></table></md-table-container></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/storage/dialogs/info.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-list class=\"md-dense\" layout=\"row\"><md-list-item class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\" aria-label=\"Tipo\"><md-icon ng-if=\"type==\'scarico\'\" md-font-icon=\"remove_circle_outline\">add_circle_outline</md-icon><md-icon ng-if=\"type==\'carico\'\" md-font-icon=\"add_circle_outline\">add_circle_outline</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"row\" flex=\"\"><h3>{{ label }}</h3></div></div></md-list-item><md-list-item class=\"md-4-line\" ng-if=\"questo.note!=null && questo.note.trim()!=\'\'\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\" aria-label=\"Note\"><md-icon md-font-icon=\"event_note\">event_note</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\">{{ questo.note }}</div></div></md-list-item></md-list><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"><span>Operatrice</span></th><th md-column=\"\"><span>Data ora</span></th><th md-column=\"\"><span>Q.t&agrave;</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ questo.user.data.color }};\"></div></td><td md-cell=\"\">{{ questo.user.data.firstname }} {{ questo.user.data.lastname }}</td><td md-cell=\"\">{{ questo.created_at_frmt }}</td><td md-cell=\"\">{{type==\'carico\'?\'+\':\'\'}}{{ questo.add_qty }}</td></tr></tbody></table></md-table-container></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/storage/dialogs/order-info.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-list class=\"md-dense\" layout=\"row\"><md-list-item class=\"md-4-line\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"shopping_cart\">shopping_cart</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"row\" flex=\"\"><h3>Ordine</h3></div></div></md-list-item><md-list-item class=\"md-4-line\" ng-if=\"questo.note!=null && questo.note.trim()!=\'\'\"><div class=\"md-list-item\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"event_note\">event_note</md-icon></md-button><span flex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\" flex=\"\">{{ origin.note }}</div></div></md-list-item></md-list><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\">Id</th><th md-column=\"\"><span>Data ord.</span></th><th md-column=\"\"><span>Stato</span></th><th md-column=\"\"><span>In data</span></th><th md-column=\"\"><span>Q.t&agrave;</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"origin!=null\"><td md-cell=\"\"><div class=\"operator-circle\" style=\"background-color: {{ origin.user.color }};\"></div></td><td md-cell=\"\">{{ origin.id }}</td><td md-cell=\"\">{{ origin.date_frmt }}</td><td md-cell=\"\">{{ origin.status }}</td><td md-cell=\"\">{{ origin.updated_at_frmt }}</td><td md-cell=\"\">+{{ questo.add_qty }}</td></tr></tbody></table></md-table-container></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/wire-transfer/dialogs/associate-appointments-dialog.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"80\" flex-md=\"70\" flex-gt-md=\"60\" role=\"dialog\" class=\"dialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Associa gli appuntamenti corrispondenti</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><bl-appointments-wire-transfers paymenttype=\"\'B\'\" wiretransfer=\"wireTransfer\" storeid=\"storeId\" token=\"ab.token\"></bl-appointments-wire-transfers></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-raised\">Chiudi</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/wire-transfer/dialogs/associated-appointments-dialog.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"40\" flex-gt-md=\"40\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Appuntamenti Associati (id: {{wireTransfer.id}})</span></h2></div></md-toolbar><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-dialog-content layout=\"row\"><md-content flex=\"100\" layout-margin=\"\"><md-table-container><table md-table=\"\"><thead md-head=\"\" class=\"tab-head\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Trattamento</span></th><th md-column=\"\"><span>Importo</span></th><th md-column=\"\"><span>Azioni</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"appointmentWireTransfer in wireTransfer.appointment_wire_transfers\"><td md-cell=\"\">{{appointmentWireTransfer.appointment.date_start_frmt}}</td><td md-cell=\"\">{{appointmentWireTransfer.appointment.treatment.name}}</td><td md-cell=\"\"><span ng-if=\"appointmentWireTransfer.appointment\"><span ng-if=\"appointmentWireTransfer.appointment.payment_type == \'B\'\">{{appointmentWireTransfer.appointment.price | number:2}}</span> <span ng-if=\"appointmentWireTransfer.appointment.payment_type == \'M\'\">{{appointmentWireTransfer.appointment.payment_bon | number:2}}</span> <span ng-if=\"appointmentWireTransfer.appointment.payment_type == \'T\'\">{{appointmentWireTransfer.appointment.payment_satis | number:2}}</span> {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</span></td><td md-cell=\"\">{{ab.user.type}}<md-button title=\"Elimina Associazione\" aria-label=\"Elimina Associazione\" class=\"md-icon-button md-primary\" ng-click=\"deleteAppointmentWireTransfer(appointmentWireTransfer)\" ng-if=\"user.type == \'admin\'\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr></tbody></table></md-table-container></md-content></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-raised\">Chiudi</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/wire-transfer/dialogs/associated-cro-dialog.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"40\" flex-gt-md=\"40\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Cro Associati (aid: {{appointment.id}})</span></h2></div></md-toolbar><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-dialog-content layout=\"row\"><md-content flex=\"100\" layout-margin=\"\"><md-table-container><table md-table=\"\"><thead md-head=\"\" class=\"tab-head\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>CRO</span></th><th md-column=\"\"><span>Data Bonifico</span></th><th md-column=\"\"><span>Importo Bonifico</span></th><th md-column=\"\"><span>Azioni</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"appointmentWireTransfer in appointment.appointment_wire_transfers\"><td md-cell=\"\">{{appointmentWireTransfer.updated_at_frmt}}</td><td md-cell=\"\">{{appointmentWireTransfer.identification}}</td><td md-cell=\"\"><span ng-if=\"appointmentWireTransfer.wire_transfer\">{{appointmentWireTransfer.wire_transfer.transfer_date_frmt}}</span></td><td md-cell=\"\"><span ng-if=\"appointmentWireTransfer.wire_transfer\">{{appointmentWireTransfer.wire_transfer.amount | number:2 }} {{ab.env.currency?ab.env.currency.symbol:\'&euro;\'}}</span></td><td md-cell=\"\"><md-button title=\"Elimina Associazione\" aria-label=\"Elimina Associazione\" class=\"md-icon-button md-primary\" ng-click=\"deleteAppointmentWireTransfer(appointmentWireTransfer)\" ng-if=\"user.type == \'admin\'\"><md-icon md-font-icon=\"delete\">delete</md-icon></md-button></td></tr></tbody></table></md-table-container></md-content></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-raised\">Chiudi</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/wire-transfer/dialogs/details-dialog.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"40\" flex-gt-md=\"40\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Dettagli Bonifico</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><md-content flex=\"100\" layout-margin=\"\" layout-padding=\"\"><p><b>CRO:</b> {{wireTransfer.identification}}</p><p><b>CAUSALE:</b> {{wireTransfer.causal}}</p></md-content></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-raised\">Chiudi</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/wire-transfer/dialogs/set-cro-dialog.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"40\" flex-gt-md=\"40\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Associa codice di riferimento operazione (aid: {{appointment.id}})</span></h2></div></md-toolbar><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-dialog-content layout=\"row\"><md-content flex=\"100\" layout-margin=\"\"><md-input-container style=\"width: 100%;\" md-no-float=\"\"><input ng-model=\"croNumber\" placeholder=\"CRO\"><div class=\"hint\">Inserisci il codice CRO da associare</div></md-input-container></md-content></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-raised\">Chiudi</md-button><md-button ng-click=\"confirm()\" aria-label=\"Conferma\" class=\"md-accent md-raised\" ng-disabled=\"loading\">Conferma</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/bl-app-appointment/dialogs/appointment-app-points-list.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"40\" flex-gt-md=\"40\" role=\"dialog\" class=\"dialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">Movimenti APP</span></h2></div></md-toolbar><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-dialog-content layout=\"row\"><md-content flex=\"100\" layout-margin=\"\"><md-table-container><table md-table=\"\"><thead md-head=\"\" class=\"tab-head\"><tr md-row=\"\"><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Ammontare</span></th><th md-column=\"\"><span>Punti</span></th><th md-column=\"\"><span>Stato</span></th><th md-column=\"\"><span>Errore</span></th><th md-column=\"\"><span>Azioni</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in rechargesApp\"><td md-cell=\"\">{{item.created_at_frmt}}</td><td md-cell=\"\">{{item.amount | number: 2}} &euro;</td><td md-cell=\"\">{{item.points}}</td><td md-cell=\"\">{{item.status}}</td><td md-cell=\"\"><md-icon title=\"{{item.error_message}}\" md-font-icon=\"warning\" ng-if=\"item.error_code\" style=\"color: grey;\">warning</md-icon></td><td md-cell=\"\"><md-button class=\"md-icon-button md-primary md-button md-ink-ripple\" title=\"Aggiungi Contabilizzazione\" ng-if=\"item.status == \'to-send\' || item.status == \'ko\'\" ng-click=\"sendToApp(item)\"><md-icon md-font-icon=\"send\">send</md-icon></md-button><md-button class=\"md-icon-button md-primary md-button md-ink-ripple\" title=\"Elimina Contabilizzazione\" ng-if=\"item.status == \'ok\'\" ng-click=\"removeFromApp(item)\"><md-icon md-font-icon=\"settings_backup_restore\">settings_backup_restore</md-icon></md-button></td></tr></tbody></table></md-table-container></md-content></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-raised\">Chiudi</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/bl-customer-calls-modal/dialogs/dialog.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"80\" flex-md=\"70\" flex-gt-md=\"60\" role=\"dialog\" class=\"dialog\"><md-dialog-content layout=\"row\"><div flex=\"\"><md-content><bl-customer-calls-list customerid=\"customer_id\"></bl-customer-calls-list></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">Chiudi</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/bm-pictures-list/dialogs/email-dialog.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{template.title}}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><p ng-bind-html=\"template.blade\"></p><br><button ng-repeat=\"photo in appointment.pictures.data\" ui-sref=\"home.customer-pictures( { customer_id : appointment.customer_id, appointment_id : appointment.id } )\" style=\"margin-left: 5px;\" class=\"btn btn-success\"><i class=\"bi bi-card-image\"></i></button></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">Chiudi</md-button><button type=\"submit\" aria-label=\"Salva\" class=\"md-accent md-raised md-button md-ink-ripple\" ng-click=\"sendEmail()\" ng-disabled=\"loading\">Invia</button><md-progress-circular md-diameter=\"15\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular></md-dialog-actions></md-dialog>");
$templateCache.put("app/xipny-wkflow/directives/wk-entity-history-button/wk-entity-history-button.html","<md-button ng-click=\"vm.showHistory(entity)\" class=\"md-icon-button md-primary md-raised\" aria-label=\"Storico modifiche lead\"><md-icon title=\"Storico modifiche\" md-font-icon=\"change_history\">change_history</md-icon></md-button>");
$templateCache.put("app/xipny-wkflow/directives/wk-entity-list/wk-entity-list.html","<md-content class=\"page-addressbook\" layout-fill=\"\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><md-icon md-font-icon=\"input\">input</md-icon><span class=\"inset\">Work List</span></h2><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select id=\"wkflow\" name=\"wkflow\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Workflow Name\" placeholder=\"Workflow Name\" ng-model=\"ab.eStatus.wkflow\" ng-change=\"ab.searchWkflowChanged()\" ng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option ng-value=\"undefined\">Tutti i workflows</md-option><md-option ng-value=\"wkflow\" ng-repeat=\"wkflow in ab.wkflows track by wkflow.id\">[{{wkflow.name}}] - {{ wkflow.label }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-select id=\"wkstate\" name=\"wkstate\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"Workflow State\" placeholder=\"Workflow State\" ng-model=\"ab.eStatus.wkstate\" ng-change=\"ab.eListLoad(1)\"><md-option ng-value=\"undefined\">Tutti gli stati</md-option><md-option ng-if=\"ab.eStatus.wkflow\" ng-value=\"wkstate.name\" ng-repeat=\"wkstate in ab.wkstates | filter: {wkflow_id: ab.eStatus.wkflow.id} : true | orderBy: \'name\'\">[{{wkstate.name}}] - {{ wkstate.label }}</md-option></md-select></md-input-container><span flex=\"\" hide-xs=\"\"></span><div layout=\"column\"><div layout=\"row\"><div><md-datepicker class=\"md-datepicker-filter-bar\" id=\"filter_date_from\" name=\"filter_date_from\" md-placeholder=\"Creazione Da\" md-max-date=\"ab.today\" ng-model=\"ab.eStatus.filter_from\" ng-change=\"ab.eListLoad(1)\"></md-datepicker></div><div><md-datepicker class=\"md-datepicker-filter-bar\" id=\"filter_date_to\" name=\"filter_date_to\" md-placeholder=\"A\" md-min-date=\"ab.eStatus.filter_from\" md-max-date=\"ab.today\" ng-model=\"ab.eStatus.filter_to\" ng-change=\"ab.eListLoad(1)\"></md-datepicker></div></div><div layout=\"row\"><div><md-datepicker class=\"md-datepicker-filter-bar\" id=\"filter_date_upd_from\" name=\"filter_date_upd_from\" md-placeholder=\"Aggiornamento Da\" md-max-date=\"ab.today\" ng-model=\"ab.eStatus.filter_upd_from\" ng-change=\"ab.eListLoad(1)\"></md-datepicker></div><div><md-datepicker class=\"md-datepicker-filter-bar\" id=\"filter_date_upd_to\" name=\"filter_date_upd_to\" md-placeholder=\"A\" md-min-date=\"ab.eStatus.filter_upd_from\" md-max-date=\"ab.today\" ng-model=\"ab.eStatus.filter_upd_to\" ng-change=\"ab.eListLoad(1)\"></md-datepicker></div></div></div></div></md-toolbar><md-card><md-card-header style=\"padding-bottom: 6px; padding-top: 6px;\"><md-toolbar class=\"md-table-toolbar md-default search-toolbar with-other-filters\"><div class=\"md-toolbar-tools\"><md-input-container flex=\"nogrow\" md-no-float=\"\"><md-icon md-font-icon=\"search\">search</md-icon><input ng-model=\"ab.query.filter\" ng-keypress=\"ab.onKeyPressSearch($event)\" type=\"search\" placeholder=\"Cerca\"></md-input-container><div flex=\"nogrow\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Annulla\" ng-click=\"ab.removeSearch()\"><md-icon md-font-icon=\"cancel\">cancel</md-icon></md-button></div><span flex=\"\" hide-xs=\"\"></span><xipny-wkflow-entity-list-buttons ng-if=\"ab.eStatus.wkstate\" user=\"ab.user\" wkstate=\"ab.eStatus.wkstate\" list=\"ab.entityList\" wkflow=\"ab.eStatus.wkflow\"></xipny-wkflow-entity-list-buttons><md-button ng-if=\"ab.eStatus.wkflow && !ab.eStatus.wkstate\" class=\"md-accent md-raised\" aria-label=\"Nuovo\" ng-click=\"ab.toggleRight()\"><md-icon md-font-icon=\"person_add\">person_add</md-icon>Nuovo</md-button></div></md-toolbar></md-card-header><md-card-content style=\"overflow-y: auto; padding-top: 0px;\"><md-table-container><table md-table=\"\" md-row-select=\"ab.options.rowSelection\" ng-model=\"ab.selected\"><thead md-head=\"\" md-order=\"ab.query.order\" md-on-reorder=\"ab.eListReOrder\"><tr md-row=\"\"><th md-column=\"\"><md-checkbox ng-if=\"ab.user.type==\'admin\'\" ng-disabled=\"!ab.eStatus.wkstate\" ng-checked=\"ab.allSelected\" ng-click=\"ab.toggleAllSelected()\" aria-label=\"Seleziona tutti\"></md-checkbox></th><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"customers.lastname\"><span>Nome</span></th><th md-column=\"\" md-order-by=\"customers.phone\"><md-icon md-font-icon=\"phone_android\">phone_android</md-icon><span>Telefono</span></th><th md-column=\"\"><span>Contatta</span></th><th md-column=\"\" md-order-by=\"customers.city\"><span>Citt&agrave;</span></th><th md-column=\"\"><span>Mod.</span></th><th md-column=\"\" md-order-by=\"leads.campagna\"><span>Campagna</span></th><th md-column=\"\" md-order-by=\"leads.category\"><span>WkFlow</span></th><th md-column=\"\" md-order-by=\"leads.note\"><span>N.</span></th><th md-column=\"\"><span>Doc.</span></th><th md-column=\"\" md-order-by=\"leads.created_at\"><span>Creato il</span></th><th md-column=\"\" md-order-by=\"status\"><span>Stato</span></th><th md-column=\"\" md-order-by=\"leads.updated_at\"><span>Mod. il</span></th><th md-column=\"\"><span>Azioni</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-if=\"ab.eListLoading\"><td md-cell=\"\" colspan=\"15\" style=\"text-align: center;\"><md-progress-circular md-diameter=\"30\" ng-if=\"ab.eListLoading\" md-mode=\"indeterminate\"></md-progress-circular></td></tr><tr md-row=\"\" md-select=\"e\" md-auto-select=\"ab.options.autoSelect\" md-select-id=\"e.id\" md-on-select=\"ab.rowClicked\" ng-repeat-start=\"e in ab.eList\" ng-style=\"e.deleted?{opacity: 0.6}:(!e.deleted && e.color && false?{ \'background-color\': e.color }:{})\"><td md-cell=\"\"><md-checkbox ng-if=\"ab.user.type==\'admin\'\" ng-disabled=\"!ab.eStatus.wkstate || ab.eStatus.wkstate != e[ab.eStatus.wkflow.entity_state]\" ng-checked=\"e.isSelected\" ng-click=\"ab.toggleSelected(e)\" aria-label=\"Seleziona\"></md-checkbox></td><td md-cell=\"\"><md-icon ng-if=\"!e.f_dup && e.f_dup_wrk\" md-font-icon=\"looks_two\" style=\"background-color: white; color:orange;\">looks_two</md-icon><md-icon ng-if=\"!e.f_dup && e.f_dup_regen\" md-font-icon=\"looks_two\" style=\"background-color: white; color:green\">looks_two</md-icon><md-icon ng-if=\"!e.f_dup_wrk && !e.f_dup_regen && e.f_many_times && e.user_times==0 && !e.f_oper && !e.f_dup\" md-font-icon=\"repeat\" style=\"color:red;\">repeat</md-icon><md-icon ng-if=\"!e.f_dup_wrk && !e.f_dup_regen && !e.f_new && !(e.f_many_times && e.user_times==0) && !e.f_oper && !e.f_dup\" md-font-icon=\"repeat\">repeat</md-icon><md-icon ng-if=\"e.f_dup\" md-font-icon=\"looks_two\">looks_two</md-icon><md-icon ng-if=\"e.f_oper\" md-font-icon=\"not_interested\">not_interested</md-icon></td><td md-cell=\"\">{{ e.customer.data.lastname }} {{ e.customer.data.firstname }}</td><td md-cell=\"\"><md-icon ng-click=\"ab.removeSearch(e.customer.data.phone)\" md-font-icon=\"search\">search</md-icon><a href=\"tel:{{ e.customer.data.phone }}\">{{ e.customer.data.phone }}</a></td><td md-cell=\"\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Chiama\" href=\"tel:+39{{e.customer.data.phone}}\"><md-icon md-font-icon=\"call\">call</md-icon></md-button><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"WhatsApp\" ui-sref=\"home.whatsapp({phone: e.customer.data.phone})\"><md-icon md-font-icon=\"chat\">chat</md-icon></md-button></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.customer.data.city }}</td><td md-cell=\"\"><xipny-wkflow-entity-history-button wkflow=\"ab.eStatus.wkflow\" entity=\"e\" user=\"ab.user\"></xipny-wkflow-entity-history-button></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.campagna }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.category }}</td><td md-cell=\"\" ng-click=\"ab.showNote( e )\"><md-icon title=\"Nota\" md-font-icon=\"event_note\" ng-if=\"e.note != null && e.note != \'\'\">event_note</md-icon></td><td md-cell=\"\" ng-click=\"ab.showDocuments( e )\"><md-button class=\"md-icon-button md-primary md-raised\" aria-label=\"Documenti\"><md-icon title=\"Documenti\" md-font-icon=\"assignment\">assignment</md-icon></md-button></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.created_at_frmt }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\"><span ng-if=\"e.wkstate && e.wkstate.data\">{{e.wkstate.data.label}}</span><md-progress-circular md-diameter=\"15\" ng-if=\"e.loading\" md-mode=\"indeterminate\"></md-progress-circular></td><td md-cell=\"\" ng-click=\"ab.rowClicked(e)\">{{ e.updated_at_frmt }}</td><td md-cell=\"\"><xipny-wkflow-entity-list-buttons user=\"ab.user\" entity=\"e\" wkflow=\"ab.eStatus.wkflow\"></xipny-wkflow-entity-list-buttons></td></tr><tr ng-repeat-end=\"\" ng-repeat=\"c in e.childs.data\" ng-style=\"c.deleted?{opacity: 0.6}:(!c.deleted && c.color?{ \'background-color\': c.color }:{})\"><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\"><xipny-wkflow-entity-history-button wkflow=\"ab.eStatus.wkflow\" entity=\"c\" user=\"ab.user\"></xipny-wkflow-entity-history-button></td><td md-cell=\"\"></td><td md-cell=\"\"></td><td md-cell=\"\" ng-click=\"ab.showNote( c )\"><md-icon title=\"Nota\" md-font-icon=\"event_note\" ng-if=\"c.note != null && c.note != \'\'\">event_note</md-icon></td><td md-cell=\"\"></td><td md-cell=\"\" ng-click=\"ab.rowClicked(c)\">{{ c.created_at_frmt }}</td><td md-cell=\"\" ng-click=\"ab.rowClicked(c)\"><span ng-if=\"c.wkstate && c.wkstate.data\">{{c.wkstate.data.label}}</span></td><td md-cell=\"\" ng-click=\"ab.rowClicked(c)\">{{ c.updated_at_frmt }}</td><td md-cell=\"\"><xipny-wkflow-entity-list-buttons user=\"ab.user\" entity=\"c\" wkflow=\"ab.eStatus.wkflow\"></xipny-wkflow-entity-list-buttons></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"!ab.eListLoading\" md-limit=\"ab.eListPag.per_page\" md-page=\"ab.eListPag.current_page\" md-total=\"{{ ab.eListPag.total }}\" md-on-paginate=\"ab.eListLoad\" md-boundary-links=\"ab.options.boundaryLinks\" md-page-select=\"ab.options.pageSelect\"></md-table-pagination></md-card-content></md-card></md-content><md-sidenav md-whiteframe=\"4\" class=\"page-addressbook md-sidenav-right\" md-component-id=\"right\"><md-toolbar class=\"soft-toolbar\"><div class=\"md-toolbar-tools\"><md-icon md-font-icon=\"input\">input</md-icon><h2 class=\"md-headline\"><span class=\"inset\">{{ ab.activeE.customer.data.firstname }} {{ ab.activeE.customer.data.lastname }} (cid: {{ ab.activeE.customer.data.id }} / lid: {{ ab.activeE.id }})</span></h2><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"ab.closeSidebar()\"><md-icon md-font-icon=\"close\">close</md-icon></md-button></div></md-toolbar><md-content layout-margin=\"\"><form autocomplete=\"off\" role=\"form\" name=\"eForm\" id=\"eForm\" layout=\"row\" layout-wrap=\"\"><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"campagna\">Campagna</label> <input type=\"text\" id=\"campagna\" name=\"campagna\" required=\"\" ng-model=\"ab.activeE.campagna\" ng-disabled=\"true\" ng-model-options=\"ab.filter.options\"></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"campagna\">WkFlow</label> <input type=\"text\" id=\"wkflow\" name=\"wkflow\" ng-model=\"ab.eStatus.wkflow.name\" ng-disabled=\"true\" ng-model-options=\"ab.filter.options\"></md-input-container></div><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"firstname\">Nome</label> <input type=\"text\" id=\"firstname\" name=\"firstname\" ng-model=\"ab.activeE.customer.data.firstname\" ng-model-options=\"ab.filter.options\" ng-disabled=\"ab.saving || ab.phoneChecking\"></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"lastname\">Cognome</label> <input type=\"text\" id=\"lastname\" name=\"lastname\" ng-model=\"ab.activeE.customer.data.lastname\" ng-model-options=\"ab.filter.options\" ng-disabled=\"ab.saving || ab.phoneChecking\"></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"phone\">Telefono</label> <input type=\"text\" id=\"phone\" name=\"phone\" required=\"\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-model=\"ab.activeE.customer.data.phone\" ng-blur=\"ab.checkPhoneExists()\" ng-model-options=\"ab.filter.options\" ng-disabled=\"ab.saving || ab.phoneChecking\"><div ng-messages=\"eForm.phone.$error\" ng-show=\"eForm.phone.$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div><div ng-message=\"pattern\"><small>Inserisci un numero di cellulare valido.</small><br>Inserisci il tuo numero di cellulare (9 o 10 cifre) senza spazi ne altri caratteri.</div><div ng-message=\"alreadyexists\">Numero di cellulare usato da altro cliente: {{ab.customerExists.lastname}} {{ab.customerExists.firstname}}</div></div><div style=\"margin-top: 5px;\" ng-if=\"ab.phoneChecking\"><md-progress-circular md-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div></md-input-container><md-input-container flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><label for=\"email\">Email</label> <input type=\"text\" id=\"email\" name=\"email\" ng-model=\"ab.activeE.customer.data.email\" ng-model-options=\"ab.filter.options\" ng-disabled=\"ab.saving || ab.phoneChecking\"></md-input-container><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\"><label for=\"birthdate\">Data di Nascita</label><md-datepicker id=\"birthdate\" name=\"birthdate\" ng-model=\"ab.activeE.customer.data.birthdate\" ng-disabled=\"ab.saving || ab.phoneChecking\" md-placeholder=\"Data di nascita\"></md-datepicker></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\"><br hide-gt-sm=\"\"><br hide-gt-sm=\"\"><label for=\"gender\" style=\"margin-bottom: 8px;\">Sesso *</label><md-radio-group id=\"gender\" name=\"gender\" ng-model=\"ab.activeE.customer.data.gender\" ng-disabled=\"ab.saving || ab.phoneChecking\" required=\"\"><md-radio-button value=\"F\">Femmina</md-radio-button><md-radio-button value=\"M\" class=\"md-primary\">Maschio</md-radio-button></md-radio-group></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"address\">Indirizzo</label> <input type=\"text\" id=\"address\" name=\"address\" ng-model=\"ab.activeE.customer.data.address\" ng-model-options=\"ab.filter.options\" ng-disabled=\"ab.saving || ab.phoneChecking\"></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"city\">Città</label> <input type=\"text\" id=\"city\" name=\"city\" ng-model=\"ab.activeE.customer.data.city\" ng-model-options=\"ab.filter.options\" ng-disabled=\"ab.saving || ab.phoneChecking\"></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"zip_code\">CAP</label> <input type=\"text\" id=\"zip_code\" name=\"zip_code\" ng-model=\"ab.activeE.customer.data.zip_code\" ng-model-options=\"ab.filter.options\" ng-disabled=\"ab.saving || ab.phoneChecking\"></md-input-container></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label for=\"province\">Provincia</label><md-select id=\"province\" name=\"province\" class=\"first-uppercase\" md-container-class=\"first-uppercase\" aria-label=\"province\" ng-model=\"ab.activeE.customer.data.province\" ng-model-options=\"ab.filter.options\" ng-disabled=\"ab.saving || ab.phoneChecking\"><md-option ng-value=\"null\">Nessuna provincia</md-option><md-optgroup label=\"{{ regione }}\" ng-repeat=\"( regione, province ) in ::ab.Italia track by regione\"><md-option ng-value=\"provincia.sigla\" ng-repeat=\"provincia in ::province track by provincia.sigla | orderBy: provincia.sigla\">{{ provincia.nome }}</md-option></md-optgroup></md-select></md-input-container></div><div flex=\"100\"><md-input-container class=\"md-block\"><label for=\"note\">Note</label> <textarea rows=\"2\" id=\"note\" name=\"note\" ng-model=\"ab.activeE.note\" ng-model-options=\"ab.filter.options\" ng-disabled=\"ab.saving || ab.phoneChecking\"></textarea></md-input-container></div><div flex=\"100\"><md-progress-circular ng-if=\"ab.saving\" md-mode=\"indeterminate\"></md-progress-circular><md-input-container class=\"md-block\"><md-button class=\"md-accent md-raised\" aria-label=\"Salva\" ng-click=\"ab.update( ab.activeE )\" ng-disabled=\"eForm.$invalid || ab.saving || ab.phoneChecking\"><md-icon md-font-icon=\"check\">check</md-icon>Salva</md-button></md-input-container></div></form></md-content></md-sidenav>");
$templateCache.put("app/xipny-wkflow/directives/wk-entity-list-buttons/wk-entity-list-buttons.html","<md-button ng-repeat=\"transition in ab.transitionsFrom\" ng-click=\"ab.startTransition(transition)\" class=\"md-primary md-raised mr-1\" aria-label=\"{{transition.label}}\" ng-show=\"!transition.auto_run || !ab.hideauto\" ng-disabled=\"!ab.canTransition(transition) || transition.auto_run || (ab.entity && ab.entity.wkloading)\"><md-icon ng-if=\"transition.icon\" md-font-icon=\"{{transition.icon}}\">{{transition.icon}}</md-icon><span ng-if=\"!transition.icon\"><b ng-if=\"transition.auto_run\">[a]</b>{{transition.label}}</span></md-button><md-button ng-if=\"ab.statesInitial && (!ab.transitionsFrom || ab.transitionsFrom.length==0)\" ng-repeat=\"state in ab.statesInitial\" ng-click=\"ab.startTransition(null, state)\" class=\"md-primary md-raised mr-1\" ng-disabled=\"ab.entity.wkloading\" aria-label=\"{{state.label}}\"><md-icon ng-if=\"state.icon\" md-font-icon=\"{{state.icon}}\">{{state.icon}}</md-icon><span ng-if=\"!state.icon\">{{state.label}}</span></md-button><md-button layout=\"row\" ng-if=\"!ab.hideundo && ab.entity && ab.entity.transitionLast && ab.entity.transitionLast.data && ab.entity.transitionLast.data.wkstate_id_from\" ng-click=\"ab.undoTransition(ab.entity.transitionLast.data)\" ng-disabled=\"ab.entity.wkloading\" class=\"md-primary md-raised md-warn mr-1\" aria-label=\"{{ab.entity.transitionLast.data.wkTransition.data.label}}\">[UNDO]&nbsp;<md-icon ng-if=\"ab.entity.transitionLast.data.wkTransition.data.icon\" md-font-icon=\"{{ab.entity.transitionLast.data.wkTransition.data.icon}}\">{{ab.entity.transitionLast.data.wkTransition.data.icon}}</md-icon><span ng-if=\"!ab.entity.transitionLast.data.wkTransition.data.icon && ab.entity.transitionLast.data.wktransition_id\">{{ab.entity.transitionLast.data.wkTransition.data.label}}</span> <span ng-if=\"!ab.entity.transitionLast.data.wkTransition.data.icon && !ab.entity.transitionLast.data.wktransition_id\">Join</span> &nbsp;<md-progress-circular class=\"\" md-diameter=\"15\" ng-if=\"ab.entity.wkloading\" md-mode=\"indeterminate\"></md-progress-circular></md-button>");
$templateCache.put("app/xipny-wkflow/directives/wk-entity-history-button/dialogs/entity-history.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"80\" flex-md=\"70\" flex-gt-md=\"60\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"column\"><div flex=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"loadingLog || loadingAct\" md-mode=\"indeterminate\"></md-progress-circular><md-tabs class=\"md-dynamic-height\" md-selected=\"selectedTab\"><md-tab label=\"Transizioni di stato\"><md-content layout-margin=\"\" layout-padding=\"\" layout=\"column\" flex=\"\" layout-align=\"center center\"><md-table-container ng-if=\"!loadingLog && transitionLogs.length>0\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Id</span></th><th md-column=\"\"><span>Operazione</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Eseguito da</span></th><th md-column=\"\"><span>Stato iniziale</span></th><th md-column=\"\"><span>Stato finale</span></th><th md-column=\"\"><span>Campi e Note</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"e in transitionLogs\"><td md-cell=\"\">{{ e.id }}</td><td md-cell=\"\">{{ e.wktransition.data.label }}</td><td md-cell=\"\">{{ e.created_at_frmt }}</td><td md-cell=\"\"><span ng-if=\"e.user && e.user.data\">{{ e.user.data.lastname }} {{ e.user.data.firstname }}</span></td><td md-cell=\"\">{{ e.wkstateFrom.data.label }}</td><td md-cell=\"\">{{ e.wkstateTo.data.label }}</td><td md-cell=\"\"><div style=\"border-bottom: dashed 1px grey;\" ng-if=\"e.wkform && e.wkform.data && e.wkform.data.fields && e.wkform.data.fields.data && e.wkform.data.fields.data.length>0\" ng-repeat=\"field in e.wkform.data.fields.data\"><i>{{field.label}}:</i> <b>{{entity[field.name]}}</b></div>{{ e.note }}</td></tr></tbody></table></md-table-container></md-content></md-tab><md-tab label=\"Dettaglio modifiche\"><md-content layout-margin=\"\" layout-padding=\"\" layout=\"column\" flex=\"\" layout-align=\"center center\"><md-table-container ng-if=\"!loadingAct && user.type==\'admin\'\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span>Id</span></th><th md-column=\"\"><span>Operazione</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"><span>Eseguito da</span></th><th md-column=\"\"><span>Dati modificati</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"activity in activities\"><td md-cell=\"\">{{ activity.id }}</td><td md-cell=\"\">{{ activity.description }}</td><td md-cell=\"\">{{ activity.created_at_frmt }}</td><td md-cell=\"\">{{ activity.causer.lastname }} {{ activity.causer.firstname }}</td><td md-cell=\"\"><p ng-repeat=\"(key, value) in activity.properties.attributes\"><span ng-if=\"key!=\'created_at\' && key!=\'created_at_r\' && key!=\'updated_at\' && activity.properties.old && !(value==0 && activity.properties.old[key]==null) && value!=activity.properties.old[key]\"><b>{{ key }}</b>: da {{activity.properties.old[key]==null?\'(vuoto)\':\"\'\"+activity.properties.old[key]+\"\'\"}} a \'{{ value }}\'</span></p></td></tr></tbody></table></md-table-container></md-content></md-tab></md-tabs></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/xipny-wkflow/directives/wk-entity-list/dialogs/customer-documents.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"70\" flex-md=\"60\" flex-gt-md=\"50\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"row\"><div flex=\"\"><md-content layout-margin=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><md-table-container ng-if=\"!loading\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"><span>Documento</span></th><th md-column=\"\"><span>Data</span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"doc in customer.documents.data\"><td md-cell=\"\"><md-icon md-font-icon=\"check\" class=\"md-accent\">check</md-icon></td><td md-cell=\"\"><span ng-if=\"doc.description\">{{ doc.description }}<br></span> <span ng-if=\"doc.original_file\"><i>{{ doc.original_file }}</i></span></td><td md-cell=\"\"><span>{{ doc.date }} {{doc.time}}</span></td><td md-cell=\"\"><md-button class=\"md-button md-raised md-accent\" ng-href=\"{{ env.API }}/documents/{{doc.id}}/download?token={{ token }}\" target=\"_blank\"><md-icon md-font-icon=\"get_app\">get_app</md-icon></md-button></td></tr></tbody></table></md-table-container></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-click=\"refresh()\" class=\"md-button md-raised md-accent\"><md-icon md-font-icon=\"refresh\">refresh</md-icon></md-button><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">{{ button_ok }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/xipny-wkflow/directives/wk-entity-list-buttons/dialogs/transition.html","<md-dialog aria-label=\"Dialog\" flex-xs=\"90\" flex-sm=\"80\" flex-md=\"70\" flex-gt-md=\"60\" role=\"dialog\" class=\"dialog page-appointments\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 class=\"md-headline\"><span class=\"inset\">{{ title }}</span></h2></div></md-toolbar><md-dialog-content layout=\"column\"><div flex=\"\"><md-content layout-margin=\"\"><md-progress-circular md-diameter=\"30\" ng-if=\"loading\" md-mode=\"indeterminate\"></md-progress-circular><h4>{{ wkform.description }}</h4><form autocomplete=\"off\" role=\"form\" name=\"wkformForm\" id=\"wkformForm\" layout=\"row\" layout-wrap=\"\"><div ng-if=\"wkform && wkform.fields\" ng-repeat=\"field in wkform.fields.data\" flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\"><md-input-container flex=\"100\"><label ng-if=\"field.type!=\'attachment\' && field.type!=\'checkbox\'\" for=\"{{field.name}}\">{{field.label}}</label> <input ng-if=\"field.type==\'integer\' || field.type==\'text\' || field.type==\'numeric\'\" type=\"{{field.type}}\" id=\"{{field.name}}\" name=\"{{field.name}}\" ng-model=\"field.data\" required=\"\" ng-model-options=\"filter.options\"><md-datepicker ng-if=\"field.type==\'date\'\" id=\"{{field.name}}\" name=\"{{field.name}}\" ng-model=\"field.data\" required=\"\" ng-model-options=\"filter.options\"></md-datepicker><md-select ng-if=\"field.type==\'select\'\" id=\"{{field.name}}\" name=\"{{field.name}}\" ng-model=\"field.data\" required=\"\"><md-option ng-repeat=\"option in field.options\" ng-value=\"option.value\">{{option.label}}</md-option></md-select><md-checkbox ng-if=\"field.type==\'checkbox\'\" id=\"{{field.name}}\" name=\"{{field.name}}\" ng-model=\"field.data\">{{field.label}}</md-checkbox><md-content layout=\"row\" ng-if=\"field.type==\'attachment\'\"><md-button id=\"upload\" w=\"\" aria-label=\"Upload\" class=\"md-fab md-mini md-primary\"><md-icon md-font-set=\"material-icons\" md-font-icon=\"{{field.icon}}\">{{field.icon}}</md-icon></md-button><md-input-container flex=\"\" class=\"md-block\" style=\"margin-top: 25px;\"><label for=\"fileName\">{{ field.label }}</label> <input id=\"fileName\" required=\"\" name=\"fileName\" type=\"text\" ng-readonly=\"true\" arita-label=\"fileName\" class=\"fileName\" ng-model=\"img.fileName\"></md-input-container><input id=\"fileObj\" name=\"fileObj\" type=\"file\" aria-label=\"fileObj\" class=\"ng-hide fileObj\" ng-model=\"img.fileObj\" accept=\"{{field.accept}}\"></md-content><div ng-messages=\"wkformForm[field.name].$error\" ng-show=\"wkformForm[field.name].$dirty\"><div ng-message=\"required\">Campo Obbligatorio</div></div></md-input-container></div><div flex=\"100\" ng-if=\"!transition || transition.f_note\"><md-input-container class=\"md-block\"><label for=\"note\">Note</label> <textarea rows=\"2\" id=\"note\" name=\"note\" ng-model-options=\"filter.options\" ng-model=\"note.data\"></textarea></md-input-container></div></form></md-content></div></md-dialog-content><md-dialog-actions layout-margin=\"\"><md-button ng-disabled=\"loading || wkformForm.$invalid\" ng-click=\"saveTransition()\" aria-label=\"Conferma\" class=\"md-accent md-raised\">Conferma</md-button><md-button ng-click=\"close()\" aria-label=\"Chiudi\" class=\"md-accent md-raised\">Chiudi</md-button></md-dialog-actions></md-dialog>");}]);